export default class Opzioni {
    classiGas = [
        {
            "id": 1,
            "classe": "G1.6",
            "portata_min": 0.016,
            "portata_max": 2.5,
            "portata_nominale": 1.6,
            "portata_termica": 38
        },
        {
            "id": 2,
            "classe": "G2.5",
            "portata_min": 0.025,
            "portata_max": 4,
            "portata_nominale": 2.5,
            "portata_termica": 59
        },
        {
            "id": 3,
            "classe": "G4",
            "portata_min": 0.04,
            "portata_max": 6,
            "portata_nominale": 4,
            "portata_termica": 38
        },
        {
            "id": 4,
            "classe": "G6",
            "portata_min": 0.06,
            "portata_max": 10,
            "portata_nominale": 6,
            "portata_termica": 58
        },
        {
            "id": 5,
            "classe": "G10",
            "portata_min": 0.1,
            "portata_max": 16,
            "portata_nominale": 10,
            "portata_termica": 96
        },
        {
            "id": 6,
            "classe": "G16",
            "portata_min": 0.16,
            "portata_max": 25,
            "portata_nominale": 16,
            "portata_termica": 154
        },
        {
            "id": 7,
            "classe": "G25",
            "portata_min": 0.25,
            "portata_max": 40,
            "portata_nominale": 25,
            "portata_termica": 240
        },
        {
            "id": 8,
            "classe": "G40",
            "portata_min": 0.4,
            "portata_max": 65,
            "portata_nominale": 40,
            "portata_termica": 384
        },
        {
            "id": 9,
            "classe": "G65",
            "portata_min": 0.65,
            "portata_max": 100,
            "portata_nominale": 65,
            "portata_termica": 624
        },
        {
            "id": 10,
            "classe": "G100",
            "portata_min": 1,
            "portata_max": 160,
            "portata_nominale": 100,
            "portata_termica": 960
        },
        {
            "id": 11,
            "classe": "G160",
            "portata_min": 1.6,
            "portata_max": 250,
            "portata_nominale": 160,
            "portata_termica": 1536
        },
        {
            "id": 12,
            "classe": "G250",
            "portata_min": 2.5,
            "portata_max": 400,
            "portata_nominale": 250,
            "portata_termica": 2400
        },
        {
            "id": 13,
            "classe": "G400",
            "portata_min": 4,
            "portata_max": 650,
            "portata_nominale": 400,
            "portata_termica": 3840
        },
        {
            "id": 14,
            "classe": "G650",
            "portata_min": 6.5,
            "portata_max": 1000,
            "portata_nominale": 650,
            "portata_termica": 6240
        },
        {
            "id": 15,
            "classe": "G1000",
            "portata_min": 10,
            "portata_max": 1600,
            "portata_nominale": 1000,
            "portata_termica": 9600
        },
        {
            "id": 16,
            "classe": "G1600",
            "portata_min": 16,
            "portata_max": 2500,
            "portata_nominale": 1600,
            "portata_termica": 15360
        },
        {
            "id": 17,
            "classe": "G2500",
            "portata_min": 25,
            "portata_max": 4000,
            "portata_nominale": 2500,
            "portata_termica": 24000
        },
        {
            "id": 18,
            "classe": "G4000",
            "portata_min": 40,
            "portata_max": 6500,
            "portata_nominale": 4000,
            "portata_termica": 38400
        },
        {
            "id": 19,
            "classe": "G6500",
            "portata_min": 65,
            "portata_max": 10000,
            "portata_nominale": 6500,
            "portata_termica": 62400
        }
    ]
    categorieGas = [
        {
            "id": 1,
            "name": "Riscaldamento",
            "code": "C1"
        },
        {
            "id": 2,
            "name": "Cottura cibi e/o produzione acqua calda sanitaria",
            "code": "C2"
        },
        {
            "id": 3,
            "name": "Riscaldamento + cottura cibi e/o produzione acqua calda sanitaria",
            "code": "C3"
        },
        {
            "id": 4,
            "name": "Condizionamento",
            "code": "C4"
        },
        {
            "id": 5,
            "name": "Condizionamento + riscaldamento",
            "code": "C5"
        },
        {
            "id": 6,
            "name": "Tecnologico (artigianale-industriale)",
            "code": "T1"
        },
        {
            "id": 7,
            "name": "Tecnologico + riscaldamento",
            "code": "T2"
        }
    ]
    remi = [
        "33067901",
        "34935501",
        "34935601",
        "34935700",
        "34935701",
        "34935702",
        "34935801",
        "34936201",
        "34936301",
        "34936401",
        "34936501",
        "34936601",
        "50135101",
        "34936502",
        "34936801",
        "34936901",
        "34937001",
        "50120401",
        "34937201",
        "34937501",
        "33063801",
        "34937701",
        "34938001",
        "50094301",
        "50112701",
        "34938301",
        "34938401",
        "34938501",
        "34938701",
        "34938901",
        "34939301",
        "34939401",
        "34939503",
        "34939500",
        "34939501",
        "34939502",
        "30000301",
        "34292700",
        "34292701",
        "34292702",
        "50110901",
        "30026501",
        "30026801",
        "30027001",
        "30027101",
        "30029001",
        "30029101",
        "34292900",
        "34292901",
        "34292902",
        "34292904",
        "34292903",
        "35509201",
        "36172401",
        "34301101",
        "34310601",
        "34293701",
        "34293901",
        "34294301",
        "34296502",
        "30002601",
        "34294801",
        "30003301",
        "34295501",
        "30004001",
        "30004201",
        "34295601",
        "30004901",
        "34296101",
        "30005501",
        "30005701",
        "34238002",
        "34296501",
        "50051101",
        "34296401",
        "30007701",
        "34296801",
        "30008001",
        "30008101",
        "30008201",
        "34296901",
        "34297301",
        "34297701",
        "34297801",
        "34297901",
        "50125201",
        "30009401",
        "30009501",
        "50145701",
        "34299101",
        "34299501",
        "34299601",
        "34300101",
        "34300700",
        "34300701",
        "34300702",
        "50051401",
        "34301201",
        "30011401",
        "34303501",
        "34303801",
        "30011901",
        "30012201",
        "30012301",
        "30012801",
        "34304000",
        "34304001",
        "34304002",
        "34304501",
        "34304701",
        "34304801",
        "34305201",
        "34305401",
        "30016601",
        "34305501",
        "34297702",
        "36115501",
        "34305801",
        "34295301",
        "34296503",
        "34303401",
        "34306301",
        "34306400",
        "34306401",
        "34306402",
        "34306601",
        "34306701",
        "30018201",
        "30018301",
        "30018401",
        "34306801",
        "50176901",
        "34309401",
        "34307701",
        "34295502",
        "30020101",
        "34308601",
        "34308602",
        "34308701",
        "34309101",
        "34309801",
        "30022701",
        "34310000",
        "34310001",
        "34310002",
        "34310003",
        "34310301",
        "34310302",
        "34310701",
        "30025601",
        "34310901",
        "34311101",
        "34311301",
        "34311601",
        "32300401",
        "34647001",
        "34647002",
        "32325801",
        "34647101",
        "34647102",
        "34647501",
        "32301901",
        "34647601",
        "34647901",
        "34648001",
        "32304601",
        "34648201",
        "32304801",
        "34648301",
        "50144501",
        "34648401",
        "32305701",
        "32305801",
        "32306101",
        "32306201",
        "32306301",
        "34648600",
        "34648601",
        "34648603",
        "34648602",
        "32308901",
        "32309101",
        "34648701",
        "50092001",
        "34648801",
        "32311901",
        "32312101",
        "32312201",
        "32312501",
        "32312901",
        "34182901",
        "34649000",
        "34649001",
        "34649002",
        "34649003",
        "34649401",
        "35893601",
        "36155101",
        "36215501",
        "50001901",
        "50030301",
        "50045401",
        "50090901",
        "32314401",
        "34649101",
        "34649801",
        "34649601",
        "32318501",
        "34650101",
        "34647103",
        "50049501",
        "32319201",
        "32319401",
        "34650300",
        "34650301",
        "34650302",
        "35646701",
        "50124801",
        "34650401",
        "34650701",
        "34651201",
        "34651301",
        "32323401",
        "34651401",
        "34651402",
        "34651403",
        "50029901",
        "32317601",
        "32317701",
        "32317901",
        "35074601",
        "30277701",
        "50121401",
        "30274301",
        "30274901",
        "34313601",
        "34314301",
        "34315301",
        "30275801",
        "30275901",
        "34316501",
        "34316801",
        "50165601",
        "30276801",
        "30277201",
        "35532201",
        "32341401",
        "32341701",
        "32341801",
        "32342401",
        "32342701",
        "32342801",
        "32342901",
        "32343201",
        "32343501",
        "32345601",
        "32345701",
        "32345801",
        "32345901",
        "34658201",
        "50048901",
        "50103701",
        "50164601",
        "34658901",
        "32331501",
        "34659201",
        "34659501",
        "32333601",
        "34659801",
        "35057801",
        "50131301",
        "32334601",
        "34660601",
        "50180401",
        "34661101",
        "32335201",
        "32335601",
        "34662001",
        "32338101",
        "32338801",
        "34664101",
        "34664102",
        "34664601",
        "36021301",
        "34795501",
        "34795601",
        "32846701",
        "32847001",
        "32847201",
        "32847301",
        "32847302",
        "32847501",
        "32849301",
        "32849401",
        "34133301",
        "34796001",
        "34796002",
        "50134701",
        "50142201",
        "32849501",
        "34796301",
        "32849701",
        "34796701",
        "34797201",
        "34797401",
        "34736801",
        "34798501",
        "32850701",
        "32850801",
        "32850901",
        "32851001",
        "50089801",
        "34798601",
        "34801901",
        "35498301",
        "34798701",
        "34799301",
        "34799401",
        "32851401",
        "34799501",
        "34799901",
        "34800101",
        "34800201",
        "32857301",
        "32857801",
        "32859101",
        "34800300",
        "34800301",
        "34800302",
        "34800303",
        "34800304",
        "34800501",
        "34800701",
        "34800901",
        "34801201",
        "34801601",
        "34803401",
        "50173701",
        "34801701",
        "34802001",
        "34802101",
        "34802301",
        "34802401",
        "34802501",
        "34802601",
        "34802701",
        "34802801",
        "32853101",
        "34802901",
        "50119701",
        "34802902",
        "34156101",
        "34803802",
        "34804001",
        "34804101",
        "32854101",
        "34804901",
        "34804902",
        "34804903",
        "34796003",
        "32854801",
        "32854901",
        "32855101",
        "32855201",
        "32855301",
        "32856001",
        "34805201",
        "34805202",
        "35526201",
        "50022301",
        "34805301",
        "50076901",
        "34806201",
        "34683301",
        "34683401",
        "34683402",
        "35066801",
        "36066301",
        "34683501",
        "34683601",
        "50074301",
        "34683701",
        "50166401",
        "32051401",
        "34684001",
        "34684101",
        "34684301",
        "32052601",
        "34684401",
        "50083801",
        "32054701",
        "34684801",
        "50032001",
        "50137501",
        "32921701",
        "34685001",
        "34685101",
        "34686001",
        "34685201",
        "34685202",
        "32057501",
        "34685301",
        "34685401",
        "34685701",
        "32059901",
        "34685801",
        "34686201",
        "32061101",
        "32061301",
        "32061401",
        "34684501",
        "34686501",
        "32062501",
        "32062701",
        "34686601",
        "35062301",
        "35943401",
        "34687101",
        "34687102",
        "34687103",
        "30038101",
        "30038901",
        "34281100",
        "34281101",
        "34281102",
        "30029301",
        "34281301",
        "34281501",
        "34281801",
        "30031201",
        "34282801",
        "34283001",
        "30031901",
        "34283401",
        "34286401",
        "34203004",
        "34286501",
        "34288601",
        "34289501",
        "34290101",
        "34286801",
        "34292301",
        "34203002",
        "50039701",
        "32539001",
        "34767901",
        "34768001",
        "34768101",
        "34768201",
        "34768301",
        "34768401",
        "32581401",
        "32581501",
        "32581701",
        "32581801",
        "32581901",
        "32582001",
        "32582201",
        "32582701",
        "34768500",
        "34768501",
        "34768502",
        "34768503",
        "36163101",
        "50013301",
        "50044101",
        "50070501",
        "34768601",
        "34768602",
        "34768801",
        "32542701",
        "34769101",
        "34769102",
        "50020301",
        "32542901",
        "32543201",
        "32543401",
        "32543901",
        "32544001",
        "32544101",
        "32558301",
        "33001901",
        "33002001",
        "34769201",
        "35403501",
        "50062801",
        "34769401",
        "34769501",
        "34769701",
        "34769801",
        "34770001",
        "34770201",
        "34770401",
        "34770601",
        "32545301",
        "32545501",
        "34770701",
        "35986701",
        "34770801",
        "32545701",
        "32545801",
        "34770901",
        "50078901",
        "50110001",
        "50115101",
        "34771001",
        "34771101",
        "34771301",
        "34771401",
        "34771501",
        "34771601",
        "32546901",
        "32547001",
        "32547101",
        "32547201",
        "32547301",
        "32547601",
        "32547701",
        "32547901",
        "32548001",
        "32548101",
        "34771801",
        "34771901",
        "34772001",
        "32548301",
        "34772101",
        "50090101",
        "50146201",
        "32558501",
        "32558601",
        "32559001",
        "34772201",
        "50105501",
        "34772501",
        "34772601",
        "50008601",
        "34772701",
        "34752301",
        "34772901",
        "34773001",
        "32550401",
        "32550801",
        "34773201",
        "50129701",
        "34773301",
        "50028101",
        "34773501",
        "50145201",
        "32552301",
        "34773601",
        "34773801",
        "34773901",
        "50006401",
        "50149501",
        "32553601",
        "32553701",
        "32553801",
        "32553901",
        "32554101",
        "34774001",
        "50035301",
        "32555301",
        "32555401",
        "32555801",
        "32555901",
        "32556001",
        "32556101",
        "32556201",
        "32556401",
        "32556601",
        "32556701",
        "32556801",
        "34138101",
        "34774301",
        "35477501",
        "35547501",
        "35833901",
        "36004801",
        "34774401",
        "34774501",
        "34774701",
        "34774901",
        "34775101",
        "35994101",
        "34775201",
        "35485201",
        "36132501",
        "34775501",
        "36145301",
        "32558201",
        "32558701",
        "32558901",
        "34775901",
        "32559301",
        "34776001",
        "35046601",
        "34776801",
        "34776701",
        "32560201",
        "32560301",
        "34100801",
        "34776901",
        "34777301",
        "32560801",
        "34777401",
        "50050201",
        "50071701",
        "32561201",
        "32561401",
        "32561601",
        "32562001",
        "32562101",
        "32566501",
        "32567001",
        "32567301",
        "32567401",
        "32567701",
        "32567901",
        "32568101",
        "32568201",
        "32568301",
        "32568401",
        "32568501",
        "32568601",
        "32568701",
        "32569401",
        "32569601",
        "32569701",
        "32569901",
        "32570101",
        "32570201",
        "32570301",
        "32570401",
        "32570501",
        "32570801",
        "32571301",
        "32571701",
        "32571801",
        "32572301",
        "32572601",
        "32572701",
        "32572801",
        "32573101",
        "32573601",
        "32573701",
        "32574301",
        "32575001",
        "32575201",
        "32575401",
        "32575501",
        "32576101",
        "32576601",
        "32576701",
        "32577001",
        "32577301",
        "32577501",
        "32577701",
        "32577901",
        "32578801",
        "32579001",
        "32579201",
        "32579301",
        "32579401",
        "32580002",
        "32580801",
        "32581001",
        "33715001",
        "34129601",
        "34129701",
        "34777701",
        "35501201",
        "35501301",
        "35504501",
        "35532501",
        "35532801",
        "35552301",
        "35556201",
        "35654601",
        "35659401",
        "35823501",
        "35866401",
        "35897301",
        "35970701",
        "36007701",
        "36007801",
        "36012701",
        "36049201",
        "36062601",
        "36065201",
        "36086501",
        "36087501",
        "36092001",
        "36097701",
        "36148601",
        "36177501",
        "36193801",
        "36216301",
        "50002601",
        "50002701",
        "50003501",
        "50003601",
        "50005501",
        "50011201",
        "50011601",
        "50017801",
        "50044601",
        "50061001",
        "50064801",
        "50100201",
        "50137301",
        "50138701",
        "50142401",
        "50173101",
        "34778301",
        "34778401",
        "34778501",
        "34778601",
        "34779301",
        "34779401",
        "35519601",
        "34779601",
        "34840801",
        "34840901",
        "50173301",
        "34841001",
        "32900701",
        "34841101",
        "35656601",
        "50082601",
        "32911101",
        "32911201",
        "32912201",
        "32912401",
        "32912601",
        "32926601",
        "32926701",
        "32927201",
        "32927701",
        "32927801",
        "32927901",
        "32928401",
        "32928601",
        "32929201",
        "32929301",
        "32929401",
        "32929501",
        "32929601",
        "32929801",
        "32930001",
        "32930201",
        "32930301",
        "32930701",
        "32932201",
        "32932301",
        "32935301",
        "32935901",
        "34157001",
        "34841300",
        "34841301",
        "34841302",
        "35053901",
        "35054701",
        "35054901",
        "35074101",
        "50037701",
        "50079301",
        "50088201",
        "50111701",
        "50131401",
        "34841701",
        "50164001",
        "32906401",
        "34841801",
        "35494001",
        "50069801",
        "50095701",
        "50167301",
        "34841901",
        "34842101",
        "34845301",
        "50083701",
        "50105801",
        "34188001",
        "34842201",
        "50107901",
        "34842301",
        "32907401",
        "34842401",
        "50058301",
        "34842501",
        "32907701",
        "32907801",
        "34842601",
        "34842602",
        "50021301",
        "34842701",
        "50022001",
        "34842801",
        "50006801",
        "50125101",
        "34842901",
        "50016601",
        "50122001",
        "50122101",
        "34843001",
        "34843101",
        "34843201",
        "50158601",
        "32911501",
        "32911801",
        "32911901",
        "32914001",
        "32930501",
        "34174801",
        "34843401",
        "34843402",
        "36032501",
        "36097901",
        "50035501",
        "50041101",
        "50071401",
        "50074401",
        "50091401",
        "50118801",
        "50168701",
        "50187001",
        "34843501",
        "50094801",
        "32916701",
        "34843601",
        "35476501",
        "36198101",
        "50084601",
        "32918501",
        "34843701",
        "36069601",
        "34843801",
        "50153701",
        "34843901",
        "50148701",
        "34844001",
        "34844101",
        "34844201",
        "36155701",
        "50031201",
        "50040901",
        "50165001",
        "34844301",
        "50005301",
        "50161101",
        "32921901",
        "34844401",
        "50097701",
        "34844501",
        "34844601",
        "34844701",
        "50100301",
        "34844801",
        "50010301",
        "32923101",
        "32923301",
        "32923601",
        "34845001",
        "36162701",
        "50097401",
        "50162601",
        "34845401",
        "50129601",
        "34845500",
        "34845501",
        "50064701",
        "34414301",
        "30317801",
        "30318101",
        "34414401",
        "34414402",
        "50107701",
        "34414601",
        "34414701",
        "30321202",
        "34414801",
        "30321901",
        "34414901",
        "34415001",
        "34415101",
        "34426901",
        "34415602",
        "34415801",
        "34416001",
        "34428001",
        "30322801",
        "30397401",
        "30398101",
        "30398401",
        "30398801",
        "34415601",
        "34416401",
        "34416402",
        "34416403",
        "50202501",
        "34416801",
        "50109501",
        "30325101",
        "34416901",
        "34417001",
        "34417201",
        "30325901",
        "34417401",
        "34417501",
        "30326601",
        "34417701",
        "30327001",
        "34417801",
        "34418001",
        "50107201",
        "34415802",
        "50121301",
        "34418600",
        "34418601",
        "34418602",
        "35516301",
        "34418701",
        "30331601",
        "34418901",
        "30332101",
        "30332201",
        "34419101",
        "35123501",
        "30332501",
        "30332701",
        "30332801",
        "30333001",
        "34419300",
        "34419301",
        "34419304",
        "34419302",
        "34419303",
        "30333701",
        "30333801",
        "34434201",
        "34415301",
        "34419901",
        "30334601",
        "34420001",
        "34426401",
        "36097101",
        "50085301",
        "50092901",
        "34420301",
        "30338101",
        "30338201",
        "34420701",
        "34420702",
        "34420901",
        "30339101",
        "30339201",
        "30339501",
        "30339601",
        "30339801",
        "34421001",
        "34421101",
        "30340201",
        "34421201",
        "35531401",
        "34425402",
        "50040601",
        "30340801",
        "30340901",
        "30341101",
        "30341201",
        "34419201",
        "34421401",
        "36033201",
        "34421501",
        "50006501",
        "30342501",
        "50097501",
        "34421700",
        "34421701",
        "34421702",
        "34429801",
        "34421900",
        "34421901",
        "34421902",
        "30343501",
        "34422001",
        "30343901",
        "30344401",
        "34422101",
        "35837101",
        "34428102",
        "30345201",
        "34422600",
        "34422601",
        "34422602",
        "34453301",
        "50028401",
        "34422901",
        "35929901",
        "30346101",
        "30346501",
        "34423101",
        "34423102",
        "50019501",
        "50027601",
        "34423301",
        "30347101",
        "34423601",
        "30347701",
        "30347901",
        "30348101",
        "30348201",
        "30348301",
        "30348401",
        "30348501",
        "30348601",
        "30348701",
        "34423801",
        "50069701",
        "30348801",
        "34424001",
        "50074801",
        "30349701",
        "34424501",
        "50019401",
        "30350101",
        "30350601",
        "30350701",
        "34424802",
        "34416802",
        "34425102",
        "34425101",
        "34425401",
        "34425501",
        "34425601",
        "30353801",
        "30353901",
        "34425700",
        "34425701",
        "34425702",
        "35560401",
        "35651401",
        "50011001",
        "50188101",
        "30356101",
        "30356301",
        "34426301",
        "34423103",
        "30359901",
        "34426801",
        "34426802",
        "34427101",
        "35816201",
        "35881001",
        "30361401",
        "30368301",
        "34427200",
        "34427201",
        "34427202",
        "50004001",
        "50126401",
        "30395901",
        "34438901",
        "34427501",
        "34489801",
        "50019301",
        "30363801",
        "34428101",
        "30364801",
        "34428201",
        "34428301",
        "30365501",
        "30365701",
        "30365801",
        "34428403",
        "34428901",
        "34429001",
        "30366801",
        "34423104",
        "30367501",
        "34429301",
        "34429401",
        "30368701",
        "30369201",
        "34430001",
        "34435501",
        "34430201",
        "34430301",
        "30370701",
        "30370801",
        "34430801",
        "34431501",
        "34431003",
        "35875201",
        "34430901",
        "30372001",
        "34431201",
        "34431301",
        "34431601",
        "34431801",
        "34431901",
        "34432101",
        "34453201",
        "30373601",
        "34432201",
        "34432601",
        "34432701",
        "30375001",
        "34432801",
        "30375501",
        "30375601",
        "34432901",
        "30376401",
        "30376601",
        "34433301",
        "30377101",
        "30377201",
        "34433501",
        "50081201",
        "30377801",
        "30378201",
        "34416404",
        "34416405",
        "50166901",
        "34433901",
        "30396501",
        "34434001",
        "30378301",
        "34434101",
        "34417301",
        "34434301",
        "34434401",
        "34434501",
        "36051601",
        "30379101",
        "30379201",
        "34434601",
        "34434701",
        "34434801",
        "35532101",
        "30381701",
        "30381801",
        "34435201",
        "34435701",
        "30383301",
        "30383501",
        "30384101",
        "30384201",
        "30384501",
        "30384601",
        "30384701",
        "30384801",
        "30384901",
        "30385001",
        "35072301",
        "50016201",
        "50073500",
        "50073501",
        "34435804",
        "50108601",
        "34435901",
        "30388601",
        "30356701",
        "30388701",
        "30389101",
        "30389301",
        "30389901",
        "34436101",
        "34436102",
        "34417901",
        "34436301",
        "34437201",
        "30392101",
        "34437301",
        "50127701",
        "30392401",
        "34419701",
        "34437701",
        "50087601",
        "30392801",
        "34414501",
        "34437801",
        "34429501",
        "30393201",
        "30393301",
        "34415201",
        "34425801",
        "30393101",
        "34437901",
        "34438301",
        "30394401",
        "34438401",
        "34438402",
        "50094701",
        "30395401",
        "30395701",
        "34438500",
        "34438502",
        "34438503",
        "34438504",
        "30236501",
        "34223401",
        "50043801",
        "50095201",
        "34224901",
        "34225901",
        "50172301",
        "50179901",
        "30244701",
        "34226801",
        "34223402",
        "34231401",
        "50093601",
        "34112001",
        "34235101",
        "30260901",
        "30261001",
        "34235201",
        "50017001",
        "50124201",
        "34223403",
        "34237301",
        "30268901",
        "30269001",
        "34227202",
        "34237701",
        "30270001",
        "34238101",
        "30270901",
        "34238201",
        "34553301",
        "34553302",
        "31162301",
        "34553501",
        "31160301",
        "50007801",
        "34554001",
        "31154001",
        "31154501",
        "34555001",
        "50111001",
        "34555801",
        "34556001",
        "34556901",
        "31159201",
        "34557701",
        "34558201",
        "34558401",
        "34750801",
        "34750901",
        "34751101",
        "34751201",
        "35049101",
        "34751301",
        "34751401",
        "32592301",
        "32593001",
        "32593601",
        "32594001",
        "32595601",
        "32596001",
        "34751001",
        "34751500",
        "34751501",
        "34751502",
        "35916201",
        "35990201",
        "36066501",
        "36131201",
        "50044201",
        "50050501",
        "50058401",
        "50127501",
        "50171701",
        "34751701",
        "50127201",
        "34752101",
        "34752401",
        "34752501",
        "34752601",
        "34752901",
        "34753201",
        "34753401",
        "34753501",
        "34753601",
        "50172401",
        "34753901",
        "34754001",
        "34754101",
        "34754201",
        "34754401",
        "34754601",
        "50170901",
        "32588401",
        "32588901",
        "34755001",
        "34755101",
        "32589101",
        "34755201",
        "34755401",
        "34755501",
        "50005401",
        "50121901",
        "34755601",
        "36206101",
        "34755701",
        "50144101",
        "34755901",
        "34756001",
        "50186001",
        "34756701",
        "34756801",
        "34757401",
        "32590701",
        "34757501",
        "50138201",
        "34757701",
        "35885701",
        "34757601",
        "34758001",
        "34758101",
        "34758301",
        "35049001",
        "50066501",
        "34758401",
        "31590701",
        "34624801",
        "31592701",
        "34624901",
        "35040001",
        "31595301",
        "34625201",
        "50012001",
        "31598201",
        "31676701",
        "31676702",
        "31677901",
        "31679301",
        "31679601",
        "31685801",
        "34625303",
        "34625305",
        "50042701",
        "35072201",
        "50007601",
        "50007602",
        "50133501",
        "50145401",
        "50148801",
        "50204001",
        "31596401",
        "31596402",
        "34625401",
        "34625501",
        "34625502",
        "50031901",
        "31598801",
        "31599001",
        "34130302",
        "36179101",
        "31603001",
        "34625804",
        "50047001",
        "31607001",
        "31607101",
        "31609901",
        "34626601",
        "34626701",
        "34626401",
        "34625304",
        "35068201",
        "31620401",
        "34627102",
        "31621801",
        "31621901",
        "34627201",
        "31623401",
        "34627501",
        "31628101",
        "31628301",
        "31628401",
        "31628901",
        "31629001",
        "31629401",
        "34627901",
        "34627902",
        "34627903",
        "34627904",
        "34627905",
        "34627906",
        "50058501",
        "50095101",
        "31633501",
        "31633701",
        "34628201",
        "34628302",
        "31634901",
        "31635001",
        "31635201",
        "34628401",
        "34628402",
        "34628403",
        "31635901",
        "31636001",
        "34628501",
        "31637501",
        "34628600",
        "34628601",
        "34628602",
        "50132201",
        "34628901",
        "31642001",
        "31642101",
        "31642201",
        "31642601",
        "34629301",
        "34629302",
        "34629401",
        "34629702",
        "31652901",
        "50179601",
        "31653501",
        "31653601",
        "34627101",
        "34630001",
        "50095601",
        "50103401",
        "50127601",
        "31658901",
        "34630101",
        "34630102",
        "34630104",
        "50092501",
        "31662901",
        "31663001",
        "34630201",
        "35493801",
        "31663702",
        "34630301",
        "31664801",
        "31664901",
        "31665301",
        "31665401",
        "31667401",
        "34629303",
        "34630402",
        "34630403",
        "31594401",
        "31594501",
        "31617801",
        "34629001",
        "34627002",
        "50035001",
        "50124101",
        "50127401",
        "31668601",
        "31668801",
        "31670001",
        "34630700",
        "34630702",
        "34630703",
        "34630704",
        "50070401",
        "32942101",
        "34848401",
        "35991201",
        "50012400",
        "50012401",
        "32940401",
        "50016401",
        "50189501",
        "34848501",
        "34848601",
        "34848701",
        "50096201",
        "34848801",
        "34848901",
        "32936201",
        "34849001",
        "50043401",
        "34849101",
        "34849201",
        "34849301",
        "34849501",
        "34849601",
        "34849701",
        "34849801",
        "50147301",
        "34849901",
        "34850001",
        "50044701",
        "34850101",
        "34850201",
        "50190901",
        "34439201",
        "30404801",
        "30472501",
        "34439301",
        "30406001",
        "34439701",
        "50108501",
        "34439801",
        "35547901",
        "34439901",
        "30409201",
        "34440201",
        "30411501",
        "34440701",
        "34441001",
        "50183001",
        "34441201",
        "34441501",
        "30415701",
        "34441801",
        "34441802",
        "30513401",
        "30513701",
        "30513801",
        "30513901",
        "30515201",
        "30515301",
        "30515401",
        "30515801",
        "30516101",
        "30516201",
        "30516301",
        "30517201",
        "34444701",
        "34446201",
        "50011801",
        "50031801",
        "50069601",
        "30416301",
        "34442101",
        "35996501",
        "30419201",
        "34442401",
        "30419801",
        "34442700",
        "34442701",
        "34442702",
        "34442901",
        "34443001",
        "30423801",
        "34443200",
        "34443201",
        "34443202",
        "34443101",
        "34443501",
        "30475601",
        "34443601",
        "34443602",
        "50073701",
        "50182801",
        "30429901",
        "30430001",
        "34444201",
        "35930001",
        "50191401",
        "34444501",
        "30433801",
        "30434501",
        "34444901",
        "34445001",
        "30435001",
        "34445100",
        "34445102",
        "34445103",
        "34445104",
        "34445401",
        "30438101",
        "30438201",
        "30438301",
        "34445501",
        "34459601",
        "30439101",
        "34440100",
        "34440101",
        "34445601",
        "34451201",
        "36049101",
        "50032401",
        "50122401",
        "34445901",
        "34446001",
        "34446002",
        "36148101",
        "30441801",
        "34446203",
        "30443901",
        "30444301",
        "30444401",
        "34446500",
        "34446501",
        "34446502",
        "34446701",
        "34446801",
        "30447101",
        "30447201",
        "34446901",
        "34447001",
        "34442402",
        "34447801",
        "30453001",
        "30453101",
        "34448201",
        "30454001",
        "30454701",
        "34448600",
        "34448602",
        "34448603",
        "50098301",
        "30461201",
        "34448901",
        "50119401",
        "30462401",
        "30462501",
        "30462701",
        "30462801",
        "34449300",
        "34449302",
        "34449303",
        "34449304",
        "50040501",
        "30468101",
        "34450300",
        "34450301",
        "50086401",
        "50033601",
        "50193201",
        "30468201",
        "30468901",
        "34450401",
        "30470101",
        "30470501",
        "30470601",
        "34450700",
        "34450701",
        "34450702",
        "35126701",
        "36048901",
        "50074101",
        "30472701",
        "30472801",
        "30473001",
        "30473201",
        "34451101",
        "35888301",
        "34451503",
        "50167601",
        "34451502",
        "34451601",
        "30475301",
        "30475501",
        "34451701",
        "34452300",
        "34452301",
        "34452302",
        "34452001",
        "34452602",
        "35929801",
        "34453202",
        "34453401",
        "30484101",
        "34453601",
        "34446202",
        "36060001",
        "34454001",
        "30488301",
        "30488401",
        "34454901",
        "34455101",
        "34455201",
        "50143901",
        "30492001",
        "34455401",
        "30492501",
        "30492601",
        "30492701",
        "34455501",
        "50034601",
        "50079701",
        "50181201",
        "30494401",
        "34455601",
        "34455602",
        "30496001",
        "34455701",
        "34455801",
        "34456000",
        "34456001",
        "34456002",
        "34456101",
        "34452801",
        "30498601",
        "34456301",
        "30499701",
        "30499901",
        "30500001",
        "34456400",
        "34456401",
        "34456402",
        "34456403",
        "50019001",
        "30503001",
        "30503301",
        "34457601",
        "34457602",
        "30504501",
        "34457800",
        "34457801",
        "34457802",
        "34458001",
        "34458201",
        "34441906",
        "34458501",
        "34458502",
        "50096401",
        "50162901",
        "34458601",
        "30509801",
        "30509901",
        "30510101",
        "34458900",
        "34458903",
        "34458904",
        "34458905",
        "34458902",
        "50121701",
        "34459001",
        "30512701",
        "34459400",
        "34459401",
        "50153101",
        "34841200",
        "34841201",
        "34841202",
        "50137801",
        "34841400",
        "34841401",
        "34841402",
        "50175801",
        "34841601",
        "34842001",
        "34837301",
        "32951201",
        "34838801",
        "34844901",
        "32925401",
        "34845201",
        "36179601",
        "34840001",
        "50060601",
        "50093201",
        "50072701",
        "31133001",
        "31133101",
        "31133201",
        "31133701",
        "31134901",
        "34497900",
        "34497901",
        "50058601",
        "36041901",
        "50036601",
        "34498201",
        "34498401",
        "34498402",
        "50029501",
        "50029502",
        "50098401",
        "34499301",
        "50124401",
        "50005801",
        "50098901",
        "34501201",
        "34502203",
        "34504501",
        "34504701",
        "50048701",
        "50033201",
        "34507401",
        "50098701",
        "50098801",
        "50095501",
        "34826301",
        "34826701",
        "32890001",
        "34826901",
        "34827401",
        "34827601",
        "34828001",
        "34828501",
        "34828801",
        "34828901",
        "35050201",
        "50025801",
        "34829501",
        "34829502",
        "34830101",
        "34830201",
        "34830301",
        "34830401",
        "34830501",
        "50029801",
        "50045601",
        "34830901",
        "34828401",
        "34831201",
        "34831401",
        "34831601",
        "34831901",
        "34832001",
        "34832301",
        "34832501",
        "34832701",
        "34829401",
        "34829901",
        "34833301",
        "34833101",
        "34757901",
        "34833401",
        "34833901",
        "34834001",
        "35969701",
        "34834201",
        "34740401",
        "34740501",
        "50098001",
        "34740701",
        "34740801",
        "50131801",
        "50148201",
        "34740901",
        "34741001",
        "34741101",
        "34741201",
        "34741301",
        "34741501",
        "32598801",
        "34741601",
        "34741701",
        "32599401",
        "32600301",
        "34741801",
        "50028301",
        "50061601",
        "50090301",
        "34742001",
        "32631101",
        "34742501",
        "34742502",
        "36187901",
        "50002101",
        "34742601",
        "34742701",
        "32601001",
        "34742901",
        "34743001",
        "50047601",
        "34745102",
        "34743301",
        "34743401",
        "34743601",
        "35520401",
        "50062701",
        "34743701",
        "32603901",
        "34743901",
        "50188901",
        "34744001",
        "34744101",
        "34744201",
        "34744301",
        "34744401",
        "34744501",
        "34744601",
        "36102901",
        "50135301",
        "34744901",
        "32605101",
        "34745101",
        "36047601",
        "50106301",
        "32606001",
        "32606501",
        "32607301",
        "32607601",
        "32607801",
        "32608501",
        "32608601",
        "32608701",
        "32610501",
        "32610601",
        "32610701",
        "32610901",
        "32611001",
        "32611701",
        "34745201",
        "34745202",
        "35557401",
        "35823401",
        "35836601",
        "36117501",
        "50008101",
        "50042401",
        "50047201",
        "50047301",
        "50047401",
        "50047501",
        "50072101",
        "34745401",
        "34745701",
        "34745801",
        "50060801",
        "32613001",
        "50060901",
        "50128601",
        "34746001",
        "34746201",
        "32613901",
        "32614001",
        "32614101",
        "32614201",
        "32614401",
        "32614701",
        "32614801",
        "32614901",
        "34107801",
        "34127401",
        "36117601",
        "36177401",
        "50047701",
        "50047801",
        "50070001",
        "50086501",
        "34746601",
        "34746701",
        "50065801",
        "34746801",
        "50182001",
        "34746901",
        "34747101",
        "34747201",
        "34747301",
        "34747401",
        "32627701",
        "32627801",
        "34750701",
        "50035201",
        "50135801",
        "32616801",
        "32618001",
        "32631401",
        "34102501",
        "34748101",
        "35046201",
        "35390901",
        "36194701",
        "50039001",
        "50123601",
        "34748301",
        "34748401",
        "34748801",
        "35505501",
        "50042801",
        "34748501",
        "34748601",
        "32620601",
        "32621501",
        "32621801",
        "34749101",
        "50047901",
        "32622101",
        "34749201",
        "35049201",
        "35846801",
        "36101401",
        "50031301",
        "50198101",
        "50062201",
        "34749401",
        "32600701",
        "32600801",
        "32600901",
        "32624001",
        "34185601",
        "50063101",
        "50020501",
        "50032601",
        "50034901",
        "50155601",
        "34749601",
        "34749801",
        "34749901",
        "34745103",
        "50132101",
        "50004401",
        "50180701",
        "34815601",
        "34815801",
        "34821201",
        "32819701",
        "32819801",
        "32820101",
        "32820501",
        "32820701",
        "32820801",
        "32820901",
        "32821001",
        "32821301",
        "32821401",
        "32821501",
        "32821801",
        "32822001",
        "32822101",
        "32822202",
        "34154801",
        "34161001",
        "34182101",
        "34816001",
        "34824701",
        "35477201",
        "35477701",
        "35526801",
        "35838901",
        "35973701",
        "35990001",
        "35990901",
        "36011101",
        "36036501",
        "50038001",
        "50049601",
        "50075701",
        "50075801",
        "34816301",
        "35127601",
        "34816801",
        "32822901",
        "34817001",
        "36131401",
        "50071301",
        "34817201",
        "34817301",
        "34817501",
        "34817601",
        "32841601",
        "32842101",
        "32842201",
        "32842501",
        "32842601",
        "32842701",
        "32842801",
        "32842901",
        "32843701",
        "32843901",
        "32844001",
        "32844101",
        "32844201",
        "32844301",
        "32845301",
        "32845501",
        "32845601",
        "32845701",
        "34817702",
        "35651301",
        "36127501",
        "50076301",
        "50128801",
        "34818001",
        "34818201",
        "32823301",
        "34818301",
        "34818302",
        "35647801",
        "34818601",
        "50104201",
        "34818901",
        "34819001",
        "34819002",
        "32825501",
        "32825601",
        "34819101",
        "34819201",
        "34819301",
        "32825801",
        "32825901",
        "32826101",
        "32826201",
        "32826301",
        "32826501",
        "32826601",
        "32826701",
        "34099401",
        "34819601",
        "50039101",
        "50062101",
        "34819801",
        "32827601",
        "32829201",
        "34820101",
        "35476701",
        "36127701",
        "36163901",
        "50077301",
        "32829401",
        "34820201",
        "34820401",
        "34820501",
        "50091201",
        "50016501",
        "50164701",
        "34821301",
        "35550101",
        "50045301",
        "32824101",
        "32832101",
        "32832201",
        "34821401",
        "50031101",
        "50046201",
        "34821601",
        "34821701",
        "34822401",
        "34822501",
        "50117201",
        "34823301",
        "34823401",
        "32832901",
        "32833101",
        "32833201",
        "32833501",
        "32833601",
        "34823601",
        "50123501",
        "35889001",
        "32834801",
        "32834901",
        "32835102",
        "32835201",
        "32835502",
        "32835601",
        "32835702",
        "32835800",
        "32835805",
        "50069001",
        "32835901",
        "32836102",
        "32836801",
        "32837301",
        "32837401",
        "34125301",
        "34823801",
        "34823802",
        "50004901",
        "50018801",
        "50030501",
        "50077901",
        "50079801",
        "34824101",
        "34824001",
        "34823901",
        "34824201",
        "34824301",
        "34832101",
        "34824501",
        "34824601",
        "34824901",
        "34825001",
        "34825101",
        "32839601",
        "32840001",
        "32840101",
        "32840301",
        "32841001",
        "32841101",
        "34825401",
        "34825402",
        "34825403",
        "35389301",
        "36127901",
        "50042201",
        "34940101",
        "50164201",
        "34940201",
        "50088001",
        "33068803",
        "33068901",
        "33069201",
        "33070801",
        "34940401",
        "35058902",
        "35808901",
        "50026801",
        "34940701",
        "34941001",
        "34941301",
        "50120101",
        "30040101",
        "30040301",
        "30040401",
        "34255901",
        "50012901",
        "50045001",
        "34263402",
        "30042801",
        "34263403",
        "30044501",
        "30044601",
        "30044701",
        "30044901",
        "34258500",
        "34258501",
        "34258502",
        "34258503",
        "34279401",
        "50060401",
        "50119801",
        "36008901",
        "50107801",
        "34278801",
        "34261701",
        "30049601",
        "34262101",
        "30050301",
        "34262300",
        "34262301",
        "34262302",
        "34263101",
        "30073101",
        "30073201",
        "34263401",
        "50038101",
        "50107101",
        "50133701",
        "34263701",
        "34264201",
        "30054501",
        "34264501",
        "34265201",
        "30057101",
        "34266001",
        "30058001",
        "34266401",
        "34255904",
        "34267401",
        "50101101",
        "34268201",
        "50099401",
        "30060001",
        "30060201",
        "30060401",
        "30060801",
        "34268601",
        "50010401",
        "50014701",
        "50043701",
        "50044301",
        "50086601",
        "34269801",
        "34272101",
        "50173801",
        "30064601",
        "34272601",
        "34273601",
        "34275901",
        "50010801",
        "30068501",
        "34276601",
        "50078301",
        "30069001",
        "34255903",
        "30069602",
        "34277101",
        "30072001",
        "30072101",
        "34279601",
        "36082501",
        "34279801",
        "34280101",
        "30526601",
        "34356901",
        "34366401",
        "50009601",
        "34357001",
        "34357101",
        "34357301",
        "34357501",
        "50113701",
        "30528401",
        "30528701",
        "34357801",
        "35070101",
        "34357901",
        "34373102",
        "34359401",
        "34360001",
        "50083101",
        "30538601",
        "30538701",
        "34360201",
        "50107301",
        "34360701",
        "34360702",
        "34360801",
        "34360901",
        "30545801",
        "30545901",
        "34360703",
        "34361401",
        "34361801",
        "50049001",
        "34362101",
        "30552301",
        "34363001",
        "34363101",
        "30634301",
        "30634701",
        "30635401",
        "30635901",
        "30636001",
        "30637501",
        "30641001",
        "34364101",
        "34364103",
        "34364104",
        "50104601",
        "30561701",
        "34366100",
        "34366101",
        "34366103",
        "34366102",
        "34366601",
        "30565601",
        "34366701",
        "30566201",
        "30566301",
        "30566501",
        "34366801",
        "34363802",
        "50023301",
        "50129501",
        "30569601",
        "30569801",
        "30585001",
        "34364106",
        "30570301",
        "34368001",
        "30571501",
        "35069801",
        "34368701",
        "30581701",
        "30581801",
        "30582501",
        "34369501",
        "34369701",
        "30583801",
        "34373104",
        "34368400",
        "34368401",
        "34370201",
        "30590801",
        "34370901",
        "30591701",
        "30591801",
        "34363102",
        "30593801",
        "30594001",
        "30594101",
        "34371301",
        "34371901",
        "30596501",
        "34364105",
        "34372301",
        "34372501",
        "30599301",
        "34372901",
        "50072301",
        "30601201",
        "30601301",
        "34373101",
        "30605001",
        "34373601",
        "30608201",
        "30608301",
        "34375401",
        "34375801",
        "30618001",
        "34376701",
        "30618501",
        "34376801",
        "34362701",
        "30621401",
        "30622901",
        "34378801",
        "36073101",
        "34379301",
        "34379302",
        "30629501",
        "30629601",
        "34380801",
        "34373103",
        "30641901",
        "34478701",
        "34478801",
        "34478901",
        "34479001",
        "34481301",
        "30642701",
        "34398601",
        "34479101",
        "34482206",
        "30643301",
        "34479301",
        "34479501",
        "34481501",
        "34486700",
        "34479801",
        "50058701",
        "34480101",
        "30644101",
        "34480202",
        "30644501",
        "34480301",
        "34480501",
        "30645501",
        "34480701",
        "34480801",
        "34480901",
        "34481101",
        "34481201",
        "50193601",
        "34481601",
        "50174301",
        "30649301",
        "34481801",
        "34482001",
        "30650201",
        "30650601",
        "34482100",
        "34482101",
        "34482104",
        "34482106",
        "34482102",
        "34486701",
        "30665701",
        "30666201",
        "30666701",
        "30666801",
        "30666901",
        "30667101",
        "34482201",
        "34482202",
        "34482205",
        "35885601",
        "50121201",
        "34483001",
        "34485001",
        "50064401",
        "34483301",
        "34483701",
        "50171101",
        "34483801",
        "36177301",
        "34484101",
        "50164501",
        "30654001",
        "34484301",
        "34484401",
        "30654901",
        "34484901",
        "34485101",
        "30656001",
        "34485201",
        "34482701",
        "34485300",
        "34485301",
        "34485302",
        "34485401",
        "34485501",
        "34485701",
        "34490901",
        "34485801",
        "34486101",
        "30658301",
        "30658401",
        "34486201",
        "34486301",
        "30659301",
        "34486601",
        "34486901",
        "50110101",
        "34487001",
        "30660201",
        "34453901",
        "34487101",
        "34487201",
        "34487301",
        "34487401",
        "34487601",
        "34484701",
        "34487701",
        "34488001",
        "34488101",
        "30661801",
        "34488201",
        "30662201",
        "34488301",
        "36207801",
        "30662701",
        "34488401",
        "30663101",
        "34488501",
        "34391601",
        "34488801",
        "34489101",
        "30643401",
        "34479401",
        "34489502",
        "34489601",
        "34489701",
        "34489902",
        "34490101",
        "50052001",
        "50049901",
        "34873401",
        "34873501",
        "50103601",
        "33031301",
        "50018101",
        "50019601",
        "50051801",
        "34874201",
        "34874501",
        "50052601",
        "50054401",
        "33031601",
        "34874801",
        "35861001",
        "50052701",
        "34875201",
        "34875601",
        "34875701",
        "34875801",
        "34876001",
        "36077901",
        "50006201",
        "33039101",
        "50084801",
        "34876201",
        "33033001",
        "34876401",
        "50013701",
        "34876701",
        "50144901",
        "34876901",
        "34877001",
        "50050001",
        "34877201",
        "50054301",
        "33034301",
        "33034601",
        "33040301",
        "34877501",
        "34883901",
        "35557501",
        "36020101",
        "36162101",
        "50023401",
        "50051601",
        "50123801",
        "50191001",
        "34877601",
        "50040701",
        "34877701",
        "34877801",
        "50052801",
        "34878001",
        "34878101",
        "33035201",
        "50023001",
        "50023101",
        "34878701",
        "34878801",
        "34879001",
        "34879401",
        "34879601",
        "33036501",
        "34879701",
        "50058901",
        "50051901",
        "34880101",
        "34880301",
        "50052201",
        "34880501",
        "33034901",
        "50001501",
        "50004501",
        "34881001",
        "33037401",
        "34881101",
        "34881201",
        "34881202",
        "35924201",
        "50126701",
        "34881301",
        "34881401",
        "50149801",
        "34881501",
        "50052101",
        "34881701",
        "34881801",
        "34882201",
        "34883001",
        "33038501",
        "34883300",
        "34883301",
        "34883302",
        "50013801",
        "50026101",
        "34883401",
        "34883501",
        "34883801",
        "34884101",
        "34884201",
        "34884301",
        "34884901",
        "34885001",
        "34885201",
        "34885301",
        "50001601",
        "50042001",
        "50136501",
        "34885501",
        "34886601",
        "50052501",
        "50052401",
        "34886401",
        "34886501",
        "34886701",
        "34887301",
        "34887401",
        "33042101",
        "34887601",
        "50193001",
        "34887701",
        "34887901",
        "34888101",
        "34888501",
        "34888601",
        "34944201",
        "34944401",
        "50043201",
        "34944301",
        "33076301",
        "35894301",
        "34944601",
        "34944701",
        "34944801",
        "50145801",
        "34944901",
        "33081201",
        "33081901",
        "33082601",
        "34945001",
        "34946601",
        "35059201",
        "50009401",
        "34945101",
        "33082801",
        "34945301",
        "33090001",
        "33090401",
        "33090601",
        "33090801",
        "33090901",
        "33091101",
        "33091301",
        "33091701",
        "33091801",
        "33092101",
        "33092201",
        "33093101",
        "33093201",
        "33094801",
        "33095101",
        "33095401",
        "33097401",
        "34945401",
        "34945402",
        "50073401",
        "35412401",
        "35996301",
        "50111401",
        "50121501",
        "34945501",
        "34945601",
        "34946501",
        "34948501",
        "34945701",
        "34946001",
        "34946201",
        "50128901",
        "34949501",
        "34946701",
        "34946801",
        "50061501",
        "50167701",
        "34946901",
        "33087101",
        "34947201",
        "34947401",
        "34947701",
        "34947801",
        "34947901",
        "34948001",
        "34948101",
        "50061401",
        "34948201",
        "50073301",
        "34948301",
        "34948601",
        "34948701",
        "35418101",
        "36031201",
        "34948901",
        "50143601",
        "34949101",
        "34949201",
        "34949401",
        "34888901",
        "50055101",
        "34889101",
        "50055901",
        "34889501",
        "50055701",
        "34889801",
        "50055501",
        "34890401",
        "33029601",
        "34890901",
        "34890902",
        "35056401",
        "36205801",
        "50006701",
        "50084701",
        "50086701",
        "50121101",
        "34891101",
        "34891301",
        "34891501",
        "50053801",
        "50053201",
        "34892001",
        "34892201",
        "34892501",
        "34892801",
        "50054101",
        "50053501",
        "50055001",
        "50055301",
        "34894501",
        "50053101",
        "50056101",
        "34895101",
        "33027001",
        "33027101",
        "33027301",
        "33027401",
        "33027701",
        "33028801",
        "33029001",
        "34904301",
        "34904302",
        "35056301",
        "35500101",
        "35809301",
        "35858801",
        "50001701",
        "50093801",
        "50143501",
        "50054701",
        "34099801",
        "34895501",
        "36092601",
        "50112601",
        "34895701",
        "33020301",
        "33020401",
        "36047001",
        "50078701",
        "50182701",
        "34896001",
        "50055201",
        "34896601",
        "34896701",
        "50053301",
        "34897301",
        "50054901",
        "34897901",
        "33020701",
        "50053601",
        "50053401",
        "50055601",
        "50053001",
        "50053901",
        "34900501",
        "34900201",
        "50056001",
        "34900601",
        "50054601",
        "34901001",
        "50053701",
        "34901301",
        "33022401",
        "34901401",
        "35074001",
        "50034301",
        "34902001",
        "50151301",
        "50054201",
        "34902501",
        "34902601",
        "50054801",
        "50055401",
        "34903401",
        "50054501",
        "34942001",
        "34942101",
        "34942201",
        "50012201",
        "34942401",
        "33103101",
        "33105101",
        "33105201",
        "34942801",
        "34942901",
        "34943101",
        "50010701",
        "34943301",
        "34943302",
        "34943401",
        "34943501",
        "34943701",
        "34943801",
        "34635401",
        "50028801",
        "31709301",
        "31709501",
        "31709701",
        "31710101",
        "31712401",
        "34635801",
        "34635802",
        "34635803",
        "35033001",
        "50017501",
        "50023201",
        "50109401",
        "50113801",
        "34635900",
        "34635901",
        "34635902",
        "50059401",
        "34636001",
        "31732301",
        "31732801",
        "31732901",
        "34636302",
        "34636303",
        "31732101",
        "35470101",
        "50029301",
        "50091101",
        "50102101",
        "31715901",
        "34636401",
        "31716701",
        "34636601",
        "34636701",
        "34636702",
        "50123901",
        "34637001",
        "34644102",
        "34637301",
        "31728901",
        "34639601",
        "34639602",
        "50034401",
        "34639901",
        "31686001",
        "34630800",
        "34630801",
        "34630802",
        "34630803",
        "34630804",
        "35074801",
        "35658901",
        "31687901",
        "31688101",
        "31689101",
        "34496202",
        "34631001",
        "34631100",
        "34631102",
        "34631103",
        "31693201",
        "31693401",
        "31693601",
        "35126100",
        "35126101",
        "35126102",
        "35126103",
        "36120501",
        "50179701",
        "34631300",
        "34631301",
        "34631302",
        "31694801",
        "31694901",
        "34631400",
        "34631401",
        "34631402",
        "31703401",
        "31703601",
        "31704201",
        "31706602",
        "34631500",
        "34631501",
        "34631502",
        "34631503",
        "50079401",
        "35067301",
        "35068301",
        "35854801",
        "36074001",
        "50007501",
        "50029201",
        "50033801",
        "50084901",
        "50135201",
        "50142101",
        "31697201",
        "34632001",
        "34632201",
        "34631701",
        "35023901",
        "50182301",
        "34631801",
        "34631901",
        "31696701",
        "34632101",
        "34632102",
        "31698102",
        "34632401",
        "34632402",
        "50137201",
        "50184901",
        "34632501",
        "34632502",
        "35477001",
        "34632601",
        "35040501",
        "34630900",
        "34630901",
        "34632701",
        "31701001",
        "34632801",
        "34631601",
        "34633101",
        "34632901",
        "34633001",
        "50171901",
        "34834801",
        "34834901",
        "34835001",
        "34114301",
        "34835201",
        "36073901",
        "50025301",
        "50070701",
        "50078401",
        "32944401",
        "32944601",
        "32944801",
        "34835301",
        "36026101",
        "34835501",
        "34835701",
        "34835801",
        "34835901",
        "34836301",
        "50058201",
        "50174201",
        "34836501",
        "50093101",
        "32952401",
        "32952501",
        "32952901",
        "32953401",
        "32953501",
        "32953601",
        "32953801",
        "32953901",
        "32954001",
        "32954201",
        "32954401",
        "32954701",
        "32954901",
        "32955001",
        "32955701",
        "32955801",
        "32955901",
        "32956801",
        "34138401",
        "34836700",
        "34836701",
        "34836702",
        "34836703",
        "36060401",
        "50060001",
        "50072501",
        "50077401",
        "50109801",
        "50180601",
        "50189201",
        "32946101",
        "32946201",
        "32946301",
        "32946801",
        "32946901",
        "32947001",
        "32947201",
        "32947301",
        "32947401",
        "32947501",
        "32947801",
        "32948001",
        "34837101",
        "36193301",
        "50087701",
        "34837201",
        "34837202",
        "34837203",
        "35054201",
        "50031501",
        "34837401",
        "34837601",
        "36119101",
        "36192401",
        "34840601",
        "34837801",
        "50043901",
        "34837901",
        "34838201",
        "50063501",
        "34838901",
        "34839701",
        "34840101",
        "34672501",
        "34673905",
        "32077901",
        "32078401",
        "32078701",
        "32078901",
        "32079001",
        "32079101",
        "32079501",
        "32080801",
        "34672701",
        "32083101",
        "32083601",
        "32084101",
        "34673201",
        "34673202",
        "50112301",
        "34673401",
        "34673402",
        "50140501",
        "34673904",
        "32085701",
        "32085801",
        "32086401",
        "32086601",
        "32087001",
        "32087701",
        "32088101",
        "32088201",
        "32089601",
        "34673601",
        "34673602",
        "35409001",
        "36073801",
        "50068801",
        "50114201",
        "50145501",
        "50206301",
        "32090801",
        "32091301",
        "34673801",
        "34674501",
        "50030901",
        "50153901",
        "50154001",
        "32157101",
        "34673901",
        "34673903",
        "35061001",
        "50020101",
        "50163501",
        "34674101",
        "50089501",
        "32098301",
        "34674301",
        "34674401",
        "34689401",
        "34674603",
        "34674602",
        "34674604",
        "34675201",
        "50145901",
        "50169001",
        "32101601",
        "32101901",
        "32102501",
        "32103301",
        "32103402",
        "32104101",
        "32105501",
        "34675001",
        "35821701",
        "32139301",
        "32139401",
        "34675801",
        "34675802",
        "32098001",
        "34676001",
        "34676002",
        "34676701",
        "50067101",
        "34676101",
        "32143201",
        "34676301",
        "32144601",
        "32145001",
        "34676501",
        "34676502",
        "36048401",
        "36048501",
        "34677101",
        "50037601",
        "32154401",
        "32154501",
        "32154701",
        "32155401",
        "34658401",
        "50082201",
        "34659403",
        "35066901",
        "35906101",
        "32334901",
        "34661501",
        "50126901",
        "34661601",
        "34663601",
        "50003101",
        "34141401",
        "34664301",
        "50027401",
        "34664701",
        "34731701",
        "34733501",
        "34734301",
        "34735301",
        "34735801",
        "34735901",
        "34736301",
        "34797701",
        "34737501",
        "34737901",
        "34739401",
        "34740201",
        "34332701",
        "30279001",
        "34333200",
        "34333201",
        "34333202",
        "34337501",
        "34333401",
        "34333501",
        "30282201",
        "30289201",
        "30292601",
        "30298301",
        "30298401",
        "34335100",
        "34335101",
        "34335102",
        "34335103",
        "34335104",
        "34335105",
        "34335106",
        "34335107",
        "35067601",
        "50028701",
        "50077601",
        "30287901",
        "34338501",
        "34338502",
        "34603201",
        "34603401",
        "36129501",
        "31518201",
        "34603601",
        "34603602",
        "50025101",
        "34603100",
        "34603101",
        "34603701",
        "31513201",
        "31513301",
        "31513801",
        "34604101",
        "35043101",
        "36024801",
        "31515401",
        "36066201",
        "34604102",
        "34605001",
        "34603603",
        "34605101",
        "50021601",
        "31517401",
        "34605401",
        "35876101",
        "36006101",
        "50031701",
        "34691101",
        "50087401",
        "34691301",
        "34691802",
        "34691501",
        "32169501",
        "34691601",
        "50189701",
        "34691701",
        "32174301",
        "34691801",
        "36156301",
        "50141801",
        "34692201",
        "34692501",
        "34692801",
        "34692802",
        "32172001",
        "34693101",
        "34693102",
        "50114701",
        "34321101",
        "34322101",
        "34324201",
        "34324501",
        "34988001",
        "34988201",
        "34988401",
        "34988501",
        "34990401",
        "34991001",
        "34991101",
        "34991301",
        "34991501",
        "34992101",
        "34992701",
        "34992901",
        "34889601",
        "34890101",
        "34890701",
        "50072901",
        "34890801",
        "34891701",
        "33015901",
        "33016001",
        "34891801",
        "34892101",
        "33016401",
        "33016701",
        "33016801",
        "33017101",
        "34156801",
        "34892301",
        "35980001",
        "36000501",
        "36000601",
        "36015301",
        "50003801",
        "50013001",
        "50037201",
        "34892401",
        "34892601",
        "50083201",
        "34895001",
        "34896101",
        "34896201",
        "34897801",
        "34898801",
        "35861101",
        "34898701",
        "34900301",
        "34900701",
        "33023201",
        "34902801",
        "34356701",
        "50192401",
        "34371502",
        "34359301",
        "50172001",
        "30535301",
        "30535401",
        "30535501",
        "34356800",
        "34356801",
        "34359701",
        "30536601",
        "30536701",
        "30536801",
        "34359901",
        "34360501",
        "30328401",
        "30328501",
        "30328601",
        "30328702",
        "30328901",
        "30329101",
        "30329701",
        "34418500",
        "34418501",
        "34418502",
        "50063701",
        "30546901",
        "34361701",
        "34362001",
        "30553301",
        "34369003",
        "50189401",
        "30557101",
        "30557401",
        "34364501",
        "30559301",
        "34365401",
        "30568001",
        "34367001",
        "34368101",
        "34374601",
        "30573901",
        "30574801",
        "30575001",
        "30575301",
        "30575401",
        "30575501",
        "30575601",
        "30576101",
        "30576201",
        "30576301",
        "30576501",
        "30576901",
        "30577001",
        "30577401",
        "30577501",
        "30577601",
        "30577901",
        "30578401",
        "30578501",
        "34369001",
        "34369002",
        "34369801",
        "30589301",
        "30589401",
        "30589501",
        "34370701",
        "30592601",
        "30592801",
        "30605701",
        "34363201",
        "34371501",
        "30595701",
        "30595801",
        "34365402",
        "30363501",
        "30363601",
        "34427801",
        "34371505",
        "34372801",
        "30600101",
        "34373001",
        "34373201",
        "30602801",
        "30603101",
        "34369004",
        "34363202",
        "34373901",
        "34369005",
        "34376401",
        "30620401",
        "30620501",
        "30620601",
        "30620701",
        "50040001",
        "30390401",
        "30390501",
        "34437001",
        "34859101",
        "34850601",
        "34851001",
        "50093401",
        "34851401",
        "34851701",
        "34852501",
        "36144201",
        "34852601",
        "50099301",
        "32958501",
        "32958701",
        "32959301",
        "32959501",
        "32959701",
        "32959801",
        "33224601",
        "34853201",
        "50046801",
        "50074501",
        "34853301",
        "34853701",
        "32963801",
        "32964201",
        "34108001",
        "34853801",
        "35906601",
        "36165201",
        "50020201",
        "50082901",
        "50084001",
        "32960801",
        "34853901",
        "50038301",
        "50118901",
        "50140401",
        "34854001",
        "50172201",
        "50127801",
        "34854801",
        "50148601",
        "32961301",
        "50093301",
        "34855501",
        "34855801",
        "36113201",
        "50082801",
        "34850401",
        "34856801",
        "34857201",
        "34857401",
        "34857001",
        "34852900",
        "34852901",
        "34857801",
        "32959001",
        "34857901",
        "36045601",
        "50009101",
        "50046701",
        "34858201",
        "36197601",
        "50151201",
        "50123401",
        "34858801",
        "34859001",
        "34853401",
        "34859501",
        "34677401",
        "32174601",
        "34677501",
        "36067101",
        "50039201",
        "50127001",
        "32175101",
        "34677901",
        "35922601",
        "32175301",
        "32175401",
        "34678001",
        "32176001",
        "34678202",
        "34678101",
        "35897001",
        "35963501",
        "36146301",
        "50016301",
        "50124001",
        "32178101",
        "32178201",
        "32178601",
        "32178901",
        "32179101",
        "32179201",
        "32179301",
        "32179501",
        "32179601",
        "32180101",
        "34678201",
        "50010201",
        "50028001",
        "50050701",
        "50131901",
        "32176401",
        "32176501",
        "32176801",
        "32176901",
        "34179001",
        "34678501",
        "34678502",
        "35050302",
        "32177300",
        "32177301",
        "32177302",
        "35825301",
        "32177601",
        "34679001",
        "34679002",
        "35652401",
        "35922801",
        "50035701",
        "34679101",
        "35980901",
        "34391101",
        "50076101",
        "34391901",
        "34392001",
        "34399200",
        "34399201",
        "34394401",
        "30758701",
        "30758901",
        "30759001",
        "30759101",
        "34394500",
        "34394503",
        "34394505",
        "50132401",
        "34394701",
        "34395401",
        "34395501",
        "34395801",
        "34396401",
        "34397001",
        "34398001",
        "50089601",
        "30807501",
        "30807601",
        "34399301",
        "35883301",
        "50105601",
        "50155901",
        "50174601",
        "34400001",
        "34400201",
        "36023401",
        "34401501",
        "30835701",
        "34401700",
        "34401701",
        "34401702",
        "50115701",
        "34402301",
        "34402401",
        "34402801",
        "30851501",
        "30959504",
        "34403901",
        "34405101",
        "34405301",
        "34405401",
        "34408701",
        "50130201",
        "30883901",
        "50063401",
        "34408101",
        "34408401",
        "30912501",
        "34408801",
        "34408900",
        "34408901",
        "34408902",
        "50171301",
        "34409401",
        "34409801",
        "34410501",
        "50015601",
        "50032201",
        "30935201",
        "34409301",
        "34410601",
        "50080201",
        "30836201",
        "30959401",
        "34401801",
        "34413101",
        "30936801",
        "34410901",
        "34411601",
        "34413601",
        "50078101",
        "32446301",
        "32446501",
        "32446601",
        "32447001",
        "32447401",
        "32447801",
        "32447901",
        "32448001",
        "32448201",
        "32448301",
        "32448501",
        "32448701",
        "32448901",
        "32449001",
        "32449101",
        "32449201",
        "32449501",
        "32451701",
        "32451801",
        "32451901",
        "32452001",
        "32452301",
        "32452601",
        "32452801",
        "34728000",
        "34728001",
        "34728002",
        "35057601",
        "35523701",
        "36125401",
        "50035801",
        "50087301",
        "50157001",
        "32453101",
        "32453301",
        "32453601",
        "32453701",
        "32454301",
        "32455001",
        "32455101",
        "32455401",
        "34728401",
        "35051601",
        "50026001",
        "50072001",
        "50154101",
        "34728501",
        "34728601",
        "50136401",
        "34728700",
        "34728701",
        "34728702",
        "35997401",
        "32457301",
        "34728801",
        "32457501",
        "34728901",
        "32464201",
        "32464301",
        "32464401",
        "32464601",
        "32464901",
        "32465401",
        "32465901",
        "32466001",
        "32466701",
        "32466901",
        "32468201",
        "34729000",
        "34729001",
        "34729003",
        "34729005",
        "34729002",
        "36129601",
        "50009801",
        "50009901",
        "50010101",
        "50014101",
        "50014201",
        "50142301",
        "50151601",
        "50168601",
        "50202401",
        "34729101",
        "34729201",
        "32457701",
        "34729301",
        "50151401",
        "34729401",
        "32459101",
        "34729601",
        "35052401",
        "50065701",
        "50073901",
        "50081301",
        "50118501",
        "50196601",
        "32459801",
        "34729801",
        "34729901",
        "34730501",
        "32461801",
        "32461901",
        "32462201",
        "32462301",
        "32462401",
        "35494101",
        "50115301",
        "32462601",
        "32463101",
        "32463501",
        "32463601",
        "34730701",
        "32463701",
        "34730901",
        "32464101",
        "34731101",
        "34731102",
        "50035601",
        "32182301",
        "32182401",
        "32182501",
        "32182601",
        "32182701",
        "32182801",
        "32182901",
        "32183701",
        "34666601",
        "35970401",
        "50134101",
        "32183901",
        "34666701",
        "50029001",
        "32185101",
        "32185201",
        "32185301",
        "34666801",
        "32186001",
        "32186301",
        "32186501",
        "32186601",
        "34666901",
        "34666902",
        "34666903",
        "35897401",
        "50102001",
        "34667001",
        "32189201",
        "32189302",
        "32189901",
        "32190001",
        "32190301",
        "32191601",
        "35912601",
        "50150401",
        "32192101",
        "34667401",
        "34667601",
        "35536801",
        "34667801",
        "34668001",
        "32205301",
        "32208301",
        "34668200",
        "34668201",
        "34668202",
        "34668203",
        "36014701",
        "36191201",
        "32194101",
        "34668301",
        "34668302",
        "32194701",
        "34668901",
        "34668902",
        "50130701",
        "32196501",
        "32196601",
        "32196701",
        "32196801",
        "32197001",
        "32197101",
        "32197201",
        "32197801",
        "32198001",
        "32198101",
        "32198201",
        "32199301",
        "34669101",
        "35498201",
        "34669301",
        "34669801",
        "34669901",
        "30714401",
        "34389401",
        "30718101",
        "30718301",
        "30718701",
        "30718801",
        "34389900",
        "34389902",
        "34389903",
        "34390401",
        "30727501",
        "34390801",
        "50087901",
        "34390901",
        "34389501",
        "30729201",
        "30729301",
        "30729801",
        "30730101",
        "34391200",
        "34391201",
        "34391202",
        "50161501",
        "30731501",
        "30732101",
        "34391401",
        "34391402",
        "34392101",
        "30739501",
        "30739901",
        "34392401",
        "34392402",
        "30740801",
        "30740901",
        "30741201",
        "34397202",
        "34392501",
        "50021801",
        "34392802",
        "34393001",
        "50028901",
        "30755801",
        "30756301",
        "34393901",
        "34393902",
        "34394001",
        "34407801",
        "30766901",
        "30767001",
        "30771901",
        "34396002",
        "34397101",
        "50152701",
        "30772001",
        "30772101",
        "30772601",
        "34396601",
        "34396602",
        "50013901",
        "34397501",
        "50015501",
        "34397901",
        "34403601",
        "30804601",
        "34399100",
        "34399101",
        "34399102",
        "34399103",
        "50027801",
        "30811501",
        "30811701",
        "30811901",
        "34360101",
        "34399800",
        "34399801",
        "34399802",
        "34400801",
        "30827401",
        "34401000",
        "34401001",
        "34401002",
        "34401101",
        "30829801",
        "30830001",
        "34401201",
        "34401202",
        "34401401",
        "50137001",
        "30838901",
        "34402001",
        "34402900",
        "34402901",
        "34402902",
        "50004101",
        "34403801",
        "30852201",
        "30854001",
        "34404000",
        "34404003",
        "34404004",
        "34404005",
        "50059601",
        "50170801",
        "50172901",
        "30852401",
        "30858901",
        "34404300",
        "34404301",
        "34404302",
        "34404700",
        "34404701",
        "34404702",
        "30869801",
        "34407101",
        "30921401",
        "30921701",
        "34389701",
        "34409900",
        "34409901",
        "34409902",
        "34411401",
        "34410301",
        "34410302",
        "30935401",
        "30935501",
        "34410701",
        "34410801",
        "34411402",
        "30952801",
        "30952901",
        "30953001",
        "34411801",
        "30954001",
        "34412201",
        "50114101",
        "30954501",
        "34412301",
        "30954801",
        "30954901",
        "30955001",
        "34412401",
        "50019101",
        "34412501",
        "34412502",
        "34413001",
        "30960001",
        "34413203",
        "34652201",
        "32347101",
        "34652501",
        "32347901",
        "32348001",
        "32348301",
        "32348401",
        "34652701",
        "50063601",
        "50120601",
        "34652901",
        "34653001",
        "34653100",
        "34653101",
        "34653102",
        "35066701",
        "50011701",
        "34653401",
        "34654101",
        "32353001",
        "34654200",
        "34654201",
        "34654202",
        "34654901",
        "32353901",
        "32354001",
        "34654401",
        "32354501",
        "34654601",
        "34654701",
        "32355001",
        "34654800",
        "34654801",
        "34654802",
        "50076401",
        "34655101",
        "50158501",
        "34655201",
        "32356302",
        "34655701",
        "34656001",
        "34656101",
        "34656102",
        "32357901",
        "34656201",
        "34656202",
        "50138601",
        "34656401",
        "34656501",
        "32360401",
        "34656701",
        "34656901",
        "34657001",
        "32360601",
        "32360801",
        "32361101",
        "34657100",
        "34657101",
        "34657102",
        "50162401",
        "32360001",
        "32362001",
        "34657201",
        "34657202",
        "34657301",
        "34657501",
        "34925101",
        "34925201",
        "34925401",
        "50085501",
        "34926201",
        "34926301",
        "34926401",
        "34926801",
        "34931501",
        "34927101",
        "34927401",
        "50009701",
        "34929400",
        "34929401",
        "34929402",
        "50044801",
        "50090701",
        "50112501",
        "33110401",
        "34929501",
        "35503001",
        "50122501",
        "34930801",
        "33114501",
        "33115101",
        "33133901",
        "34123801",
        "36091801",
        "50140201",
        "34931201",
        "50036801",
        "50041401",
        "34932201",
        "50044901",
        "34932901",
        "50117401",
        "34934201",
        "34927801",
        "34934301",
        "33120701",
        "33121701",
        "33121801",
        "33122501",
        "33123801",
        "50025701",
        "50049101",
        "34935001",
        "34935101",
        "30710501",
        "30711001",
        "34389303",
        "34389301",
        "34389601",
        "50155401",
        "30717501",
        "30717701",
        "34389801",
        "30720702",
        "30720703",
        "30720901",
        "30721001",
        "30721601",
        "34390001",
        "35071001",
        "50128701",
        "34409101",
        "34390101",
        "34390201",
        "35072501",
        "36005401",
        "50166301",
        "34390301",
        "35035501",
        "30726701",
        "30726801",
        "34411002",
        "34390601",
        "34390602",
        "34390603",
        "34390701",
        "34391001",
        "34391301",
        "30840701",
        "34391701",
        "35502801",
        "30734301",
        "30734701",
        "30734901",
        "30735101",
        "30735301",
        "30735901",
        "30736001",
        "34403705",
        "34391802",
        "50154201",
        "50160701",
        "30738501",
        "30738801",
        "34392301",
        "34392702",
        "30748501",
        "30748601",
        "30748801",
        "34392901",
        "34393200",
        "34393201",
        "34393202",
        "50179501",
        "34393501",
        "34393701",
        "34394101",
        "50075001",
        "34394201",
        "34394901",
        "30761301",
        "34395000",
        "34395001",
        "34395002",
        "34395101",
        "35558001",
        "34395201",
        "30763801",
        "34395301",
        "50032901",
        "30768101",
        "30768801",
        "34396100",
        "34396102",
        "34396103",
        "34396201",
        "34396301",
        "34396500",
        "34396501",
        "34396502",
        "34396700",
        "34396701",
        "34396702",
        "30773801",
        "30774201",
        "30774701",
        "30775101",
        "30775301",
        "34403708",
        "50074601",
        "34396901",
        "34397201",
        "35525801",
        "30788001",
        "34397601",
        "50156101",
        "30789001",
        "30791501",
        "34397701",
        "30791601",
        "30791901",
        "34390302",
        "30795001",
        "30795101",
        "30795701",
        "30795801",
        "30796001",
        "30799001",
        "30799801",
        "34398701",
        "35553101",
        "50011401",
        "50041901",
        "34398801",
        "34398901",
        "30803901",
        "34399001",
        "30807701",
        "34399400",
        "34399401",
        "30807901",
        "34399403",
        "34399404",
        "35877301",
        "30809601",
        "30809901",
        "30810101",
        "34399600",
        "34399601",
        "34399602",
        "36154901",
        "50108001",
        "50113201",
        "34399701",
        "34399902",
        "30814901",
        "34168301",
        "34400401",
        "34400402",
        "30817101",
        "34400600",
        "34400601",
        "34400602",
        "30818201",
        "30818601",
        "30818801",
        "34400701",
        "34400702",
        "50036201",
        "50147601",
        "30821301",
        "30821601",
        "30821701",
        "30821901",
        "30822201",
        "30822701",
        "30823601",
        "30823701",
        "34400900",
        "34400901",
        "34400902",
        "34408501",
        "34409201",
        "50085601",
        "50093001",
        "50154701",
        "30834901",
        "34401602",
        "30840601",
        "30840801",
        "34402100",
        "34402101",
        "34402102",
        "34402103",
        "30842401",
        "34402201",
        "34402502",
        "34403001",
        "34408603",
        "50066401",
        "34403101",
        "34408602",
        "30848601",
        "30848901",
        "30849301",
        "30986001",
        "34403301",
        "30850401",
        "34403501",
        "30967401",
        "30968401",
        "30969201",
        "30969501",
        "30970801",
        "30972101",
        "30972201",
        "30974501",
        "30975001",
        "30975401",
        "30976101",
        "30976601",
        "30978201",
        "30979001",
        "30979201",
        "30979501",
        "30980301",
        "30981901",
        "30982001",
        "30982301",
        "34403710",
        "34403713",
        "34403721",
        "50065401",
        "34403723",
        "35030801",
        "35069201",
        "35072101",
        "35072901",
        "35073301",
        "35073401",
        "35817801",
        "35992801",
        "36005201",
        "36060301",
        "50001001",
        "50021101",
        "50037101",
        "50038201",
        "50061901",
        "50089701",
        "50107401",
        "50108701",
        "50125701",
        "50127301",
        "50145101",
        "30860601",
        "30860801",
        "30860901",
        "34404500",
        "34404501",
        "34404502",
        "50132501",
        "30864801",
        "50095901",
        "35123701",
        "50005701",
        "34404901",
        "34401601",
        "34405001",
        "50070601",
        "30872401",
        "30872501",
        "30872701",
        "30872901",
        "34405700",
        "34405701",
        "34405702",
        "34405703",
        "36089001",
        "36115801",
        "50164401",
        "30875401",
        "30875601",
        "30876301",
        "34405900",
        "34405901",
        "34405902",
        "34406001",
        "34406101",
        "34406102",
        "30878601",
        "30878701",
        "34406201",
        "34406202",
        "34393101",
        "34393801",
        "34406301",
        "30880901",
        "30881101",
        "34406401",
        "34406600",
        "34406601",
        "50073201",
        "34406701",
        "50111301",
        "30888201",
        "34400501",
        "34406901",
        "34411501",
        "50095401",
        "34407001",
        "30891001",
        "30892001",
        "34407201",
        "50091001",
        "30892801",
        "30892901",
        "30893001",
        "30893101",
        "30893201",
        "30893401",
        "30893501",
        "30893601",
        "30894001",
        "30894301",
        "34407300",
        "34407302",
        "34407303",
        "34407306",
        "50059701",
        "34407301",
        "35070401",
        "35070601",
        "35070901",
        "35875001",
        "50014401",
        "50085701",
        "50160301",
        "30895701",
        "34407401",
        "34407501",
        "30900201",
        "34407601",
        "34407901",
        "50030601",
        "30901501",
        "30901701",
        "34408001",
        "34408002",
        "34408003",
        "34408200",
        "34408202",
        "34408203",
        "30905601",
        "30905801",
        "34405002",
        "34403711",
        "34408300",
        "34408302",
        "34408304",
        "35896301",
        "30907701",
        "34408601",
        "50105301",
        "50152001",
        "34409501",
        "50168501",
        "30918801",
        "34409701",
        "35070201",
        "30923301",
        "30923701",
        "30924201",
        "30924401",
        "35853701",
        "50016801",
        "50103101",
        "50139201",
        "34407602",
        "30929301",
        "30931901",
        "34410200",
        "34410201",
        "50113601",
        "30933501",
        "34396003",
        "30936901",
        "34411001",
        "30937901",
        "34411100",
        "34411102",
        "34411103",
        "34411101",
        "30943101",
        "34411200",
        "34411201",
        "34411202",
        "34411301",
        "30947501",
        "30948101",
        "30948501",
        "30949901",
        "34404601",
        "34411701",
        "50094101",
        "30965201",
        "34414001",
        "34412001",
        "30953701",
        "34412101",
        "34400301",
        "34412601",
        "34412701",
        "34403302",
        "34413901",
        "34413301",
        "34409601",
        "50064101",
        "50156501",
        "30962201",
        "34413400",
        "34413401",
        "34413402",
        "30963601",
        "34391501",
        "34392701",
        "34413802",
        "34413801",
        "34490201",
        "30706201",
        "34494101",
        "34495001",
        "34496801",
        "50094501",
        "50169301",
        "34491001",
        "50083601",
        "34490801",
        "34491701",
        "30677101",
        "30677301",
        "30677401",
        "30677601",
        "34491801",
        "34491901",
        "34492001",
        "34492301",
        "30681401",
        "34492501",
        "50184301",
        "50184401",
        "34492701",
        "30682301",
        "30682501",
        "30682701",
        "34492800",
        "34492801",
        "34492802",
        "34493001",
        "30707701",
        "30707801",
        "30707901",
        "30708401",
        "30708601",
        "30710301",
        "34493102",
        "50012301",
        "50097901",
        "50158101",
        "34493201",
        "34493400",
        "34493401",
        "34493402",
        "34493601",
        "34493801",
        "30689201",
        "30689801",
        "30689901",
        "30691601",
        "30691801",
        "34494001",
        "34494201",
        "34494301",
        "30693201",
        "34494501",
        "34533202",
        "34494601",
        "34494801",
        "34494901",
        "34495101",
        "34495201",
        "50089901",
        "34495402",
        "50018901",
        "50113101",
        "34495601",
        "34495701",
        "30699401",
        "34495901",
        "34496101",
        "30700101",
        "34496201",
        "34496401",
        "30701601",
        "34496601",
        "34497101",
        "34622208",
        "31740001",
        "34622205",
        "31741701",
        "31742201",
        "31742901",
        "34620301",
        "35975101",
        "31743001",
        "31743101",
        "31743601",
        "31744101",
        "31744301",
        "34620501",
        "34620502",
        "50087501",
        "31759001",
        "31759101",
        "34620601",
        "31759301",
        "34620701",
        "31760901",
        "31761001",
        "31761101",
        "31761401",
        "31761601",
        "31761701",
        "31761901",
        "31762101",
        "31762201",
        "31762301",
        "31762401",
        "31762501",
        "31763001",
        "31763101",
        "31763501",
        "34620801",
        "34620802",
        "35038801",
        "50206101",
        "34622202",
        "50106001",
        "31766201",
        "31766401",
        "31766501",
        "31766601",
        "31766701",
        "31766801",
        "31767201",
        "31767301",
        "31768401",
        "34621201",
        "34621202",
        "34621203",
        "50018001",
        "31768801",
        "31768901",
        "31769101",
        "31769501",
        "31769901",
        "31770501",
        "31770701",
        "31771801",
        "31771901",
        "31772001",
        "31772201",
        "31772501",
        "31772901",
        "31773501",
        "31773701",
        "31773801",
        "31773901",
        "31774401",
        "31774501",
        "31775201",
        "31775601",
        "31775801",
        "31775901",
        "31776201",
        "31776501",
        "31776601",
        "31776701",
        "31777001",
        "31777301",
        "31780301",
        "31780501",
        "34621302",
        "34621301",
        "35030901",
        "50017401",
        "50090201",
        "50134001",
        "31781301",
        "31782101",
        "34621501",
        "34621502",
        "34621503",
        "50060101",
        "31786801",
        "31786901",
        "31787201",
        "31787301",
        "31787401",
        "31787601",
        "31787701",
        "31787801",
        "31789401",
        "34621901",
        "34621902",
        "50144701",
        "34622001",
        "31790501",
        "31790701",
        "34622203",
        "31792501",
        "34622201",
        "50104001",
        "50140301",
        "31827701",
        "31827801",
        "31829001",
        "31830501",
        "31830601",
        "31830901",
        "31831201",
        "31831801",
        "31847701",
        "31847901",
        "31849401",
        "34622301",
        "34622303",
        "34622307",
        "34622304",
        "34622306",
        "35071901",
        "35812001",
        "50032501",
        "50149001",
        "50172701",
        "34622701",
        "34622702",
        "31798101",
        "31798201",
        "34622801",
        "31800701",
        "31800901",
        "31801201",
        "31803701",
        "34623001",
        "34623002",
        "35848901",
        "31806201",
        "34623401",
        "34623601",
        "31807902",
        "34622206",
        "34622207",
        "34622204",
        "31775501",
        "31810501",
        "31810701",
        "31811001",
        "31811301",
        "31811401",
        "31811801",
        "31812001",
        "31812201",
        "31812501",
        "31812701",
        "31812901",
        "31813301",
        "31813401",
        "31813501",
        "31813701",
        "31817301",
        "31817401",
        "31817501",
        "34134901",
        "34624001",
        "34624002",
        "34624003",
        "50172801",
        "50193401",
        "31818301",
        "34624101",
        "50072601",
        "31819301",
        "34624201",
        "34624202",
        "34615802",
        "35850201",
        "34624301",
        "31821001",
        "34624401",
        "31822701",
        "34624501",
        "34624502",
        "34624601",
        "34664901",
        "34665101",
        "50001401",
        "50109301",
        "32212301",
        "32212501",
        "32212701",
        "32212901",
        "32213101",
        "32213301",
        "32213401",
        "32213501",
        "32214301",
        "34665801",
        "34665802",
        "36169501",
        "50015201",
        "34665901",
        "34666001",
        "34666401",
        "34666201",
        "34666301",
        "34870101",
        "34870201",
        "32982901",
        "34870301",
        "34870302",
        "50067601",
        "50143401",
        "34870601",
        "50077001",
        "34870701",
        "32983601",
        "32984201",
        "32984601",
        "32985001",
        "32985101",
        "32985201",
        "34870801",
        "50128301",
        "34871101",
        "34871201",
        "34871301",
        "32990701",
        "32990801",
        "32990902",
        "32991401",
        "32992201",
        "34871400",
        "34871401",
        "34871402",
        "50008701",
        "50088701",
        "50094201",
        "50152401",
        "34871601",
        "34871801",
        "50030401",
        "34872001",
        "34872002",
        "35050401",
        "32988601",
        "32988901",
        "33674001",
        "34872101",
        "50022501",
        "50034101",
        "50034201",
        "50042101",
        "34872201",
        "34872301",
        "50088501",
        "32989301",
        "34872401",
        "35980201",
        "50046001",
        "34872501",
        "34872601",
        "34873101",
        "34872701",
        "34872801",
        "34872901",
        "34873001",
        "32632901",
        "32633301",
        "32633402",
        "34758601",
        "35049601",
        "36065601",
        "50039301",
        "50051201",
        "50087001",
        "50148401",
        "50151901",
        "50184701",
        "34758701",
        "50026201",
        "50154301",
        "32635601",
        "32635701",
        "32635901",
        "32637301",
        "32642301",
        "35048501",
        "50008401",
        "34759101",
        "50045201",
        "34759301",
        "36217801",
        "34759501",
        "32643401",
        "32643601",
        "32643801",
        "32644201",
        "32644401",
        "32644601",
        "32644801",
        "32645201",
        "34759601",
        "35971401",
        "50071801",
        "50126201",
        "34759701",
        "34760101",
        "50150601",
        "32647201",
        "34760201",
        "32649401",
        "34760501",
        "50023701",
        "34759001",
        "34760601",
        "32654001",
        "34760801",
        "34760802",
        "36163501",
        "32660201",
        "32660301",
        "32660901",
        "34760901",
        "35494401",
        "34761001",
        "34761201",
        "34761501",
        "34761701",
        "36041501",
        "50117001",
        "32671201",
        "34761901",
        "50134901",
        "36036201",
        "50027901",
        "50137901",
        "50181401",
        "34762101",
        "34762501",
        "34762601",
        "50150501",
        "34762701",
        "34762801",
        "50020701",
        "32674801",
        "34763001",
        "35049701",
        "34763301",
        "50124301",
        "50165101",
        "50181901",
        "32707201",
        "32708301",
        "32708501",
        "32709401",
        "32709701",
        "32712801",
        "32745501",
        "34763401",
        "34763402",
        "34763403",
        "34763405",
        "34763406",
        "36072101",
        "50006901",
        "50042301",
        "50051501",
        "50138101",
        "50148101",
        "32681001",
        "32681501",
        "50005201",
        "50050901",
        "35900401",
        "36091901",
        "36182301",
        "50003301",
        "50011501",
        "50018701",
        "50036701",
        "50105201",
        "32681601",
        "50138301",
        "34763701",
        "35835601",
        "36213801",
        "50013401",
        "34764001",
        "34764101",
        "50079201",
        "32683701",
        "32683801",
        "32683901",
        "34764201",
        "36185701",
        "50037501",
        "50151501",
        "34764301",
        "50135501",
        "50184601",
        "34764501",
        "34764502",
        "35549301",
        "32687901",
        "35899301",
        "36042601",
        "50016101",
        "50020601",
        "50145601",
        "34764801",
        "50146301",
        "50185001",
        "50033101",
        "34765301",
        "34765701",
        "50126301",
        "32692901",
        "32694401",
        "34765801",
        "50060701",
        "32695301",
        "50034501",
        "34765901",
        "34766101",
        "50037801",
        "50154501",
        "50062501",
        "32700101",
        "32700201",
        "32700301",
        "34763404",
        "34767001",
        "34767201",
        "34767301",
        "34767401",
        "50097001",
        "34239901",
        "34249902",
        "34241601",
        "34241401",
        "34241500",
        "34241501",
        "34241502",
        "34241701",
        "34242101",
        "30080701",
        "30080801",
        "34138302",
        "34242301",
        "50109601",
        "50150201",
        "34243401",
        "34243801",
        "30084401",
        "30084601",
        "34244601",
        "34244901",
        "50007401",
        "34245900",
        "34245901",
        "34245902",
        "34246101",
        "34246201",
        "34254801",
        "50004201",
        "30088601",
        "34252102",
        "30089701",
        "34246702",
        "35070801",
        "30091801",
        "34247001",
        "34248101",
        "34248601",
        "34248901",
        "30094301",
        "30094401",
        "34249101",
        "35863101",
        "50112901",
        "30109901",
        "30110201",
        "30110701",
        "30111201",
        "30111301",
        "30111401",
        "30111701",
        "34249700",
        "34249701",
        "34249702",
        "50011101",
        "50015101",
        "50085001",
        "50182101",
        "34249903",
        "30094801",
        "34250001",
        "34250301",
        "34250701",
        "30100401",
        "34252001",
        "30100801",
        "30100901",
        "30101001",
        "34252101",
        "34252201",
        "34252401",
        "34253401",
        "34253501",
        "50066101",
        "30105101",
        "34254001",
        "50113001",
        "50118101",
        "50130801",
        "30106901",
        "34254401",
        "34254901",
        "34916501",
        "34916801",
        "34917001",
        "34917301",
        "34923001",
        "34917601",
        "33141001",
        "34917801",
        "34917901",
        "34918501",
        "34918701",
        "50054001",
        "34918901",
        "34919201",
        "34919301",
        "34919601",
        "34919901",
        "34920201",
        "34920901",
        "34921201",
        "50031401",
        "34921700",
        "34921701",
        "34921702",
        "50043001",
        "50161001",
        "34922601",
        "34923101",
        "50116901",
        "33148000",
        "33148001",
        "33148006",
        "33148601",
        "33148701",
        "34923401",
        "50008801",
        "50082501",
        "34923501",
        "34924301",
        "31934101",
        "34606201",
        "34606202",
        "34606301",
        "31934601",
        "31934801",
        "34606600",
        "34606601",
        "34606602",
        "31935801",
        "34606701",
        "34606801",
        "31937301",
        "34607000",
        "34607001",
        "34607002",
        "50091501",
        "34607101",
        "31938701",
        "34469601",
        "34607301",
        "34607302",
        "35901801",
        "35911001",
        "50077201",
        "34607201",
        "34607401",
        "34607800",
        "34607801",
        "34607802",
        "35072601",
        "50131201",
        "31941201",
        "34608101",
        "50109701",
        "50181101",
        "34608201",
        "34608301",
        "34608401",
        "34608501",
        "31943601",
        "34608601",
        "31944301",
        "34608700",
        "34608701",
        "34608702",
        "50130601",
        "34608801",
        "31952301",
        "31952501",
        "31952800",
        "31952801",
        "31952802",
        "31953901",
        "31954501",
        "34609201",
        "34609202",
        "50044401",
        "50104701",
        "50129101",
        "31945601",
        "31945701",
        "31946001",
        "31946301",
        "34609501",
        "50105101",
        "31947501",
        "34609701",
        "34609702",
        "35857101",
        "34609801",
        "34609903",
        "31949901",
        "34610001",
        "34610101",
        "34610601",
        "31950301",
        "34610201",
        "35473301",
        "50152301",
        "34610301",
        "31951101",
        "34610401",
        "34610501",
        "34610801",
        "31162401",
        "34573701",
        "31163301",
        "34573901",
        "50160801",
        "34574301",
        "31164601",
        "50034801",
        "34574702",
        "34581001",
        "34581002",
        "34574901",
        "34569705",
        "34579606",
        "50162101",
        "50184001",
        "31166401",
        "34575301",
        "34575401",
        "31167701",
        "31167801",
        "34575501",
        "36153601",
        "31170101",
        "31170201",
        "31170601",
        "34575901",
        "50094901",
        "50185401",
        "31172701",
        "34576801",
        "50081401",
        "34576901",
        "34577001",
        "34577101",
        "50120801",
        "34577201",
        "50082101",
        "34577302",
        "34577303",
        "50125901",
        "50170101",
        "31176601",
        "31176701",
        "34577401",
        "50064901",
        "50099501",
        "34577601",
        "31178501",
        "34577800",
        "34577801",
        "34577802",
        "34577901",
        "31179701",
        "34579603",
        "34578101",
        "50042901",
        "50063801",
        "34578200",
        "34578201",
        "34578202",
        "34578301",
        "34578401",
        "31181701",
        "31181901",
        "31182201",
        "34579101",
        "50007301",
        "50087201",
        "50150901",
        "34573702",
        "50192601",
        "34579401",
        "31199701",
        "31200001",
        "31201501",
        "31202301",
        "34579601",
        "34579604",
        "50018301",
        "50024501",
        "50025601",
        "34579701",
        "34579901",
        "50167201",
        "34580001",
        "31187201",
        "34580101",
        "50073101",
        "31187601",
        "34580401",
        "34580601",
        "34580801",
        "50007701",
        "34581101",
        "34581201",
        "34581301",
        "31191301",
        "31191601",
        "31192101",
        "34581401",
        "34583702",
        "34582201",
        "50111901",
        "50173901",
        "34582402",
        "34582401",
        "34582501",
        "34580002",
        "34583401",
        "34579605",
        "34579607",
        "35546901",
        "34583701",
        "34578102",
        "34584001",
        "50108801",
        "32859201",
        "32859401",
        "32859501",
        "32859601",
        "32859701",
        "34811101",
        "32860002",
        "34811401",
        "34811801",
        "34815101",
        "32860201",
        "34812001",
        "34812101",
        "50092301",
        "32861601",
        "34812401",
        "34813001",
        "34813002",
        "32862401",
        "32862501",
        "34813101",
        "35851701",
        "34813201",
        "34813301",
        "34813401",
        "34813601",
        "50092401",
        "32867301",
        "32867401",
        "32870101",
        "34813701",
        "34813901",
        "34814101",
        "32865701",
        "34814201",
        "35825801",
        "50010501",
        "34814401",
        "34814801",
        "32866901",
        "34811201",
        "34815201",
        "32383801",
        "32384001",
        "34693600",
        "34693601",
        "34693603",
        "34693602",
        "32385001",
        "32385101",
        "32385201",
        "32385301",
        "32385501",
        "34693701",
        "50140601",
        "32386301",
        "34693901",
        "32386801",
        "32387001",
        "34694101",
        "34694301",
        "34694401",
        "34694601",
        "34689801",
        "34694701",
        "32389601",
        "32391101",
        "34694800",
        "34694801",
        "34694802",
        "34694803",
        "50096101",
        "34168901",
        "34695201",
        "32397601",
        "34695300",
        "34695301",
        "34695302",
        "34695303",
        "50074701",
        "34695601",
        "50039601",
        "32400801",
        "32401201",
        "32401301",
        "32401501",
        "32402001",
        "32402101",
        "34695801",
        "36182401",
        "32403301",
        "32403401",
        "32404701",
        "34695901",
        "32405401",
        "34696201",
        "32405801",
        "34696301",
        "34696501",
        "50159101",
        "32417701",
        "32419501",
        "34697401",
        "34697402",
        "34697403",
        "34697404",
        "34697405",
        "50131001",
        "50133601",
        "32407401",
        "50116601",
        "32408301",
        "32408501",
        "34697901",
        "34698001",
        "32410101",
        "34698501",
        "32411301",
        "34698600",
        "34698601",
        "34698602",
        "32411901",
        "34698701",
        "50061701",
        "50168001",
        "34698801",
        "32415001",
        "34699100",
        "34699101",
        "34699103",
        "34699102",
        "34679401",
        "34679601",
        "34679701",
        "34680101",
        "34680201",
        "34680301",
        "34680601",
        "50121801",
        "32220801",
        "34681301",
        "50192801",
        "34681501",
        "35400101",
        "32264601",
        "32264801",
        "32265001",
        "32265201",
        "32265301",
        "32267601",
        "32267701",
        "34681901",
        "34681902",
        "34681903",
        "35060401",
        "34682101",
        "32222901",
        "32222902",
        "32223501",
        "34682200",
        "34682201",
        "34682202",
        "50089001",
        "50134801",
        "50135701",
        "50137601",
        "50140101",
        "50156901",
        "32223901",
        "34682401",
        "32225101",
        "34682501",
        "34682601",
        "34682502",
        "35421001",
        "35958901",
        "50078501",
        "32262301",
        "32262501",
        "34683001",
        "50022201",
        "50036901",
        "34982901",
        "50125801",
        "34983201",
        "50024601",
        "34983701",
        "34983901",
        "31526401",
        "34984001",
        "31526701",
        "34572203",
        "34984801",
        "31529101",
        "31529501",
        "31529601",
        "31533801",
        "34985101",
        "50018601",
        "50082401",
        "50183401",
        "34985401",
        "34564702",
        "34985904",
        "31535201",
        "31535401",
        "31540101",
        "31540201",
        "31540401",
        "31540501",
        "34985901",
        "34986001",
        "34985902",
        "31536101",
        "34986501",
        "34985903",
        "31536801",
        "31537101",
        "31537401",
        "31537501",
        "31537601",
        "31537701",
        "31537801",
        "35045501",
        "35813801",
        "35831101",
        "50033401",
        "50076801",
        "50157801",
        "31538201",
        "31538501",
        "50118001",
        "31538801",
        "34987001",
        "50129401",
        "31539101",
        "34987301",
        "31539701",
        "31539801",
        "32082601",
        "34675606",
        "35061901",
        "32115501",
        "32115801",
        "32116001",
        "32117001",
        "32117101",
        "32117301",
        "32117801",
        "32117901",
        "32118101",
        "32118501",
        "32118601",
        "32119201",
        "32119301",
        "32119601",
        "32120201",
        "32120401",
        "32120501",
        "32121201",
        "32121901",
        "32122101",
        "32122201",
        "32122701",
        "32123701",
        "32124001",
        "32124701",
        "32124801",
        "32124901",
        "32125001",
        "32125101",
        "32125301",
        "32125601",
        "32125701",
        "32126801",
        "32127101",
        "32127201",
        "32127401",
        "32127501",
        "32127701",
        "32128601",
        "32129201",
        "32129601",
        "32129801",
        "32129901",
        "32134801",
        "32134901",
        "32135001",
        "32136701",
        "32137201",
        "32137401",
        "32137501",
        "32137701",
        "32137801",
        "32138101",
        "32138201",
        "32138301",
        "32138401",
        "32154301",
        "34124001",
        "34675603",
        "34675604",
        "34675605",
        "34675607",
        "35060801",
        "35061801",
        "50106201",
        "50149301",
        "31849501",
        "34610901",
        "34608000",
        "34608001",
        "34611001",
        "31850101",
        "34611101",
        "50005001",
        "34611401",
        "35811001",
        "34611500",
        "34611501",
        "34611502",
        "34612203",
        "31854001",
        "31854101",
        "31854401",
        "31854601",
        "31854701",
        "31854801",
        "31855401",
        "34611700",
        "34611704",
        "34611705",
        "34611702",
        "34611703",
        "50017701",
        "31857901",
        "34611802",
        "34614801",
        "31914201",
        "31863701",
        "31863901",
        "31864301",
        "34612200",
        "34612201",
        "34612202",
        "34612204",
        "34612205",
        "34612302",
        "50096901",
        "34612301",
        "31870701",
        "34612400",
        "34612401",
        "34612403",
        "34612402",
        "35986601",
        "31872701",
        "34612501",
        "35002901",
        "34612101",
        "34612602",
        "34614701",
        "31880401",
        "31880701",
        "31880901",
        "34612801",
        "31883501",
        "34613101",
        "50041001",
        "34613301",
        "31909701",
        "31909901",
        "31910401",
        "31910901",
        "31911101",
        "31911201",
        "31912701",
        "31914501",
        "31933301",
        "31933801",
        "34102801",
        "34613500",
        "34613501",
        "34613502",
        "34613503",
        "50035401",
        "50078001",
        "50083901",
        "50097101",
        "50131601",
        "50155101",
        "34613701",
        "34615501",
        "50126801",
        "34613801",
        "34613901",
        "31894001",
        "34614000",
        "34614001",
        "35075301",
        "35075302",
        "50163401",
        "31896001",
        "34614101",
        "31897401",
        "31907501",
        "31908101",
        "34614201",
        "34615101",
        "35843001",
        "50041301",
        "31898201",
        "31898301",
        "34614301",
        "34614401",
        "34612901",
        "34614501",
        "31903401",
        "34611801",
        "34614900",
        "34614901",
        "34614902",
        "31905301",
        "34615000",
        "34615001",
        "34615002",
        "34612803",
        "32268201",
        "32268301",
        "32268501",
        "34670201",
        "35505901",
        "34670501",
        "34671101",
        "32271501",
        "32272401",
        "34671001",
        "36007101",
        "32274301",
        "32274601",
        "34671102",
        "32280001",
        "32281301",
        "32283701",
        "32283901",
        "34671401",
        "34671402",
        "50007101",
        "32277701",
        "34671701",
        "34671901",
        "35074901",
        "34646401",
        "34645201",
        "32366901",
        "32367001",
        "32367301",
        "32367601",
        "32368201",
        "32369001",
        "32369401",
        "34641500",
        "34641501",
        "34641502",
        "35056001",
        "50003201",
        "50139601",
        "50170601",
        "34641601",
        "32370701",
        "34641701",
        "50144301",
        "34642102",
        "32371801",
        "34643101",
        "32380801",
        "32381101",
        "34644600",
        "34644601",
        "34644602",
        "34644603",
        "50001801",
        "50032701",
        "50108101",
        "34645301",
        "34645601",
        "34646701",
        "34641602",
        "50075201",
        "32366701",
        "34641401",
        "34645801",
        "34644701",
        "34460001",
        "34460101",
        "34460501",
        "50169601",
        "34460901",
        "50179101",
        "34461401",
        "34461601",
        "33890001",
        "34461901",
        "34462001",
        "34462002",
        "34472901",
        "35493201",
        "50180801",
        "34462301",
        "50166001",
        "30990501",
        "30990601",
        "34462801",
        "34462803",
        "30990901",
        "30991001",
        "30991201",
        "34302201",
        "34462901",
        "50122901",
        "34463001",
        "34463101",
        "30992501",
        "30992801",
        "34463300",
        "34463301",
        "34463302",
        "30993101",
        "30993201",
        "30993301",
        "34461902",
        "34463501",
        "34463601",
        "34464101",
        "30994501",
        "34464301",
        "35037901",
        "34464401",
        "30989701",
        "34464501",
        "34464601",
        "30996201",
        "30996601",
        "30996701",
        "30996801",
        "34465201",
        "34466601",
        "50014501",
        "34460002",
        "50097301",
        "50009001",
        "34465901",
        "34466101",
        "34466201",
        "30998101",
        "30998301",
        "34466400",
        "34466401",
        "34466402",
        "34466501",
        "30999801",
        "34466801",
        "34466802",
        "50177101",
        "34467101",
        "34467201",
        "34467401",
        "50031001",
        "50159301",
        "34467501",
        "34467701",
        "34468401",
        "31001701",
        "34468901",
        "50114801",
        "31002101",
        "31002201",
        "34469101",
        "31002501",
        "34469801",
        "34469803",
        "31005301",
        "34470501",
        "31024001",
        "31024201",
        "31024401",
        "31024501",
        "31024601",
        "31024901",
        "34470600",
        "34470601",
        "34470602",
        "34470603",
        "34473502",
        "35838201",
        "34477101",
        "35037501",
        "31006501",
        "34462802",
        "34471401",
        "31007001",
        "34471701",
        "31007201",
        "31007301",
        "34471802",
        "34471901",
        "34394601",
        "34466803",
        "34473201",
        "34463700",
        "34463701",
        "34473301",
        "31010201",
        "34473501",
        "50079101",
        "31011301",
        "34471600",
        "34471601",
        "34473601",
        "34461801",
        "34474401",
        "34474501",
        "34474601",
        "34477201",
        "34474901",
        "34475001",
        "34475101",
        "34475601",
        "34476001",
        "50019201",
        "31016501",
        "34477300",
        "34477302",
        "34477303",
        "34462601",
        "34464901",
        "34477701",
        "31020801",
        "31021001",
        "31021301",
        "34477800",
        "34477801",
        "34477802",
        "50012501",
        "34478201",
        "34478601",
        "34860201",
        "34860301",
        "34860501",
        "32993001",
        "32993101",
        "32993201",
        "32993301",
        "32993401",
        "32993701",
        "32993801",
        "32994001",
        "32994101",
        "34860601",
        "50046101",
        "50046901",
        "32994201",
        "34860701",
        "34860702",
        "32994501",
        "32994601",
        "32994801",
        "32994901",
        "32995001",
        "32995901",
        "32996001",
        "32996101",
        "32996201",
        "32996801",
        "34134701",
        "34860801",
        "50004601",
        "50109101",
        "32995301",
        "32995401",
        "32995501",
        "32995801",
        "34861001",
        "34861101",
        "34861201",
        "34861301",
        "34861701",
        "34862101",
        "34862201",
        "34862301",
        "34862401",
        "34862501",
        "34862901",
        "50065201",
        "34863001",
        "34862801",
        "34863101",
        "34863201",
        "34863301",
        "34863401",
        "34863501",
        "32997501",
        "34863701",
        "35852001",
        "35963601",
        "50050601",
        "50132301",
        "34863801",
        "34871001",
        "50117601",
        "34863901",
        "34864001",
        "34864201",
        "50183201",
        "50194301",
        "34864301",
        "35505601",
        "34864401",
        "34864501",
        "50109201",
        "34864601",
        "34864701",
        "32999201",
        "32999301",
        "32999401",
        "32999501",
        "32999701",
        "32999901",
        "33000601",
        "33000701",
        "33000801",
        "33000901",
        "33001101",
        "33001201",
        "34125001",
        "34135001",
        "34165801",
        "34169301",
        "34176101",
        "34185501",
        "34864801",
        "35474201",
        "35476601",
        "35480601",
        "35480701",
        "35492001",
        "35492101",
        "35507801",
        "35517401",
        "35517501",
        "35517601",
        "35521801",
        "35524301",
        "35551601",
        "35551701",
        "35813301",
        "35826001",
        "35842801",
        "35994201",
        "35994301",
        "36049001",
        "50026301",
        "50027101",
        "50027201",
        "50027301",
        "50046601",
        "50047101",
        "50067701",
        "50158701",
        "50168901",
        "34865001",
        "34865101",
        "34865201",
        "34865301",
        "34865401",
        "50044001",
        "34865501",
        "34865601",
        "34865701",
        "34870001",
        "33001701",
        "33001801",
        "34776601",
        "34865801",
        "34865901",
        "50003901",
        "50149901",
        "33002301",
        "34866001",
        "33011201",
        "33011401",
        "33011501",
        "33012001",
        "33012301",
        "33012501",
        "33012801",
        "33014601",
        "34866300",
        "34866301",
        "34866302",
        "50111801",
        "50133901",
        "34866401",
        "33002601",
        "33002701",
        "33003001",
        "33003301",
        "34866601",
        "50155501",
        "34866801",
        "34867001",
        "34867101",
        "33003901",
        "34867201",
        "34867301",
        "34867501",
        "34867601",
        "34867701",
        "34862001",
        "34867801",
        "33004101",
        "33004201",
        "34867901",
        "34868001",
        "50153401",
        "34868301",
        "50048601",
        "34868501",
        "34868601",
        "34868701",
        "34868801",
        "33004701",
        "33004801",
        "33005001",
        "33005201",
        "33005401",
        "33005501",
        "33005601",
        "33005801",
        "33005901",
        "33006101",
        "33006201",
        "33006301",
        "33006401",
        "33006501",
        "33006601",
        "33006701",
        "33006801",
        "33007101",
        "33007201",
        "33007301",
        "33008301",
        "33008401",
        "33008501",
        "33008701",
        "34868901",
        "35998801",
        "36093601",
        "50004701",
        "50046301",
        "50059201",
        "50064301",
        "50116101",
        "34869001",
        "34869101",
        "34869201",
        "34888001",
        "34869301",
        "34869401",
        "34869501",
        "50196101",
        "34869601",
        "34869701",
        "33009601",
        "33009801",
        "33010701",
        "34869801",
        "31957901",
        "34633401",
        "50070301",
        "34633501",
        "34633502",
        "35127201",
        "31959701",
        "31959801",
        "31959901",
        "31960401",
        "34633902",
        "50090501",
        "50094601",
        "31960601",
        "34634001",
        "34634002",
        "31961401",
        "31961501",
        "31961801",
        "34634101",
        "50089201",
        "31962401",
        "31962501",
        "31962701",
        "34634201",
        "31964201",
        "31964301",
        "31964501",
        "31964901",
        "31965201",
        "31965501",
        "34634300",
        "34634301",
        "34634304",
        "34634302",
        "34634303",
        "35040601",
        "35040602",
        "50014901",
        "50090401",
        "50094401",
        "50105001",
        "50108901",
        "50113301",
        "50139401",
        "50144601",
        "34634401",
        "31972301",
        "34634501",
        "34634502",
        "50035101",
        "34634503",
        "50116801",
        "31973301",
        "34634601",
        "31975201",
        "31975301",
        "31975501",
        "31976001",
        "31976201",
        "31976401",
        "31976801",
        "31977001",
        "31977101",
        "31978001",
        "31978002",
        "31978401",
        "31981801",
        "34162601",
        "34634701",
        "34634702",
        "34634703",
        "50098201",
        "35068501",
        "35832301",
        "36001901",
        "50010601",
        "50089101",
        "50184201",
        "31974001",
        "34634901",
        "50022801",
        "34635001",
        "50019801",
        "34635101",
        "50057401",
        "34904601",
        "50056701",
        "34904801",
        "34905001",
        "50057201",
        "34905201",
        "50056501",
        "50101001",
        "34905501",
        "50156801",
        "50057501",
        "34905901",
        "33044701",
        "34906101",
        "34906201",
        "50057801",
        "50057301",
        "34906801",
        "50056801",
        "34907001",
        "34907101",
        "50100901",
        "34907501",
        "50057601",
        "34907801",
        "50056601",
        "34908001",
        "33047401",
        "34908101",
        "36185801",
        "50007001",
        "50063001",
        "34908201",
        "50057901",
        "50162501",
        "34908401",
        "34908601",
        "34908701",
        "34909101",
        "34909201",
        "50100801",
        "50056201",
        "50100701",
        "50100601",
        "34910001",
        "50056301",
        "50057101",
        "34910401",
        "50008301",
        "50158901",
        "50006101",
        "34910801",
        "50032801",
        "34911001",
        "34911201",
        "34914001",
        "36146901",
        "50030001",
        "50116301",
        "34911401",
        "50057001",
        "34912001",
        "34912401",
        "50056901",
        "34912901",
        "34913001",
        "33053001",
        "33053301",
        "34913101",
        "50056401",
        "34913601",
        "33055601",
        "34913901",
        "31981901",
        "34618502",
        "34615701",
        "34615801",
        "31984801",
        "34615901",
        "34496701",
        "34616001",
        "31987601",
        "34616102",
        "34616103",
        "50017301",
        "31989001",
        "34616301",
        "34616401",
        "32009301",
        "31993001",
        "31993101",
        "31993201",
        "31993301",
        "31993401",
        "31993801",
        "31994701",
        "31994901",
        "31995001",
        "31995301",
        "31995501",
        "31995601",
        "31996001",
        "31996101",
        "31996301",
        "31996601",
        "31996701",
        "31997101",
        "31997501",
        "31997701",
        "31997801",
        "31998001",
        "31998101",
        "31998401",
        "31998701",
        "31998801",
        "31998901",
        "31999401",
        "34616701",
        "34616703",
        "50026701",
        "50071101",
        "50089401",
        "50106101",
        "50157701",
        "32000701",
        "32000801",
        "32001001",
        "32001101",
        "32001301",
        "32001401",
        "32001501",
        "32001601",
        "32001701",
        "32001901",
        "32002101",
        "32002201",
        "32002401",
        "32002701",
        "32003201",
        "32003401",
        "32003501",
        "32004401",
        "34616900",
        "34616901",
        "34616903",
        "34616902",
        "35035101",
        "32005201",
        "34617002",
        "34617202",
        "32010501",
        "34617500",
        "34617501",
        "34617503",
        "34617504",
        "34617505",
        "50016701",
        "50176401",
        "34617601",
        "34617704",
        "34617801",
        "32017501",
        "32017601",
        "34617901",
        "35818201",
        "32019301",
        "32019601",
        "34618101",
        "32021801",
        "34618201",
        "50104801",
        "34618301",
        "34618302",
        "50050301",
        "34618401",
        "35518201",
        "32025101",
        "34618501",
        "32043601",
        "32044001",
        "32044101",
        "32044201",
        "32044701",
        "32047801",
        "32048401",
        "34618503",
        "34618800",
        "34618801",
        "34618803",
        "34618804",
        "50000101",
        "34618802",
        "35518701",
        "50017901",
        "50089301",
        "32026301",
        "34618701",
        "50090601",
        "34618901",
        "32028401",
        "32028701",
        "32028901",
        "32029001",
        "32029301",
        "32029401",
        "32029501",
        "32029801",
        "32029901",
        "32030101",
        "32030201",
        "32030301",
        "32030501",
        "32030601",
        "32031701",
        "34619101",
        "32032101",
        "32032701",
        "34619200",
        "34619201",
        "34619202",
        "34619301",
        "32034501",
        "34617702",
        "34617703",
        "32036801",
        "32037001",
        "32037101",
        "32037201",
        "32037301",
        "32037401",
        "32037501",
        "32037901",
        "32038001",
        "32038101",
        "34619500",
        "34619501",
        "34619502",
        "34619503",
        "32041501",
        "32041601",
        "32041801",
        "32042001",
        "34619901",
        "36103001",
        "34164901",
        "34165001",
        "34165101",
        "34165301",
        "34165600",
        "34165601",
        "50029101",
        "35546501",
        "50045501",
        "34949901",
        "36164801",
        "34950001",
        "34950101",
        "34950201",
        "34950301",
        "35964501",
        "50143701",
        "34950401",
        "34950501",
        "34950600",
        "34950601",
        "34950602",
        "35913601",
        "50021901",
        "50142701",
        "34950701",
        "34950801",
        "34950901",
        "50030101",
        "34709000",
        "34709003",
        "50091901",
        "34709002",
        "34709501",
        "34710201",
        "32469201",
        "32469601",
        "32469701",
        "32470201",
        "32470301",
        "34710301",
        "34710302",
        "34711201",
        "50113901",
        "34711701",
        "34712201",
        "34712801",
        "34713401",
        "34713901",
        "32470401",
        "34714600",
        "34714601",
        "34714602",
        "34714604",
        "34714603",
        "35548601",
        "50138401",
        "50157201",
        "50135901",
        "34715301",
        "34715601",
        "34716301",
        "34716501",
        "34716601",
        "32478201",
        "32478401",
        "32479001",
        "32479101",
        "32479201",
        "34100101",
        "34716700",
        "34716701",
        "34716702",
        "36063501",
        "50070801",
        "50146001",
        "34727701",
        "34716901",
        "34727001",
        "34727501",
        "50059801",
        "50140001",
        "34717301",
        "34717501",
        "34718401",
        "34718001",
        "34718301",
        "34718601",
        "34718701",
        "34718901",
        "32482901",
        "34719201",
        "35065001",
        "34719301",
        "32484201",
        "34719601",
        "50174901",
        "50175201",
        "34721902",
        "34719801",
        "35965901",
        "34720001",
        "36047401",
        "36047501",
        "36155401",
        "34720201",
        "34720501",
        "32485301",
        "32485501",
        "32485601",
        "32485701",
        "32485801",
        "34725101",
        "34726402",
        "34726403",
        "50124501",
        "34721001",
        "35996901",
        "32486801",
        "34721601",
        "34721901",
        "34721903",
        "50122701",
        "32489401",
        "34722501",
        "35052801",
        "36173001",
        "50020001",
        "34722701",
        "34723101",
        "34723201",
        "50101301",
        "34723401",
        "34723402",
        "50139101",
        "34723501",
        "32490201",
        "32490301",
        "32490401",
        "32490601",
        "32491001",
        "32491301",
        "32491601",
        "32492701",
        "32492901",
        "32493001",
        "32493201",
        "32493301",
        "32493501",
        "32493601",
        "32493701",
        "32494401",
        "32494501",
        "32494601",
        "32494801",
        "32494901",
        "32495101",
        "32495601",
        "32495701",
        "32495801",
        "32496401",
        "32496901",
        "32499701",
        "32501201",
        "32501301",
        "34723900",
        "34723901",
        "34723902",
        "34723904",
        "34723903",
        "35053001",
        "35055101",
        "35055901",
        "35058001",
        "35479601",
        "50019701",
        "50110701",
        "50142801",
        "50203401",
        "34724001",
        "36128601",
        "34724301",
        "32489301",
        "32504701",
        "32504702",
        "32506101",
        "32506301",
        "32513001",
        "32513501",
        "32513601",
        "33677201",
        "34147801",
        "34725102",
        "34725103",
        "50006001",
        "50132001",
        "34725901",
        "34726201",
        "32502501",
        "34726401",
        "50019901",
        "34726701",
        "34727301",
        "34727101",
        "34719501",
        "34727401",
        "34727402",
        "34635301",
        "50095801",
        "34636101",
        "34644101",
        "31719501",
        "34637201",
        "50129301",
        "34638001",
        "34644401",
        "34638500",
        "34638501",
        "34638502",
        "50082301",
        "50139901",
        "31722901",
        "31729001",
        "34636102",
        "34638601",
        "34638603",
        "50092101",
        "34639001",
        "50130001",
        "31728101",
        "34639101",
        "34639102",
        "50090001",
        "50111501",
        "34640102",
        "31729301",
        "34639301",
        "34639302",
        "35034601",
        "50196901",
        "32379401",
        "34640101",
        "50100401",
        "31203301",
        "31203501",
        "31203901",
        "31204501",
        "31205101",
        "34584201",
        "34587102",
        "35042401",
        "35552601",
        "35837401",
        "36147601",
        "36160601",
        "50067801",
        "34588001",
        "34584301",
        "50087101",
        "50134201",
        "31206801",
        "34584501",
        "34584601",
        "31208501",
        "34584701",
        "31208801",
        "34146001",
        "35550801",
        "31209301",
        "34585401",
        "31209601",
        "34585601",
        "34586001",
        "34586201",
        "34586301",
        "34586401",
        "31213401",
        "34586801",
        "31213701",
        "34587001",
        "31214901",
        "31215001",
        "35918203",
        "50099601",
        "34587901",
        "31209901",
        "31210001",
        "31211801",
        "35655001",
        "35918201",
        "35918202",
        "35918204",
        "31221501",
        "31221701",
        "31221801",
        "31221901",
        "31222201",
        "31222301",
        "31222401",
        "31222601",
        "31222801",
        "34184901",
        "34588200",
        "34588201",
        "34588203",
        "34588204",
        "50008001",
        "34588301",
        "31218501",
        "34588501",
        "50079601",
        "50082701",
        "31219001",
        "34588701",
        "34588801",
        "31219901",
        "31220001",
        "31220101",
        "31220301",
        "31220401",
        "34588901",
        "50072401",
        "31221001",
        "34585900",
        "34585901",
        "34589101",
        "50023901",
        "32748602",
        "32748802",
        "32749101",
        "32749202",
        "32749401",
        "32749801",
        "34780301",
        "34780601",
        "36177001",
        "50004801",
        "50110501",
        "50114901",
        "34780901",
        "50106701",
        "50106801",
        "50129801",
        "32753401",
        "32754101",
        "32754201",
        "32754301",
        "32754401",
        "32755001",
        "32758301",
        "34115701",
        "34122901",
        "34781000",
        "34781001",
        "34781002",
        "50017101",
        "50035901",
        "50101701",
        "50143101",
        "32779001",
        "32779301",
        "34786901",
        "34795401",
        "36218801",
        "32759501",
        "32759601",
        "32759701",
        "32759801",
        "32759901",
        "32760101",
        "32760301",
        "32760501",
        "32760601",
        "32760701",
        "32760801",
        "32760901",
        "32761101",
        "32761201",
        "32761301",
        "32761501",
        "32761601",
        "34124501",
        "34127501",
        "34781301",
        "35399401",
        "50028501",
        "34781401",
        "34781801",
        "50022101",
        "50084501",
        "50097201",
        "32763501",
        "32763602",
        "32763901",
        "32764101",
        "32764202",
        "34783001",
        "50006301",
        "50128401",
        "50145001",
        "32765201",
        "32765301",
        "32765501",
        "32765601",
        "32765701",
        "32766001",
        "32766201",
        "34139401",
        "34783301",
        "50012101",
        "34783901",
        "50136001",
        "32770701",
        "32770901",
        "34784201",
        "35931001",
        "50023601",
        "32771501",
        "32771601",
        "34784601",
        "35831301",
        "50010001",
        "50048801",
        "32773801",
        "32773901",
        "32774201",
        "32774601",
        "32776401",
        "34100901",
        "34784800",
        "34784801",
        "34784802",
        "35048901",
        "35831601",
        "35848301",
        "35929501",
        "36070501",
        "36187301",
        "50033701",
        "50163601",
        "34785901",
        "34786301",
        "36222101",
        "50071001",
        "34787101",
        "50130401",
        "32778801",
        "50059101",
        "34787201",
        "32780901",
        "32781301",
        "34787401",
        "35047901",
        "50009301",
        "50020801",
        "50023801",
        "50025901",
        "50027501",
        "50036001",
        "50065501",
        "50118201",
        "32781801",
        "32783701",
        "32783801",
        "32784201",
        "32784301",
        "32784501",
        "32784602",
        "32784801",
        "32785301",
        "32785501",
        "34787501",
        "35048801",
        "35508201",
        "50069901",
        "50131501",
        "50138501",
        "32786801",
        "32786901",
        "32787001",
        "32787101",
        "32787201",
        "32787301",
        "32787401",
        "32787601",
        "34787901",
        "35395901",
        "32787801",
        "34788301",
        "50068901",
        "32788701",
        "35049801",
        "50022901",
        "50153801",
        "32790001",
        "32790101",
        "32790201",
        "32790301",
        "34788501",
        "32790401",
        "34788601",
        "50006601",
        "34788901",
        "50104101",
        "34789301",
        "32791601",
        "32791801",
        "32809401",
        "34789501",
        "50025501",
        "50028201",
        "34790401",
        "34791001",
        "50173601",
        "32791501",
        "32805401",
        "32805501",
        "32805701",
        "32805901",
        "32806001",
        "32806101",
        "32806401",
        "32807701",
        "32807801",
        "32808701",
        "32808901",
        "32809001",
        "32809101",
        "32809201",
        "32817401",
        "34166001",
        "34791200",
        "34791201",
        "34791202",
        "34791203",
        "35047701",
        "50037401",
        "50156201",
        "50190801",
        "34791301",
        "50059001",
        "34791601",
        "34792101",
        "32796501",
        "34792801",
        "32795501",
        "34792601",
        "50050401",
        "34782901",
        "34792701",
        "50049401",
        "34793101",
        "32799801",
        "32800001",
        "32800102",
        "32800302",
        "32800601",
        "32800701",
        "34793301",
        "50062001",
        "34793601",
        "34793801",
        "34794201",
        "34794701",
        "34795101",
        "50049301",
        "34687301",
        "32284501",
        "34687401",
        "34687901",
        "34688001",
        "34688201",
        "32286501",
        "32286601",
        "32286901",
        "32288701",
        "34688301",
        "34688302",
        "50128201",
        "32288901",
        "32289001",
        "34688501",
        "34688502",
        "34688600",
        "34688601",
        "34688602",
        "34688603",
        "34688702",
        "34688701",
        "34688801",
        "34688802",
        "34689201",
        "34178001",
        "34689301",
        "34689302",
        "34689902",
        "34690101",
        "32299901",
        "34690301",
        "34690302",
        "34690303",
        "50122201",
        "34690401",
        "34690601",
        "34690701",
        "50134401",
        "50015401",
        "34383701",
        "35885301",
        "34363803",
        "50030701",
        "34363801",
        "50065001",
        "34339601",
        "30304101",
        "34339701",
        "34340401",
        "34340601",
        "30307801",
        "30308001",
        "30308101",
        "30308201",
        "34340801",
        "34340802",
        "34340803",
        "34341701",
        "36044501",
        "34341301",
        "34341601",
        "34341901",
        "30306301",
        "30307001",
        "34342000",
        "34342001",
        "34342002",
        "34665102",
        "34342201",
        "50012801",
        "50176801",
        "33173701",
        "33173801",
        "33174001",
        "33174601",
        "33182001",
        "34951001",
        "50075101",
        "34951101",
        "34951501",
        "34951801",
        "34946401",
        "33176601",
        "33177101",
        "33182101",
        "34952101",
        "50030201",
        "50034701",
        "50096001",
        "50096601",
        "34952201",
        "50117300",
        "50117301",
        "50133801",
        "50062301",
        "50062401",
        "33176501",
        "33176701",
        "33176801",
        "33176901",
        "33177401",
        "33178301",
        "33179701",
        "34953001",
        "35516801",
        "35845801",
        "35875501",
        "35997801",
        "50005601",
        "50028601",
        "50104401",
        "34952501",
        "33179901",
        "34952601",
        "36070301",
        "34952701",
        "34325901",
        "30310301",
        "34332702",
        "30310401",
        "34326201",
        "30311501",
        "30311601",
        "34327201",
        "35389501",
        "50139501",
        "50160501",
        "34327301",
        "30312201",
        "30312301",
        "34327202",
        "30312601",
        "34275700",
        "34275701",
        "34328001",
        "34328101",
        "34328301",
        "30313001",
        "34328401",
        "50139001",
        "34329101",
        "34330501",
        "30314101",
        "34331301",
        "34325801",
        "50032101",
        "50061801",
        "34331901",
        "30314301",
        "34332501",
        "50049201",
        "34845601",
        "34845701",
        "34845801",
        "36174201",
        "50139701",
        "34845901",
        "34846101",
        "34846201",
        "34846202",
        "34846301",
        "34846401",
        "50121601",
        "50122301",
        "50190201",
        "34846701",
        "32968001",
        "34846801",
        "50040401",
        "32968201",
        "34847000",
        "34847001",
        "34847002",
        "50046401",
        "34847201",
        "34847401",
        "50181601",
        "34847501",
        "32971101",
        "34847601",
        "34848202",
        "50138801",
        "32972300",
        "32972301",
        "32972302",
        "32972601",
        "32972901",
        "32973001",
        "32973601",
        "32973801",
        "32973901",
        "32974301",
        "32979101",
        "32981001",
        "34848201",
        "34848203",
        "35500401",
        "35881801",
        "36070201",
        "36122001",
        "50042601",
        "50043501",
        "50045801",
        "50058101",
        "50123301",
        "50164101",
        "34806301",
        "34806601",
        "34807901",
        "34808301",
        "50002501",
        "34122801",
        "34808701",
        "32884901",
        "32885301",
        "32886301",
        "34810901",
        "32876601",
        "34808702",
        "34809201",
        "34809700",
        "34809701",
        "34809702",
        "34809900",
        "34809901",
        "34809902",
        "34809903",
        "32883501",
        "34810201",
        "34810600",
        "34810601",
        "34810602",
        "31135301",
        "34508801",
        "34509001",
        "34510801",
        "34514001",
        "31135901",
        "31136101",
        "31136201",
        "31136501",
        "34509301",
        "34509401",
        "31137201",
        "34510701",
        "34512001",
        "50065101",
        "34513301",
        "34509601",
        "34515801",
        "50196801",
        "34517901",
        "34518201",
        "31139701",
        "34518701",
        "50076501",
        "50076601",
        "34518801",
        "50158201",
        "31140601",
        "34520001",
        "50151101",
        "34520101",
        "34520701",
        "34520801",
        "34520802",
        "50080801",
        "50080901",
        "34522301",
        "31143801",
        "34523701",
        "36147501",
        "34524401",
        "31144301",
        "31145401",
        "31147201",
        "34524500",
        "34524501",
        "34524502",
        "36165501",
        "34525101",
        "50062601",
        "50115401",
        "34527401",
        "31150601",
        "34528901",
        "34528902",
        "34528903",
        "35493601",
        "50040101",
        "31149301",
        "34530501",
        "30113801",
        "30113901",
        "30114201",
        "35493901",
        "30115001",
        "30115101",
        "34217905",
        "50186501",
        "34192001",
        "30118701",
        "50070901",
        "30123301",
        "34203203",
        "34194101",
        "34209803",
        "30128102",
        "34195001",
        "35813201",
        "50107601",
        "50157601",
        "30116401",
        "30128901",
        "34195401",
        "30129801",
        "35971501",
        "34195601",
        "30130601",
        "34196500",
        "34196501",
        "34196502",
        "30132101",
        "34196601",
        "50040801",
        "36033901",
        "50012701",
        "50016901",
        "34217911",
        "50005101",
        "50175101",
        "34197301",
        "50112801",
        "34198501",
        "30140601",
        "36076301",
        "50015001",
        "34199201",
        "30143201",
        "50092201",
        "30146001",
        "34200001",
        "34200301",
        "50129001",
        "30152101",
        "34201601",
        "50150301",
        "30155401",
        "34203001",
        "30158501",
        "34203202",
        "50103801",
        "30159401",
        "30161001",
        "50048501",
        "50195501",
        "30165001",
        "30165601",
        "34217906",
        "36005501",
        "34206801",
        "30169901",
        "36005601",
        "50115801",
        "34207501",
        "34208301",
        "36068701",
        "34203206",
        "30176701",
        "34209801",
        "34209802",
        "50164801",
        "30179801",
        "34210001",
        "50185501",
        "50202001",
        "34210201",
        "34210301",
        "50168201",
        "30181101",
        "30181201",
        "34203003",
        "35855001",
        "30138501",
        "30184401",
        "34203005",
        "34198504",
        "50004301",
        "30183701",
        "35526301",
        "50049801",
        "50076001",
        "50116201",
        "34212401",
        "36014901",
        "50119001",
        "50175301",
        "34213201",
        "30192101",
        "30192201",
        "34217910",
        "34203201",
        "30193601",
        "34222101",
        "34214401",
        "34217908",
        "34214901",
        "34221401",
        "34215001",
        "30194901",
        "34215101",
        "50152201",
        "34203205",
        "34216001",
        "30199101",
        "30199201",
        "30199301",
        "30200001",
        "34198502",
        "50082001",
        "34216701",
        "30200501",
        "34209201",
        "30200901",
        "30201001",
        "30201101",
        "30201601",
        "30201701",
        "30201901",
        "30204901",
        "30219801",
        "34154501",
        "34217200",
        "34217202",
        "34217203",
        "34217205",
        "34217912",
        "35863001",
        "50060201",
        "50093701",
        "50116501",
        "34203204",
        "30215301",
        "30217301",
        "30217601",
        "30218101",
        "30218201",
        "30218301",
        "30218501",
        "30219301",
        "30220501",
        "30221901",
        "30222001",
        "30222101",
        "34217904",
        "34217907",
        "34217909",
        "36087701",
        "36176801",
        "36188901",
        "50014601",
        "50072801",
        "50077501",
        "50100001",
        "50115901",
        "50157501",
        "50171601",
        "34220001",
        "50110801",
        "30211701",
        "30211901",
        "36172101",
        "30212301",
        "30212501",
        "30212601",
        "30214101",
        "34222201",
        "33183201",
        "34914101",
        "33184901",
        "34914301",
        "34914401",
        "34914501",
        "34914601",
        "33186601",
        "33188501",
        "33189201",
        "34915101",
        "50187201",
        "34915201",
        "50101801",
        "34915301",
        "35942001",
        "34915601",
        "34915701",
        "34915801",
        "34915901",
        "33196401",
        "33198202",
        "34916101",
        "32419801",
        "34699501",
        "32420201",
        "32420301",
        "34699801",
        "34700001",
        "34700301",
        "34700501",
        "34700701",
        "34701101",
        "32421601",
        "32421701",
        "32421901",
        "32422101",
        "32422301",
        "32422401",
        "32422501",
        "32422601",
        "32423201",
        "34701600",
        "34701601",
        "34701603",
        "34701602",
        "34701604",
        "35054401",
        "35525901",
        "50117801",
        "34701701",
        "32423801",
        "34701801",
        "32424201",
        "32424401",
        "34702301",
        "34702501",
        "32425501",
        "32425901",
        "32426001",
        "32426301",
        "32426401",
        "32426701",
        "32427201",
        "32427301",
        "32428301",
        "34702600",
        "34702601",
        "34702602",
        "34702604",
        "34702603",
        "35052701",
        "35055301",
        "36175701",
        "50068601",
        "50081001",
        "50081101",
        "50130101",
        "31541401",
        "31541402",
        "34605501",
        "31542101",
        "34605701",
        "36215401",
        "31549301",
        "34122201",
        "34606000",
        "34606001",
        "34606002",
        "34559902",
        "34559903",
        "34560301",
        "31227902",
        "31228201",
        "31228301",
        "31229001",
        "34560304",
        "34568401",
        "31229301",
        "31229401",
        "31229501",
        "31230001",
        "34560701",
        "31230501",
        "31230601",
        "31230801",
        "34560800",
        "34560801",
        "34560802",
        "31231401",
        "31231801",
        "31232101",
        "31232401",
        "31232501",
        "31234501",
        "34561001",
        "34561002",
        "34561401",
        "50064001",
        "34565511",
        "34565504",
        "31237301",
        "34565503",
        "34565513",
        "34565505",
        "34562901",
        "50106501",
        "34560308",
        "31244501",
        "34560312",
        "35043301",
        "34565506",
        "31245601",
        "31246701",
        "34564100",
        "34564101",
        "34564102",
        "35957101",
        "31247001",
        "31247101",
        "31247201",
        "31247401",
        "31247501",
        "34560303",
        "35890601",
        "34564401",
        "34564701",
        "31250301",
        "31250901",
        "31251001",
        "34564901",
        "31251801",
        "34565508",
        "50138001",
        "31252101",
        "31252201",
        "34560311",
        "50107501",
        "31255101",
        "31255201",
        "34565501",
        "34565601",
        "34563501",
        "31259601",
        "34560310",
        "31261201",
        "31261901",
        "31262001",
        "31262101",
        "34566401",
        "50126601",
        "31264901",
        "34566902",
        "34566903",
        "34565602",
        "34565502",
        "31265901",
        "34565507",
        "34567401",
        "31271901",
        "34565509",
        "34565512",
        "31269501",
        "34566901",
        "34567901",
        "31270501",
        "34560307",
        "31271501",
        "31271701",
        "31272801",
        "34565510",
        "34560309",
        "31282601",
        "31282801",
        "31283301",
        "31283901",
        "31288601",
        "31288801",
        "34568402",
        "34568403",
        "34565515",
        "50095001",
        "34568701",
        "35973301",
        "50099701",
        "31276101",
        "34565514",
        "31276601",
        "34560305",
        "34560306",
        "50123701",
        "34569001",
        "34560302",
        "34569301",
        "34589401",
        "34589801",
        "34596201",
        "34590101",
        "31554501",
        "34590301",
        "34590401",
        "31554601",
        "34590501",
        "31554901",
        "34590601",
        "34590901",
        "50100501",
        "34591201",
        "34591301",
        "34591501",
        "31558001",
        "31558101",
        "31558201",
        "31558301",
        "31558401",
        "31558601",
        "31558701",
        "34591801",
        "50025201",
        "34591901",
        "34592401",
        "34593001",
        "34602601",
        "34593101",
        "34593501",
        "34593601",
        "34594001",
        "34594401",
        "34594501",
        "34594601",
        "34594602",
        "31564201",
        "34594701",
        "34594702",
        "50073001",
        "34595001",
        "31565501",
        "34595101",
        "34598401",
        "31565601",
        "34595201",
        "34595401",
        "31567001",
        "31567101",
        "31567102",
        "34595801",
        "50068701",
        "31567301",
        "34595901",
        "34596001",
        "31567501",
        "34596101",
        "31568801",
        "34596601",
        "34596801",
        "34597001",
        "31570701",
        "34596401",
        "34596602",
        "50018201",
        "50075901",
        "34597201",
        "31571401",
        "34597501",
        "34598101",
        "34598201",
        "34598301",
        "34598701",
        "31573701",
        "34598801",
        "31574001",
        "34593801",
        "35045201",
        "31574401",
        "34599001",
        "31576001",
        "31576501",
        "31576601",
        "31576701",
        "31576901",
        "31577001",
        "31577401",
        "31577501",
        "31577601",
        "31577701",
        "34189401",
        "34599201",
        "35812101",
        "35920601",
        "36153701",
        "50063201",
        "50079001",
        "50088301",
        "50088801",
        "50101201",
        "50136301",
        "50173501",
        "34599301",
        "34591902",
        "34600601",
        "31580201",
        "34600901",
        "50111601",
        "31582402",
        "34601301",
        "34601501",
        "34601601",
        "31584801",
        "31585501",
        "34602101",
        "34602102",
        "34602103",
        "34601001",
        "50058801",
        "50064601",
        "50128101",
        "50134301",
        "50198701",
        "34602201",
        "34602301",
        "34602302",
        "35045301",
        "34602501",
        "31034601",
        "31034801",
        "31035301",
        "34342801",
        "34343001",
        "31036301",
        "34343101",
        "34343201",
        "31037801",
        "34343701",
        "31038301",
        "31040101",
        "34343800",
        "34343801",
        "34343802",
        "31038801",
        "34343901",
        "34344101",
        "34344201",
        "31040301",
        "34344401",
        "34345001",
        "31042701",
        "31042801",
        "31043001",
        "31043101",
        "31043201",
        "31043601",
        "31045201",
        "31045601",
        "31045901",
        "31046101",
        "31046201",
        "31046501",
        "31046801",
        "31046901",
        "31047201",
        "31047301",
        "31047801",
        "34345100",
        "34345101",
        "34345102",
        "34345103",
        "34345104",
        "35070301",
        "34345301",
        "31053101",
        "34345401",
        "34345501",
        "34345601",
        "50194401",
        "31055001",
        "31055101",
        "31055201",
        "31055301",
        "31056601",
        "34345702",
        "31057701",
        "31057801",
        "31058101",
        "31058201",
        "31058401",
        "31059101",
        "31059601",
        "31059701",
        "31059801",
        "31060201",
        "31060401",
        "34345900",
        "34345901",
        "34345902",
        "34345903",
        "34346001",
        "31064701",
        "34346500",
        "34346501",
        "34346502",
        "34346601",
        "31066001",
        "31066501",
        "31066502",
        "31066701",
        "31067001",
        "34346700",
        "34346701",
        "34346702",
        "31068501",
        "31068801",
        "34347101",
        "50192001",
        "34347201",
        "34347301",
        "31071301",
        "34347501",
        "34347602",
        "34349702",
        "34348201",
        "31073101",
        "31073801",
        "31073901",
        "31074001",
        "31074101",
        "31074301",
        "31074501",
        "31074901",
        "31075301",
        "31075401",
        "31075501",
        "31112501",
        "34349200",
        "34349201",
        "34349202",
        "35979801",
        "34349401",
        "31076901",
        "31077001",
        "31077401",
        "31077501",
        "31077801",
        "31078001",
        "31078101",
        "31078301",
        "31078401",
        "31078601",
        "31078801",
        "31079701",
        "34345701",
        "34349500",
        "34349501",
        "34349502",
        "35070501",
        "34349601",
        "34349701",
        "50015801",
        "34349801",
        "31084401",
        "34347601",
        "34349901",
        "31084901",
        "31085001",
        "31085101",
        "31085701",
        "34350000",
        "34350001",
        "34350002",
        "34350201",
        "31086101",
        "31086501",
        "34350301",
        "36175501",
        "31087101",
        "31087301",
        "31087401",
        "31087501",
        "31087801",
        "31087901",
        "31088401",
        "31088901",
        "31097901",
        "34350401",
        "35070701",
        "31089601",
        "31090001",
        "34350902",
        "34351001",
        "31091701",
        "34351202",
        "31092501",
        "31092701",
        "31092801",
        "34351501",
        "34351502",
        "34349301",
        "34354302",
        "31096601",
        "34349703",
        "31096801",
        "34352101",
        "34352300",
        "34352301",
        "34352302",
        "34352901",
        "34353001",
        "31099801",
        "34356301",
        "34353201",
        "31102201",
        "31102501",
        "31102701",
        "31103701",
        "34353300",
        "34353301",
        "34353302",
        "31103901",
        "31104001",
        "31104201",
        "34353402",
        "50120901",
        "31105201",
        "31105401",
        "34354300",
        "34354301",
        "34354303",
        "34351301",
        "34356601",
        "34354400",
        "34354401",
        "34354402",
        "34354403",
        "50112001",
        "34352601",
        "34354500",
        "34354501",
        "34354502",
        "31110601",
        "31110701",
        "31111001",
        "31111301",
        "31111401",
        "31111501",
        "31112101",
        "31112301",
        "34353202",
        "34354601",
        "31112601",
        "31112801",
        "34354700",
        "34354701",
        "34354702",
        "31113601",
        "31114101",
        "31114301",
        "34354801",
        "34354802",
        "31116101",
        "34355702",
        "31117001",
        "34351400",
        "34351401",
        "34355202",
        "34355301",
        "31119001",
        "31119101",
        "31119201",
        "31119301",
        "31119901",
        "34353401",
        "34355500",
        "34355501",
        "34355502",
        "50147401",
        "31120201",
        "34355701",
        "34342900",
        "34342901",
        "50074201",
        "34350801",
        "34355800",
        "34355802",
        "34355803",
        "31120501",
        "34355901",
        "31121601",
        "34356101",
        "31121501",
        "34347102",
        "50091701",
        "34239501",
        "36183301",
        "34242001",
        "34242201",
        "34242601",
        "30081501",
        "34244701",
        "34244801",
        "30085601",
        "34245201",
        "34245801",
        "34246301",
        "34246501",
        "34240403",
        "34246901",
        "34248301",
        "34248701",
        "30096201",
        "30096501",
        "30096601",
        "30096701",
        "34250100",
        "34250102",
        "34250103",
        "34250104",
        "30098201",
        "34250201",
        "30098501",
        "34250801",
        "50042501",
        "30099201",
        "30099301",
        "34250901",
        "34251501",
        "30102201",
        "34254101",
        "30107901",
        "30108601",
        "34254700",
        "34254702",
        "34254704",
        "35811901",
        "50104901",
        "30109301",
        "30109401",
        "34255301",
        "50080301",
        "34222501",
        "30233501",
        "30233601",
        "30233701",
        "34222801",
        "30238401",
        "30238501",
        "30238701",
        "30238801",
        "34223801",
        "30242501",
        "34225401",
        "34225501",
        "34226401",
        "34226901",
        "30248101",
        "34227101",
        "36116901",
        "50114401",
        "34227601",
        "34228001",
        "30251101",
        "30251201",
        "30251401",
        "34228301",
        "34228401",
        "30248701",
        "30252001",
        "34227201",
        "34229001",
        "30252801",
        "50033001",
        "34229401",
        "34231001",
        "34231201",
        "50014301",
        "34237801",
        "34233001",
        "34235001",
        "34235301",
        "34235501",
        "50180101",
        "34223802",
        "30263801",
        "34236901",
        "30264001",
        "30264101",
        "34237001",
        "35841901",
        "34237201",
        "34238001",
        "50176701",
        "31289201",
        "50173401",
        "34569702",
        "34569701",
        "34573505",
        "34569901",
        "31290401",
        "31290402",
        "34570103",
        "34570105",
        "34570201",
        "50186701",
        "31291401",
        "34570500",
        "34570501",
        "34570502",
        "50081501",
        "50081601",
        "31292101",
        "31292701",
        "31293001",
        "31293201",
        "34571301",
        "35043601",
        "31294201",
        "34571401",
        "31295201",
        "31295301",
        "34571601",
        "34571602",
        "34571603",
        "50130901",
        "34571700",
        "34571701",
        "34571702",
        "50024101",
        "50071501",
        "31297101",
        "31297301",
        "34571901",
        "34572601",
        "34569703",
        "35978201",
        "31298601",
        "34572201",
        "34572202",
        "50071901",
        "34572401",
        "31299201",
        "34572501",
        "31300001",
        "34572602",
        "34572701",
        "34572901",
        "34572902",
        "31301201",
        "34569704",
        "31302501",
        "34573001",
        "31302901",
        "34573100",
        "34573101",
        "34573102",
        "34561402",
        "31303901",
        "31304601",
        "31304701",
        "31304801",
        "31305101",
        "31305401",
        "31305601",
        "31306101",
        "31306601",
        "31307001",
        "31307301",
        "31307801",
        "31307901",
        "31308001",
        "31308101",
        "31308501",
        "31308601",
        "31308701",
        "31309101",
        "31309301",
        "31309601",
        "31309801",
        "31310301",
        "31310501",
        "31310601",
        "31311401",
        "31311501",
        "31311701",
        "31311801",
        "31312101",
        "31312201",
        "31312301",
        "31312401",
        "31312501",
        "31312801",
        "31313001",
        "31313401",
        "31313501",
        "31313901",
        "31314301",
        "31314401",
        "31314501",
        "31314701",
        "31314901",
        "31315401",
        "31315701",
        "31315801",
        "31316201",
        "31316501",
        "31316701",
        "31317101",
        "31317901",
        "31319601",
        "34573501",
        "34573504",
        "34573502",
        "35044201",
        "35050002",
        "35050101",
        "36007201",
        "36189501",
        "36207401",
        "50000201",
        "50005901",
        "50008501",
        "50021701",
        "50037001",
        "50037901",
        "50078601",
        "50116401",
        "50123201",
        "50143201",
        "50157301",
        "50157401",
        "50160901",
        "50199901",
        "34541001",
        "50068501",
        "34541101",
        "31390001",
        "31390101",
        "34541201",
        "34541202",
        "50072201",
        "31392201",
        "31392301",
        "34541501",
        "34551901",
        "50092601",
        "31395101",
        "31395601",
        "31400301",
        "34541600",
        "34541601",
        "34541602",
        "34541603",
        "34541901",
        "34547701",
        "50180901",
        "31403401",
        "31403601",
        "34542001",
        "35413201",
        "34542202",
        "31409001",
        "34542301",
        "50120501",
        "34544202",
        "34542601",
        "34542901",
        "36200301",
        "50058001",
        "34543201",
        "34543301",
        "34543501",
        "34543600",
        "34543601",
        "34543602",
        "50066701",
        "31421401",
        "34543700",
        "34543701",
        "34543702",
        "50024701",
        "50024801",
        "31427101",
        "34543801",
        "35815201",
        "31428101",
        "50025001",
        "34544201",
        "34544301",
        "34544401",
        "31433701",
        "34545102",
        "50007901",
        "50084101",
        "34545401",
        "34545501",
        "31436101",
        "31436401",
        "34545601",
        "31437401",
        "31437801",
        "31437901",
        "34546000",
        "34546001",
        "34546002",
        "34546003",
        "50068401",
        "50130501",
        "31439001",
        "31439101",
        "34546101",
        "50160201",
        "34546201",
        "31439501",
        "31439701",
        "31440001",
        "31440201",
        "31440301",
        "34546401",
        "34546501",
        "34548102",
        "50083301",
        "34546301",
        "34547101",
        "31446502",
        "31446801",
        "34546801",
        "31449201",
        "31449301",
        "31449501",
        "31449601",
        "31449801",
        "34546900",
        "34546901",
        "34546902",
        "34546903",
        "35977001",
        "36154701",
        "50043301",
        "34547201",
        "34547301",
        "31454201",
        "34544601",
        "34547501",
        "34547600",
        "34547601",
        "34547602",
        "34547901",
        "34548101",
        "31460401",
        "34548201",
        "50172101",
        "31460701",
        "34548301",
        "34548501",
        "50076201",
        "31461501",
        "34548600",
        "34548601",
        "34548602",
        "34548701",
        "50083501",
        "34549201",
        "31466001",
        "34549501",
        "34549502",
        "50013601",
        "31467201",
        "34561101",
        "34581302",
        "31471201",
        "34550401",
        "34550801",
        "50114601",
        "34550301",
        "31471901",
        "34542201",
        "34547001",
        "31473401",
        "34550601",
        "34550602",
        "31475501",
        "31475601",
        "31475701",
        "31475801",
        "31476001",
        "34550802",
        "50043601",
        "50097601",
        "50158301",
        "34551001",
        "34551101",
        "34551201",
        "31482601",
        "34551300",
        "34551301",
        "34551302",
        "34551501",
        "34551601",
        "34544203",
        "34544204",
        "34550603",
        "50002001",
        "31488802",
        "31488901",
        "34551800",
        "34551801",
        "34551802",
        "34551803",
        "31491901",
        "31492101",
        "31499601",
        "31499801",
        "31501101",
        "34552301",
        "34552302",
        "34552303",
        "50064501",
        "50135601",
        "31493001",
        "34552501",
        "34546802",
        "34537403",
        "31321501",
        "34531301",
        "34531401",
        "34531701",
        "31323101",
        "34581003",
        "34532201",
        "31325201",
        "31325301",
        "50041501",
        "50098501",
        "50098601",
        "34532501",
        "31326601",
        "34532601",
        "34532701",
        "34532801",
        "35539701",
        "31327601",
        "34533001",
        "31327701",
        "31327801",
        "34533101",
        "34533102",
        "31329601",
        "34533201",
        "31330101",
        "34533301",
        "34533501",
        "34533502",
        "31331301",
        "34533700",
        "34533701",
        "34533702",
        "31332201",
        "31332401",
        "34533801",
        "50126101",
        "34533901",
        "31333401",
        "34534101",
        "50049701",
        "50099201",
        "50112401",
        "31334701",
        "34534701",
        "34539401",
        "34534901",
        "34535001",
        "34535101",
        "34535201",
        "31337701",
        "31337801",
        "31338801",
        "34535401",
        "50059501",
        "34535801",
        "34536100",
        "34536101",
        "34536102",
        "34536301",
        "31342501",
        "34536401",
        "50099001",
        "50099101",
        "34536501",
        "50167501",
        "34536601",
        "34536701",
        "34537001",
        "34537101",
        "34535901",
        "34537301",
        "34538001",
        "34545101",
        "31347801",
        "31348501",
        "34537401",
        "34537402",
        "35888501",
        "34537501",
        "31349401",
        "34537801",
        "31350301",
        "31350501",
        "31350601",
        "31350701",
        "34537900",
        "34537902",
        "34537903",
        "34537904",
        "50084301",
        "31352101",
        "34536502",
        "34538100",
        "34538102",
        "34538103",
        "31354601",
        "31355201",
        "31355601",
        "31357401",
        "34538301",
        "50101401",
        "31357601",
        "31357701",
        "34538501",
        "35004602",
        "31358201",
        "31354401",
        "34532901",
        "34538201",
        "34538701",
        "34536001",
        "34539100",
        "34539101",
        "34539102",
        "34539201",
        "31361601",
        "34539300",
        "34539301",
        "34539302",
        "34540104",
        "50011901",
        "34539501",
        "34539801",
        "34539901",
        "34539902",
        "31370301",
        "31370401",
        "31370501",
        "31371001",
        "31371401",
        "31371801",
        "31373801",
        "31388201",
        "34117701",
        "34536200",
        "34536201",
        "34538601",
        "34540103",
        "34540105",
        "34540106",
        "35834901",
        "50009501",
        "50036301",
        "50048401",
        "50096301",
        "50106401",
        "50125001",
        "50171501",
        "50187501",
        "34540201",
        "34540401",
        "34540402",
        "50007201",
        "34540501",
        "31365601",
        "34540600",
        "34540601",
        "34540602",
        "50124601",
        "31368501",
        "31368901",
        "31369001",
        "31369801",
        "34540701",
        "34540702",
        "35818801",
        "34540800",
        "34540801",
        "34540802",
        "35904901",
        "34702801",
        "34702901",
        "32524301",
        "34703001",
        "34703301",
        "36001101",
        "34703901",
        "32525101",
        "32525201",
        "32525301",
        "32525401",
        "32525601",
        "32525701",
        "35479801",
        "35884001",
        "35884101",
        "35900801",
        "50067001",
        "50073801",
        "34704601",
        "32526101",
        "32527001",
        "32527201",
        "32527601",
        "32527801",
        "32528201",
        "32528601",
        "32528701",
        "32528801",
        "32529001",
        "32529401",
        "32529701",
        "32529801",
        "32530001",
        "32530101",
        "32530201",
        "34704801",
        "35472701",
        "35479901",
        "35506101",
        "35519901",
        "35551901",
        "35837601",
        "36030701",
        "36081001",
        "36110101",
        "50023501",
        "50129201",
        "50163701",
        "50168101",
        "32530401",
        "32530501",
        "32530701",
        "32530801",
        "34181401",
        "34705001",
        "36209601",
        "32531101",
        "32531401",
        "32531501",
        "32531801",
        "32531901",
        "32532201",
        "32532202",
        "32532301",
        "32532501",
        "34705101",
        "35413601",
        "35561301",
        "36098101",
        "50060501",
        "32533101",
        "32533201",
        "32533301",
        "32533501",
        "32533601",
        "34705401",
        "35550701",
        "36006401",
        "50201901",
        "34706201",
        "35064901",
        "50050801",
        "34706401",
        "34706301",
        "32535201",
        "34706601",
        "35055501",
        "35055601",
        "35056901",
        "50167401",
        "34157401",
        "34706901",
        "34707401",
        "34707501",
        "34707601",
        "34707701",
        "50068301",
        "34707901",
        "34708201",
        "34708401",
        "34708501",
        "34708602",
        "34708600",
        "34708601",
        "34708603",
        "36128501",
        "32537701",
        "34708701",
        "34890201",
        "34891401",
        "34893001",
        "34893501",
        "34893701",
        "34894001",
        "34894801",
        "34895301",
        "34895601",
        "34896401",
        "34896801",
        "34897101",
        "34898201",
        "34898501",
        "34898901",
        "34899001",
        "34899301",
        "34899601",
        "34900401",
        "50143001",
        "34901101",
        "50128501",
        "34903501",
        "33023601",
        "33023701",
        "33024201",
        "33025601",
        "33025901",
        "34903801",
        "50048301",
        "50063901",
        "50069501",
        "34904201",
        "34725100",
        "34725200",
        "34877600",
        "34727100",
        "34731102",
        "34727501",
        "34751000",
        "34718400",
        "34724301",
        "34902001",
        "34848901",
        "34849501",
        "34357900",
        "34217900",
        "34853800",
        "34482200",
        "34226800",
        "34725100",
        "01312614"
    ]
    fields = [
        {
            "id": 1,
            "name": "RAGIONE_SOCIALE",
            "description": "Obbligatorio"
        },
        {
            "id": 2,
            "name": "CODICE_FISCALE_PIVA",
            "description": "Obbligatorio - Formato corretto: 16 caratteri alfanumerici per codice fiscale per persona fisica, 11 caratteri numerici per persona giuridica"
        },
        {
            "id": 3,
            "name": "CODICE_SDI",
            "description": "Obbligatorio per Business, Ditta Individuale o Condominio - 6/7 caratteri alfanumerici (Esempio: M5UXCR1)"
        },
        {
            "id": 4,
            "name": "IBAN",
            "description": "Facoltativo - Formato corretto: 27 caratteri alfanumerici (Esempio: IT01A0123456789012345678901)"
        },
        {
            "id": 5,
            "name": "POD_PDR",
            "description": "Obbligatorio - Formato corretto: 14 caratteri (Esempio POD: IT001E01234567; Esempio PDR: 01234567890123)"
        },
        {
            "id": 6,
            "name": "TOPONIMO_FORNITURA",
            "description": "Obbligatorio"
        },
        {
            "id": 7,
            "name": "INDIRIZZO_FORNITURA",
            "description": "Obbligatorio"
        },
        {
            "id": 8,
            "name": "CIVICO_FORNITURA",
            "description": "Obbligatorio"
        },
        {
            "id": 9,
            "name": "CAP_FORNITURA",
            "description": "Obbligatorio - Formato corretto: 5 caratteri numerici (Esempio: 70129)"
        },
        {
            "id": 10,
            "name": "SIGLA_PROVINCIA_FORNITURA",
            "description": "Obbligatorio - Scegli l'opzione - Formato corretto: AA (Esempio: BA)"
        },
        {
            "id": 11,
            "name": "CITTA_FORNITURA",
            "description": "Obbligatorio - Scegli l'opzione - Formato corretto: Nome completo del comune (Esempio: Bari)"
        },
        {
            "id": 12,
            "name": "USO",
            "description": "Obbligatorio - Scegli l'opzione"
        },
        {
            "id": 13,
            "name": "OFFERTA",
            "description": "Obbligatorio - Scegli l'opzione - Formato corretto: \"Tipo_fornitura - Tipo Uso\" (Esempio: \"Energia - Altri Usi\" oppure \"Gas - Domestico\")"
        },
        {
            "id": 14,
            "name": "MATRICOLA",
            "description": "Obbligatorio per fornitura Gas - Vedi fattura"
        },
        {
            "id": 15,
            "name": "CLASSE_MISURATORE",
            "description": "Obbligatorio per fornitura Gas - Scegli l'opzione - Vedi fattura"
        },
        {
            "id": 16,
            "name": "DESTINAZIONE_USO",
            "description": "Obbligatorio per fornitura Gas - Scegli l'opzione - Vedi fattura"
        },
        {
            "id": 17,
            "name": "CONSUMO_ANNUO",
            "description": "Obbligatorio per fornitura Gas non in Subentro - Vedi fattura"
        }
    ]
    province = [
            {
                "code": "AG",
                "name": "Agrigento",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Molo, 5",
                "cap_dogana": "92014",
                "comune_dogana": "Porto Empedocle",
                "val_dogana": 52.09,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AL",
                "name": "Alessandria",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Arnaldo Da Brescia, 19",
                "cap_dogana": "15120",
                "comune_dogana": "Alessandria",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AN",
                "name": "Ancona",
                "cod_regione": 13,
                "pec_dogana": "",
                "indirizzo_dogana": "Lungomare Vanvitelli, 5",
                "cap_dogana": "60121",
                "comune_dogana": "Ancona",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AO",
                "name": "Aosta",
                "cod_regione": 2,
                "pec_dogana": "",
                "indirizzo_dogana": "Autoparco Valle D'Aosta, 33",
                "cap_dogana": "11020",
                "comune_dogana": "Pollein",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AP",
                "name": "Ascoli Piceno",
                "cod_regione": 13,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AQ",
                "name": "L'Aquila",
                "cod_regione": 15,
                "pec_dogana": "",
                "indirizzo_dogana": "Via delle Industrie, 3/4",
                "cap_dogana": "67100",
                "comune_dogana": "L'Aquila",
                "val_dogana": 292.51,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AR",
                "name": "Arezzo",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Chiari, 55",
                "cap_dogana": "52100",
                "comune_dogana": "Arezzo",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AT",
                "name": "Asti",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "AV",
                "name": "Avellino",
                "cod_regione": 17,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 1.79,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BA",
                "name": "Bari",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": "Piazza I. D'Aragona, 50",
                "cap_dogana": "70122",
                "comune_dogana": "Bari",
                "val_dogana": 16735.6,
                "val_dogana_gas": 239,
                "zona": null
            },
            {
                "code": "BG",
                "name": "Bergamo",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Largo Belotti, 3",
                "cap_dogana": "24121",
                "comune_dogana": "Bergamo",
                "val_dogana": 752.81,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BI",
                "name": "Biella",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Addis Abeba, 57",
                "cap_dogana": "13900",
                "comune_dogana": "Biella",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BL",
                "name": "Belluno",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 1.45,
                "val_dogana_gas": 91.8,
                "zona": null
            },
            {
                "code": "BN",
                "name": "Benevento",
                "cod_regione": 17,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Martiri D'Ungheria",
                "cap_dogana": "82100",
                "comune_dogana": "Benevento",
                "val_dogana": 26.45,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BO",
                "name": "Bologna",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Tanari, 19",
                "cap_dogana": "40131",
                "comune_dogana": "Bologna",
                "val_dogana": 3.24,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BR",
                "name": "Brindisi",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": "Viale Regina Margherita, 3",
                "cap_dogana": "72100",
                "comune_dogana": "Brindisi",
                "val_dogana": 400.67,
                "val_dogana_gas": 13,
                "zona": null
            },
            {
                "code": "BS",
                "name": "Brescia",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Perotti, 9 ",
                "cap_dogana": "25125",
                "comune_dogana": "Brescia",
                "val_dogana": 354.66,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "BT",
                "name": "Barletta Andria Trani",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": "Barletta-Andria-Trani",
                "val_dogana": 3531,
                "val_dogana_gas": 23,
                "zona": null
            },
            {
                "code": "BZ",
                "name": "Bolzano",
                "cod_regione": 5,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Cassa Di Risparmio, 21",
                "cap_dogana": "39100",
                "comune_dogana": "Bolzano",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CA",
                "name": "Cagliari",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Riva Di Ponente",
                "cap_dogana": "09100",
                "comune_dogana": "Cagliari",
                "val_dogana": 9.91,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CB",
                "name": "Campobasso",
                "cod_regione": 16,
                "pec_dogana": "",
                "indirizzo_dogana": "Contrada Selva Piana",
                "cap_dogana": "86100",
                "comune_dogana": "Campobasso",
                "val_dogana": 504.5,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CE",
                "name": "Caserta",
                "cod_regione": 17,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Ficucella C/O Interporto Sud Europa",
                "cap_dogana": "81100",
                "comune_dogana": "Caserta",
                "val_dogana": 2.04,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CH",
                "name": "Chieti",
                "cod_regione": 15,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 897.61,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CI",
                "name": "Carbonia Iglesias",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CL",
                "name": "Caltanissetta",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CN",
                "name": "Cuneo",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Gobetti, 27 ",
                "cap_dogana": "12100",
                "comune_dogana": "Cuneo",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CO",
                "name": "Como",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Regina Teodolinda, 2",
                "cap_dogana": "22100",
                "comune_dogana": "Como",
                "val_dogana": 0.04,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CR",
                "name": "Cremona",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 47.94,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CS",
                "name": "Cosenza",
                "cod_regione": 20,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 106.33,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CT",
                "name": "Catania",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Viale Dusmet,  17 ",
                "cap_dogana": "95121",
                "comune_dogana": "Catania",
                "val_dogana": 2,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "CZ",
                "name": "Catanzaro",
                "cod_regione": 20,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Buccarelli, 4",
                "cap_dogana": "88100",
                "comune_dogana": "Catanzaro",
                "val_dogana": 56.14,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "EN",
                "name": "Enna",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "FC",
                "name": "Forl&igrave Cesena",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Punta Di Ferro, 2",
                "cap_dogana": "47120",
                "comune_dogana": "Forlì",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "FE",
                "name": "Ferrara",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Monsignore Maverna, 4",
                "cap_dogana": "44120",
                "comune_dogana": "Ferrara",
                "val_dogana": 160.4,
                "val_dogana_gas": 866.36,
                "zona": null
            },
            {
                "code": "FG",
                "name": "Foggia",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": "Piazza Giordano, 1",
                "cap_dogana": "71120",
                "comune_dogana": "Foggia",
                "val_dogana": 2810.49,
                "val_dogana_gas": 5,
                "zona": null
            },
            {
                "code": "FI",
                "name": "Firenze",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Panciatichi, 17",
                "cap_dogana": "50141",
                "comune_dogana": "Firenze",
                "val_dogana": 0.72,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "FM",
                "name": "Fermo",
                "cod_regione": 13,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "FR",
                "name": "Frosinone",
                "cod_regione": 14,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Armando Fabi",
                "cap_dogana": "03100",
                "comune_dogana": "Frosinone",
                "val_dogana": 3.22,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "GE",
                "name": "Genova",
                "cod_regione": 8,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Rubattino 10A",
                "cap_dogana": "16126",
                "comune_dogana": "Genova",
                "val_dogana": 47.56,
                "val_dogana_gas": 5,
                "zona": null
            },
            {
                "code": "GO",
                "name": "Gorizia",
                "cod_regione": 7,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Trieste, 301",
                "cap_dogana": "34170",
                "comune_dogana": "Gorizia",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "GR",
                "name": "Grosseto",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 5,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "IM",
                "name": "Imperia",
                "cod_regione": 8,
                "pec_dogana": "",
                "indirizzo_dogana": "Calata Sandro Anselmi",
                "cap_dogana": "18100",
                "comune_dogana": "Imperia",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "IS",
                "name": "Isernia",
                "cod_regione": 16,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 4017.91,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "KR",
                "name": "Crotone",
                "cod_regione": 20,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 3.77,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "LC",
                "name": "Lecco",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "LE",
                "name": "Lecce",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Porta D Europa, 4",
                "cap_dogana": "73100",
                "comune_dogana": "Lecce",
                "val_dogana": 503.68,
                "val_dogana_gas": 17,
                "zona": null
            },
            {
                "code": "LI",
                "name": "Livorno",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Delle Cateratte, 88",
                "cap_dogana": "57100",
                "comune_dogana": "Livorno",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "LO",
                "name": "Lodi",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 3.79,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "LT",
                "name": "Latina",
                "cod_regione": 14,
                "pec_dogana": "",
                "indirizzo_dogana": "Localita' Nuova Banchina Commerciale",
                "cap_dogana": "04024",
                "comune_dogana": "Gaeta",
                "val_dogana": 40.19,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "LU",
                "name": "Lucca",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 39.57,
                "val_dogana_gas": 16,
                "zona": null
            },
            {
                "code": "MB",
                "name": "Monza Brianza",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 118.27,
                "val_dogana_gas": 19,
                "zona": null
            },
            {
                "code": "MC",
                "name": "Macerata",
                "cod_regione": 13,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Gobetti",
                "cap_dogana": "62012",
                "comune_dogana": "Civitanova Marche",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "ME",
                "name": "Messina",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Via I Settembre,  38",
                "cap_dogana": "98122",
                "comune_dogana": "Messina",
                "val_dogana": 3.57,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "MI",
                "name": "Milano",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Ceresio, 12",
                "cap_dogana": "20154",
                "comune_dogana": "Milano",
                "val_dogana": 671.6,
                "val_dogana_gas": 28,
                "zona": null
            },
            {
                "code": "MN",
                "name": "Mantova",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Colombo, 17",
                "cap_dogana": "46100",
                "comune_dogana": "Mantova",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "MO",
                "name": "Modena",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Del Passatore, 61",
                "cap_dogana": "41120",
                "comune_dogana": "Modena",
                "val_dogana": 6.29,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "MS",
                "name": "Massa Carrara",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "MT",
                "name": "Matera",
                "cod_regione": 19,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 195.61,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "NA",
                "name": "Napoli",
                "cod_regione": 17,
                "pec_dogana": "",
                "indirizzo_dogana": "Calata Granili - Interno Porto",
                "cap_dogana": "80100",
                "comune_dogana": "Napoli",
                "val_dogana": 292.62,
                "val_dogana_gas": 19.81,
                "zona": null
            },
            {
                "code": "NO",
                "name": "Novara",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Gnifetti, 11/A",
                "cap_dogana": "28100",
                "comune_dogana": "Novara",
                "val_dogana": 1.46,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "NU",
                "name": "Nuoro",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "OG",
                "name": "Ogliastra",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "OR",
                "name": "Oristano",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "OT",
                "name": "Olbia Tempio",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 4.58,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PA",
                "name": "Palermo",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Via F. Crispi, 143 ",
                "cap_dogana": "90133",
                "comune_dogana": "Palemo",
                "val_dogana": 11.37,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PC",
                "name": "Piacenza",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Coppalati - Localita Le Mose",
                "cap_dogana": "29120",
                "comune_dogana": "Piacenza",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PD",
                "name": "Padova",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": "Corso Stati Uniti, 16",
                "cap_dogana": "35127",
                "comune_dogana": "Padova",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PE",
                "name": "Pescara",
                "cod_regione": 15,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Andrea Doria 10/12",
                "cap_dogana": "65120",
                "comune_dogana": "Pescara",
                "val_dogana": 118.97,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PG",
                "name": "Perugia",
                "cod_regione": 12,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Venanzio Gabriotti, 1",
                "cap_dogana": "06100",
                "comune_dogana": "Perugia",
                "val_dogana": 13.64,
                "val_dogana_gas": 5,
                "zona": null
            },
            {
                "code": "PI",
                "name": "Pisa",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Della Darsena, 1/A",
                "cap_dogana": "56121",
                "comune_dogana": "Pisa",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PN",
                "name": "Pordenone",
                "cod_regione": 7,
                "pec_dogana": "",
                "indirizzo_dogana": "Centro Commerciale Villanova Settore M",
                "cap_dogana": "33170",
                "comune_dogana": "Pordenone",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PO",
                "name": "Prato",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Gonfienti, 4",
                "cap_dogana": "59100",
                "comune_dogana": "Prato",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PR",
                "name": "Parma",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Piazzale Europa, 1 C/O Interporto C.E.P.I.M.",
                "cap_dogana": "43120",
                "comune_dogana": "Parma",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PT",
                "name": "Pistoia",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PU",
                "name": "Pesaro e Urbino",
                "cod_regione": 13,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 31.88,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PV",
                "name": "Pavia",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Veneroni, 18",
                "cap_dogana": "27100",
                "comune_dogana": "Pavia",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "PZ",
                "name": "Potenza",
                "cod_regione": 19,
                "pec_dogana": "",
                "indirizzo_dogana": "Corso XVIII Agosto 1860, 44",
                "cap_dogana": "85100",
                "comune_dogana": "Potenza",
                "val_dogana": 58.97,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RA",
                "name": "Ravenna",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via D'Alaggio, 1/3",
                "cap_dogana": "48120",
                "comune_dogana": "Ravenna",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RC",
                "name": "Reggio Calabria",
                "cod_regione": 20,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Porto Banchina Margottini",
                "cap_dogana": "89100",
                "comune_dogana": "Reggio Calabria",
                "val_dogana": 64.52,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RE",
                "name": "Reggio Emilia",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via S. Vincenzi 13",
                "cap_dogana": "42100",
                "comune_dogana": "Reggio Emilia",
                "val_dogana": 21.37,
                "val_dogana_gas": 24,
                "zona": null
            },
            {
                "code": "RG",
                "name": "Ragusa",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 4.48,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RI",
                "name": "Rieti",
                "cod_regione": 14,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RM",
                "name": "Roma",
                "cod_regione": 14,
                "pec_dogana": "",
                "indirizzo_dogana": "Viale Scalo San Lorenzo, 8/10",
                "cap_dogana": "00185",
                "comune_dogana": "Roma",
                "val_dogana": 514.47,
                "val_dogana_gas": 119.28,
                "zona": null
            },
            {
                "code": "RN",
                "name": "Rimini",
                "cod_regione": 10,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Emilia Vecchia, 75",
                "cap_dogana": "47920",
                "comune_dogana": "Rimini",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "RO",
                "name": "Rovigo",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 7.72,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SA",
                "name": "Salerno",
                "cod_regione": 17,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Molo Manfredi, 44",
                "cap_dogana": "84100",
                "comune_dogana": "Salerno",
                "val_dogana": 1.1,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SI",
                "name": "Siena",
                "cod_regione": 11,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 1.95,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SO",
                "name": "Sondrio",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Piazza Stazione, 22",
                "cap_dogana": "23100",
                "comune_dogana": "Sondrio",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SP",
                "name": "La Spezia",
                "cod_regione": 8,
                "pec_dogana": "",
                "indirizzo_dogana": "Viale D'Italia, 6",
                "cap_dogana": "19100",
                "comune_dogana": "La Spezia",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SR",
                "name": "Siracusa",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Via C. Forlanini, 1",
                "cap_dogana": "96100",
                "comune_dogana": "Siracusa",
                "val_dogana": 17.53,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SS",
                "name": "Sassari",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Piandanna, 14",
                "cap_dogana": "07100",
                "comune_dogana": "Sassari",
                "val_dogana": 1.8399999999999999,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SU",
                "name": "Sud Sardegna",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Riva Di Ponente",
                "cap_dogana": "09100",
                "comune_dogana": "Cagliari",
                "val_dogana": 9.91,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "SV",
                "name": "Savona",
                "cod_regione": 8,
                "pec_dogana": "",
                "indirizzo_dogana": "Piazza Rebagliati, 5",
                "cap_dogana": "17100",
                "comune_dogana": "Savona",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TA",
                "name": "Taranto",
                "cod_regione": 18,
                "pec_dogana": "",
                "indirizzo_dogana": "Molo Polisettoriale Nell'Ambito Delle Strutture Portuali",
                "cap_dogana": "74120",
                "comune_dogana": "Taranto",
                "val_dogana": 303.18,
                "val_dogana_gas": 15,
                "zona": null
            },
            {
                "code": "TE",
                "name": "Teramo",
                "cod_regione": 15,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 7.3,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TN",
                "name": "Trento",
                "cod_regione": 5,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Vannetti, 13",
                "cap_dogana": "38120",
                "comune_dogana": "Trento",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TO",
                "name": "Torino",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Interporto Torino - Prima Strada, 3",
                "cap_dogana": "10043",
                "comune_dogana": "Torino",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TP",
                "name": "Trapani",
                "cod_regione": 21,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Ammiraglio Staiti, 7",
                "cap_dogana": "91100",
                "comune_dogana": "Trapani",
                "val_dogana": 14.1,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TR",
                "name": "Terni",
                "cod_regione": 12,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TS",
                "name": "Trieste",
                "cod_regione": 7,
                "pec_dogana": "",
                "indirizzo_dogana": "Corso Cavour, 6",
                "cap_dogana": "34123",
                "comune_dogana": "Trieste",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "TV",
                "name": "Treviso",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Noalese",
                "cap_dogana": "31100",
                "comune_dogana": "Treviso",
                "val_dogana": 5.44,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "UD",
                "name": "Udine",
                "cod_regione": 7,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Gorghi, 18",
                "cap_dogana": "33100",
                "comune_dogana": "Udine",
                "val_dogana": 3.33,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VA",
                "name": "Varese",
                "cod_regione": 3,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Dalmazia, 56",
                "cap_dogana": "21100",
                "comune_dogana": "Varese",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VB",
                "name": "Verbano Cusio Ossola",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Scalo Domo II - Beura Cardezza",
                "cap_dogana": "28851",
                "comune_dogana": "Verbania",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VC",
                "name": "Vercelli",
                "cod_regione": 1,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Dante, 36",
                "cap_dogana": "13100",
                "comune_dogana": "Vercelli",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VE",
                "name": "Venezia",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Banchina Dell'Azoto, 15/1",
                "cap_dogana": "30175",
                "comune_dogana": "Venezia",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VI",
                "name": "Vicenza",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Fornaci, 23",
                "cap_dogana": "36100",
                "comune_dogana": "Vicenza",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VR",
                "name": "Verona",
                "cod_regione": 6,
                "pec_dogana": "",
                "indirizzo_dogana": "Via Sommacampagna, 26A",
                "cap_dogana": "37137",
                "comune_dogana": "Verona",
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VS",
                "name": "Medio Campidano",
                "cod_regione": 22,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 0,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VT",
                "name": "Viterbo",
                "cod_regione": 14,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 18.29,
                "val_dogana_gas": 0,
                "zona": null
            },
            {
                "code": "VV",
                "name": "Vibo Valentia",
                "cod_regione": 20,
                "pec_dogana": "",
                "indirizzo_dogana": null,
                "cap_dogana": null,
                "comune_dogana": null,
                "val_dogana": 4.28,
                "val_dogana_gas": 0,
                "zona": null
            }
    ]
    tipologieCliente = [
            {
                "id": 1,
                "name": "Business",
                "costo_deposito": -1,
                "view_selection_client": true,
                "selected": false

            },
            {
                "id": 2,
                "name": "Domestico",
                "costo_deposito": -1,
                "view_selection_client": true,
                "selected": false
            },
            {
                "id": 3,
                "name": "Condominio",
                "costo_deposito": -1,
                "view_selection_client": false,
                "selected": false
            },
            {
                "id": 4,
                "name": "Ditta Individuale",
                "costo_deposito": -1,
                "view_selection_client": true,
                "selected": false
            },
            {
                "id": 5,
                "name": "Ente Pubblico",
                "costo_deposito": -1,
                "view_selection_client": true,
                "selected": false
            },
            {
                "id": 6,
                "name": "Altri Enti/parrocchie/consorzi",
                "costo_deposito": -1,
                "view_selection_client": true,
                "selected": false
            }
    ]
    toponimi = [
        {
            "id": 1,
            "code": "ACC",
            "name": "ACCESSO"
        },
        {
            "id": 2,
            "code": "AGP",
            "name": "ANGIPORTO"
        },
        {
            "id": 3,
            "code": "AIU",
            "name": "AIUOLA"
        },
        {
            "id": 4,
            "code": "ALT",
            "name": "ALTO"
        },
        {
            "id": 5,
            "code": "ALZ",
            "name": "ALZAIA"
        },
        {
            "id": 6,
            "code": "AND",
            "name": "ANDRONA/ANDRONA I/ANDRONA II"
        },
        {
            "id": 7,
            "code": "ANG",
            "name": "ANGOLO"
        },
        {
            "id": 8,
            "code": "APE",
            "name": "APERTA"
        },
        {
            "id": 9,
            "code": "ARC",
            "name": "ARCO"
        },
        {
            "id": 10,
            "code": "ARD",
            "name": "ARGINE DESTRO"
        },
        {
            "id": 11,
            "code": "ARG",
            "name": "ARGINE"
        },
        {
            "id": 12,
            "code": "ARV",
            "name": "ARCHIVOLTO"
        },
        {
            "id": 13,
            "code": "ASS",
            "name": "ASSE"
        },
        {
            "id": 14,
            "code": "AST",
            "name": "AUTOSTRADA"
        },
        {
            "id": 15,
            "code": "ATR",
            "name": "ATRIO"
        },
        {
            "id": 16,
            "code": "BAC",
            "name": "BACINO"
        },
        {
            "id": 17,
            "code": "BAG",
            "name": "BAGLIO"
        },
        {
            "id": 18,
            "code": "BAN",
            "name": "BANCHINA"
        },
        {
            "id": 19,
            "code": "BAR",
            "name": "BARBARIA"
        },
        {
            "id": 20,
            "code": "BAS",
            "name": "BASTIONE/BASTIONI"
        },
        {
            "id": 21,
            "code": "BDO",
            "name": "BALUARDO"
        },
        {
            "id": 22,
            "code": "BEL",
            "name": "BELVEDERE"
        },
        {
            "id": 23,
            "code": "BGL",
            "name": "BORGOLOCO"
        },
        {
            "id": 24,
            "code": "BGO",
            "name": "BORGO"
        },
        {
            "id": 25,
            "code": "BGT",
            "name": "BORGATA"
        },
        {
            "id": 26,
            "code": "BLC",
            "name": "BLOCCO"
        },
        {
            "id": 27,
            "code": "BRG",
            "name": "BORGHETTO"
        },
        {
            "id": 28,
            "code": "BSS",
            "name": "BASSO"
        },
        {
            "id": 29,
            "code": "BVI",
            "name": "BIVIO"
        },
        {
            "id": 30,
            "code": "CAL",
            "name": "CALATA"
        },
        {
            "id": 31,
            "code": "CAM",
            "name": "CAMMINO"
        },
        {
            "id": 32,
            "code": "CAN",
            "name": "CANCELLO"
        },
        {
            "id": 33,
            "code": "CAP",
            "name": "CAPO"
        },
        {
            "id": 34,
            "code": "CAR",
            "name": "CARRAIA"
        },
        {
            "id": 35,
            "code": "CAS",
            "name": "CASA/CASE/CASALE"
        },
        {
            "id": 36,
            "code": "CAV",
            "name": "CAVONE"
        },
        {
            "id": 37,
            "code": "CEN",
            "name": "CENTRO"
        },
        {
            "id": 38,
            "code": "CHI",
            "name": "CHIOSTRI"
        },
        {
            "id": 39,
            "code": "CHS",
            "name": "CHIESA"
        },
        {
            "id": 40,
            "code": "CIR",
            "name": "CIRCONVALLAZIONE"
        },
        {
            "id": 41,
            "code": "CLA",
            "name": "CALLE LARGA"
        },
        {
            "id": 42,
            "code": "CLE",
            "name": "CALLE II"
        },
        {
            "id": 43,
            "code": "CLL",
            "name": "CALLE"
        },
        {
            "id": 44,
            "code": "CLP",
            "name": "CALLE I"
        },
        {
            "id": 45,
            "code": "CLT",
            "name": "CALLE III"
        },
        {
            "id": 46,
            "code": "CLV",
            "name": "CLIVO"
        },
        {
            "id": 47,
            "code": "CMP",
            "name": "CAMPIELLO"
        },
        {
            "id": 48,
            "code": "CNL",
            "name": "CANALE"
        },
        {
            "id": 49,
            "code": "CNT",
            "name": "CANTONE"
        },
        {
            "id": 50,
            "code": "COL",
            "name": "COLLE"
        },
        {
            "id": 51,
            "code": "COM",
            "name": "COMPLANARE/COMPLESSO"
        },
        {
            "id": 52,
            "code": "CON",
            "name": "CONTRADA"
        },
        {
            "id": 53,
            "code": "COR",
            "name": "CORSIA"
        },
        {
            "id": 54,
            "code": "COT",
            "name": "CORTILE"
        },
        {
            "id": 55,
            "code": "CP",
            "name": "CASELLA POSTALE"
        },
        {
            "id": 56,
            "code": "CPO",
            "name": "CAMPO"
        },
        {
            "id": 57,
            "code": "CPR",
            "name": "COMPRENSORIO"
        },
        {
            "id": 58,
            "code": "CPV",
            "name": "CUPA VICINALE"
        },
        {
            "id": 59,
            "code": "CPZ",
            "name": "CAMPAZZO"
        },
        {
            "id": 60,
            "code": "CRA",
            "name": "CROSA"
        },
        {
            "id": 61,
            "code": "CRC",
            "name": "CIRCONVALLAZIONE STATALE"
        },
        {
            "id": 62,
            "code": "CRD",
            "name": "CARRIZZADA"
        },
        {
            "id": 63,
            "code": "CRN",
            "name": "CROSINO"
        },
        {
            "id": 64,
            "code": "CRP",
            "name": "CORTILE I"
        },
        {
            "id": 65,
            "code": "CRS",
            "name": "CORTILE II"
        },
        {
            "id": 66,
            "code": "CSE",
            "name": "CASELLO"
        },
        {
            "id": 67,
            "code": "CSG",
            "name": "CASEGGIATO"
        },
        {
            "id": 68,
            "code": "CSN",
            "name": "CASCINA/CASCINE/CASCINALI"
        },
        {
            "id": 69,
            "code": "CSO",
            "name": "CORSO"
        },
        {
            "id": 70,
            "code": "CSP",
            "name": "CASE SPARSE"
        },
        {
            "id": 71,
            "code": "CSS",
            "name": "CHIASSO"
        },
        {
            "id": 72,
            "code": "CST",
            "name": "COSTA"
        },
        {
            "id": 73,
            "code": "CTE",
            "name": "CORTE"
        },
        {
            "id": 74,
            "code": "CTI",
            "name": "CORTI"
        },
        {
            "id": 75,
            "code": "CTL",
            "name": "CORTICELLA"
        },
        {
            "id": 76,
            "code": "CTP",
            "name": "CORTE I"
        },
        {
            "id": 77,
            "code": "CTQ",
            "name": "CORTE IV"
        },
        {
            "id": 78,
            "code": "CTS",
            "name": "CORTE II"
        },
        {
            "id": 79,
            "code": "CTT",
            "name": "CORSETTO"
        },
        {
            "id": 80,
            "code": "CUP",
            "name": "CUPA"
        },
        {
            "id": 81,
            "code": "CVA",
            "name": "CAVALCAVIA"
        },
        {
            "id": 82,
            "code": "DAR",
            "name": "DARSENA"
        },
        {
            "id": 83,
            "code": "DIS",
            "name": "DISTACCO"
        },
        {
            "id": 84,
            "code": "DPR",
            "name": "DIRAMAZIONE I"
        },
        {
            "id": 85,
            "code": "DPT",
            "name": "DIRAMAZIONE PRIVATA"
        },
        {
            "id": 86,
            "code": "DRC",
            "name": "DIRAMAZIONE COSTANTINO"
        },
        {
            "id": 87,
            "code": "DRG",
            "name": "DIRAMAZIONE GULLI"
        },
        {
            "id": 88,
            "code": "DRL",
            "name": "DIRAMAZIONE LAGANA"
        },
        {
            "id": 89,
            "code": "DRM",
            "name": "DIRAMAZIONE"
        },
        {
            "id": 90,
            "code": "DRS",
            "name": "DIRAMAZIONE II"
        },
        {
            "id": 91,
            "code": "DRT",
            "name": "DIRAMAZIONE III"
        },
        {
            "id": 92,
            "code": "DSC",
            "name": "DISCESA"
        },
        {
            "id": 93,
            "code": "DSO",
            "name": "DOSSO"
        },
        {
            "id": 94,
            "code": "EMI",
            "name": "EMICICLO"
        },
        {
            "id": 95,
            "code": "ERT",
            "name": "ERTA"
        },
        {
            "id": 96,
            "code": "ESR",
            "name": "ESEDRA"
        },
        {
            "id": 97,
            "code": "FNC",
            "name": "FONDACO"
        },
        {
            "id": 98,
            "code": "FND",
            "name": "FONDAMENTA"
        },
        {
            "id": 99,
            "code": "FNT",
            "name": "FONTEGO"
        },
        {
            "id": 100,
            "code": "FON",
            "name": "FONDO"
        },
        {
            "id": 101,
            "code": "FOR",
            "name": "FORNICE"
        },
        {
            "id": 102,
            "code": "FOS",
            "name": "FOSSATO"
        },
        {
            "id": 103,
            "code": "FP",
            "name": "FERMO POSTA"
        },
        {
            "id": 104,
            "code": "FRO",
            "name": "FORO"
        },
        {
            "id": 105,
            "code": "FRZ",
            "name": "FRAZIONE"
        },
        {
            "id": 106,
            "code": "GAL",
            "name": "GALLERIA"
        },
        {
            "id": 107,
            "code": "GRD",
            "name": "GRADINATA/GRADINI/GRADONI"
        },
        {
            "id": 108,
            "code": "GRM",
            "name": "GRUPPO A MONTE"
        },
        {
            "id": 109,
            "code": "GRN",
            "name": "GIARDINI/GIARDINO"
        },
        {
            "id": 110,
            "code": "GRV",
            "name": "GRUPPO A VALLE"
        },
        {
            "id": 111,
            "code": "GST",
            "name": "GUASTI"
        },
        {
            "id": 112,
            "code": "GVL",
            "name": "GRAN VIALE"
        },
        {
            "id": 113,
            "code": "INT",
            "name": "INTERNO"
        },
        {
            "id": 114,
            "code": "ISO",
            "name": "ISOLA"
        },
        {
            "id": 115,
            "code": "ITR",
            "name": "INTERRATO"
        },
        {
            "id": 116,
            "code": "LAD",
            "name": "LUNGADIGE"
        },
        {
            "id": 117,
            "code": "LAR",
            "name": "LUNGARGINE"
        },
        {
            "id": 118,
            "code": "LAT",
            "name": "LARGO ROTONDA"
        },
        {
            "id": 119,
            "code": "LBS",
            "name": "LUNGOBISAGNO"
        },
        {
            "id": 120,
            "code": "LDO",
            "name": "LUNGODORA"
        },
        {
            "id": 121,
            "code": "LFO",
            "name": "LUNGOFOGLIA"
        },
        {
            "id": 122,
            "code": "LGO",
            "name": "LARGO"
        },
        {
            "id": 123,
            "code": "LGP",
            "name": "LARGO PRIVATO"
        },
        {
            "id": 124,
            "code": "LGS",
            "name": "LARGO II"
        },
        {
            "id": 125,
            "code": "LLA",
            "name": "LUNGOLAGO"
        },
        {
            "id": 126,
            "code": "LMA",
            "name": "LUNGOMARE"
        },
        {
            "id": 127,
            "code": "LNF",
            "name": "LUNGOFIUME"
        },
        {
            "id": 128,
            "code": "LOC",
            "name": "LOCALITA"
        },
        {
            "id": 129,
            "code": "LOG",
            "name": "LOGGE"
        },
        {
            "id": 130,
            "code": "LOT",
            "name": "LOTTO/LOTTIZZAZIONE"
        },
        {
            "id": 131,
            "code": "LPA",
            "name": "LUNGOPARCO"
        },
        {
            "id": 132,
            "code": "LPM",
            "name": "LARGO I"
        },
        {
            "id": 133,
            "code": "LPO",
            "name": "LUNGOPO"
        },
        {
            "id": 134,
            "code": "LPR",
            "name": "LARGO PROPRIO"
        },
        {
            "id": 135,
            "code": "LRN",
            "name": "LUNGARNO"
        },
        {
            "id": 136,
            "code": "LRT",
            "name": "LARGHETTO"
        },
        {
            "id": 137,
            "code": "LST",
            "name": "LUNGOSTURA"
        },
        {
            "id": 138,
            "code": "LTA",
            "name": "LUNGOTANARO"
        },
        {
            "id": 139,
            "code": "LTE",
            "name": "LUNGOTEVERE"
        },
        {
            "id": 140,
            "code": "LTO",
            "name": "LITORANEA"
        },
        {
            "id": 141,
            "code": "LTP",
            "name": "LOTTO I"
        },
        {
            "id": 142,
            "code": "LTS",
            "name": "LOTTO II"
        },
        {
            "id": 143,
            "code": "LUN",
            "name": "LUNGO"
        },
        {
            "id": 144,
            "code": "LUO",
            "name": "LUOGO"
        },
        {
            "id": 145,
            "code": "LUT",
            "name": "LUNGOTORRENTE"
        },
        {
            "id": 146,
            "code": "MAS",
            "name": "MASO"
        },
        {
            "id": 147,
            "code": "MER",
            "name": "MERCATO"
        },
        {
            "id": 148,
            "code": "MLT",
            "name": "MULATTIERA"
        },
        {
            "id": 149,
            "code": "MOL",
            "name": "MOLO"
        },
        {
            "id": 150,
            "code": "MSS",
            "name": "MASSERIA"
        },
        {
            "id": 151,
            "code": "MUR",
            "name": "MURA"
        },
        {
            "id": 152,
            "code": "ORT",
            "name": "ORTO"
        },
        {
            "id": 153,
            "code": "PAS",
            "name": "PASSAGGIO"
        },
        {
            "id": 154,
            "code": "PDN",
            "name": "PENDINO"
        },
        {
            "id": 155,
            "code": "PDO",
            "name": "PENDIO"
        },
        {
            "id": 156,
            "code": "PEN",
            "name": "PENNINATA"
        },
        {
            "id": 157,
            "code": "PGO",
            "name": "PASSEGGIO"
        },
        {
            "id": 158,
            "code": "PGP",
            "name": "PASSAGGIO PRIVATO"
        },
        {
            "id": 159,
            "code": "PIA",
            "name": "PIAGGIA"
        },
        {
            "id": 160,
            "code": "PIS",
            "name": "PISCINA"
        },
        {
            "id": 161,
            "code": "PLD",
            "name": "PALUDO"
        },
        {
            "id": 162,
            "code": "PLL",
            "name": "PARALLELA"
        },
        {
            "id": 163,
            "code": "PLS",
            "name": "PARALLELA II/PLESSO"
        },
        {
            "id": 164,
            "code": "PND",
            "name": "PENDICE"
        },
        {
            "id": 165,
            "code": "PNL",
            "name": "PONTILE"
        },
        {
            "id": 166,
            "code": "PNO",
            "name": "PIANO"
        },
        {
            "id": 167,
            "code": "PNT",
            "name": "PINETA"
        },
        {
            "id": 168,
            "code": "POG",
            "name": "POGGIO"
        },
        {
            "id": 169,
            "code": "PRA",
            "name": "PRATO"
        },
        {
            "id": 170,
            "code": "PRC",
            "name": "PARCO"
        },
        {
            "id": 171,
            "code": "PRL",
            "name": "PORTICCIOLO"
        },
        {
            "id": 172,
            "code": "PRO",
            "name": "PROLUNGAMENTO"
        },
        {
            "id": 173,
            "code": "PRT",
            "name": "PORTICHETTI"
        },
        {
            "id": 174,
            "code": "PSA",
            "name": "PIASA"
        },
        {
            "id": 175,
            "code": "PSC",
            "name": "PASSO CHIUSO"
        },
        {
            "id": 176,
            "code": "PSG",
            "name": "PASSEGGIATA"
        },
        {
            "id": 177,
            "code": "PSO",
            "name": "PASSO"
        },
        {
            "id": 178,
            "code": "PSP",
            "name": "PASSO DI PIAZZA"
        },
        {
            "id": 179,
            "code": "PSS",
            "name": "PASSETTO"
        },
        {
            "id": 180,
            "code": "PTA",
            "name": "PORTA"
        },
        {
            "id": 181,
            "code": "PTC",
            "name": "PORTICO/PORTICI"
        },
        {
            "id": 182,
            "code": "PTE",
            "name": "PONTE"
        },
        {
            "id": 183,
            "code": "PTL",
            "name": "PORTELLA"
        },
        {
            "id": 184,
            "code": "PTO",
            "name": "PORTO"
        },
        {
            "id": 185,
            "code": "PTT",
            "name": "PIAZZETTA"
        },
        {
            "id": 186,
            "code": "PZA",
            "name": "PIAZZA"
        },
        {
            "id": 187,
            "code": "PZL",
            "name": "PIAZZALE"
        },
        {
            "id": 188,
            "code": "PZN",
            "name": "PIAZZA INFERIORE"
        },
        {
            "id": 189,
            "code": "PZP",
            "name": "PIAZZETTA PRIVATA"
        },
        {
            "id": 190,
            "code": "PZS",
            "name": "PIAZZA SUPERIORE"
        },
        {
            "id": 191,
            "code": "QDR",
            "name": "QUADRIVIO"
        },
        {
            "id": 192,
            "code": "QRT",
            "name": "QUARTIERE"
        },
        {
            "id": 193,
            "code": "QUA",
            "name": "QUADRATO"
        },
        {
            "id": 194,
            "code": "RAC",
            "name": "RACCORDO"
        },
        {
            "id": 195,
            "code": "RAM",
            "name": "RAMO/RAMI"
        },
        {
            "id": 196,
            "code": "RAT",
            "name": "RATTO"
        },
        {
            "id": 197,
            "code": "RCA",
            "name": "RACCORDO AUTOSTRADALE"
        },
        {
            "id": 198,
            "code": "RCO",
            "name": "RONCO"
        },
        {
            "id": 199,
            "code": "REG",
            "name": "REGIONE"
        },
        {
            "id": 200,
            "code": "RGH",
            "name": "RUGHETA"
        },
        {
            "id": 201,
            "code": "RIE",
            "name": "RIELO"
        },
        {
            "id": 202,
            "code": "RIG",
            "name": "RIGASTE"
        },
        {
            "id": 203,
            "code": "RIO",
            "name": "RIO"
        },
        {
            "id": 204,
            "code": "RIP",
            "name": "RIPA"
        },
        {
            "id": 205,
            "code": "RIT",
            "name": "RIO TERRA"
        },
        {
            "id": 206,
            "code": "RIV",
            "name": "RIVA"
        },
        {
            "id": 207,
            "code": "RMP",
            "name": "RAMPA/RAMPE"
        },
        {
            "id": 208,
            "code": "RMQ",
            "name": "RAMO IV"
        },
        {
            "id": 209,
            "code": "RMS",
            "name": "RAMO II"
        },
        {
            "id": 210,
            "code": "RNE",
            "name": "RIONE"
        },
        {
            "id": 211,
            "code": "RPA",
            "name": "RAMPARI"
        },
        {
            "id": 212,
            "code": "RPR",
            "name": "RAMO I"
        },
        {
            "id": 213,
            "code": "RTN",
            "name": "ROTONDA"
        },
        {
            "id": 214,
            "code": "RUA",
            "name": "RUA"
        },
        {
            "id": 215,
            "code": "RUG",
            "name": "RUGA"
        },
        {
            "id": 216,
            "code": "RVR",
            "name": "RIVIERA"
        },
        {
            "id": 217,
            "code": "SAC",
            "name": "STRADA COMUNALE ANTICA"
        },
        {
            "id": 218,
            "code": "SAI",
            "name": "SALITA INFERIORE"
        },
        {
            "id": 219,
            "code": "SAL",
            "name": "SALITA"
        },
        {
            "id": 220,
            "code": "SAR",
            "name": "STRADA ARGINALE"
        },
        {
            "id": 221,
            "code": "SAS",
            "name": "SALITA SUPERIORE"
        },
        {
            "id": 222,
            "code": "SAV",
            "name": "SALITA VECCHIA"
        },
        {
            "id": 223,
            "code": "SAZ",
            "name": "SALIZADA/SALIZZADA"
        },
        {
            "id": 224,
            "code": "SBA",
            "name": "SBARCATOIO"
        },
        {
            "id": 225,
            "code": "SC",
            "name": "STRADA COMUNALE"
        },
        {
            "id": 226,
            "code": "SCA",
            "name": "SCALA/SCALETTA"
        },
        {
            "id": 227,
            "code": "SCC",
            "name": "SACCA"
        },
        {
            "id": 228,
            "code": "SCE",
            "name": "SCESA"
        },
        {
            "id": 229,
            "code": "SCL",
            "name": "SCALO/SCALI"
        },
        {
            "id": 230,
            "code": "SCN",
            "name": "SCALONE"
        },
        {
            "id": 231,
            "code": "SCT",
            "name": "SCALINATA"
        },
        {
            "id": 232,
            "code": "SDR",
            "name": "SDRUCCIOLO"
        },
        {
            "id": 233,
            "code": "SEL",
            "name": "SELCIATO"
        },
        {
            "id": 234,
            "code": "SEN",
            "name": "SENTIERO"
        },
        {
            "id": 235,
            "code": "SES",
            "name": "SESTIERE"
        },
        {
            "id": 236,
            "code": "SGO",
            "name": "SOTTOPASSAGGIO/SOTTOVIA"
        },
        {
            "id": 237,
            "code": "SIT",
            "name": "SITO"
        },
        {
            "id": 238,
            "code": "SLE",
            "name": "SCALEA"
        },
        {
            "id": 239,
            "code": "SLL",
            "name": "STRADELLA/STRADELLO"
        },
        {
            "id": 240,
            "code": "SLN",
            "name": "SALITA NUOVA"
        },
        {
            "id": 241,
            "code": "SLP",
            "name": "STRADELLA I"
        },
        {
            "id": 242,
            "code": "SLQ",
            "name": "STRADELLA IV"
        },
        {
            "id": 243,
            "code": "SLS",
            "name": "STRADELLA II"
        },
        {
            "id": 244,
            "code": "SLT",
            "name": "STRADELLA III"
        },
        {
            "id": 245,
            "code": "SN",
            "name": "STRADA NAZIONALE"
        },
        {
            "id": 246,
            "code": "SNV",
            "name": "STRADA NUOVA"
        },
        {
            "id": 247,
            "code": "SOB",
            "name": "SOBBORGO"
        },
        {
            "id": 248,
            "code": "SOP",
            "name": "SOTOPORTEGO"
        },
        {
            "id": 249,
            "code": "SP",
            "name": "STRADA PROVINCIALE/VIA PROVINC"
        },
        {
            "id": 250,
            "code": "SPA",
            "name": "SPALTO"
        },
        {
            "id": 251,
            "code": "SPC",
            "name": "SOTTOPORTICO"
        },
        {
            "id": 252,
            "code": "SPN",
            "name": "SPIANATA"
        },
        {
            "id": 253,
            "code": "SPR",
            "name": "STRADA I"
        },
        {
            "id": 254,
            "code": "SPS",
            "name": "SOTTOPORTICO II"
        },
        {
            "id": 255,
            "code": "SPV",
            "name": "STRADA PRIVATA"
        },
        {
            "id": 256,
            "code": "SRA",
            "name": "STRADA ANTICA"
        },
        {
            "id": 257,
            "code": "SRE",
            "name": "STRADA III"
        },
        {
            "id": 258,
            "code": "SRQ",
            "name": "STRADA IV"
        },
        {
            "id": 259,
            "code": "SRS",
            "name": "SUPERSTRADA"
        },
        {
            "id": 260,
            "code": "SRU",
            "name": "STRADA RURALE"
        },
        {
            "id": 261,
            "code": "SRV",
            "name": "STRADA TRAVERSANTE"
        },
        {
            "id": 262,
            "code": "SS",
            "name": "STRADA STATALE"
        },
        {
            "id": 263,
            "code": "SSE",
            "name": "STRADA II"
        },
        {
            "id": 264,
            "code": "SST",
            "name": "STRADA VI"
        },
        {
            "id": 265,
            "code": "STA",
            "name": "STRADA ALTA"
        },
        {
            "id": 266,
            "code": "STB",
            "name": "STRADA BASSA"
        },
        {
            "id": 267,
            "code": "STC",
            "name": "STRADA COMUNALE CUPA"
        },
        {
            "id": 268,
            "code": "STD",
            "name": "STRADETTA"
        },
        {
            "id": 269,
            "code": "STE",
            "name": "STRADA ESTERNA"
        },
        {
            "id": 270,
            "code": "STL",
            "name": "STRADALE"
        },
        {
            "id": 271,
            "code": "STN",
            "name": "STRADONE"
        },
        {
            "id": 272,
            "code": "STQ",
            "name": "STRADA V"
        },
        {
            "id": 273,
            "code": "STR",
            "name": "STRADA"
        },
        {
            "id": 274,
            "code": "STT",
            "name": "STRETTO/STRETTOLA"
        },
        {
            "id": 275,
            "code": "STZ",
            "name": "STAZIONE"
        },
        {
            "id": 276,
            "code": "SUP",
            "name": "SUPPORTICO"
        },
        {
            "id": 277,
            "code": "SVC",
            "name": "STRADA VICINALE CUPA"
        },
        {
            "id": 278,
            "code": "SVE",
            "name": "STRADA VECCHIA"
        },
        {
            "id": 279,
            "code": "SVI",
            "name": "SVINCOLO"
        },
        {
            "id": 280,
            "code": "SVN",
            "name": "STRADA VICINALE"
        },
        {
            "id": 281,
            "code": "TAN",
            "name": "TANGENZIALE"
        },
        {
            "id": 282,
            "code": "TEN",
            "name": "TENUTA"
        },
        {
            "id": 283,
            "code": "TNN",
            "name": "TANGENZIALE NORD"
        },
        {
            "id": 284,
            "code": "TNS",
            "name": "TANGENZIALE SUD"
        },
        {
            "id": 285,
            "code": "TON",
            "name": "TONDO"
        },
        {
            "id": 286,
            "code": "TOR",
            "name": "TORRENTE"
        },
        {
            "id": 287,
            "code": "TRA",
            "name": "TRATTO"
        },
        {
            "id": 288,
            "code": "TRE",
            "name": "TRESANDA"
        },
        {
            "id": 289,
            "code": "TRS",
            "name": "TRASVERSALE"
        },
        {
            "id": 290,
            "code": "TRT",
            "name": "TRATTURO"
        },
        {
            "id": 291,
            "code": "TRV",
            "name": "TRAVERSA"
        },
        {
            "id": 292,
            "code": "V",
            "name": "VIA"
        },
        {
            "id": 293,
            "code": "VAL",
            "name": "VANELLA"
        },
        {
            "id": 294,
            "code": "VAN",
            "name": "VALLONE"
        },
        {
            "id": 295,
            "code": "VAR",
            "name": "VARCO"
        },
        {
            "id": 296,
            "code": "VCO",
            "name": "VICO/VICOLO/VICOLETTO"
        },
        {
            "id": 297,
            "code": "VDT",
            "name": "VIADOTTO"
        },
        {
            "id": 298,
            "code": "VIC",
            "name": "VICINALE"
        },
        {
            "id": 299,
            "code": "VIL",
            "name": "VILLA/VILLAGGIO"
        },
        {
            "id": 300,
            "code": "VLE",
            "name": "VIALE"
        },
        {
            "id": 301,
            "code": "VLT",
            "name": "VIALETTO"
        },
        {
            "id": 302,
            "code": "VNT",
            "name": "VARIANTE"
        },
        {
            "id": 303,
            "code": "VO",
            "name": "VO"
        },
        {
            "id": 304,
            "code": "VOC",
            "name": "VOCABOLO"
        },
        {
            "id": 305,
            "code": "VOL",
            "name": "VOLTA"
        },
        {
            "id": 306,
            "code": "VOP",
            "name": "VOCABOLO I"
        },
        {
            "id": 307,
            "code": "VOS",
            "name": "VOCABOLO II"
        },
        {
            "id": 308,
            "code": "VPR",
            "name": "VIA PRIVATA"
        },
        {
            "id": 309,
            "code": "VTL",
            "name": "VIOTTOLO/VIOTTOLA/VIOTTOLONE"
        },
        {
            "id": 310,
            "code": "VTN",
            "name": "VOLTONE"
        },
        {
            "id": 311,
            "code": "VTO",
            "name": "VOLTO"
        },
        {
            "id": 312,
            "code": "VZZ",
            "name": "VIUZZO"
        },
        {
            "id": 313,
            "code": "ZON",
            "name": "ZONA"
        },
        {
            "id": 314,
            "code": "PLE",
            "name": "PIAZZALE"
        }
    ]
    comuni = [
        {
            "id": 1,
            "name": "Abano Terme",
            "provincia": "PD",
            "cap": "35031",
            "cod_catastale": "A001",
            "cod_istat": "028001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2,
            "name": "Abbadia Cerreto",
            "provincia": "LO",
            "cap": "26834",
            "cod_catastale": "A004",
            "cod_istat": "098001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3,
            "name": "Abbadia Lariana",
            "provincia": "LC",
            "cap": "23821",
            "cod_catastale": "A005",
            "cod_istat": "097001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 4,
            "name": "Abbadia San Salvatore",
            "provincia": "SI",
            "cap": "53021",
            "cod_catastale": "A006",
            "cod_istat": "052001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 822,
            "giorni": 2994,
            "area": "",
            "ech": 0
        },
        {
            "id": 5,
            "name": "Abbasanta",
            "provincia": "OR",
            "cap": "09071",
            "cod_catastale": "A007",
            "cod_istat": "095001",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 315,
            "giorni": 1380,
            "area": "",
            "ech": 0
        },
        {
            "id": 6,
            "name": "Abbateggio",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "A008",
            "cod_istat": "068001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1949,
            "area": "",
            "ech": 0
        },
        {
            "id": 7,
            "name": "Abbiategrasso",
            "provincia": "MI",
            "cap": "20081",
            "cod_catastale": "A010",
            "cod_istat": "015002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 8,
            "name": "Abetone Cutigliano",
            "provincia": "PT",
            "cap": "51024",
            "cod_catastale": "M376",
            "cod_istat": "047023",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 9,
            "name": "Abriola",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "A013",
            "cod_istat": "076001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 957,
            "giorni": 2650,
            "area": "",
            "ech": 0
        },
        {
            "id": 10,
            "name": "Acate",
            "provincia": "RG",
            "cap": "97011",
            "cod_catastale": "A014",
            "cod_istat": "088001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1006,
            "area": "",
            "ech": 1
        },
        {
            "id": 11,
            "name": "Accadia",
            "provincia": "FG",
            "cap": "71021",
            "cod_catastale": "A015",
            "cod_istat": "071001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2223,
            "area": "",
            "ech": 0
        },
        {
            "id": 12,
            "name": "Acceglio",
            "provincia": "CN",
            "cap": "12021",
            "cod_catastale": "A016",
            "cod_istat": "004001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1200,
            "giorni": 3803,
            "area": "",
            "ech": 0
        },
        {
            "id": 13,
            "name": "Accettura",
            "provincia": "MT",
            "cap": "75011",
            "cod_catastale": "A017",
            "cod_istat": "077001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 770,
            "giorni": 2212,
            "area": "",
            "ech": 0
        },
        {
            "id": 14,
            "name": "Acciano",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "A018",
            "cod_istat": "066001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2362,
            "area": "",
            "ech": 0
        },
        {
            "id": 15,
            "name": "Accumoli",
            "provincia": "RI",
            "cap": "02011",
            "cod_catastale": "A019",
            "cod_istat": "057001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 855,
            "giorni": 2921,
            "area": "",
            "ech": 0
        },
        {
            "id": 16,
            "name": "Acerenza",
            "provincia": "PZ",
            "cap": "85011",
            "cod_catastale": "A020",
            "cod_istat": "076002",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 833,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 17,
            "name": "Acerno",
            "provincia": "SA",
            "cap": "84042",
            "cod_catastale": "A023",
            "cod_istat": "065001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 727,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 18,
            "name": "Acerra",
            "provincia": "NA",
            "cap": "80011",
            "cod_catastale": "A024",
            "cod_istat": "063001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1011,
            "area": "",
            "ech": 0
        },
        {
            "id": 19,
            "name": "Aci Bonaccorsi",
            "provincia": "CT",
            "cap": "95020",
            "cod_catastale": "A025",
            "cod_istat": "087001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 1213,
            "area": "",
            "ech": 0
        },
        {
            "id": 20,
            "name": "Aci Castello",
            "provincia": "CT",
            "cap": "95021",
            "cod_catastale": "A026",
            "cod_istat": "087002",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 784,
            "area": "",
            "ech": 1
        },
        {
            "id": 21,
            "name": "Aci Catena",
            "provincia": "CT",
            "cap": "95022",
            "cod_catastale": "A027",
            "cod_istat": "087003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 988,
            "area": "",
            "ech": 1
        },
        {
            "id": 22,
            "name": "Aci Sant'Antonio",
            "provincia": "CT",
            "cap": "95025",
            "cod_catastale": "A029",
            "cod_istat": "087005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 302,
            "giorni": 1167,
            "area": "",
            "ech": 1
        },
        {
            "id": 23,
            "name": "Acireale",
            "provincia": "CT",
            "cap": "95024",
            "cod_catastale": "A028",
            "cod_istat": "087004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 978,
            "area": "",
            "ech": 1
        },
        {
            "id": 24,
            "name": "Acquacanina",
            "provincia": "MC",
            "cap": "62035",
            "cod_catastale": "A031",
            "cod_istat": "043001",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 734,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 25,
            "name": "Acquafondata",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "A032",
            "cod_istat": "060001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 926,
            "giorni": 2839,
            "area": "",
            "ech": 0
        },
        {
            "id": 26,
            "name": "Acquaformosa",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "A033",
            "cod_istat": "078001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 756,
            "giorni": 2314,
            "area": "",
            "ech": 0
        },
        {
            "id": 27,
            "name": "Acquafredda",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "A034",
            "cod_istat": "017001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 28,
            "name": "Acqualagna",
            "provincia": "PU",
            "cap": "61041",
            "cod_catastale": "A035",
            "cod_istat": "041001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2237,
            "area": "",
            "ech": 0
        },
        {
            "id": 29,
            "name": "Acquanegra Cremonese",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "A039",
            "cod_istat": "019001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 30,
            "name": "Acquanegra sul Chiese",
            "provincia": "MN",
            "cap": "46011",
            "cod_catastale": "A038",
            "cod_istat": "020001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 31,
            "name": "Acquapendente",
            "provincia": "VT",
            "cap": "01021",
            "cod_catastale": "A040",
            "cod_istat": "056001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2299,
            "area": "",
            "ech": 0
        },
        {
            "id": 32,
            "name": "Acquappesa",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "A041",
            "cod_istat": "078002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 973,
            "area": "",
            "ech": 0
        },
        {
            "id": 33,
            "name": "Acquarica del Capo",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "A042",
            "cod_istat": "075001",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1198,
            "area": "",
            "ech": 0
        },
        {
            "id": 34,
            "name": "Acquaro",
            "provincia": "VV",
            "cap": "89832",
            "cod_catastale": "A043",
            "cod_istat": "102001",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 262,
            "giorni": 1299,
            "area": "",
            "ech": 0
        },
        {
            "id": 35,
            "name": "Acquasanta Terme",
            "provincia": "AP",
            "cap": "63095",
            "cod_catastale": "A044",
            "cod_istat": "044001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 392,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 36,
            "name": "Acquasparta",
            "provincia": "TR",
            "cap": "05021",
            "cod_catastale": "A045",
            "cod_istat": "055001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1947,
            "area": "",
            "ech": 0
        },
        {
            "id": 37,
            "name": "Acquaviva Collecroce",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "A050",
            "cod_istat": "070001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1880,
            "area": "",
            "ech": 0
        },
        {
            "id": 38,
            "name": "Acquaviva delle Fonti",
            "provincia": "BA",
            "cap": "70021",
            "cod_catastale": "A048",
            "cod_istat": "072001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1610,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 39,
            "name": "Acquaviva d'Isernia",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "A051",
            "cod_istat": "094001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 40,
            "name": "Acquaviva Picena",
            "provincia": "AP",
            "cap": "63075",
            "cod_catastale": "A047",
            "cod_istat": "044002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 359,
            "giorni": 2060,
            "area": "",
            "ech": 0
        },
        {
            "id": 41,
            "name": "Acquaviva Platani",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "A049",
            "cod_istat": "085001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 558,
            "giorni": 1508,
            "area": "",
            "ech": 0
        },
        {
            "id": 42,
            "name": "Acquedolci",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "M211",
            "cod_istat": "083107",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 716,
            "area": "",
            "ech": 0
        },
        {
            "id": 43,
            "name": "Acqui Terme",
            "provincia": "AL",
            "cap": "15011",
            "cod_catastale": "A052",
            "cod_istat": "006001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 44,
            "name": "Acri",
            "provincia": "CS",
            "cap": "87041",
            "cod_catastale": "A053",
            "cod_istat": "078003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 720,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 45,
            "name": "Acuto",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "A054",
            "cod_istat": "060002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 724,
            "giorni": 2519,
            "area": "",
            "ech": 0
        },
        {
            "id": 46,
            "name": "Adelfia",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "A055",
            "cod_istat": "072002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 1402,
            "area": "",
            "ech": 0
        },
        {
            "id": 47,
            "name": "Adrano",
            "provincia": "CT",
            "cap": "95031",
            "cod_catastale": "A056",
            "cod_istat": "087006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 1438,
            "area": "",
            "ech": 1
        },
        {
            "id": 48,
            "name": "Adrara San Martino",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A057",
            "cod_istat": "016001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 2574,
            "area": "",
            "ech": 0
        },
        {
            "id": 49,
            "name": "Adrara San Rocco",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A058",
            "cod_istat": "016002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 50,
            "name": "Adria",
            "provincia": "RO",
            "cap": "45011",
            "cod_catastale": "A059",
            "cod_istat": "029001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 51,
            "name": "Adro",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "A060",
            "cod_istat": "017002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 52,
            "name": "Affi",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "A061",
            "cod_istat": "023001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 53,
            "name": "Affile",
            "provincia": "RM",
            "cap": "00021",
            "cod_catastale": "A062",
            "cod_istat": "058001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 684,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 54,
            "name": "Afragola",
            "provincia": "NA",
            "cap": "80021",
            "cod_catastale": "A064",
            "cod_istat": "063002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1036,
            "area": "",
            "ech": 0
        },
        {
            "id": 55,
            "name": "Africo",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "A065",
            "cod_istat": "080001",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 15,
            "giorni": 664,
            "area": "",
            "ech": 1
        },
        {
            "id": 56,
            "name": "Agazzano",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "A067",
            "cod_istat": "033001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 57,
            "name": "Agerola",
            "provincia": "NA",
            "cap": "80051",
            "cod_catastale": "A068",
            "cod_istat": "063003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 1965,
            "area": "",
            "ech": 0
        },
        {
            "id": 58,
            "name": "Aggius",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "A069",
            "cod_istat": "090001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 514,
            "giorni": 1847,
            "area": "",
            "ech": 0
        },
        {
            "id": 59,
            "name": "Agira",
            "provincia": "EN",
            "cap": "94011",
            "cod_catastale": "A070",
            "cod_istat": "086001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 1648,
            "area": "",
            "ech": 1
        },
        {
            "id": 60,
            "name": "Agliana",
            "provincia": "PT",
            "cap": "51031",
            "cod_catastale": "A071",
            "cod_istat": "047002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 1737,
            "area": "",
            "ech": 0
        },
        {
            "id": 61,
            "name": "Agliano Terme",
            "provincia": "AT",
            "cap": "14041",
            "cod_catastale": "A072",
            "cod_istat": "005001",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 62,
            "name": "Agliè",
            "provincia": "TO",
            "cap": "10011",
            "cod_catastale": "A074",
            "cod_istat": "001001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 63,
            "name": "Aglientu",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "H848",
            "cod_istat": "090062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1708,
            "area": "",
            "ech": 0
        },
        {
            "id": 64,
            "name": "Agna",
            "provincia": "PD",
            "cap": "35021",
            "cod_catastale": "A075",
            "cod_istat": "028002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2361,
            "area": "",
            "ech": 0
        },
        {
            "id": 65,
            "name": "Agnadello",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "A076",
            "cod_istat": "019002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 94,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 66,
            "name": "Agnana Calabra",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "A077",
            "cod_istat": "080002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1093,
            "area": "",
            "ech": 1
        },
        {
            "id": 67,
            "name": "Agnone",
            "provincia": "IS",
            "cap": "86081",
            "cod_catastale": "A080",
            "cod_istat": "094002",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 830,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 68,
            "name": "Agnosine",
            "provincia": "BS",
            "cap": "25071",
            "cod_catastale": "A082",
            "cod_istat": "017003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 2881,
            "area": "",
            "ech": 0
        },
        {
            "id": 69,
            "name": "Agordo",
            "provincia": "BL",
            "cap": "32021",
            "cod_catastale": "A083",
            "cod_istat": "025001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 611,
            "giorni": 3376,
            "area": "",
            "ech": 0
        },
        {
            "id": 70,
            "name": "Agosta",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "A084",
            "cod_istat": "058002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 1898,
            "area": "",
            "ech": 0
        },
        {
            "id": 71,
            "name": "Agra",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "A085",
            "cod_istat": "012001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 3029,
            "area": "",
            "ech": 0
        },
        {
            "id": 72,
            "name": "Agrate Brianza",
            "provincia": "MB",
            "cap": "20864",
            "cod_catastale": "A087",
            "cod_istat": "108001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 73,
            "name": "Agrate Conturbia",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A088",
            "cod_istat": "003001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 2743,
            "area": "",
            "ech": 0
        },
        {
            "id": 74,
            "name": "Agrigento",
            "provincia": "AG",
            "cap": "92100",
            "cod_catastale": "A089",
            "cod_istat": "084001",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 230,
            "giorni": 729,
            "area": "",
            "ech": 1
        },
        {
            "id": 75,
            "name": "Agropoli",
            "provincia": "SA",
            "cap": "84043",
            "cod_catastale": "A091",
            "cod_istat": "065002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 1021,
            "area": "",
            "ech": 0
        },
        {
            "id": 76,
            "name": "Agugliano",
            "provincia": "AN",
            "cap": "60020",
            "cod_catastale": "A092",
            "cod_istat": "042001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2064,
            "area": "",
            "ech": 0
        },
        {
            "id": 77,
            "name": "Agugliaro",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "A093",
            "cod_istat": "024001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 78,
            "name": "Aicurzio",
            "provincia": "MB",
            "cap": "20886",
            "cod_catastale": "A096",
            "cod_istat": "108002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2415,
            "area": "",
            "ech": 0
        },
        {
            "id": 79,
            "name": "Aidomaggiore",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "A097",
            "cod_istat": "095002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 250,
            "giorni": 1319,
            "area": "",
            "ech": 0
        },
        {
            "id": 80,
            "name": "Aidone",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "A098",
            "cod_istat": "086002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 1763,
            "area": "",
            "ech": 1
        },
        {
            "id": 81,
            "name": "Aielli",
            "provincia": "AQ",
            "cap": "67041",
            "cod_catastale": "A100",
            "cod_istat": "066002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1021,
            "giorni": 3116,
            "area": "",
            "ech": 0
        },
        {
            "id": 82,
            "name": "Aiello Calabro",
            "provincia": "CS",
            "cap": "87031",
            "cod_catastale": "A102",
            "cod_istat": "078004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 502,
            "giorni": 1808,
            "area": "",
            "ech": 0
        },
        {
            "id": 83,
            "name": "Aiello del Friuli",
            "provincia": "UD",
            "cap": "33041",
            "cod_catastale": "A103",
            "cod_istat": "030001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2268,
            "area": "",
            "ech": 0
        },
        {
            "id": 84,
            "name": "Aiello del Sabato",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "A101",
            "cod_istat": "064001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1931,
            "area": "",
            "ech": 0
        },
        {
            "id": 85,
            "name": "Aieta",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "A105",
            "cod_istat": "078005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 524,
            "giorni": 1780,
            "area": "",
            "ech": 0
        },
        {
            "id": 86,
            "name": "Ailano",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "A106",
            "cod_istat": "061001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 260,
            "giorni": 1575,
            "area": "",
            "ech": 0
        },
        {
            "id": 87,
            "name": "Ailoche",
            "provincia": "BI",
            "cap": "13861",
            "cod_catastale": "A107",
            "cod_istat": "096001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 569,
            "giorni": 3044,
            "area": "",
            "ech": 0
        },
        {
            "id": 88,
            "name": "Airasca",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "A109",
            "cod_istat": "001002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 89,
            "name": "Airola",
            "provincia": "BN",
            "cap": "82011",
            "cod_catastale": "A110",
            "cod_istat": "062001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 90,
            "name": "Airole",
            "provincia": "IM",
            "cap": "18030",
            "cod_catastale": "A111",
            "cod_istat": "008001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 1706,
            "area": "",
            "ech": 0
        },
        {
            "id": 91,
            "name": "Airuno",
            "provincia": "LC",
            "cap": "23881",
            "cod_catastale": "A112",
            "cod_istat": "097002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 92,
            "name": "Aisone",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "A113",
            "cod_istat": "004002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 834,
            "giorni": 3349,
            "area": "",
            "ech": 0
        },
        {
            "id": 93,
            "name": "Ala",
            "provincia": "TN",
            "cap": "38061",
            "cod_catastale": "A116",
            "cod_istat": "022001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 2672,
            "area": "",
            "ech": 0
        },
        {
            "id": 94,
            "name": "Alà dei Sardi",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "A115",
            "cod_istat": "090002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 663,
            "giorni": 2208,
            "area": "",
            "ech": 1
        },
        {
            "id": 95,
            "name": "Ala di Stura",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "A117",
            "cod_istat": "001003",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1080,
            "giorni": 3974,
            "area": "",
            "ech": 0
        },
        {
            "id": 96,
            "name": "Alagna",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "A118",
            "cod_istat": "018001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 97,
            "name": "Alagna Valsesia",
            "provincia": "VC",
            "cap": "13021",
            "cod_catastale": "A119",
            "cod_istat": "002002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1191,
            "giorni": 3877,
            "area": "",
            "ech": 0
        },
        {
            "id": 98,
            "name": "Alanno",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "A120",
            "cod_istat": "068002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 1719,
            "area": "",
            "ech": 0
        },
        {
            "id": 99,
            "name": "Alano di Piave",
            "provincia": "BL",
            "cap": "32031",
            "cod_catastale": "A121",
            "cod_istat": "025002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 3071,
            "area": "",
            "ech": 0
        },
        {
            "id": 100,
            "name": "Alassio",
            "provincia": "SV",
            "cap": "17021",
            "cod_catastale": "A122",
            "cod_istat": "009001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1206,
            "area": "",
            "ech": 0
        },
        {
            "id": 101,
            "name": "Alatri",
            "provincia": "FR",
            "cap": "03011",
            "cod_catastale": "A123",
            "cod_istat": "060003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 502,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 102,
            "name": "Alba",
            "provincia": "CN",
            "cap": "12051",
            "cod_catastale": "A124",
            "cod_istat": "004003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 2528,
            "area": "",
            "ech": 0
        },
        {
            "id": 103,
            "name": "Alba Adriatica",
            "provincia": "TE",
            "cap": "64011",
            "cod_catastale": "A125",
            "cod_istat": "067001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1206,
            "area": "",
            "ech": 0
        },
        {
            "id": 104,
            "name": "Albagiara",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "A126",
            "cod_istat": "095003",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 215,
            "giorni": 1252,
            "area": "",
            "ech": 0
        },
        {
            "id": 105,
            "name": "Albairate",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "A127",
            "cod_istat": "015005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 106,
            "name": "Albanella",
            "provincia": "SA",
            "cap": "84044",
            "cod_catastale": "A128",
            "cod_istat": "065003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 1301,
            "area": "",
            "ech": 0
        },
        {
            "id": 107,
            "name": "Albano di Lucania",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "A131",
            "cod_istat": "076003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 899,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 108,
            "name": "Albano Laziale",
            "provincia": "RM",
            "cap": "00041",
            "cod_catastale": "A132",
            "cod_istat": "058003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1922,
            "area": "",
            "ech": 0
        },
        {
            "id": 109,
            "name": "Albano Sant'Alessandro",
            "provincia": "BG",
            "cap": "24061",
            "cod_catastale": "A129",
            "cod_istat": "016003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 110,
            "name": "Albano Vercellese",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "A130",
            "cod_istat": "002003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 2779,
            "area": "",
            "ech": 0
        },
        {
            "id": 111,
            "name": "Albaredo Arnaboldi",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "A134",
            "cod_istat": "018002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 112,
            "name": "Albaredo d'Adige",
            "provincia": "VR",
            "cap": "37041",
            "cod_catastale": "A137",
            "cod_istat": "023002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 113,
            "name": "Albaredo per San Marco",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "A135",
            "cod_istat": "014001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 950,
            "giorni": 3419,
            "area": "",
            "ech": 0
        },
        {
            "id": 114,
            "name": "Albareto",
            "provincia": "PR",
            "cap": "43051",
            "cod_catastale": "A138",
            "cod_istat": "034001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 512,
            "giorni": 3015,
            "area": "",
            "ech": 0
        },
        {
            "id": 115,
            "name": "Albaretto della Torre",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "A139",
            "cod_istat": "004004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 672,
            "giorni": 3148,
            "area": "",
            "ech": 0
        },
        {
            "id": 116,
            "name": "Albavilla",
            "provincia": "CO",
            "cap": "22031",
            "cod_catastale": "A143",
            "cod_istat": "013003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2679,
            "area": "",
            "ech": 0
        },
        {
            "id": 117,
            "name": "Albenga",
            "provincia": "SV",
            "cap": "17031",
            "cod_catastale": "A145",
            "cod_istat": "009002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1203,
            "area": "",
            "ech": 0
        },
        {
            "id": 118,
            "name": "Albera Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "A146",
            "cod_istat": "006002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 2831,
            "area": "",
            "ech": 0
        },
        {
            "id": 119,
            "name": "Alberobello",
            "provincia": "BA",
            "cap": "70011",
            "cod_catastale": "A149",
            "cod_istat": "072003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 1644,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 120,
            "name": "Alberona",
            "provincia": "FG",
            "cap": "71031",
            "cod_catastale": "A150",
            "cod_istat": "071002",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 732,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 121,
            "name": "Albese con Cassano",
            "provincia": "CO",
            "cap": "22032",
            "cod_catastale": "A153",
            "cod_istat": "013004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 122,
            "name": "Albettone",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "A154",
            "cod_istat": "024002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 123,
            "name": "Albi",
            "provincia": "CZ",
            "cap": "88055",
            "cod_catastale": "A155",
            "cod_istat": "079002",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 2319,
            "area": "",
            "ech": 1
        },
        {
            "id": 124,
            "name": "Albiano",
            "provincia": "TN",
            "cap": "38041",
            "cod_catastale": "A158",
            "cod_istat": "022002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 644,
            "giorni": 3395,
            "area": "",
            "ech": 0
        },
        {
            "id": 125,
            "name": "Albiano d'Ivrea",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A157",
            "cod_istat": "001004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2706,
            "area": "",
            "ech": 0
        },
        {
            "id": 126,
            "name": "Albiate",
            "provincia": "MB",
            "cap": "20847",
            "cod_catastale": "A159",
            "cod_istat": "108003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2469,
            "area": "",
            "ech": 0
        },
        {
            "id": 127,
            "name": "Albidona",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "A160",
            "cod_istat": "078006",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 810,
            "giorni": 2418,
            "area": "",
            "ech": 1
        },
        {
            "id": 128,
            "name": "Albignasego",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "A161",
            "cod_istat": "028003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 129,
            "name": "Albinea",
            "provincia": "RE",
            "cap": "42020",
            "cod_catastale": "A162",
            "cod_istat": "035001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 166,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 130,
            "name": "Albino",
            "provincia": "BG",
            "cap": "24021",
            "cod_catastale": "A163",
            "cod_istat": "016004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2543,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 131,
            "name": "Albiolo",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "A164",
            "cod_istat": "013005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 423,
            "giorni": 2670,
            "area": "",
            "ech": 0
        },
        {
            "id": 132,
            "name": "Albisola Superiore",
            "provincia": "SV",
            "cap": "17011",
            "cod_catastale": "A166",
            "cod_istat": "009004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1490,
            "area": "",
            "ech": 0
        },
        {
            "id": 133,
            "name": "Albissola Marina",
            "provincia": "SV",
            "cap": "17012",
            "cod_catastale": "A165",
            "cod_istat": "009003",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 134,
            "name": "Albizzate",
            "provincia": "VA",
            "cap": "21041",
            "cod_catastale": "A167",
            "cod_istat": "012002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2605,
            "area": "",
            "ech": 0
        },
        {
            "id": 135,
            "name": "Albonese",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "A171",
            "cod_istat": "018003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 136,
            "name": "Albosaggia",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "A172",
            "cod_istat": "014002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 3256,
            "area": "",
            "ech": 0
        },
        {
            "id": 137,
            "name": "Albugnano",
            "provincia": "AT",
            "cap": "14022",
            "cod_catastale": "A173",
            "cod_istat": "005002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 2943,
            "area": "",
            "ech": 0
        },
        {
            "id": 138,
            "name": "Albuzzano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "A175",
            "cod_istat": "018004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 139,
            "name": "Alcamo",
            "provincia": "TP",
            "cap": "91011",
            "cod_catastale": "A176",
            "cod_istat": "081001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 1140,
            "area": "",
            "ech": 0
        },
        {
            "id": 140,
            "name": "Alcara li Fusi",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "A177",
            "cod_istat": "083001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1310,
            "area": "",
            "ech": 1
        },
        {
            "id": 141,
            "name": "Aldeno",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "A178",
            "cod_istat": "022003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 142,
            "name": "Aldino",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "A179",
            "cod_istat": "021001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1225,
            "giorni": 4330,
            "area": "",
            "ech": 0
        },
        {
            "id": 143,
            "name": "Ales",
            "provincia": "OR",
            "cap": "09091",
            "cod_catastale": "A180",
            "cod_istat": "095004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 194,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 144,
            "name": "Alessandria",
            "provincia": "AL",
            "cap": "151xx",
            "cod_catastale": "A182",
            "cod_istat": "006003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 145,
            "name": "Alessandria del Carretto",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "A183",
            "cod_istat": "078007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1000,
            "giorni": 2794,
            "area": "",
            "ech": 0
        },
        {
            "id": 146,
            "name": "Alessandria della Rocca",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "A181",
            "cod_istat": "084002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 533,
            "giorni": 1311,
            "area": "",
            "ech": 0
        },
        {
            "id": 147,
            "name": "Alessano",
            "provincia": "LE",
            "cap": "73031",
            "cod_catastale": "A184",
            "cod_istat": "075002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 148,
            "name": "Alezio",
            "provincia": "LE",
            "cap": "73011",
            "cod_catastale": "A185",
            "cod_istat": "075003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1079,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 149,
            "name": "Alfano",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "A186",
            "cod_istat": "065004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 260,
            "giorni": 1369,
            "area": "",
            "ech": 0
        },
        {
            "id": 150,
            "name": "Alfedena",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "A187",
            "cod_istat": "066003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 914,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 151,
            "name": "Alfianello",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "A188",
            "cod_istat": "017004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 152,
            "name": "Alfiano Natta",
            "provincia": "AL",
            "cap": "15021",
            "cod_catastale": "A189",
            "cod_istat": "006004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 153,
            "name": "Alfonsine",
            "provincia": "RA",
            "cap": "48011",
            "cod_catastale": "A191",
            "cod_istat": "039001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 154,
            "name": "Alghero",
            "provincia": "SS",
            "cap": "07041",
            "cod_catastale": "A192",
            "cod_istat": "090003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1001,
            "area": "",
            "ech": 0
        },
        {
            "id": 155,
            "name": "Algua",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "A193",
            "cod_istat": "016248",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 156,
            "name": "Alì",
            "provincia": "ME",
            "cap": "98020",
            "cod_catastale": "A194",
            "cod_istat": "083002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1396,
            "area": "",
            "ech": 0
        },
        {
            "id": 157,
            "name": "Alì Terme",
            "provincia": "ME",
            "cap": "98021",
            "cod_catastale": "A201",
            "cod_istat": "083003",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 642,
            "area": "",
            "ech": 0
        },
        {
            "id": 158,
            "name": "Alia",
            "provincia": "PA",
            "cap": "90021",
            "cod_catastale": "A195",
            "cod_istat": "082001",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 726,
            "giorni": 1744,
            "area": "",
            "ech": 1
        },
        {
            "id": 159,
            "name": "Aliano",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "A196",
            "cod_istat": "077002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 555,
            "giorni": 1812,
            "area": "",
            "ech": 0
        },
        {
            "id": 160,
            "name": "Alice Bel Colle",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "A197",
            "cod_istat": "006005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 418,
            "giorni": 2833,
            "area": "",
            "ech": 0
        },
        {
            "id": 161,
            "name": "Alice Castello",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "A198",
            "cod_istat": "002004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 162,
            "name": "Alice Superiore",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A199",
            "cod_istat": "001005",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 3146,
            "area": "",
            "ech": 0
        },
        {
            "id": 163,
            "name": "Alife",
            "provincia": "CE",
            "cap": "81011",
            "cod_catastale": "A200",
            "cod_istat": "061002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 110,
            "giorni": 1263,
            "area": "",
            "ech": 0
        },
        {
            "id": 164,
            "name": "Alimena",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "A202",
            "cod_istat": "082002",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 1816,
            "area": "",
            "ech": 0
        },
        {
            "id": 165,
            "name": "Aliminusa",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "A203",
            "cod_istat": "082003",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1326,
            "area": "",
            "ech": 0
        },
        {
            "id": 166,
            "name": "Allai",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "A204",
            "cod_istat": "095005",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 60,
            "giorni": 969,
            "area": "",
            "ech": 0
        },
        {
            "id": 167,
            "name": "Alleghe",
            "provincia": "BL",
            "cap": "32022",
            "cod_catastale": "A206",
            "cod_istat": "025003",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 979,
            "giorni": 3874,
            "area": "",
            "ech": 0
        },
        {
            "id": 168,
            "name": "Allein",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "A205",
            "cod_istat": "007001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1190,
            "giorni": 3994,
            "area": "",
            "ech": 0
        },
        {
            "id": 169,
            "name": "Allerona",
            "provincia": "TR",
            "cap": "05011",
            "cod_catastale": "A207",
            "cod_istat": "055002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 2173,
            "area": "",
            "ech": 0
        },
        {
            "id": 170,
            "name": "Alliste",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "A208",
            "cod_istat": "075004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 1094,
            "area": "",
            "ech": 0
        },
        {
            "id": 171,
            "name": "Allumiere",
            "provincia": "RM",
            "cap": "00051",
            "cod_catastale": "A210",
            "cod_istat": "058004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 522,
            "giorni": 2134,
            "area": "",
            "ech": 0
        },
        {
            "id": 172,
            "name": "Alluvioni Cambiò",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "A211",
            "cod_istat": "006006",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 173,
            "name": "Almè",
            "provincia": "BG",
            "cap": "24011",
            "cod_catastale": "A214",
            "cod_istat": "016005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2418,
            "area": "",
            "ech": 0
        },
        {
            "id": 174,
            "name": "Almenno San Bartolomeo",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "A216",
            "cod_istat": "016006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 2500,
            "area": "",
            "ech": 0
        },
        {
            "id": 175,
            "name": "Almenno San Salvatore",
            "provincia": "BG",
            "cap": "24031",
            "cod_catastale": "A217",
            "cod_istat": "016007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 176,
            "name": "Almese",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "A218",
            "cod_istat": "001006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2900,
            "area": "",
            "ech": 0
        },
        {
            "id": 177,
            "name": "Alonte",
            "provincia": "VI",
            "cap": "36045",
            "cod_catastale": "A220",
            "cod_istat": "024003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2448,
            "area": "",
            "ech": 0
        },
        {
            "id": 178,
            "name": "Alpette",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "A221",
            "cod_istat": "001007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 957,
            "giorni": 3789,
            "area": "",
            "ech": 0
        },
        {
            "id": 179,
            "name": "Alpignano",
            "provincia": "TO",
            "cap": "10091",
            "cod_catastale": "A222",
            "cod_istat": "001008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2825,
            "area": "",
            "ech": 0
        },
        {
            "id": 180,
            "name": "Alseno",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "A223",
            "cod_istat": "033002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 2605,
            "area": "",
            "ech": 0
        },
        {
            "id": 181,
            "name": "Alserio",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "A224",
            "cod_istat": "013006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 182,
            "name": "Altamura",
            "provincia": "BA",
            "cap": "70022",
            "cod_catastale": "A225",
            "cod_istat": "072004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 467,
            "giorni": 1858,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 183,
            "name": "Altare",
            "provincia": "SV",
            "cap": "17041",
            "cod_catastale": "A226",
            "cod_istat": "009005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2264,
            "area": "",
            "ech": 0
        },
        {
            "id": 184,
            "name": "Altavilla Irpina",
            "provincia": "AV",
            "cap": "83011",
            "cod_catastale": "A228",
            "cod_istat": "064002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 1780,
            "area": "",
            "ech": 0
        },
        {
            "id": 185,
            "name": "Altavilla Milicia",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "A229",
            "cod_istat": "082004",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 869,
            "area": "",
            "ech": 1
        },
        {
            "id": 186,
            "name": "Altavilla Monferrato",
            "provincia": "AL",
            "cap": "15041",
            "cod_catastale": "A227",
            "cod_istat": "006007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 2697,
            "area": "",
            "ech": 0
        },
        {
            "id": 187,
            "name": "Altavilla Silentina",
            "provincia": "SA",
            "cap": "84045",
            "cod_catastale": "A230",
            "cod_istat": "065005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 1536,
            "area": "",
            "ech": 0
        },
        {
            "id": 188,
            "name": "Altavilla Vicentina",
            "provincia": "VI",
            "cap": "36077",
            "cod_catastale": "A231",
            "cod_istat": "024004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2381,
            "area": "",
            "ech": 0
        },
        {
            "id": 189,
            "name": "Altidona",
            "provincia": "FM",
            "cap": "63824",
            "cod_catastale": "A233",
            "cod_istat": "109001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 1988,
            "area": "",
            "ech": 0
        },
        {
            "id": 190,
            "name": "Altilia",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "A234",
            "cod_istat": "078008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 594,
            "giorni": 1990,
            "area": "",
            "ech": 0
        },
        {
            "id": 191,
            "name": "Altino",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "A235",
            "cod_istat": "069001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 1714,
            "area": "",
            "ech": 0
        },
        {
            "id": 192,
            "name": "Altissimo",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "A236",
            "cod_istat": "024005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 672,
            "giorni": 3346,
            "area": "",
            "ech": 0
        },
        {
            "id": 193,
            "name": "Altivole",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "A237",
            "cod_istat": "026001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 194,
            "name": "Alto",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "A238",
            "cod_istat": "004005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 652,
            "giorni": 3016,
            "area": "",
            "ech": 0
        },
        {
            "id": 195,
            "name": "Altofonte",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "A239",
            "cod_istat": "082005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 948,
            "area": "",
            "ech": 1
        },
        {
            "id": 196,
            "name": "Altomonte",
            "provincia": "CS",
            "cap": "87042",
            "cod_catastale": "A240",
            "cod_istat": "078009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 455,
            "giorni": 1727,
            "area": "",
            "ech": 0
        },
        {
            "id": 197,
            "name": "Altopascio",
            "provincia": "LU",
            "cap": "55011",
            "cod_catastale": "A241",
            "cod_istat": "046001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 198,
            "name": "Alviano",
            "provincia": "TR",
            "cap": "05020",
            "cod_catastale": "A242",
            "cod_istat": "055003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 1822,
            "area": "",
            "ech": 0
        },
        {
            "id": 199,
            "name": "Alvignano",
            "provincia": "CE",
            "cap": "81012",
            "cod_catastale": "A243",
            "cod_istat": "061003",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 132,
            "giorni": 1308,
            "area": "",
            "ech": 0
        },
        {
            "id": 200,
            "name": "Alvito",
            "provincia": "FR",
            "cap": "03041",
            "cod_catastale": "A244",
            "cod_istat": "060004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 475,
            "giorni": 1965,
            "area": "",
            "ech": 0
        },
        {
            "id": 201,
            "name": "Alzano Lombardo",
            "provincia": "BG",
            "cap": "24022",
            "cod_catastale": "A246",
            "cod_istat": "016008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 202,
            "name": "Alzano Scrivia",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "A245",
            "cod_istat": "006008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 203,
            "name": "Alzate Brianza",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "A249",
            "cod_istat": "013007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 371,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 204,
            "name": "Amalfi",
            "provincia": "SA",
            "cap": "84011",
            "cod_catastale": "A251",
            "cod_istat": "065006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 954,
            "area": "",
            "ech": 0
        },
        {
            "id": 205,
            "name": "Amandola",
            "provincia": "FM",
            "cap": "63857",
            "cod_catastale": "A252",
            "cod_istat": "109002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2283,
            "area": "",
            "ech": 0
        },
        {
            "id": 206,
            "name": "Amantea",
            "provincia": "CS",
            "cap": "87032",
            "cod_catastale": "A253",
            "cod_istat": "078010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 913,
            "area": "",
            "ech": 0
        },
        {
            "id": 207,
            "name": "Amaro",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "A254",
            "cod_istat": "030002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 208,
            "name": "Amaroni",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "A255",
            "cod_istat": "079003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 1513,
            "area": "",
            "ech": 0
        },
        {
            "id": 209,
            "name": "Amaseno",
            "provincia": "FR",
            "cap": "03021",
            "cod_catastale": "A256",
            "cod_istat": "060005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 1330,
            "area": "",
            "ech": 0
        },
        {
            "id": 210,
            "name": "Amato",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "A257",
            "cod_istat": "079004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 211,
            "name": "Amatrice",
            "provincia": "RI",
            "cap": "02012",
            "cod_catastale": "A258",
            "cod_istat": "057002",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 955,
            "giorni": 3048,
            "area": "",
            "ech": 0
        },
        {
            "id": 212,
            "name": "Ambivere",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "A259",
            "cod_istat": "016009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2440,
            "area": "",
            "ech": 0
        },
        {
            "id": 213,
            "name": "Amblar",
            "provincia": "TN",
            "cap": "38011",
            "cod_catastale": "A260",
            "cod_istat": "022237",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 980,
            "giorni": 3920,
            "area": "",
            "ech": 0
        },
        {
            "id": 214,
            "name": "Ameglia",
            "provincia": "SP",
            "cap": "19031",
            "cod_catastale": "A261",
            "cod_istat": "011001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1385,
            "area": "",
            "ech": 0
        },
        {
            "id": 215,
            "name": "Amelia",
            "provincia": "TR",
            "cap": "05022",
            "cod_catastale": "A262",
            "cod_istat": "055004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2038,
            "area": "",
            "ech": 0
        },
        {
            "id": 216,
            "name": "Amendolara",
            "provincia": "CS",
            "cap": "87071",
            "cod_catastale": "A263",
            "cod_istat": "078011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1264,
            "area": "",
            "ech": 1
        },
        {
            "id": 217,
            "name": "Ameno",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A264",
            "cod_istat": "003002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 2943,
            "area": "",
            "ech": 0
        },
        {
            "id": 218,
            "name": "Amorosi",
            "provincia": "BN",
            "cap": "82031",
            "cod_catastale": "A265",
            "cod_istat": "062002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 60,
            "giorni": 1179,
            "area": "",
            "ech": 0
        },
        {
            "id": 219,
            "name": "Ampezzo",
            "provincia": "UD",
            "cap": "33021",
            "cod_catastale": "A267",
            "cod_istat": "030003",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 3405,
            "area": "",
            "ech": 0
        },
        {
            "id": 220,
            "name": "Anacapri",
            "provincia": "NA",
            "cap": "80071",
            "cod_catastale": "A268",
            "cod_istat": "063004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1254,
            "area": "",
            "ech": 0
        },
        {
            "id": 221,
            "name": "Anagni",
            "provincia": "FR",
            "cap": "03012",
            "cod_catastale": "A269",
            "cod_istat": "060006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 1911,
            "area": "",
            "ech": 0
        },
        {
            "id": 222,
            "name": "Ancarano",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "A270",
            "cod_istat": "067002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1797,
            "area": "",
            "ech": 0
        },
        {
            "id": 223,
            "name": "Ancona",
            "provincia": "AN",
            "cap": "601xx",
            "cod_catastale": "A271",
            "cod_istat": "042002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1688,
            "area": "",
            "ech": 0
        },
        {
            "id": 224,
            "name": "Andali",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "A272",
            "cod_istat": "079005",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2132,
            "area": "",
            "ech": 0
        },
        {
            "id": 225,
            "name": "Andalo",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "A274",
            "cod_istat": "022005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1042,
            "giorni": 4016,
            "area": "",
            "ech": 0
        },
        {
            "id": 226,
            "name": "Andalo Valtellino",
            "provincia": "SO",
            "cap": "23014",
            "cod_catastale": "A273",
            "cod_istat": "014003",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 3011,
            "area": "",
            "ech": 0
        },
        {
            "id": 227,
            "name": "Andezeno",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "A275",
            "cod_istat": "001009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 306,
            "giorni": 2813,
            "area": "",
            "ech": 0
        },
        {
            "id": 228,
            "name": "Andora",
            "provincia": "SV",
            "cap": "17051",
            "cod_catastale": "A278",
            "cod_istat": "009006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1195,
            "area": "",
            "ech": 0
        },
        {
            "id": 229,
            "name": "Andorno Micca",
            "provincia": "BI",
            "cap": "13811",
            "cod_catastale": "A280",
            "cod_istat": "096002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 544,
            "giorni": 3012,
            "area": "",
            "ech": 0
        },
        {
            "id": 230,
            "name": "Andrano",
            "provincia": "LE",
            "cap": "73032",
            "cod_catastale": "A281",
            "cod_istat": "075005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1296,
            "area": "",
            "ech": 0
        },
        {
            "id": 231,
            "name": "Andrate",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A282",
            "cod_istat": "001010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 836,
            "giorni": 3495,
            "area": "",
            "ech": 0
        },
        {
            "id": 232,
            "name": "Andreis",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "A283",
            "cod_istat": "093001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 455,
            "giorni": 3154,
            "area": "",
            "ech": 0
        },
        {
            "id": 233,
            "name": "Andretta",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "A284",
            "cod_istat": "064003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 850,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 234,
            "name": "Andria",
            "provincia": "BT",
            "cap": "76123",
            "cod_catastale": "A285",
            "cod_istat": "110001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 1377,
            "area": "",
            "ech": 0
        },
        {
            "id": 235,
            "name": "Andriano",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "A286",
            "cod_istat": "021002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2809,
            "area": "",
            "ech": 0
        },
        {
            "id": 236,
            "name": "Anela",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "A287",
            "cod_istat": "090004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 446,
            "giorni": 1763,
            "area": "",
            "ech": 0
        },
        {
            "id": 237,
            "name": "Anfo",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "A288",
            "cod_istat": "017005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2859,
            "area": "",
            "ech": 0
        },
        {
            "id": 238,
            "name": "Angera",
            "provincia": "VA",
            "cap": "21021",
            "cod_catastale": "A290",
            "cod_istat": "012003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2433,
            "area": "",
            "ech": 0
        },
        {
            "id": 239,
            "name": "Anghiari",
            "provincia": "AR",
            "cap": "52031",
            "cod_catastale": "A291",
            "cod_istat": "051001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 240,
            "name": "Angiari",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "A292",
            "cod_istat": "023003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2325,
            "area": "",
            "ech": 0
        },
        {
            "id": 241,
            "name": "Angolo Terme",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "A293",
            "cod_istat": "017006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 2851,
            "area": "",
            "ech": 0
        },
        {
            "id": 242,
            "name": "Angri",
            "provincia": "SA",
            "cap": "84012",
            "cod_catastale": "A294",
            "cod_istat": "065007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 1175,
            "area": "",
            "ech": 0
        },
        {
            "id": 243,
            "name": "Angrogna",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "A295",
            "cod_istat": "001011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 782,
            "giorni": 3527,
            "area": "",
            "ech": 0
        },
        {
            "id": 244,
            "name": "Anguillara Sabazia",
            "provincia": "RM",
            "cap": "00061",
            "cod_catastale": "A297",
            "cod_istat": "058005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 1642,
            "area": "",
            "ech": 0
        },
        {
            "id": 245,
            "name": "Anguillara Veneta",
            "provincia": "PD",
            "cap": "35022",
            "cod_catastale": "A296",
            "cod_istat": "028004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 246,
            "name": "Annicco",
            "provincia": "CR",
            "cap": "26021",
            "cod_catastale": "A299",
            "cod_istat": "019003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 247,
            "name": "Annone di Brianza",
            "provincia": "LC",
            "cap": "23841",
            "cod_catastale": "A301",
            "cod_istat": "097003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 248,
            "name": "Annone Veneto",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "A302",
            "cod_istat": "027001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 249,
            "name": "Anoia",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "A303",
            "cod_istat": "080003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1026,
            "area": "",
            "ech": 0
        },
        {
            "id": 250,
            "name": "Antegnate",
            "provincia": "BG",
            "cap": "24051",
            "cod_catastale": "A304",
            "cod_istat": "016010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 251,
            "name": "Anterivo",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "A306",
            "cod_istat": "021003",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1209,
            "giorni": 4299,
            "area": "",
            "ech": 0
        },
        {
            "id": 252,
            "name": "Antey-Saint-André",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "A305",
            "cod_istat": "007002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1074,
            "giorni": 3843,
            "area": "",
            "ech": 0
        },
        {
            "id": 253,
            "name": "Anticoli Corrado",
            "provincia": "RM",
            "cap": "00022",
            "cod_catastale": "A309",
            "cod_istat": "058006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 254,
            "name": "Antignano",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "A312",
            "cod_istat": "005003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2622,
            "area": "",
            "ech": 0
        },
        {
            "id": 255,
            "name": "Antillo",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "A313",
            "cod_istat": "083004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 1430,
            "area": "",
            "ech": 0
        },
        {
            "id": 256,
            "name": "Antonimina",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "A314",
            "cod_istat": "080004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 327,
            "giorni": 1168,
            "area": "",
            "ech": 1
        },
        {
            "id": 257,
            "name": "Antrodoco",
            "provincia": "RI",
            "cap": "02013",
            "cod_catastale": "A315",
            "cod_istat": "057003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 525,
            "giorni": 2320,
            "area": "",
            "ech": 0
        },
        {
            "id": 258,
            "name": "Antrona Schieranco",
            "provincia": "VB",
            "cap": "28841",
            "cod_catastale": "A317",
            "cod_istat": "103001",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 902,
            "giorni": 3477,
            "area": "",
            "ech": 0
        },
        {
            "id": 259,
            "name": "Anversa degli Abruzzi",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "A318",
            "cod_istat": "066004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 2291,
            "area": "",
            "ech": 0
        },
        {
            "id": 260,
            "name": "Anzano del Parco",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "A319",
            "cod_istat": "013009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 261,
            "name": "Anzano di Puglia",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "A320",
            "cod_istat": "071003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 760,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 262,
            "name": "Anzi",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "A321",
            "cod_istat": "076004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1008,
            "giorni": 2739,
            "area": "",
            "ech": 0
        },
        {
            "id": 263,
            "name": "Anzio",
            "provincia": "RM",
            "cap": "00042",
            "cod_catastale": "A323",
            "cod_istat": "058007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1243,
            "area": "",
            "ech": 0
        },
        {
            "id": 264,
            "name": "Anzola dell'Emilia",
            "provincia": "BO",
            "cap": "40011",
            "cod_catastale": "A324",
            "cod_istat": "037001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 265,
            "name": "Anzola d'Ossola",
            "provincia": "VB",
            "cap": "28877",
            "cod_catastale": "A325",
            "cod_istat": "103002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 266,
            "name": "Aosta",
            "provincia": "AO",
            "cap": "11100",
            "cod_catastale": "A326",
            "cod_istat": "007003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 583,
            "giorni": 2850,
            "area": "",
            "ech": 0
        },
        {
            "id": 267,
            "name": "Apecchio",
            "provincia": "PU",
            "cap": "61042",
            "cod_catastale": "A327",
            "cod_istat": "041002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 2543,
            "area": "",
            "ech": 0
        },
        {
            "id": 268,
            "name": "Apice",
            "provincia": "BN",
            "cap": "82021",
            "cod_catastale": "A328",
            "cod_istat": "062003",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 227,
            "giorni": 1523,
            "area": "",
            "ech": 0
        },
        {
            "id": 269,
            "name": "Apiro",
            "provincia": "MC",
            "cap": "62021",
            "cod_catastale": "A329",
            "cod_istat": "043002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 270,
            "name": "Apollosa",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "A330",
            "cod_istat": "062004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1853,
            "area": "",
            "ech": 0
        },
        {
            "id": 271,
            "name": "Appiano Gentile",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "A333",
            "cod_istat": "013010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 366,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 272,
            "name": "Appiano sulla strada del vino",
            "provincia": "BZ",
            "cap": "39057",
            "cod_catastale": "A332",
            "cod_istat": "021004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 3058,
            "area": "",
            "ech": 0
        },
        {
            "id": 273,
            "name": "Appignano",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "A334",
            "cod_istat": "043003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1879,
            "area": "",
            "ech": 0
        },
        {
            "id": 274,
            "name": "Appignano del Tronto",
            "provincia": "AP",
            "cap": "63083",
            "cod_catastale": "A335",
            "cod_istat": "044005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 1635,
            "area": "",
            "ech": 0
        },
        {
            "id": 275,
            "name": "Aprica",
            "provincia": "SO",
            "cap": "23031",
            "cod_catastale": "A337",
            "cod_istat": "014004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1172,
            "giorni": 3734,
            "area": "",
            "ech": 0
        },
        {
            "id": 276,
            "name": "Apricale",
            "provincia": "IM",
            "cap": "18035",
            "cod_catastale": "A338",
            "cod_istat": "008002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2015,
            "area": "",
            "ech": 0
        },
        {
            "id": 277,
            "name": "Apricena",
            "provincia": "FG",
            "cap": "71011",
            "cod_catastale": "A339",
            "cod_istat": "071004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 1401,
            "area": "",
            "ech": 0
        },
        {
            "id": 278,
            "name": "Aprigliano",
            "provincia": "CS",
            "cap": "87051",
            "cod_catastale": "A340",
            "cod_istat": "078012",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 718,
            "giorni": 2227,
            "area": "",
            "ech": 0
        },
        {
            "id": 279,
            "name": "Aprilia",
            "provincia": "LT",
            "cap": "04011",
            "cod_catastale": "A341",
            "cod_istat": "059001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1374,
            "area": "",
            "ech": 0
        },
        {
            "id": 280,
            "name": "Aquara",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "A343",
            "cod_istat": "065008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1762,
            "area": "",
            "ech": 0
        },
        {
            "id": 281,
            "name": "Aquila d'Arroscia",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "A344",
            "cod_istat": "008003",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 282,
            "name": "Aquileia",
            "provincia": "UD",
            "cap": "33051",
            "cod_catastale": "A346",
            "cod_istat": "030004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2244,
            "area": "",
            "ech": 0
        },
        {
            "id": 283,
            "name": "Aquilonia",
            "provincia": "AV",
            "cap": "83041",
            "cod_catastale": "A347",
            "cod_istat": "064004",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 750,
            "giorni": 2299,
            "area": "",
            "ech": 0
        },
        {
            "id": 284,
            "name": "Aquino",
            "provincia": "FR",
            "cap": "03031",
            "cod_catastale": "A348",
            "cod_istat": "060007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 1286,
            "area": "",
            "ech": 0
        },
        {
            "id": 285,
            "name": "Aradeo",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "A350",
            "cod_istat": "075006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1148,
            "area": "",
            "ech": 0
        },
        {
            "id": 286,
            "name": "Aragona",
            "provincia": "AG",
            "cap": "92021",
            "cod_catastale": "A351",
            "cod_istat": "084003",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1149,
            "area": "",
            "ech": 0
        },
        {
            "id": 287,
            "name": "Aramengo",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "A352",
            "cod_istat": "005004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 288,
            "name": "Arba",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "A354",
            "cod_istat": "093002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2736,
            "area": "",
            "ech": 0
        },
        {
            "id": 289,
            "name": "Arborea",
            "provincia": "OR",
            "cap": "09092",
            "cod_catastale": "A357",
            "cod_istat": "095006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 951,
            "area": "",
            "ech": 0
        },
        {
            "id": 290,
            "name": "Arborio",
            "provincia": "VC",
            "cap": "13031",
            "cod_catastale": "A358",
            "cod_istat": "002006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 291,
            "name": "Arbus",
            "provincia": "SU",
            "cap": "09031",
            "cod_catastale": "A359",
            "cod_istat": "111001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 311,
            "giorni": 1402,
            "area": "",
            "ech": 0
        },
        {
            "id": 292,
            "name": "Arcade",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "A360",
            "cod_istat": "026002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 293,
            "name": "Arce",
            "provincia": "FR",
            "cap": "03032",
            "cod_catastale": "A363",
            "cod_istat": "060008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 1602,
            "area": "",
            "ech": 0
        },
        {
            "id": 294,
            "name": "Arcene",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A365",
            "cod_istat": "016011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 295,
            "name": "Arcevia",
            "provincia": "AN",
            "cap": "60011",
            "cod_catastale": "A366",
            "cod_istat": "042003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 553,
            "giorni": 2301,
            "area": "",
            "ech": 0
        },
        {
            "id": 296,
            "name": "Archi",
            "provincia": "CH",
            "cap": "66044",
            "cod_catastale": "A367",
            "cod_istat": "069002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 1889,
            "area": "",
            "ech": 0
        },
        {
            "id": 297,
            "name": "Arcidosso",
            "provincia": "GR",
            "cap": "58031",
            "cod_catastale": "A369",
            "cod_istat": "053001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 679,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 298,
            "name": "Arcinazzo Romano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "A370",
            "cod_istat": "058008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 831,
            "giorni": 2783,
            "area": "",
            "ech": 0
        },
        {
            "id": 299,
            "name": "Arcisate",
            "provincia": "VA",
            "cap": "21051",
            "cod_catastale": "A371",
            "cod_istat": "012004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 300,
            "name": "Arco",
            "provincia": "TN",
            "cap": "38062",
            "cod_catastale": "A372",
            "cod_istat": "022006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2380,
            "area": "",
            "ech": 0
        },
        {
            "id": 301,
            "name": "Arcola",
            "provincia": "SP",
            "cap": "19021",
            "cod_catastale": "A373",
            "cod_istat": "011002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1604,
            "area": "",
            "ech": 0
        },
        {
            "id": 302,
            "name": "Arcole",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "A374",
            "cod_istat": "023004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2437,
            "area": "",
            "ech": 0
        },
        {
            "id": 303,
            "name": "Arconate",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "A375",
            "cod_istat": "015007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 178,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 304,
            "name": "Arcore",
            "provincia": "MB",
            "cap": "20862",
            "cod_catastale": "A376",
            "cod_istat": "108004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 305,
            "name": "Arcugnano",
            "provincia": "VI",
            "cap": "36057",
            "cod_catastale": "A377",
            "cod_istat": "024006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2357,
            "area": "",
            "ech": 0
        },
        {
            "id": 306,
            "name": "Ardara",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "A379",
            "cod_istat": "090005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 1480,
            "area": "",
            "ech": 0
        },
        {
            "id": 307,
            "name": "Ardauli",
            "provincia": "OR",
            "cap": "09081",
            "cod_catastale": "A380",
            "cod_istat": "095007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 421,
            "giorni": 1516,
            "area": "",
            "ech": 0
        },
        {
            "id": 308,
            "name": "Ardea",
            "provincia": "RM",
            "cap": "00040",
            "cod_catastale": "M213",
            "cod_istat": "058117",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 1295,
            "area": "",
            "ech": 0
        },
        {
            "id": 309,
            "name": "Ardenno",
            "provincia": "SO",
            "cap": "23011",
            "cod_catastale": "A382",
            "cod_istat": "014005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 310,
            "name": "Ardesio",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "A383",
            "cod_istat": "016012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 608,
            "giorni": 2943,
            "area": "",
            "ech": 0
        },
        {
            "id": 311,
            "name": "Ardore",
            "provincia": "RC",
            "cap": "89031",
            "cod_catastale": "A385",
            "cod_istat": "080005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1007,
            "area": "",
            "ech": 1
        },
        {
            "id": 312,
            "name": "Arena",
            "provincia": "VV",
            "cap": "89832",
            "cod_catastale": "A386",
            "cod_istat": "102002",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 496,
            "giorni": 1628,
            "area": "",
            "ech": 0
        },
        {
            "id": 313,
            "name": "Arena Po",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "A387",
            "cod_istat": "018005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 314,
            "name": "Arenzano",
            "provincia": "GE",
            "cap": "16011",
            "cod_catastale": "A388",
            "cod_istat": "010001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1521,
            "area": "",
            "ech": 0
        },
        {
            "id": 315,
            "name": "Arese",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "A389",
            "cod_istat": "015009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 316,
            "name": "Arezzo",
            "provincia": "AR",
            "cap": "52100",
            "cod_catastale": "A390",
            "cod_istat": "051002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2104,
            "area": "",
            "ech": 0
        },
        {
            "id": 317,
            "name": "Argegno",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "A391",
            "cod_istat": "013011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 318,
            "name": "Argelato",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "A392",
            "cod_istat": "037002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2338,
            "area": "",
            "ech": 0
        },
        {
            "id": 319,
            "name": "Argenta",
            "provincia": "FE",
            "cap": "44011",
            "cod_catastale": "A393",
            "cod_istat": "038001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2414,
            "area": "",
            "ech": 0
        },
        {
            "id": 320,
            "name": "Argentera",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "A394",
            "cod_istat": "004006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1684,
            "giorni": 4403,
            "area": "",
            "ech": 0
        },
        {
            "id": 321,
            "name": "Arguello",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "A396",
            "cod_istat": "004007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 661,
            "giorni": 3135,
            "area": "",
            "ech": 0
        },
        {
            "id": 322,
            "name": "Argusto",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "A397",
            "cod_istat": "079007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 1773,
            "area": "",
            "ech": 0
        },
        {
            "id": 323,
            "name": "Ari",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "A398",
            "cod_istat": "069003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 1630,
            "area": "",
            "ech": 0
        },
        {
            "id": 324,
            "name": "Ariano Irpino",
            "provincia": "AV",
            "cap": "83031",
            "cod_catastale": "A399",
            "cod_istat": "064005",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 788,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 325,
            "name": "Ariano nel Polesine",
            "provincia": "RO",
            "cap": "45012",
            "cod_catastale": "A400",
            "cod_istat": "029002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2347,
            "area": "",
            "ech": 0
        },
        {
            "id": 326,
            "name": "Ariccia",
            "provincia": "RM",
            "cap": "00072",
            "cod_catastale": "A401",
            "cod_istat": "058009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 1942,
            "area": "",
            "ech": 0
        },
        {
            "id": 327,
            "name": "Arielli",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "A402",
            "cod_istat": "069004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 1668,
            "area": "",
            "ech": 0
        },
        {
            "id": 328,
            "name": "Arienzo",
            "provincia": "CE",
            "cap": "81021",
            "cod_catastale": "A403",
            "cod_istat": "061004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 1303,
            "area": "",
            "ech": 0
        },
        {
            "id": 329,
            "name": "Arignano",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "A405",
            "cod_istat": "001012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 330,
            "name": "Aritzo",
            "provincia": "NU",
            "cap": "08031",
            "cod_catastale": "A407",
            "cod_istat": "091001",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 796,
            "giorni": 2225,
            "area": "",
            "ech": 0
        },
        {
            "id": 331,
            "name": "Arizzano",
            "provincia": "VB",
            "cap": "28811",
            "cod_catastale": "A409",
            "cod_istat": "103003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 458,
            "giorni": 2900,
            "area": "",
            "ech": 0
        },
        {
            "id": 332,
            "name": "Arlena di Castro",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "A412",
            "cod_istat": "056002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1883,
            "area": "",
            "ech": 0
        },
        {
            "id": 333,
            "name": "Arluno",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "A413",
            "cod_istat": "015010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 334,
            "name": "Armeno",
            "provincia": "NO",
            "cap": "28011",
            "cod_catastale": "A414",
            "cod_istat": "003006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 2957,
            "area": "",
            "ech": 0
        },
        {
            "id": 335,
            "name": "Armento",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "A415",
            "cod_istat": "076005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 2156,
            "area": "",
            "ech": 0
        },
        {
            "id": 336,
            "name": "Armo",
            "provincia": "IM",
            "cap": "18026",
            "cod_catastale": "A418",
            "cod_istat": "008004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 578,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 337,
            "name": "Armungia",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "A419",
            "cod_istat": "111002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 366,
            "giorni": 1221,
            "area": "",
            "ech": 0
        },
        {
            "id": 338,
            "name": "Arnad",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "A424",
            "cod_istat": "007004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 361,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 339,
            "name": "Arnara",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "A421",
            "cod_istat": "060009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1860,
            "area": "",
            "ech": 0
        },
        {
            "id": 340,
            "name": "Arnasco",
            "provincia": "SV",
            "cap": "17032",
            "cod_catastale": "A422",
            "cod_istat": "009007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2006,
            "area": "",
            "ech": 0
        },
        {
            "id": 341,
            "name": "Arnesano",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "A425",
            "cod_istat": "075007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 1052,
            "area": "",
            "ech": 0
        },
        {
            "id": 342,
            "name": "Arola",
            "provincia": "VB",
            "cap": "28899",
            "cod_catastale": "A427",
            "cod_istat": "103004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 615,
            "giorni": 3104,
            "area": "",
            "ech": 0
        },
        {
            "id": 343,
            "name": "Arona",
            "provincia": "NO",
            "cap": "28041",
            "cod_catastale": "A429",
            "cod_istat": "003008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 344,
            "name": "Arosio",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "A430",
            "cod_istat": "013012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 345,
            "name": "Arpaia",
            "provincia": "BN",
            "cap": "82011",
            "cod_catastale": "A431",
            "cod_istat": "062005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 1585,
            "area": "",
            "ech": 0
        },
        {
            "id": 346,
            "name": "Arpaise",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "A432",
            "cod_istat": "062006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1816,
            "area": "",
            "ech": 0
        },
        {
            "id": 347,
            "name": "Arpino",
            "provincia": "FR",
            "cap": "03033",
            "cod_catastale": "A433",
            "cod_istat": "060010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2123,
            "area": "",
            "ech": 0
        },
        {
            "id": 348,
            "name": "Arquà Petrarca",
            "provincia": "PD",
            "cap": "35032",
            "cod_catastale": "A434",
            "cod_istat": "028005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 349,
            "name": "Arquà Polesine",
            "provincia": "RO",
            "cap": "45031",
            "cod_catastale": "A435",
            "cod_istat": "029003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 350,
            "name": "Arquata del Tronto",
            "provincia": "AP",
            "cap": "63096",
            "cod_catastale": "A437",
            "cod_istat": "044006",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 777,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 351,
            "name": "Arquata Scrivia",
            "provincia": "AL",
            "cap": "15061",
            "cod_catastale": "A436",
            "cod_istat": "006009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 352,
            "name": "Arre",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "A438",
            "cod_istat": "028006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 353,
            "name": "Arrone",
            "provincia": "TR",
            "cap": "05031",
            "cod_catastale": "A439",
            "cod_istat": "055005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 354,
            "name": "Arsago Seprio",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "A441",
            "cod_istat": "012005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 355,
            "name": "Arsiè",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "A443",
            "cod_istat": "025004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 3063,
            "area": "",
            "ech": 0
        },
        {
            "id": 356,
            "name": "Arsiero",
            "provincia": "VI",
            "cap": "36011",
            "cod_catastale": "A444",
            "cod_istat": "024007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2872,
            "area": "",
            "ech": 0
        },
        {
            "id": 357,
            "name": "Arsita",
            "provincia": "TE",
            "cap": "64031",
            "cod_catastale": "A445",
            "cod_istat": "067003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 470,
            "giorni": 2114,
            "area": "",
            "ech": 0
        },
        {
            "id": 358,
            "name": "Arsoli",
            "provincia": "RM",
            "cap": "00023",
            "cod_catastale": "A446",
            "cod_istat": "058010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 359,
            "name": "Arta Terme",
            "provincia": "UD",
            "cap": "33022",
            "cod_catastale": "A447",
            "cod_istat": "030005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 442,
            "giorni": 3249,
            "area": "",
            "ech": 0
        },
        {
            "id": 360,
            "name": "Artegna",
            "provincia": "UD",
            "cap": "33011",
            "cod_catastale": "A448",
            "cod_istat": "030006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2730,
            "area": "",
            "ech": 0
        },
        {
            "id": 361,
            "name": "Artena",
            "provincia": "RM",
            "cap": "00031",
            "cod_catastale": "A449",
            "cod_istat": "058011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1912,
            "area": "",
            "ech": 0
        },
        {
            "id": 362,
            "name": "Artogne",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "A451",
            "cod_istat": "017007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 363,
            "name": "Arvier",
            "provincia": "AO",
            "cap": "11011",
            "cod_catastale": "A452",
            "cod_istat": "007005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 776,
            "giorni": 3396,
            "area": "",
            "ech": 0
        },
        {
            "id": 364,
            "name": "Arzachena",
            "provincia": "SS",
            "cap": "07021",
            "cod_catastale": "A453",
            "cod_istat": "090006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 1074,
            "area": "",
            "ech": 0
        },
        {
            "id": 365,
            "name": "Arzago d'Adda",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A440",
            "cod_istat": "016013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 366,
            "name": "Arzana",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "A454",
            "cod_istat": "091002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 672,
            "giorni": 1683,
            "area": "",
            "ech": 1
        },
        {
            "id": 367,
            "name": "Arzano",
            "provincia": "NA",
            "cap": "80022",
            "cod_catastale": "A455",
            "cod_istat": "063005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1269,
            "area": "",
            "ech": 0
        },
        {
            "id": 368,
            "name": "Arzene",
            "provincia": "PN",
            "cap": "33098",
            "cod_catastale": "A456",
            "cod_istat": "093003",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 369,
            "name": "Arzergrande",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "A458",
            "cod_istat": "028007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 370,
            "name": "Arzignano",
            "provincia": "VI",
            "cap": "36071",
            "cod_catastale": "A459",
            "cod_istat": "024008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 371,
            "name": "Ascea",
            "provincia": "SA",
            "cap": "84046",
            "cod_catastale": "A460",
            "cod_istat": "065009",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 235,
            "giorni": 1338,
            "area": "",
            "ech": 0
        },
        {
            "id": 372,
            "name": "Asciano",
            "provincia": "SI",
            "cap": "53041",
            "cod_catastale": "A461",
            "cod_istat": "052002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 373,
            "name": "Ascoli Piceno",
            "provincia": "AP",
            "cap": "63100",
            "cod_catastale": "A462",
            "cod_istat": "044007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 154,
            "giorni": 1698,
            "area": "",
            "ech": 0
        },
        {
            "id": 374,
            "name": "Ascoli Satriano",
            "provincia": "FG",
            "cap": "71022",
            "cod_catastale": "A463",
            "cod_istat": "071005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 1652,
            "area": "",
            "ech": 0
        },
        {
            "id": 375,
            "name": "Ascrea",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "A464",
            "cod_istat": "057004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 757,
            "giorni": 2742,
            "area": "",
            "ech": 0
        },
        {
            "id": 376,
            "name": "Asiago",
            "provincia": "VI",
            "cap": "36012",
            "cod_catastale": "A465",
            "cod_istat": "024009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1001,
            "giorni": 4163,
            "area": "",
            "ech": 0
        },
        {
            "id": 377,
            "name": "Asigliano Veneto",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "A467",
            "cod_istat": "024010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2456,
            "area": "",
            "ech": 0
        },
        {
            "id": 378,
            "name": "Asigliano Vercellese",
            "provincia": "VC",
            "cap": "13032",
            "cod_catastale": "A466",
            "cod_istat": "002007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 379,
            "name": "Asola",
            "provincia": "MN",
            "cap": "46041",
            "cod_catastale": "A470",
            "cod_istat": "020002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 380,
            "name": "Asolo",
            "provincia": "TV",
            "cap": "31011",
            "cod_catastale": "A471",
            "cod_istat": "026003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 381,
            "name": "Assago",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "A473",
            "cod_istat": "015011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 382,
            "name": "Assemini",
            "provincia": "CA",
            "cap": "09032",
            "cod_catastale": "A474",
            "cod_istat": "092003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 935,
            "area": "",
            "ech": 0
        },
        {
            "id": 383,
            "name": "Assisi",
            "provincia": "PG",
            "cap": "06081",
            "cod_catastale": "A475",
            "cod_istat": "054001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 2198,
            "area": "",
            "ech": 0
        },
        {
            "id": 384,
            "name": "Asso",
            "provincia": "CO",
            "cap": "22033",
            "cod_catastale": "A476",
            "cod_istat": "013013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 427,
            "giorni": 2837,
            "area": "",
            "ech": 0
        },
        {
            "id": 385,
            "name": "Assolo",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "A477",
            "cod_istat": "095008",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 255,
            "giorni": 1303,
            "area": "",
            "ech": 0
        },
        {
            "id": 386,
            "name": "Assoro",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "A478",
            "cod_istat": "086003",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 850,
            "giorni": 1952,
            "area": "",
            "ech": 1
        },
        {
            "id": 387,
            "name": "Asti",
            "provincia": "AT",
            "cap": "14100",
            "cod_catastale": "A479",
            "cod_istat": "005005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 388,
            "name": "Asuni",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "A480",
            "cod_istat": "095009",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 233,
            "giorni": 1275,
            "area": "",
            "ech": 0
        },
        {
            "id": 389,
            "name": "Ateleta",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "A481",
            "cod_istat": "066005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 390,
            "name": "Atella",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "A482",
            "cod_istat": "076006",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1818,
            "area": "",
            "ech": 0
        },
        {
            "id": 391,
            "name": "Atena Lucana",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "A484",
            "cod_istat": "065010",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 2049,
            "area": "",
            "ech": 0
        },
        {
            "id": 392,
            "name": "Atessa",
            "provincia": "CH",
            "cap": "66041",
            "cod_catastale": "A485",
            "cod_istat": "069005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 433,
            "giorni": 1846,
            "area": "",
            "ech": 0
        },
        {
            "id": 393,
            "name": "Atina",
            "provincia": "FR",
            "cap": "03042",
            "cod_catastale": "A486",
            "cod_istat": "060011",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 490,
            "giorni": 2127,
            "area": "",
            "ech": 0
        },
        {
            "id": 394,
            "name": "Atrani",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "A487",
            "cod_istat": "065011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 973,
            "area": "",
            "ech": 0
        },
        {
            "id": 395,
            "name": "Atri",
            "provincia": "TE",
            "cap": "64032",
            "cod_catastale": "A488",
            "cod_istat": "067004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 2068,
            "area": "",
            "ech": 0
        },
        {
            "id": 396,
            "name": "Atripalda",
            "provincia": "AV",
            "cap": "83042",
            "cod_catastale": "A489",
            "cod_istat": "064006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 1609,
            "area": "",
            "ech": 0
        },
        {
            "id": 397,
            "name": "Attigliano",
            "provincia": "TR",
            "cap": "05012",
            "cod_catastale": "A490",
            "cod_istat": "055006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 1872,
            "area": "",
            "ech": 0
        },
        {
            "id": 398,
            "name": "Attimis",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "A491",
            "cod_istat": "030007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 2639,
            "area": "",
            "ech": 0
        },
        {
            "id": 399,
            "name": "Atzara",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "A492",
            "cod_istat": "091003",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1631,
            "area": "",
            "ech": 0
        },
        {
            "id": 400,
            "name": "Auditore",
            "provincia": "PU",
            "cap": "61020",
            "cod_catastale": "A493",
            "cod_istat": "041071",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 373,
            "giorni": 2290,
            "area": "",
            "ech": 0
        },
        {
            "id": 401,
            "name": "Augusta",
            "provincia": "SR",
            "cap": "96011",
            "cod_catastale": "A494",
            "cod_istat": "089001",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 821,
            "area": "",
            "ech": 1
        },
        {
            "id": 402,
            "name": "Auletta",
            "provincia": "SA",
            "cap": "84031",
            "cod_catastale": "A495",
            "cod_istat": "065012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 281,
            "giorni": 1437,
            "area": "",
            "ech": 0
        },
        {
            "id": 403,
            "name": "Aulla",
            "provincia": "MS",
            "cap": "54011",
            "cod_catastale": "A496",
            "cod_istat": "045001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 1658,
            "area": "",
            "ech": 0
        },
        {
            "id": 404,
            "name": "Aurano",
            "provincia": "VB",
            "cap": "28812",
            "cod_catastale": "A497",
            "cod_istat": "103005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 683,
            "giorni": 3192,
            "area": "",
            "ech": 0
        },
        {
            "id": 405,
            "name": "Aurigo",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "A499",
            "cod_istat": "008005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2170,
            "area": "",
            "ech": 0
        },
        {
            "id": 406,
            "name": "Auronzo di Cadore",
            "provincia": "BL",
            "cap": "32041",
            "cod_catastale": "A501",
            "cod_istat": "025005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 866,
            "giorni": 4166,
            "area": "",
            "ech": 0
        },
        {
            "id": 407,
            "name": "Ausonia",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "A502",
            "cod_istat": "060012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 178,
            "giorni": 1469,
            "area": "",
            "ech": 0
        },
        {
            "id": 408,
            "name": "Austis",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "A503",
            "cod_istat": "091004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 737,
            "giorni": 1923,
            "area": "",
            "ech": 0
        },
        {
            "id": 409,
            "name": "Avegno",
            "provincia": "GE",
            "cap": "16036",
            "cod_catastale": "A506",
            "cod_istat": "010002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1535,
            "area": "",
            "ech": 0
        },
        {
            "id": 410,
            "name": "Avelengo",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "A507",
            "cod_istat": "021005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1290,
            "giorni": 4446,
            "area": "",
            "ech": 0
        },
        {
            "id": 411,
            "name": "Avella",
            "provincia": "AV",
            "cap": "83021",
            "cod_catastale": "A508",
            "cod_istat": "064007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 1500,
            "area": "",
            "ech": 0
        },
        {
            "id": 412,
            "name": "Avellino",
            "provincia": "AV",
            "cap": "83100",
            "cod_catastale": "A509",
            "cod_istat": "064008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 348,
            "giorni": 1742,
            "area": "",
            "ech": 0
        },
        {
            "id": 413,
            "name": "Averara",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "A511",
            "cod_istat": "016014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2993,
            "area": "",
            "ech": 0
        },
        {
            "id": 414,
            "name": "Aversa",
            "provincia": "CE",
            "cap": "81031",
            "cod_catastale": "A512",
            "cod_istat": "061005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 1119,
            "area": "",
            "ech": 0
        },
        {
            "id": 415,
            "name": "Avetrana",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "A514",
            "cod_istat": "073001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 1147,
            "area": "",
            "ech": 0
        },
        {
            "id": 416,
            "name": "Avezzano",
            "provincia": "AQ",
            "cap": "67051",
            "cod_catastale": "A515",
            "cod_istat": "066006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 695,
            "giorni": 2561,
            "area": "",
            "ech": 0
        },
        {
            "id": 417,
            "name": "Aviano",
            "provincia": "PN",
            "cap": "33081",
            "cod_catastale": "A516",
            "cod_istat": "093004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 2417,
            "area": "",
            "ech": 0
        },
        {
            "id": 418,
            "name": "Aviatico",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "A517",
            "cod_istat": "016015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1022,
            "giorni": 3521,
            "area": "",
            "ech": 0
        },
        {
            "id": 419,
            "name": "Avigliana",
            "provincia": "TO",
            "cap": "10051",
            "cod_catastale": "A518",
            "cod_istat": "001013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2928,
            "area": "",
            "ech": 0
        },
        {
            "id": 420,
            "name": "Avigliano",
            "provincia": "PZ",
            "cap": "85021",
            "cod_catastale": "A519",
            "cod_istat": "076007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 421,
            "name": "Avigliano Umbro",
            "provincia": "TR",
            "cap": "05020",
            "cod_catastale": "M258",
            "cod_istat": "055033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2167,
            "area": "",
            "ech": 0
        },
        {
            "id": 422,
            "name": "Avio",
            "provincia": "TN",
            "cap": "38063",
            "cod_catastale": "A520",
            "cod_istat": "022007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 423,
            "name": "Avise",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "A521",
            "cod_istat": "007006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 3395,
            "area": "",
            "ech": 0
        },
        {
            "id": 424,
            "name": "Avola",
            "provincia": "SR",
            "cap": "96012",
            "cod_catastale": "A522",
            "cod_istat": "089002",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 823,
            "area": "",
            "ech": 1
        },
        {
            "id": 425,
            "name": "Avolasca",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "A523",
            "cod_istat": "006010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2926,
            "area": "",
            "ech": 0
        },
        {
            "id": 426,
            "name": "Ayas",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "A094",
            "cod_istat": "007007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1699,
            "giorni": 4781,
            "area": "",
            "ech": 0
        },
        {
            "id": 427,
            "name": "Aymavilles",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "A108",
            "cod_istat": "007008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2937,
            "area": "",
            "ech": 0
        },
        {
            "id": 428,
            "name": "Azeglio",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A525",
            "cod_istat": "001014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 429,
            "name": "Azzanello",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "A526",
            "cod_istat": "019004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 430,
            "name": "Azzano d'Asti",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "A527",
            "cod_istat": "005006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 431,
            "name": "Azzano Decimo",
            "provincia": "PN",
            "cap": "33082",
            "cod_catastale": "A530",
            "cod_istat": "093005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 432,
            "name": "Azzano Mella",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "A529",
            "cod_istat": "017008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 433,
            "name": "Azzano San Paolo",
            "provincia": "BG",
            "cap": "24052",
            "cod_catastale": "A528",
            "cod_istat": "016016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 434,
            "name": "Azzate",
            "provincia": "VA",
            "cap": "21022",
            "cod_catastale": "A531",
            "cod_istat": "012006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 2602,
            "area": "",
            "ech": 0
        },
        {
            "id": 435,
            "name": "Azzio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "A532",
            "cod_istat": "012007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 399,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 436,
            "name": "Azzone",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "A533",
            "cod_istat": "016017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 973,
            "giorni": 3451,
            "area": "",
            "ech": 0
        },
        {
            "id": 437,
            "name": "Baceno",
            "provincia": "VB",
            "cap": "28861",
            "cod_catastale": "A534",
            "cod_istat": "103006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 3156,
            "area": "",
            "ech": 0
        },
        {
            "id": 438,
            "name": "Bacoli",
            "provincia": "NA",
            "cap": "80070",
            "cod_catastale": "A535",
            "cod_istat": "063006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1071,
            "area": "",
            "ech": 0
        },
        {
            "id": 439,
            "name": "Badalucco",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "A536",
            "cod_istat": "008006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 1543,
            "area": "",
            "ech": 0
        },
        {
            "id": 440,
            "name": "Badesi",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M214",
            "cod_istat": "090081",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 1110,
            "area": "",
            "ech": 0
        },
        {
            "id": 441,
            "name": "Badia",
            "provincia": "BZ",
            "cap": "39036",
            "cod_catastale": "A537",
            "cod_istat": "021006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1315,
            "giorni": 4598,
            "area": "",
            "ech": 0
        },
        {
            "id": 442,
            "name": "Badia Calavena",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "A540",
            "cod_istat": "023005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 3059,
            "area": "",
            "ech": 0
        },
        {
            "id": 443,
            "name": "Badia Pavese",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "A538",
            "cod_istat": "018006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 444,
            "name": "Badia Polesine",
            "provincia": "RO",
            "cap": "45021",
            "cod_catastale": "A539",
            "cod_istat": "029004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 445,
            "name": "Badia Tedalda",
            "provincia": "AR",
            "cap": "52032",
            "cod_catastale": "A541",
            "cod_istat": "051003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 446,
            "name": "Badolato",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "A542",
            "cod_istat": "079008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1253,
            "area": "",
            "ech": 0
        },
        {
            "id": 447,
            "name": "Bagaladi",
            "provincia": "RC",
            "cap": "89060",
            "cod_catastale": "A544",
            "cod_istat": "080006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 473,
            "giorni": 1586,
            "area": "",
            "ech": 1
        },
        {
            "id": 448,
            "name": "Bagheria",
            "provincia": "PA",
            "cap": "90011",
            "cod_catastale": "A546",
            "cod_istat": "082006",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 874,
            "area": "",
            "ech": 0
        },
        {
            "id": 449,
            "name": "Bagnacavallo",
            "provincia": "RA",
            "cap": "48012",
            "cod_catastale": "A547",
            "cod_istat": "039002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 450,
            "name": "Bagnara Calabra",
            "provincia": "RC",
            "cap": "89011",
            "cod_catastale": "A552",
            "cod_istat": "080007",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 758,
            "area": "",
            "ech": 0
        },
        {
            "id": 451,
            "name": "Bagnara di Romagna",
            "provincia": "RA",
            "cap": "48031",
            "cod_catastale": "A551",
            "cod_istat": "039003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 452,
            "name": "Bagnaria",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "A550",
            "cod_istat": "018007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 2911,
            "area": "",
            "ech": 0
        },
        {
            "id": 453,
            "name": "Bagnaria Arsa",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "A553",
            "cod_istat": "030008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2222,
            "area": "",
            "ech": 0
        },
        {
            "id": 454,
            "name": "Bagnasco",
            "provincia": "CN",
            "cap": "12071",
            "cod_catastale": "A555",
            "cod_istat": "004008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 483,
            "giorni": 2914,
            "area": "",
            "ech": 0
        },
        {
            "id": 455,
            "name": "Bagnatica",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A557",
            "cod_istat": "016018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2492,
            "area": "",
            "ech": 0
        },
        {
            "id": 456,
            "name": "Bagni di Lucca",
            "provincia": "LU",
            "cap": "55022",
            "cod_catastale": "A560",
            "cod_istat": "046002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 2227,
            "area": "",
            "ech": 0
        },
        {
            "id": 457,
            "name": "Bagno a Ripoli",
            "provincia": "FI",
            "cap": "50012",
            "cod_catastale": "A564",
            "cod_istat": "048001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1854,
            "area": "",
            "ech": 0
        },
        {
            "id": 458,
            "name": "Bagno di Romagna",
            "provincia": "FC",
            "cap": "47021",
            "cod_catastale": "A565",
            "cod_istat": "040001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 462,
            "giorni": 2789,
            "area": "",
            "ech": 0
        },
        {
            "id": 459,
            "name": "Bagnoli del Trigno",
            "provincia": "IS",
            "cap": "86091",
            "cod_catastale": "A567",
            "cod_istat": "094003",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 660,
            "giorni": 2263,
            "area": "",
            "ech": 0
        },
        {
            "id": 460,
            "name": "Bagnoli di Sopra",
            "provincia": "PD",
            "cap": "35023",
            "cod_catastale": "A568",
            "cod_istat": "028008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 461,
            "name": "Bagnoli Irpino",
            "provincia": "AV",
            "cap": "83043",
            "cod_catastale": "A566",
            "cod_istat": "064009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 654,
            "giorni": 2144,
            "area": "",
            "ech": 0
        },
        {
            "id": 462,
            "name": "Bagnolo Cremasco",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "A570",
            "cod_istat": "019005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 463,
            "name": "Bagnolo del Salento",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "A572",
            "cod_istat": "075008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 1231,
            "area": "",
            "ech": 0
        },
        {
            "id": 464,
            "name": "Bagnolo di Po",
            "provincia": "RO",
            "cap": "45022",
            "cod_catastale": "A574",
            "cod_istat": "029005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 465,
            "name": "Bagnolo in Piano",
            "provincia": "RE",
            "cap": "42011",
            "cod_catastale": "A573",
            "cod_istat": "035002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 466,
            "name": "Bagnolo Mella",
            "provincia": "BS",
            "cap": "25021",
            "cod_catastale": "A569",
            "cod_istat": "017009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 467,
            "name": "Bagnolo Piemonte",
            "provincia": "CN",
            "cap": "12031",
            "cod_catastale": "A571",
            "cod_istat": "004009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 2768,
            "area": "",
            "ech": 0
        },
        {
            "id": 468,
            "name": "Bagnolo San Vito",
            "provincia": "MN",
            "cap": "46031",
            "cod_catastale": "A575",
            "cod_istat": "020003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 469,
            "name": "Bagnone",
            "provincia": "MS",
            "cap": "54021",
            "cod_catastale": "A576",
            "cod_istat": "045002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 470,
            "name": "Bagnoregio",
            "provincia": "VT",
            "cap": "01022",
            "cod_catastale": "A577",
            "cod_istat": "056003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 484,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 471,
            "name": "Bagolino",
            "provincia": "BS",
            "cap": "25072",
            "cod_catastale": "A578",
            "cod_istat": "017010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 778,
            "giorni": 3322,
            "area": "",
            "ech": 0
        },
        {
            "id": 472,
            "name": "Baia e Latina",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "A579",
            "cod_istat": "061006",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 123,
            "giorni": 1289,
            "area": "",
            "ech": 0
        },
        {
            "id": 473,
            "name": "Baiano",
            "provincia": "AV",
            "cap": "83022",
            "cod_catastale": "A580",
            "cod_istat": "064010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 196,
            "giorni": 1117,
            "area": "",
            "ech": 0
        },
        {
            "id": 474,
            "name": "Bairo",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A584",
            "cod_istat": "001015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2684,
            "area": "",
            "ech": 0
        },
        {
            "id": 475,
            "name": "Baiso",
            "provincia": "RE",
            "cap": "42031",
            "cod_catastale": "A586",
            "cod_istat": "035003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 542,
            "giorni": 2953,
            "area": "",
            "ech": 0
        },
        {
            "id": 476,
            "name": "Bajardo",
            "provincia": "IM",
            "cap": "18031",
            "cod_catastale": "A581",
            "cod_istat": "008007",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 477,
            "name": "Balangero",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "A587",
            "cod_istat": "001016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 440,
            "giorni": 3085,
            "area": "",
            "ech": 0
        },
        {
            "id": 478,
            "name": "Baldichieri d'Asti",
            "provincia": "AT",
            "cap": "14011",
            "cod_catastale": "A588",
            "cod_istat": "005007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 479,
            "name": "Baldissero Canavese",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "A590",
            "cod_istat": "001017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 392,
            "giorni": 2732,
            "area": "",
            "ech": 0
        },
        {
            "id": 480,
            "name": "Baldissero d'Alba",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "A589",
            "cod_istat": "004010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2786,
            "area": "",
            "ech": 0
        },
        {
            "id": 481,
            "name": "Baldissero Torinese",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "A591",
            "cod_istat": "001018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 2985,
            "area": "",
            "ech": 0
        },
        {
            "id": 482,
            "name": "Balestrate",
            "provincia": "PA",
            "cap": "90041",
            "cod_catastale": "A592",
            "cod_istat": "082007",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 650,
            "area": "",
            "ech": 0
        },
        {
            "id": 483,
            "name": "Balestrino",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "A593",
            "cod_istat": "009008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 371,
            "giorni": 2190,
            "area": "",
            "ech": 0
        },
        {
            "id": 484,
            "name": "Ballabio",
            "provincia": "LC",
            "cap": "23811",
            "cod_catastale": "A594",
            "cod_istat": "097004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 661,
            "giorni": 3014,
            "area": "",
            "ech": 0
        },
        {
            "id": 485,
            "name": "Ballao",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "A597",
            "cod_istat": "111003",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 90,
            "giorni": 833,
            "area": "",
            "ech": 0
        },
        {
            "id": 486,
            "name": "Balme",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "A599",
            "cod_istat": "001019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1432,
            "giorni": 4502,
            "area": "",
            "ech": 0
        },
        {
            "id": 487,
            "name": "Balmuccia",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "A600",
            "cod_istat": "002008",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 3032,
            "area": "",
            "ech": 0
        },
        {
            "id": 488,
            "name": "Balocco",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "A601",
            "cod_istat": "002009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 166,
            "giorni": 2520,
            "area": "",
            "ech": 0
        },
        {
            "id": 489,
            "name": "Balsorano",
            "provincia": "AQ",
            "cap": "67052",
            "cod_catastale": "A603",
            "cod_istat": "066007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 340,
            "giorni": 1897,
            "area": "",
            "ech": 0
        },
        {
            "id": 490,
            "name": "Balvano",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "A604",
            "cod_istat": "076008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1682,
            "area": "",
            "ech": 0
        },
        {
            "id": 491,
            "name": "Balzola",
            "provincia": "AL",
            "cap": "15031",
            "cod_catastale": "A605",
            "cod_istat": "006011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2817,
            "area": "",
            "ech": 0
        },
        {
            "id": 492,
            "name": "Banari",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "A606",
            "cod_istat": "090007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 419,
            "giorni": 1818,
            "area": "",
            "ech": 0
        },
        {
            "id": 493,
            "name": "Banchette",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A607",
            "cod_istat": "001020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2756,
            "area": "",
            "ech": 0
        },
        {
            "id": 494,
            "name": "Bannio Anzino",
            "provincia": "VB",
            "cap": "28871",
            "cod_catastale": "A610",
            "cod_istat": "103007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 669,
            "giorni": 3174,
            "area": "",
            "ech": 0
        },
        {
            "id": 495,
            "name": "Banzi",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "A612",
            "cod_istat": "076009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 568,
            "giorni": 2056,
            "area": "",
            "ech": 0
        },
        {
            "id": 496,
            "name": "Baone",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "A613",
            "cod_istat": "028009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 497,
            "name": "Baradili",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "A614",
            "cod_istat": "095010",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 165,
            "giorni": 1167,
            "area": "",
            "ech": 0
        },
        {
            "id": 498,
            "name": "Baragiano",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "A615",
            "cod_istat": "076010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2046,
            "area": "",
            "ech": 0
        },
        {
            "id": 499,
            "name": "Baranello",
            "provincia": "CB",
            "cap": "86011",
            "cod_catastale": "A616",
            "cod_istat": "070002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 2118,
            "area": "",
            "ech": 0
        },
        {
            "id": 500,
            "name": "Barano d'Ischia",
            "provincia": "NA",
            "cap": "80072",
            "cod_catastale": "A617",
            "cod_istat": "063007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1364,
            "area": "",
            "ech": 0
        },
        {
            "id": 501,
            "name": "Baranzate",
            "provincia": "MI",
            "cap": "20021",
            "cod_catastale": "A618",
            "cod_istat": "015250",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 502,
            "name": "Barasso",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "A619",
            "cod_istat": "012008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 401,
            "giorni": 2679,
            "area": "",
            "ech": 0
        },
        {
            "id": 503,
            "name": "Baratili San Pietro",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "A621",
            "cod_istat": "095011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 1062,
            "area": "",
            "ech": 0
        },
        {
            "id": 504,
            "name": "Barbania",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "A625",
            "cod_istat": "001021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 362,
            "giorni": 2897,
            "area": "",
            "ech": 0
        },
        {
            "id": 505,
            "name": "Barbara",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "A626",
            "cod_istat": "042004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 1957,
            "area": "",
            "ech": 0
        },
        {
            "id": 506,
            "name": "Barbarano Romano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "A628",
            "cod_istat": "056004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2024,
            "area": "",
            "ech": 0
        },
        {
            "id": 507,
            "name": "Barbarano Vicentino",
            "provincia": "VI",
            "cap": "36021",
            "cod_catastale": "A627",
            "cod_istat": "024011",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2337,
            "area": "",
            "ech": 0
        },
        {
            "id": 508,
            "name": "Barbaresco",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "A629",
            "cod_istat": "004011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2508,
            "area": "",
            "ech": 0
        },
        {
            "id": 509,
            "name": "Barbariga",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "A630",
            "cod_istat": "017011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 2341,
            "area": "",
            "ech": 0
        },
        {
            "id": 510,
            "name": "Barbata",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A631",
            "cod_istat": "016019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 511,
            "name": "Barberino di Mugello",
            "provincia": "FI",
            "cap": "50031",
            "cod_catastale": "A632",
            "cod_istat": "048002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2178,
            "area": "",
            "ech": 0
        },
        {
            "id": 512,
            "name": "Barberino Val d''Elsa",
            "provincia": "FI",
            "cap": "50021",
            "cod_catastale": "A633",
            "cod_istat": "048003",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 513,
            "name": "Barbianello",
            "provincia": "PV",
            "cap": "27041",
            "cod_catastale": "A634",
            "cod_istat": "018008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 514,
            "name": "Barbiano",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "A635",
            "cod_istat": "021007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 3767,
            "area": "",
            "ech": 0
        },
        {
            "id": 515,
            "name": "Barbona",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "A637",
            "cod_istat": "028010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 516,
            "name": "Barcellona Pozzo di Gotto",
            "provincia": "ME",
            "cap": "98051",
            "cod_catastale": "A638",
            "cod_istat": "083005",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 729,
            "area": "",
            "ech": 1
        },
        {
            "id": 517,
            "name": "Barchi",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "A639",
            "cod_istat": "041004",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 2330,
            "area": "",
            "ech": 0
        },
        {
            "id": 518,
            "name": "Barcis",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "A640",
            "cod_istat": "093006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 3148,
            "area": "",
            "ech": 0
        },
        {
            "id": 519,
            "name": "Bard",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "A643",
            "cod_istat": "007009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2832,
            "area": "",
            "ech": 0
        },
        {
            "id": 520,
            "name": "Bardello",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "A645",
            "cod_istat": "012009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 521,
            "name": "Bardi",
            "provincia": "PR",
            "cap": "43032",
            "cod_catastale": "A646",
            "cod_istat": "034002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 3257,
            "area": "",
            "ech": 0
        },
        {
            "id": 522,
            "name": "Bardineto",
            "provincia": "SV",
            "cap": "17057",
            "cod_catastale": "A647",
            "cod_istat": "009009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 711,
            "giorni": 3072,
            "area": "",
            "ech": 0
        },
        {
            "id": 523,
            "name": "Bardolino",
            "provincia": "VR",
            "cap": "37011",
            "cod_catastale": "A650",
            "cod_istat": "023006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2231,
            "area": "",
            "ech": 0
        },
        {
            "id": 524,
            "name": "Bardonecchia",
            "provincia": "TO",
            "cap": "10052",
            "cod_catastale": "A651",
            "cod_istat": "001022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1312,
            "giorni": 3043,
            "area": "",
            "ech": 0
        },
        {
            "id": 525,
            "name": "Bareggio",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "A652",
            "cod_istat": "015012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 526,
            "name": "Barengo",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A653",
            "cod_istat": "003012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 527,
            "name": "Baressa",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "A655",
            "cod_istat": "095012",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 165,
            "giorni": 1167,
            "area": "",
            "ech": 0
        },
        {
            "id": 528,
            "name": "Barete",
            "provincia": "AQ",
            "cap": "67010",
            "cod_catastale": "A656",
            "cod_istat": "066008",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 529,
            "name": "Barga",
            "provincia": "LU",
            "cap": "55051",
            "cod_catastale": "A657",
            "cod_istat": "046003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 530,
            "name": "Bargagli",
            "provincia": "GE",
            "cap": "16021",
            "cod_catastale": "A658",
            "cod_istat": "010003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2300,
            "area": "",
            "ech": 0
        },
        {
            "id": 531,
            "name": "Barge",
            "provincia": "CN",
            "cap": "12032",
            "cod_catastale": "A660",
            "cod_istat": "004012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 532,
            "name": "Barghe",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "A661",
            "cod_istat": "017012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 533,
            "name": "Bari",
            "provincia": "BA",
            "cap": "701xx",
            "cod_catastale": "A662",
            "cod_istat": "072006",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 5,
            "giorni": 1185,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 534,
            "name": "Bari Sardo",
            "provincia": "NU",
            "cap": "08042",
            "cod_catastale": "A663",
            "cod_istat": "091005",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 824,
            "area": "",
            "ech": 1
        },
        {
            "id": 535,
            "name": "Bariano",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "A664",
            "cod_istat": "016020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 536,
            "name": "Baricella",
            "provincia": "BO",
            "cap": "40052",
            "cod_catastale": "A665",
            "cod_istat": "037003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2172,
            "area": "",
            "ech": 0
        },
        {
            "id": 537,
            "name": "Barile",
            "provincia": "PZ",
            "cap": "85022",
            "cod_catastale": "A666",
            "cod_istat": "076011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2079,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 538,
            "name": "Barisciano",
            "provincia": "AQ",
            "cap": "67021",
            "cod_catastale": "A667",
            "cod_istat": "066009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 940,
            "giorni": 2877,
            "area": "",
            "ech": 0
        },
        {
            "id": 539,
            "name": "Barlassina",
            "provincia": "MB",
            "cap": "20825",
            "cod_catastale": "A668",
            "cod_istat": "108005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2489,
            "area": "",
            "ech": 0
        },
        {
            "id": 540,
            "name": "Barletta",
            "provincia": "BT",
            "cap": "76121",
            "cod_catastale": "A669",
            "cod_istat": "110002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 15,
            "giorni": 1306,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 541,
            "name": "Barni",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "A670",
            "cod_istat": "013015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 627,
            "giorni": 2960,
            "area": "",
            "ech": 0
        },
        {
            "id": 542,
            "name": "Barolo",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "A671",
            "cod_istat": "004013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 543,
            "name": "Barone Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "A673",
            "cod_istat": "001023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2841,
            "area": "",
            "ech": 0
        },
        {
            "id": 544,
            "name": "Baronissi",
            "provincia": "SA",
            "cap": "84081",
            "cod_catastale": "A674",
            "cod_istat": "065013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 1437,
            "area": "",
            "ech": 0
        },
        {
            "id": 545,
            "name": "Barrafranca",
            "provincia": "EN",
            "cap": "94012",
            "cod_catastale": "A676",
            "cod_istat": "086004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1344,
            "area": "",
            "ech": 0
        },
        {
            "id": 546,
            "name": "Barrali",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "A677",
            "cod_istat": "111004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 140,
            "giorni": 1292,
            "area": "",
            "ech": 1
        },
        {
            "id": 547,
            "name": "Barrea",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "A678",
            "cod_istat": "066010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1060,
            "giorni": 3186,
            "area": "",
            "ech": 0
        },
        {
            "id": 548,
            "name": "Barumini",
            "provincia": "SU",
            "cap": "09021",
            "cod_catastale": "A681",
            "cod_istat": "111005",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 202,
            "giorni": 1270,
            "area": "",
            "ech": 0
        },
        {
            "id": 549,
            "name": "Barzago",
            "provincia": "LC",
            "cap": "23890",
            "cod_catastale": "A683",
            "cod_istat": "097005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 550,
            "name": "Barzana",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "A684",
            "cod_istat": "016021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 551,
            "name": "Barzanò",
            "provincia": "LC",
            "cap": "23891",
            "cod_catastale": "A686",
            "cod_istat": "097006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2595,
            "area": "",
            "ech": 0
        },
        {
            "id": 552,
            "name": "Barzio",
            "provincia": "LC",
            "cap": "23816",
            "cod_catastale": "A687",
            "cod_istat": "097007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 769,
            "giorni": 3158,
            "area": "",
            "ech": 0
        },
        {
            "id": 553,
            "name": "Basaluzzo",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "A689",
            "cod_istat": "006012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 554,
            "name": "Bascapè",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "A690",
            "cod_istat": "018009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 555,
            "name": "Baschi",
            "provincia": "TR",
            "cap": "05023",
            "cod_catastale": "A691",
            "cod_istat": "055007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1665,
            "area": "",
            "ech": 0
        },
        {
            "id": 556,
            "name": "Basciano",
            "provincia": "TE",
            "cap": "64030",
            "cod_catastale": "A692",
            "cod_istat": "067005",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 388,
            "giorni": 2036,
            "area": "",
            "ech": 0
        },
        {
            "id": 557,
            "name": "Baselga di Pinè",
            "provincia": "TN",
            "cap": "38042",
            "cod_catastale": "A694",
            "cod_istat": "022009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 964,
            "giorni": 3790,
            "area": "",
            "ech": 0
        },
        {
            "id": 558,
            "name": "Baselice",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "A696",
            "cod_istat": "062007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 620,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 559,
            "name": "Basiano",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "A697",
            "cod_istat": "015014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 560,
            "name": "Basicò",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "A698",
            "cod_istat": "083006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 1516,
            "area": "",
            "ech": 0
        },
        {
            "id": 561,
            "name": "Basiglio",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "A699",
            "cod_istat": "015015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 562,
            "name": "Basiliano",
            "provincia": "UD",
            "cap": "33031",
            "cod_catastale": "A700",
            "cod_istat": "030009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2277,
            "area": "",
            "ech": 0
        },
        {
            "id": 563,
            "name": "Bassano Bresciano",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "A702",
            "cod_istat": "017013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 564,
            "name": "Bassano del Grappa",
            "provincia": "VI",
            "cap": "36061",
            "cod_catastale": "A703",
            "cod_istat": "024012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2473,
            "area": "",
            "ech": 0
        },
        {
            "id": 565,
            "name": "Bassano in Teverina",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "A706",
            "cod_istat": "056006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 566,
            "name": "Bassano Romano",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "A704",
            "cod_istat": "056005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2060,
            "area": "",
            "ech": 0
        },
        {
            "id": 567,
            "name": "Bassiano",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "A707",
            "cod_istat": "059002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 562,
            "giorni": 2108,
            "area": "",
            "ech": 0
        },
        {
            "id": 568,
            "name": "Bassignana",
            "provincia": "AL",
            "cap": "15042",
            "cod_catastale": "A708",
            "cod_istat": "006013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 569,
            "name": "Bastia Mondovì",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "A709",
            "cod_istat": "004014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 570,
            "name": "Bastia Umbra",
            "provincia": "PG",
            "cap": "06083",
            "cod_catastale": "A710",
            "cod_istat": "054002",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 571,
            "name": "Bastida de'' Dossi",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "A711",
            "cod_istat": "018010",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 572,
            "name": "Bastida Pancarana",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "A712",
            "cod_istat": "018011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 573,
            "name": "Bastiglia",
            "provincia": "MO",
            "cap": "41030",
            "cod_catastale": "A713",
            "cod_istat": "036001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2247,
            "area": "",
            "ech": 0
        },
        {
            "id": 574,
            "name": "Battaglia Terme",
            "provincia": "PD",
            "cap": "35041",
            "cod_catastale": "A714",
            "cod_istat": "028011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 575,
            "name": "Battifollo",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "A716",
            "cod_istat": "004015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 846,
            "giorni": 3364,
            "area": "",
            "ech": 0
        },
        {
            "id": 576,
            "name": "Battipaglia",
            "provincia": "SA",
            "cap": "84091",
            "cod_catastale": "A717",
            "cod_istat": "065014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1134,
            "area": "",
            "ech": 0
        },
        {
            "id": 577,
            "name": "Battuda",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "A718",
            "cod_istat": "018012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 578,
            "name": "Baucina",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "A719",
            "cod_istat": "082008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1577,
            "area": "",
            "ech": 0
        },
        {
            "id": 579,
            "name": "Bauladu",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "A721",
            "cod_istat": "095013",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 38,
            "giorni": 1026,
            "area": "",
            "ech": 0
        },
        {
            "id": 580,
            "name": "Baunei",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "A722",
            "cod_istat": "091006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 1532,
            "area": "",
            "ech": 1
        },
        {
            "id": 581,
            "name": "Baveno",
            "provincia": "VB",
            "cap": "28831",
            "cod_catastale": "A725",
            "cod_istat": "103008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 582,
            "name": "Valsamoggia",
            "provincia": "BO",
            "cap": "40053",
            "cod_catastale": "M320",
            "cod_istat": "037061",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 583,
            "name": "Bedero Valcuvia",
            "provincia": "VA",
            "cap": "21039",
            "cod_catastale": "A728",
            "cod_istat": "012010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2764,
            "area": "",
            "ech": 0
        },
        {
            "id": 584,
            "name": "Bedizzole",
            "provincia": "BS",
            "cap": "25081",
            "cod_catastale": "A729",
            "cod_istat": "017014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 585,
            "name": "Bedollo",
            "provincia": "TN",
            "cap": "38043",
            "cod_catastale": "A730",
            "cod_istat": "022011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1059,
            "giorni": 4043,
            "area": "",
            "ech": 0
        },
        {
            "id": 586,
            "name": "Bedonia",
            "provincia": "PR",
            "cap": "43041",
            "cod_catastale": "A731",
            "cod_istat": "034003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 3000,
            "area": "",
            "ech": 0
        },
        {
            "id": 587,
            "name": "Bedulita",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "A732",
            "cod_istat": "016022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2922,
            "area": "",
            "ech": 0
        },
        {
            "id": 588,
            "name": "Bee",
            "provincia": "VB",
            "cap": "28813",
            "cod_catastale": "A733",
            "cod_istat": "103009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 591,
            "giorni": 3073,
            "area": "",
            "ech": 0
        },
        {
            "id": 589,
            "name": "Beinasco",
            "provincia": "TO",
            "cap": "10092",
            "cod_catastale": "A734",
            "cod_istat": "001024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2591,
            "area": "",
            "ech": 0
        },
        {
            "id": 590,
            "name": "Beinette",
            "provincia": "CN",
            "cap": "12081",
            "cod_catastale": "A735",
            "cod_istat": "004016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 491,
            "giorni": 2958,
            "area": "",
            "ech": 0
        },
        {
            "id": 591,
            "name": "Belcastro",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "A736",
            "cod_istat": "079009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 495,
            "giorni": 1700,
            "area": "",
            "ech": 0
        },
        {
            "id": 592,
            "name": "Belfiore",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "A737",
            "cod_istat": "023007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 593,
            "name": "Belforte all'Isauro",
            "provincia": "PU",
            "cap": "61026",
            "cod_catastale": "A740",
            "cod_istat": "041005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 2350,
            "area": "",
            "ech": 0
        },
        {
            "id": 594,
            "name": "Belforte del Chienti",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "A739",
            "cod_istat": "043004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 347,
            "giorni": 2046,
            "area": "",
            "ech": 0
        },
        {
            "id": 595,
            "name": "Belforte Monferrato",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "A738",
            "cod_istat": "006014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 596,
            "name": "Belgioioso",
            "provincia": "PV",
            "cap": "27011",
            "cod_catastale": "A741",
            "cod_istat": "018013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 597,
            "name": "Belgirate",
            "provincia": "VB",
            "cap": "28832",
            "cod_catastale": "A742",
            "cod_istat": "103010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 598,
            "name": "Bella",
            "provincia": "PZ",
            "cap": "85051",
            "cod_catastale": "A743",
            "cod_istat": "076012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 662,
            "giorni": 2127,
            "area": "",
            "ech": 0
        },
        {
            "id": 599,
            "name": "Bellagio",
            "provincia": "CO",
            "cap": "22021",
            "cod_catastale": "M335",
            "cod_istat": "013250",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 600,
            "name": "Bellano",
            "provincia": "LC",
            "cap": "23822",
            "cod_catastale": "A745",
            "cod_istat": "097008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2220,
            "area": "",
            "ech": 0
        },
        {
            "id": 601,
            "name": "Bellante",
            "provincia": "TE",
            "cap": "64020",
            "cod_catastale": "A746",
            "cod_istat": "067006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 354,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 602,
            "name": "Bellaria-Igea Marina",
            "provincia": "RN",
            "cap": "47814",
            "cod_catastale": "A747",
            "cod_istat": "099001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2318,
            "area": "",
            "ech": 0
        },
        {
            "id": 603,
            "name": "Bellegra",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "A749",
            "cod_istat": "058012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 815,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 604,
            "name": "Bellino",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "A750",
            "cod_istat": "004017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1572,
            "giorni": 4264,
            "area": "",
            "ech": 0
        },
        {
            "id": 605,
            "name": "Bellinzago Lombardo",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "A751",
            "cod_istat": "015016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 606,
            "name": "Bellinzago Novarese",
            "provincia": "NO",
            "cap": "28043",
            "cod_catastale": "A752",
            "cod_istat": "003016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 607,
            "name": "Bellizzi",
            "provincia": "SA",
            "cap": "84092",
            "cod_catastale": "M294",
            "cod_istat": "065158",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 1118,
            "area": "",
            "ech": 0
        },
        {
            "id": 608,
            "name": "Bellona",
            "provincia": "CE",
            "cap": "81041",
            "cod_catastale": "A755",
            "cod_istat": "061007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1190,
            "area": "",
            "ech": 0
        },
        {
            "id": 609,
            "name": "Bellosguardo",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "A756",
            "cod_istat": "065015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 559,
            "giorni": 1913,
            "area": "",
            "ech": 0
        },
        {
            "id": 610,
            "name": "Belluno",
            "provincia": "BL",
            "cap": "32100",
            "cod_catastale": "A757",
            "cod_istat": "025006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 389,
            "giorni": 3001,
            "area": "",
            "ech": 0
        },
        {
            "id": 611,
            "name": "Bellusco",
            "provincia": "MB",
            "cap": "20882",
            "cod_catastale": "A759",
            "cod_istat": "108006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2409,
            "area": "",
            "ech": 0
        },
        {
            "id": 612,
            "name": "Belmonte Calabro",
            "provincia": "CS",
            "cap": "87033",
            "cod_catastale": "A762",
            "cod_istat": "078013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 1333,
            "area": "",
            "ech": 0
        },
        {
            "id": 613,
            "name": "Belmonte Castello",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "A763",
            "cod_istat": "060013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 369,
            "giorni": 1804,
            "area": "",
            "ech": 0
        },
        {
            "id": 614,
            "name": "Belmonte del Sannio",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "A761",
            "cod_istat": "094004",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 864,
            "giorni": 2515,
            "area": "",
            "ech": 0
        },
        {
            "id": 615,
            "name": "Belmonte in Sabina",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "A765",
            "cod_istat": "057005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 756,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 616,
            "name": "Belmonte Mezzagno",
            "provincia": "PA",
            "cap": "90031",
            "cod_catastale": "A764",
            "cod_istat": "082009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 1251,
            "area": "",
            "ech": 0
        },
        {
            "id": 617,
            "name": "Belmonte Piceno",
            "provincia": "FM",
            "cap": "63838",
            "cod_catastale": "A760",
            "cod_istat": "109003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 618,
            "name": "Belpasso",
            "provincia": "CT",
            "cap": "95032",
            "cod_catastale": "A766",
            "cod_istat": "087007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 551,
            "giorni": 1429,
            "area": "",
            "ech": 1
        },
        {
            "id": 619,
            "name": "Belsito",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "A768",
            "cod_istat": "078014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2122,
            "area": "",
            "ech": 0
        },
        {
            "id": 620,
            "name": "Belvedere di Spinello",
            "provincia": "KR",
            "cap": "88824",
            "cod_catastale": "A772",
            "cod_istat": "101001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1383,
            "area": "",
            "ech": 0
        },
        {
            "id": 621,
            "name": "Belvedere Langhe",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "A774",
            "cod_istat": "004018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 639,
            "giorni": 3107,
            "area": "",
            "ech": 0
        },
        {
            "id": 622,
            "name": "Belvedere Marittimo",
            "provincia": "CS",
            "cap": "87021",
            "cod_catastale": "A773",
            "cod_istat": "078015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1120,
            "area": "",
            "ech": 1
        },
        {
            "id": 623,
            "name": "Belvedere Ostrense",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "A769",
            "cod_istat": "042005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 2109,
            "area": "",
            "ech": 0
        },
        {
            "id": 624,
            "name": "Belveglio",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "A770",
            "cod_istat": "005008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 625,
            "name": "Belvì",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "A776",
            "cod_istat": "091007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 1885,
            "area": "",
            "ech": 0
        },
        {
            "id": 626,
            "name": "Bema",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "A777",
            "cod_istat": "014006",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 627,
            "name": "Bene Lario",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "A778",
            "cod_istat": "013021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 377,
            "giorni": 2605,
            "area": "",
            "ech": 0
        },
        {
            "id": 628,
            "name": "Bene Vagienna",
            "provincia": "CN",
            "cap": "12041",
            "cod_catastale": "A779",
            "cod_istat": "004019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2605,
            "area": "",
            "ech": 0
        },
        {
            "id": 629,
            "name": "Benestare",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "A780",
            "cod_istat": "080008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1007,
            "area": "",
            "ech": 0
        },
        {
            "id": 630,
            "name": "Benetutti",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "A781",
            "cod_istat": "090008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 406,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 631,
            "name": "Benevello",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "A782",
            "cod_istat": "004020",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 671,
            "giorni": 3147,
            "area": "",
            "ech": 0
        },
        {
            "id": 632,
            "name": "Benevento",
            "provincia": "BN",
            "cap": "82100",
            "cod_catastale": "A783",
            "cod_istat": "062008",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 135,
            "giorni": 1316,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 633,
            "name": "Benna",
            "provincia": "BI",
            "cap": "13871",
            "cod_catastale": "A784",
            "cod_istat": "096003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 634,
            "name": "Bentivoglio",
            "provincia": "BO",
            "cap": "40010",
            "cod_catastale": "A785",
            "cod_istat": "037005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 635,
            "name": "Berbenno",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "A786",
            "cod_istat": "016023",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 675,
            "giorni": 3028,
            "area": "",
            "ech": 0
        },
        {
            "id": 636,
            "name": "Berbenno di Valtellina",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "A787",
            "cod_istat": "014007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2844,
            "area": "",
            "ech": 0
        },
        {
            "id": 637,
            "name": "Berceto",
            "provincia": "PR",
            "cap": "43042",
            "cod_catastale": "A788",
            "cod_istat": "034004",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 808,
            "giorni": 3317,
            "area": "",
            "ech": 0
        },
        {
            "id": 638,
            "name": "Berchidda",
            "provincia": "SS",
            "cap": "07022",
            "cod_catastale": "A789",
            "cod_istat": "090009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1486,
            "area": "",
            "ech": 0
        },
        {
            "id": 639,
            "name": "Beregazzo con Figliaro",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "A791",
            "cod_istat": "013022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 423,
            "giorni": 2730,
            "area": "",
            "ech": 0
        },
        {
            "id": 640,
            "name": "Bereguardo",
            "provincia": "PV",
            "cap": "27021",
            "cod_catastale": "A792",
            "cod_istat": "018014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 641,
            "name": "Bergamasco",
            "provincia": "AL",
            "cap": "15022",
            "cod_catastale": "A793",
            "cod_istat": "006015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2587,
            "area": "",
            "ech": 0
        },
        {
            "id": 642,
            "name": "Bergamo",
            "provincia": "BG",
            "cap": "241xx",
            "cod_catastale": "A794",
            "cod_istat": "016024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2533,
            "area": "",
            "ech": 0
        },
        {
            "id": 643,
            "name": "Bergantino",
            "provincia": "RO",
            "cap": "45032",
            "cod_catastale": "A795",
            "cod_istat": "029006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 644,
            "name": "Bergeggi",
            "provincia": "SV",
            "cap": "17028",
            "cod_catastale": "A796",
            "cod_istat": "009010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 645,
            "name": "Bergolo",
            "provincia": "CN",
            "cap": "12074",
            "cod_catastale": "A798",
            "cod_istat": "004021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 616,
            "giorni": 3079,
            "area": "",
            "ech": 0
        },
        {
            "id": 646,
            "name": "Berlingo",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "A799",
            "cod_istat": "017015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 647,
            "name": "Bernalda",
            "provincia": "MT",
            "cap": "75012",
            "cod_catastale": "A801",
            "cod_istat": "077003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 1366,
            "area": "",
            "ech": 0
        },
        {
            "id": 648,
            "name": "Bernareggio",
            "provincia": "MB",
            "cap": "20881",
            "cod_catastale": "A802",
            "cod_istat": "108007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 649,
            "name": "Bernate Ticino",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "A804",
            "cod_istat": "015019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 650,
            "name": "Bernezzo",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "A805",
            "cod_istat": "004022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3062,
            "area": "",
            "ech": 0
        },
        {
            "id": 651,
            "name": "Berra",
            "provincia": "FE",
            "cap": "44033",
            "cod_catastale": "A806",
            "cod_istat": "038002",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2346,
            "area": "",
            "ech": 0
        },
        {
            "id": 652,
            "name": "Bersone",
            "provincia": "TN",
            "cap": "38085",
            "cod_catastale": "A808",
            "cod_istat": "022012",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 637,
            "giorni": 3384,
            "area": "",
            "ech": 0
        },
        {
            "id": 653,
            "name": "Bertinoro",
            "provincia": "FC",
            "cap": "47032",
            "cod_catastale": "A809",
            "cod_istat": "040003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 654,
            "name": "Bertiolo",
            "provincia": "UD",
            "cap": "33032",
            "cod_catastale": "A810",
            "cod_istat": "030010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 655,
            "name": "Bertonico",
            "provincia": "LO",
            "cap": "26821",
            "cod_catastale": "A811",
            "cod_istat": "098002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 656,
            "name": "Berzano di San Pietro",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "A812",
            "cod_istat": "005009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 2838,
            "area": "",
            "ech": 0
        },
        {
            "id": 657,
            "name": "Berzano di Tortona",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "A813",
            "cod_istat": "006016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2709,
            "area": "",
            "ech": 0
        },
        {
            "id": 658,
            "name": "Berzo Demo",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "A816",
            "cod_istat": "017016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 790,
            "giorni": 3332,
            "area": "",
            "ech": 0
        },
        {
            "id": 659,
            "name": "Berzo Inferiore",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "A817",
            "cod_istat": "017017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2718,
            "area": "",
            "ech": 0
        },
        {
            "id": 660,
            "name": "Berzo San Fermo",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A815",
            "cod_istat": "016025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2497,
            "area": "",
            "ech": 0
        },
        {
            "id": 661,
            "name": "Besana in Brianza",
            "provincia": "MB",
            "cap": "20842",
            "cod_catastale": "A818",
            "cod_istat": "108008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 662,
            "name": "Besano",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "A819",
            "cod_istat": "012011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 663,
            "name": "Besate",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "A820",
            "cod_istat": "015022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 664,
            "name": "Besenello",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "A821",
            "cod_istat": "022013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 665,
            "name": "Besenzone",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "A823",
            "cod_istat": "033003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2518,
            "area": "",
            "ech": 0
        },
        {
            "id": 666,
            "name": "Besnate",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "A825",
            "cod_istat": "012012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2761,
            "area": "",
            "ech": 0
        },
        {
            "id": 667,
            "name": "Besozzo",
            "provincia": "VA",
            "cap": "21023",
            "cod_catastale": "A826",
            "cod_istat": "012013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 668,
            "name": "Bessude",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "A827",
            "cod_istat": "090010",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 447,
            "giorni": 1879,
            "area": "",
            "ech": 0
        },
        {
            "id": 669,
            "name": "Bettola",
            "provincia": "PC",
            "cap": "29021",
            "cod_catastale": "A831",
            "cod_istat": "033004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2878,
            "area": "",
            "ech": 0
        },
        {
            "id": 670,
            "name": "Bettona",
            "provincia": "PG",
            "cap": "06084",
            "cod_catastale": "A832",
            "cod_istat": "054003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 2149,
            "area": "",
            "ech": 0
        },
        {
            "id": 671,
            "name": "Beura-Cardezza",
            "provincia": "VB",
            "cap": "28851",
            "cod_catastale": "A834",
            "cod_istat": "103011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2523,
            "area": "",
            "ech": 0
        },
        {
            "id": 672,
            "name": "Bevagna",
            "provincia": "PG",
            "cap": "06031",
            "cod_catastale": "A835",
            "cod_istat": "054004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2004,
            "area": "",
            "ech": 0
        },
        {
            "id": 673,
            "name": "Beverino",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "A836",
            "cod_istat": "011003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 1467,
            "area": "",
            "ech": 0
        },
        {
            "id": 674,
            "name": "Bevilacqua",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "A837",
            "cod_istat": "023008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 675,
            "name": "Biancavilla",
            "provincia": "CT",
            "cap": "95033",
            "cod_catastale": "A841",
            "cod_istat": "087008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 1391,
            "area": "",
            "ech": 1
        },
        {
            "id": 676,
            "name": "Bianchi",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "A842",
            "cod_istat": "078016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 825,
            "giorni": 2448,
            "area": "",
            "ech": 0
        },
        {
            "id": 677,
            "name": "Bianco",
            "provincia": "RC",
            "cap": "89032",
            "cod_catastale": "A843",
            "cod_istat": "080009",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 784,
            "area": "",
            "ech": 1
        },
        {
            "id": 678,
            "name": "Biandrate",
            "provincia": "NO",
            "cap": "28061",
            "cod_catastale": "A844",
            "cod_istat": "003018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 679,
            "name": "Biandronno",
            "provincia": "VA",
            "cap": "21024",
            "cod_catastale": "A845",
            "cod_istat": "012014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2512,
            "area": "",
            "ech": 0
        },
        {
            "id": 680,
            "name": "Bianzano",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A846",
            "cod_istat": "016026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2922,
            "area": "",
            "ech": 0
        },
        {
            "id": 681,
            "name": "Bianzè",
            "provincia": "VC",
            "cap": "13041",
            "cod_catastale": "A847",
            "cod_istat": "002011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 682,
            "name": "Bianzone",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "A848",
            "cod_istat": "014008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 2700,
            "area": "",
            "ech": 0
        },
        {
            "id": 683,
            "name": "Biassono",
            "provincia": "MB",
            "cap": "20853",
            "cod_catastale": "A849",
            "cod_istat": "108009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 684,
            "name": "Bibbiano",
            "provincia": "RE",
            "cap": "42021",
            "cod_catastale": "A850",
            "cod_istat": "035004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 685,
            "name": "Bibbiena",
            "provincia": "AR",
            "cap": "52011",
            "cod_catastale": "A851",
            "cod_istat": "051004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 686,
            "name": "Bibbona",
            "provincia": "LI",
            "cap": "57020",
            "cod_catastale": "A852",
            "cod_istat": "049001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1417,
            "area": "",
            "ech": 0
        },
        {
            "id": 687,
            "name": "Bibiana",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "A853",
            "cod_istat": "001025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 2827,
            "area": "",
            "ech": 0
        },
        {
            "id": 688,
            "name": "Biccari",
            "provincia": "FG",
            "cap": "71032",
            "cod_catastale": "A854",
            "cod_istat": "071006",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1926,
            "area": "",
            "ech": 0
        },
        {
            "id": 689,
            "name": "Bicinicco",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "A855",
            "cod_istat": "030011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2454,
            "area": "",
            "ech": 0
        },
        {
            "id": 690,
            "name": "Bidonì",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "A856",
            "cod_istat": "095014",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 250,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 691,
            "name": "Biella",
            "provincia": "BI",
            "cap": "13900",
            "cod_catastale": "A859",
            "cod_istat": "096004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 692,
            "name": "Bienno",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "A861",
            "cod_istat": "017018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 2870,
            "area": "",
            "ech": 0
        },
        {
            "id": 693,
            "name": "Bieno",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "A863",
            "cod_istat": "022015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 815,
            "giorni": 3880,
            "area": "",
            "ech": 0
        },
        {
            "id": 694,
            "name": "Bientina",
            "provincia": "PI",
            "cap": "56031",
            "cod_catastale": "A864",
            "cod_istat": "050001",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1856,
            "area": "",
            "ech": 0
        },
        {
            "id": 695,
            "name": "Bigarello",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "A866",
            "cod_istat": "020004",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 696,
            "name": "Binago",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "A870",
            "cod_istat": "013023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 697,
            "name": "Binasco",
            "provincia": "MI",
            "cap": "20082",
            "cod_catastale": "A872",
            "cod_istat": "015024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 698,
            "name": "Binetto",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "A874",
            "cod_istat": "072008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 179,
            "giorni": 1425,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 699,
            "name": "Bioglio",
            "provincia": "BI",
            "cap": "13841",
            "cod_catastale": "A876",
            "cod_istat": "096005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 513,
            "giorni": 2971,
            "area": "",
            "ech": 0
        },
        {
            "id": 700,
            "name": "Bionaz",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "A877",
            "cod_istat": "007010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1606,
            "giorni": 4641,
            "area": "",
            "ech": 0
        },
        {
            "id": 701,
            "name": "Bione",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "A878",
            "cod_istat": "017019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 3067,
            "area": "",
            "ech": 0
        },
        {
            "id": 702,
            "name": "Birori",
            "provincia": "NU",
            "cap": "08010",
            "cod_catastale": "A880",
            "cod_istat": "091008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 464,
            "giorni": 1483,
            "area": "",
            "ech": 0
        },
        {
            "id": 703,
            "name": "Bisaccia",
            "provincia": "AV",
            "cap": "83044",
            "cod_catastale": "A881",
            "cod_istat": "064011",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 860,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 704,
            "name": "Bisacquino",
            "provincia": "PA",
            "cap": "90032",
            "cod_catastale": "A882",
            "cod_istat": "082010",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 744,
            "giorni": 1758,
            "area": "",
            "ech": 0
        },
        {
            "id": 705,
            "name": "Bisceglie",
            "provincia": "BT",
            "cap": "76011",
            "cod_catastale": "A883",
            "cod_istat": "110003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1203,
            "area": "",
            "ech": 0
        },
        {
            "id": 706,
            "name": "Bisegna",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "A884",
            "cod_istat": "066011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 3454,
            "area": "",
            "ech": 0
        },
        {
            "id": 707,
            "name": "Bisenti",
            "provincia": "TE",
            "cap": "64033",
            "cod_catastale": "A885",
            "cod_istat": "067007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 274,
            "giorni": 1763,
            "area": "",
            "ech": 0
        },
        {
            "id": 708,
            "name": "Bisignano",
            "provincia": "CS",
            "cap": "87043",
            "cod_catastale": "A887",
            "cod_istat": "078017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1523,
            "area": "",
            "ech": 0
        },
        {
            "id": 709,
            "name": "Bistagno",
            "provincia": "AL",
            "cap": "15012",
            "cod_catastale": "A889",
            "cod_istat": "006017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2629,
            "area": "",
            "ech": 0
        },
        {
            "id": 710,
            "name": "Bisuschio",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "A891",
            "cod_istat": "012015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 711,
            "name": "Bitetto",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "A892",
            "cod_istat": "072010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 139,
            "giorni": 1380,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 712,
            "name": "Bitonto",
            "provincia": "BA",
            "cap": "70032",
            "cod_catastale": "A893",
            "cod_istat": "072011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 1350,
            "area": "",
            "ech": 0
        },
        {
            "id": 713,
            "name": "Bitritto",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "A894",
            "cod_istat": "072012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 1327,
            "area": "",
            "ech": 0
        },
        {
            "id": 714,
            "name": "Bitti",
            "provincia": "NU",
            "cap": "08021",
            "cod_catastale": "A895",
            "cod_istat": "091009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 548,
            "giorni": 1646,
            "area": "",
            "ech": 1
        },
        {
            "id": 715,
            "name": "Bivona",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "A896",
            "cod_istat": "084004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 503,
            "giorni": 1268,
            "area": "",
            "ech": 0
        },
        {
            "id": 716,
            "name": "Bivongi",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "A897",
            "cod_istat": "080010",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 270,
            "giorni": 1029,
            "area": "",
            "ech": 1
        },
        {
            "id": 717,
            "name": "Bizzarone",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "A898",
            "cod_istat": "013024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 436,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 718,
            "name": "Bleggio Superiore",
            "provincia": "TN",
            "cap": "38071",
            "cod_catastale": "A902",
            "cod_istat": "022017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 628,
            "giorni": 3349,
            "area": "",
            "ech": 0
        },
        {
            "id": 719,
            "name": "Blello",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "A903",
            "cod_istat": "016027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 815,
            "giorni": 3227,
            "area": "",
            "ech": 0
        },
        {
            "id": 720,
            "name": "Blera",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "A857",
            "cod_istat": "056007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1900,
            "area": "",
            "ech": 0
        },
        {
            "id": 721,
            "name": "Blessagno",
            "provincia": "CO",
            "cap": "22028",
            "cod_catastale": "A904",
            "cod_istat": "013025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 762,
            "giorni": 3152,
            "area": "",
            "ech": 0
        },
        {
            "id": 722,
            "name": "Blevio",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "A905",
            "cod_istat": "013026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 723,
            "name": "Blufi",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "M268",
            "cod_istat": "082082",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 725,
            "giorni": 1734,
            "area": "",
            "ech": 0
        },
        {
            "id": 724,
            "name": "Boara Pisani",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "A906",
            "cod_istat": "028012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 725,
            "name": "Bobbio",
            "provincia": "PC",
            "cap": "29022",
            "cod_catastale": "A909",
            "cod_istat": "033005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 726,
            "name": "Bobbio Pellice",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "A910",
            "cod_istat": "001026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 3452,
            "area": "",
            "ech": 0
        },
        {
            "id": 727,
            "name": "Boca",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A911",
            "cod_istat": "003019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 389,
            "giorni": 2810,
            "area": "",
            "ech": 0
        },
        {
            "id": 728,
            "name": "Bocchigliero",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "A912",
            "cod_istat": "078018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 729,
            "name": "Boccioleto",
            "provincia": "VC",
            "cap": "13022",
            "cod_catastale": "A914",
            "cod_istat": "002014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 667,
            "giorni": 3172,
            "area": "",
            "ech": 0
        },
        {
            "id": 730,
            "name": "Bocenago",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "A916",
            "cod_istat": "022018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3561,
            "area": "",
            "ech": 0
        },
        {
            "id": 731,
            "name": "Bodio Lomnago",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "A918",
            "cod_istat": "012016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 732,
            "name": "Boffalora d'Adda",
            "provincia": "LO",
            "cap": "26811",
            "cod_catastale": "A919",
            "cod_istat": "098003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 733,
            "name": "Boffalora sopra Ticino",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "A920",
            "cod_istat": "015026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 734,
            "name": "Bogliasco",
            "provincia": "GE",
            "cap": "16031",
            "cod_catastale": "A922",
            "cod_istat": "010004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1448,
            "area": "",
            "ech": 0
        },
        {
            "id": 735,
            "name": "Bognanco",
            "provincia": "VB",
            "cap": "28842",
            "cod_catastale": "A925",
            "cod_istat": "103012",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 980,
            "giorni": 3578,
            "area": "",
            "ech": 0
        },
        {
            "id": 736,
            "name": "Bogogno",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A929",
            "cod_istat": "003021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 737,
            "name": "Boissano",
            "provincia": "SV",
            "cap": "17054",
            "cod_catastale": "A931",
            "cod_istat": "009011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 1653,
            "area": "",
            "ech": 0
        },
        {
            "id": 738,
            "name": "Bojano",
            "provincia": "CB",
            "cap": "86021",
            "cod_catastale": "A930",
            "cod_istat": "070003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 1962,
            "area": "",
            "ech": 0
        },
        {
            "id": 739,
            "name": "Bolano",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "A932",
            "cod_istat": "011004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 1819,
            "area": "",
            "ech": 0
        },
        {
            "id": 740,
            "name": "Bolbeno",
            "provincia": "TN",
            "cap": "38079",
            "cod_catastale": "A933",
            "cod_istat": "022019",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3288,
            "area": "",
            "ech": 0
        },
        {
            "id": 741,
            "name": "Bolgare",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "A937",
            "cod_istat": "016028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 742,
            "name": "Bollate",
            "provincia": "MI",
            "cap": "20021",
            "cod_catastale": "A940",
            "cod_istat": "015027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 743,
            "name": "Bollengo",
            "provincia": "TO",
            "cap": "10012",
            "cod_catastale": "A941",
            "cod_istat": "001027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 744,
            "name": "Bologna",
            "provincia": "BO",
            "cap": "401xx",
            "cod_catastale": "A944",
            "cod_istat": "037006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 745,
            "name": "Bolognano",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "A945",
            "cod_istat": "068003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 1672,
            "area": "",
            "ech": 0
        },
        {
            "id": 746,
            "name": "Bolognetta",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "A946",
            "cod_istat": "082011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1207,
            "area": "",
            "ech": 1
        },
        {
            "id": 747,
            "name": "Bolognola",
            "provincia": "MC",
            "cap": "62035",
            "cod_catastale": "A947",
            "cod_istat": "043005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1070,
            "giorni": 2891,
            "area": "",
            "ech": 0
        },
        {
            "id": 748,
            "name": "Bolotana",
            "provincia": "NU",
            "cap": "08011",
            "cod_catastale": "A948",
            "cod_istat": "091010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 1636,
            "area": "",
            "ech": 0
        },
        {
            "id": 749,
            "name": "Bolsena",
            "provincia": "VT",
            "cap": "01023",
            "cod_catastale": "A949",
            "cod_istat": "056008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1932,
            "area": "",
            "ech": 0
        },
        {
            "id": 750,
            "name": "Boltiere",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A950",
            "cod_istat": "016029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 751,
            "name": "Bolzano",
            "provincia": "BZ",
            "cap": "39100",
            "cod_catastale": "A952",
            "cod_istat": "021008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2791,
            "area": "",
            "ech": 0
        },
        {
            "id": 752,
            "name": "Bolzano Novarese",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "A953",
            "cod_istat": "003022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2821,
            "area": "",
            "ech": 0
        },
        {
            "id": 753,
            "name": "Bolzano Vicentino",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "A954",
            "cod_istat": "024013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2381,
            "area": "",
            "ech": 0
        },
        {
            "id": 754,
            "name": "Bomarzo",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "A955",
            "cod_istat": "056009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 755,
            "name": "Bomba",
            "provincia": "CH",
            "cap": "66042",
            "cod_catastale": "A956",
            "cod_istat": "069006",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 424,
            "giorni": 1832,
            "area": "",
            "ech": 0
        },
        {
            "id": 756,
            "name": "Bompensiere",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "A957",
            "cod_istat": "085002",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 283,
            "giorni": 1090,
            "area": "",
            "ech": 0
        },
        {
            "id": 757,
            "name": "Bompietro",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "A958",
            "cod_istat": "082012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 685,
            "giorni": 1715,
            "area": "",
            "ech": 0
        },
        {
            "id": 758,
            "name": "Bomporto",
            "provincia": "MO",
            "cap": "41030",
            "cod_catastale": "A959",
            "cod_istat": "036002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2244,
            "area": "",
            "ech": 0
        },
        {
            "id": 759,
            "name": "Bonarcado",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "A960",
            "cod_istat": "095015",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 283,
            "giorni": 1338,
            "area": "",
            "ech": 0
        },
        {
            "id": 760,
            "name": "Bonassola",
            "provincia": "SP",
            "cap": "19011",
            "cod_catastale": "A961",
            "cod_istat": "011005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1509,
            "area": "",
            "ech": 0
        },
        {
            "id": 761,
            "name": "Bonate Sopra",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A963",
            "cod_istat": "016030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 762,
            "name": "Bonate Sotto",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "A962",
            "cod_istat": "016031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 763,
            "name": "Bonavigo",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "A964",
            "cod_istat": "023009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2424,
            "area": "",
            "ech": 0
        },
        {
            "id": 764,
            "name": "Bondeno",
            "provincia": "FE",
            "cap": "44012",
            "cod_catastale": "A965",
            "cod_istat": "038003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2281,
            "area": "",
            "ech": 0
        },
        {
            "id": 765,
            "name": "Bondo",
            "provincia": "TN",
            "cap": "38081",
            "cod_catastale": "A967",
            "cod_istat": "022020",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 823,
            "giorni": 3675,
            "area": "",
            "ech": 0
        },
        {
            "id": 766,
            "name": "Bondone",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "A968",
            "cod_istat": "022021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 3514,
            "area": "",
            "ech": 0
        },
        {
            "id": 767,
            "name": "Bonea",
            "provincia": "BN",
            "cap": "82013",
            "cod_catastale": "A970",
            "cod_istat": "062009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1707,
            "area": "",
            "ech": 0
        },
        {
            "id": 768,
            "name": "Bonefro",
            "provincia": "CB",
            "cap": "86041",
            "cod_catastale": "A971",
            "cod_istat": "070004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 769,
            "name": "Bonemerse",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "A972",
            "cod_istat": "019006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 770,
            "name": "Bonifati",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "A973",
            "cod_istat": "078019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 771,
            "name": "Bonito",
            "provincia": "AV",
            "cap": "83032",
            "cod_catastale": "A975",
            "cod_istat": "064012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 490,
            "giorni": 1980,
            "area": "",
            "ech": 0
        },
        {
            "id": 772,
            "name": "Bonnanaro",
            "provincia": "SS",
            "cap": "07043",
            "cod_catastale": "A976",
            "cod_istat": "090011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 405,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 773,
            "name": "Bono",
            "provincia": "SS",
            "cap": "07011",
            "cod_catastale": "A977",
            "cod_istat": "090012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1934,
            "area": "",
            "ech": 0
        },
        {
            "id": 774,
            "name": "Bonorva",
            "provincia": "SS",
            "cap": "07012",
            "cod_catastale": "A978",
            "cod_istat": "090013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 508,
            "giorni": 1881,
            "area": "",
            "ech": 0
        },
        {
            "id": 775,
            "name": "Bonvicino",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "A979",
            "cod_istat": "004023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 502,
            "giorni": 2938,
            "area": "",
            "ech": 0
        },
        {
            "id": 776,
            "name": "Borbona",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "A981",
            "cod_istat": "057006",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 760,
            "giorni": 2805,
            "area": "",
            "ech": 0
        },
        {
            "id": 777,
            "name": "Borca di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "A982",
            "cod_istat": "025007",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 942,
            "giorni": 4072,
            "area": "",
            "ech": 0
        },
        {
            "id": 778,
            "name": "Bordano",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "A983",
            "cod_istat": "030012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2585,
            "area": "",
            "ech": 0
        },
        {
            "id": 779,
            "name": "Bordighera",
            "provincia": "IM",
            "cap": "18012",
            "cod_catastale": "A984",
            "cod_istat": "008008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1057,
            "area": "",
            "ech": 0
        },
        {
            "id": 780,
            "name": "Bordolano",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "A986",
            "cod_istat": "019007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 781,
            "name": "Bore",
            "provincia": "PR",
            "cap": "43030",
            "cod_catastale": "A987",
            "cod_istat": "034005",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 835,
            "giorni": 3522,
            "area": "",
            "ech": 0
        },
        {
            "id": 782,
            "name": "Boretto",
            "provincia": "RE",
            "cap": "42022",
            "cod_catastale": "A988",
            "cod_istat": "035005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 783,
            "name": "Borgarello",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "A989",
            "cod_istat": "018015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 784,
            "name": "Borgaro Torinese",
            "provincia": "TO",
            "cap": "10071",
            "cod_catastale": "A990",
            "cod_istat": "001028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2639,
            "area": "",
            "ech": 0
        },
        {
            "id": 785,
            "name": "Borgetto",
            "provincia": "PA",
            "cap": "90042",
            "cod_catastale": "A991",
            "cod_istat": "082013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 976,
            "area": "",
            "ech": 1
        },
        {
            "id": 786,
            "name": "Borghetto d'Arroscia",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "A993",
            "cod_istat": "008009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 2153,
            "area": "",
            "ech": 0
        },
        {
            "id": 787,
            "name": "Borghetto di Borbera",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "A998",
            "cod_istat": "006018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 788,
            "name": "Borghetto di Vara",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "A992",
            "cod_istat": "011006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 1619,
            "area": "",
            "ech": 0
        },
        {
            "id": 789,
            "name": "Borghetto Lodigiano",
            "provincia": "LO",
            "cap": "26812",
            "cod_catastale": "A995",
            "cod_istat": "098004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 790,
            "name": "Borghetto Santo Spirito",
            "provincia": "SV",
            "cap": "17052",
            "cod_catastale": "A999",
            "cod_istat": "009012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1360,
            "area": "",
            "ech": 0
        },
        {
            "id": 791,
            "name": "Borghi",
            "provincia": "FC",
            "cap": "47030",
            "cod_catastale": "B001",
            "cod_istat": "040004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2497,
            "area": "",
            "ech": 0
        },
        {
            "id": 792,
            "name": "Borgia",
            "provincia": "CZ",
            "cap": "88021",
            "cod_catastale": "B002",
            "cod_istat": "079011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 1372,
            "area": "",
            "ech": 1
        },
        {
            "id": 793,
            "name": "Borgiallo",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B003",
            "cod_istat": "001029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 3020,
            "area": "",
            "ech": 0
        },
        {
            "id": 794,
            "name": "Borgio Verezzi",
            "provincia": "SV",
            "cap": "17022",
            "cod_catastale": "B005",
            "cod_istat": "009013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1351,
            "area": "",
            "ech": 0
        },
        {
            "id": 795,
            "name": "Borgo a Mozzano",
            "provincia": "LU",
            "cap": "55023",
            "cod_catastale": "B007",
            "cod_istat": "046004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2101,
            "area": "",
            "ech": 0
        },
        {
            "id": 796,
            "name": "Borgo d'Ale",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "B009",
            "cod_istat": "002015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 797,
            "name": "Borgo di Terzo",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B010",
            "cod_istat": "016032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 798,
            "name": "Borgo Pace",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "B026",
            "cod_istat": "041006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 469,
            "giorni": 2523,
            "area": "",
            "ech": 0
        },
        {
            "id": 799,
            "name": "Borgo Priolo",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B028",
            "cod_istat": "018016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 800,
            "name": "Borgo San Dalmazzo",
            "provincia": "CN",
            "cap": "12011",
            "cod_catastale": "B033",
            "cod_istat": "004025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 636,
            "giorni": 3104,
            "area": "",
            "ech": 0
        },
        {
            "id": 801,
            "name": "Borgo San Giacomo",
            "provincia": "BS",
            "cap": "25022",
            "cod_catastale": "B035",
            "cod_istat": "017020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 802,
            "name": "Borgo San Giovanni",
            "provincia": "LO",
            "cap": "26851",
            "cod_catastale": "B017",
            "cod_istat": "098005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 803,
            "name": "Borgo San Lorenzo",
            "provincia": "FI",
            "cap": "50032",
            "cod_catastale": "B036",
            "cod_istat": "048004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2122,
            "area": "",
            "ech": 0
        },
        {
            "id": 804,
            "name": "Borgo San Martino",
            "provincia": "AL",
            "cap": "15032",
            "cod_catastale": "B037",
            "cod_istat": "006020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2807,
            "area": "",
            "ech": 0
        },
        {
            "id": 805,
            "name": "Borgo San Siro",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "B038",
            "cod_istat": "018018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 806,
            "name": "Borgo Ticino",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "B043",
            "cod_istat": "003025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 807,
            "name": "Borgo Tossignano",
            "provincia": "BO",
            "cap": "40021",
            "cod_catastale": "B044",
            "cod_istat": "037007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2302,
            "area": "",
            "ech": 0
        },
        {
            "id": 808,
            "name": "Borgo Val di Taro",
            "provincia": "PR",
            "cap": "43043",
            "cod_catastale": "B042",
            "cod_istat": "034006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 411,
            "giorni": 2983,
            "area": "",
            "ech": 0
        },
        {
            "id": 809,
            "name": "Borgo Valsugana",
            "provincia": "TN",
            "cap": "38051",
            "cod_catastale": "B006",
            "cod_istat": "022022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2984,
            "area": "",
            "ech": 0
        },
        {
            "id": 810,
            "name": "Borgo Velino",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "A996",
            "cod_istat": "057008",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 460,
            "giorni": 2202,
            "area": "",
            "ech": 0
        },
        {
            "id": 811,
            "name": "Borgo Vercelli",
            "provincia": "VC",
            "cap": "13012",
            "cod_catastale": "B046",
            "cod_istat": "002017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2746,
            "area": "",
            "ech": 0
        },
        {
            "id": 812,
            "name": "Borgoforte",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "B011",
            "cod_istat": "020005",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 813,
            "name": "Borgofranco d'Ivrea",
            "provincia": "TO",
            "cap": "10013",
            "cod_catastale": "B015",
            "cod_istat": "001030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2737,
            "area": "",
            "ech": 0
        },
        {
            "id": 814,
            "name": "Borgofranco sul Po",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "B013",
            "cod_istat": "020006",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 815,
            "name": "Borgolavezzaro",
            "provincia": "NO",
            "cap": "28071",
            "cod_catastale": "B016",
            "cod_istat": "003023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 816,
            "name": "Borgomale",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "B018",
            "cod_istat": "004024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 471,
            "giorni": 2899,
            "area": "",
            "ech": 0
        },
        {
            "id": 817,
            "name": "Borgomanero",
            "provincia": "NO",
            "cap": "28021",
            "cod_catastale": "B019",
            "cod_istat": "003024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 818,
            "name": "Borgomaro",
            "provincia": "IM",
            "cap": "18021",
            "cod_catastale": "B020",
            "cod_istat": "008010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 1717,
            "area": "",
            "ech": 0
        },
        {
            "id": 819,
            "name": "Borgomasino",
            "provincia": "TO",
            "cap": "10031",
            "cod_catastale": "B021",
            "cod_istat": "001031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 820,
            "name": "Borgone Susa",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "B024",
            "cod_istat": "001032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2945,
            "area": "",
            "ech": 0
        },
        {
            "id": 821,
            "name": "Borgonovo Val Tidone",
            "provincia": "PC",
            "cap": "29011",
            "cod_catastale": "B025",
            "cod_istat": "033006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2603,
            "area": "",
            "ech": 0
        },
        {
            "id": 822,
            "name": "Borgoratto Alessandrino",
            "provincia": "AL",
            "cap": "15013",
            "cod_catastale": "B029",
            "cod_istat": "006019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2567,
            "area": "",
            "ech": 0
        },
        {
            "id": 823,
            "name": "Borgoratto Mormorolo",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B030",
            "cod_istat": "018017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 3053,
            "area": "",
            "ech": 0
        },
        {
            "id": 824,
            "name": "Borgoricco",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "B031",
            "cod_istat": "028013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 825,
            "name": "Borgorose",
            "provincia": "RI",
            "cap": "02021",
            "cod_catastale": "B008",
            "cod_istat": "057007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 732,
            "giorni": 2697,
            "area": "",
            "ech": 0
        },
        {
            "id": 826,
            "name": "Borgosatollo",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "B040",
            "cod_istat": "017021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 827,
            "name": "Borgosesia",
            "provincia": "VC",
            "cap": "13011",
            "cod_catastale": "B041",
            "cod_istat": "002016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 354,
            "giorni": 2765,
            "area": "",
            "ech": 0
        },
        {
            "id": 828,
            "name": "Bormida",
            "provincia": "SV",
            "cap": "17045",
            "cod_catastale": "B048",
            "cod_istat": "009014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 586,
            "giorni": 2678,
            "area": "",
            "ech": 0
        },
        {
            "id": 829,
            "name": "Bormio",
            "provincia": "SO",
            "cap": "23032",
            "cod_catastale": "B049",
            "cod_istat": "014009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1225,
            "giorni": 3838,
            "area": "",
            "ech": 0
        },
        {
            "id": 830,
            "name": "Bornasco",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "B051",
            "cod_istat": "018019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 831,
            "name": "Borno",
            "provincia": "BS",
            "cap": "25042",
            "cod_catastale": "B054",
            "cod_istat": "017022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 912,
            "giorni": 3612,
            "area": "",
            "ech": 0
        },
        {
            "id": 832,
            "name": "Boroneddu",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "B055",
            "cod_istat": "095016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 1253,
            "area": "",
            "ech": 0
        },
        {
            "id": 833,
            "name": "Borore",
            "provincia": "NU",
            "cap": "08016",
            "cod_catastale": "B056",
            "cod_istat": "091011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 1301,
            "area": "",
            "ech": 0
        },
        {
            "id": 834,
            "name": "Borrello",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "B057",
            "cod_istat": "069007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 804,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 835,
            "name": "Borriana",
            "provincia": "BI",
            "cap": "13872",
            "cod_catastale": "B058",
            "cod_istat": "096006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 836,
            "name": "Borso del Grappa",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "B061",
            "cod_istat": "026004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 837,
            "name": "Bortigali",
            "provincia": "NU",
            "cap": "08012",
            "cod_catastale": "B062",
            "cod_istat": "091012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 505,
            "giorni": 1636,
            "area": "",
            "ech": 0
        },
        {
            "id": 838,
            "name": "Bortigiadas",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "B063",
            "cod_istat": "090014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 1780,
            "area": "",
            "ech": 0
        },
        {
            "id": 839,
            "name": "Borutta",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "B064",
            "cod_istat": "090015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 471,
            "giorni": 1849,
            "area": "",
            "ech": 0
        },
        {
            "id": 840,
            "name": "Borzonasca",
            "provincia": "GE",
            "cap": "16041",
            "cod_catastale": "B067",
            "cod_istat": "010005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 167,
            "giorni": 2018,
            "area": "",
            "ech": 0
        },
        {
            "id": 841,
            "name": "Bosa",
            "provincia": "OR",
            "cap": "08013",
            "cod_catastale": "B068",
            "cod_istat": "095079",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 744,
            "area": "",
            "ech": 0
        },
        {
            "id": 842,
            "name": "Bosaro",
            "provincia": "RO",
            "cap": "45033",
            "cod_catastale": "B069",
            "cod_istat": "029007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 843,
            "name": "Boschi Sant'Anna",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "B070",
            "cod_istat": "023010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 844,
            "name": "Bosco Chiesanuova",
            "provincia": "VR",
            "cap": "37021",
            "cod_catastale": "B073",
            "cod_istat": "023011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1106,
            "giorni": 4089,
            "area": "",
            "ech": 0
        },
        {
            "id": 845,
            "name": "Bosco Marengo",
            "provincia": "AL",
            "cap": "15062",
            "cod_catastale": "B071",
            "cod_istat": "006021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 846,
            "name": "Bosconero",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B075",
            "cod_istat": "001033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 847,
            "name": "Boscoreale",
            "provincia": "NA",
            "cap": "80041",
            "cod_catastale": "B076",
            "cod_istat": "063008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 1240,
            "area": "",
            "ech": 0
        },
        {
            "id": 848,
            "name": "Boscotrecase",
            "provincia": "NA",
            "cap": "80042",
            "cod_catastale": "B077",
            "cod_istat": "063009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 1275,
            "area": "",
            "ech": 0
        },
        {
            "id": 849,
            "name": "Bosentino",
            "provincia": "TN",
            "cap": "38049",
            "cod_catastale": "B078",
            "cod_istat": "022023",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 688,
            "giorni": 3464,
            "area": "",
            "ech": 0
        },
        {
            "id": 850,
            "name": "Bosia",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "B079",
            "cod_istat": "004026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 484,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 851,
            "name": "Bosio",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B080",
            "cod_istat": "006022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2783,
            "area": "",
            "ech": 0
        },
        {
            "id": 852,
            "name": "Bosisio Parini",
            "provincia": "LC",
            "cap": "23842",
            "cod_catastale": "B081",
            "cod_istat": "097009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 853,
            "name": "Bosnasco",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B082",
            "cod_istat": "018020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 854,
            "name": "Bossico",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B083",
            "cod_istat": "016033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 860,
            "giorni": 3291,
            "area": "",
            "ech": 0
        },
        {
            "id": 855,
            "name": "Bossolasco",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "B084",
            "cod_istat": "004027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 757,
            "giorni": 3254,
            "area": "",
            "ech": 0
        },
        {
            "id": 856,
            "name": "Botricello",
            "provincia": "CZ",
            "cap": "88070",
            "cod_catastale": "B085",
            "cod_istat": "079012",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 853,
            "area": "",
            "ech": 1
        },
        {
            "id": 857,
            "name": "Botrugno",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "B086",
            "cod_istat": "075009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 1202,
            "area": "",
            "ech": 0
        },
        {
            "id": 858,
            "name": "Bottanuco",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "B088",
            "cod_istat": "016034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 859,
            "name": "Botticino",
            "provincia": "BS",
            "cap": "25082",
            "cod_catastale": "B091",
            "cod_istat": "017023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 153,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 860,
            "name": "Bottidda",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "B094",
            "cod_istat": "090016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 396,
            "giorni": 1668,
            "area": "",
            "ech": 0
        },
        {
            "id": 861,
            "name": "Bova",
            "provincia": "RC",
            "cap": "89033",
            "cod_catastale": "B097",
            "cod_istat": "080011",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 820,
            "giorni": 2250,
            "area": "",
            "ech": 1
        },
        {
            "id": 862,
            "name": "Bova Marina",
            "provincia": "RC",
            "cap": "89035",
            "cod_catastale": "B099",
            "cod_istat": "080013",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 765,
            "area": "",
            "ech": 1
        },
        {
            "id": 863,
            "name": "Bovalino",
            "provincia": "RC",
            "cap": "89034",
            "cod_catastale": "B098",
            "cod_istat": "080012",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 782,
            "area": "",
            "ech": 1
        },
        {
            "id": 864,
            "name": "Bovegno",
            "provincia": "BS",
            "cap": "25061",
            "cod_catastale": "B100",
            "cod_istat": "017024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 684,
            "giorni": 3187,
            "area": "",
            "ech": 0
        },
        {
            "id": 865,
            "name": "Boves",
            "provincia": "CN",
            "cap": "12012",
            "cod_catastale": "B101",
            "cod_istat": "004028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 3047,
            "area": "",
            "ech": 0
        },
        {
            "id": 866,
            "name": "Bovezzo",
            "provincia": "BS",
            "cap": "25073",
            "cod_catastale": "B102",
            "cod_istat": "017025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2501,
            "area": "",
            "ech": 0
        },
        {
            "id": 867,
            "name": "Boville Ernica",
            "provincia": "FR",
            "cap": "03022",
            "cod_catastale": "A720",
            "cod_istat": "060014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1942,
            "area": "",
            "ech": 0
        },
        {
            "id": 868,
            "name": "Bovino",
            "provincia": "FG",
            "cap": "71023",
            "cod_catastale": "B104",
            "cod_istat": "071007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 620,
            "giorni": 2243,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 869,
            "name": "Bovisio-Masciago",
            "provincia": "MB",
            "cap": "20813",
            "cod_catastale": "B105",
            "cod_istat": "108010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 188,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 870,
            "name": "Bovolenta",
            "provincia": "PD",
            "cap": "35024",
            "cod_catastale": "B106",
            "cod_istat": "028014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 871,
            "name": "Bovolone",
            "provincia": "VR",
            "cap": "37051",
            "cod_catastale": "B107",
            "cod_istat": "023012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2336,
            "area": "",
            "ech": 0
        },
        {
            "id": 872,
            "name": "Bozzole",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "B109",
            "cod_istat": "006023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 873,
            "name": "Bozzolo",
            "provincia": "MN",
            "cap": "46012",
            "cod_catastale": "B110",
            "cod_istat": "020007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 874,
            "name": "Bra",
            "provincia": "CN",
            "cap": "12042",
            "cod_catastale": "B111",
            "cod_istat": "004029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 875,
            "name": "Bracca",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "B112",
            "cod_istat": "016035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 2980,
            "area": "",
            "ech": 0
        },
        {
            "id": 876,
            "name": "Bracciano",
            "provincia": "RM",
            "cap": "00062",
            "cod_catastale": "B114",
            "cod_istat": "058013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1786,
            "area": "",
            "ech": 0
        },
        {
            "id": 877,
            "name": "Bracigliano",
            "provincia": "SA",
            "cap": "84082",
            "cod_catastale": "B115",
            "cod_istat": "065016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 1646,
            "area": "",
            "ech": 0
        },
        {
            "id": 878,
            "name": "Braies",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "B116",
            "cod_istat": "021009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1213,
            "giorni": 4487,
            "area": "",
            "ech": 0
        },
        {
            "id": 879,
            "name": "Brallo di Pregola",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "B117",
            "cod_istat": "018021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 951,
            "giorni": 3772,
            "area": "",
            "ech": 0
        },
        {
            "id": 880,
            "name": "Brancaleone",
            "provincia": "RC",
            "cap": "89036",
            "cod_catastale": "B118",
            "cod_istat": "080014",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 770,
            "area": "",
            "ech": 0
        },
        {
            "id": 881,
            "name": "Brandico",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "B120",
            "cod_istat": "017026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 882,
            "name": "Brandizzo",
            "provincia": "TO",
            "cap": "10032",
            "cod_catastale": "B121",
            "cod_istat": "001034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 883,
            "name": "Branzi",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "B123",
            "cod_istat": "016036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 874,
            "giorni": 3311,
            "area": "",
            "ech": 0
        },
        {
            "id": 884,
            "name": "Braone",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "B124",
            "cod_istat": "017027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2982,
            "area": "",
            "ech": 0
        },
        {
            "id": 885,
            "name": "Brebbia",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B126",
            "cod_istat": "012017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2461,
            "area": "",
            "ech": 0
        },
        {
            "id": 886,
            "name": "Breda di Piave",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "B128",
            "cod_istat": "026005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 887,
            "name": "Bregano",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B131",
            "cod_istat": "012018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2543,
            "area": "",
            "ech": 0
        },
        {
            "id": 888,
            "name": "Breganze",
            "provincia": "VI",
            "cap": "36042",
            "cod_catastale": "B132",
            "cod_istat": "024014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 889,
            "name": "Bregnano",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B134",
            "cod_istat": "013028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 298,
            "giorni": 2553,
            "area": "",
            "ech": 0
        },
        {
            "id": 890,
            "name": "Breguzzo",
            "provincia": "TN",
            "cap": "38081",
            "cod_catastale": "B135",
            "cod_istat": "022024",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 798,
            "giorni": 3636,
            "area": "",
            "ech": 0
        },
        {
            "id": 891,
            "name": "Breia",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "B136",
            "cod_istat": "002019",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 809,
            "giorni": 3356,
            "area": "",
            "ech": 0
        },
        {
            "id": 892,
            "name": "Brembate",
            "provincia": "BG",
            "cap": "24041",
            "cod_catastale": "B137",
            "cod_istat": "016037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 893,
            "name": "Brembate di Sopra",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "B138",
            "cod_istat": "016038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 894,
            "name": "Brembilla",
            "provincia": "BG",
            "cap": "24012",
            "cod_catastale": "B140",
            "cod_istat": "016253",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2775,
            "area": "",
            "ech": 0
        },
        {
            "id": 895,
            "name": "Brembio",
            "provincia": "LO",
            "cap": "26822",
            "cod_catastale": "B141",
            "cod_istat": "098006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 896,
            "name": "Breme",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "B142",
            "cod_istat": "018022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 897,
            "name": "Brendola",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "B143",
            "cod_istat": "024015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 898,
            "name": "Brenna",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "B144",
            "cod_istat": "013029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 899,
            "name": "Brennero",
            "provincia": "BZ",
            "cap": "39041",
            "cod_catastale": "B145",
            "cod_istat": "021010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1098,
            "giorni": 4210,
            "area": "",
            "ech": 0
        },
        {
            "id": 900,
            "name": "Breno",
            "provincia": "BS",
            "cap": "25043",
            "cod_catastale": "B149",
            "cod_istat": "017028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 3425,
            "area": "",
            "ech": 0
        },
        {
            "id": 901,
            "name": "Brenta",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B150",
            "cod_istat": "012019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2531,
            "area": "",
            "ech": 0
        },
        {
            "id": 902,
            "name": "Brentino Belluno",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "B152",
            "cod_istat": "023013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 2520,
            "area": "",
            "ech": 0
        },
        {
            "id": 903,
            "name": "Brentonico",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "B153",
            "cod_istat": "022025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 692,
            "giorni": 3470,
            "area": "",
            "ech": 0
        },
        {
            "id": 904,
            "name": "Brenzone sul Garda",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "B154",
            "cod_istat": "023014",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 905,
            "name": "Brescello",
            "provincia": "RE",
            "cap": "42041",
            "cod_catastale": "B156",
            "cod_istat": "035006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 906,
            "name": "Brescia",
            "provincia": "BS",
            "cap": "251xx",
            "cod_catastale": "B157",
            "cod_istat": "017029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 907,
            "name": "Bresimo",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "B158",
            "cod_istat": "022026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1036,
            "giorni": 4007,
            "area": "",
            "ech": 0
        },
        {
            "id": 908,
            "name": "Bressana Bottarone",
            "provincia": "PV",
            "cap": "27042",
            "cod_catastale": "B159",
            "cod_istat": "018023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 909,
            "name": "Bressanone",
            "provincia": "BZ",
            "cap": "39042",
            "cod_catastale": "B160",
            "cod_istat": "021011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 559,
            "giorni": 3507,
            "area": "",
            "ech": 0
        },
        {
            "id": 910,
            "name": "Bressanvido",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "B161",
            "cod_istat": "024016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 911,
            "name": "Bresso",
            "provincia": "MI",
            "cap": "20091",
            "cod_catastale": "B162",
            "cod_istat": "015032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 912,
            "name": "Brez",
            "provincia": "TN",
            "cap": "38021",
            "cod_catastale": "B165",
            "cod_istat": "022027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 792,
            "giorni": 3626,
            "area": "",
            "ech": 0
        },
        {
            "id": 913,
            "name": "Brezzo di Bedero",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "B166",
            "cod_istat": "012020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 2668,
            "area": "",
            "ech": 0
        },
        {
            "id": 914,
            "name": "Briaglia",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "B167",
            "cod_istat": "004030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 546,
            "giorni": 2827,
            "area": "",
            "ech": 0
        },
        {
            "id": 915,
            "name": "Briatico",
            "provincia": "VV",
            "cap": "89817",
            "cod_catastale": "B169",
            "cod_istat": "102003",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 891,
            "area": "",
            "ech": 0
        },
        {
            "id": 916,
            "name": "Bricherasio",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "B171",
            "cod_istat": "001035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2847,
            "area": "",
            "ech": 0
        },
        {
            "id": 917,
            "name": "Brienno",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "B172",
            "cod_istat": "013030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2358,
            "area": "",
            "ech": 0
        },
        {
            "id": 918,
            "name": "Brienza",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "B173",
            "cod_istat": "076013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 713,
            "giorni": 2206,
            "area": "",
            "ech": 0
        },
        {
            "id": 919,
            "name": "Briga Alta",
            "provincia": "CN",
            "cap": "18025",
            "cod_catastale": "B175",
            "cod_istat": "004031",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1310,
            "giorni": 3939,
            "area": "",
            "ech": 0
        },
        {
            "id": 920,
            "name": "Briga Novarese",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "B176",
            "cod_istat": "003026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2753,
            "area": "",
            "ech": 0
        },
        {
            "id": 921,
            "name": "Brignano Gera d'Adda",
            "provincia": "BG",
            "cap": "24053",
            "cod_catastale": "B178",
            "cod_istat": "016040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 922,
            "name": "Brignano-Frascata",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "B179",
            "cod_istat": "006024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 2724,
            "area": "",
            "ech": 0
        },
        {
            "id": 923,
            "name": "Brindisi",
            "provincia": "BR",
            "cap": "72100",
            "cod_catastale": "B180",
            "cod_istat": "074001",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 1083,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 924,
            "name": "Brindisi Montagna",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "B181",
            "cod_istat": "076014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 925,
            "name": "Brinzio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B182",
            "cod_istat": "012021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 2751,
            "area": "",
            "ech": 0
        },
        {
            "id": 926,
            "name": "Briona",
            "provincia": "NO",
            "cap": "28072",
            "cod_catastale": "B183",
            "cod_istat": "003027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2571,
            "area": "",
            "ech": 0
        },
        {
            "id": 927,
            "name": "Brione",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "B184",
            "cod_istat": "017030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 614,
            "giorni": 3087,
            "area": "",
            "ech": 0
        },
        {
            "id": 928,
            "name": "Brione",
            "provincia": "TN",
            "cap": "38083",
            "cod_catastale": "B185",
            "cod_istat": "022028",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 893,
            "giorni": 3784,
            "area": "",
            "ech": 0
        },
        {
            "id": 929,
            "name": "Briosco",
            "provincia": "MB",
            "cap": "20836",
            "cod_catastale": "B187",
            "cod_istat": "108011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 930,
            "name": "Brisighella",
            "provincia": "RA",
            "cap": "48013",
            "cod_catastale": "B188",
            "cod_istat": "039004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 931,
            "name": "Brissago-Valtravaglia",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B191",
            "cod_istat": "012022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2772,
            "area": "",
            "ech": 0
        },
        {
            "id": 932,
            "name": "Brissogne",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "B192",
            "cod_istat": "007011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 839,
            "giorni": 3516,
            "area": "",
            "ech": 0
        },
        {
            "id": 933,
            "name": "Brittoli",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "B193",
            "cod_istat": "068004",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 779,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 934,
            "name": "Brivio",
            "provincia": "LC",
            "cap": "23883",
            "cod_catastale": "B194",
            "cod_istat": "097010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 935,
            "name": "Broccostella",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "B195",
            "cod_istat": "060015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2138,
            "area": "",
            "ech": 0
        },
        {
            "id": 936,
            "name": "Brogliano",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "B196",
            "cod_istat": "024017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 937,
            "name": "Brognaturo",
            "provincia": "VV",
            "cap": "89822",
            "cod_catastale": "B197",
            "cod_istat": "102004",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 755,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 938,
            "name": "Brolo",
            "provincia": "ME",
            "cap": "98061",
            "cod_catastale": "B198",
            "cod_istat": "083007",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 640,
            "area": "",
            "ech": 1
        },
        {
            "id": 939,
            "name": "Brondello",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "B200",
            "cod_istat": "004032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 467,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 940,
            "name": "Broni",
            "provincia": "PV",
            "cap": "27043",
            "cod_catastale": "B201",
            "cod_istat": "018024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 941,
            "name": "Bronte",
            "provincia": "CT",
            "cap": "95034",
            "cod_catastale": "B202",
            "cod_istat": "087009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 1648,
            "area": "",
            "ech": 1
        },
        {
            "id": 942,
            "name": "Bronzolo",
            "provincia": "BZ",
            "cap": "39051",
            "cod_catastale": "B203",
            "cod_istat": "021012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 238,
            "giorni": 2925,
            "area": "",
            "ech": 0
        },
        {
            "id": 943,
            "name": "Brossasco",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "B204",
            "cod_istat": "004033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 606,
            "giorni": 3067,
            "area": "",
            "ech": 0
        },
        {
            "id": 944,
            "name": "Brosso",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B205",
            "cod_istat": "001036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 797,
            "giorni": 3420,
            "area": "",
            "ech": 0
        },
        {
            "id": 945,
            "name": "Brovello-Carpugnino",
            "provincia": "VB",
            "cap": "28833",
            "cod_catastale": "B207",
            "cod_istat": "103013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 2883,
            "area": "",
            "ech": 0
        },
        {
            "id": 946,
            "name": "Brozolo",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "B209",
            "cod_istat": "001037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 947,
            "name": "Brugherio",
            "provincia": "MB",
            "cap": "20861",
            "cod_catastale": "B212",
            "cod_istat": "108012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 2404,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 948,
            "name": "Brugine",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "B213",
            "cod_istat": "028015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 949,
            "name": "Brugnato",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "B214",
            "cod_istat": "011007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 1663,
            "area": "",
            "ech": 0
        },
        {
            "id": 950,
            "name": "Brugnera",
            "provincia": "PN",
            "cap": "33070",
            "cod_catastale": "B215",
            "cod_istat": "093007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2445,
            "area": "",
            "ech": 0
        },
        {
            "id": 951,
            "name": "Bruino",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "B216",
            "cod_istat": "001038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2834,
            "area": "",
            "ech": 0
        },
        {
            "id": 952,
            "name": "Brumano",
            "provincia": "BG",
            "cap": "24037",
            "cod_catastale": "B217",
            "cod_istat": "016041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 911,
            "giorni": 3363,
            "area": "",
            "ech": 0
        },
        {
            "id": 953,
            "name": "Brunate",
            "provincia": "CO",
            "cap": "22034",
            "cod_catastale": "B218",
            "cod_istat": "013032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 715,
            "giorni": 3085,
            "area": "",
            "ech": 0
        },
        {
            "id": 954,
            "name": "Brunello",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B219",
            "cod_istat": "012023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 411,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 955,
            "name": "Brunico",
            "provincia": "BZ",
            "cap": "39031",
            "cod_catastale": "B220",
            "cod_istat": "021013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 838,
            "giorni": 3867,
            "area": "",
            "ech": 0
        },
        {
            "id": 956,
            "name": "Bruno",
            "provincia": "AT",
            "cap": "14046",
            "cod_catastale": "B221",
            "cod_istat": "005010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 957,
            "name": "Brusaporto",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B223",
            "cod_istat": "016042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 958,
            "name": "Brusasco",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "B225",
            "cod_istat": "001039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2609,
            "area": "",
            "ech": 0
        },
        {
            "id": 959,
            "name": "Brusciano",
            "provincia": "NA",
            "cap": "80031",
            "cod_catastale": "B227",
            "cod_istat": "063010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 1009,
            "area": "",
            "ech": 0
        },
        {
            "id": 960,
            "name": "Brusimpiano",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "B228",
            "cod_istat": "012024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 961,
            "name": "Brusnengo",
            "provincia": "BI",
            "cap": "13862",
            "cod_catastale": "B229",
            "cod_istat": "096007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 962,
            "name": "Brusson",
            "provincia": "AO",
            "cap": "11022",
            "cod_catastale": "B230",
            "cod_istat": "007012",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1338,
            "giorni": 4453,
            "area": "",
            "ech": 0
        },
        {
            "id": 963,
            "name": "Bruzolo",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "B232",
            "cod_istat": "001040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 455,
            "giorni": 3036,
            "area": "",
            "ech": 0
        },
        {
            "id": 964,
            "name": "Bruzzano Zeffirio",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "B234",
            "cod_istat": "080015",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 710,
            "area": "",
            "ech": 1
        },
        {
            "id": 965,
            "name": "Bubbiano",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "B235",
            "cod_istat": "015035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 966,
            "name": "Bubbio",
            "provincia": "AT",
            "cap": "14051",
            "cod_catastale": "B236",
            "cod_istat": "005011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2670,
            "area": "",
            "ech": 0
        },
        {
            "id": 967,
            "name": "Buccheri",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "B237",
            "cod_istat": "089003",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 820,
            "giorni": 1720,
            "area": "",
            "ech": 0
        },
        {
            "id": 968,
            "name": "Bucchianico",
            "provincia": "CH",
            "cap": "66011",
            "cod_catastale": "B238",
            "cod_istat": "069008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1753,
            "area": "",
            "ech": 0
        },
        {
            "id": 969,
            "name": "Bucciano",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "B239",
            "cod_istat": "062010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 1573,
            "area": "",
            "ech": 0
        },
        {
            "id": 970,
            "name": "Buccinasco",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "B240",
            "cod_istat": "015036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 971,
            "name": "Buccino",
            "provincia": "SA",
            "cap": "84021",
            "cod_catastale": "B242",
            "cod_istat": "065017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 649,
            "giorni": 2100,
            "area": "",
            "ech": 0
        },
        {
            "id": 972,
            "name": "Bucine",
            "provincia": "AR",
            "cap": "52021",
            "cod_catastale": "B243",
            "cod_istat": "051005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2050,
            "area": "",
            "ech": 0
        },
        {
            "id": 973,
            "name": "Buddusò",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "B246",
            "cod_istat": "090017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2276,
            "area": "",
            "ech": 1
        },
        {
            "id": 974,
            "name": "Budoia",
            "provincia": "PN",
            "cap": "33070",
            "cod_catastale": "B247",
            "cod_istat": "093008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 975,
            "name": "Budoni",
            "provincia": "SS",
            "cap": "07051",
            "cod_catastale": "B248",
            "cod_istat": "090091",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 767,
            "area": "",
            "ech": 1
        },
        {
            "id": 976,
            "name": "Budrio",
            "provincia": "BO",
            "cap": "40054",
            "cod_catastale": "B249",
            "cod_istat": "037008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2194,
            "area": "",
            "ech": 0
        },
        {
            "id": 977,
            "name": "Buggerru",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "B250",
            "cod_istat": "111006",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 851,
            "area": "",
            "ech": 0
        },
        {
            "id": 978,
            "name": "Buggiano",
            "provincia": "PT",
            "cap": "51011",
            "cod_catastale": "B251",
            "cod_istat": "047003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 41,
            "giorni": 1812,
            "area": "",
            "ech": 0
        },
        {
            "id": 979,
            "name": "Buglio in Monte",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "B255",
            "cod_istat": "014010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 577,
            "giorni": 3047,
            "area": "",
            "ech": 0
        },
        {
            "id": 980,
            "name": "Bugnara",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "B256",
            "cod_istat": "066012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 580,
            "giorni": 2327,
            "area": "",
            "ech": 0
        },
        {
            "id": 981,
            "name": "Buguggiate",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B258",
            "cod_istat": "012025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 306,
            "giorni": 2567,
            "area": "",
            "ech": 0
        },
        {
            "id": 982,
            "name": "Buja",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "B259",
            "cod_istat": "030013",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 983,
            "name": "Bulciago",
            "provincia": "LC",
            "cap": "23892",
            "cod_catastale": "B261",
            "cod_istat": "097011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 984,
            "name": "Bulgarograsso",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B262",
            "cod_istat": "013034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 985,
            "name": "Bultei",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "B264",
            "cod_istat": "090018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 509,
            "giorni": 1883,
            "area": "",
            "ech": 0
        },
        {
            "id": 986,
            "name": "Bulzi",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "B265",
            "cod_istat": "090019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 1205,
            "area": "",
            "ech": 0
        },
        {
            "id": 987,
            "name": "Buonabitacolo",
            "provincia": "SA",
            "cap": "84032",
            "cod_catastale": "B266",
            "cod_istat": "065018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 501,
            "giorni": 1772,
            "area": "",
            "ech": 0
        },
        {
            "id": 988,
            "name": "Buonalbergo",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "B267",
            "cod_istat": "062011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 555,
            "giorni": 1975,
            "area": "",
            "ech": 0
        },
        {
            "id": 989,
            "name": "Buonconvento",
            "provincia": "SI",
            "cap": "53022",
            "cod_catastale": "B269",
            "cod_istat": "052003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 1598,
            "area": "",
            "ech": 0
        },
        {
            "id": 990,
            "name": "Buonvicino",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "B270",
            "cod_istat": "078020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1584,
            "area": "",
            "ech": 0
        },
        {
            "id": 991,
            "name": "Burago di Molgora",
            "provincia": "MB",
            "cap": "20875",
            "cod_catastale": "B272",
            "cod_istat": "108013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 992,
            "name": "Burcei",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "B274",
            "cod_istat": "111007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 1950,
            "area": "",
            "ech": 0
        },
        {
            "id": 993,
            "name": "Burgio",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "B275",
            "cod_istat": "084005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 1002,
            "area": "",
            "ech": 1
        },
        {
            "id": 994,
            "name": "Burgos",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "B276",
            "cod_istat": "090020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 561,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 995,
            "name": "Buriasco",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "B278",
            "cod_istat": "001041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2726,
            "area": "",
            "ech": 0
        },
        {
            "id": 996,
            "name": "Burolo",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "B279",
            "cod_istat": "001042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2771,
            "area": "",
            "ech": 0
        },
        {
            "id": 997,
            "name": "Buronzo",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "B280",
            "cod_istat": "002021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2550,
            "area": "",
            "ech": 0
        },
        {
            "id": 998,
            "name": "Busachi",
            "provincia": "OR",
            "cap": "09082",
            "cod_catastale": "B281",
            "cod_istat": "095017",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 379,
            "giorni": 1387,
            "area": "",
            "ech": 0
        },
        {
            "id": 999,
            "name": "Busalla",
            "provincia": "GE",
            "cap": "16012",
            "cod_catastale": "B282",
            "cod_istat": "010006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 1000,
            "name": "Busana",
            "provincia": "RE",
            "cap": "42032",
            "cod_catastale": "B283",
            "cod_istat": "035007",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 855,
            "giorni": 3235,
            "area": "",
            "ech": 0
        },
        {
            "id": 1001,
            "name": "Busano",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B284",
            "cod_istat": "001043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 1002,
            "name": "Busca",
            "provincia": "CN",
            "cap": "12022",
            "cod_catastale": "B285",
            "cod_istat": "004034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2935,
            "area": "",
            "ech": 0
        },
        {
            "id": 1003,
            "name": "Buscate",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "B286",
            "cod_istat": "015038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 178,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 1004,
            "name": "Buscemi",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "B287",
            "cod_istat": "089004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 761,
            "giorni": 1652,
            "area": "",
            "ech": 0
        },
        {
            "id": 1005,
            "name": "Buseto Palizzolo",
            "provincia": "TP",
            "cap": "91012",
            "cod_catastale": "B288",
            "cod_istat": "081002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 1086,
            "area": "",
            "ech": 0
        },
        {
            "id": 1006,
            "name": "Busnago",
            "provincia": "MB",
            "cap": "20874",
            "cod_catastale": "B289",
            "cod_istat": "108051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 1007,
            "name": "Bussero",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "B292",
            "cod_istat": "015040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1008,
            "name": "Busseto",
            "provincia": "PR",
            "cap": "43011",
            "cod_catastale": "B293",
            "cod_istat": "034007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2508,
            "area": "",
            "ech": 0
        },
        {
            "id": 1009,
            "name": "Bussi sul Tirino",
            "provincia": "PE",
            "cap": "65022",
            "cod_catastale": "B294",
            "cod_istat": "068005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 1789,
            "area": "",
            "ech": 0
        },
        {
            "id": 1010,
            "name": "Busso",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "B295",
            "cod_istat": "070005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 756,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 1011,
            "name": "Bussolengo",
            "provincia": "VR",
            "cap": "37012",
            "cod_catastale": "B296",
            "cod_istat": "023015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 1012,
            "name": "Bussoleno",
            "provincia": "TO",
            "cap": "10053",
            "cod_catastale": "B297",
            "cod_istat": "001044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 440,
            "giorni": 3014,
            "area": "",
            "ech": 0
        },
        {
            "id": 1013,
            "name": "Busto Arsizio",
            "provincia": "VA",
            "cap": "21052",
            "cod_catastale": "B300",
            "cod_istat": "012026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2861,
            "area": "",
            "ech": 0
        },
        {
            "id": 1014,
            "name": "Busto Garolfo",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "B301",
            "cod_istat": "015041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 1015,
            "name": "Butera",
            "provincia": "CL",
            "cap": "93011",
            "cod_catastale": "B302",
            "cod_istat": "085003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 1271,
            "area": "",
            "ech": 1
        },
        {
            "id": 1016,
            "name": "Buti",
            "provincia": "PI",
            "cap": "56032",
            "cod_catastale": "B303",
            "cod_istat": "050002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 1017,
            "name": "Buttapietra",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "B304",
            "cod_istat": "023016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 1018,
            "name": "Buttigliera Alta",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "B305",
            "cod_istat": "001045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2975,
            "area": "",
            "ech": 0
        },
        {
            "id": 1019,
            "name": "Buttigliera d'Asti",
            "provincia": "AT",
            "cap": "14021",
            "cod_catastale": "B306",
            "cod_istat": "005012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2733,
            "area": "",
            "ech": 0
        },
        {
            "id": 1020,
            "name": "Buttrio",
            "provincia": "UD",
            "cap": "33042",
            "cod_catastale": "B309",
            "cod_istat": "030014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 1021,
            "name": "Ca' d'Andrea",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "B320",
            "cod_istat": "019008",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1022,
            "name": "Cabella Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B311",
            "cod_istat": "006025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 2911,
            "area": "",
            "ech": 0
        },
        {
            "id": 1023,
            "name": "Cabiate",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "B313",
            "cod_istat": "013035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2406,
            "area": "",
            "ech": 0
        },
        {
            "id": 1024,
            "name": "Cabras",
            "provincia": "OR",
            "cap": "09072",
            "cod_catastale": "B314",
            "cod_istat": "095018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1143,
            "area": "",
            "ech": 0
        },
        {
            "id": 1025,
            "name": "Caccamo",
            "provincia": "PA",
            "cap": "90012",
            "cod_catastale": "B315",
            "cod_istat": "082014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 1531,
            "area": "",
            "ech": 0
        },
        {
            "id": 1026,
            "name": "Caccuri",
            "provincia": "KR",
            "cap": "88833",
            "cod_catastale": "B319",
            "cod_istat": "101002",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 646,
            "giorni": 2094,
            "area": "",
            "ech": 0
        },
        {
            "id": 1027,
            "name": "Cadegliano-Viconago",
            "provincia": "VA",
            "cap": "21031",
            "cod_catastale": "B326",
            "cod_istat": "012027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2705,
            "area": "",
            "ech": 0
        },
        {
            "id": 1028,
            "name": "Cadelbosco di Sopra",
            "provincia": "RE",
            "cap": "42023",
            "cod_catastale": "B328",
            "cod_istat": "035008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 1029,
            "name": "Cadeo",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "B332",
            "cod_istat": "033007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 1030,
            "name": "Caderzone Terme",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "B335",
            "cod_istat": "022029",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1031,
            "name": "Cadoneghe",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "B345",
            "cod_istat": "028016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1032,
            "name": "Cadorago",
            "provincia": "CO",
            "cap": "22071",
            "cod_catastale": "B346",
            "cod_istat": "013036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 1033,
            "name": "Cadrezzate",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B347",
            "cod_istat": "012143",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 1034,
            "name": "Caerano di San Marco",
            "provincia": "TV",
            "cap": "31031",
            "cod_catastale": "B349",
            "cod_istat": "026006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 1035,
            "name": "Cafasse",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "B350",
            "cod_istat": "001046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 3039,
            "area": "",
            "ech": 0
        },
        {
            "id": 1036,
            "name": "Caggiano",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "B351",
            "cod_istat": "065019",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 828,
            "giorni": 1772,
            "area": "",
            "ech": 0
        },
        {
            "id": 1037,
            "name": "Cagli",
            "provincia": "PU",
            "cap": "61043",
            "cod_catastale": "B352",
            "cod_istat": "041007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2295,
            "area": "",
            "ech": 0
        },
        {
            "id": 1038,
            "name": "Cagliari",
            "provincia": "CA",
            "cap": "091xx",
            "cod_catastale": "B354",
            "cod_istat": "092009",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 6,
            "giorni": 990,
            "area": "",
            "ech": 1
        },
        {
            "id": 1039,
            "name": "Caglio",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "B355",
            "cod_istat": "013037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 1040,
            "name": "Cagnano Amiterno",
            "provincia": "AQ",
            "cap": "67012",
            "cod_catastale": "B358",
            "cod_istat": "066013",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 841,
            "giorni": 2754,
            "area": "",
            "ech": 0
        },
        {
            "id": 1041,
            "name": "Cagnano Varano",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "B357",
            "cod_istat": "071008",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 165,
            "giorni": 1396,
            "area": "",
            "ech": 0
        },
        {
            "id": 1042,
            "name": "Cagno",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B359",
            "cod_istat": "013038",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2705,
            "area": "",
            "ech": 0
        },
        {
            "id": 1043,
            "name": "Cagnò",
            "provincia": "TN",
            "cap": "38028",
            "cod_catastale": "B360",
            "cod_istat": "022030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 663,
            "giorni": 3273,
            "area": "",
            "ech": 0
        },
        {
            "id": 1044,
            "name": "Caianello",
            "provincia": "CE",
            "cap": "81059",
            "cod_catastale": "B361",
            "cod_istat": "061008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 236,
            "giorni": 1521,
            "area": "",
            "ech": 0
        },
        {
            "id": 1045,
            "name": "Caiazzo",
            "provincia": "CE",
            "cap": "81013",
            "cod_catastale": "B362",
            "cod_istat": "061009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1446,
            "area": "",
            "ech": 0
        },
        {
            "id": 1046,
            "name": "Caines",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "B364",
            "cod_istat": "021014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 592,
            "giorni": 3304,
            "area": "",
            "ech": 0
        },
        {
            "id": 1047,
            "name": "Caino",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "B365",
            "cod_istat": "017031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2760,
            "area": "",
            "ech": 0
        },
        {
            "id": 1048,
            "name": "Caiolo",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "B366",
            "cod_istat": "014011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 3111,
            "area": "",
            "ech": 0
        },
        {
            "id": 1049,
            "name": "Cairano",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B367",
            "cod_istat": "064013",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 770,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 1050,
            "name": "Cairate",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "B368",
            "cod_istat": "012029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 1051,
            "name": "Cairo Montenotte",
            "provincia": "SV",
            "cap": "17014",
            "cod_catastale": "B369",
            "cod_istat": "009015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 338,
            "giorni": 2128,
            "area": "",
            "ech": 0
        },
        {
            "id": 1052,
            "name": "Caivano",
            "provincia": "NA",
            "cap": "80023",
            "cod_catastale": "B371",
            "cod_istat": "063011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 1090,
            "area": "",
            "ech": 0
        },
        {
            "id": 1053,
            "name": "Calabritto",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B374",
            "cod_istat": "064014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 480,
            "giorni": 1806,
            "area": "",
            "ech": 0
        },
        {
            "id": 1054,
            "name": "Calalzo di Cadore",
            "provincia": "BL",
            "cap": "32042",
            "cod_catastale": "B375",
            "cod_istat": "025008",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 806,
            "giorni": 3899,
            "area": "",
            "ech": 0
        },
        {
            "id": 1055,
            "name": "Calamandrana",
            "provincia": "AT",
            "cap": "14042",
            "cod_catastale": "B376",
            "cod_istat": "005013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 1056,
            "name": "Calamonaci",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "B377",
            "cod_istat": "084006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 988,
            "area": "",
            "ech": 0
        },
        {
            "id": 1057,
            "name": "Calangianus",
            "provincia": "SS",
            "cap": "07023",
            "cod_catastale": "B378",
            "cod_istat": "090021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1854,
            "area": "",
            "ech": 0
        },
        {
            "id": 1058,
            "name": "Calanna",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "B379",
            "cod_istat": "080016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 511,
            "giorni": 1658,
            "area": "",
            "ech": 1
        },
        {
            "id": 1059,
            "name": "Calasca-Castiglione",
            "provincia": "VB",
            "cap": "28873",
            "cod_catastale": "B380",
            "cod_istat": "103014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 665,
            "giorni": 3169,
            "area": "",
            "ech": 0
        },
        {
            "id": 1060,
            "name": "Calascibetta",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "B381",
            "cod_istat": "086005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 691,
            "giorni": 1710,
            "area": "",
            "ech": 0
        },
        {
            "id": 1061,
            "name": "Calascio",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "B382",
            "cod_istat": "066014",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1210,
            "giorni": 3454,
            "area": "",
            "ech": 0
        },
        {
            "id": 1062,
            "name": "Calasetta",
            "provincia": "SU",
            "cap": "09011",
            "cod_catastale": "B383",
            "cod_istat": "111008",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 789,
            "area": "",
            "ech": 0
        },
        {
            "id": 1063,
            "name": "Calatabiano",
            "provincia": "CT",
            "cap": "95011",
            "cod_catastale": "B384",
            "cod_istat": "087010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 913,
            "area": "",
            "ech": 1
        },
        {
            "id": 1064,
            "name": "Calatafimi-Segesta",
            "provincia": "TP",
            "cap": "91013",
            "cod_catastale": "B385",
            "cod_istat": "081003",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1065,
            "name": "Calavino",
            "provincia": "TN",
            "cap": "38072",
            "cod_catastale": "B386",
            "cod_istat": "022031",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 3029,
            "area": "",
            "ech": 0
        },
        {
            "id": 1066,
            "name": "Calcata",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "B388",
            "cod_istat": "056010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 1727,
            "area": "",
            "ech": 0
        },
        {
            "id": 1067,
            "name": "Calceranica al Lago",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "B389",
            "cod_istat": "022032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 1068,
            "name": "Calci",
            "provincia": "PI",
            "cap": "56011",
            "cod_catastale": "B390",
            "cod_istat": "050003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1069,
            "name": "Calciano",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "B391",
            "cod_istat": "077004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 1070,
            "name": "Calcinaia",
            "provincia": "PI",
            "cap": "56012",
            "cod_catastale": "B392",
            "cod_istat": "050004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1864,
            "area": "",
            "ech": 0
        },
        {
            "id": 1071,
            "name": "Calcinate",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "B393",
            "cod_istat": "016043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1072,
            "name": "Calcinato",
            "provincia": "BS",
            "cap": "25011",
            "cod_catastale": "B394",
            "cod_istat": "017032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 1073,
            "name": "Calcio",
            "provincia": "BG",
            "cap": "24054",
            "cod_catastale": "B395",
            "cod_istat": "016044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1074,
            "name": "Calco",
            "provincia": "LC",
            "cap": "23885",
            "cod_catastale": "B396",
            "cod_istat": "097012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 1075,
            "name": "Caldaro sulla strada del vino",
            "provincia": "BZ",
            "cap": "39052",
            "cod_catastale": "B397",
            "cod_istat": "021015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 3074,
            "area": "",
            "ech": 0
        },
        {
            "id": 1076,
            "name": "Caldarola",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "B398",
            "cod_istat": "043006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2007,
            "area": "",
            "ech": 0
        },
        {
            "id": 1077,
            "name": "Calderara di Reno",
            "provincia": "BO",
            "cap": "40012",
            "cod_catastale": "B399",
            "cod_istat": "037009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2225,
            "area": "",
            "ech": 0
        },
        {
            "id": 1078,
            "name": "Caldes",
            "provincia": "TN",
            "cap": "38022",
            "cod_catastale": "B400",
            "cod_istat": "022033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 697,
            "giorni": 3326,
            "area": "",
            "ech": 0
        },
        {
            "id": 1079,
            "name": "Caldiero",
            "provincia": "VR",
            "cap": "37042",
            "cod_catastale": "B402",
            "cod_istat": "023017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 1080,
            "name": "Caldogno",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "B403",
            "cod_istat": "024018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2395,
            "area": "",
            "ech": 0
        },
        {
            "id": 1081,
            "name": "Caldonazzo",
            "provincia": "TN",
            "cap": "38052",
            "cod_catastale": "B404",
            "cod_istat": "022034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 3089,
            "area": "",
            "ech": 0
        },
        {
            "id": 1082,
            "name": "Calendasco",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "B405",
            "cod_istat": "033008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2707,
            "area": "",
            "ech": 0
        },
        {
            "id": 1083,
            "name": "Calenzano",
            "provincia": "FI",
            "cap": "50041",
            "cod_catastale": "B406",
            "cod_istat": "048005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1740,
            "area": "",
            "ech": 0
        },
        {
            "id": 1084,
            "name": "Calestano",
            "provincia": "PR",
            "cap": "43030",
            "cod_catastale": "B408",
            "cod_istat": "034008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2991,
            "area": "",
            "ech": 0
        },
        {
            "id": 1085,
            "name": "Calice al Cornoviglio",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "B410",
            "cod_istat": "011008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 1886,
            "area": "",
            "ech": 0
        },
        {
            "id": 1086,
            "name": "Calice Ligure",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "B409",
            "cod_istat": "009016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1437,
            "area": "",
            "ech": 0
        },
        {
            "id": 1087,
            "name": "Calimera",
            "provincia": "LE",
            "cap": "73021",
            "cod_catastale": "B413",
            "cod_istat": "075010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 1173,
            "area": "",
            "ech": 0
        },
        {
            "id": 1088,
            "name": "Calitri",
            "provincia": "AV",
            "cap": "83045",
            "cod_catastale": "B415",
            "cod_istat": "064015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 1929,
            "area": "",
            "ech": 0
        },
        {
            "id": 1089,
            "name": "Calizzano",
            "provincia": "SV",
            "cap": "17057",
            "cod_catastale": "B416",
            "cod_istat": "009017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 647,
            "giorni": 2927,
            "area": "",
            "ech": 0
        },
        {
            "id": 1090,
            "name": "Callabiana",
            "provincia": "BI",
            "cap": "13821",
            "cod_catastale": "B417",
            "cod_istat": "096008",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 743,
            "giorni": 3253,
            "area": "",
            "ech": 0
        },
        {
            "id": 1091,
            "name": "Calliano",
            "provincia": "AT",
            "cap": "14031",
            "cod_catastale": "B418",
            "cod_istat": "005014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2699,
            "area": "",
            "ech": 0
        },
        {
            "id": 1092,
            "name": "Calliano",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "B419",
            "cod_istat": "022035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2686,
            "area": "",
            "ech": 0
        },
        {
            "id": 1093,
            "name": "Calolziocorte",
            "provincia": "LC",
            "cap": "23801",
            "cod_catastale": "B423",
            "cod_istat": "097013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2412,
            "area": "",
            "ech": 0
        },
        {
            "id": 1094,
            "name": "Calopezzati",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "B424",
            "cod_istat": "078021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 1137,
            "area": "",
            "ech": 0
        },
        {
            "id": 1095,
            "name": "Calosso",
            "provincia": "AT",
            "cap": "14052",
            "cod_catastale": "B425",
            "cod_istat": "005015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 399,
            "giorni": 2817,
            "area": "",
            "ech": 0
        },
        {
            "id": 1096,
            "name": "Caloveto",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "B426",
            "cod_istat": "078022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 385,
            "giorni": 1604,
            "area": "",
            "ech": 0
        },
        {
            "id": 1097,
            "name": "Caltabellotta",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "B427",
            "cod_istat": "084007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 949,
            "giorni": 1949,
            "area": "",
            "ech": 0
        },
        {
            "id": 1098,
            "name": "Caltagirone",
            "provincia": "CT",
            "cap": "95041",
            "cod_catastale": "B428",
            "cod_istat": "087011",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 608,
            "giorni": 1398,
            "area": "",
            "ech": 1
        },
        {
            "id": 1099,
            "name": "Caltanissetta",
            "provincia": "CL",
            "cap": "93100",
            "cod_catastale": "B429",
            "cod_istat": "085004",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 568,
            "giorni": 1550,
            "area": "",
            "ech": 1
        },
        {
            "id": 1100,
            "name": "Caltavuturo",
            "provincia": "PA",
            "cap": "90022",
            "cod_catastale": "B430",
            "cod_istat": "082015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 635,
            "giorni": 1664,
            "area": "",
            "ech": 0
        },
        {
            "id": 1101,
            "name": "Caltignaga",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "B431",
            "cod_istat": "003030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 178,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 1102,
            "name": "Calto",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "B432",
            "cod_istat": "029008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1103,
            "name": "Caltrano",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "B433",
            "cod_istat": "024019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2678,
            "area": "",
            "ech": 0
        },
        {
            "id": 1104,
            "name": "Calusco d'Adda",
            "provincia": "BG",
            "cap": "24033",
            "cod_catastale": "B434",
            "cod_istat": "016046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 1105,
            "name": "Caluso",
            "provincia": "TO",
            "cap": "10014",
            "cod_catastale": "B435",
            "cod_istat": "001047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2808,
            "area": "",
            "ech": 0
        },
        {
            "id": 1106,
            "name": "Calvagese della Riviera",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "B436",
            "cod_istat": "017033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 1107,
            "name": "Calvanico",
            "provincia": "SA",
            "cap": "84080",
            "cod_catastale": "B437",
            "cod_istat": "065020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1669,
            "area": "",
            "ech": 0
        },
        {
            "id": 1108,
            "name": "Calvatone",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "B439",
            "cod_istat": "019009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 1109,
            "name": "Calvello",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "B440",
            "cod_istat": "076015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2237,
            "area": "",
            "ech": 0
        },
        {
            "id": 1110,
            "name": "Calvene",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "B441",
            "cod_istat": "024020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2621,
            "area": "",
            "ech": 0
        },
        {
            "id": 1111,
            "name": "Calvenzano",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "B442",
            "cod_istat": "016047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1112,
            "name": "Calvera",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "B443",
            "cod_istat": "076016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2055,
            "area": "",
            "ech": 0
        },
        {
            "id": 1113,
            "name": "Calvi",
            "provincia": "BN",
            "cap": "82018",
            "cod_catastale": "B444",
            "cod_istat": "062012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 376,
            "giorni": 1755,
            "area": "",
            "ech": 0
        },
        {
            "id": 1114,
            "name": "Calvi dell'Umbria",
            "provincia": "TR",
            "cap": "05032",
            "cod_catastale": "B446",
            "cod_istat": "055008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 401,
            "giorni": 2095,
            "area": "",
            "ech": 0
        },
        {
            "id": 1115,
            "name": "Calvi Risorta",
            "provincia": "CE",
            "cap": "81042",
            "cod_catastale": "B445",
            "cod_istat": "061010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 1257,
            "area": "",
            "ech": 0
        },
        {
            "id": 1116,
            "name": "Calvignano",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B447",
            "cod_istat": "018025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2973,
            "area": "",
            "ech": 0
        },
        {
            "id": 1117,
            "name": "Calvignasco",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "B448",
            "cod_istat": "015042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 1118,
            "name": "Calvisano",
            "provincia": "BS",
            "cap": "25012",
            "cod_catastale": "B450",
            "cod_istat": "017034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1119,
            "name": "Calvizzano",
            "provincia": "NA",
            "cap": "80012",
            "cod_catastale": "B452",
            "cod_istat": "063012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 1191,
            "area": "",
            "ech": 0
        },
        {
            "id": 1120,
            "name": "Camagna Monferrato",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "B453",
            "cod_istat": "006026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 1121,
            "name": "Camaiore",
            "provincia": "LU",
            "cap": "55041",
            "cod_catastale": "B455",
            "cod_istat": "046005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1485,
            "area": "",
            "ech": 0
        },
        {
            "id": 1122,
            "name": "Camairago",
            "provincia": "LO",
            "cap": "26823",
            "cod_catastale": "B456",
            "cod_istat": "098007",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 1123,
            "name": "Camandona",
            "provincia": "BI",
            "cap": "13821",
            "cod_catastale": "B457",
            "cod_istat": "096009",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 792,
            "giorni": 3334,
            "area": "",
            "ech": 0
        },
        {
            "id": 1124,
            "name": "Camastra",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "B460",
            "cod_istat": "084008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 1078,
            "area": "",
            "ech": 1
        },
        {
            "id": 1125,
            "name": "Cambiago",
            "provincia": "MI",
            "cap": "20040",
            "cod_catastale": "B461",
            "cod_istat": "015044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 1126,
            "name": "Cambiano",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "B462",
            "cod_istat": "001048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 1127,
            "name": "Cambiasca",
            "provincia": "VB",
            "cap": "28814",
            "cod_catastale": "B463",
            "cod_istat": "103015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 1128,
            "name": "Camburzano",
            "provincia": "BI",
            "cap": "13891",
            "cod_catastale": "B465",
            "cod_istat": "096010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 419,
            "giorni": 2588,
            "area": "",
            "ech": 0
        },
        {
            "id": 1129,
            "name": "Camerana",
            "provincia": "CN",
            "cap": "12072",
            "cod_catastale": "B467",
            "cod_istat": "004035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 2966,
            "area": "",
            "ech": 0
        },
        {
            "id": 1130,
            "name": "Camerano",
            "provincia": "AN",
            "cap": "60021",
            "cod_catastale": "B468",
            "cod_istat": "042006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 1969,
            "area": "",
            "ech": 0
        },
        {
            "id": 1131,
            "name": "Camerano Casasco",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "B469",
            "cod_istat": "005016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 1132,
            "name": "Camerata Cornello",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "B471",
            "cod_istat": "016048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 1133,
            "name": "Camerata Nuova",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "B472",
            "cod_istat": "058014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 810,
            "giorni": 2921,
            "area": "",
            "ech": 0
        },
        {
            "id": 1134,
            "name": "Camerata Picena",
            "provincia": "AN",
            "cap": "60020",
            "cod_catastale": "B470",
            "cod_istat": "042007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1882,
            "area": "",
            "ech": 0
        },
        {
            "id": 1135,
            "name": "Cameri",
            "provincia": "NO",
            "cap": "28062",
            "cod_catastale": "B473",
            "cod_istat": "003032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 1136,
            "name": "Camerino",
            "provincia": "MC",
            "cap": "62032",
            "cod_catastale": "B474",
            "cod_istat": "043007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 661,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 1137,
            "name": "Camerota",
            "provincia": "SA",
            "cap": "84059",
            "cod_catastale": "B476",
            "cod_istat": "065021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 322,
            "giorni": 1447,
            "area": "",
            "ech": 0
        },
        {
            "id": 1138,
            "name": "Camigliano",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "B477",
            "cod_istat": "061011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 1139,
            "name": "Caminata",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "B479",
            "cod_istat": "033009",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2816,
            "area": "",
            "ech": 0
        },
        {
            "id": 1140,
            "name": "Camini",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "B481",
            "cod_istat": "080017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1091,
            "area": "",
            "ech": 0
        },
        {
            "id": 1141,
            "name": "Camino",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "B482",
            "cod_istat": "006027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 1142,
            "name": "Camino al Tagliamento",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "B483",
            "cod_istat": "030015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 1143,
            "name": "Camisano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B484",
            "cod_istat": "019010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1144,
            "name": "Camisano Vicentino",
            "provincia": "VI",
            "cap": "36043",
            "cod_catastale": "B485",
            "cod_istat": "024021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2277,
            "area": "",
            "ech": 0
        },
        {
            "id": 1145,
            "name": "Cammarata",
            "provincia": "AG",
            "cap": "92022",
            "cod_catastale": "B486",
            "cod_istat": "084009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 682,
            "giorni": 1605,
            "area": "",
            "ech": 0
        },
        {
            "id": 1146,
            "name": "Camo",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "B489",
            "cod_istat": "004036",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 471,
            "giorni": 2899,
            "area": "",
            "ech": 0
        },
        {
            "id": 1147,
            "name": "Camogli",
            "provincia": "GE",
            "cap": "16032",
            "cod_catastale": "B490",
            "cod_istat": "010007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 1531,
            "area": "",
            "ech": 0
        },
        {
            "id": 1148,
            "name": "Campagna",
            "provincia": "SA",
            "cap": "84022",
            "cod_catastale": "B492",
            "cod_istat": "065022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 410,
            "giorni": 1557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1149,
            "name": "Campagna Lupia",
            "provincia": "VE",
            "cap": "30010",
            "cod_catastale": "B493",
            "cod_istat": "027002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1150,
            "name": "Campagnano di Roma",
            "provincia": "RM",
            "cap": "00063",
            "cod_catastale": "B496",
            "cod_istat": "058015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 1151,
            "name": "Campagnatico",
            "provincia": "GR",
            "cap": "58042",
            "cod_catastale": "B497",
            "cod_istat": "053002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1903,
            "area": "",
            "ech": 0
        },
        {
            "id": 1152,
            "name": "Campagnola Cremasca",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B498",
            "cod_istat": "019011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1153,
            "name": "Campagnola Emilia",
            "provincia": "RE",
            "cap": "42012",
            "cod_catastale": "B499",
            "cod_istat": "035009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2508,
            "area": "",
            "ech": 0
        },
        {
            "id": 1154,
            "name": "Campana",
            "provincia": "CS",
            "cap": "87061",
            "cod_catastale": "B500",
            "cod_istat": "078023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 612,
            "giorni": 2030,
            "area": "",
            "ech": 0
        },
        {
            "id": 1155,
            "name": "Camparada",
            "provincia": "MB",
            "cap": "20857",
            "cod_catastale": "B501",
            "cod_istat": "108014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 1156,
            "name": "Campegine",
            "provincia": "RE",
            "cap": "42040",
            "cod_catastale": "B502",
            "cod_istat": "035010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 1157,
            "name": "Campello sul Clitunno",
            "provincia": "PG",
            "cap": "06042",
            "cod_catastale": "B504",
            "cod_istat": "054005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2085,
            "area": "",
            "ech": 0
        },
        {
            "id": 1158,
            "name": "Campertogno",
            "provincia": "VC",
            "cap": "13023",
            "cod_catastale": "B505",
            "cod_istat": "002025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 815,
            "giorni": 3380,
            "area": "",
            "ech": 0
        },
        {
            "id": 1159,
            "name": "Campi Bisenzio",
            "provincia": "FI",
            "cap": "50013",
            "cod_catastale": "B507",
            "cod_istat": "048006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1721,
            "area": "",
            "ech": 0
        },
        {
            "id": 1160,
            "name": "Campi Salentina",
            "provincia": "LE",
            "cap": "73012",
            "cod_catastale": "B506",
            "cod_istat": "075011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 1119,
            "area": "",
            "ech": 0
        },
        {
            "id": 1161,
            "name": "Campiglia Cervo",
            "provincia": "BI",
            "cap": "13812",
            "cod_catastale": "M373",
            "cod_istat": "096086",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 3312,
            "area": "",
            "ech": 0
        },
        {
            "id": 1162,
            "name": "Campiglia dei Berici",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "B511",
            "cod_istat": "024022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2264,
            "area": "",
            "ech": 0
        },
        {
            "id": 1163,
            "name": "Campiglia Marittima",
            "provincia": "LI",
            "cap": "57021",
            "cod_catastale": "B509",
            "cod_istat": "049002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 1865,
            "area": "",
            "ech": 0
        },
        {
            "id": 1164,
            "name": "Campiglione Fenile",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "B512",
            "cod_istat": "001049",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1165,
            "name": "Campione d'Italia",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "B513",
            "cod_istat": "013040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 1166,
            "name": "Campitello di Fassa",
            "provincia": "TN",
            "cap": "38031",
            "cod_catastale": "B514",
            "cod_istat": "022036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1448,
            "giorni": 4892,
            "area": "",
            "ech": 0
        },
        {
            "id": 1167,
            "name": "Campli",
            "provincia": "TE",
            "cap": "64012",
            "cod_catastale": "B515",
            "cod_istat": "067008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 2045,
            "area": "",
            "ech": 0
        },
        {
            "id": 1168,
            "name": "Campo Calabro",
            "provincia": "RC",
            "cap": "89052",
            "cod_catastale": "B516",
            "cod_istat": "080018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 1015,
            "area": "",
            "ech": 0
        },
        {
            "id": 1169,
            "name": "Campo di Giove",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "B526",
            "cod_istat": "066015",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1064,
            "giorni": 3193,
            "area": "",
            "ech": 0
        },
        {
            "id": 1170,
            "name": "Campo di Trens",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "B529",
            "cod_istat": "021016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 937,
            "giorni": 3639,
            "area": "",
            "ech": 0
        },
        {
            "id": 1171,
            "name": "Campo Ligure",
            "provincia": "GE",
            "cap": "16013",
            "cod_catastale": "B538",
            "cod_istat": "010008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2143,
            "area": "",
            "ech": 0
        },
        {
            "id": 1172,
            "name": "Campo nell'Elba",
            "provincia": "LI",
            "cap": "57034",
            "cod_catastale": "B553",
            "cod_istat": "049003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1057,
            "area": "",
            "ech": 0
        },
        {
            "id": 1173,
            "name": "Campo San Martino",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "B564",
            "cod_istat": "028020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 1174,
            "name": "Campo Tures",
            "provincia": "BZ",
            "cap": "39032",
            "cod_catastale": "B570",
            "cod_istat": "021017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 864,
            "giorni": 3913,
            "area": "",
            "ech": 0
        },
        {
            "id": 1175,
            "name": "Campobasso",
            "provincia": "CB",
            "cap": "86100",
            "cod_catastale": "B519",
            "cod_istat": "070006",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 701,
            "giorni": 2346,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1176,
            "name": "Campobello di Licata",
            "provincia": "AG",
            "cap": "92023",
            "cod_catastale": "B520",
            "cod_istat": "084010",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 316,
            "giorni": 1044,
            "area": "",
            "ech": 0
        },
        {
            "id": 1177,
            "name": "Campobello di Mazara",
            "provincia": "TP",
            "cap": "91021",
            "cod_catastale": "B521",
            "cod_istat": "081004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1038,
            "area": "",
            "ech": 1
        },
        {
            "id": 1178,
            "name": "Campochiaro",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "B522",
            "cod_istat": "070007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2345,
            "area": "",
            "ech": 0
        },
        {
            "id": 1179,
            "name": "Campodarsego",
            "provincia": "PD",
            "cap": "35011",
            "cod_catastale": "B524",
            "cod_istat": "028017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1180,
            "name": "Campodenno",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "B525",
            "cod_istat": "022037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 534,
            "giorni": 3224,
            "area": "",
            "ech": 0
        },
        {
            "id": 1181,
            "name": "Campodimele",
            "provincia": "LT",
            "cap": "04020",
            "cod_catastale": "B527",
            "cod_istat": "059003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 647,
            "giorni": 2265,
            "area": "",
            "ech": 0
        },
        {
            "id": 1182,
            "name": "Campodipietra",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "B528",
            "cod_istat": "070008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 1183,
            "name": "Campodolcino",
            "provincia": "SO",
            "cap": "23021",
            "cod_catastale": "B530",
            "cod_istat": "014012",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1071,
            "giorni": 3590,
            "area": "",
            "ech": 0
        },
        {
            "id": 1184,
            "name": "Campodoro",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "B531",
            "cod_istat": "028018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1185,
            "name": "Campofelice di Fitalia",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "B533",
            "cod_istat": "082016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 734,
            "giorni": 1813,
            "area": "",
            "ech": 1
        },
        {
            "id": 1186,
            "name": "Campofelice di Roccella",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "B532",
            "cod_istat": "082017",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 759,
            "area": "",
            "ech": 0
        },
        {
            "id": 1187,
            "name": "Campofilone",
            "provincia": "FM",
            "cap": "63828",
            "cod_catastale": "B534",
            "cod_istat": "109004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 1876,
            "area": "",
            "ech": 0
        },
        {
            "id": 1188,
            "name": "Campofiorito",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "B535",
            "cod_istat": "082018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 666,
            "giorni": 1627,
            "area": "",
            "ech": 0
        },
        {
            "id": 1189,
            "name": "Campoformido",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "B536",
            "cod_istat": "030016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 1190,
            "name": "Campofranco",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "B537",
            "cod_istat": "085005",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 350,
            "giorni": 1192,
            "area": "",
            "ech": 0
        },
        {
            "id": 1191,
            "name": "Campogalliano",
            "provincia": "MO",
            "cap": "41011",
            "cod_catastale": "B539",
            "cod_istat": "036003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 1192,
            "name": "Campolattaro",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "B541",
            "cod_istat": "062013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1853,
            "area": "",
            "ech": 0
        },
        {
            "id": 1193,
            "name": "Campoli Appennino",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "B543",
            "cod_istat": "060016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2374,
            "area": "",
            "ech": 0
        },
        {
            "id": 1194,
            "name": "Campoli del Monte Taburno",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "B542",
            "cod_istat": "062014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 439,
            "giorni": 1869,
            "area": "",
            "ech": 0
        },
        {
            "id": 1195,
            "name": "Campolieto",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "B544",
            "cod_istat": "070009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 735,
            "giorni": 2305,
            "area": "",
            "ech": 0
        },
        {
            "id": 1196,
            "name": "Campolongo Maggiore",
            "provincia": "VE",
            "cap": "30010",
            "cod_catastale": "B546",
            "cod_istat": "027003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2429,
            "area": "",
            "ech": 0
        },
        {
            "id": 1197,
            "name": "Campolongo sul Brenta",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "B547",
            "cod_istat": "024023",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 1198,
            "name": "Campolongo Tapogliano",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "M311",
            "cod_istat": "030138",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1199,
            "name": "Campomaggiore",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "B549",
            "cod_istat": "076017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 795,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1200,
            "name": "Campomarino",
            "provincia": "CB",
            "cap": "86042",
            "cod_catastale": "B550",
            "cod_istat": "070010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 1347,
            "area": "",
            "ech": 0
        },
        {
            "id": 1201,
            "name": "Campomorone",
            "provincia": "GE",
            "cap": "16014",
            "cod_catastale": "B551",
            "cod_istat": "010009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 1867,
            "area": "",
            "ech": 0
        },
        {
            "id": 1202,
            "name": "Camponogara",
            "provincia": "VE",
            "cap": "30010",
            "cod_catastale": "B554",
            "cod_istat": "027004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 1203,
            "name": "Campora",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "B555",
            "cod_istat": "065023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1848,
            "area": "",
            "ech": 0
        },
        {
            "id": 1204,
            "name": "Camporeale",
            "provincia": "PA",
            "cap": "90043",
            "cod_catastale": "B556",
            "cod_istat": "082019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1273,
            "area": "",
            "ech": 0
        },
        {
            "id": 1205,
            "name": "Camporgiano",
            "provincia": "LU",
            "cap": "55031",
            "cod_catastale": "B557",
            "cod_istat": "046006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 1206,
            "name": "Camporosso",
            "provincia": "IM",
            "cap": "18033",
            "cod_catastale": "B559",
            "cod_istat": "008011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1301,
            "area": "",
            "ech": 0
        },
        {
            "id": 1207,
            "name": "Camporotondo di Fiastrone",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "B562",
            "cod_istat": "043008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 2032,
            "area": "",
            "ech": 0
        },
        {
            "id": 1208,
            "name": "Camporotondo Etneo",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "B561",
            "cod_istat": "087012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 1318,
            "area": "",
            "ech": 1
        },
        {
            "id": 1209,
            "name": "Camposampiero",
            "provincia": "PD",
            "cap": "35012",
            "cod_catastale": "B563",
            "cod_istat": "028019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 1210,
            "name": "Camposano",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "B565",
            "cod_istat": "063013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1036,
            "area": "",
            "ech": 0
        },
        {
            "id": 1211,
            "name": "Camposanto",
            "provincia": "MO",
            "cap": "41031",
            "cod_catastale": "B566",
            "cod_istat": "036004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2197,
            "area": "",
            "ech": 0
        },
        {
            "id": 1212,
            "name": "Campospinoso",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B567",
            "cod_istat": "018026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1213,
            "name": "Campotosto",
            "provincia": "AQ",
            "cap": "67013",
            "cod_catastale": "B569",
            "cod_istat": "066016",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1420,
            "giorni": 3807,
            "area": "",
            "ech": 0
        },
        {
            "id": 1214,
            "name": "Camugnano",
            "provincia": "BO",
            "cap": "40032",
            "cod_catastale": "B572",
            "cod_istat": "037010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 692,
            "giorni": 2997,
            "area": "",
            "ech": 0
        },
        {
            "id": 1215,
            "name": "Canal San Bovo",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "B577",
            "cod_istat": "022038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 757,
            "giorni": 3572,
            "area": "",
            "ech": 0
        },
        {
            "id": 1216,
            "name": "Canale",
            "provincia": "CN",
            "cap": "12043",
            "cod_catastale": "B573",
            "cod_istat": "004037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2554,
            "area": "",
            "ech": 0
        },
        {
            "id": 1217,
            "name": "Canale d'Agordo",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "B574",
            "cod_istat": "025023",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 976,
            "giorni": 4055,
            "area": "",
            "ech": 0
        },
        {
            "id": 1218,
            "name": "Canale Monterano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "B576",
            "cod_istat": "058016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 1952,
            "area": "",
            "ech": 0
        },
        {
            "id": 1219,
            "name": "Canaro",
            "provincia": "RO",
            "cap": "45034",
            "cod_catastale": "B578",
            "cod_istat": "029009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1220,
            "name": "Canazei",
            "provincia": "TN",
            "cap": "38032",
            "cod_catastale": "B579",
            "cod_istat": "022039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1465,
            "giorni": 4918,
            "area": "",
            "ech": 0
        },
        {
            "id": 1221,
            "name": "Cancellara",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "B580",
            "cod_istat": "076018",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 680,
            "giorni": 2146,
            "area": "",
            "ech": 0
        },
        {
            "id": 1222,
            "name": "Cancello ed Arnone",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "B581",
            "cod_istat": "061012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 1134,
            "area": "",
            "ech": 0
        },
        {
            "id": 1223,
            "name": "Canda",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "B582",
            "cod_istat": "029010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1224,
            "name": "Candela",
            "provincia": "FG",
            "cap": "71024",
            "cod_catastale": "B584",
            "cod_istat": "071009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 474,
            "giorni": 1986,
            "area": "",
            "ech": 0
        },
        {
            "id": 1225,
            "name": "Candelo",
            "provincia": "BI",
            "cap": "13878",
            "cod_catastale": "B586",
            "cod_istat": "096012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2746,
            "area": "",
            "ech": 0
        },
        {
            "id": 1226,
            "name": "Candia Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "B588",
            "cod_istat": "001050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 1227,
            "name": "Candia Lomellina",
            "provincia": "PV",
            "cap": "27031",
            "cod_catastale": "B587",
            "cod_istat": "018027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 1228,
            "name": "Candiana",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "B589",
            "cod_istat": "028021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 1229,
            "name": "Candida",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B590",
            "cod_istat": "064016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 579,
            "giorni": 2087,
            "area": "",
            "ech": 0
        },
        {
            "id": 1230,
            "name": "Candidoni",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "B591",
            "cod_istat": "080019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 1199,
            "area": "",
            "ech": 0
        },
        {
            "id": 1231,
            "name": "Candiolo",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "B592",
            "cod_istat": "001051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 1232,
            "name": "Canegrate",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "B593",
            "cod_istat": "015046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 1233,
            "name": "Canelli",
            "provincia": "AT",
            "cap": "14053",
            "cod_catastale": "B594",
            "cod_istat": "005017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2540,
            "area": "",
            "ech": 0
        },
        {
            "id": 1234,
            "name": "Canepina",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "B597",
            "cod_istat": "056011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 501,
            "giorni": 2309,
            "area": "",
            "ech": 0
        },
        {
            "id": 1235,
            "name": "Caneva",
            "provincia": "PN",
            "cap": "33070",
            "cod_catastale": "B598",
            "cod_istat": "093009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2451,
            "area": "",
            "ech": 0
        },
        {
            "id": 1236,
            "name": "Canevino",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B599",
            "cod_istat": "018028",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2917,
            "area": "",
            "ech": 0
        },
        {
            "id": 1237,
            "name": "Canicattì",
            "provincia": "AG",
            "cap": "92024",
            "cod_catastale": "B602",
            "cod_istat": "084011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 1418,
            "area": "",
            "ech": 0
        },
        {
            "id": 1238,
            "name": "Canicattini Bagni",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "B603",
            "cod_istat": "089005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 362,
            "giorni": 1193,
            "area": "",
            "ech": 0
        },
        {
            "id": 1239,
            "name": "Canino",
            "provincia": "VT",
            "cap": "01011",
            "cod_catastale": "B604",
            "cod_istat": "056012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 1828,
            "area": "",
            "ech": 0
        },
        {
            "id": 1240,
            "name": "Canischio",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B605",
            "cod_istat": "001052",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 659,
            "giorni": 3342,
            "area": "",
            "ech": 0
        },
        {
            "id": 1241,
            "name": "Canistro",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "B606",
            "cod_istat": "066017",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 554,
            "giorni": 2280,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 1242,
            "name": "Canna",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "B607",
            "cod_istat": "078024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 417,
            "giorni": 1640,
            "area": "",
            "ech": 0
        },
        {
            "id": 1243,
            "name": "Cannalonga",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "B608",
            "cod_istat": "065024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 1827,
            "area": "",
            "ech": 0
        },
        {
            "id": 1244,
            "name": "Cannara",
            "provincia": "PG",
            "cap": "06033",
            "cod_catastale": "B609",
            "cod_istat": "054006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 1985,
            "area": "",
            "ech": 0
        },
        {
            "id": 1245,
            "name": "Cannero Riviera",
            "provincia": "VB",
            "cap": "28821",
            "cod_catastale": "B610",
            "cod_istat": "103016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 1246,
            "name": "Canneto Pavese",
            "provincia": "PV",
            "cap": "27044",
            "cod_catastale": "B613",
            "cod_istat": "018029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2878,
            "area": "",
            "ech": 0
        },
        {
            "id": 1247,
            "name": "Canneto sull'Oglio",
            "provincia": "MN",
            "cap": "46013",
            "cod_catastale": "B612",
            "cod_istat": "020008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1248,
            "name": "Cannobio",
            "provincia": "VB",
            "cap": "28822",
            "cod_catastale": "B615",
            "cod_istat": "103017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2583,
            "area": "",
            "ech": 0
        },
        {
            "id": 1249,
            "name": "Cannole",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "B616",
            "cod_istat": "075012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 1231,
            "area": "",
            "ech": 0
        },
        {
            "id": 1250,
            "name": "Canolo",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "B617",
            "cod_istat": "080020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 432,
            "giorni": 1490,
            "area": "",
            "ech": 0
        },
        {
            "id": 1251,
            "name": "Canonica d'Adda",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "B618",
            "cod_istat": "016049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 1252,
            "name": "Canosa di Puglia",
            "provincia": "BT",
            "cap": "76012",
            "cod_catastale": "B619",
            "cod_istat": "110004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1187,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1253,
            "name": "Canosa Sannita",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "B620",
            "cod_istat": "069010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 1593,
            "area": "",
            "ech": 0
        },
        {
            "id": 1254,
            "name": "Canosio",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "B621",
            "cod_istat": "004038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1225,
            "giorni": 3834,
            "area": "",
            "ech": 0
        },
        {
            "id": 1255,
            "name": "Canossa",
            "provincia": "RE",
            "cap": "42026",
            "cod_catastale": "C669",
            "cod_istat": "035018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 1256,
            "name": "Cansano",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "B624",
            "cod_istat": "066018",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 835,
            "giorni": 2783,
            "area": "",
            "ech": 0
        },
        {
            "id": 1257,
            "name": "Cantagallo",
            "provincia": "PO",
            "cap": "59025",
            "cod_catastale": "B626",
            "cod_istat": "100001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 423,
            "giorni": 2960,
            "area": "",
            "ech": 0
        },
        {
            "id": 1258,
            "name": "Cantalice",
            "provincia": "RI",
            "cap": "02014",
            "cod_catastale": "B627",
            "cod_istat": "057009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 660,
            "giorni": 2566,
            "area": "",
            "ech": 0
        },
        {
            "id": 1259,
            "name": "Cantalupa",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "B628",
            "cod_istat": "001053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 2936,
            "area": "",
            "ech": 0
        },
        {
            "id": 1260,
            "name": "Cantalupo in Sabina",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "B631",
            "cod_istat": "057010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 1994,
            "area": "",
            "ech": 0
        },
        {
            "id": 1261,
            "name": "Cantalupo Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B629",
            "cod_istat": "006028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 1262,
            "name": "Cantalupo nel Sannio",
            "provincia": "IS",
            "cap": "86092",
            "cod_catastale": "B630",
            "cod_istat": "094005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 588,
            "giorni": 2131,
            "area": "",
            "ech": 0
        },
        {
            "id": 1263,
            "name": "Cantarana",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "B633",
            "cod_istat": "005018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 1264,
            "name": "Cantello",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "B634",
            "cod_istat": "012030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 2702,
            "area": "",
            "ech": 0
        },
        {
            "id": 1265,
            "name": "Canterano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "B635",
            "cod_istat": "058017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 1266,
            "name": "Cantiano",
            "provincia": "PU",
            "cap": "61044",
            "cod_catastale": "B636",
            "cod_istat": "041008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2363,
            "area": "",
            "ech": 0
        },
        {
            "id": 1267,
            "name": "Cantoira",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "B637",
            "cod_istat": "001054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3479,
            "area": "",
            "ech": 0
        },
        {
            "id": 1268,
            "name": "Cantù",
            "provincia": "CO",
            "cap": "22063",
            "cod_catastale": "B639",
            "cod_istat": "013041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 2594,
            "area": "",
            "ech": 0
        },
        {
            "id": 1269,
            "name": "Canzano",
            "provincia": "TE",
            "cap": "64020",
            "cod_catastale": "B640",
            "cod_istat": "067009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 448,
            "giorni": 2143,
            "area": "",
            "ech": 0
        },
        {
            "id": 1270,
            "name": "Canzo",
            "provincia": "CO",
            "cap": "22035",
            "cod_catastale": "B641",
            "cod_istat": "013042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 2801,
            "area": "",
            "ech": 0
        },
        {
            "id": 1271,
            "name": "Caorle",
            "provincia": "VE",
            "cap": "30021",
            "cod_catastale": "B642",
            "cod_istat": "027005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 1272,
            "name": "Caorso",
            "provincia": "PC",
            "cap": "29012",
            "cod_catastale": "B643",
            "cod_istat": "033010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2511,
            "area": "",
            "ech": 0
        },
        {
            "id": 1273,
            "name": "Capaccio Paestum",
            "provincia": "SA",
            "cap": "84047",
            "cod_catastale": "B644",
            "cod_istat": "065025",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1274,
            "name": "Capaci",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "B645",
            "cod_istat": "082020",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 737,
            "area": "",
            "ech": 1
        },
        {
            "id": 1275,
            "name": "Capalbio",
            "provincia": "GR",
            "cap": "58011",
            "cod_catastale": "B646",
            "cod_istat": "053003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 1823,
            "area": "",
            "ech": 0
        },
        {
            "id": 1276,
            "name": "Capannoli",
            "provincia": "PI",
            "cap": "56033",
            "cod_catastale": "B647",
            "cod_istat": "050005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 1650,
            "area": "",
            "ech": 0
        },
        {
            "id": 1277,
            "name": "Capannori",
            "provincia": "LU",
            "cap": "55012",
            "cod_catastale": "B648",
            "cod_istat": "046007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1691,
            "area": "",
            "ech": 0
        },
        {
            "id": 1278,
            "name": "Capena",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "B649",
            "cod_istat": "058018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 1747,
            "area": "",
            "ech": 0
        },
        {
            "id": 1279,
            "name": "Capergnanica",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B650",
            "cod_istat": "019012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1280,
            "name": "Capestrano",
            "provincia": "AQ",
            "cap": "67022",
            "cod_catastale": "B651",
            "cod_istat": "066019",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 465,
            "giorni": 2121,
            "area": "",
            "ech": 0
        },
        {
            "id": 1281,
            "name": "Capiago Intimiano",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B653",
            "cod_istat": "013043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 2667,
            "area": "",
            "ech": 0
        },
        {
            "id": 1282,
            "name": "Capistrano",
            "provincia": "VV",
            "cap": "89818",
            "cod_catastale": "B655",
            "cod_istat": "102005",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 352,
            "giorni": 1399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1283,
            "name": "Capistrello",
            "provincia": "AQ",
            "cap": "67053",
            "cod_catastale": "B656",
            "cod_istat": "066020",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 734,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 1284,
            "name": "Capitignano",
            "provincia": "AQ",
            "cap": "67014",
            "cod_catastale": "B658",
            "cod_istat": "066021",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 916,
            "giorni": 2928,
            "area": "",
            "ech": 0
        },
        {
            "id": 1285,
            "name": "Capizzi",
            "provincia": "ME",
            "cap": "98031",
            "cod_catastale": "B660",
            "cod_istat": "083008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1100,
            "giorni": 2507,
            "area": "",
            "ech": 1
        },
        {
            "id": 1286,
            "name": "Capizzone",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "B661",
            "cod_istat": "016050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 1287,
            "name": "Capo di Ponte",
            "provincia": "BS",
            "cap": "25044",
            "cod_catastale": "B664",
            "cod_istat": "017035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 362,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 1288,
            "name": "Capo d'Orlando",
            "provincia": "ME",
            "cap": "98071",
            "cod_catastale": "B666",
            "cod_istat": "083009",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 640,
            "area": "",
            "ech": 0
        },
        {
            "id": 1289,
            "name": "Capodimonte",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "B663",
            "cod_istat": "056013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2014,
            "area": "",
            "ech": 0
        },
        {
            "id": 1290,
            "name": "Capodrise",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "B667",
            "cod_istat": "061013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1109,
            "area": "",
            "ech": 0
        },
        {
            "id": 1291,
            "name": "Capoliveri",
            "provincia": "LI",
            "cap": "57031",
            "cod_catastale": "B669",
            "cod_istat": "049004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 167,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 1292,
            "name": "Capolona",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "B670",
            "cod_istat": "051006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2026,
            "area": "",
            "ech": 0
        },
        {
            "id": 1293,
            "name": "Caponago",
            "provincia": "MB",
            "cap": "20867",
            "cod_catastale": "B671",
            "cod_istat": "108052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 1294,
            "name": "Caporciano",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "B672",
            "cod_istat": "066022",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 836,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 1295,
            "name": "Caposele",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B674",
            "cod_istat": "064017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 405,
            "giorni": 1716,
            "area": "",
            "ech": 0
        },
        {
            "id": 1296,
            "name": "Capoterra",
            "provincia": "CA",
            "cap": "09012",
            "cod_catastale": "B675",
            "cod_istat": "092011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 985,
            "area": "",
            "ech": 0
        },
        {
            "id": 1297,
            "name": "Capovalle",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "B676",
            "cod_istat": "017036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 3544,
            "area": "",
            "ech": 0
        },
        {
            "id": 1298,
            "name": "Cappadocia",
            "provincia": "AQ",
            "cap": "67060",
            "cod_catastale": "B677",
            "cod_istat": "066023",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1108,
            "giorni": 3272,
            "area": "",
            "ech": 0
        },
        {
            "id": 1299,
            "name": "Cappella Cantone",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "B679",
            "cod_istat": "019013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1300,
            "name": "Cappella de' Picenardi",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "B680",
            "cod_istat": "019014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1301,
            "name": "Cappella Maggiore",
            "provincia": "TV",
            "cap": "31012",
            "cod_catastale": "B678",
            "cod_istat": "026007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 1302,
            "name": "Cappelle sul Tavo",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "B681",
            "cod_istat": "068006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 1454,
            "area": "",
            "ech": 0
        },
        {
            "id": 1303,
            "name": "Capracotta",
            "provincia": "IS",
            "cap": "86082",
            "cod_catastale": "B682",
            "cod_istat": "094006",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1421,
            "giorni": 4004,
            "area": "",
            "ech": 0
        },
        {
            "id": 1304,
            "name": "Capraia e Limite",
            "provincia": "FI",
            "cap": "50050",
            "cod_catastale": "B684",
            "cod_istat": "048008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1658,
            "area": "",
            "ech": 0
        },
        {
            "id": 1305,
            "name": "Capraia Isola",
            "provincia": "LI",
            "cap": "57032",
            "cod_catastale": "B685",
            "cod_istat": "049005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 1306,
            "name": "Capralba",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B686",
            "cod_istat": "019015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1307,
            "name": "Capranica",
            "provincia": "VT",
            "cap": "01012",
            "cod_catastale": "B688",
            "cod_istat": "056014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2077,
            "area": "",
            "ech": 0
        },
        {
            "id": 1308,
            "name": "Capranica Prenestina",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "B687",
            "cod_istat": "058019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 915,
            "giorni": 2927,
            "area": "",
            "ech": 0
        },
        {
            "id": 1309,
            "name": "Caprarica di Lecce",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "B690",
            "cod_istat": "075013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 1178,
            "area": "",
            "ech": 0
        },
        {
            "id": 1310,
            "name": "Caprarola",
            "provincia": "VT",
            "cap": "01032",
            "cod_catastale": "B691",
            "cod_istat": "056015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2343,
            "area": "",
            "ech": 0
        },
        {
            "id": 1311,
            "name": "Caprauna",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "B692",
            "cod_istat": "004039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 954,
            "giorni": 3498,
            "area": "",
            "ech": 0
        },
        {
            "id": 1312,
            "name": "Caprese Michelangelo",
            "provincia": "AR",
            "cap": "52033",
            "cod_catastale": "B693",
            "cod_istat": "051007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 653,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 1313,
            "name": "Caprezzo",
            "provincia": "VB",
            "cap": "28815",
            "cod_catastale": "B694",
            "cod_istat": "103018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2993,
            "area": "",
            "ech": 0
        },
        {
            "id": 1314,
            "name": "Capri",
            "provincia": "NA",
            "cap": "80073",
            "cod_catastale": "B696",
            "cod_istat": "063014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 1031,
            "area": "",
            "ech": 0
        },
        {
            "id": 1315,
            "name": "Capri Leone",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "B695",
            "cod_istat": "083010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1310,
            "area": "",
            "ech": 0
        },
        {
            "id": 1316,
            "name": "Capriana",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "B697",
            "cod_istat": "022040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1007,
            "giorni": 4039,
            "area": "",
            "ech": 0
        },
        {
            "id": 1317,
            "name": "Capriano del Colle",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "B698",
            "cod_istat": "017037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1318,
            "name": "Capriata d'Orba",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B701",
            "cod_istat": "006029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2699,
            "area": "",
            "ech": 0
        },
        {
            "id": 1319,
            "name": "Capriate San Gervasio",
            "provincia": "BG",
            "cap": "24042",
            "cod_catastale": "B703",
            "cod_istat": "016051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 1320,
            "name": "Capriati a Volturno",
            "provincia": "CE",
            "cap": "81014",
            "cod_catastale": "B704",
            "cod_istat": "061014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 1321,
            "name": "Caprie",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "B705",
            "cod_istat": "001055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 374,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 1322,
            "name": "Capriglia Irpina",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "B706",
            "cod_istat": "064018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2080,
            "area": "",
            "ech": 0
        },
        {
            "id": 1323,
            "name": "Capriglio",
            "provincia": "AT",
            "cap": "14014",
            "cod_catastale": "B707",
            "cod_istat": "005019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 1324,
            "name": "Caprile",
            "provincia": "BI",
            "cap": "13864",
            "cod_catastale": "B708",
            "cod_istat": "096013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 559,
            "giorni": 3031,
            "area": "",
            "ech": 0
        },
        {
            "id": 1325,
            "name": "Caprino Bergamasco",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "B710",
            "cod_istat": "016052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 2517,
            "area": "",
            "ech": 0
        },
        {
            "id": 1326,
            "name": "Caprino Veronese",
            "provincia": "VR",
            "cap": "37013",
            "cod_catastale": "B709",
            "cod_istat": "023018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2709,
            "area": "",
            "ech": 0
        },
        {
            "id": 1327,
            "name": "Capriolo",
            "provincia": "BS",
            "cap": "25031",
            "cod_catastale": "B711",
            "cod_istat": "017038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 1328,
            "name": "Capriva del Friuli",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "B712",
            "cod_istat": "031001",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2288,
            "area": "",
            "ech": 0
        },
        {
            "id": 1329,
            "name": "Capua",
            "provincia": "CE",
            "cap": "81043",
            "cod_catastale": "B715",
            "cod_istat": "061015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1091,
            "area": "",
            "ech": 0
        },
        {
            "id": 1330,
            "name": "Capurso",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "B716",
            "cod_istat": "072014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1287,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1331,
            "name": "Caraffa del Bianco",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "B718",
            "cod_istat": "080021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 1344,
            "area": "",
            "ech": 1
        },
        {
            "id": 1332,
            "name": "Caraffa di Catanzaro",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "B717",
            "cod_istat": "079017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 1409,
            "area": "",
            "ech": 0
        },
        {
            "id": 1333,
            "name": "Caraglio",
            "provincia": "CN",
            "cap": "12023",
            "cod_catastale": "B719",
            "cod_istat": "004040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3062,
            "area": "",
            "ech": 0
        },
        {
            "id": 1334,
            "name": "Caramagna Piemonte",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "B720",
            "cod_istat": "004041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 1335,
            "name": "Caramanico Terme",
            "provincia": "PE",
            "cap": "65023",
            "cod_catastale": "B722",
            "cod_istat": "068007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1336,
            "name": "Carano",
            "provincia": "TN",
            "cap": "38033",
            "cod_catastale": "B723",
            "cod_istat": "022041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1086,
            "giorni": 4162,
            "area": "",
            "ech": 0
        },
        {
            "id": 1337,
            "name": "Carapelle",
            "provincia": "FG",
            "cap": "71041",
            "cod_catastale": "B724",
            "cod_istat": "071010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 1384,
            "area": "",
            "ech": 0
        },
        {
            "id": 1338,
            "name": "Carapelle Calvisio",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "B725",
            "cod_istat": "066024",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 910,
            "giorni": 2917,
            "area": "",
            "ech": 0
        },
        {
            "id": 1339,
            "name": "Carasco",
            "provincia": "GE",
            "cap": "16042",
            "cod_catastale": "B726",
            "cod_istat": "010010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 1596,
            "area": "",
            "ech": 0
        },
        {
            "id": 1340,
            "name": "Carassai",
            "provincia": "AP",
            "cap": "63063",
            "cod_catastale": "B727",
            "cod_istat": "044010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 2067,
            "area": "",
            "ech": 0
        },
        {
            "id": 1341,
            "name": "Carate Brianza",
            "provincia": "MB",
            "cap": "20841",
            "cod_catastale": "B729",
            "cod_istat": "108015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2492,
            "area": "",
            "ech": 0
        },
        {
            "id": 1342,
            "name": "Carate Urio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "B730",
            "cod_istat": "013044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2233,
            "area": "",
            "ech": 0
        },
        {
            "id": 1343,
            "name": "Caravaggio",
            "provincia": "BG",
            "cap": "24043",
            "cod_catastale": "B731",
            "cod_istat": "016053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1344,
            "name": "Caravate",
            "provincia": "VA",
            "cap": "21032",
            "cod_catastale": "B732",
            "cod_istat": "012031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 1345,
            "name": "Caravino",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "B733",
            "cod_istat": "001056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2743,
            "area": "",
            "ech": 0
        },
        {
            "id": 1346,
            "name": "Caravonica",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "B734",
            "cod_istat": "008012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2051,
            "area": "",
            "ech": 0
        },
        {
            "id": 1347,
            "name": "Carbognano",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "B735",
            "cod_istat": "056016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 1348,
            "name": "Carbonara al Ticino",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "B741",
            "cod_istat": "018030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1349,
            "name": "Carbonara di Nola",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "B740",
            "cod_istat": "063015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 174,
            "giorni": 1256,
            "area": "",
            "ech": 0
        },
        {
            "id": 1350,
            "name": "Carbonara di Po",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "B739",
            "cod_istat": "020009",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1351,
            "name": "Carbonara Scrivia",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "B736",
            "cod_istat": "006030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2700,
            "area": "",
            "ech": 0
        },
        {
            "id": 1352,
            "name": "Carbonate",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B742",
            "cod_istat": "013045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 1353,
            "name": "Carbone",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "B743",
            "cod_istat": "076019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 1354,
            "name": "Carbonera",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "B744",
            "cod_istat": "026008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 1355,
            "name": "Carbonia",
            "provincia": "SU",
            "cap": "09013",
            "cod_catastale": "B745",
            "cod_istat": "111009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 922,
            "area": "",
            "ech": 0
        },
        {
            "id": 1356,
            "name": "Carcare",
            "provincia": "SV",
            "cap": "17043",
            "cod_catastale": "B748",
            "cod_istat": "009018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 2295,
            "area": "",
            "ech": 0
        },
        {
            "id": 1357,
            "name": "Carceri",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "B749",
            "cod_istat": "028022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 1358,
            "name": "Carcoforo",
            "provincia": "VC",
            "cap": "13026",
            "cod_catastale": "B752",
            "cod_istat": "002029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1304,
            "giorni": 4000,
            "area": "",
            "ech": 0
        },
        {
            "id": 1359,
            "name": "Cardano al Campo",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "B754",
            "cod_istat": "012032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2880,
            "area": "",
            "ech": 0
        },
        {
            "id": 1360,
            "name": "Cardè",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "B755",
            "cod_istat": "004042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2635,
            "area": "",
            "ech": 0
        },
        {
            "id": 1361,
            "name": "Cardedu",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "M285",
            "cod_istat": "091103",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 822,
            "area": "",
            "ech": 1
        },
        {
            "id": 1362,
            "name": "Cardeto",
            "provincia": "RC",
            "cap": "89060",
            "cod_catastale": "B756",
            "cod_istat": "080022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 700,
            "giorni": 2033,
            "area": "",
            "ech": 1
        },
        {
            "id": 1363,
            "name": "Cardinale",
            "provincia": "CZ",
            "cap": "88062",
            "cod_catastale": "B758",
            "cod_istat": "079018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 562,
            "giorni": 1840,
            "area": "",
            "ech": 1
        },
        {
            "id": 1364,
            "name": "Cardito",
            "provincia": "NA",
            "cap": "80024",
            "cod_catastale": "B759",
            "cod_istat": "063016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 1061,
            "area": "",
            "ech": 0
        },
        {
            "id": 1365,
            "name": "Careggine",
            "provincia": "LU",
            "cap": "55030",
            "cod_catastale": "B760",
            "cod_istat": "046008",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 882,
            "giorni": 3512,
            "area": "",
            "ech": 0
        },
        {
            "id": 1366,
            "name": "Carema",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "B762",
            "cod_istat": "001057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2726,
            "area": "",
            "ech": 0
        },
        {
            "id": 1367,
            "name": "Carenno",
            "provincia": "LC",
            "cap": "23802",
            "cod_catastale": "B763",
            "cod_istat": "097014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 635,
            "giorni": 2971,
            "area": "",
            "ech": 0
        },
        {
            "id": 1368,
            "name": "Carentino",
            "provincia": "AL",
            "cap": "15026",
            "cod_catastale": "B765",
            "cod_istat": "006031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 1369,
            "name": "Careri",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "B766",
            "cod_istat": "080023",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 320,
            "giorni": 1144,
            "area": "",
            "ech": 1
        },
        {
            "id": 1370,
            "name": "Caresana",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "B767",
            "cod_istat": "002030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2820,
            "area": "",
            "ech": 0
        },
        {
            "id": 1371,
            "name": "Caresanablot",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "B768",
            "cod_istat": "002031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 1372,
            "name": "Carezzano",
            "provincia": "AL",
            "cap": "15051",
            "cod_catastale": "B769",
            "cod_istat": "006032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 1373,
            "name": "Carfizzi",
            "provincia": "KR",
            "cap": "88817",
            "cod_catastale": "B771",
            "cod_istat": "101003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 512,
            "giorni": 1827,
            "area": "",
            "ech": 0
        },
        {
            "id": 1374,
            "name": "Cargeghe",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "B772",
            "cod_istat": "090022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 1526,
            "area": "",
            "ech": 0
        },
        {
            "id": 1375,
            "name": "Cariati",
            "provincia": "CS",
            "cap": "87062",
            "cod_catastale": "B774",
            "cod_istat": "078025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 913,
            "area": "",
            "ech": 1
        },
        {
            "id": 1376,
            "name": "Carife",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B776",
            "cod_istat": "064019",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 1377,
            "name": "Carignano",
            "provincia": "TO",
            "cap": "10041",
            "cod_catastale": "B777",
            "cod_istat": "001058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 1378,
            "name": "Carimate",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "B778",
            "cod_istat": "013046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 1379,
            "name": "Carinaro",
            "provincia": "CE",
            "cap": "81032",
            "cod_catastale": "B779",
            "cod_istat": "061016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 1099,
            "area": "",
            "ech": 0
        },
        {
            "id": 1380,
            "name": "Carini",
            "provincia": "PA",
            "cap": "90044",
            "cod_catastale": "B780",
            "cod_istat": "082021",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 788,
            "area": "",
            "ech": 0
        },
        {
            "id": 1381,
            "name": "Carinola",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "B781",
            "cod_istat": "061017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1190,
            "area": "",
            "ech": 0
        },
        {
            "id": 1382,
            "name": "Carisio",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "B782",
            "cod_istat": "002032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 1383,
            "name": "Carisolo",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "B783",
            "cod_istat": "022042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 808,
            "giorni": 3651,
            "area": "",
            "ech": 0
        },
        {
            "id": 1384,
            "name": "Carlantino",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "B784",
            "cod_istat": "071011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 558,
            "giorni": 2049,
            "area": "",
            "ech": 0
        },
        {
            "id": 1385,
            "name": "Carlazzo",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "B785",
            "cod_istat": "013047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 481,
            "giorni": 2753,
            "area": "",
            "ech": 0
        },
        {
            "id": 1386,
            "name": "Carlentini",
            "provincia": "SR",
            "cap": "96013",
            "cod_catastale": "B787",
            "cod_istat": "089006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1007,
            "area": "",
            "ech": 1
        },
        {
            "id": 1387,
            "name": "Carlino",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "B788",
            "cod_istat": "030018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1388,
            "name": "Carloforte",
            "provincia": "SU",
            "cap": "09014",
            "cod_catastale": "B789",
            "cod_istat": "111010",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 789,
            "area": "",
            "ech": 0
        },
        {
            "id": 1389,
            "name": "Carlopoli",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "B790",
            "cod_istat": "079020",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 924,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 1390,
            "name": "Carmagnola",
            "provincia": "TO",
            "cap": "10022",
            "cod_catastale": "B791",
            "cod_istat": "001059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 1391,
            "name": "Carmiano",
            "provincia": "LE",
            "cap": "73041",
            "cod_catastale": "B792",
            "cod_istat": "075014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 1096,
            "area": "",
            "ech": 0
        },
        {
            "id": 1392,
            "name": "Carmignano",
            "provincia": "PO",
            "cap": "59015",
            "cod_catastale": "B794",
            "cod_istat": "100002",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2053,
            "area": "",
            "ech": 0
        },
        {
            "id": 1393,
            "name": "Carmignano di Brenta",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "B795",
            "cod_istat": "028023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 1394,
            "name": "Carnago",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "B796",
            "cod_istat": "012033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 354,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 1395,
            "name": "Carnate",
            "provincia": "MB",
            "cap": "20866",
            "cod_catastale": "B798",
            "cod_istat": "108016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2433,
            "area": "",
            "ech": 0
        },
        {
            "id": 1396,
            "name": "Carobbio degli Angeli",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B801",
            "cod_istat": "016055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1397,
            "name": "Carolei",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "B802",
            "cod_istat": "078026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 624,
            "giorni": 2046,
            "area": "",
            "ech": 0
        },
        {
            "id": 1398,
            "name": "Carona",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "B803",
            "cod_istat": "016056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1110,
            "giorni": 3646,
            "area": "",
            "ech": 0
        },
        {
            "id": 1399,
            "name": "Caronia",
            "provincia": "ME",
            "cap": "98072",
            "cod_catastale": "B804",
            "cod_istat": "083011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 1146,
            "area": "",
            "ech": 1
        },
        {
            "id": 1400,
            "name": "Caronno Pertusella",
            "provincia": "VA",
            "cap": "21042",
            "cod_catastale": "B805",
            "cod_istat": "012034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2352,
            "area": "",
            "ech": 0
        },
        {
            "id": 1401,
            "name": "Caronno Varesino",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "B807",
            "cod_istat": "012035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 403,
            "giorni": 2700,
            "area": "",
            "ech": 0
        },
        {
            "id": 1402,
            "name": "Carosino",
            "provincia": "TA",
            "cap": "74021",
            "cod_catastale": "B808",
            "cod_istat": "073002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1194,
            "area": "",
            "ech": 0
        },
        {
            "id": 1403,
            "name": "Carovigno",
            "provincia": "BR",
            "cap": "72012",
            "cod_catastale": "B809",
            "cod_istat": "074002",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 1320,
            "area": "",
            "ech": 0
        },
        {
            "id": 1404,
            "name": "Carovilli",
            "provincia": "IS",
            "cap": "86083",
            "cod_catastale": "B810",
            "cod_istat": "094007",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 860,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 1405,
            "name": "Carpaneto Piacentino",
            "provincia": "PC",
            "cap": "29013",
            "cod_catastale": "B812",
            "cod_istat": "033011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 1406,
            "name": "Carpanzano",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "B813",
            "cod_istat": "078027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2002,
            "area": "",
            "ech": 1
        },
        {
            "id": 1407,
            "name": "Carpasio",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "B814",
            "cod_istat": "008013",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 2958,
            "area": "",
            "ech": 0
        },
        {
            "id": 1408,
            "name": "Carpegna",
            "provincia": "PU",
            "cap": "61021",
            "cod_catastale": "B816",
            "cod_istat": "041009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 748,
            "giorni": 2874,
            "area": "",
            "ech": 0
        },
        {
            "id": 1409,
            "name": "Carpenedolo",
            "provincia": "BS",
            "cap": "25013",
            "cod_catastale": "B817",
            "cod_istat": "017039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1410,
            "name": "Carpeneto",
            "provincia": "AL",
            "cap": "15071",
            "cod_catastale": "B818",
            "cod_istat": "006033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 1411,
            "name": "Carpi",
            "provincia": "MO",
            "cap": "41012",
            "cod_catastale": "B819",
            "cod_istat": "036005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 1412,
            "name": "Carpiano",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "B820",
            "cod_istat": "015050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1413,
            "name": "Carpignano Salentino",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "B822",
            "cod_istat": "075015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1232,
            "area": "",
            "ech": 0
        },
        {
            "id": 1414,
            "name": "Carpignano Sesia",
            "provincia": "NO",
            "cap": "28064",
            "cod_catastale": "B823",
            "cod_istat": "003036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 1415,
            "name": "Carpineti",
            "provincia": "RE",
            "cap": "42033",
            "cod_catastale": "B825",
            "cod_istat": "035011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 562,
            "giorni": 2982,
            "area": "",
            "ech": 0
        },
        {
            "id": 1416,
            "name": "Carpineto della Nora",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "B827",
            "cod_istat": "068008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 535,
            "giorni": 2078,
            "area": "",
            "ech": 0
        },
        {
            "id": 1417,
            "name": "Carpineto Romano",
            "provincia": "RM",
            "cap": "00032",
            "cod_catastale": "B828",
            "cod_istat": "058020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 2063,
            "area": "",
            "ech": 0
        },
        {
            "id": 1418,
            "name": "Carpineto Sinello",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "B826",
            "cod_istat": "069011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 381,
            "giorni": 1768,
            "area": "",
            "ech": 0
        },
        {
            "id": 1419,
            "name": "Carpino",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "B829",
            "cod_istat": "071012",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 147,
            "giorni": 1368,
            "area": "",
            "ech": 0
        },
        {
            "id": 1420,
            "name": "Carpinone",
            "provincia": "IS",
            "cap": "86093",
            "cod_catastale": "B830",
            "cod_istat": "094008",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 636,
            "giorni": 2211,
            "area": "",
            "ech": 0
        },
        {
            "id": 1421,
            "name": "Carrara",
            "provincia": "MS",
            "cap": "54033",
            "cod_catastale": "B832",
            "cod_istat": "045003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 1601,
            "area": "",
            "ech": 0
        },
        {
            "id": 1422,
            "name": "Carrè",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "B835",
            "cod_istat": "024024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2546,
            "area": "",
            "ech": 0
        },
        {
            "id": 1423,
            "name": "Carrega Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B836",
            "cod_istat": "006034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 958,
            "giorni": 3287,
            "area": "",
            "ech": 0
        },
        {
            "id": 1424,
            "name": "Carro",
            "provincia": "SP",
            "cap": "19012",
            "cod_catastale": "B838",
            "cod_istat": "011009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2038,
            "area": "",
            "ech": 0
        },
        {
            "id": 1425,
            "name": "Carrodano",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "B839",
            "cod_istat": "011010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 1888,
            "area": "",
            "ech": 0
        },
        {
            "id": 1426,
            "name": "Carrosio",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "B840",
            "cod_istat": "006035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 1427,
            "name": "Carrù",
            "provincia": "CN",
            "cap": "12061",
            "cod_catastale": "B841",
            "cod_istat": "004043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2766,
            "area": "",
            "ech": 0
        },
        {
            "id": 1428,
            "name": "Carsoli",
            "provincia": "AQ",
            "cap": "67061",
            "cod_catastale": "B842",
            "cod_istat": "066025",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 616,
            "giorni": 2603,
            "area": "",
            "ech": 0
        },
        {
            "id": 1429,
            "name": "Cartigliano",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "B844",
            "cod_istat": "024025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 1430,
            "name": "Cartignano",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "B845",
            "cod_istat": "004044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 690,
            "giorni": 3171,
            "area": "",
            "ech": 0
        },
        {
            "id": 1431,
            "name": "Cartoceto",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "B846",
            "cod_istat": "041010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2250,
            "area": "",
            "ech": 0
        },
        {
            "id": 1432,
            "name": "Cartosio",
            "provincia": "AL",
            "cap": "15015",
            "cod_catastale": "B847",
            "cod_istat": "006036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2504,
            "area": "",
            "ech": 0
        },
        {
            "id": 1433,
            "name": "Cartura",
            "provincia": "PD",
            "cap": "35025",
            "cod_catastale": "B848",
            "cod_istat": "028026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 1434,
            "name": "Carugate",
            "provincia": "MI",
            "cap": "20061",
            "cod_catastale": "B850",
            "cod_istat": "015051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 1435,
            "name": "Carugo",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "B851",
            "cod_istat": "013048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 1436,
            "name": "Carunchio",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "B853",
            "cod_istat": "069012",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 714,
            "giorni": 2314,
            "area": "",
            "ech": 0
        },
        {
            "id": 1437,
            "name": "Carvico",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "B854",
            "cod_istat": "016057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 1438,
            "name": "Carzano",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "B856",
            "cod_istat": "022043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 433,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 1439,
            "name": "Casabona",
            "provincia": "KR",
            "cap": "88822",
            "cod_catastale": "B857",
            "cod_istat": "101004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 1362,
            "area": "",
            "ech": 0
        },
        {
            "id": 1440,
            "name": "Casacalenda",
            "provincia": "CB",
            "cap": "86043",
            "cod_catastale": "B858",
            "cod_istat": "070011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 641,
            "giorni": 2230,
            "area": "",
            "ech": 0
        },
        {
            "id": 1441,
            "name": "Casacanditella",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "B859",
            "cod_istat": "069013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 1844,
            "area": "",
            "ech": 0
        },
        {
            "id": 1442,
            "name": "Casagiove",
            "provincia": "CE",
            "cap": "81022",
            "cod_catastale": "B860",
            "cod_istat": "061018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 942,
            "area": "",
            "ech": 0
        },
        {
            "id": 1443,
            "name": "Casal Cermelli",
            "provincia": "AL",
            "cap": "15072",
            "cod_catastale": "B870",
            "cod_istat": "006037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2565,
            "area": "",
            "ech": 0
        },
        {
            "id": 1444,
            "name": "Casal di Principe",
            "provincia": "CE",
            "cap": "81033",
            "cod_catastale": "B872",
            "cod_istat": "061019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1094,
            "area": "",
            "ech": 0
        },
        {
            "id": 1445,
            "name": "Casal Velino",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "B895",
            "cod_istat": "065028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 1151,
            "area": "",
            "ech": 0
        },
        {
            "id": 1446,
            "name": "Casalanguida",
            "provincia": "CH",
            "cap": "66031",
            "cod_catastale": "B861",
            "cod_istat": "069014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1871,
            "area": "",
            "ech": 0
        },
        {
            "id": 1447,
            "name": "Casalattico",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "B862",
            "cod_istat": "060017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1855,
            "area": "",
            "ech": 0
        },
        {
            "id": 1448,
            "name": "Casalbeltrame",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "B864",
            "cod_istat": "003037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 2616,
            "area": "",
            "ech": 0
        },
        {
            "id": 1449,
            "name": "Casalbordino",
            "provincia": "CH",
            "cap": "66021",
            "cod_catastale": "B865",
            "cod_istat": "069015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 1540,
            "area": "",
            "ech": 0
        },
        {
            "id": 1450,
            "name": "Casalbore",
            "provincia": "AV",
            "cap": "83034",
            "cod_catastale": "B866",
            "cod_istat": "064020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 601,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 1451,
            "name": "Casalborgone",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "B867",
            "cod_istat": "001060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 1452,
            "name": "Casalbuono",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "B868",
            "cod_istat": "065026",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 661,
            "giorni": 1975,
            "area": "",
            "ech": 0
        },
        {
            "id": 1453,
            "name": "Casalbuttano ed Uniti",
            "provincia": "CR",
            "cap": "26011",
            "cod_catastale": "B869",
            "cod_istat": "019016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1454,
            "name": "Casalciprano",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "B871",
            "cod_istat": "070012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 658,
            "giorni": 2213,
            "area": "",
            "ech": 0
        },
        {
            "id": 1455,
            "name": "Casalduni",
            "provincia": "BN",
            "cap": "82027",
            "cod_catastale": "B873",
            "cod_istat": "062015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1616,
            "area": "",
            "ech": 0
        },
        {
            "id": 1456,
            "name": "Casale Corte Cerro",
            "provincia": "VB",
            "cap": "28881",
            "cod_catastale": "B876",
            "cod_istat": "103019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2788,
            "area": "",
            "ech": 0
        },
        {
            "id": 1457,
            "name": "Casale Cremasco-Vidolasco",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B881",
            "cod_istat": "019017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1458,
            "name": "Casale di Scodosia",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "B877",
            "cod_istat": "028027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 1459,
            "name": "Casale Litta",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B875",
            "cod_istat": "012036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 1460,
            "name": "Casale Marittimo",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "B878",
            "cod_istat": "050006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 1843,
            "area": "",
            "ech": 0
        },
        {
            "id": 1461,
            "name": "Casale Monferrato",
            "provincia": "AL",
            "cap": "15033",
            "cod_catastale": "B885",
            "cod_istat": "006039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2815,
            "area": "",
            "ech": 0
        },
        {
            "id": 1462,
            "name": "Casale sul Sile",
            "provincia": "TV",
            "cap": "31032",
            "cod_catastale": "B879",
            "cod_istat": "026009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 1463,
            "name": "Casalecchio di Reno",
            "provincia": "BO",
            "cap": "40033",
            "cod_catastale": "B880",
            "cod_istat": "037011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 1464,
            "name": "Casaleggio Boiro",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "B882",
            "cod_istat": "006038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 1465,
            "name": "Casaleggio Novara",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "B883",
            "cod_istat": "003039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 1466,
            "name": "Casaleone",
            "provincia": "VR",
            "cap": "37052",
            "cod_catastale": "B886",
            "cod_istat": "023019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 1467,
            "name": "Casaletto Ceredano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B889",
            "cod_istat": "019018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1468,
            "name": "Casaletto di Sopra",
            "provincia": "CR",
            "cap": "26014",
            "cod_catastale": "B890",
            "cod_istat": "019019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1469,
            "name": "Casaletto Lodigiano",
            "provincia": "LO",
            "cap": "26852",
            "cod_catastale": "B887",
            "cod_istat": "098008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 1470,
            "name": "Casaletto Spartano",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "B888",
            "cod_istat": "065027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1431,
            "area": "",
            "ech": 0
        },
        {
            "id": 1471,
            "name": "Casaletto Vaprio",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B891",
            "cod_istat": "019020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1472,
            "name": "Casalfiumanese",
            "provincia": "BO",
            "cap": "40020",
            "cod_catastale": "B892",
            "cod_istat": "037012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2334,
            "area": "",
            "ech": 0
        },
        {
            "id": 1473,
            "name": "Casalgrande",
            "provincia": "RE",
            "cap": "42013",
            "cod_catastale": "B893",
            "cod_istat": "035012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 1474,
            "name": "Casalgrasso",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "B894",
            "cod_istat": "004045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 1475,
            "name": "Casalincontrada",
            "provincia": "CH",
            "cap": "66012",
            "cod_catastale": "B896",
            "cod_istat": "069016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 1560,
            "area": "",
            "ech": 0
        },
        {
            "id": 1476,
            "name": "Casalino",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "B897",
            "cod_istat": "003040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2590,
            "area": "",
            "ech": 0
        },
        {
            "id": 1477,
            "name": "Casalmaggiore",
            "provincia": "CR",
            "cap": "26041",
            "cod_catastale": "B898",
            "cod_istat": "019021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 1478,
            "name": "Casalmaiocco",
            "provincia": "LO",
            "cap": "26831",
            "cod_catastale": "B899",
            "cod_istat": "098009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1479,
            "name": "Casalmorano",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "B900",
            "cod_istat": "019022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1480,
            "name": "Casalmoro",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "B901",
            "cod_istat": "020010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 1481,
            "name": "Casalnoceto",
            "provincia": "AL",
            "cap": "15052",
            "cod_catastale": "B902",
            "cod_istat": "006040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 2548,
            "area": "",
            "ech": 0
        },
        {
            "id": 1482,
            "name": "Casalnuovo di Napoli",
            "provincia": "NA",
            "cap": "80013",
            "cod_catastale": "B905",
            "cod_istat": "063017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 1064,
            "area": "",
            "ech": 0
        },
        {
            "id": 1483,
            "name": "Casalnuovo Monterotaro",
            "provincia": "FG",
            "cap": "71033",
            "cod_catastale": "B904",
            "cod_istat": "071013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 432,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 1484,
            "name": "Casaloldo",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "B907",
            "cod_istat": "020011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 1485,
            "name": "Casalpusterlengo",
            "provincia": "LO",
            "cap": "26841",
            "cod_catastale": "B910",
            "cod_istat": "098010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 1486,
            "name": "Casalromano",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "B911",
            "cod_istat": "020012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 1487,
            "name": "Casalserugo",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "B912",
            "cod_istat": "028028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1488,
            "name": "Casaluce",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "B916",
            "cod_istat": "061020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1091,
            "area": "",
            "ech": 0
        },
        {
            "id": 1489,
            "name": "Casalvecchio di Puglia",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "B917",
            "cod_istat": "071014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 465,
            "giorni": 1851,
            "area": "",
            "ech": 0
        },
        {
            "id": 1490,
            "name": "Casalvecchio Siculo",
            "provincia": "ME",
            "cap": "98032",
            "cod_catastale": "B918",
            "cod_istat": "083012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1345,
            "area": "",
            "ech": 0
        },
        {
            "id": 1491,
            "name": "Casalvieri",
            "provincia": "FR",
            "cap": "03034",
            "cod_catastale": "B919",
            "cod_istat": "060018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 380,
            "giorni": 1778,
            "area": "",
            "ech": 0
        },
        {
            "id": 1492,
            "name": "Casalvolone",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "B920",
            "cod_istat": "003041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2603,
            "area": "",
            "ech": 0
        },
        {
            "id": 1493,
            "name": "Casalzuigno",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B921",
            "cod_istat": "012037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 1494,
            "name": "Casamarciano",
            "provincia": "NA",
            "cap": "80032",
            "cod_catastale": "B922",
            "cod_istat": "063018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1082,
            "area": "",
            "ech": 0
        },
        {
            "id": 1495,
            "name": "Casamassima",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "B923",
            "cod_istat": "072015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 1496,
            "name": "Casamicciola Terme",
            "provincia": "NA",
            "cap": "80074",
            "cod_catastale": "B924",
            "cod_istat": "063019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1109,
            "area": "",
            "ech": 0
        },
        {
            "id": 1497,
            "name": "Casandrino",
            "provincia": "NA",
            "cap": "80025",
            "cod_catastale": "B925",
            "cod_istat": "063020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 1244,
            "area": "",
            "ech": 0
        },
        {
            "id": 1498,
            "name": "Casanova Elvo",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "B928",
            "cod_istat": "002033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2780,
            "area": "",
            "ech": 0
        },
        {
            "id": 1499,
            "name": "Casanova Lerrone",
            "provincia": "SV",
            "cap": "17033",
            "cod_catastale": "B927",
            "cod_istat": "009019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 1929,
            "area": "",
            "ech": 0
        },
        {
            "id": 1500,
            "name": "Casanova Lonati",
            "provincia": "PV",
            "cap": "27041",
            "cod_catastale": "B929",
            "cod_istat": "018031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1501,
            "name": "Casape",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "B932",
            "cod_istat": "058021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2189,
            "area": "",
            "ech": 0
        },
        {
            "id": 1502,
            "name": "Casapesenna",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "M260",
            "cod_istat": "061103",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1257,
            "area": "",
            "ech": 0
        },
        {
            "id": 1503,
            "name": "Casapinta",
            "provincia": "BI",
            "cap": "13866",
            "cod_catastale": "B933",
            "cod_istat": "096014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 2866,
            "area": "",
            "ech": 0
        },
        {
            "id": 1504,
            "name": "Casaprota",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "B934",
            "cod_istat": "057011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 2317,
            "area": "",
            "ech": 0
        },
        {
            "id": 1505,
            "name": "Casapulla",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "B935",
            "cod_istat": "061021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 924,
            "area": "",
            "ech": 0
        },
        {
            "id": 1506,
            "name": "Casarano",
            "provincia": "LE",
            "cap": "73042",
            "cod_catastale": "B936",
            "cod_istat": "075016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 1113,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1507,
            "name": "Casargo",
            "provincia": "LC",
            "cap": "23831",
            "cod_catastale": "B937",
            "cod_istat": "097015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 804,
            "giorni": 3211,
            "area": "",
            "ech": 0
        },
        {
            "id": 1508,
            "name": "Casarile",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "B938",
            "cod_istat": "015055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 1509,
            "name": "Casarsa della Delizia",
            "provincia": "PN",
            "cap": "33072",
            "cod_catastale": "B940",
            "cod_istat": "093010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 1510,
            "name": "Casarza Ligure",
            "provincia": "GE",
            "cap": "16030",
            "cod_catastale": "B939",
            "cod_istat": "010011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1480,
            "area": "",
            "ech": 0
        },
        {
            "id": 1511,
            "name": "Casasco",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "B941",
            "cod_istat": "006041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2903,
            "area": "",
            "ech": 0
        },
        {
            "id": 1512,
            "name": "Casasco d''Intelvi",
            "provincia": "CO",
            "cap": "22022",
            "cod_catastale": "B942",
            "cod_istat": "013050",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1513,
            "name": "Casatenovo",
            "provincia": "LC",
            "cap": "23880",
            "cod_catastale": "B943",
            "cod_istat": "097016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 1514,
            "name": "Casatisma",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "B945",
            "cod_istat": "018032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 1515,
            "name": "Casavatore",
            "provincia": "NA",
            "cap": "80020",
            "cod_catastale": "B946",
            "cod_istat": "063021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1279,
            "area": "",
            "ech": 0
        },
        {
            "id": 1516,
            "name": "Casazza",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B947",
            "cod_istat": "016058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2565,
            "area": "",
            "ech": 0
        },
        {
            "id": 1517,
            "name": "Cascia",
            "provincia": "PG",
            "cap": "06043",
            "cod_catastale": "B948",
            "cod_istat": "054007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 653,
            "giorni": 2452,
            "area": "",
            "ech": 0
        },
        {
            "id": 1518,
            "name": "Casciago",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "B949",
            "cod_istat": "012038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 1519,
            "name": "Casciana Terme",
            "provincia": "PI",
            "cap": "56034",
            "cod_catastale": "A559",
            "cod_istat": "050040",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1747,
            "area": "",
            "ech": 0
        },
        {
            "id": 1520,
            "name": "Cascina",
            "provincia": "PI",
            "cap": "56021",
            "cod_catastale": "B950",
            "cod_istat": "050008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 1853,
            "area": "",
            "ech": 0
        },
        {
            "id": 1521,
            "name": "Cascinette d'Ivrea",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "B953",
            "cod_istat": "001061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 1522,
            "name": "Casei Gerola",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "B954",
            "cod_istat": "018033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1523,
            "name": "Caselette",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "B955",
            "cod_istat": "001062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2961,
            "area": "",
            "ech": 0
        },
        {
            "id": 1524,
            "name": "Casella",
            "provincia": "GE",
            "cap": "16015",
            "cod_catastale": "B956",
            "cod_istat": "010012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 1525,
            "name": "Caselle in Pittari",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "B959",
            "cod_istat": "065029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 444,
            "giorni": 1599,
            "area": "",
            "ech": 0
        },
        {
            "id": 1526,
            "name": "Caselle Landi",
            "provincia": "LO",
            "cap": "26842",
            "cod_catastale": "B961",
            "cod_istat": "098011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 1527,
            "name": "Caselle Lurani",
            "provincia": "LO",
            "cap": "26853",
            "cod_catastale": "B958",
            "cod_istat": "098012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1528,
            "name": "Caselle Torinese",
            "provincia": "TO",
            "cap": "10072",
            "cod_catastale": "B960",
            "cod_istat": "001063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2770,
            "area": "",
            "ech": 0
        },
        {
            "id": 1529,
            "name": "Caserta",
            "provincia": "CE",
            "cap": "81100",
            "cod_catastale": "B963",
            "cod_istat": "061022",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 68,
            "giorni": 1013,
            "area": "",
            "ech": 0
        },
        {
            "id": 1530,
            "name": "Casier",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "B965",
            "cod_istat": "026010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 1531,
            "name": "Casignana",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "B966",
            "cod_istat": "080024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 1187,
            "area": "",
            "ech": 1
        },
        {
            "id": 1532,
            "name": "Casina",
            "provincia": "RE",
            "cap": "42034",
            "cod_catastale": "B967",
            "cod_istat": "035013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 574,
            "giorni": 2999,
            "area": "",
            "ech": 0
        },
        {
            "id": 1533,
            "name": "Casirate d'Adda",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "B971",
            "cod_istat": "016059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1534,
            "name": "Caslino d'Erba",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "B974",
            "cod_istat": "013052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 427,
            "giorni": 2837,
            "area": "",
            "ech": 0
        },
        {
            "id": 1535,
            "name": "Casnate con Bernate",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "B977",
            "cod_istat": "013053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2555,
            "area": "",
            "ech": 0
        },
        {
            "id": 1536,
            "name": "Casnigo",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "B978",
            "cod_istat": "016060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 514,
            "giorni": 2799,
            "area": "",
            "ech": 0
        },
        {
            "id": 1537,
            "name": "Casola di Napoli",
            "provincia": "NA",
            "cap": "80050",
            "cod_catastale": "B980",
            "cod_istat": "063022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 1293,
            "area": "",
            "ech": 0
        },
        {
            "id": 1538,
            "name": "Casola in Lunigiana",
            "provincia": "MS",
            "cap": "54014",
            "cod_catastale": "B979",
            "cod_istat": "045004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 1539,
            "name": "Casola Valsenio",
            "provincia": "RA",
            "cap": "48032",
            "cod_catastale": "B982",
            "cod_istat": "039005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 1540,
            "name": "Casole Bruzio",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "B983",
            "cod_istat": "078028",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 647,
            "giorni": 2085,
            "area": "",
            "ech": 0
        },
        {
            "id": 1541,
            "name": "Casole d'Elsa",
            "provincia": "SI",
            "cap": "53031",
            "cod_catastale": "B984",
            "cod_istat": "052004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2105,
            "area": "",
            "ech": 0
        },
        {
            "id": 1542,
            "name": "Casoli",
            "provincia": "CH",
            "cap": "66043",
            "cod_catastale": "B985",
            "cod_istat": "069017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 1763,
            "area": "",
            "ech": 0
        },
        {
            "id": 1543,
            "name": "Casorate Primo",
            "provincia": "PV",
            "cap": "27022",
            "cod_catastale": "B988",
            "cod_istat": "018034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1544,
            "name": "Casorate Sempione",
            "provincia": "VA",
            "cap": "21011",
            "cod_catastale": "B987",
            "cod_istat": "012039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2938,
            "area": "",
            "ech": 0
        },
        {
            "id": 1545,
            "name": "Casorezzo",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "B989",
            "cod_istat": "015058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 166,
            "giorni": 2656,
            "area": "",
            "ech": 0
        },
        {
            "id": 1546,
            "name": "Casoria",
            "provincia": "NA",
            "cap": "80026",
            "cod_catastale": "B990",
            "cod_istat": "063023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1263,
            "area": "",
            "ech": 0
        },
        {
            "id": 1547,
            "name": "Casorzo",
            "provincia": "AT",
            "cap": "14032",
            "cod_catastale": "B991",
            "cod_istat": "005020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 1548,
            "name": "Casperia",
            "provincia": "RI",
            "cap": "02041",
            "cod_catastale": "A472",
            "cod_istat": "057012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2087,
            "area": "",
            "ech": 0
        },
        {
            "id": 1549,
            "name": "Caspoggio",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "B993",
            "cod_istat": "014013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1098,
            "giorni": 3629,
            "area": "",
            "ech": 0
        },
        {
            "id": 1550,
            "name": "Cassacco",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "B994",
            "cod_istat": "030019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2415,
            "area": "",
            "ech": 0
        },
        {
            "id": 1551,
            "name": "Cassago Brianza",
            "provincia": "LC",
            "cap": "23893",
            "cod_catastale": "B996",
            "cod_istat": "097017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 1552,
            "name": "Cassano all'Ionio",
            "provincia": "CS",
            "cap": "87011",
            "cod_catastale": "C002",
            "cod_istat": "078029",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 1
        },
        {
            "id": 1553,
            "name": "Cassano d'Adda",
            "provincia": "MI",
            "cap": "20062",
            "cod_catastale": "C003",
            "cod_istat": "015059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 1554,
            "name": "Cassano delle Murge",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "B998",
            "cod_istat": "072016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 341,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 1555,
            "name": "Cassano Irpino",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "B997",
            "cod_istat": "064021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 510,
            "giorni": 2010,
            "area": "",
            "ech": 0
        },
        {
            "id": 1556,
            "name": "Cassano Magnago",
            "provincia": "VA",
            "cap": "21012",
            "cod_catastale": "C004",
            "cod_istat": "012040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 1557,
            "name": "Cassano Spinola",
            "provincia": "AL",
            "cap": "15063",
            "cod_catastale": "M388",
            "cod_istat": "006191",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 1558,
            "name": "Cassano Valcuvia",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B999",
            "cod_istat": "012041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2534,
            "area": "",
            "ech": 0
        },
        {
            "id": 1559,
            "name": "Cassaro",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "C006",
            "cod_istat": "089007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1409,
            "area": "",
            "ech": 0
        },
        {
            "id": 1560,
            "name": "Cassiglio",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "C007",
            "cod_istat": "016061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 1561,
            "name": "Cassina de' Pecchi",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "C014",
            "cod_istat": "015060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 1562,
            "name": "Cassina Rizzardi",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "C020",
            "cod_istat": "013055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 1563,
            "name": "Cassina Valsassina",
            "provincia": "LC",
            "cap": "23817",
            "cod_catastale": "C024",
            "cod_istat": "097018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 849,
            "giorni": 3272,
            "area": "",
            "ech": 0
        },
        {
            "id": 1564,
            "name": "Cassinasco",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "C022",
            "cod_istat": "005021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 447,
            "giorni": 2858,
            "area": "",
            "ech": 0
        },
        {
            "id": 1565,
            "name": "Cassine",
            "provincia": "AL",
            "cap": "15016",
            "cod_catastale": "C027",
            "cod_istat": "006043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 1566,
            "name": "Cassinelle",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "C030",
            "cod_istat": "006044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 1567,
            "name": "Cassinetta di Lugagnano",
            "provincia": "MI",
            "cap": "20081",
            "cod_catastale": "C033",
            "cod_istat": "015061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2532,
            "area": "",
            "ech": 0
        },
        {
            "id": 1568,
            "name": "Cassino",
            "provincia": "FR",
            "cap": "03043",
            "cod_catastale": "C034",
            "cod_istat": "060019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1164,
            "area": "",
            "ech": 0
        },
        {
            "id": 1569,
            "name": "Cassola",
            "provincia": "VI",
            "cap": "36022",
            "cod_catastale": "C037",
            "cod_istat": "024026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2412,
            "area": "",
            "ech": 0
        },
        {
            "id": 1570,
            "name": "Cassolnovo",
            "provincia": "PV",
            "cap": "27023",
            "cod_catastale": "C038",
            "cod_istat": "018035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 1571,
            "name": "Castagnaro",
            "provincia": "VR",
            "cap": "37043",
            "cod_catastale": "C041",
            "cod_istat": "023020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 1572,
            "name": "Castagneto Carducci",
            "provincia": "LI",
            "cap": "57022",
            "cod_catastale": "C044",
            "cod_istat": "049006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 1432,
            "area": "",
            "ech": 0
        },
        {
            "id": 1573,
            "name": "Castagneto Po",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "C045",
            "cod_istat": "001064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 473,
            "giorni": 3063,
            "area": "",
            "ech": 0
        },
        {
            "id": 1574,
            "name": "Castagnito",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "C046",
            "cod_istat": "004046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2602,
            "area": "",
            "ech": 0
        },
        {
            "id": 1575,
            "name": "Castagnole delle Lanze",
            "provincia": "AT",
            "cap": "14054",
            "cod_catastale": "C049",
            "cod_istat": "005022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 1576,
            "name": "Castagnole Monferrato",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "C047",
            "cod_istat": "005023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2677,
            "area": "",
            "ech": 0
        },
        {
            "id": 1577,
            "name": "Castagnole Piemonte",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "C048",
            "cod_istat": "001065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2762,
            "area": "",
            "ech": 0
        },
        {
            "id": 1578,
            "name": "Castana",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "C050",
            "cod_istat": "018036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2968,
            "area": "",
            "ech": 0
        },
        {
            "id": 1579,
            "name": "Castano Primo",
            "provincia": "MI",
            "cap": "20022",
            "cod_catastale": "C052",
            "cod_istat": "015062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 1580,
            "name": "Casteggio",
            "provincia": "PV",
            "cap": "27045",
            "cod_catastale": "C053",
            "cod_istat": "018037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1581,
            "name": "Castegnato",
            "provincia": "BS",
            "cap": "25045",
            "cod_catastale": "C055",
            "cod_istat": "017040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1582,
            "name": "Castegnero",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "C056",
            "cod_istat": "024027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2304,
            "area": "",
            "ech": 0
        },
        {
            "id": 1583,
            "name": "Castel Baronia",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "C058",
            "cod_istat": "064022",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 639,
            "giorni": 2231,
            "area": "",
            "ech": 0
        },
        {
            "id": 1584,
            "name": "Castel Boglione",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "C064",
            "cod_istat": "005024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 1585,
            "name": "Castel Bolognese",
            "provincia": "RA",
            "cap": "48014",
            "cod_catastale": "C065",
            "cod_istat": "039006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 1586,
            "name": "Castel Campagnano",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "B494",
            "cod_istat": "061023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 1158,
            "area": "",
            "ech": 0
        },
        {
            "id": 1587,
            "name": "Castel Castagna",
            "provincia": "TE",
            "cap": "64030",
            "cod_catastale": "C040",
            "cod_istat": "067010",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 452,
            "giorni": 2104,
            "area": "",
            "ech": 0
        },
        {
            "id": 1588,
            "name": "Castel Colonna",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "C071",
            "cod_istat": "042009",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1823,
            "area": "",
            "ech": 0
        },
        {
            "id": 1589,
            "name": "Castel Condino",
            "provincia": "TN",
            "cap": "38082",
            "cod_catastale": "C183",
            "cod_istat": "022045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 811,
            "giorni": 3656,
            "area": "",
            "ech": 0
        },
        {
            "id": 1590,
            "name": "Castel d'Aiano",
            "provincia": "BO",
            "cap": "40034",
            "cod_catastale": "C075",
            "cod_istat": "037013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 805,
            "giorni": 3300,
            "area": "",
            "ech": 0
        },
        {
            "id": 1591,
            "name": "Castel d'Ario",
            "provincia": "MN",
            "cap": "46033",
            "cod_catastale": "C076",
            "cod_istat": "020014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 1592,
            "name": "Castel d'Azzano",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "C078",
            "cod_istat": "023021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 1593,
            "name": "Castel del Giudice",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "C082",
            "cod_istat": "094009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 1594,
            "name": "Castel del Monte",
            "provincia": "AQ",
            "cap": "67023",
            "cod_catastale": "C083",
            "cod_istat": "066026",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1346,
            "giorni": 3428,
            "area": "",
            "ech": 0
        },
        {
            "id": 1595,
            "name": "Castel del Piano",
            "provincia": "GR",
            "cap": "58033",
            "cod_catastale": "C085",
            "cod_istat": "053004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 637,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 1596,
            "name": "Castel del Rio",
            "provincia": "BO",
            "cap": "40022",
            "cod_catastale": "C086",
            "cod_istat": "037014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 1597,
            "name": "Castel di Casio",
            "provincia": "BO",
            "cap": "40030",
            "cod_catastale": "B969",
            "cod_istat": "037015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 533,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 1598,
            "name": "Castel di Ieri",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "C090",
            "cod_istat": "066027",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 519,
            "giorni": 2217,
            "area": "",
            "ech": 0
        },
        {
            "id": 1599,
            "name": "Castel di Iudica",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "C091",
            "cod_istat": "087013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 1349,
            "area": "",
            "ech": 1
        },
        {
            "id": 1600,
            "name": "Castel di Lama",
            "provincia": "AP",
            "cap": "63082",
            "cod_catastale": "C093",
            "cod_istat": "044011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 1875,
            "area": "",
            "ech": 0
        },
        {
            "id": 1601,
            "name": "Castel di Lucio",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "C094",
            "cod_istat": "083013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 753,
            "giorni": 1914,
            "area": "",
            "ech": 0
        },
        {
            "id": 1602,
            "name": "Castel di Sangro",
            "provincia": "AQ",
            "cap": "67031",
            "cod_catastale": "C096",
            "cod_istat": "066028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 793,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 1603,
            "name": "Castel di Sasso",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "C097",
            "cod_istat": "061024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1446,
            "area": "",
            "ech": 0
        },
        {
            "id": 1604,
            "name": "Castel di Tora",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "C098",
            "cod_istat": "057013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 607,
            "giorni": 2469,
            "area": "",
            "ech": 0
        },
        {
            "id": 1605,
            "name": "Castel Focognano",
            "provincia": "AR",
            "cap": "52016",
            "cod_catastale": "C102",
            "cod_istat": "051008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2109,
            "area": "",
            "ech": 0
        },
        {
            "id": 1606,
            "name": "Castel Frentano",
            "provincia": "CH",
            "cap": "66032",
            "cod_catastale": "C114",
            "cod_istat": "069018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1795,
            "area": "",
            "ech": 0
        },
        {
            "id": 1607,
            "name": "Castel Gabbiano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "C115",
            "cod_istat": "019024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1608,
            "name": "Castel Gandolfo",
            "provincia": "RM",
            "cap": "00073",
            "cod_catastale": "C116",
            "cod_istat": "058022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 1966,
            "area": "",
            "ech": 0
        },
        {
            "id": 1609,
            "name": "Castel Giorgio",
            "provincia": "TR",
            "cap": "05013",
            "cod_catastale": "C117",
            "cod_istat": "055009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 559,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 1610,
            "name": "Castel Goffredo",
            "provincia": "MN",
            "cap": "46042",
            "cod_catastale": "C118",
            "cod_istat": "020015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 1611,
            "name": "Castel Guelfo di Bologna",
            "provincia": "BO",
            "cap": "40023",
            "cod_catastale": "C121",
            "cod_istat": "037016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 1612,
            "name": "Castel Madama",
            "provincia": "RM",
            "cap": "00024",
            "cod_catastale": "C203",
            "cod_istat": "058023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 2104,
            "area": "",
            "ech": 0
        },
        {
            "id": 1613,
            "name": "Castel Maggiore",
            "provincia": "BO",
            "cap": "40013",
            "cod_catastale": "C204",
            "cod_istat": "037019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2224,
            "area": "",
            "ech": 0
        },
        {
            "id": 1614,
            "name": "Castel Mella",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "C208",
            "cod_istat": "017042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1615,
            "name": "Castel Morrone",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "C211",
            "cod_istat": "061026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 1616,
            "name": "Castel Ritaldi",
            "provincia": "PG",
            "cap": "06044",
            "cod_catastale": "C252",
            "cod_istat": "054008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2109,
            "area": "",
            "ech": 0
        },
        {
            "id": 1617,
            "name": "Castel Rocchero",
            "provincia": "AT",
            "cap": "14044",
            "cod_catastale": "C253",
            "cod_istat": "005032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2830,
            "area": "",
            "ech": 0
        },
        {
            "id": 1618,
            "name": "Castel Rozzone",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "C255",
            "cod_istat": "016063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1619,
            "name": "Castel San Giorgio",
            "provincia": "SA",
            "cap": "84083",
            "cod_catastale": "C259",
            "cod_istat": "065034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1253,
            "area": "",
            "ech": 0
        },
        {
            "id": 1620,
            "name": "Castel San Giovanni",
            "provincia": "PC",
            "cap": "29015",
            "cod_catastale": "C261",
            "cod_istat": "033013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 1621,
            "name": "Castel San Lorenzo",
            "provincia": "SA",
            "cap": "84049",
            "cod_catastale": "C262",
            "cod_istat": "065035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 1585,
            "area": "",
            "ech": 0
        },
        {
            "id": 1622,
            "name": "Castel San Niccolò",
            "provincia": "AR",
            "cap": "52018",
            "cod_catastale": "C263",
            "cod_istat": "051010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2170,
            "area": "",
            "ech": 0
        },
        {
            "id": 1623,
            "name": "Castel San Pietro Romano",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "C266",
            "cod_istat": "058025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 752,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 1624,
            "name": "Castel San Pietro Terme",
            "provincia": "BO",
            "cap": "40024",
            "cod_catastale": "C265",
            "cod_istat": "037020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2263,
            "area": "",
            "ech": 0
        },
        {
            "id": 1625,
            "name": "Castel San Vincenzo",
            "provincia": "IS",
            "cap": "86071",
            "cod_catastale": "C270",
            "cod_istat": "094012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 749,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 1626,
            "name": "Castel Sant'Angelo",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "C268",
            "cod_istat": "057015",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 581,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 1627,
            "name": "Castel Sant'Elia",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "C269",
            "cod_istat": "056017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1794,
            "area": "",
            "ech": 0
        },
        {
            "id": 1628,
            "name": "Castel Viscardo",
            "provincia": "TR",
            "cap": "05014",
            "cod_catastale": "C289",
            "cod_istat": "055010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 507,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 1629,
            "name": "Castel Vittorio",
            "provincia": "IM",
            "cap": "18030",
            "cod_catastale": "C110",
            "cod_istat": "008015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2143,
            "area": "",
            "ech": 0
        },
        {
            "id": 1630,
            "name": "Castel Volturno",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "C291",
            "cod_istat": "061027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1124,
            "area": "",
            "ech": 0
        },
        {
            "id": 1631,
            "name": "Castelbaldo",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "C057",
            "cod_istat": "028029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1632,
            "name": "Castelbelforte",
            "provincia": "MN",
            "cap": "46032",
            "cod_catastale": "C059",
            "cod_istat": "020013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 1633,
            "name": "Castelbellino",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "C060",
            "cod_istat": "042008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2068,
            "area": "",
            "ech": 0
        },
        {
            "id": 1634,
            "name": "Castelbello-Ciardes",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "C062",
            "cod_istat": "021018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 587,
            "giorni": 3267,
            "area": "",
            "ech": 0
        },
        {
            "id": 1635,
            "name": "Castelbianco",
            "provincia": "SV",
            "cap": "17030",
            "cod_catastale": "C063",
            "cod_istat": "009020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 2126,
            "area": "",
            "ech": 0
        },
        {
            "id": 1636,
            "name": "Castelbottaccio",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "C066",
            "cod_istat": "070013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 618,
            "giorni": 2156,
            "area": "",
            "ech": 0
        },
        {
            "id": 1637,
            "name": "Castelbuono",
            "provincia": "PA",
            "cap": "90013",
            "cod_catastale": "C067",
            "cod_istat": "082022",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 423,
            "giorni": 1321,
            "area": "",
            "ech": 0
        },
        {
            "id": 1638,
            "name": "Castelcivita",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "C069",
            "cod_istat": "065030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 487,
            "giorni": 1746,
            "area": "",
            "ech": 0
        },
        {
            "id": 1639,
            "name": "Castelcovati",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "C072",
            "cod_istat": "017041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1640,
            "name": "Castelcucco",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "C073",
            "cod_istat": "026011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2660,
            "area": "",
            "ech": 0
        },
        {
            "id": 1641,
            "name": "Casteldaccia",
            "provincia": "PA",
            "cap": "90014",
            "cod_catastale": "C074",
            "cod_istat": "082023",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 879,
            "area": "",
            "ech": 0
        },
        {
            "id": 1642,
            "name": "Casteldelci",
            "provincia": "RN",
            "cap": "47861",
            "cod_catastale": "C080",
            "cod_istat": "099021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 618,
            "giorni": 2572,
            "area": "",
            "ech": 0
        },
        {
            "id": 1643,
            "name": "Casteldelfino",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "C081",
            "cod_istat": "004047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1296,
            "giorni": 4107,
            "area": "",
            "ech": 0
        },
        {
            "id": 1644,
            "name": "Casteldidone",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "C089",
            "cod_istat": "019023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1645,
            "name": "Castelfidardo",
            "provincia": "AN",
            "cap": "60022",
            "cod_catastale": "C100",
            "cod_istat": "042010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1881,
            "area": "",
            "ech": 0
        },
        {
            "id": 1646,
            "name": "Castelfiorentino",
            "provincia": "FI",
            "cap": "50051",
            "cod_catastale": "C101",
            "cod_istat": "048010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1692,
            "area": "",
            "ech": 0
        },
        {
            "id": 1647,
            "name": "Castelfondo",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "C103",
            "cod_istat": "022046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 948,
            "giorni": 3870,
            "area": "",
            "ech": 0
        },
        {
            "id": 1648,
            "name": "Castelforte",
            "provincia": "LT",
            "cap": "04021",
            "cod_catastale": "C104",
            "cod_istat": "059004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 1313,
            "area": "",
            "ech": 0
        },
        {
            "id": 1649,
            "name": "Castelfranci",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "C105",
            "cod_istat": "064023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1993,
            "area": "",
            "ech": 0
        },
        {
            "id": 1650,
            "name": "Castelfranco di Sopra",
            "provincia": "AR",
            "cap": "52020",
            "cod_catastale": "C112",
            "cod_istat": "051009",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2064,
            "area": "",
            "ech": 0
        },
        {
            "id": 1651,
            "name": "Castelfranco di Sotto",
            "provincia": "PI",
            "cap": "56022",
            "cod_catastale": "C113",
            "cod_istat": "050009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1864,
            "area": "",
            "ech": 0
        },
        {
            "id": 1652,
            "name": "Castelfranco Emilia",
            "provincia": "MO",
            "cap": "41013",
            "cod_catastale": "C107",
            "cod_istat": "036006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 1653,
            "name": "Castelfranco in Miscano",
            "provincia": "BN",
            "cap": "82022",
            "cod_catastale": "C106",
            "cod_istat": "062016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 760,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 1654,
            "name": "Castelfranco Veneto",
            "provincia": "TV",
            "cap": "31033",
            "cod_catastale": "C111",
            "cod_istat": "026012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2429,
            "area": "",
            "ech": 0
        },
        {
            "id": 1655,
            "name": "Castelgomberto",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "C119",
            "cod_istat": "024028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 1656,
            "name": "Castelgrande",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "C120",
            "cod_istat": "076021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 950,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 1657,
            "name": "Castelguglielmo",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "C122",
            "cod_istat": "029011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1658,
            "name": "Castelguidone",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "C123",
            "cod_istat": "069019",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 775,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 1659,
            "name": "Castellabate",
            "provincia": "SA",
            "cap": "84048",
            "cod_catastale": "C125",
            "cod_istat": "065031",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 35,
            "giorni": 1088,
            "area": "",
            "ech": 0
        },
        {
            "id": 1660,
            "name": "Castellafiume",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "C126",
            "cod_istat": "066029",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 840,
            "giorni": 2792,
            "area": "",
            "ech": 0
        },
        {
            "id": 1661,
            "name": "Castell'Alfero",
            "provincia": "AT",
            "cap": "14033",
            "cod_catastale": "C127",
            "cod_istat": "005025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 1662,
            "name": "Castellalto",
            "provincia": "TE",
            "cap": "64020",
            "cod_catastale": "C128",
            "cod_istat": "067011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 481,
            "giorni": 2134,
            "area": "",
            "ech": 0
        },
        {
            "id": 1663,
            "name": "Castellammare del Golfo",
            "provincia": "TP",
            "cap": "91014",
            "cod_catastale": "C130",
            "cod_istat": "081005",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 820,
            "area": "",
            "ech": 0
        },
        {
            "id": 1664,
            "name": "Castellammare di Stabia",
            "provincia": "NA",
            "cap": "80053",
            "cod_catastale": "C129",
            "cod_istat": "063024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1095,
            "area": "",
            "ech": 0
        },
        {
            "id": 1665,
            "name": "Castellamonte",
            "provincia": "TO",
            "cap": "10081",
            "cod_catastale": "C133",
            "cod_istat": "001066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 1666,
            "name": "Castellana Grotte",
            "provincia": "BA",
            "cap": "70013",
            "cod_catastale": "C134",
            "cod_istat": "072017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 1673,
            "area": "",
            "ech": 0
        },
        {
            "id": 1667,
            "name": "Castellana Sicula",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "C135",
            "cod_istat": "082024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 765,
            "giorni": 1835,
            "area": "",
            "ech": 0
        },
        {
            "id": 1668,
            "name": "Castellaneta",
            "provincia": "TA",
            "cap": "74011",
            "cod_catastale": "C136",
            "cod_istat": "073003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 1534,
            "area": "",
            "ech": 0
        },
        {
            "id": 1669,
            "name": "Castellania",
            "provincia": "AL",
            "cap": "15051",
            "cod_catastale": "C137",
            "cod_istat": "006045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2818,
            "area": "",
            "ech": 0
        },
        {
            "id": 1670,
            "name": "Castellanza",
            "provincia": "VA",
            "cap": "21053",
            "cod_catastale": "C139",
            "cod_istat": "012042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2847,
            "area": "",
            "ech": 0
        },
        {
            "id": 1671,
            "name": "Castellar",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "C140",
            "cod_istat": "004048",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 1672,
            "name": "Castellar Guidobono",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "C142",
            "cod_istat": "006046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 1673,
            "name": "Castellarano",
            "provincia": "RE",
            "cap": "42014",
            "cod_catastale": "C141",
            "cod_istat": "035014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1674,
            "name": "Castellaro",
            "provincia": "IM",
            "cap": "18011",
            "cod_catastale": "C143",
            "cod_istat": "008014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1782,
            "area": "",
            "ech": 0
        },
        {
            "id": 1675,
            "name": "Castell'Arquato",
            "provincia": "PC",
            "cap": "29014",
            "cod_catastale": "C145",
            "cod_istat": "033012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 1676,
            "name": "Castellavazzo",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "C146",
            "cod_istat": "025009",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1677,
            "name": "Castell'Azzara",
            "provincia": "GR",
            "cap": "58034",
            "cod_catastale": "C147",
            "cod_istat": "053005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 815,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 1678,
            "name": "Castellazzo Bormida",
            "provincia": "AL",
            "cap": "15073",
            "cod_catastale": "C148",
            "cod_istat": "006047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2567,
            "area": "",
            "ech": 0
        },
        {
            "id": 1679,
            "name": "Castellazzo Novarese",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "C149",
            "cod_istat": "003042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 1680,
            "name": "Castelleone",
            "provincia": "CR",
            "cap": "26012",
            "cod_catastale": "C153",
            "cod_istat": "019025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1681,
            "name": "Castelleone di Suasa",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "C152",
            "cod_istat": "042011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 1966,
            "area": "",
            "ech": 0
        },
        {
            "id": 1682,
            "name": "Castellero",
            "provincia": "AT",
            "cap": "14013",
            "cod_catastale": "C154",
            "cod_istat": "005026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2690,
            "area": "",
            "ech": 0
        },
        {
            "id": 1683,
            "name": "Castelletto Cervo",
            "provincia": "BI",
            "cap": "13851",
            "cod_catastale": "C155",
            "cod_istat": "096015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2585,
            "area": "",
            "ech": 0
        },
        {
            "id": 1684,
            "name": "Castelletto d'Erro",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "C156",
            "cod_istat": "006048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 544,
            "giorni": 2939,
            "area": "",
            "ech": 0
        },
        {
            "id": 1685,
            "name": "Castelletto di Branduzzo",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "C157",
            "cod_istat": "018038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 1686,
            "name": "Castelletto d'Orba",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "C158",
            "cod_istat": "006049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2650,
            "area": "",
            "ech": 0
        },
        {
            "id": 1687,
            "name": "Castelletto Merli",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "C160",
            "cod_istat": "006050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2707,
            "area": "",
            "ech": 0
        },
        {
            "id": 1688,
            "name": "Castelletto Molina",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "C161",
            "cod_istat": "005027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 1689,
            "name": "Castelletto Monferrato",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "C162",
            "cod_istat": "006051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2648,
            "area": "",
            "ech": 0
        },
        {
            "id": 1690,
            "name": "Castelletto sopra Ticino",
            "provincia": "NO",
            "cap": "28053",
            "cod_catastale": "C166",
            "cod_istat": "003043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2598,
            "area": "",
            "ech": 0
        },
        {
            "id": 1691,
            "name": "Castelletto Stura",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "C165",
            "cod_istat": "004049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 447,
            "giorni": 2869,
            "area": "",
            "ech": 0
        },
        {
            "id": 1692,
            "name": "Castelletto Uzzone",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "C167",
            "cod_istat": "004050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2842,
            "area": "",
            "ech": 0
        },
        {
            "id": 1693,
            "name": "Castelli",
            "provincia": "TE",
            "cap": "64041",
            "cod_catastale": "C169",
            "cod_istat": "067012",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 497,
            "giorni": 2185,
            "area": "",
            "ech": 0
        },
        {
            "id": 1694,
            "name": "Castelli Calepio",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "C079",
            "cod_istat": "016062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 1695,
            "name": "Castellina in Chianti",
            "provincia": "SI",
            "cap": "53011",
            "cod_catastale": "C172",
            "cod_istat": "052005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 578,
            "giorni": 2326,
            "area": "",
            "ech": 0
        },
        {
            "id": 1696,
            "name": "Castellina Marittima",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "C174",
            "cod_istat": "050010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2054,
            "area": "",
            "ech": 0
        },
        {
            "id": 1697,
            "name": "Castellinaldo d'Alba",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "C173",
            "cod_istat": "004051",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1698,
            "name": "Castellino del Biferno",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "C175",
            "cod_istat": "070014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1916,
            "area": "",
            "ech": 0
        },
        {
            "id": 1699,
            "name": "Castellino Tanaro",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "C176",
            "cod_istat": "004052",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 613,
            "giorni": 3075,
            "area": "",
            "ech": 0
        },
        {
            "id": 1700,
            "name": "Castelliri",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "C177",
            "cod_istat": "060020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2080,
            "area": "",
            "ech": 0
        },
        {
            "id": 1701,
            "name": "Castello Cabiaglio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "B312",
            "cod_istat": "012043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 514,
            "giorni": 2756,
            "area": "",
            "ech": 0
        },
        {
            "id": 1702,
            "name": "Castello d'Agogna",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "C184",
            "cod_istat": "018039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 1703,
            "name": "Castello d'Argile",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "C185",
            "cod_istat": "037017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2189,
            "area": "",
            "ech": 0
        },
        {
            "id": 1704,
            "name": "Castello del Matese",
            "provincia": "CE",
            "cap": "81016",
            "cod_catastale": "C178",
            "cod_istat": "061025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 476,
            "giorni": 2006,
            "area": "",
            "ech": 0
        },
        {
            "id": 1705,
            "name": "Castello dell'Acqua",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "C186",
            "cod_istat": "014014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 3012,
            "area": "",
            "ech": 0
        },
        {
            "id": 1706,
            "name": "Castello di Annone",
            "provincia": "AT",
            "cap": "14034",
            "cod_catastale": "A300",
            "cod_istat": "005028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 1707,
            "name": "Castello di Brianza",
            "provincia": "LC",
            "cap": "23884",
            "cod_catastale": "C187",
            "cod_istat": "097019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2538,
            "area": "",
            "ech": 0
        },
        {
            "id": 1708,
            "name": "Castello di Cisterna",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "C188",
            "cod_istat": "063025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1021,
            "area": "",
            "ech": 0
        },
        {
            "id": 1709,
            "name": "Castello di Godego",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "C190",
            "cod_istat": "026013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 2443,
            "area": "",
            "ech": 0
        },
        {
            "id": 1710,
            "name": "Castello di Serravalle",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "C191",
            "cod_istat": "037018",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2415,
            "area": "",
            "ech": 0
        },
        {
            "id": 1711,
            "name": "Castello Tesino",
            "provincia": "TN",
            "cap": "38053",
            "cod_catastale": "C194",
            "cod_istat": "022048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 871,
            "giorni": 3750,
            "area": "",
            "ech": 0
        },
        {
            "id": 1712,
            "name": "Castello-Molina di Fiemme",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "C189",
            "cod_istat": "022047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1005,
            "giorni": 3955,
            "area": "",
            "ech": 0
        },
        {
            "id": 1713,
            "name": "Castellucchio",
            "provincia": "MN",
            "cap": "46014",
            "cod_catastale": "C195",
            "cod_istat": "020016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 1714,
            "name": "Castelluccio dei Sauri",
            "provincia": "FG",
            "cap": "71025",
            "cod_catastale": "C198",
            "cod_istat": "071015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 1726,
            "area": "",
            "ech": 0
        },
        {
            "id": 1715,
            "name": "Castelluccio Inferiore",
            "provincia": "PZ",
            "cap": "85040",
            "cod_catastale": "C199",
            "cod_istat": "076022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 1809,
            "area": "",
            "ech": 0
        },
        {
            "id": 1716,
            "name": "Castelluccio Superiore",
            "provincia": "PZ",
            "cap": "85040",
            "cod_catastale": "C201",
            "cod_istat": "076023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 1717,
            "name": "Castelluccio Valmaggiore",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "C202",
            "cod_istat": "071016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 630,
            "giorni": 2035,
            "area": "",
            "ech": 0
        },
        {
            "id": 1718,
            "name": "Castell'Umberto",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "C051",
            "cod_istat": "083014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 660,
            "giorni": 1755,
            "area": "",
            "ech": 1
        },
        {
            "id": 1719,
            "name": "Castelmagno",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "C205",
            "cod_istat": "004053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1141,
            "giorni": 3730,
            "area": "",
            "ech": 0
        },
        {
            "id": 1720,
            "name": "Castelmarte",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "C206",
            "cod_istat": "013058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 2882,
            "area": "",
            "ech": 0
        },
        {
            "id": 1721,
            "name": "Castelmassa",
            "provincia": "RO",
            "cap": "45035",
            "cod_catastale": "C207",
            "cod_istat": "029012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1722,
            "name": "Castelmauro",
            "provincia": "CB",
            "cap": "86031",
            "cod_catastale": "C197",
            "cod_istat": "070015",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 692,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 1723,
            "name": "Castelmezzano",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "C209",
            "cod_istat": "076024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 1724,
            "name": "Castelmola",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "C210",
            "cod_istat": "083015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 529,
            "giorni": 1504,
            "area": "",
            "ech": 1
        },
        {
            "id": 1725,
            "name": "Castelnovetto",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "C213",
            "cod_istat": "018040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 1726,
            "name": "Castelnovo Bariano",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "C215",
            "cod_istat": "029013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1727,
            "name": "Castelnovo del Friuli",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "C217",
            "cod_istat": "093011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2818,
            "area": "",
            "ech": 0
        },
        {
            "id": 1728,
            "name": "Castelnovo di Sotto",
            "provincia": "RE",
            "cap": "42024",
            "cod_catastale": "C218",
            "cod_istat": "035015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 1729,
            "name": "Castelnovo ne' Monti",
            "provincia": "RE",
            "cap": "42035",
            "cod_catastale": "C219",
            "cod_istat": "035016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 3182,
            "area": "",
            "ech": 0
        },
        {
            "id": 1730,
            "name": "Castelnuovo",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "C216",
            "cod_istat": "022049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 348,
            "giorni": 2934,
            "area": "",
            "ech": 0
        },
        {
            "id": 1731,
            "name": "Castelnuovo Belbo",
            "provincia": "AT",
            "cap": "14043",
            "cod_catastale": "C226",
            "cod_istat": "005029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2511,
            "area": "",
            "ech": 0
        },
        {
            "id": 1732,
            "name": "Castelnuovo Berardenga",
            "provincia": "SI",
            "cap": "53019",
            "cod_catastale": "C227",
            "cod_istat": "052006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 2099,
            "area": "",
            "ech": 0
        },
        {
            "id": 1733,
            "name": "Castelnuovo Bocca d'Adda",
            "provincia": "LO",
            "cap": "26843",
            "cod_catastale": "C228",
            "cod_istat": "098013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 1734,
            "name": "Castelnuovo Bormida",
            "provincia": "AL",
            "cap": "15017",
            "cod_catastale": "C229",
            "cod_istat": "006052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2585,
            "area": "",
            "ech": 0
        },
        {
            "id": 1735,
            "name": "Castelnuovo Bozzente",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "C220",
            "cod_istat": "013059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 1736,
            "name": "Castelnuovo Calcea",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "C230",
            "cod_istat": "005030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 1737,
            "name": "Castelnuovo Cilento",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "C231",
            "cod_istat": "065032",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 280,
            "giorni": 1354,
            "area": "",
            "ech": 0
        },
        {
            "id": 1738,
            "name": "Castelnuovo del Garda",
            "provincia": "VR",
            "cap": "37014",
            "cod_catastale": "C225",
            "cod_istat": "023022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2626,
            "area": "",
            "ech": 0
        },
        {
            "id": 1739,
            "name": "Castelnuovo della Daunia",
            "provincia": "FG",
            "cap": "71034",
            "cod_catastale": "C222",
            "cod_istat": "071017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 543,
            "giorni": 1958,
            "area": "",
            "ech": 0
        },
        {
            "id": 1740,
            "name": "Castelnuovo di Ceva",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "C214",
            "cod_istat": "004054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 743,
            "giorni": 3236,
            "area": "",
            "ech": 0
        },
        {
            "id": 1741,
            "name": "Castelnuovo di Conza",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "C235",
            "cod_istat": "065033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2127,
            "area": "",
            "ech": 0
        },
        {
            "id": 1742,
            "name": "Castelnuovo di Farfa",
            "provincia": "RI",
            "cap": "02031",
            "cod_catastale": "C224",
            "cod_istat": "057014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 1743,
            "name": "Castelnuovo di Garfagnana",
            "provincia": "LU",
            "cap": "55032",
            "cod_catastale": "C236",
            "cod_istat": "046009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 1744,
            "name": "Castelnuovo di Porto",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "C237",
            "cod_istat": "058024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1733,
            "area": "",
            "ech": 0
        },
        {
            "id": 1745,
            "name": "Castelnuovo di Val di Cecina",
            "provincia": "PI",
            "cap": "56041",
            "cod_catastale": "C244",
            "cod_istat": "050011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 576,
            "giorni": 2144,
            "area": "",
            "ech": 0
        },
        {
            "id": 1746,
            "name": "Castelnuovo Don Bosco",
            "provincia": "AT",
            "cap": "14022",
            "cod_catastale": "C232",
            "cod_istat": "005031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 1747,
            "name": "Castelnuovo Magra",
            "provincia": "SP",
            "cap": "19033",
            "cod_catastale": "C240",
            "cod_istat": "011011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 181,
            "giorni": 1755,
            "area": "",
            "ech": 0
        },
        {
            "id": 1748,
            "name": "Castelnuovo Nigra",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C241",
            "cod_istat": "001067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 828,
            "giorni": 3483,
            "area": "",
            "ech": 0
        },
        {
            "id": 1749,
            "name": "Castelnuovo Parano",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "C223",
            "cod_istat": "060021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1698,
            "area": "",
            "ech": 0
        },
        {
            "id": 1750,
            "name": "Castelnuovo Rangone",
            "provincia": "MO",
            "cap": "41051",
            "cod_catastale": "C242",
            "cod_istat": "036007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2317,
            "area": "",
            "ech": 0
        },
        {
            "id": 1751,
            "name": "Castelnuovo Scrivia",
            "provincia": "AL",
            "cap": "15053",
            "cod_catastale": "C243",
            "cod_istat": "006053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 1752,
            "name": "Castelpagano",
            "provincia": "BN",
            "cap": "82024",
            "cod_catastale": "C245",
            "cod_istat": "062017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2217,
            "area": "",
            "ech": 0
        },
        {
            "id": 1753,
            "name": "Castelpetroso",
            "provincia": "IS",
            "cap": "86090",
            "cod_catastale": "C246",
            "cod_istat": "094010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 872,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 1754,
            "name": "Castelpizzuto",
            "provincia": "IS",
            "cap": "86090",
            "cod_catastale": "C247",
            "cod_istat": "094011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 836,
            "giorni": 2358,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1755,
            "name": "Castelplanio",
            "provincia": "AN",
            "cap": "60031",
            "cod_catastale": "C248",
            "cod_istat": "042012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 1756,
            "name": "Castelpoto",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "C250",
            "cod_istat": "062018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1603,
            "area": "",
            "ech": 0
        },
        {
            "id": 1757,
            "name": "Castelraimondo",
            "provincia": "MC",
            "cap": "62022",
            "cod_catastale": "C251",
            "cod_istat": "043009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 1999,
            "area": "",
            "ech": 0
        },
        {
            "id": 1758,
            "name": "Castelrotto",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "C254",
            "cod_istat": "021019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1060,
            "giorni": 4108,
            "area": "",
            "ech": 0
        },
        {
            "id": 1759,
            "name": "Castelsantangelo sul Nera",
            "provincia": "MC",
            "cap": "62039",
            "cod_catastale": "C267",
            "cod_istat": "043010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 1760,
            "name": "Castelsaraceno",
            "provincia": "PZ",
            "cap": "85031",
            "cod_catastale": "C271",
            "cod_istat": "076025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 916,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 1761,
            "name": "Castelsardo",
            "provincia": "SS",
            "cap": "07031",
            "cod_catastale": "C272",
            "cod_istat": "090023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 1040,
            "area": "",
            "ech": 0
        },
        {
            "id": 1762,
            "name": "Castelseprio",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "C273",
            "cod_istat": "012044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2572,
            "area": "",
            "ech": 0
        },
        {
            "id": 1763,
            "name": "Castelsilano",
            "provincia": "KR",
            "cap": "88834",
            "cod_catastale": "B968",
            "cod_istat": "101005",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 900,
            "giorni": 2600,
            "area": "",
            "ech": 0
        },
        {
            "id": 1764,
            "name": "Castelspina",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "C274",
            "cod_istat": "006054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 1765,
            "name": "Casteltermini",
            "provincia": "AG",
            "cap": "92025",
            "cod_catastale": "C275",
            "cod_istat": "084012",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 554,
            "giorni": 1384,
            "area": "",
            "ech": 0
        },
        {
            "id": 1766,
            "name": "Castelveccana",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "C181",
            "cod_istat": "012045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 1767,
            "name": "Castelvecchio Calvisio",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "C278",
            "cod_istat": "066030",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1045,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 1768,
            "name": "Castelvecchio di Rocca Barbena",
            "provincia": "SV",
            "cap": "17034",
            "cod_catastale": "C276",
            "cod_istat": "009021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 1769,
            "name": "Castelvecchio Subequo",
            "provincia": "AQ",
            "cap": "67024",
            "cod_catastale": "C279",
            "cod_istat": "066031",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 409,
            "giorni": 2166,
            "area": "",
            "ech": 0
        },
        {
            "id": 1770,
            "name": "Castelvenere",
            "provincia": "BN",
            "cap": "82037",
            "cod_catastale": "C280",
            "cod_istat": "062019",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 119,
            "giorni": 1287,
            "area": "",
            "ech": 0
        },
        {
            "id": 1771,
            "name": "Castelverde",
            "provincia": "CR",
            "cap": "26022",
            "cod_catastale": "B129",
            "cod_istat": "019026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1772,
            "name": "Castelverrino",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "C200",
            "cod_istat": "094013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2153,
            "area": "",
            "ech": 0
        },
        {
            "id": 1773,
            "name": "Castelvetere in Val Fortore",
            "provincia": "BN",
            "cap": "82023",
            "cod_catastale": "C284",
            "cod_istat": "062020",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 706,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1774,
            "name": "Castelvetere sul Calore",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "C283",
            "cod_istat": "064024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2311,
            "area": "",
            "ech": 0
        },
        {
            "id": 1775,
            "name": "Castelvetrano",
            "provincia": "TP",
            "cap": "91022",
            "cod_catastale": "C286",
            "cod_istat": "081006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 1055,
            "area": "",
            "ech": 1
        },
        {
            "id": 1776,
            "name": "Castelvetro di Modena",
            "provincia": "MO",
            "cap": "41014",
            "cod_catastale": "C287",
            "cod_istat": "036008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 1777,
            "name": "Castelvetro Piacentino",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "C288",
            "cod_istat": "033014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 2381,
            "area": "",
            "ech": 0
        },
        {
            "id": 1778,
            "name": "Castelvisconti",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "C290",
            "cod_istat": "019027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1779,
            "name": "Castenaso",
            "provincia": "BO",
            "cap": "40055",
            "cod_catastale": "C292",
            "cod_istat": "037021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2182,
            "area": "",
            "ech": 0
        },
        {
            "id": 1780,
            "name": "Castenedolo",
            "provincia": "BS",
            "cap": "25014",
            "cod_catastale": "C293",
            "cod_istat": "017043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 1781,
            "name": "Castiadas",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "M288",
            "cod_istat": "111011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 921,
            "area": "",
            "ech": 0
        },
        {
            "id": 1782,
            "name": "Castiglion Fibocchi",
            "provincia": "AR",
            "cap": "52029",
            "cod_catastale": "C318",
            "cod_istat": "051011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2093,
            "area": "",
            "ech": 0
        },
        {
            "id": 1783,
            "name": "Castiglion Fiorentino",
            "provincia": "AR",
            "cap": "52043",
            "cod_catastale": "C319",
            "cod_istat": "051012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2159,
            "area": "",
            "ech": 0
        },
        {
            "id": 1784,
            "name": "Castiglione a Casauria",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "C308",
            "cod_istat": "068009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 350,
            "giorni": 1798,
            "area": "",
            "ech": 0
        },
        {
            "id": 1785,
            "name": "Castiglione Chiavarese",
            "provincia": "GE",
            "cap": "16030",
            "cod_catastale": "C302",
            "cod_istat": "010013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2346,
            "area": "",
            "ech": 0
        },
        {
            "id": 1786,
            "name": "Castiglione Cosentino",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "C301",
            "cod_istat": "078030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1588,
            "area": "",
            "ech": 0
        },
        {
            "id": 1787,
            "name": "Castiglione d'Adda",
            "provincia": "LO",
            "cap": "26823",
            "cod_catastale": "C304",
            "cod_istat": "098014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 1788,
            "name": "Castiglione dei Pepoli",
            "provincia": "BO",
            "cap": "40035",
            "cod_catastale": "C296",
            "cod_istat": "037022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 691,
            "giorni": 2876,
            "area": "",
            "ech": 0
        },
        {
            "id": 1789,
            "name": "Castiglione del Genovesi",
            "provincia": "SA",
            "cap": "84090",
            "cod_catastale": "C306",
            "cod_istat": "065036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 598,
            "giorni": 1792,
            "area": "",
            "ech": 0
        },
        {
            "id": 1790,
            "name": "Castiglione del Lago",
            "provincia": "PG",
            "cap": "06061",
            "cod_catastale": "C309",
            "cod_istat": "054009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2099,
            "area": "",
            "ech": 0
        },
        {
            "id": 1791,
            "name": "Castiglione della Pescaia",
            "provincia": "GR",
            "cap": "58043",
            "cod_catastale": "C310",
            "cod_istat": "053006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1527,
            "area": "",
            "ech": 0
        },
        {
            "id": 1792,
            "name": "Castiglione delle Stiviere",
            "provincia": "MN",
            "cap": "46043",
            "cod_catastale": "C312",
            "cod_istat": "020017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2363,
            "area": "",
            "ech": 0
        },
        {
            "id": 1793,
            "name": "Castiglione di Garfagnana",
            "provincia": "LU",
            "cap": "55033",
            "cod_catastale": "C303",
            "cod_istat": "046010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 545,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 1794,
            "name": "Castiglione di Sicilia",
            "provincia": "CT",
            "cap": "95012",
            "cod_catastale": "C297",
            "cod_istat": "087014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 621,
            "giorni": 1502,
            "area": "",
            "ech": 1
        },
        {
            "id": 1795,
            "name": "Castiglione d''Intelvi",
            "provincia": "CO",
            "cap": "22023",
            "cod_catastale": "C299",
            "cod_istat": "013060",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1796,
            "name": "Castiglione d'Orcia",
            "provincia": "SI",
            "cap": "53023",
            "cod_catastale": "C313",
            "cod_istat": "052007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 1797,
            "name": "Castiglione Falletto",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "C314",
            "cod_istat": "004055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2749,
            "area": "",
            "ech": 0
        },
        {
            "id": 1798,
            "name": "Castiglione in Teverina",
            "provincia": "VT",
            "cap": "01024",
            "cod_catastale": "C315",
            "cod_istat": "056018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 228,
            "giorni": 1826,
            "area": "",
            "ech": 0
        },
        {
            "id": 1799,
            "name": "Castiglione Messer Marino",
            "provincia": "CH",
            "cap": "66033",
            "cod_catastale": "C298",
            "cod_istat": "069020",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1000,
            "giorni": 2696,
            "area": "",
            "ech": 0
        },
        {
            "id": 1800,
            "name": "Castiglione Messer Raimondo",
            "provincia": "TE",
            "cap": "64034",
            "cod_catastale": "C316",
            "cod_istat": "067013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 306,
            "giorni": 1908,
            "area": "",
            "ech": 0
        },
        {
            "id": 1801,
            "name": "Castiglione Olona",
            "provincia": "VA",
            "cap": "21043",
            "cod_catastale": "C300",
            "cod_istat": "012046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 1802,
            "name": "Castiglione Tinella",
            "provincia": "CN",
            "cap": "12053",
            "cod_catastale": "C317",
            "cod_istat": "004056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 2821,
            "area": "",
            "ech": 0
        },
        {
            "id": 1803,
            "name": "Castiglione Torinese",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "C307",
            "cod_istat": "001068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2678,
            "area": "",
            "ech": 0
        },
        {
            "id": 1804,
            "name": "Castignano",
            "provincia": "AP",
            "cap": "63072",
            "cod_catastale": "C321",
            "cod_istat": "044012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2193,
            "area": "",
            "ech": 0
        },
        {
            "id": 1805,
            "name": "Castilenti",
            "provincia": "TE",
            "cap": "64035",
            "cod_catastale": "C322",
            "cod_istat": "067014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 1760,
            "area": "",
            "ech": 0
        },
        {
            "id": 1806,
            "name": "Castino",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "C323",
            "cod_istat": "004057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 2985,
            "area": "",
            "ech": 0
        },
        {
            "id": 1807,
            "name": "Castione Andevenno",
            "provincia": "SO",
            "cap": "23012",
            "cod_catastale": "C325",
            "cod_istat": "014015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 468,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 1808,
            "name": "Castione della Presolana",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "C324",
            "cod_istat": "016064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 3305,
            "area": "",
            "ech": 0
        },
        {
            "id": 1809,
            "name": "Castions di Strada",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "C327",
            "cod_istat": "030020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2203,
            "area": "",
            "ech": 0
        },
        {
            "id": 1810,
            "name": "Castiraga Vidardo",
            "provincia": "LO",
            "cap": "26866",
            "cod_catastale": "C329",
            "cod_istat": "098015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 1811,
            "name": "Casto",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "C330",
            "cod_istat": "017044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2804,
            "area": "",
            "ech": 0
        },
        {
            "id": 1812,
            "name": "Castorano",
            "provincia": "AP",
            "cap": "63081",
            "cod_catastale": "C331",
            "cod_istat": "044013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1966,
            "area": "",
            "ech": 0
        },
        {
            "id": 1813,
            "name": "Castrezzato",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "C332",
            "cod_istat": "017045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1814,
            "name": "Castri di Lecce",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "C334",
            "cod_istat": "075017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 1161,
            "area": "",
            "ech": 0
        },
        {
            "id": 1815,
            "name": "Castrignano de' Greci",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "C335",
            "cod_istat": "075018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1252,
            "area": "",
            "ech": 0
        },
        {
            "id": 1816,
            "name": "Castrignano del Capo",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "C336",
            "cod_istat": "075019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 1116,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1817,
            "name": "Castro",
            "provincia": "BG",
            "cap": "24063",
            "cod_catastale": "C337",
            "cod_istat": "016065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2354,
            "area": "",
            "ech": 0
        },
        {
            "id": 1818,
            "name": "Castro",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "M261",
            "cod_istat": "075096",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1243,
            "area": "",
            "ech": 0
        },
        {
            "id": 1819,
            "name": "Castro dei Volsci",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "C338",
            "cod_istat": "060023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 1831,
            "area": "",
            "ech": 0
        },
        {
            "id": 1820,
            "name": "Castrocaro Terme e Terra del Sole",
            "provincia": "FC",
            "cap": "47011",
            "cod_catastale": "C339",
            "cod_istat": "040005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2131,
            "area": "",
            "ech": 0
        },
        {
            "id": 1821,
            "name": "Castrocielo",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "C340",
            "cod_istat": "060022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1585,
            "area": "",
            "ech": 0
        },
        {
            "id": 1822,
            "name": "Castrofilippo",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "C341",
            "cod_istat": "084013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 1425,
            "area": "",
            "ech": 0
        },
        {
            "id": 1823,
            "name": "Castrolibero",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "C108",
            "cod_istat": "078031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 559,
            "giorni": 1917,
            "area": "",
            "ech": 0
        },
        {
            "id": 1824,
            "name": "Castronno",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "C343",
            "cod_istat": "012047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 1825,
            "name": "Castronovo di Sicilia",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "C344",
            "cod_istat": "082025",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 1
        },
        {
            "id": 1826,
            "name": "Castronuovo di Sant'Andrea",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "C345",
            "cod_istat": "076026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 1827,
            "name": "Castropignano",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "C346",
            "cod_istat": "070016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 2116,
            "area": "",
            "ech": 0
        },
        {
            "id": 1828,
            "name": "Castroreale",
            "provincia": "ME",
            "cap": "98053",
            "cod_catastale": "C347",
            "cod_istat": "083016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 1300,
            "area": "",
            "ech": 1
        },
        {
            "id": 1829,
            "name": "Castroregio",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "C348",
            "cod_istat": "078032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 819,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 1830,
            "name": "Castrovillari",
            "provincia": "CS",
            "cap": "87012",
            "cod_catastale": "C349",
            "cod_istat": "078033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 362,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 1831,
            "name": "Catania",
            "provincia": "CT",
            "cap": "951xx",
            "cod_catastale": "C351",
            "cod_istat": "087015",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 7,
            "giorni": 833,
            "area": "",
            "ech": 1
        },
        {
            "id": 1832,
            "name": "Catanzaro",
            "provincia": "CZ",
            "cap": "88100",
            "cod_catastale": "C352",
            "cod_istat": "079023",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 320,
            "giorni": 1328,
            "area": "",
            "ech": 1
        },
        {
            "id": 1833,
            "name": "Catenanuova",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "C353",
            "cod_istat": "086006",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 170,
            "giorni": 918,
            "area": "",
            "ech": 1
        },
        {
            "id": 1834,
            "name": "Catignano",
            "provincia": "PE",
            "cap": "65011",
            "cod_catastale": "C354",
            "cod_istat": "068010",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 355,
            "giorni": 1806,
            "area": "",
            "ech": 0
        },
        {
            "id": 1835,
            "name": "Cattolica",
            "provincia": "RN",
            "cap": "47841",
            "cod_catastale": "C357",
            "cod_istat": "099002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2165,
            "area": "",
            "ech": 0
        },
        {
            "id": 1836,
            "name": "Cattolica Eraclea",
            "provincia": "AG",
            "cap": "92011",
            "cod_catastale": "C356",
            "cod_istat": "084014",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 849,
            "area": "",
            "ech": 0
        },
        {
            "id": 1837,
            "name": "Caulonia",
            "provincia": "RC",
            "cap": "89041",
            "cod_catastale": "C285",
            "cod_istat": "080025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1091,
            "area": "",
            "ech": 1
        },
        {
            "id": 1838,
            "name": "Cautano",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "C359",
            "cod_istat": "062021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 385,
            "giorni": 1771,
            "area": "",
            "ech": 0
        },
        {
            "id": 1839,
            "name": "Cava de' Tirreni",
            "provincia": "SA",
            "cap": "84013",
            "cod_catastale": "C361",
            "cod_istat": "065037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 1274,
            "area": "",
            "ech": 0
        },
        {
            "id": 1840,
            "name": "Cava Manara",
            "provincia": "PV",
            "cap": "27051",
            "cod_catastale": "C360",
            "cod_istat": "018041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1841,
            "name": "Cavacurta",
            "provincia": "LO",
            "cap": "26844",
            "cod_catastale": "C362",
            "cod_istat": "098016",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 1842,
            "name": "Cavaglià",
            "provincia": "BI",
            "cap": "13881",
            "cod_catastale": "C363",
            "cod_istat": "096016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2657,
            "area": "",
            "ech": 0
        },
        {
            "id": 1843,
            "name": "Cavaglietto",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "C364",
            "cod_istat": "003044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 1844,
            "name": "Cavaglio d'Agogna",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "C365",
            "cod_istat": "003045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 1845,
            "name": "Cavaglio-Spoccia",
            "provincia": "VB",
            "cap": "28825",
            "cod_catastale": "C367",
            "cod_istat": "103020",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 410,
            "giorni": 3042,
            "area": "",
            "ech": 0
        },
        {
            "id": 1846,
            "name": "Cavagnolo",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "C369",
            "cod_istat": "001069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1847,
            "name": "Cavaion Veronese",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "C370",
            "cod_istat": "023023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2605,
            "area": "",
            "ech": 0
        },
        {
            "id": 1848,
            "name": "Cavalese",
            "provincia": "TN",
            "cap": "38033",
            "cod_catastale": "C372",
            "cod_istat": "022050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1000,
            "giorni": 4028,
            "area": "",
            "ech": 0
        },
        {
            "id": 1849,
            "name": "Cavallasca",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "C374",
            "cod_istat": "013061",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 1850,
            "name": "Cavallerleone",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "C375",
            "cod_istat": "004058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 1851,
            "name": "Cavallermaggiore",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "C376",
            "cod_istat": "004059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 1852,
            "name": "Cavallino",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "C377",
            "cod_istat": "075020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1104,
            "area": "",
            "ech": 0
        },
        {
            "id": 1853,
            "name": "Cavallino-Treporti",
            "provincia": "VE",
            "cap": "30013",
            "cod_catastale": "M308",
            "cod_istat": "027044",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1854,
            "name": "Cavallirio",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "C378",
            "cod_istat": "003047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 367,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 1855,
            "name": "Cavareno",
            "provincia": "TN",
            "cap": "38011",
            "cod_catastale": "C380",
            "cod_istat": "022051",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 973,
            "giorni": 3909,
            "area": "",
            "ech": 0
        },
        {
            "id": 1856,
            "name": "Cavargna",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "C381",
            "cod_istat": "013062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1071,
            "giorni": 3590,
            "area": "",
            "ech": 0
        },
        {
            "id": 1857,
            "name": "Cavaria con Premezzo",
            "provincia": "VA",
            "cap": "21044",
            "cod_catastale": "C382",
            "cod_istat": "012048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2716,
            "area": "",
            "ech": 0
        },
        {
            "id": 1858,
            "name": "Cavarzere",
            "provincia": "VE",
            "cap": "30014",
            "cod_catastale": "C383",
            "cod_istat": "027006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 1859,
            "name": "Cavaso del Tomba",
            "provincia": "TV",
            "cap": "31034",
            "cod_catastale": "C384",
            "cod_istat": "026014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 1860,
            "name": "Cavasso Nuovo",
            "provincia": "PN",
            "cap": "33092",
            "cod_catastale": "C385",
            "cod_istat": "093012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2881,
            "area": "",
            "ech": 0
        },
        {
            "id": 1861,
            "name": "Cavatore",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "C387",
            "cod_istat": "006055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2916,
            "area": "",
            "ech": 0
        },
        {
            "id": 1862,
            "name": "Cavazzo Carnico",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "C389",
            "cod_istat": "030021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 1863,
            "name": "Cave",
            "provincia": "RM",
            "cap": "00033",
            "cod_catastale": "C390",
            "cod_istat": "058026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 399,
            "giorni": 1926,
            "area": "",
            "ech": 0
        },
        {
            "id": 1864,
            "name": "Cavedago",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "C392",
            "cod_istat": "022052",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 864,
            "giorni": 3739,
            "area": "",
            "ech": 0
        },
        {
            "id": 1865,
            "name": "Cavedine",
            "provincia": "TN",
            "cap": "38073",
            "cod_catastale": "C393",
            "cod_istat": "022053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 3177,
            "area": "",
            "ech": 0
        },
        {
            "id": 1866,
            "name": "Cavenago d'Adda",
            "provincia": "LO",
            "cap": "26824",
            "cod_catastale": "C394",
            "cod_istat": "098017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2629,
            "area": "",
            "ech": 0
        },
        {
            "id": 1867,
            "name": "Cavenago di Brianza",
            "provincia": "MB",
            "cap": "20873",
            "cod_catastale": "C395",
            "cod_istat": "108017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 1868,
            "name": "Cavernago",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "C396",
            "cod_istat": "016066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 1869,
            "name": "Cavezzo",
            "provincia": "MO",
            "cap": "41032",
            "cod_catastale": "C398",
            "cod_istat": "036009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2202,
            "area": "",
            "ech": 0
        },
        {
            "id": 1870,
            "name": "Cavizzana",
            "provincia": "TN",
            "cap": "38022",
            "cod_catastale": "C400",
            "cod_istat": "022054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 3498,
            "area": "",
            "ech": 0
        },
        {
            "id": 1871,
            "name": "Cavour",
            "provincia": "TO",
            "cap": "10061",
            "cod_catastale": "C404",
            "cod_istat": "001070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 1872,
            "name": "Cavriago",
            "provincia": "RE",
            "cap": "42025",
            "cod_catastale": "C405",
            "cod_istat": "035017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2555,
            "area": "",
            "ech": 0
        },
        {
            "id": 1873,
            "name": "Cavriana",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "C406",
            "cod_istat": "020018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2598,
            "area": "",
            "ech": 0
        },
        {
            "id": 1874,
            "name": "Cavriglia",
            "provincia": "AR",
            "cap": "52022",
            "cod_catastale": "C407",
            "cod_istat": "051013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2106,
            "area": "",
            "ech": 0
        },
        {
            "id": 1875,
            "name": "Cazzago Brabbia",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "C409",
            "cod_istat": "012049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 1876,
            "name": "Cazzago San Martino",
            "provincia": "BS",
            "cap": "25046",
            "cod_catastale": "C408",
            "cod_istat": "017046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 1877,
            "name": "Cazzano di Tramigna",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "C412",
            "cod_istat": "023024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 1878,
            "name": "Cazzano Sant'Andrea",
            "provincia": "BG",
            "cap": "24026",
            "cod_catastale": "C410",
            "cod_istat": "016067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 1879,
            "name": "Ceccano",
            "provincia": "FR",
            "cap": "03023",
            "cod_catastale": "C413",
            "cod_istat": "060024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1775,
            "area": "",
            "ech": 0
        },
        {
            "id": 1880,
            "name": "Cecima",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "C414",
            "cod_istat": "018042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 331,
            "giorni": 2937,
            "area": "",
            "ech": 0
        },
        {
            "id": 1881,
            "name": "Cecina",
            "provincia": "LI",
            "cap": "57023",
            "cod_catastale": "C415",
            "cod_istat": "049007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1332,
            "area": "",
            "ech": 0
        },
        {
            "id": 1882,
            "name": "Cedegolo",
            "provincia": "BS",
            "cap": "25051",
            "cod_catastale": "C417",
            "cod_istat": "017047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 413,
            "giorni": 2800,
            "area": "",
            "ech": 0
        },
        {
            "id": 1883,
            "name": "Cedrasco",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "C418",
            "cod_istat": "014016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 1884,
            "name": "Cefalà Diana",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "C420",
            "cod_istat": "082026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 563,
            "giorni": 1546,
            "area": "",
            "ech": 0
        },
        {
            "id": 1885,
            "name": "Cefalù",
            "provincia": "PA",
            "cap": "90015",
            "cod_catastale": "C421",
            "cod_istat": "082027",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 702,
            "area": "",
            "ech": 0
        },
        {
            "id": 1886,
            "name": "Ceggia",
            "provincia": "VE",
            "cap": "30022",
            "cod_catastale": "C422",
            "cod_istat": "027007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 1887,
            "name": "Ceglie Messapica",
            "provincia": "BR",
            "cap": "72013",
            "cod_catastale": "C424",
            "cod_istat": "074003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 298,
            "giorni": 1542,
            "area": "",
            "ech": 0
        },
        {
            "id": 1888,
            "name": "Celano",
            "provincia": "AQ",
            "cap": "67043",
            "cod_catastale": "C426",
            "cod_istat": "066032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 1889,
            "name": "Celenza sul Trigno",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "C428",
            "cod_istat": "069021",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 646,
            "giorni": 2212,
            "area": "",
            "ech": 0
        },
        {
            "id": 1890,
            "name": "Celenza Valfortore",
            "provincia": "FG",
            "cap": "71035",
            "cod_catastale": "C429",
            "cod_istat": "071018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 480,
            "giorni": 1997,
            "area": "",
            "ech": 0
        },
        {
            "id": 1891,
            "name": "Celico",
            "provincia": "CS",
            "cap": "87053",
            "cod_catastale": "C430",
            "cod_istat": "078034",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 750,
            "giorni": 2291,
            "area": "",
            "ech": 0
        },
        {
            "id": 1892,
            "name": "Cella Dati",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "C435",
            "cod_istat": "019028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 1893,
            "name": "Cella Monte",
            "provincia": "AL",
            "cap": "15034",
            "cod_catastale": "C432",
            "cod_istat": "006056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2707,
            "area": "",
            "ech": 0
        },
        {
            "id": 1894,
            "name": "Cellamare",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "C436",
            "cod_istat": "072018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1339,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1895,
            "name": "Cellara",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "C437",
            "cod_istat": "078035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2291,
            "area": "",
            "ech": 0
        },
        {
            "id": 1896,
            "name": "Cellarengo",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "C438",
            "cod_istat": "005033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2752,
            "area": "",
            "ech": 0
        },
        {
            "id": 1897,
            "name": "Cellatica",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "C439",
            "cod_istat": "017048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1898,
            "name": "Celle di Bulgheria",
            "provincia": "SA",
            "cap": "84040",
            "cod_catastale": "C444",
            "cod_istat": "065038",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 234,
            "giorni": 1337,
            "area": "",
            "ech": 0
        },
        {
            "id": 1899,
            "name": "Celle di Macra",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "C441",
            "cod_istat": "004060",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1270,
            "giorni": 3890,
            "area": "",
            "ech": 0
        },
        {
            "id": 1900,
            "name": "Celle di San Vito",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "C442",
            "cod_istat": "071019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 726,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 1901,
            "name": "Celle Enomondo",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "C440",
            "cod_istat": "005034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2600,
            "area": "",
            "ech": 0
        },
        {
            "id": 1902,
            "name": "Celle Ligure",
            "provincia": "SV",
            "cap": "17015",
            "cod_catastale": "C443",
            "cod_istat": "009022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1490,
            "area": "",
            "ech": 0
        },
        {
            "id": 1903,
            "name": "Celleno",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "C446",
            "cod_istat": "056019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 407,
            "giorni": 2143,
            "area": "",
            "ech": 0
        },
        {
            "id": 1904,
            "name": "Cellere",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "C447",
            "cod_istat": "056020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 2031,
            "area": "",
            "ech": 0
        },
        {
            "id": 1905,
            "name": "Cellino Attanasio",
            "provincia": "TE",
            "cap": "64036",
            "cod_catastale": "C449",
            "cod_istat": "067015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 443,
            "giorni": 2134,
            "area": "",
            "ech": 0
        },
        {
            "id": 1906,
            "name": "Cellino San Marco",
            "provincia": "BR",
            "cap": "72020",
            "cod_catastale": "C448",
            "cod_istat": "074004",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 1159,
            "area": "",
            "ech": 0
        },
        {
            "id": 1907,
            "name": "Cellio",
            "provincia": "VC",
            "cap": "13024",
            "cod_catastale": "C450",
            "cod_istat": "002038",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 685,
            "giorni": 3195,
            "area": "",
            "ech": 0
        },
        {
            "id": 1908,
            "name": "Cellole",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "M262",
            "cod_istat": "061102",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 1074,
            "area": "",
            "ech": 0
        },
        {
            "id": 1909,
            "name": "Cembra",
            "provincia": "TN",
            "cap": "38034",
            "cod_catastale": "C452",
            "cod_istat": "022241",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 667,
            "giorni": 3431,
            "area": "",
            "ech": 0
        },
        {
            "id": 1910,
            "name": "Cenadi",
            "provincia": "CZ",
            "cap": "88067",
            "cod_catastale": "C453",
            "cod_istat": "079024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 539,
            "giorni": 1792,
            "area": "",
            "ech": 0
        },
        {
            "id": 1911,
            "name": "Cenate Sopra",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "C456",
            "cod_istat": "016068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2686,
            "area": "",
            "ech": 0
        },
        {
            "id": 1912,
            "name": "Cenate Sotto",
            "provincia": "BG",
            "cap": "24069",
            "cod_catastale": "C457",
            "cod_istat": "016069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 1913,
            "name": "Cencenighe Agordino",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "C458",
            "cod_istat": "025010",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 773,
            "giorni": 3805,
            "area": "",
            "ech": 0
        },
        {
            "id": 1914,
            "name": "Cene",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "C459",
            "cod_istat": "016070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 1915,
            "name": "Ceneselli",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "C461",
            "cod_istat": "029014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1916,
            "name": "Cengio",
            "provincia": "SV",
            "cap": "17056",
            "cod_catastale": "C463",
            "cod_istat": "009023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 1917,
            "name": "Centa San Nicolò",
            "provincia": "TN",
            "cap": "38040",
            "cod_catastale": "C467",
            "cod_istat": "022056",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 3674,
            "area": "",
            "ech": 0
        },
        {
            "id": 1918,
            "name": "Centallo",
            "provincia": "CN",
            "cap": "12044",
            "cod_catastale": "C466",
            "cod_istat": "004061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 2946,
            "area": "",
            "ech": 0
        },
        {
            "id": 1919,
            "name": "Cento",
            "provincia": "FE",
            "cap": "44042",
            "cod_catastale": "C469",
            "cod_istat": "038004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2294,
            "area": "",
            "ech": 0
        },
        {
            "id": 1920,
            "name": "Centola",
            "provincia": "SA",
            "cap": "84051",
            "cod_catastale": "C470",
            "cod_istat": "065039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 336,
            "giorni": 1464,
            "area": "",
            "ech": 0
        },
        {
            "id": 1921,
            "name": "Centrache",
            "provincia": "CZ",
            "cap": "88067",
            "cod_catastale": "C472",
            "cod_istat": "079025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 458,
            "giorni": 1622,
            "area": "",
            "ech": 0
        },
        {
            "id": 1922,
            "name": "Centuripe",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "C471",
            "cod_istat": "086007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 730,
            "giorni": 1769,
            "area": "",
            "ech": 1
        },
        {
            "id": 1923,
            "name": "Cepagatti",
            "provincia": "PE",
            "cap": "65012",
            "cod_catastale": "C474",
            "cod_istat": "068011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 1489,
            "area": "",
            "ech": 0
        },
        {
            "id": 1924,
            "name": "Ceppaloni",
            "provincia": "BN",
            "cap": "82014",
            "cod_catastale": "C476",
            "cod_istat": "062022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 1740,
            "area": "",
            "ech": 0
        },
        {
            "id": 1925,
            "name": "Ceppo Morelli",
            "provincia": "VB",
            "cap": "28875",
            "cod_catastale": "C478",
            "cod_istat": "103021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 753,
            "giorni": 3283,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 1926,
            "name": "Ceprano",
            "provincia": "FR",
            "cap": "03024",
            "cod_catastale": "C479",
            "cod_istat": "060025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1324,
            "area": "",
            "ech": 0
        },
        {
            "id": 1927,
            "name": "Cerami",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "C480",
            "cod_istat": "086008",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 970,
            "giorni": 2134,
            "area": "",
            "ech": 0
        },
        {
            "id": 1928,
            "name": "Ceranesi",
            "provincia": "GE",
            "cap": "16014",
            "cod_catastale": "C481",
            "cod_istat": "010014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1789,
            "area": "",
            "ech": 0
        },
        {
            "id": 1929,
            "name": "Cerano",
            "provincia": "NO",
            "cap": "28065",
            "cod_catastale": "C483",
            "cod_istat": "003049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 2422,
            "area": "",
            "ech": 0
        },
        {
            "id": 1930,
            "name": "Cerano d'Intelvi",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "C482",
            "cod_istat": "013063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2964,
            "area": "",
            "ech": 0
        },
        {
            "id": 1931,
            "name": "Ceranova",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "C484",
            "cod_istat": "018043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1932,
            "name": "Ceraso",
            "provincia": "SA",
            "cap": "84052",
            "cod_catastale": "C485",
            "cod_istat": "065040",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 340,
            "giorni": 1356,
            "area": "",
            "ech": 0
        },
        {
            "id": 1933,
            "name": "Cercemaggiore",
            "provincia": "CB",
            "cap": "86012",
            "cod_catastale": "C486",
            "cod_istat": "070017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 930,
            "giorni": 2602,
            "area": "",
            "ech": 0
        },
        {
            "id": 1934,
            "name": "Cercenasco",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "C487",
            "cod_istat": "001071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 1935,
            "name": "Cercepiccola",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "C488",
            "cod_istat": "070018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 679,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 1936,
            "name": "Cerchiara di Calabria",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "C489",
            "cod_istat": "078036",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2101,
            "area": "",
            "ech": 0
        },
        {
            "id": 1937,
            "name": "Cerchio",
            "provincia": "AQ",
            "cap": "67044",
            "cod_catastale": "C492",
            "cod_istat": "066033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 834,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 1938,
            "name": "Cercino",
            "provincia": "SO",
            "cap": "23016",
            "cod_catastale": "C493",
            "cod_istat": "014017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 487,
            "giorni": 2761,
            "area": "",
            "ech": 0
        },
        {
            "id": 1939,
            "name": "Cercivento",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "C494",
            "cod_istat": "030022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 607,
            "giorni": 3548,
            "area": "",
            "ech": 0
        },
        {
            "id": 1940,
            "name": "Cercola",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "C495",
            "cod_istat": "063026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1105,
            "area": "",
            "ech": 0
        },
        {
            "id": 1941,
            "name": "Cerda",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "C496",
            "cod_istat": "082028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 1050,
            "area": "",
            "ech": 0
        },
        {
            "id": 1942,
            "name": "Cerea",
            "provincia": "VR",
            "cap": "37053",
            "cod_catastale": "C498",
            "cod_istat": "023025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2327,
            "area": "",
            "ech": 0
        },
        {
            "id": 1943,
            "name": "Ceregnano",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "C500",
            "cod_istat": "029015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 1944,
            "name": "Cerenzia",
            "provincia": "KR",
            "cap": "88833",
            "cod_catastale": "C501",
            "cod_istat": "101006",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 664,
            "giorni": 2123,
            "area": "",
            "ech": 1
        },
        {
            "id": 1945,
            "name": "Ceres",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "C497",
            "cod_istat": "001072",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 704,
            "giorni": 3410,
            "area": "",
            "ech": 0
        },
        {
            "id": 1946,
            "name": "Ceresara",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "C502",
            "cod_istat": "020019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 1947,
            "name": "Cereseto",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "C503",
            "cod_istat": "006057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 1948,
            "name": "Ceresole Alba",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "C504",
            "cod_istat": "004062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 1949,
            "name": "Ceresole Reale",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C505",
            "cod_istat": "001073",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1620,
            "giorni": 5154,
            "area": "",
            "ech": 0
        },
        {
            "id": 1950,
            "name": "Cerete",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "C506",
            "cod_istat": "016071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 612,
            "giorni": 2949,
            "area": "",
            "ech": 0
        },
        {
            "id": 1951,
            "name": "Ceretto Lomellina",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "C508",
            "cod_istat": "018044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 1952,
            "name": "Cergnago",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "C509",
            "cod_istat": "018045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1953,
            "name": "Ceriale",
            "provincia": "SV",
            "cap": "17023",
            "cod_catastale": "C510",
            "cod_istat": "009024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1251,
            "area": "",
            "ech": 0
        },
        {
            "id": 1954,
            "name": "Ceriana",
            "provincia": "IM",
            "cap": "18034",
            "cod_catastale": "C511",
            "cod_istat": "008016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 1955,
            "name": "Ceriano Laghetto",
            "provincia": "MB",
            "cap": "20816",
            "cod_catastale": "C512",
            "cod_istat": "108018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 1956,
            "name": "Cerignale",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "C513",
            "cod_istat": "033015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 3385,
            "area": "",
            "ech": 0
        },
        {
            "id": 1957,
            "name": "Cerignola",
            "provincia": "FG",
            "cap": "71042",
            "cod_catastale": "C514",
            "cod_istat": "071020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1465,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 1958,
            "name": "Cerisano",
            "provincia": "CS",
            "cap": "87044",
            "cod_catastale": "C515",
            "cod_istat": "078037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 2018,
            "area": "",
            "ech": 0
        },
        {
            "id": 1959,
            "name": "Cermenate",
            "provincia": "CO",
            "cap": "22072",
            "cod_catastale": "C516",
            "cod_istat": "013064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 1960,
            "name": "Cermes",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "A022",
            "cod_istat": "021020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2864,
            "area": "",
            "ech": 0
        },
        {
            "id": 1961,
            "name": "Cermignano",
            "provincia": "TE",
            "cap": "64037",
            "cod_catastale": "C517",
            "cod_istat": "067016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 563,
            "giorni": 2281,
            "area": "",
            "ech": 0
        },
        {
            "id": 1962,
            "name": "Cernobbio",
            "provincia": "CO",
            "cap": "22012",
            "cod_catastale": "C520",
            "cod_istat": "013065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2228,
            "area": "",
            "ech": 0
        },
        {
            "id": 1963,
            "name": "Cernusco Lombardone",
            "provincia": "LC",
            "cap": "23870",
            "cod_catastale": "C521",
            "cod_istat": "097020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 1964,
            "name": "Cernusco sul Naviglio",
            "provincia": "MI",
            "cap": "20063",
            "cod_catastale": "C523",
            "cod_istat": "015070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 1965,
            "name": "Cerreto Castello",
            "provincia": "BI",
            "cap": "13852",
            "cod_catastale": "C526",
            "cod_istat": "096017",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 1966,
            "name": "Cerreto d'Asti",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "C528",
            "cod_istat": "005035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 1967,
            "name": "Cerreto d'Esi",
            "provincia": "AN",
            "cap": "60043",
            "cod_catastale": "C524",
            "cod_istat": "042013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 1968,
            "name": "Cerreto di Spoleto",
            "provincia": "PG",
            "cap": "06041",
            "cod_catastale": "C527",
            "cod_istat": "054010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 1969,
            "name": "Cerreto Grue",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "C507",
            "cod_istat": "006058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 1970,
            "name": "Cerreto Guidi",
            "provincia": "FI",
            "cap": "50050",
            "cod_catastale": "C529",
            "cod_istat": "048011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 1698,
            "area": "",
            "ech": 0
        },
        {
            "id": 1971,
            "name": "Cerreto Laziale",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "C518",
            "cod_istat": "058027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2224,
            "area": "",
            "ech": 0
        },
        {
            "id": 1972,
            "name": "Cerreto Sannita",
            "provincia": "BN",
            "cap": "82032",
            "cod_catastale": "C525",
            "cod_istat": "062023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 277,
            "giorni": 1574,
            "area": "",
            "ech": 0
        },
        {
            "id": 1973,
            "name": "Cerretto Langhe",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "C530",
            "cod_istat": "004063",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 1974,
            "name": "Cerrina Monferrato",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "C531",
            "cod_istat": "006059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 1975,
            "name": "Cerrione",
            "provincia": "BI",
            "cap": "13882",
            "cod_catastale": "C532",
            "cod_istat": "096018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2629,
            "area": "",
            "ech": 0
        },
        {
            "id": 1976,
            "name": "Cerro al Lambro",
            "provincia": "MI",
            "cap": "20070",
            "cod_catastale": "C536",
            "cod_istat": "015071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 1977,
            "name": "Cerro al Volturno",
            "provincia": "IS",
            "cap": "86072",
            "cod_catastale": "C534",
            "cod_istat": "094014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 572,
            "giorni": 1990,
            "area": "",
            "ech": 0
        },
        {
            "id": 1978,
            "name": "Cerro Maggiore",
            "provincia": "MI",
            "cap": "20023",
            "cod_catastale": "C537",
            "cod_istat": "015072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 1979,
            "name": "Cerro Tanaro",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "C533",
            "cod_istat": "005036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2574,
            "area": "",
            "ech": 0
        },
        {
            "id": 1980,
            "name": "Cerro Veronese",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "C538",
            "cod_istat": "023026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 3480,
            "area": "",
            "ech": 0
        },
        {
            "id": 1981,
            "name": "Cersosimo",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "C539",
            "cod_istat": "076027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 548,
            "giorni": 1905,
            "area": "",
            "ech": 0
        },
        {
            "id": 1982,
            "name": "Certaldo",
            "provincia": "FI",
            "cap": "50052",
            "cod_catastale": "C540",
            "cod_istat": "048012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 1865,
            "area": "",
            "ech": 0
        },
        {
            "id": 1983,
            "name": "Certosa di Pavia",
            "provincia": "PV",
            "cap": "27012",
            "cod_catastale": "C541",
            "cod_istat": "018046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1984,
            "name": "Cerva",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "C542",
            "cod_istat": "079027",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 1985,
            "name": "Cervara di Roma",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "C543",
            "cod_istat": "058028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1053,
            "giorni": 3134,
            "area": "",
            "ech": 0
        },
        {
            "id": 1986,
            "name": "Cervarese Santa Croce",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "C544",
            "cod_istat": "028030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 1987,
            "name": "Cervaro",
            "provincia": "FR",
            "cap": "03044",
            "cod_catastale": "C545",
            "cod_istat": "060026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1527,
            "area": "",
            "ech": 0
        },
        {
            "id": 1988,
            "name": "Cervasca",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "C547",
            "cod_istat": "004064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 578,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 1989,
            "name": "Cervatto",
            "provincia": "VC",
            "cap": "13025",
            "cod_catastale": "C548",
            "cod_istat": "002041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1004,
            "giorni": 3610,
            "area": "",
            "ech": 0
        },
        {
            "id": 1990,
            "name": "Cerveno",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "C549",
            "cod_istat": "017049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 1991,
            "name": "Cervere",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "C550",
            "cod_istat": "004065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 1992,
            "name": "Cervesina",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "C551",
            "cod_istat": "018047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 1993,
            "name": "Cerveteri",
            "provincia": "RM",
            "cap": "00052",
            "cod_catastale": "C552",
            "cod_istat": "058029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 1450,
            "area": "",
            "ech": 0
        },
        {
            "id": 1994,
            "name": "Cervia",
            "provincia": "RA",
            "cap": "48015",
            "cod_catastale": "C553",
            "cod_istat": "039007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2312,
            "area": "",
            "ech": 0
        },
        {
            "id": 1995,
            "name": "Cervicati",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "C554",
            "cod_istat": "078038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 1890,
            "area": "",
            "ech": 0
        },
        {
            "id": 1996,
            "name": "Cervignano d'Adda",
            "provincia": "LO",
            "cap": "26832",
            "cod_catastale": "C555",
            "cod_istat": "098018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 1997,
            "name": "Cervignano del Friuli",
            "provincia": "UD",
            "cap": "33052",
            "cod_catastale": "C556",
            "cod_istat": "030023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2239,
            "area": "",
            "ech": 0
        },
        {
            "id": 1998,
            "name": "Cervinara",
            "provincia": "AV",
            "cap": "83012",
            "cod_catastale": "C557",
            "cod_istat": "064025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 1576,
            "area": "",
            "ech": 0
        },
        {
            "id": 1999,
            "name": "Cervino",
            "provincia": "CE",
            "cap": "81023",
            "cod_catastale": "C558",
            "cod_istat": "061028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 1392,
            "area": "",
            "ech": 0
        },
        {
            "id": 2000,
            "name": "Cervo",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "C559",
            "cod_istat": "008017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 1340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2001,
            "name": "Cerzeto",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "C560",
            "cod_istat": "078039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1788,
            "area": "",
            "ech": 0
        },
        {
            "id": 2002,
            "name": "Cesa",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "C561",
            "cod_istat": "061029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1201,
            "area": "",
            "ech": 0
        },
        {
            "id": 2003,
            "name": "Cesana Brianza",
            "provincia": "LC",
            "cap": "23861",
            "cod_catastale": "C563",
            "cod_istat": "097021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 2004,
            "name": "Cesana Torinese",
            "provincia": "TO",
            "cap": "10054",
            "cod_catastale": "C564",
            "cod_istat": "001074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1354,
            "giorni": 4385,
            "area": "",
            "ech": 0
        },
        {
            "id": 2005,
            "name": "Cesano Boscone",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "C565",
            "cod_istat": "015074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2006,
            "name": "Cesano Maderno",
            "provincia": "MB",
            "cap": "20811",
            "cod_catastale": "C566",
            "cod_istat": "108019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2450,
            "area": "",
            "ech": 0
        },
        {
            "id": 2007,
            "name": "Cesara",
            "provincia": "VB",
            "cap": "28891",
            "cod_catastale": "C567",
            "cod_istat": "103022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 499,
            "giorni": 2919,
            "area": "",
            "ech": 0
        },
        {
            "id": 2008,
            "name": "Cesarò",
            "provincia": "ME",
            "cap": "98033",
            "cod_catastale": "C568",
            "cod_istat": "083017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1150,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 2009,
            "name": "Cesate",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "C569",
            "cod_istat": "015076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 2010,
            "name": "Cesena",
            "provincia": "FC",
            "cap": "475xx",
            "cod_catastale": "C573",
            "cod_istat": "040007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2130,
            "area": "",
            "ech": 0
        },
        {
            "id": 2011,
            "name": "Cesenatico",
            "provincia": "FC",
            "cap": "47042",
            "cod_catastale": "C574",
            "cod_istat": "040008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 2012,
            "name": "Cesinali",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "C576",
            "cod_istat": "064026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1821,
            "area": "",
            "ech": 0
        },
        {
            "id": 2013,
            "name": "Cesio",
            "provincia": "IM",
            "cap": "18022",
            "cod_catastale": "C578",
            "cod_istat": "008018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 2014,
            "name": "Cesiomaggiore",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "C577",
            "cod_istat": "025011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 3341,
            "area": "",
            "ech": 0
        },
        {
            "id": 2015,
            "name": "Cessalto",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "C580",
            "cod_istat": "026015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 2016,
            "name": "Cessaniti",
            "provincia": "VV",
            "cap": "89816",
            "cod_catastale": "C581",
            "cod_istat": "102006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 1699,
            "area": "",
            "ech": 0
        },
        {
            "id": 2017,
            "name": "Cessapalombo",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "C582",
            "cod_istat": "043011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 434,
            "giorni": 2147,
            "area": "",
            "ech": 0
        },
        {
            "id": 2018,
            "name": "Cessole",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "C583",
            "cod_istat": "005037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 2019,
            "name": "Cetara",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "C584",
            "cod_istat": "065041",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 999,
            "area": "",
            "ech": 0
        },
        {
            "id": 2020,
            "name": "Ceto",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "C585",
            "cod_istat": "017050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 453,
            "giorni": 2857,
            "area": "",
            "ech": 0
        },
        {
            "id": 2021,
            "name": "Cetona",
            "provincia": "SI",
            "cap": "53040",
            "cod_catastale": "C587",
            "cod_istat": "052008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2000,
            "area": "",
            "ech": 0
        },
        {
            "id": 2022,
            "name": "Cetraro",
            "provincia": "CS",
            "cap": "87022",
            "cod_catastale": "C588",
            "cod_istat": "078040",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1117,
            "area": "",
            "ech": 1
        },
        {
            "id": 2023,
            "name": "Ceva",
            "provincia": "CN",
            "cap": "12073",
            "cod_catastale": "C589",
            "cod_istat": "004066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 2024,
            "name": "Cevo",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "C591",
            "cod_istat": "017051",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1070,
            "giorni": 3739,
            "area": "",
            "ech": 0
        },
        {
            "id": 2025,
            "name": "Challand-Saint-Anselme",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "C593",
            "cod_istat": "007013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1030,
            "giorni": 3791,
            "area": "",
            "ech": 0
        },
        {
            "id": 2026,
            "name": "Challand-Saint-Victor",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "C594",
            "cod_istat": "007014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 744,
            "giorni": 3321,
            "area": "",
            "ech": 0
        },
        {
            "id": 2027,
            "name": "Chambave",
            "provincia": "AO",
            "cap": "11023",
            "cod_catastale": "C595",
            "cod_istat": "007015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2912,
            "area": "",
            "ech": 0
        },
        {
            "id": 2028,
            "name": "Chamois",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "B491",
            "cod_istat": "007016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1816,
            "giorni": 4955,
            "area": "",
            "ech": 0
        },
        {
            "id": 2029,
            "name": "Champdepraz",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "C596",
            "cod_istat": "007017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 2971,
            "area": "",
            "ech": 0
        },
        {
            "id": 2030,
            "name": "Champorcher",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "B540",
            "cod_istat": "007018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1427,
            "giorni": 4373,
            "area": "",
            "ech": 0
        },
        {
            "id": 2031,
            "name": "Charvensod",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "C598",
            "cod_istat": "007019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 766,
            "giorni": 3351,
            "area": "",
            "ech": 0
        },
        {
            "id": 2032,
            "name": "Châtillon",
            "provincia": "AO",
            "cap": "11024",
            "cod_catastale": "C294",
            "cod_istat": "007020",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 3012,
            "area": "",
            "ech": 0
        },
        {
            "id": 2033,
            "name": "Cherasco",
            "provincia": "CN",
            "cap": "12062",
            "cod_catastale": "C599",
            "cod_istat": "004067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 2034,
            "name": "Cheremule",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "C600",
            "cod_istat": "090024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1942,
            "area": "",
            "ech": 0
        },
        {
            "id": 2035,
            "name": "Chialamberto",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "C604",
            "cod_istat": "001075",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 851,
            "giorni": 3630,
            "area": "",
            "ech": 0
        },
        {
            "id": 2036,
            "name": "Chiampo",
            "provincia": "VI",
            "cap": "36072",
            "cod_catastale": "C605",
            "cod_istat": "024029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2526,
            "area": "",
            "ech": 0
        },
        {
            "id": 2037,
            "name": "Chianche",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "C606",
            "cod_istat": "064027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 356,
            "giorni": 1834,
            "area": "",
            "ech": 0
        },
        {
            "id": 2038,
            "name": "Chianciano Terme",
            "provincia": "SI",
            "cap": "53042",
            "cod_catastale": "C608",
            "cod_istat": "052009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2152,
            "area": "",
            "ech": 0
        },
        {
            "id": 2039,
            "name": "Chianni",
            "provincia": "PI",
            "cap": "56034",
            "cod_catastale": "C609",
            "cod_istat": "050012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 1955,
            "area": "",
            "ech": 0
        },
        {
            "id": 2040,
            "name": "Chianocco",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "C610",
            "cod_istat": "001076",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 3179,
            "area": "",
            "ech": 0
        },
        {
            "id": 2041,
            "name": "Chiaramonte Gulfi",
            "provincia": "RG",
            "cap": "97012",
            "cod_catastale": "C612",
            "cod_istat": "088002",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 668,
            "giorni": 1565,
            "area": "",
            "ech": 1
        },
        {
            "id": 2042,
            "name": "Chiaramonti",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "C613",
            "cod_istat": "090025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1754,
            "area": "",
            "ech": 0
        },
        {
            "id": 2043,
            "name": "Chiarano",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "C614",
            "cod_istat": "026016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2336,
            "area": "",
            "ech": 0
        },
        {
            "id": 2044,
            "name": "Chiaravalle",
            "provincia": "AN",
            "cap": "60033",
            "cod_catastale": "C615",
            "cod_istat": "042014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 1823,
            "area": "",
            "ech": 0
        },
        {
            "id": 2045,
            "name": "Chiaravalle Centrale",
            "provincia": "CZ",
            "cap": "88064",
            "cod_catastale": "C616",
            "cod_istat": "079029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 545,
            "giorni": 1804,
            "area": "",
            "ech": 0
        },
        {
            "id": 2046,
            "name": "Chiari",
            "provincia": "BS",
            "cap": "25032",
            "cod_catastale": "C618",
            "cod_istat": "017052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 2047,
            "name": "Chiaromonte",
            "provincia": "PZ",
            "cap": "85032",
            "cod_catastale": "C619",
            "cod_istat": "076028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 794,
            "giorni": 2226,
            "area": "",
            "ech": 0
        },
        {
            "id": 2048,
            "name": "Chiauci",
            "provincia": "IS",
            "cap": "86097",
            "cod_catastale": "C620",
            "cod_istat": "094015",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 868,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 2049,
            "name": "Chiavari",
            "provincia": "GE",
            "cap": "16043",
            "cod_catastale": "C621",
            "cod_istat": "010015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1418,
            "area": "",
            "ech": 0
        },
        {
            "id": 2050,
            "name": "Chiavenna",
            "provincia": "SO",
            "cap": "23022",
            "cod_catastale": "C623",
            "cod_istat": "014018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 2051,
            "name": "Chiaverano",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "C624",
            "cod_istat": "001077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2848,
            "area": "",
            "ech": 0
        },
        {
            "id": 2052,
            "name": "Chienes",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "C625",
            "cod_istat": "021021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 784,
            "giorni": 3741,
            "area": "",
            "ech": 0
        },
        {
            "id": 2053,
            "name": "Chieri",
            "provincia": "TO",
            "cap": "10023",
            "cod_catastale": "C627",
            "cod_istat": "001078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 2054,
            "name": "Chies d'Alpago",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "C630",
            "cod_istat": "025012",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 647,
            "giorni": 3463,
            "area": "",
            "ech": 0
        },
        {
            "id": 2055,
            "name": "Chiesa in Valmalenco",
            "provincia": "SO",
            "cap": "23023",
            "cod_catastale": "C628",
            "cod_istat": "014019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 3433,
            "area": "",
            "ech": 0
        },
        {
            "id": 2056,
            "name": "Chiesanuova",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C629",
            "cod_istat": "001079",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 3224,
            "area": "",
            "ech": 0
        },
        {
            "id": 2057,
            "name": "Chiesina Uzzanese",
            "provincia": "PT",
            "cap": "51013",
            "cod_catastale": "C631",
            "cod_istat": "047022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1695,
            "area": "",
            "ech": 0
        },
        {
            "id": 2058,
            "name": "Chieti",
            "provincia": "CH",
            "cap": "66100",
            "cod_catastale": "C632",
            "cod_istat": "069022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 330,
            "giorni": 1556,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 2059,
            "name": "Chieuti",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "C633",
            "cod_istat": "071021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 1547,
            "area": "",
            "ech": 0
        },
        {
            "id": 2060,
            "name": "Chieve",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "C634",
            "cod_istat": "019029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 2061,
            "name": "Chignolo d'Isola",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "C635",
            "cod_istat": "016072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2395,
            "area": "",
            "ech": 0
        },
        {
            "id": 2062,
            "name": "Chignolo Po",
            "provincia": "PV",
            "cap": "27013",
            "cod_catastale": "C637",
            "cod_istat": "018048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 2063,
            "name": "Chioggia",
            "provincia": "VE",
            "cap": "30015",
            "cod_catastale": "C638",
            "cod_istat": "027008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 2064,
            "name": "Chiomonte",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "C639",
            "cod_istat": "001080",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3479,
            "area": "",
            "ech": 0
        },
        {
            "id": 2065,
            "name": "Chions",
            "provincia": "PN",
            "cap": "33083",
            "cod_catastale": "C640",
            "cod_istat": "093013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 2066,
            "name": "Chiopris-Viscone",
            "provincia": "UD",
            "cap": "33048",
            "cod_catastale": "C641",
            "cod_istat": "030024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2295,
            "area": "",
            "ech": 0
        },
        {
            "id": 2067,
            "name": "Chitignano",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "C648",
            "cod_istat": "051014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 582,
            "giorni": 2531,
            "area": "",
            "ech": 0
        },
        {
            "id": 2068,
            "name": "Chiuduno",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "C649",
            "cod_istat": "016073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2379,
            "area": "",
            "ech": 0
        },
        {
            "id": 2069,
            "name": "Chiuppano",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "C650",
            "cod_istat": "024030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2690,
            "area": "",
            "ech": 0
        },
        {
            "id": 2070,
            "name": "Chiuro",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "C651",
            "cod_istat": "014020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2873,
            "area": "",
            "ech": 0
        },
        {
            "id": 2071,
            "name": "Chiusa",
            "provincia": "BZ",
            "cap": "39043",
            "cod_catastale": "C652",
            "cod_istat": "021022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 3449,
            "area": "",
            "ech": 0
        },
        {
            "id": 2072,
            "name": "Chiusa di Pesio",
            "provincia": "CN",
            "cap": "12013",
            "cod_catastale": "C653",
            "cod_istat": "004068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3028,
            "area": "",
            "ech": 0
        },
        {
            "id": 2073,
            "name": "Chiusa di San Michele",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "C655",
            "cod_istat": "001081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 2921,
            "area": "",
            "ech": 0
        },
        {
            "id": 2074,
            "name": "Chiusa Sclafani",
            "provincia": "PA",
            "cap": "90033",
            "cod_catastale": "C654",
            "cod_istat": "082029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 658,
            "giorni": 1770,
            "area": "",
            "ech": 1
        },
        {
            "id": 2075,
            "name": "Chiusaforte",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "C656",
            "cod_istat": "030025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 3498,
            "area": "",
            "ech": 0
        },
        {
            "id": 2076,
            "name": "Chiusanico",
            "provincia": "IM",
            "cap": "18027",
            "cod_catastale": "C657",
            "cod_istat": "008019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2051,
            "area": "",
            "ech": 0
        },
        {
            "id": 2077,
            "name": "Chiusano d'Asti",
            "provincia": "AT",
            "cap": "14025",
            "cod_catastale": "C658",
            "cod_istat": "005038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 2078,
            "name": "Chiusano di San Domenico",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "C659",
            "cod_istat": "064028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 2079,
            "name": "Chiusavecchia",
            "provincia": "IM",
            "cap": "18027",
            "cod_catastale": "C660",
            "cod_istat": "008020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1514,
            "area": "",
            "ech": 0
        },
        {
            "id": 2080,
            "name": "Chiusdino",
            "provincia": "SI",
            "cap": "53012",
            "cod_catastale": "C661",
            "cod_istat": "052010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 564,
            "giorni": 2303,
            "area": "",
            "ech": 0
        },
        {
            "id": 2081,
            "name": "Chiusi",
            "provincia": "SI",
            "cap": "53043",
            "cod_catastale": "C662",
            "cod_istat": "052011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2022,
            "area": "",
            "ech": 0
        },
        {
            "id": 2082,
            "name": "Chiusi della Verna",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "C663",
            "cod_istat": "051015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 954,
            "giorni": 3280,
            "area": "",
            "ech": 0
        },
        {
            "id": 2083,
            "name": "Chivasso",
            "provincia": "TO",
            "cap": "10034",
            "cod_catastale": "C665",
            "cod_istat": "001082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2084,
            "name": "Ciampino",
            "provincia": "RM",
            "cap": "00043",
            "cod_catastale": "M272",
            "cod_istat": "058118",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 1582,
            "area": "",
            "ech": 0
        },
        {
            "id": 2085,
            "name": "Cianciana",
            "provincia": "AG",
            "cap": "92012",
            "cod_catastale": "C668",
            "cod_istat": "084015",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 390,
            "giorni": 1106,
            "area": "",
            "ech": 0
        },
        {
            "id": 2086,
            "name": "Cibiana di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "C672",
            "cod_istat": "025013",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 985,
            "giorni": 4140,
            "area": "",
            "ech": 0
        },
        {
            "id": 2087,
            "name": "Cicagna",
            "provincia": "GE",
            "cap": "16044",
            "cod_catastale": "C673",
            "cod_istat": "010016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 1856,
            "area": "",
            "ech": 0
        },
        {
            "id": 2088,
            "name": "Cicala",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "C674",
            "cod_istat": "079030",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 829,
            "giorni": 2490,
            "area": "",
            "ech": 1
        },
        {
            "id": 2089,
            "name": "Cicciano",
            "provincia": "NA",
            "cap": "80033",
            "cod_catastale": "C675",
            "cod_istat": "063027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1048,
            "area": "",
            "ech": 0
        },
        {
            "id": 2090,
            "name": "Cicerale",
            "provincia": "SA",
            "cap": "84053",
            "cod_catastale": "C676",
            "cod_istat": "065042",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 475,
            "giorni": 1731,
            "area": "",
            "ech": 0
        },
        {
            "id": 2091,
            "name": "Ciciliano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "C677",
            "cod_istat": "058030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 619,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 2092,
            "name": "Cicognolo",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "C678",
            "cod_istat": "019030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2093,
            "name": "Ciconio",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C679",
            "cod_istat": "001083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 2094,
            "name": "Cigliano",
            "provincia": "VC",
            "cap": "13043",
            "cod_catastale": "C680",
            "cod_istat": "002042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 2095,
            "name": "Cigliè",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "C681",
            "cod_istat": "004069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 2831,
            "area": "",
            "ech": 0
        },
        {
            "id": 2096,
            "name": "Cigognola",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "C684",
            "cod_istat": "018049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2998,
            "area": "",
            "ech": 0
        },
        {
            "id": 2097,
            "name": "Cigole",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "C685",
            "cod_istat": "017053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2341,
            "area": "",
            "ech": 0
        },
        {
            "id": 2098,
            "name": "Cilavegna",
            "provincia": "PV",
            "cap": "27024",
            "cod_catastale": "C686",
            "cod_istat": "018050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 2099,
            "name": "Cimadolmo",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "C689",
            "cod_istat": "026017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2100,
            "name": "Cimbergo",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "C691",
            "cod_istat": "017054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 3425,
            "area": "",
            "ech": 0
        },
        {
            "id": 2101,
            "name": "Cimego",
            "provincia": "TN",
            "cap": "38082",
            "cod_catastale": "C694",
            "cod_istat": "022057",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 3260,
            "area": "",
            "ech": 0
        },
        {
            "id": 2102,
            "name": "Ciminà",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "C695",
            "cod_istat": "080026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 1137,
            "area": "",
            "ech": 0
        },
        {
            "id": 2103,
            "name": "Ciminna",
            "provincia": "PA",
            "cap": "90023",
            "cod_catastale": "C696",
            "cod_istat": "082030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 1545,
            "area": "",
            "ech": 1
        },
        {
            "id": 2104,
            "name": "Cimitile",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "C697",
            "cod_istat": "063028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1031,
            "area": "",
            "ech": 0
        },
        {
            "id": 2105,
            "name": "Cimolais",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "C699",
            "cod_istat": "093014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 652,
            "giorni": 3639,
            "area": "",
            "ech": 0
        },
        {
            "id": 2106,
            "name": "Cimone",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "C700",
            "cod_istat": "022058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 3218,
            "area": "",
            "ech": 0
        },
        {
            "id": 2107,
            "name": "Cinaglio",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "C701",
            "cod_istat": "005039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 2108,
            "name": "Cineto Romano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "C702",
            "cod_istat": "058031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 519,
            "giorni": 2129,
            "area": "",
            "ech": 0
        },
        {
            "id": 2109,
            "name": "Cingia de' Botti",
            "provincia": "CR",
            "cap": "26042",
            "cod_catastale": "C703",
            "cod_istat": "019031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2110,
            "name": "Cingoli",
            "provincia": "MC",
            "cap": "62011",
            "cod_catastale": "C704",
            "cod_istat": "043012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 631,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 2111,
            "name": "Cinigiano",
            "provincia": "GR",
            "cap": "58044",
            "cod_catastale": "C705",
            "cod_istat": "053007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 324,
            "giorni": 1972,
            "area": "",
            "ech": 0
        },
        {
            "id": 2112,
            "name": "Cinisello Balsamo",
            "provincia": "MI",
            "cap": "20092",
            "cod_catastale": "C707",
            "cod_istat": "015077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2113,
            "name": "Cinisi",
            "provincia": "PA",
            "cap": "90045",
            "cod_catastale": "C708",
            "cod_istat": "082031",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 785,
            "area": "",
            "ech": 1
        },
        {
            "id": 2114,
            "name": "Cino",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "C709",
            "cod_istat": "014021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 3004,
            "area": "",
            "ech": 0
        },
        {
            "id": 2115,
            "name": "Cinquefrondi",
            "provincia": "RC",
            "cap": "89021",
            "cod_catastale": "C710",
            "cod_istat": "080027",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 257,
            "giorni": 1191,
            "area": "",
            "ech": 0
        },
        {
            "id": 2116,
            "name": "Cintano",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C711",
            "cod_istat": "001084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 646,
            "giorni": 3195,
            "area": "",
            "ech": 0
        },
        {
            "id": 2117,
            "name": "Cinte Tesino",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "C712",
            "cod_istat": "022059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 851,
            "giorni": 3718,
            "area": "",
            "ech": 0
        },
        {
            "id": 2118,
            "name": "Cinto Caomaggiore",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "C714",
            "cod_istat": "027009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 2119,
            "name": "Cinto Euganeo",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "C713",
            "cod_istat": "028031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 2120,
            "name": "Cinzano",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "C715",
            "cod_istat": "001085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 3096,
            "area": "",
            "ech": 0
        },
        {
            "id": 2121,
            "name": "Ciorlano",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "C716",
            "cod_istat": "061030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 330,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 2122,
            "name": "Cipressa",
            "provincia": "IM",
            "cap": "18017",
            "cod_catastale": "C718",
            "cod_istat": "008021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1694,
            "area": "",
            "ech": 0
        },
        {
            "id": 2123,
            "name": "Circello",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "C719",
            "cod_istat": "062024",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2253,
            "area": "",
            "ech": 0
        },
        {
            "id": 2124,
            "name": "Ciriè",
            "provincia": "TO",
            "cap": "10073",
            "cod_catastale": "C722",
            "cod_istat": "001086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 2870,
            "area": "",
            "ech": 0
        },
        {
            "id": 2125,
            "name": "Cirigliano",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "C723",
            "cod_istat": "077005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 656,
            "giorni": 2044,
            "area": "",
            "ech": 0
        },
        {
            "id": 2126,
            "name": "Cirimido",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "C724",
            "cod_istat": "013068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 2127,
            "name": "Cirò",
            "provincia": "KR",
            "cap": "88813",
            "cod_catastale": "C725",
            "cod_istat": "101007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 1571,
            "area": "",
            "ech": 0
        },
        {
            "id": 2128,
            "name": "Cirò Marina",
            "provincia": "KR",
            "cap": "88811",
            "cod_catastale": "C726",
            "cod_istat": "101008",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 845,
            "area": "",
            "ech": 1
        },
        {
            "id": 2129,
            "name": "Cis",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "C727",
            "cod_istat": "022060",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 3381,
            "area": "",
            "ech": 0
        },
        {
            "id": 2130,
            "name": "Cisano Bergamasco",
            "provincia": "BG",
            "cap": "24034",
            "cod_catastale": "C728",
            "cod_istat": "016074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2450,
            "area": "",
            "ech": 0
        },
        {
            "id": 2131,
            "name": "Cisano sul Neva",
            "provincia": "SV",
            "cap": "17035",
            "cod_catastale": "C729",
            "cod_istat": "009025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 1310,
            "area": "",
            "ech": 0
        },
        {
            "id": 2132,
            "name": "Ciserano",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "C730",
            "cod_istat": "016075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2133,
            "name": "Cislago",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "C732",
            "cod_istat": "012050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2876,
            "area": "",
            "ech": 0
        },
        {
            "id": 2134,
            "name": "Cisliano",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "C733",
            "cod_istat": "015078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2538,
            "area": "",
            "ech": 0
        },
        {
            "id": 2135,
            "name": "Cismon del Grappa",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "C734",
            "cod_istat": "024031",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2691,
            "area": "",
            "ech": 0
        },
        {
            "id": 2136,
            "name": "Cison di Valmarino",
            "provincia": "TV",
            "cap": "31030",
            "cod_catastale": "C735",
            "cod_istat": "026018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2808,
            "area": "",
            "ech": 0
        },
        {
            "id": 2137,
            "name": "Cissone",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "C738",
            "cod_istat": "004070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 661,
            "giorni": 3135,
            "area": "",
            "ech": 0
        },
        {
            "id": 2138,
            "name": "Cisterna d'Asti",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "C739",
            "cod_istat": "005040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2588,
            "area": "",
            "ech": 0
        },
        {
            "id": 2139,
            "name": "Cisterna di Latina",
            "provincia": "LT",
            "cap": "04012",
            "cod_catastale": "C740",
            "cod_istat": "059005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 1216,
            "area": "",
            "ech": 0
        },
        {
            "id": 2140,
            "name": "Cisternino",
            "provincia": "BR",
            "cap": "72014",
            "cod_catastale": "C741",
            "cod_istat": "074005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 1590,
            "area": "",
            "ech": 0
        },
        {
            "id": 2141,
            "name": "Citerna",
            "provincia": "PG",
            "cap": "06010",
            "cod_catastale": "C742",
            "cod_istat": "054011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2277,
            "area": "",
            "ech": 0
        },
        {
            "id": 2142,
            "name": "Città della Pieve",
            "provincia": "PG",
            "cap": "06062",
            "cod_catastale": "C744",
            "cod_istat": "054012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 509,
            "giorni": 2306,
            "area": "",
            "ech": 0
        },
        {
            "id": 2143,
            "name": "Città di Castello",
            "provincia": "PG",
            "cap": "06012",
            "cod_catastale": "C745",
            "cod_istat": "054013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 2347,
            "area": "",
            "ech": 0
        },
        {
            "id": 2144,
            "name": "Città Sant'Angelo",
            "provincia": "PE",
            "cap": "65013",
            "cod_catastale": "C750",
            "cod_istat": "068012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 1748,
            "area": "",
            "ech": 0
        },
        {
            "id": 2145,
            "name": "Cittadella",
            "provincia": "PD",
            "cap": "35013",
            "cod_catastale": "C743",
            "cod_istat": "028032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 2146,
            "name": "Cittaducale",
            "provincia": "RI",
            "cap": "02015",
            "cod_catastale": "C746",
            "cod_istat": "057016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 481,
            "giorni": 2240,
            "area": "",
            "ech": 0
        },
        {
            "id": 2147,
            "name": "Cittanova",
            "provincia": "RC",
            "cap": "89022",
            "cod_catastale": "C747",
            "cod_istat": "080028",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1423,
            "area": "",
            "ech": 0
        },
        {
            "id": 2148,
            "name": "Cittareale",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "C749",
            "cod_istat": "057017",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 962,
            "giorni": 3061,
            "area": "",
            "ech": 0
        },
        {
            "id": 2149,
            "name": "Cittiglio",
            "provincia": "VA",
            "cap": "21033",
            "cod_catastale": "C751",
            "cod_istat": "012051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2501,
            "area": "",
            "ech": 0
        },
        {
            "id": 2150,
            "name": "Civate",
            "provincia": "LC",
            "cap": "23862",
            "cod_catastale": "C752",
            "cod_istat": "097022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 269,
            "giorni": 2452,
            "area": "",
            "ech": 0
        },
        {
            "id": 2151,
            "name": "Civenna",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "C754",
            "cod_istat": "013070",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 627,
            "giorni": 2960,
            "area": "",
            "ech": 0
        },
        {
            "id": 2152,
            "name": "Civezza",
            "provincia": "IM",
            "cap": "18017",
            "cod_catastale": "C755",
            "cod_istat": "008022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1657,
            "area": "",
            "ech": 0
        },
        {
            "id": 2153,
            "name": "Civezzano",
            "provincia": "TN",
            "cap": "38045",
            "cod_catastale": "C756",
            "cod_istat": "022061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 469,
            "giorni": 3127,
            "area": "",
            "ech": 0
        },
        {
            "id": 2154,
            "name": "Civiasco",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "C757",
            "cod_istat": "002043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 716,
            "giorni": 3235,
            "area": "",
            "ech": 0
        },
        {
            "id": 2155,
            "name": "Cividale del Friuli",
            "provincia": "UD",
            "cap": "33043",
            "cod_catastale": "C758",
            "cod_istat": "030026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 2156,
            "name": "Cividate al Piano",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "C759",
            "cod_istat": "016076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2157,
            "name": "Cividate Camuno",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "C760",
            "cod_istat": "017055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 2158,
            "name": "Civita",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "C763",
            "cod_istat": "078041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 2159,
            "name": "Civita Castellana",
            "provincia": "VT",
            "cap": "01033",
            "cod_catastale": "C765",
            "cod_istat": "056021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 1703,
            "area": "",
            "ech": 0
        },
        {
            "id": 2160,
            "name": "Civita d'Antino",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "C766",
            "cod_istat": "066034",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 904,
            "giorni": 2907,
            "area": "",
            "ech": 0
        },
        {
            "id": 2161,
            "name": "Civitacampomarano",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "C764",
            "cod_istat": "070019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2027,
            "area": "",
            "ech": 0
        },
        {
            "id": 2162,
            "name": "Civitaluparella",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "C768",
            "cod_istat": "069023",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 903,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 2163,
            "name": "Civitanova del Sannio",
            "provincia": "IS",
            "cap": "86094",
            "cod_catastale": "C769",
            "cod_istat": "094016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 565,
            "giorni": 2257,
            "area": "",
            "ech": 0
        },
        {
            "id": 2164,
            "name": "Civitanova Marche",
            "provincia": "MC",
            "cap": "62012",
            "cod_catastale": "C770",
            "cod_istat": "043013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1643,
            "area": "",
            "ech": 0
        },
        {
            "id": 2165,
            "name": "Civitaquana",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "C771",
            "cod_istat": "068013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 2100,
            "area": "",
            "ech": 0
        },
        {
            "id": 2166,
            "name": "Civitavecchia",
            "provincia": "RM",
            "cap": "00053",
            "cod_catastale": "C773",
            "cod_istat": "058032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1085,
            "area": "",
            "ech": 0
        },
        {
            "id": 2167,
            "name": "Civitella Alfedena",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "C778",
            "cod_istat": "066035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1123,
            "giorni": 3299,
            "area": "",
            "ech": 0
        },
        {
            "id": 2168,
            "name": "Civitella Casanova",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "C779",
            "cod_istat": "068014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1874,
            "area": "",
            "ech": 0
        },
        {
            "id": 2169,
            "name": "Civitella d'Agliano",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "C780",
            "cod_istat": "056022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 1886,
            "area": "",
            "ech": 0
        },
        {
            "id": 2170,
            "name": "Civitella del Tronto",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "C781",
            "cod_istat": "067017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 589,
            "giorni": 2327,
            "area": "",
            "ech": 0
        },
        {
            "id": 2171,
            "name": "Civitella di Romagna",
            "provincia": "FC",
            "cap": "47012",
            "cod_catastale": "C777",
            "cod_istat": "040009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2424,
            "area": "",
            "ech": 0
        },
        {
            "id": 2172,
            "name": "Civitella in Val di Chiana",
            "provincia": "AR",
            "cap": "52041",
            "cod_catastale": "C774",
            "cod_istat": "051016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 2173,
            "name": "Civitella Messer Raimondo",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "C776",
            "cod_istat": "069024",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 613,
            "giorni": 2116,
            "area": "",
            "ech": 0
        },
        {
            "id": 2174,
            "name": "Civitella Paganico",
            "provincia": "GR",
            "cap": "58045",
            "cod_catastale": "C782",
            "cod_istat": "053008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 1979,
            "area": "",
            "ech": 0
        },
        {
            "id": 2175,
            "name": "Civitella Roveto",
            "provincia": "AQ",
            "cap": "67054",
            "cod_catastale": "C783",
            "cod_istat": "066036",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 528,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 2176,
            "name": "Civitella San Paolo",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "C784",
            "cod_istat": "058033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 1811,
            "area": "",
            "ech": 0
        },
        {
            "id": 2177,
            "name": "Civo",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "C785",
            "cod_istat": "014022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 719,
            "giorni": 3091,
            "area": "",
            "ech": 0
        },
        {
            "id": 2178,
            "name": "Claino con Osteno",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "C787",
            "cod_istat": "013071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2179,
            "name": "Claut",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "C790",
            "cod_istat": "093015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 613,
            "giorni": 3572,
            "area": "",
            "ech": 0
        },
        {
            "id": 2180,
            "name": "Clauzetto",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "C791",
            "cod_istat": "093016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 558,
            "giorni": 3389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2181,
            "name": "Clavesana",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "C792",
            "cod_istat": "004071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 2182,
            "name": "Claviere",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "C793",
            "cod_istat": "001087",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1760,
            "giorni": 4994,
            "area": "",
            "ech": 0
        },
        {
            "id": 2183,
            "name": "Cles",
            "provincia": "TN",
            "cap": "38023",
            "cod_catastale": "C794",
            "cod_istat": "022062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 658,
            "giorni": 3265,
            "area": "",
            "ech": 0
        },
        {
            "id": 2184,
            "name": "Cleto",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "C795",
            "cod_istat": "078042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1309,
            "area": "",
            "ech": 0
        },
        {
            "id": 2185,
            "name": "Clivio",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "C796",
            "cod_istat": "012052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 468,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 2186,
            "name": "Cloz",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "C797",
            "cod_istat": "022063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 791,
            "giorni": 3625,
            "area": "",
            "ech": 0
        },
        {
            "id": 2187,
            "name": "Clusone",
            "provincia": "BG",
            "cap": "24023",
            "cod_catastale": "C800",
            "cod_istat": "016077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 3000,
            "area": "",
            "ech": 0
        },
        {
            "id": 2188,
            "name": "Coassolo Torinese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "C801",
            "cod_istat": "001088",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 742,
            "giorni": 3467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2189,
            "name": "Coazze",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "C803",
            "cod_istat": "001089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3479,
            "area": "",
            "ech": 0
        },
        {
            "id": 2190,
            "name": "Coazzolo",
            "provincia": "AT",
            "cap": "14054",
            "cod_catastale": "C804",
            "cod_istat": "005041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 2539,
            "area": "",
            "ech": 0
        },
        {
            "id": 2191,
            "name": "Coccaglio",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "C806",
            "cod_istat": "017056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2192,
            "name": "Cocconato",
            "provincia": "AT",
            "cap": "14023",
            "cod_catastale": "C807",
            "cod_istat": "005042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 491,
            "giorni": 2895,
            "area": "",
            "ech": 0
        },
        {
            "id": 2193,
            "name": "Cocquio-Trevisago",
            "provincia": "VA",
            "cap": "21034",
            "cod_catastale": "C810",
            "cod_istat": "012053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 2194,
            "name": "Cocullo",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "C811",
            "cod_istat": "066037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 897,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 2195,
            "name": "Codevigo",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "C812",
            "cod_istat": "028033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 2196,
            "name": "Codevilla",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "C813",
            "cod_istat": "018051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 146,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 2197,
            "name": "Codigoro",
            "provincia": "FE",
            "cap": "44021",
            "cod_catastale": "C814",
            "cod_istat": "038005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2523,
            "area": "",
            "ech": 0
        },
        {
            "id": 2198,
            "name": "Codognè",
            "provincia": "TV",
            "cap": "31013",
            "cod_catastale": "C815",
            "cod_istat": "026019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2422,
            "area": "",
            "ech": 0
        },
        {
            "id": 2199,
            "name": "Codogno",
            "provincia": "LO",
            "cap": "26845",
            "cod_catastale": "C816",
            "cod_istat": "098019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2200,
            "name": "Codroipo",
            "provincia": "UD",
            "cap": "33033",
            "cod_catastale": "C817",
            "cod_istat": "030027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2201,
            "name": "Codrongianos",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "C818",
            "cod_istat": "090026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 1632,
            "area": "",
            "ech": 0
        },
        {
            "id": 2202,
            "name": "Coggiola",
            "provincia": "BI",
            "cap": "13863",
            "cod_catastale": "C819",
            "cod_istat": "096019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2902,
            "area": "",
            "ech": 0
        },
        {
            "id": 2203,
            "name": "Cogliate",
            "provincia": "MB",
            "cap": "20815",
            "cod_catastale": "C820",
            "cod_istat": "108020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 2204,
            "name": "Cogne",
            "provincia": "AO",
            "cap": "11012",
            "cod_catastale": "C821",
            "cod_istat": "007021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1534,
            "giorni": 4533,
            "area": "",
            "ech": 0
        },
        {
            "id": 2205,
            "name": "Cogoleto",
            "provincia": "GE",
            "cap": "16016",
            "cod_catastale": "C823",
            "cod_istat": "010017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1517,
            "area": "",
            "ech": 0
        },
        {
            "id": 2206,
            "name": "Cogollo del Cengio",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "C824",
            "cod_istat": "024032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2799,
            "area": "",
            "ech": 0
        },
        {
            "id": 2207,
            "name": "Cogorno",
            "provincia": "GE",
            "cap": "16030",
            "cod_catastale": "C826",
            "cod_istat": "010018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1490,
            "area": "",
            "ech": 0
        },
        {
            "id": 2208,
            "name": "Colazza",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "C829",
            "cod_istat": "003051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 2949,
            "area": "",
            "ech": 0
        },
        {
            "id": 2209,
            "name": "Colbordolo",
            "provincia": "PU",
            "cap": "61022",
            "cod_catastale": "C830",
            "cod_istat": "041012",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2309,
            "area": "",
            "ech": 0
        },
        {
            "id": 2210,
            "name": "Colere",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "C835",
            "cod_istat": "016078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1013,
            "giorni": 3508,
            "area": "",
            "ech": 0
        },
        {
            "id": 2211,
            "name": "Colfelice",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "C836",
            "cod_istat": "060027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 1425,
            "area": "",
            "ech": 0
        },
        {
            "id": 2212,
            "name": "Coli",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "C838",
            "cod_istat": "033016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 638,
            "giorni": 3274,
            "area": "",
            "ech": 0
        },
        {
            "id": 2213,
            "name": "Colico",
            "provincia": "LC",
            "cap": "23823",
            "cod_catastale": "C839",
            "cod_istat": "097023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 2214,
            "name": "Collagna",
            "provincia": "RE",
            "cap": "42037",
            "cod_catastale": "C840",
            "cod_istat": "035019",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 3370,
            "area": "",
            "ech": 0
        },
        {
            "id": 2215,
            "name": "Collalto Sabino",
            "provincia": "RI",
            "cap": "02022",
            "cod_catastale": "C841",
            "cod_istat": "057018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 980,
            "giorni": 3148,
            "area": "",
            "ech": 0
        },
        {
            "id": 2216,
            "name": "Collarmele",
            "provincia": "AQ",
            "cap": "67040",
            "cod_catastale": "C844",
            "cod_istat": "066038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 835,
            "giorni": 2783,
            "area": "",
            "ech": 0
        },
        {
            "id": 2217,
            "name": "Collazzone",
            "provincia": "PG",
            "cap": "06050",
            "cod_catastale": "C845",
            "cod_istat": "054014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 469,
            "giorni": 2266,
            "area": "",
            "ech": 0
        },
        {
            "id": 2218,
            "name": "Colle Brianza",
            "provincia": "LC",
            "cap": "23886",
            "cod_catastale": "C851",
            "cod_istat": "097024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 558,
            "giorni": 2862,
            "area": "",
            "ech": 0
        },
        {
            "id": 2219,
            "name": "Colle d'Anchise",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "C854",
            "cod_istat": "070020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 649,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 2220,
            "name": "Colle di Tora",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "C857",
            "cod_istat": "057019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 542,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 2221,
            "name": "Colle di Val d'Elsa",
            "provincia": "SI",
            "cap": "53034",
            "cod_catastale": "C847",
            "cod_istat": "052012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 1776,
            "area": "",
            "ech": 0
        },
        {
            "id": 2222,
            "name": "Colle San Magno",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "C870",
            "cod_istat": "060029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 2103,
            "area": "",
            "ech": 0
        },
        {
            "id": 2223,
            "name": "Colle Sannita",
            "provincia": "BN",
            "cap": "82024",
            "cod_catastale": "C846",
            "cod_istat": "062025",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 769,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 2224,
            "name": "Colle Santa Lucia",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "C872",
            "cod_istat": "025014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1453,
            "giorni": 4880,
            "area": "",
            "ech": 0
        },
        {
            "id": 2225,
            "name": "Colle Umberto",
            "provincia": "TV",
            "cap": "31014",
            "cod_catastale": "C848",
            "cod_istat": "026020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 2226,
            "name": "Collebeato",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "C850",
            "cod_istat": "017057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 2227,
            "name": "Collecchio",
            "provincia": "PR",
            "cap": "43044",
            "cod_catastale": "C852",
            "cod_istat": "034009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2600,
            "area": "",
            "ech": 0
        },
        {
            "id": 2228,
            "name": "Collecorvino",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "C853",
            "cod_istat": "068015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 1652,
            "area": "",
            "ech": 0
        },
        {
            "id": 2229,
            "name": "Colledara",
            "provincia": "TE",
            "cap": "64042",
            "cod_catastale": "C311",
            "cod_istat": "067018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 2065,
            "area": "",
            "ech": 0
        },
        {
            "id": 2230,
            "name": "Colledimacine",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "C855",
            "cod_istat": "069025",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 770,
            "giorni": 2351,
            "area": "",
            "ech": 0
        },
        {
            "id": 2231,
            "name": "Colledimezzo",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "C856",
            "cod_istat": "069026",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 425,
            "giorni": 1832,
            "area": "",
            "ech": 0
        },
        {
            "id": 2232,
            "name": "Colleferro",
            "provincia": "RM",
            "cap": "00034",
            "cod_catastale": "C858",
            "cod_istat": "058034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 1571,
            "area": "",
            "ech": 0
        },
        {
            "id": 2233,
            "name": "Collegiove",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "C859",
            "cod_istat": "057020",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1001,
            "giorni": 3187,
            "area": "",
            "ech": 0
        },
        {
            "id": 2234,
            "name": "Collegno",
            "provincia": "TO",
            "cap": "10093",
            "cod_catastale": "C860",
            "cod_istat": "001090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 302,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 2235,
            "name": "Collelongo",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "C862",
            "cod_istat": "066039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 915,
            "giorni": 2926,
            "area": "",
            "ech": 0
        },
        {
            "id": 2236,
            "name": "Collepardo",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "C864",
            "cod_istat": "060028",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 586,
            "giorni": 2266,
            "area": "",
            "ech": 0
        },
        {
            "id": 2237,
            "name": "Collepasso",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "C865",
            "cod_istat": "075021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 1290,
            "area": "",
            "ech": 0
        },
        {
            "id": 2238,
            "name": "Collepietro",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "C866",
            "cod_istat": "066040",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 849,
            "giorni": 2808,
            "area": "",
            "ech": 0
        },
        {
            "id": 2239,
            "name": "Colleretto Castelnuovo",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "C867",
            "cod_istat": "001091",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 585,
            "giorni": 3094,
            "area": "",
            "ech": 0
        },
        {
            "id": 2240,
            "name": "Colleretto Giacosa",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "C868",
            "cod_istat": "001092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2779,
            "area": "",
            "ech": 0
        },
        {
            "id": 2241,
            "name": "Collesalvetti",
            "provincia": "LI",
            "cap": "57014",
            "cod_catastale": "C869",
            "cod_istat": "049008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1500,
            "area": "",
            "ech": 0
        },
        {
            "id": 2242,
            "name": "Collesano",
            "provincia": "PA",
            "cap": "90016",
            "cod_catastale": "C871",
            "cod_istat": "082032",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 468,
            "giorni": 1379,
            "area": "",
            "ech": 0
        },
        {
            "id": 2243,
            "name": "Colletorto",
            "provincia": "CB",
            "cap": "86044",
            "cod_catastale": "C875",
            "cod_istat": "070021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 515,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 2244,
            "name": "Collevecchio",
            "provincia": "RI",
            "cap": "02042",
            "cod_catastale": "C876",
            "cod_istat": "057021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 2245,
            "name": "Colli a Volturno",
            "provincia": "IS",
            "cap": "86073",
            "cod_catastale": "C878",
            "cod_istat": "094017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 1804,
            "area": "",
            "ech": 0
        },
        {
            "id": 2246,
            "name": "Colli del Tronto",
            "provincia": "AP",
            "cap": "63079",
            "cod_catastale": "C877",
            "cod_istat": "044014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 168,
            "giorni": 1495,
            "area": "",
            "ech": 0
        },
        {
            "id": 2247,
            "name": "Colli sul Velino",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "C880",
            "cod_istat": "057022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 2211,
            "area": "",
            "ech": 0
        },
        {
            "id": 2248,
            "name": "Colliano",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "C879",
            "cod_istat": "065043",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 630,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 2249,
            "name": "Collinas",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "C882",
            "cod_istat": "111012",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 249,
            "giorni": 1343,
            "area": "",
            "ech": 0
        },
        {
            "id": 2250,
            "name": "Collio",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "C883",
            "cod_istat": "017058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 3473,
            "area": "",
            "ech": 0
        },
        {
            "id": 2251,
            "name": "Collobiano",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "C884",
            "cod_istat": "002045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 2768,
            "area": "",
            "ech": 0
        },
        {
            "id": 2252,
            "name": "Colloredo di Monte Albano",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "C885",
            "cod_istat": "030028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 2253,
            "name": "Colmurano",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "C886",
            "cod_istat": "043014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2124,
            "area": "",
            "ech": 0
        },
        {
            "id": 2254,
            "name": "Colobraro",
            "provincia": "MT",
            "cap": "75021",
            "cod_catastale": "C888",
            "cod_istat": "077006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2006,
            "area": "",
            "ech": 0
        },
        {
            "id": 2255,
            "name": "Cologna Veneta",
            "provincia": "VR",
            "cap": "37044",
            "cod_catastale": "C890",
            "cod_istat": "023027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 2256,
            "name": "Cologne",
            "provincia": "BS",
            "cap": "25033",
            "cod_catastale": "C893",
            "cod_istat": "017059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2257,
            "name": "Cologno al Serio",
            "provincia": "BG",
            "cap": "24055",
            "cod_catastale": "C894",
            "cod_istat": "016079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 2258,
            "name": "Cologno Monzese",
            "provincia": "MI",
            "cap": "20093",
            "cod_catastale": "C895",
            "cod_istat": "015081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2259,
            "name": "Colognola ai Colli",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "C897",
            "cod_istat": "023028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 2260,
            "name": "Colonna",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "C900",
            "cod_istat": "058035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 1832,
            "area": "",
            "ech": 0
        },
        {
            "id": 2261,
            "name": "Colonnella",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "C901",
            "cod_istat": "067019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 1815,
            "area": "",
            "ech": 0
        },
        {
            "id": 2262,
            "name": "Colonno",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "C902",
            "cod_istat": "013074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 2263,
            "name": "Colorina",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "C903",
            "cod_istat": "014023",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 302,
            "giorni": 3080,
            "area": "",
            "ech": 0
        },
        {
            "id": 2264,
            "name": "Colorno",
            "provincia": "PR",
            "cap": "43052",
            "cod_catastale": "C904",
            "cod_istat": "034010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 2265,
            "name": "Colosimi",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "C905",
            "cod_istat": "078043",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 870,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 2266,
            "name": "Colturano",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "C908",
            "cod_istat": "015082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2267,
            "name": "Colzate",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "C910",
            "cod_istat": "016080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 2672,
            "area": "",
            "ech": 0
        },
        {
            "id": 2268,
            "name": "Comabbio",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "C911",
            "cod_istat": "012054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 2269,
            "name": "Comacchio",
            "provincia": "FE",
            "cap": "44022",
            "cod_catastale": "C912",
            "cod_istat": "038006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 0,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 2270,
            "name": "Comano",
            "provincia": "MS",
            "cap": "54015",
            "cod_catastale": "C914",
            "cod_istat": "045005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 2271,
            "name": "Comano Terme",
            "provincia": "TN",
            "cap": "38077",
            "cod_catastale": "M314",
            "cod_istat": "022228",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2272,
            "name": "Comazzo",
            "provincia": "LO",
            "cap": "26833",
            "cod_catastale": "C917",
            "cod_istat": "098020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 2273,
            "name": "Comeglians",
            "provincia": "UD",
            "cap": "33023",
            "cod_catastale": "C918",
            "cod_istat": "030029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 553,
            "giorni": 3469,
            "area": "",
            "ech": 0
        },
        {
            "id": 2274,
            "name": "Comelico Superiore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "C920",
            "cod_istat": "025015",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 4496,
            "area": "",
            "ech": 0
        },
        {
            "id": 2275,
            "name": "Comerio",
            "provincia": "VA",
            "cap": "21025",
            "cod_catastale": "C922",
            "cod_istat": "012055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 2276,
            "name": "Comezzano-Cizzago",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "C925",
            "cod_istat": "017060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 2277,
            "name": "Comignago",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "C926",
            "cod_istat": "003052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2509,
            "area": "",
            "ech": 0
        },
        {
            "id": 2278,
            "name": "Comiso",
            "provincia": "RG",
            "cap": "97013",
            "cod_catastale": "C927",
            "cod_istat": "088003",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 1012,
            "area": "",
            "ech": 1
        },
        {
            "id": 2279,
            "name": "Comitini",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "C928",
            "cod_istat": "084016",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 350,
            "giorni": 1077,
            "area": "",
            "ech": 0
        },
        {
            "id": 2280,
            "name": "Comiziano",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "C929",
            "cod_istat": "063029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 1259,
            "area": "",
            "ech": 0
        },
        {
            "id": 2281,
            "name": "Commessaggio",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "C930",
            "cod_istat": "020020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 2282,
            "name": "Commezzadura",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "C931",
            "cod_istat": "022064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 3717,
            "area": "",
            "ech": 0
        },
        {
            "id": 2283,
            "name": "Como",
            "provincia": "CO",
            "cap": "22100",
            "cod_catastale": "C933",
            "cod_istat": "013075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2228,
            "area": "",
            "ech": 0
        },
        {
            "id": 2284,
            "name": "Compiano",
            "provincia": "PR",
            "cap": "43053",
            "cod_catastale": "C934",
            "cod_istat": "034011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 519,
            "giorni": 3024,
            "area": "",
            "ech": 0
        },
        {
            "id": 2285,
            "name": "Comun Nuovo",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "C937",
            "cod_istat": "016081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 188,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 2286,
            "name": "Comunanza",
            "provincia": "AP",
            "cap": "63087",
            "cod_catastale": "C935",
            "cod_istat": "044015",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 448,
            "giorni": 2164,
            "area": "",
            "ech": 0
        },
        {
            "id": 2287,
            "name": "Cona",
            "provincia": "VE",
            "cap": "30010",
            "cod_catastale": "C938",
            "cod_istat": "027010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 2288,
            "name": "Conca Casale",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "C941",
            "cod_istat": "094018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 657,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 2289,
            "name": "Conca dei Marini",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "C940",
            "cod_istat": "065044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1169,
            "area": "",
            "ech": 0
        },
        {
            "id": 2290,
            "name": "Conca della Campania",
            "provincia": "CE",
            "cap": "81044",
            "cod_catastale": "C939",
            "cod_istat": "061031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1892,
            "area": "",
            "ech": 0
        },
        {
            "id": 2291,
            "name": "Concamarise",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "C943",
            "cod_istat": "023029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2330,
            "area": "",
            "ech": 0
        },
        {
            "id": 2292,
            "name": "Concerviano",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "C946",
            "cod_istat": "057023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 2241,
            "area": "",
            "ech": 0
        },
        {
            "id": 2293,
            "name": "Concesio",
            "provincia": "BS",
            "cap": "25062",
            "cod_catastale": "C948",
            "cod_istat": "017061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 2294,
            "name": "Conco",
            "provincia": "VI",
            "cap": "36062",
            "cod_catastale": "C949",
            "cod_istat": "024033",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 3656,
            "area": "",
            "ech": 0
        },
        {
            "id": 2295,
            "name": "Concordia Sagittaria",
            "provincia": "VE",
            "cap": "30023",
            "cod_catastale": "C950",
            "cod_istat": "027011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 2296,
            "name": "Concordia sulla Secchia",
            "provincia": "MO",
            "cap": "41033",
            "cod_catastale": "C951",
            "cod_istat": "036010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 2297,
            "name": "Concorezzo",
            "provincia": "MB",
            "cap": "20863",
            "cod_catastale": "C952",
            "cod_istat": "108021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2298,
            "name": "Condino",
            "provincia": "TN",
            "cap": "38083",
            "cod_catastale": "C953",
            "cod_istat": "022066",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 3083,
            "area": "",
            "ech": 0
        },
        {
            "id": 2299,
            "name": "Condofuri",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "C954",
            "cod_istat": "080029",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 339,
            "giorni": 1323,
            "area": "",
            "ech": 1
        },
        {
            "id": 2300,
            "name": "Condove",
            "provincia": "TO",
            "cap": "10055",
            "cod_catastale": "C955",
            "cod_istat": "001093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2918,
            "area": "",
            "ech": 0
        },
        {
            "id": 2301,
            "name": "Condrò",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "C956",
            "cod_istat": "083018",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 726,
            "area": "",
            "ech": 1
        },
        {
            "id": 2302,
            "name": "Conegliano",
            "provincia": "TV",
            "cap": "31015",
            "cod_catastale": "C957",
            "cod_istat": "026021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 2303,
            "name": "Confienza",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "C958",
            "cod_istat": "018052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 2304,
            "name": "Configni",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "C959",
            "cod_istat": "057024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 2305,
            "name": "Conflenti",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "C960",
            "cod_istat": "079033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1883,
            "area": "",
            "ech": 0
        },
        {
            "id": 2306,
            "name": "Coniolo",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "C962",
            "cod_istat": "006060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 2307,
            "name": "Conselice",
            "provincia": "RA",
            "cap": "48017",
            "cod_catastale": "C963",
            "cod_istat": "039008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2239,
            "area": "",
            "ech": 0
        },
        {
            "id": 2308,
            "name": "Conselve",
            "provincia": "PD",
            "cap": "35026",
            "cod_catastale": "C964",
            "cod_istat": "028034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 2309,
            "name": "Contessa Entellina",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "C968",
            "cod_istat": "082033",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 571,
            "giorni": 1588,
            "area": "",
            "ech": 1
        },
        {
            "id": 2310,
            "name": "Contigliano",
            "provincia": "RI",
            "cap": "02043",
            "cod_catastale": "C969",
            "cod_istat": "057025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 488,
            "giorni": 2253,
            "area": "",
            "ech": 0
        },
        {
            "id": 2311,
            "name": "Contrada",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "C971",
            "cod_istat": "064029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 2312,
            "name": "Controguerra",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "C972",
            "cod_istat": "067020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 1751,
            "area": "",
            "ech": 0
        },
        {
            "id": 2313,
            "name": "Controne",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "C973",
            "cod_istat": "065045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 200,
            "giorni": 1467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2314,
            "name": "Contursi Terme",
            "provincia": "SA",
            "cap": "84024",
            "cod_catastale": "C974",
            "cod_istat": "065046",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 250,
            "giorni": 1546,
            "area": "",
            "ech": 0
        },
        {
            "id": 2315,
            "name": "Conversano",
            "provincia": "BA",
            "cap": "70014",
            "cod_catastale": "C975",
            "cod_istat": "072019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 1642,
            "area": "",
            "ech": 0
        },
        {
            "id": 2316,
            "name": "Conza della Campania",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "C976",
            "cod_istat": "064030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 594,
            "giorni": 2086,
            "area": "",
            "ech": 0
        },
        {
            "id": 2317,
            "name": "Conzano",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "C977",
            "cod_istat": "006061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2702,
            "area": "",
            "ech": 0
        },
        {
            "id": 2318,
            "name": "Copertino",
            "provincia": "LE",
            "cap": "73043",
            "cod_catastale": "C978",
            "cod_istat": "075022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1194,
            "area": "",
            "ech": 0
        },
        {
            "id": 2319,
            "name": "Copiano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "C979",
            "cod_istat": "018053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2320,
            "name": "Copparo",
            "provincia": "FE",
            "cap": "44034",
            "cod_catastale": "C980",
            "cod_istat": "038007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2322,
            "area": "",
            "ech": 0
        },
        {
            "id": 2321,
            "name": "Corana",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "C982",
            "cod_istat": "018054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 2322,
            "name": "Corato",
            "provincia": "BA",
            "cap": "70033",
            "cod_catastale": "C983",
            "cod_istat": "072020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 1545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2323,
            "name": "Corbara",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "C984",
            "cod_istat": "065047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 167,
            "giorni": 1349,
            "area": "",
            "ech": 0
        },
        {
            "id": 2324,
            "name": "Corbetta",
            "provincia": "MI",
            "cap": "20011",
            "cod_catastale": "C986",
            "cod_istat": "015085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 2325,
            "name": "Corbola",
            "provincia": "RO",
            "cap": "45015",
            "cod_catastale": "C987",
            "cod_istat": "029017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 2326,
            "name": "Corchiano",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "C988",
            "cod_istat": "056023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 196,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 2327,
            "name": "Corciano",
            "provincia": "PG",
            "cap": "06073",
            "cod_catastale": "C990",
            "cod_istat": "054015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 2204,
            "area": "",
            "ech": 0
        },
        {
            "id": 2328,
            "name": "Cordenons",
            "provincia": "PN",
            "cap": "33084",
            "cod_catastale": "C991",
            "cod_istat": "093017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 2329,
            "name": "Cordignano",
            "provincia": "TV",
            "cap": "31016",
            "cod_catastale": "C992",
            "cod_istat": "026022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2456,
            "area": "",
            "ech": 0
        },
        {
            "id": 2330,
            "name": "Cordovado",
            "provincia": "PN",
            "cap": "33075",
            "cod_catastale": "C993",
            "cod_istat": "093018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 2331,
            "name": "Coredo",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "C994",
            "cod_istat": "022067",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 831,
            "giorni": 3687,
            "area": "",
            "ech": 0
        },
        {
            "id": 2332,
            "name": "Coreglia Antelminelli",
            "provincia": "LU",
            "cap": "55025",
            "cod_catastale": "C996",
            "cod_istat": "046011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 595,
            "giorni": 2892,
            "area": "",
            "ech": 0
        },
        {
            "id": 2333,
            "name": "Coreglia Ligure",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "C995",
            "cod_istat": "010019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 2220,
            "area": "",
            "ech": 0
        },
        {
            "id": 2334,
            "name": "Coreno Ausonio",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "C998",
            "cod_istat": "060030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 318,
            "giorni": 1717,
            "area": "",
            "ech": 0
        },
        {
            "id": 2335,
            "name": "Corfinio",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "C999",
            "cod_istat": "066041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 1908,
            "area": "",
            "ech": 0
        },
        {
            "id": 2336,
            "name": "Cori",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "D003",
            "cod_istat": "059006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 384,
            "giorni": 1781,
            "area": "",
            "ech": 0
        },
        {
            "id": 2337,
            "name": "Coriano",
            "provincia": "RN",
            "cap": "47853",
            "cod_catastale": "D004",
            "cod_istat": "099003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 2338,
            "name": "Corigliano Calabro",
            "provincia": "CS",
            "cap": "87064",
            "cod_catastale": "D005",
            "cod_istat": "078044",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1146,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 2339,
            "name": "Corigliano d'Otranto",
            "provincia": "LE",
            "cap": "73022",
            "cod_catastale": "D006",
            "cod_istat": "075023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 2340,
            "name": "Corinaldo",
            "provincia": "AN",
            "cap": "60013",
            "cod_catastale": "D007",
            "cod_istat": "042015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 1903,
            "area": "",
            "ech": 0
        },
        {
            "id": 2341,
            "name": "Corio",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "D008",
            "cod_istat": "001094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 3291,
            "area": "",
            "ech": 0
        },
        {
            "id": 2342,
            "name": "Corleone",
            "provincia": "PA",
            "cap": "90034",
            "cod_catastale": "D009",
            "cod_istat": "082034",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1481,
            "area": "",
            "ech": 1
        },
        {
            "id": 2343,
            "name": "Corleto Monforte",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "D011",
            "cod_istat": "065048",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 672,
            "giorni": 1921,
            "area": "",
            "ech": 0
        },
        {
            "id": 2344,
            "name": "Corleto Perticara",
            "provincia": "PZ",
            "cap": "85012",
            "cod_catastale": "D010",
            "cod_istat": "076029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 757,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 2345,
            "name": "Cormano",
            "provincia": "MI",
            "cap": "20032",
            "cod_catastale": "D013",
            "cod_istat": "015086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2346,
            "name": "Cormons",
            "provincia": "GO",
            "cap": "34071",
            "cod_catastale": "D014",
            "cod_istat": "031002",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2283,
            "area": "",
            "ech": 0
        },
        {
            "id": 2347,
            "name": "Corna Imagna",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "D015",
            "cod_istat": "016082",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 736,
            "giorni": 3115,
            "area": "",
            "ech": 0
        },
        {
            "id": 2348,
            "name": "Cornalba",
            "provincia": "BG",
            "cap": "24017",
            "cod_catastale": "D016",
            "cod_istat": "016249",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 893,
            "giorni": 3338,
            "area": "",
            "ech": 0
        },
        {
            "id": 2349,
            "name": "Cornale",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "D017",
            "cod_istat": "018191",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 2350,
            "name": "Cornaredo",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "D018",
            "cod_istat": "015087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 2351,
            "name": "Cornate d'Adda",
            "provincia": "MB",
            "cap": "20872",
            "cod_catastale": "D019",
            "cod_istat": "108053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 2352,
            "name": "Cornedo all'Isarco",
            "provincia": "BZ",
            "cap": "39053",
            "cod_catastale": "B799",
            "cod_istat": "021023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2833,
            "area": "",
            "ech": 0
        },
        {
            "id": 2353,
            "name": "Cornedo Vicentino",
            "provincia": "VI",
            "cap": "36073",
            "cod_catastale": "D020",
            "cod_istat": "024034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 2354,
            "name": "Cornegliano Laudense",
            "provincia": "LO",
            "cap": "26854",
            "cod_catastale": "D021",
            "cod_istat": "098021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 2355,
            "name": "Corneliano d'Alba",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "D022",
            "cod_istat": "004072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 2356,
            "name": "Corniglio",
            "provincia": "PR",
            "cap": "43021",
            "cod_catastale": "D026",
            "cod_istat": "034012",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 690,
            "giorni": 3429,
            "area": "",
            "ech": 0
        },
        {
            "id": 2357,
            "name": "Corno di Rosazzo",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "D027",
            "cod_istat": "030030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2358,
            "name": "Corno Giovine",
            "provincia": "LO",
            "cap": "26846",
            "cod_catastale": "D028",
            "cod_istat": "098022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2359,
            "name": "Cornovecchio",
            "provincia": "LO",
            "cap": "26842",
            "cod_catastale": "D029",
            "cod_istat": "098023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2360,
            "name": "Cornuda",
            "provincia": "TV",
            "cap": "31041",
            "cod_catastale": "D030",
            "cod_istat": "026023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 163,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 2361,
            "name": "Correggio",
            "provincia": "RE",
            "cap": "42015",
            "cod_catastale": "D037",
            "cod_istat": "035020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 2362,
            "name": "Correzzana",
            "provincia": "MB",
            "cap": "20856",
            "cod_catastale": "D038",
            "cod_istat": "108022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 2363,
            "name": "Correzzola",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "D040",
            "cod_istat": "028035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 2364,
            "name": "Corrido",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D041",
            "cod_istat": "013077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 483,
            "giorni": 2755,
            "area": "",
            "ech": 0
        },
        {
            "id": 2365,
            "name": "Corridonia",
            "provincia": "MC",
            "cap": "62014",
            "cod_catastale": "D042",
            "cod_istat": "043015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 1976,
            "area": "",
            "ech": 0
        },
        {
            "id": 2366,
            "name": "Corropoli",
            "provincia": "TE",
            "cap": "64013",
            "cod_catastale": "D043",
            "cod_istat": "067021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 1434,
            "area": "",
            "ech": 0
        },
        {
            "id": 2367,
            "name": "Corsano",
            "provincia": "LE",
            "cap": "73033",
            "cod_catastale": "D044",
            "cod_istat": "075024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 1211,
            "area": "",
            "ech": 0
        },
        {
            "id": 2368,
            "name": "Corsico",
            "provincia": "MI",
            "cap": "20094",
            "cod_catastale": "D045",
            "cod_istat": "015093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2369,
            "name": "Corsione",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "D046",
            "cod_istat": "005044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 2370,
            "name": "Cortaccia sulla strada del vino",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "D048",
            "cod_istat": "021024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 2910,
            "area": "",
            "ech": 0
        },
        {
            "id": 2371,
            "name": "Cortale",
            "provincia": "CZ",
            "cap": "88020",
            "cod_catastale": "D049",
            "cod_istat": "079034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1642,
            "area": "",
            "ech": 0
        },
        {
            "id": 2372,
            "name": "Cortandone",
            "provincia": "AT",
            "cap": "14013",
            "cod_catastale": "D050",
            "cod_istat": "005045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2697,
            "area": "",
            "ech": 0
        },
        {
            "id": 2373,
            "name": "Cortanze",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "D051",
            "cod_istat": "005046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2733,
            "area": "",
            "ech": 0
        },
        {
            "id": 2374,
            "name": "Cortazzone",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "D052",
            "cod_istat": "005047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 2375,
            "name": "Corte Brugnatella",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "D054",
            "cod_istat": "033017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2902,
            "area": "",
            "ech": 0
        },
        {
            "id": 2376,
            "name": "Corte de' Cortesi con Cignone",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "D056",
            "cod_istat": "019032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2377,
            "name": "Corte de' Frati",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "D057",
            "cod_istat": "019033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2378,
            "name": "Corte Franca",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "D058",
            "cod_istat": "017062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 2379,
            "name": "Corte Palasio",
            "provincia": "LO",
            "cap": "26834",
            "cod_catastale": "D068",
            "cod_istat": "098024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 2380,
            "name": "Cortemaggiore",
            "provincia": "PC",
            "cap": "29016",
            "cod_catastale": "D061",
            "cod_istat": "033018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 2381,
            "name": "Cortemilia",
            "provincia": "CN",
            "cap": "12074",
            "cod_catastale": "D062",
            "cod_istat": "004073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2621,
            "area": "",
            "ech": 0
        },
        {
            "id": 2382,
            "name": "Corteno Golgi",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "D064",
            "cod_istat": "017063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 925,
            "giorni": 3532,
            "area": "",
            "ech": 0
        },
        {
            "id": 2383,
            "name": "Cortenova",
            "provincia": "LC",
            "cap": "23813",
            "cod_catastale": "D065",
            "cod_istat": "097025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 483,
            "giorni": 2755,
            "area": "",
            "ech": 0
        },
        {
            "id": 2384,
            "name": "Cortenuova",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "D066",
            "cod_istat": "016083",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2385,
            "name": "Corteolona",
            "provincia": "PV",
            "cap": "27014",
            "cod_catastale": "D067",
            "cod_istat": "018192",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2386,
            "name": "Cortiglione",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "D072",
            "cod_istat": "005048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 2387,
            "name": "Cortina d'Ampezzo",
            "provincia": "BL",
            "cap": "32043",
            "cod_catastale": "A266",
            "cod_istat": "025016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1211,
            "giorni": 4433,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 2388,
            "name": "Cortina sulla strada del vino",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "D075",
            "cod_istat": "021025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 2389,
            "name": "Cortino",
            "provincia": "TE",
            "cap": "64040",
            "cod_catastale": "D076",
            "cod_istat": "067022",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 982,
            "giorni": 3031,
            "area": "",
            "ech": 0
        },
        {
            "id": 2390,
            "name": "Cortona",
            "provincia": "AR",
            "cap": "52044",
            "cod_catastale": "D077",
            "cod_istat": "051017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 494,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 2391,
            "name": "Corvara",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "D078",
            "cod_istat": "068016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 2214,
            "area": "",
            "ech": 0
        },
        {
            "id": 2392,
            "name": "Corvara in Badia",
            "provincia": "BZ",
            "cap": "39033",
            "cod_catastale": "D079",
            "cod_istat": "021026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1568,
            "giorni": 5135,
            "area": "",
            "ech": 0
        },
        {
            "id": 2393,
            "name": "Corvino San Quirico",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "D081",
            "cod_istat": "018057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2842,
            "area": "",
            "ech": 0
        },
        {
            "id": 2394,
            "name": "Corzano",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "D082",
            "cod_istat": "017064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2341,
            "area": "",
            "ech": 0
        },
        {
            "id": 2395,
            "name": "Coseano",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "D085",
            "cod_istat": "030031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 2396,
            "name": "Cosenza",
            "provincia": "CS",
            "cap": "87100",
            "cod_catastale": "D086",
            "cod_istat": "078045",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 238,
            "giorni": 1317,
            "area": "",
            "ech": 0
        },
        {
            "id": 2397,
            "name": "Cosio d'Arroscia",
            "provincia": "IM",
            "cap": "18023",
            "cod_catastale": "D087",
            "cod_istat": "008023",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2398,
            "name": "Cosio Valtellino",
            "provincia": "SO",
            "cap": "23013",
            "cod_catastale": "D088",
            "cod_istat": "014024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 3013,
            "area": "",
            "ech": 0
        },
        {
            "id": 2399,
            "name": "Cosoleto",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "D089",
            "cod_istat": "080030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 440,
            "giorni": 1574,
            "area": "",
            "ech": 0
        },
        {
            "id": 2400,
            "name": "Cossano Belbo",
            "provincia": "CN",
            "cap": "12054",
            "cod_catastale": "D093",
            "cod_istat": "004074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 2401,
            "name": "Cossano Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "D092",
            "cod_istat": "001095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 2873,
            "area": "",
            "ech": 0
        },
        {
            "id": 2402,
            "name": "Cossato",
            "provincia": "BI",
            "cap": "13836",
            "cod_catastale": "D094",
            "cod_istat": "096020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 2403,
            "name": "Cosseria",
            "provincia": "SV",
            "cap": "17017",
            "cod_catastale": "D095",
            "cod_istat": "009026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2519,
            "area": "",
            "ech": 0
        },
        {
            "id": 2404,
            "name": "Cossignano",
            "provincia": "AP",
            "cap": "63067",
            "cod_catastale": "D096",
            "cod_istat": "044016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2108,
            "area": "",
            "ech": 0
        },
        {
            "id": 2405,
            "name": "Cossogno",
            "provincia": "VB",
            "cap": "28801",
            "cod_catastale": "D099",
            "cod_istat": "103023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2798,
            "area": "",
            "ech": 0
        },
        {
            "id": 2406,
            "name": "Cossoine",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "D100",
            "cod_istat": "090027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 529,
            "giorni": 1921,
            "area": "",
            "ech": 0
        },
        {
            "id": 2407,
            "name": "Cossombrato",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "D101",
            "cod_istat": "005049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 2408,
            "name": "Costa de' Nobili",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "D109",
            "cod_istat": "018058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2409,
            "name": "Costa di Mezzate",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D110",
            "cod_istat": "016084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2489,
            "area": "",
            "ech": 0
        },
        {
            "id": 2410,
            "name": "Costa di Rovigo",
            "provincia": "RO",
            "cap": "45023",
            "cod_catastale": "D105",
            "cod_istat": "029018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 2411,
            "name": "Costa Masnaga",
            "provincia": "LC",
            "cap": "23845",
            "cod_catastale": "D112",
            "cod_istat": "097026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 318,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 2412,
            "name": "Costa Serina",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "D111",
            "cod_istat": "016247",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2413,
            "name": "Costa Valle Imagna",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "D103",
            "cod_istat": "016085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1014,
            "giorni": 3509,
            "area": "",
            "ech": 0
        },
        {
            "id": 2414,
            "name": "Costa Vescovato",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "D102",
            "cod_istat": "006062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 2415,
            "name": "Costa Volpino",
            "provincia": "BG",
            "cap": "24062",
            "cod_catastale": "D117",
            "cod_istat": "016086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 2416,
            "name": "Costabissara",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "D107",
            "cod_istat": "024035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 2417,
            "name": "Costacciaro",
            "provincia": "PG",
            "cap": "06021",
            "cod_catastale": "D108",
            "cod_istat": "054016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 2418,
            "name": "Costanzana",
            "provincia": "VC",
            "cap": "13033",
            "cod_catastale": "D113",
            "cod_istat": "002047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 2419,
            "name": "Costarainera",
            "provincia": "IM",
            "cap": "18017",
            "cod_catastale": "D114",
            "cod_istat": "008024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1645,
            "area": "",
            "ech": 0
        },
        {
            "id": 2420,
            "name": "Costermano sul Garda",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "D118",
            "cod_istat": "023030",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2421,
            "name": "Costigliole d'Asti",
            "provincia": "AT",
            "cap": "14055",
            "cod_catastale": "D119",
            "cod_istat": "005050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 2422,
            "name": "Costigliole Saluzzo",
            "provincia": "CN",
            "cap": "12024",
            "cod_catastale": "D120",
            "cod_istat": "004075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2991,
            "area": "",
            "ech": 0
        },
        {
            "id": 2423,
            "name": "Cotignola",
            "provincia": "RA",
            "cap": "48033",
            "cod_catastale": "D121",
            "cod_istat": "039009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 2424,
            "name": "Cotronei",
            "provincia": "KR",
            "cap": "88836",
            "cod_catastale": "D123",
            "cod_istat": "101009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 502,
            "giorni": 1846,
            "area": "",
            "ech": 0
        },
        {
            "id": 2425,
            "name": "Cottanello",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "D124",
            "cod_istat": "057026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 551,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 2426,
            "name": "Courmayeur",
            "provincia": "AO",
            "cap": "11013",
            "cod_catastale": "D012",
            "cod_istat": "007022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1224,
            "giorni": 3926,
            "area": "",
            "ech": 0
        },
        {
            "id": 2427,
            "name": "Covo",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "D126",
            "cod_istat": "016087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2428,
            "name": "Cozzo",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "D127",
            "cod_istat": "018059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 2429,
            "name": "Craco",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "D128",
            "cod_istat": "077007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 1655,
            "area": "",
            "ech": 0
        },
        {
            "id": 2430,
            "name": "Crandola Valsassina",
            "provincia": "LC",
            "cap": "23832",
            "cod_catastale": "D131",
            "cod_istat": "097027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 3177,
            "area": "",
            "ech": 0
        },
        {
            "id": 2431,
            "name": "Cravagliana",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "D132",
            "cod_istat": "002048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 615,
            "giorni": 3104,
            "area": "",
            "ech": 0
        },
        {
            "id": 2432,
            "name": "Cravanzana",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "D133",
            "cod_istat": "004076",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 585,
            "giorni": 3040,
            "area": "",
            "ech": 0
        },
        {
            "id": 2433,
            "name": "Craveggia",
            "provincia": "VB",
            "cap": "28852",
            "cod_catastale": "D134",
            "cod_istat": "103024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 889,
            "giorni": 3460,
            "area": "",
            "ech": 0
        },
        {
            "id": 2434,
            "name": "Creazzo",
            "provincia": "VI",
            "cap": "36051",
            "cod_catastale": "D136",
            "cod_istat": "024036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 2435,
            "name": "Crecchio",
            "provincia": "CH",
            "cap": "66014",
            "cod_catastale": "D137",
            "cod_istat": "069027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 1554,
            "area": "",
            "ech": 0
        },
        {
            "id": 2436,
            "name": "Credaro",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D139",
            "cod_istat": "016088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2437,
            "name": "Credera Rubbiano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "D141",
            "cod_istat": "019034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 2438,
            "name": "Crema",
            "provincia": "CR",
            "cap": "26013",
            "cod_catastale": "D142",
            "cod_istat": "019035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 2439,
            "name": "Cremella",
            "provincia": "LC",
            "cap": "23894",
            "cod_catastale": "D143",
            "cod_istat": "097028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 2440,
            "name": "Cremenaga",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D144",
            "cod_istat": "012056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2543,
            "area": "",
            "ech": 0
        },
        {
            "id": 2441,
            "name": "Cremeno",
            "provincia": "LC",
            "cap": "23814",
            "cod_catastale": "D145",
            "cod_istat": "097029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 792,
            "giorni": 3191,
            "area": "",
            "ech": 0
        },
        {
            "id": 2442,
            "name": "Cremia",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D147",
            "cod_istat": "013083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 2528,
            "area": "",
            "ech": 0
        },
        {
            "id": 2443,
            "name": "Cremolino",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "D149",
            "cod_istat": "006063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2822,
            "area": "",
            "ech": 0
        },
        {
            "id": 2444,
            "name": "Cremona",
            "provincia": "CR",
            "cap": "26100",
            "cod_catastale": "D150",
            "cod_istat": "019036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2389,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 2445,
            "name": "Cremosano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "D151",
            "cod_istat": "019037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 2446,
            "name": "Crescentino",
            "provincia": "VC",
            "cap": "13044",
            "cod_catastale": "D154",
            "cod_istat": "002049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 2447,
            "name": "Crespadoro",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "D156",
            "cod_istat": "024037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 2836,
            "area": "",
            "ech": 0
        },
        {
            "id": 2448,
            "name": "Crespano del Grappa",
            "provincia": "TV",
            "cap": "31017",
            "cod_catastale": "D157",
            "cod_istat": "026024",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2818,
            "area": "",
            "ech": 0
        },
        {
            "id": 2449,
            "name": "Crespellano",
            "provincia": "BO",
            "cap": "40056",
            "cod_catastale": "D158",
            "cod_istat": "037023",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 2450,
            "name": "Crespiatica",
            "provincia": "LO",
            "cap": "26835",
            "cod_catastale": "D159",
            "cod_istat": "098025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 2451,
            "name": "Crespina",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "D160",
            "cod_istat": "050041",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 1696,
            "area": "",
            "ech": 0
        },
        {
            "id": 2452,
            "name": "Crespino",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "D161",
            "cod_istat": "029019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2406,
            "area": "",
            "ech": 0
        },
        {
            "id": 2453,
            "name": "Cressa",
            "provincia": "NO",
            "cap": "28012",
            "cod_catastale": "D162",
            "cod_istat": "003055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2507,
            "area": "",
            "ech": 0
        },
        {
            "id": 2454,
            "name": "Crevacuore",
            "provincia": "BI",
            "cap": "13864",
            "cod_catastale": "D165",
            "cod_istat": "096021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 377,
            "giorni": 2795,
            "area": "",
            "ech": 0
        },
        {
            "id": 2455,
            "name": "Crevalcore",
            "provincia": "BO",
            "cap": "40014",
            "cod_catastale": "D166",
            "cod_istat": "037024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2238,
            "area": "",
            "ech": 0
        },
        {
            "id": 2456,
            "name": "Crevoladossola",
            "provincia": "VB",
            "cap": "28865",
            "cod_catastale": "D168",
            "cod_istat": "103025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2627,
            "area": "",
            "ech": 0
        },
        {
            "id": 2457,
            "name": "Crispano",
            "provincia": "NA",
            "cap": "80020",
            "cod_catastale": "D170",
            "cod_istat": "063030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 1030,
            "area": "",
            "ech": 0
        },
        {
            "id": 2458,
            "name": "Crispiano",
            "provincia": "TA",
            "cap": "74012",
            "cod_catastale": "D171",
            "cod_istat": "073004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 243,
            "giorni": 1386,
            "area": "",
            "ech": 0
        },
        {
            "id": 2459,
            "name": "Crissolo",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "D172",
            "cod_istat": "004077",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1318,
            "giorni": 3866,
            "area": "",
            "ech": 0
        },
        {
            "id": 2460,
            "name": "Crocefieschi",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "D175",
            "cod_istat": "010020",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 742,
            "giorni": 3467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2461,
            "name": "Crocetta del Montello",
            "provincia": "TV",
            "cap": "31035",
            "cod_catastale": "C670",
            "cod_istat": "026025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2461,
            "area": "",
            "ech": 0
        },
        {
            "id": 2462,
            "name": "Crodo",
            "provincia": "VB",
            "cap": "28862",
            "cod_catastale": "D177",
            "cod_istat": "103026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 505,
            "giorni": 2961,
            "area": "",
            "ech": 0
        },
        {
            "id": 2463,
            "name": "Crognaleto",
            "provincia": "TE",
            "cap": "64043",
            "cod_catastale": "D179",
            "cod_istat": "067023",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 835,
            "giorni": 2767,
            "area": "",
            "ech": 0
        },
        {
            "id": 2464,
            "name": "Cropalati",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "D180",
            "cod_istat": "078046",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 384,
            "giorni": 1602,
            "area": "",
            "ech": 0
        },
        {
            "id": 2465,
            "name": "Cropani",
            "provincia": "CZ",
            "cap": "88051",
            "cod_catastale": "D181",
            "cod_istat": "079036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 347,
            "giorni": 1264,
            "area": "",
            "ech": 1
        },
        {
            "id": 2466,
            "name": "Crosa",
            "provincia": "BI",
            "cap": "13853",
            "cod_catastale": "D182",
            "cod_istat": "096022",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 2467,
            "name": "Crosia",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "D184",
            "cod_istat": "078047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 1163,
            "area": "",
            "ech": 1
        },
        {
            "id": 2468,
            "name": "Crosio della Valle",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "D185",
            "cod_istat": "012057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 2469,
            "name": "Crotone",
            "provincia": "KR",
            "cap": "88900",
            "cod_catastale": "D122",
            "cod_istat": "101010",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 8,
            "giorni": 899,
            "area": "",
            "ech": 1
        },
        {
            "id": 2470,
            "name": "Crotta d'Adda",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "D186",
            "cod_istat": "019038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2471,
            "name": "Crova",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "D187",
            "cod_istat": "002052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 167,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 2472,
            "name": "Croviana",
            "provincia": "TN",
            "cap": "38027",
            "cod_catastale": "D188",
            "cod_istat": "022068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 3516,
            "area": "",
            "ech": 0
        },
        {
            "id": 2473,
            "name": "Crucoli",
            "provincia": "KR",
            "cap": "88812",
            "cod_catastale": "D189",
            "cod_istat": "101011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1547,
            "area": "",
            "ech": 1
        },
        {
            "id": 2474,
            "name": "Cuasso al Monte",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "D192",
            "cod_istat": "012058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 2475,
            "name": "Cuccaro Monferrato",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "D194",
            "cod_istat": "006064",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2677,
            "area": "",
            "ech": 0
        },
        {
            "id": 2476,
            "name": "Cuccaro Vetere",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "D195",
            "cod_istat": "065049",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 629,
            "giorni": 1914,
            "area": "",
            "ech": 0
        },
        {
            "id": 2477,
            "name": "Cucciago",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "D196",
            "cod_istat": "013084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2565,
            "area": "",
            "ech": 0
        },
        {
            "id": 2478,
            "name": "Cuceglio",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "D197",
            "cod_istat": "001096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2706,
            "area": "",
            "ech": 0
        },
        {
            "id": 2479,
            "name": "Cuggiono",
            "provincia": "MI",
            "cap": "20012",
            "cod_catastale": "D198",
            "cod_istat": "015096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 2480,
            "name": "Cugliate-Fabiasco",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D199",
            "cod_istat": "012059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2759,
            "area": "",
            "ech": 0
        },
        {
            "id": 2481,
            "name": "Cuglieri",
            "provincia": "OR",
            "cap": "09073",
            "cod_catastale": "D200",
            "cod_istat": "095019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 483,
            "giorni": 1554,
            "area": "",
            "ech": 0
        },
        {
            "id": 2482,
            "name": "Cugnoli",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "D201",
            "cod_istat": "068017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 331,
            "giorni": 1755,
            "area": "",
            "ech": 0
        },
        {
            "id": 2483,
            "name": "Cumiana",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "D202",
            "cod_istat": "001097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 377,
            "giorni": 2829,
            "area": "",
            "ech": 0
        },
        {
            "id": 2484,
            "name": "Cumignano sul Naviglio",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "D203",
            "cod_istat": "019039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 2485,
            "name": "Cunardo",
            "provincia": "VA",
            "cap": "21035",
            "cod_catastale": "D204",
            "cod_istat": "012060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 2486,
            "name": "Cuneo",
            "provincia": "CN",
            "cap": "12100",
            "cod_catastale": "D205",
            "cod_istat": "004078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 534,
            "giorni": 3012,
            "area": "",
            "ech": 0
        },
        {
            "id": 2487,
            "name": "Cunevo",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D206",
            "cod_istat": "022069",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 572,
            "giorni": 3283,
            "area": "",
            "ech": 0
        },
        {
            "id": 2488,
            "name": "Cunico",
            "provincia": "AT",
            "cap": "14026",
            "cod_catastale": "D207",
            "cod_istat": "005051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2698,
            "area": "",
            "ech": 0
        },
        {
            "id": 2489,
            "name": "Cuorgnè",
            "provincia": "TO",
            "cap": "10082",
            "cod_catastale": "D208",
            "cod_istat": "001098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2975,
            "area": "",
            "ech": 0
        },
        {
            "id": 2490,
            "name": "Cupello",
            "provincia": "CH",
            "cap": "66051",
            "cod_catastale": "D209",
            "cod_istat": "069028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 1646,
            "area": "",
            "ech": 0
        },
        {
            "id": 2491,
            "name": "Cupra Marittima",
            "provincia": "AP",
            "cap": "63064",
            "cod_catastale": "D210",
            "cod_istat": "044017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1644,
            "area": "",
            "ech": 0
        },
        {
            "id": 2492,
            "name": "Cupramontana",
            "provincia": "AN",
            "cap": "60034",
            "cod_catastale": "D211",
            "cod_istat": "042016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 505,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 2493,
            "name": "Cura Carpignano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "B824",
            "cod_istat": "018060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2494,
            "name": "Curcuris",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "D214",
            "cod_istat": "095077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1159,
            "area": "",
            "ech": 0
        },
        {
            "id": 2495,
            "name": "Cureggio",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "D216",
            "cod_istat": "003058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 2496,
            "name": "Curiglia con Monteviasco",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "D217",
            "cod_istat": "012061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 670,
            "giorni": 3050,
            "area": "",
            "ech": 0
        },
        {
            "id": 2497,
            "name": "Curinga",
            "provincia": "CZ",
            "cap": "88022",
            "cod_catastale": "D218",
            "cod_istat": "079039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1502,
            "area": "",
            "ech": 0
        },
        {
            "id": 2498,
            "name": "Curino",
            "provincia": "BI",
            "cap": "13865",
            "cod_catastale": "D219",
            "cod_istat": "096023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2811,
            "area": "",
            "ech": 0
        },
        {
            "id": 2499,
            "name": "Curno",
            "provincia": "BG",
            "cap": "24035",
            "cod_catastale": "D221",
            "cod_istat": "016089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2526,
            "area": "",
            "ech": 0
        },
        {
            "id": 2500,
            "name": "Curon Venosta",
            "provincia": "BZ",
            "cap": "39027",
            "cod_catastale": "D222",
            "cod_istat": "021027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1520,
            "giorni": 5036,
            "area": "",
            "ech": 0
        },
        {
            "id": 2501,
            "name": "Cursi",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "D223",
            "cod_istat": "075025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 1248,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 2502,
            "name": "Cursolo-Orasso",
            "provincia": "VB",
            "cap": "28827",
            "cod_catastale": "D225",
            "cod_istat": "103027",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 886,
            "giorni": 3456,
            "area": "",
            "ech": 0
        },
        {
            "id": 2503,
            "name": "Curtarolo",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "D226",
            "cod_istat": "028036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2504,
            "name": "Curtatone",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "D227",
            "cod_istat": "020021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 2505,
            "name": "Curti",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "D228",
            "cod_istat": "061032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 911,
            "area": "",
            "ech": 0
        },
        {
            "id": 2506,
            "name": "Cusago",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "D229",
            "cod_istat": "015097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2507,
            "name": "Cusano Milanino",
            "provincia": "MI",
            "cap": "20095",
            "cod_catastale": "D231",
            "cod_istat": "015098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2508,
            "name": "Cusano Mutri",
            "provincia": "BN",
            "cap": "82033",
            "cod_catastale": "D230",
            "cod_istat": "062026",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 475,
            "giorni": 1935,
            "area": "",
            "ech": 0
        },
        {
            "id": 2509,
            "name": "Cusino",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D232",
            "cod_istat": "013085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 2510,
            "name": "Cusio",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "D233",
            "cod_istat": "016090",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1040,
            "giorni": 3546,
            "area": "",
            "ech": 0
        },
        {
            "id": 2511,
            "name": "Custonaci",
            "provincia": "TP",
            "cap": "91015",
            "cod_catastale": "D234",
            "cod_istat": "081007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 1015,
            "area": "",
            "ech": 1
        },
        {
            "id": 2512,
            "name": "Cutigliano",
            "provincia": "PT",
            "cap": "51024",
            "cod_catastale": "D235",
            "cod_istat": "047004",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 678,
            "giorni": 2901,
            "area": "",
            "ech": 0
        },
        {
            "id": 2513,
            "name": "Cutro",
            "provincia": "KR",
            "cap": "88842",
            "cod_catastale": "D236",
            "cod_istat": "101012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1167,
            "area": "",
            "ech": 1
        },
        {
            "id": 2514,
            "name": "Cutrofiano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "D237",
            "cod_istat": "075026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 1240,
            "area": "",
            "ech": 0
        },
        {
            "id": 2515,
            "name": "Cuveglio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D238",
            "cod_istat": "012062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2531,
            "area": "",
            "ech": 0
        },
        {
            "id": 2516,
            "name": "Cuvio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D239",
            "cod_istat": "012063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 2517,
            "name": "Daiano",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "D243",
            "cod_istat": "022070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1160,
            "giorni": 4200,
            "area": "",
            "ech": 0
        },
        {
            "id": 2518,
            "name": "Dairago",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "D244",
            "cod_istat": "015099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 2519,
            "name": "Dalmine",
            "provincia": "BG",
            "cap": "24044",
            "cod_catastale": "D245",
            "cod_istat": "016091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2473,
            "area": "",
            "ech": 0
        },
        {
            "id": 2520,
            "name": "Dambel",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D246",
            "cod_istat": "022071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 751,
            "giorni": 3562,
            "area": "",
            "ech": 0
        },
        {
            "id": 2521,
            "name": "Danta di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "D247",
            "cod_istat": "025017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1398,
            "giorni": 4793,
            "area": "",
            "ech": 0
        },
        {
            "id": 2522,
            "name": "Daone",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "D248",
            "cod_istat": "022072",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 767,
            "giorni": 3587,
            "area": "",
            "ech": 0
        },
        {
            "id": 2523,
            "name": "Darè",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "D250",
            "cod_istat": "022073",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 3327,
            "area": "",
            "ech": 0
        },
        {
            "id": 2524,
            "name": "Darfo Boario Terme",
            "provincia": "BS",
            "cap": "25047",
            "cod_catastale": "D251",
            "cod_istat": "017065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 2525,
            "name": "Dasà",
            "provincia": "VV",
            "cap": "89832",
            "cod_catastale": "D253",
            "cod_istat": "102007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 1291,
            "area": "",
            "ech": 0
        },
        {
            "id": 2526,
            "name": "Davagna",
            "provincia": "GE",
            "cap": "16022",
            "cod_catastale": "D255",
            "cod_istat": "010021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 2527,
            "name": "Daverio",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "D256",
            "cod_istat": "012064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 2528,
            "name": "Davoli",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "D257",
            "cod_istat": "079042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 401,
            "giorni": 1591,
            "area": "",
            "ech": 1
        },
        {
            "id": 2529,
            "name": "Dazio",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "D258",
            "cod_istat": "014025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 568,
            "giorni": 3041,
            "area": "",
            "ech": 0
        },
        {
            "id": 2530,
            "name": "Decimomannu",
            "provincia": "CA",
            "cap": "09033",
            "cod_catastale": "D259",
            "cod_istat": "092015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1183,
            "area": "",
            "ech": 0
        },
        {
            "id": 2531,
            "name": "Decimoputzu",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "D260",
            "cod_istat": "111013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 1139,
            "area": "",
            "ech": 0
        },
        {
            "id": 2532,
            "name": "Decollatura",
            "provincia": "CZ",
            "cap": "88041",
            "cod_catastale": "D261",
            "cod_istat": "079043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 765,
            "giorni": 2370,
            "area": "",
            "ech": 0
        },
        {
            "id": 2533,
            "name": "Dego",
            "provincia": "SV",
            "cap": "17058",
            "cod_catastale": "D264",
            "cod_istat": "009027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2105,
            "area": "",
            "ech": 0
        },
        {
            "id": 2534,
            "name": "Deiva Marina",
            "provincia": "SP",
            "cap": "19013",
            "cod_catastale": "D265",
            "cod_istat": "011012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1428,
            "area": "",
            "ech": 0
        },
        {
            "id": 2535,
            "name": "Delebio",
            "provincia": "SO",
            "cap": "23014",
            "cod_catastale": "D266",
            "cod_istat": "014026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 3001,
            "area": "",
            "ech": 0
        },
        {
            "id": 2536,
            "name": "Delia",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "D267",
            "cod_istat": "085006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1298,
            "area": "",
            "ech": 0
        },
        {
            "id": 2537,
            "name": "Delianuova",
            "provincia": "RC",
            "cap": "89012",
            "cod_catastale": "D268",
            "cod_istat": "080031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1827,
            "area": "",
            "ech": 0
        },
        {
            "id": 2538,
            "name": "Deliceto",
            "provincia": "FG",
            "cap": "71026",
            "cod_catastale": "D269",
            "cod_istat": "071022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2245,
            "area": "",
            "ech": 0
        },
        {
            "id": 2539,
            "name": "Dello",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "D270",
            "cod_istat": "017066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2540,
            "name": "Demonte",
            "provincia": "CN",
            "cap": "12014",
            "cod_catastale": "D271",
            "cod_istat": "004079",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 3282,
            "area": "",
            "ech": 0
        },
        {
            "id": 2541,
            "name": "Denice",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "D272",
            "cod_istat": "006065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 387,
            "giorni": 2807,
            "area": "",
            "ech": 0
        },
        {
            "id": 2542,
            "name": "Denno",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D273",
            "cod_istat": "022074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 3060,
            "area": "",
            "ech": 0
        },
        {
            "id": 2543,
            "name": "Dernice",
            "provincia": "AL",
            "cap": "15056",
            "cod_catastale": "D277",
            "cod_istat": "006066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2986,
            "area": "",
            "ech": 0
        },
        {
            "id": 2544,
            "name": "Derovere",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "D278",
            "cod_istat": "019040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2545,
            "name": "Deruta",
            "provincia": "PG",
            "cap": "06053",
            "cod_catastale": "D279",
            "cod_istat": "054017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2013,
            "area": "",
            "ech": 0
        },
        {
            "id": 2546,
            "name": "Dervio",
            "provincia": "LC",
            "cap": "23824",
            "cod_catastale": "D280",
            "cod_istat": "097030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 238,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 2547,
            "name": "Desana",
            "provincia": "VC",
            "cap": "13034",
            "cod_catastale": "D281",
            "cod_istat": "002054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2753,
            "area": "",
            "ech": 0
        },
        {
            "id": 2548,
            "name": "Desenzano del Garda",
            "provincia": "BS",
            "cap": "25015",
            "cod_catastale": "D284",
            "cod_istat": "017067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 2549,
            "name": "Desio",
            "provincia": "MB",
            "cap": "20832",
            "cod_catastale": "D286",
            "cod_istat": "108023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 196,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 2550,
            "name": "Desulo",
            "provincia": "NU",
            "cap": "08032",
            "cod_catastale": "D287",
            "cod_istat": "091016",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 888,
            "giorni": 2169,
            "area": "",
            "ech": 0
        },
        {
            "id": 2551,
            "name": "Diamante",
            "provincia": "CS",
            "cap": "87023",
            "cod_catastale": "D289",
            "cod_istat": "078048",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 873,
            "area": "",
            "ech": 0
        },
        {
            "id": 2552,
            "name": "Diano Arentino",
            "provincia": "IM",
            "cap": "18013",
            "cod_catastale": "D293",
            "cod_istat": "008025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 331,
            "giorni": 1979,
            "area": "",
            "ech": 0
        },
        {
            "id": 2553,
            "name": "Diano Castello",
            "provincia": "IM",
            "cap": "18013",
            "cod_catastale": "D296",
            "cod_istat": "008026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 1501,
            "area": "",
            "ech": 0
        },
        {
            "id": 2554,
            "name": "Diano d'Alba",
            "provincia": "CN",
            "cap": "12055",
            "cod_catastale": "D291",
            "cod_istat": "004080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 2930,
            "area": "",
            "ech": 0
        },
        {
            "id": 2555,
            "name": "Diano Marina",
            "provincia": "IM",
            "cap": "18013",
            "cod_catastale": "D297",
            "cod_istat": "008027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1186,
            "area": "",
            "ech": 0
        },
        {
            "id": 2556,
            "name": "Diano San Pietro",
            "provincia": "IM",
            "cap": "18013",
            "cod_catastale": "D298",
            "cod_istat": "008028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 1382,
            "area": "",
            "ech": 0
        },
        {
            "id": 2557,
            "name": "Dicomano",
            "provincia": "FI",
            "cap": "50062",
            "cod_catastale": "D299",
            "cod_istat": "048013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2012,
            "area": "",
            "ech": 0
        },
        {
            "id": 2558,
            "name": "Dignano",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "D300",
            "cod_istat": "030032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2590,
            "area": "",
            "ech": 0
        },
        {
            "id": 2559,
            "name": "Dimaro",
            "provincia": "TN",
            "cap": "38025",
            "cod_catastale": "D302",
            "cod_istat": "022233",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 766,
            "giorni": 3586,
            "area": "",
            "ech": 0
        },
        {
            "id": 2560,
            "name": "Dinami",
            "provincia": "VV",
            "cap": "89833",
            "cod_catastale": "D303",
            "cod_istat": "102008",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 260,
            "giorni": 1295,
            "area": "",
            "ech": 1
        },
        {
            "id": 2561,
            "name": "Dipignano",
            "provincia": "CS",
            "cap": "87045",
            "cod_catastale": "D304",
            "cod_istat": "078049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 2231,
            "area": "",
            "ech": 0
        },
        {
            "id": 2562,
            "name": "Diso",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "D305",
            "cod_istat": "075027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 1246,
            "area": "",
            "ech": 0
        },
        {
            "id": 2563,
            "name": "Divignano",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "D309",
            "cod_istat": "003060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 2743,
            "area": "",
            "ech": 0
        },
        {
            "id": 2564,
            "name": "Dizzasco",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "D310",
            "cod_istat": "013087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 506,
            "giorni": 2788,
            "area": "",
            "ech": 0
        },
        {
            "id": 2565,
            "name": "Dobbiaco",
            "provincia": "BZ",
            "cap": "39034",
            "cod_catastale": "D311",
            "cod_istat": "021028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1256,
            "giorni": 4503,
            "area": "",
            "ech": 0
        },
        {
            "id": 2566,
            "name": "Doberdò del Lago",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "D312",
            "cod_istat": "031003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 2567,
            "name": "Dogliani",
            "provincia": "CN",
            "cap": "12063",
            "cod_catastale": "D314",
            "cod_istat": "004081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2681,
            "area": "",
            "ech": 0
        },
        {
            "id": 2568,
            "name": "Dogliola",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "D315",
            "cod_istat": "069029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 445,
            "giorni": 1864,
            "area": "",
            "ech": 0
        },
        {
            "id": 2569,
            "name": "Dogna",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "D316",
            "cod_istat": "030033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 419,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 2570,
            "name": "Dolcè",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "D317",
            "cod_istat": "023031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 2571,
            "name": "Dolceacqua",
            "provincia": "IM",
            "cap": "18035",
            "cod_catastale": "D318",
            "cod_istat": "008029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 1365,
            "area": "",
            "ech": 0
        },
        {
            "id": 2572,
            "name": "Dolcedo",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "D319",
            "cod_istat": "008030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1362,
            "area": "",
            "ech": 0
        },
        {
            "id": 2573,
            "name": "Dolegna del Collio",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "D321",
            "cod_istat": "031004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 2574,
            "name": "Dolianova",
            "provincia": "SU",
            "cap": "09041",
            "cod_catastale": "D323",
            "cod_istat": "111014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 1289,
            "area": "",
            "ech": 0
        },
        {
            "id": 2575,
            "name": "Dolo",
            "provincia": "VE",
            "cap": "30031",
            "cod_catastale": "D325",
            "cod_istat": "027012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2576,
            "name": "Dolzago",
            "provincia": "LC",
            "cap": "23843",
            "cod_catastale": "D327",
            "cod_istat": "097031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 298,
            "giorni": 2493,
            "area": "",
            "ech": 0
        },
        {
            "id": 2577,
            "name": "Domanico",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "D328",
            "cod_istat": "078050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 2578,
            "name": "Domaso",
            "provincia": "CO",
            "cap": "22013",
            "cod_catastale": "D329",
            "cod_istat": "013089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 2579,
            "name": "Domegge di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "D330",
            "cod_istat": "025018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 763,
            "giorni": 3831,
            "area": "",
            "ech": 0
        },
        {
            "id": 2580,
            "name": "Domicella",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "D331",
            "cod_istat": "064031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1374,
            "area": "",
            "ech": 0
        },
        {
            "id": 2581,
            "name": "Domodossola",
            "provincia": "VB",
            "cap": "28845",
            "cod_catastale": "D332",
            "cod_istat": "103028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 2582,
            "name": "Domus de Maria",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "D333",
            "cod_istat": "111015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 1005,
            "area": "",
            "ech": 0
        },
        {
            "id": 2583,
            "name": "Domusnovas",
            "provincia": "SU",
            "cap": "09015",
            "cod_catastale": "D334",
            "cod_istat": "111016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 1148,
            "area": "",
            "ech": 0
        },
        {
            "id": 2584,
            "name": "Don",
            "provincia": "TN",
            "cap": "38011",
            "cod_catastale": "D336",
            "cod_istat": "022076",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 971,
            "giorni": 3906,
            "area": "",
            "ech": 0
        },
        {
            "id": 2585,
            "name": "Donato",
            "provincia": "BI",
            "cap": "13893",
            "cod_catastale": "D339",
            "cod_istat": "096024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 711,
            "giorni": 3229,
            "area": "",
            "ech": 0
        },
        {
            "id": 2586,
            "name": "Dongo",
            "provincia": "CO",
            "cap": "22014",
            "cod_catastale": "D341",
            "cod_istat": "013090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 2587,
            "name": "Donnas",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "D338",
            "cod_istat": "007023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2700,
            "area": "",
            "ech": 0
        },
        {
            "id": 2588,
            "name": "Donori",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "D344",
            "cod_istat": "111017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 1293,
            "area": "",
            "ech": 0
        },
        {
            "id": 2589,
            "name": "Dorgali",
            "provincia": "NU",
            "cap": "08022",
            "cod_catastale": "D345",
            "cod_istat": "091017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 1360,
            "area": "",
            "ech": 1
        },
        {
            "id": 2590,
            "name": "Dorio",
            "provincia": "LC",
            "cap": "23824",
            "cod_catastale": "D346",
            "cod_istat": "097032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2232,
            "area": "",
            "ech": 0
        },
        {
            "id": 2591,
            "name": "Dormelletto",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "D347",
            "cod_istat": "003062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2610,
            "area": "",
            "ech": 0
        },
        {
            "id": 2592,
            "name": "Dorno",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "D348",
            "cod_istat": "018061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 2593,
            "name": "Dorsino",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "D349",
            "cod_istat": "022231",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 635,
            "giorni": 3381,
            "area": "",
            "ech": 0
        },
        {
            "id": 2594,
            "name": "Dorzano",
            "provincia": "BI",
            "cap": "13881",
            "cod_catastale": "D350",
            "cod_istat": "096025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 2595,
            "name": "Dosolo",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "D351",
            "cod_istat": "020022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 2596,
            "name": "Dossena",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "D352",
            "cod_istat": "016092",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 986,
            "giorni": 3470,
            "area": "",
            "ech": 0
        },
        {
            "id": 2597,
            "name": "Dosso del Liro",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D355",
            "cod_istat": "013092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2993,
            "area": "",
            "ech": 0
        },
        {
            "id": 2598,
            "name": "Doues",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "D356",
            "cod_istat": "007024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1176,
            "giorni": 3996,
            "area": "",
            "ech": 0
        },
        {
            "id": 2599,
            "name": "Dovadola",
            "provincia": "FC",
            "cap": "47013",
            "cod_catastale": "D357",
            "cod_istat": "040011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2331,
            "area": "",
            "ech": 0
        },
        {
            "id": 2600,
            "name": "Dovera",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "D358",
            "cod_istat": "019041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 2601,
            "name": "Dozza",
            "provincia": "BO",
            "cap": "40060",
            "cod_catastale": "D360",
            "cod_istat": "037025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 2602,
            "name": "Dragoni",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "D361",
            "cod_istat": "061033",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 130,
            "giorni": 1304,
            "area": "",
            "ech": 0
        },
        {
            "id": 2603,
            "name": "Drapia",
            "provincia": "VV",
            "cap": "89862",
            "cod_catastale": "D364",
            "cod_istat": "102009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 1334,
            "area": "",
            "ech": 0
        },
        {
            "id": 2604,
            "name": "Drena",
            "provincia": "TN",
            "cap": "38074",
            "cod_catastale": "D365",
            "cod_istat": "022078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 3012,
            "area": "",
            "ech": 0
        },
        {
            "id": 2605,
            "name": "Drenchia",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "D366",
            "cod_istat": "030034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 663,
            "giorni": 3577,
            "area": "",
            "ech": 0
        },
        {
            "id": 2606,
            "name": "Dresano",
            "provincia": "MI",
            "cap": "20070",
            "cod_catastale": "D367",
            "cod_istat": "015101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 2607,
            "name": "Drezzo",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "D369",
            "cod_istat": "013093",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 2608,
            "name": "Drizzona",
            "provincia": "CR",
            "cap": "26034",
            "cod_catastale": "D370",
            "cod_istat": "019116",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2609,
            "name": "Dro",
            "provincia": "TN",
            "cap": "38074",
            "cod_catastale": "D371",
            "cod_istat": "022079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2354,
            "area": "",
            "ech": 0
        },
        {
            "id": 2610,
            "name": "Dronero",
            "provincia": "CN",
            "cap": "12025",
            "cod_catastale": "D372",
            "cod_istat": "004082",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 622,
            "giorni": 3086,
            "area": "",
            "ech": 0
        },
        {
            "id": 2611,
            "name": "Druento",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "D373",
            "cod_istat": "001099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 2612,
            "name": "Druogno",
            "provincia": "VB",
            "cap": "28853",
            "cod_catastale": "D374",
            "cod_istat": "103029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 836,
            "giorni": 3391,
            "area": "",
            "ech": 0
        },
        {
            "id": 2613,
            "name": "Dualchi",
            "provincia": "NU",
            "cap": "08010",
            "cod_catastale": "D376",
            "cod_istat": "091018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1270,
            "area": "",
            "ech": 0
        },
        {
            "id": 2614,
            "name": "Dubino",
            "provincia": "SO",
            "cap": "23015",
            "cod_catastale": "D377",
            "cod_istat": "014027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 2615,
            "name": "Due Carrare",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "M300",
            "cod_istat": "028106",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2616,
            "name": "Dueville",
            "provincia": "VI",
            "cap": "36031",
            "cod_catastale": "D379",
            "cod_istat": "024038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2401,
            "area": "",
            "ech": 0
        },
        {
            "id": 2617,
            "name": "Dugenta",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "D380",
            "cod_istat": "062027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1170,
            "area": "",
            "ech": 0
        },
        {
            "id": 2618,
            "name": "Duino Aurisina",
            "provincia": "TS",
            "cap": "34011",
            "cod_catastale": "D383",
            "cod_istat": "032001",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2619,
            "name": "Dumenza",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "D384",
            "cod_istat": "012065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 411,
            "giorni": 2692,
            "area": "",
            "ech": 0
        },
        {
            "id": 2620,
            "name": "Duno",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D385",
            "cod_istat": "012066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 2621,
            "name": "Durazzano",
            "provincia": "BN",
            "cap": "82015",
            "cod_catastale": "D386",
            "cod_istat": "062028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 1591,
            "area": "",
            "ech": 0
        },
        {
            "id": 2622,
            "name": "Duronia",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "C772",
            "cod_istat": "070022",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 918,
            "giorni": 2571,
            "area": "",
            "ech": 0
        },
        {
            "id": 2623,
            "name": "Dusino San Michele",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "D388",
            "cod_istat": "005052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 2624,
            "name": "Eboli",
            "provincia": "SA",
            "cap": "84025",
            "cod_catastale": "D390",
            "cod_istat": "065050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 1226,
            "area": "",
            "ech": 0
        },
        {
            "id": 2625,
            "name": "Edolo",
            "provincia": "BS",
            "cap": "25048",
            "cod_catastale": "D391",
            "cod_istat": "017068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 699,
            "giorni": 3209,
            "area": "",
            "ech": 0
        },
        {
            "id": 2626,
            "name": "Egna",
            "provincia": "BZ",
            "cap": "39044",
            "cod_catastale": "D392",
            "cod_istat": "021029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2899,
            "area": "",
            "ech": 0
        },
        {
            "id": 2627,
            "name": "Elice",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "D394",
            "cod_istat": "068018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 259,
            "giorni": 1661,
            "area": "",
            "ech": 0
        },
        {
            "id": 2628,
            "name": "Elini",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "D395",
            "cod_istat": "091019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 1519,
            "area": "",
            "ech": 1
        },
        {
            "id": 2629,
            "name": "Ello",
            "provincia": "LC",
            "cap": "23848",
            "cod_catastale": "D398",
            "cod_istat": "097033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 411,
            "giorni": 2653,
            "area": "",
            "ech": 0
        },
        {
            "id": 2630,
            "name": "Elmas",
            "provincia": "CA",
            "cap": "09067",
            "cod_catastale": "D399",
            "cod_istat": "092108",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 934,
            "area": "",
            "ech": 0
        },
        {
            "id": 2631,
            "name": "Elva",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "D401",
            "cod_istat": "004083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1637,
            "giorni": 4345,
            "area": "",
            "ech": 0
        },
        {
            "id": 2632,
            "name": "Emarèse",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "D402",
            "cod_istat": "007025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1170,
            "giorni": 3997,
            "area": "",
            "ech": 0
        },
        {
            "id": 2633,
            "name": "Empoli",
            "provincia": "FI",
            "cap": "50053",
            "cod_catastale": "D403",
            "cod_istat": "048014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1658,
            "area": "",
            "ech": 0
        },
        {
            "id": 2634,
            "name": "Endine Gaiano",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D406",
            "cod_istat": "016093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 2635,
            "name": "Enego",
            "provincia": "VI",
            "cap": "36052",
            "cod_catastale": "D407",
            "cod_istat": "024039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3541,
            "area": "",
            "ech": 0
        },
        {
            "id": 2636,
            "name": "Enemonzo",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "D408",
            "cod_istat": "030035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 3168,
            "area": "",
            "ech": 0
        },
        {
            "id": 2637,
            "name": "Enna",
            "provincia": "EN",
            "cap": "94100",
            "cod_catastale": "C342",
            "cod_istat": "086009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 931,
            "giorni": 2248,
            "area": "",
            "ech": 1
        },
        {
            "id": 2638,
            "name": "Entracque",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "D410",
            "cod_istat": "004084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 894,
            "giorni": 3424,
            "area": "",
            "ech": 0
        },
        {
            "id": 2639,
            "name": "Entratico",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D411",
            "cod_istat": "016094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 2640,
            "name": "Envie",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "D412",
            "cod_istat": "004085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 2641,
            "name": "Episcopia",
            "provincia": "PZ",
            "cap": "85033",
            "cod_catastale": "D414",
            "cod_istat": "076030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 1873,
            "area": "",
            "ech": 0
        },
        {
            "id": 2642,
            "name": "Eraclea",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "D415",
            "cod_istat": "027013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 2643,
            "name": "Erba",
            "provincia": "CO",
            "cap": "22036",
            "cod_catastale": "D416",
            "cod_istat": "013095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 2644,
            "name": "Erbè",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "D419",
            "cod_istat": "023032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2391,
            "area": "",
            "ech": 0
        },
        {
            "id": 2645,
            "name": "Erbezzo",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "D420",
            "cod_istat": "023033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1118,
            "giorni": 4109,
            "area": "",
            "ech": 0
        },
        {
            "id": 2646,
            "name": "Erbusco",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "D421",
            "cod_istat": "017069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2706,
            "area": "",
            "ech": 0
        },
        {
            "id": 2647,
            "name": "Erchie",
            "provincia": "BR",
            "cap": "72020",
            "cod_catastale": "D422",
            "cod_istat": "074006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1156,
            "area": "",
            "ech": 0
        },
        {
            "id": 2648,
            "name": "Ercolano",
            "provincia": "NA",
            "cap": "80056",
            "cod_catastale": "H243",
            "cod_istat": "063064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 969,
            "area": "",
            "ech": 0
        },
        {
            "id": 2649,
            "name": "Erice",
            "provincia": "TP",
            "cap": "91016",
            "cod_catastale": "D423",
            "cod_istat": "081008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 751,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 2650,
            "name": "Erli",
            "provincia": "SV",
            "cap": "17030",
            "cod_catastale": "D424",
            "cod_istat": "009028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1983,
            "area": "",
            "ech": 0
        },
        {
            "id": 2651,
            "name": "Erto e Casso",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "D426",
            "cod_istat": "093019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 3757,
            "area": "",
            "ech": 0
        },
        {
            "id": 2652,
            "name": "Erula",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M292",
            "cod_istat": "090088",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 457,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 2653,
            "name": "Erve",
            "provincia": "LC",
            "cap": "23805",
            "cod_catastale": "D428",
            "cod_istat": "097034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 559,
            "giorni": 2863,
            "area": "",
            "ech": 0
        },
        {
            "id": 2654,
            "name": "Esanatoglia",
            "provincia": "MC",
            "cap": "62024",
            "cod_catastale": "D429",
            "cod_istat": "043016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 446,
            "giorni": 2161,
            "area": "",
            "ech": 0
        },
        {
            "id": 2655,
            "name": "Escalaplano",
            "provincia": "SU",
            "cap": "09051",
            "cod_catastale": "D430",
            "cod_istat": "111018",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 338,
            "giorni": 1135,
            "area": "",
            "ech": 1
        },
        {
            "id": 2656,
            "name": "Escolca",
            "provincia": "SU",
            "cap": "09052",
            "cod_catastale": "D431",
            "cod_istat": "111019",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 416,
            "giorni": 1427,
            "area": "",
            "ech": 0
        },
        {
            "id": 2657,
            "name": "Esine",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "D434",
            "cod_istat": "017070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 2658,
            "name": "Esino Lario",
            "provincia": "LC",
            "cap": "23825",
            "cod_catastale": "D436",
            "cod_istat": "097035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 910,
            "giorni": 3362,
            "area": "",
            "ech": 0
        },
        {
            "id": 2659,
            "name": "Esperia",
            "provincia": "FR",
            "cap": "03045",
            "cod_catastale": "D440",
            "cod_istat": "060031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 1811,
            "area": "",
            "ech": 0
        },
        {
            "id": 2660,
            "name": "Esporlatu",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "D441",
            "cod_istat": "090028",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 473,
            "giorni": 1817,
            "area": "",
            "ech": 0
        },
        {
            "id": 2661,
            "name": "Este",
            "provincia": "PD",
            "cap": "35042",
            "cod_catastale": "D442",
            "cod_istat": "028037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 2662,
            "name": "Esterzili",
            "provincia": "SU",
            "cap": "09053",
            "cod_catastale": "D443",
            "cod_istat": "111020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 731,
            "giorni": 1946,
            "area": "",
            "ech": 0
        },
        {
            "id": 2663,
            "name": "Etroubles",
            "provincia": "AO",
            "cap": "11014",
            "cod_catastale": "D444",
            "cod_istat": "007026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1270,
            "giorni": 4137,
            "area": "",
            "ech": 0
        },
        {
            "id": 2664,
            "name": "Eupilio",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "D445",
            "cod_istat": "013097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2775,
            "area": "",
            "ech": 0
        },
        {
            "id": 2665,
            "name": "Exilles",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "D433",
            "cod_istat": "001100",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 3659,
            "area": "",
            "ech": 0
        },
        {
            "id": 2666,
            "name": "Fabbrica Curone",
            "provincia": "AL",
            "cap": "15054",
            "cod_catastale": "D447",
            "cod_istat": "006067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 712,
            "giorni": 3080,
            "area": "",
            "ech": 0
        },
        {
            "id": 2667,
            "name": "Fabbriche di Vallico",
            "provincia": "LU",
            "cap": "55020",
            "cod_catastale": "D449",
            "cod_istat": "046012",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 2668,
            "name": "Fabbrico",
            "provincia": "RE",
            "cap": "42042",
            "cod_catastale": "D450",
            "cod_istat": "035021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2438,
            "area": "",
            "ech": 0
        },
        {
            "id": 2669,
            "name": "Fabriano",
            "provincia": "AN",
            "cap": "60044",
            "cod_catastale": "D451",
            "cod_istat": "042017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2198,
            "area": "",
            "ech": 0
        },
        {
            "id": 2670,
            "name": "Fabrica di Roma",
            "provincia": "VT",
            "cap": "01034",
            "cod_catastale": "D452",
            "cod_istat": "056024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 1946,
            "area": "",
            "ech": 0
        },
        {
            "id": 2671,
            "name": "Fabrizia",
            "provincia": "VV",
            "cap": "89823",
            "cod_catastale": "D453",
            "cod_istat": "102010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 947,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 2672,
            "name": "Fabro",
            "provincia": "TR",
            "cap": "05015",
            "cod_catastale": "D454",
            "cod_istat": "055011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2027,
            "area": "",
            "ech": 0
        },
        {
            "id": 2673,
            "name": "Faedis",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "D455",
            "cod_istat": "030036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 2656,
            "area": "",
            "ech": 0
        },
        {
            "id": 2674,
            "name": "Faedo",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D457",
            "cod_istat": "022080",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 591,
            "giorni": 3313,
            "area": "",
            "ech": 0
        },
        {
            "id": 2675,
            "name": "Faedo Valtellino",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "D456",
            "cod_istat": "014028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 3319,
            "area": "",
            "ech": 0
        },
        {
            "id": 2676,
            "name": "Faenza",
            "provincia": "RA",
            "cap": "48018",
            "cod_catastale": "D458",
            "cod_istat": "039010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2263,
            "area": "",
            "ech": 0
        },
        {
            "id": 2677,
            "name": "Faeto",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "D459",
            "cod_istat": "071023",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 820,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 2678,
            "name": "Fagagna",
            "provincia": "UD",
            "cap": "33034",
            "cod_catastale": "D461",
            "cod_istat": "030037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 2679,
            "name": "Faggeto Lario",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "D462",
            "cod_istat": "013098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 533,
            "giorni": 2826,
            "area": "",
            "ech": 0
        },
        {
            "id": 2680,
            "name": "Faggiano",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "D463",
            "cod_istat": "073005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1137,
            "area": "",
            "ech": 0
        },
        {
            "id": 2681,
            "name": "Fagnano Alto",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "D465",
            "cod_istat": "066042",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 665,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 2682,
            "name": "Fagnano Castello",
            "provincia": "CS",
            "cap": "87013",
            "cod_catastale": "D464",
            "cod_istat": "078051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 1951,
            "area": "",
            "ech": 0
        },
        {
            "id": 2683,
            "name": "Fagnano Olona",
            "provincia": "VA",
            "cap": "21054",
            "cod_catastale": "D467",
            "cod_istat": "012067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 2684,
            "name": "Fai della Paganella",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D468",
            "cod_istat": "022081",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 957,
            "giorni": 3884,
            "area": "",
            "ech": 0
        },
        {
            "id": 2685,
            "name": "Faicchio",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "D469",
            "cod_istat": "062029",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 175,
            "giorni": 1389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2686,
            "name": "Falcade",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "D470",
            "cod_istat": "025019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1137,
            "giorni": 4309,
            "area": "",
            "ech": 0
        },
        {
            "id": 2687,
            "name": "Falciano del Massico",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "D471",
            "cod_istat": "061101",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1182,
            "area": "",
            "ech": 0
        },
        {
            "id": 2688,
            "name": "Falconara Albanese",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "D473",
            "cod_istat": "078052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 1996,
            "area": "",
            "ech": 0
        },
        {
            "id": 2689,
            "name": "Falconara Marittima",
            "provincia": "AN",
            "cap": "60015",
            "cod_catastale": "D472",
            "cod_istat": "042018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1888,
            "area": "",
            "ech": 0
        },
        {
            "id": 2690,
            "name": "Falcone",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "D474",
            "cod_istat": "083019",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 631,
            "area": "",
            "ech": 1
        },
        {
            "id": 2691,
            "name": "Faleria",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "D475",
            "cod_istat": "056025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 1806,
            "area": "",
            "ech": 0
        },
        {
            "id": 2692,
            "name": "Falerna",
            "provincia": "CZ",
            "cap": "88042",
            "cod_catastale": "D476",
            "cod_istat": "079047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1904,
            "area": "",
            "ech": 0
        },
        {
            "id": 2693,
            "name": "Falerone",
            "provincia": "FM",
            "cap": "63837",
            "cod_catastale": "D477",
            "cod_istat": "109005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 2146,
            "area": "",
            "ech": 0
        },
        {
            "id": 2694,
            "name": "Fallo",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "D480",
            "cod_istat": "069104",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 575,
            "giorni": 2059,
            "area": "",
            "ech": 0
        },
        {
            "id": 2695,
            "name": "Falmenta",
            "provincia": "VB",
            "cap": "28827",
            "cod_catastale": "D481",
            "cod_istat": "103030",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 715,
            "giorni": 3174,
            "area": "",
            "ech": 0
        },
        {
            "id": 2696,
            "name": "Faloppio",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "D482",
            "cod_istat": "013099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 2697,
            "name": "Falvaterra",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "D483",
            "cod_istat": "060032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 1904,
            "area": "",
            "ech": 0
        },
        {
            "id": 2698,
            "name": "Falzes",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "D484",
            "cod_istat": "021030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1022,
            "giorni": 4373,
            "area": "",
            "ech": 0
        },
        {
            "id": 2699,
            "name": "Fanano",
            "provincia": "MO",
            "cap": "41021",
            "cod_catastale": "D486",
            "cod_istat": "036011",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3095,
            "area": "",
            "ech": 0
        },
        {
            "id": 2700,
            "name": "Fanna",
            "provincia": "PN",
            "cap": "33092",
            "cod_catastale": "D487",
            "cod_istat": "093020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2834,
            "area": "",
            "ech": 0
        },
        {
            "id": 2701,
            "name": "Fano",
            "provincia": "PU",
            "cap": "61032",
            "cod_catastale": "D488",
            "cod_istat": "041013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2130,
            "area": "",
            "ech": 0
        },
        {
            "id": 2702,
            "name": "Fano Adriano",
            "provincia": "TE",
            "cap": "64044",
            "cod_catastale": "D489",
            "cod_istat": "067024",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 745,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 2703,
            "name": "Fara Filiorum Petri",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "D494",
            "cod_istat": "069030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1511,
            "area": "",
            "ech": 0
        },
        {
            "id": 2704,
            "name": "Fara Gera d'Adda",
            "provincia": "BG",
            "cap": "24045",
            "cod_catastale": "D490",
            "cod_istat": "016096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 2705,
            "name": "Fara in Sabina",
            "provincia": "RI",
            "cap": "02032",
            "cod_catastale": "D493",
            "cod_istat": "057027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 2706,
            "name": "Fara Novarese",
            "provincia": "NO",
            "cap": "28073",
            "cod_catastale": "D492",
            "cod_istat": "003065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 2707,
            "name": "Fara Olivana con Sola",
            "provincia": "BG",
            "cap": "24058",
            "cod_catastale": "D491",
            "cod_istat": "016097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2708,
            "name": "Fara San Martino",
            "provincia": "CH",
            "cap": "66015",
            "cod_catastale": "D495",
            "cod_istat": "069031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 440,
            "giorni": 1856,
            "area": "",
            "ech": 0
        },
        {
            "id": 2709,
            "name": "Fara Vicentino",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "D496",
            "cod_istat": "024040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2625,
            "area": "",
            "ech": 0
        },
        {
            "id": 2710,
            "name": "Fardella",
            "provincia": "PZ",
            "cap": "85034",
            "cod_catastale": "D497",
            "cod_istat": "076031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 745,
            "giorni": 2206,
            "area": "",
            "ech": 0
        },
        {
            "id": 2711,
            "name": "Farigliano",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "D499",
            "cod_istat": "004086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 2712,
            "name": "Farindola",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "D501",
            "cod_istat": "068019",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 2070,
            "area": "",
            "ech": 0
        },
        {
            "id": 2713,
            "name": "Farini",
            "provincia": "PC",
            "cap": "29023",
            "cod_catastale": "D502",
            "cod_istat": "033019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 2893,
            "area": "",
            "ech": 0
        },
        {
            "id": 2714,
            "name": "Farnese",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "D503",
            "cod_istat": "056026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2026,
            "area": "",
            "ech": 0
        },
        {
            "id": 2715,
            "name": "Farra d'Alpago",
            "provincia": "BL",
            "cap": "32016",
            "cod_catastale": "D506",
            "cod_istat": "025020",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 3053,
            "area": "",
            "ech": 0
        },
        {
            "id": 2716,
            "name": "Farra di Soligo",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "D505",
            "cod_istat": "026026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 163,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 2717,
            "name": "Farra d'Isonzo",
            "provincia": "GO",
            "cap": "34072",
            "cod_catastale": "D504",
            "cod_istat": "031005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2283,
            "area": "",
            "ech": 0
        },
        {
            "id": 2718,
            "name": "Fasano",
            "provincia": "BR",
            "cap": "72015",
            "cod_catastale": "D508",
            "cod_istat": "074007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 1251,
            "area": "",
            "ech": 0
        },
        {
            "id": 2719,
            "name": "Fascia",
            "provincia": "GE",
            "cap": "16020",
            "cod_catastale": "D509",
            "cod_istat": "010022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 900,
            "giorni": 3655,
            "area": "",
            "ech": 0
        },
        {
            "id": 2720,
            "name": "Fauglia",
            "provincia": "PI",
            "cap": "56043",
            "cod_catastale": "D510",
            "cod_istat": "050014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 1682,
            "area": "",
            "ech": 0
        },
        {
            "id": 2721,
            "name": "Faule",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "D511",
            "cod_istat": "004087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 2722,
            "name": "Favale di Malvaro",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "D512",
            "cod_istat": "010023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2157,
            "area": "",
            "ech": 0
        },
        {
            "id": 2723,
            "name": "Favara",
            "provincia": "AG",
            "cap": "92026",
            "cod_catastale": "D514",
            "cod_istat": "084017",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 338,
            "giorni": 1060,
            "area": "",
            "ech": 1
        },
        {
            "id": 2724,
            "name": "Faver",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "D516",
            "cod_istat": "022082",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 673,
            "giorni": 3441,
            "area": "",
            "ech": 0
        },
        {
            "id": 2725,
            "name": "Favignana",
            "provincia": "TP",
            "cap": "91023",
            "cod_catastale": "D518",
            "cod_istat": "081009",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 814,
            "area": "",
            "ech": 0
        },
        {
            "id": 2726,
            "name": "Favria",
            "provincia": "TO",
            "cap": "10083",
            "cod_catastale": "D520",
            "cod_istat": "001101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 316,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 2727,
            "name": "Feisoglio",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "D523",
            "cod_istat": "004088",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 706,
            "giorni": 3191,
            "area": "",
            "ech": 0
        },
        {
            "id": 2728,
            "name": "Feletto",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "D524",
            "cod_istat": "001102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 2729,
            "name": "Felino",
            "provincia": "PR",
            "cap": "43035",
            "cod_catastale": "D526",
            "cod_istat": "034013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 2730,
            "name": "Felitto",
            "provincia": "SA",
            "cap": "84055",
            "cod_catastale": "D527",
            "cod_istat": "065051",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 275,
            "giorni": 1481,
            "area": "",
            "ech": 0
        },
        {
            "id": 2731,
            "name": "Felizzano",
            "provincia": "AL",
            "cap": "15023",
            "cod_catastale": "D528",
            "cod_istat": "006068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 2732,
            "name": "Felonica",
            "provincia": "MN",
            "cap": "46022",
            "cod_catastale": "D529",
            "cod_istat": "020061",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 2733,
            "name": "Feltre",
            "provincia": "BL",
            "cap": "32032",
            "cod_catastale": "D530",
            "cod_istat": "025021",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 3097,
            "area": "",
            "ech": 0
        },
        {
            "id": 2734,
            "name": "Fenegrò",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "D531",
            "cod_istat": "013100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 2735,
            "name": "Fenestrelle",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "D532",
            "cod_istat": "001103",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1154,
            "giorni": 3781,
            "area": "",
            "ech": 0
        },
        {
            "id": 2736,
            "name": "Fénis",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "D537",
            "cod_istat": "007027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 541,
            "giorni": 3063,
            "area": "",
            "ech": 0
        },
        {
            "id": 2737,
            "name": "Ferentillo",
            "provincia": "TR",
            "cap": "05034",
            "cod_catastale": "D538",
            "cod_istat": "055012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1838,
            "area": "",
            "ech": 0
        },
        {
            "id": 2738,
            "name": "Ferentino",
            "provincia": "FR",
            "cap": "03013",
            "cod_catastale": "D539",
            "cod_istat": "060033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 1913,
            "area": "",
            "ech": 0
        },
        {
            "id": 2739,
            "name": "Ferla",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "D540",
            "cod_istat": "089008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 556,
            "giorni": 1416,
            "area": "",
            "ech": 0
        },
        {
            "id": 2740,
            "name": "Fermignano",
            "provincia": "PU",
            "cap": "61033",
            "cod_catastale": "D541",
            "cod_istat": "041014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2233,
            "area": "",
            "ech": 0
        },
        {
            "id": 2741,
            "name": "Fermo",
            "provincia": "FM",
            "cap": "63900",
            "cod_catastale": "D542",
            "cod_istat": "109006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 1955,
            "area": "",
            "ech": 0
        },
        {
            "id": 2742,
            "name": "Ferno",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "D543",
            "cod_istat": "012068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2840,
            "area": "",
            "ech": 0
        },
        {
            "id": 2743,
            "name": "Feroleto Antico",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "D544",
            "cod_istat": "079048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1295,
            "area": "",
            "ech": 0
        },
        {
            "id": 2744,
            "name": "Feroleto della Chiesa",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "D545",
            "cod_istat": "080032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 1015,
            "area": "",
            "ech": 0
        },
        {
            "id": 2745,
            "name": "Ferrandina",
            "provincia": "MT",
            "cap": "75013",
            "cod_catastale": "D547",
            "cod_istat": "077008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 497,
            "giorni": 1788,
            "area": "",
            "ech": 0
        },
        {
            "id": 2746,
            "name": "Ferrara",
            "provincia": "FE",
            "cap": "441xx",
            "cod_catastale": "D548",
            "cod_istat": "038008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2326,
            "area": "",
            "ech": 0
        },
        {
            "id": 2747,
            "name": "Ferrara di Monte Baldo",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "D549",
            "cod_istat": "023034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 856,
            "giorni": 3684,
            "area": "",
            "ech": 0
        },
        {
            "id": 2748,
            "name": "Ferrazzano",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "D550",
            "cod_istat": "070023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 872,
            "giorni": 2519,
            "area": "",
            "ech": 0
        },
        {
            "id": 2749,
            "name": "Ferrera di Varese",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "D551",
            "cod_istat": "012069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2569,
            "area": "",
            "ech": 0
        },
        {
            "id": 2750,
            "name": "Ferrera Erbognone",
            "provincia": "PV",
            "cap": "27032",
            "cod_catastale": "D552",
            "cod_istat": "018062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 2751,
            "name": "Ferrere",
            "provincia": "AT",
            "cap": "14012",
            "cod_catastale": "D554",
            "cod_istat": "005053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2707,
            "area": "",
            "ech": 0
        },
        {
            "id": 2752,
            "name": "Ferriere",
            "provincia": "PC",
            "cap": "29024",
            "cod_catastale": "D555",
            "cod_istat": "033020",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 626,
            "giorni": 3258,
            "area": "",
            "ech": 0
        },
        {
            "id": 2753,
            "name": "Ferruzzano",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "D557",
            "cod_istat": "080033",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 470,
            "giorni": 1566,
            "area": "",
            "ech": 1
        },
        {
            "id": 2754,
            "name": "Fiamignano",
            "provincia": "RI",
            "cap": "02023",
            "cod_catastale": "D560",
            "cod_istat": "057028",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 988,
            "giorni": 3163,
            "area": "",
            "ech": 0
        },
        {
            "id": 2755,
            "name": "Fiano",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "D562",
            "cod_istat": "001104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2997,
            "area": "",
            "ech": 0
        },
        {
            "id": 2756,
            "name": "Fiano Romano",
            "provincia": "RM",
            "cap": "00065",
            "cod_catastale": "D561",
            "cod_istat": "058036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1637,
            "area": "",
            "ech": 0
        },
        {
            "id": 2757,
            "name": "Fiastra",
            "provincia": "MC",
            "cap": "62035",
            "cod_catastale": "D564",
            "cod_istat": "043017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 2758,
            "name": "Fiavè",
            "provincia": "TN",
            "cap": "38075",
            "cod_catastale": "D565",
            "cod_istat": "022083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 669,
            "giorni": 3434,
            "area": "",
            "ech": 0
        },
        {
            "id": 2759,
            "name": "Ficarazzi",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "D567",
            "cod_istat": "082035",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 791,
            "area": "",
            "ech": 0
        },
        {
            "id": 2760,
            "name": "Ficarolo",
            "provincia": "RO",
            "cap": "45036",
            "cod_catastale": "D568",
            "cod_istat": "029021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 2761,
            "name": "Ficarra",
            "provincia": "ME",
            "cap": "98062",
            "cod_catastale": "D569",
            "cod_istat": "083020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1396,
            "area": "",
            "ech": 1
        },
        {
            "id": 2762,
            "name": "Ficulle",
            "provincia": "TR",
            "cap": "05016",
            "cod_catastale": "D570",
            "cod_istat": "055013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 437,
            "giorni": 2160,
            "area": "",
            "ech": 0
        },
        {
            "id": 2763,
            "name": "Fidenza",
            "provincia": "PR",
            "cap": "43036",
            "cod_catastale": "B034",
            "cod_istat": "034014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 2764,
            "name": "Fiè allo Sciliar",
            "provincia": "BZ",
            "cap": "39050",
            "cod_catastale": "D571",
            "cod_istat": "021031",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 880,
            "giorni": 3828,
            "area": "",
            "ech": 0
        },
        {
            "id": 2765,
            "name": "Fiera di Primiero",
            "provincia": "TN",
            "cap": "38054",
            "cod_catastale": "D572",
            "cod_istat": "022084",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 3498,
            "area": "",
            "ech": 0
        },
        {
            "id": 2766,
            "name": "Fierozzo",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "D573",
            "cod_istat": "022085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1127,
            "giorni": 4149,
            "area": "",
            "ech": 0
        },
        {
            "id": 2767,
            "name": "Fiesco",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "D574",
            "cod_istat": "019043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 2768,
            "name": "Fiesole",
            "provincia": "FI",
            "cap": "50014",
            "cod_catastale": "D575",
            "cod_istat": "048015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2216,
            "area": "",
            "ech": 0
        },
        {
            "id": 2769,
            "name": "Fiesse",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "D576",
            "cod_istat": "017071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 2770,
            "name": "Fiesso d'Artico",
            "provincia": "VE",
            "cap": "30032",
            "cod_catastale": "D578",
            "cod_istat": "027014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 2771,
            "name": "Fiesso Umbertiano",
            "provincia": "RO",
            "cap": "45024",
            "cod_catastale": "D577",
            "cod_istat": "029022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 2772,
            "name": "Figino Serenza",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "D579",
            "cod_istat": "013101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 2773,
            "name": "Figline Valdarno",
            "provincia": "FI",
            "cap": "50063",
            "cod_catastale": "D583",
            "cod_istat": "048052",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 1925,
            "area": "",
            "ech": 0
        },
        {
            "id": 2774,
            "name": "Figline Vegliaturo",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "D582",
            "cod_istat": "078053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 705,
            "giorni": 2201,
            "area": "",
            "ech": 0
        },
        {
            "id": 2775,
            "name": "Filacciano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "D586",
            "cod_istat": "058037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 1814,
            "area": "",
            "ech": 0
        },
        {
            "id": 2776,
            "name": "Filadelfia",
            "provincia": "VV",
            "cap": "89814",
            "cod_catastale": "D587",
            "cod_istat": "102011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 1857,
            "area": "",
            "ech": 1
        },
        {
            "id": 2777,
            "name": "Filago",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "D588",
            "cod_istat": "016098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 2778,
            "name": "Filandari",
            "provincia": "VV",
            "cap": "89841",
            "cod_catastale": "D589",
            "cod_istat": "102012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 486,
            "giorni": 1607,
            "area": "",
            "ech": 0
        },
        {
            "id": 2779,
            "name": "Filattiera",
            "provincia": "MS",
            "cap": "54023",
            "cod_catastale": "D590",
            "cod_istat": "045006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2191,
            "area": "",
            "ech": 0
        },
        {
            "id": 2780,
            "name": "Filettino",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "D591",
            "cod_istat": "060034",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1063,
            "giorni": 3088,
            "area": "",
            "ech": 0
        },
        {
            "id": 2781,
            "name": "Filetto",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "D592",
            "cod_istat": "069032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 403,
            "giorni": 1801,
            "area": "",
            "ech": 0
        },
        {
            "id": 2782,
            "name": "Filiano",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "D593",
            "cod_istat": "076032",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 597,
            "giorni": 1995,
            "area": "",
            "ech": 0
        },
        {
            "id": 2783,
            "name": "Filighera",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "D594",
            "cod_istat": "018063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 2784,
            "name": "Filignano",
            "provincia": "IS",
            "cap": "86074",
            "cod_catastale": "D595",
            "cod_istat": "094019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1924,
            "area": "",
            "ech": 0
        },
        {
            "id": 2785,
            "name": "Filogaso",
            "provincia": "VV",
            "cap": "89843",
            "cod_catastale": "D596",
            "cod_istat": "102013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 1343,
            "area": "",
            "ech": 1
        },
        {
            "id": 2786,
            "name": "Filottrano",
            "provincia": "AN",
            "cap": "60024",
            "cod_catastale": "D597",
            "cod_istat": "042019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 2787,
            "name": "Finale Emilia",
            "provincia": "MO",
            "cap": "41034",
            "cod_catastale": "D599",
            "cod_istat": "036012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2189,
            "area": "",
            "ech": 0
        },
        {
            "id": 2788,
            "name": "Finale Ligure",
            "provincia": "SV",
            "cap": "17024",
            "cod_catastale": "D600",
            "cod_istat": "009029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1340,
            "area": "",
            "ech": 0
        },
        {
            "id": 2789,
            "name": "Fino del Monte",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "D604",
            "cod_istat": "016099",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 3074,
            "area": "",
            "ech": 0
        },
        {
            "id": 2790,
            "name": "Fino Mornasco",
            "provincia": "CO",
            "cap": "22073",
            "cod_catastale": "D605",
            "cod_istat": "013102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 2791,
            "name": "Fiorano al Serio",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "D606",
            "cod_istat": "016100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 396,
            "giorni": 2632,
            "area": "",
            "ech": 0
        },
        {
            "id": 2792,
            "name": "Fiorano Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "D608",
            "cod_istat": "001105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 2793,
            "name": "Fiorano Modenese",
            "provincia": "MO",
            "cap": "41042",
            "cod_catastale": "D607",
            "cod_istat": "036013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 2794,
            "name": "Fiordimonte",
            "provincia": "MC",
            "cap": "62035",
            "cod_catastale": "D609",
            "cod_istat": "043018",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 569,
            "giorni": 2305,
            "area": "",
            "ech": 0
        },
        {
            "id": 2795,
            "name": "Fiorenzuola d'Arda",
            "provincia": "PC",
            "cap": "29017",
            "cod_catastale": "D611",
            "cod_istat": "033021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 2796,
            "name": "Firenze",
            "provincia": "FI",
            "cap": "501xx",
            "cod_catastale": "D612",
            "cod_istat": "048017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1821,
            "area": "",
            "ech": 0
        },
        {
            "id": 2797,
            "name": "Firenzuola",
            "provincia": "FI",
            "cap": "50033",
            "cod_catastale": "D613",
            "cod_istat": "048018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 422,
            "giorni": 2919,
            "area": "",
            "ech": 0
        },
        {
            "id": 2798,
            "name": "Firmo",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "D614",
            "cod_istat": "078054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 1720,
            "area": "",
            "ech": 0
        },
        {
            "id": 2799,
            "name": "Fisciano",
            "provincia": "SA",
            "cap": "84084",
            "cod_catastale": "D615",
            "cod_istat": "065052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1637,
            "area": "",
            "ech": 0
        },
        {
            "id": 2800,
            "name": "Fiuggi",
            "provincia": "FR",
            "cap": "03014",
            "cod_catastale": "A310",
            "cod_istat": "060035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 747,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 2801,
            "name": "Fiumalbo",
            "provincia": "MO",
            "cap": "41022",
            "cod_catastale": "D617",
            "cod_istat": "036014",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 953,
            "giorni": 3549,
            "area": "",
            "ech": 0
        },
        {
            "id": 2802,
            "name": "Fiumara",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "D619",
            "cod_istat": "080034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 1010,
            "area": "",
            "ech": 0
        },
        {
            "id": 2803,
            "name": "Fiume Veneto",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "D621",
            "cod_istat": "093021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2452,
            "area": "",
            "ech": 0
        },
        {
            "id": 2804,
            "name": "Fiumedinisi",
            "provincia": "ME",
            "cap": "98022",
            "cod_catastale": "D622",
            "cod_istat": "083021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 968,
            "area": "",
            "ech": 0
        },
        {
            "id": 2805,
            "name": "Fiumefreddo Bruzio",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "D624",
            "cod_istat": "078055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1250,
            "area": "",
            "ech": 0
        },
        {
            "id": 2806,
            "name": "Fiumefreddo di Sicilia",
            "provincia": "CT",
            "cap": "95013",
            "cod_catastale": "D623",
            "cod_istat": "087016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 915,
            "area": "",
            "ech": 1
        },
        {
            "id": 2807,
            "name": "Fiumicello",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "D627",
            "cod_istat": "030190",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 2808,
            "name": "Fiumicino",
            "provincia": "RM",
            "cap": "00054",
            "cod_catastale": "M297",
            "cod_istat": "058120",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 1240,
            "area": "",
            "ech": 0
        },
        {
            "id": 2809,
            "name": "Fiuminata",
            "provincia": "MC",
            "cap": "62025",
            "cod_catastale": "D628",
            "cod_istat": "043019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 2810,
            "name": "Fivizzano",
            "provincia": "MS",
            "cap": "54013",
            "cod_catastale": "D629",
            "cod_istat": "045007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 2283,
            "area": "",
            "ech": 0
        },
        {
            "id": 2811,
            "name": "Flaibano",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "D630",
            "cod_istat": "030039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2331,
            "area": "",
            "ech": 0
        },
        {
            "id": 2812,
            "name": "Flavon",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "D631",
            "cod_istat": "022086",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3288,
            "area": "",
            "ech": 0
        },
        {
            "id": 2813,
            "name": "Flero",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "D634",
            "cod_istat": "017072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 2814,
            "name": "Floresta",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "D635",
            "cod_istat": "083022",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1275,
            "giorni": 3309,
            "area": "",
            "ech": 1
        },
        {
            "id": 2815,
            "name": "Floridia",
            "provincia": "SR",
            "cap": "96014",
            "cod_catastale": "D636",
            "cod_istat": "089009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 904,
            "area": "",
            "ech": 1
        },
        {
            "id": 2816,
            "name": "Florinas",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "D637",
            "cod_istat": "090029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 1708,
            "area": "",
            "ech": 0
        },
        {
            "id": 2817,
            "name": "Flumeri",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "D638",
            "cod_istat": "064032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 2154,
            "area": "",
            "ech": 0
        },
        {
            "id": 2818,
            "name": "Fluminimaggiore",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "D639",
            "cod_istat": "111021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 1000,
            "area": "",
            "ech": 0
        },
        {
            "id": 2819,
            "name": "Flussio",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "D640",
            "cod_istat": "095080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 2820,
            "name": "Fobello",
            "provincia": "VC",
            "cap": "13025",
            "cod_catastale": "D641",
            "cod_istat": "002057",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 873,
            "giorni": 3439,
            "area": "",
            "ech": 0
        },
        {
            "id": 2821,
            "name": "Foggia",
            "provincia": "FG",
            "cap": "711xx",
            "cod_catastale": "D643",
            "cod_istat": "071024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 76,
            "giorni": 1530,
            "area": "",
            "ech": 0
        },
        {
            "id": 2822,
            "name": "Foglianise",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "D644",
            "cod_istat": "062030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 350,
            "giorni": 1707,
            "area": "",
            "ech": 0
        },
        {
            "id": 2823,
            "name": "Fogliano Redipuglia",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "D645",
            "cod_istat": "031006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2277,
            "area": "",
            "ech": 0
        },
        {
            "id": 2824,
            "name": "Foglizzo",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "D646",
            "cod_istat": "001106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2724,
            "area": "",
            "ech": 0
        },
        {
            "id": 2825,
            "name": "Foiano della Chiana",
            "provincia": "AR",
            "cap": "52045",
            "cod_catastale": "D649",
            "cod_istat": "051018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 318,
            "giorni": 2121,
            "area": "",
            "ech": 0
        },
        {
            "id": 2826,
            "name": "Foiano di Val Fortore",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "D650",
            "cod_istat": "062031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2017,
            "area": "",
            "ech": 0
        },
        {
            "id": 2827,
            "name": "Folgaria",
            "provincia": "TN",
            "cap": "38064",
            "cod_catastale": "D651",
            "cod_istat": "022087",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1166,
            "giorni": 4141,
            "area": "",
            "ech": 0
        },
        {
            "id": 2828,
            "name": "Folignano",
            "provincia": "AP",
            "cap": "63084",
            "cod_catastale": "D652",
            "cod_istat": "044020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 2013,
            "area": "",
            "ech": 0
        },
        {
            "id": 2829,
            "name": "Foligno",
            "provincia": "PG",
            "cap": "06034",
            "cod_catastale": "D653",
            "cod_istat": "054018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 2830,
            "name": "Follina",
            "provincia": "TV",
            "cap": "31051",
            "cod_catastale": "D654",
            "cod_istat": "026027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2697,
            "area": "",
            "ech": 0
        },
        {
            "id": 2831,
            "name": "Follo",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "D655",
            "cod_istat": "011013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1433,
            "area": "",
            "ech": 0
        },
        {
            "id": 2832,
            "name": "Follonica",
            "provincia": "GR",
            "cap": "58022",
            "cod_catastale": "D656",
            "cod_istat": "053009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1527,
            "area": "",
            "ech": 0
        },
        {
            "id": 2833,
            "name": "Fombio",
            "provincia": "LO",
            "cap": "26861",
            "cod_catastale": "D660",
            "cod_istat": "098026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 2834,
            "name": "Fondachelli-Fantina",
            "provincia": "ME",
            "cap": "98050",
            "cod_catastale": "D661",
            "cod_istat": "083023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 628,
            "giorni": 1700,
            "area": "",
            "ech": 0
        },
        {
            "id": 2835,
            "name": "Fondi",
            "provincia": "LT",
            "cap": "04022",
            "cod_catastale": "D662",
            "cod_istat": "059007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 1089,
            "area": "",
            "ech": 0
        },
        {
            "id": 2836,
            "name": "Fondo",
            "provincia": "TN",
            "cap": "38013",
            "cod_catastale": "D663",
            "cod_istat": "022088",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 987,
            "giorni": 3930,
            "area": "",
            "ech": 0
        },
        {
            "id": 2837,
            "name": "Fonni",
            "provincia": "NU",
            "cap": "08023",
            "cod_catastale": "D665",
            "cod_istat": "091024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1000,
            "giorni": 2315,
            "area": "",
            "ech": 0
        },
        {
            "id": 2838,
            "name": "Fontainemore",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "D666",
            "cod_istat": "007028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 3372,
            "area": "",
            "ech": 0
        },
        {
            "id": 2839,
            "name": "Fontana Liri",
            "provincia": "FR",
            "cap": "03035",
            "cod_catastale": "D667",
            "cod_istat": "060036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1523,
            "area": "",
            "ech": 0
        },
        {
            "id": 2840,
            "name": "Fontanafredda",
            "provincia": "PN",
            "cap": "33074",
            "cod_catastale": "D670",
            "cod_istat": "093022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2367,
            "area": "",
            "ech": 0
        },
        {
            "id": 2841,
            "name": "Fontanarosa",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "D671",
            "cod_istat": "064033",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 480,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 2842,
            "name": "Fontanelice",
            "provincia": "BO",
            "cap": "40025",
            "cod_catastale": "D668",
            "cod_istat": "037026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 2843,
            "name": "Fontanella",
            "provincia": "BG",
            "cap": "24056",
            "cod_catastale": "D672",
            "cod_istat": "016101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 2844,
            "name": "Fontanellato",
            "provincia": "PR",
            "cap": "43012",
            "cod_catastale": "D673",
            "cod_istat": "034015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2488,
            "area": "",
            "ech": 0
        },
        {
            "id": 2845,
            "name": "Fontanelle",
            "provincia": "TV",
            "cap": "31043",
            "cod_catastale": "D674",
            "cod_istat": "026028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2379,
            "area": "",
            "ech": 0
        },
        {
            "id": 2846,
            "name": "Fontaneto d'Agogna",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "D675",
            "cod_istat": "003066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 2847,
            "name": "Fontanetto Po",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "D676",
            "cod_istat": "002058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 2810,
            "area": "",
            "ech": 0
        },
        {
            "id": 2848,
            "name": "Fontanigorda",
            "provincia": "GE",
            "cap": "16023",
            "cod_catastale": "D677",
            "cod_istat": "010024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 819,
            "giorni": 3489,
            "area": "",
            "ech": 0
        },
        {
            "id": 2849,
            "name": "Fontanile",
            "provincia": "AT",
            "cap": "14044",
            "cod_catastale": "D678",
            "cod_istat": "005054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 2850,
            "name": "Fontaniva",
            "provincia": "PD",
            "cap": "35014",
            "cod_catastale": "D679",
            "cod_istat": "028038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 2851,
            "name": "Fonte",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "D680",
            "cod_istat": "026029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 2852,
            "name": "Fonte Nuova",
            "provincia": "RM",
            "cap": "00013",
            "cod_catastale": "M309",
            "cod_istat": "058122",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2853,
            "name": "Fontecchio",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "D681",
            "cod_istat": "066043",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 668,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 2854,
            "name": "Fontechiari",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "D682",
            "cod_istat": "060037",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 375,
            "giorni": 1759,
            "area": "",
            "ech": 0
        },
        {
            "id": 2855,
            "name": "Fontegreca",
            "provincia": "CE",
            "cap": "81014",
            "cod_catastale": "D683",
            "cod_istat": "061034",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 320,
            "giorni": 1651,
            "area": "",
            "ech": 0
        },
        {
            "id": 2856,
            "name": "Fonteno",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D684",
            "cod_istat": "016102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 606,
            "giorni": 2930,
            "area": "",
            "ech": 0
        },
        {
            "id": 2857,
            "name": "Fontevivo",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "D685",
            "cod_istat": "034016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2610,
            "area": "",
            "ech": 0
        },
        {
            "id": 2858,
            "name": "Fonzaso",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "D686",
            "cod_istat": "025022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 3104,
            "area": "",
            "ech": 0
        },
        {
            "id": 2859,
            "name": "Foppolo",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "D688",
            "cod_istat": "016103",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1508,
            "giorni": 4444,
            "area": "",
            "ech": 0
        },
        {
            "id": 2860,
            "name": "Forano",
            "provincia": "RI",
            "cap": "02044",
            "cod_catastale": "D689",
            "cod_istat": "057029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 1850,
            "area": "",
            "ech": 0
        },
        {
            "id": 2861,
            "name": "Force",
            "provincia": "AP",
            "cap": "63086",
            "cod_catastale": "D691",
            "cod_istat": "044021",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 689,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 2862,
            "name": "Forchia",
            "provincia": "BN",
            "cap": "82011",
            "cod_catastale": "D693",
            "cod_istat": "062032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 1583,
            "area": "",
            "ech": 0
        },
        {
            "id": 2863,
            "name": "Forcola",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "D694",
            "cod_istat": "014029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 3067,
            "area": "",
            "ech": 0
        },
        {
            "id": 2864,
            "name": "Fordongianus",
            "provincia": "OR",
            "cap": "09083",
            "cod_catastale": "D695",
            "cod_istat": "095020",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 35,
            "giorni": 947,
            "area": "",
            "ech": 0
        },
        {
            "id": 2865,
            "name": "Forenza",
            "provincia": "PZ",
            "cap": "85023",
            "cod_catastale": "D696",
            "cod_istat": "076033",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 836,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 2866,
            "name": "Foresto Sparso",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D697",
            "cod_istat": "016104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 2561,
            "area": "",
            "ech": 0
        },
        {
            "id": 2867,
            "name": "Forgaria nel Friuli",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "D700",
            "cod_istat": "030137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 2868,
            "name": "Forino",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "D701",
            "cod_istat": "064034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 2869,
            "name": "Forio",
            "provincia": "NA",
            "cap": "80075",
            "cod_catastale": "D702",
            "cod_istat": "063031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 1069,
            "area": "",
            "ech": 0
        },
        {
            "id": 2870,
            "name": "Forlì",
            "provincia": "FC",
            "cap": "471xx",
            "cod_catastale": "D704",
            "cod_istat": "040012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2087,
            "area": "",
            "ech": 0
        },
        {
            "id": 2871,
            "name": "Forlì del Sannio",
            "provincia": "IS",
            "cap": "86084",
            "cod_catastale": "D703",
            "cod_istat": "094020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 2169,
            "area": "",
            "ech": 0
        },
        {
            "id": 2872,
            "name": "Forlimpopoli",
            "provincia": "FC",
            "cap": "47034",
            "cod_catastale": "D705",
            "cod_istat": "040013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2082,
            "area": "",
            "ech": 0
        },
        {
            "id": 2873,
            "name": "Formazza",
            "provincia": "VB",
            "cap": "28863",
            "cod_catastale": "D706",
            "cod_istat": "103031",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1280,
            "giorni": 3968,
            "area": "",
            "ech": 0
        },
        {
            "id": 2874,
            "name": "Formello",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "D707",
            "cod_istat": "058038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1693,
            "area": "",
            "ech": 0
        },
        {
            "id": 2875,
            "name": "Formia",
            "provincia": "LT",
            "cap": "04023",
            "cod_catastale": "D708",
            "cod_istat": "059008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 967,
            "area": "",
            "ech": 0
        },
        {
            "id": 2876,
            "name": "Formicola",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "D709",
            "cod_istat": "061035",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 196,
            "giorni": 1438,
            "area": "",
            "ech": 0
        },
        {
            "id": 2877,
            "name": "Formigara",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "D710",
            "cod_istat": "019044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2878,
            "name": "Formigine",
            "provincia": "MO",
            "cap": "41043",
            "cod_catastale": "D711",
            "cod_istat": "036015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2286,
            "area": "",
            "ech": 0
        },
        {
            "id": 2879,
            "name": "Formigliana",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "D712",
            "cod_istat": "002059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2509,
            "area": "",
            "ech": 0
        },
        {
            "id": 2880,
            "name": "Formignana",
            "provincia": "FE",
            "cap": "44035",
            "cod_catastale": "D713",
            "cod_istat": "038009",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 2881,
            "name": "Fornace",
            "provincia": "TN",
            "cap": "38040",
            "cod_catastale": "D714",
            "cod_istat": "022089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 740,
            "giorni": 3545,
            "area": "",
            "ech": 0
        },
        {
            "id": 2882,
            "name": "Fornelli",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "D715",
            "cod_istat": "094021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2039,
            "area": "",
            "ech": 0
        },
        {
            "id": 2883,
            "name": "Forni Avoltri",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "D718",
            "cod_istat": "030040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 888,
            "giorni": 4110,
            "area": "",
            "ech": 0
        },
        {
            "id": 2884,
            "name": "Forni di Sopra",
            "provincia": "UD",
            "cap": "33024",
            "cod_catastale": "D719",
            "cod_istat": "030041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 907,
            "giorni": 3798,
            "area": "",
            "ech": 0
        },
        {
            "id": 2885,
            "name": "Forni di Sotto",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "D720",
            "cod_istat": "030042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 776,
            "giorni": 3715,
            "area": "",
            "ech": 0
        },
        {
            "id": 2886,
            "name": "Forno Canavese",
            "provincia": "TO",
            "cap": "10084",
            "cod_catastale": "D725",
            "cod_istat": "001107",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 585,
            "giorni": 3231,
            "area": "",
            "ech": 0
        },
        {
            "id": 2887,
            "name": "Forno di Zoldo",
            "provincia": "BL",
            "cap": "32012",
            "cod_catastale": "D726",
            "cod_istat": "025024",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 848,
            "giorni": 3956,
            "area": "",
            "ech": 0
        },
        {
            "id": 2888,
            "name": "Fornovo di Taro",
            "provincia": "PR",
            "cap": "43045",
            "cod_catastale": "D728",
            "cod_istat": "034017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 2602,
            "area": "",
            "ech": 0
        },
        {
            "id": 2889,
            "name": "Fornovo San Giovanni",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "D727",
            "cod_istat": "016105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2890,
            "name": "Forte dei Marmi",
            "provincia": "LU",
            "cap": "55042",
            "cod_catastale": "D730",
            "cod_istat": "046013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1402,
            "area": "",
            "ech": 0
        },
        {
            "id": 2891,
            "name": "Fortezza",
            "provincia": "BZ",
            "cap": "39045",
            "cod_catastale": "D731",
            "cod_istat": "021032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 749,
            "giorni": 3596,
            "area": "",
            "ech": 0
        },
        {
            "id": 2892,
            "name": "Fortunago",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "D732",
            "cod_istat": "018064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 2962,
            "area": "",
            "ech": 0
        },
        {
            "id": 2893,
            "name": "Forza d'Agrò",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "D733",
            "cod_istat": "083024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1345,
            "area": "",
            "ech": 0
        },
        {
            "id": 2894,
            "name": "Fosciandora",
            "provincia": "LU",
            "cap": "55020",
            "cod_catastale": "D734",
            "cod_istat": "046014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 2895,
            "name": "Fosdinovo",
            "provincia": "MS",
            "cap": "54035",
            "cod_catastale": "D735",
            "cod_istat": "045008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 2896,
            "name": "Fossa",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "D736",
            "cod_istat": "066044",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 644,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 2897,
            "name": "Fossacesia",
            "provincia": "CH",
            "cap": "66022",
            "cod_catastale": "D738",
            "cod_istat": "069033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1406,
            "area": "",
            "ech": 0
        },
        {
            "id": 2898,
            "name": "Fossalta di Piave",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "D740",
            "cod_istat": "027015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 2899,
            "name": "Fossalta di Portogruaro",
            "provincia": "VE",
            "cap": "30025",
            "cod_catastale": "D741",
            "cod_istat": "027016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 2900,
            "name": "Fossalto",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "D737",
            "cod_istat": "070024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 511,
            "giorni": 2003,
            "area": "",
            "ech": 0
        },
        {
            "id": 2901,
            "name": "Fossano",
            "provincia": "CN",
            "cap": "12045",
            "cod_catastale": "D742",
            "cod_istat": "004089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2637,
            "area": "",
            "ech": 0
        },
        {
            "id": 2902,
            "name": "Fossato di Vico",
            "provincia": "PG",
            "cap": "06022",
            "cod_catastale": "D745",
            "cod_istat": "054019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 581,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 2903,
            "name": "Fossato Serralta",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "D744",
            "cod_istat": "079052",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 722,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 2904,
            "name": "Fossò",
            "provincia": "VE",
            "cap": "30030",
            "cod_catastale": "D748",
            "cod_istat": "027017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 2905,
            "name": "Fossombrone",
            "provincia": "PU",
            "cap": "61034",
            "cod_catastale": "D749",
            "cod_istat": "041015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2167,
            "area": "",
            "ech": 0
        },
        {
            "id": 2906,
            "name": "Foza",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "D750",
            "cod_istat": "024041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1083,
            "giorni": 4295,
            "area": "",
            "ech": 0
        },
        {
            "id": 2907,
            "name": "Frabosa Soprana",
            "provincia": "CN",
            "cap": "12082",
            "cod_catastale": "D751",
            "cod_istat": "004090",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 891,
            "giorni": 3420,
            "area": "",
            "ech": 0
        },
        {
            "id": 2908,
            "name": "Frabosa Sottana",
            "provincia": "CN",
            "cap": "12083",
            "cod_catastale": "D752",
            "cod_istat": "004091",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 641,
            "giorni": 3110,
            "area": "",
            "ech": 0
        },
        {
            "id": 2909,
            "name": "Fraconalto",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "D559",
            "cod_istat": "006069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 3091,
            "area": "",
            "ech": 0
        },
        {
            "id": 2910,
            "name": "Fragagnano",
            "provincia": "TA",
            "cap": "74022",
            "cod_catastale": "D754",
            "cod_istat": "073006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 1266,
            "area": "",
            "ech": 0
        },
        {
            "id": 2911,
            "name": "Fragneto l'Abate",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "D755",
            "cod_istat": "062033",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 501,
            "giorni": 1982,
            "area": "",
            "ech": 0
        },
        {
            "id": 2912,
            "name": "Fragneto Monforte",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "D756",
            "cod_istat": "062034",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 380,
            "giorni": 1762,
            "area": "",
            "ech": 0
        },
        {
            "id": 2913,
            "name": "Fraine",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "D757",
            "cod_istat": "069034",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 751,
            "giorni": 2370,
            "area": "",
            "ech": 0
        },
        {
            "id": 2914,
            "name": "Framura",
            "provincia": "SP",
            "cap": "19014",
            "cod_catastale": "D758",
            "cod_istat": "011014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 1670,
            "area": "",
            "ech": 0
        },
        {
            "id": 2915,
            "name": "Francavilla al Mare",
            "provincia": "CH",
            "cap": "66023",
            "cod_catastale": "D763",
            "cod_istat": "069035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1830,
            "area": "",
            "ech": 0
        },
        {
            "id": 2916,
            "name": "Francavilla Angitola",
            "provincia": "VV",
            "cap": "89815",
            "cod_catastale": "D762",
            "cod_istat": "102014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 1269,
            "area": "",
            "ech": 1
        },
        {
            "id": 2917,
            "name": "Francavilla Bisio",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "D759",
            "cod_istat": "006070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 2918,
            "name": "Francavilla d'Ete",
            "provincia": "FM",
            "cap": "63816",
            "cod_catastale": "D760",
            "cod_istat": "109007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 1910,
            "area": "",
            "ech": 0
        },
        {
            "id": 2919,
            "name": "Francavilla di Sicilia",
            "provincia": "ME",
            "cap": "98034",
            "cod_catastale": "D765",
            "cod_istat": "083025",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 330,
            "giorni": 1191,
            "area": "",
            "ech": 1
        },
        {
            "id": 2920,
            "name": "Francavilla Fontana",
            "provincia": "BR",
            "cap": "72021",
            "cod_catastale": "D761",
            "cod_istat": "074008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 1286,
            "area": "",
            "ech": 0
        },
        {
            "id": 2921,
            "name": "Francavilla in Sinni",
            "provincia": "PZ",
            "cap": "85034",
            "cod_catastale": "D766",
            "cod_istat": "076034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 2922,
            "name": "Francavilla Marittima",
            "provincia": "CS",
            "cap": "87072",
            "cod_catastale": "D764",
            "cod_istat": "078056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 1355,
            "area": "",
            "ech": 1
        },
        {
            "id": 2923,
            "name": "Francica",
            "provincia": "VV",
            "cap": "89851",
            "cod_catastale": "D767",
            "cod_istat": "102015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 1262,
            "area": "",
            "ech": 0
        },
        {
            "id": 2924,
            "name": "Francofonte",
            "provincia": "SR",
            "cap": "96015",
            "cod_catastale": "D768",
            "cod_istat": "089010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 1100,
            "area": "",
            "ech": 0
        },
        {
            "id": 2925,
            "name": "Francolise",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "D769",
            "cod_istat": "061036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 1249,
            "area": "",
            "ech": 0
        },
        {
            "id": 2926,
            "name": "Frascaro",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "D770",
            "cod_istat": "006071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2583,
            "area": "",
            "ech": 0
        },
        {
            "id": 2927,
            "name": "Frascarolo",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "D771",
            "cod_istat": "018065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 2928,
            "name": "Frascati",
            "provincia": "RM",
            "cap": "00044",
            "cod_catastale": "D773",
            "cod_istat": "058039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1818,
            "area": "",
            "ech": 0
        },
        {
            "id": 2929,
            "name": "Frascineto",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "D774",
            "cod_istat": "078057",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 486,
            "giorni": 1776,
            "area": "",
            "ech": 0
        },
        {
            "id": 2930,
            "name": "Frassilongo",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "D775",
            "cod_istat": "022090",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 852,
            "giorni": 3720,
            "area": "",
            "ech": 0
        },
        {
            "id": 2931,
            "name": "Frassinelle Polesine",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "D776",
            "cod_istat": "029023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 2932,
            "name": "Frassinello Monferrato",
            "provincia": "AL",
            "cap": "15035",
            "cod_catastale": "D777",
            "cod_istat": "006072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 2933,
            "name": "Frassineto Po",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "D780",
            "cod_istat": "006073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2804,
            "area": "",
            "ech": 0
        },
        {
            "id": 2934,
            "name": "Frassinetto",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "D781",
            "cod_istat": "001108",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1048,
            "giorni": 3826,
            "area": "",
            "ech": 0
        },
        {
            "id": 2935,
            "name": "Frassino",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "D782",
            "cod_istat": "004092",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3245,
            "area": "",
            "ech": 0
        },
        {
            "id": 2936,
            "name": "Frassinoro",
            "provincia": "MO",
            "cap": "41044",
            "cod_catastale": "D783",
            "cod_istat": "036016",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1131,
            "giorni": 3972,
            "area": "",
            "ech": 0
        },
        {
            "id": 2937,
            "name": "Frasso Sabino",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "D785",
            "cod_istat": "057030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2115,
            "area": "",
            "ech": 0
        },
        {
            "id": 2938,
            "name": "Frasso Telesino",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "D784",
            "cod_istat": "062035",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 374,
            "giorni": 1751,
            "area": "",
            "ech": 0
        },
        {
            "id": 2939,
            "name": "Fratta Polesine",
            "provincia": "RO",
            "cap": "45025",
            "cod_catastale": "D788",
            "cod_istat": "029024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 2940,
            "name": "Fratta Todina",
            "provincia": "PG",
            "cap": "06054",
            "cod_catastale": "D787",
            "cod_istat": "054020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 1915,
            "area": "",
            "ech": 0
        },
        {
            "id": 2941,
            "name": "Frattamaggiore",
            "provincia": "NA",
            "cap": "80027",
            "cod_catastale": "D789",
            "cod_istat": "063032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 1008,
            "area": "",
            "ech": 0
        },
        {
            "id": 2942,
            "name": "Frattaminore",
            "provincia": "NA",
            "cap": "80020",
            "cod_catastale": "D790",
            "cod_istat": "063033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1105,
            "area": "",
            "ech": 0
        },
        {
            "id": 2943,
            "name": "Fratte Rosa",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "D791",
            "cod_istat": "041016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 419,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 2944,
            "name": "Frazzanò",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "D793",
            "cod_istat": "083026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 563,
            "giorni": 1589,
            "area": "",
            "ech": 0
        },
        {
            "id": 2945,
            "name": "Fregona",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "D794",
            "cod_istat": "026030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2823,
            "area": "",
            "ech": 0
        },
        {
            "id": 2946,
            "name": "Fresagrandinaria",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "D796",
            "cod_istat": "069036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 1783,
            "area": "",
            "ech": 0
        },
        {
            "id": 2947,
            "name": "Fresonara",
            "provincia": "AL",
            "cap": "15064",
            "cod_catastale": "D797",
            "cod_istat": "006074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 2948,
            "name": "Frigento",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "D798",
            "cod_istat": "064035",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 911,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 2949,
            "name": "Frignano",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "D799",
            "cod_istat": "061037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1101,
            "area": "",
            "ech": 0
        },
        {
            "id": 2950,
            "name": "Frinco",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "D802",
            "cod_istat": "005055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 2951,
            "name": "Frisa",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "D803",
            "cod_istat": "069037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 1596,
            "area": "",
            "ech": 0
        },
        {
            "id": 2952,
            "name": "Frisanco",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "D804",
            "cod_istat": "093024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 3235,
            "area": "",
            "ech": 0
        },
        {
            "id": 2953,
            "name": "Front",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "D805",
            "cod_istat": "001109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2759,
            "area": "",
            "ech": 0
        },
        {
            "id": 2954,
            "name": "Frontino",
            "provincia": "PU",
            "cap": "61021",
            "cod_catastale": "D807",
            "cod_istat": "041017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 519,
            "giorni": 2492,
            "area": "",
            "ech": 0
        },
        {
            "id": 2955,
            "name": "Frontone",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "D808",
            "cod_istat": "041018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 2956,
            "name": "Frosinone",
            "provincia": "FR",
            "cap": "03100",
            "cod_catastale": "D810",
            "cod_istat": "060038",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 291,
            "giorni": 2196,
            "area": "",
            "ech": 0
        },
        {
            "id": 2957,
            "name": "Frosolone",
            "provincia": "IS",
            "cap": "86095",
            "cod_catastale": "D811",
            "cod_istat": "094022",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 894,
            "giorni": 2539,
            "area": "",
            "ech": 0
        },
        {
            "id": 2958,
            "name": "Frossasco",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "D812",
            "cod_istat": "001110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2815,
            "area": "",
            "ech": 0
        },
        {
            "id": 2959,
            "name": "Frugarolo",
            "provincia": "AL",
            "cap": "15065",
            "cod_catastale": "D813",
            "cod_istat": "006075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2609,
            "area": "",
            "ech": 0
        },
        {
            "id": 2960,
            "name": "Fubine Monferrato",
            "provincia": "AL",
            "cap": "15043",
            "cod_catastale": "D814",
            "cod_istat": "006076",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 2961,
            "name": "Fucecchio",
            "provincia": "FI",
            "cap": "50054",
            "cod_catastale": "D815",
            "cod_istat": "048019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1728,
            "area": "",
            "ech": 0
        },
        {
            "id": 2962,
            "name": "Fuipiano Valle Imagna",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "D817",
            "cod_istat": "016106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1019,
            "giorni": 3520,
            "area": "",
            "ech": 0
        },
        {
            "id": 2963,
            "name": "Fumane",
            "provincia": "VR",
            "cap": "37022",
            "cod_catastale": "D818",
            "cod_istat": "023035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 2964,
            "name": "Fumone",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "D819",
            "cod_istat": "060039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 783,
            "giorni": 2533,
            "area": "",
            "ech": 0
        },
        {
            "id": 2965,
            "name": "Funes",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "D821",
            "cod_istat": "021033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1132,
            "giorni": 4264,
            "area": "",
            "ech": 0
        },
        {
            "id": 2966,
            "name": "Furci",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "D823",
            "cod_istat": "069038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 2021,
            "area": "",
            "ech": 0
        },
        {
            "id": 2967,
            "name": "Furci Siculo",
            "provincia": "ME",
            "cap": "98023",
            "cod_catastale": "D824",
            "cod_istat": "083027",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 642,
            "area": "",
            "ech": 0
        },
        {
            "id": 2968,
            "name": "Furnari",
            "provincia": "ME",
            "cap": "98054",
            "cod_catastale": "D825",
            "cod_istat": "083028",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 874,
            "area": "",
            "ech": 0
        },
        {
            "id": 2969,
            "name": "Furore",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "D826",
            "cod_istat": "065053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1543,
            "area": "",
            "ech": 0
        },
        {
            "id": 2970,
            "name": "Furtei",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "D827",
            "cod_istat": "111022",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 90,
            "giorni": 1107,
            "area": "",
            "ech": 0
        },
        {
            "id": 2971,
            "name": "Fuscaldo",
            "provincia": "CS",
            "cap": "87024",
            "cod_catastale": "D828",
            "cod_istat": "078058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 2972,
            "name": "Fusignano",
            "provincia": "RA",
            "cap": "48034",
            "cod_catastale": "D829",
            "cod_istat": "039011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 2973,
            "name": "Fusine",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "D830",
            "cod_istat": "014030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 3064,
            "area": "",
            "ech": 0
        },
        {
            "id": 2974,
            "name": "Futani",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "D832",
            "cod_istat": "065054",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 431,
            "giorni": 1583,
            "area": "",
            "ech": 0
        },
        {
            "id": 2975,
            "name": "Gabbioneta-Binanuova",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "D834",
            "cod_istat": "019045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2976,
            "name": "Gabiano",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "D835",
            "cod_istat": "006077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 2977,
            "name": "Gabicce Mare",
            "provincia": "PU",
            "cap": "61011",
            "cod_catastale": "D836",
            "cod_istat": "041019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2114,
            "area": "",
            "ech": 0
        },
        {
            "id": 2978,
            "name": "Gaby",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "D839",
            "cod_istat": "007029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1047,
            "giorni": 3803,
            "area": "",
            "ech": 0
        },
        {
            "id": 2979,
            "name": "Gadesco-Pieve Delmona",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "D841",
            "cod_istat": "019046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 2980,
            "name": "Gadoni",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "D842",
            "cod_istat": "091025",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 696,
            "giorni": 1940,
            "area": "",
            "ech": 0
        },
        {
            "id": 2981,
            "name": "Gaeta",
            "provincia": "LT",
            "cap": "04024",
            "cod_catastale": "D843",
            "cod_istat": "059009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 938,
            "area": "",
            "ech": 0
        },
        {
            "id": 2982,
            "name": "Gaggi",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "D844",
            "cod_istat": "083029",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 808,
            "area": "",
            "ech": 1
        },
        {
            "id": 2983,
            "name": "Gaggiano",
            "provincia": "MI",
            "cap": "20083",
            "cod_catastale": "D845",
            "cod_istat": "015103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 2984,
            "name": "Gaggio Montano",
            "provincia": "BO",
            "cap": "40041",
            "cod_catastale": "D847",
            "cod_istat": "037027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 682,
            "giorni": 2983,
            "area": "",
            "ech": 0
        },
        {
            "id": 2985,
            "name": "Gaglianico",
            "provincia": "BI",
            "cap": "13894",
            "cod_catastale": "D848",
            "cod_istat": "096026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 2986,
            "name": "Gagliano Aterno",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "D850",
            "cod_istat": "066045",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2202,
            "area": "",
            "ech": 0
        },
        {
            "id": 2987,
            "name": "Gagliano Castelferrato",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "D849",
            "cod_istat": "086010",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 651,
            "giorni": 1649,
            "area": "",
            "ech": 1
        },
        {
            "id": 2988,
            "name": "Gagliano del Capo",
            "provincia": "LE",
            "cap": "73034",
            "cod_catastale": "D851",
            "cod_istat": "075028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 1100,
            "area": "",
            "ech": 0
        },
        {
            "id": 2989,
            "name": "Gagliato",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "D852",
            "cod_istat": "079055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1605,
            "area": "",
            "ech": 0
        },
        {
            "id": 2990,
            "name": "Gagliole",
            "provincia": "MC",
            "cap": "62022",
            "cod_catastale": "D853",
            "cod_istat": "043020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 484,
            "giorni": 2206,
            "area": "",
            "ech": 0
        },
        {
            "id": 2991,
            "name": "Gaiarine",
            "provincia": "TV",
            "cap": "31018",
            "cod_catastale": "D854",
            "cod_istat": "026031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2451,
            "area": "",
            "ech": 0
        },
        {
            "id": 2992,
            "name": "Gaiba",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "D855",
            "cod_istat": "029025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2338,
            "area": "",
            "ech": 0
        },
        {
            "id": 2993,
            "name": "Gaiola",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "D856",
            "cod_istat": "004093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 962,
            "giorni": 3508,
            "area": "",
            "ech": 0
        },
        {
            "id": 2994,
            "name": "Gaiole in Chianti",
            "provincia": "SI",
            "cap": "53013",
            "cod_catastale": "D858",
            "cod_istat": "052013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1958,
            "area": "",
            "ech": 0
        },
        {
            "id": 2995,
            "name": "Gairo",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "D859",
            "cod_istat": "091026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 685,
            "giorni": 1929,
            "area": "",
            "ech": 1
        },
        {
            "id": 2996,
            "name": "Gais",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "D860",
            "cod_istat": "021034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 841,
            "giorni": 3844,
            "area": "",
            "ech": 0
        },
        {
            "id": 2997,
            "name": "Galati Mamertino",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "D861",
            "cod_istat": "083030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 790,
            "giorni": 1977,
            "area": "",
            "ech": 1
        },
        {
            "id": 2998,
            "name": "Galatina",
            "provincia": "LE",
            "cap": "73013",
            "cod_catastale": "D862",
            "cod_istat": "075029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1201,
            "area": "",
            "ech": 0
        },
        {
            "id": 2999,
            "name": "Galatone",
            "provincia": "LE",
            "cap": "73044",
            "cod_catastale": "D863",
            "cod_istat": "075030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 1224,
            "area": "",
            "ech": 0
        },
        {
            "id": 3000,
            "name": "Galatro",
            "provincia": "RC",
            "cap": "89054",
            "cod_catastale": "D864",
            "cod_istat": "080035",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 158,
            "giorni": 985,
            "area": "",
            "ech": 0
        },
        {
            "id": 3001,
            "name": "Galbiate",
            "provincia": "LC",
            "cap": "23851",
            "cod_catastale": "D865",
            "cod_istat": "097036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 371,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 3002,
            "name": "Galeata",
            "provincia": "FC",
            "cap": "47010",
            "cod_catastale": "D867",
            "cod_istat": "040014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2438,
            "area": "",
            "ech": 0
        },
        {
            "id": 3003,
            "name": "Galgagnano",
            "provincia": "LO",
            "cap": "26832",
            "cod_catastale": "D868",
            "cod_istat": "098027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3004,
            "name": "Gallarate",
            "provincia": "VA",
            "cap": "21013",
            "cod_catastale": "D869",
            "cod_istat": "012070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 238,
            "giorni": 2877,
            "area": "",
            "ech": 0
        },
        {
            "id": 3005,
            "name": "Gallese",
            "provincia": "VT",
            "cap": "01035",
            "cod_catastale": "D870",
            "cod_istat": "056027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 1661,
            "area": "",
            "ech": 0
        },
        {
            "id": 3006,
            "name": "Galliate",
            "provincia": "NO",
            "cap": "28066",
            "cod_catastale": "D872",
            "cod_istat": "003068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 153,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 3007,
            "name": "Galliate Lombardo",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "D871",
            "cod_istat": "012071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 3008,
            "name": "Galliavola",
            "provincia": "PV",
            "cap": "27034",
            "cod_catastale": "D873",
            "cod_istat": "018066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3009,
            "name": "Gallicano",
            "provincia": "LU",
            "cap": "55027",
            "cod_catastale": "D874",
            "cod_istat": "046015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2183,
            "area": "",
            "ech": 0
        },
        {
            "id": 3010,
            "name": "Gallicano nel Lazio",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "D875",
            "cod_istat": "058040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 1659,
            "area": "",
            "ech": 0
        },
        {
            "id": 3011,
            "name": "Gallicchio",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "D876",
            "cod_istat": "076035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2207,
            "area": "",
            "ech": 0
        },
        {
            "id": 3012,
            "name": "Galliera",
            "provincia": "BO",
            "cap": "40015",
            "cod_catastale": "D878",
            "cod_istat": "037028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2332,
            "area": "",
            "ech": 0
        },
        {
            "id": 3013,
            "name": "Galliera Veneta",
            "provincia": "PD",
            "cap": "35015",
            "cod_catastale": "D879",
            "cod_istat": "028039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 3014,
            "name": "Gallinaro",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "D881",
            "cod_istat": "060040",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 558,
            "giorni": 2131,
            "area": "",
            "ech": 0
        },
        {
            "id": 3015,
            "name": "Gallio",
            "provincia": "VI",
            "cap": "36032",
            "cod_catastale": "D882",
            "cod_istat": "024042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1090,
            "giorni": 4308,
            "area": "",
            "ech": 0
        },
        {
            "id": 3016,
            "name": "Gallipoli",
            "provincia": "LE",
            "cap": "73014",
            "cod_catastale": "D883",
            "cod_istat": "075031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 999,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3017,
            "name": "Gallo Matese",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "D884",
            "cod_istat": "061038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 875,
            "giorni": 2739,
            "area": "",
            "ech": 0
        },
        {
            "id": 3018,
            "name": "Gallodoro",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "D885",
            "cod_istat": "083031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 388,
            "giorni": 1290,
            "area": "",
            "ech": 0
        },
        {
            "id": 3019,
            "name": "Galluccio",
            "provincia": "CE",
            "cap": "81044",
            "cod_catastale": "D886",
            "cod_istat": "061039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 368,
            "giorni": 1787,
            "area": "",
            "ech": 0
        },
        {
            "id": 3020,
            "name": "Galtellì",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "D888",
            "cod_istat": "091027",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 35,
            "giorni": 846,
            "area": "",
            "ech": 1
        },
        {
            "id": 3021,
            "name": "Galzignano Terme",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "D889",
            "cod_istat": "028040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2418,
            "area": "",
            "ech": 0
        },
        {
            "id": 3022,
            "name": "Gamalero",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "D890",
            "cod_istat": "006078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 3023,
            "name": "Gambara",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "D891",
            "cod_istat": "017073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 3024,
            "name": "Gambarana",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "D892",
            "cod_istat": "018067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3025,
            "name": "Gambasca",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "D894",
            "cod_istat": "004094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 478,
            "giorni": 2908,
            "area": "",
            "ech": 0
        },
        {
            "id": 3026,
            "name": "Gambassi Terme",
            "provincia": "FI",
            "cap": "50050",
            "cod_catastale": "D895",
            "cod_istat": "048020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 3027,
            "name": "Gambatesa",
            "provincia": "CB",
            "cap": "86013",
            "cod_catastale": "D896",
            "cod_istat": "070025",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 468,
            "giorni": 1979,
            "area": "",
            "ech": 0
        },
        {
            "id": 3028,
            "name": "Gambellara",
            "provincia": "VI",
            "cap": "36053",
            "cod_catastale": "D897",
            "cod_istat": "024043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 3029,
            "name": "Gamberale",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "D898",
            "cod_istat": "069039",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1343,
            "giorni": 3425,
            "area": "",
            "ech": 0
        },
        {
            "id": 3030,
            "name": "Gambettola",
            "provincia": "FC",
            "cap": "47035",
            "cod_catastale": "D899",
            "cod_istat": "040015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 3031,
            "name": "Gambolò",
            "provincia": "PV",
            "cap": "27025",
            "cod_catastale": "D901",
            "cod_istat": "018068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3032,
            "name": "Gambugliano",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "D902",
            "cod_istat": "024044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 3033,
            "name": "Gandellino",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "D903",
            "cod_istat": "016107",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 682,
            "giorni": 3048,
            "area": "",
            "ech": 0
        },
        {
            "id": 3034,
            "name": "Gandino",
            "provincia": "BG",
            "cap": "24024",
            "cod_catastale": "D905",
            "cod_istat": "016108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 2853,
            "area": "",
            "ech": 0
        },
        {
            "id": 3035,
            "name": "Gandosso",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D906",
            "cod_istat": "016109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 488,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 3036,
            "name": "Gangi",
            "provincia": "PA",
            "cap": "90024",
            "cod_catastale": "D907",
            "cod_istat": "082036",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1011,
            "giorni": 2179,
            "area": "",
            "ech": 0
        },
        {
            "id": 3037,
            "name": "Garaguso",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "D909",
            "cod_istat": "077009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 492,
            "giorni": 1803,
            "area": "",
            "ech": 0
        },
        {
            "id": 3038,
            "name": "Garbagna",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "D910",
            "cod_istat": "006079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 3039,
            "name": "Garbagna Novarese",
            "provincia": "NO",
            "cap": "28070",
            "cod_catastale": "D911",
            "cod_istat": "003069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 3040,
            "name": "Garbagnate Milanese",
            "provincia": "MI",
            "cap": "20024",
            "cod_catastale": "D912",
            "cod_istat": "015105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 3041,
            "name": "Garbagnate Monastero",
            "provincia": "LC",
            "cap": "23846",
            "cod_catastale": "D913",
            "cod_istat": "097037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 3042,
            "name": "Garda",
            "provincia": "VR",
            "cap": "37016",
            "cod_catastale": "D915",
            "cod_istat": "023036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 3043,
            "name": "Gardone Riviera",
            "provincia": "BS",
            "cap": "25083",
            "cod_catastale": "D917",
            "cod_istat": "017074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3044,
            "name": "Gardone Val Trompia",
            "provincia": "BS",
            "cap": "25063",
            "cod_catastale": "D918",
            "cod_istat": "017075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 3045,
            "name": "Garessio",
            "provincia": "CN",
            "cap": "12075",
            "cod_catastale": "D920",
            "cod_istat": "004095",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 621,
            "giorni": 3085,
            "area": "",
            "ech": 0
        },
        {
            "id": 3046,
            "name": "Gargallo",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "D921",
            "cod_istat": "003070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2824,
            "area": "",
            "ech": 0
        },
        {
            "id": 3047,
            "name": "Gargazzone",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "D923",
            "cod_istat": "021035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2827,
            "area": "",
            "ech": 0
        },
        {
            "id": 3048,
            "name": "Gargnano",
            "provincia": "BS",
            "cap": "25084",
            "cod_catastale": "D924",
            "cod_istat": "017076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 3049,
            "name": "Garlasco",
            "provincia": "PV",
            "cap": "27026",
            "cod_catastale": "D925",
            "cod_istat": "018069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3050,
            "name": "Garlate",
            "provincia": "LC",
            "cap": "23852",
            "cod_catastale": "D926",
            "cod_istat": "097038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2361,
            "area": "",
            "ech": 0
        },
        {
            "id": 3051,
            "name": "Garlenda",
            "provincia": "SV",
            "cap": "17033",
            "cod_catastale": "D927",
            "cod_istat": "009030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1362,
            "area": "",
            "ech": 0
        },
        {
            "id": 3052,
            "name": "Garniga Terme",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "D928",
            "cod_istat": "022091",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3053,
            "name": "Garzeno",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D930",
            "cod_istat": "013106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 662,
            "giorni": 3010,
            "area": "",
            "ech": 0
        },
        {
            "id": 3054,
            "name": "Garzigliana",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "D931",
            "cod_istat": "001111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 3055,
            "name": "Gasperina",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "D932",
            "cod_istat": "079056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 489,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 3056,
            "name": "Gassino Torinese",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "D933",
            "cod_istat": "001112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2699,
            "area": "",
            "ech": 0
        },
        {
            "id": 3057,
            "name": "Gattatico",
            "provincia": "RE",
            "cap": "42043",
            "cod_catastale": "D934",
            "cod_istat": "035022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2367,
            "area": "",
            "ech": 0
        },
        {
            "id": 3058,
            "name": "Gatteo",
            "provincia": "FC",
            "cap": "47043",
            "cod_catastale": "D935",
            "cod_istat": "040016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2175,
            "area": "",
            "ech": 0
        },
        {
            "id": 3059,
            "name": "Gattico",
            "provincia": "NO",
            "cap": "28013",
            "cod_catastale": "D937",
            "cod_istat": "003166",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 3060,
            "name": "Gattinara",
            "provincia": "VC",
            "cap": "13045",
            "cod_catastale": "D938",
            "cod_istat": "002061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 3061,
            "name": "Gavardo",
            "provincia": "BS",
            "cap": "25085",
            "cod_catastale": "D940",
            "cod_istat": "017077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 3062,
            "name": "Gavazzana",
            "provincia": "AL",
            "cap": "15063",
            "cod_catastale": "D941",
            "cod_istat": "006080",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 3063,
            "name": "Gavello",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "D942",
            "cod_istat": "029026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 3064,
            "name": "Gaverina Terme",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "D943",
            "cod_istat": "016110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 599,
            "giorni": 2920,
            "area": "",
            "ech": 0
        },
        {
            "id": 3065,
            "name": "Gavi",
            "provincia": "AL",
            "cap": "15066",
            "cod_catastale": "D944",
            "cod_istat": "006081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2678,
            "area": "",
            "ech": 0
        },
        {
            "id": 3066,
            "name": "Gavignano",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "D945",
            "cod_istat": "058041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 1935,
            "area": "",
            "ech": 0
        },
        {
            "id": 3067,
            "name": "Gavirate",
            "provincia": "VA",
            "cap": "21026",
            "cod_catastale": "D946",
            "cod_istat": "012072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2511,
            "area": "",
            "ech": 0
        },
        {
            "id": 3068,
            "name": "Gavoi",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "D947",
            "cod_istat": "091028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 790,
            "giorni": 2022,
            "area": "",
            "ech": 0
        },
        {
            "id": 3069,
            "name": "Gavorrano",
            "provincia": "GR",
            "cap": "58023",
            "cod_catastale": "D948",
            "cod_istat": "053010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 1748,
            "area": "",
            "ech": 0
        },
        {
            "id": 3070,
            "name": "Gazoldo degli Ippoliti",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "D949",
            "cod_istat": "020024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3071,
            "name": "Gazzada Schianno",
            "provincia": "VA",
            "cap": "21045",
            "cod_catastale": "D951",
            "cod_istat": "012073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 3072,
            "name": "Gazzaniga",
            "provincia": "BG",
            "cap": "24025",
            "cod_catastale": "D952",
            "cod_istat": "016111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 3073,
            "name": "Gazzo",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "D956",
            "cod_istat": "028041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 3074,
            "name": "Gazzo Veronese",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "D957",
            "cod_istat": "023037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 3075,
            "name": "Gazzola",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "D958",
            "cod_istat": "033022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 139,
            "giorni": 2635,
            "area": "",
            "ech": 0
        },
        {
            "id": 3076,
            "name": "Gazzuolo",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "D959",
            "cod_istat": "020025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3077,
            "name": "Gela",
            "provincia": "CL",
            "cap": "93012",
            "cod_catastale": "D960",
            "cod_istat": "085007",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 822,
            "area": "",
            "ech": 1
        },
        {
            "id": 3078,
            "name": "Gemmano",
            "provincia": "RN",
            "cap": "47855",
            "cod_catastale": "D961",
            "cod_istat": "099004",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 2675,
            "area": "",
            "ech": 0
        },
        {
            "id": 3079,
            "name": "Gemona del Friuli",
            "provincia": "UD",
            "cap": "33013",
            "cod_catastale": "D962",
            "cod_istat": "030043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2488,
            "area": "",
            "ech": 0
        },
        {
            "id": 3080,
            "name": "Gemonio",
            "provincia": "VA",
            "cap": "21036",
            "cod_catastale": "D963",
            "cod_istat": "012074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2569,
            "area": "",
            "ech": 0
        },
        {
            "id": 3081,
            "name": "Genazzano",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "D964",
            "cod_istat": "058042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 1886,
            "area": "",
            "ech": 0
        },
        {
            "id": 3082,
            "name": "Genga",
            "provincia": "AN",
            "cap": "60040",
            "cod_catastale": "D965",
            "cod_istat": "042020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2195,
            "area": "",
            "ech": 0
        },
        {
            "id": 3083,
            "name": "Genivolta",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "D966",
            "cod_istat": "019047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3084,
            "name": "Genola",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "D967",
            "cod_istat": "004096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 3085,
            "name": "Genoni",
            "provincia": "SU",
            "cap": "09054",
            "cod_catastale": "D968",
            "cod_istat": "111023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 447,
            "giorni": 1478,
            "area": "",
            "ech": 1
        },
        {
            "id": 3086,
            "name": "Genova",
            "provincia": "GE",
            "cap": "161xx",
            "cod_catastale": "D969",
            "cod_istat": "010025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 1435,
            "area": "",
            "ech": 0
        },
        {
            "id": 3087,
            "name": "Genuri",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "D970",
            "cod_istat": "111024",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 230,
            "giorni": 1293,
            "area": "",
            "ech": 0
        },
        {
            "id": 3088,
            "name": "Genzano di Lucania",
            "provincia": "PZ",
            "cap": "85013",
            "cod_catastale": "D971",
            "cod_istat": "076036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 587,
            "giorni": 2015,
            "area": "",
            "ech": 0
        },
        {
            "id": 3089,
            "name": "Genzano di Roma",
            "provincia": "RM",
            "cap": "00045",
            "cod_catastale": "D972",
            "cod_istat": "058043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 435,
            "giorni": 1982,
            "area": "",
            "ech": 0
        },
        {
            "id": 3090,
            "name": "Genzone",
            "provincia": "PV",
            "cap": "27014",
            "cod_catastale": "D973",
            "cod_istat": "018070",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 3091,
            "name": "Gera Lario",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "D974",
            "cod_istat": "013107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3092,
            "name": "Gerace",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "D975",
            "cod_istat": "080036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1699,
            "area": "",
            "ech": 1
        },
        {
            "id": 3093,
            "name": "Geraci Siculo",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "D977",
            "cod_istat": "082037",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1077,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 3094,
            "name": "Gerano",
            "provincia": "RM",
            "cap": "00025",
            "cod_catastale": "D978",
            "cod_istat": "058044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 502,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 3095,
            "name": "Gerenzago",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "D980",
            "cod_istat": "018071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 3096,
            "name": "Gerenzano",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "D981",
            "cod_istat": "012075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2437,
            "area": "",
            "ech": 0
        },
        {
            "id": 3097,
            "name": "Gergei",
            "provincia": "SU",
            "cap": "09055",
            "cod_catastale": "D982",
            "cod_istat": "111025",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 374,
            "giorni": 1357,
            "area": "",
            "ech": 0
        },
        {
            "id": 3098,
            "name": "Germagnano",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "D983",
            "cod_istat": "001113",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 3152,
            "area": "",
            "ech": 0
        },
        {
            "id": 3099,
            "name": "Germagno",
            "provincia": "VB",
            "cap": "28887",
            "cod_catastale": "D984",
            "cod_istat": "103032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 3087,
            "area": "",
            "ech": 0
        },
        {
            "id": 3100,
            "name": "Germignaga",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "D987",
            "cod_istat": "012076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2433,
            "area": "",
            "ech": 0
        },
        {
            "id": 3101,
            "name": "Gerocarne",
            "provincia": "VV",
            "cap": "89831",
            "cod_catastale": "D988",
            "cod_istat": "102016",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 241,
            "giorni": 1160,
            "area": "",
            "ech": 0
        },
        {
            "id": 3102,
            "name": "Gerola Alta",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "D990",
            "cod_istat": "014031",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1050,
            "giorni": 3561,
            "area": "",
            "ech": 0
        },
        {
            "id": 3103,
            "name": "Gerosa",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "D991",
            "cod_istat": "016112",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 3149,
            "area": "",
            "ech": 0
        },
        {
            "id": 3104,
            "name": "Gerre de' Caprioli",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "D993",
            "cod_istat": "019048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3105,
            "name": "Gesico",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "D994",
            "cod_istat": "111026",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1416,
            "area": "",
            "ech": 0
        },
        {
            "id": 3106,
            "name": "Gessate",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "D995",
            "cod_istat": "015106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 3107,
            "name": "Gessopalena",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "D996",
            "cod_istat": "069040",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 644,
            "giorni": 2162,
            "area": "",
            "ech": 0
        },
        {
            "id": 3108,
            "name": "Gesturi",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "D997",
            "cod_istat": "111027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 310,
            "giorni": 1436,
            "area": "",
            "ech": 0
        },
        {
            "id": 3109,
            "name": "Gesualdo",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "D998",
            "cod_istat": "064036",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 676,
            "giorni": 2305,
            "area": "",
            "ech": 0
        },
        {
            "id": 3110,
            "name": "Ghedi",
            "provincia": "BS",
            "cap": "25016",
            "cod_catastale": "D999",
            "cod_istat": "017078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 3111,
            "name": "Ghemme",
            "provincia": "NO",
            "cap": "28074",
            "cod_catastale": "E001",
            "cod_istat": "003073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2473,
            "area": "",
            "ech": 0
        },
        {
            "id": 3112,
            "name": "Ghiffa",
            "provincia": "VB",
            "cap": "28823",
            "cod_catastale": "E003",
            "cod_istat": "103033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 3113,
            "name": "Ghilarza",
            "provincia": "OR",
            "cap": "09074",
            "cod_catastale": "E004",
            "cod_istat": "095021",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 290,
            "giorni": 1348,
            "area": "",
            "ech": 0
        },
        {
            "id": 3114,
            "name": "Ghisalba",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "E006",
            "cod_istat": "016113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3115,
            "name": "Ghislarengo",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "E007",
            "cod_istat": "002062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2572,
            "area": "",
            "ech": 0
        },
        {
            "id": 3116,
            "name": "Giacciano con Baruchella",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "E008",
            "cod_istat": "029027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3117,
            "name": "Giaglione",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "E009",
            "cod_istat": "001114",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 771,
            "giorni": 3510,
            "area": "",
            "ech": 0
        },
        {
            "id": 3118,
            "name": "Gianico",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "E010",
            "cod_istat": "017079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 3119,
            "name": "Giano dell'Umbria",
            "provincia": "PG",
            "cap": "06030",
            "cod_catastale": "E012",
            "cod_istat": "054021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 546,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 3120,
            "name": "Giano Vetusto",
            "provincia": "CE",
            "cap": "81042",
            "cod_catastale": "E011",
            "cod_istat": "061040",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 225,
            "giorni": 1497,
            "area": "",
            "ech": 0
        },
        {
            "id": 3121,
            "name": "Giardinello",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "E013",
            "cod_istat": "082038",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1012,
            "area": "",
            "ech": 1
        },
        {
            "id": 3122,
            "name": "Giardini-Naxos",
            "provincia": "ME",
            "cap": "98035",
            "cod_catastale": "E014",
            "cod_istat": "083032",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 635,
            "area": "",
            "ech": 1
        },
        {
            "id": 3123,
            "name": "Giarole",
            "provincia": "AL",
            "cap": "15036",
            "cod_catastale": "E015",
            "cod_istat": "006082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2564,
            "area": "",
            "ech": 0
        },
        {
            "id": 3124,
            "name": "Giarratana",
            "provincia": "RG",
            "cap": "97010",
            "cod_catastale": "E016",
            "cod_istat": "088004",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1375,
            "area": "",
            "ech": 1
        },
        {
            "id": 3125,
            "name": "Giarre",
            "provincia": "CT",
            "cap": "95014",
            "cod_catastale": "E017",
            "cod_istat": "087017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 935,
            "area": "",
            "ech": 0
        },
        {
            "id": 3126,
            "name": "Giave",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "E019",
            "cod_istat": "090030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 595,
            "giorni": 2047,
            "area": "",
            "ech": 0
        },
        {
            "id": 3127,
            "name": "Giaveno",
            "provincia": "TO",
            "cap": "10094",
            "cod_catastale": "E020",
            "cod_istat": "001115",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 506,
            "giorni": 3113,
            "area": "",
            "ech": 0
        },
        {
            "id": 3128,
            "name": "Giavera del Montello",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "E021",
            "cod_istat": "026032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 3129,
            "name": "Giba",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "E022",
            "cod_istat": "111028",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 833,
            "area": "",
            "ech": 1
        },
        {
            "id": 3130,
            "name": "Gibellina",
            "provincia": "TP",
            "cap": "91024",
            "cod_catastale": "E023",
            "cod_istat": "081010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1263,
            "area": "",
            "ech": 0
        },
        {
            "id": 3131,
            "name": "Gifflenga",
            "provincia": "BI",
            "cap": "13874",
            "cod_catastale": "E024",
            "cod_istat": "096027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2548,
            "area": "",
            "ech": 0
        },
        {
            "id": 3132,
            "name": "Giffone",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "E025",
            "cod_istat": "080037",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 594,
            "giorni": 1896,
            "area": "",
            "ech": 0
        },
        {
            "id": 3133,
            "name": "Giffoni Sei Casali",
            "provincia": "SA",
            "cap": "84090",
            "cod_catastale": "E026",
            "cod_istat": "065055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1396,
            "area": "",
            "ech": 0
        },
        {
            "id": 3134,
            "name": "Giffoni Valle Piana",
            "provincia": "SA",
            "cap": "84095",
            "cod_catastale": "E027",
            "cod_istat": "065056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1294,
            "area": "",
            "ech": 0
        },
        {
            "id": 3135,
            "name": "Gignese",
            "provincia": "VB",
            "cap": "28836",
            "cod_catastale": "E028",
            "cod_istat": "103034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 707,
            "giorni": 3224,
            "area": "",
            "ech": 0
        },
        {
            "id": 3136,
            "name": "Gignod",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "E029",
            "cod_istat": "007030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 988,
            "giorni": 3505,
            "area": "",
            "ech": 0
        },
        {
            "id": 3137,
            "name": "Gildone",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "E030",
            "cod_istat": "070026",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 608,
            "giorni": 2142,
            "area": "",
            "ech": 0
        },
        {
            "id": 3138,
            "name": "Gimigliano",
            "provincia": "CZ",
            "cap": "88045",
            "cod_catastale": "E031",
            "cod_istat": "079058",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1902,
            "area": "",
            "ech": 0
        },
        {
            "id": 3139,
            "name": "Ginestra",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "E033",
            "cod_istat": "076099",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 564,
            "giorni": 1956,
            "area": "",
            "ech": 0
        },
        {
            "id": 3140,
            "name": "Ginestra degli Schiavoni",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "E034",
            "cod_istat": "062036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 2034,
            "area": "",
            "ech": 0
        },
        {
            "id": 3141,
            "name": "Ginosa",
            "provincia": "TA",
            "cap": "74013",
            "cod_catastale": "E036",
            "cod_istat": "073007",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1500,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3142,
            "name": "Gioi",
            "provincia": "SA",
            "cap": "84056",
            "cod_catastale": "E037",
            "cod_istat": "065057",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 680,
            "giorni": 2112,
            "area": "",
            "ech": 0
        },
        {
            "id": 3143,
            "name": "Gioia dei Marsi",
            "provincia": "AQ",
            "cap": "67055",
            "cod_catastale": "E040",
            "cod_istat": "066046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 3144,
            "name": "Gioia del Colle",
            "provincia": "BA",
            "cap": "70023",
            "cod_catastale": "E038",
            "cod_istat": "072021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 360,
            "giorni": 1755,
            "area": "",
            "ech": 0
        },
        {
            "id": 3145,
            "name": "Gioia Sannitica",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "E039",
            "cod_istat": "061041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 275,
            "giorni": 1598,
            "area": "",
            "ech": 0
        },
        {
            "id": 3146,
            "name": "Gioia Tauro",
            "provincia": "RC",
            "cap": "89013",
            "cod_catastale": "E041",
            "cod_istat": "080038",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 715,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3147,
            "name": "Gioiosa Ionica",
            "provincia": "RC",
            "cap": "89042",
            "cod_catastale": "E044",
            "cod_istat": "080039",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1010,
            "area": "",
            "ech": 0
        },
        {
            "id": 3148,
            "name": "Gioiosa Marea",
            "provincia": "ME",
            "cap": "98063",
            "cod_catastale": "E043",
            "cod_istat": "083033",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 678,
            "area": "",
            "ech": 1
        },
        {
            "id": 3149,
            "name": "Giove",
            "provincia": "TR",
            "cap": "05024",
            "cod_catastale": "E045",
            "cod_istat": "055014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 1896,
            "area": "",
            "ech": 0
        },
        {
            "id": 3150,
            "name": "Giovinazzo",
            "provincia": "BA",
            "cap": "70054",
            "cod_catastale": "E047",
            "cod_istat": "072022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1190,
            "area": "",
            "ech": 0
        },
        {
            "id": 3151,
            "name": "Giovo",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "E048",
            "cod_istat": "022092",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 3059,
            "area": "",
            "ech": 0
        },
        {
            "id": 3152,
            "name": "Girasole",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "E049",
            "cod_istat": "091031",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 753,
            "area": "",
            "ech": 1
        },
        {
            "id": 3153,
            "name": "Girifalco",
            "provincia": "CZ",
            "cap": "88024",
            "cod_catastale": "E050",
            "cod_istat": "079059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 456,
            "giorni": 1676,
            "area": "",
            "ech": 0
        },
        {
            "id": 3154,
            "name": "Gironico",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "E051",
            "cod_istat": "013109",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 3155,
            "name": "Gissi",
            "provincia": "CH",
            "cap": "66052",
            "cod_catastale": "E052",
            "cod_istat": "069041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 499,
            "giorni": 1945,
            "area": "",
            "ech": 0
        },
        {
            "id": 3156,
            "name": "Giuggianello",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "E053",
            "cod_istat": "075032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 1225,
            "area": "",
            "ech": 0
        },
        {
            "id": 3157,
            "name": "Giugliano in Campania",
            "provincia": "NA",
            "cap": "80014",
            "cod_catastale": "E054",
            "cod_istat": "063034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1207,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 3158,
            "name": "Giuliana",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "E055",
            "cod_istat": "082039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 1722,
            "area": "",
            "ech": 1
        },
        {
            "id": 3159,
            "name": "Giuliano di Roma",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "E057",
            "cod_istat": "060041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 1822,
            "area": "",
            "ech": 0
        },
        {
            "id": 3160,
            "name": "Giuliano Teatino",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "E056",
            "cod_istat": "069042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 1469,
            "area": "",
            "ech": 0
        },
        {
            "id": 3161,
            "name": "Giulianova",
            "provincia": "TE",
            "cap": "64021",
            "cod_catastale": "E058",
            "cod_istat": "067025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1319,
            "area": "",
            "ech": 0
        },
        {
            "id": 3162,
            "name": "Giuncugnano",
            "provincia": "LU",
            "cap": "55030",
            "cod_catastale": "E059",
            "cod_istat": "046037",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 834,
            "giorni": 3408,
            "area": "",
            "ech": 0
        },
        {
            "id": 3163,
            "name": "Giungano",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E060",
            "cod_istat": "065058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1450,
            "area": "",
            "ech": 0
        },
        {
            "id": 3164,
            "name": "Giurdignano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "E061",
            "cod_istat": "075033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 1190,
            "area": "",
            "ech": 0
        },
        {
            "id": 3165,
            "name": "Giussago",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E062",
            "cod_istat": "018072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3166,
            "name": "Giussano",
            "provincia": "MB",
            "cap": "20833",
            "cod_catastale": "E063",
            "cod_istat": "108024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 3167,
            "name": "Giustenice",
            "provincia": "SV",
            "cap": "17027",
            "cod_catastale": "E064",
            "cod_istat": "009031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1696,
            "area": "",
            "ech": 0
        },
        {
            "id": 3168,
            "name": "Giustino",
            "provincia": "TN",
            "cap": "38086",
            "cod_catastale": "E065",
            "cod_istat": "022093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 770,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 3169,
            "name": "Giusvalla",
            "provincia": "SV",
            "cap": "17010",
            "cod_catastale": "E066",
            "cod_istat": "009032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 3170,
            "name": "Givoletto",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E067",
            "cod_istat": "001116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2951,
            "area": "",
            "ech": 0
        },
        {
            "id": 3171,
            "name": "Gizzeria",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "E068",
            "cod_istat": "079060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2037,
            "area": "",
            "ech": 0
        },
        {
            "id": 3172,
            "name": "Glorenza",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "E069",
            "cod_istat": "021036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 907,
            "giorni": 3765,
            "area": "",
            "ech": 0
        },
        {
            "id": 3173,
            "name": "Godega di Sant'Urbano",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "E071",
            "cod_istat": "026033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 3174,
            "name": "Godiasco Salice Terme",
            "provincia": "PV",
            "cap": "27052",
            "cod_catastale": "E072",
            "cod_istat": "018073",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3175,
            "name": "Godrano",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "E074",
            "cod_istat": "082040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 698,
            "giorni": 1748,
            "area": "",
            "ech": 1
        },
        {
            "id": 3176,
            "name": "Goito",
            "provincia": "MN",
            "cap": "46044",
            "cod_catastale": "E078",
            "cod_istat": "020026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3177,
            "name": "Golasecca",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "E079",
            "cod_istat": "012077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2935,
            "area": "",
            "ech": 0
        },
        {
            "id": 3178,
            "name": "Golferenzo",
            "provincia": "PV",
            "cap": "27047",
            "cod_catastale": "E081",
            "cod_istat": "018074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 464,
            "giorni": 3003,
            "area": "",
            "ech": 0
        },
        {
            "id": 3179,
            "name": "Golfo Aranci",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "M274",
            "cod_istat": "090083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 1150,
            "area": "",
            "ech": 0
        },
        {
            "id": 3180,
            "name": "Gombito",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "E082",
            "cod_istat": "019049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 3181,
            "name": "Gonars",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "E083",
            "cod_istat": "030044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2201,
            "area": "",
            "ech": 0
        },
        {
            "id": 3182,
            "name": "Goni",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "E084",
            "cod_istat": "111029",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 383,
            "giorni": 1283,
            "area": "",
            "ech": 0
        },
        {
            "id": 3183,
            "name": "Gonnesa",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "E086",
            "cod_istat": "111030",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 766,
            "area": "",
            "ech": 0
        },
        {
            "id": 3184,
            "name": "Gonnoscodina",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "E087",
            "cod_istat": "095022",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 112,
            "giorni": 1099,
            "area": "",
            "ech": 0
        },
        {
            "id": 3185,
            "name": "Gonnosfanadiga",
            "provincia": "SU",
            "cap": "09035",
            "cod_catastale": "E085",
            "cod_istat": "111031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 1210,
            "area": "",
            "ech": 0
        },
        {
            "id": 3186,
            "name": "Gonnosnò",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "D585",
            "cod_istat": "095023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 1205,
            "area": "",
            "ech": 0
        },
        {
            "id": 3187,
            "name": "Gonnostramatza",
            "provincia": "OR",
            "cap": "09093",
            "cod_catastale": "E088",
            "cod_istat": "095024",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 96,
            "giorni": 1098,
            "area": "",
            "ech": 0
        },
        {
            "id": 3188,
            "name": "Gonzaga",
            "provincia": "MN",
            "cap": "46023",
            "cod_catastale": "E089",
            "cod_istat": "020027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 3189,
            "name": "Gordona",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "E090",
            "cod_istat": "014032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3190,
            "name": "Gorga",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "E091",
            "cod_istat": "058045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 766,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 3191,
            "name": "Gorgo al Monticano",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "E092",
            "cod_istat": "026034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2354,
            "area": "",
            "ech": 0
        },
        {
            "id": 3192,
            "name": "Gorgoglione",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "E093",
            "cod_istat": "077010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 3193,
            "name": "Gorgonzola",
            "provincia": "MI",
            "cap": "20064",
            "cod_catastale": "E094",
            "cod_istat": "015108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3194,
            "name": "Goriano Sicoli",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "E096",
            "cod_istat": "066047",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 720,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 3195,
            "name": "Gorizia",
            "provincia": "GO",
            "cap": "34170",
            "cod_catastale": "E098",
            "cod_istat": "031007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 3196,
            "name": "Gorla Maggiore",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "E101",
            "cod_istat": "012078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2905,
            "area": "",
            "ech": 0
        },
        {
            "id": 3197,
            "name": "Gorla Minore",
            "provincia": "VA",
            "cap": "21055",
            "cod_catastale": "E102",
            "cod_istat": "012079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2876,
            "area": "",
            "ech": 0
        },
        {
            "id": 3198,
            "name": "Gorlago",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "E100",
            "cod_istat": "016114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 3199,
            "name": "Gorle",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "E103",
            "cod_istat": "016115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2560,
            "area": "",
            "ech": 0
        },
        {
            "id": 3200,
            "name": "Gornate Olona",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "E104",
            "cod_istat": "012080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2562,
            "area": "",
            "ech": 0
        },
        {
            "id": 3201,
            "name": "Gorno",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "E106",
            "cod_istat": "016116",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 3078,
            "area": "",
            "ech": 0
        },
        {
            "id": 3202,
            "name": "Goro",
            "provincia": "FE",
            "cap": "44020",
            "cod_catastale": "E107",
            "cod_istat": "038025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 3203,
            "name": "Gorreto",
            "provincia": "GE",
            "cap": "16020",
            "cod_catastale": "E109",
            "cod_istat": "010026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 533,
            "giorni": 2794,
            "area": "",
            "ech": 0
        },
        {
            "id": 3204,
            "name": "Gorzegno",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "E111",
            "cod_istat": "004097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 3205,
            "name": "Gosaldo",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "E113",
            "cod_istat": "025025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1141,
            "giorni": 4622,
            "area": "",
            "ech": 0
        },
        {
            "id": 3206,
            "name": "Gossolengo",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "E114",
            "cod_istat": "033023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2574,
            "area": "",
            "ech": 0
        },
        {
            "id": 3207,
            "name": "Gottasecca",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "E115",
            "cod_istat": "004098",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 3195,
            "area": "",
            "ech": 0
        },
        {
            "id": 3208,
            "name": "Gottolengo",
            "provincia": "BS",
            "cap": "25023",
            "cod_catastale": "E116",
            "cod_istat": "017080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 3209,
            "name": "Govone",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "E118",
            "cod_istat": "004099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 3210,
            "name": "Gozzano",
            "provincia": "NO",
            "cap": "28024",
            "cod_catastale": "E120",
            "cod_istat": "003076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 367,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 3211,
            "name": "Gradara",
            "provincia": "PU",
            "cap": "61012",
            "cod_catastale": "E122",
            "cod_istat": "041020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2186,
            "area": "",
            "ech": 0
        },
        {
            "id": 3212,
            "name": "Gradisca d'Isonzo",
            "provincia": "GO",
            "cap": "34072",
            "cod_catastale": "E124",
            "cod_istat": "031008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 3213,
            "name": "Grado",
            "provincia": "GO",
            "cap": "34073",
            "cod_catastale": "E125",
            "cod_istat": "031009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2239,
            "area": "",
            "ech": 0
        },
        {
            "id": 3214,
            "name": "Gradoli",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "E126",
            "cod_istat": "056028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 2254,
            "area": "",
            "ech": 0
        },
        {
            "id": 3215,
            "name": "Graffignana",
            "provincia": "LO",
            "cap": "26813",
            "cod_catastale": "E127",
            "cod_istat": "098028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 3216,
            "name": "Graffignano",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "E128",
            "cod_istat": "056029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 1753,
            "area": "",
            "ech": 0
        },
        {
            "id": 3217,
            "name": "Graglia",
            "provincia": "BI",
            "cap": "13895",
            "cod_catastale": "E130",
            "cod_istat": "096028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 596,
            "giorni": 3079,
            "area": "",
            "ech": 0
        },
        {
            "id": 3218,
            "name": "Gragnano",
            "provincia": "NA",
            "cap": "80054",
            "cod_catastale": "E131",
            "cod_istat": "063035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 1235,
            "area": "",
            "ech": 0
        },
        {
            "id": 3219,
            "name": "Gragnano Trebbiense",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "E132",
            "cod_istat": "033024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 3220,
            "name": "Grammichele",
            "provincia": "CT",
            "cap": "95042",
            "cod_catastale": "E133",
            "cod_istat": "087018",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1304,
            "area": "",
            "ech": 1
        },
        {
            "id": 3221,
            "name": "Grana",
            "provincia": "AT",
            "cap": "14031",
            "cod_catastale": "E134",
            "cod_istat": "005056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2725,
            "area": "",
            "ech": 0
        },
        {
            "id": 3222,
            "name": "Granaglione",
            "provincia": "BO",
            "cap": "40045",
            "cod_catastale": "E135",
            "cod_istat": "037029",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 3223,
            "name": "Granarolo dell'Emilia",
            "provincia": "BO",
            "cap": "40057",
            "cod_catastale": "E136",
            "cod_istat": "037030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2162,
            "area": "",
            "ech": 0
        },
        {
            "id": 3224,
            "name": "Grancona",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "E138",
            "cod_istat": "024045",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2297,
            "area": "",
            "ech": 0
        },
        {
            "id": 3225,
            "name": "Grandate",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E139",
            "cod_istat": "013110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2584,
            "area": "",
            "ech": 0
        },
        {
            "id": 3226,
            "name": "Grandola ed Uniti",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "E141",
            "cod_istat": "013111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 443,
            "giorni": 2699,
            "area": "",
            "ech": 0
        },
        {
            "id": 3227,
            "name": "Graniti",
            "provincia": "ME",
            "cap": "98036",
            "cod_catastale": "E142",
            "cod_istat": "083034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1225,
            "area": "",
            "ech": 0
        },
        {
            "id": 3228,
            "name": "Granozzo con Monticello",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "E143",
            "cod_istat": "003077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 3229,
            "name": "Grantola",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "E144",
            "cod_istat": "012081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2632,
            "area": "",
            "ech": 0
        },
        {
            "id": 3230,
            "name": "Grantorto",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "E145",
            "cod_istat": "028042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2401,
            "area": "",
            "ech": 0
        },
        {
            "id": 3231,
            "name": "Granze",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "E146",
            "cod_istat": "028043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3232,
            "name": "Grassano",
            "provincia": "MT",
            "cap": "75014",
            "cod_catastale": "E147",
            "cod_istat": "077011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 576,
            "giorni": 1837,
            "area": "",
            "ech": 0
        },
        {
            "id": 3233,
            "name": "Grassobbio",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "E148",
            "cod_istat": "016117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 3234,
            "name": "Gratteri",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "E149",
            "cod_istat": "082041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 657,
            "giorni": 1734,
            "area": "",
            "ech": 0
        },
        {
            "id": 3235,
            "name": "Grauno",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "E150",
            "cod_istat": "022094",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 976,
            "giorni": 3913,
            "area": "",
            "ech": 0
        },
        {
            "id": 3236,
            "name": "Gravedona ed Uniti",
            "provincia": "CO",
            "cap": "22015",
            "cod_catastale": "M315",
            "cod_istat": "013249",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3237,
            "name": "Gravellona Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "E152",
            "cod_istat": "018075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 3238,
            "name": "Gravellona Toce",
            "provincia": "VB",
            "cap": "28883",
            "cod_catastale": "E153",
            "cod_istat": "103035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 3239,
            "name": "Gravere",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "E154",
            "cod_istat": "001117",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 821,
            "giorni": 3585,
            "area": "",
            "ech": 0
        },
        {
            "id": 3240,
            "name": "Gravina di Catania",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "E156",
            "cod_istat": "087019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 1202,
            "area": "",
            "ech": 1
        },
        {
            "id": 3241,
            "name": "Gravina in Puglia",
            "provincia": "BA",
            "cap": "70024",
            "cod_catastale": "E155",
            "cod_istat": "072023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 338,
            "giorni": 1746,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3242,
            "name": "Grazzanise",
            "provincia": "CE",
            "cap": "81046",
            "cod_catastale": "E158",
            "cod_istat": "061042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1086,
            "area": "",
            "ech": 0
        },
        {
            "id": 3243,
            "name": "Grazzano Badoglio",
            "provincia": "AT",
            "cap": "14035",
            "cod_catastale": "E159",
            "cod_istat": "005057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2733,
            "area": "",
            "ech": 0
        },
        {
            "id": 3244,
            "name": "Greccio",
            "provincia": "RI",
            "cap": "02045",
            "cod_catastale": "E160",
            "cod_istat": "057031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 388,
            "giorni": 2294,
            "area": "",
            "ech": 0
        },
        {
            "id": 3245,
            "name": "Greci",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "E161",
            "cod_istat": "064037",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 821,
            "giorni": 2658,
            "area": "",
            "ech": 0
        },
        {
            "id": 3246,
            "name": "Greggio",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "E163",
            "cod_istat": "002065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 3247,
            "name": "Gremiasco",
            "provincia": "AL",
            "cap": "15056",
            "cod_catastale": "E164",
            "cod_istat": "006083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2905,
            "area": "",
            "ech": 0
        },
        {
            "id": 3248,
            "name": "Gressan",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E165",
            "cod_istat": "007031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 626,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 3249,
            "name": "Gressoney-La-Trinité",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E167",
            "cod_istat": "007032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1624,
            "giorni": 4787,
            "area": "",
            "ech": 0
        },
        {
            "id": 3250,
            "name": "Gressoney-Saint-Jean",
            "provincia": "AO",
            "cap": "11025",
            "cod_catastale": "E168",
            "cod_istat": "007033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1385,
            "giorni": 4726,
            "area": "",
            "ech": 0
        },
        {
            "id": 3251,
            "name": "Greve in Chianti",
            "provincia": "FI",
            "cap": "50022",
            "cod_catastale": "E169",
            "cod_istat": "048021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2126,
            "area": "",
            "ech": 0
        },
        {
            "id": 3252,
            "name": "Grezzago",
            "provincia": "MI",
            "cap": "20056",
            "cod_catastale": "E170",
            "cod_istat": "015110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 3253,
            "name": "Grezzana",
            "provincia": "VR",
            "cap": "37023",
            "cod_catastale": "E171",
            "cod_istat": "023038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 3254,
            "name": "Griante",
            "provincia": "CO",
            "cap": "22011",
            "cod_catastale": "E172",
            "cod_istat": "013113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 3255,
            "name": "Gricignano di Aversa",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "E173",
            "cod_istat": "061043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1097,
            "area": "",
            "ech": 0
        },
        {
            "id": 3256,
            "name": "Grignasco",
            "provincia": "NO",
            "cap": "28075",
            "cod_catastale": "E177",
            "cod_istat": "003079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 3257,
            "name": "Grigno",
            "provincia": "TN",
            "cap": "38055",
            "cod_catastale": "E178",
            "cod_istat": "022095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2801,
            "area": "",
            "ech": 0
        },
        {
            "id": 3258,
            "name": "Grimacco",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "E179",
            "cod_istat": "030045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2788,
            "area": "",
            "ech": 0
        },
        {
            "id": 3259,
            "name": "Grimaldi",
            "provincia": "CS",
            "cap": "87034",
            "cod_catastale": "E180",
            "cod_istat": "078059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2101,
            "area": "",
            "ech": 0
        },
        {
            "id": 3260,
            "name": "Grinzane Cavour",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "E182",
            "cod_istat": "004100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3261,
            "name": "Grisignano di Zocco",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "E184",
            "cod_istat": "024046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 3262,
            "name": "Grisolia",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "E185",
            "cod_istat": "078060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 1735,
            "area": "",
            "ech": 0
        },
        {
            "id": 3263,
            "name": "Grizzana Morandi",
            "provincia": "BO",
            "cap": "40030",
            "cod_catastale": "E187",
            "cod_istat": "037031",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3264,
            "name": "Grognardo",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "E188",
            "cod_istat": "006084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 3265,
            "name": "Gromo",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "E189",
            "cod_istat": "016118",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 676,
            "giorni": 3040,
            "area": "",
            "ech": 0
        },
        {
            "id": 3266,
            "name": "Grondona",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "E191",
            "cod_istat": "006085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 3267,
            "name": "Grone",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "E192",
            "cod_istat": "016119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 388,
            "giorni": 2621,
            "area": "",
            "ech": 0
        },
        {
            "id": 3268,
            "name": "Grontardo",
            "provincia": "CR",
            "cap": "26044",
            "cod_catastale": "E193",
            "cod_istat": "019050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3269,
            "name": "Gropello Cairoli",
            "provincia": "PV",
            "cap": "27027",
            "cod_catastale": "E195",
            "cod_istat": "018076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3270,
            "name": "Gropparello",
            "provincia": "PC",
            "cap": "29025",
            "cod_catastale": "E196",
            "cod_istat": "033025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 2911,
            "area": "",
            "ech": 0
        },
        {
            "id": 3271,
            "name": "Groscavallo",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "E199",
            "cod_istat": "001118",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1110,
            "giorni": 4019,
            "area": "",
            "ech": 0
        },
        {
            "id": 3272,
            "name": "Grosio",
            "provincia": "SO",
            "cap": "23033",
            "cod_catastale": "E200",
            "cod_istat": "014033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 656,
            "giorni": 3001,
            "area": "",
            "ech": 0
        },
        {
            "id": 3273,
            "name": "Grosotto",
            "provincia": "SO",
            "cap": "23034",
            "cod_catastale": "E201",
            "cod_istat": "014034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 3054,
            "area": "",
            "ech": 0
        },
        {
            "id": 3274,
            "name": "Grosseto",
            "provincia": "GR",
            "cap": "58100",
            "cod_catastale": "E202",
            "cod_istat": "053011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1550,
            "area": "CNOR",
            "ech": 0
        },
        {
            "id": 3275,
            "name": "Grosso",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "E203",
            "cod_istat": "001119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2945,
            "area": "",
            "ech": 0
        },
        {
            "id": 3276,
            "name": "Grottaferrata",
            "provincia": "RM",
            "cap": "00046",
            "cod_catastale": "E204",
            "cod_istat": "058046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1801,
            "area": "",
            "ech": 0
        },
        {
            "id": 3277,
            "name": "Grottaglie",
            "provincia": "TA",
            "cap": "74023",
            "cod_catastale": "E205",
            "cod_istat": "073008",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1263,
            "area": "",
            "ech": 0
        },
        {
            "id": 3278,
            "name": "Grottaminarda",
            "provincia": "AV",
            "cap": "83035",
            "cod_catastale": "E206",
            "cod_istat": "064038",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 405,
            "giorni": 1950,
            "area": "",
            "ech": 0
        },
        {
            "id": 3279,
            "name": "Grottammare",
            "provincia": "AP",
            "cap": "63066",
            "cod_catastale": "E207",
            "cod_istat": "044023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1591,
            "area": "",
            "ech": 0
        },
        {
            "id": 3280,
            "name": "Grottazzolina",
            "provincia": "FM",
            "cap": "63844",
            "cod_catastale": "E208",
            "cod_istat": "109008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1986,
            "area": "",
            "ech": 0
        },
        {
            "id": 3281,
            "name": "Grotte",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "E209",
            "cod_istat": "084018",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 516,
            "giorni": 1314,
            "area": "",
            "ech": 0
        },
        {
            "id": 3282,
            "name": "Grotte di Castro",
            "provincia": "VT",
            "cap": "01025",
            "cod_catastale": "E210",
            "cod_istat": "056030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 467,
            "giorni": 2249,
            "area": "",
            "ech": 0
        },
        {
            "id": 3283,
            "name": "Grotteria",
            "provincia": "RC",
            "cap": "89043",
            "cod_catastale": "E212",
            "cod_istat": "080040",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 317,
            "giorni": 1317,
            "area": "",
            "ech": 1
        },
        {
            "id": 3284,
            "name": "Grottole",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "E213",
            "cod_istat": "077012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 482,
            "giorni": 1787,
            "area": "",
            "ech": 0
        },
        {
            "id": 3285,
            "name": "Grottolella",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "E214",
            "cod_istat": "064039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 565,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 3286,
            "name": "Gruaro",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "E215",
            "cod_istat": "027018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 3287,
            "name": "Grugliasco",
            "provincia": "TO",
            "cap": "10095",
            "cod_catastale": "E216",
            "cod_istat": "001120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 3288,
            "name": "Grumello Cremonese ed Uniti",
            "provincia": "CR",
            "cap": "26023",
            "cod_catastale": "E217",
            "cod_istat": "019051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3289,
            "name": "Grumello del Monte",
            "provincia": "BG",
            "cap": "24064",
            "cod_catastale": "E219",
            "cod_istat": "016120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 3290,
            "name": "Grumento Nova",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "E221",
            "cod_istat": "076037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 771,
            "giorni": 2311,
            "area": "",
            "ech": 0
        },
        {
            "id": 3291,
            "name": "Grumes",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "E222",
            "cod_istat": "022096",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 851,
            "giorni": 3718,
            "area": "",
            "ech": 0
        },
        {
            "id": 3292,
            "name": "Grumo Appula",
            "provincia": "BA",
            "cap": "70025",
            "cod_catastale": "E223",
            "cod_istat": "072024",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 181,
            "giorni": 1441,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3293,
            "name": "Grumo Nevano",
            "provincia": "NA",
            "cap": "80028",
            "cod_catastale": "E224",
            "cod_istat": "063036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 1023,
            "area": "",
            "ech": 0
        },
        {
            "id": 3294,
            "name": "Grumolo delle Abbadesse",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "E226",
            "cod_istat": "024047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2317,
            "area": "",
            "ech": 0
        },
        {
            "id": 3295,
            "name": "Guagnano",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "E227",
            "cod_istat": "075034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 1133,
            "area": "",
            "ech": 0
        },
        {
            "id": 3296,
            "name": "Gualdo",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "E228",
            "cod_istat": "043021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 652,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 3297,
            "name": "Gualdo Cattaneo",
            "provincia": "PG",
            "cap": "06035",
            "cod_catastale": "E229",
            "cod_istat": "054022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 446,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 3298,
            "name": "Gualdo Tadino",
            "provincia": "PG",
            "cap": "06023",
            "cod_catastale": "E230",
            "cod_istat": "054023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 536,
            "giorni": 2334,
            "area": "",
            "ech": 0
        },
        {
            "id": 3299,
            "name": "Gualtieri",
            "provincia": "RE",
            "cap": "42044",
            "cod_catastale": "E232",
            "cod_istat": "035023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 3300,
            "name": "Gualtieri Sicaminò",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "E233",
            "cod_istat": "083035",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 763,
            "area": "",
            "ech": 1
        },
        {
            "id": 3301,
            "name": "Guamaggiore",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "E234",
            "cod_istat": "111032",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 199,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 3302,
            "name": "Guanzate",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E235",
            "cod_istat": "013114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2615,
            "area": "",
            "ech": 0
        },
        {
            "id": 3303,
            "name": "Guarcino",
            "provincia": "FR",
            "cap": "03016",
            "cod_catastale": "E236",
            "cod_istat": "060042",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 3304,
            "name": "Guarda Veneta",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "E240",
            "cod_istat": "029028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 3305,
            "name": "Guardabosone",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "E237",
            "cod_istat": "002066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 2927,
            "area": "",
            "ech": 0
        },
        {
            "id": 3306,
            "name": "Guardamiglio",
            "provincia": "LO",
            "cap": "26862",
            "cod_catastale": "E238",
            "cod_istat": "098029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 3307,
            "name": "Guardavalle",
            "provincia": "CZ",
            "cap": "88065",
            "cod_catastale": "E239",
            "cod_istat": "079061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1222,
            "area": "",
            "ech": 1
        },
        {
            "id": 3308,
            "name": "Guardea",
            "provincia": "TR",
            "cap": "05025",
            "cod_catastale": "E241",
            "cod_istat": "055015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 387,
            "giorni": 2069,
            "area": "",
            "ech": 0
        },
        {
            "id": 3309,
            "name": "Guardia Lombardi",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "E245",
            "cod_istat": "064040",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 998,
            "giorni": 2686,
            "area": "",
            "ech": 0
        },
        {
            "id": 3310,
            "name": "Guardia Perticara",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "E246",
            "cod_istat": "076038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 3311,
            "name": "Guardia Piemontese",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "E242",
            "cod_istat": "078061",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 1949,
            "area": "",
            "ech": 0
        },
        {
            "id": 3312,
            "name": "Guardia Sanframondi",
            "provincia": "BN",
            "cap": "82034",
            "cod_catastale": "E249",
            "cod_istat": "062037",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 428,
            "giorni": 1849,
            "area": "",
            "ech": 0
        },
        {
            "id": 3313,
            "name": "Guardiagrele",
            "provincia": "CH",
            "cap": "66016",
            "cod_catastale": "E243",
            "cod_istat": "069043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 576,
            "giorni": 1928,
            "area": "",
            "ech": 0
        },
        {
            "id": 3314,
            "name": "Guardialfiera",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "E244",
            "cod_istat": "070027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 1680,
            "area": "",
            "ech": 0
        },
        {
            "id": 3315,
            "name": "Guardiaregia",
            "provincia": "CB",
            "cap": "86014",
            "cod_catastale": "E248",
            "cod_istat": "070028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 3316,
            "name": "Guardistallo",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "E250",
            "cod_istat": "050015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 1927,
            "area": "",
            "ech": 0
        },
        {
            "id": 3317,
            "name": "Guarene",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "E251",
            "cod_istat": "004101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2615,
            "area": "",
            "ech": 0
        },
        {
            "id": 3318,
            "name": "Guasila",
            "provincia": "CA",
            "cap": "09040",
            "cod_catastale": "E252",
            "cod_istat": "111033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 1292,
            "area": "",
            "ech": 1
        },
        {
            "id": 3319,
            "name": "Guastalla",
            "provincia": "RE",
            "cap": "42016",
            "cod_catastale": "E253",
            "cod_istat": "035024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2438,
            "area": "",
            "ech": 0
        },
        {
            "id": 3320,
            "name": "Guazzora",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "E255",
            "cod_istat": "006086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2548,
            "area": "",
            "ech": 0
        },
        {
            "id": 3321,
            "name": "Gubbio",
            "provincia": "PG",
            "cap": "06024",
            "cod_catastale": "E256",
            "cod_istat": "054024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 522,
            "giorni": 2357,
            "area": "",
            "ech": 0
        },
        {
            "id": 3322,
            "name": "Gudo Visconti",
            "provincia": "MI",
            "cap": "20088",
            "cod_catastale": "E258",
            "cod_istat": "015112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 3323,
            "name": "Guglionesi",
            "provincia": "CB",
            "cap": "86034",
            "cod_catastale": "E259",
            "cod_istat": "070029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 3324,
            "name": "Guidizzolo",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "E261",
            "cod_istat": "020028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 3325,
            "name": "Guidonia Montecelio",
            "provincia": "RM",
            "cap": "00012",
            "cod_catastale": "E263",
            "cod_istat": "058047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1561,
            "area": "",
            "ech": 0
        },
        {
            "id": 3326,
            "name": "Guiglia",
            "provincia": "MO",
            "cap": "41052",
            "cod_catastale": "E264",
            "cod_istat": "036017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 2877,
            "area": "",
            "ech": 0
        },
        {
            "id": 3327,
            "name": "Guilmi",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "E266",
            "cod_istat": "069044",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 674,
            "giorni": 2207,
            "area": "",
            "ech": 0
        },
        {
            "id": 3328,
            "name": "Gurro",
            "provincia": "VB",
            "cap": "28828",
            "cod_catastale": "E269",
            "cod_istat": "103036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 812,
            "giorni": 3360,
            "area": "",
            "ech": 0
        },
        {
            "id": 3329,
            "name": "Guspini",
            "provincia": "SU",
            "cap": "09036",
            "cod_catastale": "E270",
            "cod_istat": "111034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1130,
            "area": "",
            "ech": 0
        },
        {
            "id": 3330,
            "name": "Gussago",
            "provincia": "BS",
            "cap": "25064",
            "cod_catastale": "E271",
            "cod_istat": "017081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3331,
            "name": "Gussola",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "E272",
            "cod_istat": "019052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3332,
            "name": "Hône",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E273",
            "cod_istat": "007034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 3333,
            "name": "Idro",
            "provincia": "BS",
            "cap": "25074",
            "cod_catastale": "E280",
            "cod_istat": "017082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2746,
            "area": "",
            "ech": 0
        },
        {
            "id": 3334,
            "name": "Iglesias",
            "provincia": "SU",
            "cap": "09016",
            "cod_catastale": "E281",
            "cod_istat": "111035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 916,
            "area": "",
            "ech": 0
        },
        {
            "id": 3335,
            "name": "Igliano",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "E282",
            "cod_istat": "004102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 532,
            "giorni": 2975,
            "area": "",
            "ech": 0
        },
        {
            "id": 3336,
            "name": "Ilbono",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "E283",
            "cod_istat": "091032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1400,
            "area": "",
            "ech": 1
        },
        {
            "id": 3337,
            "name": "Illasi",
            "provincia": "VR",
            "cap": "37031",
            "cod_catastale": "E284",
            "cod_istat": "023039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 3338,
            "name": "Illorai",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "E285",
            "cod_istat": "090031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 515,
            "giorni": 1872,
            "area": "",
            "ech": 0
        },
        {
            "id": 3339,
            "name": "Imbersago",
            "provincia": "LC",
            "cap": "23898",
            "cod_catastale": "E287",
            "cod_istat": "097039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 3340,
            "name": "Imer",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "E288",
            "cod_istat": "022097",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 670,
            "giorni": 3436,
            "area": "",
            "ech": 0
        },
        {
            "id": 3341,
            "name": "Imola",
            "provincia": "BO",
            "cap": "40026",
            "cod_catastale": "E289",
            "cod_istat": "037032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2292,
            "area": "",
            "ech": 0
        },
        {
            "id": 3342,
            "name": "Imperia",
            "provincia": "IM",
            "cap": "18100",
            "cod_catastale": "E290",
            "cod_istat": "008031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1201,
            "area": "",
            "ech": 0
        },
        {
            "id": 3343,
            "name": "Impruneta",
            "provincia": "FI",
            "cap": "50023",
            "cod_catastale": "E291",
            "cod_istat": "048022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2186,
            "area": "",
            "ech": 0
        },
        {
            "id": 3344,
            "name": "Inarzo",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "E292",
            "cod_istat": "012082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2485,
            "area": "",
            "ech": 0
        },
        {
            "id": 3345,
            "name": "Incisa in Val d'Arno",
            "provincia": "FI",
            "cap": "50064",
            "cod_catastale": "E296",
            "cod_istat": "048052",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 1950,
            "area": "",
            "ech": 0
        },
        {
            "id": 3346,
            "name": "Incisa Scapaccino",
            "provincia": "AT",
            "cap": "14045",
            "cod_catastale": "E295",
            "cod_istat": "005058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2518,
            "area": "",
            "ech": 0
        },
        {
            "id": 3347,
            "name": "Incudine",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "E297",
            "cod_istat": "017083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 910,
            "giorni": 3511,
            "area": "",
            "ech": 0
        },
        {
            "id": 3348,
            "name": "Induno Olona",
            "provincia": "VA",
            "cap": "21056",
            "cod_catastale": "E299",
            "cod_istat": "012083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2669,
            "area": "",
            "ech": 0
        },
        {
            "id": 3349,
            "name": "Ingria",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "E301",
            "cod_istat": "001121",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 816,
            "giorni": 3497,
            "area": "",
            "ech": 0
        },
        {
            "id": 3350,
            "name": "Intragna",
            "provincia": "VB",
            "cap": "28816",
            "cod_catastale": "E304",
            "cod_istat": "103037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 729,
            "giorni": 3252,
            "area": "",
            "ech": 0
        },
        {
            "id": 3351,
            "name": "Introbio",
            "provincia": "LC",
            "cap": "23815",
            "cod_catastale": "E305",
            "cod_istat": "097040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 586,
            "giorni": 2902,
            "area": "",
            "ech": 0
        },
        {
            "id": 3352,
            "name": "Introd",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "E306",
            "cod_istat": "007035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 869,
            "giorni": 3472,
            "area": "",
            "ech": 0
        },
        {
            "id": 3353,
            "name": "Introdacqua",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "E307",
            "cod_istat": "066048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 642,
            "giorni": 2438,
            "area": "",
            "ech": 0
        },
        {
            "id": 3354,
            "name": "Introzzo",
            "provincia": "LC",
            "cap": "23835",
            "cod_catastale": "E308",
            "cod_istat": "097041",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 704,
            "giorni": 3069,
            "area": "",
            "ech": 0
        },
        {
            "id": 3355,
            "name": "Inverigo",
            "provincia": "CO",
            "cap": "22044",
            "cod_catastale": "E309",
            "cod_istat": "013118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 2561,
            "area": "",
            "ech": 0
        },
        {
            "id": 3356,
            "name": "Inverno e Monteleone",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E310",
            "cod_istat": "018077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3357,
            "name": "Inverso Pinasca",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "E311",
            "cod_istat": "001122",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 3194,
            "area": "",
            "ech": 0
        },
        {
            "id": 3358,
            "name": "Inveruno",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "E313",
            "cod_istat": "015113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2609,
            "area": "",
            "ech": 0
        },
        {
            "id": 3359,
            "name": "Invorio",
            "provincia": "NO",
            "cap": "28045",
            "cod_catastale": "E314",
            "cod_istat": "003082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 2816,
            "area": "",
            "ech": 0
        },
        {
            "id": 3360,
            "name": "Inzago",
            "provincia": "MI",
            "cap": "20065",
            "cod_catastale": "E317",
            "cod_istat": "015114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 3361,
            "name": "Ionadi",
            "provincia": "VV",
            "cap": "89851",
            "cod_catastale": "E321",
            "cod_istat": "102017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1652,
            "area": "",
            "ech": 0
        },
        {
            "id": 3362,
            "name": "Irgoli",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "E323",
            "cod_istat": "091033",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 26,
            "giorni": 899,
            "area": "",
            "ech": 1
        },
        {
            "id": 3363,
            "name": "Irma",
            "provincia": "BS",
            "cap": "25061",
            "cod_catastale": "E325",
            "cod_istat": "017084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 804,
            "giorni": 3360,
            "area": "",
            "ech": 0
        },
        {
            "id": 3364,
            "name": "Irsina",
            "provincia": "MT",
            "cap": "75022",
            "cod_catastale": "E326",
            "cod_istat": "077013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 548,
            "giorni": 1885,
            "area": "",
            "ech": 0
        },
        {
            "id": 3365,
            "name": "Isasca",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "E327",
            "cod_istat": "004103",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 3133,
            "area": "",
            "ech": 0
        },
        {
            "id": 3366,
            "name": "Isca sullo Ionio",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "E328",
            "cod_istat": "079063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 188,
            "giorni": 1144,
            "area": "",
            "ech": 0
        },
        {
            "id": 3367,
            "name": "Ischia",
            "provincia": "NA",
            "cap": "80077",
            "cod_catastale": "E329",
            "cod_istat": "063037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1044,
            "area": "",
            "ech": 0
        },
        {
            "id": 3368,
            "name": "Ischia di Castro",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "E330",
            "cod_istat": "056031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 384,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 3369,
            "name": "Ischitella",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "E332",
            "cod_istat": "071025",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 310,
            "giorni": 1766,
            "area": "",
            "ech": 0
        },
        {
            "id": 3370,
            "name": "Iseo",
            "provincia": "BS",
            "cap": "25049",
            "cod_catastale": "E333",
            "cod_istat": "017085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3371,
            "name": "Isera",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "E334",
            "cod_istat": "022098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2773,
            "area": "",
            "ech": 0
        },
        {
            "id": 3372,
            "name": "Isernia",
            "provincia": "IS",
            "cap": "86170",
            "cod_catastale": "E335",
            "cod_istat": "094023",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 423,
            "giorni": 1866,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3373,
            "name": "Isili",
            "provincia": "SU",
            "cap": "09056",
            "cod_catastale": "E336",
            "cod_istat": "111036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 523,
            "giorni": 1741,
            "area": "",
            "ech": 0
        },
        {
            "id": 3374,
            "name": "Isnello",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "E337",
            "cod_istat": "082042",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 1504,
            "area": "",
            "ech": 0
        },
        {
            "id": 3375,
            "name": "Isola d'Asti",
            "provincia": "AT",
            "cap": "14057",
            "cod_catastale": "E338",
            "cod_istat": "005059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3376,
            "name": "Isola del Cantone",
            "provincia": "GE",
            "cap": "16017",
            "cod_catastale": "E341",
            "cod_istat": "010027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 298,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 3377,
            "name": "Isola del Giglio",
            "provincia": "GR",
            "cap": "58012",
            "cod_catastale": "E348",
            "cod_istat": "053012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2084,
            "area": "",
            "ech": 0
        },
        {
            "id": 3378,
            "name": "Isola del Gran Sasso d'Italia",
            "provincia": "TE",
            "cap": "64045",
            "cod_catastale": "E343",
            "cod_istat": "067026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 2038,
            "area": "",
            "ech": 0
        },
        {
            "id": 3379,
            "name": "Isola del Liri",
            "provincia": "FR",
            "cap": "03036",
            "cod_catastale": "E340",
            "cod_istat": "060043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 1916,
            "area": "",
            "ech": 0
        },
        {
            "id": 3380,
            "name": "Isola del Piano",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "E351",
            "cod_istat": "041021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 3381,
            "name": "Isola della Scala",
            "provincia": "VR",
            "cap": "37063",
            "cod_catastale": "E349",
            "cod_istat": "023040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 3382,
            "name": "Isola delle Femmine",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "E350",
            "cod_istat": "082043",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 631,
            "area": "",
            "ech": 1
        },
        {
            "id": 3383,
            "name": "Isola di Capo Rizzuto",
            "provincia": "KR",
            "cap": "88841",
            "cod_catastale": "E339",
            "cod_istat": "101013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 991,
            "area": "",
            "ech": 0
        },
        {
            "id": 3384,
            "name": "Isola di Fondra",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "E353",
            "cod_istat": "016121",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 799,
            "giorni": 3204,
            "area": "",
            "ech": 0
        },
        {
            "id": 3385,
            "name": "Isola Dovarese",
            "provincia": "CR",
            "cap": "26031",
            "cod_catastale": "E356",
            "cod_istat": "019053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3386,
            "name": "Isola Rizza",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "E358",
            "cod_istat": "023041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 3387,
            "name": "Isola Sant'Antonio",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "E360",
            "cod_istat": "006087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2546,
            "area": "",
            "ech": 0
        },
        {
            "id": 3388,
            "name": "Isola Vicentina",
            "provincia": "VI",
            "cap": "36033",
            "cod_catastale": "E354",
            "cod_istat": "024048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 3389,
            "name": "Isolabella",
            "provincia": "TO",
            "cap": "10046",
            "cod_catastale": "E345",
            "cod_istat": "001123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 3390,
            "name": "Isolabona",
            "provincia": "IM",
            "cap": "18035",
            "cod_catastale": "E346",
            "cod_istat": "008032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 1502,
            "area": "",
            "ech": 0
        },
        {
            "id": 3391,
            "name": "Isole Tremiti",
            "provincia": "FG",
            "cap": "71051",
            "cod_catastale": "E363",
            "cod_istat": "071026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 953,
            "area": "",
            "ech": 0
        },
        {
            "id": 3392,
            "name": "Isorella",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "E364",
            "cod_istat": "017086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 3393,
            "name": "Ispani",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E365",
            "cod_istat": "065059",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 256,
            "giorni": 1364,
            "area": "",
            "ech": 0
        },
        {
            "id": 3394,
            "name": "Ispica",
            "provincia": "RG",
            "cap": "97014",
            "cod_catastale": "E366",
            "cod_istat": "088005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 972,
            "area": "",
            "ech": 1
        },
        {
            "id": 3395,
            "name": "Ispra",
            "provincia": "VA",
            "cap": "21027",
            "cod_catastale": "E367",
            "cod_istat": "012084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2454,
            "area": "",
            "ech": 0
        },
        {
            "id": 3396,
            "name": "Issiglio",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "E368",
            "cod_istat": "001124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 2921,
            "area": "",
            "ech": 0
        },
        {
            "id": 3397,
            "name": "Issime",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E369",
            "cod_istat": "007036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 3672,
            "area": "",
            "ech": 0
        },
        {
            "id": 3398,
            "name": "Isso",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "E370",
            "cod_istat": "016122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2189,
            "area": "",
            "ech": 0
        },
        {
            "id": 3399,
            "name": "Issogne",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E371",
            "cod_istat": "007037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 387,
            "giorni": 2786,
            "area": "",
            "ech": 0
        },
        {
            "id": 3400,
            "name": "Istrana",
            "provincia": "TV",
            "cap": "31036",
            "cod_catastale": "E373",
            "cod_istat": "026035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2405,
            "area": "",
            "ech": 0
        },
        {
            "id": 3401,
            "name": "Itala",
            "provincia": "ME",
            "cap": "98025",
            "cod_catastale": "E374",
            "cod_istat": "083036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 985,
            "area": "",
            "ech": 0
        },
        {
            "id": 3402,
            "name": "Itri",
            "provincia": "LT",
            "cap": "04020",
            "cod_catastale": "E375",
            "cod_istat": "059010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 1387,
            "area": "",
            "ech": 0
        },
        {
            "id": 3403,
            "name": "Ittireddu",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "E376",
            "cod_istat": "090032",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 313,
            "giorni": 1511,
            "area": "",
            "ech": 0
        },
        {
            "id": 3404,
            "name": "Ittiri",
            "provincia": "SS",
            "cap": "07044",
            "cod_catastale": "E377",
            "cod_istat": "090033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1676,
            "area": "",
            "ech": 0
        },
        {
            "id": 3405,
            "name": "Ivano-Fracena",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "E378",
            "cod_istat": "022099",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 452,
            "giorni": 3096,
            "area": "",
            "ech": 0
        },
        {
            "id": 3406,
            "name": "Ivrea",
            "provincia": "TO",
            "cap": "10015",
            "cod_catastale": "E379",
            "cod_istat": "001125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2737,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3407,
            "name": "Izano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "E380",
            "cod_istat": "019054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 3408,
            "name": "Jacurso",
            "provincia": "CZ",
            "cap": "88020",
            "cod_catastale": "E274",
            "cod_istat": "079065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 1680,
            "area": "",
            "ech": 0
        },
        {
            "id": 3409,
            "name": "Jelsi",
            "provincia": "CB",
            "cap": "86015",
            "cod_catastale": "E381",
            "cod_istat": "070030",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 580,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 3410,
            "name": "Jenne",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "E382",
            "cod_istat": "058048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 834,
            "giorni": 2788,
            "area": "",
            "ech": 0
        },
        {
            "id": 3411,
            "name": "Jerago con Orago",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "E386",
            "cod_istat": "012085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 324,
            "giorni": 2591,
            "area": "",
            "ech": 0
        },
        {
            "id": 3412,
            "name": "Jerzu",
            "provincia": "NU",
            "cap": "08044",
            "cod_catastale": "E387",
            "cod_istat": "091035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 427,
            "giorni": 1467,
            "area": "",
            "ech": 0
        },
        {
            "id": 3413,
            "name": "Jesi",
            "provincia": "AN",
            "cap": "60035",
            "cod_catastale": "E388",
            "cod_istat": "042021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 3414,
            "name": "Jesolo",
            "provincia": "VE",
            "cap": "30016",
            "cod_catastale": "C388",
            "cod_istat": "027019",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3415,
            "name": "Jolanda di Savoia",
            "provincia": "FE",
            "cap": "44037",
            "cod_catastale": "E320",
            "cod_istat": "038010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": -1,
            "giorni": 2267,
            "area": "",
            "ech": 0
        },
        {
            "id": 3416,
            "name": "Joppolo",
            "provincia": "VV",
            "cap": "89863",
            "cod_catastale": "E389",
            "cod_istat": "102018",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 177,
            "giorni": 1105,
            "area": "",
            "ech": 0
        },
        {
            "id": 3417,
            "name": "Joppolo Giancaxio",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "E390",
            "cod_istat": "084019",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 275,
            "giorni": 970,
            "area": "",
            "ech": 0
        },
        {
            "id": 3418,
            "name": "Jovençan",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E391",
            "cod_istat": "007038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 632,
            "giorni": 2925,
            "area": "",
            "ech": 0
        },
        {
            "id": 3419,
            "name": "La Cassa",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E394",
            "cod_istat": "001126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 374,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 3420,
            "name": "La Loggia",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E423",
            "cod_istat": "001127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 3421,
            "name": "La Maddalena",
            "provincia": "SS",
            "cap": "07024",
            "cod_catastale": "E425",
            "cod_istat": "090035",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 864,
            "area": "",
            "ech": 0
        },
        {
            "id": 3422,
            "name": "La Magdeleine",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "A308",
            "cod_istat": "007039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1644,
            "giorni": 4698,
            "area": "",
            "ech": 0
        },
        {
            "id": 3423,
            "name": "La Morra",
            "provincia": "CN",
            "cap": "12064",
            "cod_catastale": "E430",
            "cod_istat": "004105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 513,
            "giorni": 2951,
            "area": "",
            "ech": 0
        },
        {
            "id": 3424,
            "name": "La Salle",
            "provincia": "AO",
            "cap": "11015",
            "cod_catastale": "E458",
            "cod_istat": "007040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1001,
            "giorni": 3734,
            "area": "",
            "ech": 0
        },
        {
            "id": 3425,
            "name": "La Spezia",
            "provincia": "SP",
            "cap": "191xx",
            "cod_catastale": "E463",
            "cod_istat": "011015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1413,
            "area": "",
            "ech": 0
        },
        {
            "id": 3426,
            "name": "La Thuile",
            "provincia": "AO",
            "cap": "11016",
            "cod_catastale": "E470",
            "cod_istat": "007041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1441,
            "giorni": 4394,
            "area": "",
            "ech": 0
        },
        {
            "id": 3427,
            "name": "La Valle",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "E491",
            "cod_istat": "021117",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1353,
            "giorni": 4649,
            "area": "",
            "ech": 0
        },
        {
            "id": 3428,
            "name": "La Valle Agordina",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "E490",
            "cod_istat": "025027",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3848,
            "area": "",
            "ech": 0
        },
        {
            "id": 3429,
            "name": "Labico",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "E392",
            "cod_istat": "058049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 1791,
            "area": "",
            "ech": 0
        },
        {
            "id": 3430,
            "name": "Labro",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "E393",
            "cod_istat": "057032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 628,
            "giorni": 2508,
            "area": "",
            "ech": 0
        },
        {
            "id": 3431,
            "name": "Lacchiarella",
            "provincia": "MI",
            "cap": "20084",
            "cod_catastale": "E395",
            "cod_istat": "015115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 3432,
            "name": "Lacco Ameno",
            "provincia": "NA",
            "cap": "80076",
            "cod_catastale": "E396",
            "cod_istat": "063038",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1041,
            "area": "",
            "ech": 0
        },
        {
            "id": 3433,
            "name": "Lacedonia",
            "provincia": "AV",
            "cap": "83046",
            "cod_catastale": "E397",
            "cod_istat": "064041",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 732,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 3434,
            "name": "Laces",
            "provincia": "BZ",
            "cap": "39021",
            "cod_catastale": "E398",
            "cod_istat": "021037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 639,
            "giorni": 3443,
            "area": "",
            "ech": 0
        },
        {
            "id": 3435,
            "name": "Laconi",
            "provincia": "OR",
            "cap": "08034",
            "cod_catastale": "E400",
            "cod_istat": "095082",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 3436,
            "name": "Ladispoli",
            "provincia": "RM",
            "cap": "00055",
            "cod_catastale": "M212",
            "cod_istat": "058116",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1295,
            "area": "",
            "ech": 0
        },
        {
            "id": 3437,
            "name": "Laerru",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "E401",
            "cod_istat": "090034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 1249,
            "area": "",
            "ech": 0
        },
        {
            "id": 3438,
            "name": "Laganadi",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "E402",
            "cod_istat": "080041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 499,
            "giorni": 1639,
            "area": "",
            "ech": 1
        },
        {
            "id": 3439,
            "name": "Laghi",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "E403",
            "cod_istat": "024049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 3173,
            "area": "",
            "ech": 0
        },
        {
            "id": 3440,
            "name": "Laglio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "E405",
            "cod_istat": "013119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2230,
            "area": "",
            "ech": 0
        },
        {
            "id": 3441,
            "name": "Lagnasco",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "E406",
            "cod_istat": "004104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 2804,
            "area": "",
            "ech": 0
        },
        {
            "id": 3442,
            "name": "Lago",
            "provincia": "CS",
            "cap": "87035",
            "cod_catastale": "E407",
            "cod_istat": "078062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 1787,
            "area": "",
            "ech": 0
        },
        {
            "id": 3443,
            "name": "Lagonegro",
            "provincia": "PZ",
            "cap": "85042",
            "cod_catastale": "E409",
            "cod_istat": "076039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 666,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 3444,
            "name": "Lagosanto",
            "provincia": "FE",
            "cap": "44023",
            "cod_catastale": "E410",
            "cod_istat": "038011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 0,
            "giorni": 2268,
            "area": "",
            "ech": 0
        },
        {
            "id": 3445,
            "name": "Lagundo",
            "provincia": "BZ",
            "cap": "39022",
            "cod_catastale": "E412",
            "cod_istat": "021038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2911,
            "area": "",
            "ech": 0
        },
        {
            "id": 3446,
            "name": "Laigueglia",
            "provincia": "SV",
            "cap": "17053",
            "cod_catastale": "E414",
            "cod_istat": "009033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1206,
            "area": "",
            "ech": 0
        },
        {
            "id": 3447,
            "name": "Lainate",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "E415",
            "cod_istat": "015116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 3448,
            "name": "Laino",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "E416",
            "cod_istat": "013120",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 671,
            "giorni": 3022,
            "area": "",
            "ech": 0
        },
        {
            "id": 3449,
            "name": "Laino Borgo",
            "provincia": "CS",
            "cap": "87014",
            "cod_catastale": "E417",
            "cod_istat": "078063",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 271,
            "giorni": 1351,
            "area": "",
            "ech": 0
        },
        {
            "id": 3450,
            "name": "Laino Castello",
            "provincia": "CS",
            "cap": "87015",
            "cod_catastale": "E419",
            "cod_istat": "078064",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1606,
            "area": "",
            "ech": 0
        },
        {
            "id": 3451,
            "name": "Laion",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "E420",
            "cod_istat": "021039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1093,
            "giorni": 4186,
            "area": "",
            "ech": 0
        },
        {
            "id": 3452,
            "name": "Laives",
            "provincia": "BZ",
            "cap": "39055",
            "cod_catastale": "E421",
            "cod_istat": "021040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2951,
            "area": "",
            "ech": 0
        },
        {
            "id": 3453,
            "name": "Lajatico",
            "provincia": "PI",
            "cap": "56030",
            "cod_catastale": "E413",
            "cod_istat": "050016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 1831,
            "area": "",
            "ech": 0
        },
        {
            "id": 3454,
            "name": "Lallio",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "E422",
            "cod_istat": "016123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 3455,
            "name": "Lama dei Peligni",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "E424",
            "cod_istat": "069045",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 669,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 3456,
            "name": "Lama Mocogno",
            "provincia": "MO",
            "cap": "41023",
            "cod_catastale": "E426",
            "cod_istat": "036018",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 842,
            "giorni": 3388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3457,
            "name": "Lambrugo",
            "provincia": "CO",
            "cap": "22045",
            "cod_catastale": "E428",
            "cod_istat": "013121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 3458,
            "name": "Lamezia Terme",
            "provincia": "CZ",
            "cap": "88046",
            "cod_catastale": "M208",
            "cod_istat": "079160",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 1199,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3459,
            "name": "Lamon",
            "provincia": "BL",
            "cap": "32033",
            "cod_catastale": "E429",
            "cod_istat": "025026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 594,
            "giorni": 3522,
            "area": "",
            "ech": 0
        },
        {
            "id": 3460,
            "name": "Lampedusa e Linosa",
            "provincia": "AG",
            "cap": "92031",
            "cod_catastale": "E431",
            "cod_istat": "084020",
            "attivo": 1,
            "zona": "A",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 568,
            "area": "",
            "ech": 0
        },
        {
            "id": 3461,
            "name": "Lamporecchio",
            "provincia": "PT",
            "cap": "51035",
            "cod_catastale": "E432",
            "cod_istat": "047005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 3462,
            "name": "Lamporo",
            "provincia": "VC",
            "cap": "13046",
            "cod_catastale": "E433",
            "cod_istat": "002067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 2519,
            "area": "",
            "ech": 0
        },
        {
            "id": 3463,
            "name": "Lana",
            "provincia": "BZ",
            "cap": "39011",
            "cod_catastale": "E434",
            "cod_istat": "021041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2904,
            "area": "",
            "ech": 0
        },
        {
            "id": 3464,
            "name": "Lanciano",
            "provincia": "CH",
            "cap": "66034",
            "cod_catastale": "E435",
            "cod_istat": "069046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 1638,
            "area": "",
            "ech": 0
        },
        {
            "id": 3465,
            "name": "Landiona",
            "provincia": "NO",
            "cap": "28064",
            "cod_catastale": "E436",
            "cod_istat": "003083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 3466,
            "name": "Landriano",
            "provincia": "PV",
            "cap": "27015",
            "cod_catastale": "E437",
            "cod_istat": "018078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3467,
            "name": "Langhirano",
            "provincia": "PR",
            "cap": "43013",
            "cod_catastale": "E438",
            "cod_istat": "034018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2796,
            "area": "",
            "ech": 0
        },
        {
            "id": 3468,
            "name": "Langosco",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "E439",
            "cod_istat": "018079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 3469,
            "name": "Lanusei",
            "provincia": "NU",
            "cap": "08045",
            "cod_catastale": "E441",
            "cod_istat": "091037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 595,
            "giorni": 1714,
            "area": "",
            "ech": 1
        },
        {
            "id": 3470,
            "name": "Lanuvio",
            "provincia": "RM",
            "cap": "00075",
            "cod_catastale": "C767",
            "cod_istat": "058050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 324,
            "giorni": 1532,
            "area": "",
            "ech": 0
        },
        {
            "id": 3471,
            "name": "Lanzada",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "E443",
            "cod_istat": "014036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 983,
            "giorni": 3465,
            "area": "",
            "ech": 0
        },
        {
            "id": 3472,
            "name": "Lanzo d'Intelvi",
            "provincia": "CO",
            "cap": "22024",
            "cod_catastale": "E444",
            "cod_istat": "013122",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 907,
            "giorni": 3358,
            "area": "",
            "ech": 0
        },
        {
            "id": 3473,
            "name": "Lanzo Torinese",
            "provincia": "TO",
            "cap": "10074",
            "cod_catastale": "E445",
            "cod_istat": "001128",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 3197,
            "area": "",
            "ech": 0
        },
        {
            "id": 3474,
            "name": "Lapedona",
            "provincia": "FM",
            "cap": "63823",
            "cod_catastale": "E447",
            "cod_istat": "109009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 1889,
            "area": "",
            "ech": 0
        },
        {
            "id": 3475,
            "name": "Lapio",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "E448",
            "cod_istat": "064042",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1932,
            "area": "",
            "ech": 0
        },
        {
            "id": 3476,
            "name": "Lappano",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "E450",
            "cod_istat": "078065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 3477,
            "name": "L'Aquila",
            "provincia": "AQ",
            "cap": "67100",
            "cod_catastale": "A345",
            "cod_istat": "066049",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 714,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 3478,
            "name": "Larciano",
            "provincia": "PT",
            "cap": "51036",
            "cod_catastale": "E451",
            "cod_istat": "047006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1694,
            "area": "",
            "ech": 0
        },
        {
            "id": 3479,
            "name": "Lardaro",
            "provincia": "TN",
            "cap": "38087",
            "cod_catastale": "E452",
            "cod_istat": "022100",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 3533,
            "area": "",
            "ech": 0
        },
        {
            "id": 3480,
            "name": "Lardirago",
            "provincia": "PV",
            "cap": "27016",
            "cod_catastale": "E454",
            "cod_istat": "018080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3481,
            "name": "Lari",
            "provincia": "PI",
            "cap": "56035",
            "cod_catastale": "E455",
            "cod_istat": "050017",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1754,
            "area": "",
            "ech": 0
        },
        {
            "id": 3482,
            "name": "Lariano",
            "provincia": "RM",
            "cap": "00076",
            "cod_catastale": "M207",
            "cod_istat": "058115",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1575,
            "area": "",
            "ech": 0
        },
        {
            "id": 3483,
            "name": "Larino",
            "provincia": "CB",
            "cap": "86035",
            "cod_catastale": "E456",
            "cod_istat": "070031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 1605,
            "area": "",
            "ech": 0
        },
        {
            "id": 3484,
            "name": "Las Plassas",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "E464",
            "cod_istat": "111037",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 148,
            "giorni": 1169,
            "area": "",
            "ech": 0
        },
        {
            "id": 3485,
            "name": "Lasa",
            "provincia": "BZ",
            "cap": "39023",
            "cod_catastale": "E457",
            "cod_istat": "021042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 868,
            "giorni": 3825,
            "area": "",
            "ech": 0
        },
        {
            "id": 3486,
            "name": "Lascari",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "E459",
            "cod_istat": "082044",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 796,
            "area": "",
            "ech": 0
        },
        {
            "id": 3487,
            "name": "Lasino",
            "provincia": "TN",
            "cap": "38076",
            "cod_catastale": "E461",
            "cod_istat": "022101",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 463,
            "giorni": 3108,
            "area": "",
            "ech": 0
        },
        {
            "id": 3488,
            "name": "Lasnigo",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "E462",
            "cod_istat": "013123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 3489,
            "name": "Lastebasse",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "E465",
            "cod_istat": "024050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 592,
            "giorni": 3214,
            "area": "",
            "ech": 0
        },
        {
            "id": 3490,
            "name": "Lastra a Signa",
            "provincia": "FI",
            "cap": "50055",
            "cod_catastale": "E466",
            "cod_istat": "048024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1806,
            "area": "",
            "ech": 0
        },
        {
            "id": 3491,
            "name": "Latera",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "E467",
            "cod_istat": "056032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 2322,
            "area": "",
            "ech": 0
        },
        {
            "id": 3492,
            "name": "Laterina",
            "provincia": "AR",
            "cap": "52020",
            "cod_catastale": "E468",
            "cod_istat": "051042",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2000,
            "area": "",
            "ech": 0
        },
        {
            "id": 3493,
            "name": "Laterza",
            "provincia": "TA",
            "cap": "74014",
            "cod_catastale": "E469",
            "cod_istat": "073009",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 340,
            "giorni": 1657,
            "area": "",
            "ech": 0
        },
        {
            "id": 3494,
            "name": "Latiano",
            "provincia": "BR",
            "cap": "72022",
            "cod_catastale": "E471",
            "cod_istat": "074009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1277,
            "area": "",
            "ech": 0
        },
        {
            "id": 3495,
            "name": "Latina",
            "provincia": "LT",
            "cap": "04100",
            "cod_catastale": "E472",
            "cod_istat": "059011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 1220,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 3496,
            "name": "Latisana",
            "provincia": "UD",
            "cap": "33053",
            "cod_catastale": "E473",
            "cod_istat": "030046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 3497,
            "name": "Latronico",
            "provincia": "PZ",
            "cap": "85043",
            "cod_catastale": "E474",
            "cod_istat": "076040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 888,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 3498,
            "name": "Lattarico",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "E475",
            "cod_istat": "078066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 1644,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3499,
            "name": "Lauco",
            "provincia": "UD",
            "cap": "33029",
            "cod_catastale": "E476",
            "cod_istat": "030047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 719,
            "giorni": 3692,
            "area": "",
            "ech": 0
        },
        {
            "id": 3500,
            "name": "Laureana Cilento",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E480",
            "cod_istat": "065060",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 452,
            "giorni": 1730,
            "area": "",
            "ech": 0
        },
        {
            "id": 3501,
            "name": "Laureana di Borrello",
            "provincia": "RC",
            "cap": "89023",
            "cod_catastale": "E479",
            "cod_istat": "080042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1267,
            "area": "",
            "ech": 0
        },
        {
            "id": 3502,
            "name": "Lauregno",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "E481",
            "cod_istat": "021043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1150,
            "giorni": 4167,
            "area": "",
            "ech": 0
        },
        {
            "id": 3503,
            "name": "Laurenzana",
            "provincia": "PZ",
            "cap": "85014",
            "cod_catastale": "E482",
            "cod_istat": "076041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 3504,
            "name": "Lauria",
            "provincia": "PZ",
            "cap": "85044",
            "cod_catastale": "E483",
            "cod_istat": "076042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1691,
            "area": "",
            "ech": 0
        },
        {
            "id": 3505,
            "name": "Lauriano",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "E484",
            "cod_istat": "001129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2616,
            "area": "",
            "ech": 0
        },
        {
            "id": 3506,
            "name": "Laurino",
            "provincia": "SA",
            "cap": "84057",
            "cod_catastale": "E485",
            "cod_istat": "065061",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 531,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 3507,
            "name": "Laurito",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E486",
            "cod_istat": "065062",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 475,
            "giorni": 1638,
            "area": "",
            "ech": 0
        },
        {
            "id": 3508,
            "name": "Lauro",
            "provincia": "AV",
            "cap": "83023",
            "cod_catastale": "E487",
            "cod_istat": "064043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 1351,
            "area": "",
            "ech": 0
        },
        {
            "id": 3509,
            "name": "Lavagna",
            "provincia": "GE",
            "cap": "16033",
            "cod_catastale": "E488",
            "cod_istat": "010028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1552,
            "area": "",
            "ech": 0
        },
        {
            "id": 3510,
            "name": "Lavagno",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "E489",
            "cod_istat": "023042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2406,
            "area": "",
            "ech": 0
        },
        {
            "id": 3511,
            "name": "Lavarone",
            "provincia": "TN",
            "cap": "38046",
            "cod_catastale": "E492",
            "cod_istat": "022102",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1170,
            "giorni": 4147,
            "area": "",
            "ech": 0
        },
        {
            "id": 3512,
            "name": "Lavello",
            "provincia": "PZ",
            "cap": "85024",
            "cod_catastale": "E493",
            "cod_istat": "076043",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 313,
            "giorni": 1501,
            "area": "",
            "ech": 0
        },
        {
            "id": 3513,
            "name": "Lavena Ponte Tresa",
            "provincia": "VA",
            "cap": "21037",
            "cod_catastale": "E494",
            "cod_istat": "012086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2507,
            "area": "",
            "ech": 0
        },
        {
            "id": 3514,
            "name": "Laveno-Mombello",
            "provincia": "VA",
            "cap": "21014",
            "cod_catastale": "E496",
            "cod_istat": "012087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2433,
            "area": "",
            "ech": 0
        },
        {
            "id": 3515,
            "name": "Lavenone",
            "provincia": "BS",
            "cap": "25074",
            "cod_catastale": "E497",
            "cod_istat": "017087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2760,
            "area": "",
            "ech": 0
        },
        {
            "id": 3516,
            "name": "Laviano",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "E498",
            "cod_istat": "065063",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 475,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 3517,
            "name": "Lavis",
            "provincia": "TN",
            "cap": "38015",
            "cod_catastale": "E500",
            "cod_istat": "022103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 3518,
            "name": "Lazise",
            "provincia": "VR",
            "cap": "37017",
            "cod_catastale": "E502",
            "cod_istat": "023043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 3519,
            "name": "Lazzate",
            "provincia": "MB",
            "cap": "20824",
            "cod_catastale": "E504",
            "cod_istat": "108025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2530,
            "area": "",
            "ech": 0
        },
        {
            "id": 3520,
            "name": "Lecce",
            "provincia": "LE",
            "cap": "73100",
            "cod_catastale": "E506",
            "cod_istat": "075035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 1153,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3521,
            "name": "Lecce nei Marsi",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "E505",
            "cod_istat": "066050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 740,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 3522,
            "name": "Lecco",
            "provincia": "LC",
            "cap": "23900",
            "cod_catastale": "E507",
            "cod_istat": "097042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3523,
            "name": "Ledro",
            "provincia": "TN",
            "cap": "38067",
            "cod_catastale": "M313",
            "cod_istat": "022229",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3524,
            "name": "Leffe",
            "provincia": "BG",
            "cap": "24026",
            "cod_catastale": "E509",
            "cod_istat": "016124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 2713,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 3525,
            "name": "Leggiuno",
            "provincia": "VA",
            "cap": "21038",
            "cod_catastale": "E510",
            "cod_istat": "012088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2482,
            "area": "",
            "ech": 0
        },
        {
            "id": 3526,
            "name": "Legnago",
            "provincia": "VR",
            "cap": "37045",
            "cod_catastale": "E512",
            "cod_istat": "023044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 3527,
            "name": "Legnano",
            "provincia": "MI",
            "cap": "20025",
            "cod_catastale": "E514",
            "cod_istat": "015118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2451,
            "area": "",
            "ech": 0
        },
        {
            "id": 3528,
            "name": "Legnaro",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "E515",
            "cod_istat": "028044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3529,
            "name": "Lei",
            "provincia": "NU",
            "cap": "08010",
            "cod_catastale": "E517",
            "cod_istat": "091038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 456,
            "giorni": 1493,
            "area": "",
            "ech": 0
        },
        {
            "id": 3530,
            "name": "Leini",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E518",
            "cod_istat": "001130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 3531,
            "name": "Leivi",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "E519",
            "cod_istat": "010029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2133,
            "area": "",
            "ech": 0
        },
        {
            "id": 3532,
            "name": "Lemie",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "E520",
            "cod_istat": "001131",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 957,
            "giorni": 3789,
            "area": "",
            "ech": 0
        },
        {
            "id": 3533,
            "name": "Lendinara",
            "provincia": "RO",
            "cap": "45026",
            "cod_catastale": "E522",
            "cod_istat": "029029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3534,
            "name": "Leni",
            "provincia": "ME",
            "cap": "98050",
            "cod_catastale": "E523",
            "cod_istat": "083037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 972,
            "area": "",
            "ech": 0
        },
        {
            "id": 3535,
            "name": "Lenna",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "E524",
            "cod_istat": "016125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 2754,
            "area": "",
            "ech": 0
        },
        {
            "id": 3536,
            "name": "Lenno",
            "provincia": "CO",
            "cap": "22016",
            "cod_catastale": "E525",
            "cod_istat": "013125",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 2366,
            "area": "",
            "ech": 0
        },
        {
            "id": 3537,
            "name": "Leno",
            "provincia": "BS",
            "cap": "25024",
            "cod_catastale": "E526",
            "cod_istat": "017088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 3538,
            "name": "Lenola",
            "provincia": "LT",
            "cap": "04025",
            "cod_catastale": "E527",
            "cod_istat": "059012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1856,
            "area": "",
            "ech": 0
        },
        {
            "id": 3539,
            "name": "Lenta",
            "provincia": "VC",
            "cap": "13035",
            "cod_catastale": "E528",
            "cod_istat": "002068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2445,
            "area": "",
            "ech": 0
        },
        {
            "id": 3540,
            "name": "Lentate sul Seveso",
            "provincia": "MB",
            "cap": "20823",
            "cod_catastale": "E530",
            "cod_istat": "108054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 3541,
            "name": "Lentella",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "E531",
            "cod_istat": "069047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 1793,
            "area": "",
            "ech": 0
        },
        {
            "id": 3542,
            "name": "Lentiai",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "C562",
            "cod_istat": "025028",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2998,
            "area": "",
            "ech": 0
        },
        {
            "id": 3543,
            "name": "Lentini",
            "provincia": "SR",
            "cap": "96016",
            "cod_catastale": "E532",
            "cod_istat": "089011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 915,
            "area": "",
            "ech": 1
        },
        {
            "id": 3544,
            "name": "Leonessa",
            "provincia": "RI",
            "cap": "02016",
            "cod_catastale": "E535",
            "cod_istat": "057033",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 969,
            "giorni": 2901,
            "area": "",
            "ech": 0
        },
        {
            "id": 3545,
            "name": "Leonforte",
            "provincia": "EN",
            "cap": "94013",
            "cod_catastale": "E536",
            "cod_istat": "086011",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 603,
            "giorni": 1576,
            "area": "",
            "ech": 1
        },
        {
            "id": 3546,
            "name": "Leporano",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "E537",
            "cod_istat": "073010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 1140,
            "area": "",
            "ech": 0
        },
        {
            "id": 3547,
            "name": "Lequile",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "E538",
            "cod_istat": "075036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1059,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3548,
            "name": "Lequio Berria",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "E540",
            "cod_istat": "004106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 715,
            "giorni": 3202,
            "area": "",
            "ech": 0
        },
        {
            "id": 3549,
            "name": "Lequio Tanaro",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "E539",
            "cod_istat": "004107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 3550,
            "name": "Lercara Friddi",
            "provincia": "PA",
            "cap": "90025",
            "cod_catastale": "E541",
            "cod_istat": "082045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 1574,
            "area": "",
            "ech": 1
        },
        {
            "id": 3551,
            "name": "Lerici",
            "provincia": "SP",
            "cap": "19032",
            "cod_catastale": "E542",
            "cod_istat": "011016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1427,
            "area": "",
            "ech": 0
        },
        {
            "id": 3552,
            "name": "Lerma",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "E543",
            "cod_istat": "006088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 3553,
            "name": "Lesa",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "E544",
            "cod_istat": "003084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2562,
            "area": "",
            "ech": 0
        },
        {
            "id": 3554,
            "name": "Lesegno",
            "provincia": "CN",
            "cap": "12076",
            "cod_catastale": "E546",
            "cod_istat": "004108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 422,
            "giorni": 2838,
            "area": "",
            "ech": 0
        },
        {
            "id": 3555,
            "name": "Lesignano de' Bagni",
            "provincia": "PR",
            "cap": "43037",
            "cod_catastale": "E547",
            "cod_istat": "034019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2780,
            "area": "",
            "ech": 0
        },
        {
            "id": 3556,
            "name": "Lesina",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "E549",
            "cod_istat": "071027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1449,
            "area": "",
            "ech": 0
        },
        {
            "id": 3557,
            "name": "Lesmo",
            "provincia": "MB",
            "cap": "20855",
            "cod_catastale": "E550",
            "cod_istat": "108026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 3558,
            "name": "Lessolo",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "E551",
            "cod_istat": "001132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2773,
            "area": "",
            "ech": 0
        },
        {
            "id": 3559,
            "name": "Lessona",
            "provincia": "BI",
            "cap": "13853",
            "cod_catastale": "M371",
            "cod_istat": "096085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2772,
            "area": "",
            "ech": 0
        },
        {
            "id": 3560,
            "name": "Lestizza",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "E553",
            "cod_istat": "030048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2238,
            "area": "",
            "ech": 0
        },
        {
            "id": 3561,
            "name": "Letino",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "E554",
            "cod_istat": "061044",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 961,
            "giorni": 2908,
            "area": "",
            "ech": 0
        },
        {
            "id": 3562,
            "name": "Letojanni",
            "provincia": "ME",
            "cap": "98037",
            "cod_catastale": "E555",
            "cod_istat": "083038",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 635,
            "area": "",
            "ech": 1
        },
        {
            "id": 3563,
            "name": "Lettere",
            "provincia": "NA",
            "cap": "80050",
            "cod_catastale": "E557",
            "cod_istat": "063039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 3564,
            "name": "Lettomanoppello",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "E558",
            "cod_istat": "068020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 370,
            "giorni": 1828,
            "area": "",
            "ech": 0
        },
        {
            "id": 3565,
            "name": "Lettopalena",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "E559",
            "cod_istat": "069048",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 680,
            "giorni": 2216,
            "area": "",
            "ech": 0
        },
        {
            "id": 3566,
            "name": "Levanto",
            "provincia": "SP",
            "cap": "19015",
            "cod_catastale": "E560",
            "cod_istat": "011017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1413,
            "area": "",
            "ech": 0
        },
        {
            "id": 3567,
            "name": "Levate",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "E562",
            "cod_istat": "016126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 3568,
            "name": "Leverano",
            "provincia": "LE",
            "cap": "73045",
            "cod_catastale": "E563",
            "cod_istat": "075037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 1197,
            "area": "",
            "ech": 0
        },
        {
            "id": 3569,
            "name": "Levice",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "E564",
            "cod_istat": "004109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 547,
            "giorni": 2993,
            "area": "",
            "ech": 0
        },
        {
            "id": 3570,
            "name": "Levico Terme",
            "provincia": "TN",
            "cap": "38056",
            "cod_catastale": "E565",
            "cod_istat": "022104",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 506,
            "giorni": 3075,
            "area": "",
            "ech": 0
        },
        {
            "id": 3571,
            "name": "Levone",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "E566",
            "cod_istat": "001133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 2779,
            "area": "",
            "ech": 0
        },
        {
            "id": 3572,
            "name": "Lezzeno",
            "provincia": "CO",
            "cap": "22025",
            "cod_catastale": "E569",
            "cod_istat": "013126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 3573,
            "name": "Liberi",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "E570",
            "cod_istat": "061045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 470,
            "giorni": 1994,
            "area": "",
            "ech": 0
        },
        {
            "id": 3574,
            "name": "Librizzi",
            "provincia": "ME",
            "cap": "98064",
            "cod_catastale": "E571",
            "cod_istat": "083039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 501,
            "giorni": 1483,
            "area": "",
            "ech": 0
        },
        {
            "id": 3575,
            "name": "Licata",
            "provincia": "AG",
            "cap": "92027",
            "cod_catastale": "E573",
            "cod_istat": "084021",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 604,
            "area": "",
            "ech": 1
        },
        {
            "id": 3576,
            "name": "Licciana Nardi",
            "provincia": "MS",
            "cap": "54016",
            "cod_catastale": "E574",
            "cod_istat": "045009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2146,
            "area": "",
            "ech": 0
        },
        {
            "id": 3577,
            "name": "Licenza",
            "provincia": "RM",
            "cap": "00026",
            "cod_catastale": "E576",
            "cod_istat": "058051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2260,
            "area": "",
            "ech": 0
        },
        {
            "id": 3578,
            "name": "Licodia Eubea",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "E578",
            "cod_istat": "087020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1496,
            "area": "",
            "ech": 1
        },
        {
            "id": 3579,
            "name": "Lierna",
            "provincia": "LC",
            "cap": "23827",
            "cod_catastale": "E581",
            "cod_istat": "097043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2220,
            "area": "",
            "ech": 0
        },
        {
            "id": 3580,
            "name": "Lignana",
            "provincia": "VC",
            "cap": "13034",
            "cod_catastale": "E583",
            "cod_istat": "002070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 2757,
            "area": "",
            "ech": 0
        },
        {
            "id": 3581,
            "name": "Lignano Sabbiadoro",
            "provincia": "UD",
            "cap": "33054",
            "cod_catastale": "E584",
            "cod_istat": "030049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 3582,
            "name": "Ligonchio",
            "provincia": "RE",
            "cap": "42039",
            "cod_catastale": "E585",
            "cod_istat": "035025",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 949,
            "giorni": 3371,
            "area": "",
            "ech": 0
        },
        {
            "id": 3583,
            "name": "Ligosullo",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "E586",
            "cod_istat": "030050",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 949,
            "giorni": 3680,
            "area": "",
            "ech": 0
        },
        {
            "id": 3584,
            "name": "Lillianes",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "E587",
            "cod_istat": "007042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 3223,
            "area": "",
            "ech": 0
        },
        {
            "id": 3585,
            "name": "Limana",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "E588",
            "cod_istat": "025029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2906,
            "area": "",
            "ech": 0
        },
        {
            "id": 3586,
            "name": "Limatola",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "E589",
            "cod_istat": "062038",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 48,
            "giorni": 937,
            "area": "",
            "ech": 0
        },
        {
            "id": 3587,
            "name": "Limbadi",
            "provincia": "VV",
            "cap": "89844",
            "cod_catastale": "E590",
            "cod_istat": "102019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 1163,
            "area": "",
            "ech": 0
        },
        {
            "id": 3588,
            "name": "Limbiate",
            "provincia": "MB",
            "cap": "20812",
            "cod_catastale": "E591",
            "cod_istat": "108027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 3589,
            "name": "Limena",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "E592",
            "cod_istat": "028045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3590,
            "name": "Limido Comasco",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E593",
            "cod_istat": "013128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 3591,
            "name": "Limina",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "E594",
            "cod_istat": "083040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 1570,
            "area": "",
            "ech": 0
        },
        {
            "id": 3592,
            "name": "Limone Piemonte",
            "provincia": "CN",
            "cap": "12015",
            "cod_catastale": "E597",
            "cod_istat": "004110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1009,
            "giorni": 3566,
            "area": "",
            "ech": 0
        },
        {
            "id": 3593,
            "name": "Limone sul Garda",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "E596",
            "cod_istat": "017089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2176,
            "area": "",
            "ech": 0
        },
        {
            "id": 3594,
            "name": "Limosano",
            "provincia": "CB",
            "cap": "86022",
            "cod_catastale": "E599",
            "cod_istat": "070032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 580,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 3595,
            "name": "Linarolo",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E600",
            "cod_istat": "018081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3596,
            "name": "Linguaglossa",
            "provincia": "CT",
            "cap": "95015",
            "cod_catastale": "E602",
            "cod_istat": "087021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1760,
            "area": "",
            "ech": 1
        },
        {
            "id": 3597,
            "name": "Lioni",
            "provincia": "AV",
            "cap": "83047",
            "cod_catastale": "E605",
            "cod_istat": "064044",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 2022,
            "area": "",
            "ech": 0
        },
        {
            "id": 3598,
            "name": "Lipari",
            "provincia": "ME",
            "cap": "98055",
            "cod_catastale": "E606",
            "cod_istat": "083041",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 758,
            "area": "",
            "ech": 0
        },
        {
            "id": 3599,
            "name": "Lipomo",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "E607",
            "cod_istat": "013129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 384,
            "giorni": 2615,
            "area": "",
            "ech": 0
        },
        {
            "id": 3600,
            "name": "Lirio",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "E608",
            "cod_istat": "018082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2944,
            "area": "",
            "ech": 0
        },
        {
            "id": 3601,
            "name": "Liscate",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "E610",
            "cod_istat": "015122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3602,
            "name": "Liscia",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "E611",
            "cod_istat": "069049",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 3603,
            "name": "Lisciano Niccone",
            "provincia": "PG",
            "cap": "06060",
            "cod_catastale": "E613",
            "cod_istat": "054025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2109,
            "area": "",
            "ech": 0
        },
        {
            "id": 3604,
            "name": "Lisignago",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "E614",
            "cod_istat": "022105",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 582,
            "giorni": 3299,
            "area": "",
            "ech": 0
        },
        {
            "id": 3605,
            "name": "Lisio",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "E615",
            "cod_istat": "004111",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3028,
            "area": "",
            "ech": 0
        },
        {
            "id": 3606,
            "name": "Lissone",
            "provincia": "MB",
            "cap": "20851",
            "cod_catastale": "E617",
            "cod_istat": "108028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 3607,
            "name": "Liveri",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "E620",
            "cod_istat": "063040",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1115,
            "area": "",
            "ech": 0
        },
        {
            "id": 3608,
            "name": "Livigno",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "E621",
            "cod_istat": "014037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1816,
            "giorni": 4648,
            "area": "",
            "ech": 0
        },
        {
            "id": 3609,
            "name": "Livinallongo del Col di Lana",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "E622",
            "cod_istat": "025030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1475,
            "giorni": 4806,
            "area": "",
            "ech": 0
        },
        {
            "id": 3610,
            "name": "Livo",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "E624",
            "cod_istat": "022106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 741,
            "giorni": 3547,
            "area": "",
            "ech": 0
        },
        {
            "id": 3611,
            "name": "Livo",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "E623",
            "cod_istat": "013130",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 675,
            "giorni": 3028,
            "area": "",
            "ech": 0
        },
        {
            "id": 3612,
            "name": "Livorno",
            "provincia": "LI",
            "cap": "571xx",
            "cod_catastale": "E625",
            "cod_istat": "049009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1408,
            "area": "",
            "ech": 0
        },
        {
            "id": 3613,
            "name": "Livorno Ferraris",
            "provincia": "VC",
            "cap": "13046",
            "cod_catastale": "E626",
            "cod_istat": "002071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 188,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 3614,
            "name": "Livraga",
            "provincia": "LO",
            "cap": "26814",
            "cod_catastale": "E627",
            "cod_istat": "098030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 3615,
            "name": "Lizzanello",
            "provincia": "LE",
            "cap": "73023",
            "cod_catastale": "E629",
            "cod_istat": "075038",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 1110,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3616,
            "name": "Lizzano",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "E630",
            "cod_istat": "073011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 1004,
            "area": "",
            "ech": 0
        },
        {
            "id": 3617,
            "name": "Lizzano in Belvedere",
            "provincia": "BO",
            "cap": "40042",
            "cod_catastale": "A771",
            "cod_istat": "037033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 3618,
            "name": "Loano",
            "provincia": "SV",
            "cap": "17025",
            "cod_catastale": "E632",
            "cod_istat": "009034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1337,
            "area": "",
            "ech": 0
        },
        {
            "id": 3619,
            "name": "Loazzolo",
            "provincia": "AT",
            "cap": "14051",
            "cod_catastale": "E633",
            "cod_istat": "005060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2843,
            "area": "",
            "ech": 0
        },
        {
            "id": 3620,
            "name": "Locana",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "E635",
            "cod_istat": "001134",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 613,
            "giorni": 3273,
            "area": "",
            "ech": 0
        },
        {
            "id": 3621,
            "name": "Locate di Triulzi",
            "provincia": "MI",
            "cap": "20085",
            "cod_catastale": "E639",
            "cod_istat": "015125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 3622,
            "name": "Locate Varesino",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E638",
            "cod_istat": "013131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2519,
            "area": "",
            "ech": 0
        },
        {
            "id": 3623,
            "name": "Locatello",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "E640",
            "cod_istat": "016127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 2861,
            "area": "",
            "ech": 0
        },
        {
            "id": 3624,
            "name": "Loceri",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "E644",
            "cod_istat": "091039",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 1094,
            "area": "",
            "ech": 1
        },
        {
            "id": 3625,
            "name": "Locorotondo",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "E645",
            "cod_istat": "072025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1618,
            "area": "",
            "ech": 0
        },
        {
            "id": 3626,
            "name": "Locri",
            "provincia": "RC",
            "cap": "89044",
            "cod_catastale": "D976",
            "cod_istat": "080043",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 774,
            "area": "",
            "ech": 1
        },
        {
            "id": 3627,
            "name": "Loculi",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "E646",
            "cod_istat": "091040",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 27,
            "giorni": 899,
            "area": "",
            "ech": 1
        },
        {
            "id": 3628,
            "name": "Lodè",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "E647",
            "cod_istat": "091041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 1536,
            "area": "",
            "ech": 1
        },
        {
            "id": 3629,
            "name": "Lodi",
            "provincia": "LO",
            "cap": "26900",
            "cod_catastale": "E648",
            "cod_istat": "098031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 3630,
            "name": "Lodi Vecchio",
            "provincia": "LO",
            "cap": "26855",
            "cod_catastale": "E651",
            "cod_istat": "098032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 3631,
            "name": "Lodine",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "E649",
            "cod_istat": "091104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 884,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 3632,
            "name": "Lodrino",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "E652",
            "cod_istat": "017090",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 3233,
            "area": "",
            "ech": 0
        },
        {
            "id": 3633,
            "name": "Lograto",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "E654",
            "cod_istat": "017091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3634,
            "name": "Loiano",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "E655",
            "cod_istat": "037034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 714,
            "giorni": 3171,
            "area": "",
            "ech": 0
        },
        {
            "id": 3635,
            "name": "Loiri Porto San Paolo",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "M275",
            "cod_istat": "090084",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3636,
            "name": "Lomagna",
            "provincia": "LC",
            "cap": "23871",
            "cod_catastale": "E656",
            "cod_istat": "097044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 3637,
            "name": "Lomazzo",
            "provincia": "CO",
            "cap": "22074",
            "cod_catastale": "E659",
            "cod_istat": "013133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2550,
            "area": "",
            "ech": 0
        },
        {
            "id": 3638,
            "name": "Lombardore",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E660",
            "cod_istat": "001135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2756,
            "area": "",
            "ech": 0
        },
        {
            "id": 3639,
            "name": "Lombriasco",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "E661",
            "cod_istat": "001136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 3640,
            "name": "Lomello",
            "provincia": "PV",
            "cap": "27034",
            "cod_catastale": "E662",
            "cod_istat": "018083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3641,
            "name": "Lona-Lases",
            "provincia": "TN",
            "cap": "38040",
            "cod_catastale": "E664",
            "cod_istat": "022108",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 639,
            "giorni": 3388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3642,
            "name": "Lonate Ceppino",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "E665",
            "cod_istat": "012089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2540,
            "area": "",
            "ech": 0
        },
        {
            "id": 3643,
            "name": "Lonate Pozzolo",
            "provincia": "VA",
            "cap": "21015",
            "cod_catastale": "E666",
            "cod_istat": "012090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 3644,
            "name": "Lonato del Garda",
            "provincia": "BS",
            "cap": "25017",
            "cod_catastale": "M312",
            "cod_istat": "017092",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3645,
            "name": "Londa",
            "provincia": "FI",
            "cap": "50060",
            "cod_catastale": "E668",
            "cod_istat": "048025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2110,
            "area": "",
            "ech": 0
        },
        {
            "id": 3646,
            "name": "Longano",
            "provincia": "IS",
            "cap": "86090",
            "cod_catastale": "E669",
            "cod_istat": "094024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 3647,
            "name": "Longare",
            "provincia": "VI",
            "cap": "36023",
            "cod_catastale": "E671",
            "cod_istat": "024051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 3648,
            "name": "Longarone",
            "provincia": "BL",
            "cap": "32013",
            "cod_catastale": "M342",
            "cod_istat": "025071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 473,
            "giorni": 3331,
            "area": "",
            "ech": 0
        },
        {
            "id": 3649,
            "name": "Longhena",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "E673",
            "cod_istat": "017093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3650,
            "name": "Longi",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "E674",
            "cod_istat": "083042",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 616,
            "giorni": 1680,
            "area": "",
            "ech": 0
        },
        {
            "id": 3651,
            "name": "Longiano",
            "provincia": "FC",
            "cap": "47020",
            "cod_catastale": "E675",
            "cod_istat": "040018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 3652,
            "name": "Longobardi",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "E677",
            "cod_istat": "078067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1458,
            "area": "",
            "ech": 0
        },
        {
            "id": 3653,
            "name": "Longobucco",
            "provincia": "CS",
            "cap": "87066",
            "cod_catastale": "E678",
            "cod_istat": "078068",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 784,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 3654,
            "name": "Longone al Segrino",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "E679",
            "cod_istat": "013134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 2753,
            "area": "",
            "ech": 0
        },
        {
            "id": 3655,
            "name": "Longone Sabino",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "E681",
            "cod_istat": "057034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 804,
            "giorni": 2828,
            "area": "",
            "ech": 0
        },
        {
            "id": 3656,
            "name": "Lonigo",
            "provincia": "VI",
            "cap": "36045",
            "cod_catastale": "E682",
            "cod_istat": "024052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2444,
            "area": "",
            "ech": 0
        },
        {
            "id": 3657,
            "name": "Loranzè",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "E683",
            "cod_istat": "001137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 3658,
            "name": "Loreggia",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "E684",
            "cod_istat": "028046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 3659,
            "name": "Loreglia",
            "provincia": "VB",
            "cap": "28893",
            "cod_catastale": "E685",
            "cod_istat": "103038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 719,
            "giorni": 3239,
            "area": "",
            "ech": 0
        },
        {
            "id": 3660,
            "name": "Lorenzago di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "E687",
            "cod_istat": "025032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 883,
            "giorni": 3982,
            "area": "",
            "ech": 0
        },
        {
            "id": 3661,
            "name": "Lorenzana",
            "provincia": "PI",
            "cap": "56043",
            "cod_catastale": "E688",
            "cod_istat": "050041",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 1750,
            "area": "",
            "ech": 0
        },
        {
            "id": 3662,
            "name": "Loreo",
            "provincia": "RO",
            "cap": "45017",
            "cod_catastale": "E689",
            "cod_istat": "029030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 3663,
            "name": "Loreto",
            "provincia": "AN",
            "cap": "60025",
            "cod_catastale": "E690",
            "cod_istat": "042022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 1897,
            "area": "",
            "ech": 0
        },
        {
            "id": 3664,
            "name": "Loreto Aprutino",
            "provincia": "PE",
            "cap": "65014",
            "cod_catastale": "E691",
            "cod_istat": "068021",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 294,
            "giorni": 1699,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 3665,
            "name": "Loria",
            "provincia": "TV",
            "cap": "31037",
            "cod_catastale": "E692",
            "cod_istat": "026036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 3666,
            "name": "Loro Ciuffenna",
            "provincia": "AR",
            "cap": "52024",
            "cod_catastale": "E693",
            "cod_istat": "051020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2140,
            "area": "",
            "ech": 0
        },
        {
            "id": 3667,
            "name": "Loro Piceno",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "E694",
            "cod_istat": "043022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 436,
            "giorni": 2150,
            "area": "",
            "ech": 0
        },
        {
            "id": 3668,
            "name": "Lorsica",
            "provincia": "GE",
            "cap": "16045",
            "cod_catastale": "E695",
            "cod_istat": "010030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 2292,
            "area": "",
            "ech": 0
        },
        {
            "id": 3669,
            "name": "Losine",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "E698",
            "cod_istat": "017094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2768,
            "area": "",
            "ech": 0
        },
        {
            "id": 3670,
            "name": "Lotzorai",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "E700",
            "cod_istat": "091042",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 767,
            "area": "",
            "ech": 1
        },
        {
            "id": 3671,
            "name": "Lovere",
            "provincia": "BG",
            "cap": "24065",
            "cod_catastale": "E704",
            "cod_istat": "016128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 3672,
            "name": "Lovero",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "E705",
            "cod_istat": "014038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 3011,
            "area": "",
            "ech": 0
        },
        {
            "id": 3673,
            "name": "Lozio",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "E706",
            "cod_istat": "017095",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 975,
            "giorni": 3604,
            "area": "",
            "ech": 0
        },
        {
            "id": 3674,
            "name": "Lozza",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "E707",
            "cod_istat": "012091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2598,
            "area": "",
            "ech": 0
        },
        {
            "id": 3675,
            "name": "Lozzo Atestino",
            "provincia": "PD",
            "cap": "35034",
            "cod_catastale": "E709",
            "cod_istat": "028047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 3676,
            "name": "Lozzo di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "E708",
            "cod_istat": "025033",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 756,
            "giorni": 3820,
            "area": "",
            "ech": 0
        },
        {
            "id": 3677,
            "name": "Lozzolo",
            "provincia": "VC",
            "cap": "13045",
            "cod_catastale": "E711",
            "cod_istat": "002072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 3678,
            "name": "Lu",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "E712",
            "cod_istat": "006089",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 3679,
            "name": "Lubriano",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "E713",
            "cod_istat": "056033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2203,
            "area": "",
            "ech": 0
        },
        {
            "id": 3680,
            "name": "Lucca",
            "provincia": "LU",
            "cap": "55100",
            "cod_catastale": "E715",
            "cod_istat": "046017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 1715,
            "area": "",
            "ech": 0
        },
        {
            "id": 3681,
            "name": "Lucca Sicula",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "E714",
            "cod_istat": "084022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 513,
            "giorni": 1282,
            "area": "",
            "ech": 1
        },
        {
            "id": 3682,
            "name": "Lucera",
            "provincia": "FG",
            "cap": "71036",
            "cod_catastale": "E716",
            "cod_istat": "071028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 1473,
            "area": "",
            "ech": 0
        },
        {
            "id": 3683,
            "name": "Lucignano",
            "provincia": "AR",
            "cap": "52046",
            "cod_catastale": "E718",
            "cod_istat": "051021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2248,
            "area": "",
            "ech": 0
        },
        {
            "id": 3684,
            "name": "Lucinasco",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "E719",
            "cod_istat": "008033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 499,
            "giorni": 2339,
            "area": "",
            "ech": 0
        },
        {
            "id": 3685,
            "name": "Lucito",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "E722",
            "cod_istat": "070033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 1959,
            "area": "",
            "ech": 0
        },
        {
            "id": 3686,
            "name": "Luco dei Marsi",
            "provincia": "AQ",
            "cap": "67056",
            "cod_catastale": "E723",
            "cod_istat": "066051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3687,
            "name": "Lucoli",
            "provincia": "AQ",
            "cap": "67045",
            "cod_catastale": "E724",
            "cod_istat": "066052",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 956,
            "giorni": 3000,
            "area": "",
            "ech": 0
        },
        {
            "id": 3688,
            "name": "Lugagnano Val d'Arda",
            "provincia": "PC",
            "cap": "29018",
            "cod_catastale": "E726",
            "cod_istat": "033026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 3689,
            "name": "Lugnacco",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "E727",
            "cod_istat": "001138",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 3081,
            "area": "",
            "ech": 0
        },
        {
            "id": 3690,
            "name": "Lugnano in Teverina",
            "provincia": "TR",
            "cap": "05020",
            "cod_catastale": "E729",
            "cod_istat": "055016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 419,
            "giorni": 2127,
            "area": "",
            "ech": 0
        },
        {
            "id": 3691,
            "name": "Lugo",
            "provincia": "RA",
            "cap": "48022",
            "cod_catastale": "E730",
            "cod_istat": "039012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 3692,
            "name": "Lugo di Vicenza",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "E731",
            "cod_istat": "024053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2572,
            "area": "",
            "ech": 0
        },
        {
            "id": 3693,
            "name": "Luino",
            "provincia": "VA",
            "cap": "21016",
            "cod_catastale": "E734",
            "cod_istat": "012092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2465,
            "area": "",
            "ech": 0
        },
        {
            "id": 3694,
            "name": "Luisago",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E735",
            "cod_istat": "013135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2534,
            "area": "",
            "ech": 0
        },
        {
            "id": 3695,
            "name": "Lula",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "E736",
            "cod_istat": "091043",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 516,
            "giorni": 1600,
            "area": "",
            "ech": 0
        },
        {
            "id": 3696,
            "name": "Lumarzo",
            "provincia": "GE",
            "cap": "16024",
            "cod_catastale": "E737",
            "cod_istat": "010031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 228,
            "giorni": 2056,
            "area": "",
            "ech": 0
        },
        {
            "id": 3697,
            "name": "Lumezzane",
            "provincia": "BS",
            "cap": "25065",
            "cod_catastale": "E738",
            "cod_istat": "017096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2867,
            "area": "",
            "ech": 0
        },
        {
            "id": 3698,
            "name": "Lunamatrona",
            "provincia": "SU",
            "cap": "09022",
            "cod_catastale": "E742",
            "cod_istat": "111038",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 180,
            "giorni": 1181,
            "area": "",
            "ech": 0
        },
        {
            "id": 3699,
            "name": "Lunano",
            "provincia": "PU",
            "cap": "61026",
            "cod_catastale": "E743",
            "cod_istat": "041022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2312,
            "area": "",
            "ech": 0
        },
        {
            "id": 3700,
            "name": "Lungavilla",
            "provincia": "PV",
            "cap": "27053",
            "cod_catastale": "B387",
            "cod_istat": "018084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3701,
            "name": "Lungro",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "E745",
            "cod_istat": "078069",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2010,
            "area": "",
            "ech": 0
        },
        {
            "id": 3702,
            "name": "Luogosano",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "E746",
            "cod_istat": "064045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 390,
            "giorni": 1913,
            "area": "",
            "ech": 0
        },
        {
            "id": 3703,
            "name": "Luogosanto",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "E747",
            "cod_istat": "090036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1643,
            "area": "",
            "ech": 0
        },
        {
            "id": 3704,
            "name": "Lupara",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "E748",
            "cod_istat": "070034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 505,
            "giorni": 1994,
            "area": "",
            "ech": 0
        },
        {
            "id": 3705,
            "name": "Lurago d'Erba",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "E749",
            "cod_istat": "013136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 3706,
            "name": "Lurago Marinone",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "E750",
            "cod_istat": "013137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 3707,
            "name": "Lurano",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "E751",
            "cod_istat": "016129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 3708,
            "name": "Luras",
            "provincia": "SS",
            "cap": "07025",
            "cod_catastale": "E752",
            "cod_istat": "090037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 1881,
            "area": "",
            "ech": 0
        },
        {
            "id": 3709,
            "name": "Lurate Caccivio",
            "provincia": "CO",
            "cap": "22075",
            "cod_catastale": "E753",
            "cod_istat": "013138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2587,
            "area": "",
            "ech": 0
        },
        {
            "id": 3710,
            "name": "Lusciano",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "E754",
            "cod_istat": "061046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 1129,
            "area": "",
            "ech": 0
        },
        {
            "id": 3711,
            "name": "Luserna",
            "provincia": "TN",
            "cap": "38040",
            "cod_catastale": "E757",
            "cod_istat": "022109",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1333,
            "giorni": 4470,
            "area": "",
            "ech": 0
        },
        {
            "id": 3712,
            "name": "Luserna San Giovanni",
            "provincia": "TO",
            "cap": "10062",
            "cod_catastale": "E758",
            "cod_istat": "001139",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 474,
            "giorni": 3065,
            "area": "",
            "ech": 0
        },
        {
            "id": 3713,
            "name": "Lusernetta",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "E759",
            "cod_istat": "001140",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 507,
            "giorni": 3114,
            "area": "",
            "ech": 0
        },
        {
            "id": 3714,
            "name": "Lusevera",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "E760",
            "cod_istat": "030051",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 3072,
            "area": "",
            "ech": 0
        },
        {
            "id": 3715,
            "name": "Lusia",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "E761",
            "cod_istat": "029031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3716,
            "name": "Lusiana",
            "provincia": "VI",
            "cap": "36046",
            "cod_catastale": "E762",
            "cod_istat": "024054",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 752,
            "giorni": 3519,
            "area": "",
            "ech": 0
        },
        {
            "id": 3717,
            "name": "Lusigliè",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "E763",
            "cod_istat": "001141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 3718,
            "name": "Luson",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "E764",
            "cod_istat": "021044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 972,
            "giorni": 4011,
            "area": "",
            "ech": 0
        },
        {
            "id": 3719,
            "name": "Lustra",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E767",
            "cod_istat": "065064",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 466,
            "giorni": 1720,
            "area": "",
            "ech": 0
        },
        {
            "id": 3720,
            "name": "Luvinate",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "E769",
            "cod_istat": "012093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 3721,
            "name": "Luzzana",
            "provincia": "BG",
            "cap": "24069",
            "cod_catastale": "E770",
            "cod_istat": "016130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 3722,
            "name": "Luzzara",
            "provincia": "RE",
            "cap": "42045",
            "cod_catastale": "E772",
            "cod_istat": "035026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 3723,
            "name": "Luzzi",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "E773",
            "cod_istat": "078070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 1573,
            "area": "",
            "ech": 0
        },
        {
            "id": 3724,
            "name": "Maccagno con Pino e Veddasca",
            "provincia": "VA",
            "cap": "21061",
            "cod_catastale": "M339",
            "cod_istat": "012142",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 3725,
            "name": "Maccastorna",
            "provincia": "LO",
            "cap": "26843",
            "cod_catastale": "E777",
            "cod_istat": "098033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 3726,
            "name": "Macchia d'Isernia",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "E778",
            "cod_istat": "094025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1764,
            "area": "",
            "ech": 0
        },
        {
            "id": 3727,
            "name": "Macchia Valfortore",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "E780",
            "cod_istat": "070035",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 477,
            "giorni": 1992,
            "area": "",
            "ech": 0
        },
        {
            "id": 3728,
            "name": "Macchiagodena",
            "provincia": "IS",
            "cap": "86096",
            "cod_catastale": "E779",
            "cod_istat": "094026",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 864,
            "giorni": 2583,
            "area": "",
            "ech": 0
        },
        {
            "id": 3729,
            "name": "Macello",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "E782",
            "cod_istat": "001142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 3730,
            "name": "Macerata",
            "provincia": "MC",
            "cap": "62100",
            "cod_catastale": "E783",
            "cod_istat": "043023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 2005,
            "area": "",
            "ech": 0
        },
        {
            "id": 3731,
            "name": "Macerata Campania",
            "provincia": "CE",
            "cap": "81047",
            "cod_catastale": "E784",
            "cod_istat": "061047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1109,
            "area": "",
            "ech": 0
        },
        {
            "id": 3732,
            "name": "Macerata Feltria",
            "provincia": "PU",
            "cap": "61023",
            "cod_catastale": "E785",
            "cod_istat": "041023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2331,
            "area": "",
            "ech": 0
        },
        {
            "id": 3733,
            "name": "Macherio",
            "provincia": "MB",
            "cap": "20846",
            "cod_catastale": "E786",
            "cod_istat": "108029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2442,
            "area": "",
            "ech": 0
        },
        {
            "id": 3734,
            "name": "Maclodio",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "E787",
            "cod_istat": "017097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3735,
            "name": "Macomer",
            "provincia": "NU",
            "cap": "08015",
            "cod_catastale": "E788",
            "cod_istat": "091044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 563,
            "giorni": 1580,
            "area": "",
            "ech": 0
        },
        {
            "id": 3736,
            "name": "Macra",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "E789",
            "cod_istat": "004112",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 875,
            "giorni": 3400,
            "area": "",
            "ech": 0
        },
        {
            "id": 3737,
            "name": "Macugnaga",
            "provincia": "VB",
            "cap": "28876",
            "cod_catastale": "E790",
            "cod_istat": "103039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1327,
            "giorni": 4030,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 3738,
            "name": "Maddaloni",
            "provincia": "CE",
            "cap": "81024",
            "cod_catastale": "E791",
            "cod_istat": "061048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 978,
            "area": "",
            "ech": 0
        },
        {
            "id": 3739,
            "name": "Madesimo",
            "provincia": "SO",
            "cap": "23024",
            "cod_catastale": "E342",
            "cod_istat": "014035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1399,
            "giorni": 4056,
            "area": "",
            "ech": 0
        },
        {
            "id": 3740,
            "name": "Madignano",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "E793",
            "cod_istat": "019055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 3741,
            "name": "Madone",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "E794",
            "cod_istat": "016131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 3742,
            "name": "Madonna del Sasso",
            "provincia": "VB",
            "cap": "28894",
            "cod_catastale": "E795",
            "cod_istat": "103040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 696,
            "giorni": 3209,
            "area": "",
            "ech": 0
        },
        {
            "id": 3743,
            "name": "Maenza",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "E798",
            "cod_istat": "059013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 1733,
            "area": "",
            "ech": 0
        },
        {
            "id": 3744,
            "name": "Mafalda",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "E799",
            "cod_istat": "070036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 1929,
            "area": "",
            "ech": 0
        },
        {
            "id": 3745,
            "name": "Magasa",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "E800",
            "cod_istat": "017098",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 970,
            "giorni": 3596,
            "area": "",
            "ech": 0
        },
        {
            "id": 3746,
            "name": "Magenta",
            "provincia": "MI",
            "cap": "20013",
            "cod_catastale": "E801",
            "cod_istat": "015130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 2532,
            "area": "",
            "ech": 0
        },
        {
            "id": 3747,
            "name": "Maggiora",
            "provincia": "NO",
            "cap": "28014",
            "cod_catastale": "E803",
            "cod_istat": "003088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 3748,
            "name": "Magherno",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E804",
            "cod_istat": "018085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3749,
            "name": "Magione",
            "provincia": "PG",
            "cap": "06063",
            "cod_catastale": "E805",
            "cod_istat": "054026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 2094,
            "area": "",
            "ech": 0
        },
        {
            "id": 3750,
            "name": "Magisano",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "E806",
            "cod_istat": "079068",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 565,
            "giorni": 1962,
            "area": "",
            "ech": 0
        },
        {
            "id": 3751,
            "name": "Magliano Alfieri",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "E809",
            "cod_istat": "004113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 3752,
            "name": "Magliano Alpi",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "E808",
            "cod_istat": "004114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 403,
            "giorni": 2815,
            "area": "",
            "ech": 0
        },
        {
            "id": 3753,
            "name": "Magliano de' Marsi",
            "provincia": "AQ",
            "cap": "67062",
            "cod_catastale": "E811",
            "cod_istat": "066053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 3754,
            "name": "Magliano di Tenna",
            "provincia": "FM",
            "cap": "63832",
            "cod_catastale": "E807",
            "cod_istat": "109010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1924,
            "area": "",
            "ech": 0
        },
        {
            "id": 3755,
            "name": "Magliano in Toscana",
            "provincia": "GR",
            "cap": "58051",
            "cod_catastale": "E810",
            "cod_istat": "053013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 1699,
            "area": "",
            "ech": 0
        },
        {
            "id": 3756,
            "name": "Magliano Romano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "E813",
            "cod_istat": "058052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 3757,
            "name": "Magliano Sabina",
            "provincia": "RI",
            "cap": "02046",
            "cod_catastale": "E812",
            "cod_istat": "057035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 3758,
            "name": "Magliano Vetere",
            "provincia": "SA",
            "cap": "84050",
            "cod_catastale": "E814",
            "cod_istat": "065065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 1950,
            "area": "",
            "ech": 0
        },
        {
            "id": 3759,
            "name": "Maglie",
            "provincia": "LE",
            "cap": "73024",
            "cod_catastale": "E815",
            "cod_istat": "075039",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 1240,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3760,
            "name": "Magliolo",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "E816",
            "cod_istat": "009035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1991,
            "area": "",
            "ech": 0
        },
        {
            "id": 3761,
            "name": "Maglione",
            "provincia": "TO",
            "cap": "10030",
            "cod_catastale": "E817",
            "cod_istat": "001143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2819,
            "area": "",
            "ech": 0
        },
        {
            "id": 3762,
            "name": "Magnacavallo",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "E818",
            "cod_istat": "020029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3763,
            "name": "Magnago",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "E819",
            "cod_istat": "015131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2448,
            "area": "",
            "ech": 0
        },
        {
            "id": 3764,
            "name": "Magnano",
            "provincia": "BI",
            "cap": "13887",
            "cod_catastale": "E821",
            "cod_istat": "096030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 543,
            "giorni": 3010,
            "area": "",
            "ech": 0
        },
        {
            "id": 3765,
            "name": "Magnano in Riviera",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "E820",
            "cod_istat": "030052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 3766,
            "name": "Magomadas",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "E825",
            "cod_istat": "095083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 3767,
            "name": "Magrè sulla strada del vino",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "E829",
            "cod_istat": "021045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2770,
            "area": "",
            "ech": 0
        },
        {
            "id": 3768,
            "name": "Magreglio",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "E830",
            "cod_istat": "013139",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 744,
            "giorni": 3126,
            "area": "",
            "ech": 0
        },
        {
            "id": 3769,
            "name": "Maida",
            "provincia": "CZ",
            "cap": "88025",
            "cod_catastale": "E834",
            "cod_istat": "079069",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 1323,
            "area": "",
            "ech": 0
        },
        {
            "id": 3770,
            "name": "Maierà",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "E835",
            "cod_istat": "078071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1527,
            "area": "",
            "ech": 0
        },
        {
            "id": 3771,
            "name": "Maierato",
            "provincia": "VV",
            "cap": "89843",
            "cod_catastale": "E836",
            "cod_istat": "102020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 1291,
            "area": "",
            "ech": 0
        },
        {
            "id": 3772,
            "name": "Maiolati Spontini",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "E837",
            "cod_istat": "042023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2149,
            "area": "",
            "ech": 0
        },
        {
            "id": 3773,
            "name": "Maiolo",
            "provincia": "RN",
            "cap": "47862",
            "cod_catastale": "E838",
            "cod_istat": "099022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 3774,
            "name": "Maiori",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "E839",
            "cod_istat": "065066",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 977,
            "area": "",
            "ech": 0
        },
        {
            "id": 3775,
            "name": "Mairago",
            "provincia": "LO",
            "cap": "26825",
            "cod_catastale": "E840",
            "cod_istat": "098034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 3776,
            "name": "Mairano",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "E841",
            "cod_istat": "017099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 3777,
            "name": "Maissana",
            "provincia": "SP",
            "cap": "19010",
            "cod_catastale": "E842",
            "cod_istat": "011018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2300,
            "area": "",
            "ech": 0
        },
        {
            "id": 3778,
            "name": "Majano",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "E833",
            "cod_istat": "030053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2395,
            "area": "",
            "ech": 0
        },
        {
            "id": 3779,
            "name": "Malagnino",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "E843",
            "cod_istat": "019056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3780,
            "name": "Malalbergo",
            "provincia": "BO",
            "cap": "40051",
            "cod_catastale": "E844",
            "cod_istat": "037035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 3781,
            "name": "Malborghetto Valbruna",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "E847",
            "cod_istat": "030054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 3680,
            "area": "",
            "ech": 0
        },
        {
            "id": 3782,
            "name": "Malcesine",
            "provincia": "VR",
            "cap": "37018",
            "cod_catastale": "E848",
            "cod_istat": "023045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2131,
            "area": "",
            "ech": 0
        },
        {
            "id": 3783,
            "name": "Malé",
            "provincia": "TN",
            "cap": "38027",
            "cod_catastale": "E850",
            "cod_istat": "022110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 738,
            "giorni": 3542,
            "area": "",
            "ech": 0
        },
        {
            "id": 3784,
            "name": "Malegno",
            "provincia": "BS",
            "cap": "25053",
            "cod_catastale": "E851",
            "cod_istat": "017100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2678,
            "area": "",
            "ech": 0
        },
        {
            "id": 3785,
            "name": "Maleo",
            "provincia": "LO",
            "cap": "26847",
            "cod_catastale": "E852",
            "cod_istat": "098035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 3786,
            "name": "Malesco",
            "provincia": "VB",
            "cap": "28854",
            "cod_catastale": "E853",
            "cod_istat": "103041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 761,
            "giorni": 3294,
            "area": "",
            "ech": 0
        },
        {
            "id": 3787,
            "name": "Maletto",
            "provincia": "CT",
            "cap": "95035",
            "cod_catastale": "E854",
            "cod_istat": "087022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 2268,
            "area": "",
            "ech": 1
        },
        {
            "id": 3788,
            "name": "Malfa",
            "provincia": "ME",
            "cap": "98050",
            "cod_catastale": "E855",
            "cod_istat": "083043",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 780,
            "area": "",
            "ech": 0
        },
        {
            "id": 3789,
            "name": "Malgesso",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "E856",
            "cod_istat": "012095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 3790,
            "name": "Malgrate",
            "provincia": "LC",
            "cap": "23864",
            "cod_catastale": "E858",
            "cod_istat": "097045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2398,
            "area": "",
            "ech": 0
        },
        {
            "id": 3791,
            "name": "Malito",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "E859",
            "cod_istat": "078072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 3792,
            "name": "Mallare",
            "provincia": "SV",
            "cap": "17045",
            "cod_catastale": "E860",
            "cod_istat": "009036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 458,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 3793,
            "name": "Malles Venosta",
            "provincia": "BZ",
            "cap": "39024",
            "cod_catastale": "E862",
            "cod_istat": "021046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1051,
            "giorni": 4131,
            "area": "",
            "ech": 0
        },
        {
            "id": 3794,
            "name": "Malnate",
            "provincia": "VA",
            "cap": "21046",
            "cod_catastale": "E863",
            "cod_istat": "012096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 3795,
            "name": "Malo",
            "provincia": "VI",
            "cap": "36034",
            "cod_catastale": "E864",
            "cod_istat": "024055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2378,
            "area": "",
            "ech": 0
        },
        {
            "id": 3796,
            "name": "Malonno",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "E865",
            "cod_istat": "017101",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 596,
            "giorni": 3053,
            "area": "",
            "ech": 0
        },
        {
            "id": 3797,
            "name": "Malosco",
            "provincia": "TN",
            "cap": "38013",
            "cod_catastale": "E866",
            "cod_istat": "022111",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1041,
            "giorni": 4015,
            "area": "",
            "ech": 0
        },
        {
            "id": 3798,
            "name": "Maltignano",
            "provincia": "AP",
            "cap": "63085",
            "cod_catastale": "E868",
            "cod_istat": "044027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 1999,
            "area": "",
            "ech": 0
        },
        {
            "id": 3799,
            "name": "Malvagna",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "E869",
            "cod_istat": "083044",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 1840,
            "area": "",
            "ech": 0
        },
        {
            "id": 3800,
            "name": "Malvicino",
            "provincia": "AL",
            "cap": "15015",
            "cod_catastale": "E870",
            "cod_istat": "006090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 3801,
            "name": "Malvito",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "E872",
            "cod_istat": "078073",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 449,
            "giorni": 1821,
            "area": "",
            "ech": 0
        },
        {
            "id": 3802,
            "name": "Mammola",
            "provincia": "RC",
            "cap": "89045",
            "cod_catastale": "E873",
            "cod_istat": "080044",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 240,
            "giorni": 1156,
            "area": "",
            "ech": 0
        },
        {
            "id": 3803,
            "name": "Mamoiada",
            "provincia": "NU",
            "cap": "08024",
            "cod_catastale": "E874",
            "cod_istat": "091046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 644,
            "giorni": 1803,
            "area": "",
            "ech": 0
        },
        {
            "id": 3804,
            "name": "Manciano",
            "provincia": "GR",
            "cap": "58014",
            "cod_catastale": "E875",
            "cod_istat": "053014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 2214,
            "area": "",
            "ech": 0
        },
        {
            "id": 3805,
            "name": "Mandanici",
            "provincia": "ME",
            "cap": "98020",
            "cod_catastale": "E876",
            "cod_istat": "083045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 1339,
            "area": "",
            "ech": 0
        },
        {
            "id": 3806,
            "name": "Mandas",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "E877",
            "cod_istat": "111039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 457,
            "giorni": 1652,
            "area": "",
            "ech": 1
        },
        {
            "id": 3807,
            "name": "Mandatoriccio",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "E878",
            "cod_istat": "078074",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 561,
            "giorni": 1927,
            "area": "",
            "ech": 1
        },
        {
            "id": 3808,
            "name": "Mandela",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "B632",
            "cod_istat": "058053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 487,
            "giorni": 2075,
            "area": "",
            "ech": 0
        },
        {
            "id": 3809,
            "name": "Mandello del Lario",
            "provincia": "LC",
            "cap": "23826",
            "cod_catastale": "E879",
            "cod_istat": "097046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2373,
            "area": "",
            "ech": 0
        },
        {
            "id": 3810,
            "name": "Mandello Vitta",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "E880",
            "cod_istat": "003090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 3811,
            "name": "Manduria",
            "provincia": "TA",
            "cap": "74024",
            "cod_catastale": "E882",
            "cod_istat": "073012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 1174,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3812,
            "name": "Manerba del Garda",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "E883",
            "cod_istat": "017102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3813,
            "name": "Manerbio",
            "provincia": "BS",
            "cap": "25025",
            "cod_catastale": "E884",
            "cod_istat": "017103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 3814,
            "name": "Manfredonia",
            "provincia": "FG",
            "cap": "71043",
            "cod_catastale": "E885",
            "cod_istat": "071029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1523,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3815,
            "name": "Mango",
            "provincia": "CN",
            "cap": "12056",
            "cod_catastale": "E887",
            "cod_istat": "004115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 2961,
            "area": "",
            "ech": 0
        },
        {
            "id": 3816,
            "name": "Mangone",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "E888",
            "cod_istat": "078075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 805,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 3817,
            "name": "Maniace",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "M283",
            "cod_istat": "087057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 787,
            "giorni": 1972,
            "area": "",
            "ech": 0
        },
        {
            "id": 3818,
            "name": "Maniago",
            "provincia": "PN",
            "cap": "33085",
            "cod_catastale": "E889",
            "cod_istat": "093025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2850,
            "area": "",
            "ech": 0
        },
        {
            "id": 3819,
            "name": "Manocalzati",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "E891",
            "cod_istat": "064046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1993,
            "area": "",
            "ech": 0
        },
        {
            "id": 3820,
            "name": "Manoppello",
            "provincia": "PE",
            "cap": "65024",
            "cod_catastale": "E892",
            "cod_istat": "068022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 1644,
            "area": "",
            "ech": 0
        },
        {
            "id": 3821,
            "name": "Mansuè",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "E893",
            "cod_istat": "026037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 3822,
            "name": "Manta",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "E894",
            "cod_istat": "004116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 2814,
            "area": "",
            "ech": 0
        },
        {
            "id": 3823,
            "name": "Mantello",
            "provincia": "SO",
            "cap": "23016",
            "cod_catastale": "E896",
            "cod_istat": "014039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 3824,
            "name": "Mantova",
            "provincia": "MN",
            "cap": "46100",
            "cod_catastale": "E897",
            "cod_istat": "020030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3825,
            "name": "Manzano",
            "provincia": "UD",
            "cap": "33044",
            "cod_catastale": "E899",
            "cod_istat": "030055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2267,
            "area": "",
            "ech": 0
        },
        {
            "id": 3826,
            "name": "Manziana",
            "provincia": "RM",
            "cap": "00066",
            "cod_catastale": "E900",
            "cod_istat": "058054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 1936,
            "area": "",
            "ech": 0
        },
        {
            "id": 3827,
            "name": "Mapello",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "E901",
            "cod_istat": "016132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2425,
            "area": "",
            "ech": 0
        },
        {
            "id": 3828,
            "name": "Mara",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "E902",
            "cod_istat": "090038",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 257,
            "giorni": 1412,
            "area": "",
            "ech": 0
        },
        {
            "id": 3829,
            "name": "Maracalagonis",
            "provincia": "CA",
            "cap": "09069",
            "cod_catastale": "E903",
            "cod_istat": "092037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 939,
            "area": "",
            "ech": 0
        },
        {
            "id": 3830,
            "name": "Maranello",
            "provincia": "MO",
            "cap": "41053",
            "cod_catastale": "E904",
            "cod_istat": "036019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 2378,
            "area": "",
            "ech": 0
        },
        {
            "id": 3831,
            "name": "Marano di Napoli",
            "provincia": "NA",
            "cap": "80016",
            "cod_catastale": "E906",
            "cod_istat": "063041",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 1355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3832,
            "name": "Marano di Valpolicella",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "E911",
            "cod_istat": "023046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2865,
            "area": "",
            "ech": 0
        },
        {
            "id": 3833,
            "name": "Marano Equo",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "E908",
            "cod_istat": "058055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2013,
            "area": "",
            "ech": 0
        },
        {
            "id": 3834,
            "name": "Marano Lagunare",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "E910",
            "cod_istat": "030056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 3835,
            "name": "Marano Marchesato",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "E914",
            "cod_istat": "078076",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 3836,
            "name": "Marano Principato",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "E915",
            "cod_istat": "078077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 1791,
            "area": "",
            "ech": 0
        },
        {
            "id": 3837,
            "name": "Marano sul Panaro",
            "provincia": "MO",
            "cap": "41054",
            "cod_catastale": "E905",
            "cod_istat": "036020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2373,
            "area": "",
            "ech": 0
        },
        {
            "id": 3838,
            "name": "Marano Ticino",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "E907",
            "cod_istat": "003091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2745,
            "area": "",
            "ech": 0
        },
        {
            "id": 3839,
            "name": "Marano Vicentino",
            "provincia": "VI",
            "cap": "36035",
            "cod_catastale": "E912",
            "cod_istat": "024056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 3840,
            "name": "Maranzana",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "E917",
            "cod_istat": "005061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 3841,
            "name": "Maratea",
            "provincia": "PZ",
            "cap": "85046",
            "cod_catastale": "E919",
            "cod_istat": "076044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1325,
            "area": "",
            "ech": 0
        },
        {
            "id": 3842,
            "name": "Marcallo con Casone",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "E921",
            "cod_istat": "015134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 3843,
            "name": "Marcaria",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "E922",
            "cod_istat": "020031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3844,
            "name": "Marcedusa",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "E923",
            "cod_istat": "079071",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 1310,
            "area": "",
            "ech": 0
        },
        {
            "id": 3845,
            "name": "Marcellina",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "E924",
            "cod_istat": "058056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 1865,
            "area": "",
            "ech": 0
        },
        {
            "id": 3846,
            "name": "Marcellinara",
            "provincia": "CZ",
            "cap": "88044",
            "cod_catastale": "E925",
            "cod_istat": "079072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 1363,
            "area": "",
            "ech": 0
        },
        {
            "id": 3847,
            "name": "Marcetelli",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "E927",
            "cod_istat": "057036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 930,
            "giorni": 3057,
            "area": "",
            "ech": 0
        },
        {
            "id": 3848,
            "name": "Marcheno",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "E928",
            "cod_istat": "017104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2767,
            "area": "",
            "ech": 0
        },
        {
            "id": 3849,
            "name": "Marchirolo",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "E929",
            "cod_istat": "012097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2736,
            "area": "",
            "ech": 0
        },
        {
            "id": 3850,
            "name": "Marciana",
            "provincia": "LI",
            "cap": "57030",
            "cod_catastale": "E930",
            "cod_istat": "049010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 1546,
            "area": "",
            "ech": 0
        },
        {
            "id": 3851,
            "name": "Marciana Marina",
            "provincia": "LI",
            "cap": "57033",
            "cod_catastale": "E931",
            "cod_istat": "049011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 989,
            "area": "",
            "ech": 0
        },
        {
            "id": 3852,
            "name": "Marcianise",
            "provincia": "CE",
            "cap": "81025",
            "cod_catastale": "E932",
            "cod_istat": "061049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 1107,
            "area": "",
            "ech": 0
        },
        {
            "id": 3853,
            "name": "Marciano della Chiana",
            "provincia": "AR",
            "cap": "52047",
            "cod_catastale": "E933",
            "cod_istat": "051022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2124,
            "area": "",
            "ech": 0
        },
        {
            "id": 3854,
            "name": "Marcignago",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "E934",
            "cod_istat": "018086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3855,
            "name": "Marcon",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "E936",
            "cod_istat": "027020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 3856,
            "name": "Marebbe",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "E938",
            "cod_istat": "021047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1285,
            "giorni": 4411,
            "area": "",
            "ech": 0
        },
        {
            "id": 3857,
            "name": "Marene",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "E939",
            "cod_istat": "004117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2639,
            "area": "",
            "ech": 0
        },
        {
            "id": 3858,
            "name": "Mareno di Piave",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "E940",
            "cod_istat": "026038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 3859,
            "name": "Marentino",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "E941",
            "cod_istat": "001144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2928,
            "area": "",
            "ech": 0
        },
        {
            "id": 3860,
            "name": "Maretto",
            "provincia": "AT",
            "cap": "14018",
            "cod_catastale": "E944",
            "cod_istat": "005062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2684,
            "area": "",
            "ech": 0
        },
        {
            "id": 3861,
            "name": "Margarita",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "E945",
            "cod_istat": "004118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 448,
            "giorni": 2871,
            "area": "",
            "ech": 0
        },
        {
            "id": 3862,
            "name": "Margherita di Savoia",
            "provincia": "BT",
            "cap": "76016",
            "cod_catastale": "E946",
            "cod_istat": "110005",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 1284,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3863,
            "name": "Margno",
            "provincia": "LC",
            "cap": "23832",
            "cod_catastale": "E947",
            "cod_istat": "097047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 3106,
            "area": "",
            "ech": 0
        },
        {
            "id": 3864,
            "name": "Mariana Mantovana",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "E949",
            "cod_istat": "020032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3865,
            "name": "Mariano Comense",
            "provincia": "CO",
            "cap": "22066",
            "cod_catastale": "E951",
            "cod_istat": "013143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 3866,
            "name": "Mariano del Friuli",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "E952",
            "cod_istat": "031010",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 3867,
            "name": "Marianopoli",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "E953",
            "cod_istat": "085008",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 720,
            "giorni": 1754,
            "area": "",
            "ech": 1
        },
        {
            "id": 3868,
            "name": "Mariglianella",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "E954",
            "cod_istat": "063042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1130,
            "area": "",
            "ech": 0
        },
        {
            "id": 3869,
            "name": "Marigliano",
            "provincia": "NA",
            "cap": "80034",
            "cod_catastale": "E955",
            "cod_istat": "063043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1014,
            "area": "",
            "ech": 0
        },
        {
            "id": 3870,
            "name": "Marina di Gioiosa Ionica",
            "provincia": "RC",
            "cap": "89046",
            "cod_catastale": "E956",
            "cod_istat": "080045",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 780,
            "area": "",
            "ech": 1
        },
        {
            "id": 3871,
            "name": "Marineo",
            "provincia": "PA",
            "cap": "90035",
            "cod_catastale": "E957",
            "cod_istat": "082046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 531,
            "giorni": 1522,
            "area": "",
            "ech": 0
        },
        {
            "id": 3872,
            "name": "Marino",
            "provincia": "RM",
            "cap": "00047",
            "cod_catastale": "E958",
            "cod_istat": "058057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 3873,
            "name": "Marlengo",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "E959",
            "cod_istat": "021048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 3874,
            "name": "Marliana",
            "provincia": "PT",
            "cap": "51010",
            "cod_catastale": "E960",
            "cod_istat": "047007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 469,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 3875,
            "name": "Marmentino",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "E961",
            "cod_istat": "017105",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 875,
            "giorni": 3461,
            "area": "",
            "ech": 0
        },
        {
            "id": 3876,
            "name": "Marmirolo",
            "provincia": "MN",
            "cap": "46045",
            "cod_catastale": "E962",
            "cod_istat": "020033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 3877,
            "name": "Marmora",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "E963",
            "cod_istat": "004119",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1225,
            "giorni": 3835,
            "area": "",
            "ech": 0
        },
        {
            "id": 3878,
            "name": "Marnate",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "E965",
            "cod_istat": "012098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2862,
            "area": "",
            "ech": 0
        },
        {
            "id": 3879,
            "name": "Marone",
            "provincia": "BS",
            "cap": "25054",
            "cod_catastale": "E967",
            "cod_istat": "017106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 3880,
            "name": "Maropati",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "E968",
            "cod_istat": "080046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 1154,
            "area": "",
            "ech": 0
        },
        {
            "id": 3881,
            "name": "Marostica",
            "provincia": "VI",
            "cap": "36063",
            "cod_catastale": "E970",
            "cod_istat": "024057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 3882,
            "name": "Marradi",
            "provincia": "FI",
            "cap": "50034",
            "cod_catastale": "E971",
            "cod_istat": "048026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2267,
            "area": "",
            "ech": 0
        },
        {
            "id": 3883,
            "name": "Marrubiu",
            "provincia": "OR",
            "cap": "09094",
            "cod_catastale": "E972",
            "cod_istat": "095025",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 7,
            "giorni": 986,
            "area": "",
            "ech": 0
        },
        {
            "id": 3884,
            "name": "Marsaglia",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "E973",
            "cod_istat": "004120",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 607,
            "giorni": 3068,
            "area": "",
            "ech": 0
        },
        {
            "id": 3885,
            "name": "Marsala",
            "provincia": "TP",
            "cap": "91025",
            "cod_catastale": "E974",
            "cod_istat": "081011",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 816,
            "area": "",
            "ech": 1
        },
        {
            "id": 3886,
            "name": "Marsciano",
            "provincia": "PG",
            "cap": "06055",
            "cod_catastale": "E975",
            "cod_istat": "054027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 1978,
            "area": "",
            "ech": 0
        },
        {
            "id": 3887,
            "name": "Marsico Nuovo",
            "provincia": "PZ",
            "cap": "85052",
            "cod_catastale": "E976",
            "cod_istat": "076045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 865,
            "giorni": 2482,
            "area": "",
            "ech": 0
        },
        {
            "id": 3888,
            "name": "Marsicovetere",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "E977",
            "cod_istat": "076046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1037,
            "giorni": 2801,
            "area": "",
            "ech": 0
        },
        {
            "id": 3889,
            "name": "Marta",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "E978",
            "cod_istat": "056034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 1980,
            "area": "",
            "ech": 0
        },
        {
            "id": 3890,
            "name": "Martano",
            "provincia": "LE",
            "cap": "73025",
            "cod_catastale": "E979",
            "cod_istat": "075040",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 1253,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3891,
            "name": "Martellago",
            "provincia": "VE",
            "cap": "30030",
            "cod_catastale": "E980",
            "cod_istat": "027021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 3892,
            "name": "Martello",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "E981",
            "cod_istat": "021049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1312,
            "giorni": 4369,
            "area": "",
            "ech": 0
        },
        {
            "id": 3893,
            "name": "Martignacco",
            "provincia": "UD",
            "cap": "33035",
            "cod_catastale": "E982",
            "cod_istat": "030057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 3894,
            "name": "Martignana di Po",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "E983",
            "cod_istat": "019057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 3895,
            "name": "Martignano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "E984",
            "cod_istat": "075041",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1216,
            "area": "",
            "ech": 0
        },
        {
            "id": 3896,
            "name": "Martina Franca",
            "provincia": "TA",
            "cap": "74015",
            "cod_catastale": "E986",
            "cod_istat": "073013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 431,
            "giorni": 1844,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3897,
            "name": "Martinengo",
            "provincia": "BG",
            "cap": "24057",
            "cod_catastale": "E987",
            "cod_istat": "016133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 3898,
            "name": "Martiniana Po",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "E988",
            "cod_istat": "004121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2885,
            "area": "",
            "ech": 0
        },
        {
            "id": 3899,
            "name": "Martinsicuro",
            "provincia": "TE",
            "cap": "64014",
            "cod_catastale": "E989",
            "cod_istat": "067047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1201,
            "area": "",
            "ech": 0
        },
        {
            "id": 3900,
            "name": "Martirano",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "E990",
            "cod_istat": "079073",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 3901,
            "name": "Martirano Lombardo",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "E991",
            "cod_istat": "079074",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 3902,
            "name": "Martis",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "E992",
            "cod_istat": "090039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1475,
            "area": "",
            "ech": 0
        },
        {
            "id": 3903,
            "name": "Martone",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "E993",
            "cod_istat": "080047",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 290,
            "giorni": 1218,
            "area": "",
            "ech": 0
        },
        {
            "id": 3904,
            "name": "Marudo",
            "provincia": "LO",
            "cap": "26866",
            "cod_catastale": "E994",
            "cod_istat": "098036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 3905,
            "name": "Maruggio",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "E995",
            "cod_istat": "073014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 1103,
            "area": "",
            "ech": 0
        },
        {
            "id": 3906,
            "name": "Marzabotto",
            "provincia": "BO",
            "cap": "40043",
            "cod_catastale": "B689",
            "cod_istat": "037036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2341,
            "area": "",
            "ech": 0
        },
        {
            "id": 3907,
            "name": "Marzano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E999",
            "cod_istat": "018087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 3908,
            "name": "Marzano Appio",
            "provincia": "CE",
            "cap": "81035",
            "cod_catastale": "E998",
            "cod_istat": "061050",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 318,
            "giorni": 1685,
            "area": "",
            "ech": 0
        },
        {
            "id": 3909,
            "name": "Marzano di Nola",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "E997",
            "cod_istat": "064047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1217,
            "area": "",
            "ech": 0
        },
        {
            "id": 3910,
            "name": "Marzi",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "F001",
            "cod_istat": "078078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 1861,
            "area": "",
            "ech": 0
        },
        {
            "id": 3911,
            "name": "Marzio",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "F002",
            "cod_istat": "012099",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 3142,
            "area": "",
            "ech": 0
        },
        {
            "id": 3912,
            "name": "Masainas",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "M270",
            "cod_istat": "111040",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 990,
            "area": "",
            "ech": 0
        },
        {
            "id": 3913,
            "name": "Masate",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "F003",
            "cod_istat": "015136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 153,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 3914,
            "name": "Mascali",
            "provincia": "CT",
            "cap": "95016",
            "cod_catastale": "F004",
            "cod_istat": "087023",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 869,
            "area": "",
            "ech": 1
        },
        {
            "id": 3915,
            "name": "Mascalucia",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "F005",
            "cod_istat": "087024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1271,
            "area": "",
            "ech": 1
        },
        {
            "id": 3916,
            "name": "Maschito",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "F006",
            "cod_istat": "076047",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 595,
            "giorni": 1991,
            "area": "",
            "ech": 0
        },
        {
            "id": 3917,
            "name": "Masciago Primo",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "F007",
            "cod_istat": "012100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 2599,
            "area": "",
            "ech": 0
        },
        {
            "id": 3918,
            "name": "Maser",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "F009",
            "cod_istat": "026039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 3919,
            "name": "Masera",
            "provincia": "VB",
            "cap": "28855",
            "cod_catastale": "F010",
            "cod_istat": "103042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 3920,
            "name": "Maserà di Padova",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "F011",
            "cod_istat": "028048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 3921,
            "name": "Maserada sul Piave",
            "provincia": "TV",
            "cap": "31052",
            "cod_catastale": "F012",
            "cod_istat": "026040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 3922,
            "name": "Masi",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "F013",
            "cod_istat": "028049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3923,
            "name": "Masi Torello",
            "provincia": "FE",
            "cap": "44020",
            "cod_catastale": "F016",
            "cod_istat": "038012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 3924,
            "name": "Masio",
            "provincia": "AL",
            "cap": "15024",
            "cod_catastale": "F015",
            "cod_istat": "006091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2528,
            "area": "",
            "ech": 0
        },
        {
            "id": 3925,
            "name": "Maslianico",
            "provincia": "CO",
            "cap": "22026",
            "cod_catastale": "F017",
            "cod_istat": "013144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 3926,
            "name": "Mason Vicentino",
            "provincia": "VI",
            "cap": "36064",
            "cod_catastale": "F019",
            "cod_istat": "024058",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2407,
            "area": "",
            "ech": 0
        },
        {
            "id": 3927,
            "name": "Masone",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "F020",
            "cod_istat": "010032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 403,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 3928,
            "name": "Massa",
            "provincia": "MS",
            "cap": "54100",
            "cod_catastale": "F023",
            "cod_istat": "045010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 1525,
            "area": "",
            "ech": 0
        },
        {
            "id": 3929,
            "name": "Massa d'Albe",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "F022",
            "cod_istat": "066054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 865,
            "giorni": 2837,
            "area": "",
            "ech": 0
        },
        {
            "id": 3930,
            "name": "Massa di Somma",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "M289",
            "cod_istat": "063092",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 1273,
            "area": "",
            "ech": 0
        },
        {
            "id": 3931,
            "name": "Massa e Cozzile",
            "provincia": "PT",
            "cap": "51010",
            "cod_catastale": "F025",
            "cod_istat": "047008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 2509,
            "area": "",
            "ech": 0
        },
        {
            "id": 3932,
            "name": "Massa Fermana",
            "provincia": "FM",
            "cap": "63834",
            "cod_catastale": "F021",
            "cod_istat": "109011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2037,
            "area": "",
            "ech": 0
        },
        {
            "id": 3933,
            "name": "Massa Fiscaglia",
            "provincia": "FE",
            "cap": "44025",
            "cod_catastale": "F026",
            "cod_istat": "038013",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 3934,
            "name": "Massa Lombarda",
            "provincia": "RA",
            "cap": "48024",
            "cod_catastale": "F029",
            "cod_istat": "039013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 3935,
            "name": "Massa Lubrense",
            "provincia": "NA",
            "cap": "80061",
            "cod_catastale": "F030",
            "cod_istat": "063044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 1079,
            "area": "",
            "ech": 0
        },
        {
            "id": 3936,
            "name": "Massa Marittima",
            "provincia": "GR",
            "cap": "58024",
            "cod_catastale": "F032",
            "cod_istat": "053015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2129,
            "area": "",
            "ech": 0
        },
        {
            "id": 3937,
            "name": "Massa Martana",
            "provincia": "PG",
            "cap": "06056",
            "cod_catastale": "F024",
            "cod_istat": "054028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 3938,
            "name": "Massafra",
            "provincia": "TA",
            "cap": "74016",
            "cod_catastale": "F027",
            "cod_istat": "073015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1123,
            "area": "",
            "ech": 0
        },
        {
            "id": 3939,
            "name": "Massalengo",
            "provincia": "LO",
            "cap": "26815",
            "cod_catastale": "F028",
            "cod_istat": "098037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 3940,
            "name": "Massanzago",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "F033",
            "cod_istat": "028050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 3941,
            "name": "Massarosa",
            "provincia": "LU",
            "cap": "55054",
            "cod_catastale": "F035",
            "cod_istat": "046018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1433,
            "area": "",
            "ech": 0
        },
        {
            "id": 3942,
            "name": "Massazza",
            "provincia": "BI",
            "cap": "13873",
            "cod_catastale": "F037",
            "cod_istat": "096031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2598,
            "area": "",
            "ech": 0
        },
        {
            "id": 3943,
            "name": "Massello",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "F041",
            "cod_istat": "001145",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1188,
            "giorni": 3832,
            "area": "",
            "ech": 0
        },
        {
            "id": 3944,
            "name": "Masserano",
            "provincia": "BI",
            "cap": "13866",
            "cod_catastale": "F042",
            "cod_istat": "096032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 3945,
            "name": "Massignano",
            "provincia": "AP",
            "cap": "63061",
            "cod_catastale": "F044",
            "cod_istat": "044029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 1880,
            "area": "",
            "ech": 0
        },
        {
            "id": 3946,
            "name": "Massimeno",
            "provincia": "TN",
            "cap": "38086",
            "cod_catastale": "F045",
            "cod_istat": "022112",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 861,
            "giorni": 3734,
            "area": "",
            "ech": 0
        },
        {
            "id": 3947,
            "name": "Massimino",
            "provincia": "SV",
            "cap": "12071",
            "cod_catastale": "F046",
            "cod_istat": "009037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 527,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 3948,
            "name": "Massino Visconti",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "F047",
            "cod_istat": "003093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 3949,
            "name": "Massiola",
            "provincia": "VB",
            "cap": "28895",
            "cod_catastale": "F048",
            "cod_istat": "103043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 772,
            "giorni": 3308,
            "area": "",
            "ech": 0
        },
        {
            "id": 3950,
            "name": "Masullas",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "F050",
            "cod_istat": "095026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 1121,
            "area": "",
            "ech": 0
        },
        {
            "id": 3951,
            "name": "Matelica",
            "provincia": "MC",
            "cap": "62024",
            "cod_catastale": "F051",
            "cod_istat": "043024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 354,
            "giorni": 2054,
            "area": "",
            "ech": 0
        },
        {
            "id": 3952,
            "name": "Matera",
            "provincia": "MT",
            "cap": "75100",
            "cod_catastale": "F052",
            "cod_istat": "077014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 401,
            "giorni": 1776,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3953,
            "name": "Mathi",
            "provincia": "TO",
            "cap": "10075",
            "cod_catastale": "F053",
            "cod_istat": "001146",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 3005,
            "area": "",
            "ech": 0
        },
        {
            "id": 3954,
            "name": "Matino",
            "provincia": "LE",
            "cap": "73046",
            "cod_catastale": "F054",
            "cod_istat": "075042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1073,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3955,
            "name": "Matrice",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "F055",
            "cod_istat": "070037",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 690,
            "giorni": 2237,
            "area": "",
            "ech": 0
        },
        {
            "id": 3956,
            "name": "Mattie",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "F058",
            "cod_istat": "001147",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 3449,
            "area": "",
            "ech": 0
        },
        {
            "id": 3957,
            "name": "Mattinata",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "F059",
            "cod_istat": "071031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 75,
            "giorni": 1404,
            "area": "",
            "ech": 0
        },
        {
            "id": 3958,
            "name": "Mazara del Vallo",
            "provincia": "TP",
            "cap": "91026",
            "cod_catastale": "F061",
            "cod_istat": "081012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 927,
            "area": "",
            "ech": 1
        },
        {
            "id": 3959,
            "name": "Mazzano",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "F063",
            "cod_istat": "017107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 3960,
            "name": "Mazzano Romano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "F064",
            "cod_istat": "058058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1649,
            "area": "",
            "ech": 0
        },
        {
            "id": 3961,
            "name": "Mazzarino",
            "provincia": "CL",
            "cap": "93013",
            "cod_catastale": "F065",
            "cod_istat": "085009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 553,
            "giorni": 1544,
            "area": "",
            "ech": 1
        },
        {
            "id": 3962,
            "name": "Mazzarrà Sant'Andrea",
            "provincia": "ME",
            "cap": "98056",
            "cod_catastale": "F066",
            "cod_istat": "083046",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 814,
            "area": "",
            "ech": 0
        },
        {
            "id": 3963,
            "name": "Mazzarrone",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "M271",
            "cod_istat": "087056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 1182,
            "area": "",
            "ech": 1
        },
        {
            "id": 3964,
            "name": "Mazzè",
            "provincia": "TO",
            "cap": "10035",
            "cod_catastale": "F067",
            "cod_istat": "001148",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 2838,
            "area": "",
            "ech": 0
        },
        {
            "id": 3965,
            "name": "Mazzin",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "F068",
            "cod_istat": "022113",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1382,
            "giorni": 4773,
            "area": "",
            "ech": 0
        },
        {
            "id": 3966,
            "name": "Mazzo di Valtellina",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "F070",
            "cod_istat": "014040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 3032,
            "area": "",
            "ech": 0
        },
        {
            "id": 3967,
            "name": "Meana di Susa",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "F074",
            "cod_istat": "001149",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 681,
            "giorni": 3390,
            "area": "",
            "ech": 0
        },
        {
            "id": 3968,
            "name": "Meana Sardo",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "F073",
            "cod_istat": "091047",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 588,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 3969,
            "name": "Meda",
            "provincia": "MB",
            "cap": "20821",
            "cod_catastale": "F078",
            "cod_istat": "108030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 3970,
            "name": "Mede",
            "provincia": "PV",
            "cap": "27035",
            "cod_catastale": "F080",
            "cod_istat": "018088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 3971,
            "name": "Medea",
            "provincia": "GO",
            "cap": "34076",
            "cod_catastale": "F081",
            "cod_istat": "031011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2289,
            "area": "",
            "ech": 0
        },
        {
            "id": 3972,
            "name": "Medesano",
            "provincia": "PR",
            "cap": "43014",
            "cod_catastale": "F082",
            "cod_istat": "034020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 3973,
            "name": "Medicina",
            "provincia": "BO",
            "cap": "40059",
            "cod_catastale": "F083",
            "cod_istat": "037037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2261,
            "area": "",
            "ech": 0
        },
        {
            "id": 3974,
            "name": "Mediglia",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "F084",
            "cod_istat": "015139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3975,
            "name": "Medolago",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "F085",
            "cod_istat": "016250",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2419,
            "area": "",
            "ech": 0
        },
        {
            "id": 3976,
            "name": "Medole",
            "provincia": "MN",
            "cap": "46046",
            "cod_catastale": "F086",
            "cod_istat": "020034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 3977,
            "name": "Medolla",
            "provincia": "MO",
            "cap": "41036",
            "cod_catastale": "F087",
            "cod_istat": "036021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 3978,
            "name": "Meduna di Livenza",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "F088",
            "cod_istat": "026041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 3979,
            "name": "Meduno",
            "provincia": "PN",
            "cap": "33092",
            "cod_catastale": "F089",
            "cod_istat": "093026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2904,
            "area": "",
            "ech": 0
        },
        {
            "id": 3980,
            "name": "Megliadino San Fidenzio",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "F091",
            "cod_istat": "028051",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 3981,
            "name": "Megliadino San Vitale",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "F092",
            "cod_istat": "028052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 3982,
            "name": "Meina",
            "provincia": "NO",
            "cap": "28046",
            "cod_catastale": "F093",
            "cod_istat": "003095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2583,
            "area": "",
            "ech": 0
        },
        {
            "id": 3983,
            "name": "Mel",
            "provincia": "BL",
            "cap": "32026",
            "cod_catastale": "F094",
            "cod_istat": "025034",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 3140,
            "area": "",
            "ech": 0
        },
        {
            "id": 3984,
            "name": "Melara",
            "provincia": "RO",
            "cap": "45037",
            "cod_catastale": "F095",
            "cod_istat": "029032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 3985,
            "name": "Melazzo",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F096",
            "cod_istat": "006092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 3986,
            "name": "Meldola",
            "provincia": "FC",
            "cap": "47014",
            "cod_catastale": "F097",
            "cod_istat": "040019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 2225,
            "area": "",
            "ech": 0
        },
        {
            "id": 3987,
            "name": "Mele",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "F098",
            "cod_istat": "010033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1845,
            "area": "",
            "ech": 0
        },
        {
            "id": 3988,
            "name": "Melegnano",
            "provincia": "MI",
            "cap": "20077",
            "cod_catastale": "F100",
            "cod_istat": "015140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 3989,
            "name": "Melendugno",
            "provincia": "LE",
            "cap": "73026",
            "cod_catastale": "F101",
            "cod_istat": "075043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1147,
            "area": "",
            "ech": 0
        },
        {
            "id": 3990,
            "name": "Meleti",
            "provincia": "LO",
            "cap": "26843",
            "cod_catastale": "F102",
            "cod_istat": "098038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 3991,
            "name": "Melfi",
            "provincia": "PZ",
            "cap": "85025",
            "cod_catastale": "F104",
            "cod_istat": "076048",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 1841,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3992,
            "name": "Melicuccà",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "F105",
            "cod_istat": "080048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 981,
            "area": "",
            "ech": 0
        },
        {
            "id": 3993,
            "name": "Melicucco",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "F106",
            "cod_istat": "080049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 167,
            "giorni": 1003,
            "area": "",
            "ech": 0
        },
        {
            "id": 3994,
            "name": "Melilli",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "F107",
            "cod_istat": "089012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1133,
            "area": "",
            "ech": 1
        },
        {
            "id": 3995,
            "name": "Melissa",
            "provincia": "KR",
            "cap": "88814",
            "cod_catastale": "F108",
            "cod_istat": "101014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 1287,
            "area": "",
            "ech": 1
        },
        {
            "id": 3996,
            "name": "Melissano",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "F109",
            "cod_istat": "075044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 1100,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 3997,
            "name": "Melito di Napoli",
            "provincia": "NA",
            "cap": "80017",
            "cod_catastale": "F111",
            "cod_istat": "063045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1194,
            "area": "",
            "ech": 0
        },
        {
            "id": 3998,
            "name": "Melito di Porto Salvo",
            "provincia": "RC",
            "cap": "89063",
            "cod_catastale": "F112",
            "cod_istat": "080050",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 805,
            "area": "",
            "ech": 1
        },
        {
            "id": 3999,
            "name": "Melito Irpino",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "F110",
            "cod_istat": "064048",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 242,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 4000,
            "name": "Melizzano",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "F113",
            "cod_istat": "062039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 190,
            "giorni": 1461,
            "area": "",
            "ech": 0
        },
        {
            "id": 4001,
            "name": "Melle",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "F114",
            "cod_istat": "004122",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 683,
            "giorni": 3162,
            "area": "",
            "ech": 0
        },
        {
            "id": 4002,
            "name": "Mello",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "F115",
            "cod_istat": "014041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 681,
            "giorni": 3037,
            "area": "",
            "ech": 0
        },
        {
            "id": 4003,
            "name": "Melpignano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "F117",
            "cod_istat": "075045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1250,
            "area": "",
            "ech": 0
        },
        {
            "id": 4004,
            "name": "Meltina",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "F118",
            "cod_istat": "021050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1142,
            "giorni": 4186,
            "area": "",
            "ech": 0
        },
        {
            "id": 4005,
            "name": "Melzo",
            "provincia": "MI",
            "cap": "20066",
            "cod_catastale": "F119",
            "cod_istat": "015142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4006,
            "name": "Menaggio",
            "provincia": "CO",
            "cap": "22017",
            "cod_catastale": "F120",
            "cod_istat": "013145",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2222,
            "area": "",
            "ech": 0
        },
        {
            "id": 4007,
            "name": "Menarola",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "F121",
            "cod_istat": "014042",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 3092,
            "area": "",
            "ech": 0
        },
        {
            "id": 4008,
            "name": "Menconico",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "F122",
            "cod_istat": "018089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 3420,
            "area": "",
            "ech": 0
        },
        {
            "id": 4009,
            "name": "Mendatica",
            "provincia": "IM",
            "cap": "18025",
            "cod_catastale": "F123",
            "cod_istat": "008034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 778,
            "giorni": 3235,
            "area": "",
            "ech": 0
        },
        {
            "id": 4010,
            "name": "Mendicino",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "F125",
            "cod_istat": "078079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1799,
            "area": "",
            "ech": 1
        },
        {
            "id": 4011,
            "name": "Menfi",
            "provincia": "AG",
            "cap": "92013",
            "cod_catastale": "F126",
            "cod_istat": "084023",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 825,
            "area": "",
            "ech": 1
        },
        {
            "id": 4012,
            "name": "Mentana",
            "provincia": "RM",
            "cap": "00013",
            "cod_catastale": "F127",
            "cod_istat": "058059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1641,
            "area": "",
            "ech": 0
        },
        {
            "id": 4013,
            "name": "Meolo",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "F130",
            "cod_istat": "027022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 4014,
            "name": "Merana",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F131",
            "cod_istat": "006093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2523,
            "area": "",
            "ech": 0
        },
        {
            "id": 4015,
            "name": "Merano",
            "provincia": "BZ",
            "cap": "39012",
            "cod_catastale": "F132",
            "cod_istat": "021051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2863,
            "area": "",
            "ech": 0
        },
        {
            "id": 4016,
            "name": "Merate",
            "provincia": "LC",
            "cap": "23807",
            "cod_catastale": "F133",
            "cod_istat": "097048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 4017,
            "name": "Mercallo",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "F134",
            "cod_istat": "012101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2840,
            "area": "",
            "ech": 0
        },
        {
            "id": 4018,
            "name": "Mercatello sul Metauro",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "F135",
            "cod_istat": "041025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2491,
            "area": "",
            "ech": 0
        },
        {
            "id": 4019,
            "name": "Mercatino Conca",
            "provincia": "PU",
            "cap": "61013",
            "cod_catastale": "F136",
            "cod_istat": "041026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2294,
            "area": "",
            "ech": 0
        },
        {
            "id": 4020,
            "name": "Mercato San Severino",
            "provincia": "SA",
            "cap": "84085",
            "cod_catastale": "F138",
            "cod_istat": "065067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 146,
            "giorni": 1171,
            "area": "",
            "ech": 0
        },
        {
            "id": 4021,
            "name": "Mercato Saraceno",
            "provincia": "FC",
            "cap": "47025",
            "cod_catastale": "F139",
            "cod_istat": "040020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 4022,
            "name": "Mercenasco",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "F140",
            "cod_istat": "001150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2587,
            "area": "",
            "ech": 0
        },
        {
            "id": 4023,
            "name": "Mercogliano",
            "provincia": "AV",
            "cap": "83013",
            "cod_catastale": "F141",
            "cod_istat": "064049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 2005,
            "area": "",
            "ech": 0
        },
        {
            "id": 4024,
            "name": "Mereto di Tomba",
            "provincia": "UD",
            "cap": "33036",
            "cod_catastale": "F144",
            "cod_istat": "030058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2292,
            "area": "",
            "ech": 0
        },
        {
            "id": 4025,
            "name": "Mergo",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "F145",
            "cod_istat": "042024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 2141,
            "area": "",
            "ech": 0
        },
        {
            "id": 4026,
            "name": "Mergozzo",
            "provincia": "VB",
            "cap": "28802",
            "cod_catastale": "F146",
            "cod_istat": "103044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 4027,
            "name": "Merì",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "F147",
            "cod_istat": "083047",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 736,
            "area": "",
            "ech": 1
        },
        {
            "id": 4028,
            "name": "Merlara",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "F148",
            "cod_istat": "028053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 4029,
            "name": "Merlino",
            "provincia": "LO",
            "cap": "26833",
            "cod_catastale": "F149",
            "cod_istat": "098039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4030,
            "name": "Merone",
            "provincia": "CO",
            "cap": "22046",
            "cod_catastale": "F151",
            "cod_istat": "013147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 4031,
            "name": "Mesagne",
            "provincia": "BR",
            "cap": "72023",
            "cod_catastale": "F152",
            "cod_istat": "074010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1237,
            "area": "",
            "ech": 0
        },
        {
            "id": 4032,
            "name": "Mese",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "F153",
            "cod_istat": "014043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 4033,
            "name": "Mesenzana",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "F154",
            "cod_istat": "012102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 4034,
            "name": "Mesero",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "F155",
            "cod_istat": "015144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2609,
            "area": "",
            "ech": 0
        },
        {
            "id": 4035,
            "name": "Mesola",
            "provincia": "FE",
            "cap": "44026",
            "cod_catastale": "F156",
            "cod_istat": "038014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 4036,
            "name": "Mesoraca",
            "provincia": "KR",
            "cap": "88838",
            "cod_catastale": "F157",
            "cod_istat": "101015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 415,
            "giorni": 1671,
            "area": "",
            "ech": 0
        },
        {
            "id": 4037,
            "name": "Messina",
            "provincia": "ME",
            "cap": "981xx",
            "cod_catastale": "F158",
            "cod_istat": "083048",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 3,
            "giorni": 707,
            "area": "",
            "ech": 1
        },
        {
            "id": 4038,
            "name": "Mestrino",
            "provincia": "PD",
            "cap": "35035",
            "cod_catastale": "F161",
            "cod_istat": "028054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4039,
            "name": "Meta",
            "provincia": "NA",
            "cap": "80062",
            "cod_catastale": "F162",
            "cod_istat": "063046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 1146,
            "area": "",
            "ech": 0
        },
        {
            "id": 4040,
            "name": "Meugliano",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "F164",
            "cod_istat": "001151",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 3258,
            "area": "",
            "ech": 0
        },
        {
            "id": 4041,
            "name": "Mezzago",
            "provincia": "MB",
            "cap": "20883",
            "cod_catastale": "F165",
            "cod_istat": "108031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 4042,
            "name": "Mezzana",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "F168",
            "cod_istat": "022114",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 940,
            "giorni": 3859,
            "area": "",
            "ech": 0
        },
        {
            "id": 4043,
            "name": "Mezzana Bigli",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "F170",
            "cod_istat": "018090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4044,
            "name": "Mezzana Mortigliengo",
            "provincia": "BI",
            "cap": "13831",
            "cod_catastale": "F167",
            "cod_istat": "096033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2584,
            "area": "",
            "ech": 0
        },
        {
            "id": 4045,
            "name": "Mezzana Rabattone",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "F171",
            "cod_istat": "018091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4046,
            "name": "Mezzane di Sotto",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "F172",
            "cod_istat": "023047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 4047,
            "name": "Mezzanego",
            "provincia": "GE",
            "cap": "16046",
            "cod_catastale": "F173",
            "cod_istat": "010034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 1845,
            "area": "",
            "ech": 0
        },
        {
            "id": 4048,
            "name": "Mezzani",
            "provincia": "PR",
            "cap": "43055",
            "cod_catastale": "F174",
            "cod_istat": "034021",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 4049,
            "name": "Mezzanino",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "F175",
            "cod_istat": "018092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 4050,
            "name": "Mezzano",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "F176",
            "cod_istat": "022115",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4051,
            "name": "Mezzegra",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "F181",
            "cod_istat": "013148",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2226,
            "area": "",
            "ech": 0
        },
        {
            "id": 4052,
            "name": "Mezzenile",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "F182",
            "cod_istat": "001152",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 3329,
            "area": "",
            "ech": 0
        },
        {
            "id": 4053,
            "name": "Mezzocorona",
            "provincia": "TN",
            "cap": "38016",
            "cod_catastale": "F183",
            "cod_istat": "022116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 4054,
            "name": "Mezzojuso",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "F184",
            "cod_istat": "082047",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 534,
            "giorni": 1526,
            "area": "",
            "ech": 1
        },
        {
            "id": 4055,
            "name": "Mezzoldo",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "F186",
            "cod_istat": "016134",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 835,
            "giorni": 3255,
            "area": "",
            "ech": 0
        },
        {
            "id": 4056,
            "name": "Mezzolombardo",
            "provincia": "TN",
            "cap": "38017",
            "cod_catastale": "F187",
            "cod_istat": "022117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 4057,
            "name": "Mezzomerico",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "F188",
            "cod_istat": "003097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2650,
            "area": "",
            "ech": 0
        },
        {
            "id": 4058,
            "name": "Miagliano",
            "provincia": "BI",
            "cap": "13816",
            "cod_catastale": "F189",
            "cod_istat": "096034",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 541,
            "giorni": 3020,
            "area": "",
            "ech": 0
        },
        {
            "id": 4059,
            "name": "Miane",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "F190",
            "cod_istat": "026042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 259,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 4060,
            "name": "Miasino",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "F191",
            "cod_istat": "003098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 4061,
            "name": "Miazzina",
            "provincia": "VB",
            "cap": "28817",
            "cod_catastale": "F192",
            "cod_istat": "103045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 3242,
            "area": "",
            "ech": 0
        },
        {
            "id": 4062,
            "name": "Micigliano",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "F193",
            "cod_istat": "057037",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 925,
            "giorni": 3048,
            "area": "",
            "ech": 0
        },
        {
            "id": 4063,
            "name": "Miggiano",
            "provincia": "LE",
            "cap": "73035",
            "cod_catastale": "F194",
            "cod_istat": "075046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 1316,
            "area": "",
            "ech": 0
        },
        {
            "id": 4064,
            "name": "Miglianico",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "F196",
            "cod_istat": "069050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1384,
            "area": "",
            "ech": 0
        },
        {
            "id": 4065,
            "name": "Migliarino",
            "provincia": "FE",
            "cap": "44027",
            "cod_catastale": "F198",
            "cod_istat": "038015",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 4066,
            "name": "Migliaro",
            "provincia": "FE",
            "cap": "44020",
            "cod_catastale": "F199",
            "cod_istat": "038026",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 4067,
            "name": "Miglierina",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "F200",
            "cod_istat": "079077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 1799,
            "area": "",
            "ech": 0
        },
        {
            "id": 4068,
            "name": "Miglionico",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "F201",
            "cod_istat": "077015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 461,
            "giorni": 1757,
            "area": "",
            "ech": 0
        },
        {
            "id": 4069,
            "name": "Mignanego",
            "provincia": "GE",
            "cap": "16018",
            "cod_catastale": "F202",
            "cod_istat": "010035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 1962,
            "area": "",
            "ech": 0
        },
        {
            "id": 4070,
            "name": "Mignano Monte Lungo",
            "provincia": "CE",
            "cap": "81049",
            "cod_catastale": "F203",
            "cod_istat": "061051",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 137,
            "giorni": 1318,
            "area": "",
            "ech": 0
        },
        {
            "id": 4071,
            "name": "Milano",
            "provincia": "MI",
            "cap": "201xx",
            "cod_catastale": "F205",
            "cod_istat": "015146",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4072,
            "name": "Milazzo",
            "provincia": "ME",
            "cap": "98057",
            "cod_catastale": "F206",
            "cod_istat": "083049",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 628,
            "area": "",
            "ech": 1
        },
        {
            "id": 4073,
            "name": "Milena",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "E618",
            "cod_istat": "085010",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 436,
            "giorni": 1373,
            "area": "",
            "ech": 0
        },
        {
            "id": 4074,
            "name": "Mileto",
            "provincia": "VV",
            "cap": "89852",
            "cod_catastale": "F207",
            "cod_istat": "102021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 1241,
            "area": "",
            "ech": 1
        },
        {
            "id": 4075,
            "name": "Milis",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "F208",
            "cod_istat": "095027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1069,
            "area": "",
            "ech": 0
        },
        {
            "id": 4076,
            "name": "Militello in Val di Catania",
            "provincia": "CT",
            "cap": "95043",
            "cod_catastale": "F209",
            "cod_istat": "087025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 413,
            "giorni": 1284,
            "area": "",
            "ech": 1
        },
        {
            "id": 4077,
            "name": "Militello Rosmarino",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "F210",
            "cod_istat": "083050",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1345,
            "area": "",
            "ech": 0
        },
        {
            "id": 4078,
            "name": "Millesimo",
            "provincia": "SV",
            "cap": "17017",
            "cod_catastale": "F213",
            "cod_istat": "009038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2334,
            "area": "",
            "ech": 0
        },
        {
            "id": 4079,
            "name": "Milo",
            "provincia": "CT",
            "cap": "95010",
            "cod_catastale": "F214",
            "cod_istat": "087026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 1337,
            "area": "",
            "ech": 0
        },
        {
            "id": 4080,
            "name": "Milzano",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "F216",
            "cod_istat": "017108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 4081,
            "name": "Mineo",
            "provincia": "CT",
            "cap": "95044",
            "cod_catastale": "F217",
            "cod_istat": "087027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 511,
            "giorni": 1293,
            "area": "",
            "ech": 1
        },
        {
            "id": 4082,
            "name": "Minerbe",
            "provincia": "VR",
            "cap": "37046",
            "cod_catastale": "F218",
            "cod_istat": "023048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2419,
            "area": "",
            "ech": 0
        },
        {
            "id": 4083,
            "name": "Minerbio",
            "provincia": "BO",
            "cap": "40061",
            "cod_catastale": "F219",
            "cod_istat": "037038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2291,
            "area": "",
            "ech": 0
        },
        {
            "id": 4084,
            "name": "Minervino di Lecce",
            "provincia": "LE",
            "cap": "73027",
            "cod_catastale": "F221",
            "cod_istat": "075047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 1199,
            "area": "",
            "ech": 0
        },
        {
            "id": 4085,
            "name": "Minervino Murge",
            "provincia": "BT",
            "cap": "76013",
            "cod_catastale": "F220",
            "cod_istat": "110006",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 429,
            "giorni": 1798,
            "area": "",
            "ech": 0
        },
        {
            "id": 4086,
            "name": "Minori",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "F223",
            "cod_istat": "065068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1043,
            "area": "",
            "ech": 0
        },
        {
            "id": 4087,
            "name": "Minturno",
            "provincia": "LT",
            "cap": "04026",
            "cod_catastale": "F224",
            "cod_istat": "059014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 1334,
            "area": "",
            "ech": 0
        },
        {
            "id": 4088,
            "name": "Minucciano",
            "provincia": "LU",
            "cap": "55034",
            "cod_catastale": "F225",
            "cod_istat": "046019",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 697,
            "giorni": 3112,
            "area": "",
            "ech": 0
        },
        {
            "id": 4089,
            "name": "Mioglia",
            "provincia": "SV",
            "cap": "17040",
            "cod_catastale": "F226",
            "cod_istat": "009039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 354,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 4090,
            "name": "Mira",
            "provincia": "VE",
            "cap": "30034",
            "cod_catastale": "F229",
            "cod_istat": "027023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 4091,
            "name": "Mirabella Eclano",
            "provincia": "AV",
            "cap": "83036",
            "cod_catastale": "F230",
            "cod_istat": "064050",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 372,
            "giorni": 1869,
            "area": "",
            "ech": 0
        },
        {
            "id": 4092,
            "name": "Mirabella Imbaccari",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "F231",
            "cod_istat": "087028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 518,
            "giorni": 1430,
            "area": "",
            "ech": 1
        },
        {
            "id": 4093,
            "name": "Mirabello",
            "provincia": "FE",
            "cap": "44043",
            "cod_catastale": "F235",
            "cod_istat": "038016",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 4094,
            "name": "Mirabello Monferrato",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "F232",
            "cod_istat": "006094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 4095,
            "name": "Mirabello Sannitico",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "F233",
            "cod_istat": "070038",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2130,
            "area": "",
            "ech": 0
        },
        {
            "id": 4096,
            "name": "Miradolo Terme",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "F238",
            "cod_istat": "018093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 4097,
            "name": "Miranda",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "F239",
            "cod_istat": "094027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 860,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 4098,
            "name": "Mirandola",
            "provincia": "MO",
            "cap": "41037",
            "cod_catastale": "F240",
            "cod_istat": "036022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2193,
            "area": "",
            "ech": 0
        },
        {
            "id": 4099,
            "name": "Mirano",
            "provincia": "VE",
            "cap": "30035",
            "cod_catastale": "F241",
            "cod_istat": "027024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 4100,
            "name": "Mirto",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "F242",
            "cod_istat": "083051",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 428,
            "giorni": 1358,
            "area": "",
            "ech": 0
        },
        {
            "id": 4101,
            "name": "Misano Adriatico",
            "provincia": "RN",
            "cap": "47843",
            "cod_catastale": "F244",
            "cod_istat": "099005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2137,
            "area": "",
            "ech": 0
        },
        {
            "id": 4102,
            "name": "Misano di Gera d'Adda",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "F243",
            "cod_istat": "016135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4103,
            "name": "Misilmeri",
            "provincia": "PA",
            "cap": "90036",
            "cod_catastale": "F246",
            "cod_istat": "082048",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 897,
            "area": "",
            "ech": 0
        },
        {
            "id": 4104,
            "name": "Misinto",
            "provincia": "MB",
            "cap": "20826",
            "cod_catastale": "F247",
            "cod_istat": "108032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 4105,
            "name": "Missaglia",
            "provincia": "LC",
            "cap": "23873",
            "cod_catastale": "F248",
            "cod_istat": "097049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 2533,
            "area": "",
            "ech": 0
        },
        {
            "id": 4106,
            "name": "Missanello",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "F249",
            "cod_istat": "076049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 1999,
            "area": "",
            "ech": 0
        },
        {
            "id": 4107,
            "name": "Misterbianco",
            "provincia": "CT",
            "cap": "95045",
            "cod_catastale": "F250",
            "cod_istat": "087029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 1078,
            "area": "",
            "ech": 1
        },
        {
            "id": 4108,
            "name": "Mistretta",
            "provincia": "ME",
            "cap": "98073",
            "cod_catastale": "F251",
            "cod_istat": "083052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 900,
            "giorni": 2165,
            "area": "",
            "ech": 0
        },
        {
            "id": 4109,
            "name": "Moasca",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "F254",
            "cod_istat": "005063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2627,
            "area": "",
            "ech": 0
        },
        {
            "id": 4110,
            "name": "Moconesi",
            "provincia": "GE",
            "cap": "16047",
            "cod_catastale": "F256",
            "cod_istat": "010036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 1946,
            "area": "",
            "ech": 0
        },
        {
            "id": 4111,
            "name": "Modena",
            "provincia": "MO",
            "cap": "411xx",
            "cod_catastale": "F257",
            "cod_istat": "036023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 4112,
            "name": "Modica",
            "provincia": "RG",
            "cap": "97015",
            "cod_catastale": "F258",
            "cod_istat": "088006",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 1117,
            "area": "SICI",
            "ech": 0
        },
        {
            "id": 4113,
            "name": "Modigliana",
            "provincia": "FC",
            "cap": "47015",
            "cod_catastale": "F259",
            "cod_istat": "040022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 4114,
            "name": "Modolo",
            "provincia": "OR",
            "cap": "08019",
            "cod_catastale": "F261",
            "cod_istat": "095084",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 977,
            "area": "",
            "ech": 0
        },
        {
            "id": 4115,
            "name": "Modugno",
            "provincia": "BA",
            "cap": "70026",
            "cod_catastale": "F262",
            "cod_istat": "072027",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 1311,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4116,
            "name": "Moena",
            "provincia": "TN",
            "cap": "38035",
            "cod_catastale": "F263",
            "cod_istat": "022118",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1184,
            "giorni": 4238,
            "area": "",
            "ech": 0
        },
        {
            "id": 4117,
            "name": "Moggio",
            "provincia": "LC",
            "cap": "23817",
            "cod_catastale": "F265",
            "cod_istat": "097050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 890,
            "giorni": 3330,
            "area": "",
            "ech": 0
        },
        {
            "id": 4118,
            "name": "Moggio Udinese",
            "provincia": "UD",
            "cap": "33015",
            "cod_catastale": "F266",
            "cod_istat": "030059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 3060,
            "area": "",
            "ech": 0
        },
        {
            "id": 4119,
            "name": "Moglia",
            "provincia": "MN",
            "cap": "46024",
            "cod_catastale": "F267",
            "cod_istat": "020035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 4120,
            "name": "Mogliano",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F268",
            "cod_istat": "043025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2006,
            "area": "",
            "ech": 0
        },
        {
            "id": 4121,
            "name": "Mogliano Veneto",
            "provincia": "TV",
            "cap": "31021",
            "cod_catastale": "F269",
            "cod_istat": "026043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2546,
            "area": "",
            "ech": 0
        },
        {
            "id": 4122,
            "name": "Mogorella",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "F270",
            "cod_istat": "095028",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 265,
            "giorni": 1316,
            "area": "",
            "ech": 0
        },
        {
            "id": 4123,
            "name": "Mogoro",
            "provincia": "OR",
            "cap": "09095",
            "cod_catastale": "F272",
            "cod_istat": "095029",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 132,
            "giorni": 1124,
            "area": "",
            "ech": 0
        },
        {
            "id": 4124,
            "name": "Moiano",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "F274",
            "cod_istat": "062040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 1563,
            "area": "",
            "ech": 0
        },
        {
            "id": 4125,
            "name": "Moimacco",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "F275",
            "cod_istat": "030060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2337,
            "area": "",
            "ech": 0
        },
        {
            "id": 4126,
            "name": "Moio Alcantara",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "F277",
            "cod_istat": "083053",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 538,
            "giorni": 1546,
            "area": "",
            "ech": 0
        },
        {
            "id": 4127,
            "name": "Moio de' Calvi",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "F276",
            "cod_istat": "016136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 654,
            "giorni": 2998,
            "area": "",
            "ech": 0
        },
        {
            "id": 4128,
            "name": "Moio della Civitella",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "F278",
            "cod_istat": "065069",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 515,
            "giorni": 1794,
            "area": "",
            "ech": 0
        },
        {
            "id": 4129,
            "name": "Moiola",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "F279",
            "cod_istat": "004123",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 689,
            "giorni": 3169,
            "area": "",
            "ech": 0
        },
        {
            "id": 4130,
            "name": "Mola di Bari",
            "provincia": "BA",
            "cap": "70042",
            "cod_catastale": "F280",
            "cod_istat": "072028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1187,
            "area": "",
            "ech": 0
        },
        {
            "id": 4131,
            "name": "Molare",
            "provincia": "AL",
            "cap": "15074",
            "cod_catastale": "F281",
            "cod_istat": "006095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 4132,
            "name": "Molazzana",
            "provincia": "LU",
            "cap": "55020",
            "cod_catastale": "F283",
            "cod_istat": "046020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 474,
            "giorni": 2630,
            "area": "",
            "ech": 0
        },
        {
            "id": 4133,
            "name": "Molfetta",
            "provincia": "BA",
            "cap": "70056",
            "cod_catastale": "F284",
            "cod_istat": "072029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1202,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4134,
            "name": "Molina Aterno",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "M255",
            "cod_istat": "066055",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 482,
            "giorni": 2205,
            "area": "",
            "ech": 0
        },
        {
            "id": 4135,
            "name": "Molinara",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "F287",
            "cod_istat": "062041",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 580,
            "giorni": 2126,
            "area": "",
            "ech": 0
        },
        {
            "id": 4136,
            "name": "Molinella",
            "provincia": "BO",
            "cap": "40062",
            "cod_catastale": "F288",
            "cod_istat": "037039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2168,
            "area": "",
            "ech": 0
        },
        {
            "id": 4137,
            "name": "Molini di Triora",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "F290",
            "cod_istat": "008035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 4138,
            "name": "Molino dei Torti",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "F293",
            "cod_istat": "006096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2546,
            "area": "",
            "ech": 0
        },
        {
            "id": 4139,
            "name": "Molise",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "F294",
            "cod_istat": "070039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 868,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 4140,
            "name": "Moliterno",
            "provincia": "PZ",
            "cap": "85047",
            "cod_catastale": "F295",
            "cod_istat": "076050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 879,
            "giorni": 2295,
            "area": "",
            "ech": 0
        },
        {
            "id": 4141,
            "name": "Mollia",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "F297",
            "cod_istat": "002078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 880,
            "giorni": 3448,
            "area": "",
            "ech": 0
        },
        {
            "id": 4142,
            "name": "Molochio",
            "provincia": "RC",
            "cap": "89010",
            "cod_catastale": "F301",
            "cod_istat": "080051",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 310,
            "giorni": 1235,
            "area": "",
            "ech": 1
        },
        {
            "id": 4143,
            "name": "Molteno",
            "provincia": "LC",
            "cap": "23847",
            "cod_catastale": "F304",
            "cod_istat": "097051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 4144,
            "name": "Moltrasio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "F305",
            "cod_istat": "013152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2420,
            "area": "",
            "ech": 0
        },
        {
            "id": 4145,
            "name": "Molvena",
            "provincia": "VI",
            "cap": "36060",
            "cod_catastale": "F306",
            "cod_istat": "024059",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2536,
            "area": "",
            "ech": 0
        },
        {
            "id": 4146,
            "name": "Molveno",
            "provincia": "TN",
            "cap": "38018",
            "cod_catastale": "F307",
            "cod_istat": "022120",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 865,
            "giorni": 3740,
            "area": "",
            "ech": 0
        },
        {
            "id": 4147,
            "name": "Mombaldone",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "F308",
            "cod_istat": "005064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 4148,
            "name": "Mombarcaro",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "F309",
            "cod_istat": "004124",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 896,
            "giorni": 3426,
            "area": "",
            "ech": 0
        },
        {
            "id": 4149,
            "name": "Mombaroccio",
            "provincia": "PU",
            "cap": "61024",
            "cod_catastale": "F310",
            "cod_istat": "041027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2331,
            "area": "",
            "ech": 0
        },
        {
            "id": 4150,
            "name": "Mombaruzzo",
            "provincia": "AT",
            "cap": "14046",
            "cod_catastale": "F311",
            "cod_istat": "005065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 4151,
            "name": "Mombasiglio",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "F312",
            "cod_istat": "004125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 2878,
            "area": "",
            "ech": 0
        },
        {
            "id": 4152,
            "name": "Mombello di Torino",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "F315",
            "cod_istat": "001153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 336,
            "giorni": 2858,
            "area": "",
            "ech": 0
        },
        {
            "id": 4153,
            "name": "Mombello Monferrato",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "F313",
            "cod_istat": "006097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 4154,
            "name": "Mombercelli",
            "provincia": "AT",
            "cap": "14047",
            "cod_catastale": "F316",
            "cod_istat": "005066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 4155,
            "name": "Momo",
            "provincia": "NO",
            "cap": "28015",
            "cod_catastale": "F317",
            "cod_istat": "003100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 4156,
            "name": "Mompantero",
            "provincia": "TO",
            "cap": "10059",
            "cod_catastale": "F318",
            "cod_istat": "001154",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 838,
            "giorni": 3302,
            "area": "",
            "ech": 0
        },
        {
            "id": 4157,
            "name": "Mompeo",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "F319",
            "cod_istat": "057038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 457,
            "giorni": 2196,
            "area": "",
            "ech": 0
        },
        {
            "id": 4158,
            "name": "Momperone",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "F320",
            "cod_istat": "006098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2716,
            "area": "",
            "ech": 0
        },
        {
            "id": 4159,
            "name": "Monacilioni",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "F322",
            "cod_istat": "070040",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 2116,
            "area": "",
            "ech": 0
        },
        {
            "id": 4160,
            "name": "Monale",
            "provincia": "AT",
            "cap": "14013",
            "cod_catastale": "F323",
            "cod_istat": "005067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2681,
            "area": "",
            "ech": 0
        },
        {
            "id": 4161,
            "name": "Monasterace",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "F324",
            "cod_istat": "080052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 943,
            "area": "",
            "ech": 1
        },
        {
            "id": 4162,
            "name": "Monastero Bormida",
            "provincia": "AT",
            "cap": "14058",
            "cod_catastale": "F325",
            "cod_istat": "005068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 4163,
            "name": "Monastero di Lanzo",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "F327",
            "cod_istat": "001155",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 825,
            "giorni": 3591,
            "area": "",
            "ech": 0
        },
        {
            "id": 4164,
            "name": "Monastero di Vasco",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "F326",
            "cod_istat": "004126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 2780,
            "area": "",
            "ech": 0
        },
        {
            "id": 4165,
            "name": "Monasterolo Casotto",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "F329",
            "cod_istat": "004127",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 726,
            "giorni": 3110,
            "area": "",
            "ech": 0
        },
        {
            "id": 4166,
            "name": "Monasterolo del Castello",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "F328",
            "cod_istat": "016137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 2588,
            "area": "",
            "ech": 0
        },
        {
            "id": 4167,
            "name": "Monasterolo di Savigliano",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "F330",
            "cod_istat": "004128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 2615,
            "area": "",
            "ech": 0
        },
        {
            "id": 4168,
            "name": "Monastier di Treviso",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "F332",
            "cod_istat": "026044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2337,
            "area": "",
            "ech": 0
        },
        {
            "id": 4169,
            "name": "Monastir",
            "provincia": "SU",
            "cap": "09023",
            "cod_catastale": "F333",
            "cod_istat": "111041",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 1047,
            "area": "",
            "ech": 1
        },
        {
            "id": 4170,
            "name": "Moncalieri",
            "provincia": "TO",
            "cap": "10024",
            "cod_catastale": "F335",
            "cod_istat": "001156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2553,
            "area": "",
            "ech": 0
        },
        {
            "id": 4171,
            "name": "Moncalvo",
            "provincia": "AT",
            "cap": "14036",
            "cod_catastale": "F336",
            "cod_istat": "005069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 4172,
            "name": "Moncenisio",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "D553",
            "cod_istat": "001157",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1461,
            "giorni": 4545,
            "area": "",
            "ech": 0
        },
        {
            "id": 4173,
            "name": "Moncestino",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "F337",
            "cod_istat": "006099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 4174,
            "name": "Monchiero",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "F338",
            "cod_istat": "004129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 4175,
            "name": "Monchio delle Corti",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "F340",
            "cod_istat": "034022",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 3595,
            "area": "",
            "ech": 0
        },
        {
            "id": 4176,
            "name": "Monclassico",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "F341",
            "cod_istat": "022121",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 770,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 4177,
            "name": "Moncrivello",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "F342",
            "cod_istat": "002079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 4178,
            "name": "Moncucco Torinese",
            "provincia": "AT",
            "cap": "14024",
            "cod_catastale": "F343",
            "cod_istat": "005070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 403,
            "giorni": 2821,
            "area": "",
            "ech": 0
        },
        {
            "id": 4179,
            "name": "Mondaino",
            "provincia": "RN",
            "cap": "47836",
            "cod_catastale": "F346",
            "cod_istat": "099006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2669,
            "area": "",
            "ech": 0
        },
        {
            "id": 4180,
            "name": "Mondavio",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "F347",
            "cod_istat": "041028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2298,
            "area": "",
            "ech": 0
        },
        {
            "id": 4181,
            "name": "Mondolfo",
            "provincia": "PU",
            "cap": "61037",
            "cod_catastale": "F348",
            "cod_istat": "041029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 2188,
            "area": "",
            "ech": 0
        },
        {
            "id": 4182,
            "name": "Mondovì",
            "provincia": "CN",
            "cap": "12084",
            "cod_catastale": "F351",
            "cod_istat": "004130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 4183,
            "name": "Mondragone",
            "provincia": "CE",
            "cap": "81034",
            "cod_catastale": "F352",
            "cod_istat": "061052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1060,
            "area": "",
            "ech": 0
        },
        {
            "id": 4184,
            "name": "Moneglia",
            "provincia": "GE",
            "cap": "16030",
            "cod_catastale": "F354",
            "cod_istat": "010037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1547,
            "area": "",
            "ech": 0
        },
        {
            "id": 4185,
            "name": "Monesiglio",
            "provincia": "CN",
            "cap": "12077",
            "cod_catastale": "F355",
            "cod_istat": "004131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 4186,
            "name": "Monfalcone",
            "provincia": "GO",
            "cap": "34074",
            "cod_catastale": "F356",
            "cod_istat": "031012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2213,
            "area": "",
            "ech": 0
        },
        {
            "id": 4187,
            "name": "Monforte d'Alba",
            "provincia": "CN",
            "cap": "12065",
            "cod_catastale": "F358",
            "cod_istat": "004132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2910,
            "area": "",
            "ech": 0
        },
        {
            "id": 4188,
            "name": "Monforte San Giorgio",
            "provincia": "ME",
            "cap": "98041",
            "cod_catastale": "F359",
            "cod_istat": "083054",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 1117,
            "area": "",
            "ech": 1
        },
        {
            "id": 4189,
            "name": "Monfumo",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "F360",
            "cod_istat": "026045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 4190,
            "name": "Mongardino",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "F361",
            "cod_istat": "005071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2540,
            "area": "",
            "ech": 0
        },
        {
            "id": 4191,
            "name": "Monghidoro",
            "provincia": "BO",
            "cap": "40063",
            "cod_catastale": "F363",
            "cod_istat": "037040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 841,
            "giorni": 3351,
            "area": "",
            "ech": 0
        },
        {
            "id": 4192,
            "name": "Mongiana",
            "provincia": "VV",
            "cap": "89823",
            "cod_catastale": "F364",
            "cod_istat": "102022",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 922,
            "giorni": 2779,
            "area": "",
            "ech": 0
        },
        {
            "id": 4193,
            "name": "Mongiardino Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "F365",
            "cod_istat": "006100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2986,
            "area": "",
            "ech": 0
        },
        {
            "id": 4194,
            "name": "Mongiuffi Melia",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "F368",
            "cod_istat": "083055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 1268,
            "area": "",
            "ech": 0
        },
        {
            "id": 4195,
            "name": "Mongrando",
            "provincia": "BI",
            "cap": "13888",
            "cod_catastale": "F369",
            "cod_istat": "096035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 4196,
            "name": "Mongrassano",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "F370",
            "cod_istat": "078080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1998,
            "area": "",
            "ech": 0
        },
        {
            "id": 4197,
            "name": "Monguelfo-Tesido",
            "provincia": "BZ",
            "cap": "39035",
            "cod_catastale": "F371",
            "cod_istat": "021052",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4198,
            "name": "Monguzzo",
            "provincia": "CO",
            "cap": "22040",
            "cod_catastale": "F372",
            "cod_istat": "013153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 4199,
            "name": "Moniga del Garda",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "F373",
            "cod_istat": "017109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 4200,
            "name": "Monleale",
            "provincia": "AL",
            "cap": "15059",
            "cod_catastale": "F374",
            "cod_istat": "006101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 4201,
            "name": "Monno",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "F375",
            "cod_istat": "017110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1066,
            "giorni": 3734,
            "area": "",
            "ech": 0
        },
        {
            "id": 4202,
            "name": "Monopoli",
            "provincia": "BA",
            "cap": "70043",
            "cod_catastale": "F376",
            "cod_istat": "072030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 1066,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4203,
            "name": "Monreale",
            "provincia": "PA",
            "cap": "90046",
            "cod_catastale": "F377",
            "cod_istat": "082049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1033,
            "area": "",
            "ech": 1
        },
        {
            "id": 4204,
            "name": "Monrupino",
            "provincia": "TS",
            "cap": "34016",
            "cod_catastale": "F378",
            "cod_istat": "032002",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 418,
            "giorni": 3341,
            "area": "",
            "ech": 0
        },
        {
            "id": 4205,
            "name": "Monsampietro Morico",
            "provincia": "FM",
            "cap": "63842",
            "cod_catastale": "F379",
            "cod_istat": "109012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2064,
            "area": "",
            "ech": 0
        },
        {
            "id": 4206,
            "name": "Monsampolo del Tronto",
            "provincia": "AP",
            "cap": "63077",
            "cod_catastale": "F380",
            "cod_istat": "044031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 1514,
            "area": "",
            "ech": 0
        },
        {
            "id": 4207,
            "name": "Monsano",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "F381",
            "cod_istat": "042025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 1996,
            "area": "",
            "ech": 0
        },
        {
            "id": 4208,
            "name": "Monselice",
            "provincia": "PD",
            "cap": "35043",
            "cod_catastale": "F382",
            "cod_istat": "028055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 4209,
            "name": "Monserrato",
            "provincia": "CA",
            "cap": "09042",
            "cod_catastale": "F383",
            "cod_istat": "092109",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 989,
            "area": "",
            "ech": 0
        },
        {
            "id": 4210,
            "name": "Monsummano Terme",
            "provincia": "PT",
            "cap": "51015",
            "cod_catastale": "F384",
            "cod_istat": "047009",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1695,
            "area": "",
            "ech": 0
        },
        {
            "id": 4211,
            "name": "Montà",
            "provincia": "CN",
            "cap": "12046",
            "cod_catastale": "F385",
            "cod_istat": "004133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 316,
            "giorni": 2707,
            "area": "",
            "ech": 0
        },
        {
            "id": 4212,
            "name": "Montabone",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "F386",
            "cod_istat": "005072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 2863,
            "area": "",
            "ech": 0
        },
        {
            "id": 4213,
            "name": "Montacuto",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "F387",
            "cod_istat": "006102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 2923,
            "area": "",
            "ech": 0
        },
        {
            "id": 4214,
            "name": "Montafia",
            "provincia": "AT",
            "cap": "14014",
            "cod_catastale": "F390",
            "cod_istat": "005073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2706,
            "area": "",
            "ech": 0
        },
        {
            "id": 4215,
            "name": "Montagano",
            "provincia": "CB",
            "cap": "86023",
            "cod_catastale": "F391",
            "cod_istat": "070041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 801,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 4216,
            "name": "Montagna",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "F392",
            "cod_istat": "021053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 497,
            "giorni": 3182,
            "area": "",
            "ech": 0
        },
        {
            "id": 4217,
            "name": "Montagna in Valtellina",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "F393",
            "cod_istat": "014044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 3041,
            "area": "",
            "ech": 0
        },
        {
            "id": 4218,
            "name": "Montagnana",
            "provincia": "PD",
            "cap": "35044",
            "cod_catastale": "F394",
            "cod_istat": "028056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 4219,
            "name": "Montagnareale",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "F395",
            "cod_istat": "083056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 1187,
            "area": "",
            "ech": 0
        },
        {
            "id": 4220,
            "name": "Montagne",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "F396",
            "cod_istat": "022122",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1004,
            "giorni": 3954,
            "area": "",
            "ech": 0
        },
        {
            "id": 4221,
            "name": "Montaguto",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "F397",
            "cod_istat": "064051",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 730,
            "giorni": 2363,
            "area": "",
            "ech": 0
        },
        {
            "id": 4222,
            "name": "Montaione",
            "provincia": "FI",
            "cap": "50050",
            "cod_catastale": "F398",
            "cod_istat": "048027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 2289,
            "area": "",
            "ech": 0
        },
        {
            "id": 4223,
            "name": "Montalbano Elicona",
            "provincia": "ME",
            "cap": "98065",
            "cod_catastale": "F400",
            "cod_istat": "083057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 920,
            "giorni": 2200,
            "area": "",
            "ech": 1
        },
        {
            "id": 4224,
            "name": "Montalbano Jonico",
            "provincia": "MT",
            "cap": "75023",
            "cod_catastale": "F399",
            "cod_istat": "077016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 1392,
            "area": "",
            "ech": 0
        },
        {
            "id": 4225,
            "name": "Montalcino",
            "provincia": "SI",
            "cap": "53024",
            "cod_catastale": "M378",
            "cod_istat": "052037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 2308,
            "area": "",
            "ech": 0
        },
        {
            "id": 4226,
            "name": "Montaldeo",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "F403",
            "cod_istat": "006103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 4227,
            "name": "Montaldo Bormida",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F404",
            "cod_istat": "006104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 4228,
            "name": "Montaldo di Mondovì",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "F405",
            "cod_istat": "004134",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3307,
            "area": "",
            "ech": 0
        },
        {
            "id": 4229,
            "name": "Montaldo Roero",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "F408",
            "cod_istat": "004135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 4230,
            "name": "Montaldo Scarampi",
            "provincia": "AT",
            "cap": "14048",
            "cod_catastale": "F409",
            "cod_istat": "005074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2699,
            "area": "",
            "ech": 0
        },
        {
            "id": 4231,
            "name": "Montaldo Torinese",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "F407",
            "cod_istat": "001158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2916,
            "area": "",
            "ech": 0
        },
        {
            "id": 4232,
            "name": "Montale",
            "provincia": "PT",
            "cap": "51037",
            "cod_catastale": "F410",
            "cod_istat": "047010",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 1811,
            "area": "",
            "ech": 0
        },
        {
            "id": 4233,
            "name": "Montalenghe",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "F411",
            "cod_istat": "001159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 4234,
            "name": "Montallegro",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "F414",
            "cod_istat": "084024",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 735,
            "area": "",
            "ech": 1
        },
        {
            "id": 4235,
            "name": "Montalto delle Marche",
            "provincia": "AP",
            "cap": "63068",
            "cod_catastale": "F415",
            "cod_istat": "044032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 513,
            "giorni": 2240,
            "area": "",
            "ech": 0
        },
        {
            "id": 4236,
            "name": "Montalto di Castro",
            "provincia": "VT",
            "cap": "01014",
            "cod_catastale": "F419",
            "cod_istat": "056035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 1497,
            "area": "",
            "ech": 0
        },
        {
            "id": 4237,
            "name": "Montalto Dora",
            "provincia": "TO",
            "cap": "10016",
            "cod_catastale": "F420",
            "cod_istat": "001160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2728,
            "area": "",
            "ech": 0
        },
        {
            "id": 4238,
            "name": "Montalto Ligure",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "F406",
            "cod_istat": "008036",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 1881,
            "area": "",
            "ech": 0
        },
        {
            "id": 4239,
            "name": "Montalto Pavese",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "F417",
            "cod_istat": "018094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 3138,
            "area": "",
            "ech": 0
        },
        {
            "id": 4240,
            "name": "Montalto Uffugo",
            "provincia": "CS",
            "cap": "87046",
            "cod_catastale": "F416",
            "cod_istat": "078081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1691,
            "area": "",
            "ech": 1
        },
        {
            "id": 4241,
            "name": "Montanaro",
            "provincia": "TO",
            "cap": "10017",
            "cod_catastale": "F422",
            "cod_istat": "001161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 2667,
            "area": "",
            "ech": 0
        },
        {
            "id": 4242,
            "name": "Montanaso Lombardo",
            "provincia": "LO",
            "cap": "26836",
            "cod_catastale": "F423",
            "cod_istat": "098040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4243,
            "name": "Montanera",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "F424",
            "cod_istat": "004136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 427,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 4244,
            "name": "Montano Antilia",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "F426",
            "cod_istat": "065070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2004,
            "area": "",
            "ech": 0
        },
        {
            "id": 4245,
            "name": "Montano Lucino",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "F427",
            "cod_istat": "013154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 331,
            "giorni": 2540,
            "area": "",
            "ech": 0
        },
        {
            "id": 4246,
            "name": "Montappone",
            "provincia": "FM",
            "cap": "63835",
            "cod_catastale": "F428",
            "cod_istat": "109013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2072,
            "area": "",
            "ech": 0
        },
        {
            "id": 4247,
            "name": "Montaquila",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "F429",
            "cod_istat": "094028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1924,
            "area": "",
            "ech": 0
        },
        {
            "id": 4248,
            "name": "Montasola",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "F430",
            "cod_istat": "057039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 4249,
            "name": "Montauro",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "F432",
            "cod_istat": "079080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 1485,
            "area": "",
            "ech": 1
        },
        {
            "id": 4250,
            "name": "Montazzoli",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "F433",
            "cod_istat": "069051",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 850,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 4251,
            "name": "Monte Argentario",
            "provincia": "GR",
            "cap": "58019",
            "cod_catastale": "F437",
            "cod_istat": "053016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1399,
            "area": "",
            "ech": 0
        },
        {
            "id": 4252,
            "name": "Monte Castello di Vibio",
            "provincia": "PG",
            "cap": "06057",
            "cod_catastale": "F456",
            "cod_istat": "054029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 423,
            "giorni": 2215,
            "area": "",
            "ech": 0
        },
        {
            "id": 4253,
            "name": "Monte Cavallo",
            "provincia": "MC",
            "cap": "62036",
            "cod_catastale": "F460",
            "cod_istat": "043027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 2398,
            "area": "",
            "ech": 0
        },
        {
            "id": 4254,
            "name": "Monte Cerignone",
            "provincia": "PU",
            "cap": "61010",
            "cod_catastale": "F467",
            "cod_istat": "041031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 528,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 4255,
            "name": "Monte Colombo",
            "provincia": "RN",
            "cap": "47854",
            "cod_catastale": "F476",
            "cod_istat": "099007",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 4256,
            "name": "Monte Compatri",
            "provincia": "RM",
            "cap": "00077",
            "cod_catastale": "F477",
            "cod_istat": "058060",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4257,
            "name": "Monte Cremasco",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "F434",
            "cod_istat": "019058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4258,
            "name": "Monte di Malo",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "F486",
            "cod_istat": "024063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 374,
            "giorni": 2855,
            "area": "",
            "ech": 0
        },
        {
            "id": 4259,
            "name": "Monte di Procida",
            "provincia": "NA",
            "cap": "80070",
            "cod_catastale": "F488",
            "cod_istat": "063047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 1125,
            "area": "",
            "ech": 0
        },
        {
            "id": 4260,
            "name": "Monte Giberto",
            "provincia": "FM",
            "cap": "63846",
            "cod_catastale": "F517",
            "cod_istat": "109016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 4261,
            "name": "Monte Grimano Terme",
            "provincia": "PU",
            "cap": "61010",
            "cod_catastale": "F524",
            "cod_istat": "041035",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4262,
            "name": "Monte Isola",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "F532",
            "cod_istat": "017111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2621,
            "area": "",
            "ech": 0
        },
        {
            "id": 4263,
            "name": "Monte Marenzo",
            "provincia": "LC",
            "cap": "23804",
            "cod_catastale": "F561",
            "cod_istat": "097052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 440,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 4264,
            "name": "Monte Porzio",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "F589",
            "cod_istat": "041038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2157,
            "area": "",
            "ech": 0
        },
        {
            "id": 4265,
            "name": "Monte Porzio Catone",
            "provincia": "RM",
            "cap": "00078",
            "cod_catastale": "F590",
            "cod_istat": "058064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 451,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 4266,
            "name": "Monte Rinaldo",
            "provincia": "FM",
            "cap": "63852",
            "cod_catastale": "F599",
            "cod_istat": "109021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2207,
            "area": "",
            "ech": 0
        },
        {
            "id": 4267,
            "name": "Monte Roberto",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "F600",
            "cod_istat": "042029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 348,
            "giorni": 2158,
            "area": "",
            "ech": 0
        },
        {
            "id": 4268,
            "name": "Monte Romano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "F603",
            "cod_istat": "056037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 1829,
            "area": "",
            "ech": 0
        },
        {
            "id": 4269,
            "name": "Monte San Biagio",
            "provincia": "LT",
            "cap": "04020",
            "cod_catastale": "F616",
            "cod_istat": "059015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 1319,
            "area": "",
            "ech": 0
        },
        {
            "id": 4270,
            "name": "Monte San Giacomo",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "F618",
            "cod_istat": "065075",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 668,
            "giorni": 2098,
            "area": "",
            "ech": 0
        },
        {
            "id": 4271,
            "name": "Monte San Giovanni Campano",
            "provincia": "FR",
            "cap": "03025",
            "cod_catastale": "F620",
            "cod_istat": "060044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 438,
            "giorni": 2028,
            "area": "",
            "ech": 0
        },
        {
            "id": 4272,
            "name": "Monte San Giovanni in Sabina",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "F619",
            "cod_istat": "057043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 2690,
            "area": "",
            "ech": 0
        },
        {
            "id": 4273,
            "name": "Monte San Giusto",
            "provincia": "MC",
            "cap": "62015",
            "cod_catastale": "F621",
            "cod_istat": "043031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 1923,
            "area": "",
            "ech": 0
        },
        {
            "id": 4274,
            "name": "Monte San Martino",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "F622",
            "cod_istat": "043032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 603,
            "giorni": 2345,
            "area": "",
            "ech": 0
        },
        {
            "id": 4275,
            "name": "Monte San Pietrangeli",
            "provincia": "FM",
            "cap": "63815",
            "cod_catastale": "F626",
            "cod_istat": "109023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 1922,
            "area": "",
            "ech": 0
        },
        {
            "id": 4276,
            "name": "Monte San Pietro",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "F627",
            "cod_istat": "037042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2316,
            "area": "",
            "ech": 0
        },
        {
            "id": 4277,
            "name": "Monte San Savino",
            "provincia": "AR",
            "cap": "52048",
            "cod_catastale": "F628",
            "cod_istat": "051025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2140,
            "area": "",
            "ech": 0
        },
        {
            "id": 4278,
            "name": "Monte San Vito",
            "provincia": "AN",
            "cap": "60037",
            "cod_catastale": "F634",
            "cod_istat": "042030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 1870,
            "area": "",
            "ech": 0
        },
        {
            "id": 4279,
            "name": "Monte Santa Maria Tiberina",
            "provincia": "PG",
            "cap": "06010",
            "cod_catastale": "F629",
            "cod_istat": "054032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 688,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 4280,
            "name": "Monte Sant'Angelo",
            "provincia": "FG",
            "cap": "71037",
            "cod_catastale": "F631",
            "cod_istat": "071033",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 796,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 4281,
            "name": "Monte Urano",
            "provincia": "FM",
            "cap": "63813",
            "cod_catastale": "F653",
            "cod_istat": "109024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 1870,
            "area": "",
            "ech": 0
        },
        {
            "id": 4282,
            "name": "Monte Vidon Combatte",
            "provincia": "FM",
            "cap": "63847",
            "cod_catastale": "F664",
            "cod_istat": "109025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 2099,
            "area": "",
            "ech": 0
        },
        {
            "id": 4283,
            "name": "Monte Vidon Corrado",
            "provincia": "FM",
            "cap": "63836",
            "cod_catastale": "F665",
            "cod_istat": "109026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 2142,
            "area": "",
            "ech": 0
        },
        {
            "id": 4284,
            "name": "Montebello della Battaglia",
            "provincia": "PV",
            "cap": "27054",
            "cod_catastale": "F440",
            "cod_istat": "018095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4285,
            "name": "Montebello di Bertona",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "F441",
            "cod_istat": "068023",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 615,
            "giorni": 2198,
            "area": "",
            "ech": 0
        },
        {
            "id": 4286,
            "name": "Montebello Jonico",
            "provincia": "RC",
            "cap": "89064",
            "cod_catastale": "D746",
            "cod_istat": "080053",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 1
        },
        {
            "id": 4287,
            "name": "Montebello sul Sangro",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "B268",
            "cod_istat": "069009",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 810,
            "giorni": 2314,
            "area": "",
            "ech": 0
        },
        {
            "id": 4288,
            "name": "Montebello Vicentino",
            "provincia": "VI",
            "cap": "36054",
            "cod_catastale": "F442",
            "cod_istat": "024060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2325,
            "area": "",
            "ech": 0
        },
        {
            "id": 4289,
            "name": "Montebelluna",
            "provincia": "TV",
            "cap": "31044",
            "cod_catastale": "F443",
            "cod_istat": "026046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4290,
            "name": "Montebruno",
            "provincia": "GE",
            "cap": "16025",
            "cod_catastale": "F445",
            "cod_istat": "010038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 3153,
            "area": "",
            "ech": 0
        },
        {
            "id": 4291,
            "name": "Montebuono",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "F446",
            "cod_istat": "057040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1956,
            "area": "",
            "ech": 0
        },
        {
            "id": 4292,
            "name": "Montecalvo in Foglia",
            "provincia": "PU",
            "cap": "61020",
            "cod_catastale": "F450",
            "cod_istat": "041030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2351,
            "area": "",
            "ech": 0
        },
        {
            "id": 4293,
            "name": "Montecalvo Irpino",
            "provincia": "AV",
            "cap": "83037",
            "cod_catastale": "F448",
            "cod_istat": "064052",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 623,
            "giorni": 2214,
            "area": "",
            "ech": 0
        },
        {
            "id": 4294,
            "name": "Montecalvo Versiggia",
            "provincia": "PV",
            "cap": "27047",
            "cod_catastale": "F449",
            "cod_istat": "018096",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 3189,
            "area": "",
            "ech": 0
        },
        {
            "id": 4295,
            "name": "Montecarlo",
            "provincia": "LU",
            "cap": "55015",
            "cod_catastale": "F452",
            "cod_istat": "046021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 1956,
            "area": "",
            "ech": 0
        },
        {
            "id": 4296,
            "name": "Montecarotto",
            "provincia": "AN",
            "cap": "60036",
            "cod_catastale": "F453",
            "cod_istat": "042026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2168,
            "area": "",
            "ech": 0
        },
        {
            "id": 4297,
            "name": "Montecassiano",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F454",
            "cod_istat": "043026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 1898,
            "area": "",
            "ech": 0
        },
        {
            "id": 4298,
            "name": "Montecastello",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "F455",
            "cod_istat": "006105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2577,
            "area": "",
            "ech": 0
        },
        {
            "id": 4299,
            "name": "Montecastrilli",
            "provincia": "TR",
            "cap": "05026",
            "cod_catastale": "F457",
            "cod_istat": "055017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2076,
            "area": "",
            "ech": 0
        },
        {
            "id": 4300,
            "name": "Montecatini Val di Cecina",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "F458",
            "cod_istat": "050019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 2107,
            "area": "",
            "ech": 0
        },
        {
            "id": 4301,
            "name": "Montecatini-Terme",
            "provincia": "PT",
            "cap": "51016",
            "cod_catastale": "A561",
            "cod_istat": "047011",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4302,
            "name": "Montecchia di Crosara",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "F461",
            "cod_istat": "023049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 4303,
            "name": "Montecchio",
            "provincia": "TR",
            "cap": "05020",
            "cod_catastale": "F462",
            "cod_istat": "055018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 377,
            "giorni": 2051,
            "area": "",
            "ech": 0
        },
        {
            "id": 4304,
            "name": "Montecchio Emilia",
            "provincia": "RE",
            "cap": "42027",
            "cod_catastale": "F463",
            "cod_istat": "035027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 4305,
            "name": "Montecchio Maggiore",
            "provincia": "VI",
            "cap": "36075",
            "cod_catastale": "F464",
            "cod_istat": "024061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 4306,
            "name": "Montecchio Precalcino",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "F465",
            "cod_istat": "024062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2485,
            "area": "",
            "ech": 0
        },
        {
            "id": 4307,
            "name": "Montechiaro d'Acqui",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F469",
            "cod_istat": "006106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 2953,
            "area": "",
            "ech": 0
        },
        {
            "id": 4308,
            "name": "Montechiaro d'Asti",
            "provincia": "AT",
            "cap": "14025",
            "cod_catastale": "F468",
            "cod_istat": "005075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 4309,
            "name": "Montechiarugolo",
            "provincia": "PR",
            "cap": "43022",
            "cod_catastale": "F473",
            "cod_istat": "034023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2626,
            "area": "",
            "ech": 0
        },
        {
            "id": 4310,
            "name": "Monteciccardo",
            "provincia": "PU",
            "cap": "61024",
            "cod_catastale": "F474",
            "cod_istat": "041032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 384,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 4311,
            "name": "Montecilfone",
            "provincia": "CB",
            "cap": "86032",
            "cod_catastale": "F475",
            "cod_istat": "070042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 1851,
            "area": "",
            "ech": 0
        },
        {
            "id": 4312,
            "name": "Montecopiolo",
            "provincia": "PU",
            "cap": "61014",
            "cod_catastale": "F478",
            "cod_istat": "041033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 915,
            "giorni": 2813,
            "area": "",
            "ech": 0
        },
        {
            "id": 4313,
            "name": "Montecorice",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "F479",
            "cod_istat": "065071",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1157,
            "area": "",
            "ech": 0
        },
        {
            "id": 4314,
            "name": "Montecorvino Pugliano",
            "provincia": "SA",
            "cap": "84090",
            "cod_catastale": "F480",
            "cod_istat": "065072",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 368,
            "giorni": 1700,
            "area": "",
            "ech": 0
        },
        {
            "id": 4315,
            "name": "Montecorvino Rovella",
            "provincia": "SA",
            "cap": "84096",
            "cod_catastale": "F481",
            "cod_istat": "065073",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 1536,
            "area": "",
            "ech": 0
        },
        {
            "id": 4316,
            "name": "Montecosaro",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F482",
            "cod_istat": "043028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 1934,
            "area": "",
            "ech": 0
        },
        {
            "id": 4317,
            "name": "Montecrestese",
            "provincia": "VB",
            "cap": "28864",
            "cod_catastale": "F483",
            "cod_istat": "103046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 486,
            "giorni": 2936,
            "area": "",
            "ech": 0
        },
        {
            "id": 4318,
            "name": "Montecreto",
            "provincia": "MO",
            "cap": "41025",
            "cod_catastale": "F484",
            "cod_istat": "036024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 864,
            "giorni": 3420,
            "area": "",
            "ech": 0
        },
        {
            "id": 4319,
            "name": "Montedinove",
            "provincia": "AP",
            "cap": "63069",
            "cod_catastale": "F487",
            "cod_istat": "044034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 561,
            "giorni": 2296,
            "area": "",
            "ech": 0
        },
        {
            "id": 4320,
            "name": "Montedoro",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "F489",
            "cod_istat": "085011",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1394,
            "area": "",
            "ech": 0
        },
        {
            "id": 4321,
            "name": "Montefalcione",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "F491",
            "cod_istat": "064053",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 523,
            "giorni": 2172,
            "area": "",
            "ech": 0
        },
        {
            "id": 4322,
            "name": "Montefalco",
            "provincia": "PG",
            "cap": "06036",
            "cod_catastale": "F492",
            "cod_istat": "054030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 4323,
            "name": "Montefalcone Appennino",
            "provincia": "FM",
            "cap": "63855",
            "cod_catastale": "F493",
            "cod_istat": "109014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 757,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 4324,
            "name": "Montefalcone di Val Fortore",
            "provincia": "BN",
            "cap": "82025",
            "cod_catastale": "F494",
            "cod_istat": "062042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 4325,
            "name": "Montefalcone nel Sannio",
            "provincia": "CB",
            "cap": "86033",
            "cod_catastale": "F495",
            "cod_istat": "070043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 659,
            "giorni": 2215,
            "area": "",
            "ech": 0
        },
        {
            "id": 4326,
            "name": "Montefano",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F496",
            "cod_istat": "043029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 1930,
            "area": "",
            "ech": 0
        },
        {
            "id": 4327,
            "name": "Montefelcino",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "F497",
            "cod_istat": "041034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 4328,
            "name": "Monteferrante",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "F498",
            "cod_istat": "069052",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4329,
            "name": "Montefiascone",
            "provincia": "VT",
            "cap": "01027",
            "cod_catastale": "F499",
            "cod_istat": "056036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 4330,
            "name": "Montefino",
            "provincia": "TE",
            "cap": "64030",
            "cod_catastale": "F500",
            "cod_istat": "067027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 1903,
            "area": "",
            "ech": 0
        },
        {
            "id": 4331,
            "name": "Montefiore Conca",
            "provincia": "RN",
            "cap": "47834",
            "cod_catastale": "F502",
            "cod_istat": "099008",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2650,
            "area": "",
            "ech": 0
        },
        {
            "id": 4332,
            "name": "Montefiore dell'Aso",
            "provincia": "AP",
            "cap": "63062",
            "cod_catastale": "F501",
            "cod_istat": "044036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2122,
            "area": "",
            "ech": 0
        },
        {
            "id": 4333,
            "name": "Montefiorino",
            "provincia": "MO",
            "cap": "41045",
            "cod_catastale": "F503",
            "cod_istat": "036025",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 797,
            "giorni": 3323,
            "area": "",
            "ech": 0
        },
        {
            "id": 4334,
            "name": "Monteflavio",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "F504",
            "cod_istat": "058061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2805,
            "area": "",
            "ech": 0
        },
        {
            "id": 4335,
            "name": "Monteforte Cilento",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "F507",
            "cod_istat": "065074",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1979,
            "area": "",
            "ech": 0
        },
        {
            "id": 4336,
            "name": "Monteforte d'Alpone",
            "provincia": "VR",
            "cap": "37032",
            "cod_catastale": "F508",
            "cod_istat": "023050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 4337,
            "name": "Monteforte Irpino",
            "provincia": "AV",
            "cap": "83024",
            "cod_catastale": "F506",
            "cod_istat": "064054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 502,
            "giorni": 1957,
            "area": "",
            "ech": 0
        },
        {
            "id": 4338,
            "name": "Montefortino",
            "provincia": "FM",
            "cap": "63858",
            "cod_catastale": "F509",
            "cod_istat": "109015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 612,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 4339,
            "name": "Montefranco",
            "provincia": "TR",
            "cap": "05030",
            "cod_catastale": "F510",
            "cod_istat": "055019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2047,
            "area": "",
            "ech": 0
        },
        {
            "id": 4340,
            "name": "Montefredane",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "F511",
            "cod_istat": "064055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 593,
            "giorni": 2115,
            "area": "",
            "ech": 0
        },
        {
            "id": 4341,
            "name": "Montefusco",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "F512",
            "cod_istat": "064056",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 705,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 4342,
            "name": "Montegabbione",
            "provincia": "TR",
            "cap": "05010",
            "cod_catastale": "F513",
            "cod_istat": "055020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 594,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 4343,
            "name": "Montegalda",
            "provincia": "VI",
            "cap": "36047",
            "cod_catastale": "F514",
            "cod_istat": "024064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 4344,
            "name": "Montegaldella",
            "provincia": "VI",
            "cap": "36047",
            "cod_catastale": "F515",
            "cod_istat": "024065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 4345,
            "name": "Montegallo",
            "provincia": "AP",
            "cap": "63094",
            "cod_catastale": "F516",
            "cod_istat": "044038",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 870,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 4346,
            "name": "Montegioco",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "F518",
            "cod_istat": "006107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2648,
            "area": "",
            "ech": 0
        },
        {
            "id": 4347,
            "name": "Montegiordano",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "F519",
            "cod_istat": "078082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 619,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 4348,
            "name": "Montegiorgio",
            "provincia": "FM",
            "cap": "63833",
            "cod_catastale": "F520",
            "cod_istat": "109017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 411,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 4349,
            "name": "Montegranaro",
            "provincia": "FM",
            "cap": "63812",
            "cod_catastale": "F522",
            "cod_istat": "109018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 1908,
            "area": "",
            "ech": 0
        },
        {
            "id": 4350,
            "name": "Montegridolfo",
            "provincia": "RN",
            "cap": "47837",
            "cod_catastale": "F523",
            "cod_istat": "099009",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2526,
            "area": "",
            "ech": 0
        },
        {
            "id": 4351,
            "name": "Montegrino Valtravaglia",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "F526",
            "cod_istat": "012103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 2771,
            "area": "",
            "ech": 0
        },
        {
            "id": 4352,
            "name": "Montegrosso d'Asti",
            "provincia": "AT",
            "cap": "14048",
            "cod_catastale": "F527",
            "cod_istat": "005076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 4353,
            "name": "Montegrosso Pian Latte",
            "provincia": "IM",
            "cap": "18025",
            "cod_catastale": "F528",
            "cod_istat": "008037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 3093,
            "area": "",
            "ech": 0
        },
        {
            "id": 4354,
            "name": "Montegrotto Terme",
            "provincia": "PD",
            "cap": "35036",
            "cod_catastale": "F529",
            "cod_istat": "028057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4355,
            "name": "Monteiasi",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "F531",
            "cod_istat": "073016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 1182,
            "area": "",
            "ech": 0
        },
        {
            "id": 4356,
            "name": "Montelabbate",
            "provincia": "PU",
            "cap": "61025",
            "cod_catastale": "F533",
            "cod_istat": "041036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2144,
            "area": "",
            "ech": 0
        },
        {
            "id": 4357,
            "name": "Montelanico",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "F534",
            "cod_istat": "058062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 1754,
            "area": "",
            "ech": 0
        },
        {
            "id": 4358,
            "name": "Montelapiano",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "F535",
            "cod_istat": "069053",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2306,
            "area": "",
            "ech": 0
        },
        {
            "id": 4359,
            "name": "Monteleone di Fermo",
            "provincia": "FM",
            "cap": "63841",
            "cod_catastale": "F536",
            "cod_istat": "109019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 427,
            "giorni": 2139,
            "area": "",
            "ech": 0
        },
        {
            "id": 4360,
            "name": "Monteleone di Puglia",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "F538",
            "cod_istat": "071032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 842,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 4361,
            "name": "Monteleone di Spoleto",
            "provincia": "PG",
            "cap": "06045",
            "cod_catastale": "F540",
            "cod_istat": "054031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 978,
            "giorni": 2914,
            "area": "",
            "ech": 0
        },
        {
            "id": 4362,
            "name": "Monteleone d'Orvieto",
            "provincia": "TR",
            "cap": "05017",
            "cod_catastale": "F543",
            "cod_istat": "055021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 4363,
            "name": "Monteleone Rocca Doria",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "F542",
            "cod_istat": "090040",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 368,
            "giorni": 1615,
            "area": "",
            "ech": 0
        },
        {
            "id": 4364,
            "name": "Monteleone Sabino",
            "provincia": "RI",
            "cap": "02033",
            "cod_catastale": "F541",
            "cod_istat": "057041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 2187,
            "area": "",
            "ech": 0
        },
        {
            "id": 4365,
            "name": "Montelepre",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "F544",
            "cod_istat": "082050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 1058,
            "area": "",
            "ech": 0
        },
        {
            "id": 4366,
            "name": "Montelibretti",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "F545",
            "cod_istat": "058063",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 1789,
            "area": "",
            "ech": 0
        },
        {
            "id": 4367,
            "name": "Montella",
            "provincia": "AV",
            "cap": "83048",
            "cod_catastale": "F546",
            "cod_istat": "064057",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 560,
            "giorni": 2002,
            "area": "",
            "ech": 0
        },
        {
            "id": 4368,
            "name": "Montello",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "F547",
            "cod_istat": "016139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 4369,
            "name": "Montelongo",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "F548",
            "cod_istat": "070044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 591,
            "giorni": 2117,
            "area": "",
            "ech": 0
        },
        {
            "id": 4370,
            "name": "Montelparo",
            "provincia": "FM",
            "cap": "63853",
            "cod_catastale": "F549",
            "cod_istat": "109020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 588,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 4371,
            "name": "Montelupo Albese",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "F550",
            "cod_istat": "004137",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 564,
            "giorni": 3014,
            "area": "",
            "ech": 0
        },
        {
            "id": 4372,
            "name": "Montelupo Fiorentino",
            "provincia": "FI",
            "cap": "50056",
            "cod_catastale": "F551",
            "cod_istat": "048028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1669,
            "area": "",
            "ech": 0
        },
        {
            "id": 4373,
            "name": "Montelupone",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F552",
            "cod_istat": "043030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 1958,
            "area": "",
            "ech": 0
        },
        {
            "id": 4374,
            "name": "Colli al Metauro",
            "provincia": "PU",
            "cap": "61036",
            "cod_catastale": "M380",
            "cod_istat": "041069",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4375,
            "name": "Montemaggiore Belsito",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "F553",
            "cod_istat": "082051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 1430,
            "area": "",
            "ech": 0
        },
        {
            "id": 4376,
            "name": "Montemagno",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "F556",
            "cod_istat": "005077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 4377,
            "name": "Montemale di Cuneo",
            "provincia": "CN",
            "cap": "12025",
            "cod_catastale": "F558",
            "cod_istat": "004138",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 931,
            "giorni": 3470,
            "area": "",
            "ech": 0
        },
        {
            "id": 4378,
            "name": "Montemarano",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "F559",
            "cod_istat": "064058",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 820,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 4379,
            "name": "Montemarciano",
            "provincia": "AN",
            "cap": "60018",
            "cod_catastale": "F560",
            "cod_istat": "042027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 1826,
            "area": "",
            "ech": 0
        },
        {
            "id": 4380,
            "name": "Montemarzino",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "F562",
            "cod_istat": "006108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 448,
            "giorni": 2945,
            "area": "",
            "ech": 0
        },
        {
            "id": 4381,
            "name": "Montemesola",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "F563",
            "cod_istat": "073017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 178,
            "giorni": 1359,
            "area": "",
            "ech": 0
        },
        {
            "id": 4382,
            "name": "Montemezzo",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "F564",
            "cod_istat": "013155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 522,
            "giorni": 2811,
            "area": "",
            "ech": 0
        },
        {
            "id": 4383,
            "name": "Montemignaio",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "F565",
            "cod_istat": "051023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 739,
            "giorni": 2949,
            "area": "",
            "ech": 0
        },
        {
            "id": 4384,
            "name": "Montemiletto",
            "provincia": "AV",
            "cap": "83038",
            "cod_catastale": "F566",
            "cod_istat": "064059",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2158,
            "area": "",
            "ech": 0
        },
        {
            "id": 4385,
            "name": "Montemilone",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "F568",
            "cod_istat": "076051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1405,
            "area": "",
            "ech": 0
        },
        {
            "id": 4386,
            "name": "Montemitro",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "F569",
            "cod_istat": "070045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 2020,
            "area": "",
            "ech": 0
        },
        {
            "id": 4387,
            "name": "Montemonaco",
            "provincia": "AP",
            "cap": "63088",
            "cod_catastale": "F570",
            "cod_istat": "044044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 988,
            "giorni": 2757,
            "area": "",
            "ech": 0
        },
        {
            "id": 4388,
            "name": "Montemurlo",
            "provincia": "PO",
            "cap": "59013",
            "cod_catastale": "F572",
            "cod_istat": "100003",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 1792,
            "area": "",
            "ech": 0
        },
        {
            "id": 4389,
            "name": "Montemurro",
            "provincia": "PZ",
            "cap": "85053",
            "cod_catastale": "F573",
            "cod_istat": "076052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 723,
            "giorni": 2224,
            "area": "",
            "ech": 0
        },
        {
            "id": 4390,
            "name": "Montenars",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "F574",
            "cod_istat": "030061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 486,
            "giorni": 3330,
            "area": "",
            "ech": 0
        },
        {
            "id": 4391,
            "name": "Montenero di Bisaccia",
            "provincia": "CB",
            "cap": "86036",
            "cod_catastale": "F576",
            "cod_istat": "070046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 1663,
            "area": "",
            "ech": 0
        },
        {
            "id": 4392,
            "name": "Montenero Sabino",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "F579",
            "cod_istat": "057042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2184,
            "area": "",
            "ech": 0
        },
        {
            "id": 4393,
            "name": "Montenero Val Cocchiara",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "F580",
            "cod_istat": "094029",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 950,
            "giorni": 2538,
            "area": "",
            "ech": 0
        },
        {
            "id": 4394,
            "name": "Montenerodomo",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "F578",
            "cod_istat": "069054",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1165,
            "giorni": 2936,
            "area": "",
            "ech": 0
        },
        {
            "id": 4395,
            "name": "Monteodorisio",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "F582",
            "cod_istat": "069055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 1708,
            "area": "",
            "ech": 0
        },
        {
            "id": 4396,
            "name": "Montepaone",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "F586",
            "cod_istat": "079081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 367,
            "giorni": 1431,
            "area": "",
            "ech": 1
        },
        {
            "id": 4397,
            "name": "Monteparano",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "F587",
            "cod_istat": "073018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 1284,
            "area": "",
            "ech": 0
        },
        {
            "id": 4398,
            "name": "Monteprandone",
            "provincia": "AP",
            "cap": "63076",
            "cod_catastale": "F591",
            "cod_istat": "044045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 1951,
            "area": "",
            "ech": 0
        },
        {
            "id": 4399,
            "name": "Montepulciano",
            "provincia": "SI",
            "cap": "53045",
            "cod_catastale": "F592",
            "cod_istat": "052015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 605,
            "giorni": 2100,
            "area": "",
            "ech": 0
        },
        {
            "id": 4400,
            "name": "Monterado",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "F593",
            "cod_istat": "042028",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 1897,
            "area": "",
            "ech": 0
        },
        {
            "id": 4401,
            "name": "Monterchi",
            "provincia": "AR",
            "cap": "52035",
            "cod_catastale": "F594",
            "cod_istat": "051024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 4402,
            "name": "Montereale",
            "provincia": "AQ",
            "cap": "67015",
            "cod_catastale": "F595",
            "cod_istat": "066056",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 945,
            "giorni": 2980,
            "area": "",
            "ech": 0
        },
        {
            "id": 4403,
            "name": "Montereale Valcellina",
            "provincia": "PN",
            "cap": "33086",
            "cod_catastale": "F596",
            "cod_istat": "093027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 318,
            "giorni": 2911,
            "area": "",
            "ech": 0
        },
        {
            "id": 4404,
            "name": "Monterenzio",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "F597",
            "cod_istat": "037041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2490,
            "area": "",
            "ech": 0
        },
        {
            "id": 4405,
            "name": "Monteriggioni",
            "provincia": "SI",
            "cap": "53035",
            "cod_catastale": "F598",
            "cod_istat": "052016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 4406,
            "name": "Monteroduni",
            "provincia": "IS",
            "cap": "86075",
            "cod_catastale": "F601",
            "cod_istat": "094030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 468,
            "giorni": 1903,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4407,
            "name": "Monteroni d'Arbia",
            "provincia": "SI",
            "cap": "53014",
            "cod_catastale": "F605",
            "cod_istat": "052017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 1621,
            "area": "",
            "ech": 0
        },
        {
            "id": 4408,
            "name": "Monteroni di Lecce",
            "provincia": "LE",
            "cap": "73047",
            "cod_catastale": "F604",
            "cod_istat": "075048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1055,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4409,
            "name": "Monterosi",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "F606",
            "cod_istat": "056038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 1911,
            "area": "",
            "ech": 0
        },
        {
            "id": 4410,
            "name": "Monterosso al Mare",
            "provincia": "SP",
            "cap": "19016",
            "cod_catastale": "F609",
            "cod_istat": "011019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1321,
            "area": "",
            "ech": 0
        },
        {
            "id": 4411,
            "name": "Monterosso Almo",
            "provincia": "RG",
            "cap": "97010",
            "cod_catastale": "F610",
            "cod_istat": "088007",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 691,
            "giorni": 1591,
            "area": "",
            "ech": 1
        },
        {
            "id": 4412,
            "name": "Monterosso Calabro",
            "provincia": "VV",
            "cap": "89819",
            "cod_catastale": "F607",
            "cod_istat": "102023",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 310,
            "giorni": 1311,
            "area": "",
            "ech": 1
        },
        {
            "id": 4413,
            "name": "Monterosso Grana",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "F608",
            "cod_istat": "004139",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 3208,
            "area": "",
            "ech": 0
        },
        {
            "id": 4414,
            "name": "Monterotondo",
            "provincia": "RM",
            "cap": "00015",
            "cod_catastale": "F611",
            "cod_istat": "058065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1669,
            "area": "",
            "ech": 0
        },
        {
            "id": 4415,
            "name": "Monterotondo Marittimo",
            "provincia": "GR",
            "cap": "58025",
            "cod_catastale": "F612",
            "cod_istat": "053027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 539,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 4416,
            "name": "Monterubbiano",
            "provincia": "FM",
            "cap": "63825",
            "cod_catastale": "F614",
            "cod_istat": "109022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 463,
            "giorni": 2181,
            "area": "",
            "ech": 0
        },
        {
            "id": 4417,
            "name": "Montesano Salentino",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "F623",
            "cod_istat": "075049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 1312,
            "area": "",
            "ech": 0
        },
        {
            "id": 4418,
            "name": "Montesano sulla Marcellana",
            "provincia": "SA",
            "cap": "84033",
            "cod_catastale": "F625",
            "cod_istat": "065076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 4419,
            "name": "Montesarchio",
            "provincia": "BN",
            "cap": "82016",
            "cod_catastale": "F636",
            "cod_istat": "062043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1616,
            "area": "",
            "ech": 0
        },
        {
            "id": 4420,
            "name": "Montescaglioso",
            "provincia": "MT",
            "cap": "75024",
            "cod_catastale": "F637",
            "cod_istat": "077017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 352,
            "giorni": 1597,
            "area": "",
            "ech": 0
        },
        {
            "id": 4421,
            "name": "Montescano",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "F638",
            "cod_istat": "018097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 4422,
            "name": "Montescheno",
            "provincia": "VB",
            "cap": "28843",
            "cod_catastale": "F639",
            "cod_istat": "103047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 512,
            "giorni": 2970,
            "area": "",
            "ech": 0
        },
        {
            "id": 4423,
            "name": "Montescudaio",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "F640",
            "cod_istat": "050020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 1879,
            "area": "",
            "ech": 0
        },
        {
            "id": 4424,
            "name": "Montescudo",
            "provincia": "RN",
            "cap": "47854",
            "cod_catastale": "F641",
            "cod_istat": "099010",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 4425,
            "name": "Montese",
            "provincia": "MO",
            "cap": "41055",
            "cod_catastale": "F642",
            "cod_istat": "036026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 841,
            "giorni": 3386,
            "area": "",
            "ech": 0
        },
        {
            "id": 4426,
            "name": "Montesegale",
            "provincia": "PV",
            "cap": "27052",
            "cod_catastale": "F644",
            "cod_istat": "018098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 2962,
            "area": "",
            "ech": 0
        },
        {
            "id": 4427,
            "name": "Montesilvano",
            "provincia": "PE",
            "cap": "65015",
            "cod_catastale": "F646",
            "cod_istat": "068024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1720,
            "area": "",
            "ech": 0
        },
        {
            "id": 4428,
            "name": "Montespertoli",
            "provincia": "FI",
            "cap": "50025",
            "cod_catastale": "F648",
            "cod_istat": "048030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2158,
            "area": "",
            "ech": 0
        },
        {
            "id": 4429,
            "name": "Monteu da Po",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "F651",
            "cod_istat": "001162",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4430,
            "name": "Monteu Roero",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "F654",
            "cod_istat": "004140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 2805,
            "area": "",
            "ech": 0
        },
        {
            "id": 4431,
            "name": "Montevago",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "F655",
            "cod_istat": "084025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1189,
            "area": "",
            "ech": 0
        },
        {
            "id": 4432,
            "name": "Montevarchi",
            "provincia": "AR",
            "cap": "52025",
            "cod_catastale": "F656",
            "cod_istat": "051026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 1953,
            "area": "",
            "ech": 0
        },
        {
            "id": 4433,
            "name": "Montevecchia",
            "provincia": "LC",
            "cap": "23874",
            "cod_catastale": "F657",
            "cod_istat": "097053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 4434,
            "name": "Monteveglio",
            "provincia": "BO",
            "cap": "40050",
            "cod_catastale": "F659",
            "cod_istat": "037043",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2319,
            "area": "",
            "ech": 0
        },
        {
            "id": 4435,
            "name": "Monteverde",
            "provincia": "AV",
            "cap": "83049",
            "cod_catastale": "F660",
            "cod_istat": "064060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2302,
            "area": "",
            "ech": 0
        },
        {
            "id": 4436,
            "name": "Monteverdi Marittimo",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "F661",
            "cod_istat": "050021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2039,
            "area": "",
            "ech": 0
        },
        {
            "id": 4437,
            "name": "Monteviale",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "F662",
            "cod_istat": "024066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2497,
            "area": "",
            "ech": 0
        },
        {
            "id": 4438,
            "name": "Montezemolo",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "F666",
            "cod_istat": "004141",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 741,
            "giorni": 3234,
            "area": "",
            "ech": 0
        },
        {
            "id": 4439,
            "name": "Monti",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "F667",
            "cod_istat": "090041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1486,
            "area": "",
            "ech": 0
        },
        {
            "id": 4440,
            "name": "Montiano",
            "provincia": "FC",
            "cap": "47020",
            "cod_catastale": "F668",
            "cod_istat": "040028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 4441,
            "name": "Monticelli Brusati",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "F672",
            "cod_istat": "017112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 4442,
            "name": "Monticelli d'Ongina",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "F671",
            "cod_istat": "033027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 4443,
            "name": "Monticelli Pavese",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "F670",
            "cod_istat": "018099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 4444,
            "name": "Monticello Brianza",
            "provincia": "LC",
            "cap": "23876",
            "cod_catastale": "F674",
            "cod_istat": "097054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 4445,
            "name": "Monticello Conte Otto",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "F675",
            "cod_istat": "024067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 4446,
            "name": "Monticello d'Alba",
            "provincia": "CN",
            "cap": "12066",
            "cod_catastale": "F669",
            "cod_istat": "004142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 4447,
            "name": "Montichiari",
            "provincia": "BS",
            "cap": "25018",
            "cod_catastale": "F471",
            "cod_istat": "017113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 4448,
            "name": "Monticiano",
            "provincia": "SI",
            "cap": "53015",
            "cod_catastale": "F676",
            "cod_istat": "052018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 1983,
            "area": "",
            "ech": 0
        },
        {
            "id": 4449,
            "name": "Montieri",
            "provincia": "GR",
            "cap": "58026",
            "cod_catastale": "F677",
            "cod_istat": "053017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 704,
            "giorni": 2500,
            "area": "",
            "ech": 0
        },
        {
            "id": 4450,
            "name": "Montiglio Monferrato",
            "provincia": "AT",
            "cap": "14026",
            "cod_catastale": "M302",
            "cod_istat": "005121",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4451,
            "name": "Montignoso",
            "provincia": "MS",
            "cap": "54038",
            "cod_catastale": "F679",
            "cod_istat": "045011",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1887,
            "area": "",
            "ech": 0
        },
        {
            "id": 4452,
            "name": "Montirone",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "F680",
            "cod_istat": "017114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 4453,
            "name": "Montjovet",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "F367",
            "cod_istat": "007043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 2785,
            "area": "",
            "ech": 0
        },
        {
            "id": 4454,
            "name": "Montodine",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "F681",
            "cod_istat": "019059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 4455,
            "name": "Montoggio",
            "provincia": "GE",
            "cap": "16026",
            "cod_catastale": "F682",
            "cod_istat": "010039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 438,
            "giorni": 2486,
            "area": "",
            "ech": 0
        },
        {
            "id": 4456,
            "name": "Montone",
            "provincia": "PG",
            "cap": "06014",
            "cod_catastale": "F685",
            "cod_istat": "054033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 4457,
            "name": "Montopoli di Sabina",
            "provincia": "RI",
            "cap": "02034",
            "cod_catastale": "F687",
            "cod_istat": "057044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 331,
            "giorni": 2056,
            "area": "",
            "ech": 0
        },
        {
            "id": 4458,
            "name": "Montopoli in Val d'Arno",
            "provincia": "PI",
            "cap": "56020",
            "cod_catastale": "F686",
            "cod_istat": "050022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 1714,
            "area": "",
            "ech": 0
        },
        {
            "id": 4459,
            "name": "Montorfano",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "F688",
            "cod_istat": "013157",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2657,
            "area": "",
            "ech": 0
        },
        {
            "id": 4460,
            "name": "Montorio al Vomano",
            "provincia": "TE",
            "cap": "64046",
            "cod_catastale": "F690",
            "cod_istat": "067028",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 263,
            "giorni": 1744,
            "area": "",
            "ech": 0
        },
        {
            "id": 4461,
            "name": "Montorio nei Frentani",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "F689",
            "cod_istat": "070047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 654,
            "giorni": 2207,
            "area": "",
            "ech": 0
        },
        {
            "id": 4462,
            "name": "Montorio Romano",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "F692",
            "cod_istat": "058066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2224,
            "area": "",
            "ech": 0
        },
        {
            "id": 4463,
            "name": "Montoro Inferiore",
            "provincia": "AV",
            "cap": "83025",
            "cod_catastale": "F693",
            "cod_istat": "064061",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 1353,
            "area": "",
            "ech": 0
        },
        {
            "id": 4464,
            "name": "Montoro Superiore",
            "provincia": "AV",
            "cap": "83026",
            "cod_catastale": "F694",
            "cod_istat": "064062",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1476,
            "area": "",
            "ech": 0
        },
        {
            "id": 4465,
            "name": "Montorso Vicentino",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "F696",
            "cod_istat": "024068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2422,
            "area": "",
            "ech": 0
        },
        {
            "id": 4466,
            "name": "Montottone",
            "provincia": "FM",
            "cap": "63843",
            "cod_catastale": "F697",
            "cod_istat": "109027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2050,
            "area": "",
            "ech": 0
        },
        {
            "id": 4467,
            "name": "Montresta",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "F698",
            "cod_istat": "095085",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 410,
            "giorni": 1475,
            "area": "",
            "ech": 0
        },
        {
            "id": 4468,
            "name": "Montù Beccaria",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "F701",
            "cod_istat": "018100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2947,
            "area": "",
            "ech": 0
        },
        {
            "id": 4469,
            "name": "Monvalle",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "F703",
            "cod_istat": "012104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 4470,
            "name": "Monza",
            "provincia": "MB",
            "cap": "20900",
            "cod_catastale": "F704",
            "cod_istat": "108033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2404,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 4471,
            "name": "Monzambano",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "F705",
            "cod_istat": "020036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 4472,
            "name": "Monzuno",
            "provincia": "BO",
            "cap": "40036",
            "cod_catastale": "F706",
            "cod_istat": "037044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 621,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 4473,
            "name": "Morano Calabro",
            "provincia": "CS",
            "cap": "87016",
            "cod_catastale": "F708",
            "cod_istat": "078083",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 694,
            "giorni": 2188,
            "area": "",
            "ech": 0
        },
        {
            "id": 4474,
            "name": "Morano sul Po",
            "provincia": "AL",
            "cap": "15025",
            "cod_catastale": "F707",
            "cod_istat": "006109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2820,
            "area": "",
            "ech": 0
        },
        {
            "id": 4475,
            "name": "Moransengo",
            "provincia": "AT",
            "cap": "14023",
            "cod_catastale": "F709",
            "cod_istat": "005079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2818,
            "area": "",
            "ech": 0
        },
        {
            "id": 4476,
            "name": "Moraro",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "F710",
            "cod_istat": "031013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 4477,
            "name": "Morazzone",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "F711",
            "cod_istat": "012105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 4478,
            "name": "Morbegno",
            "provincia": "SO",
            "cap": "23017",
            "cod_catastale": "F712",
            "cod_istat": "014045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 3042,
            "area": "",
            "ech": 0
        },
        {
            "id": 4479,
            "name": "Morbello",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F713",
            "cod_istat": "006110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 2820,
            "area": "",
            "ech": 0
        },
        {
            "id": 4480,
            "name": "Morciano di Leuca",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "F716",
            "cod_istat": "075050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1105,
            "area": "",
            "ech": 0
        },
        {
            "id": 4481,
            "name": "Morciano di Romagna",
            "provincia": "RN",
            "cap": "47833",
            "cod_catastale": "F715",
            "cod_istat": "099011",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2257,
            "area": "",
            "ech": 0
        },
        {
            "id": 4482,
            "name": "Morcone",
            "provincia": "BN",
            "cap": "82026",
            "cod_catastale": "F717",
            "cod_istat": "062044",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2162,
            "area": "",
            "ech": 0
        },
        {
            "id": 4483,
            "name": "Mordano",
            "provincia": "BO",
            "cap": "40027",
            "cod_catastale": "F718",
            "cod_istat": "037045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2255,
            "area": "",
            "ech": 0
        },
        {
            "id": 4484,
            "name": "Morengo",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "F720",
            "cod_istat": "016140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 4485,
            "name": "Mores",
            "provincia": "SS",
            "cap": "07013",
            "cod_catastale": "F721",
            "cod_istat": "090042",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 366,
            "giorni": 1611,
            "area": "",
            "ech": 0
        },
        {
            "id": 4486,
            "name": "Moresco",
            "provincia": "FM",
            "cap": "63826",
            "cod_catastale": "F722",
            "cod_istat": "109028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 4487,
            "name": "Moretta",
            "provincia": "CN",
            "cap": "12033",
            "cod_catastale": "F723",
            "cod_istat": "004143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 4488,
            "name": "Morfasso",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "F724",
            "cod_istat": "033028",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 631,
            "giorni": 3265,
            "area": "",
            "ech": 0
        },
        {
            "id": 4489,
            "name": "Morgano",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "F725",
            "cod_istat": "026047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 4490,
            "name": "Morgex",
            "provincia": "AO",
            "cap": "11017",
            "cod_catastale": "F726",
            "cod_istat": "007044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 923,
            "giorni": 3617,
            "area": "",
            "ech": 0
        },
        {
            "id": 4491,
            "name": "Morgongiori",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "F727",
            "cod_istat": "095030",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 351,
            "giorni": 1426,
            "area": "",
            "ech": 0
        },
        {
            "id": 4492,
            "name": "Mori",
            "provincia": "TN",
            "cap": "38065",
            "cod_catastale": "F728",
            "cod_istat": "022123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 4493,
            "name": "Moriago della Battaglia",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "F729",
            "cod_istat": "026048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2564,
            "area": "",
            "ech": 0
        },
        {
            "id": 4494,
            "name": "Moricone",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "F730",
            "cod_istat": "058067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 1903,
            "area": "",
            "ech": 0
        },
        {
            "id": 4495,
            "name": "Morigerati",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "F731",
            "cod_istat": "065077",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 268,
            "giorni": 1319,
            "area": "",
            "ech": 0
        },
        {
            "id": 4496,
            "name": "Morimondo",
            "provincia": "MI",
            "cap": "20081",
            "cod_catastale": "D033",
            "cod_istat": "015150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 4497,
            "name": "Morino",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "F732",
            "cod_istat": "066057",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 443,
            "giorni": 2081,
            "area": "",
            "ech": 0
        },
        {
            "id": 4498,
            "name": "Moriondo Torinese",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "F733",
            "cod_istat": "001163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 2846,
            "area": "",
            "ech": 0
        },
        {
            "id": 4499,
            "name": "Morlupo",
            "provincia": "RM",
            "cap": "00067",
            "cod_catastale": "F734",
            "cod_istat": "058068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 1831,
            "area": "",
            "ech": 0
        },
        {
            "id": 4500,
            "name": "Mormanno",
            "provincia": "CS",
            "cap": "87026",
            "cod_catastale": "F735",
            "cod_istat": "078084",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 840,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 4501,
            "name": "Mornago",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "F736",
            "cod_istat": "012106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 4502,
            "name": "Mornese",
            "provincia": "AL",
            "cap": "15075",
            "cod_catastale": "F737",
            "cod_istat": "006111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2801,
            "area": "",
            "ech": 0
        },
        {
            "id": 4503,
            "name": "Mornico al Serio",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "F738",
            "cod_istat": "016141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4504,
            "name": "Mornico Losana",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "F739",
            "cod_istat": "018101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 2958,
            "area": "",
            "ech": 0
        },
        {
            "id": 4505,
            "name": "Morolo",
            "provincia": "FR",
            "cap": "03017",
            "cod_catastale": "F740",
            "cod_istat": "060045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2044,
            "area": "",
            "ech": 0
        },
        {
            "id": 4506,
            "name": "Morozzo",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "F743",
            "cod_istat": "004144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2850,
            "area": "",
            "ech": 0
        },
        {
            "id": 4507,
            "name": "Morra De Sanctis",
            "provincia": "AV",
            "cap": "83040",
            "cod_catastale": "F744",
            "cod_istat": "064063",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 863,
            "giorni": 2363,
            "area": "",
            "ech": 0
        },
        {
            "id": 4508,
            "name": "Morro d'Alba",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "F745",
            "cod_istat": "042031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1936,
            "area": "",
            "ech": 0
        },
        {
            "id": 4509,
            "name": "Morro d'Oro",
            "provincia": "TE",
            "cap": "64020",
            "cod_catastale": "F747",
            "cod_istat": "067029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1649,
            "area": "",
            "ech": 0
        },
        {
            "id": 4510,
            "name": "Morro Reatino",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "F746",
            "cod_istat": "057045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 745,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 4511,
            "name": "Morrone del Sannio",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "F748",
            "cod_istat": "070048",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 839,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 4512,
            "name": "Morrovalle",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F749",
            "cod_istat": "043033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 1995,
            "area": "",
            "ech": 0
        },
        {
            "id": 4513,
            "name": "Morsano al Tagliamento",
            "provincia": "PN",
            "cap": "33075",
            "cod_catastale": "F750",
            "cod_istat": "093028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 4514,
            "name": "Morsasco",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "F751",
            "cod_istat": "006112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 4515,
            "name": "Mortara",
            "provincia": "PV",
            "cap": "27036",
            "cod_catastale": "F754",
            "cod_istat": "018102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 4516,
            "name": "Mortegliano",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "F756",
            "cod_istat": "030062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 41,
            "giorni": 2235,
            "area": "",
            "ech": 0
        },
        {
            "id": 4517,
            "name": "Morterone",
            "provincia": "LC",
            "cap": "23811",
            "cod_catastale": "F758",
            "cod_istat": "097055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1070,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 4518,
            "name": "Moruzzo",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "F760",
            "cod_istat": "030063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 263,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 4519,
            "name": "Moscazzano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "F761",
            "cod_istat": "019060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 4520,
            "name": "Moschiano",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "F762",
            "cod_istat": "064064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 1565,
            "area": "",
            "ech": 0
        },
        {
            "id": 4521,
            "name": "Mosciano Sant'Angelo",
            "provincia": "TE",
            "cap": "64023",
            "cod_catastale": "F764",
            "cod_istat": "067030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1604,
            "area": "",
            "ech": 0
        },
        {
            "id": 4522,
            "name": "Moscufo",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "F765",
            "cod_istat": "068025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 1429,
            "area": "",
            "ech": 0
        },
        {
            "id": 4523,
            "name": "Moso in Passiria",
            "provincia": "BZ",
            "cap": "39013",
            "cod_catastale": "F766",
            "cod_istat": "021054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1007,
            "giorni": 4058,
            "area": "",
            "ech": 0
        },
        {
            "id": 4524,
            "name": "Mossa",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "F767",
            "cod_istat": "031014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2306,
            "area": "",
            "ech": 0
        },
        {
            "id": 4525,
            "name": "Mossano",
            "provincia": "VI",
            "cap": "36024",
            "cod_catastale": "F768",
            "cod_istat": "024069",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 4526,
            "name": "Mosso",
            "provincia": "BI",
            "cap": "13822",
            "cod_catastale": "M304",
            "cod_istat": "096084",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4527,
            "name": "Motta Baluffi",
            "provincia": "CR",
            "cap": "26045",
            "cod_catastale": "F771",
            "cod_istat": "019061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4528,
            "name": "Motta Camastra",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "F772",
            "cod_istat": "083058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 453,
            "giorni": 1401,
            "area": "",
            "ech": 0
        },
        {
            "id": 4529,
            "name": "Motta d'Affermo",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "F773",
            "cod_istat": "083059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 1755,
            "area": "",
            "ech": 0
        },
        {
            "id": 4530,
            "name": "Motta de' Conti",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "F774",
            "cod_istat": "002082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2804,
            "area": "",
            "ech": 0
        },
        {
            "id": 4531,
            "name": "Motta di Livenza",
            "provincia": "TV",
            "cap": "31045",
            "cod_catastale": "F770",
            "cod_istat": "026049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2347,
            "area": "",
            "ech": 0
        },
        {
            "id": 4532,
            "name": "Motta Montecorvino",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "F777",
            "cod_istat": "071034",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 662,
            "giorni": 2215,
            "area": "",
            "ech": 0
        },
        {
            "id": 4533,
            "name": "Motta San Giovanni",
            "provincia": "RC",
            "cap": "89065",
            "cod_catastale": "F779",
            "cod_istat": "080054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1535,
            "area": "",
            "ech": 1
        },
        {
            "id": 4534,
            "name": "Motta Santa Lucia",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "F780",
            "cod_istat": "079083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 1988,
            "area": "",
            "ech": 0
        },
        {
            "id": 4535,
            "name": "Motta Sant'Anastasia",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "F781",
            "cod_istat": "087030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1143,
            "area": "",
            "ech": 1
        },
        {
            "id": 4536,
            "name": "Motta Visconti",
            "provincia": "MI",
            "cap": "20086",
            "cod_catastale": "F783",
            "cod_istat": "015151",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 4537,
            "name": "Mottafollone",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "F775",
            "cod_istat": "078085",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 384,
            "giorni": 1616,
            "area": "",
            "ech": 0
        },
        {
            "id": 4538,
            "name": "Mottalciata",
            "provincia": "BI",
            "cap": "13874",
            "cod_catastale": "F776",
            "cod_istat": "096037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 4539,
            "name": "Motteggiana",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "B012",
            "cod_istat": "020037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 4540,
            "name": "Mottola",
            "provincia": "TA",
            "cap": "74017",
            "cod_catastale": "F784",
            "cod_istat": "073019",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 387,
            "giorni": 1715,
            "area": "",
            "ech": 0
        },
        {
            "id": 4541,
            "name": "Mozzagrogna",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "F785",
            "cod_istat": "069056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 1575,
            "area": "",
            "ech": 0
        },
        {
            "id": 4542,
            "name": "Mozzanica",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "F786",
            "cod_istat": "016142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4543,
            "name": "Mozzate",
            "provincia": "CO",
            "cap": "22076",
            "cod_catastale": "F788",
            "cod_istat": "013159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2219,
            "area": "",
            "ech": 0
        },
        {
            "id": 4544,
            "name": "Mozzecane",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "F789",
            "cod_istat": "023051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2492,
            "area": "",
            "ech": 0
        },
        {
            "id": 4545,
            "name": "Mozzo",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "F791",
            "cod_istat": "016143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2358,
            "area": "",
            "ech": 0
        },
        {
            "id": 4546,
            "name": "Muccia",
            "provincia": "MC",
            "cap": "62034",
            "cod_catastale": "F793",
            "cod_istat": "043034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 2171,
            "area": "",
            "ech": 0
        },
        {
            "id": 4547,
            "name": "Muggia",
            "provincia": "TS",
            "cap": "34015",
            "cod_catastale": "F795",
            "cod_istat": "032003",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2104,
            "area": "",
            "ech": 0
        },
        {
            "id": 4548,
            "name": "Muggiò",
            "provincia": "MB",
            "cap": "20835",
            "cod_catastale": "F797",
            "cod_istat": "108034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4549,
            "name": "Mugnano del Cardinale",
            "provincia": "AV",
            "cap": "83027",
            "cod_catastale": "F798",
            "cod_istat": "064065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1442,
            "area": "",
            "ech": 0
        },
        {
            "id": 4550,
            "name": "Mugnano di Napoli",
            "provincia": "NA",
            "cap": "80018",
            "cod_catastale": "F799",
            "cod_istat": "063048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 4551,
            "name": "Mulazzano",
            "provincia": "LO",
            "cap": "26837",
            "cod_catastale": "F801",
            "cod_istat": "098041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4552,
            "name": "Mulazzo",
            "provincia": "MS",
            "cap": "54026",
            "cod_catastale": "F802",
            "cod_istat": "045012",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 4553,
            "name": "Mura",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "F806",
            "cod_istat": "017115",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 691,
            "giorni": 3197,
            "area": "",
            "ech": 0
        },
        {
            "id": 4554,
            "name": "Muravera",
            "provincia": "SU",
            "cap": "09043",
            "cod_catastale": "F808",
            "cod_istat": "111042",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 862,
            "area": "",
            "ech": 0
        },
        {
            "id": 4555,
            "name": "Murazzano",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "F809",
            "cod_istat": "004145",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 739,
            "giorni": 3231,
            "area": "",
            "ech": 0
        },
        {
            "id": 4556,
            "name": "Murello",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "F811",
            "cod_istat": "004146",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2637,
            "area": "",
            "ech": 0
        },
        {
            "id": 4557,
            "name": "Murialdo",
            "provincia": "SV",
            "cap": "17013",
            "cod_catastale": "F813",
            "cod_istat": "009040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 524,
            "giorni": 2518,
            "area": "",
            "ech": 0
        },
        {
            "id": 4558,
            "name": "Murisengo",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "F814",
            "cod_istat": "006113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 338,
            "giorni": 2766,
            "area": "",
            "ech": 0
        },
        {
            "id": 4559,
            "name": "Murlo",
            "provincia": "SI",
            "cap": "53016",
            "cod_catastale": "F815",
            "cod_istat": "052019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 1846,
            "area": "",
            "ech": 0
        },
        {
            "id": 4560,
            "name": "Muro Leccese",
            "provincia": "LE",
            "cap": "73036",
            "cod_catastale": "F816",
            "cod_istat": "075051",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 1213,
            "area": "",
            "ech": 0
        },
        {
            "id": 4561,
            "name": "Muro Lucano",
            "provincia": "PZ",
            "cap": "85054",
            "cod_catastale": "F817",
            "cod_istat": "076053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2000,
            "area": "",
            "ech": 0
        },
        {
            "id": 4562,
            "name": "Muros",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "F818",
            "cod_istat": "090043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 1496,
            "area": "",
            "ech": 0
        },
        {
            "id": 4563,
            "name": "Muscoline",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "F820",
            "cod_istat": "017116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2632,
            "area": "",
            "ech": 0
        },
        {
            "id": 4564,
            "name": "Musei",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "F822",
            "cod_istat": "111043",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 119,
            "giorni": 1076,
            "area": "",
            "ech": 0
        },
        {
            "id": 4565,
            "name": "Musile di Piave",
            "provincia": "VE",
            "cap": "30024",
            "cod_catastale": "F826",
            "cod_istat": "027025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 4566,
            "name": "Musso",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "F828",
            "cod_istat": "013160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2219,
            "area": "",
            "ech": 0
        },
        {
            "id": 4567,
            "name": "Mussolente",
            "provincia": "VI",
            "cap": "36065",
            "cod_catastale": "F829",
            "cod_istat": "024070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 4568,
            "name": "Mussomeli",
            "provincia": "CL",
            "cap": "93014",
            "cod_catastale": "F830",
            "cod_istat": "085012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 726,
            "giorni": 1763,
            "area": "",
            "ech": 1
        },
        {
            "id": 4569,
            "name": "Muzzana del Turgnano",
            "provincia": "UD",
            "cap": "33055",
            "cod_catastale": "F832",
            "cod_istat": "030064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 4570,
            "name": "Muzzano",
            "provincia": "BI",
            "cap": "13895",
            "cod_catastale": "F833",
            "cod_istat": "096038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 565,
            "giorni": 3058,
            "area": "",
            "ech": 0
        },
        {
            "id": 4571,
            "name": "Nago-Torbole",
            "provincia": "TN",
            "cap": "38069",
            "cod_catastale": "F835",
            "cod_istat": "022124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 4572,
            "name": "Nalles",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "F836",
            "cod_istat": "021055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2915,
            "area": "",
            "ech": 0
        },
        {
            "id": 4573,
            "name": "Nanno",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "F837",
            "cod_istat": "022125",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 551,
            "giorni": 3250,
            "area": "",
            "ech": 0
        },
        {
            "id": 4574,
            "name": "Nanto",
            "provincia": "VI",
            "cap": "36024",
            "cod_catastale": "F838",
            "cod_istat": "024071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 4575,
            "name": "Napoli",
            "provincia": "NA",
            "cap": "801xx",
            "cod_catastale": "F839",
            "cod_istat": "063049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 1034,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 4576,
            "name": "Narbolia",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "F840",
            "cod_istat": "095031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 1050,
            "area": "",
            "ech": 0
        },
        {
            "id": 4577,
            "name": "Narcao",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "F841",
            "cod_istat": "111044",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 125,
            "giorni": 1103,
            "area": "",
            "ech": 1
        },
        {
            "id": 4578,
            "name": "Nardò",
            "provincia": "LE",
            "cap": "73048",
            "cod_catastale": "F842",
            "cod_istat": "075052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 1208,
            "area": "",
            "ech": 0
        },
        {
            "id": 4579,
            "name": "Nardodipace",
            "provincia": "VV",
            "cap": "89824",
            "cod_catastale": "F843",
            "cod_istat": "102024",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1080,
            "giorni": 3017,
            "area": "",
            "ech": 0
        },
        {
            "id": 4580,
            "name": "Narni",
            "provincia": "TR",
            "cap": "05035",
            "cod_catastale": "F844",
            "cod_istat": "055022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1802,
            "area": "",
            "ech": 0
        },
        {
            "id": 4581,
            "name": "Naro",
            "provincia": "AG",
            "cap": "92028",
            "cod_catastale": "F845",
            "cod_istat": "084026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1320,
            "area": "",
            "ech": 1
        },
        {
            "id": 4582,
            "name": "Narzole",
            "provincia": "CN",
            "cap": "12068",
            "cod_catastale": "F846",
            "cod_istat": "004147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2718,
            "area": "",
            "ech": 0
        },
        {
            "id": 4583,
            "name": "Nasino",
            "provincia": "SV",
            "cap": "17030",
            "cod_catastale": "F847",
            "cod_istat": "009041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 2108,
            "area": "",
            "ech": 0
        },
        {
            "id": 4584,
            "name": "Naso",
            "provincia": "ME",
            "cap": "98074",
            "cod_catastale": "F848",
            "cod_istat": "083060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 1464,
            "area": "",
            "ech": 1
        },
        {
            "id": 4585,
            "name": "Naturno",
            "provincia": "BZ",
            "cap": "39025",
            "cod_catastale": "F849",
            "cod_istat": "021056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 528,
            "giorni": 3188,
            "area": "",
            "ech": 0
        },
        {
            "id": 4586,
            "name": "Nave",
            "provincia": "BS",
            "cap": "25075",
            "cod_catastale": "F851",
            "cod_istat": "017117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 4587,
            "name": "Nave San Rocco",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "F853",
            "cod_istat": "022126",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2745,
            "area": "",
            "ech": 0
        },
        {
            "id": 4588,
            "name": "Navelli",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "F852",
            "cod_istat": "066058",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 760,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 4589,
            "name": "Naz-Sciaves",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "F856",
            "cod_istat": "021057",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 772,
            "giorni": 3637,
            "area": "",
            "ech": 0
        },
        {
            "id": 4590,
            "name": "Nazzano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "F857",
            "cod_istat": "058069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 1823,
            "area": "",
            "ech": 0
        },
        {
            "id": 4591,
            "name": "Ne",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "F858",
            "cod_istat": "010040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1819,
            "area": "",
            "ech": 0
        },
        {
            "id": 4592,
            "name": "Nebbiuno",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "F859",
            "cod_istat": "003103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2831,
            "area": "",
            "ech": 0
        },
        {
            "id": 4593,
            "name": "Negrar di Valpolicella",
            "provincia": "VR",
            "cap": "37024",
            "cod_catastale": "F861",
            "cod_istat": "023052",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4594,
            "name": "Neirone",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "F862",
            "cod_istat": "010041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2290,
            "area": "",
            "ech": 0
        },
        {
            "id": 4595,
            "name": "Neive",
            "provincia": "CN",
            "cap": "12052",
            "cod_catastale": "F863",
            "cod_istat": "004148",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 2550,
            "area": "",
            "ech": 0
        },
        {
            "id": 4596,
            "name": "Nembro",
            "provincia": "BG",
            "cap": "24027",
            "cod_catastale": "F864",
            "cod_istat": "016144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 4597,
            "name": "Nemi",
            "provincia": "RM",
            "cap": "00074",
            "cod_catastale": "F865",
            "cod_istat": "058070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 2161,
            "area": "",
            "ech": 0
        },
        {
            "id": 4598,
            "name": "Nemoli",
            "provincia": "PZ",
            "cap": "85040",
            "cod_catastale": "F866",
            "cod_istat": "076054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 4599,
            "name": "Neoneli",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "F867",
            "cod_istat": "095032",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 554,
            "giorni": 1686,
            "area": "",
            "ech": 0
        },
        {
            "id": 4600,
            "name": "Nepi",
            "provincia": "VT",
            "cap": "01036",
            "cod_catastale": "F868",
            "cod_istat": "056039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 1824,
            "area": "",
            "ech": 0
        },
        {
            "id": 4601,
            "name": "Nereto",
            "provincia": "TE",
            "cap": "64015",
            "cod_catastale": "F870",
            "cod_istat": "067031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 163,
            "giorni": 1489,
            "area": "",
            "ech": 0
        },
        {
            "id": 4602,
            "name": "Nerola",
            "provincia": "RM",
            "cap": "00017",
            "cod_catastale": "F871",
            "cod_istat": "058071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 453,
            "giorni": 2018,
            "area": "",
            "ech": 0
        },
        {
            "id": 4603,
            "name": "Nervesa della Battaglia",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "F872",
            "cod_istat": "026050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2465,
            "area": "",
            "ech": 0
        },
        {
            "id": 4604,
            "name": "Nerviano",
            "provincia": "MI",
            "cap": "20014",
            "cod_catastale": "F874",
            "cod_istat": "015154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 4605,
            "name": "Nespolo",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "F876",
            "cod_istat": "057046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 886,
            "giorni": 2977,
            "area": "",
            "ech": 0
        },
        {
            "id": 4606,
            "name": "Nesso",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "F877",
            "cod_istat": "013161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 4607,
            "name": "Netro",
            "provincia": "BI",
            "cap": "13896",
            "cod_catastale": "F878",
            "cod_istat": "096039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 606,
            "giorni": 3092,
            "area": "",
            "ech": 0
        },
        {
            "id": 4608,
            "name": "Nettuno",
            "provincia": "RM",
            "cap": "00048",
            "cod_catastale": "F880",
            "cod_istat": "058072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 1255,
            "area": "",
            "ech": 0
        },
        {
            "id": 4609,
            "name": "Neviano",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "F881",
            "cod_istat": "075053",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1288,
            "area": "",
            "ech": 0
        },
        {
            "id": 4610,
            "name": "Neviano degli Arduini",
            "provincia": "PR",
            "cap": "43024",
            "cod_catastale": "F882",
            "cod_istat": "034024",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 3119,
            "area": "",
            "ech": 0
        },
        {
            "id": 4611,
            "name": "Neviglie",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "F883",
            "cod_istat": "004149",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 461,
            "giorni": 2887,
            "area": "",
            "ech": 0
        },
        {
            "id": 4612,
            "name": "Niardo",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "F884",
            "cod_istat": "017118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 442,
            "giorni": 2843,
            "area": "",
            "ech": 0
        },
        {
            "id": 4613,
            "name": "Nibbiano",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "F885",
            "cod_istat": "033029",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 4614,
            "name": "Nibbiola",
            "provincia": "NO",
            "cap": "28070",
            "cod_catastale": "F886",
            "cod_istat": "003104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 4615,
            "name": "Nibionno",
            "provincia": "LC",
            "cap": "23895",
            "cod_catastale": "F887",
            "cod_istat": "097056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 306,
            "giorni": 2504,
            "area": "",
            "ech": 0
        },
        {
            "id": 4616,
            "name": "Nichelino",
            "provincia": "TO",
            "cap": "10042",
            "cod_catastale": "F889",
            "cod_istat": "001164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 4617,
            "name": "Nicolosi",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "F890",
            "cod_istat": "087031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 1663,
            "area": "",
            "ech": 1
        },
        {
            "id": 4618,
            "name": "Nicorvo",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "F891",
            "cod_istat": "018103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 4619,
            "name": "Nicosia",
            "provincia": "EN",
            "cap": "94014",
            "cod_catastale": "F892",
            "cod_istat": "086012",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 724,
            "giorni": 1760,
            "area": "",
            "ech": 1
        },
        {
            "id": 4620,
            "name": "Nicotera",
            "provincia": "VV",
            "cap": "89844",
            "cod_catastale": "F893",
            "cod_istat": "102025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 1194,
            "area": "",
            "ech": 0
        },
        {
            "id": 4621,
            "name": "Niella Belbo",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "F894",
            "cod_istat": "004150",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 785,
            "giorni": 3288,
            "area": "",
            "ech": 0
        },
        {
            "id": 4622,
            "name": "Niella Tanaro",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "F895",
            "cod_istat": "004151",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 371,
            "giorni": 2775,
            "area": "",
            "ech": 0
        },
        {
            "id": 4623,
            "name": "Nimis",
            "provincia": "UD",
            "cap": "33045",
            "cod_catastale": "F898",
            "cod_istat": "030065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2787,
            "area": "",
            "ech": 0
        },
        {
            "id": 4624,
            "name": "Niscemi",
            "provincia": "CL",
            "cap": "93015",
            "cod_catastale": "F899",
            "cod_istat": "085013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 1164,
            "area": "",
            "ech": 0
        },
        {
            "id": 4625,
            "name": "Nissoria",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "F900",
            "cod_istat": "086013",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 691,
            "giorni": 1710,
            "area": "",
            "ech": 1
        },
        {
            "id": 4626,
            "name": "Nizza di Sicilia",
            "provincia": "ME",
            "cap": "98026",
            "cod_catastale": "F901",
            "cod_istat": "083061",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 642,
            "area": "",
            "ech": 0
        },
        {
            "id": 4627,
            "name": "Nizza Monferrato",
            "provincia": "AT",
            "cap": "14049",
            "cod_catastale": "F902",
            "cod_istat": "005080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 4628,
            "name": "Noale",
            "provincia": "VE",
            "cap": "30033",
            "cod_catastale": "F904",
            "cod_istat": "027026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 4629,
            "name": "Noasca",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "F906",
            "cod_istat": "001165",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1062,
            "giorni": 3904,
            "area": "",
            "ech": 0
        },
        {
            "id": 4630,
            "name": "Nocara",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "F907",
            "cod_istat": "078086",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 859,
            "giorni": 2515,
            "area": "",
            "ech": 0
        },
        {
            "id": 4631,
            "name": "Nocciano",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "F908",
            "cod_istat": "068026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 1710,
            "area": "",
            "ech": 0
        },
        {
            "id": 4632,
            "name": "Nocera Inferiore",
            "provincia": "SA",
            "cap": "84014",
            "cod_catastale": "F912",
            "cod_istat": "065078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1194,
            "area": "",
            "ech": 0
        },
        {
            "id": 4633,
            "name": "Nocera Superiore",
            "provincia": "SA",
            "cap": "84015",
            "cod_catastale": "F913",
            "cod_istat": "065079",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1228,
            "area": "",
            "ech": 0
        },
        {
            "id": 4634,
            "name": "Nocera Terinese",
            "provincia": "CZ",
            "cap": "88047",
            "cod_catastale": "F910",
            "cod_istat": "079087",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4635,
            "name": "Nocera Umbra",
            "provincia": "PG",
            "cap": "06025",
            "cod_catastale": "F911",
            "cod_istat": "054034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2318,
            "area": "",
            "ech": 0
        },
        {
            "id": 4636,
            "name": "Noceto",
            "provincia": "PR",
            "cap": "43015",
            "cod_catastale": "F914",
            "cod_istat": "034025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 4637,
            "name": "Noci",
            "provincia": "BA",
            "cap": "70015",
            "cod_catastale": "F915",
            "cod_istat": "072031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1785,
            "area": "",
            "ech": 0
        },
        {
            "id": 4638,
            "name": "Nociglia",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "F916",
            "cod_istat": "075054",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 1276,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4639,
            "name": "Noepoli",
            "provincia": "PZ",
            "cap": "85035",
            "cod_catastale": "F917",
            "cod_istat": "076055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 676,
            "giorni": 2138,
            "area": "",
            "ech": 0
        },
        {
            "id": 4640,
            "name": "Nogara",
            "provincia": "VR",
            "cap": "37054",
            "cod_catastale": "F918",
            "cod_istat": "023053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2327,
            "area": "",
            "ech": 0
        },
        {
            "id": 4641,
            "name": "Nogaredo",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "F920",
            "cod_istat": "022127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2731,
            "area": "",
            "ech": 0
        },
        {
            "id": 4642,
            "name": "Nogarole Rocca",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "F921",
            "cod_istat": "023054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 2358,
            "area": "",
            "ech": 0
        },
        {
            "id": 4643,
            "name": "Nogarole Vicentino",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "F922",
            "cod_istat": "024072",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 3104,
            "area": "",
            "ech": 0
        },
        {
            "id": 4644,
            "name": "Noicattaro",
            "provincia": "BA",
            "cap": "70016",
            "cod_catastale": "F923",
            "cod_istat": "072032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 1321,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4645,
            "name": "Nola",
            "provincia": "NA",
            "cap": "80035",
            "cod_catastale": "F924",
            "cod_istat": "063050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 1021,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 4646,
            "name": "Nole",
            "provincia": "TO",
            "cap": "10076",
            "cod_catastale": "F925",
            "cod_istat": "001166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2948,
            "area": "",
            "ech": 0
        },
        {
            "id": 4647,
            "name": "Noli",
            "provincia": "SV",
            "cap": "17026",
            "cod_catastale": "F926",
            "cod_istat": "009042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1379,
            "area": "",
            "ech": 0
        },
        {
            "id": 4648,
            "name": "Nomaglio",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "F927",
            "cod_istat": "001167",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3101,
            "area": "",
            "ech": 0
        },
        {
            "id": 4649,
            "name": "Nomi",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "F929",
            "cod_istat": "022128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2674,
            "area": "",
            "ech": 0
        },
        {
            "id": 4650,
            "name": "Nonantola",
            "provincia": "MO",
            "cap": "41015",
            "cod_catastale": "F930",
            "cod_istat": "036027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 4651,
            "name": "None",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "F931",
            "cod_istat": "001168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 4652,
            "name": "Nonio",
            "provincia": "VB",
            "cap": "28891",
            "cod_catastale": "F932",
            "cod_istat": "103048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 476,
            "giorni": 2889,
            "area": "",
            "ech": 0
        },
        {
            "id": 4653,
            "name": "Noragugume",
            "provincia": "NU",
            "cap": "08010",
            "cod_catastale": "F933",
            "cod_istat": "091050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 1126,
            "area": "",
            "ech": 0
        },
        {
            "id": 4654,
            "name": "Norbello",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "F934",
            "cod_istat": "095033",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 315,
            "giorni": 1380,
            "area": "",
            "ech": 0
        },
        {
            "id": 4655,
            "name": "Norcia",
            "provincia": "PG",
            "cap": "06046",
            "cod_catastale": "F935",
            "cod_istat": "054035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 4656,
            "name": "Norma",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "F937",
            "cod_istat": "059016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1828,
            "area": "",
            "ech": 0
        },
        {
            "id": 4657,
            "name": "Nosate",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "F939",
            "cod_istat": "015155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 4658,
            "name": "Notaresco",
            "provincia": "TE",
            "cap": "64024",
            "cod_catastale": "F942",
            "cod_istat": "067032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 1751,
            "area": "",
            "ech": 0
        },
        {
            "id": 4659,
            "name": "Noto",
            "provincia": "SR",
            "cap": "96017",
            "cod_catastale": "F943",
            "cod_istat": "089013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 952,
            "area": "",
            "ech": 1
        },
        {
            "id": 4660,
            "name": "Nova Levante",
            "provincia": "BZ",
            "cap": "39056",
            "cod_catastale": "F949",
            "cod_istat": "021058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1182,
            "giorni": 4301,
            "area": "",
            "ech": 0
        },
        {
            "id": 4661,
            "name": "Nova Milanese",
            "provincia": "MB",
            "cap": "20834",
            "cod_catastale": "F944",
            "cod_istat": "108035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4662,
            "name": "Nova Ponente",
            "provincia": "BZ",
            "cap": "39050",
            "cod_catastale": "F950",
            "cod_istat": "021059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1357,
            "giorni": 4642,
            "area": "",
            "ech": 0
        },
        {
            "id": 4663,
            "name": "Nova Siri",
            "provincia": "MT",
            "cap": "75020",
            "cod_catastale": "A942",
            "cod_istat": "077018",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 1542,
            "area": "",
            "ech": 0
        },
        {
            "id": 4664,
            "name": "Novafeltria",
            "provincia": "RN",
            "cap": "47863",
            "cod_catastale": "F137",
            "cod_istat": "099023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2294,
            "area": "",
            "ech": 0
        },
        {
            "id": 4665,
            "name": "Novaledo",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "F947",
            "cod_istat": "022129",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 3026,
            "area": "",
            "ech": 0
        },
        {
            "id": 4666,
            "name": "Novalesa",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "F948",
            "cod_istat": "001169",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 828,
            "giorni": 3596,
            "area": "",
            "ech": 0
        },
        {
            "id": 4667,
            "name": "Novara",
            "provincia": "NO",
            "cap": "28100",
            "cod_catastale": "F952",
            "cod_istat": "003106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2463,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4668,
            "name": "Novara di Sicilia",
            "provincia": "ME",
            "cap": "98058",
            "cod_catastale": "F951",
            "cod_istat": "083062",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 1738,
            "area": "",
            "ech": 1
        },
        {
            "id": 4669,
            "name": "Novate Mezzola",
            "provincia": "SO",
            "cap": "23025",
            "cod_catastale": "F956",
            "cod_istat": "014046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 4670,
            "name": "Novate Milanese",
            "provincia": "MI",
            "cap": "20026",
            "cod_catastale": "F955",
            "cod_istat": "015157",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4671,
            "name": "Nove",
            "provincia": "VI",
            "cap": "36055",
            "cod_catastale": "F957",
            "cod_istat": "024073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 4672,
            "name": "Novedrate",
            "provincia": "CO",
            "cap": "22060",
            "cod_catastale": "F958",
            "cod_istat": "013163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2463,
            "area": "",
            "ech": 0
        },
        {
            "id": 4673,
            "name": "Novellara",
            "provincia": "RE",
            "cap": "42017",
            "cod_catastale": "F960",
            "cod_istat": "035028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 4674,
            "name": "Novello",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "F961",
            "cod_istat": "004152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 471,
            "giorni": 2899,
            "area": "",
            "ech": 0
        },
        {
            "id": 4675,
            "name": "Noventa di Piave",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "F963",
            "cod_istat": "027027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2349,
            "area": "",
            "ech": 0
        },
        {
            "id": 4676,
            "name": "Noventa Padovana",
            "provincia": "PD",
            "cap": "35027",
            "cod_catastale": "F962",
            "cod_istat": "028058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4677,
            "name": "Noventa Vicentina",
            "provincia": "VI",
            "cap": "36025",
            "cod_catastale": "F964",
            "cod_istat": "024074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2490,
            "area": "",
            "ech": 0
        },
        {
            "id": 4678,
            "name": "Novi di Modena",
            "provincia": "MO",
            "cap": "41016",
            "cod_catastale": "F966",
            "cod_istat": "036028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2197,
            "area": "",
            "ech": 0
        },
        {
            "id": 4679,
            "name": "Novi Ligure",
            "provincia": "AL",
            "cap": "15067",
            "cod_catastale": "F965",
            "cod_istat": "006114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 4680,
            "name": "Novi Velia",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "F967",
            "cod_istat": "065080",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 648,
            "giorni": 1949,
            "area": "",
            "ech": 0
        },
        {
            "id": 4681,
            "name": "Noviglio",
            "provincia": "MI",
            "cap": "20082",
            "cod_catastale": "F968",
            "cod_istat": "015158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 4682,
            "name": "Novoli",
            "provincia": "LE",
            "cap": "73051",
            "cod_catastale": "F970",
            "cod_istat": "075055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 1091,
            "area": "",
            "ech": 0
        },
        {
            "id": 4683,
            "name": "Nucetto",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "F972",
            "cod_istat": "004153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2873,
            "area": "",
            "ech": 0
        },
        {
            "id": 4684,
            "name": "Nughedu San Nicolò",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "F975",
            "cod_istat": "090044",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4685,
            "name": "Nughedu Santa Vittoria",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "F974",
            "cod_istat": "095034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 1612,
            "area": "",
            "ech": 0
        },
        {
            "id": 4686,
            "name": "Nule",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "F976",
            "cod_istat": "090045",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2151,
            "area": "",
            "ech": 0
        },
        {
            "id": 4687,
            "name": "Nulvi",
            "provincia": "SS",
            "cap": "07032",
            "cod_catastale": "F977",
            "cod_istat": "090046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 478,
            "giorni": 1824,
            "area": "",
            "ech": 0
        },
        {
            "id": 4688,
            "name": "Numana",
            "provincia": "AN",
            "cap": "60026",
            "cod_catastale": "F978",
            "cod_istat": "042032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1789,
            "area": "",
            "ech": 0
        },
        {
            "id": 4689,
            "name": "Nuoro",
            "provincia": "NU",
            "cap": "08100",
            "cod_catastale": "F979",
            "cod_istat": "091051",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 549,
            "giorni": 1602,
            "area": "",
            "ech": 1
        },
        {
            "id": 4690,
            "name": "Nurachi",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "F980",
            "cod_istat": "095035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1055,
            "area": "",
            "ech": 0
        },
        {
            "id": 4691,
            "name": "Nuragus",
            "provincia": "SU",
            "cap": "09057",
            "cod_catastale": "F981",
            "cod_istat": "111045",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 359,
            "giorni": 1333,
            "area": "",
            "ech": 0
        },
        {
            "id": 4692,
            "name": "Nurallao",
            "provincia": "SU",
            "cap": "09058",
            "cod_catastale": "F982",
            "cod_istat": "111046",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 390,
            "giorni": 1384,
            "area": "",
            "ech": 0
        },
        {
            "id": 4693,
            "name": "Nuraminis",
            "provincia": "SU",
            "cap": "09024",
            "cod_catastale": "F983",
            "cod_istat": "111047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 1102,
            "area": "",
            "ech": 1
        },
        {
            "id": 4694,
            "name": "Nureci",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "F985",
            "cod_istat": "095036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 1406,
            "area": "",
            "ech": 0
        },
        {
            "id": 4695,
            "name": "Nurri",
            "provincia": "SU",
            "cap": "09059",
            "cod_catastale": "F986",
            "cod_istat": "111048",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 1893,
            "area": "",
            "ech": 0
        },
        {
            "id": 4696,
            "name": "Nus",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "F987",
            "cod_istat": "007045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 529,
            "giorni": 3026,
            "area": "",
            "ech": 0
        },
        {
            "id": 4697,
            "name": "Nusco",
            "provincia": "AV",
            "cap": "83051",
            "cod_catastale": "F988",
            "cod_istat": "064066",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 914,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 4698,
            "name": "Nuvolento",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "F989",
            "cod_istat": "017119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 4699,
            "name": "Nuvolera",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "F990",
            "cod_istat": "017120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 2417,
            "area": "",
            "ech": 0
        },
        {
            "id": 4700,
            "name": "Nuxis",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "F991",
            "cod_istat": "111049",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 190,
            "giorni": 1221,
            "area": "",
            "ech": 0
        },
        {
            "id": 4701,
            "name": "Occhieppo Inferiore",
            "provincia": "BI",
            "cap": "13897",
            "cod_catastale": "F992",
            "cod_istat": "096040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 4702,
            "name": "Occhieppo Superiore",
            "provincia": "BI",
            "cap": "13898",
            "cod_catastale": "F993",
            "cod_istat": "096041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 532,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 4703,
            "name": "Occhiobello",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "F994",
            "cod_istat": "029033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 4704,
            "name": "Occimiano",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "F995",
            "cod_istat": "006115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2572,
            "area": "",
            "ech": 0
        },
        {
            "id": 4705,
            "name": "Ocre",
            "provincia": "AQ",
            "cap": "67040",
            "cod_catastale": "F996",
            "cod_istat": "066059",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 850,
            "giorni": 2810,
            "area": "",
            "ech": 0
        },
        {
            "id": 4706,
            "name": "Odalengo Grande",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "F997",
            "cod_istat": "006116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 4707,
            "name": "Odalengo Piccolo",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "F998",
            "cod_istat": "006117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2725,
            "area": "",
            "ech": 0
        },
        {
            "id": 4708,
            "name": "Oderzo",
            "provincia": "TV",
            "cap": "31046",
            "cod_catastale": "F999",
            "cod_istat": "026051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2358,
            "area": "",
            "ech": 0
        },
        {
            "id": 4709,
            "name": "Odolo",
            "provincia": "BS",
            "cap": "25076",
            "cod_catastale": "G001",
            "cod_istat": "017121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2703,
            "area": "",
            "ech": 0
        },
        {
            "id": 4710,
            "name": "Ofena",
            "provincia": "AQ",
            "cap": "67025",
            "cod_catastale": "G002",
            "cod_istat": "066060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 531,
            "giorni": 2239,
            "area": "",
            "ech": 0
        },
        {
            "id": 4711,
            "name": "Offagna",
            "provincia": "AN",
            "cap": "60020",
            "cod_catastale": "G003",
            "cod_istat": "042033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 306,
            "giorni": 2198,
            "area": "",
            "ech": 0
        },
        {
            "id": 4712,
            "name": "Offanengo",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "G004",
            "cod_istat": "019062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 4713,
            "name": "Offida",
            "provincia": "AP",
            "cap": "63073",
            "cod_catastale": "G005",
            "cod_istat": "044054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1981,
            "area": "",
            "ech": 0
        },
        {
            "id": 4714,
            "name": "Offlaga",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "G006",
            "cod_istat": "017122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 4715,
            "name": "Oggebbio",
            "provincia": "VB",
            "cap": "28824",
            "cod_catastale": "G007",
            "cod_istat": "103049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2512,
            "area": "",
            "ech": 0
        },
        {
            "id": 4716,
            "name": "Oggiona con Santo Stefano",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "G008",
            "cod_istat": "012107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2530,
            "area": "",
            "ech": 0
        },
        {
            "id": 4717,
            "name": "Oggiono",
            "provincia": "LC",
            "cap": "23848",
            "cod_catastale": "G009",
            "cod_istat": "097057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2450,
            "area": "",
            "ech": 0
        },
        {
            "id": 4718,
            "name": "Oglianico",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G010",
            "cod_istat": "001170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 4719,
            "name": "Ogliastro Cilento",
            "provincia": "SA",
            "cap": "84061",
            "cod_catastale": "G011",
            "cod_istat": "065081",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 352,
            "giorni": 1577,
            "area": "",
            "ech": 0
        },
        {
            "id": 4720,
            "name": "Olbia",
            "provincia": "SS",
            "cap": "07026",
            "cod_catastale": "G015",
            "cod_istat": "090047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1142,
            "area": "",
            "ech": 1
        },
        {
            "id": 4721,
            "name": "Olcenengo",
            "provincia": "VC",
            "cap": "13047",
            "cod_catastale": "G016",
            "cod_istat": "002088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 4722,
            "name": "Oldenico",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "G018",
            "cod_istat": "002089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 2768,
            "area": "",
            "ech": 0
        },
        {
            "id": 4723,
            "name": "Oleggio",
            "provincia": "NO",
            "cap": "28047",
            "cod_catastale": "G019",
            "cod_istat": "003108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 4724,
            "name": "Oleggio Castello",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "G020",
            "cod_istat": "003109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 4725,
            "name": "Olevano di Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "G021",
            "cod_istat": "018104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 4726,
            "name": "Olevano Romano",
            "provincia": "RM",
            "cap": "00035",
            "cod_catastale": "G022",
            "cod_istat": "058073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 571,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 4727,
            "name": "Olevano sul Tusciano",
            "provincia": "SA",
            "cap": "84062",
            "cod_catastale": "G023",
            "cod_istat": "065082",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 197,
            "giorni": 1542,
            "area": "",
            "ech": 0
        },
        {
            "id": 4728,
            "name": "Olgiate Comasco",
            "provincia": "CO",
            "cap": "22077",
            "cod_catastale": "G025",
            "cod_istat": "013165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 2719,
            "area": "",
            "ech": 0
        },
        {
            "id": 4729,
            "name": "Olgiate Molgora",
            "provincia": "LC",
            "cap": "23887",
            "cod_catastale": "G026",
            "cod_istat": "097058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 4730,
            "name": "Olgiate Olona",
            "provincia": "VA",
            "cap": "21057",
            "cod_catastale": "G028",
            "cod_istat": "012108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 4731,
            "name": "Olginate",
            "provincia": "LC",
            "cap": "23854",
            "cod_catastale": "G030",
            "cod_istat": "097059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2362,
            "area": "",
            "ech": 0
        },
        {
            "id": 4732,
            "name": "Oliena",
            "provincia": "NU",
            "cap": "08025",
            "cod_catastale": "G031",
            "cod_istat": "091055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 379,
            "giorni": 1366,
            "area": "",
            "ech": 0
        },
        {
            "id": 4733,
            "name": "Oliva Gessi",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "G032",
            "cod_istat": "018105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2944,
            "area": "",
            "ech": 0
        },
        {
            "id": 4734,
            "name": "Olivadi",
            "provincia": "CZ",
            "cap": "88067",
            "cod_catastale": "G034",
            "cod_istat": "079088",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 1678,
            "area": "",
            "ech": 1
        },
        {
            "id": 4735,
            "name": "Oliveri",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "G036",
            "cod_istat": "083063",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 630,
            "area": "",
            "ech": 1
        },
        {
            "id": 4736,
            "name": "Oliveto Citra",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "G039",
            "cod_istat": "065083",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1546,
            "area": "",
            "ech": 0
        },
        {
            "id": 4737,
            "name": "Oliveto Lario",
            "provincia": "LC",
            "cap": "23865",
            "cod_catastale": "G040",
            "cod_istat": "097060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 4738,
            "name": "Oliveto Lucano",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "G037",
            "cod_istat": "077019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 546,
            "giorni": 1882,
            "area": "",
            "ech": 0
        },
        {
            "id": 4739,
            "name": "Olivetta San Michele",
            "provincia": "IM",
            "cap": "18030",
            "cod_catastale": "G041",
            "cod_istat": "008038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 1748,
            "area": "",
            "ech": 0
        },
        {
            "id": 4740,
            "name": "Olivola",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "G042",
            "cod_istat": "006118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 4741,
            "name": "Ollastra",
            "provincia": "OR",
            "cap": "09088",
            "cod_catastale": "G043",
            "cod_istat": "095037",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4742,
            "name": "Ollolai",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G044",
            "cod_istat": "091056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 920,
            "giorni": 2256,
            "area": "",
            "ech": 0
        },
        {
            "id": 4743,
            "name": "Ollomont",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "G045",
            "cod_istat": "007046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1356,
            "giorni": 4266,
            "area": "",
            "ech": 0
        },
        {
            "id": 4744,
            "name": "Olmedo",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "G046",
            "cod_istat": "090048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1106,
            "area": "",
            "ech": 0
        },
        {
            "id": 4745,
            "name": "Olmeneta",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "G047",
            "cod_istat": "019063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4746,
            "name": "Olmo al Brembo",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "G049",
            "cod_istat": "016145",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 556,
            "giorni": 2859,
            "area": "",
            "ech": 0
        },
        {
            "id": 4747,
            "name": "Olmo Gentile",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "G048",
            "cod_istat": "005081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 615,
            "giorni": 2999,
            "area": "",
            "ech": 0
        },
        {
            "id": 4748,
            "name": "Oltre il Colle",
            "provincia": "BG",
            "cap": "24013",
            "cod_catastale": "G050",
            "cod_istat": "016146",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1030,
            "giorni": 3532,
            "area": "",
            "ech": 0
        },
        {
            "id": 4749,
            "name": "Oltressenda Alta",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G054",
            "cod_istat": "016147",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 737,
            "giorni": 3126,
            "area": "",
            "ech": 0
        },
        {
            "id": 4750,
            "name": "Oltrona di San Mamette",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "G056",
            "cod_istat": "013169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 4751,
            "name": "Olzai",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G058",
            "cod_istat": "091057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 474,
            "giorni": 1513,
            "area": "",
            "ech": 0
        },
        {
            "id": 4752,
            "name": "Ome",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G061",
            "cod_istat": "017123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2555,
            "area": "",
            "ech": 0
        },
        {
            "id": 4753,
            "name": "Omegna",
            "provincia": "VB",
            "cap": "28887",
            "cod_catastale": "G062",
            "cod_istat": "103050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2688,
            "area": "",
            "ech": 0
        },
        {
            "id": 4754,
            "name": "Omignano",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "G063",
            "cod_istat": "065084",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1857,
            "area": "",
            "ech": 0
        },
        {
            "id": 4755,
            "name": "Onanì",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G064",
            "cod_istat": "091058",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 482,
            "giorni": 1536,
            "area": "",
            "ech": 1
        },
        {
            "id": 4756,
            "name": "Onano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "G065",
            "cod_istat": "056040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 2325,
            "area": "",
            "ech": 0
        },
        {
            "id": 4757,
            "name": "Oncino",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "G066",
            "cod_istat": "004154",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1220,
            "giorni": 3828,
            "area": "",
            "ech": 0
        },
        {
            "id": 4758,
            "name": "Oneta",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G068",
            "cod_istat": "016148",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 740,
            "giorni": 3120,
            "area": "",
            "ech": 0
        },
        {
            "id": 4759,
            "name": "Onifai",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G070",
            "cod_istat": "091059",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 29,
            "giorni": 903,
            "area": "",
            "ech": 1
        },
        {
            "id": 4760,
            "name": "Oniferi",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G071",
            "cod_istat": "091060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 478,
            "giorni": 1492,
            "area": "",
            "ech": 0
        },
        {
            "id": 4761,
            "name": "Ono San Pietro",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "G074",
            "cod_istat": "017124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2947,
            "area": "",
            "ech": 0
        },
        {
            "id": 4762,
            "name": "Onore",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G075",
            "cod_istat": "016149",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 3074,
            "area": "",
            "ech": 0
        },
        {
            "id": 4763,
            "name": "Onzo",
            "provincia": "SV",
            "cap": "17037",
            "cod_catastale": "G076",
            "cod_istat": "009043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 4764,
            "name": "Opera",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "G078",
            "cod_istat": "015159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4765,
            "name": "Opi",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "G079",
            "cod_istat": "066061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1250,
            "giorni": 3526,
            "area": "",
            "ech": 0
        },
        {
            "id": 4766,
            "name": "Oppeano",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "G080",
            "cod_istat": "023055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 4767,
            "name": "Oppido Lucano",
            "provincia": "PZ",
            "cap": "85015",
            "cod_catastale": "G081",
            "cod_istat": "076056",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 670,
            "giorni": 2127,
            "area": "",
            "ech": 0
        },
        {
            "id": 4768,
            "name": "Oppido Mamertina",
            "provincia": "RC",
            "cap": "89014",
            "cod_catastale": "G082",
            "cod_istat": "080055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1258,
            "area": "",
            "ech": 0
        },
        {
            "id": 4769,
            "name": "Ora",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "G083",
            "cod_istat": "021060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 4770,
            "name": "Orani",
            "provincia": "NU",
            "cap": "08026",
            "cod_catastale": "G084",
            "cod_istat": "091061",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 1681,
            "area": "",
            "ech": 0
        },
        {
            "id": 4771,
            "name": "Oratino",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "G086",
            "cod_istat": "070049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 795,
            "giorni": 2409,
            "area": "",
            "ech": 0
        },
        {
            "id": 4772,
            "name": "Orbassano",
            "provincia": "TO",
            "cap": "10043",
            "cod_catastale": "G087",
            "cod_istat": "001171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2634,
            "area": "",
            "ech": 0
        },
        {
            "id": 4773,
            "name": "Orbetello",
            "provincia": "GR",
            "cap": "58015",
            "cod_catastale": "G088",
            "cod_istat": "053018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 4774,
            "name": "Orciano di Pesaro",
            "provincia": "PU",
            "cap": "61038",
            "cod_catastale": "G089",
            "cod_istat": "041040",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2285,
            "area": "",
            "ech": 0
        },
        {
            "id": 4775,
            "name": "Orciano Pisano",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "G090",
            "cod_istat": "050023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 1743,
            "area": "",
            "ech": 0
        },
        {
            "id": 4776,
            "name": "Orco Feglino",
            "provincia": "SV",
            "cap": "17024",
            "cod_catastale": "D522",
            "cod_istat": "009044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 1694,
            "area": "",
            "ech": 0
        },
        {
            "id": 4777,
            "name": "Ordona",
            "provincia": "FG",
            "cap": "71040",
            "cod_catastale": "M266",
            "cod_istat": "071063",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1473,
            "area": "",
            "ech": 0
        },
        {
            "id": 4778,
            "name": "Orero",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "G093",
            "cod_istat": "010042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2022,
            "area": "",
            "ech": 0
        },
        {
            "id": 4779,
            "name": "Orgiano",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "G095",
            "cod_istat": "024075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2442,
            "area": "",
            "ech": 0
        },
        {
            "id": 4780,
            "name": "Orgosolo",
            "provincia": "NU",
            "cap": "08027",
            "cod_catastale": "G097",
            "cod_istat": "091062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 1763,
            "area": "",
            "ech": 0
        },
        {
            "id": 4781,
            "name": "Oria",
            "provincia": "BR",
            "cap": "72024",
            "cod_catastale": "G098",
            "cod_istat": "074011",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 1328,
            "area": "",
            "ech": 0
        },
        {
            "id": 4782,
            "name": "Oricola",
            "provincia": "AQ",
            "cap": "67063",
            "cod_catastale": "G102",
            "cod_istat": "066062",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 810,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 4783,
            "name": "Origgio",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "G103",
            "cod_istat": "012109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 4784,
            "name": "Orino",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "G105",
            "cod_istat": "012110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 456,
            "giorni": 2754,
            "area": "",
            "ech": 0
        },
        {
            "id": 4785,
            "name": "Orio al Serio",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "G108",
            "cod_istat": "016150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 4786,
            "name": "Orio Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "G109",
            "cod_istat": "001172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2844,
            "area": "",
            "ech": 0
        },
        {
            "id": 4787,
            "name": "Orio Litta",
            "provincia": "LO",
            "cap": "26863",
            "cod_catastale": "G107",
            "cod_istat": "098042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 4788,
            "name": "Oriolo",
            "provincia": "CS",
            "cap": "87073",
            "cod_catastale": "G110",
            "cod_istat": "078087",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 4789,
            "name": "Oriolo Romano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "G111",
            "cod_istat": "056041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2166,
            "area": "",
            "ech": 0
        },
        {
            "id": 4790,
            "name": "Oristano",
            "provincia": "OR",
            "cap": "09170",
            "cod_catastale": "G113",
            "cod_istat": "095038",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 9,
            "giorni": 1059,
            "area": "",
            "ech": 0
        },
        {
            "id": 4791,
            "name": "Ormea",
            "provincia": "CN",
            "cap": "12078",
            "cod_catastale": "G114",
            "cod_istat": "004155",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 736,
            "giorni": 3122,
            "area": "",
            "ech": 0
        },
        {
            "id": 4792,
            "name": "Ormelle",
            "provincia": "TV",
            "cap": "31024",
            "cod_catastale": "G115",
            "cod_istat": "026052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 4793,
            "name": "Ornago",
            "provincia": "MB",
            "cap": "20876",
            "cod_catastale": "G116",
            "cod_istat": "108036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4794,
            "name": "Ornavasso",
            "provincia": "VB",
            "cap": "28877",
            "cod_catastale": "G117",
            "cod_istat": "103051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2584,
            "area": "",
            "ech": 0
        },
        {
            "id": 4795,
            "name": "Ornica",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "G118",
            "cod_istat": "016151",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 922,
            "giorni": 3379,
            "area": "",
            "ech": 0
        },
        {
            "id": 4796,
            "name": "Orosei",
            "provincia": "NU",
            "cap": "08028",
            "cod_catastale": "G119",
            "cod_istat": "091063",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 887,
            "area": "",
            "ech": 1
        },
        {
            "id": 4797,
            "name": "Orotelli",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G120",
            "cod_istat": "091064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 1513,
            "area": "",
            "ech": 0
        },
        {
            "id": 4798,
            "name": "Orria",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "G121",
            "cod_istat": "065085",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1812,
            "area": "",
            "ech": 0
        },
        {
            "id": 4799,
            "name": "Orroli",
            "provincia": "SU",
            "cap": "09061",
            "cod_catastale": "G122",
            "cod_istat": "111050",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 530,
            "giorni": 1615,
            "area": "",
            "ech": 0
        },
        {
            "id": 4800,
            "name": "Orsago",
            "provincia": "TV",
            "cap": "31010",
            "cod_catastale": "G123",
            "cod_istat": "026053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4801,
            "name": "Orsara Bormida",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "G124",
            "cod_istat": "006119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2667,
            "area": "",
            "ech": 0
        },
        {
            "id": 4802,
            "name": "Orsara di Puglia",
            "provincia": "FG",
            "cap": "71027",
            "cod_catastale": "G125",
            "cod_istat": "071035",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 635,
            "giorni": 2266,
            "area": "",
            "ech": 0
        },
        {
            "id": 4803,
            "name": "Orsenigo",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "G126",
            "cod_istat": "013170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 4804,
            "name": "Orsogna",
            "provincia": "CH",
            "cap": "66036",
            "cod_catastale": "G128",
            "cod_istat": "069057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 4805,
            "name": "Orsomarso",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "G129",
            "cod_istat": "078088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1097,
            "area": "",
            "ech": 0
        },
        {
            "id": 4806,
            "name": "Orta di Atella",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "G130",
            "cod_istat": "061053",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1193,
            "area": "",
            "ech": 0
        },
        {
            "id": 4807,
            "name": "Orta Nova",
            "provincia": "FG",
            "cap": "71045",
            "cod_catastale": "G131",
            "cod_istat": "071036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 1395,
            "area": "",
            "ech": 0
        },
        {
            "id": 4808,
            "name": "Orta San Giulio",
            "provincia": "NO",
            "cap": "28016",
            "cod_catastale": "G134",
            "cod_istat": "003112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 4809,
            "name": "Ortacesus",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "G133",
            "cod_istat": "111051",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 162,
            "giorni": 1218,
            "area": "",
            "ech": 0
        },
        {
            "id": 4810,
            "name": "Orte",
            "provincia": "VT",
            "cap": "01028",
            "cod_catastale": "G135",
            "cod_istat": "056042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 1935,
            "area": "",
            "ech": 0
        },
        {
            "id": 4811,
            "name": "Ortelle",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "G136",
            "cod_istat": "075056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 1282,
            "area": "",
            "ech": 0
        },
        {
            "id": 4812,
            "name": "Ortezzano",
            "provincia": "FM",
            "cap": "63851",
            "cod_catastale": "G137",
            "cod_istat": "109029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 4813,
            "name": "Ortignano Raggiolo",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "G139",
            "cod_istat": "051027",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4814,
            "name": "Ortisei",
            "provincia": "BZ",
            "cap": "39046",
            "cod_catastale": "G140",
            "cod_istat": "021061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1234,
            "giorni": 4407,
            "area": "",
            "ech": 0
        },
        {
            "id": 4815,
            "name": "Ortona",
            "provincia": "CH",
            "cap": "66026",
            "cod_catastale": "G141",
            "cod_istat": "069058",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1298,
            "area": "",
            "ech": 0
        },
        {
            "id": 4816,
            "name": "Ortona dei Marsi",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "G142",
            "cod_istat": "066063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1003,
            "giorni": 3084,
            "area": "",
            "ech": 0
        },
        {
            "id": 4817,
            "name": "Luni",
            "provincia": "SP",
            "cap": "19034",
            "cod_catastale": "G143",
            "cod_istat": "011020",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4818,
            "name": "Ortovero",
            "provincia": "SV",
            "cap": "17037",
            "cod_catastale": "G144",
            "cod_istat": "009045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 1335,
            "area": "",
            "ech": 0
        },
        {
            "id": 4819,
            "name": "Ortucchio",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "G145",
            "cod_istat": "066064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2534,
            "area": "",
            "ech": 0
        },
        {
            "id": 4820,
            "name": "Ortueri",
            "provincia": "NU",
            "cap": "08036",
            "cod_catastale": "G146",
            "cod_istat": "091066",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 585,
            "giorni": 1704,
            "area": "",
            "ech": 0
        },
        {
            "id": 4821,
            "name": "Orune",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G147",
            "cod_istat": "091067",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 750,
            "giorni": 1970,
            "area": "",
            "ech": 1
        },
        {
            "id": 4822,
            "name": "Orvieto",
            "provincia": "TR",
            "cap": "05018",
            "cod_catastale": "G148",
            "cod_istat": "055023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1905,
            "area": "",
            "ech": 0
        },
        {
            "id": 4823,
            "name": "Orvinio",
            "provincia": "RI",
            "cap": "02035",
            "cod_catastale": "B595",
            "cod_istat": "057047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 840,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 4824,
            "name": "Orzinuovi",
            "provincia": "BS",
            "cap": "25034",
            "cod_catastale": "G149",
            "cod_istat": "017125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 4825,
            "name": "Orzivecchi",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "G150",
            "cod_istat": "017126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 4826,
            "name": "Osasco",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G151",
            "cod_istat": "001173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 4827,
            "name": "Osasio",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "G152",
            "cod_istat": "001174",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 4828,
            "name": "Oschiri",
            "provincia": "SS",
            "cap": "07027",
            "cod_catastale": "G153",
            "cod_istat": "090049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 202,
            "giorni": 1300,
            "area": "",
            "ech": 0
        },
        {
            "id": 4829,
            "name": "Osidda",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G154",
            "cod_istat": "091068",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 1981,
            "area": "",
            "ech": 0
        },
        {
            "id": 4830,
            "name": "Osiglia",
            "provincia": "SV",
            "cap": "17010",
            "cod_catastale": "G155",
            "cod_istat": "009046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 715,
            "giorni": 3044,
            "area": "",
            "ech": 0
        },
        {
            "id": 4831,
            "name": "Osilo",
            "provincia": "SS",
            "cap": "07033",
            "cod_catastale": "G156",
            "cod_istat": "090050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 615,
            "giorni": 2086,
            "area": "",
            "ech": 0
        },
        {
            "id": 4832,
            "name": "Osimo",
            "provincia": "AN",
            "cap": "60027",
            "cod_catastale": "G157",
            "cod_istat": "042034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2073,
            "area": "",
            "ech": 0
        },
        {
            "id": 4833,
            "name": "Osini",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "G158",
            "cod_istat": "091069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 645,
            "giorni": 1862,
            "area": "",
            "ech": 1
        },
        {
            "id": 4834,
            "name": "Osio Sopra",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "G159",
            "cod_istat": "016152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 4835,
            "name": "Osio Sotto",
            "provincia": "BG",
            "cap": "24046",
            "cod_catastale": "G160",
            "cod_istat": "016153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 4836,
            "name": "Osmate",
            "provincia": "VA",
            "cap": "21018",
            "cod_catastale": "E529",
            "cod_istat": "012111",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 2585,
            "area": "",
            "ech": 0
        },
        {
            "id": 4837,
            "name": "Osnago",
            "provincia": "LC",
            "cap": "23875",
            "cod_catastale": "G161",
            "cod_istat": "097061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 4838,
            "name": "Osoppo",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "G163",
            "cod_istat": "030066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2483,
            "area": "",
            "ech": 0
        },
        {
            "id": 4839,
            "name": "Ospedaletti",
            "provincia": "IM",
            "cap": "18014",
            "cod_catastale": "G164",
            "cod_istat": "008039",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1057,
            "area": "",
            "ech": 0
        },
        {
            "id": 4840,
            "name": "Ospedaletto",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "G168",
            "cod_istat": "022130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2952,
            "area": "",
            "ech": 0
        },
        {
            "id": 4841,
            "name": "Ospedaletto d'Alpinolo",
            "provincia": "AV",
            "cap": "83014",
            "cod_catastale": "G165",
            "cod_istat": "064067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 2401,
            "area": "",
            "ech": 0
        },
        {
            "id": 4842,
            "name": "Ospedaletto Euganeo",
            "provincia": "PD",
            "cap": "35045",
            "cod_catastale": "G167",
            "cod_istat": "028059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 4843,
            "name": "Ospedaletto Lodigiano",
            "provincia": "LO",
            "cap": "26864",
            "cod_catastale": "G166",
            "cod_istat": "098043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 4844,
            "name": "Ospitale di Cadore",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "G169",
            "cod_istat": "025035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 3484,
            "area": "",
            "ech": 0
        },
        {
            "id": 4845,
            "name": "Ospitaletto",
            "provincia": "BS",
            "cap": "25035",
            "cod_catastale": "G170",
            "cod_istat": "017127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 4846,
            "name": "Ossago Lodigiano",
            "provincia": "LO",
            "cap": "26816",
            "cod_catastale": "G171",
            "cod_istat": "098044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 4847,
            "name": "Ossana",
            "provincia": "TN",
            "cap": "38026",
            "cod_catastale": "G173",
            "cod_istat": "022131",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1003,
            "giorni": 3955,
            "area": "",
            "ech": 0
        },
        {
            "id": 4848,
            "name": "Ossi",
            "provincia": "SS",
            "cap": "07045",
            "cod_catastale": "G178",
            "cod_istat": "090051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 1528,
            "area": "",
            "ech": 0
        },
        {
            "id": 4849,
            "name": "Ossimo",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G179",
            "cod_istat": "017128",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 869,
            "giorni": 3452,
            "area": "",
            "ech": 0
        },
        {
            "id": 4850,
            "name": "Ossona",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "G181",
            "cod_istat": "015164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 2656,
            "area": "",
            "ech": 0
        },
        {
            "id": 4851,
            "name": "Ossuccio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "G182",
            "cod_istat": "013172",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 4852,
            "name": "Ostana",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "G183",
            "cod_istat": "004156",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1250,
            "giorni": 3865,
            "area": "",
            "ech": 0
        },
        {
            "id": 4853,
            "name": "Ostellato",
            "provincia": "FE",
            "cap": "44020",
            "cod_catastale": "G184",
            "cod_istat": "038017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 4854,
            "name": "Ostiano",
            "provincia": "CR",
            "cap": "26032",
            "cod_catastale": "G185",
            "cod_istat": "019064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4855,
            "name": "Ostiglia",
            "provincia": "MN",
            "cap": "46035",
            "cod_catastale": "G186",
            "cod_istat": "020038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 4856,
            "name": "Ostra",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "F401",
            "cod_istat": "042035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 1993,
            "area": "",
            "ech": 0
        },
        {
            "id": 4857,
            "name": "Ostra Vetere",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "F581",
            "cod_istat": "042036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1989,
            "area": "",
            "ech": 0
        },
        {
            "id": 4858,
            "name": "Ostuni",
            "provincia": "BR",
            "cap": "72017",
            "cod_catastale": "G187",
            "cod_istat": "074012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 1259,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4859,
            "name": "Otranto",
            "provincia": "LE",
            "cap": "73028",
            "cod_catastale": "G188",
            "cod_istat": "075057",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1099,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4860,
            "name": "Otricoli",
            "provincia": "TR",
            "cap": "05030",
            "cod_catastale": "G189",
            "cod_istat": "055024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 1745,
            "area": "",
            "ech": 0
        },
        {
            "id": 4861,
            "name": "Ottana",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G191",
            "cod_istat": "091070",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 1208,
            "area": "",
            "ech": 0
        },
        {
            "id": 4862,
            "name": "Ottati",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "G192",
            "cod_istat": "065086",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 529,
            "giorni": 1881,
            "area": "",
            "ech": 0
        },
        {
            "id": 4863,
            "name": "Ottaviano",
            "provincia": "NA",
            "cap": "80044",
            "cod_catastale": "G190",
            "cod_istat": "063051",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1334,
            "area": "",
            "ech": 0
        },
        {
            "id": 4864,
            "name": "Ottiglio",
            "provincia": "AL",
            "cap": "15038",
            "cod_catastale": "G193",
            "cod_istat": "006120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 4865,
            "name": "Ottobiano",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "G194",
            "cod_istat": "018106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4866,
            "name": "Ottone",
            "provincia": "PC",
            "cap": "29026",
            "cod_catastale": "G195",
            "cod_istat": "033030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 2737,
            "area": "",
            "ech": 0
        },
        {
            "id": 4867,
            "name": "Oulx",
            "provincia": "TO",
            "cap": "10056",
            "cod_catastale": "G196",
            "cod_istat": "001175",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1100,
            "giorni": 4100,
            "area": "",
            "ech": 0
        },
        {
            "id": 4868,
            "name": "Ovada",
            "provincia": "AL",
            "cap": "15076",
            "cod_catastale": "G197",
            "cod_istat": "006121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 4869,
            "name": "Ovaro",
            "provincia": "UD",
            "cap": "33025",
            "cod_catastale": "G198",
            "cod_istat": "030067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 3386,
            "area": "",
            "ech": 0
        },
        {
            "id": 4870,
            "name": "Oviglio",
            "provincia": "AL",
            "cap": "15026",
            "cod_catastale": "G199",
            "cod_istat": "006122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2569,
            "area": "",
            "ech": 0
        },
        {
            "id": 4871,
            "name": "Ovindoli",
            "provincia": "AQ",
            "cap": "67046",
            "cod_catastale": "G200",
            "cod_istat": "066065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1375,
            "giorni": 3756,
            "area": "",
            "ech": 0
        },
        {
            "id": 4872,
            "name": "Ovodda",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G201",
            "cod_istat": "091071",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 1945,
            "area": "",
            "ech": 0
        },
        {
            "id": 4873,
            "name": "Oyace",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "G012",
            "cod_istat": "007047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1377,
            "giorni": 4313,
            "area": "",
            "ech": 0
        },
        {
            "id": 4874,
            "name": "Ozegna",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G202",
            "cod_istat": "001176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2594,
            "area": "",
            "ech": 0
        },
        {
            "id": 4875,
            "name": "Ozieri",
            "provincia": "SS",
            "cap": "07014",
            "cod_catastale": "G203",
            "cod_istat": "090052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 1629,
            "area": "",
            "ech": 0
        },
        {
            "id": 4876,
            "name": "Ozzano dell'Emilia",
            "provincia": "BO",
            "cap": "40064",
            "cod_catastale": "G205",
            "cod_istat": "037046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 4877,
            "name": "Ozzano Monferrato",
            "provincia": "AL",
            "cap": "15039",
            "cod_catastale": "G204",
            "cod_istat": "006123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 4878,
            "name": "Ozzero",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "G206",
            "cod_istat": "015165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 4879,
            "name": "Pabillonis",
            "provincia": "SU",
            "cap": "09030",
            "cod_catastale": "G207",
            "cod_istat": "111052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 988,
            "area": "",
            "ech": 0
        },
        {
            "id": 4880,
            "name": "Pace del Mela",
            "provincia": "ME",
            "cap": "98042",
            "cod_catastale": "G209",
            "cod_istat": "083064",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 821,
            "area": "",
            "ech": 1
        },
        {
            "id": 4881,
            "name": "Paceco",
            "provincia": "TP",
            "cap": "91027",
            "cod_catastale": "G208",
            "cod_istat": "081013",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 848,
            "area": "",
            "ech": 0
        },
        {
            "id": 4882,
            "name": "Pacentro",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "G210",
            "cod_istat": "066066",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 690,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 4883,
            "name": "Pachino",
            "provincia": "SR",
            "cap": "96018",
            "cod_catastale": "G211",
            "cod_istat": "089014",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 780,
            "area": "",
            "ech": 1
        },
        {
            "id": 4884,
            "name": "Paciano",
            "provincia": "PG",
            "cap": "06060",
            "cod_catastale": "G212",
            "cod_istat": "054036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2187,
            "area": "",
            "ech": 0
        },
        {
            "id": 4885,
            "name": "Padenghe sul Garda",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "G213",
            "cod_istat": "017129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 4886,
            "name": "Padergnone",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "G214",
            "cod_istat": "022132",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 2825,
            "area": "",
            "ech": 0
        },
        {
            "id": 4887,
            "name": "Paderna",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "G215",
            "cod_istat": "006124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 4888,
            "name": "Paderno d'Adda",
            "provincia": "LC",
            "cap": "23877",
            "cod_catastale": "G218",
            "cod_istat": "097062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 4889,
            "name": "Paderno del Grappa",
            "provincia": "TV",
            "cap": "31017",
            "cod_catastale": "G221",
            "cod_istat": "026054",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2745,
            "area": "",
            "ech": 0
        },
        {
            "id": 4890,
            "name": "Paderno Dugnano",
            "provincia": "MI",
            "cap": "20037",
            "cod_catastale": "G220",
            "cod_istat": "015166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 163,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 4891,
            "name": "Paderno Franciacorta",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G217",
            "cod_istat": "017130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 4892,
            "name": "Paderno Ponchielli",
            "provincia": "CR",
            "cap": "26024",
            "cod_catastale": "G222",
            "cod_istat": "019065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 4893,
            "name": "Padova",
            "provincia": "PD",
            "cap": "351xx",
            "cod_catastale": "G224",
            "cod_istat": "028060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4894,
            "name": "Padria",
            "provincia": "SS",
            "cap": "07015",
            "cod_catastale": "G225",
            "cod_istat": "090053",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 304,
            "giorni": 1494,
            "area": "",
            "ech": 0
        },
        {
            "id": 4895,
            "name": "Padru",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "M301",
            "cod_istat": "090090",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4896,
            "name": "Padula",
            "provincia": "SA",
            "cap": "84034",
            "cod_catastale": "G226",
            "cod_istat": "065087",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 699,
            "giorni": 1899,
            "area": "",
            "ech": 0
        },
        {
            "id": 4897,
            "name": "Paduli",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "G227",
            "cod_istat": "062045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 349,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 4898,
            "name": "Paesana",
            "provincia": "CN",
            "cap": "12034",
            "cod_catastale": "G228",
            "cod_istat": "004157",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 614,
            "giorni": 3076,
            "area": "",
            "ech": 0
        },
        {
            "id": 4899,
            "name": "Paese",
            "provincia": "TV",
            "cap": "31038",
            "cod_catastale": "G229",
            "cod_istat": "026055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2401,
            "area": "",
            "ech": 0
        },
        {
            "id": 4900,
            "name": "Pagani",
            "provincia": "SA",
            "cap": "84016",
            "cod_catastale": "G230",
            "cod_istat": "065088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1184,
            "area": "",
            "ech": 0
        },
        {
            "id": 4901,
            "name": "Paganico Sabino",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "G232",
            "cod_istat": "057048",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 4902,
            "name": "Pagazzano",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "G233",
            "cod_istat": "016154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4903,
            "name": "Pagliara",
            "provincia": "ME",
            "cap": "98020",
            "cod_catastale": "G234",
            "cod_istat": "083065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 968,
            "area": "",
            "ech": 0
        },
        {
            "id": 4904,
            "name": "Paglieta",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "G237",
            "cod_istat": "069059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 4905,
            "name": "Pagnacco",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "G238",
            "cod_istat": "030068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 4906,
            "name": "Pagno",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "G240",
            "cod_istat": "004158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 362,
            "giorni": 2762,
            "area": "",
            "ech": 0
        },
        {
            "id": 4907,
            "name": "Pagnona",
            "provincia": "LC",
            "cap": "23833",
            "cod_catastale": "G241",
            "cod_istat": "097063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 790,
            "giorni": 3191,
            "area": "",
            "ech": 0
        },
        {
            "id": 4908,
            "name": "Pago del Vallo di Lauro",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "G242",
            "cod_istat": "064068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1236,
            "area": "",
            "ech": 0
        },
        {
            "id": 4909,
            "name": "Pago Veiano",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "G243",
            "cod_istat": "062046",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 485,
            "giorni": 1953,
            "area": "",
            "ech": 0
        },
        {
            "id": 4910,
            "name": "Paisco Loveno",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G247",
            "cod_istat": "017131",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 853,
            "giorni": 3429,
            "area": "",
            "ech": 0
        },
        {
            "id": 4911,
            "name": "Paitone",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "G248",
            "cod_istat": "017132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 4912,
            "name": "Paladina",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "G249",
            "cod_istat": "016155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2456,
            "area": "",
            "ech": 0
        },
        {
            "id": 4913,
            "name": "Palagano",
            "provincia": "MO",
            "cap": "41046",
            "cod_catastale": "G250",
            "cod_istat": "036029",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 703,
            "giorni": 3186,
            "area": "",
            "ech": 0
        },
        {
            "id": 4914,
            "name": "Palagianello",
            "provincia": "TA",
            "cap": "74018",
            "cod_catastale": "G251",
            "cod_istat": "073020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 1317,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4915,
            "name": "Palagiano",
            "provincia": "TA",
            "cap": "74019",
            "cod_catastale": "G252",
            "cod_istat": "073021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 1162,
            "area": "",
            "ech": 0
        },
        {
            "id": 4916,
            "name": "Palagonia",
            "provincia": "CT",
            "cap": "95046",
            "cod_catastale": "G253",
            "cod_istat": "087032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1085,
            "area": "",
            "ech": 1
        },
        {
            "id": 4917,
            "name": "Palaia",
            "provincia": "PI",
            "cap": "56036",
            "cod_catastale": "G254",
            "cod_istat": "050024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1877,
            "area": "",
            "ech": 0
        },
        {
            "id": 4918,
            "name": "Palanzano",
            "provincia": "PR",
            "cap": "43025",
            "cod_catastale": "G255",
            "cod_istat": "034026",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 691,
            "giorni": 3432,
            "area": "",
            "ech": 0
        },
        {
            "id": 4919,
            "name": "Palata",
            "provincia": "CB",
            "cap": "86037",
            "cod_catastale": "G257",
            "cod_istat": "070050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2016,
            "area": "",
            "ech": 0
        },
        {
            "id": 4920,
            "name": "Palau",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "G258",
            "cod_istat": "090054",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 817,
            "area": "",
            "ech": 0
        },
        {
            "id": 4921,
            "name": "Palazzago",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "G259",
            "cod_istat": "016156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 4922,
            "name": "Palazzo Adriano",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "G263",
            "cod_istat": "082052",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 696,
            "giorni": 1716,
            "area": "",
            "ech": 1
        },
        {
            "id": 4923,
            "name": "Palazzo Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "G262",
            "cod_istat": "001177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 2730,
            "area": "",
            "ech": 0
        },
        {
            "id": 4924,
            "name": "Palazzo Pignano",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "G260",
            "cod_istat": "019066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4925,
            "name": "Palazzo San Gervasio",
            "provincia": "PZ",
            "cap": "85026",
            "cod_catastale": "G261",
            "cod_istat": "076057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 1924,
            "area": "",
            "ech": 0
        },
        {
            "id": 4926,
            "name": "Palazzolo Acreide",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "G267",
            "cod_istat": "089015",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 670,
            "giorni": 1567,
            "area": "",
            "ech": 0
        },
        {
            "id": 4927,
            "name": "Palazzolo dello Stella",
            "provincia": "UD",
            "cap": "33056",
            "cod_catastale": "G268",
            "cod_istat": "030069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 4928,
            "name": "Palazzolo sull'Oglio",
            "provincia": "BS",
            "cap": "25036",
            "cod_catastale": "G264",
            "cod_istat": "017133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 166,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4929,
            "name": "Palazzolo Vercellese",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "G266",
            "cod_istat": "002090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 4930,
            "name": "Palazzuolo sul Senio",
            "provincia": "FI",
            "cap": "50035",
            "cod_catastale": "G270",
            "cod_istat": "048031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 437,
            "giorni": 2942,
            "area": "",
            "ech": 0
        },
        {
            "id": 4931,
            "name": "Palena",
            "provincia": "CH",
            "cap": "66017",
            "cod_catastale": "G271",
            "cod_istat": "069060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 767,
            "giorni": 2261,
            "area": "",
            "ech": 0
        },
        {
            "id": 4932,
            "name": "Palermiti",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "G272",
            "cod_istat": "079089",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 1702,
            "area": "",
            "ech": 1
        },
        {
            "id": 4933,
            "name": "Palermo",
            "provincia": "PA",
            "cap": "901xx",
            "cod_catastale": "G273",
            "cod_istat": "082053",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 14,
            "giorni": 751,
            "area": "SICI",
            "ech": 0
        },
        {
            "id": 4934,
            "name": "Palestrina",
            "provincia": "RM",
            "cap": "00036",
            "cod_catastale": "G274",
            "cod_istat": "058074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2141,
            "area": "",
            "ech": 0
        },
        {
            "id": 4935,
            "name": "Palestro",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "G275",
            "cod_istat": "018107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 4936,
            "name": "Paliano",
            "provincia": "FR",
            "cap": "03018",
            "cod_catastale": "G276",
            "cod_istat": "060046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 471,
            "giorni": 1984,
            "area": "",
            "ech": 0
        },
        {
            "id": 4937,
            "name": "Palizzi",
            "provincia": "RC",
            "cap": "89038",
            "cod_catastale": "G277",
            "cod_istat": "080056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 1205,
            "area": "",
            "ech": 1
        },
        {
            "id": 4938,
            "name": "Pallagorio",
            "provincia": "KR",
            "cap": "88818",
            "cod_catastale": "G278",
            "cod_istat": "101016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 554,
            "giorni": 1898,
            "area": "",
            "ech": 0
        },
        {
            "id": 4939,
            "name": "Pallanzeno",
            "provincia": "VB",
            "cap": "28884",
            "cod_catastale": "G280",
            "cod_istat": "103052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2485,
            "area": "",
            "ech": 0
        },
        {
            "id": 4940,
            "name": "Pallare",
            "provincia": "SV",
            "cap": "17043",
            "cod_catastale": "G281",
            "cod_istat": "009047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 4941,
            "name": "Palma Campania",
            "provincia": "NA",
            "cap": "80036",
            "cod_catastale": "G283",
            "cod_istat": "063052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 1229,
            "area": "",
            "ech": 0
        },
        {
            "id": 4942,
            "name": "Palma di Montechiaro",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "G282",
            "cod_istat": "084027",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 829,
            "area": "",
            "ech": 1
        },
        {
            "id": 4943,
            "name": "Palmanova",
            "provincia": "UD",
            "cap": "33057",
            "cod_catastale": "G284",
            "cod_istat": "030070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2438,
            "area": "",
            "ech": 0
        },
        {
            "id": 4944,
            "name": "Palmariggi",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "G285",
            "cod_istat": "075058",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 1235,
            "area": "",
            "ech": 0
        },
        {
            "id": 4945,
            "name": "Palmas Arborea",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "G286",
            "cod_istat": "095039",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1053,
            "area": "",
            "ech": 0
        },
        {
            "id": 4946,
            "name": "Palmi",
            "provincia": "RC",
            "cap": "89015",
            "cod_catastale": "G288",
            "cod_istat": "080057",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 228,
            "giorni": 888,
            "area": "",
            "ech": 1
        },
        {
            "id": 4947,
            "name": "Palmiano",
            "provincia": "AP",
            "cap": "63092",
            "cod_catastale": "G289",
            "cod_istat": "044056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 2283,
            "area": "",
            "ech": 0
        },
        {
            "id": 4948,
            "name": "Palmoli",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "G290",
            "cod_istat": "069061",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 711,
            "giorni": 2334,
            "area": "",
            "ech": 0
        },
        {
            "id": 4949,
            "name": "Palo del Colle",
            "provincia": "BA",
            "cap": "70027",
            "cod_catastale": "G291",
            "cod_istat": "072033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 1435,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 4950,
            "name": "Palombara Sabina",
            "provincia": "RM",
            "cap": "00018",
            "cod_catastale": "G293",
            "cod_istat": "058075",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2012,
            "area": "",
            "ech": 0
        },
        {
            "id": 4951,
            "name": "Palombaro",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "G294",
            "cod_istat": "069062",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 536,
            "giorni": 1868,
            "area": "",
            "ech": 0
        },
        {
            "id": 4952,
            "name": "Palomonte",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "G292",
            "cod_istat": "065089",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1983,
            "area": "",
            "ech": 0
        },
        {
            "id": 4953,
            "name": "Palosco",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "G295",
            "cod_istat": "016157",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 4954,
            "name": "Palù",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "G297",
            "cod_istat": "023056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 4955,
            "name": "Palù del Fersina",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "G296",
            "cod_istat": "022133",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1360,
            "giorni": 4512,
            "area": "",
            "ech": 0
        },
        {
            "id": 4956,
            "name": "Paludi",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "G298",
            "cod_istat": "078089",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1693,
            "area": "",
            "ech": 0
        },
        {
            "id": 4957,
            "name": "Paluzza",
            "provincia": "UD",
            "cap": "33026",
            "cod_catastale": "G300",
            "cod_istat": "030071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 3297,
            "area": "",
            "ech": 0
        },
        {
            "id": 4958,
            "name": "Pamparato",
            "provincia": "CN",
            "cap": "12087",
            "cod_catastale": "G302",
            "cod_istat": "004159",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 816,
            "giorni": 3327,
            "area": "",
            "ech": 0
        },
        {
            "id": 4959,
            "name": "Pancalieri",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G303",
            "cod_istat": "001178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 4960,
            "name": "Pancarana",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "G304",
            "cod_istat": "018108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 4961,
            "name": "Panchià",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "G305",
            "cod_istat": "022134",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 981,
            "giorni": 3921,
            "area": "",
            "ech": 0
        },
        {
            "id": 4962,
            "name": "Pandino",
            "provincia": "CR",
            "cap": "26025",
            "cod_catastale": "G306",
            "cod_istat": "019067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4963,
            "name": "Panettieri",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "G307",
            "cod_istat": "078090",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 937,
            "giorni": 2669,
            "area": "",
            "ech": 0
        },
        {
            "id": 4964,
            "name": "Panicale",
            "provincia": "PG",
            "cap": "06064",
            "cod_catastale": "G308",
            "cod_istat": "054037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2228,
            "area": "",
            "ech": 0
        },
        {
            "id": 4965,
            "name": "Pannarano",
            "provincia": "BN",
            "cap": "82017",
            "cod_catastale": "G311",
            "cod_istat": "062047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1725,
            "area": "",
            "ech": 0
        },
        {
            "id": 4966,
            "name": "Panni",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "G312",
            "cod_istat": "071037",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 801,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 4967,
            "name": "Pantelleria",
            "provincia": "TP",
            "cap": "91017",
            "cod_catastale": "G315",
            "cod_istat": "081014",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 717,
            "area": "",
            "ech": 1
        },
        {
            "id": 4968,
            "name": "Pantigliate",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "G316",
            "cod_istat": "015167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 4969,
            "name": "Paola",
            "provincia": "CS",
            "cap": "87027",
            "cod_catastale": "G317",
            "cod_istat": "078091",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 94,
            "giorni": 1033,
            "area": "",
            "ech": 0
        },
        {
            "id": 4970,
            "name": "Paolisi",
            "provincia": "BN",
            "cap": "82011",
            "cod_catastale": "G318",
            "cod_istat": "062048",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1562,
            "area": "",
            "ech": 0
        },
        {
            "id": 4971,
            "name": "Papasidero",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "G320",
            "cod_istat": "078092",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 1260,
            "area": "",
            "ech": 0
        },
        {
            "id": 4972,
            "name": "Papozze",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "G323",
            "cod_istat": "029034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2347,
            "area": "",
            "ech": 0
        },
        {
            "id": 4973,
            "name": "Parabiago",
            "provincia": "MI",
            "cap": "20015",
            "cod_catastale": "G324",
            "cod_istat": "015168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2603,
            "area": "",
            "ech": 0
        },
        {
            "id": 4974,
            "name": "Parabita",
            "provincia": "LE",
            "cap": "73052",
            "cod_catastale": "G325",
            "cod_istat": "075059",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1086,
            "area": "",
            "ech": 0
        },
        {
            "id": 4975,
            "name": "Paratico",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "G327",
            "cod_istat": "017134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 4976,
            "name": "Parcines",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "G328",
            "cod_istat": "021062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 626,
            "giorni": 3330,
            "area": "",
            "ech": 0
        },
        {
            "id": 4977,
            "name": "Parè",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "G329",
            "cod_istat": "013175",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2655,
            "area": "",
            "ech": 0
        },
        {
            "id": 4978,
            "name": "Parella",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "G330",
            "cod_istat": "001179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 4979,
            "name": "Parenti",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "G331",
            "cod_istat": "078093",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 798,
            "giorni": 2394,
            "area": "",
            "ech": 0
        },
        {
            "id": 4980,
            "name": "Parete",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "G333",
            "cod_istat": "061054",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 1166,
            "area": "",
            "ech": 0
        },
        {
            "id": 4981,
            "name": "Pareto",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "G334",
            "cod_istat": "006125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 476,
            "giorni": 2882,
            "area": "",
            "ech": 0
        },
        {
            "id": 4982,
            "name": "Parghelia",
            "provincia": "VV",
            "cap": "89861",
            "cod_catastale": "G335",
            "cod_istat": "102026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 952,
            "area": "",
            "ech": 0
        },
        {
            "id": 4983,
            "name": "Parlasco",
            "provincia": "LC",
            "cap": "23837",
            "cod_catastale": "G336",
            "cod_istat": "097064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 679,
            "giorni": 3034,
            "area": "",
            "ech": 0
        },
        {
            "id": 4984,
            "name": "Parma",
            "provincia": "PR",
            "cap": "431xx",
            "cod_catastale": "G337",
            "cod_istat": "034027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 4985,
            "name": "Parodi Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "G338",
            "cod_istat": "006126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 4986,
            "name": "Paroldo",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "G339",
            "cod_istat": "004160",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3109,
            "area": "",
            "ech": 0
        },
        {
            "id": 4987,
            "name": "Parolise",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "G340",
            "cod_istat": "064069",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 546,
            "giorni": 2112,
            "area": "",
            "ech": 0
        },
        {
            "id": 4988,
            "name": "Parona",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "G342",
            "cod_istat": "018109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 4989,
            "name": "Parrano",
            "provincia": "TR",
            "cap": "05010",
            "cod_catastale": "G344",
            "cod_istat": "055025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2167,
            "area": "",
            "ech": 0
        },
        {
            "id": 4990,
            "name": "Parre",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G346",
            "cod_istat": "016158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2989,
            "area": "",
            "ech": 0
        },
        {
            "id": 4991,
            "name": "Partanna",
            "provincia": "TP",
            "cap": "91028",
            "cod_catastale": "G347",
            "cod_istat": "081015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 1236,
            "area": "",
            "ech": 0
        },
        {
            "id": 4992,
            "name": "Partinico",
            "provincia": "PA",
            "cap": "90047",
            "cod_catastale": "G348",
            "cod_istat": "082054",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 796,
            "area": "",
            "ech": 1
        },
        {
            "id": 4993,
            "name": "Paruzzaro",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "G349",
            "cod_istat": "003114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2739,
            "area": "",
            "ech": 0
        },
        {
            "id": 4994,
            "name": "Parzanica",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "G350",
            "cod_istat": "016159",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 753,
            "giorni": 3139,
            "area": "",
            "ech": 0
        },
        {
            "id": 4995,
            "name": "Pasian di Prato",
            "provincia": "UD",
            "cap": "33037",
            "cod_catastale": "G352",
            "cod_istat": "030072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 4996,
            "name": "Pasiano di Pordenone",
            "provincia": "PN",
            "cap": "33087",
            "cod_catastale": "G353",
            "cod_istat": "093029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 4997,
            "name": "Paspardo",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G354",
            "cod_istat": "017135",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 978,
            "giorni": 3608,
            "area": "",
            "ech": 0
        },
        {
            "id": 4998,
            "name": "Passerano Marmorito",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "G358",
            "cod_istat": "005082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2751,
            "area": "",
            "ech": 0
        },
        {
            "id": 4999,
            "name": "Passignano sul Trasimeno",
            "provincia": "PG",
            "cap": "06065",
            "cod_catastale": "G359",
            "cod_istat": "054038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2084,
            "area": "",
            "ech": 0
        },
        {
            "id": 5000,
            "name": "Passirano",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G361",
            "cod_istat": "017136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 5001,
            "name": "Pastena",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "G362",
            "cod_istat": "060047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 318,
            "giorni": 1878,
            "area": "",
            "ech": 0
        },
        {
            "id": 5002,
            "name": "Pastorano",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "G364",
            "cod_istat": "061055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 1176,
            "area": "",
            "ech": 0
        },
        {
            "id": 5003,
            "name": "Pastrengo",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "G365",
            "cod_istat": "023057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2609,
            "area": "",
            "ech": 0
        },
        {
            "id": 5004,
            "name": "Pasturana",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "G367",
            "cod_istat": "006127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2731,
            "area": "",
            "ech": 0
        },
        {
            "id": 5005,
            "name": "Pasturo",
            "provincia": "LC",
            "cap": "23818",
            "cod_catastale": "G368",
            "cod_istat": "097065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 641,
            "giorni": 2980,
            "area": "",
            "ech": 0
        },
        {
            "id": 5006,
            "name": "Paterno",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "M269",
            "cod_istat": "076100",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 634,
            "giorni": 2062,
            "area": "",
            "ech": 0
        },
        {
            "id": 5007,
            "name": "Paternò",
            "provincia": "CT",
            "cap": "95047",
            "cod_catastale": "G371",
            "cod_istat": "087033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1087,
            "area": "",
            "ech": 1
        },
        {
            "id": 5008,
            "name": "Paterno Calabro",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "G372",
            "cod_istat": "078094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2151,
            "area": "",
            "ech": 0
        },
        {
            "id": 5009,
            "name": "Paternopoli",
            "provincia": "AV",
            "cap": "83052",
            "cod_catastale": "G370",
            "cod_istat": "064070",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 490,
            "giorni": 1921,
            "area": "",
            "ech": 0
        },
        {
            "id": 5010,
            "name": "Patrica",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "G374",
            "cod_istat": "060048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2133,
            "area": "",
            "ech": 0
        },
        {
            "id": 5011,
            "name": "Pattada",
            "provincia": "SS",
            "cap": "07016",
            "cod_catastale": "G376",
            "cod_istat": "090055",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 778,
            "giorni": 2394,
            "area": "",
            "ech": 0
        },
        {
            "id": 5012,
            "name": "Patti",
            "provincia": "ME",
            "cap": "98066",
            "cod_catastale": "G377",
            "cod_istat": "083066",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 895,
            "area": "",
            "ech": 1
        },
        {
            "id": 5013,
            "name": "Patù",
            "provincia": "LE",
            "cap": "73053",
            "cod_catastale": "G378",
            "cod_istat": "075060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 1097,
            "area": "",
            "ech": 0
        },
        {
            "id": 5014,
            "name": "Pau",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "G379",
            "cod_istat": "095040",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 315,
            "giorni": 1380,
            "area": "",
            "ech": 0
        },
        {
            "id": 5015,
            "name": "Paularo",
            "provincia": "UD",
            "cap": "33027",
            "cod_catastale": "G381",
            "cod_istat": "030073",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 3510,
            "area": "",
            "ech": 0
        },
        {
            "id": 5016,
            "name": "Pauli Arbarei",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "G382",
            "cod_istat": "111053",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 136,
            "giorni": 1136,
            "area": "",
            "ech": 0
        },
        {
            "id": 5017,
            "name": "Paulilatino",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "G384",
            "cod_istat": "095041",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 280,
            "giorni": 1335,
            "area": "",
            "ech": 0
        },
        {
            "id": 5018,
            "name": "Paullo",
            "provincia": "MI",
            "cap": "20067",
            "cod_catastale": "G385",
            "cod_istat": "015169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5019,
            "name": "Paupisi",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "G386",
            "cod_istat": "062049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1653,
            "area": "",
            "ech": 0
        },
        {
            "id": 5020,
            "name": "Pavarolo",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "G387",
            "cod_istat": "001180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 2898,
            "area": "",
            "ech": 0
        },
        {
            "id": 5021,
            "name": "Pavia",
            "provincia": "PV",
            "cap": "27100",
            "cod_catastale": "G388",
            "cod_istat": "018110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 5022,
            "name": "Pavia di Udine",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "G389",
            "cod_istat": "030074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5023,
            "name": "Pavone Canavese",
            "provincia": "TO",
            "cap": "10018",
            "cod_catastale": "G392",
            "cod_istat": "001181",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2751,
            "area": "",
            "ech": 0
        },
        {
            "id": 5024,
            "name": "Pavone del Mella",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "G391",
            "cod_istat": "017137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 5025,
            "name": "Pavullo nel Frignano",
            "provincia": "MO",
            "cap": "41026",
            "cod_catastale": "G393",
            "cod_istat": "036030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 682,
            "giorni": 3348,
            "area": "",
            "ech": 0
        },
        {
            "id": 5026,
            "name": "Pazzano",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "G394",
            "cod_istat": "080058",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 410,
            "giorni": 1511,
            "area": "",
            "ech": 0
        },
        {
            "id": 5027,
            "name": "Peccioli",
            "provincia": "PI",
            "cap": "56037",
            "cod_catastale": "G395",
            "cod_istat": "050025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 1772,
            "area": "",
            "ech": 0
        },
        {
            "id": 5028,
            "name": "Pecco",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G396",
            "cod_istat": "001182",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 3209,
            "area": "",
            "ech": 0
        },
        {
            "id": 5029,
            "name": "Pecetto di Valenza",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "G397",
            "cod_istat": "006128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2657,
            "area": "",
            "ech": 0
        },
        {
            "id": 5030,
            "name": "Pecetto Torinese",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "G398",
            "cod_istat": "001183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 407,
            "giorni": 2964,
            "area": "",
            "ech": 0
        },
        {
            "id": 5031,
            "name": "Pecorara",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "G399",
            "cod_istat": "033031",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 481,
            "giorni": 3070,
            "area": "",
            "ech": 0
        },
        {
            "id": 5032,
            "name": "Pedace",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "G400",
            "cod_istat": "078095",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 598,
            "giorni": 1986,
            "area": "",
            "ech": 0
        },
        {
            "id": 5033,
            "name": "Pedara",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "G402",
            "cod_istat": "087034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 1568,
            "area": "",
            "ech": 1
        },
        {
            "id": 5034,
            "name": "Pedaso",
            "provincia": "FM",
            "cap": "63827",
            "cod_catastale": "G403",
            "cod_istat": "109030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1645,
            "area": "",
            "ech": 0
        },
        {
            "id": 5035,
            "name": "Pedavena",
            "provincia": "BL",
            "cap": "32034",
            "cod_catastale": "G404",
            "cod_istat": "025036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 359,
            "giorni": 3151,
            "area": "",
            "ech": 0
        },
        {
            "id": 5036,
            "name": "Pedemonte",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "G406",
            "cod_istat": "024076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 446,
            "giorni": 2973,
            "area": "",
            "ech": 0
        },
        {
            "id": 5037,
            "name": "Pederobba",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "G408",
            "cod_istat": "026056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 174,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 5038,
            "name": "Pedesina",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "G410",
            "cod_istat": "014047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1032,
            "giorni": 3535,
            "area": "",
            "ech": 0
        },
        {
            "id": 5039,
            "name": "Pedivigliano",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "G411",
            "cod_istat": "078096",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 580,
            "giorni": 1963,
            "area": "",
            "ech": 0
        },
        {
            "id": 5040,
            "name": "Pedrengo",
            "provincia": "BG",
            "cap": "24066",
            "cod_catastale": "G412",
            "cod_istat": "016160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 5041,
            "name": "Peglio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "G415",
            "cod_istat": "013178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2993,
            "area": "",
            "ech": 0
        },
        {
            "id": 5042,
            "name": "Peglio",
            "provincia": "PU",
            "cap": "61049",
            "cod_catastale": "G416",
            "cod_istat": "041041",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5043,
            "name": "Pegognaga",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "G417",
            "cod_istat": "020039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 5044,
            "name": "Peia",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G418",
            "cod_istat": "016161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 5045,
            "name": "Peio",
            "provincia": "TN",
            "cap": "38024",
            "cod_catastale": "G419",
            "cod_istat": "022136",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1173,
            "giorni": 4221,
            "area": "",
            "ech": 0
        },
        {
            "id": 5046,
            "name": "Pelago",
            "provincia": "FI",
            "cap": "50060",
            "cod_catastale": "G420",
            "cod_istat": "048032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2238,
            "area": "",
            "ech": 0
        },
        {
            "id": 5047,
            "name": "Pella",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "G421",
            "cod_istat": "003115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 5048,
            "name": "Pellegrino Parmense",
            "provincia": "PR",
            "cap": "43047",
            "cod_catastale": "G424",
            "cod_istat": "034028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2982,
            "area": "",
            "ech": 0
        },
        {
            "id": 5049,
            "name": "Pellezzano",
            "provincia": "SA",
            "cap": "84080",
            "cod_catastale": "G426",
            "cod_istat": "065090",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 1518,
            "area": "",
            "ech": 0
        },
        {
            "id": 5050,
            "name": "Pellio Intelvi",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "G427",
            "cod_istat": "013179",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3135,
            "area": "",
            "ech": 0
        },
        {
            "id": 5051,
            "name": "Pellizzano",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "G428",
            "cod_istat": "022137",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 925,
            "giorni": 3834,
            "area": "",
            "ech": 0
        },
        {
            "id": 5052,
            "name": "Pelugo",
            "provincia": "TN",
            "cap": "38079",
            "cod_catastale": "G429",
            "cod_istat": "022138",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 652,
            "giorni": 3408,
            "area": "",
            "ech": 0
        },
        {
            "id": 5053,
            "name": "Penango",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "G430",
            "cod_istat": "005083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 5054,
            "name": "Penna in Teverina",
            "provincia": "TR",
            "cap": "05028",
            "cod_catastale": "G432",
            "cod_istat": "055026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 302,
            "giorni": 1914,
            "area": "",
            "ech": 0
        },
        {
            "id": 5055,
            "name": "Penna San Giovanni",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "G436",
            "cod_istat": "043035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 5056,
            "name": "Penna Sant'Andrea",
            "provincia": "TE",
            "cap": "64039",
            "cod_catastale": "G437",
            "cod_istat": "067033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 413,
            "giorni": 2081,
            "area": "",
            "ech": 0
        },
        {
            "id": 5057,
            "name": "Pennabilli",
            "provincia": "RN",
            "cap": "47864",
            "cod_catastale": "G433",
            "cod_istat": "099024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 629,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 5058,
            "name": "Pennadomo",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "G434",
            "cod_istat": "069063",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 460,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 5059,
            "name": "Pennapiedimonte",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "G435",
            "cod_istat": "069064",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 669,
            "giorni": 2200,
            "area": "",
            "ech": 0
        },
        {
            "id": 5060,
            "name": "Penne",
            "provincia": "PE",
            "cap": "65017",
            "cod_catastale": "G438",
            "cod_istat": "068027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 438,
            "giorni": 1811,
            "area": "",
            "ech": 0
        },
        {
            "id": 5061,
            "name": "Pentone",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "G439",
            "cod_istat": "079092",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 2082,
            "area": "",
            "ech": 0
        },
        {
            "id": 5062,
            "name": "Perano",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "G441",
            "cod_istat": "069065",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 256,
            "giorni": 1556,
            "area": "",
            "ech": 0
        },
        {
            "id": 5063,
            "name": "Perarolo di Cadore",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "G442",
            "cod_istat": "025037",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 532,
            "giorni": 3550,
            "area": "",
            "ech": 0
        },
        {
            "id": 5064,
            "name": "Perca",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "G443",
            "cod_istat": "021063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 972,
            "giorni": 3966,
            "area": "",
            "ech": 0
        },
        {
            "id": 5065,
            "name": "Percile",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "G444",
            "cod_istat": "058076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2440,
            "area": "",
            "ech": 0
        },
        {
            "id": 5066,
            "name": "Perdasdefogu",
            "provincia": "NU",
            "cap": "08046",
            "cod_catastale": "G445",
            "cod_istat": "091072",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 599,
            "giorni": 1763,
            "area": "",
            "ech": 1
        },
        {
            "id": 5067,
            "name": "Perdaxius",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "G446",
            "cod_istat": "111054",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 98,
            "giorni": 901,
            "area": "",
            "ech": 1
        },
        {
            "id": 5068,
            "name": "Perdifumo",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "G447",
            "cod_istat": "065091",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 425,
            "giorni": 1576,
            "area": "",
            "ech": 0
        },
        {
            "id": 5069,
            "name": "Perego",
            "provincia": "LC",
            "cap": "23888",
            "cod_catastale": "G448",
            "cod_istat": "097066",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 374,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 5070,
            "name": "Pereto",
            "provincia": "AQ",
            "cap": "67064",
            "cod_catastale": "G449",
            "cod_istat": "066067",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 800,
            "giorni": 2768,
            "area": "",
            "ech": 0
        },
        {
            "id": 5071,
            "name": "Perfugas",
            "provincia": "SS",
            "cap": "07034",
            "cod_catastale": "G450",
            "cod_istat": "090056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 92,
            "giorni": 1006,
            "area": "",
            "ech": 0
        },
        {
            "id": 5072,
            "name": "Pergine Valdarno",
            "provincia": "AR",
            "cap": "52020",
            "cod_catastale": "G451",
            "cod_istat": "051042",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 361,
            "giorni": 2188,
            "area": "",
            "ech": 0
        },
        {
            "id": 5073,
            "name": "Pergine Valsugana",
            "provincia": "TN",
            "cap": "38057",
            "cod_catastale": "G452",
            "cod_istat": "022139",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 3147,
            "area": "",
            "ech": 0
        },
        {
            "id": 5074,
            "name": "Pergola",
            "provincia": "PU",
            "cap": "61045",
            "cod_catastale": "G453",
            "cod_istat": "041043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2264,
            "area": "",
            "ech": 0
        },
        {
            "id": 5075,
            "name": "Perinaldo",
            "provincia": "IM",
            "cap": "18032",
            "cod_catastale": "G454",
            "cod_istat": "008040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 572,
            "giorni": 2521,
            "area": "",
            "ech": 0
        },
        {
            "id": 5076,
            "name": "Perito",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "G455",
            "cod_istat": "065092",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 465,
            "giorni": 1626,
            "area": "",
            "ech": 0
        },
        {
            "id": 5077,
            "name": "Perledo",
            "provincia": "LC",
            "cap": "23828",
            "cod_catastale": "G456",
            "cod_istat": "097067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 395,
            "giorni": 2630,
            "area": "",
            "ech": 0
        },
        {
            "id": 5078,
            "name": "Perletto",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "G457",
            "cod_istat": "004161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 446,
            "giorni": 2868,
            "area": "",
            "ech": 0
        },
        {
            "id": 5079,
            "name": "Perlo",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "G458",
            "cod_istat": "004162",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 697,
            "giorni": 3179,
            "area": "",
            "ech": 0
        },
        {
            "id": 5080,
            "name": "Perloz",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "G459",
            "cod_istat": "007048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 661,
            "giorni": 3210,
            "area": "",
            "ech": 0
        },
        {
            "id": 5081,
            "name": "Pernumia",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "G461",
            "cod_istat": "028061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5082,
            "name": "Pero",
            "provincia": "MI",
            "cap": "20016",
            "cod_catastale": "C013",
            "cod_istat": "015170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5083,
            "name": "Perosa Argentina",
            "provincia": "TO",
            "cap": "10063",
            "cod_catastale": "G463",
            "cod_istat": "001184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 608,
            "giorni": 3266,
            "area": "",
            "ech": 0
        },
        {
            "id": 5084,
            "name": "Perosa Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "G462",
            "cod_istat": "001185",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2755,
            "area": "",
            "ech": 0
        },
        {
            "id": 5085,
            "name": "Perrero",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G465",
            "cod_istat": "001186",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 844,
            "giorni": 3620,
            "area": "",
            "ech": 0
        },
        {
            "id": 5086,
            "name": "Persico Dosimo",
            "provincia": "CR",
            "cap": "26043",
            "cod_catastale": "G469",
            "cod_istat": "019068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5087,
            "name": "Pertengo",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "G471",
            "cod_istat": "002091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 5088,
            "name": "Pertica Alta",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "G474",
            "cod_istat": "017139",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 900,
            "giorni": 3496,
            "area": "",
            "ech": 0
        },
        {
            "id": 5089,
            "name": "Pertica Bassa",
            "provincia": "BS",
            "cap": "25078",
            "cod_catastale": "G475",
            "cod_istat": "017140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 511,
            "giorni": 2940,
            "area": "",
            "ech": 0
        },
        {
            "id": 5090,
            "name": "Pertosa",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "G476",
            "cod_istat": "065093",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 301,
            "giorni": 1453,
            "area": "",
            "ech": 0
        },
        {
            "id": 5091,
            "name": "Pertusio",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G477",
            "cod_istat": "001187",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 2690,
            "area": "",
            "ech": 0
        },
        {
            "id": 5092,
            "name": "Perugia",
            "provincia": "PG",
            "cap": "061xx",
            "cod_catastale": "G478",
            "cod_istat": "054039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 2289,
            "area": "",
            "ech": 0
        },
        {
            "id": 5093,
            "name": "Pesaro",
            "provincia": "PU",
            "cap": "611xx",
            "cod_catastale": "G479",
            "cod_istat": "041044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2083,
            "area": "CNOR",
            "ech": 0
        },
        {
            "id": 5094,
            "name": "Pescaglia",
            "provincia": "LU",
            "cap": "55064",
            "cod_catastale": "G480",
            "cod_istat": "046022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 5095,
            "name": "Pescantina",
            "provincia": "VR",
            "cap": "37026",
            "cod_catastale": "G481",
            "cod_istat": "023058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 5096,
            "name": "Pescara",
            "provincia": "PE",
            "cap": "651xx",
            "cod_catastale": "G482",
            "cod_istat": "068028",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 4,
            "giorni": 1718,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 5097,
            "name": "Pescarolo ed Uniti",
            "provincia": "CR",
            "cap": "26033",
            "cod_catastale": "G483",
            "cod_istat": "019069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5098,
            "name": "Pescasseroli",
            "provincia": "AQ",
            "cap": "67032",
            "cod_catastale": "G484",
            "cod_istat": "066068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1167,
            "giorni": 3531,
            "area": "",
            "ech": 0
        },
        {
            "id": 5099,
            "name": "Pescate",
            "provincia": "LC",
            "cap": "23855",
            "cod_catastale": "G485",
            "cod_istat": "097068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2373,
            "area": "",
            "ech": 0
        },
        {
            "id": 5100,
            "name": "Pesche",
            "provincia": "IS",
            "cap": "86090",
            "cod_catastale": "G486",
            "cod_istat": "094031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 5101,
            "name": "Peschici",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "G487",
            "cod_istat": "071038",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 90,
            "giorni": 1427,
            "area": "",
            "ech": 0
        },
        {
            "id": 5102,
            "name": "Peschiera Borromeo",
            "provincia": "MI",
            "cap": "20068",
            "cod_catastale": "G488",
            "cod_istat": "015171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5103,
            "name": "Peschiera del Garda",
            "provincia": "VR",
            "cap": "37019",
            "cod_catastale": "G489",
            "cod_istat": "023059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2381,
            "area": "",
            "ech": 0
        },
        {
            "id": 5104,
            "name": "Pescia",
            "provincia": "PT",
            "cap": "51017",
            "cod_catastale": "G491",
            "cod_istat": "047012",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 1877,
            "area": "",
            "ech": 0
        },
        {
            "id": 5105,
            "name": "Pescina",
            "provincia": "AQ",
            "cap": "67057",
            "cod_catastale": "G492",
            "cod_istat": "066069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 735,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 5106,
            "name": "Pesco Sannita",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "G494",
            "cod_istat": "062050",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 393,
            "giorni": 1785,
            "area": "",
            "ech": 0
        },
        {
            "id": 5107,
            "name": "Pescocostanzo",
            "provincia": "AQ",
            "cap": "67033",
            "cod_catastale": "G493",
            "cod_istat": "066070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1395,
            "giorni": 3503,
            "area": "",
            "ech": 0
        },
        {
            "id": 5108,
            "name": "Pescolanciano",
            "provincia": "IS",
            "cap": "86097",
            "cod_catastale": "G495",
            "cod_istat": "094032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 819,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 5109,
            "name": "Pescopagano",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "G496",
            "cod_istat": "076058",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 954,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 5110,
            "name": "Pescopennataro",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "G497",
            "cod_istat": "094033",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1190,
            "giorni": 3114,
            "area": "",
            "ech": 0
        },
        {
            "id": 5111,
            "name": "Pescorocchiano",
            "provincia": "RI",
            "cap": "02024",
            "cod_catastale": "G498",
            "cod_istat": "057049",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 806,
            "giorni": 2832,
            "area": "",
            "ech": 0
        },
        {
            "id": 5112,
            "name": "Pescosansonesco",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "G499",
            "cod_istat": "068029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 2085,
            "area": "",
            "ech": 0
        },
        {
            "id": 5113,
            "name": "Pescosolido",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "G500",
            "cod_istat": "060049",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 630,
            "giorni": 2346,
            "area": "",
            "ech": 0
        },
        {
            "id": 5114,
            "name": "Pessano con Bornago",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "G502",
            "cod_istat": "015172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5115,
            "name": "Pessina Cremonese",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "G504",
            "cod_istat": "019070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5116,
            "name": "Pessinetto",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "G505",
            "cod_istat": "001188",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 3310,
            "area": "",
            "ech": 0
        },
        {
            "id": 5117,
            "name": "Petacciato",
            "provincia": "CB",
            "cap": "86038",
            "cod_catastale": "G506",
            "cod_istat": "070051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1594,
            "area": "",
            "ech": 0
        },
        {
            "id": 5118,
            "name": "Petilia Policastro",
            "provincia": "KR",
            "cap": "88837",
            "cod_catastale": "G508",
            "cod_istat": "101017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 436,
            "giorni": 1681,
            "area": "",
            "ech": 0
        },
        {
            "id": 5119,
            "name": "Petina",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "G509",
            "cod_istat": "065094",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 649,
            "giorni": 2090,
            "area": "",
            "ech": 0
        },
        {
            "id": 5120,
            "name": "Petralia Soprana",
            "provincia": "PA",
            "cap": "90026",
            "cod_catastale": "G510",
            "cod_istat": "082055",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1147,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 5121,
            "name": "Petralia Sottana",
            "provincia": "PA",
            "cap": "90027",
            "cod_catastale": "G511",
            "cod_istat": "082056",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1000,
            "giorni": 2162,
            "area": "",
            "ech": 0
        },
        {
            "id": 5122,
            "name": "Petrella Salto",
            "provincia": "RI",
            "cap": "02025",
            "cod_catastale": "G513",
            "cod_istat": "057050",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 786,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 5123,
            "name": "Petrella Tifernina",
            "provincia": "CB",
            "cap": "86024",
            "cod_catastale": "G512",
            "cod_istat": "070052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 651,
            "giorni": 2185,
            "area": "",
            "ech": 0
        },
        {
            "id": 5124,
            "name": "Petriano",
            "provincia": "PU",
            "cap": "61020",
            "cod_catastale": "G514",
            "cod_istat": "041045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2336,
            "area": "",
            "ech": 0
        },
        {
            "id": 5125,
            "name": "Petriolo",
            "provincia": "MC",
            "cap": "62014",
            "cod_catastale": "G515",
            "cod_istat": "043036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 1995,
            "area": "",
            "ech": 0
        },
        {
            "id": 5126,
            "name": "Petritoli",
            "provincia": "FM",
            "cap": "63848",
            "cod_catastale": "G516",
            "cod_istat": "109031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2058,
            "area": "",
            "ech": 0
        },
        {
            "id": 5127,
            "name": "Petrizzi",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "G517",
            "cod_istat": "079094",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 1481,
            "area": "",
            "ech": 0
        },
        {
            "id": 5128,
            "name": "Petronà",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "G518",
            "cod_istat": "079095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 889,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 5129,
            "name": "Petrosino",
            "provincia": "TP",
            "cap": "91020",
            "cod_catastale": "M281",
            "cod_istat": "081024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 936,
            "area": "",
            "ech": 1
        },
        {
            "id": 5130,
            "name": "Petruro Irpino",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "G519",
            "cod_istat": "064071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1969,
            "area": "",
            "ech": 0
        },
        {
            "id": 5131,
            "name": "Pettenasco",
            "provincia": "NO",
            "cap": "28028",
            "cod_catastale": "G520",
            "cod_istat": "003116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 5132,
            "name": "Pettinengo",
            "provincia": "BI",
            "cap": "13843",
            "cod_catastale": "G521",
            "cod_istat": "096042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 3168,
            "area": "",
            "ech": 0
        },
        {
            "id": 5133,
            "name": "Pettineo",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "G522",
            "cod_istat": "083067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1139,
            "area": "",
            "ech": 0
        },
        {
            "id": 5134,
            "name": "Pettoranello del Molise",
            "provincia": "IS",
            "cap": "86090",
            "cod_catastale": "G523",
            "cod_istat": "094034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 737,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 5135,
            "name": "Pettorano sul Gizio",
            "provincia": "AQ",
            "cap": "67034",
            "cod_catastale": "G524",
            "cod_istat": "066071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2407,
            "area": "",
            "ech": 0
        },
        {
            "id": 5136,
            "name": "Pettorazza Grimani",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "G525",
            "cod_istat": "029035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 5137,
            "name": "Peveragno",
            "provincia": "CN",
            "cap": "12016",
            "cod_catastale": "G526",
            "cod_istat": "004163",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 3022,
            "area": "",
            "ech": 0
        },
        {
            "id": 5138,
            "name": "Pezzana",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "G528",
            "cod_istat": "002093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 5139,
            "name": "Pezzaze",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "G529",
            "cod_istat": "017141",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 3227,
            "area": "",
            "ech": 0
        },
        {
            "id": 5140,
            "name": "Pezzolo Valle Uzzone",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "G532",
            "cod_istat": "004164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 5141,
            "name": "Piacenza",
            "provincia": "PC",
            "cap": "291xx",
            "cod_catastale": "G535",
            "cod_istat": "033032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 5142,
            "name": "Piacenza d'Adige",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "G534",
            "cod_istat": "028062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 5143,
            "name": "Piadena",
            "provincia": "CR",
            "cap": "26034",
            "cod_catastale": "G536",
            "cod_istat": "019116",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5144,
            "name": "Piagge",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "G537",
            "cod_istat": "041046",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 5145,
            "name": "Piaggine",
            "provincia": "SA",
            "cap": "84065",
            "cod_catastale": "G538",
            "cod_istat": "065095",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2028,
            "area": "",
            "ech": 0
        },
        {
            "id": 5146,
            "name": "Pian Camuno",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "G546",
            "cod_istat": "017142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 5147,
            "name": "Pian di Sco",
            "provincia": "AR",
            "cap": "52026",
            "cod_catastale": "G552",
            "cod_istat": "051040",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2169,
            "area": "",
            "ech": 0
        },
        {
            "id": 5148,
            "name": "Piana Crixia",
            "provincia": "SV",
            "cap": "17058",
            "cod_catastale": "G542",
            "cod_istat": "009048",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 1996,
            "area": "",
            "ech": 0
        },
        {
            "id": 5149,
            "name": "Piana degli Albanesi",
            "provincia": "PA",
            "cap": "90037",
            "cod_catastale": "G543",
            "cod_istat": "082057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 1711,
            "area": "",
            "ech": 1
        },
        {
            "id": 5150,
            "name": "Piana di Monte Verna",
            "provincia": "CE",
            "cap": "81013",
            "cod_catastale": "G541",
            "cod_istat": "061056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 1001,
            "area": "",
            "ech": 0
        },
        {
            "id": 5151,
            "name": "Piancastagnaio",
            "provincia": "SI",
            "cap": "53025",
            "cod_catastale": "G547",
            "cod_istat": "052020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 772,
            "giorni": 2629,
            "area": "",
            "ech": 0
        },
        {
            "id": 5152,
            "name": "Piancogno",
            "provincia": "BS",
            "cap": "25052",
            "cod_catastale": "G549",
            "cod_istat": "017206",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2568,
            "area": "",
            "ech": 0
        },
        {
            "id": 5153,
            "name": "Piandimeleto",
            "provincia": "PU",
            "cap": "61026",
            "cod_catastale": "G551",
            "cod_istat": "041047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 2330,
            "area": "",
            "ech": 0
        },
        {
            "id": 5154,
            "name": "Piane Crati",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "G553",
            "cod_istat": "078097",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 609,
            "giorni": 2008,
            "area": "",
            "ech": 0
        },
        {
            "id": 5155,
            "name": "Pianella",
            "provincia": "PE",
            "cap": "65019",
            "cod_catastale": "G555",
            "cod_istat": "068030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 1414,
            "area": "",
            "ech": 0
        },
        {
            "id": 5156,
            "name": "Pianello del Lario",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "G556",
            "cod_istat": "013183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2236,
            "area": "",
            "ech": 0
        },
        {
            "id": 5157,
            "name": "Pianello Val Tidone",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "G557",
            "cod_istat": "033033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2703,
            "area": "",
            "ech": 0
        },
        {
            "id": 5158,
            "name": "Pianengo",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "G558",
            "cod_istat": "019072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 5159,
            "name": "Pianezza",
            "provincia": "TO",
            "cap": "10044",
            "cod_catastale": "G559",
            "cod_istat": "001189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2735,
            "area": "",
            "ech": 0
        },
        {
            "id": 5160,
            "name": "Pianezze",
            "provincia": "VI",
            "cap": "36060",
            "cod_catastale": "G560",
            "cod_istat": "024077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2528,
            "area": "",
            "ech": 0
        },
        {
            "id": 5161,
            "name": "Pianfei",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "G561",
            "cod_istat": "004165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 503,
            "giorni": 2939,
            "area": "",
            "ech": 0
        },
        {
            "id": 5162,
            "name": "Pianico",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "G564",
            "cod_istat": "016162",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 5163,
            "name": "Pianiga",
            "provincia": "VE",
            "cap": "30030",
            "cod_catastale": "G565",
            "cod_istat": "027028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 5164,
            "name": "Piano di Sorrento",
            "provincia": "NA",
            "cap": "80063",
            "cod_catastale": "G568",
            "cod_istat": "063053",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 1121,
            "area": "",
            "ech": 0
        },
        {
            "id": 5165,
            "name": "Pianopoli",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "D546",
            "cod_istat": "079096",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1233,
            "area": "",
            "ech": 0
        },
        {
            "id": 5166,
            "name": "Pianoro",
            "provincia": "BO",
            "cap": "40065",
            "cod_catastale": "G570",
            "cod_istat": "037047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 5167,
            "name": "Piansano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "G571",
            "cod_istat": "056043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 2146,
            "area": "",
            "ech": 0
        },
        {
            "id": 5168,
            "name": "Piantedo",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "G572",
            "cod_istat": "014048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 5169,
            "name": "Piario",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G574",
            "cod_istat": "016163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 539,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 5170,
            "name": "Piasco",
            "provincia": "CN",
            "cap": "12026",
            "cod_catastale": "G575",
            "cod_istat": "004166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2910,
            "area": "",
            "ech": 0
        },
        {
            "id": 5171,
            "name": "Piateda",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "G576",
            "cod_istat": "014049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 3082,
            "area": "",
            "ech": 0
        },
        {
            "id": 5172,
            "name": "Piatto",
            "provincia": "BI",
            "cap": "13844",
            "cod_catastale": "G577",
            "cod_istat": "096043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 5173,
            "name": "Piazza al Serchio",
            "provincia": "LU",
            "cap": "55035",
            "cod_catastale": "G582",
            "cod_istat": "046023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 536,
            "giorni": 2764,
            "area": "",
            "ech": 0
        },
        {
            "id": 5174,
            "name": "Piazza Armerina",
            "provincia": "EN",
            "cap": "94015",
            "cod_catastale": "G580",
            "cod_istat": "086014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 697,
            "giorni": 1607,
            "area": "",
            "ech": 1
        },
        {
            "id": 5175,
            "name": "Piazza Brembana",
            "provincia": "BG",
            "cap": "24014",
            "cod_catastale": "G579",
            "cod_istat": "016164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 536,
            "giorni": 2831,
            "area": "",
            "ech": 0
        },
        {
            "id": 5176,
            "name": "Piazzatorre",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "G583",
            "cod_istat": "016165",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 868,
            "giorni": 3302,
            "area": "",
            "ech": 0
        },
        {
            "id": 5177,
            "name": "Piazzola sul Brenta",
            "provincia": "PD",
            "cap": "35016",
            "cod_catastale": "G587",
            "cod_istat": "028063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5178,
            "name": "Piazzolo",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "G588",
            "cod_istat": "016166",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 702,
            "giorni": 3066,
            "area": "",
            "ech": 0
        },
        {
            "id": 5179,
            "name": "Picciano",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "G589",
            "cod_istat": "068031",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 170,
            "giorni": 1526,
            "area": "",
            "ech": 0
        },
        {
            "id": 5180,
            "name": "Picerno",
            "provincia": "PZ",
            "cap": "85055",
            "cod_catastale": "G590",
            "cod_istat": "076059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 2265,
            "area": "",
            "ech": 0
        },
        {
            "id": 5181,
            "name": "Picinisco",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "G591",
            "cod_istat": "060050",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 725,
            "giorni": 2407,
            "area": "",
            "ech": 0
        },
        {
            "id": 5182,
            "name": "Pico",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "G592",
            "cod_istat": "060051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 1478,
            "area": "",
            "ech": 0
        },
        {
            "id": 5183,
            "name": "Piea",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "G593",
            "cod_istat": "005084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 5184,
            "name": "Piedicavallo",
            "provincia": "BI",
            "cap": "13812",
            "cod_catastale": "G594",
            "cod_istat": "096044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1050,
            "giorni": 3669,
            "area": "",
            "ech": 0
        },
        {
            "id": 5185,
            "name": "Piedimonte Etneo",
            "provincia": "CT",
            "cap": "95017",
            "cod_catastale": "G597",
            "cod_istat": "087035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 348,
            "giorni": 1236,
            "area": "",
            "ech": 1
        },
        {
            "id": 5186,
            "name": "Piedimonte Matese",
            "provincia": "CE",
            "cap": "81016",
            "cod_catastale": "G596",
            "cod_istat": "061057",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 170,
            "giorni": 1385,
            "area": "",
            "ech": 0
        },
        {
            "id": 5187,
            "name": "Piedimonte San Germano",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "G598",
            "cod_istat": "060052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 1284,
            "area": "",
            "ech": 0
        },
        {
            "id": 5188,
            "name": "Piedimulera",
            "provincia": "VB",
            "cap": "28885",
            "cod_catastale": "G600",
            "cod_istat": "103053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 5189,
            "name": "Piegaro",
            "provincia": "PG",
            "cap": "06066",
            "cod_catastale": "G601",
            "cod_istat": "054040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2152,
            "area": "",
            "ech": 0
        },
        {
            "id": 5190,
            "name": "Pienza",
            "provincia": "SI",
            "cap": "53026",
            "cod_catastale": "G602",
            "cod_istat": "052021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 491,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 5191,
            "name": "Pieranica",
            "provincia": "CR",
            "cap": "26017",
            "cod_catastale": "G603",
            "cod_istat": "019073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5192,
            "name": "Pietra de' Giorgi",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "G612",
            "cod_istat": "018111",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 311,
            "giorni": 3001,
            "area": "",
            "ech": 0
        },
        {
            "id": 5193,
            "name": "Pietra Ligure",
            "provincia": "SV",
            "cap": "17027",
            "cod_catastale": "G605",
            "cod_istat": "009049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1285,
            "area": "",
            "ech": 0
        },
        {
            "id": 5194,
            "name": "Pietra Marazzi",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "G619",
            "cod_istat": "006129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 5195,
            "name": "Pietrabbondante",
            "provincia": "IS",
            "cap": "86085",
            "cod_catastale": "G606",
            "cod_istat": "094035",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1027,
            "giorni": 2849,
            "area": "",
            "ech": 0
        },
        {
            "id": 5196,
            "name": "Pietrabruna",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "G607",
            "cod_istat": "008041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2093,
            "area": "",
            "ech": 0
        },
        {
            "id": 5197,
            "name": "Pietracamela",
            "provincia": "TE",
            "cap": "64047",
            "cod_catastale": "G608",
            "cod_istat": "067034",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1005,
            "giorni": 3077,
            "area": "",
            "ech": 0
        },
        {
            "id": 5198,
            "name": "Pietracatella",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "G609",
            "cod_istat": "070053",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 666,
            "giorni": 2303,
            "area": "",
            "ech": 0
        },
        {
            "id": 5199,
            "name": "Pietracupa",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "G610",
            "cod_istat": "070054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 695,
            "giorni": 2266,
            "area": "",
            "ech": 0
        },
        {
            "id": 5200,
            "name": "Pietradefusi",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "G611",
            "cod_istat": "064072",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1938,
            "area": "",
            "ech": 0
        },
        {
            "id": 5201,
            "name": "Pietraferrazzana",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "G613",
            "cod_istat": "069103",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 357,
            "giorni": 1732,
            "area": "",
            "ech": 0
        },
        {
            "id": 5202,
            "name": "Pietrafitta",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "G615",
            "cod_istat": "078098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2191,
            "area": "",
            "ech": 0
        },
        {
            "id": 5203,
            "name": "Pietragalla",
            "provincia": "PZ",
            "cap": "85016",
            "cod_catastale": "G616",
            "cod_istat": "076060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 839,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 5204,
            "name": "Pietralunga",
            "provincia": "PG",
            "cap": "06026",
            "cod_catastale": "G618",
            "cod_istat": "054041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 566,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 5205,
            "name": "Pietramelara",
            "provincia": "CE",
            "cap": "81051",
            "cod_catastale": "G620",
            "cod_istat": "061058",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 132,
            "giorni": 1308,
            "area": "",
            "ech": 0
        },
        {
            "id": 5206,
            "name": "Pietramontecorvino",
            "provincia": "FG",
            "cap": "71038",
            "cod_catastale": "G604",
            "cod_istat": "071039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 456,
            "giorni": 1714,
            "area": "",
            "ech": 0
        },
        {
            "id": 5207,
            "name": "Pietranico",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "G621",
            "cod_istat": "068032",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 2161,
            "area": "",
            "ech": 0
        },
        {
            "id": 5208,
            "name": "Pietrapaola",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "G622",
            "cod_istat": "078099",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 1564,
            "area": "",
            "ech": 0
        },
        {
            "id": 5209,
            "name": "Pietrapertosa",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "G623",
            "cod_istat": "076061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1088,
            "giorni": 2888,
            "area": "",
            "ech": 0
        },
        {
            "id": 5210,
            "name": "Pietraperzia",
            "provincia": "EN",
            "cap": "94016",
            "cod_catastale": "G624",
            "cod_istat": "086015",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 476,
            "giorni": 1383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5211,
            "name": "Pietraporzio",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "G625",
            "cod_istat": "004167",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1246,
            "giorni": 3860,
            "area": "",
            "ech": 0
        },
        {
            "id": 5212,
            "name": "Pietraroja",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "G626",
            "cod_istat": "062051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 818,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 5213,
            "name": "Pietrarubbia",
            "provincia": "PU",
            "cap": "61023",
            "cod_catastale": "G627",
            "cod_istat": "041048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 572,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 5214,
            "name": "Pietrasanta",
            "provincia": "LU",
            "cap": "55045",
            "cod_catastale": "G628",
            "cod_istat": "046024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 1428,
            "area": "",
            "ech": 0
        },
        {
            "id": 5215,
            "name": "Pietrastornina",
            "provincia": "AV",
            "cap": "83015",
            "cod_catastale": "G629",
            "cod_istat": "064073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 513,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 5216,
            "name": "Pietravairano",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "G630",
            "cod_istat": "061059",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 250,
            "giorni": 1555,
            "area": "",
            "ech": 0
        },
        {
            "id": 5217,
            "name": "Pietrelcina",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "G631",
            "cod_istat": "062052",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 345,
            "giorni": 1698,
            "area": "",
            "ech": 0
        },
        {
            "id": 5218,
            "name": "Pieve a Nievole",
            "provincia": "PT",
            "cap": "51018",
            "cod_catastale": "G636",
            "cod_istat": "047013",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1708,
            "area": "",
            "ech": 0
        },
        {
            "id": 5219,
            "name": "Pieve Albignola",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "G635",
            "cod_istat": "018112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5220,
            "name": "Pieve d'Alpago",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "G638",
            "cod_istat": "025038",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 690,
            "giorni": 3531,
            "area": "",
            "ech": 0
        },
        {
            "id": 5221,
            "name": "Pieve del Cairo",
            "provincia": "PV",
            "cap": "27037",
            "cod_catastale": "G639",
            "cod_istat": "018113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5222,
            "name": "Pieve di Bono",
            "provincia": "TN",
            "cap": "38085",
            "cod_catastale": "G641",
            "cod_istat": "022234",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 514,
            "giorni": 3193,
            "area": "",
            "ech": 0
        },
        {
            "id": 5223,
            "name": "Pieve di Cadore",
            "provincia": "BL",
            "cap": "32044",
            "cod_catastale": "G642",
            "cod_istat": "025039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 878,
            "giorni": 4055,
            "area": "",
            "ech": 0
        },
        {
            "id": 5224,
            "name": "Pieve di Cento",
            "provincia": "BO",
            "cap": "40066",
            "cod_catastale": "G643",
            "cod_istat": "037048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2182,
            "area": "",
            "ech": 0
        },
        {
            "id": 5225,
            "name": "Pieve di Coriano",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "G633",
            "cod_istat": "020040",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5226,
            "name": "Pieve di Soligo",
            "provincia": "TV",
            "cap": "31053",
            "cod_catastale": "G645",
            "cod_istat": "026057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 2624,
            "area": "",
            "ech": 0
        },
        {
            "id": 5227,
            "name": "Pieve di Teco",
            "provincia": "IM",
            "cap": "18026",
            "cod_catastale": "G632",
            "cod_istat": "008042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2290,
            "area": "",
            "ech": 0
        },
        {
            "id": 5228,
            "name": "Pieve d'Olmi",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "G647",
            "cod_istat": "019074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5229,
            "name": "Pieve Emanuele",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "G634",
            "cod_istat": "015173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5230,
            "name": "Pieve Fissiraga",
            "provincia": "LO",
            "cap": "26854",
            "cod_catastale": "G096",
            "cod_istat": "098045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 5231,
            "name": "Pieve Fosciana",
            "provincia": "LU",
            "cap": "55036",
            "cod_catastale": "G648",
            "cod_istat": "046025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 2448,
            "area": "",
            "ech": 0
        },
        {
            "id": 5232,
            "name": "Pieve Ligure",
            "provincia": "GE",
            "cap": "16031",
            "cod_catastale": "G646",
            "cod_istat": "010043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1933,
            "area": "",
            "ech": 0
        },
        {
            "id": 5233,
            "name": "Pieve Porto Morone",
            "provincia": "PV",
            "cap": "27017",
            "cod_catastale": "G650",
            "cod_istat": "018114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 5234,
            "name": "Pieve San Giacomo",
            "provincia": "CR",
            "cap": "26035",
            "cod_catastale": "G651",
            "cod_istat": "019075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5235,
            "name": "Pieve Santo Stefano",
            "provincia": "AR",
            "cap": "52036",
            "cod_catastale": "G653",
            "cod_istat": "051030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 433,
            "giorni": 2297,
            "area": "",
            "ech": 0
        },
        {
            "id": 5236,
            "name": "Pieve Tesino",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "G656",
            "cod_istat": "022142",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 843,
            "giorni": 3706,
            "area": "",
            "ech": 0
        },
        {
            "id": 5237,
            "name": "Pieve Torina",
            "provincia": "MC",
            "cap": "62036",
            "cod_catastale": "G657",
            "cod_istat": "043038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 2189,
            "area": "",
            "ech": 0
        },
        {
            "id": 5238,
            "name": "Pieve Vergonte",
            "provincia": "VB",
            "cap": "28886",
            "cod_catastale": "G658",
            "cod_istat": "103054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2490,
            "area": "",
            "ech": 0
        },
        {
            "id": 5239,
            "name": "Pievebovigliana",
            "provincia": "MC",
            "cap": "62035",
            "cod_catastale": "G637",
            "cod_istat": "043037",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2156,
            "area": "",
            "ech": 0
        },
        {
            "id": 5240,
            "name": "Pievepelago",
            "provincia": "MO",
            "cap": "41027",
            "cod_catastale": "G649",
            "cod_istat": "036031",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 781,
            "giorni": 3299,
            "area": "",
            "ech": 0
        },
        {
            "id": 5241,
            "name": "Piglio",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "G659",
            "cod_istat": "060053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 2330,
            "area": "",
            "ech": 0
        },
        {
            "id": 5242,
            "name": "Pigna",
            "provincia": "IM",
            "cap": "18037",
            "cod_catastale": "G660",
            "cod_istat": "008043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1718,
            "area": "",
            "ech": 0
        },
        {
            "id": 5243,
            "name": "Pignataro Interamna",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "G662",
            "cod_istat": "060054",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 1211,
            "area": "",
            "ech": 0
        },
        {
            "id": 5244,
            "name": "Pignataro Maggiore",
            "provincia": "CE",
            "cap": "81052",
            "cod_catastale": "G661",
            "cod_istat": "061060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 1229,
            "area": "",
            "ech": 0
        },
        {
            "id": 5245,
            "name": "Pignola",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "G663",
            "cod_istat": "076062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 926,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 5246,
            "name": "Pignone",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "G664",
            "cod_istat": "011021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 1659,
            "area": "",
            "ech": 0
        },
        {
            "id": 5247,
            "name": "Pigra",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "G665",
            "cod_istat": "013184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 881,
            "giorni": 3321,
            "area": "",
            "ech": 0
        },
        {
            "id": 5248,
            "name": "Pila",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "G666",
            "cod_istat": "002096",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 686,
            "giorni": 3196,
            "area": "",
            "ech": 0
        },
        {
            "id": 5249,
            "name": "Pimentel",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "G669",
            "cod_istat": "111055",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 154,
            "giorni": 1208,
            "area": "",
            "ech": 0
        },
        {
            "id": 5250,
            "name": "Pimonte",
            "provincia": "NA",
            "cap": "80050",
            "cod_catastale": "G670",
            "cod_istat": "063054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 1646,
            "area": "",
            "ech": 0
        },
        {
            "id": 5251,
            "name": "Pinarolo Po",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "G671",
            "cod_istat": "018115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 5252,
            "name": "Pinasca",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G672",
            "cod_istat": "001190",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 3194,
            "area": "",
            "ech": 0
        },
        {
            "id": 5253,
            "name": "Pincara",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "G673",
            "cod_istat": "029036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2370,
            "area": "",
            "ech": 0
        },
        {
            "id": 5254,
            "name": "Pinerolo",
            "provincia": "TO",
            "cap": "10064",
            "cod_catastale": "G674",
            "cod_istat": "001191",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2815,
            "area": "",
            "ech": 0
        },
        {
            "id": 5255,
            "name": "Pineto",
            "provincia": "TE",
            "cap": "64025",
            "cod_catastale": "F831",
            "cod_istat": "067035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1280,
            "area": "",
            "ech": 0
        },
        {
            "id": 5256,
            "name": "Pino d'Asti",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "G676",
            "cod_istat": "005085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2828,
            "area": "",
            "ech": 0
        },
        {
            "id": 5257,
            "name": "Pino sulla Sponda del Lago Maggiore",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "G677",
            "cod_istat": "012112",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 5258,
            "name": "Pino Torinese",
            "provincia": "TO",
            "cap": "10025",
            "cod_catastale": "G678",
            "cod_istat": "001192",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 3096,
            "area": "",
            "ech": 0
        },
        {
            "id": 5259,
            "name": "Pinzano al Tagliamento",
            "provincia": "PN",
            "cap": "33094",
            "cod_catastale": "G680",
            "cod_istat": "093030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 5260,
            "name": "Pinzolo",
            "provincia": "TN",
            "cap": "38086",
            "cod_catastale": "G681",
            "cod_istat": "022143",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 770,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 5261,
            "name": "Piobbico",
            "provincia": "PU",
            "cap": "61046",
            "cod_catastale": "G682",
            "cod_istat": "041049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 339,
            "giorni": 2346,
            "area": "",
            "ech": 0
        },
        {
            "id": 5262,
            "name": "Piobesi d'Alba",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "G683",
            "cod_istat": "004168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2556,
            "area": "",
            "ech": 0
        },
        {
            "id": 5263,
            "name": "Piobesi Torinese",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "G684",
            "cod_istat": "001193",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 2575,
            "area": "",
            "ech": 0
        },
        {
            "id": 5264,
            "name": "Piode",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "G685",
            "cod_istat": "002097",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 752,
            "giorni": 3282,
            "area": "",
            "ech": 0
        },
        {
            "id": 5265,
            "name": "Pioltello",
            "provincia": "MI",
            "cap": "20096",
            "cod_catastale": "G686",
            "cod_istat": "015175",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5266,
            "name": "Piombino",
            "provincia": "LI",
            "cap": "57025",
            "cod_catastale": "G687",
            "cod_istat": "049012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 1245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5267,
            "name": "Piombino Dese",
            "provincia": "PD",
            "cap": "35017",
            "cod_catastale": "G688",
            "cod_istat": "028064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 5268,
            "name": "Pioraco",
            "provincia": "MC",
            "cap": "62025",
            "cod_catastale": "G690",
            "cod_istat": "043039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2156,
            "area": "",
            "ech": 0
        },
        {
            "id": 5269,
            "name": "Piossasco",
            "provincia": "TO",
            "cap": "10045",
            "cod_catastale": "G691",
            "cod_istat": "001194",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 5270,
            "name": "Piovà Massaia",
            "provincia": "AT",
            "cap": "14026",
            "cod_catastale": "G692",
            "cod_istat": "005086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 5271,
            "name": "Piove di Sacco",
            "provincia": "PD",
            "cap": "35028",
            "cod_catastale": "G693",
            "cod_istat": "028065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 5272,
            "name": "Piovene Rocchette",
            "provincia": "VI",
            "cap": "36013",
            "cod_catastale": "G694",
            "cod_istat": "024078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2751,
            "area": "",
            "ech": 0
        },
        {
            "id": 5273,
            "name": "Piovera",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "G695",
            "cod_istat": "006130",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2554,
            "area": "",
            "ech": 0
        },
        {
            "id": 5274,
            "name": "Piozzano",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "G696",
            "cod_istat": "033034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 5275,
            "name": "Piozzo",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "G697",
            "cod_istat": "004169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2721,
            "area": "",
            "ech": 0
        },
        {
            "id": 5276,
            "name": "Piraino",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "G699",
            "cod_istat": "083068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 1336,
            "area": "",
            "ech": 1
        },
        {
            "id": 5277,
            "name": "Pisa",
            "provincia": "PI",
            "cap": "561xx",
            "cod_catastale": "G702",
            "cod_istat": "050026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1694,
            "area": "",
            "ech": 0
        },
        {
            "id": 5278,
            "name": "Pisano",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "G703",
            "cod_istat": "003119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 5279,
            "name": "Piscina",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G705",
            "cod_istat": "001195",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 5280,
            "name": "Piscinas",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "M291",
            "cod_istat": "111056",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 844,
            "area": "",
            "ech": 1
        },
        {
            "id": 5281,
            "name": "Pisciotta",
            "provincia": "SA",
            "cap": "84066",
            "cod_catastale": "G707",
            "cod_istat": "065096",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 170,
            "giorni": 1257,
            "area": "",
            "ech": 0
        },
        {
            "id": 5282,
            "name": "Pisogne",
            "provincia": "BS",
            "cap": "25055",
            "cod_catastale": "G710",
            "cod_istat": "017143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 5283,
            "name": "Pisoniano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "G704",
            "cod_istat": "058077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 532,
            "giorni": 2280,
            "area": "",
            "ech": 0
        },
        {
            "id": 5284,
            "name": "Pisticci",
            "provincia": "MT",
            "cap": "75015",
            "cod_catastale": "G712",
            "cod_istat": "077020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 1615,
            "area": "",
            "ech": 0
        },
        {
            "id": 5285,
            "name": "Pistoia",
            "provincia": "PT",
            "cap": "51100",
            "cod_catastale": "G713",
            "cod_istat": "047014",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 1885,
            "area": "",
            "ech": 0
        },
        {
            "id": 5286,
            "name": "Piteglio",
            "provincia": "PT",
            "cap": "51020",
            "cod_catastale": "G715",
            "cod_istat": "047015",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 698,
            "giorni": 2933,
            "area": "",
            "ech": 0
        },
        {
            "id": 5287,
            "name": "Pitigliano",
            "provincia": "GR",
            "cap": "58017",
            "cod_catastale": "G716",
            "cod_istat": "053019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2195,
            "area": "",
            "ech": 0
        },
        {
            "id": 5288,
            "name": "Piubega",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "G717",
            "cod_istat": "020041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5289,
            "name": "Piuro",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "G718",
            "cod_istat": "014050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 5290,
            "name": "Piverone",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "G719",
            "cod_istat": "001196",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2728,
            "area": "",
            "ech": 0
        },
        {
            "id": 5291,
            "name": "Pizzale",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "G720",
            "cod_istat": "018116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5292,
            "name": "Pizzighettone",
            "provincia": "CR",
            "cap": "26026",
            "cod_catastale": "G721",
            "cod_istat": "019076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 5293,
            "name": "Pizzo",
            "provincia": "VV",
            "cap": "89812",
            "cod_catastale": "G722",
            "cod_istat": "102027",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 880,
            "area": "",
            "ech": 0
        },
        {
            "id": 5294,
            "name": "Pizzoferrato",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "G724",
            "cod_istat": "069066",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1251,
            "giorni": 3073,
            "area": "",
            "ech": 0
        },
        {
            "id": 5295,
            "name": "Pizzoli",
            "provincia": "AQ",
            "cap": "67017",
            "cod_catastale": "G726",
            "cod_istat": "066072",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 5296,
            "name": "Pizzone",
            "provincia": "IS",
            "cap": "86071",
            "cod_catastale": "G727",
            "cod_istat": "094036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 5297,
            "name": "Pizzoni",
            "provincia": "VV",
            "cap": "89834",
            "cod_catastale": "G728",
            "cod_istat": "102028",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 290,
            "giorni": 1358,
            "area": "",
            "ech": 0
        },
        {
            "id": 5298,
            "name": "Placanica",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "G729",
            "cod_istat": "080059",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 240,
            "giorni": 863,
            "area": "",
            "ech": 1
        },
        {
            "id": 5299,
            "name": "Plataci",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "G733",
            "cod_istat": "078100",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 930,
            "giorni": 2656,
            "area": "",
            "ech": 0
        },
        {
            "id": 5300,
            "name": "Platania",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "G734",
            "cod_istat": "079099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 5301,
            "name": "Platì",
            "provincia": "RC",
            "cap": "89039",
            "cod_catastale": "G735",
            "cod_istat": "080060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1111,
            "area": "",
            "ech": 0
        },
        {
            "id": 5302,
            "name": "Plaus",
            "provincia": "BZ",
            "cap": "39025",
            "cod_catastale": "G299",
            "cod_istat": "021064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 519,
            "giorni": 3134,
            "area": "",
            "ech": 0
        },
        {
            "id": 5303,
            "name": "Plesio",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "G737",
            "cod_istat": "013185",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 595,
            "giorni": 2880,
            "area": "",
            "ech": 0
        },
        {
            "id": 5304,
            "name": "Ploaghe",
            "provincia": "SS",
            "cap": "07017",
            "cod_catastale": "G740",
            "cod_istat": "090057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 1701,
            "area": "",
            "ech": 0
        },
        {
            "id": 5305,
            "name": "Plodio",
            "provincia": "SV",
            "cap": "17043",
            "cod_catastale": "G741",
            "cod_istat": "009050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 498,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 5306,
            "name": "Pocapaglia",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "G742",
            "cod_istat": "004170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 5307,
            "name": "Pocenia",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "G743",
            "cod_istat": "030075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2406,
            "area": "",
            "ech": 0
        },
        {
            "id": 5308,
            "name": "Podenzana",
            "provincia": "MS",
            "cap": "54010",
            "cod_catastale": "G746",
            "cod_istat": "045013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 2280,
            "area": "",
            "ech": 0
        },
        {
            "id": 5309,
            "name": "Podenzano",
            "provincia": "PC",
            "cap": "29027",
            "cod_catastale": "G747",
            "cod_istat": "033035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 5310,
            "name": "Pofi",
            "provincia": "FR",
            "cap": "03026",
            "cod_catastale": "G749",
            "cod_istat": "060055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 283,
            "giorni": 2158,
            "area": "",
            "ech": 0
        },
        {
            "id": 5311,
            "name": "Poggiardo",
            "provincia": "LE",
            "cap": "73037",
            "cod_catastale": "G751",
            "cod_istat": "075061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 1229,
            "area": "",
            "ech": 0
        },
        {
            "id": 5312,
            "name": "Poggibonsi",
            "provincia": "SI",
            "cap": "53036",
            "cod_catastale": "G752",
            "cod_istat": "052022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 1984,
            "area": "",
            "ech": 0
        },
        {
            "id": 5313,
            "name": "Poggio a Caiano",
            "provincia": "PO",
            "cap": "59016",
            "cod_catastale": "G754",
            "cod_istat": "100004",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 1732,
            "area": "",
            "ech": 0
        },
        {
            "id": 5314,
            "name": "Poggio Berni",
            "provincia": "RN",
            "cap": "47824",
            "cod_catastale": "G755",
            "cod_istat": "099012",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 2351,
            "area": "",
            "ech": 0
        },
        {
            "id": 5315,
            "name": "Poggio Bustone",
            "provincia": "RI",
            "cap": "02018",
            "cod_catastale": "G756",
            "cod_istat": "057051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 756,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 5316,
            "name": "Poggio Catino",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "G757",
            "cod_istat": "057052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 387,
            "giorni": 2069,
            "area": "",
            "ech": 0
        },
        {
            "id": 5317,
            "name": "Poggio Imperiale",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "G761",
            "cod_istat": "071040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 1401,
            "area": "",
            "ech": 0
        },
        {
            "id": 5318,
            "name": "Poggio Mirteto",
            "provincia": "RI",
            "cap": "02047",
            "cod_catastale": "G763",
            "cod_istat": "057053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 1901,
            "area": "",
            "ech": 0
        },
        {
            "id": 5319,
            "name": "Poggio Moiano",
            "provincia": "RI",
            "cap": "02037",
            "cod_catastale": "G764",
            "cod_istat": "057054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2311,
            "area": "",
            "ech": 0
        },
        {
            "id": 5320,
            "name": "Poggio Nativo",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "G765",
            "cod_istat": "057055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 2120,
            "area": "",
            "ech": 0
        },
        {
            "id": 5321,
            "name": "Poggio Picenze",
            "provincia": "AQ",
            "cap": "67026",
            "cod_catastale": "G766",
            "cod_istat": "066073",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 756,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 5322,
            "name": "Poggio Renatico",
            "provincia": "FE",
            "cap": "44028",
            "cod_catastale": "G768",
            "cod_istat": "038018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2280,
            "area": "",
            "ech": 0
        },
        {
            "id": 5323,
            "name": "Poggio Rusco",
            "provincia": "MN",
            "cap": "46025",
            "cod_catastale": "G753",
            "cod_istat": "020042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 5324,
            "name": "Poggio San Lorenzo",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "G770",
            "cod_istat": "057056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 494,
            "giorni": 2183,
            "area": "",
            "ech": 0
        },
        {
            "id": 5325,
            "name": "Poggio San Marcello",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "G771",
            "cod_istat": "042037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2196,
            "area": "",
            "ech": 0
        },
        {
            "id": 5326,
            "name": "Poggio San Vicino",
            "provincia": "MC",
            "cap": "62021",
            "cod_catastale": "D566",
            "cod_istat": "043040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 509,
            "giorni": 2235,
            "area": "",
            "ech": 0
        },
        {
            "id": 5327,
            "name": "Poggio Sannita",
            "provincia": "IS",
            "cap": "86086",
            "cod_catastale": "B317",
            "cod_istat": "094037",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 705,
            "giorni": 2345,
            "area": "",
            "ech": 0
        },
        {
            "id": 5328,
            "name": "Poggiodomo",
            "provincia": "PG",
            "cap": "06040",
            "cod_catastale": "G758",
            "cod_istat": "054042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 974,
            "giorni": 2910,
            "area": "",
            "ech": 0
        },
        {
            "id": 5329,
            "name": "Poggiofiorito",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "G760",
            "cod_istat": "069067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 1689,
            "area": "",
            "ech": 0
        },
        {
            "id": 5330,
            "name": "Poggiomarino",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "G762",
            "cod_istat": "063055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 1166,
            "area": "",
            "ech": 0
        },
        {
            "id": 5331,
            "name": "Poggioreale",
            "provincia": "TP",
            "cap": "91020",
            "cod_catastale": "G767",
            "cod_istat": "081016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 5332,
            "name": "Poggiorsini",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "G769",
            "cod_istat": "072034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1820,
            "area": "",
            "ech": 0
        },
        {
            "id": 5333,
            "name": "Poggiridenti",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "G431",
            "cod_istat": "014051",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 564,
            "giorni": 3039,
            "area": "",
            "ech": 0
        },
        {
            "id": 5334,
            "name": "Pogliano Milanese",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "G772",
            "cod_istat": "015176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 164,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 5335,
            "name": "Pognana Lario",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "G773",
            "cod_istat": "013186",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 5336,
            "name": "Pognano",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "G774",
            "cod_istat": "016167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5337,
            "name": "Pogno",
            "provincia": "NO",
            "cap": "28076",
            "cod_catastale": "G775",
            "cod_istat": "003120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2869,
            "area": "",
            "ech": 0
        },
        {
            "id": 5338,
            "name": "Poirino",
            "provincia": "TO",
            "cap": "10046",
            "cod_catastale": "G777",
            "cod_istat": "001197",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 5339,
            "name": "Pojana Maggiore",
            "provincia": "VI",
            "cap": "36026",
            "cod_catastale": "G776",
            "cod_istat": "024079",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5340,
            "name": "Polaveno",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "G779",
            "cod_istat": "017144",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 568,
            "giorni": 3084,
            "area": "",
            "ech": 0
        },
        {
            "id": 5341,
            "name": "Polcenigo",
            "provincia": "PN",
            "cap": "33070",
            "cod_catastale": "G780",
            "cod_istat": "093031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2461,
            "area": "",
            "ech": 0
        },
        {
            "id": 5342,
            "name": "Polesella",
            "provincia": "RO",
            "cap": "45038",
            "cod_catastale": "G782",
            "cod_istat": "029037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 5343,
            "name": "Polesine Parmense",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "G783",
            "cod_istat": "034029",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 5344,
            "name": "Poli",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "G784",
            "cod_istat": "058078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 435,
            "giorni": 2121,
            "area": "",
            "ech": 0
        },
        {
            "id": 5345,
            "name": "Polia",
            "provincia": "VV",
            "cap": "89813",
            "cod_catastale": "G785",
            "cod_istat": "102029",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1500,
            "area": "",
            "ech": 1
        },
        {
            "id": 5346,
            "name": "Policoro",
            "provincia": "MT",
            "cap": "75025",
            "cod_catastale": "G786",
            "cod_istat": "077021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1137,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5347,
            "name": "Polignano a Mare",
            "provincia": "BA",
            "cap": "70044",
            "cod_catastale": "G787",
            "cod_istat": "072035",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 1088,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5348,
            "name": "Polinago",
            "provincia": "MO",
            "cap": "41040",
            "cod_catastale": "G789",
            "cod_istat": "036032",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 810,
            "giorni": 3341,
            "area": "",
            "ech": 0
        },
        {
            "id": 5349,
            "name": "Polino",
            "provincia": "TR",
            "cap": "05030",
            "cod_catastale": "G790",
            "cod_istat": "055027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 836,
            "giorni": 2886,
            "area": "",
            "ech": 0
        },
        {
            "id": 5350,
            "name": "Polistena",
            "provincia": "RC",
            "cap": "89024",
            "cod_catastale": "G791",
            "cod_istat": "080061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 1185,
            "area": "",
            "ech": 0
        },
        {
            "id": 5351,
            "name": "Polizzi Generosa",
            "provincia": "PA",
            "cap": "90028",
            "cod_catastale": "G792",
            "cod_istat": "082058",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 920,
            "giorni": 2037,
            "area": "",
            "ech": 0
        },
        {
            "id": 5352,
            "name": "Polla",
            "provincia": "SA",
            "cap": "84035",
            "cod_catastale": "G793",
            "cod_istat": "065097",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 468,
            "giorni": 1610,
            "area": "",
            "ech": 0
        },
        {
            "id": 5353,
            "name": "Pollein",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "G794",
            "cod_istat": "007049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 551,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 5354,
            "name": "Pollena Trocchia",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "G795",
            "cod_istat": "063056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 5355,
            "name": "Pollenza",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "F567",
            "cod_istat": "043041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2039,
            "area": "",
            "ech": 0
        },
        {
            "id": 5356,
            "name": "Pollica",
            "provincia": "SA",
            "cap": "84068",
            "cod_catastale": "G796",
            "cod_istat": "065098",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 370,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 5357,
            "name": "Pollina",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "G797",
            "cod_istat": "082059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 5358,
            "name": "Pollone",
            "provincia": "BI",
            "cap": "13814",
            "cod_catastale": "G798",
            "cod_istat": "096046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 3123,
            "area": "",
            "ech": 0
        },
        {
            "id": 5359,
            "name": "Pollutri",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "G799",
            "cod_istat": "069068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 1505,
            "area": "",
            "ech": 0
        },
        {
            "id": 5360,
            "name": "Polonghera",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "G800",
            "cod_istat": "004171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5361,
            "name": "Polpenazze del Garda",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "G801",
            "cod_istat": "017145",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2520,
            "area": "",
            "ech": 0
        },
        {
            "id": 5362,
            "name": "Polverara",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "G802",
            "cod_istat": "028066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5363,
            "name": "Polverigi",
            "provincia": "AN",
            "cap": "60020",
            "cod_catastale": "G803",
            "cod_istat": "042038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1876,
            "area": "",
            "ech": 0
        },
        {
            "id": 5364,
            "name": "Pomarance",
            "provincia": "PI",
            "cap": "56045",
            "cod_catastale": "G804",
            "cod_istat": "050027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 1874,
            "area": "",
            "ech": 0
        },
        {
            "id": 5365,
            "name": "Pomaretto",
            "provincia": "TO",
            "cap": "10063",
            "cod_catastale": "G805",
            "cod_istat": "001198",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 3299,
            "area": "",
            "ech": 0
        },
        {
            "id": 5366,
            "name": "Pomarico",
            "provincia": "MT",
            "cap": "75016",
            "cod_catastale": "G806",
            "cod_istat": "077022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 454,
            "giorni": 1753,
            "area": "",
            "ech": 0
        },
        {
            "id": 5367,
            "name": "Pomaro Monferrato",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "G807",
            "cod_istat": "006131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 142,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 5368,
            "name": "Pomarolo",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "G808",
            "cod_istat": "022144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2716,
            "area": "",
            "ech": 0
        },
        {
            "id": 5369,
            "name": "Pombia",
            "provincia": "NO",
            "cap": "28050",
            "cod_catastale": "G809",
            "cod_istat": "003121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 2676,
            "area": "",
            "ech": 0
        },
        {
            "id": 5370,
            "name": "Pomezia",
            "provincia": "RM",
            "cap": "00071",
            "cod_catastale": "G811",
            "cod_istat": "058079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1536,
            "area": "",
            "ech": 0
        },
        {
            "id": 5371,
            "name": "Pomigliano d'Arco",
            "provincia": "NA",
            "cap": "80038",
            "cod_catastale": "G812",
            "cod_istat": "063057",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 1127,
            "area": "",
            "ech": 0
        },
        {
            "id": 5372,
            "name": "Pompei",
            "provincia": "NA",
            "cap": "80045",
            "cod_catastale": "G813",
            "cod_istat": "063058",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 1131,
            "area": "",
            "ech": 0
        },
        {
            "id": 5373,
            "name": "Pompeiana",
            "provincia": "IM",
            "cap": "18015",
            "cod_catastale": "G814",
            "cod_istat": "008044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1566,
            "area": "",
            "ech": 0
        },
        {
            "id": 5374,
            "name": "Pompiano",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "G815",
            "cod_istat": "017146",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 5375,
            "name": "Pomponesco",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "G816",
            "cod_istat": "020043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 5376,
            "name": "Pompu",
            "provincia": "OR",
            "cap": "09093",
            "cod_catastale": "G817",
            "cod_istat": "095042",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 147,
            "giorni": 1144,
            "area": "",
            "ech": 0
        },
        {
            "id": 5377,
            "name": "Poncarale",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "G818",
            "cod_istat": "017147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 5378,
            "name": "Ponderano",
            "provincia": "BI",
            "cap": "13875",
            "cod_catastale": "G820",
            "cod_istat": "096047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2691,
            "area": "",
            "ech": 0
        },
        {
            "id": 5379,
            "name": "Ponna",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "G821",
            "cod_istat": "013187",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 3305,
            "area": "",
            "ech": 0
        },
        {
            "id": 5380,
            "name": "Ponsacco",
            "provincia": "PI",
            "cap": "56038",
            "cod_catastale": "G822",
            "cod_istat": "050028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 1874,
            "area": "",
            "ech": 0
        },
        {
            "id": 5381,
            "name": "Ponso",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "G823",
            "cod_istat": "028067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 5382,
            "name": "Pontassieve",
            "provincia": "FI",
            "cap": "50065",
            "cod_catastale": "G825",
            "cod_istat": "048033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1928,
            "area": "",
            "ech": 0
        },
        {
            "id": 5383,
            "name": "Pontboset",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "G545",
            "cod_istat": "007050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 3402,
            "area": "",
            "ech": 0
        },
        {
            "id": 5384,
            "name": "Pont-Canavese",
            "provincia": "TO",
            "cap": "10085",
            "cod_catastale": "G826",
            "cod_istat": "001199",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5385,
            "name": "Ponte",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "G827",
            "cod_istat": "062053",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 147,
            "giorni": 1338,
            "area": "",
            "ech": 0
        },
        {
            "id": 5386,
            "name": "Ponte Buggianese",
            "provincia": "PT",
            "cap": "51019",
            "cod_catastale": "G833",
            "cod_istat": "047016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 1691,
            "area": "",
            "ech": 0
        },
        {
            "id": 5387,
            "name": "Ponte dell'Olio",
            "provincia": "PC",
            "cap": "29028",
            "cod_catastale": "G842",
            "cod_istat": "033036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 5388,
            "name": "Ponte di Legno",
            "provincia": "BS",
            "cap": "25056",
            "cod_catastale": "G844",
            "cod_istat": "017148",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1257,
            "giorni": 4007,
            "area": "",
            "ech": 0
        },
        {
            "id": 5389,
            "name": "Ponte di Piave",
            "provincia": "TV",
            "cap": "31047",
            "cod_catastale": "G846",
            "cod_istat": "026058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 5390,
            "name": "Ponte Gardena",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "G830",
            "cod_istat": "021065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 3202,
            "area": "",
            "ech": 0
        },
        {
            "id": 5391,
            "name": "Ponte in Valtellina",
            "provincia": "SO",
            "cap": "23026",
            "cod_catastale": "G829",
            "cod_istat": "014052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 5392,
            "name": "Ponte Lambro",
            "provincia": "CO",
            "cap": "22037",
            "cod_catastale": "G847",
            "cod_istat": "013188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 5393,
            "name": "Ponte nelle Alpi",
            "provincia": "BL",
            "cap": "32014",
            "cod_catastale": "B662",
            "cod_istat": "025040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 392,
            "giorni": 3048,
            "area": "",
            "ech": 0
        },
        {
            "id": 5394,
            "name": "Ponte Nizza",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "G851",
            "cod_istat": "018117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 5395,
            "name": "Ponte Nossa",
            "provincia": "BG",
            "cap": "24028",
            "cod_catastale": "F941",
            "cod_istat": "016168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 2730,
            "area": "",
            "ech": 0
        },
        {
            "id": 5396,
            "name": "Ponte San Nicolò",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "G855",
            "cod_istat": "028069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5397,
            "name": "Ponte San Pietro",
            "provincia": "BG",
            "cap": "24036",
            "cod_catastale": "G856",
            "cod_istat": "016170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 5398,
            "name": "Pontebba",
            "provincia": "UD",
            "cap": "33016",
            "cod_catastale": "G831",
            "cod_istat": "030076",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 568,
            "giorni": 3627,
            "area": "",
            "ech": 0
        },
        {
            "id": 5399,
            "name": "Pontecagnano Faiano",
            "provincia": "SA",
            "cap": "84098",
            "cod_catastale": "G834",
            "cod_istat": "065099",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1011,
            "area": "",
            "ech": 0
        },
        {
            "id": 5400,
            "name": "Pontecchio Polesine",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "G836",
            "cod_istat": "029038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 5401,
            "name": "Pontechianale",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "G837",
            "cod_istat": "004172",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1614,
            "giorni": 4316,
            "area": "",
            "ech": 0
        },
        {
            "id": 5402,
            "name": "Pontecorvo",
            "provincia": "FR",
            "cap": "03037",
            "cod_catastale": "G838",
            "cod_istat": "060056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1200,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 5403,
            "name": "Pontecurone",
            "provincia": "AL",
            "cap": "15055",
            "cod_catastale": "G839",
            "cod_istat": "006132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 5404,
            "name": "Pontedassio",
            "provincia": "IM",
            "cap": "18027",
            "cod_catastale": "G840",
            "cod_istat": "008045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1354,
            "area": "",
            "ech": 0
        },
        {
            "id": 5405,
            "name": "Pontedera",
            "provincia": "PI",
            "cap": "56025",
            "cod_catastale": "G843",
            "cod_istat": "050029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 1861,
            "area": "",
            "ech": 0
        },
        {
            "id": 5406,
            "name": "Pontelandolfo",
            "provincia": "BN",
            "cap": "82027",
            "cod_catastale": "G848",
            "cod_istat": "062054",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 510,
            "giorni": 1998,
            "area": "",
            "ech": 0
        },
        {
            "id": 5407,
            "name": "Pontelatone",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "G849",
            "cod_istat": "061061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1283,
            "area": "",
            "ech": 0
        },
        {
            "id": 5408,
            "name": "Pontelongo",
            "provincia": "PD",
            "cap": "35029",
            "cod_catastale": "G850",
            "cod_istat": "028068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 5409,
            "name": "Pontenure",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "G852",
            "cod_istat": "033037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2670,
            "area": "",
            "ech": 0
        },
        {
            "id": 5410,
            "name": "Ponteranica",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "G853",
            "cod_istat": "016169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 5411,
            "name": "Pontestura",
            "provincia": "AL",
            "cap": "15027",
            "cod_catastale": "G858",
            "cod_istat": "006133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2835,
            "area": "",
            "ech": 0
        },
        {
            "id": 5412,
            "name": "Pontevico",
            "provincia": "BS",
            "cap": "25026",
            "cod_catastale": "G859",
            "cod_istat": "017149",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5413,
            "name": "Pontey",
            "provincia": "AO",
            "cap": "11024",
            "cod_catastale": "G860",
            "cod_istat": "007051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 2971,
            "area": "",
            "ech": 0
        },
        {
            "id": 5414,
            "name": "Ponti",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "G861",
            "cod_istat": "006134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 5415,
            "name": "Ponti sul Mincio",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "G862",
            "cod_istat": "020044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 5416,
            "name": "Pontida",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "G864",
            "cod_istat": "016171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 5417,
            "name": "Pontinia",
            "provincia": "LT",
            "cap": "04014",
            "cod_catastale": "G865",
            "cod_istat": "059017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1165,
            "area": "",
            "ech": 0
        },
        {
            "id": 5418,
            "name": "Pontinvrea",
            "provincia": "SV",
            "cap": "17042",
            "cod_catastale": "G866",
            "cod_istat": "009051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2325,
            "area": "",
            "ech": 0
        },
        {
            "id": 5419,
            "name": "Pontirolo Nuovo",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "G867",
            "cod_istat": "016172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 5420,
            "name": "Pontoglio",
            "provincia": "BS",
            "cap": "25037",
            "cod_catastale": "G869",
            "cod_istat": "017150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5421,
            "name": "Pontremoli",
            "provincia": "MS",
            "cap": "54027",
            "cod_catastale": "G870",
            "cod_istat": "045014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2166,
            "area": "",
            "ech": 0
        },
        {
            "id": 5422,
            "name": "Pont-Saint-Martin",
            "provincia": "AO",
            "cap": "11026",
            "cod_catastale": "G854",
            "cod_istat": "007052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2735,
            "area": "",
            "ech": 0
        },
        {
            "id": 5423,
            "name": "Ponza",
            "provincia": "LT",
            "cap": "04027",
            "cod_catastale": "G871",
            "cod_istat": "059018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1092,
            "area": "",
            "ech": 0
        },
        {
            "id": 5424,
            "name": "Ponzano di Fermo",
            "provincia": "FM",
            "cap": "63845",
            "cod_catastale": "G873",
            "cod_istat": "109032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 1872,
            "area": "",
            "ech": 0
        },
        {
            "id": 5425,
            "name": "Ponzano Monferrato",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "G872",
            "cod_istat": "006135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2806,
            "area": "",
            "ech": 0
        },
        {
            "id": 5426,
            "name": "Ponzano Romano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "G874",
            "cod_istat": "058080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 1828,
            "area": "",
            "ech": 0
        },
        {
            "id": 5427,
            "name": "Ponzano Veneto",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "G875",
            "cod_istat": "026059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 5428,
            "name": "Ponzone",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "G877",
            "cod_istat": "006136",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 629,
            "giorni": 3010,
            "area": "",
            "ech": 0
        },
        {
            "id": 5429,
            "name": "Popoli",
            "provincia": "PE",
            "cap": "65026",
            "cod_catastale": "G878",
            "cod_istat": "068033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 1653,
            "area": "",
            "ech": 0
        },
        {
            "id": 5430,
            "name": "Poppi",
            "provincia": "AR",
            "cap": "52014",
            "cod_catastale": "G879",
            "cod_istat": "051031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 437,
            "giorni": 2306,
            "area": "",
            "ech": 0
        },
        {
            "id": 5431,
            "name": "Porano",
            "provincia": "TR",
            "cap": "05010",
            "cod_catastale": "G881",
            "cod_istat": "055028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 2173,
            "area": "",
            "ech": 0
        },
        {
            "id": 5432,
            "name": "Porcari",
            "provincia": "LU",
            "cap": "55016",
            "cod_catastale": "G882",
            "cod_istat": "046026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 1676,
            "area": "",
            "ech": 0
        },
        {
            "id": 5433,
            "name": "Porcia",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "G886",
            "cod_istat": "093032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 5434,
            "name": "Pordenone",
            "provincia": "PN",
            "cap": "33170",
            "cod_catastale": "G888",
            "cod_istat": "093033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 5435,
            "name": "Porlezza",
            "provincia": "CO",
            "cap": "22018",
            "cod_catastale": "G889",
            "cod_istat": "013189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 5436,
            "name": "Pornassio",
            "provincia": "IM",
            "cap": "18024",
            "cod_catastale": "G890",
            "cod_istat": "008046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2866,
            "area": "",
            "ech": 0
        },
        {
            "id": 5437,
            "name": "Porpetto",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "G891",
            "cod_istat": "030077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2180,
            "area": "",
            "ech": 0
        },
        {
            "id": 5438,
            "name": "Porretta Terme",
            "provincia": "BO",
            "cap": "40046",
            "cod_catastale": "A558",
            "cod_istat": "037049",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2648,
            "area": "",
            "ech": 0
        },
        {
            "id": 5439,
            "name": "Portacomaro",
            "provincia": "AT",
            "cap": "14037",
            "cod_catastale": "G894",
            "cod_istat": "005087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2708,
            "area": "",
            "ech": 0
        },
        {
            "id": 5440,
            "name": "Portalbera",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "G895",
            "cod_istat": "018118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 5441,
            "name": "Porte",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G900",
            "cod_istat": "001200",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 436,
            "giorni": 2902,
            "area": "",
            "ech": 0
        },
        {
            "id": 5442,
            "name": "Portici",
            "provincia": "NA",
            "cap": "80055",
            "cod_catastale": "G902",
            "cod_istat": "063059",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 1028,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 5443,
            "name": "Portico di Caserta",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "G903",
            "cod_istat": "061062",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 1127,
            "area": "",
            "ech": 0
        },
        {
            "id": 5444,
            "name": "Portico e San Benedetto",
            "provincia": "FC",
            "cap": "47010",
            "cod_catastale": "G904",
            "cod_istat": "040031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 5445,
            "name": "Portigliola",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "G905",
            "cod_istat": "080062",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 970,
            "area": "",
            "ech": 0
        },
        {
            "id": 5446,
            "name": "Porto Azzurro",
            "provincia": "LI",
            "cap": "57036",
            "cod_catastale": "E680",
            "cod_istat": "049013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1023,
            "area": "",
            "ech": 0
        },
        {
            "id": 5447,
            "name": "Porto Ceresio",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "G906",
            "cod_istat": "012113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2512,
            "area": "",
            "ech": 0
        },
        {
            "id": 5448,
            "name": "Porto Cesareo",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "M263",
            "cod_istat": "075097",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 1154,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5449,
            "name": "Porto Empedocle",
            "provincia": "AG",
            "cap": "92014",
            "cod_catastale": "F299",
            "cod_istat": "084028",
            "attivo": 1,
            "zona": "A",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 579,
            "area": "",
            "ech": 1
        },
        {
            "id": 5450,
            "name": "Porto Mantovano",
            "provincia": "MN",
            "cap": "46047",
            "cod_catastale": "G917",
            "cod_istat": "020045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5451,
            "name": "Porto Recanati",
            "provincia": "MC",
            "cap": "62017",
            "cod_catastale": "G919",
            "cod_istat": "043042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1647,
            "area": "",
            "ech": 0
        },
        {
            "id": 5452,
            "name": "Porto San Giorgio",
            "provincia": "FM",
            "cap": "63822",
            "cod_catastale": "G920",
            "cod_istat": "109033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1644,
            "area": "",
            "ech": 0
        },
        {
            "id": 5453,
            "name": "Porto Sant'Elpidio",
            "provincia": "FM",
            "cap": "63821",
            "cod_catastale": "G921",
            "cod_istat": "109034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1644,
            "area": "",
            "ech": 0
        },
        {
            "id": 5454,
            "name": "Porto Tolle",
            "provincia": "RO",
            "cap": "45018",
            "cod_catastale": "G923",
            "cod_istat": "029039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 5455,
            "name": "Porto Torres",
            "provincia": "SS",
            "cap": "07046",
            "cod_catastale": "G924",
            "cod_istat": "090058",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 948,
            "area": "",
            "ech": 0
        },
        {
            "id": 5456,
            "name": "Porto Valtravaglia",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "G907",
            "cod_istat": "012114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2425,
            "area": "",
            "ech": 0
        },
        {
            "id": 5457,
            "name": "Porto Viro",
            "provincia": "RO",
            "cap": "45014",
            "cod_catastale": "G926",
            "cod_istat": "029052",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5458,
            "name": "Portobuffolè",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "G909",
            "cod_istat": "026060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 5459,
            "name": "Portocannone",
            "provincia": "CB",
            "cap": "86045",
            "cod_catastale": "G910",
            "cod_istat": "070055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 1484,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5460,
            "name": "Portoferraio",
            "provincia": "LI",
            "cap": "57037",
            "cod_catastale": "G912",
            "cod_istat": "049014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1025,
            "area": "",
            "ech": 0
        },
        {
            "id": 5461,
            "name": "Portofino",
            "provincia": "GE",
            "cap": "16034",
            "cod_catastale": "G913",
            "cod_istat": "010044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1414,
            "area": "",
            "ech": 0
        },
        {
            "id": 5462,
            "name": "Portogruaro",
            "provincia": "VE",
            "cap": "30026",
            "cod_catastale": "G914",
            "cod_istat": "027029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 5463,
            "name": "Portomaggiore",
            "provincia": "FE",
            "cap": "44015",
            "cod_catastale": "G916",
            "cod_istat": "038019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 5464,
            "name": "Portopalo di Capo Passero",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "M257",
            "cod_istat": "089020",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 728,
            "area": "",
            "ech": 1
        },
        {
            "id": 5465,
            "name": "Portoscuso",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "G922",
            "cod_istat": "111057",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 794,
            "area": "",
            "ech": 0
        },
        {
            "id": 5466,
            "name": "Portovenere",
            "provincia": "SP",
            "cap": "19025",
            "cod_catastale": "G925",
            "cod_istat": "011022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 1454,
            "area": "",
            "ech": 0
        },
        {
            "id": 5467,
            "name": "Portula",
            "provincia": "BI",
            "cap": "13833",
            "cod_catastale": "G927",
            "cod_istat": "096048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 634,
            "giorni": 3129,
            "area": "",
            "ech": 0
        },
        {
            "id": 5468,
            "name": "Posada",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "G929",
            "cod_istat": "091073",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 892,
            "area": "",
            "ech": 1
        },
        {
            "id": 5469,
            "name": "Posina",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "G931",
            "cod_istat": "024080",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 554,
            "giorni": 3159,
            "area": "",
            "ech": 0
        },
        {
            "id": 5470,
            "name": "Positano",
            "provincia": "SA",
            "cap": "84017",
            "cod_catastale": "G932",
            "cod_istat": "065100",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1052,
            "area": "",
            "ech": 0
        },
        {
            "id": 5471,
            "name": "Possagno",
            "provincia": "TV",
            "cap": "31054",
            "cod_catastale": "G933",
            "cod_istat": "026061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2820,
            "area": "",
            "ech": 0
        },
        {
            "id": 5472,
            "name": "Posta",
            "provincia": "RI",
            "cap": "02019",
            "cod_catastale": "G934",
            "cod_istat": "057057",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 721,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 5473,
            "name": "Posta Fibreno",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "G935",
            "cod_istat": "060057",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1859,
            "area": "",
            "ech": 0
        },
        {
            "id": 5474,
            "name": "Postal",
            "provincia": "BZ",
            "cap": "39014",
            "cod_catastale": "G936",
            "cod_istat": "021066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2831,
            "area": "",
            "ech": 0
        },
        {
            "id": 5475,
            "name": "Postalesio",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "G937",
            "cod_istat": "014053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 3011,
            "area": "",
            "ech": 0
        },
        {
            "id": 5476,
            "name": "Postiglione",
            "provincia": "SA",
            "cap": "84026",
            "cod_catastale": "G939",
            "cod_istat": "065101",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 605,
            "giorni": 2037,
            "area": "",
            "ech": 0
        },
        {
            "id": 5477,
            "name": "Postua",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "G940",
            "cod_istat": "002102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 2867,
            "area": "",
            "ech": 0
        },
        {
            "id": 5478,
            "name": "Potenza",
            "provincia": "PZ",
            "cap": "85100",
            "cod_catastale": "G942",
            "cod_istat": "076063",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 819,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 5479,
            "name": "Potenza Picena",
            "provincia": "MC",
            "cap": "62018",
            "cod_catastale": "F632",
            "cod_istat": "043043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 1917,
            "area": "",
            "ech": 0
        },
        {
            "id": 5480,
            "name": "Pove del Grappa",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "G943",
            "cod_istat": "024081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 163,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 5481,
            "name": "Povegliano",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "G944",
            "cod_istat": "026062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 5482,
            "name": "Povegliano Veronese",
            "provincia": "VR",
            "cap": "37064",
            "cod_catastale": "G945",
            "cod_istat": "023060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2492,
            "area": "",
            "ech": 0
        },
        {
            "id": 5483,
            "name": "Poviglio",
            "provincia": "RE",
            "cap": "42028",
            "cod_catastale": "G947",
            "cod_istat": "035029",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2443,
            "area": "",
            "ech": 0
        },
        {
            "id": 5484,
            "name": "Povoletto",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "G949",
            "cod_istat": "030078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 5485,
            "name": "Pozza di Fassa",
            "provincia": "TN",
            "cap": "38036",
            "cod_catastale": "G950",
            "cod_istat": "022145",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1325,
            "giorni": 4700,
            "area": "",
            "ech": 0
        },
        {
            "id": 5486,
            "name": "Pozzaglia Sabina",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "G951",
            "cod_istat": "057058",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5487,
            "name": "Pozzaglio ed Uniti",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "B914",
            "cod_istat": "019077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5488,
            "name": "Pozzallo",
            "provincia": "RG",
            "cap": "97016",
            "cod_catastale": "G953",
            "cod_istat": "088008",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 800,
            "area": "",
            "ech": 1
        },
        {
            "id": 5489,
            "name": "Pozzilli",
            "provincia": "IS",
            "cap": "86077",
            "cod_catastale": "G954",
            "cod_istat": "094038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 1513,
            "area": "",
            "ech": 0
        },
        {
            "id": 5490,
            "name": "Pozzo d'Adda",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "G955",
            "cod_istat": "015177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 164,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 5491,
            "name": "Pozzol Groppo",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "G960",
            "cod_istat": "006137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 5492,
            "name": "Pozzolengo",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "G959",
            "cod_istat": "017151",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 5493,
            "name": "Pozzoleone",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "G957",
            "cod_istat": "024082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 5494,
            "name": "Pozzolo Formigaro",
            "provincia": "AL",
            "cap": "15068",
            "cod_catastale": "G961",
            "cod_istat": "006138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 5495,
            "name": "Pozzomaggiore",
            "provincia": "SS",
            "cap": "07018",
            "cod_catastale": "G962",
            "cod_istat": "090059",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 438,
            "giorni": 1748,
            "area": "",
            "ech": 0
        },
        {
            "id": 5496,
            "name": "Pozzonovo",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "G963",
            "cod_istat": "028070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 5497,
            "name": "Pozzuoli",
            "provincia": "NA",
            "cap": "80078",
            "cod_catastale": "G964",
            "cod_istat": "063060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 979,
            "area": "",
            "ech": 0
        },
        {
            "id": 5498,
            "name": "Pozzuolo del Friuli",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "G966",
            "cod_istat": "030079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2281,
            "area": "",
            "ech": 0
        },
        {
            "id": 5499,
            "name": "Pozzuolo Martesana",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "G965",
            "cod_istat": "015178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5500,
            "name": "Pradalunga",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "G968",
            "cod_istat": "016173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 5501,
            "name": "Pradamano",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "G969",
            "cod_istat": "030080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2278,
            "area": "",
            "ech": 0
        },
        {
            "id": 5502,
            "name": "Pradleves",
            "provincia": "CN",
            "cap": "12027",
            "cod_catastale": "G970",
            "cod_istat": "004173",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 822,
            "giorni": 3334,
            "area": "",
            "ech": 0
        },
        {
            "id": 5503,
            "name": "Pragelato",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G973",
            "cod_istat": "001201",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1524,
            "giorni": 4640,
            "area": "",
            "ech": 0
        },
        {
            "id": 5504,
            "name": "Praia a Mare",
            "provincia": "CS",
            "cap": "87028",
            "cod_catastale": "G975",
            "cod_istat": "078101",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 857,
            "area": "",
            "ech": 0
        },
        {
            "id": 5505,
            "name": "Praiano",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "G976",
            "cod_istat": "065102",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1165,
            "area": "",
            "ech": 0
        },
        {
            "id": 5506,
            "name": "Pralboino",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "G977",
            "cod_istat": "017152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 5507,
            "name": "Prali",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G978",
            "cod_istat": "001202",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1455,
            "giorni": 4536,
            "area": "",
            "ech": 0
        },
        {
            "id": 5508,
            "name": "Pralormo",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "G979",
            "cod_istat": "001203",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2808,
            "area": "",
            "ech": 0
        },
        {
            "id": 5509,
            "name": "Pralungo",
            "provincia": "BI",
            "cap": "13899",
            "cod_catastale": "G980",
            "cod_istat": "096049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 554,
            "giorni": 3025,
            "area": "",
            "ech": 0
        },
        {
            "id": 5510,
            "name": "Pramaggiore",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "G981",
            "cod_istat": "027030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 5511,
            "name": "Pramollo",
            "provincia": "TO",
            "cap": "10065",
            "cod_catastale": "G982",
            "cod_istat": "001204",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 678,
            "giorni": 3371,
            "area": "",
            "ech": 0
        },
        {
            "id": 5512,
            "name": "Prarolo",
            "provincia": "VC",
            "cap": "13012",
            "cod_catastale": "G985",
            "cod_istat": "002104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2776,
            "area": "",
            "ech": 0
        },
        {
            "id": 5513,
            "name": "Prarostino",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "G986",
            "cod_istat": "001205",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 3352,
            "area": "",
            "ech": 0
        },
        {
            "id": 5514,
            "name": "Prasco",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "G987",
            "cod_istat": "006139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 245,
            "giorni": 2591,
            "area": "",
            "ech": 0
        },
        {
            "id": 5515,
            "name": "Prascorsano",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G988",
            "cod_istat": "001206",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 3239,
            "area": "",
            "ech": 0
        },
        {
            "id": 5516,
            "name": "Praso",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "G989",
            "cod_istat": "022146",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 785,
            "giorni": 3615,
            "area": "",
            "ech": 0
        },
        {
            "id": 5517,
            "name": "Prata Camportaccio",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "G993",
            "cod_istat": "014054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 5518,
            "name": "Prata d'Ansidonia",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "G992",
            "cod_istat": "066074",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 846,
            "giorni": 2708,
            "area": "",
            "ech": 0
        },
        {
            "id": 5519,
            "name": "Prata di Pordenone",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "G994",
            "cod_istat": "093034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 5520,
            "name": "Prata di Principato Ultra",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "G990",
            "cod_istat": "064074",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1648,
            "area": "",
            "ech": 0
        },
        {
            "id": 5521,
            "name": "Prata Sannita",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "G991",
            "cod_istat": "061063",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 333,
            "giorni": 1673,
            "area": "",
            "ech": 0
        },
        {
            "id": 5522,
            "name": "Pratella",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "G995",
            "cod_istat": "061064",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 152,
            "giorni": 1363,
            "area": "",
            "ech": 0
        },
        {
            "id": 5523,
            "name": "Pratiglione",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "G997",
            "cod_istat": "001207",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 611,
            "giorni": 3270,
            "area": "",
            "ech": 0
        },
        {
            "id": 5524,
            "name": "Prato",
            "provincia": "PO",
            "cap": "59100",
            "cod_catastale": "G999",
            "cod_istat": "100005",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 1668,
            "area": "",
            "ech": 0
        },
        {
            "id": 5525,
            "name": "Prato allo Stelvio",
            "provincia": "BZ",
            "cap": "39026",
            "cod_catastale": "H004",
            "cod_istat": "021067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 915,
            "giorni": 3779,
            "area": "",
            "ech": 0
        },
        {
            "id": 5526,
            "name": "Prato Carnico",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "H002",
            "cod_istat": "030081",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 686,
            "giorni": 3529,
            "area": "",
            "ech": 0
        },
        {
            "id": 5527,
            "name": "Prato Sesia",
            "provincia": "NO",
            "cap": "28077",
            "cod_catastale": "H001",
            "cod_istat": "003122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2518,
            "area": "",
            "ech": 0
        },
        {
            "id": 5528,
            "name": "Pratola Peligna",
            "provincia": "AQ",
            "cap": "67035",
            "cod_catastale": "H007",
            "cod_istat": "066075",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 1901,
            "area": "",
            "ech": 0
        },
        {
            "id": 5529,
            "name": "Pratola Serra",
            "provincia": "AV",
            "cap": "83039",
            "cod_catastale": "H006",
            "cod_istat": "064075",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 280,
            "giorni": 1575,
            "area": "",
            "ech": 0
        },
        {
            "id": 5530,
            "name": "Pratovecchio",
            "provincia": "AR",
            "cap": "52015",
            "cod_catastale": "H008",
            "cod_istat": "051032",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 5531,
            "name": "Pravisdomini",
            "provincia": "PN",
            "cap": "33076",
            "cod_catastale": "H010",
            "cod_istat": "093035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 5532,
            "name": "Pray",
            "provincia": "BI",
            "cap": "13867",
            "cod_catastale": "G974",
            "cod_istat": "096050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 496,
            "giorni": 2850,
            "area": "",
            "ech": 0
        },
        {
            "id": 5533,
            "name": "Prazzo",
            "provincia": "CN",
            "cap": "12028",
            "cod_catastale": "H011",
            "cod_istat": "004174",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1030,
            "giorni": 3592,
            "area": "",
            "ech": 0
        },
        {
            "id": 5534,
            "name": "Precenicco",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "H014",
            "cod_istat": "030082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 5535,
            "name": "Preci",
            "provincia": "PG",
            "cap": "06047",
            "cod_catastale": "H015",
            "cod_istat": "054043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 596,
            "giorni": 2394,
            "area": "",
            "ech": 0
        },
        {
            "id": 5536,
            "name": "Predappio",
            "provincia": "FC",
            "cap": "47016",
            "cod_catastale": "H017",
            "cod_istat": "040032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 2322,
            "area": "",
            "ech": 0
        },
        {
            "id": 5537,
            "name": "Predazzo",
            "provincia": "TN",
            "cap": "38037",
            "cod_catastale": "H018",
            "cod_istat": "022147",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1018,
            "giorni": 4295,
            "area": "",
            "ech": 0
        },
        {
            "id": 5538,
            "name": "Predoi",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "H019",
            "cod_istat": "021068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1475,
            "giorni": 4839,
            "area": "",
            "ech": 0
        },
        {
            "id": 5539,
            "name": "Predore",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "H020",
            "cod_istat": "016174",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 5540,
            "name": "Predosa",
            "provincia": "AL",
            "cap": "15077",
            "cod_catastale": "H021",
            "cod_istat": "006140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 5541,
            "name": "Preganziol",
            "provincia": "TV",
            "cap": "31022",
            "cod_catastale": "H022",
            "cod_istat": "026063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2373,
            "area": "",
            "ech": 0
        },
        {
            "id": 5542,
            "name": "Pregnana Milanese",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "H026",
            "cod_istat": "015179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 5543,
            "name": "Prelà",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "H027",
            "cod_istat": "008047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 1541,
            "area": "",
            "ech": 0
        },
        {
            "id": 5544,
            "name": "Premana",
            "provincia": "LC",
            "cap": "23834",
            "cod_catastale": "H028",
            "cod_istat": "097069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1000,
            "giorni": 3490,
            "area": "",
            "ech": 0
        },
        {
            "id": 5545,
            "name": "Premariacco",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "H029",
            "cod_istat": "030083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2321,
            "area": "",
            "ech": 0
        },
        {
            "id": 5546,
            "name": "Premeno",
            "provincia": "VB",
            "cap": "28818",
            "cod_catastale": "H030",
            "cod_istat": "103055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 840,
            "giorni": 3396,
            "area": "",
            "ech": 0
        },
        {
            "id": 5547,
            "name": "Premia",
            "provincia": "VB",
            "cap": "28866",
            "cod_catastale": "H033",
            "cod_istat": "103056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3344,
            "area": "",
            "ech": 0
        },
        {
            "id": 5548,
            "name": "Premilcuore",
            "provincia": "FC",
            "cap": "47010",
            "cod_catastale": "H034",
            "cod_istat": "040033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 5549,
            "name": "Premolo",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "H036",
            "cod_istat": "016175",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2967,
            "area": "",
            "ech": 0
        },
        {
            "id": 5550,
            "name": "Premosello-Chiovenda",
            "provincia": "VB",
            "cap": "28803",
            "cod_catastale": "H037",
            "cod_istat": "103057",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5551,
            "name": "Preone",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "H038",
            "cod_istat": "030084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 3258,
            "area": "",
            "ech": 0
        },
        {
            "id": 5552,
            "name": "Preore",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "H039",
            "cod_istat": "022148",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 3192,
            "area": "",
            "ech": 0
        },
        {
            "id": 5553,
            "name": "Prepotto",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "H040",
            "cod_istat": "030085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 5554,
            "name": "Pré-Saint-Didier",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H042",
            "cod_istat": "007053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1014,
            "giorni": 3738,
            "area": "",
            "ech": 0
        },
        {
            "id": 5555,
            "name": "Preseglie",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "H043",
            "cod_istat": "017153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2771,
            "area": "",
            "ech": 0
        },
        {
            "id": 5556,
            "name": "Presenzano",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "H045",
            "cod_istat": "061065",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 272,
            "giorni": 1592,
            "area": "",
            "ech": 0
        },
        {
            "id": 5557,
            "name": "Presezzo",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "H046",
            "cod_istat": "016176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 236,
            "giorni": 2515,
            "area": "",
            "ech": 0
        },
        {
            "id": 5558,
            "name": "Presicce",
            "provincia": "LE",
            "cap": "73054",
            "cod_catastale": "H047",
            "cod_istat": "075098",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 1332,
            "area": "",
            "ech": 0
        },
        {
            "id": 5559,
            "name": "Pressana",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "H048",
            "cod_istat": "023061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2459,
            "area": "",
            "ech": 0
        },
        {
            "id": 5560,
            "name": "Prestine",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "H050",
            "cod_istat": "017154",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 3082,
            "area": "",
            "ech": 0
        },
        {
            "id": 5561,
            "name": "Pretoro",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "H052",
            "cod_istat": "069069",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 560,
            "giorni": 2121,
            "area": "",
            "ech": 0
        },
        {
            "id": 5562,
            "name": "Prevalle",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "H055",
            "cod_istat": "017155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 5563,
            "name": "Prezza",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "H056",
            "cod_istat": "066076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 5564,
            "name": "Prezzo",
            "provincia": "TN",
            "cap": "38085",
            "cod_catastale": "H057",
            "cod_istat": "022149",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 3427,
            "area": "",
            "ech": 0
        },
        {
            "id": 5565,
            "name": "Priero",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "H059",
            "cod_istat": "004175",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2904,
            "area": "",
            "ech": 0
        },
        {
            "id": 5566,
            "name": "Prignano Cilento",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "H062",
            "cod_istat": "065103",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 410,
            "giorni": 1650,
            "area": "",
            "ech": 0
        },
        {
            "id": 5567,
            "name": "Prignano sulla Secchia",
            "provincia": "MO",
            "cap": "41048",
            "cod_catastale": "H061",
            "cod_istat": "036033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 2975,
            "area": "",
            "ech": 0
        },
        {
            "id": 5568,
            "name": "Primaluna",
            "provincia": "LC",
            "cap": "23819",
            "cod_catastale": "H063",
            "cod_istat": "097070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 558,
            "giorni": 2862,
            "area": "",
            "ech": 0
        },
        {
            "id": 5569,
            "name": "Priocca",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "H068",
            "cod_istat": "004176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2482,
            "area": "",
            "ech": 0
        },
        {
            "id": 5570,
            "name": "Priola",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "H069",
            "cod_istat": "004177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 537,
            "giorni": 2981,
            "area": "",
            "ech": 0
        },
        {
            "id": 5571,
            "name": "Priolo Gargallo",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "M279",
            "cod_istat": "089021",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 838,
            "area": "",
            "ech": 1
        },
        {
            "id": 5572,
            "name": "Priverno",
            "provincia": "LT",
            "cap": "04015",
            "cod_catastale": "G698",
            "cod_istat": "059019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 1352,
            "area": "",
            "ech": 0
        },
        {
            "id": 5573,
            "name": "Prizzi",
            "provincia": "PA",
            "cap": "90038",
            "cod_catastale": "H070",
            "cod_istat": "082060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 966,
            "giorni": 2304,
            "area": "",
            "ech": 0
        },
        {
            "id": 5574,
            "name": "Proceno",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "H071",
            "cod_istat": "056044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 418,
            "giorni": 2295,
            "area": "",
            "ech": 0
        },
        {
            "id": 5575,
            "name": "Procida",
            "provincia": "NA",
            "cap": "80079",
            "cod_catastale": "H072",
            "cod_istat": "063061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 1088,
            "area": "",
            "ech": 0
        },
        {
            "id": 5576,
            "name": "Propata",
            "provincia": "GE",
            "cap": "16027",
            "cod_catastale": "H073",
            "cod_istat": "010045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 990,
            "giorni": 3618,
            "area": "",
            "ech": 0
        },
        {
            "id": 5577,
            "name": "Proserpio",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "H074",
            "cod_istat": "013192",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2870,
            "area": "",
            "ech": 0
        },
        {
            "id": 5578,
            "name": "Prossedi",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "H076",
            "cod_istat": "059020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 1453,
            "area": "",
            "ech": 0
        },
        {
            "id": 5579,
            "name": "Provaglio d'Iseo",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "H078",
            "cod_istat": "017156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2538,
            "area": "",
            "ech": 0
        },
        {
            "id": 5580,
            "name": "Provaglio Val Sabbia",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "H077",
            "cod_istat": "017157",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 678,
            "giorni": 3179,
            "area": "",
            "ech": 0
        },
        {
            "id": 5581,
            "name": "Proves",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "H081",
            "cod_istat": "021069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1420,
            "giorni": 4747,
            "area": "",
            "ech": 0
        },
        {
            "id": 5582,
            "name": "Provvidenti",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "H083",
            "cod_istat": "070056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2087,
            "area": "",
            "ech": 0
        },
        {
            "id": 5583,
            "name": "Prunetto",
            "provincia": "CN",
            "cap": "12077",
            "cod_catastale": "H085",
            "cod_istat": "004178",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5584,
            "name": "Puegnago sul Garda",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "H086",
            "cod_istat": "017158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2530,
            "area": "",
            "ech": 0
        },
        {
            "id": 5585,
            "name": "Puglianello",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "H087",
            "cod_istat": "062055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 1181,
            "area": "",
            "ech": 0
        },
        {
            "id": 5586,
            "name": "Pula",
            "provincia": "CA",
            "cap": "09050",
            "cod_catastale": "H088",
            "cod_istat": "092050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 946,
            "area": "",
            "ech": 0
        },
        {
            "id": 5587,
            "name": "Pulfero",
            "provincia": "UD",
            "cap": "33046",
            "cod_catastale": "H089",
            "cod_istat": "030086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 184,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 5588,
            "name": "Pulsano",
            "provincia": "TA",
            "cap": "74026",
            "cod_catastale": "H090",
            "cod_istat": "073022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 1138,
            "area": "",
            "ech": 0
        },
        {
            "id": 5589,
            "name": "Pumenengo",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "H091",
            "cod_istat": "016177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 5590,
            "name": "Puos d''Alpago",
            "provincia": "BL",
            "cap": "32015",
            "cod_catastale": "H092",
            "cod_istat": "025041",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5591,
            "name": "Pusiano",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "H094",
            "cod_istat": "013193",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2444,
            "area": "",
            "ech": 0
        },
        {
            "id": 5592,
            "name": "Putifigari",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "H095",
            "cod_istat": "090060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 1423,
            "area": "",
            "ech": 0
        },
        {
            "id": 5593,
            "name": "Putignano",
            "provincia": "BA",
            "cap": "70017",
            "cod_catastale": "H096",
            "cod_istat": "072036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 1716,
            "area": "",
            "ech": 0
        },
        {
            "id": 5594,
            "name": "Quadrelle",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "H097",
            "cod_istat": "064076",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1624,
            "area": "",
            "ech": 0
        },
        {
            "id": 5595,
            "name": "Quadri",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "H098",
            "cod_istat": "069070",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 640,
            "giorni": 2096,
            "area": "",
            "ech": 0
        },
        {
            "id": 5596,
            "name": "Quagliuzzo",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H100",
            "cod_istat": "001208",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2645,
            "area": "",
            "ech": 0
        },
        {
            "id": 5597,
            "name": "Qualiano",
            "provincia": "NA",
            "cap": "80019",
            "cod_catastale": "H101",
            "cod_istat": "063062",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 1213,
            "area": "",
            "ech": 0
        },
        {
            "id": 5598,
            "name": "Quaranti",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "H102",
            "cod_istat": "005088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 5599,
            "name": "Quaregna",
            "provincia": "BI",
            "cap": "13854",
            "cod_catastale": "H103",
            "cod_istat": "096051",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 5600,
            "name": "Quargnento",
            "provincia": "AL",
            "cap": "15044",
            "cod_catastale": "H104",
            "cod_istat": "006141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 5601,
            "name": "Quarna Sopra",
            "provincia": "VB",
            "cap": "28898",
            "cod_catastale": "H106",
            "cod_istat": "103058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 860,
            "giorni": 3422,
            "area": "",
            "ech": 0
        },
        {
            "id": 5602,
            "name": "Quarna Sotto",
            "provincia": "VB",
            "cap": "28896",
            "cod_catastale": "H107",
            "cod_istat": "103059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 802,
            "giorni": 3347,
            "area": "",
            "ech": 0
        },
        {
            "id": 5603,
            "name": "Quarona",
            "provincia": "VC",
            "cap": "13017",
            "cod_catastale": "H108",
            "cod_istat": "002107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 406,
            "giorni": 2798,
            "area": "",
            "ech": 0
        },
        {
            "id": 5604,
            "name": "Quarrata",
            "provincia": "PT",
            "cap": "51039",
            "cod_catastale": "H109",
            "cod_istat": "047017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 1691,
            "area": "",
            "ech": 0
        },
        {
            "id": 5605,
            "name": "Quart",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "H110",
            "cod_istat": "007054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 535,
            "giorni": 2778,
            "area": "",
            "ech": 0
        },
        {
            "id": 5606,
            "name": "Quarto",
            "provincia": "NA",
            "cap": "80010",
            "cod_catastale": "H114",
            "cod_istat": "063063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1039,
            "area": "",
            "ech": 0
        },
        {
            "id": 5607,
            "name": "Quarto d'Altino",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "H117",
            "cod_istat": "027031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 5608,
            "name": "Quartu Sant'Elena",
            "provincia": "CA",
            "cap": "09045",
            "cod_catastale": "H118",
            "cod_istat": "092051",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 931,
            "area": "",
            "ech": 1
        },
        {
            "id": 5609,
            "name": "Quartucciu",
            "provincia": "CA",
            "cap": "09044",
            "cod_catastale": "H119",
            "cod_istat": "092105",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1003,
            "area": "",
            "ech": 1
        },
        {
            "id": 5610,
            "name": "Quassolo",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H120",
            "cod_istat": "001209",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2770,
            "area": "",
            "ech": 0
        },
        {
            "id": 5611,
            "name": "Quattordio",
            "provincia": "AL",
            "cap": "15028",
            "cod_catastale": "H121",
            "cod_istat": "006142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 5612,
            "name": "Quattro Castella",
            "provincia": "RE",
            "cap": "42020",
            "cod_catastale": "H122",
            "cod_istat": "035030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2400,
            "area": "",
            "ech": 0
        },
        {
            "id": 5613,
            "name": "Quero",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "H124",
            "cod_istat": "025070",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 288,
            "giorni": 3022,
            "area": "",
            "ech": 0
        },
        {
            "id": 5614,
            "name": "Quiliano",
            "provincia": "SV",
            "cap": "17047",
            "cod_catastale": "H126",
            "cod_istat": "009052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 1447,
            "area": "",
            "ech": 0
        },
        {
            "id": 5615,
            "name": "Quincinetto",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H127",
            "cod_istat": "001210",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 295,
            "giorni": 2643,
            "area": "",
            "ech": 0
        },
        {
            "id": 5616,
            "name": "Quindici",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "H128",
            "cod_istat": "064077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 1436,
            "area": "",
            "ech": 0
        },
        {
            "id": 5617,
            "name": "Quingentole",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "H129",
            "cod_istat": "020046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5618,
            "name": "Quintano",
            "provincia": "CR",
            "cap": "26017",
            "cod_catastale": "H130",
            "cod_istat": "019078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5619,
            "name": "Quinto di Treviso",
            "provincia": "TV",
            "cap": "31055",
            "cod_catastale": "H131",
            "cod_istat": "026064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2409,
            "area": "",
            "ech": 0
        },
        {
            "id": 5620,
            "name": "Quinto Vercellese",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "H132",
            "cod_istat": "002108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2764,
            "area": "",
            "ech": 0
        },
        {
            "id": 5621,
            "name": "Quinto Vicentino",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "H134",
            "cod_istat": "024083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 5622,
            "name": "Quinzano d'Oglio",
            "provincia": "BS",
            "cap": "25027",
            "cod_catastale": "H140",
            "cod_istat": "017159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 5623,
            "name": "Quistello",
            "provincia": "MN",
            "cap": "46026",
            "cod_catastale": "H143",
            "cod_istat": "020047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5624,
            "name": "Quittengo",
            "provincia": "BI",
            "cap": "13812",
            "cod_catastale": "H145",
            "cod_istat": "096052",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 3344,
            "area": "",
            "ech": 0
        },
        {
            "id": 5625,
            "name": "Rabbi",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "H146",
            "cod_istat": "022150",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1095,
            "giorni": 4099,
            "area": "",
            "ech": 0
        },
        {
            "id": 5626,
            "name": "Racale",
            "provincia": "LE",
            "cap": "73055",
            "cod_catastale": "H147",
            "cod_istat": "075063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1095,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5627,
            "name": "Racalmuto",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "H148",
            "cod_istat": "084029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 1389,
            "area": "",
            "ech": 1
        },
        {
            "id": 5628,
            "name": "Racconigi",
            "provincia": "CN",
            "cap": "12035",
            "cod_catastale": "H150",
            "cod_istat": "004179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2637,
            "area": "",
            "ech": 0
        },
        {
            "id": 5629,
            "name": "Raccuja",
            "provincia": "ME",
            "cap": "98067",
            "cod_catastale": "H151",
            "cod_istat": "083069",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 640,
            "giorni": 1721,
            "area": "",
            "ech": 1
        },
        {
            "id": 5630,
            "name": "Racines",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "H152",
            "cod_istat": "021070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 976,
            "giorni": 3704,
            "area": "",
            "ech": 0
        },
        {
            "id": 5631,
            "name": "Radda in Chianti",
            "provincia": "SI",
            "cap": "53017",
            "cod_catastale": "H153",
            "cod_istat": "052023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 2245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5632,
            "name": "Raddusa",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "H154",
            "cod_istat": "087036",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 350,
            "giorni": 1253,
            "area": "",
            "ech": 1
        },
        {
            "id": 5633,
            "name": "Radicofani",
            "provincia": "SI",
            "cap": "53040",
            "cod_catastale": "H156",
            "cod_istat": "052024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 814,
            "giorni": 2648,
            "area": "",
            "ech": 0
        },
        {
            "id": 5634,
            "name": "Radicondoli",
            "provincia": "SI",
            "cap": "53030",
            "cod_catastale": "H157",
            "cod_istat": "052025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 509,
            "giorni": 2261,
            "area": "",
            "ech": 0
        },
        {
            "id": 5635,
            "name": "Raffadali",
            "provincia": "AG",
            "cap": "92015",
            "cod_catastale": "H159",
            "cod_istat": "084030",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1177,
            "area": "",
            "ech": 0
        },
        {
            "id": 5636,
            "name": "Ragalna",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "M287",
            "cod_istat": "087058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 1879,
            "area": "",
            "ech": 1
        },
        {
            "id": 5637,
            "name": "Ragogna",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "H161",
            "cod_istat": "030087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2509,
            "area": "",
            "ech": 0
        },
        {
            "id": 5638,
            "name": "Ragoli",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "H162",
            "cod_istat": "022151",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 556,
            "giorni": 3234,
            "area": "",
            "ech": 0
        },
        {
            "id": 5639,
            "name": "Ragusa",
            "provincia": "RG",
            "cap": "97100",
            "cod_catastale": "H163",
            "cod_istat": "088009",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 502,
            "giorni": 1324,
            "area": "",
            "ech": 1
        },
        {
            "id": 5640,
            "name": "Raiano",
            "provincia": "AQ",
            "cap": "67027",
            "cod_catastale": "H166",
            "cod_istat": "066077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 1987,
            "area": "",
            "ech": 0
        },
        {
            "id": 5641,
            "name": "Ramacca",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "H168",
            "cod_istat": "087037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1040,
            "area": "",
            "ech": 1
        },
        {
            "id": 5642,
            "name": "Ramiseto",
            "provincia": "RE",
            "cap": "42030",
            "cod_catastale": "G654",
            "cod_istat": "035031",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 781,
            "giorni": 3299,
            "area": "",
            "ech": 0
        },
        {
            "id": 5643,
            "name": "Ramponio Verna",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "H171",
            "cod_istat": "013194",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 667,
            "giorni": 3017,
            "area": "",
            "ech": 0
        },
        {
            "id": 5644,
            "name": "Rancio Valcuvia",
            "provincia": "VA",
            "cap": "21030",
            "cod_catastale": "H173",
            "cod_istat": "012115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2534,
            "area": "",
            "ech": 0
        },
        {
            "id": 5645,
            "name": "Ranco",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "H174",
            "cod_istat": "012116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 214,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 5646,
            "name": "Randazzo",
            "provincia": "CT",
            "cap": "95036",
            "cod_catastale": "H175",
            "cod_istat": "087038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 765,
            "giorni": 1934,
            "area": "",
            "ech": 1
        },
        {
            "id": 5647,
            "name": "Ranica",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "H176",
            "cod_istat": "016178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2486,
            "area": "",
            "ech": 0
        },
        {
            "id": 5648,
            "name": "Ranzanico",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "H177",
            "cod_istat": "016179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 519,
            "giorni": 2807,
            "area": "",
            "ech": 0
        },
        {
            "id": 5649,
            "name": "Ranzo",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "H180",
            "cod_istat": "008048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2103,
            "area": "",
            "ech": 0
        },
        {
            "id": 5650,
            "name": "Rapagnano",
            "provincia": "FM",
            "cap": "63831",
            "cod_catastale": "H182",
            "cod_istat": "109035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 316,
            "giorni": 2007,
            "area": "",
            "ech": 0
        },
        {
            "id": 5651,
            "name": "Rapallo",
            "provincia": "GE",
            "cap": "16035",
            "cod_catastale": "H183",
            "cod_istat": "010046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1412,
            "area": "",
            "ech": 0
        },
        {
            "id": 5652,
            "name": "Rapino",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "H184",
            "cod_istat": "069071",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1826,
            "area": "",
            "ech": 0
        },
        {
            "id": 5653,
            "name": "Rapolano Terme",
            "provincia": "SI",
            "cap": "53040",
            "cod_catastale": "H185",
            "cod_istat": "052026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 1914,
            "area": "",
            "ech": 0
        },
        {
            "id": 5654,
            "name": "Rapolla",
            "provincia": "PZ",
            "cap": "85027",
            "cod_catastale": "H186",
            "cod_istat": "076064",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 439,
            "giorni": 1676,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5655,
            "name": "Rapone",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "H187",
            "cod_istat": "076065",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 838,
            "giorni": 2433,
            "area": "",
            "ech": 0
        },
        {
            "id": 5656,
            "name": "Rassa",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "H188",
            "cod_istat": "002110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 917,
            "giorni": 3497,
            "area": "",
            "ech": 0
        },
        {
            "id": 5657,
            "name": "Rasun-Anterselva",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "H189",
            "cod_istat": "021071",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5658,
            "name": "Rasura",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "H192",
            "cod_istat": "014055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 762,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 5659,
            "name": "Ravanusa",
            "provincia": "AG",
            "cap": "92029",
            "cod_catastale": "H194",
            "cod_istat": "084031",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 320,
            "giorni": 1051,
            "area": "",
            "ech": 1
        },
        {
            "id": 5660,
            "name": "Ravarino",
            "provincia": "MO",
            "cap": "41017",
            "cod_catastale": "H195",
            "cod_istat": "036034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 5661,
            "name": "Ravascletto",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "H196",
            "cod_istat": "030088",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 950,
            "giorni": 3812,
            "area": "",
            "ech": 0
        },
        {
            "id": 5662,
            "name": "Ravello",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "H198",
            "cod_istat": "065104",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1422,
            "area": "",
            "ech": 0
        },
        {
            "id": 5663,
            "name": "Ravenna",
            "provincia": "RA",
            "cap": "481xx",
            "cod_catastale": "H199",
            "cod_istat": "039014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 2227,
            "area": "",
            "ech": 0
        },
        {
            "id": 5664,
            "name": "Raveo",
            "provincia": "UD",
            "cap": "33029",
            "cod_catastale": "H200",
            "cod_istat": "030089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 518,
            "giorni": 3399,
            "area": "",
            "ech": 0
        },
        {
            "id": 5665,
            "name": "Raviscanina",
            "provincia": "CE",
            "cap": "81017",
            "cod_catastale": "H202",
            "cod_istat": "061066",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 358,
            "giorni": 1766,
            "area": "",
            "ech": 0
        },
        {
            "id": 5666,
            "name": "Re",
            "provincia": "VB",
            "cap": "28856",
            "cod_catastale": "H203",
            "cod_istat": "103060",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 710,
            "giorni": 3227,
            "area": "",
            "ech": 0
        },
        {
            "id": 5667,
            "name": "Rea",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "H204",
            "cod_istat": "018119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5668,
            "name": "Realmonte",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "H205",
            "cod_istat": "084032",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 782,
            "area": "",
            "ech": 0
        },
        {
            "id": 5669,
            "name": "Reana del Rojale",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "H206",
            "cod_istat": "030090",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5670,
            "name": "Reano",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H207",
            "cod_istat": "001211",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 3059,
            "area": "",
            "ech": 0
        },
        {
            "id": 5671,
            "name": "Recale",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "H210",
            "cod_istat": "061067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 918,
            "area": "",
            "ech": 0
        },
        {
            "id": 5672,
            "name": "Recanati",
            "provincia": "MC",
            "cap": "62019",
            "cod_catastale": "H211",
            "cod_istat": "043044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1982,
            "area": "",
            "ech": 0
        },
        {
            "id": 5673,
            "name": "Recco",
            "provincia": "GE",
            "cap": "16036",
            "cod_catastale": "H212",
            "cod_istat": "010047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1418,
            "area": "",
            "ech": 0
        },
        {
            "id": 5674,
            "name": "Recetto",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "H213",
            "cod_istat": "003129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2515,
            "area": "",
            "ech": 0
        },
        {
            "id": 5675,
            "name": "Recoaro Terme",
            "provincia": "VI",
            "cap": "36076",
            "cod_catastale": "H214",
            "cod_istat": "024084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 5676,
            "name": "Redavalle",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "H216",
            "cod_istat": "018120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 5677,
            "name": "Redondesco",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "H218",
            "cod_istat": "020048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5678,
            "name": "Refrancore",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "H219",
            "cod_istat": "005089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 5679,
            "name": "Refrontolo",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "H220",
            "cod_istat": "026065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 5680,
            "name": "Regalbuto",
            "provincia": "EN",
            "cap": "94017",
            "cod_catastale": "H221",
            "cod_istat": "086016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1450,
            "area": "",
            "ech": 0
        },
        {
            "id": 5681,
            "name": "Reggello",
            "provincia": "FI",
            "cap": "50066",
            "cod_catastale": "H222",
            "cod_istat": "048035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2363,
            "area": "",
            "ech": 0
        },
        {
            "id": 5682,
            "name": "Reggio di Calabria",
            "provincia": "RC",
            "cap": "891xx",
            "cod_catastale": "H224",
            "cod_istat": "080063",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 31,
            "giorni": 772,
            "area": "",
            "ech": 0
        },
        {
            "id": 5683,
            "name": "Reggio nell'Emilia",
            "provincia": "RE",
            "cap": "421xx",
            "cod_catastale": "H223",
            "cod_istat": "035033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 2560,
            "area": "",
            "ech": 0
        },
        {
            "id": 5684,
            "name": "Reggiolo",
            "provincia": "RE",
            "cap": "42046",
            "cod_catastale": "H225",
            "cod_istat": "035032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 5685,
            "name": "Reino",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "H227",
            "cod_istat": "062056",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 390,
            "giorni": 1780,
            "area": "",
            "ech": 0
        },
        {
            "id": 5686,
            "name": "Reitano",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "H228",
            "cod_istat": "083070",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 396,
            "giorni": 1304,
            "area": "",
            "ech": 0
        },
        {
            "id": 5687,
            "name": "Remanzacco",
            "provincia": "UD",
            "cap": "33047",
            "cod_catastale": "H229",
            "cod_istat": "030091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 2587,
            "area": "",
            "ech": 0
        },
        {
            "id": 5688,
            "name": "Remedello",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "H230",
            "cod_istat": "017160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2278,
            "area": "",
            "ech": 0
        },
        {
            "id": 5689,
            "name": "Renate",
            "provincia": "MB",
            "cap": "20838",
            "cod_catastale": "H233",
            "cod_istat": "108037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 5690,
            "name": "Rende",
            "provincia": "CS",
            "cap": "87036",
            "cod_catastale": "H235",
            "cod_istat": "078102",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 474,
            "giorni": 1747,
            "area": "SUD",
            "ech": 1
        },
        {
            "id": 5691,
            "name": "Renon",
            "provincia": "BZ",
            "cap": "39054",
            "cod_catastale": "H236",
            "cod_istat": "021072",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1154,
            "giorni": 4223,
            "area": "",
            "ech": 0
        },
        {
            "id": 5692,
            "name": "Resana",
            "provincia": "TV",
            "cap": "31023",
            "cod_catastale": "H238",
            "cod_istat": "026066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 5693,
            "name": "Rescaldina",
            "provincia": "MI",
            "cap": "20027",
            "cod_catastale": "H240",
            "cod_istat": "015181",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2480,
            "area": "",
            "ech": 0
        },
        {
            "id": 5694,
            "name": "Resia",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "H242",
            "cod_istat": "030092",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 492,
            "giorni": 3490,
            "area": "",
            "ech": 0
        },
        {
            "id": 5695,
            "name": "Resiutta",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "H244",
            "cod_istat": "030093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 316,
            "giorni": 3014,
            "area": "",
            "ech": 0
        },
        {
            "id": 5696,
            "name": "Resuttano",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "H245",
            "cod_istat": "085014",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1572,
            "area": "",
            "ech": 0
        },
        {
            "id": 5697,
            "name": "Retorbido",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "H246",
            "cod_istat": "018121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 5698,
            "name": "Revello",
            "provincia": "CN",
            "cap": "12036",
            "cod_catastale": "H247",
            "cod_istat": "004180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 351,
            "giorni": 2748,
            "area": "",
            "ech": 0
        },
        {
            "id": 5699,
            "name": "Revere",
            "provincia": "MN",
            "cap": "46036",
            "cod_catastale": "H248",
            "cod_istat": "020049",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5700,
            "name": "Revigliasco d'Asti",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "H250",
            "cod_istat": "005090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2684,
            "area": "",
            "ech": 0
        },
        {
            "id": 5701,
            "name": "Revine Lago",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "H253",
            "cod_istat": "026067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2795,
            "area": "",
            "ech": 0
        },
        {
            "id": 5702,
            "name": "Revò",
            "provincia": "TN",
            "cap": "38028",
            "cod_catastale": "H254",
            "cod_istat": "022152",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 724,
            "giorni": 3520,
            "area": "",
            "ech": 0
        },
        {
            "id": 5703,
            "name": "Rezzago",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "H255",
            "cod_istat": "013195",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 654,
            "giorni": 2998,
            "area": "",
            "ech": 0
        },
        {
            "id": 5704,
            "name": "Rezzato",
            "provincia": "BS",
            "cap": "25086",
            "cod_catastale": "H256",
            "cod_istat": "017161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 5705,
            "name": "Rezzo",
            "provincia": "IM",
            "cap": "18026",
            "cod_catastale": "H257",
            "cod_istat": "008049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 563,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 5706,
            "name": "Rezzoaglio",
            "provincia": "GE",
            "cap": "16048",
            "cod_catastale": "H258",
            "cod_istat": "010048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 3245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5707,
            "name": "Rhêmes-Notre-Dame",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H262",
            "cod_istat": "007055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1725,
            "giorni": 4820,
            "area": "",
            "ech": 0
        },
        {
            "id": 5708,
            "name": "Rhêmes-Saint-Georges",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H263",
            "cod_istat": "007056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1218,
            "giorni": 4059,
            "area": "",
            "ech": 0
        },
        {
            "id": 5709,
            "name": "Rho",
            "provincia": "MI",
            "cap": "20017",
            "cod_catastale": "H264",
            "cod_istat": "015182",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 5710,
            "name": "Riace",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "H265",
            "cod_istat": "080064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1091,
            "area": "",
            "ech": 1
        },
        {
            "id": 5711,
            "name": "Rialto",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "H266",
            "cod_istat": "009053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 2238,
            "area": "",
            "ech": 0
        },
        {
            "id": 5712,
            "name": "Riano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "H267",
            "cod_istat": "058081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1599,
            "area": "",
            "ech": 0
        },
        {
            "id": 5713,
            "name": "Riardo",
            "provincia": "CE",
            "cap": "81053",
            "cod_catastale": "H268",
            "cod_istat": "061068",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 150,
            "giorni": 1344,
            "area": "",
            "ech": 0
        },
        {
            "id": 5714,
            "name": "Ribera",
            "provincia": "AG",
            "cap": "92016",
            "cod_catastale": "H269",
            "cod_istat": "084033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 974,
            "area": "",
            "ech": 1
        },
        {
            "id": 5715,
            "name": "Ribordone",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H270",
            "cod_istat": "001212",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1023,
            "giorni": 3783,
            "area": "",
            "ech": 0
        },
        {
            "id": 5716,
            "name": "Ricadi",
            "provincia": "VV",
            "cap": "89866",
            "cod_catastale": "H271",
            "cod_istat": "102030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 1345,
            "area": "",
            "ech": 0
        },
        {
            "id": 5717,
            "name": "Ricaldone",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "H272",
            "cod_istat": "006143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 5718,
            "name": "Riccia",
            "provincia": "CB",
            "cap": "86016",
            "cod_catastale": "H273",
            "cod_istat": "070057",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 2288,
            "area": "",
            "ech": 0
        },
        {
            "id": 5719,
            "name": "Riccione",
            "provincia": "RN",
            "cap": "47838",
            "cod_catastale": "H274",
            "cod_istat": "099013",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 5720,
            "name": "Riccò del Golfo di Spezia",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "H275",
            "cod_istat": "011023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 1618,
            "area": "",
            "ech": 0
        },
        {
            "id": 5721,
            "name": "Ricengo",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H276",
            "cod_istat": "019079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 5722,
            "name": "Ricigliano",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "H277",
            "cod_istat": "065105",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 560,
            "giorni": 1744,
            "area": "",
            "ech": 0
        },
        {
            "id": 5723,
            "name": "Riese Pio X",
            "provincia": "TV",
            "cap": "31039",
            "cod_catastale": "H280",
            "cod_istat": "026068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 5724,
            "name": "Riesi",
            "provincia": "CL",
            "cap": "93016",
            "cod_catastale": "H281",
            "cod_istat": "085015",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 330,
            "giorni": 1161,
            "area": "",
            "ech": 0
        },
        {
            "id": 5725,
            "name": "Rieti",
            "provincia": "RI",
            "cap": "02100",
            "cod_catastale": "H282",
            "cod_istat": "057059",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 405,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 5726,
            "name": "Rifiano",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "H284",
            "cod_istat": "021073",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 3160,
            "area": "",
            "ech": 0
        },
        {
            "id": 5727,
            "name": "Rifreddo",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "H285",
            "cod_istat": "004181",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 433,
            "giorni": 2852,
            "area": "",
            "ech": 0
        },
        {
            "id": 5728,
            "name": "Rignano Flaminio",
            "provincia": "RM",
            "cap": "00068",
            "cod_catastale": "H288",
            "cod_istat": "058082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1908,
            "area": "",
            "ech": 0
        },
        {
            "id": 5729,
            "name": "Rignano Garganico",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "H287",
            "cod_istat": "071041",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 2147,
            "area": "",
            "ech": 0
        },
        {
            "id": 5730,
            "name": "Rignano sull'Arno",
            "provincia": "FI",
            "cap": "50067",
            "cod_catastale": "H286",
            "cod_istat": "048036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 1944,
            "area": "",
            "ech": 0
        },
        {
            "id": 5731,
            "name": "Rigolato",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "H289",
            "cod_istat": "030094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 3842,
            "area": "",
            "ech": 0
        },
        {
            "id": 5732,
            "name": "Rima San Giuseppe",
            "provincia": "VC",
            "cap": "13026",
            "cod_catastale": "H291",
            "cod_istat": "002111",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1411,
            "giorni": 4139,
            "area": "",
            "ech": 0
        },
        {
            "id": 5733,
            "name": "Rimasco",
            "provincia": "VC",
            "cap": "13026",
            "cod_catastale": "H292",
            "cod_istat": "002112",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 906,
            "giorni": 3482,
            "area": "",
            "ech": 0
        },
        {
            "id": 5734,
            "name": "Rimella",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "H293",
            "cod_istat": "002113",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1176,
            "giorni": 3833,
            "area": "",
            "ech": 0
        },
        {
            "id": 5735,
            "name": "Rimini",
            "provincia": "RN",
            "cap": "479xx",
            "cod_catastale": "H294",
            "cod_istat": "099014",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2139,
            "area": "",
            "ech": 0
        },
        {
            "id": 5736,
            "name": "Rio di Pusteria",
            "provincia": "BZ",
            "cap": "39037",
            "cod_catastale": "H299",
            "cod_istat": "021074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 777,
            "giorni": 3646,
            "area": "",
            "ech": 0
        },
        {
            "id": 5737,
            "name": "Rio Marina",
            "provincia": "LI",
            "cap": "57038",
            "cod_catastale": "H305",
            "cod_istat": "049015",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 51,
            "giorni": 1033,
            "area": "",
            "ech": 0
        },
        {
            "id": 5738,
            "name": "Rio nell'Elba",
            "provincia": "LI",
            "cap": "57039",
            "cod_catastale": "H297",
            "cod_istat": "049016",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1236,
            "area": "",
            "ech": 0
        },
        {
            "id": 5739,
            "name": "Rio Saliceto",
            "provincia": "RE",
            "cap": "42010",
            "cod_catastale": "H298",
            "cod_istat": "035034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2377,
            "area": "",
            "ech": 0
        },
        {
            "id": 5740,
            "name": "Riofreddo",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "H300",
            "cod_istat": "058083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 705,
            "giorni": 2761,
            "area": "",
            "ech": 0
        },
        {
            "id": 5741,
            "name": "Riola Sardo",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "H301",
            "cod_istat": "095043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 1059,
            "area": "",
            "ech": 0
        },
        {
            "id": 5742,
            "name": "Riolo Terme",
            "provincia": "RA",
            "cap": "48025",
            "cod_catastale": "H302",
            "cod_istat": "039015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2349,
            "area": "",
            "ech": 0
        },
        {
            "id": 5743,
            "name": "Riolunato",
            "provincia": "MO",
            "cap": "41020",
            "cod_catastale": "H303",
            "cod_istat": "036035",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 716,
            "giorni": 3189,
            "area": "",
            "ech": 0
        },
        {
            "id": 5744,
            "name": "Riomaggiore",
            "provincia": "SP",
            "cap": "19017",
            "cod_catastale": "H304",
            "cod_istat": "011024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1437,
            "area": "",
            "ech": 0
        },
        {
            "id": 5745,
            "name": "Rionero in Vulture",
            "provincia": "PZ",
            "cap": "85028",
            "cod_catastale": "H307",
            "cod_istat": "076066",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 656,
            "giorni": 2144,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 5746,
            "name": "Rionero Sannitico",
            "provincia": "IS",
            "cap": "86087",
            "cod_catastale": "H308",
            "cod_istat": "094039",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1051,
            "giorni": 2888,
            "area": "",
            "ech": 0
        },
        {
            "id": 5747,
            "name": "Ripa Teatina",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "H320",
            "cod_istat": "069072",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1495,
            "area": "",
            "ech": 0
        },
        {
            "id": 5748,
            "name": "Ripabottoni",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "H311",
            "cod_istat": "070058",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 654,
            "giorni": 2219,
            "area": "",
            "ech": 0
        },
        {
            "id": 5749,
            "name": "Ripacandida",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "H312",
            "cod_istat": "076067",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 620,
            "giorni": 2036,
            "area": "",
            "ech": 0
        },
        {
            "id": 5750,
            "name": "Ripalimosani",
            "provincia": "CB",
            "cap": "86025",
            "cod_catastale": "H313",
            "cod_istat": "070059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2161,
            "area": "",
            "ech": 0
        },
        {
            "id": 5751,
            "name": "Ripalta Arpina",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H314",
            "cod_istat": "019080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 5752,
            "name": "Ripalta Cremasca",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H315",
            "cod_istat": "019081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 5753,
            "name": "Ripalta Guerina",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H316",
            "cod_istat": "019082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2474,
            "area": "",
            "ech": 0
        },
        {
            "id": 5754,
            "name": "Riparbella",
            "provincia": "PI",
            "cap": "56046",
            "cod_catastale": "H319",
            "cod_istat": "050030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 1845,
            "area": "",
            "ech": 0
        },
        {
            "id": 5755,
            "name": "Ripatransone",
            "provincia": "AP",
            "cap": "63065",
            "cod_catastale": "H321",
            "cod_istat": "044063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 494,
            "giorni": 2218,
            "area": "",
            "ech": 0
        },
        {
            "id": 5756,
            "name": "Ripe",
            "provincia": "AN",
            "cap": "60010",
            "cod_catastale": "H322",
            "cod_istat": "042039",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 143,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 5757,
            "name": "Ripe San Ginesio",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "H323",
            "cod_istat": "043045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2143,
            "area": "",
            "ech": 0
        },
        {
            "id": 5758,
            "name": "Ripi",
            "provincia": "FR",
            "cap": "03027",
            "cod_catastale": "H324",
            "cod_istat": "060058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2150,
            "area": "",
            "ech": 0
        },
        {
            "id": 5759,
            "name": "Riposto",
            "provincia": "CT",
            "cap": "95018",
            "cod_catastale": "H325",
            "cod_istat": "087039",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 857,
            "area": "",
            "ech": 1
        },
        {
            "id": 5760,
            "name": "Rittana",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "H326",
            "cod_istat": "004182",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3245,
            "area": "",
            "ech": 0
        },
        {
            "id": 5761,
            "name": "Riva del Garda",
            "provincia": "TN",
            "cap": "38066",
            "cod_catastale": "H330",
            "cod_istat": "022153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 5762,
            "name": "Riva di Solto",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "H331",
            "cod_istat": "016180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 186,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 5763,
            "name": "Riva Ligure",
            "provincia": "IM",
            "cap": "18015",
            "cod_catastale": "H328",
            "cod_istat": "008050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1050,
            "area": "",
            "ech": 0
        },
        {
            "id": 5764,
            "name": "Riva presso Chieri",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "H337",
            "cod_istat": "001215",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2747,
            "area": "",
            "ech": 0
        },
        {
            "id": 5765,
            "name": "Riva Valdobbia",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "H329",
            "cod_istat": "002114",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1112,
            "giorni": 3774,
            "area": "",
            "ech": 0
        },
        {
            "id": 5766,
            "name": "Rivalba",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H333",
            "cod_istat": "001213",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2846,
            "area": "",
            "ech": 0
        },
        {
            "id": 5767,
            "name": "Rivalta Bormida",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "H334",
            "cod_istat": "006144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2600,
            "area": "",
            "ech": 0
        },
        {
            "id": 5768,
            "name": "Rivalta di Torino",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "H335",
            "cod_istat": "001214",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 294,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 5769,
            "name": "Rivamonte Agordino",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "H327",
            "cod_istat": "025043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 973,
            "giorni": 4121,
            "area": "",
            "ech": 0
        },
        {
            "id": 5770,
            "name": "Rivanazzano Terme",
            "provincia": "PV",
            "cap": "27055",
            "cod_catastale": "H336",
            "cod_istat": "018122",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5771,
            "name": "Rivara",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H338",
            "cod_istat": "001216",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 392,
            "giorni": 2942,
            "area": "",
            "ech": 0
        },
        {
            "id": 5772,
            "name": "Rivarolo Canavese",
            "provincia": "TO",
            "cap": "10086",
            "cod_catastale": "H340",
            "cod_istat": "001217",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2600,
            "area": "",
            "ech": 0
        },
        {
            "id": 5773,
            "name": "Rivarolo del Re ed Uniti",
            "provincia": "CR",
            "cap": "26036",
            "cod_catastale": "H341",
            "cod_istat": "019083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5774,
            "name": "Rivarolo Mantovano",
            "provincia": "MN",
            "cap": "46017",
            "cod_catastale": "H342",
            "cod_istat": "020050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5775,
            "name": "Rivarone",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "H343",
            "cod_istat": "006145",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2566,
            "area": "",
            "ech": 0
        },
        {
            "id": 5776,
            "name": "Rivarossa",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "H344",
            "cod_istat": "001218",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 2783,
            "area": "",
            "ech": 0
        },
        {
            "id": 5777,
            "name": "Rive",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "H346",
            "cod_istat": "002115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 2829,
            "area": "",
            "ech": 0
        },
        {
            "id": 5778,
            "name": "Rive d'Arcano",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "H347",
            "cod_istat": "030095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2406,
            "area": "",
            "ech": 0
        },
        {
            "id": 5779,
            "name": "Rivello",
            "provincia": "PZ",
            "cap": "85040",
            "cod_catastale": "H348",
            "cod_istat": "076068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 479,
            "giorni": 1780,
            "area": "",
            "ech": 0
        },
        {
            "id": 5780,
            "name": "Rivergaro",
            "provincia": "PC",
            "cap": "29029",
            "cod_catastale": "H350",
            "cod_istat": "033038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2636,
            "area": "",
            "ech": 0
        },
        {
            "id": 5781,
            "name": "Rivignano",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "H352",
            "cod_istat": "030188",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2413,
            "area": "",
            "ech": 0
        },
        {
            "id": 5782,
            "name": "Rivisondoli",
            "provincia": "AQ",
            "cap": "67036",
            "cod_catastale": "H353",
            "cod_istat": "066078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1320,
            "giorni": 3651,
            "area": "",
            "ech": 0
        },
        {
            "id": 5783,
            "name": "Rivodutri",
            "provincia": "RI",
            "cap": "02010",
            "cod_catastale": "H354",
            "cod_istat": "057060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 5784,
            "name": "Rivoli",
            "provincia": "TO",
            "cap": "10098",
            "cod_catastale": "H355",
            "cod_istat": "001219",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2939,
            "area": "",
            "ech": 0
        },
        {
            "id": 5785,
            "name": "Rivoli Veronese",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "H356",
            "cod_istat": "023062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 5786,
            "name": "Rivolta d'Adda",
            "provincia": "CR",
            "cap": "26027",
            "cod_catastale": "H357",
            "cod_istat": "019084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5787,
            "name": "Rizziconi",
            "provincia": "RC",
            "cap": "89016",
            "cod_catastale": "H359",
            "cod_istat": "080065",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 864,
            "area": "",
            "ech": 0
        },
        {
            "id": 5788,
            "name": "Ro",
            "provincia": "FE",
            "cap": "44030",
            "cod_catastale": "H360",
            "cod_istat": "038020",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2274,
            "area": "",
            "ech": 0
        },
        {
            "id": 5789,
            "name": "Roana",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "H361",
            "cod_istat": "024085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1001,
            "giorni": 4163,
            "area": "",
            "ech": 0
        },
        {
            "id": 5790,
            "name": "Roaschia",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "H362",
            "cod_istat": "004183",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 3332,
            "area": "",
            "ech": 0
        },
        {
            "id": 5791,
            "name": "Roascio",
            "provincia": "CN",
            "cap": "12073",
            "cod_catastale": "H363",
            "cod_istat": "004184",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 458,
            "giorni": 2883,
            "area": "",
            "ech": 0
        },
        {
            "id": 5792,
            "name": "Roasio",
            "provincia": "VC",
            "cap": "13060",
            "cod_catastale": "H365",
            "cod_istat": "002116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 5793,
            "name": "Roatto",
            "provincia": "AT",
            "cap": "14018",
            "cod_catastale": "H366",
            "cod_istat": "005091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 2697,
            "area": "",
            "ech": 0
        },
        {
            "id": 5794,
            "name": "Robassomero",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "H367",
            "cod_istat": "001220",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2894,
            "area": "",
            "ech": 0
        },
        {
            "id": 5795,
            "name": "Robbiate",
            "provincia": "LC",
            "cap": "23899",
            "cod_catastale": "G223",
            "cod_istat": "097071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 5796,
            "name": "Robbio",
            "provincia": "PV",
            "cap": "27038",
            "cod_catastale": "H369",
            "cod_istat": "018123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 5797,
            "name": "Robecchetto con Induno",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "H371",
            "cod_istat": "015183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 5798,
            "name": "Robecco d'Oglio",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H372",
            "cod_istat": "019085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 5799,
            "name": "Robecco Pavese",
            "provincia": "PV",
            "cap": "27042",
            "cod_catastale": "H375",
            "cod_istat": "018124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5800,
            "name": "Robecco sul Naviglio",
            "provincia": "MI",
            "cap": "20087",
            "cod_catastale": "H373",
            "cod_istat": "015184",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 5801,
            "name": "Robella",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "H376",
            "cod_istat": "005092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 2842,
            "area": "",
            "ech": 0
        },
        {
            "id": 5802,
            "name": "Robilante",
            "provincia": "CN",
            "cap": "12017",
            "cod_catastale": "H377",
            "cod_istat": "004185",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 686,
            "giorni": 3166,
            "area": "",
            "ech": 0
        },
        {
            "id": 5803,
            "name": "Roburent",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "H378",
            "cod_istat": "004186",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 788,
            "giorni": 3292,
            "area": "",
            "ech": 0
        },
        {
            "id": 5804,
            "name": "Rocca Canavese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "H386",
            "cod_istat": "001221",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 3056,
            "area": "",
            "ech": 0
        },
        {
            "id": 5805,
            "name": "Rocca Canterano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "H387",
            "cod_istat": "058084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 745,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 5806,
            "name": "Rocca Cigliè",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "H391",
            "cod_istat": "004188",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 3064,
            "area": "",
            "ech": 0
        },
        {
            "id": 5807,
            "name": "Rocca d'Arazzo",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "H392",
            "cod_istat": "005093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 2677,
            "area": "",
            "ech": 0
        },
        {
            "id": 5808,
            "name": "Rocca d'Arce",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "H393",
            "cod_istat": "060059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 507,
            "giorni": 2107,
            "area": "",
            "ech": 0
        },
        {
            "id": 5809,
            "name": "Rocca de' Baldi",
            "provincia": "CN",
            "cap": "12047",
            "cod_catastale": "H395",
            "cod_istat": "004189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2828,
            "area": "",
            "ech": 0
        },
        {
            "id": 5810,
            "name": "Rocca de' Giorgi",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "H396",
            "cod_istat": "018125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2745,
            "area": "",
            "ech": 0
        },
        {
            "id": 5811,
            "name": "Rocca d'Evandro",
            "provincia": "CE",
            "cap": "81040",
            "cod_catastale": "H398",
            "cod_istat": "061069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 1466,
            "area": "",
            "ech": 0
        },
        {
            "id": 5812,
            "name": "Rocca di Botte",
            "provincia": "AQ",
            "cap": "67066",
            "cod_catastale": "H399",
            "cod_istat": "066080",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 750,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 5813,
            "name": "Rocca di Cambio",
            "provincia": "AQ",
            "cap": "67047",
            "cod_catastale": "H400",
            "cod_istat": "066081",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1433,
            "giorni": 3853,
            "area": "",
            "ech": 0
        },
        {
            "id": 5814,
            "name": "Rocca di Cave",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "H401",
            "cod_istat": "058085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 933,
            "giorni": 2958,
            "area": "",
            "ech": 0
        },
        {
            "id": 5815,
            "name": "Rocca di Mezzo",
            "provincia": "AQ",
            "cap": "67048",
            "cod_catastale": "H402",
            "cod_istat": "066082",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1322,
            "giorni": 3886,
            "area": "",
            "ech": 0
        },
        {
            "id": 5816,
            "name": "Rocca di Neto",
            "provincia": "KR",
            "cap": "88821",
            "cod_catastale": "H403",
            "cod_istat": "101019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1132,
            "area": "",
            "ech": 1
        },
        {
            "id": 5817,
            "name": "Rocca di Papa",
            "provincia": "RM",
            "cap": "00040",
            "cod_catastale": "H404",
            "cod_istat": "058086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 5818,
            "name": "Rocca Grimalda",
            "provincia": "AL",
            "cap": "15078",
            "cod_catastale": "H414",
            "cod_istat": "006147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 5819,
            "name": "Rocca Imperiale",
            "provincia": "CS",
            "cap": "87074",
            "cod_catastale": "H416",
            "cod_istat": "078103",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 1218,
            "area": "",
            "ech": 0
        },
        {
            "id": 5820,
            "name": "Rocca Massima",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "H421",
            "cod_istat": "059022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 735,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 5821,
            "name": "Rocca Pia",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "H429",
            "cod_istat": "066083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1181,
            "giorni": 3402,
            "area": "",
            "ech": 0
        },
        {
            "id": 5822,
            "name": "Rocca Pietore",
            "provincia": "BL",
            "cap": "32023",
            "cod_catastale": "H379",
            "cod_istat": "025044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1143,
            "giorni": 4379,
            "area": "",
            "ech": 0
        },
        {
            "id": 5823,
            "name": "Rocca Priora",
            "provincia": "RM",
            "cap": "00079",
            "cod_catastale": "H432",
            "cod_istat": "058088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 768,
            "giorni": 2548,
            "area": "",
            "ech": 0
        },
        {
            "id": 5824,
            "name": "Rocca San Casciano",
            "provincia": "FC",
            "cap": "47017",
            "cod_catastale": "H437",
            "cod_istat": "040036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 2412,
            "area": "",
            "ech": 0
        },
        {
            "id": 5825,
            "name": "Rocca San Felice",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "H438",
            "cod_istat": "064079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2424,
            "area": "",
            "ech": 0
        },
        {
            "id": 5826,
            "name": "Rocca San Giovanni",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "H439",
            "cod_istat": "069074",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 1429,
            "area": "",
            "ech": 0
        },
        {
            "id": 5827,
            "name": "Rocca Santa Maria",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "H440",
            "cod_istat": "067036",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1073,
            "giorni": 3193,
            "area": "",
            "ech": 0
        },
        {
            "id": 5828,
            "name": "Rocca Santo Stefano",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "H441",
            "cod_istat": "058089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 2325,
            "area": "",
            "ech": 0
        },
        {
            "id": 5829,
            "name": "Rocca Sinibalda",
            "provincia": "RI",
            "cap": "02026",
            "cod_catastale": "H446",
            "cod_istat": "057062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 2289,
            "area": "",
            "ech": 0
        },
        {
            "id": 5830,
            "name": "Rocca Susella",
            "provincia": "PV",
            "cap": "27052",
            "cod_catastale": "H450",
            "cod_istat": "018126",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 3246,
            "area": "",
            "ech": 0
        },
        {
            "id": 5831,
            "name": "Roccabascerana",
            "provincia": "AV",
            "cap": "83016",
            "cod_catastale": "H382",
            "cod_istat": "064078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2004,
            "area": "",
            "ech": 0
        },
        {
            "id": 5832,
            "name": "Roccabernarda",
            "provincia": "KR",
            "cap": "88835",
            "cod_catastale": "H383",
            "cod_istat": "101018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 1083,
            "area": "",
            "ech": 0
        },
        {
            "id": 5833,
            "name": "Roccabianca",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "H384",
            "cod_istat": "034030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 5834,
            "name": "Roccabruna",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "H385",
            "cod_istat": "004187",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 3183,
            "area": "",
            "ech": 0
        },
        {
            "id": 5835,
            "name": "Roccacasale",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "H389",
            "cod_istat": "066079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2119,
            "area": "",
            "ech": 0
        },
        {
            "id": 5836,
            "name": "Roccadaspide",
            "provincia": "SA",
            "cap": "84069",
            "cod_catastale": "H394",
            "cod_istat": "065106",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 354,
            "giorni": 1580,
            "area": "",
            "ech": 0
        },
        {
            "id": 5837,
            "name": "Roccafiorita",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "H405",
            "cod_istat": "083071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 723,
            "giorni": 1863,
            "area": "",
            "ech": 0
        },
        {
            "id": 5838,
            "name": "Roccafluvione",
            "provincia": "AP",
            "cap": "63093",
            "cod_catastale": "H390",
            "cod_istat": "044064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 299,
            "giorni": 1989,
            "area": "",
            "ech": 0
        },
        {
            "id": 5839,
            "name": "Roccaforte del Greco",
            "provincia": "RC",
            "cap": "89060",
            "cod_catastale": "H408",
            "cod_istat": "080066",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 971,
            "giorni": 2548,
            "area": "",
            "ech": 0
        },
        {
            "id": 5840,
            "name": "Roccaforte Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "H406",
            "cod_istat": "006146",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 704,
            "giorni": 3073,
            "area": "",
            "ech": 0
        },
        {
            "id": 5841,
            "name": "Roccaforte Mondovì",
            "provincia": "CN",
            "cap": "12088",
            "cod_catastale": "H407",
            "cod_istat": "004190",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 574,
            "giorni": 2862,
            "area": "",
            "ech": 0
        },
        {
            "id": 5842,
            "name": "Roccaforzata",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "H409",
            "cod_istat": "073023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 1303,
            "area": "",
            "ech": 0
        },
        {
            "id": 5843,
            "name": "Roccafranca",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "H410",
            "cod_istat": "017162",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 5844,
            "name": "Roccagiovine",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "H411",
            "cod_istat": "058087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2203,
            "area": "",
            "ech": 0
        },
        {
            "id": 5845,
            "name": "Roccagloriosa",
            "provincia": "SA",
            "cap": "84060",
            "cod_catastale": "H412",
            "cod_istat": "065107",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1582,
            "area": "",
            "ech": 0
        },
        {
            "id": 5846,
            "name": "Roccagorga",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "H413",
            "cod_istat": "059021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 1602,
            "area": "",
            "ech": 0
        },
        {
            "id": 5847,
            "name": "Roccalbegna",
            "provincia": "GR",
            "cap": "58053",
            "cod_catastale": "H417",
            "cod_istat": "053020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 522,
            "giorni": 2247,
            "area": "",
            "ech": 0
        },
        {
            "id": 5848,
            "name": "Roccalumera",
            "provincia": "ME",
            "cap": "98027",
            "cod_catastale": "H418",
            "cod_istat": "083072",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 638,
            "area": "",
            "ech": 0
        },
        {
            "id": 5849,
            "name": "Roccamandolfi",
            "provincia": "IS",
            "cap": "86092",
            "cod_catastale": "H420",
            "cod_istat": "094040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 2560,
            "area": "",
            "ech": 0
        },
        {
            "id": 5850,
            "name": "Roccamena",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "H422",
            "cod_istat": "082061",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 480,
            "giorni": 1346,
            "area": "",
            "ech": 0
        },
        {
            "id": 5851,
            "name": "Roccamonfina",
            "provincia": "CE",
            "cap": "81035",
            "cod_catastale": "H423",
            "cod_istat": "061070",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 612,
            "giorni": 2255,
            "area": "",
            "ech": 0
        },
        {
            "id": 5852,
            "name": "Roccamontepiano",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "H424",
            "cod_istat": "069073",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 458,
            "giorni": 1883,
            "area": "",
            "ech": 0
        },
        {
            "id": 5853,
            "name": "Roccamorice",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "H425",
            "cod_istat": "068034",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 2055,
            "area": "",
            "ech": 0
        },
        {
            "id": 5854,
            "name": "Roccanova",
            "provincia": "PZ",
            "cap": "85036",
            "cod_catastale": "H426",
            "cod_istat": "076069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 648,
            "giorni": 2087,
            "area": "",
            "ech": 0
        },
        {
            "id": 5855,
            "name": "Roccantica",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "H427",
            "cod_istat": "057061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 457,
            "giorni": 2196,
            "area": "",
            "ech": 0
        },
        {
            "id": 5856,
            "name": "Roccapalumba",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "H428",
            "cod_istat": "082062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 1457,
            "area": "",
            "ech": 0
        },
        {
            "id": 5857,
            "name": "Roccapiemonte",
            "provincia": "SA",
            "cap": "84086",
            "cod_catastale": "H431",
            "cod_istat": "065108",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 1248,
            "area": "",
            "ech": 0
        },
        {
            "id": 5858,
            "name": "Roccarainola",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "H433",
            "cod_istat": "063065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 1135,
            "area": "",
            "ech": 0
        },
        {
            "id": 5859,
            "name": "Roccaraso",
            "provincia": "AQ",
            "cap": "67037",
            "cod_catastale": "H434",
            "cod_istat": "066084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1236,
            "giorni": 3218,
            "area": "",
            "ech": 0
        },
        {
            "id": 5860,
            "name": "Roccaromana",
            "provincia": "CE",
            "cap": "81051",
            "cod_catastale": "H436",
            "cod_istat": "061071",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 180,
            "giorni": 1407,
            "area": "",
            "ech": 0
        },
        {
            "id": 5861,
            "name": "Roccascalegna",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "H442",
            "cod_istat": "069075",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 455,
            "giorni": 1879,
            "area": "",
            "ech": 0
        },
        {
            "id": 5862,
            "name": "Roccasecca",
            "provincia": "FR",
            "cap": "03038",
            "cod_catastale": "H443",
            "cod_istat": "060060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 1589,
            "area": "",
            "ech": 0
        },
        {
            "id": 5863,
            "name": "Roccasecca dei Volsci",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "H444",
            "cod_istat": "059023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 376,
            "giorni": 1766,
            "area": "",
            "ech": 0
        },
        {
            "id": 5864,
            "name": "Roccasicura",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "H445",
            "cod_istat": "094041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 758,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 5865,
            "name": "Roccasparvera",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "H447",
            "cod_istat": "004191",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 674,
            "giorni": 3151,
            "area": "",
            "ech": 0
        },
        {
            "id": 5866,
            "name": "Roccaspinalveti",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "H448",
            "cod_istat": "069076",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 5867,
            "name": "Roccastrada",
            "provincia": "GR",
            "cap": "58036",
            "cod_catastale": "H449",
            "cod_istat": "053021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2181,
            "area": "",
            "ech": 0
        },
        {
            "id": 5868,
            "name": "Roccavaldina",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "H380",
            "cod_istat": "083073",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 5869,
            "name": "Roccaverano",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "H451",
            "cod_istat": "005094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 759,
            "giorni": 3120,
            "area": "",
            "ech": 0
        },
        {
            "id": 5870,
            "name": "Roccavignale",
            "provincia": "SV",
            "cap": "17017",
            "cod_catastale": "H452",
            "cod_istat": "009054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 2594,
            "area": "",
            "ech": 0
        },
        {
            "id": 5871,
            "name": "Roccavione",
            "provincia": "CN",
            "cap": "12018",
            "cod_catastale": "H453",
            "cod_istat": "004192",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 646,
            "giorni": 3116,
            "area": "",
            "ech": 0
        },
        {
            "id": 5872,
            "name": "Roccavivara",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "H454",
            "cod_istat": "070060",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2202,
            "area": "",
            "ech": 0
        },
        {
            "id": 5873,
            "name": "Roccella Ionica",
            "provincia": "RC",
            "cap": "89047",
            "cod_catastale": "H456",
            "cod_istat": "080067",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 793,
            "area": "",
            "ech": 1
        },
        {
            "id": 5874,
            "name": "Roccella Valdemone",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "H455",
            "cod_istat": "083074",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 812,
            "giorni": 2015,
            "area": "",
            "ech": 1
        },
        {
            "id": 5875,
            "name": "Rocchetta a Volturno",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "H458",
            "cod_istat": "094042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 2055,
            "area": "",
            "ech": 0
        },
        {
            "id": 5876,
            "name": "Rocchetta Belbo",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "H462",
            "cod_istat": "004193",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2654,
            "area": "",
            "ech": 0
        },
        {
            "id": 5877,
            "name": "Rocchetta di Vara",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "H461",
            "cod_istat": "011025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1934,
            "area": "",
            "ech": 0
        },
        {
            "id": 5878,
            "name": "Rocchetta e Croce",
            "provincia": "CE",
            "cap": "81042",
            "cod_catastale": "H459",
            "cod_istat": "061072",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 459,
            "giorni": 1972,
            "area": "",
            "ech": 0
        },
        {
            "id": 5879,
            "name": "Rocchetta Ligure",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "H465",
            "cod_istat": "006148",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 5880,
            "name": "Rocchetta Nervina",
            "provincia": "IM",
            "cap": "18030",
            "cod_catastale": "H460",
            "cod_istat": "008051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 1606,
            "area": "",
            "ech": 0
        },
        {
            "id": 5881,
            "name": "Rocchetta Palafea",
            "provincia": "AT",
            "cap": "14042",
            "cod_catastale": "H466",
            "cod_istat": "005095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 423,
            "giorni": 2837,
            "area": "",
            "ech": 0
        },
        {
            "id": 5882,
            "name": "Rocchetta Sant'Antonio",
            "provincia": "FG",
            "cap": "71020",
            "cod_catastale": "H467",
            "cod_istat": "071042",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 633,
            "giorni": 2263,
            "area": "",
            "ech": 0
        },
        {
            "id": 5883,
            "name": "Rocchetta Tanaro",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "H468",
            "cod_istat": "005096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 5884,
            "name": "Rodano",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "H470",
            "cod_istat": "015185",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 5885,
            "name": "Roddi",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "H472",
            "cod_istat": "004194",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 284,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 5886,
            "name": "Roddino",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "H473",
            "cod_istat": "004195",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 3071,
            "area": "",
            "ech": 0
        },
        {
            "id": 5887,
            "name": "Rodello",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "H474",
            "cod_istat": "004196",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 537,
            "giorni": 2981,
            "area": "",
            "ech": 0
        },
        {
            "id": 5888,
            "name": "Rodengo",
            "provincia": "BZ",
            "cap": "39037",
            "cod_catastale": "H475",
            "cod_istat": "021075",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 885,
            "giorni": 3832,
            "area": "",
            "ech": 0
        },
        {
            "id": 5889,
            "name": "Rodengo Saiano",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "H477",
            "cod_istat": "017163",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5890,
            "name": "Rodero",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "H478",
            "cod_istat": "013197",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 5891,
            "name": "Rodi Garganico",
            "provincia": "FG",
            "cap": "71012",
            "cod_catastale": "H480",
            "cod_istat": "071043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 1353,
            "area": "",
            "ech": 0
        },
        {
            "id": 5892,
            "name": "Rodì Milici",
            "provincia": "ME",
            "cap": "98059",
            "cod_catastale": "H479",
            "cod_istat": "083075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 929,
            "area": "",
            "ech": 1
        },
        {
            "id": 5893,
            "name": "Rodigo",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "H481",
            "cod_istat": "020051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5894,
            "name": "Roè Volciano",
            "provincia": "BS",
            "cap": "25077",
            "cod_catastale": "H484",
            "cod_istat": "017164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2553,
            "area": "",
            "ech": 0
        },
        {
            "id": 5895,
            "name": "Rofrano",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "H485",
            "cod_istat": "065109",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1607,
            "area": "",
            "ech": 0
        },
        {
            "id": 5896,
            "name": "Rogeno",
            "provincia": "LC",
            "cap": "23849",
            "cod_catastale": "H486",
            "cod_istat": "097072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 5897,
            "name": "Roggiano Gravina",
            "provincia": "CS",
            "cap": "87017",
            "cod_catastale": "H488",
            "cod_istat": "078104",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1348,
            "area": "",
            "ech": 0
        },
        {
            "id": 5898,
            "name": "Roghudi",
            "provincia": "RC",
            "cap": "89060",
            "cod_catastale": "H489",
            "cod_istat": "080068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1001,
            "area": "",
            "ech": 1
        },
        {
            "id": 5899,
            "name": "Rogliano",
            "provincia": "CS",
            "cap": "87054",
            "cod_catastale": "H490",
            "cod_istat": "078105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 2122,
            "area": "",
            "ech": 0
        },
        {
            "id": 5900,
            "name": "Rognano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "H491",
            "cod_istat": "018127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 5901,
            "name": "Rogno",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "H492",
            "cod_istat": "016182",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 5902,
            "name": "Rogolo",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "H493",
            "cod_istat": "014056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 3002,
            "area": "",
            "ech": 0
        },
        {
            "id": 5903,
            "name": "Roiate",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "H494",
            "cod_istat": "058090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 697,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 5904,
            "name": "Roio del Sangro",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "H495",
            "cod_istat": "069077",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 870,
            "giorni": 2449,
            "area": "",
            "ech": 0
        },
        {
            "id": 5905,
            "name": "Roisan",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H497",
            "cod_istat": "007057",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 3327,
            "area": "",
            "ech": 0
        },
        {
            "id": 5906,
            "name": "Roletto",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "H498",
            "cod_istat": "001222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2868,
            "area": "",
            "ech": 0
        },
        {
            "id": 5907,
            "name": "Rolo",
            "provincia": "RE",
            "cap": "42047",
            "cod_catastale": "H500",
            "cod_istat": "035035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 5908,
            "name": "Roma",
            "provincia": "RM",
            "cap": "001xx",
            "cod_catastale": "H501",
            "cod_istat": "058091",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1415,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 5909,
            "name": "Romagnano al Monte",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "H503",
            "cod_istat": "065110",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 635,
            "giorni": 2083,
            "area": "",
            "ech": 0
        },
        {
            "id": 5910,
            "name": "Romagnano Sesia",
            "provincia": "NO",
            "cap": "28078",
            "cod_catastale": "H502",
            "cod_istat": "003130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2509,
            "area": "",
            "ech": 0
        },
        {
            "id": 5911,
            "name": "Romagnese",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "H505",
            "cod_istat": "018128",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 3265,
            "area": "",
            "ech": 0
        },
        {
            "id": 5912,
            "name": "Romallo",
            "provincia": "TN",
            "cap": "38028",
            "cod_catastale": "H506",
            "cod_istat": "022154",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 733,
            "giorni": 3534,
            "area": "",
            "ech": 0
        },
        {
            "id": 5913,
            "name": "Romana",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "H507",
            "cod_istat": "090061",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 267,
            "giorni": 1423,
            "area": "",
            "ech": 0
        },
        {
            "id": 5914,
            "name": "Romanengo",
            "provincia": "CR",
            "cap": "26014",
            "cod_catastale": "H508",
            "cod_istat": "019086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2320,
            "area": "",
            "ech": 0
        },
        {
            "id": 5915,
            "name": "Romano Canavese",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H511",
            "cod_istat": "001223",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2762,
            "area": "",
            "ech": 0
        },
        {
            "id": 5916,
            "name": "Romano d'Ezzelino",
            "provincia": "VI",
            "cap": "36060",
            "cod_catastale": "H512",
            "cod_istat": "024086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 5917,
            "name": "Romano di Lombardia",
            "provincia": "BG",
            "cap": "24058",
            "cod_catastale": "H509",
            "cod_istat": "016183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 5918,
            "name": "Romans d'Isonzo",
            "provincia": "GO",
            "cap": "34076",
            "cod_catastale": "H514",
            "cod_istat": "031015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2241,
            "area": "",
            "ech": 0
        },
        {
            "id": 5919,
            "name": "Rombiolo",
            "provincia": "VV",
            "cap": "89841",
            "cod_catastale": "H516",
            "cod_istat": "102031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1552,
            "area": "",
            "ech": 0
        },
        {
            "id": 5920,
            "name": "Romeno",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "H517",
            "cod_istat": "022155",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 961,
            "giorni": 3890,
            "area": "",
            "ech": 0
        },
        {
            "id": 5921,
            "name": "Romentino",
            "provincia": "NO",
            "cap": "28068",
            "cod_catastale": "H518",
            "cod_istat": "003131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 146,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 5922,
            "name": "Rometta",
            "provincia": "ME",
            "cap": "98043",
            "cod_catastale": "H519",
            "cod_istat": "083076",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 1584,
            "area": "SICI",
            "ech": 0
        },
        {
            "id": 5923,
            "name": "Ronago",
            "provincia": "CO",
            "cap": "22027",
            "cod_catastale": "H521",
            "cod_istat": "013199",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2637,
            "area": "",
            "ech": 0
        },
        {
            "id": 5924,
            "name": "Roncà",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "H522",
            "cod_istat": "023063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2424,
            "area": "",
            "ech": 0
        },
        {
            "id": 5925,
            "name": "Roncade",
            "provincia": "TV",
            "cap": "31056",
            "cod_catastale": "H523",
            "cod_istat": "026069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 5926,
            "name": "Roncadelle",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "H525",
            "cod_istat": "017165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 118,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 5927,
            "name": "Roncaro",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "H527",
            "cod_istat": "018129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 81,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 5928,
            "name": "Roncegno Terme",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "H528",
            "cod_istat": "022156",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 5929,
            "name": "Roncello",
            "provincia": "MB",
            "cap": "20877",
            "cod_catastale": "H529",
            "cod_istat": "108055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 196,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 5930,
            "name": "Ronchi dei Legionari",
            "provincia": "GO",
            "cap": "34077",
            "cod_catastale": "H531",
            "cod_istat": "031016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2255,
            "area": "",
            "ech": 0
        },
        {
            "id": 5931,
            "name": "Ronchi Valsugana",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "H532",
            "cod_istat": "022157",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 776,
            "giorni": 3601,
            "area": "",
            "ech": 0
        },
        {
            "id": 5932,
            "name": "Ronchis",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "H533",
            "cod_istat": "030097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 5933,
            "name": "Ronciglione",
            "provincia": "VT",
            "cap": "01037",
            "cod_catastale": "H534",
            "cod_istat": "056045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2203,
            "area": "",
            "ech": 0
        },
        {
            "id": 5934,
            "name": "Ronco all'Adige",
            "provincia": "VR",
            "cap": "37055",
            "cod_catastale": "H540",
            "cod_istat": "023064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2335,
            "area": "",
            "ech": 0
        },
        {
            "id": 5935,
            "name": "Ronco Biellese",
            "provincia": "BI",
            "cap": "13845",
            "cod_catastale": "H538",
            "cod_istat": "096053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 5936,
            "name": "Ronco Briantino",
            "provincia": "MB",
            "cap": "20885",
            "cod_catastale": "H537",
            "cod_istat": "108038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2441,
            "area": "",
            "ech": 0
        },
        {
            "id": 5937,
            "name": "Ronco Canavese",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H539",
            "cod_istat": "001224",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 956,
            "giorni": 3716,
            "area": "",
            "ech": 0
        },
        {
            "id": 5938,
            "name": "Ronco Scrivia",
            "provincia": "GE",
            "cap": "16019",
            "cod_catastale": "H536",
            "cod_istat": "010049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2273,
            "area": "",
            "ech": 0
        },
        {
            "id": 5939,
            "name": "Roncobello",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "H535",
            "cod_istat": "016184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1007,
            "giorni": 3500,
            "area": "",
            "ech": 0
        },
        {
            "id": 5940,
            "name": "Roncoferraro",
            "provincia": "MN",
            "cap": "46037",
            "cod_catastale": "H541",
            "cod_istat": "020052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5941,
            "name": "Roncofreddo",
            "provincia": "FC",
            "cap": "47020",
            "cod_catastale": "H542",
            "cod_istat": "040037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 2558,
            "area": "",
            "ech": 0
        },
        {
            "id": 5942,
            "name": "Roncola",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "H544",
            "cod_istat": "016185",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 3282,
            "area": "",
            "ech": 0
        },
        {
            "id": 5943,
            "name": "Roncone",
            "provincia": "TN",
            "cap": "38087",
            "cod_catastale": "H545",
            "cod_istat": "022158",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 842,
            "giorni": 3704,
            "area": "",
            "ech": 0
        },
        {
            "id": 5944,
            "name": "Rondanina",
            "provincia": "GE",
            "cap": "16025",
            "cod_catastale": "H546",
            "cod_istat": "010050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 981,
            "giorni": 3821,
            "area": "",
            "ech": 0
        },
        {
            "id": 5945,
            "name": "Rondissone",
            "provincia": "TO",
            "cap": "10030",
            "cod_catastale": "H547",
            "cod_istat": "001225",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2670,
            "area": "",
            "ech": 0
        },
        {
            "id": 5946,
            "name": "Ronsecco",
            "provincia": "VC",
            "cap": "13036",
            "cod_catastale": "H549",
            "cod_istat": "002118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 2771,
            "area": "",
            "ech": 0
        },
        {
            "id": 5947,
            "name": "Ronzo-Chienis",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "M303",
            "cod_istat": "022135",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 974,
            "giorni": 3837,
            "area": "",
            "ech": 0
        },
        {
            "id": 5948,
            "name": "Ronzone",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "H552",
            "cod_istat": "022159",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1085,
            "giorni": 4082,
            "area": "",
            "ech": 0
        },
        {
            "id": 5949,
            "name": "Roppolo",
            "provincia": "BI",
            "cap": "13883",
            "cod_catastale": "H553",
            "cod_istat": "096054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 5950,
            "name": "Rorà",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "H554",
            "cod_istat": "001226",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 967,
            "giorni": 3804,
            "area": "",
            "ech": 0
        },
        {
            "id": 5951,
            "name": "Rosà",
            "provincia": "VI",
            "cap": "36027",
            "cod_catastale": "H556",
            "cod_istat": "024087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2419,
            "area": "",
            "ech": 0
        },
        {
            "id": 5952,
            "name": "Rosarno",
            "provincia": "RC",
            "cap": "89025",
            "cod_catastale": "H558",
            "cod_istat": "080069",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 823,
            "area": "",
            "ech": 0
        },
        {
            "id": 5953,
            "name": "Rosasco",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "H559",
            "cod_istat": "018130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 5954,
            "name": "Rosate",
            "provincia": "MI",
            "cap": "20088",
            "cod_catastale": "H560",
            "cod_istat": "015188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 5955,
            "name": "Rosazza",
            "provincia": "BI",
            "cap": "13815",
            "cod_catastale": "H561",
            "cod_istat": "096055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 882,
            "giorni": 3451,
            "area": "",
            "ech": 0
        },
        {
            "id": 5956,
            "name": "Rosciano",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "H562",
            "cod_istat": "068035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 1621,
            "area": "",
            "ech": 0
        },
        {
            "id": 5957,
            "name": "Roscigno",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "H564",
            "cod_istat": "065111",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 570,
            "giorni": 1850,
            "area": "",
            "ech": 0
        },
        {
            "id": 5958,
            "name": "Rose",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "H565",
            "cod_istat": "078106",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 399,
            "giorni": 1605,
            "area": "",
            "ech": 0
        },
        {
            "id": 5959,
            "name": "Rosello",
            "provincia": "CH",
            "cap": "66040",
            "cod_catastale": "H566",
            "cod_istat": "069078",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 920,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 5960,
            "name": "Roseto Capo Spulico",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "H572",
            "cod_istat": "078107",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 1244,
            "area": "",
            "ech": 0
        },
        {
            "id": 5961,
            "name": "Roseto degli Abruzzi",
            "provincia": "TE",
            "cap": "64026",
            "cod_catastale": "F585",
            "cod_istat": "067037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1282,
            "area": "",
            "ech": 0
        },
        {
            "id": 5962,
            "name": "Roseto Valfortore",
            "provincia": "FG",
            "cap": "71039",
            "cod_catastale": "H568",
            "cod_istat": "071044",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 658,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 5963,
            "name": "Rosignano Marittimo",
            "provincia": "LI",
            "cap": "57016",
            "cod_catastale": "H570",
            "cod_istat": "049017",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 1640,
            "area": "",
            "ech": 0
        },
        {
            "id": 5964,
            "name": "Rosignano Monferrato",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "H569",
            "cod_istat": "006149",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2717,
            "area": "",
            "ech": 0
        },
        {
            "id": 5965,
            "name": "Rosolina",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "H573",
            "cod_istat": "029040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 5966,
            "name": "Rosolini",
            "provincia": "SR",
            "cap": "96019",
            "cod_catastale": "H574",
            "cod_istat": "089016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 954,
            "area": "SICI",
            "ech": 1
        },
        {
            "id": 5967,
            "name": "Rosora",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "H575",
            "cod_istat": "042040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2123,
            "area": "",
            "ech": 0
        },
        {
            "id": 5968,
            "name": "Rossa",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "H577",
            "cod_istat": "002121",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 813,
            "giorni": 3361,
            "area": "",
            "ech": 0
        },
        {
            "id": 5969,
            "name": "Rossana",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "H578",
            "cod_istat": "004197",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 535,
            "giorni": 2978,
            "area": "",
            "ech": 0
        },
        {
            "id": 5970,
            "name": "Rossano",
            "provincia": "CS",
            "cap": "87067",
            "cod_catastale": "H579",
            "cod_istat": "078142",
            "attivo": 0,
            "zona": "C",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1146,
            "area": "",
            "ech": 0
        },
        {
            "id": 5971,
            "name": "Rossano Veneto",
            "provincia": "VI",
            "cap": "36028",
            "cod_catastale": "H580",
            "cod_istat": "024088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2366,
            "area": "",
            "ech": 0
        },
        {
            "id": 5972,
            "name": "Rossiglione",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "H581",
            "cod_istat": "010051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 297,
            "giorni": 2497,
            "area": "",
            "ech": 0
        },
        {
            "id": 5973,
            "name": "Rosta",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H583",
            "cod_istat": "001228",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 399,
            "giorni": 2952,
            "area": "",
            "ech": 0
        },
        {
            "id": 5974,
            "name": "Rota d'Imagna",
            "provincia": "BG",
            "cap": "24037",
            "cod_catastale": "H584",
            "cod_istat": "016186",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 690,
            "giorni": 3049,
            "area": "",
            "ech": 0
        },
        {
            "id": 5975,
            "name": "Rota Greca",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "H585",
            "cod_istat": "078109",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 1939,
            "area": "",
            "ech": 0
        },
        {
            "id": 5976,
            "name": "Rotella",
            "provincia": "AP",
            "cap": "63071",
            "cod_catastale": "H588",
            "cod_istat": "044065",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 395,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 5977,
            "name": "Rotello",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "H589",
            "cod_istat": "070061",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 1766,
            "area": "",
            "ech": 0
        },
        {
            "id": 5978,
            "name": "Rotonda",
            "provincia": "PZ",
            "cap": "85048",
            "cod_catastale": "H590",
            "cod_istat": "076070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 580,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 5979,
            "name": "Rotondella",
            "provincia": "MT",
            "cap": "75026",
            "cod_catastale": "H591",
            "cod_istat": "077023",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 576,
            "giorni": 1925,
            "area": "",
            "ech": 0
        },
        {
            "id": 5980,
            "name": "Rotondi",
            "provincia": "AV",
            "cap": "83017",
            "cod_catastale": "H592",
            "cod_istat": "064080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 1688,
            "area": "",
            "ech": 0
        },
        {
            "id": 5981,
            "name": "Rottofreno",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "H593",
            "cod_istat": "033039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 5982,
            "name": "Rotzo",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "H594",
            "cod_istat": "024089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 939,
            "giorni": 4281,
            "area": "",
            "ech": 0
        },
        {
            "id": 5983,
            "name": "Roure",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "H555",
            "cod_istat": "001227",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 860,
            "giorni": 3644,
            "area": "",
            "ech": 0
        },
        {
            "id": 5984,
            "name": "Rovagnate",
            "provincia": "LC",
            "cap": "23888",
            "cod_catastale": "H596",
            "cod_istat": "097073",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2555,
            "area": "",
            "ech": 0
        },
        {
            "id": 5985,
            "name": "Rovasenda",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "H364",
            "cod_istat": "002122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 5986,
            "name": "Rovato",
            "provincia": "BS",
            "cap": "25038",
            "cod_catastale": "H598",
            "cod_istat": "017166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 5987,
            "name": "Rovegno",
            "provincia": "GE",
            "cap": "16028",
            "cod_catastale": "H599",
            "cod_istat": "010052",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 658,
            "giorni": 3159,
            "area": "",
            "ech": 0
        },
        {
            "id": 5988,
            "name": "Rovellasca",
            "provincia": "CO",
            "cap": "22069",
            "cod_catastale": "H601",
            "cod_istat": "013201",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 244,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 5989,
            "name": "Rovello Porro",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "H602",
            "cod_istat": "013202",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 5990,
            "name": "Roverbella",
            "provincia": "MN",
            "cap": "46048",
            "cod_catastale": "H604",
            "cod_istat": "020053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 5991,
            "name": "Roverchiara",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "H606",
            "cod_istat": "023065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2330,
            "area": "",
            "ech": 0
        },
        {
            "id": 5992,
            "name": "Roverè della Luna",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "H607",
            "cod_istat": "022160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 2888,
            "area": "",
            "ech": 0
        },
        {
            "id": 5993,
            "name": "Roverè Veronese",
            "provincia": "VR",
            "cap": "37028",
            "cod_catastale": "H608",
            "cod_istat": "023067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 843,
            "giorni": 3663,
            "area": "",
            "ech": 0
        },
        {
            "id": 5994,
            "name": "Roveredo di Guà",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "H610",
            "cod_istat": "023066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2455,
            "area": "",
            "ech": 0
        },
        {
            "id": 5995,
            "name": "Roveredo in Piano",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "H609",
            "cod_istat": "093036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 5996,
            "name": "Rovereto",
            "provincia": "TN",
            "cap": "38068",
            "cod_catastale": "H612",
            "cod_istat": "022161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 5997,
            "name": "Rovescala",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "H614",
            "cod_istat": "018131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 5998,
            "name": "Rovetta",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "H615",
            "cod_istat": "016187",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 658,
            "giorni": 3014,
            "area": "",
            "ech": 0
        },
        {
            "id": 5999,
            "name": "Roviano",
            "provincia": "RM",
            "cap": "00027",
            "cod_catastale": "H618",
            "cod_istat": "058092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 6000,
            "name": "Rovigo",
            "provincia": "RO",
            "cap": "45100",
            "cod_catastale": "H620",
            "cod_istat": "029041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6001,
            "name": "Rovito",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "H621",
            "cod_istat": "078110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 744,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 6002,
            "name": "Rovolon",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "H622",
            "cod_istat": "028071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 6003,
            "name": "Rozzano",
            "provincia": "MI",
            "cap": "20089",
            "cod_catastale": "H623",
            "cod_istat": "015189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6004,
            "name": "Rubano",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "H625",
            "cod_istat": "028072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 6005,
            "name": "Rubiana",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "H627",
            "cod_istat": "001229",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3314,
            "area": "",
            "ech": 0
        },
        {
            "id": 6006,
            "name": "Rubiera",
            "provincia": "RE",
            "cap": "42048",
            "cod_catastale": "H628",
            "cod_istat": "035036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 53,
            "giorni": 2419,
            "area": "",
            "ech": 0
        },
        {
            "id": 6007,
            "name": "Ruda",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "H629",
            "cod_istat": "030098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2257,
            "area": "",
            "ech": 0
        },
        {
            "id": 6008,
            "name": "Rudiano",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "H630",
            "cod_istat": "017167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 6009,
            "name": "Rueglio",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H631",
            "cod_istat": "001230",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 675,
            "giorni": 3268,
            "area": "",
            "ech": 0
        },
        {
            "id": 6010,
            "name": "Ruffano",
            "provincia": "LE",
            "cap": "73049",
            "cod_catastale": "H632",
            "cod_istat": "075064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 1362,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6011,
            "name": "Ruffia",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "H633",
            "cod_istat": "004198",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 6012,
            "name": "Ruffrè-Mendola",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "H634",
            "cod_istat": "022162",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6013,
            "name": "Rufina",
            "provincia": "FI",
            "cap": "50068",
            "cod_catastale": "H635",
            "cod_istat": "048037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 1939,
            "area": "",
            "ech": 0
        },
        {
            "id": 6014,
            "name": "Ruinas",
            "provincia": "OR",
            "cap": "09085",
            "cod_catastale": "F271",
            "cod_istat": "095044",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 359,
            "giorni": 1436,
            "area": "",
            "ech": 0
        },
        {
            "id": 6015,
            "name": "Ruino",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "H637",
            "cod_istat": "018132",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 526,
            "giorni": 3100,
            "area": "",
            "ech": 0
        },
        {
            "id": 6016,
            "name": "Rumo",
            "provincia": "TN",
            "cap": "38020",
            "cod_catastale": "H639",
            "cod_istat": "022163",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 944,
            "giorni": 3863,
            "area": "",
            "ech": 0
        },
        {
            "id": 6017,
            "name": "Ruoti",
            "provincia": "PZ",
            "cap": "85056",
            "cod_catastale": "H641",
            "cod_istat": "076071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 751,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 6018,
            "name": "Russi",
            "provincia": "RA",
            "cap": "48026",
            "cod_catastale": "H642",
            "cod_istat": "039016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2469,
            "area": "",
            "ech": 0
        },
        {
            "id": 6019,
            "name": "Rutigliano",
            "provincia": "BA",
            "cap": "70018",
            "cod_catastale": "H643",
            "cod_istat": "072037",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1360,
            "area": "",
            "ech": 0
        },
        {
            "id": 6020,
            "name": "Rutino",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "H644",
            "cod_istat": "065112",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 371,
            "giorni": 1467,
            "area": "",
            "ech": 0
        },
        {
            "id": 6021,
            "name": "Ruviano",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "H165",
            "cod_istat": "061073",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 80,
            "giorni": 1202,
            "area": "",
            "ech": 0
        },
        {
            "id": 6022,
            "name": "Ruvo del Monte",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "H646",
            "cod_istat": "076072",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 638,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 6023,
            "name": "Ruvo di Puglia",
            "provincia": "BA",
            "cap": "70037",
            "cod_catastale": "H645",
            "cod_istat": "072038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 256,
            "giorni": 1579,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6024,
            "name": "Sabaudia",
            "provincia": "LT",
            "cap": "04016",
            "cod_catastale": "H647",
            "cod_istat": "059024",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 1171,
            "area": "",
            "ech": 0
        },
        {
            "id": 6025,
            "name": "Sabbia",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "H648",
            "cod_istat": "002123",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 728,
            "giorni": 3251,
            "area": "",
            "ech": 0
        },
        {
            "id": 6026,
            "name": "Sabbio Chiese",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "H650",
            "cod_istat": "017168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2610,
            "area": "",
            "ech": 0
        },
        {
            "id": 6027,
            "name": "Sabbioneta",
            "provincia": "MN",
            "cap": "46018",
            "cod_catastale": "H652",
            "cod_istat": "020054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 6028,
            "name": "Sacco",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "H654",
            "cod_istat": "065113",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 1971,
            "area": "",
            "ech": 0
        },
        {
            "id": 6029,
            "name": "Saccolongo",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "H655",
            "cod_istat": "028073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 6030,
            "name": "Sacile",
            "provincia": "PN",
            "cap": "33077",
            "cod_catastale": "H657",
            "cod_istat": "093037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2461,
            "area": "",
            "ech": 0
        },
        {
            "id": 6031,
            "name": "Sacrofano",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "H658",
            "cod_istat": "058093",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1751,
            "area": "",
            "ech": 0
        },
        {
            "id": 6032,
            "name": "Sadali",
            "provincia": "SU",
            "cap": "09062",
            "cod_catastale": "H659",
            "cod_istat": "111058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 705,
            "giorni": 1904,
            "area": "",
            "ech": 0
        },
        {
            "id": 6033,
            "name": "Sagama",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "H661",
            "cod_istat": "095086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 1313,
            "area": "",
            "ech": 0
        },
        {
            "id": 6034,
            "name": "Sagliano Micca",
            "provincia": "BI",
            "cap": "13816",
            "cod_catastale": "H662",
            "cod_istat": "096056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 589,
            "giorni": 3070,
            "area": "",
            "ech": 0
        },
        {
            "id": 6035,
            "name": "Sagrado",
            "provincia": "GO",
            "cap": "34078",
            "cod_catastale": "H665",
            "cod_istat": "031017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2258,
            "area": "",
            "ech": 0
        },
        {
            "id": 6036,
            "name": "Sagron Mis",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "H666",
            "cod_istat": "022164",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1062,
            "giorni": 4047,
            "area": "",
            "ech": 0
        },
        {
            "id": 6037,
            "name": "Saint-Christophe",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "H669",
            "cod_istat": "007058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 619,
            "giorni": 2904,
            "area": "",
            "ech": 0
        },
        {
            "id": 6038,
            "name": "Saint-Denis",
            "provincia": "AO",
            "cap": "11023",
            "cod_catastale": "H670",
            "cod_istat": "007059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 3424,
            "area": "",
            "ech": 0
        },
        {
            "id": 6039,
            "name": "Saint-Marcel",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "H671",
            "cod_istat": "007060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2913,
            "area": "",
            "ech": 0
        },
        {
            "id": 6040,
            "name": "Saint-Nicolas",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H672",
            "cod_istat": "007061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1200,
            "giorni": 4032,
            "area": "",
            "ech": 0
        },
        {
            "id": 6041,
            "name": "Saint-Oyen",
            "provincia": "AO",
            "cap": "11014",
            "cod_catastale": "H673",
            "cod_istat": "007062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1372,
            "giorni": 4292,
            "area": "",
            "ech": 0
        },
        {
            "id": 6042,
            "name": "Saint-Pierre",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H674",
            "cod_istat": "007063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 676,
            "giorni": 3263,
            "area": "",
            "ech": 0
        },
        {
            "id": 6043,
            "name": "Saint-Rhémy-en-Bosses",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "H675",
            "cod_istat": "007064",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6044,
            "name": "Saint-Vincent",
            "provincia": "AO",
            "cap": "11027",
            "cod_catastale": "H676",
            "cod_istat": "007065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 3053,
            "area": "",
            "ech": 0
        },
        {
            "id": 6045,
            "name": "Sala Baganza",
            "provincia": "PR",
            "cap": "43038",
            "cod_catastale": "H682",
            "cod_istat": "034031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 6046,
            "name": "Sala Biellese",
            "provincia": "BI",
            "cap": "13884",
            "cod_catastale": "H681",
            "cod_istat": "096057",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 626,
            "giorni": 3118,
            "area": "",
            "ech": 0
        },
        {
            "id": 6047,
            "name": "Sala Bolognese",
            "provincia": "BO",
            "cap": "40010",
            "cod_catastale": "H678",
            "cod_istat": "037050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2338,
            "area": "",
            "ech": 0
        },
        {
            "id": 6048,
            "name": "Sala Comacina",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "H679",
            "cod_istat": "013203",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2372,
            "area": "",
            "ech": 0
        },
        {
            "id": 6049,
            "name": "Sala Consilina",
            "provincia": "SA",
            "cap": "84036",
            "cod_catastale": "H683",
            "cod_istat": "065114",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 614,
            "giorni": 2033,
            "area": "",
            "ech": 0
        },
        {
            "id": 6050,
            "name": "Sala Monferrato",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "H677",
            "cod_istat": "006150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 6051,
            "name": "Salandra",
            "provincia": "MT",
            "cap": "75017",
            "cod_catastale": "H687",
            "cod_istat": "077024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 1959,
            "area": "",
            "ech": 0
        },
        {
            "id": 6052,
            "name": "Salaparuta",
            "provincia": "TP",
            "cap": "91020",
            "cod_catastale": "H688",
            "cod_istat": "081017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 1259,
            "area": "",
            "ech": 1
        },
        {
            "id": 6053,
            "name": "Salara",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "H689",
            "cod_istat": "029042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6054,
            "name": "Salasco",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "H690",
            "cod_istat": "002126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 148,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 6055,
            "name": "Salassa",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H691",
            "cod_istat": "001231",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 349,
            "giorni": 2668,
            "area": "",
            "ech": 0
        },
        {
            "id": 6056,
            "name": "Salbertrand",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "H684",
            "cod_istat": "001232",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1032,
            "giorni": 3998,
            "area": "",
            "ech": 0
        },
        {
            "id": 6057,
            "name": "Salcedo",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "F810",
            "cod_istat": "024090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 6058,
            "name": "Salcito",
            "provincia": "CB",
            "cap": "86026",
            "cod_catastale": "H693",
            "cod_istat": "070062",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 678,
            "giorni": 2242,
            "area": "",
            "ech": 0
        },
        {
            "id": 6059,
            "name": "Sale",
            "provincia": "AL",
            "cap": "15045",
            "cod_catastale": "H694",
            "cod_istat": "006151",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 6060,
            "name": "Sale delle Langhe",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "H695",
            "cod_istat": "004199",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2910,
            "area": "",
            "ech": 0
        },
        {
            "id": 6061,
            "name": "Sale Marasino",
            "provincia": "BS",
            "cap": "25057",
            "cod_catastale": "H699",
            "cod_istat": "017169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2497,
            "area": "",
            "ech": 0
        },
        {
            "id": 6062,
            "name": "Sale San Giovanni",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "H704",
            "cod_istat": "004200",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 615,
            "giorni": 3078,
            "area": "",
            "ech": 0
        },
        {
            "id": 6063,
            "name": "Salemi",
            "provincia": "TP",
            "cap": "91018",
            "cod_catastale": "H700",
            "cod_istat": "081018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 446,
            "giorni": 1203,
            "area": "",
            "ech": 0
        },
        {
            "id": 6064,
            "name": "Salento",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "H686",
            "cod_istat": "065115",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1529,
            "area": "",
            "ech": 0
        },
        {
            "id": 6065,
            "name": "Salerano Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H702",
            "cod_istat": "001233",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2728,
            "area": "",
            "ech": 0
        },
        {
            "id": 6066,
            "name": "Salerano sul Lambro",
            "provincia": "LO",
            "cap": "26857",
            "cod_catastale": "H701",
            "cod_istat": "098046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 6067,
            "name": "Salerno",
            "provincia": "SA",
            "cap": "841xx",
            "cod_catastale": "H703",
            "cod_istat": "065116",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 4,
            "giorni": 994,
            "area": "",
            "ech": 0
        },
        {
            "id": 6068,
            "name": "Saletto",
            "provincia": "PD",
            "cap": "35046",
            "cod_catastale": "H705",
            "cod_istat": "028074",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 6069,
            "name": "Salgareda",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "H706",
            "cod_istat": "026070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2351,
            "area": "",
            "ech": 0
        },
        {
            "id": 6070,
            "name": "Sali Vercellese",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "H707",
            "cod_istat": "002127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 139,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 6071,
            "name": "Salice Salentino",
            "provincia": "LE",
            "cap": "73015",
            "cod_catastale": "H708",
            "cod_istat": "075065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 1137,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6072,
            "name": "Saliceto",
            "provincia": "CN",
            "cap": "12079",
            "cod_catastale": "H710",
            "cod_istat": "004201",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 389,
            "giorni": 2797,
            "area": "",
            "ech": 0
        },
        {
            "id": 6073,
            "name": "Salisano",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "H713",
            "cod_istat": "057063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2202,
            "area": "",
            "ech": 0
        },
        {
            "id": 6074,
            "name": "Salizzole",
            "provincia": "VR",
            "cap": "37056",
            "cod_catastale": "H714",
            "cod_istat": "023068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 6075,
            "name": "Salle",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "H715",
            "cod_istat": "068036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1949,
            "area": "",
            "ech": 0
        },
        {
            "id": 6076,
            "name": "Salmour",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "H716",
            "cod_istat": "004202",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2657,
            "area": "",
            "ech": 0
        },
        {
            "id": 6077,
            "name": "Salò",
            "provincia": "BS",
            "cap": "25087",
            "cod_catastale": "H717",
            "cod_istat": "017170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2265,
            "area": "",
            "ech": 0
        },
        {
            "id": 6078,
            "name": "Salorno",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "H719",
            "cod_istat": "021076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 6079,
            "name": "Salsomaggiore Terme",
            "provincia": "PR",
            "cap": "43039",
            "cod_catastale": "H720",
            "cod_istat": "034032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 6080,
            "name": "Saltara",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "H721",
            "cod_istat": "041050",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2201,
            "area": "",
            "ech": 0
        },
        {
            "id": 6081,
            "name": "Saltrio",
            "provincia": "VA",
            "cap": "21050",
            "cod_catastale": "H723",
            "cod_istat": "012117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 543,
            "giorni": 2796,
            "area": "",
            "ech": 0
        },
        {
            "id": 6082,
            "name": "Saludecio",
            "provincia": "RN",
            "cap": "47835",
            "cod_catastale": "H724",
            "cod_istat": "099015",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 2595,
            "area": "",
            "ech": 0
        },
        {
            "id": 6083,
            "name": "Saluggia",
            "provincia": "VC",
            "cap": "13040",
            "cod_catastale": "H725",
            "cod_istat": "002128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 6084,
            "name": "Salussola",
            "provincia": "BI",
            "cap": "13885",
            "cod_catastale": "H726",
            "cod_istat": "096058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 6085,
            "name": "Saluzzo",
            "provincia": "CN",
            "cap": "12037",
            "cod_catastale": "H727",
            "cod_istat": "004203",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2735,
            "area": "",
            "ech": 0
        },
        {
            "id": 6086,
            "name": "Salve",
            "provincia": "LE",
            "cap": "73050",
            "cod_catastale": "H729",
            "cod_istat": "075066",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1224,
            "area": "",
            "ech": 0
        },
        {
            "id": 6087,
            "name": "Salvirola",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "H731",
            "cod_istat": "019087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2320,
            "area": "",
            "ech": 0
        },
        {
            "id": 6088,
            "name": "Salvitelle",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "H732",
            "cod_istat": "065117",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 640,
            "giorni": 2072,
            "area": "",
            "ech": 0
        },
        {
            "id": 6089,
            "name": "Salza di Pinerolo",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "H734",
            "cod_istat": "001234",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 4169,
            "area": "",
            "ech": 0
        },
        {
            "id": 6090,
            "name": "Salza Irpina",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "H733",
            "cod_istat": "064081",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 2097,
            "area": "",
            "ech": 0
        },
        {
            "id": 6091,
            "name": "Salzano",
            "provincia": "VE",
            "cap": "30030",
            "cod_catastale": "H735",
            "cod_istat": "027032",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2635,
            "area": "",
            "ech": 0
        },
        {
            "id": 6092,
            "name": "Samarate",
            "provincia": "VA",
            "cap": "21017",
            "cod_catastale": "H736",
            "cod_istat": "012118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2854,
            "area": "",
            "ech": 0
        },
        {
            "id": 6093,
            "name": "Samassi",
            "provincia": "SU",
            "cap": "09030",
            "cod_catastale": "H738",
            "cod_istat": "111059",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1053,
            "area": "",
            "ech": 0
        },
        {
            "id": 6094,
            "name": "Samatzai",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "H739",
            "cod_istat": "111060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 1225,
            "area": "",
            "ech": 1
        },
        {
            "id": 6095,
            "name": "Sambuca di Sicilia",
            "provincia": "AG",
            "cap": "92017",
            "cod_catastale": "H743",
            "cod_istat": "084034",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1092,
            "area": "",
            "ech": 1
        },
        {
            "id": 6096,
            "name": "Sambuca Pistoiese",
            "provincia": "PT",
            "cap": "51020",
            "cod_catastale": "H744",
            "cod_istat": "047018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 2594,
            "area": "",
            "ech": 0
        },
        {
            "id": 6097,
            "name": "Sambuci",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "H745",
            "cod_istat": "058094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 434,
            "giorni": 2114,
            "area": "",
            "ech": 0
        },
        {
            "id": 6098,
            "name": "Sambuco",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "H746",
            "cod_istat": "004204",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1184,
            "giorni": 3783,
            "area": "",
            "ech": 0
        },
        {
            "id": 6099,
            "name": "Sammichele di Bari",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "H749",
            "cod_istat": "072039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1735,
            "area": "",
            "ech": 0
        },
        {
            "id": 6100,
            "name": "Samo",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "H013",
            "cod_istat": "080070",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 280,
            "giorni": 1194,
            "area": "",
            "ech": 1
        },
        {
            "id": 6101,
            "name": "Samolaco",
            "provincia": "SO",
            "cap": "23027",
            "cod_catastale": "H752",
            "cod_istat": "014057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2372,
            "area": "",
            "ech": 0
        },
        {
            "id": 6102,
            "name": "Samone",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H753",
            "cod_istat": "001235",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2728,
            "area": "",
            "ech": 0
        },
        {
            "id": 6103,
            "name": "Samone",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "H754",
            "cod_istat": "022165",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 673,
            "giorni": 3441,
            "area": "",
            "ech": 0
        },
        {
            "id": 6104,
            "name": "Sampeyre",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "H755",
            "cod_istat": "004205",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 976,
            "giorni": 3525,
            "area": "",
            "ech": 0
        },
        {
            "id": 6105,
            "name": "Samugheo",
            "provincia": "OR",
            "cap": "09086",
            "cod_catastale": "H756",
            "cod_istat": "095045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 370,
            "giorni": 1450,
            "area": "",
            "ech": 0
        },
        {
            "id": 6106,
            "name": "San Bartolomeo al Mare",
            "provincia": "IM",
            "cap": "18016",
            "cod_catastale": "H763",
            "cod_istat": "008052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 1240,
            "area": "",
            "ech": 0
        },
        {
            "id": 6107,
            "name": "San Bartolomeo in Galdo",
            "provincia": "BN",
            "cap": "82028",
            "cod_catastale": "H764",
            "cod_istat": "062057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 585,
            "giorni": 2135,
            "area": "",
            "ech": 0
        },
        {
            "id": 6108,
            "name": "San Bartolomeo Val Cavargna",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "H760",
            "cod_istat": "013204",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 852,
            "giorni": 3279,
            "area": "",
            "ech": 0
        },
        {
            "id": 6109,
            "name": "San Basile",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "H765",
            "cod_istat": "078111",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1883,
            "area": "",
            "ech": 0
        },
        {
            "id": 6110,
            "name": "San Basilio",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "H766",
            "cod_istat": "111061",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1571,
            "area": "",
            "ech": 1
        },
        {
            "id": 6111,
            "name": "San Bassano",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "H767",
            "cod_istat": "019088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6112,
            "name": "San Bellino",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "H768",
            "cod_istat": "029043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6113,
            "name": "San Benedetto Belbo",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "H770",
            "cod_istat": "004206",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 637,
            "giorni": 3105,
            "area": "",
            "ech": 0
        },
        {
            "id": 6114,
            "name": "San Benedetto dei Marsi",
            "provincia": "AQ",
            "cap": "67058",
            "cod_catastale": "H772",
            "cod_istat": "066085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 678,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 6115,
            "name": "San Benedetto del Tronto",
            "provincia": "AP",
            "cap": "63074",
            "cod_catastale": "H769",
            "cod_istat": "044066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1593,
            "area": "",
            "ech": 0
        },
        {
            "id": 6116,
            "name": "San Benedetto in Perillis",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "H773",
            "cod_istat": "066086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 878,
            "giorni": 2860,
            "area": "",
            "ech": 0
        },
        {
            "id": 6117,
            "name": "San Benedetto Po",
            "provincia": "MN",
            "cap": "46027",
            "cod_catastale": "H771",
            "cod_istat": "020055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 6118,
            "name": "San Benedetto Ullano",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "H774",
            "cod_istat": "078112",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1750,
            "area": "",
            "ech": 0
        },
        {
            "id": 6119,
            "name": "San Benedetto Val di Sambro",
            "provincia": "BO",
            "cap": "40048",
            "cod_catastale": "G566",
            "cod_istat": "037051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 602,
            "giorni": 2808,
            "area": "",
            "ech": 0
        },
        {
            "id": 6120,
            "name": "San Benigno Canavese",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H775",
            "cod_istat": "001236",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 6121,
            "name": "San Bernardino Verbano",
            "provincia": "VB",
            "cap": "28804",
            "cod_catastale": "H777",
            "cod_istat": "103061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2565,
            "area": "",
            "ech": 0
        },
        {
            "id": 6122,
            "name": "San Biagio della Cima",
            "provincia": "IM",
            "cap": "18036",
            "cod_catastale": "H780",
            "cod_istat": "008053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 1584,
            "area": "",
            "ech": 0
        },
        {
            "id": 6123,
            "name": "San Biagio di Callalta",
            "provincia": "TV",
            "cap": "31048",
            "cod_catastale": "H781",
            "cod_istat": "026071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2343,
            "area": "",
            "ech": 0
        },
        {
            "id": 6124,
            "name": "San Biagio Platani",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "H778",
            "cod_istat": "084035",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 416,
            "giorni": 1144,
            "area": "",
            "ech": 1
        },
        {
            "id": 6125,
            "name": "San Biagio Saracinisco",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "H779",
            "cod_istat": "060061",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 836,
            "giorni": 2658,
            "area": "",
            "ech": 0
        },
        {
            "id": 6126,
            "name": "San Biase",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "H782",
            "cod_istat": "070063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 804,
            "giorni": 2422,
            "area": "",
            "ech": 0
        },
        {
            "id": 6127,
            "name": "San Bonifacio",
            "provincia": "VR",
            "cap": "37047",
            "cod_catastale": "H783",
            "cod_istat": "023069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 6128,
            "name": "San Buono",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "H784",
            "cod_istat": "069079",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 470,
            "giorni": 1901,
            "area": "",
            "ech": 0
        },
        {
            "id": 6129,
            "name": "San Calogero",
            "provincia": "VV",
            "cap": "89842",
            "cod_catastale": "H785",
            "cod_istat": "102032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 6130,
            "name": "San Candido",
            "provincia": "BZ",
            "cap": "39038",
            "cod_catastale": "H786",
            "cod_istat": "021077",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1175,
            "giorni": 4188,
            "area": "",
            "ech": 0
        },
        {
            "id": 6131,
            "name": "San Canzian d'Isonzo",
            "provincia": "GO",
            "cap": "34075",
            "cod_catastale": "H787",
            "cod_istat": "031018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2250,
            "area": "",
            "ech": 0
        },
        {
            "id": 6132,
            "name": "San Carlo Canavese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "H789",
            "cod_istat": "001237",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 6133,
            "name": "San Casciano dei Bagni",
            "provincia": "SI",
            "cap": "53040",
            "cod_catastale": "H790",
            "cod_istat": "052027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 582,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 6134,
            "name": "San Casciano in Val di Pesa",
            "provincia": "FI",
            "cap": "50026",
            "cod_catastale": "H791",
            "cod_istat": "048038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2240,
            "area": "",
            "ech": 0
        },
        {
            "id": 6135,
            "name": "San Cassiano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "M264",
            "cod_istat": "075095",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 6136,
            "name": "San Cataldo",
            "provincia": "CL",
            "cap": "93017",
            "cod_catastale": "H792",
            "cod_istat": "085016",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 1637,
            "area": "",
            "ech": 0
        },
        {
            "id": 6137,
            "name": "San Cesareo",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "M295",
            "cod_istat": "058119",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 1908,
            "area": "",
            "ech": 0
        },
        {
            "id": 6138,
            "name": "San Cesario di Lecce",
            "provincia": "LE",
            "cap": "73016",
            "cod_catastale": "H793",
            "cod_istat": "075068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 1110,
            "area": "",
            "ech": 0
        },
        {
            "id": 6139,
            "name": "San Cesario sul Panaro",
            "provincia": "MO",
            "cap": "41018",
            "cod_catastale": "H794",
            "cod_istat": "036036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 6140,
            "name": "San Chirico Nuovo",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "H795",
            "cod_istat": "076073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 745,
            "giorni": 2134,
            "area": "",
            "ech": 0
        },
        {
            "id": 6141,
            "name": "San Chirico Raparo",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "H796",
            "cod_istat": "076074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 2201,
            "area": "",
            "ech": 0
        },
        {
            "id": 6142,
            "name": "San Cipirello",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "H797",
            "cod_istat": "082063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 394,
            "giorni": 1203,
            "area": "",
            "ech": 0
        },
        {
            "id": 6143,
            "name": "San Cipriano d'Aversa",
            "provincia": "CE",
            "cap": "81036",
            "cod_catastale": "H798",
            "cod_istat": "061074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1333,
            "area": "",
            "ech": 0
        },
        {
            "id": 6144,
            "name": "San Cipriano Picentino",
            "provincia": "SA",
            "cap": "84099",
            "cod_catastale": "H800",
            "cod_istat": "065118",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 1499,
            "area": "",
            "ech": 0
        },
        {
            "id": 6145,
            "name": "San Cipriano Po",
            "provincia": "PV",
            "cap": "27043",
            "cod_catastale": "H799",
            "cod_istat": "018133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6146,
            "name": "San Clemente",
            "provincia": "RN",
            "cap": "47832",
            "cod_catastale": "H801",
            "cod_istat": "099016",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2382,
            "area": "",
            "ech": 0
        },
        {
            "id": 6147,
            "name": "San Colombano al Lambro",
            "provincia": "MI",
            "cap": "20078",
            "cod_catastale": "H803",
            "cod_istat": "015191",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 6148,
            "name": "San Colombano Belmonte",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "H804",
            "cod_istat": "001238",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 3179,
            "area": "",
            "ech": 0
        },
        {
            "id": 6149,
            "name": "San Colombano Certenoli",
            "provincia": "GE",
            "cap": "16040",
            "cod_catastale": "H802",
            "cod_istat": "010053",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6150,
            "name": "San Cono",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "H805",
            "cod_istat": "087040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 1437,
            "area": "",
            "ech": 0
        },
        {
            "id": 6151,
            "name": "San Cosmo Albanese",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "H806",
            "cod_istat": "078113",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1623,
            "area": "",
            "ech": 1
        },
        {
            "id": 6152,
            "name": "San Costantino Albanese",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "H808",
            "cod_istat": "076075",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 6153,
            "name": "San Costantino Calabro",
            "provincia": "VV",
            "cap": "89851",
            "cod_catastale": "H807",
            "cod_istat": "102033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 454,
            "giorni": 1539,
            "area": "",
            "ech": 0
        },
        {
            "id": 6154,
            "name": "San Costanzo",
            "provincia": "PU",
            "cap": "61039",
            "cod_catastale": "H809",
            "cod_istat": "041051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 2193,
            "area": "",
            "ech": 0
        },
        {
            "id": 6155,
            "name": "San Cristoforo",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "H810",
            "cod_istat": "006152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2638,
            "area": "",
            "ech": 0
        },
        {
            "id": 6156,
            "name": "San Damiano al Colle",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "H814",
            "cod_istat": "018134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2851,
            "area": "",
            "ech": 0
        },
        {
            "id": 6157,
            "name": "San Damiano d'Asti",
            "provincia": "AT",
            "cap": "14015",
            "cod_catastale": "H811",
            "cod_istat": "005097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 2632,
            "area": "",
            "ech": 0
        },
        {
            "id": 6158,
            "name": "San Damiano Macra",
            "provincia": "CN",
            "cap": "12029",
            "cod_catastale": "H812",
            "cod_istat": "004207",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 743,
            "giorni": 3236,
            "area": "",
            "ech": 0
        },
        {
            "id": 6159,
            "name": "San Daniele del Friuli",
            "provincia": "UD",
            "cap": "33038",
            "cod_catastale": "H816",
            "cod_istat": "030099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 6160,
            "name": "San Daniele Po",
            "provincia": "CR",
            "cap": "26046",
            "cod_catastale": "H815",
            "cod_istat": "019089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6161,
            "name": "San Demetrio Corone",
            "provincia": "CS",
            "cap": "87069",
            "cod_catastale": "H818",
            "cod_istat": "078114",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 1862,
            "area": "",
            "ech": 0
        },
        {
            "id": 6162,
            "name": "San Demetrio ne' Vestini",
            "provincia": "AQ",
            "cap": "67028",
            "cod_catastale": "H819",
            "cod_istat": "066087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 662,
            "giorni": 2473,
            "area": "",
            "ech": 0
        },
        {
            "id": 6163,
            "name": "San Didero",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "H820",
            "cod_istat": "001239",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2999,
            "area": "",
            "ech": 0
        },
        {
            "id": 6164,
            "name": "San Donà di Piave",
            "provincia": "VE",
            "cap": "30027",
            "cod_catastale": "H823",
            "cod_istat": "027033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 6165,
            "name": "San Donaci",
            "provincia": "BR",
            "cap": "72025",
            "cod_catastale": "H822",
            "cod_istat": "074013",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 1133,
            "area": "",
            "ech": 0
        },
        {
            "id": 6166,
            "name": "San Donato di Lecce",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "H826",
            "cod_istat": "075069",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 79,
            "giorni": 1202,
            "area": "",
            "ech": 0
        },
        {
            "id": 6167,
            "name": "San Donato di Ninea",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "H825",
            "cod_istat": "078115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 6168,
            "name": "San Donato Milanese",
            "provincia": "MI",
            "cap": "20097",
            "cod_catastale": "H827",
            "cod_istat": "015192",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6169,
            "name": "San Donato Val di Comino",
            "provincia": "FR",
            "cap": "03046",
            "cod_catastale": "H824",
            "cod_istat": "060062",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 721,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 6170,
            "name": "San Dorligo della Valle",
            "provincia": "TS",
            "cap": "34018",
            "cod_catastale": "D324",
            "cod_istat": "032004",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6171,
            "name": "San Fedele Intelvi",
            "provincia": "CO",
            "cap": "22028",
            "cod_catastale": "H830",
            "cod_istat": "013205",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 779,
            "giorni": 3176,
            "area": "",
            "ech": 0
        },
        {
            "id": 6172,
            "name": "San Fele",
            "provincia": "PZ",
            "cap": "85020",
            "cod_catastale": "H831",
            "cod_istat": "076076",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 937,
            "giorni": 2495,
            "area": "",
            "ech": 0
        },
        {
            "id": 6173,
            "name": "San Felice a Cancello",
            "provincia": "CE",
            "cap": "81027",
            "cod_catastale": "H834",
            "cod_istat": "061075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1236,
            "area": "",
            "ech": 0
        },
        {
            "id": 6174,
            "name": "San Felice Circeo",
            "provincia": "LT",
            "cap": "04017",
            "cod_catastale": "H836",
            "cod_istat": "059025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 1254,
            "area": "",
            "ech": 0
        },
        {
            "id": 6175,
            "name": "San Felice del Benaco",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "H838",
            "cod_istat": "017171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 109,
            "giorni": 2265,
            "area": "",
            "ech": 0
        },
        {
            "id": 6176,
            "name": "San Felice del Molise",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "H833",
            "cod_istat": "070064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 548,
            "giorni": 1917,
            "area": "",
            "ech": 0
        },
        {
            "id": 6177,
            "name": "San Felice sul Panaro",
            "provincia": "MO",
            "cap": "41038",
            "cod_catastale": "H835",
            "cod_istat": "036037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2194,
            "area": "",
            "ech": 0
        },
        {
            "id": 6178,
            "name": "San Ferdinando",
            "provincia": "RC",
            "cap": "89026",
            "cod_catastale": "M277",
            "cod_istat": "080097",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 691,
            "area": "",
            "ech": 0
        },
        {
            "id": 6179,
            "name": "San Ferdinando di Puglia",
            "provincia": "BT",
            "cap": "76017",
            "cod_catastale": "H839",
            "cod_istat": "110007",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 1393,
            "area": "",
            "ech": 0
        },
        {
            "id": 6180,
            "name": "San Fermo della Battaglia",
            "provincia": "CO",
            "cap": "22042",
            "cod_catastale": "H840",
            "cod_istat": "013206",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 6181,
            "name": "San Fili",
            "provincia": "CS",
            "cap": "87037",
            "cod_catastale": "H841",
            "cod_istat": "078116",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 566,
            "giorni": 1930,
            "area": "",
            "ech": 0
        },
        {
            "id": 6182,
            "name": "San Filippo del Mela",
            "provincia": "ME",
            "cap": "98044",
            "cod_catastale": "H842",
            "cod_istat": "083077",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 837,
            "area": "",
            "ech": 0
        },
        {
            "id": 6183,
            "name": "San Fior",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "H843",
            "cod_istat": "026072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 6184,
            "name": "San Fiorano",
            "provincia": "LO",
            "cap": "26848",
            "cod_catastale": "H844",
            "cod_istat": "098047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6185,
            "name": "San Floriano del Collio",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "H845",
            "cod_istat": "031019",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2702,
            "area": "",
            "ech": 0
        },
        {
            "id": 6186,
            "name": "San Floro",
            "provincia": "CZ",
            "cap": "88021",
            "cod_catastale": "H846",
            "cod_istat": "079108",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1198,
            "area": "",
            "ech": 0
        },
        {
            "id": 6187,
            "name": "San Francesco al Campo",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "H847",
            "cod_istat": "001240",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 327,
            "giorni": 2845,
            "area": "",
            "ech": 0
        },
        {
            "id": 6188,
            "name": "San Fratello",
            "provincia": "ME",
            "cap": "98075",
            "cod_catastale": "H850",
            "cod_istat": "083078",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 675,
            "giorni": 1781,
            "area": "",
            "ech": 1
        },
        {
            "id": 6189,
            "name": "San Gavino Monreale",
            "provincia": "SU",
            "cap": "09037",
            "cod_catastale": "H856",
            "cod_istat": "111062",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 1046,
            "area": "",
            "ech": 0
        },
        {
            "id": 6190,
            "name": "San Gemini",
            "provincia": "TR",
            "cap": "05029",
            "cod_catastale": "H857",
            "cod_istat": "055029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 1978,
            "area": "",
            "ech": 0
        },
        {
            "id": 6191,
            "name": "San Genesio Atesino",
            "provincia": "BZ",
            "cap": "39050",
            "cod_catastale": "H858",
            "cod_istat": "021079",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1087,
            "giorni": 4073,
            "area": "",
            "ech": 0
        },
        {
            "id": 6192,
            "name": "San Genesio ed Uniti",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "H859",
            "cod_istat": "018135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6193,
            "name": "San Gennaro Vesuviano",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "H860",
            "cod_istat": "063066",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 6194,
            "name": "San Germano Chisone",
            "provincia": "TO",
            "cap": "10065",
            "cod_catastale": "H862",
            "cod_istat": "001242",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 486,
            "giorni": 3083,
            "area": "",
            "ech": 0
        },
        {
            "id": 6195,
            "name": "San Germano dei Berici",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "H863",
            "cod_istat": "024092",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2386,
            "area": "",
            "ech": 0
        },
        {
            "id": 6196,
            "name": "San Germano Vercellese",
            "provincia": "VC",
            "cap": "13047",
            "cod_catastale": "H861",
            "cod_istat": "002131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 6197,
            "name": "San Gervasio Bresciano",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "H865",
            "cod_istat": "017172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6198,
            "name": "San Giacomo degli Schiavoni",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "H867",
            "cod_istat": "070065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 1514,
            "area": "",
            "ech": 0
        },
        {
            "id": 6199,
            "name": "San Giacomo delle Segnate",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "H870",
            "cod_istat": "020056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 6200,
            "name": "San Giacomo Filippo",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "H868",
            "cod_istat": "014058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 522,
            "giorni": 3001,
            "area": "",
            "ech": 0
        },
        {
            "id": 6201,
            "name": "San Giacomo Vercellese",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "B952",
            "cod_istat": "002035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2561,
            "area": "",
            "ech": 0
        },
        {
            "id": 6202,
            "name": "San Gillio",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "H873",
            "cod_istat": "001243",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2834,
            "area": "",
            "ech": 0
        },
        {
            "id": 6203,
            "name": "San Gimignano",
            "provincia": "SI",
            "cap": "53037",
            "cod_catastale": "H875",
            "cod_istat": "052028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 324,
            "giorni": 2085,
            "area": "",
            "ech": 0
        },
        {
            "id": 6204,
            "name": "San Ginesio",
            "provincia": "MC",
            "cap": "62026",
            "cod_catastale": "H876",
            "cod_istat": "043046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 6205,
            "name": "San Giorgio a Cremano",
            "provincia": "NA",
            "cap": "80046",
            "cod_catastale": "H892",
            "cod_istat": "063067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1073,
            "area": "",
            "ech": 0
        },
        {
            "id": 6206,
            "name": "San Giorgio a Liri",
            "provincia": "FR",
            "cap": "03047",
            "cod_catastale": "H880",
            "cod_istat": "060063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1099,
            "area": "",
            "ech": 0
        },
        {
            "id": 6207,
            "name": "San Giorgio Albanese",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "H881",
            "cod_istat": "078118",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 1695,
            "area": "",
            "ech": 0
        },
        {
            "id": 6208,
            "name": "San Giorgio Canavese",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H890",
            "cod_istat": "001244",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2594,
            "area": "",
            "ech": 0
        },
        {
            "id": 6209,
            "name": "San Giorgio del Sannio",
            "provincia": "BN",
            "cap": "82018",
            "cod_catastale": "H894",
            "cod_istat": "062058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1762,
            "area": "",
            "ech": 0
        },
        {
            "id": 6210,
            "name": "San Giorgio della Richinvelda",
            "provincia": "PN",
            "cap": "33095",
            "cod_catastale": "H891",
            "cod_istat": "093038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 6211,
            "name": "San Giorgio delle Pertiche",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "H893",
            "cod_istat": "028075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 6212,
            "name": "San Giorgio di Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "H885",
            "cod_istat": "018136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6213,
            "name": "San Giorgio Bigarello",
            "provincia": "MN",
            "cap": "46051",
            "cod_catastale": "H883",
            "cod_istat": "020057",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6214,
            "name": "San Giorgio di Nogaro",
            "provincia": "UD",
            "cap": "33058",
            "cod_catastale": "H895",
            "cod_istat": "030100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 6215,
            "name": "San Giorgio di Pesaro",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "H886",
            "cod_istat": "041052",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 6216,
            "name": "San Giorgio di Piano",
            "provincia": "BO",
            "cap": "40016",
            "cod_catastale": "H896",
            "cod_istat": "037052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2332,
            "area": "",
            "ech": 0
        },
        {
            "id": 6217,
            "name": "San Giorgio in Bosco",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "H897",
            "cod_istat": "028076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 6218,
            "name": "San Giorgio Ionico",
            "provincia": "TA",
            "cap": "74027",
            "cod_catastale": "H882",
            "cod_istat": "073024",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6219,
            "name": "San Giorgio La Molara",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "H898",
            "cod_istat": "062059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 667,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 6220,
            "name": "San Giorgio Lucano",
            "provincia": "MT",
            "cap": "75027",
            "cod_catastale": "H888",
            "cod_istat": "077025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 1691,
            "area": "",
            "ech": 0
        },
        {
            "id": 6221,
            "name": "San Giorgio Monferrato",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "H878",
            "cod_istat": "006153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2718,
            "area": "",
            "ech": 0
        },
        {
            "id": 6222,
            "name": "San Giorgio Morgeto",
            "provincia": "RC",
            "cap": "89017",
            "cod_catastale": "H889",
            "cod_istat": "080071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 512,
            "giorni": 1657,
            "area": "",
            "ech": 0
        },
        {
            "id": 6223,
            "name": "San Giorgio Piacentino",
            "provincia": "PC",
            "cap": "29019",
            "cod_catastale": "H887",
            "cod_istat": "033040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2668,
            "area": "",
            "ech": 0
        },
        {
            "id": 6224,
            "name": "San Giorgio Scarampi",
            "provincia": "AT",
            "cap": "14059",
            "cod_catastale": "H899",
            "cod_istat": "005098",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 3032,
            "area": "",
            "ech": 0
        },
        {
            "id": 6225,
            "name": "San Giorgio su Legnano",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "H884",
            "cod_istat": "015194",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2450,
            "area": "",
            "ech": 0
        },
        {
            "id": 6226,
            "name": "San Giorio di Susa",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "H900",
            "cod_istat": "001245",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 420,
            "giorni": 3013,
            "area": "",
            "ech": 0
        },
        {
            "id": 6227,
            "name": "San Giovanni a Piro",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "H907",
            "cod_istat": "065119",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1607,
            "area": "",
            "ech": 0
        },
        {
            "id": 6228,
            "name": "San Giovanni al Natisone",
            "provincia": "UD",
            "cap": "33048",
            "cod_catastale": "H906",
            "cod_istat": "030101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2281,
            "area": "",
            "ech": 0
        },
        {
            "id": 6229,
            "name": "San Giovanni Bianco",
            "provincia": "BG",
            "cap": "24015",
            "cod_catastale": "H910",
            "cod_istat": "016188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 2698,
            "area": "",
            "ech": 0
        },
        {
            "id": 6230,
            "name": "San Giovanni d'Asso",
            "provincia": "SI",
            "cap": "53020",
            "cod_catastale": "H911",
            "cod_istat": "052029",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1873,
            "area": "",
            "ech": 0
        },
        {
            "id": 6231,
            "name": "San Giovanni del Dosso",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "H912",
            "cod_istat": "020058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2334,
            "area": "",
            "ech": 0
        },
        {
            "id": 6232,
            "name": "San Giovanni di Gerace",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "H903",
            "cod_istat": "080072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1260,
            "area": "",
            "ech": 1
        },
        {
            "id": 6233,
            "name": "San Giovanni Gemini",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "H914",
            "cod_istat": "084036",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 670,
            "giorni": 1588,
            "area": "",
            "ech": 0
        },
        {
            "id": 6234,
            "name": "San Giovanni Ilarione",
            "provincia": "VR",
            "cap": "37035",
            "cod_catastale": "H916",
            "cod_istat": "023070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 6235,
            "name": "San Giovanni in Croce",
            "provincia": "CR",
            "cap": "26037",
            "cod_catastale": "H918",
            "cod_istat": "019090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6236,
            "name": "San Giovanni in Fiore",
            "provincia": "CS",
            "cap": "87055",
            "cod_catastale": "H919",
            "cod_istat": "078119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1049,
            "giorni": 2897,
            "area": "",
            "ech": 1
        },
        {
            "id": 6237,
            "name": "San Giovanni in Galdo",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "H920",
            "cod_istat": "070066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 2062,
            "area": "",
            "ech": 0
        },
        {
            "id": 6238,
            "name": "San Giovanni in Marignano",
            "provincia": "RN",
            "cap": "47842",
            "cod_catastale": "H921",
            "cod_istat": "099017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2187,
            "area": "",
            "ech": 0
        },
        {
            "id": 6239,
            "name": "San Giovanni in Persiceto",
            "provincia": "BO",
            "cap": "40017",
            "cod_catastale": "G467",
            "cod_istat": "037053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2187,
            "area": "",
            "ech": 0
        },
        {
            "id": 6240,
            "name": "San Giovanni Incarico",
            "provincia": "FR",
            "cap": "03028",
            "cod_catastale": "H917",
            "cod_istat": "060064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1499,
            "area": "",
            "ech": 0
        },
        {
            "id": 6241,
            "name": "San Giovanni la Punta",
            "provincia": "CT",
            "cap": "95037",
            "cod_catastale": "H922",
            "cod_istat": "087041",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1197,
            "area": "",
            "ech": 1
        },
        {
            "id": 6242,
            "name": "San Giovanni Lipioni",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "H923",
            "cod_istat": "069080",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 545,
            "giorni": 2062,
            "area": "",
            "ech": 0
        },
        {
            "id": 6243,
            "name": "San Giovanni Lupatoto",
            "provincia": "VR",
            "cap": "37057",
            "cod_catastale": "H924",
            "cod_istat": "023071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2366,
            "area": "",
            "ech": 0
        },
        {
            "id": 6244,
            "name": "San Giovanni Rotondo",
            "provincia": "FG",
            "cap": "71013",
            "cod_catastale": "H926",
            "cod_istat": "071046",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 566,
            "giorni": 2004,
            "area": "",
            "ech": 0
        },
        {
            "id": 6245,
            "name": "San Giovanni Suergiu",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "G287",
            "cod_istat": "111063",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 766,
            "area": "",
            "ech": 0
        },
        {
            "id": 6246,
            "name": "San Giovanni Teatino",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "D690",
            "cod_istat": "069081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1735,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 6247,
            "name": "San Giovanni Valdarno",
            "provincia": "AR",
            "cap": "52027",
            "cod_catastale": "H901",
            "cod_istat": "051033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 1937,
            "area": "",
            "ech": 0
        },
        {
            "id": 6248,
            "name": "San Giuliano del Sannio",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "H928",
            "cod_istat": "070067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 621,
            "giorni": 2160,
            "area": "",
            "ech": 0
        },
        {
            "id": 6249,
            "name": "San Giuliano di Puglia",
            "provincia": "CB",
            "cap": "86040",
            "cod_catastale": "H929",
            "cod_istat": "070068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 452,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 6250,
            "name": "San Giuliano Milanese",
            "provincia": "MI",
            "cap": "20098",
            "cod_catastale": "H930",
            "cod_istat": "015195",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 6251,
            "name": "San Giuliano Terme",
            "provincia": "PI",
            "cap": "56017",
            "cod_catastale": "A562",
            "cod_istat": "050031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1696,
            "area": "",
            "ech": 0
        },
        {
            "id": 6252,
            "name": "San Giuseppe Jato",
            "provincia": "PA",
            "cap": "90048",
            "cod_catastale": "H933",
            "cod_istat": "082064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 467,
            "giorni": 1317,
            "area": "",
            "ech": 0
        },
        {
            "id": 6253,
            "name": "San Giuseppe Vesuviano",
            "provincia": "NA",
            "cap": "80047",
            "cod_catastale": "H931",
            "cod_istat": "063068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 1134,
            "area": "",
            "ech": 0
        },
        {
            "id": 6254,
            "name": "San Giustino",
            "provincia": "PG",
            "cap": "06016",
            "cod_catastale": "H935",
            "cod_istat": "054044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 336,
            "giorni": 2132,
            "area": "",
            "ech": 0
        },
        {
            "id": 6255,
            "name": "San Giusto Canavese",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H936",
            "cod_istat": "001246",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 6256,
            "name": "San Godenzo",
            "provincia": "FI",
            "cap": "50060",
            "cod_catastale": "H937",
            "cod_istat": "048039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 2891,
            "area": "",
            "ech": 0
        },
        {
            "id": 6257,
            "name": "San Gregorio da Sassola",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "H942",
            "cod_istat": "058095",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 6258,
            "name": "San Gregorio di Catania",
            "provincia": "CT",
            "cap": "95027",
            "cod_catastale": "H940",
            "cod_istat": "087042",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1106,
            "area": "",
            "ech": 1
        },
        {
            "id": 6259,
            "name": "San Gregorio d'Ippona",
            "provincia": "VV",
            "cap": "89853",
            "cod_catastale": "H941",
            "cod_istat": "102034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 402,
            "giorni": 1593,
            "area": "",
            "ech": 0
        },
        {
            "id": 6260,
            "name": "San Gregorio Magno",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "H943",
            "cod_istat": "065120",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 1789,
            "area": "",
            "ech": 0
        },
        {
            "id": 6261,
            "name": "San Gregorio Matese",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "H939",
            "cod_istat": "061076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 765,
            "giorni": 2293,
            "area": "",
            "ech": 0
        },
        {
            "id": 6262,
            "name": "San Gregorio nelle Alpi",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "H938",
            "cod_istat": "025045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 528,
            "giorni": 3418,
            "area": "",
            "ech": 0
        },
        {
            "id": 6263,
            "name": "San Lazzaro di Savena",
            "provincia": "BO",
            "cap": "40068",
            "cod_catastale": "H945",
            "cod_istat": "037054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 2210,
            "area": "",
            "ech": 0
        },
        {
            "id": 6264,
            "name": "San Leo",
            "provincia": "RN",
            "cap": "47865",
            "cod_catastale": "H949",
            "cod_istat": "099025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 589,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 6265,
            "name": "San Leonardo",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "H951",
            "cod_istat": "030102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 168,
            "giorni": 2691,
            "area": "",
            "ech": 0
        },
        {
            "id": 6266,
            "name": "San Leonardo in Passiria",
            "provincia": "BZ",
            "cap": "39015",
            "cod_catastale": "H952",
            "cod_istat": "021080",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 689,
            "giorni": 3453,
            "area": "",
            "ech": 0
        },
        {
            "id": 6267,
            "name": "San Leucio del Sannio",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "H953",
            "cod_istat": "062060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 1742,
            "area": "",
            "ech": 0
        },
        {
            "id": 6268,
            "name": "San Lorenzello",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "H955",
            "cod_istat": "062061",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1525,
            "area": "",
            "ech": 0
        },
        {
            "id": 6269,
            "name": "San Lorenzo",
            "provincia": "RC",
            "cap": "89069",
            "cod_catastale": "H959",
            "cod_istat": "080073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 787,
            "giorni": 2203,
            "area": "",
            "ech": 1
        },
        {
            "id": 6270,
            "name": "San Lorenzo al Mare",
            "provincia": "IM",
            "cap": "18017",
            "cod_catastale": "H957",
            "cod_istat": "008054",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1191,
            "area": "",
            "ech": 0
        },
        {
            "id": 6271,
            "name": "San Lorenzo Bellizzi",
            "provincia": "CS",
            "cap": "87070",
            "cod_catastale": "H961",
            "cod_istat": "078120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 2458,
            "area": "",
            "ech": 1
        },
        {
            "id": 6272,
            "name": "San Lorenzo del Vallo",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "H962",
            "cod_istat": "078121",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1482,
            "area": "",
            "ech": 0
        },
        {
            "id": 6273,
            "name": "San Lorenzo di Sebato",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "H956",
            "cod_istat": "021081",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 810,
            "giorni": 3788,
            "area": "",
            "ech": 0
        },
        {
            "id": 6274,
            "name": "San Lorenzo in Banale",
            "provincia": "TN",
            "cap": "38078",
            "cod_catastale": "H966",
            "cod_istat": "022166",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 758,
            "giorni": 3573,
            "area": "",
            "ech": 0
        },
        {
            "id": 6275,
            "name": "San Lorenzo in Campo",
            "provincia": "PU",
            "cap": "61047",
            "cod_catastale": "H958",
            "cod_istat": "041054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 2241,
            "area": "",
            "ech": 0
        },
        {
            "id": 6276,
            "name": "San Lorenzo Isontino",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "H964",
            "cod_istat": "031020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 2279,
            "area": "",
            "ech": 0
        },
        {
            "id": 6277,
            "name": "San Lorenzo Maggiore",
            "provincia": "BN",
            "cap": "82034",
            "cod_catastale": "H967",
            "cod_istat": "062062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1671,
            "area": "",
            "ech": 0
        },
        {
            "id": 6278,
            "name": "San Lorenzo Nuovo",
            "provincia": "VT",
            "cap": "01020",
            "cod_catastale": "H969",
            "cod_istat": "056047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 503,
            "giorni": 2313,
            "area": "",
            "ech": 0
        },
        {
            "id": 6279,
            "name": "San Luca",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "H970",
            "cod_istat": "080074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1007,
            "area": "",
            "ech": 0
        },
        {
            "id": 6280,
            "name": "San Lucido",
            "provincia": "CS",
            "cap": "87038",
            "cod_catastale": "H971",
            "cod_istat": "078122",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 959,
            "area": "",
            "ech": 1
        },
        {
            "id": 6281,
            "name": "San Lupo",
            "provincia": "BN",
            "cap": "82034",
            "cod_catastale": "H973",
            "cod_istat": "062063",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1980,
            "area": "",
            "ech": 0
        },
        {
            "id": 6282,
            "name": "San Mango d'Aquino",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "H976",
            "cod_istat": "079110",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 468,
            "giorni": 1732,
            "area": "",
            "ech": 0
        },
        {
            "id": 6283,
            "name": "San Mango Piemonte",
            "provincia": "SA",
            "cap": "84090",
            "cod_catastale": "H977",
            "cod_istat": "065121",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1378,
            "area": "",
            "ech": 0
        },
        {
            "id": 6284,
            "name": "San Mango sul Calore",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "H975",
            "cod_istat": "064082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 1895,
            "area": "",
            "ech": 0
        },
        {
            "id": 6285,
            "name": "San Marcellino",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "H978",
            "cod_istat": "061077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1113,
            "area": "",
            "ech": 0
        },
        {
            "id": 6286,
            "name": "San Marcello",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "H979",
            "cod_istat": "042041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 1969,
            "area": "",
            "ech": 0
        },
        {
            "id": 6287,
            "name": "San Marcello Pistoiese",
            "provincia": "PT",
            "cap": "51028",
            "cod_catastale": "H980",
            "cod_istat": "047019",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 623,
            "giorni": 2813,
            "area": "",
            "ech": 0
        },
        {
            "id": 6288,
            "name": "San Marco Argentano",
            "provincia": "CS",
            "cap": "87018",
            "cod_catastale": "H981",
            "cod_istat": "078123",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 1774,
            "area": "",
            "ech": 0
        },
        {
            "id": 6289,
            "name": "San Marco d'Alunzio",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "H982",
            "cod_istat": "083079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1550,
            "area": "",
            "ech": 0
        },
        {
            "id": 6290,
            "name": "San Marco dei Cavoti",
            "provincia": "BN",
            "cap": "82029",
            "cod_catastale": "H984",
            "cod_istat": "062064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 695,
            "giorni": 2335,
            "area": "",
            "ech": 0
        },
        {
            "id": 6291,
            "name": "San Marco Evangelista",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "F043",
            "cod_istat": "061104",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 924,
            "area": "",
            "ech": 0
        },
        {
            "id": 6292,
            "name": "San Marco in Lamis",
            "provincia": "FG",
            "cap": "71014",
            "cod_catastale": "H985",
            "cod_istat": "071047",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1981,
            "area": "",
            "ech": 0
        },
        {
            "id": 6293,
            "name": "San Marco la Catola",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "H986",
            "cod_istat": "071048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 683,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 6294,
            "name": "San Martino al Tagliamento",
            "provincia": "PN",
            "cap": "33098",
            "cod_catastale": "H999",
            "cod_istat": "093039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2517,
            "area": "",
            "ech": 0
        },
        {
            "id": 6295,
            "name": "San Martino Alfieri",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "H987",
            "cod_istat": "005099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 6296,
            "name": "San Martino Buon Albergo",
            "provincia": "VR",
            "cap": "37036",
            "cod_catastale": "I003",
            "cod_istat": "023073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 6297,
            "name": "San Martino Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "H997",
            "cod_istat": "001247",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 6298,
            "name": "San Martino d'Agri",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "H994",
            "cod_istat": "076077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 666,
            "giorni": 2076,
            "area": "",
            "ech": 0
        },
        {
            "id": 6299,
            "name": "San Martino dall'Argine",
            "provincia": "MN",
            "cap": "46010",
            "cod_catastale": "I005",
            "cod_istat": "020059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 6300,
            "name": "San Martino del Lago",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "I007",
            "cod_istat": "019091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6301,
            "name": "San Martino di Finita",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "H992",
            "cod_istat": "078124",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1923,
            "area": "",
            "ech": 0
        },
        {
            "id": 6302,
            "name": "San Martino di Lupari",
            "provincia": "PD",
            "cap": "35018",
            "cod_catastale": "I008",
            "cod_istat": "028077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 6303,
            "name": "San Martino di Venezze",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "H996",
            "cod_istat": "029044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6304,
            "name": "San Martino in Badia",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "H988",
            "cod_istat": "021082",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1115,
            "giorni": 4279,
            "area": "",
            "ech": 0
        },
        {
            "id": 6305,
            "name": "San Martino in Passiria",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "H989",
            "cod_istat": "021083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 597,
            "giorni": 3291,
            "area": "",
            "ech": 0
        },
        {
            "id": 6306,
            "name": "San Martino in Pensilis",
            "provincia": "CB",
            "cap": "86046",
            "cod_catastale": "H990",
            "cod_istat": "070069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 1674,
            "area": "",
            "ech": 0
        },
        {
            "id": 6307,
            "name": "San Martino in Rio",
            "provincia": "RE",
            "cap": "42018",
            "cod_catastale": "I011",
            "cod_istat": "035037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2394,
            "area": "",
            "ech": 0
        },
        {
            "id": 6308,
            "name": "San Martino in Strada",
            "provincia": "LO",
            "cap": "26817",
            "cod_catastale": "I012",
            "cod_istat": "098048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2524,
            "area": "",
            "ech": 0
        },
        {
            "id": 6309,
            "name": "San Martino Sannita",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "I002",
            "cod_istat": "062065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1889,
            "area": "",
            "ech": 0
        },
        {
            "id": 6310,
            "name": "San Martino Siccomario",
            "provincia": "PV",
            "cap": "27028",
            "cod_catastale": "I014",
            "cod_istat": "018137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 6311,
            "name": "San Martino sulla Marrucina",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "H991",
            "cod_istat": "069082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1826,
            "area": "",
            "ech": 0
        },
        {
            "id": 6312,
            "name": "San Martino Valle Caudina",
            "provincia": "AV",
            "cap": "83018",
            "cod_catastale": "I016",
            "cod_istat": "064083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 1794,
            "area": "",
            "ech": 0
        },
        {
            "id": 6313,
            "name": "San Marzano di San Giuseppe",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "I018",
            "cod_istat": "073025",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 1247,
            "area": "",
            "ech": 0
        },
        {
            "id": 6314,
            "name": "San Marzano Oliveto",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "I017",
            "cod_istat": "005100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 301,
            "giorni": 2735,
            "area": "",
            "ech": 0
        },
        {
            "id": 6315,
            "name": "San Marzano sul Sarno",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "I019",
            "cod_istat": "065122",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1148,
            "area": "",
            "ech": 0
        },
        {
            "id": 6316,
            "name": "San Massimo",
            "provincia": "CB",
            "cap": "86027",
            "cod_catastale": "I023",
            "cod_istat": "070070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 2173,
            "area": "",
            "ech": 0
        },
        {
            "id": 6317,
            "name": "San Maurizio Canavese",
            "provincia": "TO",
            "cap": "10077",
            "cod_catastale": "I024",
            "cod_istat": "001248",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2830,
            "area": "",
            "ech": 0
        },
        {
            "id": 6318,
            "name": "San Maurizio d'Opaglio",
            "provincia": "NO",
            "cap": "28017",
            "cod_catastale": "I025",
            "cod_istat": "003133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 2789,
            "area": "",
            "ech": 0
        },
        {
            "id": 6319,
            "name": "San Mauro Castelverde",
            "provincia": "PA",
            "cap": "90010",
            "cod_catastale": "I028",
            "cod_istat": "082065",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1050,
            "giorni": 2240,
            "area": "",
            "ech": 0
        },
        {
            "id": 6320,
            "name": "San Mauro Cilento",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "I031",
            "cod_istat": "065123",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 560,
            "giorni": 1943,
            "area": "",
            "ech": 0
        },
        {
            "id": 6321,
            "name": "San Mauro di Saline",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "H712",
            "cod_istat": "023074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 804,
            "giorni": 3600,
            "area": "",
            "ech": 0
        },
        {
            "id": 6322,
            "name": "San Mauro Forte",
            "provincia": "MT",
            "cap": "75010",
            "cod_catastale": "I029",
            "cod_istat": "077026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1874,
            "area": "",
            "ech": 0
        },
        {
            "id": 6323,
            "name": "San Mauro la Bruca",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "I032",
            "cod_istat": "065124",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1607,
            "area": "",
            "ech": 0
        },
        {
            "id": 6324,
            "name": "San Mauro Marchesato",
            "provincia": "KR",
            "cap": "88831",
            "cod_catastale": "I026",
            "cod_istat": "101020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 1356,
            "area": "",
            "ech": 1
        },
        {
            "id": 6325,
            "name": "San Mauro Pascoli",
            "provincia": "FC",
            "cap": "47030",
            "cod_catastale": "I027",
            "cod_istat": "040041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2341,
            "area": "",
            "ech": 0
        },
        {
            "id": 6326,
            "name": "San Mauro Torinese",
            "provincia": "TO",
            "cap": "10099",
            "cod_catastale": "I030",
            "cod_istat": "001249",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 6327,
            "name": "San Michele al Tagliamento",
            "provincia": "VE",
            "cap": "30028",
            "cod_catastale": "I040",
            "cod_istat": "027034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 6328,
            "name": "San Michele all'Adige",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I042",
            "cod_istat": "022167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 228,
            "giorni": 2849,
            "area": "",
            "ech": 0
        },
        {
            "id": 6329,
            "name": "San Michele di Ganzaria",
            "provincia": "CT",
            "cap": "95040",
            "cod_catastale": "I035",
            "cod_istat": "087043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 1274,
            "area": "",
            "ech": 0
        },
        {
            "id": 6330,
            "name": "San Michele di Serino",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "I034",
            "cod_istat": "064084",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 1781,
            "area": "",
            "ech": 0
        },
        {
            "id": 6331,
            "name": "San Michele Mondovì",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "I037",
            "cod_istat": "004210",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 444,
            "giorni": 2866,
            "area": "",
            "ech": 0
        },
        {
            "id": 6332,
            "name": "San Michele Salentino",
            "provincia": "BR",
            "cap": "72018",
            "cod_catastale": "I045",
            "cod_istat": "074014",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 153,
            "giorni": 1307,
            "area": "",
            "ech": 0
        },
        {
            "id": 6333,
            "name": "San Miniato",
            "provincia": "PI",
            "cap": "56028",
            "cod_catastale": "I046",
            "cod_istat": "050032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1513,
            "area": "",
            "ech": 0
        },
        {
            "id": 6334,
            "name": "San Nazario",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "I047",
            "cod_istat": "024093",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 6335,
            "name": "San Nazzaro",
            "provincia": "BN",
            "cap": "82018",
            "cod_catastale": "I049",
            "cod_istat": "062066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 1971,
            "area": "",
            "ech": 0
        },
        {
            "id": 6336,
            "name": "San Nazzaro Sesia",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "I052",
            "cod_istat": "003134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 153,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6337,
            "name": "San Nazzaro Val Cavargna",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "I051",
            "cod_istat": "013207",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 995,
            "giorni": 3482,
            "area": "",
            "ech": 0
        },
        {
            "id": 6338,
            "name": "San Nicandro Garganico",
            "provincia": "FG",
            "cap": "71015",
            "cod_catastale": "I054",
            "cod_istat": "071049",
            "attivo": 1,
            "zona": null,
            "cassa": 1,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6339,
            "name": "San Nicola Arcella",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "I060",
            "cod_istat": "078125",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1045,
            "area": "",
            "ech": 0
        },
        {
            "id": 6340,
            "name": "San Nicola Baronia",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I061",
            "cod_istat": "064085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 2179,
            "area": "",
            "ech": 0
        },
        {
            "id": 6341,
            "name": "San Nicola da Crissa",
            "provincia": "VV",
            "cap": "89821",
            "cod_catastale": "I058",
            "cod_istat": "102035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 518,
            "giorni": 1837,
            "area": "",
            "ech": 1
        },
        {
            "id": 6342,
            "name": "San Nicola dell'Alto",
            "provincia": "KR",
            "cap": "88817",
            "cod_catastale": "I057",
            "cod_istat": "101021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 579,
            "giorni": 1966,
            "area": "",
            "ech": 0
        },
        {
            "id": 6343,
            "name": "San Nicola la Strada",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "I056",
            "cod_istat": "061078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 948,
            "area": "",
            "ech": 0
        },
        {
            "id": 6344,
            "name": "San Nicola Manfredi",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "I062",
            "cod_istat": "062067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 1815,
            "area": "",
            "ech": 0
        },
        {
            "id": 6345,
            "name": "San Nicolò d'Arcidano",
            "provincia": "OR",
            "cap": "09097",
            "cod_catastale": "A368",
            "cod_istat": "095046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 972,
            "area": "",
            "ech": 0
        },
        {
            "id": 6346,
            "name": "San Nicolò di Comelico",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "I063",
            "cod_istat": "025046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1061,
            "giorni": 4260,
            "area": "",
            "ech": 0
        },
        {
            "id": 6347,
            "name": "San Nicolò Gerrei",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "G383",
            "cod_istat": "111064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 1339,
            "area": "",
            "ech": 0
        },
        {
            "id": 6348,
            "name": "San Pancrazio",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "I065",
            "cod_istat": "021084",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 735,
            "giorni": 3550,
            "area": "",
            "ech": 0
        },
        {
            "id": 6349,
            "name": "San Pancrazio Salentino",
            "provincia": "BR",
            "cap": "72026",
            "cod_catastale": "I066",
            "cod_istat": "074015",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 1160,
            "area": "",
            "ech": 0
        },
        {
            "id": 6350,
            "name": "San Paolo",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "G407",
            "cod_istat": "017138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 6351,
            "name": "San Paolo Albanese",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "B906",
            "cod_istat": "076020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2364,
            "area": "",
            "ech": 0
        },
        {
            "id": 6352,
            "name": "San Paolo Bel Sito",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "I073",
            "cod_istat": "063069",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1048,
            "area": "",
            "ech": 0
        },
        {
            "id": 6353,
            "name": "San Paolo Cervo",
            "provincia": "BI",
            "cap": "13812",
            "cod_catastale": "I074",
            "cod_istat": "096060",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 795,
            "giorni": 3338,
            "area": "",
            "ech": 0
        },
        {
            "id": 6354,
            "name": "San Paolo d'Argon",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "B310",
            "cod_istat": "016189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 2432,
            "area": "",
            "ech": 0
        },
        {
            "id": 6355,
            "name": "San Paolo di Civitate",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "I072",
            "cod_istat": "071050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 1576,
            "area": "",
            "ech": 0
        },
        {
            "id": 6356,
            "name": "San Paolo di Jesi",
            "provincia": "AN",
            "cap": "60038",
            "cod_catastale": "I071",
            "cod_istat": "042042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 1962,
            "area": "",
            "ech": 0
        },
        {
            "id": 6357,
            "name": "San Paolo Solbrito",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "I076",
            "cod_istat": "005101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2705,
            "area": "",
            "ech": 0
        },
        {
            "id": 6358,
            "name": "San Pellegrino Terme",
            "provincia": "BG",
            "cap": "24016",
            "cod_catastale": "I079",
            "cod_istat": "016190",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 358,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 6359,
            "name": "San Pier d'Isonzo",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "I082",
            "cod_istat": "031021",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2268,
            "area": "",
            "ech": 0
        },
        {
            "id": 6360,
            "name": "San Pier Niceto",
            "provincia": "ME",
            "cap": "98045",
            "cod_catastale": "I084",
            "cod_istat": "083080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 1071,
            "area": "",
            "ech": 0
        },
        {
            "id": 6361,
            "name": "San Piero a Sieve",
            "provincia": "FI",
            "cap": "50037",
            "cod_catastale": "I085",
            "cod_istat": "048040",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2151,
            "area": "",
            "ech": 0
        },
        {
            "id": 6362,
            "name": "San Piero Patti",
            "provincia": "ME",
            "cap": "98068",
            "cod_catastale": "I086",
            "cod_istat": "083081",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 448,
            "giorni": 1392,
            "area": "",
            "ech": 1
        },
        {
            "id": 6363,
            "name": "San Pietro a Maida",
            "provincia": "CZ",
            "cap": "88025",
            "cod_catastale": "I093",
            "cod_istat": "079114",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 1523,
            "area": "",
            "ech": 0
        },
        {
            "id": 6364,
            "name": "San Pietro al Natisone",
            "provincia": "UD",
            "cap": "33049",
            "cod_catastale": "I092",
            "cod_istat": "030103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 6365,
            "name": "San Pietro al Tanagro",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "I089",
            "cod_istat": "065125",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1587,
            "area": "",
            "ech": 0
        },
        {
            "id": 6366,
            "name": "San Pietro Apostolo",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "I095",
            "cod_istat": "079115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 2324,
            "area": "",
            "ech": 0
        },
        {
            "id": 6367,
            "name": "San Pietro Avellana",
            "provincia": "IS",
            "cap": "86088",
            "cod_catastale": "I096",
            "cod_istat": "094043",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 960,
            "giorni": 2739,
            "area": "",
            "ech": 0
        },
        {
            "id": 6368,
            "name": "San Pietro Clarenza",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "I098",
            "cod_istat": "087044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 463,
            "giorni": 1337,
            "area": "",
            "ech": 1
        },
        {
            "id": 6369,
            "name": "San Pietro di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "I088",
            "cod_istat": "025047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1100,
            "giorni": 4322,
            "area": "",
            "ech": 0
        },
        {
            "id": 6370,
            "name": "San Pietro di Caridà",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "I102",
            "cod_istat": "080075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1334,
            "area": "",
            "ech": 0
        },
        {
            "id": 6371,
            "name": "San Pietro di Feletto",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "I103",
            "cod_istat": "026073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2766,
            "area": "",
            "ech": 0
        },
        {
            "id": 6372,
            "name": "San Pietro di Morubio",
            "provincia": "VR",
            "cap": "37050",
            "cod_catastale": "I105",
            "cod_istat": "023075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2429,
            "area": "",
            "ech": 0
        },
        {
            "id": 6373,
            "name": "San Pietro in Amantea",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "I108",
            "cod_istat": "078126",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 374,
            "giorni": 1555,
            "area": "",
            "ech": 0
        },
        {
            "id": 6374,
            "name": "San Pietro in Cariano",
            "provincia": "VR",
            "cap": "37029",
            "cod_catastale": "I109",
            "cod_istat": "023076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 151,
            "giorni": 2439,
            "area": "",
            "ech": 0
        },
        {
            "id": 6375,
            "name": "San Pietro in Casale",
            "provincia": "BO",
            "cap": "40018",
            "cod_catastale": "I110",
            "cod_istat": "037055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2181,
            "area": "",
            "ech": 0
        },
        {
            "id": 6376,
            "name": "San Pietro in Cerro",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "G788",
            "cod_istat": "033041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 6377,
            "name": "San Pietro in Gu",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "I107",
            "cod_istat": "028078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 6378,
            "name": "San Pietro in Guarano",
            "provincia": "CS",
            "cap": "87047",
            "cod_catastale": "I114",
            "cod_istat": "078127",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 6379,
            "name": "San Pietro in Lama",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "I115",
            "cod_istat": "075071",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1111,
            "area": "",
            "ech": 0
        },
        {
            "id": 6380,
            "name": "San Pietro Infine",
            "provincia": "CE",
            "cap": "81049",
            "cod_catastale": "I113",
            "cod_istat": "061079",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 1324,
            "area": "",
            "ech": 0
        },
        {
            "id": 6381,
            "name": "San Pietro Mosezzo",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "I116",
            "cod_istat": "003135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 6382,
            "name": "San Pietro Mussolino",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "I117",
            "cod_istat": "024094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2683,
            "area": "",
            "ech": 0
        },
        {
            "id": 6383,
            "name": "San Pietro Val Lemina",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "I090",
            "cod_istat": "001250",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 451,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 6384,
            "name": "San Pietro Vernotico",
            "provincia": "BR",
            "cap": "72027",
            "cod_catastale": "I119",
            "cod_istat": "074016",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1123,
            "area": "",
            "ech": 0
        },
        {
            "id": 6385,
            "name": "San Pietro Viminario",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "I120",
            "cod_istat": "028079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 6386,
            "name": "San Pio delle Camere",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "I121",
            "cod_istat": "066088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 830,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 6387,
            "name": "San Polo dei Cavalieri",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "I125",
            "cod_istat": "058096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 651,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 6388,
            "name": "San Polo d'Enza",
            "provincia": "RE",
            "cap": "42020",
            "cod_catastale": "I123",
            "cod_istat": "035038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 166,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 6389,
            "name": "San Polo di Piave",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "I124",
            "cod_istat": "026074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 27,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 6390,
            "name": "San Polo Matese",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "I122",
            "cod_istat": "070071",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6391,
            "name": "San Ponso",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "I126",
            "cod_istat": "001251",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 347,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 6392,
            "name": "San Possidonio",
            "provincia": "MO",
            "cap": "41039",
            "cod_catastale": "I128",
            "cod_istat": "036038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2196,
            "area": "",
            "ech": 0
        },
        {
            "id": 6393,
            "name": "San Potito Sannitico",
            "provincia": "CE",
            "cap": "81016",
            "cod_catastale": "I130",
            "cod_istat": "061080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 6394,
            "name": "San Potito Ultra",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I129",
            "cod_istat": "064086",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 1966,
            "area": "",
            "ech": 0
        },
        {
            "id": 6395,
            "name": "San Prisco",
            "provincia": "CE",
            "cap": "81054",
            "cod_catastale": "I131",
            "cod_istat": "061081",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 928,
            "area": "",
            "ech": 0
        },
        {
            "id": 6396,
            "name": "San Procopio",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "I132",
            "cod_istat": "080076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 352,
            "giorni": 1390,
            "area": "",
            "ech": 1
        },
        {
            "id": 6397,
            "name": "San Prospero",
            "provincia": "MO",
            "cap": "41030",
            "cod_catastale": "I133",
            "cod_istat": "036039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2199,
            "area": "",
            "ech": 0
        },
        {
            "id": 6398,
            "name": "San Quirico d'Orcia",
            "provincia": "SI",
            "cap": "53027",
            "cod_catastale": "I135",
            "cod_istat": "052030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 2041,
            "area": "",
            "ech": 0
        },
        {
            "id": 6399,
            "name": "San Quirino",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "I136",
            "cod_istat": "093040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2437,
            "area": "",
            "ech": 0
        },
        {
            "id": 6400,
            "name": "San Raffaele Cimena",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "I137",
            "cod_istat": "001252",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 195,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 6401,
            "name": "San Roberto",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "I139",
            "cod_istat": "080077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1190,
            "area": "",
            "ech": 0
        },
        {
            "id": 6402,
            "name": "San Rocco al Porto",
            "provincia": "LO",
            "cap": "26865",
            "cod_catastale": "I140",
            "cod_istat": "098049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6403,
            "name": "San Romano in Garfagnana",
            "provincia": "LU",
            "cap": "55038",
            "cod_catastale": "I142",
            "cod_istat": "046027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 555,
            "giorni": 2805,
            "area": "",
            "ech": 0
        },
        {
            "id": 6404,
            "name": "San Rufo",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "I143",
            "cod_istat": "065126",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2079,
            "area": "",
            "ech": 0
        },
        {
            "id": 6405,
            "name": "San Salvatore di Fitalia",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "I147",
            "cod_istat": "083082",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 603,
            "giorni": 1657,
            "area": "",
            "ech": 0
        },
        {
            "id": 6406,
            "name": "San Salvatore Monferrato",
            "provincia": "AL",
            "cap": "15046",
            "cod_catastale": "I144",
            "cod_istat": "006154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 6407,
            "name": "San Salvatore Telesino",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "I145",
            "cod_istat": "062068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 1243,
            "area": "",
            "ech": 0
        },
        {
            "id": 6408,
            "name": "San Salvo",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "I148",
            "cod_istat": "069083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 100,
            "giorni": 1385,
            "area": "",
            "ech": 0
        },
        {
            "id": 6409,
            "name": "San Sebastiano al Vesuvio",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "I151",
            "cod_istat": "063070",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 1273,
            "area": "",
            "ech": 0
        },
        {
            "id": 6410,
            "name": "San Sebastiano Curone",
            "provincia": "AL",
            "cap": "15056",
            "cod_catastale": "I150",
            "cod_istat": "006155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2769,
            "area": "",
            "ech": 0
        },
        {
            "id": 6411,
            "name": "San Sebastiano da Po",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "I152",
            "cod_istat": "001253",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2823,
            "area": "",
            "ech": 0
        },
        {
            "id": 6412,
            "name": "San Secondo di Pinerolo",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "I154",
            "cod_istat": "001254",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 413,
            "giorni": 2885,
            "area": "",
            "ech": 0
        },
        {
            "id": 6413,
            "name": "San Secondo Parmense",
            "provincia": "PR",
            "cap": "43017",
            "cod_catastale": "I153",
            "cod_istat": "034033",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 6414,
            "name": "San Severino Lucano",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "I157",
            "cod_istat": "076078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 877,
            "giorni": 2504,
            "area": "",
            "ech": 0
        },
        {
            "id": 6415,
            "name": "San Severino Marche",
            "provincia": "MC",
            "cap": "62027",
            "cod_catastale": "I156",
            "cod_istat": "043047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 1915,
            "area": "",
            "ech": 0
        },
        {
            "id": 6416,
            "name": "San Severo",
            "provincia": "FG",
            "cap": "71016",
            "cod_catastale": "I158",
            "cod_istat": "071051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 1494,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 6417,
            "name": "San Siro",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "I162",
            "cod_istat": "013248",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 6418,
            "name": "San Sossio Baronia",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I163",
            "cod_istat": "064087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 6419,
            "name": "San Sostene",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "I164",
            "cod_istat": "079116",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 1647,
            "area": "",
            "ech": 1
        },
        {
            "id": 6420,
            "name": "San Sosti",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "I165",
            "cod_istat": "078128",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 1580,
            "area": "",
            "ech": 1
        },
        {
            "id": 6421,
            "name": "San Sperate",
            "provincia": "SU",
            "cap": "09026",
            "cod_catastale": "I166",
            "cod_istat": "111065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 41,
            "giorni": 989,
            "area": "",
            "ech": 1
        },
        {
            "id": 6422,
            "name": "San Tammaro",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "I261",
            "cod_istat": "061085",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 1084,
            "area": "",
            "ech": 0
        },
        {
            "id": 6423,
            "name": "San Teodoro",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "I328",
            "cod_istat": "083090",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1150,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 6424,
            "name": "San Teodoro",
            "provincia": "SS",
            "cap": "07052",
            "cod_catastale": "I329",
            "cod_istat": "090092",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 765,
            "area": "",
            "ech": 1
        },
        {
            "id": 6425,
            "name": "San Tomaso Agordino",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "I347",
            "cod_istat": "025049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1081,
            "giorni": 4292,
            "area": "",
            "ech": 0
        },
        {
            "id": 6426,
            "name": "San Valentino in Abruzzo Citeriore",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "I376",
            "cod_istat": "068038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 457,
            "giorni": 1960,
            "area": "",
            "ech": 0
        },
        {
            "id": 6427,
            "name": "San Valentino Torio",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "I377",
            "cod_istat": "065132",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 1150,
            "area": "",
            "ech": 0
        },
        {
            "id": 6428,
            "name": "San Venanzo",
            "provincia": "TR",
            "cap": "05010",
            "cod_catastale": "I381",
            "cod_istat": "055030",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 2211,
            "area": "",
            "ech": 0
        },
        {
            "id": 6429,
            "name": "San Vendemiano",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "I382",
            "cod_istat": "026076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 6430,
            "name": "San Vero Milis",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "I384",
            "cod_istat": "095050",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 976,
            "area": "",
            "ech": 0
        },
        {
            "id": 6431,
            "name": "San Vincenzo",
            "provincia": "LI",
            "cap": "57027",
            "cod_catastale": "I390",
            "cod_istat": "049018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1051,
            "area": "",
            "ech": 0
        },
        {
            "id": 6432,
            "name": "San Vincenzo La Costa",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "I388",
            "cod_istat": "078135",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 1785,
            "area": "",
            "ech": 0
        },
        {
            "id": 6433,
            "name": "San Vincenzo Valle Roveto",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "I389",
            "cod_istat": "066092",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 388,
            "giorni": 1983,
            "area": "",
            "ech": 0
        },
        {
            "id": 6434,
            "name": "San Vitaliano",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "I391",
            "cod_istat": "063075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1014,
            "area": "",
            "ech": 0
        },
        {
            "id": 6435,
            "name": "San Vito",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I402",
            "cod_istat": "111066",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 869,
            "area": "",
            "ech": 0
        },
        {
            "id": 6436,
            "name": "San Vito al Tagliamento",
            "provincia": "PN",
            "cap": "33078",
            "cod_catastale": "I403",
            "cod_istat": "093041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 6437,
            "name": "San Vito al Torre",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "I404",
            "cod_istat": "030105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2278,
            "area": "",
            "ech": 0
        },
        {
            "id": 6438,
            "name": "San Vito Chietino",
            "provincia": "CH",
            "cap": "66038",
            "cod_catastale": "I394",
            "cod_istat": "069086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 1379,
            "area": "",
            "ech": 0
        },
        {
            "id": 6439,
            "name": "San Vito dei Normanni",
            "provincia": "BR",
            "cap": "72019",
            "cod_catastale": "I396",
            "cod_istat": "074017",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1234,
            "area": "",
            "ech": 0
        },
        {
            "id": 6440,
            "name": "San Vito di Cadore",
            "provincia": "BL",
            "cap": "32046",
            "cod_catastale": "I392",
            "cod_istat": "025051",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1010,
            "giorni": 4180,
            "area": "",
            "ech": 0
        },
        {
            "id": 6441,
            "name": "San Vito di Fagagna",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "I405",
            "cod_istat": "030106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 2353,
            "area": "",
            "ech": 0
        },
        {
            "id": 6442,
            "name": "San Vito di Leguzzano",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "I401",
            "cod_istat": "024096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 158,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 6443,
            "name": "San Vito Lo Capo",
            "provincia": "TP",
            "cap": "91010",
            "cod_catastale": "I407",
            "cod_istat": "081020",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 813,
            "area": "",
            "ech": 0
        },
        {
            "id": 6444,
            "name": "San Vito Romano",
            "provincia": "RM",
            "cap": "00030",
            "cod_catastale": "I400",
            "cod_istat": "058100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 655,
            "giorni": 2488,
            "area": "",
            "ech": 0
        },
        {
            "id": 6445,
            "name": "San Vito sullo Ionio",
            "provincia": "CZ",
            "cap": "88067",
            "cod_catastale": "I393",
            "cod_istat": "079122",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 1508,
            "area": "",
            "ech": 1
        },
        {
            "id": 6446,
            "name": "San Vittore del Lazio",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "I408",
            "cod_istat": "060070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 6447,
            "name": "San Vittore Olona",
            "provincia": "MI",
            "cap": "20028",
            "cod_catastale": "I409",
            "cod_istat": "015201",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2448,
            "area": "",
            "ech": 0
        },
        {
            "id": 6448,
            "name": "San Zeno di Montagna",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "I414",
            "cod_istat": "023079",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 3253,
            "area": "",
            "ech": 0
        },
        {
            "id": 6449,
            "name": "San Zeno Naviglio",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "I412",
            "cod_istat": "017173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2350,
            "area": "",
            "ech": 0
        },
        {
            "id": 6450,
            "name": "San Zenone al Lambro",
            "provincia": "MI",
            "cap": "20070",
            "cod_catastale": "I415",
            "cod_istat": "015202",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 6451,
            "name": "San Zenone al Po",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "I416",
            "cod_istat": "018145",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6452,
            "name": "San Zenone degli Ezzelini",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "I417",
            "cod_istat": "026077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2454,
            "area": "",
            "ech": 0
        },
        {
            "id": 6453,
            "name": "Sanarica",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "H757",
            "cod_istat": "075067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 1224,
            "area": "",
            "ech": 0
        },
        {
            "id": 6454,
            "name": "Sandigliano",
            "provincia": "BI",
            "cap": "13876",
            "cod_catastale": "H821",
            "cod_istat": "096059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 2724,
            "area": "",
            "ech": 0
        },
        {
            "id": 6455,
            "name": "Sandrigo",
            "provincia": "VI",
            "cap": "36066",
            "cod_catastale": "H829",
            "cod_istat": "024091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2343,
            "area": "",
            "ech": 0
        },
        {
            "id": 6456,
            "name": "Sanfrè",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "H851",
            "cod_istat": "004208",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2592,
            "area": "",
            "ech": 0
        },
        {
            "id": 6457,
            "name": "Sanfront",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "H852",
            "cod_istat": "004209",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 2923,
            "area": "",
            "ech": 0
        },
        {
            "id": 6458,
            "name": "Sangano",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "H855",
            "cod_istat": "001241",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 2864,
            "area": "",
            "ech": 0
        },
        {
            "id": 6459,
            "name": "Sangiano",
            "provincia": "VA",
            "cap": "21038",
            "cod_catastale": "H872",
            "cod_istat": "012141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 2458,
            "area": "",
            "ech": 0
        },
        {
            "id": 6460,
            "name": "Sangineto",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "H877",
            "cod_istat": "078117",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1382,
            "area": "",
            "ech": 1
        },
        {
            "id": 6461,
            "name": "Sanguinetto",
            "provincia": "VR",
            "cap": "37058",
            "cod_catastale": "H944",
            "cod_istat": "023072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 6462,
            "name": "Sanluri",
            "provincia": "SU",
            "cap": "09025",
            "cod_catastale": "H974",
            "cod_istat": "111067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 135,
            "giorni": 1267,
            "area": "",
            "ech": 1
        },
        {
            "id": 6463,
            "name": "Sannazzaro de' Burgondi",
            "provincia": "PV",
            "cap": "27039",
            "cod_catastale": "I048",
            "cod_istat": "018138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6464,
            "name": "Sannicandro di Bari",
            "provincia": "BA",
            "cap": "70028",
            "cod_catastale": "I053",
            "cod_istat": "072040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 1444,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6465,
            "name": "Sannicola",
            "provincia": "LE",
            "cap": "73017",
            "cod_catastale": "I059",
            "cod_istat": "075070",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1079,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6466,
            "name": "Sanremo",
            "provincia": "IM",
            "cap": "18038",
            "cod_catastale": "I138",
            "cod_istat": "008055",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6467,
            "name": "Sansepolcro",
            "provincia": "AR",
            "cap": "52037",
            "cod_catastale": "I155",
            "cod_istat": "051034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2231,
            "area": "",
            "ech": 0
        },
        {
            "id": 6468,
            "name": "Santa Brigida",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "I168",
            "cod_istat": "016191",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 805,
            "giorni": 3213,
            "area": "",
            "ech": 0
        },
        {
            "id": 6469,
            "name": "Santa Caterina Albanese",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "I171",
            "cod_istat": "078129",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 1866,
            "area": "",
            "ech": 0
        },
        {
            "id": 6470,
            "name": "Santa Caterina dello Ionio",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "I170",
            "cod_istat": "079117",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 1
        },
        {
            "id": 6471,
            "name": "Santa Caterina Villarmosa",
            "provincia": "CL",
            "cap": "93018",
            "cod_catastale": "I169",
            "cod_istat": "085017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 606,
            "giorni": 1581,
            "area": "",
            "ech": 0
        },
        {
            "id": 6472,
            "name": "Santa Cesarea Terme",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "I172",
            "cod_istat": "075072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1178,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6473,
            "name": "Santa Cristina d'Aspromonte",
            "provincia": "RC",
            "cap": "89056",
            "cod_catastale": "I176",
            "cod_istat": "080078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 514,
            "giorni": 1729,
            "area": "",
            "ech": 1
        },
        {
            "id": 6474,
            "name": "Santa Cristina e Bissone",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "I175",
            "cod_istat": "018139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6475,
            "name": "Santa Cristina Gela",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "I174",
            "cod_istat": "082066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 674,
            "giorni": 1719,
            "area": "",
            "ech": 0
        },
        {
            "id": 6476,
            "name": "Santa Cristina Valgardena",
            "provincia": "BZ",
            "cap": "39047",
            "cod_catastale": "I173",
            "cod_istat": "021085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1428,
            "giorni": 4861,
            "area": "",
            "ech": 0
        },
        {
            "id": 6477,
            "name": "Santa Croce Camerina",
            "provincia": "RG",
            "cap": "97017",
            "cod_catastale": "I178",
            "cod_istat": "088010",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 87,
            "giorni": 877,
            "area": "",
            "ech": 1
        },
        {
            "id": 6478,
            "name": "Santa Croce del Sannio",
            "provincia": "BN",
            "cap": "82020",
            "cod_catastale": "I179",
            "cod_istat": "062069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 689,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 6479,
            "name": "Santa Croce di Magliano",
            "provincia": "CB",
            "cap": "86047",
            "cod_catastale": "I181",
            "cod_istat": "070072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 608,
            "giorni": 2142,
            "area": "",
            "ech": 0
        },
        {
            "id": 6480,
            "name": "Santa Croce sull'Arno",
            "provincia": "PI",
            "cap": "56029",
            "cod_catastale": "I177",
            "cod_istat": "050033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 1866,
            "area": "",
            "ech": 0
        },
        {
            "id": 6481,
            "name": "Santa Domenica Talao",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "I183",
            "cod_istat": "078130",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 1416,
            "area": "",
            "ech": 0
        },
        {
            "id": 6482,
            "name": "Santa Domenica Vittoria",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "I184",
            "cod_istat": "083083",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1027,
            "giorni": 2383,
            "area": "",
            "ech": 1
        },
        {
            "id": 6483,
            "name": "Santa Elisabetta",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "I185",
            "cod_istat": "084037",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 457,
            "giorni": 1230,
            "area": "",
            "ech": 0
        },
        {
            "id": 6484,
            "name": "Santa Fiora",
            "provincia": "GR",
            "cap": "58037",
            "cod_catastale": "I187",
            "cod_istat": "053022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 687,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 6485,
            "name": "Santa Flavia",
            "provincia": "PA",
            "cap": "90017",
            "cod_catastale": "I188",
            "cod_istat": "082067",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 796,
            "area": "",
            "ech": 1
        },
        {
            "id": 6486,
            "name": "Santa Giuletta",
            "provincia": "PV",
            "cap": "27046",
            "cod_catastale": "I203",
            "cod_istat": "018140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6487,
            "name": "Santa Giusta",
            "provincia": "OR",
            "cap": "09096",
            "cod_catastale": "I205",
            "cod_istat": "095047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1060,
            "area": "",
            "ech": 0
        },
        {
            "id": 6488,
            "name": "Santa Giustina",
            "provincia": "BL",
            "cap": "32035",
            "cod_catastale": "I206",
            "cod_istat": "025048",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 3071,
            "area": "",
            "ech": 0
        },
        {
            "id": 6489,
            "name": "Santa Giustina in Colle",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "I207",
            "cod_istat": "028080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2399,
            "area": "",
            "ech": 0
        },
        {
            "id": 6490,
            "name": "Santa Luce",
            "provincia": "PI",
            "cap": "56040",
            "cod_catastale": "I217",
            "cod_istat": "050034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1824,
            "area": "",
            "ech": 0
        },
        {
            "id": 6491,
            "name": "Santa Lucia del Mela",
            "provincia": "ME",
            "cap": "98046",
            "cod_catastale": "I220",
            "cod_istat": "083086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 994,
            "area": "",
            "ech": 1
        },
        {
            "id": 6492,
            "name": "Santa Lucia di Piave",
            "provincia": "TV",
            "cap": "31025",
            "cod_catastale": "I221",
            "cod_istat": "026075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 6493,
            "name": "Santa Lucia di Serino",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "I219",
            "cod_istat": "064088",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1870,
            "area": "",
            "ech": 0
        },
        {
            "id": 6494,
            "name": "Santa Margherita d''Adige",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "I226",
            "cod_istat": "028081",
            "attivo": 0,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6495,
            "name": "Santa Margherita di Belice",
            "provincia": "AG",
            "cap": "92018",
            "cod_catastale": "I224",
            "cod_istat": "084038",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1218,
            "area": "",
            "ech": 0
        },
        {
            "id": 6496,
            "name": "Santa Margherita di Staffora",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "I230",
            "cod_istat": "018142",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 3138,
            "area": "",
            "ech": 0
        },
        {
            "id": 6497,
            "name": "Santa Margherita Ligure",
            "provincia": "GE",
            "cap": "16038",
            "cod_catastale": "I225",
            "cod_istat": "010054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 1434,
            "area": "",
            "ech": 0
        },
        {
            "id": 6498,
            "name": "Santa Maria a Monte",
            "provincia": "PI",
            "cap": "56020",
            "cod_catastale": "I232",
            "cod_istat": "050035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 1916,
            "area": "",
            "ech": 0
        },
        {
            "id": 6499,
            "name": "Santa Maria a Vico",
            "provincia": "CE",
            "cap": "81028",
            "cod_catastale": "I233",
            "cod_istat": "061082",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 1208,
            "area": "",
            "ech": 0
        },
        {
            "id": 6500,
            "name": "Santa Maria Capua Vetere",
            "provincia": "CE",
            "cap": "81055",
            "cod_catastale": "I234",
            "cod_istat": "061083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 1113,
            "area": "",
            "ech": 0
        },
        {
            "id": 6501,
            "name": "Santa Maria Coghinas",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M284",
            "cod_istat": "090087",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 866,
            "area": "",
            "ech": 0
        },
        {
            "id": 6502,
            "name": "Santa Maria del Cedro",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "C717",
            "cod_istat": "078132",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1030,
            "area": "",
            "ech": 0
        },
        {
            "id": 6503,
            "name": "Santa Maria del Molise",
            "provincia": "IS",
            "cap": "86096",
            "cod_catastale": "I238",
            "cod_istat": "094045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2131,
            "area": "",
            "ech": 0
        },
        {
            "id": 6504,
            "name": "Santa Maria della Versa",
            "provincia": "PV",
            "cap": "27047",
            "cod_catastale": "I237",
            "cod_istat": "018143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2852,
            "area": "",
            "ech": 0
        },
        {
            "id": 6505,
            "name": "Santa Maria di Licodia",
            "provincia": "CT",
            "cap": "95038",
            "cod_catastale": "I240",
            "cod_istat": "087047",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 442,
            "giorni": 1340,
            "area": "",
            "ech": 1
        },
        {
            "id": 6506,
            "name": "Santa Maria di Sala",
            "provincia": "VE",
            "cap": "30036",
            "cod_catastale": "I242",
            "cod_istat": "027035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 6507,
            "name": "Santa Maria Hoè",
            "provincia": "LC",
            "cap": "23889",
            "cod_catastale": "I243",
            "cod_istat": "097074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 371,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 6508,
            "name": "Santa Maria Imbaro",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "I244",
            "cod_istat": "069084",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 1576,
            "area": "",
            "ech": 0
        },
        {
            "id": 6509,
            "name": "Santa Maria la Carità",
            "provincia": "NA",
            "cap": "80050",
            "cod_catastale": "M273",
            "cod_istat": "063090",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1112,
            "area": "",
            "ech": 0
        },
        {
            "id": 6510,
            "name": "Santa Maria la Fossa",
            "provincia": "CE",
            "cap": "81050",
            "cod_catastale": "I247",
            "cod_istat": "061084",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 1094,
            "area": "",
            "ech": 0
        },
        {
            "id": 6511,
            "name": "Santa Maria la Longa",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "I248",
            "cod_istat": "030104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 6512,
            "name": "Santa Maria Maggiore",
            "provincia": "VB",
            "cap": "28857",
            "cod_catastale": "I249",
            "cod_istat": "103062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 816,
            "giorni": 3365,
            "area": "",
            "ech": 0
        },
        {
            "id": 6513,
            "name": "Santa Maria Nuova",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "I251",
            "cod_istat": "042043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 1988,
            "area": "",
            "ech": 0
        },
        {
            "id": 6514,
            "name": "Santa Marina",
            "provincia": "SA",
            "cap": "84067",
            "cod_catastale": "I253",
            "cod_istat": "065127",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 415,
            "giorni": 1563,
            "area": "",
            "ech": 0
        },
        {
            "id": 6515,
            "name": "Santa Marina Salina",
            "provincia": "ME",
            "cap": "98050",
            "cod_catastale": "I254",
            "cod_istat": "083087",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 669,
            "area": "",
            "ech": 0
        },
        {
            "id": 6516,
            "name": "Santa Marinella",
            "provincia": "RM",
            "cap": "00058",
            "cod_catastale": "I255",
            "cod_istat": "058097",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1264,
            "area": "",
            "ech": 0
        },
        {
            "id": 6517,
            "name": "Santa Ninfa",
            "provincia": "TP",
            "cap": "91029",
            "cod_catastale": "I291",
            "cod_istat": "081019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1231,
            "area": "",
            "ech": 0
        },
        {
            "id": 6518,
            "name": "Santa Paolina",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "I301",
            "cod_istat": "064093",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 2072,
            "area": "",
            "ech": 0
        },
        {
            "id": 6519,
            "name": "Santa Severina",
            "provincia": "KR",
            "cap": "88832",
            "cod_catastale": "I308",
            "cod_istat": "101022",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 1434,
            "area": "",
            "ech": 0
        },
        {
            "id": 6520,
            "name": "Santa Sofia",
            "provincia": "FC",
            "cap": "47018",
            "cod_catastale": "I310",
            "cod_istat": "040043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2484,
            "area": "",
            "ech": 0
        },
        {
            "id": 6521,
            "name": "Santa Sofia d'Epiro",
            "provincia": "CS",
            "cap": "87048",
            "cod_catastale": "I309",
            "cod_istat": "078133",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 558,
            "giorni": 1935,
            "area": "",
            "ech": 0
        },
        {
            "id": 6522,
            "name": "Santa Teresa di Riva",
            "provincia": "ME",
            "cap": "98028",
            "cod_catastale": "I311",
            "cod_istat": "083089",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 637,
            "area": "",
            "ech": 0
        },
        {
            "id": 6523,
            "name": "Santa Teresa Gallura",
            "provincia": "SS",
            "cap": "07028",
            "cod_catastale": "I312",
            "cod_istat": "090063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 992,
            "area": "",
            "ech": 0
        },
        {
            "id": 6524,
            "name": "Santa Venerina",
            "provincia": "CT",
            "cap": "95010",
            "cod_catastale": "I314",
            "cod_istat": "087048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 1094,
            "area": "",
            "ech": 1
        },
        {
            "id": 6525,
            "name": "Santa Vittoria d'Alba",
            "provincia": "CN",
            "cap": "12069",
            "cod_catastale": "I316",
            "cod_istat": "004212",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 2683,
            "area": "",
            "ech": 0
        },
        {
            "id": 6526,
            "name": "Santa Vittoria in Matenano",
            "provincia": "FM",
            "cap": "63854",
            "cod_catastale": "I315",
            "cod_istat": "109036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2372,
            "area": "",
            "ech": 0
        },
        {
            "id": 6527,
            "name": "Santadi",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "I182",
            "cod_istat": "111068",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 135,
            "giorni": 1119,
            "area": "",
            "ech": 1
        },
        {
            "id": 6528,
            "name": "Sant'Agapito",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "I189",
            "cod_istat": "094044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 547,
            "giorni": 2081,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6529,
            "name": "Sant'Agata Bolognese",
            "provincia": "BO",
            "cap": "40019",
            "cod_catastale": "I191",
            "cod_istat": "037056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2187,
            "area": "",
            "ech": 0
        },
        {
            "id": 6530,
            "name": "Sant'Agata de' Goti",
            "provincia": "BN",
            "cap": "82019",
            "cod_catastale": "I197",
            "cod_istat": "062070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 1404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6531,
            "name": "Sant'Agata del Bianco",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "I198",
            "cod_istat": "080079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 1441,
            "area": "",
            "ech": 1
        },
        {
            "id": 6532,
            "name": "Sant'Agata di Esaro",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "I192",
            "cod_istat": "078131",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 461,
            "giorni": 1560,
            "area": "",
            "ech": 0
        },
        {
            "id": 6533,
            "name": "Sant'Agata di Militello",
            "provincia": "ME",
            "cap": "98076",
            "cod_catastale": "I199",
            "cod_istat": "083084",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 678,
            "area": "",
            "ech": 0
        },
        {
            "id": 6534,
            "name": "Sant'Agata di Puglia",
            "provincia": "FG",
            "cap": "71028",
            "cod_catastale": "I193",
            "cod_istat": "071052",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 794,
            "giorni": 2511,
            "area": "",
            "ech": 0
        },
        {
            "id": 6535,
            "name": "Sant'Agata Feltria",
            "provincia": "RN",
            "cap": "47866",
            "cod_catastale": "I201",
            "cod_istat": "099026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 607,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 6536,
            "name": "Sant'Agata Fossili",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "I190",
            "cod_istat": "006156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2926,
            "area": "",
            "ech": 0
        },
        {
            "id": 6537,
            "name": "Sant'Agata li Battiati",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "I202",
            "cod_istat": "087045",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1083,
            "area": "",
            "ech": 1
        },
        {
            "id": 6538,
            "name": "Sant'Agata sul Santerno",
            "provincia": "RA",
            "cap": "48020",
            "cod_catastale": "I196",
            "cod_istat": "039017",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 6539,
            "name": "Sant'Agnello",
            "provincia": "NA",
            "cap": "80065",
            "cod_catastale": "I208",
            "cod_istat": "063071",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 1135,
            "area": "",
            "ech": 0
        },
        {
            "id": 6540,
            "name": "Sant'Agostino",
            "provincia": "FE",
            "cap": "44047",
            "cod_catastale": "I209",
            "cod_istat": "038021",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2290,
            "area": "",
            "ech": 0
        },
        {
            "id": 6541,
            "name": "Sant'Albano Stura",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "I210",
            "cod_istat": "004211",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 2782,
            "area": "",
            "ech": 0
        },
        {
            "id": 6542,
            "name": "Sant'Alessio con Vialone",
            "provincia": "PV",
            "cap": "27016",
            "cod_catastale": "I213",
            "cod_istat": "018141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 6543,
            "name": "Sant'Alessio in Aspromonte",
            "provincia": "RC",
            "cap": "89050",
            "cod_catastale": "I214",
            "cod_istat": "080080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 1772,
            "area": "",
            "ech": 1
        },
        {
            "id": 6544,
            "name": "Sant'Alessio Siculo",
            "provincia": "ME",
            "cap": "98030",
            "cod_catastale": "I215",
            "cod_istat": "083085",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 652,
            "area": "",
            "ech": 0
        },
        {
            "id": 6545,
            "name": "Sant'Alfio",
            "provincia": "CT",
            "cap": "95010",
            "cod_catastale": "I216",
            "cod_istat": "087046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 531,
            "giorni": 1440,
            "area": "",
            "ech": 1
        },
        {
            "id": 6546,
            "name": "Sant'Ambrogio di Torino",
            "provincia": "TO",
            "cap": "10057",
            "cod_catastale": "I258",
            "cod_istat": "001255",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2888,
            "area": "",
            "ech": 0
        },
        {
            "id": 6547,
            "name": "Sant'Ambrogio di Valpolicella",
            "provincia": "VR",
            "cap": "37015",
            "cod_catastale": "I259",
            "cod_istat": "023077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 174,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 6548,
            "name": "Sant'Ambrogio sul Garigliano",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "I256",
            "cod_istat": "060065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 137,
            "giorni": 1347,
            "area": "",
            "ech": 0
        },
        {
            "id": 6549,
            "name": "Sant'Anastasia",
            "provincia": "NA",
            "cap": "80048",
            "cod_catastale": "I262",
            "cod_istat": "063072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1216,
            "area": "",
            "ech": 0
        },
        {
            "id": 6550,
            "name": "Sant'Anatolia di Narco",
            "provincia": "PG",
            "cap": "06040",
            "cod_catastale": "I263",
            "cod_istat": "054045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2124,
            "area": "",
            "ech": 0
        },
        {
            "id": 6551,
            "name": "Sant'Andrea Apostolo dello Ionio",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "I266",
            "cod_istat": "079118",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 1404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6552,
            "name": "Sant'Andrea del Garigliano",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "I265",
            "cod_istat": "060066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 1636,
            "area": "",
            "ech": 0
        },
        {
            "id": 6553,
            "name": "Sant'Andrea di Conza",
            "provincia": "AV",
            "cap": "83053",
            "cod_catastale": "I264",
            "cod_istat": "064089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 665,
            "giorni": 2261,
            "area": "",
            "ech": 0
        },
        {
            "id": 6554,
            "name": "Sant'Andrea Frius",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I271",
            "cod_istat": "111069",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1376,
            "area": "",
            "ech": 0
        },
        {
            "id": 6555,
            "name": "Sant'Angelo a Cupolo",
            "provincia": "BN",
            "cap": "82010",
            "cod_catastale": "I277",
            "cod_istat": "062071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 459,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 6556,
            "name": "Sant'Angelo a Fasanella",
            "provincia": "SA",
            "cap": "84027",
            "cod_catastale": "I278",
            "cod_istat": "065128",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 1850,
            "area": "",
            "ech": 0
        },
        {
            "id": 6557,
            "name": "Sant'Angelo a Scala",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "I280",
            "cod_istat": "064091",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 2069,
            "area": "",
            "ech": 0
        },
        {
            "id": 6558,
            "name": "Sant'Angelo all'Esca",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I279",
            "cod_istat": "064090",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 1856,
            "area": "",
            "ech": 0
        },
        {
            "id": 6559,
            "name": "Sant'Angelo d'Alife",
            "provincia": "CE",
            "cap": "81017",
            "cod_catastale": "I273",
            "cod_istat": "061086",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 1821,
            "area": "",
            "ech": 0
        },
        {
            "id": 6560,
            "name": "Sant'Angelo dei Lombardi",
            "provincia": "AV",
            "cap": "83054",
            "cod_catastale": "I281",
            "cod_istat": "064092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 6561,
            "name": "Sant'Angelo del Pesco",
            "provincia": "IS",
            "cap": "86080",
            "cod_catastale": "I282",
            "cod_istat": "094046",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 805,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 6562,
            "name": "Sant'Angelo di Brolo",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "I283",
            "cod_istat": "083088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 314,
            "giorni": 1163,
            "area": "",
            "ech": 1
        },
        {
            "id": 6563,
            "name": "Sant'Angelo di Piove di Sacco",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "I275",
            "cod_istat": "028082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 6564,
            "name": "Sant'Angelo in Lizzola",
            "provincia": "PU",
            "cap": "61020",
            "cod_catastale": "I285",
            "cod_istat": "041056",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2298,
            "area": "",
            "ech": 0
        },
        {
            "id": 6565,
            "name": "Sant'Angelo in Pontano",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "I286",
            "cod_istat": "043048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 473,
            "giorni": 2193,
            "area": "",
            "ech": 0
        },
        {
            "id": 6566,
            "name": "Sant'Angelo in Vado",
            "provincia": "PU",
            "cap": "61048",
            "cod_catastale": "I287",
            "cod_istat": "041057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 359,
            "giorni": 2434,
            "area": "",
            "ech": 0
        },
        {
            "id": 6567,
            "name": "Sant'Angelo Le Fratte",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "I288",
            "cod_istat": "076079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 1927,
            "area": "",
            "ech": 0
        },
        {
            "id": 6568,
            "name": "Sant'Angelo Limosano",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "I289",
            "cod_istat": "070073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 894,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 6569,
            "name": "Sant'Angelo Lodigiano",
            "provincia": "LO",
            "cap": "26866",
            "cod_catastale": "I274",
            "cod_istat": "098050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 6570,
            "name": "Sant'Angelo Lomellina",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "I276",
            "cod_istat": "018144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 6571,
            "name": "Sant'Angelo Muxaro",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "I290",
            "cod_istat": "084039",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 335,
            "giorni": 954,
            "area": "",
            "ech": 1
        },
        {
            "id": 6572,
            "name": "Sant'Angelo Romano",
            "provincia": "RM",
            "cap": "00010",
            "cod_catastale": "I284",
            "cod_istat": "058098",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1928,
            "area": "",
            "ech": 0
        },
        {
            "id": 6573,
            "name": "Sant'Anna Arresi",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "M209",
            "cod_istat": "111070",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 863,
            "area": "",
            "ech": 1
        },
        {
            "id": 6574,
            "name": "Sant'Anna d'Alfaedo",
            "provincia": "VR",
            "cap": "37020",
            "cod_catastale": "I292",
            "cod_istat": "023078",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 939,
            "giorni": 3819,
            "area": "",
            "ech": 0
        },
        {
            "id": 6575,
            "name": "Sant'Antimo",
            "provincia": "NA",
            "cap": "80029",
            "cod_catastale": "I293",
            "cod_istat": "063073",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 1032,
            "area": "",
            "ech": 0
        },
        {
            "id": 6576,
            "name": "Sant'Antioco",
            "provincia": "SU",
            "cap": "09017",
            "cod_catastale": "I294",
            "cod_istat": "111071",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 772,
            "area": "",
            "ech": 0
        },
        {
            "id": 6577,
            "name": "Sant'Antonino di Susa",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "I296",
            "cod_istat": "001256",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 6578,
            "name": "Sant'Antonio Abate",
            "provincia": "NA",
            "cap": "80057",
            "cod_catastale": "I300",
            "cod_istat": "063074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 1061,
            "area": "",
            "ech": 0
        },
        {
            "id": 6579,
            "name": "Sant'Antonio di Gallura",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M276",
            "cod_istat": "090085",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 355,
            "giorni": 1589,
            "area": "",
            "ech": 0
        },
        {
            "id": 6580,
            "name": "Sant'Apollinare",
            "provincia": "FR",
            "cap": "03048",
            "cod_catastale": "I302",
            "cod_istat": "060067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 1184,
            "area": "",
            "ech": 0
        },
        {
            "id": 6581,
            "name": "Sant'Arcangelo",
            "provincia": "PZ",
            "cap": "85037",
            "cod_catastale": "I305",
            "cod_istat": "076080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 388,
            "giorni": 1614,
            "area": "",
            "ech": 0
        },
        {
            "id": 6582,
            "name": "Sant'Arcangelo di Romagna",
            "provincia": "RN",
            "cap": "47822",
            "cod_catastale": "I304",
            "cod_istat": "099018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2186,
            "area": "",
            "ech": 0
        },
        {
            "id": 6583,
            "name": "Sant'Arcangelo Trimonte",
            "provincia": "BN",
            "cap": "82021",
            "cod_catastale": "F557",
            "cod_istat": "062078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 1731,
            "area": "",
            "ech": 0
        },
        {
            "id": 6584,
            "name": "Sant'Arpino",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "I306",
            "cod_istat": "061087",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1207,
            "area": "",
            "ech": 0
        },
        {
            "id": 6585,
            "name": "Sant'Arsenio",
            "provincia": "SA",
            "cap": "84037",
            "cod_catastale": "I307",
            "cod_istat": "065129",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 463,
            "giorni": 1604,
            "area": "",
            "ech": 0
        },
        {
            "id": 6586,
            "name": "Sante Marie",
            "provincia": "AQ",
            "cap": "67067",
            "cod_catastale": "I326",
            "cod_istat": "066089",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 850,
            "giorni": 2852,
            "area": "",
            "ech": 0
        },
        {
            "id": 6587,
            "name": "Sant'Egidio alla Vibrata",
            "provincia": "TE",
            "cap": "64016",
            "cod_catastale": "I318",
            "cod_istat": "067038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 1621,
            "area": "",
            "ech": 0
        },
        {
            "id": 6588,
            "name": "Sant'Egidio del Monte Albino",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "I317",
            "cod_istat": "065130",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 1216,
            "area": "",
            "ech": 0
        },
        {
            "id": 6589,
            "name": "Sant'Elena",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "I319",
            "cod_istat": "028083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6590,
            "name": "Sant'Elena Sannita",
            "provincia": "IS",
            "cap": "86095",
            "cod_catastale": "B466",
            "cod_istat": "094047",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 780,
            "giorni": 2446,
            "area": "",
            "ech": 0
        },
        {
            "id": 6591,
            "name": "Sant'Elia a Pianisi",
            "provincia": "CB",
            "cap": "86048",
            "cod_catastale": "I320",
            "cod_istat": "070074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 666,
            "giorni": 2266,
            "area": "",
            "ech": 0
        },
        {
            "id": 6592,
            "name": "Sant'Elia Fiumerapido",
            "provincia": "FR",
            "cap": "03049",
            "cod_catastale": "I321",
            "cod_istat": "060068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 1311,
            "area": "",
            "ech": 0
        },
        {
            "id": 6593,
            "name": "Sant'Elpidio a Mare",
            "provincia": "FM",
            "cap": "63811",
            "cod_catastale": "I324",
            "cod_istat": "109037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 1875,
            "area": "",
            "ech": 0
        },
        {
            "id": 6594,
            "name": "Santena",
            "provincia": "TO",
            "cap": "10026",
            "cod_catastale": "I327",
            "cod_istat": "001257",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 2580,
            "area": "",
            "ech": 0
        },
        {
            "id": 6595,
            "name": "Santeramo in Colle",
            "provincia": "BA",
            "cap": "70029",
            "cod_catastale": "I330",
            "cod_istat": "072041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 489,
            "giorni": 1884,
            "area": "",
            "ech": 0
        },
        {
            "id": 6596,
            "name": "Sant'Eufemia a Maiella",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "I332",
            "cod_istat": "068037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 878,
            "giorni": 2644,
            "area": "",
            "ech": 0
        },
        {
            "id": 6597,
            "name": "Sant'Eufemia d'Aspromonte",
            "provincia": "RC",
            "cap": "89027",
            "cod_catastale": "I333",
            "cod_istat": "080081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1581,
            "area": "",
            "ech": 0
        },
        {
            "id": 6598,
            "name": "Sant'Eusanio del Sangro",
            "provincia": "CH",
            "cap": "66037",
            "cod_catastale": "I335",
            "cod_istat": "069085",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 6599,
            "name": "Sant'Eusanio Forconese",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "I336",
            "cod_istat": "066090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 591,
            "giorni": 2346,
            "area": "",
            "ech": 0
        },
        {
            "id": 6600,
            "name": "Santhià",
            "provincia": "VC",
            "cap": "13048",
            "cod_catastale": "I337",
            "cod_istat": "002133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 6601,
            "name": "Santi Cosma e Damiano",
            "provincia": "LT",
            "cap": "04020",
            "cod_catastale": "I339",
            "cod_istat": "059026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 181,
            "giorni": 1315,
            "area": "",
            "ech": 0
        },
        {
            "id": 6602,
            "name": "Sant'Ilario dello Ionio",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "I341",
            "cod_istat": "080082",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 752,
            "area": "",
            "ech": 1
        },
        {
            "id": 6603,
            "name": "Sant'Ilario d'Enza",
            "provincia": "RE",
            "cap": "42049",
            "cod_catastale": "I342",
            "cod_istat": "035039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2531,
            "area": "",
            "ech": 0
        },
        {
            "id": 6604,
            "name": "Sant'Ippolito",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "I344",
            "cod_istat": "041058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2271,
            "area": "",
            "ech": 0
        },
        {
            "id": 6605,
            "name": "Santo Stefano al Mare",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "I365",
            "cod_istat": "008056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1062,
            "area": "",
            "ech": 0
        },
        {
            "id": 6606,
            "name": "Santo Stefano Belbo",
            "provincia": "CN",
            "cap": "12058",
            "cod_catastale": "I367",
            "cod_istat": "004213",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2563,
            "area": "",
            "ech": 0
        },
        {
            "id": 6607,
            "name": "Santo Stefano d'Aveto",
            "provincia": "GE",
            "cap": "16049",
            "cod_catastale": "I368",
            "cod_istat": "010056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1012,
            "giorni": 3885,
            "area": "",
            "ech": 0
        },
        {
            "id": 6608,
            "name": "Santo Stefano del Sole",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I357",
            "cod_istat": "064095",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 547,
            "giorni": 2025,
            "area": "",
            "ech": 0
        },
        {
            "id": 6609,
            "name": "Santo Stefano di Cadore",
            "provincia": "BL",
            "cap": "32045",
            "cod_catastale": "C919",
            "cod_istat": "025050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 908,
            "giorni": 4141,
            "area": "",
            "ech": 0
        },
        {
            "id": 6610,
            "name": "Santo Stefano di Camastra",
            "provincia": "ME",
            "cap": "98077",
            "cod_catastale": "I370",
            "cod_istat": "083091",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 746,
            "area": "",
            "ech": 1
        },
        {
            "id": 6611,
            "name": "Santo Stefano di Magra",
            "provincia": "SP",
            "cap": "19037",
            "cod_catastale": "I363",
            "cod_istat": "011026",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1449,
            "area": "",
            "ech": 0
        },
        {
            "id": 6612,
            "name": "Santo Stefano di Rogliano",
            "provincia": "CS",
            "cap": "87056",
            "cod_catastale": "I359",
            "cod_istat": "078134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 663,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 6613,
            "name": "Santo Stefano di Sessanio",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "I360",
            "cod_istat": "066091",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1251,
            "giorni": 3433,
            "area": "",
            "ech": 0
        },
        {
            "id": 6614,
            "name": "Santo Stefano in Aspromonte",
            "provincia": "RC",
            "cap": "89057",
            "cod_catastale": "I371",
            "cod_istat": "080083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 714,
            "giorni": 2141,
            "area": "",
            "ech": 1
        },
        {
            "id": 6615,
            "name": "Santo Stefano Lodigiano",
            "provincia": "LO",
            "cap": "26849",
            "cod_catastale": "I362",
            "cod_istat": "098051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6616,
            "name": "Santo Stefano Quisquina",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "I356",
            "cod_istat": "084040",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 730,
            "giorni": 1688,
            "area": "",
            "ech": 1
        },
        {
            "id": 6617,
            "name": "Santo Stefano Roero",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "I372",
            "cod_istat": "004214",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2724,
            "area": "",
            "ech": 0
        },
        {
            "id": 6618,
            "name": "Santo Stefano Ticino",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "I361",
            "cod_istat": "015200",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2656,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 6619,
            "name": "San Stino di Livenza",
            "provincia": "VE",
            "cap": "30029",
            "cod_catastale": "I373",
            "cod_istat": "027036",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6620,
            "name": "Sant'Olcese",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "I346",
            "cod_istat": "010055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 6621,
            "name": "Santomenna",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "I260",
            "cod_istat": "065131",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 540,
            "giorni": 1989,
            "area": "",
            "ech": 0
        },
        {
            "id": 6622,
            "name": "Sant'Omero",
            "provincia": "TE",
            "cap": "64027",
            "cod_catastale": "I348",
            "cod_istat": "067039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 1571,
            "area": "",
            "ech": 0
        },
        {
            "id": 6623,
            "name": "Sant'Omobono Terme",
            "provincia": "BG",
            "cap": "24038",
            "cod_catastale": "M333",
            "cod_istat": "016252",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6624,
            "name": "Sant'Onofrio",
            "provincia": "VV",
            "cap": "89843",
            "cod_catastale": "I350",
            "cod_istat": "102036",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1321,
            "area": "",
            "ech": 0
        },
        {
            "id": 6625,
            "name": "Santopadre",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "I351",
            "cod_istat": "060069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 730,
            "giorni": 2414,
            "area": "",
            "ech": 0
        },
        {
            "id": 6626,
            "name": "Sant'Oreste",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "I352",
            "cod_istat": "058099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2209,
            "area": "",
            "ech": 0
        },
        {
            "id": 6627,
            "name": "Santorso",
            "provincia": "VI",
            "cap": "36014",
            "cod_catastale": "I353",
            "cod_istat": "024095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 6628,
            "name": "Sant'Orsola Terme",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "I354",
            "cod_istat": "022168",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 925,
            "giorni": 3729,
            "area": "",
            "ech": 0
        },
        {
            "id": 6629,
            "name": "Santu Lussurgiu",
            "provincia": "OR",
            "cap": "09075",
            "cod_catastale": "I374",
            "cod_istat": "095049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 503,
            "giorni": 1684,
            "area": "",
            "ech": 0
        },
        {
            "id": 6630,
            "name": "Sant'Urbano",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "I375",
            "cod_istat": "028084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6631,
            "name": "Sanza",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "I410",
            "cod_istat": "065133",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 558,
            "giorni": 1854,
            "area": "",
            "ech": 0
        },
        {
            "id": 6632,
            "name": "Sanzeno",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I411",
            "cod_istat": "022169",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 3237,
            "area": "",
            "ech": 0
        },
        {
            "id": 6633,
            "name": "Saonara",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "I418",
            "cod_istat": "028085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 6634,
            "name": "Saponara",
            "provincia": "ME",
            "cap": "98047",
            "cod_catastale": "I420",
            "cod_istat": "083092",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 900,
            "area": "",
            "ech": 1
        },
        {
            "id": 6635,
            "name": "Sappada",
            "provincia": "UD",
            "cap": "33012",
            "cod_catastale": "I421",
            "cod_istat": "030189",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1218,
            "giorni": 4736,
            "area": "",
            "ech": 0
        },
        {
            "id": 6636,
            "name": "Sapri",
            "provincia": "SA",
            "cap": "84073",
            "cod_catastale": "I422",
            "cod_istat": "065134",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 5,
            "giorni": 938,
            "area": "",
            "ech": 0
        },
        {
            "id": 6637,
            "name": "Saracena",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "I423",
            "cod_istat": "078136",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 606,
            "giorni": 2014,
            "area": "",
            "ech": 0
        },
        {
            "id": 6638,
            "name": "Saracinesco",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "I424",
            "cod_istat": "058101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 908,
            "giorni": 2787,
            "area": "",
            "ech": 0
        },
        {
            "id": 6639,
            "name": "Sarcedo",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "I425",
            "cod_istat": "024097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 157,
            "giorni": 2445,
            "area": "",
            "ech": 0
        },
        {
            "id": 6640,
            "name": "Sarconi",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "I426",
            "cod_istat": "076081",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 636,
            "giorni": 2066,
            "area": "",
            "ech": 0
        },
        {
            "id": 6641,
            "name": "Sardara",
            "provincia": "SU",
            "cap": "09030",
            "cod_catastale": "I428",
            "cod_istat": "111072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 155,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 6642,
            "name": "Sardigliano",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "I429",
            "cod_istat": "006157",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 6643,
            "name": "Sarego",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "I430",
            "cod_istat": "024098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2462,
            "area": "",
            "ech": 0
        },
        {
            "id": 6644,
            "name": "Sarentino",
            "provincia": "BZ",
            "cap": "39058",
            "cod_catastale": "I431",
            "cod_istat": "021086",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 961,
            "giorni": 3927,
            "area": "",
            "ech": 0
        },
        {
            "id": 6645,
            "name": "Sarezzano",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "I432",
            "cod_istat": "006158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 6646,
            "name": "Sarezzo",
            "provincia": "BS",
            "cap": "25068",
            "cod_catastale": "I433",
            "cod_istat": "017174",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 6647,
            "name": "Sarmato",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "I434",
            "cod_istat": "033042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2552,
            "area": "",
            "ech": 0
        },
        {
            "id": 6648,
            "name": "Sarmede",
            "provincia": "TV",
            "cap": "31026",
            "cod_catastale": "I435",
            "cod_istat": "026078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2546,
            "area": "",
            "ech": 0
        },
        {
            "id": 6649,
            "name": "Sarnano",
            "provincia": "MC",
            "cap": "62028",
            "cod_catastale": "I436",
            "cod_istat": "043049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 539,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 6650,
            "name": "Sarnico",
            "provincia": "BG",
            "cap": "24067",
            "cod_catastale": "I437",
            "cod_istat": "016193",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 6651,
            "name": "Sarno",
            "provincia": "SA",
            "cap": "84087",
            "cod_catastale": "I438",
            "cod_istat": "065135",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 1178,
            "area": "",
            "ech": 0
        },
        {
            "id": 6652,
            "name": "Sarnonico",
            "provincia": "TN",
            "cap": "38011",
            "cod_catastale": "I439",
            "cod_istat": "022170",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 963,
            "giorni": 3893,
            "area": "",
            "ech": 0
        },
        {
            "id": 6653,
            "name": "Saronno",
            "provincia": "VA",
            "cap": "21047",
            "cod_catastale": "I441",
            "cod_istat": "012119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 212,
            "giorni": 2418,
            "area": "",
            "ech": 0
        },
        {
            "id": 6654,
            "name": "Sarre",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "I442",
            "cod_istat": "007066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 625,
            "giorni": 2935,
            "area": "",
            "ech": 0
        },
        {
            "id": 6655,
            "name": "Sarroch",
            "provincia": "CA",
            "cap": "09018",
            "cod_catastale": "I443",
            "cod_istat": "092066",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 999,
            "area": "",
            "ech": 0
        },
        {
            "id": 6656,
            "name": "Sarsina",
            "provincia": "FC",
            "cap": "47027",
            "cod_catastale": "I444",
            "cod_istat": "040044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2303,
            "area": "",
            "ech": 0
        },
        {
            "id": 6657,
            "name": "Sarteano",
            "provincia": "SI",
            "cap": "53047",
            "cod_catastale": "I445",
            "cod_istat": "052031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 573,
            "giorni": 2237,
            "area": "",
            "ech": 0
        },
        {
            "id": 6658,
            "name": "Sartirana Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "I447",
            "cod_istat": "018146",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 2730,
            "area": "",
            "ech": 0
        },
        {
            "id": 6659,
            "name": "Sarule",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "I448",
            "cod_istat": "091077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 626,
            "giorni": 1841,
            "area": "",
            "ech": 0
        },
        {
            "id": 6660,
            "name": "Sarzana",
            "provincia": "SP",
            "cap": "19038",
            "cod_catastale": "I449",
            "cod_istat": "011027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 1566,
            "area": "",
            "ech": 0
        },
        {
            "id": 6661,
            "name": "Sassano",
            "provincia": "SA",
            "cap": "84038",
            "cod_catastale": "I451",
            "cod_istat": "065136",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 491,
            "giorni": 1639,
            "area": "",
            "ech": 0
        },
        {
            "id": 6662,
            "name": "Sassari",
            "provincia": "SS",
            "cap": "07100",
            "cod_catastale": "I452",
            "cod_istat": "090064",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 225,
            "giorni": 1185,
            "area": "",
            "ech": 0
        },
        {
            "id": 6663,
            "name": "Sassello",
            "provincia": "SV",
            "cap": "17046",
            "cod_catastale": "I453",
            "cod_istat": "009055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2352,
            "area": "",
            "ech": 0
        },
        {
            "id": 6664,
            "name": "Sassetta",
            "provincia": "LI",
            "cap": "57020",
            "cod_catastale": "I454",
            "cod_istat": "049019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1897,
            "area": "",
            "ech": 0
        },
        {
            "id": 6665,
            "name": "Sassinoro",
            "provincia": "BN",
            "cap": "82026",
            "cod_catastale": "I455",
            "cod_istat": "062072",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 545,
            "giorni": 2062,
            "area": "",
            "ech": 0
        },
        {
            "id": 6666,
            "name": "Sasso di Castalda",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "I457",
            "cod_istat": "076082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 949,
            "giorni": 2635,
            "area": "",
            "ech": 0
        },
        {
            "id": 6667,
            "name": "Sasso Marconi",
            "provincia": "BO",
            "cap": "40037",
            "cod_catastale": "G972",
            "cod_istat": "037057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2339,
            "area": "",
            "ech": 0
        },
        {
            "id": 6668,
            "name": "Sassocorvaro",
            "provincia": "PU",
            "cap": "61028",
            "cod_catastale": "I459",
            "cod_istat": "041071",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 2336,
            "area": "",
            "ech": 0
        },
        {
            "id": 6669,
            "name": "Sassofeltrio",
            "provincia": "PU",
            "cap": "61013",
            "cod_catastale": "I460",
            "cod_istat": "041060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 466,
            "giorni": 2365,
            "area": "",
            "ech": 0
        },
        {
            "id": 6670,
            "name": "Sassoferrato",
            "provincia": "AN",
            "cap": "60041",
            "cod_catastale": "I461",
            "cod_istat": "042044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 2226,
            "area": "",
            "ech": 0
        },
        {
            "id": 6671,
            "name": "Sassuolo",
            "provincia": "MO",
            "cap": "41049",
            "cod_catastale": "I462",
            "cod_istat": "036040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2447,
            "area": "",
            "ech": 0
        },
        {
            "id": 6672,
            "name": "Satriano",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "I463",
            "cod_istat": "079123",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 1275,
            "area": "",
            "ech": 1
        },
        {
            "id": 6673,
            "name": "Satriano di Lucania",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "G614",
            "cod_istat": "076083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 653,
            "giorni": 2096,
            "area": "",
            "ech": 0
        },
        {
            "id": 6674,
            "name": "Sauris",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "I464",
            "cod_istat": "030107",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1214,
            "giorni": 4437,
            "area": "",
            "ech": 0
        },
        {
            "id": 6675,
            "name": "Sauze di Cesana",
            "provincia": "TO",
            "cap": "10054",
            "cod_catastale": "I465",
            "cod_istat": "001258",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1560,
            "giorni": 4694,
            "area": "",
            "ech": 0
        },
        {
            "id": 6676,
            "name": "Sauze d'Oulx",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "I466",
            "cod_istat": "001259",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1509,
            "giorni": 4617,
            "area": "",
            "ech": 0
        },
        {
            "id": 6677,
            "name": "Sava",
            "provincia": "TA",
            "cap": "74028",
            "cod_catastale": "I467",
            "cod_istat": "073026",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 1164,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 6678,
            "name": "Savelli",
            "provincia": "KR",
            "cap": "88825",
            "cod_catastale": "I468",
            "cod_istat": "101023",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1014,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 6679,
            "name": "Saviano",
            "provincia": "NA",
            "cap": "80039",
            "cod_catastale": "I469",
            "cod_istat": "063076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1023,
            "area": "",
            "ech": 0
        },
        {
            "id": 6680,
            "name": "Savigliano",
            "provincia": "CN",
            "cap": "12038",
            "cod_catastale": "I470",
            "cod_istat": "004215",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2817,
            "area": "",
            "ech": 0
        },
        {
            "id": 6681,
            "name": "Savignano Irpino",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "I471",
            "cod_istat": "064096",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 698,
            "giorni": 2284,
            "area": "",
            "ech": 0
        },
        {
            "id": 6682,
            "name": "Savignano sul Panaro",
            "provincia": "MO",
            "cap": "41056",
            "cod_catastale": "I473",
            "cod_istat": "036041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2289,
            "area": "",
            "ech": 0
        },
        {
            "id": 6683,
            "name": "Savignano sul Rubicone",
            "provincia": "FC",
            "cap": "47039",
            "cod_catastale": "I472",
            "cod_istat": "040045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2191,
            "area": "",
            "ech": 0
        },
        {
            "id": 6684,
            "name": "Savigno",
            "provincia": "BO",
            "cap": "40060",
            "cod_catastale": "I474",
            "cod_istat": "037058",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 259,
            "giorni": 2525,
            "area": "",
            "ech": 0
        },
        {
            "id": 6685,
            "name": "Savignone",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "I475",
            "cod_istat": "010057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 471,
            "giorni": 2554,
            "area": "",
            "ech": 0
        },
        {
            "id": 6686,
            "name": "Saviore dell'Adamello",
            "provincia": "BS",
            "cap": "25040",
            "cod_catastale": "I476",
            "cod_istat": "017175",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 3940,
            "area": "",
            "ech": 0
        },
        {
            "id": 6687,
            "name": "Savoca",
            "provincia": "ME",
            "cap": "98038",
            "cod_catastale": "I477",
            "cod_istat": "083093",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 1144,
            "area": "",
            "ech": 0
        },
        {
            "id": 6688,
            "name": "Savogna",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "I478",
            "cod_istat": "030108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2750,
            "area": "",
            "ech": 0
        },
        {
            "id": 6689,
            "name": "Savogna d'Isonzo",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "I479",
            "cod_istat": "031022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 6690,
            "name": "Savoia di Lucania",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "H730",
            "cod_istat": "076084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 720,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 6691,
            "name": "Savona",
            "provincia": "SV",
            "cap": "17100",
            "cod_catastale": "I480",
            "cod_istat": "009056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 4,
            "giorni": 1481,
            "area": "",
            "ech": 0
        },
        {
            "id": 6692,
            "name": "Scafa",
            "provincia": "PE",
            "cap": "65027",
            "cod_catastale": "I482",
            "cod_istat": "068039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1433,
            "area": "",
            "ech": 0
        },
        {
            "id": 6693,
            "name": "Scafati",
            "provincia": "SA",
            "cap": "84018",
            "cod_catastale": "I483",
            "cod_istat": "065137",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1150,
            "area": "",
            "ech": 0
        },
        {
            "id": 6694,
            "name": "Scagnello",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "I484",
            "cod_istat": "004216",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 748,
            "giorni": 3243,
            "area": "",
            "ech": 0
        },
        {
            "id": 6695,
            "name": "Scala",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "I486",
            "cod_istat": "065138",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 1618,
            "area": "",
            "ech": 0
        },
        {
            "id": 6696,
            "name": "Scala Coeli",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "I485",
            "cod_istat": "078137",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 1537,
            "area": "",
            "ech": 0
        },
        {
            "id": 6697,
            "name": "Scaldasole",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "I487",
            "cod_istat": "018147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6698,
            "name": "Scalea",
            "provincia": "CS",
            "cap": "87029",
            "cod_catastale": "I489",
            "cod_istat": "078138",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 875,
            "area": "",
            "ech": 0
        },
        {
            "id": 6699,
            "name": "Scalenghe",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "I490",
            "cod_istat": "001260",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2788,
            "area": "",
            "ech": 0
        },
        {
            "id": 6700,
            "name": "Scaletta Zanclea",
            "provincia": "ME",
            "cap": "98029",
            "cod_catastale": "I492",
            "cod_istat": "083094",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 637,
            "area": "",
            "ech": 0
        },
        {
            "id": 6701,
            "name": "Scampitella",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I493",
            "cod_istat": "064097",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 775,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 6702,
            "name": "Scandale",
            "provincia": "KR",
            "cap": "88831",
            "cod_catastale": "I494",
            "cod_istat": "101024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1440,
            "area": "",
            "ech": 1
        },
        {
            "id": 6703,
            "name": "Scandiano",
            "provincia": "RE",
            "cap": "42019",
            "cod_catastale": "I496",
            "cod_istat": "035040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2473,
            "area": "",
            "ech": 0
        },
        {
            "id": 6704,
            "name": "Scandicci",
            "provincia": "FI",
            "cap": "50018",
            "cod_catastale": "B962",
            "cod_istat": "048041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 1817,
            "area": "",
            "ech": 0
        },
        {
            "id": 6705,
            "name": "Scandolara Ravara",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "I497",
            "cod_istat": "019092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6706,
            "name": "Scandolara Ripa d'Oglio",
            "provincia": "CR",
            "cap": "26047",
            "cod_catastale": "I498",
            "cod_istat": "019093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6707,
            "name": "Scandriglia",
            "provincia": "RI",
            "cap": "02038",
            "cod_catastale": "I499",
            "cod_istat": "057064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 535,
            "giorni": 2338,
            "area": "",
            "ech": 0
        },
        {
            "id": 6708,
            "name": "Scanno",
            "provincia": "AQ",
            "cap": "67038",
            "cod_catastale": "I501",
            "cod_istat": "066093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1050,
            "giorni": 3160,
            "area": "",
            "ech": 0
        },
        {
            "id": 6709,
            "name": "Scano di Montiferro",
            "provincia": "OR",
            "cap": "09078",
            "cod_catastale": "I503",
            "cod_istat": "095051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 1463,
            "area": "",
            "ech": 0
        },
        {
            "id": 6710,
            "name": "Scansano",
            "provincia": "GR",
            "cap": "58054",
            "cod_catastale": "I504",
            "cod_istat": "053023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2216,
            "area": "",
            "ech": 0
        },
        {
            "id": 6711,
            "name": "Scanzano Jonico",
            "provincia": "MT",
            "cap": "75020",
            "cod_catastale": "M256",
            "cod_istat": "077031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 1131,
            "area": "",
            "ech": 0
        },
        {
            "id": 6712,
            "name": "Scanzorosciate",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "I506",
            "cod_istat": "016194",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6713,
            "name": "Scapoli",
            "provincia": "IS",
            "cap": "86070",
            "cod_catastale": "I507",
            "cod_istat": "094048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 611,
            "giorni": 2171,
            "area": "",
            "ech": 0
        },
        {
            "id": 6714,
            "name": "Scarlino",
            "provincia": "GR",
            "cap": "58020",
            "cod_catastale": "I510",
            "cod_istat": "053024",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 1840,
            "area": "",
            "ech": 0
        },
        {
            "id": 6715,
            "name": "Scarmagno",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "I511",
            "cod_istat": "001261",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 6716,
            "name": "Scarnafigi",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "I512",
            "cod_istat": "004217",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 6717,
            "name": "Scarperia",
            "provincia": "FI",
            "cap": "50038",
            "cod_catastale": "I514",
            "cod_istat": "048042",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 292,
            "giorni": 2212,
            "area": "",
            "ech": 0
        },
        {
            "id": 6718,
            "name": "Scena",
            "provincia": "BZ",
            "cap": "39017",
            "cod_catastale": "I519",
            "cod_istat": "021087",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 3317,
            "area": "",
            "ech": 0
        },
        {
            "id": 6719,
            "name": "Scerni",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "I520",
            "cod_istat": "069087",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 1657,
            "area": "",
            "ech": 0
        },
        {
            "id": 6720,
            "name": "Scheggia e Pascelupo",
            "provincia": "PG",
            "cap": "06027",
            "cod_catastale": "I522",
            "cod_istat": "054046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 580,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 6721,
            "name": "Scheggino",
            "provincia": "PG",
            "cap": "06040",
            "cod_catastale": "I523",
            "cod_istat": "054047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2076,
            "area": "",
            "ech": 0
        },
        {
            "id": 6722,
            "name": "Schiavi di Abruzzo",
            "provincia": "CH",
            "cap": "66045",
            "cod_catastale": "I526",
            "cod_istat": "069088",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1172,
            "giorni": 2954,
            "area": "",
            "ech": 0
        },
        {
            "id": 6723,
            "name": "Schiavon",
            "provincia": "VI",
            "cap": "36060",
            "cod_catastale": "I527",
            "cod_istat": "024099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2360,
            "area": "",
            "ech": 0
        },
        {
            "id": 6724,
            "name": "Schignano",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "I529",
            "cod_istat": "013211",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2922,
            "area": "",
            "ech": 0
        },
        {
            "id": 6725,
            "name": "Schilpario",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "I530",
            "cod_istat": "016195",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1124,
            "giorni": 3666,
            "area": "",
            "ech": 0
        },
        {
            "id": 6726,
            "name": "Schio",
            "provincia": "VI",
            "cap": "36015",
            "cod_catastale": "I531",
            "cod_istat": "024100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2588,
            "area": "",
            "ech": 0
        },
        {
            "id": 6727,
            "name": "Schivenoglia",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "I532",
            "cod_istat": "020060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 6728,
            "name": "Sciacca",
            "provincia": "AG",
            "cap": "92019",
            "cod_catastale": "I533",
            "cod_istat": "084041",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 887,
            "area": "",
            "ech": 1
        },
        {
            "id": 6729,
            "name": "Sciara",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "I534",
            "cod_istat": "082068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1047,
            "area": "",
            "ech": 1
        },
        {
            "id": 6730,
            "name": "Scicli",
            "provincia": "RG",
            "cap": "97018",
            "cod_catastale": "I535",
            "cod_istat": "088011",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 899,
            "area": "",
            "ech": 0
        },
        {
            "id": 6731,
            "name": "Scido",
            "provincia": "RC",
            "cap": "89010",
            "cod_catastale": "I536",
            "cod_istat": "080084",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 456,
            "giorni": 1607,
            "area": "",
            "ech": 0
        },
        {
            "id": 6732,
            "name": "Scigliano",
            "provincia": "CS",
            "cap": "87057",
            "cod_catastale": "D290",
            "cod_istat": "078139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 659,
            "giorni": 2119,
            "area": "",
            "ech": 0
        },
        {
            "id": 6733,
            "name": "Scilla",
            "provincia": "RC",
            "cap": "89058",
            "cod_catastale": "I537",
            "cod_istat": "080085",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 886,
            "area": "",
            "ech": 0
        },
        {
            "id": 6734,
            "name": "Scillato",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "I538",
            "cod_istat": "082081",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 218,
            "giorni": 1009,
            "area": "",
            "ech": 0
        },
        {
            "id": 6735,
            "name": "Sciolze",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "I539",
            "cod_istat": "001262",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 436,
            "giorni": 3008,
            "area": "",
            "ech": 0
        },
        {
            "id": 6736,
            "name": "Scisciano",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "I540",
            "cod_istat": "063077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 1016,
            "area": "",
            "ech": 0
        },
        {
            "id": 6737,
            "name": "Sclafani Bagni",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "I541",
            "cod_istat": "082069",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 813,
            "giorni": 1927,
            "area": "",
            "ech": 0
        },
        {
            "id": 6738,
            "name": "Scontrone",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "I543",
            "cod_istat": "066094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1038,
            "giorni": 3146,
            "area": "",
            "ech": 0
        },
        {
            "id": 6739,
            "name": "Scopa",
            "provincia": "VC",
            "cap": "13027",
            "cod_catastale": "I544",
            "cod_istat": "002134",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 622,
            "giorni": 3113,
            "area": "",
            "ech": 0
        },
        {
            "id": 6740,
            "name": "Scopello",
            "provincia": "VC",
            "cap": "13028",
            "cod_catastale": "I545",
            "cod_istat": "002135",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 659,
            "giorni": 3161,
            "area": "",
            "ech": 0
        },
        {
            "id": 6741,
            "name": "Scoppito",
            "provincia": "AQ",
            "cap": "67019",
            "cod_catastale": "I546",
            "cod_istat": "066095",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 820,
            "giorni": 2756,
            "area": "",
            "ech": 0
        },
        {
            "id": 6742,
            "name": "Scordia",
            "provincia": "CT",
            "cap": "95048",
            "cod_catastale": "I548",
            "cod_istat": "087049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1032,
            "area": "",
            "ech": 1
        },
        {
            "id": 6743,
            "name": "Scorrano",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "I549",
            "cod_istat": "075073",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 1230,
            "area": "",
            "ech": 0
        },
        {
            "id": 6744,
            "name": "Scorzè",
            "provincia": "VE",
            "cap": "30037",
            "cod_catastale": "I551",
            "cod_istat": "027037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 6745,
            "name": "Scurcola Marsicana",
            "provincia": "AQ",
            "cap": "67068",
            "cod_catastale": "I553",
            "cod_istat": "066096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 2570,
            "area": "",
            "ech": 0
        },
        {
            "id": 6746,
            "name": "Scurelle",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "I554",
            "cod_istat": "022171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 375,
            "giorni": 2976,
            "area": "",
            "ech": 0
        },
        {
            "id": 6747,
            "name": "Scurzolengo",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "I555",
            "cod_istat": "005103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2695,
            "area": "",
            "ech": 0
        },
        {
            "id": 6748,
            "name": "Seborga",
            "provincia": "IM",
            "cap": "18012",
            "cod_catastale": "I556",
            "cod_istat": "008057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2342,
            "area": "",
            "ech": 0
        },
        {
            "id": 6749,
            "name": "Secinaro",
            "provincia": "AQ",
            "cap": "67029",
            "cod_catastale": "I558",
            "cod_istat": "066097",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 859,
            "giorni": 2826,
            "area": "",
            "ech": 0
        },
        {
            "id": 6750,
            "name": "Seclì",
            "provincia": "LE",
            "cap": "73050",
            "cod_catastale": "I559",
            "cod_istat": "075074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1247,
            "area": "",
            "ech": 0
        },
        {
            "id": 6751,
            "name": "Secugnago",
            "provincia": "LO",
            "cap": "26826",
            "cod_catastale": "I561",
            "cod_istat": "098052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 6752,
            "name": "Sedegliano",
            "provincia": "UD",
            "cap": "33039",
            "cod_catastale": "I562",
            "cod_istat": "030109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2244,
            "area": "",
            "ech": 0
        },
        {
            "id": 6753,
            "name": "Sedico",
            "provincia": "BL",
            "cap": "32036",
            "cod_catastale": "I563",
            "cod_istat": "025053",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 3085,
            "area": "",
            "ech": 0
        },
        {
            "id": 6754,
            "name": "Sedilo",
            "provincia": "OR",
            "cap": "09076",
            "cod_catastale": "I564",
            "cod_istat": "095052",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 283,
            "giorni": 1357,
            "area": "",
            "ech": 0
        },
        {
            "id": 6755,
            "name": "Sedini",
            "provincia": "SS",
            "cap": "07035",
            "cod_catastale": "I565",
            "cod_istat": "090065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 306,
            "giorni": 1409,
            "area": "",
            "ech": 0
        },
        {
            "id": 6756,
            "name": "Sedriano",
            "provincia": "MI",
            "cap": "20018",
            "cod_catastale": "I566",
            "cod_istat": "015204",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 145,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 6757,
            "name": "Sedrina",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "I567",
            "cod_istat": "016196",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 2535,
            "area": "",
            "ech": 0
        },
        {
            "id": 6758,
            "name": "Sefro",
            "provincia": "MC",
            "cap": "62025",
            "cod_catastale": "I569",
            "cod_istat": "043050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 497,
            "giorni": 2221,
            "area": "",
            "ech": 0
        },
        {
            "id": 6759,
            "name": "Segariu",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I570",
            "cod_istat": "111073",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 117,
            "giorni": 1170,
            "area": "",
            "ech": 0
        },
        {
            "id": 6760,
            "name": "Seggiano",
            "provincia": "GR",
            "cap": "58038",
            "cod_catastale": "I571",
            "cod_istat": "053025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 491,
            "giorni": 2204,
            "area": "",
            "ech": 0
        },
        {
            "id": 6761,
            "name": "Segni",
            "provincia": "RM",
            "cap": "00037",
            "cod_catastale": "I573",
            "cod_istat": "058102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 668,
            "giorni": 2331,
            "area": "",
            "ech": 0
        },
        {
            "id": 6762,
            "name": "Segonzano",
            "provincia": "TN",
            "cap": "38047",
            "cod_catastale": "I576",
            "cod_istat": "022172",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 660,
            "giorni": 3420,
            "area": "",
            "ech": 0
        },
        {
            "id": 6763,
            "name": "Segrate",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "I577",
            "cod_istat": "015205",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 115,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6764,
            "name": "Segusino",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "I578",
            "cod_istat": "026079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2735,
            "area": "",
            "ech": 0
        },
        {
            "id": 6765,
            "name": "Selargius",
            "provincia": "CA",
            "cap": "09047",
            "cod_catastale": "I580",
            "cod_istat": "092068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 1001,
            "area": "",
            "ech": 0
        },
        {
            "id": 6766,
            "name": "Selci",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "I581",
            "cod_istat": "057065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 1825,
            "area": "",
            "ech": 0
        },
        {
            "id": 6767,
            "name": "Selegas",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I582",
            "cod_istat": "111074",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 234,
            "giorni": 1317,
            "area": "",
            "ech": 0
        },
        {
            "id": 6768,
            "name": "Sellano",
            "provincia": "PG",
            "cap": "06030",
            "cod_catastale": "I585",
            "cod_istat": "054048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2312,
            "area": "",
            "ech": 0
        },
        {
            "id": 6769,
            "name": "Sellero",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "I588",
            "cod_istat": "017176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 476,
            "giorni": 2890,
            "area": "",
            "ech": 0
        },
        {
            "id": 6770,
            "name": "Sellia",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I589",
            "cod_istat": "079126",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 560,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 6771,
            "name": "Sellia Marina",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I590",
            "cod_istat": "079127",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 955,
            "area": "",
            "ech": 1
        },
        {
            "id": 6772,
            "name": "Selva dei Molini",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "I593",
            "cod_istat": "021088",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1229,
            "giorni": 4458,
            "area": "",
            "ech": 0
        },
        {
            "id": 6773,
            "name": "Selva di Cadore",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "I592",
            "cod_istat": "025054",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1335,
            "giorni": 4693,
            "area": "",
            "ech": 0
        },
        {
            "id": 6774,
            "name": "Selva di Progno",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "I594",
            "cod_istat": "023080",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 3221,
            "area": "",
            "ech": 0
        },
        {
            "id": 6775,
            "name": "Selva di Val Gardena",
            "provincia": "BZ",
            "cap": "39048",
            "cod_catastale": "I591",
            "cod_istat": "021089",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1563,
            "giorni": 5072,
            "area": "",
            "ech": 0
        },
        {
            "id": 6776,
            "name": "Selvazzano Dentro",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "I595",
            "cod_istat": "028086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 6777,
            "name": "Selve Marcone",
            "provincia": "BI",
            "cap": "13841",
            "cod_catastale": "I596",
            "cod_istat": "096061",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 760,
            "giorni": 3292,
            "area": "",
            "ech": 0
        },
        {
            "id": 6778,
            "name": "Selvino",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "I597",
            "cod_istat": "016197",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 3433,
            "area": "",
            "ech": 0
        },
        {
            "id": 6779,
            "name": "Semestene",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "I598",
            "cod_istat": "090066",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 405,
            "giorni": 1646,
            "area": "",
            "ech": 0
        },
        {
            "id": 6780,
            "name": "Semiana",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "I599",
            "cod_istat": "018148",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 6781,
            "name": "Seminara",
            "provincia": "RC",
            "cap": "89028",
            "cod_catastale": "I600",
            "cod_istat": "080086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 1017,
            "area": "",
            "ech": 0
        },
        {
            "id": 6782,
            "name": "Semproniano",
            "provincia": "GR",
            "cap": "58055",
            "cod_catastale": "I601",
            "cod_istat": "053028",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 601,
            "giorni": 2357,
            "area": "",
            "ech": 0
        },
        {
            "id": 6783,
            "name": "Senago",
            "provincia": "MI",
            "cap": "20030",
            "cod_catastale": "I602",
            "cod_istat": "015206",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2485,
            "area": "",
            "ech": 0
        },
        {
            "id": 6784,
            "name": "Senales",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "I604",
            "cod_istat": "021091",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1327,
            "giorni": 4390,
            "area": "",
            "ech": 0
        },
        {
            "id": 6785,
            "name": "Senale-San Felice",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "I603",
            "cod_istat": "021118",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1279,
            "giorni": 4401,
            "area": "",
            "ech": 0
        },
        {
            "id": 6786,
            "name": "Seneghe",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "I605",
            "cod_istat": "095053",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 305,
            "giorni": 1367,
            "area": "",
            "ech": 0
        },
        {
            "id": 6787,
            "name": "Senerchia",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I606",
            "cod_istat": "064098",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 600,
            "giorni": 2101,
            "area": "",
            "ech": 0
        },
        {
            "id": 6788,
            "name": "Seniga",
            "provincia": "BS",
            "cap": "25020",
            "cod_catastale": "I607",
            "cod_istat": "017177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2275,
            "area": "",
            "ech": 0
        },
        {
            "id": 6789,
            "name": "Senigallia",
            "provincia": "AN",
            "cap": "60019",
            "cod_catastale": "I608",
            "cod_istat": "042045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1737,
            "area": "",
            "ech": 0
        },
        {
            "id": 6790,
            "name": "Senis",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I609",
            "cod_istat": "095054",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 256,
            "giorni": 1305,
            "area": "",
            "ech": 0
        },
        {
            "id": 6791,
            "name": "Senise",
            "provincia": "PZ",
            "cap": "85038",
            "cod_catastale": "I610",
            "cod_istat": "076085",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 335,
            "giorni": 1518,
            "area": "",
            "ech": 0
        },
        {
            "id": 6792,
            "name": "Senna Comasco",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "I611",
            "cod_istat": "013212",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 296,
            "giorni": 2490,
            "area": "",
            "ech": 0
        },
        {
            "id": 6793,
            "name": "Senna Lodigiana",
            "provincia": "LO",
            "cap": "26856",
            "cod_catastale": "I612",
            "cod_istat": "098053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 62,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6794,
            "name": "Sennariolo",
            "provincia": "OR",
            "cap": "09078",
            "cod_catastale": "I613",
            "cod_istat": "095055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 1328,
            "area": "",
            "ech": 0
        },
        {
            "id": 6795,
            "name": "Sennori",
            "provincia": "SS",
            "cap": "07036",
            "cod_catastale": "I614",
            "cod_istat": "090067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 1442,
            "area": "",
            "ech": 0
        },
        {
            "id": 6796,
            "name": "Senorbì",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I615",
            "cod_istat": "111075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 1215,
            "area": "",
            "ech": 0
        },
        {
            "id": 6797,
            "name": "Sepino",
            "provincia": "CB",
            "cap": "86017",
            "cod_catastale": "I618",
            "cod_istat": "070075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 698,
            "giorni": 2270,
            "area": "",
            "ech": 0
        },
        {
            "id": 6798,
            "name": "Seppiana",
            "provincia": "VB",
            "cap": "28843",
            "cod_catastale": "I619",
            "cod_istat": "103063",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 557,
            "giorni": 3029,
            "area": "",
            "ech": 0
        },
        {
            "id": 6799,
            "name": "Sequals",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "I621",
            "cod_istat": "093042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 6800,
            "name": "Seravezza",
            "provincia": "LU",
            "cap": "55047",
            "cod_catastale": "I622",
            "cod_istat": "046028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1493,
            "area": "",
            "ech": 0
        },
        {
            "id": 6801,
            "name": "Serdiana",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I624",
            "cod_istat": "111076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 171,
            "giorni": 1290,
            "area": "",
            "ech": 0
        },
        {
            "id": 6802,
            "name": "Seregno",
            "provincia": "MB",
            "cap": "20831",
            "cod_catastale": "I625",
            "cod_istat": "108039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 2482,
            "area": "",
            "ech": 0
        },
        {
            "id": 6803,
            "name": "Seren del Grappa",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "I626",
            "cod_istat": "025055",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 3176,
            "area": "",
            "ech": 0
        },
        {
            "id": 6804,
            "name": "Sergnano",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "I627",
            "cod_istat": "019094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6805,
            "name": "Seriate",
            "provincia": "BG",
            "cap": "24068",
            "cod_catastale": "I628",
            "cod_istat": "016198",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2530,
            "area": "",
            "ech": 0
        },
        {
            "id": 6806,
            "name": "Serina",
            "provincia": "BG",
            "cap": "24017",
            "cod_catastale": "I629",
            "cod_istat": "016199",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 3387,
            "area": "",
            "ech": 0
        },
        {
            "id": 6807,
            "name": "Serino",
            "provincia": "AV",
            "cap": "83028",
            "cod_catastale": "I630",
            "cod_istat": "064099",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 416,
            "giorni": 1909,
            "area": "",
            "ech": 0
        },
        {
            "id": 6808,
            "name": "Serle",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "I631",
            "cod_istat": "017178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 2919,
            "area": "",
            "ech": 0
        },
        {
            "id": 6809,
            "name": "Sermide e Felonica",
            "provincia": "MN",
            "cap": "46028",
            "cod_catastale": "I632",
            "cod_istat": "020061",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6810,
            "name": "Sermoneta",
            "provincia": "LT",
            "cap": "04013",
            "cod_catastale": "I634",
            "cod_istat": "059027",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 1547,
            "area": "",
            "ech": 0
        },
        {
            "id": 6811,
            "name": "Sernaglia della Battaglia",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "I635",
            "cod_istat": "026080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 117,
            "giorni": 2416,
            "area": "",
            "ech": 0
        },
        {
            "id": 6812,
            "name": "Sernio",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "I636",
            "cod_istat": "014059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 632,
            "giorni": 3078,
            "area": "",
            "ech": 0
        },
        {
            "id": 6813,
            "name": "Serole",
            "provincia": "AT",
            "cap": "14050",
            "cod_catastale": "I637",
            "cod_istat": "005104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 588,
            "giorni": 2976,
            "area": "",
            "ech": 0
        },
        {
            "id": 6814,
            "name": "Serra d'Aiello",
            "provincia": "CS",
            "cap": "87030",
            "cod_catastale": "I642",
            "cod_istat": "078140",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 373,
            "giorni": 1553,
            "area": "",
            "ech": 0
        },
        {
            "id": 6815,
            "name": "Serra de' Conti",
            "provincia": "AN",
            "cap": "60030",
            "cod_catastale": "I643",
            "cod_istat": "042046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 1954,
            "area": "",
            "ech": 0
        },
        {
            "id": 6816,
            "name": "Serra Pedace",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "I650",
            "cod_istat": "078141",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 726,
            "giorni": 2243,
            "area": "",
            "ech": 0
        },
        {
            "id": 6817,
            "name": "Serra Riccò",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "I640",
            "cod_istat": "010058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 6818,
            "name": "Serra San Bruno",
            "provincia": "VV",
            "cap": "89822",
            "cod_catastale": "I639",
            "cod_istat": "102037",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 790,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 6819,
            "name": "Serra San Quirico",
            "provincia": "AN",
            "cap": "60048",
            "cod_catastale": "I653",
            "cod_istat": "042047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 6820,
            "name": "Serra Sant'Abbondio",
            "provincia": "PU",
            "cap": "61040",
            "cod_catastale": "I654",
            "cod_istat": "041061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 536,
            "giorni": 2356,
            "area": "",
            "ech": 0
        },
        {
            "id": 6821,
            "name": "Serracapriola",
            "provincia": "FG",
            "cap": "71010",
            "cod_catastale": "I641",
            "cod_istat": "071053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1622,
            "area": "",
            "ech": 0
        },
        {
            "id": 6822,
            "name": "Serradifalco",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "I644",
            "cod_istat": "085018",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 504,
            "giorni": 1426,
            "area": "",
            "ech": 1
        },
        {
            "id": 6823,
            "name": "Serralunga d'Alba",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "I646",
            "cod_istat": "004218",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2828,
            "area": "",
            "ech": 0
        },
        {
            "id": 6824,
            "name": "Serralunga di Crea",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "I645",
            "cod_istat": "006159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2684,
            "area": "",
            "ech": 0
        },
        {
            "id": 6825,
            "name": "Serramanna",
            "provincia": "SU",
            "cap": "09038",
            "cod_catastale": "I647",
            "cod_istat": "111077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 982,
            "area": "",
            "ech": 1
        },
        {
            "id": 6826,
            "name": "Serramazzoni",
            "provincia": "MO",
            "cap": "41028",
            "cod_catastale": "F357",
            "cod_istat": "036042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 791,
            "giorni": 3314,
            "area": "",
            "ech": 0
        },
        {
            "id": 6827,
            "name": "Serramezzana",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "I648",
            "cod_istat": "065139",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1694,
            "area": "",
            "ech": 0
        },
        {
            "id": 6828,
            "name": "Serramonacesca",
            "provincia": "PE",
            "cap": "65025",
            "cod_catastale": "I649",
            "cod_istat": "068040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1693,
            "area": "",
            "ech": 0
        },
        {
            "id": 6829,
            "name": "Serrapetrona",
            "provincia": "MC",
            "cap": "62020",
            "cod_catastale": "I651",
            "cod_istat": "043051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 2213,
            "area": "",
            "ech": 0
        },
        {
            "id": 6830,
            "name": "Serrara Fontana",
            "provincia": "NA",
            "cap": "80081",
            "cod_catastale": "I652",
            "cod_istat": "063078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 366,
            "giorni": 1623,
            "area": "",
            "ech": 0
        },
        {
            "id": 6831,
            "name": "Serrastretta",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "I655",
            "cod_istat": "079129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 840,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 6832,
            "name": "Serrata",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "I656",
            "cod_istat": "080087",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 277,
            "giorni": 1109,
            "area": "",
            "ech": 0
        },
        {
            "id": 6833,
            "name": "Serravalle a Po",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "I662",
            "cod_istat": "020062",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 6834,
            "name": "Serravalle di Chienti",
            "provincia": "MC",
            "cap": "62038",
            "cod_catastale": "I661",
            "cod_istat": "043052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 647,
            "giorni": 2397,
            "area": "",
            "ech": 0
        },
        {
            "id": 6835,
            "name": "Serravalle Langhe",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "I659",
            "cod_istat": "004219",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 762,
            "giorni": 3260,
            "area": "",
            "ech": 0
        },
        {
            "id": 6836,
            "name": "Serravalle Pistoiese",
            "provincia": "PT",
            "cap": "51034",
            "cod_catastale": "I660",
            "cod_istat": "047020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2010,
            "area": "",
            "ech": 0
        },
        {
            "id": 6837,
            "name": "Serravalle Scrivia",
            "provincia": "AL",
            "cap": "15069",
            "cod_catastale": "I657",
            "cod_istat": "006160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 6838,
            "name": "Serravalle Sesia",
            "provincia": "VC",
            "cap": "13037",
            "cod_catastale": "I663",
            "cod_istat": "002137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 2567,
            "area": "",
            "ech": 0
        },
        {
            "id": 6839,
            "name": "Serre",
            "provincia": "SA",
            "cap": "84028",
            "cod_catastale": "I666",
            "cod_istat": "065140",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1294,
            "area": "",
            "ech": 0
        },
        {
            "id": 6840,
            "name": "Serrenti",
            "provincia": "SU",
            "cap": "09027",
            "cod_catastale": "I667",
            "cod_istat": "111078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 114,
            "giorni": 1147,
            "area": "",
            "ech": 0
        },
        {
            "id": 6841,
            "name": "Serri",
            "provincia": "SU",
            "cap": "09063",
            "cod_catastale": "I668",
            "cod_istat": "111079",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 617,
            "giorni": 1887,
            "area": "",
            "ech": 0
        },
        {
            "id": 6842,
            "name": "Serrone",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "I669",
            "cod_istat": "060071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 738,
            "giorni": 2566,
            "area": "",
            "ech": 0
        },
        {
            "id": 6843,
            "name": "Serrungarina",
            "provincia": "PU",
            "cap": "61030",
            "cod_catastale": "I670",
            "cod_istat": "041062",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 209,
            "giorni": 2241,
            "area": "",
            "ech": 0
        },
        {
            "id": 6844,
            "name": "Sersale",
            "provincia": "CZ",
            "cap": "88054",
            "cod_catastale": "I671",
            "cod_istat": "079130",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 740,
            "giorni": 2309,
            "area": "",
            "ech": 0
        },
        {
            "id": 6845,
            "name": "Servigliano",
            "provincia": "FM",
            "cap": "63839",
            "cod_catastale": "C070",
            "cod_istat": "109038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 215,
            "giorni": 2123,
            "area": "",
            "ech": 0
        },
        {
            "id": 6846,
            "name": "Sessa Aurunca",
            "provincia": "CE",
            "cap": "81037",
            "cod_catastale": "I676",
            "cod_istat": "061088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 1355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6847,
            "name": "Sessa Cilento",
            "provincia": "SA",
            "cap": "84074",
            "cod_catastale": "I677",
            "cod_istat": "065141",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 520,
            "giorni": 1851,
            "area": "",
            "ech": 0
        },
        {
            "id": 6848,
            "name": "Sessame",
            "provincia": "AT",
            "cap": "14058",
            "cod_catastale": "I678",
            "cod_istat": "005105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2755,
            "area": "",
            "ech": 0
        },
        {
            "id": 6849,
            "name": "Sessano del Molise",
            "provincia": "IS",
            "cap": "86097",
            "cod_catastale": "I679",
            "cod_istat": "094049",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 796,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 6850,
            "name": "Sesta Godano",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "E070",
            "cod_istat": "011028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 242,
            "giorni": 1761,
            "area": "",
            "ech": 0
        },
        {
            "id": 6851,
            "name": "Sestino",
            "provincia": "AR",
            "cap": "52038",
            "cod_catastale": "I681",
            "cod_istat": "051035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 493,
            "giorni": 2533,
            "area": "",
            "ech": 0
        },
        {
            "id": 6852,
            "name": "Sesto",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "I687",
            "cod_istat": "021092",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1310,
            "giorni": 4718,
            "area": "",
            "ech": 0
        },
        {
            "id": 6853,
            "name": "Sesto al Reghena",
            "provincia": "PN",
            "cap": "33079",
            "cod_catastale": "I686",
            "cod_istat": "093043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 6854,
            "name": "Sesto Calende",
            "provincia": "VA",
            "cap": "21018",
            "cod_catastale": "I688",
            "cod_istat": "012120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 198,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 6855,
            "name": "Sesto Campano",
            "provincia": "IS",
            "cap": "86078",
            "cod_catastale": "I682",
            "cod_istat": "094050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 1701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6856,
            "name": "Sesto ed Uniti",
            "provincia": "CR",
            "cap": "26028",
            "cod_catastale": "I683",
            "cod_istat": "019095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 52,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6857,
            "name": "Sesto Fiorentino",
            "provincia": "FI",
            "cap": "50019",
            "cod_catastale": "I684",
            "cod_istat": "048043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1772,
            "area": "",
            "ech": 0
        },
        {
            "id": 6858,
            "name": "Sesto San Giovanni",
            "provincia": "MI",
            "cap": "20099",
            "cod_catastale": "I690",
            "cod_istat": "015209",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6859,
            "name": "Sestola",
            "provincia": "MO",
            "cap": "41029",
            "cod_catastale": "I689",
            "cod_istat": "036043",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1020,
            "giorni": 3419,
            "area": "",
            "ech": 0
        },
        {
            "id": 6860,
            "name": "Sestri Levante",
            "provincia": "GE",
            "cap": "16039",
            "cod_catastale": "I693",
            "cod_istat": "010059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1416,
            "area": "",
            "ech": 0
        },
        {
            "id": 6861,
            "name": "Sestriere",
            "provincia": "TO",
            "cap": "10058",
            "cod_catastale": "I692",
            "cod_istat": "001263",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 2035,
            "giorni": 5165,
            "area": "",
            "ech": 0
        },
        {
            "id": 6862,
            "name": "Sestu",
            "provincia": "CA",
            "cap": "09028",
            "cod_catastale": "I695",
            "cod_istat": "092074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 987,
            "area": "",
            "ech": 0
        },
        {
            "id": 6863,
            "name": "Settala",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "I696",
            "cod_istat": "015210",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 6864,
            "name": "Settefrati",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "I697",
            "cod_istat": "060072",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 784,
            "giorni": 2477,
            "area": "",
            "ech": 0
        },
        {
            "id": 6865,
            "name": "Settime",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "I698",
            "cod_istat": "005106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 272,
            "giorni": 2711,
            "area": "",
            "ech": 0
        },
        {
            "id": 6866,
            "name": "Settimo Milanese",
            "provincia": "MI",
            "cap": "20019",
            "cod_catastale": "I700",
            "cod_istat": "015211",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 2549,
            "area": "",
            "ech": 0
        },
        {
            "id": 6867,
            "name": "Settimo Rottaro",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "I701",
            "cod_istat": "001264",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 258,
            "giorni": 2744,
            "area": "",
            "ech": 0
        },
        {
            "id": 6868,
            "name": "Settimo San Pietro",
            "provincia": "CA",
            "cap": "09060",
            "cod_catastale": "I699",
            "cod_istat": "092075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1038,
            "area": "",
            "ech": 0
        },
        {
            "id": 6869,
            "name": "Settimo Torinese",
            "provincia": "TO",
            "cap": "10036",
            "cod_catastale": "I703",
            "cod_istat": "001265",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 6870,
            "name": "Settimo Vittone",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "I702",
            "cod_istat": "001266",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2781,
            "area": "",
            "ech": 0
        },
        {
            "id": 6871,
            "name": "Settingiano",
            "provincia": "CZ",
            "cap": "88040",
            "cod_catastale": "I704",
            "cod_istat": "079131",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1219,
            "area": "",
            "ech": 0
        },
        {
            "id": 6872,
            "name": "Setzu",
            "provincia": "SU",
            "cap": "09029",
            "cod_catastale": "I705",
            "cod_istat": "111080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 1237,
            "area": "",
            "ech": 0
        },
        {
            "id": 6873,
            "name": "Seui",
            "provincia": "SU",
            "cap": "09064",
            "cod_catastale": "I706",
            "cod_istat": "111081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 2182,
            "area": "",
            "ech": 1
        },
        {
            "id": 6874,
            "name": "Seulo",
            "provincia": "SU",
            "cap": "09065",
            "cod_catastale": "I707",
            "cod_istat": "111082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 799,
            "giorni": 2055,
            "area": "",
            "ech": 0
        },
        {
            "id": 6875,
            "name": "Seveso",
            "provincia": "MB",
            "cap": "20822",
            "cod_catastale": "I709",
            "cod_istat": "108040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 6876,
            "name": "Sezzadio",
            "provincia": "AL",
            "cap": "15079",
            "cod_catastale": "I711",
            "cod_istat": "006161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 127,
            "giorni": 2589,
            "area": "",
            "ech": 0
        },
        {
            "id": 6877,
            "name": "Sezze",
            "provincia": "LT",
            "cap": "04018",
            "cod_catastale": "I712",
            "cod_istat": "059028",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 1661,
            "area": "",
            "ech": 0
        },
        {
            "id": 6878,
            "name": "Sfruz",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I714",
            "cod_istat": "022173",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1015,
            "giorni": 3974,
            "area": "",
            "ech": 0
        },
        {
            "id": 6879,
            "name": "Sgonico",
            "provincia": "TS",
            "cap": "34010",
            "cod_catastale": "I715",
            "cod_istat": "032005",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2866,
            "area": "",
            "ech": 0
        },
        {
            "id": 6880,
            "name": "Sgurgola",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "I716",
            "cod_istat": "060073",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 1962,
            "area": "",
            "ech": 0
        },
        {
            "id": 6881,
            "name": "Siamaggiore",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "I717",
            "cod_istat": "095056",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 1058,
            "area": "",
            "ech": 0
        },
        {
            "id": 6882,
            "name": "Siamanna",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I718",
            "cod_istat": "095057",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 1026,
            "area": "",
            "ech": 0
        },
        {
            "id": 6883,
            "name": "Siano",
            "provincia": "SA",
            "cap": "84088",
            "cod_catastale": "I720",
            "cod_istat": "065142",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 126,
            "giorni": 1298,
            "area": "",
            "ech": 0
        },
        {
            "id": 6884,
            "name": "Siapiccia",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I721",
            "cod_istat": "095076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 1059,
            "area": "",
            "ech": 0
        },
        {
            "id": 6885,
            "name": "Sicignano degli Alburni",
            "provincia": "SA",
            "cap": "84029",
            "cod_catastale": "M253",
            "cod_istat": "065143",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 610,
            "giorni": 2058,
            "area": "",
            "ech": 0
        },
        {
            "id": 6886,
            "name": "Siculiana",
            "provincia": "AG",
            "cap": "92010",
            "cod_catastale": "I723",
            "cod_istat": "084042",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 761,
            "area": "",
            "ech": 0
        },
        {
            "id": 6887,
            "name": "Siddi",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "I724",
            "cod_istat": "111083",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 184,
            "giorni": 1207,
            "area": "",
            "ech": 0
        },
        {
            "id": 6888,
            "name": "Siderno",
            "provincia": "RC",
            "cap": "89048",
            "cod_catastale": "I725",
            "cod_istat": "080088",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 770,
            "area": "",
            "ech": 1
        },
        {
            "id": 6889,
            "name": "Siena",
            "provincia": "SI",
            "cap": "53100",
            "cod_catastale": "I726",
            "cod_istat": "052032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 322,
            "giorni": 1943,
            "area": "",
            "ech": 0
        },
        {
            "id": 6890,
            "name": "Sigillo",
            "provincia": "PG",
            "cap": "06028",
            "cod_catastale": "I727",
            "cod_istat": "054049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 490,
            "giorni": 2287,
            "area": "",
            "ech": 0
        },
        {
            "id": 6891,
            "name": "Signa",
            "provincia": "FI",
            "cap": "50058",
            "cod_catastale": "I728",
            "cod_istat": "048044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 1754,
            "area": "",
            "ech": 0
        },
        {
            "id": 6892,
            "name": "Silandro",
            "provincia": "BZ",
            "cap": "39028",
            "cod_catastale": "I729",
            "cod_istat": "021093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 721,
            "giorni": 3435,
            "area": "",
            "ech": 0
        },
        {
            "id": 6893,
            "name": "Silanus",
            "provincia": "NU",
            "cap": "08017",
            "cod_catastale": "I730",
            "cod_istat": "091083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 432,
            "giorni": 1507,
            "area": "",
            "ech": 0
        },
        {
            "id": 6894,
            "name": "Silea",
            "provincia": "TV",
            "cap": "31057",
            "cod_catastale": "F116",
            "cod_istat": "026081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2367,
            "area": "",
            "ech": 0
        },
        {
            "id": 6895,
            "name": "Siligo",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "I732",
            "cod_istat": "090068",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 406,
            "giorni": 1835,
            "area": "",
            "ech": 0
        },
        {
            "id": 6896,
            "name": "Siliqua",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "I734",
            "cod_istat": "111084",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 1030,
            "area": "",
            "ech": 0
        },
        {
            "id": 6897,
            "name": "Silius",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I735",
            "cod_istat": "111085",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 565,
            "giorni": 1632,
            "area": "",
            "ech": 0
        },
        {
            "id": 6898,
            "name": "Sillano",
            "provincia": "LU",
            "cap": "55030",
            "cod_catastale": "I737",
            "cod_istat": "046037",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 735,
            "giorni": 3194,
            "area": "",
            "ech": 0
        },
        {
            "id": 6899,
            "name": "Sillavengo",
            "provincia": "NO",
            "cap": "28064",
            "cod_catastale": "I736",
            "cod_istat": "003138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2554,
            "area": "",
            "ech": 0
        },
        {
            "id": 6900,
            "name": "Silvano d'Orba",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "I738",
            "cod_istat": "006162",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 2629,
            "area": "",
            "ech": 0
        },
        {
            "id": 6901,
            "name": "Silvano Pietra",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "I739",
            "cod_istat": "018149",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 83,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6902,
            "name": "Silvi",
            "provincia": "TE",
            "cap": "64028",
            "cod_catastale": "I741",
            "cod_istat": "067040",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1278,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 6903,
            "name": "Simala",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "I742",
            "cod_istat": "095058",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 155,
            "giorni": 1154,
            "area": "",
            "ech": 0
        },
        {
            "id": 6904,
            "name": "Simaxis",
            "provincia": "OR",
            "cap": "09088",
            "cod_catastale": "I743",
            "cod_istat": "095059",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 17,
            "giorni": 1069,
            "area": "",
            "ech": 0
        },
        {
            "id": 6905,
            "name": "Simbario",
            "provincia": "VV",
            "cap": "89822",
            "cod_catastale": "I744",
            "cod_istat": "102038",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 766,
            "giorni": 2662,
            "area": "",
            "ech": 0
        },
        {
            "id": 6906,
            "name": "Simeri Crichi",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I745",
            "cod_istat": "079133",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 465,
            "giorni": 1501,
            "area": "",
            "ech": 1
        },
        {
            "id": 6907,
            "name": "Sinagra",
            "provincia": "ME",
            "cap": "98069",
            "cod_catastale": "I747",
            "cod_istat": "083095",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 260,
            "giorni": 1071,
            "area": "",
            "ech": 1
        },
        {
            "id": 6908,
            "name": "Sinalunga",
            "provincia": "SI",
            "cap": "53048",
            "cod_catastale": "A468",
            "cod_istat": "052033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 364,
            "giorni": 1965,
            "area": "",
            "ech": 0
        },
        {
            "id": 6909,
            "name": "Sindia",
            "provincia": "NU",
            "cap": "08018",
            "cod_catastale": "I748",
            "cod_istat": "091084",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 1580,
            "area": "",
            "ech": 0
        },
        {
            "id": 6910,
            "name": "Sini",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "I749",
            "cod_istat": "095060",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 1303,
            "area": "",
            "ech": 0
        },
        {
            "id": 6911,
            "name": "Sinio",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "I750",
            "cod_istat": "004220",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 6912,
            "name": "Siniscola",
            "provincia": "NU",
            "cap": "08029",
            "cod_catastale": "I751",
            "cod_istat": "091085",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 922,
            "area": "",
            "ech": 1
        },
        {
            "id": 6913,
            "name": "Sinnai",
            "provincia": "CA",
            "cap": "09048",
            "cod_catastale": "I752",
            "cod_istat": "092080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 134,
            "giorni": 1019,
            "area": "",
            "ech": 1
        },
        {
            "id": 6914,
            "name": "Sinopoli",
            "provincia": "RC",
            "cap": "89020",
            "cod_catastale": "I753",
            "cod_istat": "080089",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1699,
            "area": "",
            "ech": 0
        },
        {
            "id": 6915,
            "name": "Siracusa",
            "provincia": "SR",
            "cap": "96100",
            "cod_catastale": "I754",
            "cod_istat": "089017",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 17,
            "giorni": 799,
            "area": "",
            "ech": 0
        },
        {
            "id": 6916,
            "name": "Sirignano",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "I756",
            "cod_istat": "064100",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 1550,
            "area": "",
            "ech": 0
        },
        {
            "id": 6917,
            "name": "Siris",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "I757",
            "cod_istat": "095061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 1162,
            "area": "",
            "ech": 0
        },
        {
            "id": 6918,
            "name": "Sirmione",
            "provincia": "BS",
            "cap": "25019",
            "cod_catastale": "I633",
            "cod_istat": "017179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 66,
            "giorni": 2229,
            "area": "",
            "ech": 0
        },
        {
            "id": 6919,
            "name": "Sirolo",
            "provincia": "AN",
            "cap": "60020",
            "cod_catastale": "I758",
            "cod_istat": "042048",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 1860,
            "area": "",
            "ech": 0
        },
        {
            "id": 6920,
            "name": "Sirone",
            "provincia": "LC",
            "cap": "23844",
            "cod_catastale": "I759",
            "cod_istat": "097075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2457,
            "area": "",
            "ech": 0
        },
        {
            "id": 6921,
            "name": "Siror",
            "provincia": "TN",
            "cap": "38054",
            "cod_catastale": "I760",
            "cod_istat": "022174",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 765,
            "giorni": 3584,
            "area": "",
            "ech": 0
        },
        {
            "id": 6922,
            "name": "Sirtori",
            "provincia": "LC",
            "cap": "23896",
            "cod_catastale": "I761",
            "cod_istat": "097076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 457,
            "giorni": 2719,
            "area": "",
            "ech": 0
        },
        {
            "id": 6923,
            "name": "Sissa",
            "provincia": "PR",
            "cap": "43018",
            "cod_catastale": "I763",
            "cod_istat": "034049",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 6924,
            "name": "Siurgus Donigala",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I765",
            "cod_istat": "111086",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 452,
            "giorni": 1642,
            "area": "",
            "ech": 1
        },
        {
            "id": 6925,
            "name": "Siziano",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "E265",
            "cod_istat": "018150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 6926,
            "name": "Sizzano",
            "provincia": "NO",
            "cap": "28070",
            "cod_catastale": "I767",
            "cod_istat": "003139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2453,
            "area": "",
            "ech": 0
        },
        {
            "id": 6927,
            "name": "Sluderno",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "I771",
            "cod_istat": "021094",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 921,
            "giorni": 3788,
            "area": "",
            "ech": 0
        },
        {
            "id": 6928,
            "name": "Smarano",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I772",
            "cod_istat": "022175",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 985,
            "giorni": 3927,
            "area": "",
            "ech": 0
        },
        {
            "id": 6929,
            "name": "Smerillo",
            "provincia": "FM",
            "cap": "63856",
            "cod_catastale": "I774",
            "cod_istat": "109039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 806,
            "giorni": 2583,
            "area": "",
            "ech": 0
        },
        {
            "id": 6930,
            "name": "Soave",
            "provincia": "VR",
            "cap": "37038",
            "cod_catastale": "I775",
            "cod_istat": "023081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 2362,
            "area": "",
            "ech": 0
        },
        {
            "id": 6931,
            "name": "Socchieve",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "I777",
            "cod_istat": "030110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 3263,
            "area": "",
            "ech": 0
        },
        {
            "id": 6932,
            "name": "Soddì",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I778",
            "cod_istat": "095078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 6933,
            "name": "Sogliano al Rubicone",
            "provincia": "FC",
            "cap": "47030",
            "cod_catastale": "I779",
            "cod_istat": "040046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 379,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 6934,
            "name": "Sogliano Cavour",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "I780",
            "cod_istat": "075075",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1225,
            "area": "",
            "ech": 0
        },
        {
            "id": 6935,
            "name": "Soglio",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "I781",
            "cod_istat": "005107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 223,
            "giorni": 2669,
            "area": "",
            "ech": 0
        },
        {
            "id": 6936,
            "name": "Soiano del Lago",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "I782",
            "cod_istat": "017180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 196,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6937,
            "name": "Solagna",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "I783",
            "cod_istat": "024101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 6938,
            "name": "Solarino",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "I785",
            "cod_istat": "089018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 966,
            "area": "",
            "ech": 1
        },
        {
            "id": 6939,
            "name": "Solaro",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "I786",
            "cod_istat": "015213",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 6940,
            "name": "Solarolo",
            "provincia": "RA",
            "cap": "48027",
            "cod_catastale": "I787",
            "cod_istat": "039018",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 6941,
            "name": "Solarolo Rainerio",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "I790",
            "cod_istat": "019096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 6942,
            "name": "Solarussa",
            "provincia": "OR",
            "cap": "09077",
            "cod_catastale": "I791",
            "cod_istat": "095062",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1063,
            "area": "",
            "ech": 0
        },
        {
            "id": 6943,
            "name": "Solbiate",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "I792",
            "cod_istat": "013255",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 445,
            "giorni": 2762,
            "area": "",
            "ech": 0
        },
        {
            "id": 6944,
            "name": "Solbiate Arno",
            "provincia": "VA",
            "cap": "21048",
            "cod_catastale": "I793",
            "cod_istat": "012121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 6945,
            "name": "Solbiate Olona",
            "provincia": "VA",
            "cap": "21058",
            "cod_catastale": "I794",
            "cod_istat": "012122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6946,
            "name": "Soldano",
            "provincia": "IM",
            "cap": "18036",
            "cod_catastale": "I796",
            "cod_istat": "008058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1401,
            "area": "",
            "ech": 0
        },
        {
            "id": 6947,
            "name": "Soleminis",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I797",
            "cod_istat": "111087",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1257,
            "area": "",
            "ech": 0
        },
        {
            "id": 6948,
            "name": "Solero",
            "provincia": "AL",
            "cap": "15029",
            "cod_catastale": "I798",
            "cod_istat": "006163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2565,
            "area": "",
            "ech": 0
        },
        {
            "id": 6949,
            "name": "Solesino",
            "provincia": "PD",
            "cap": "35047",
            "cod_catastale": "I799",
            "cod_istat": "028087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 6950,
            "name": "Soleto",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "I800",
            "cod_istat": "075076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 1216,
            "area": "",
            "ech": 0
        },
        {
            "id": 6951,
            "name": "Solferino",
            "provincia": "MN",
            "cap": "46040",
            "cod_catastale": "I801",
            "cod_istat": "020063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2442,
            "area": "",
            "ech": 0
        },
        {
            "id": 6952,
            "name": "Soliera",
            "provincia": "MO",
            "cap": "41019",
            "cod_catastale": "I802",
            "cod_istat": "036044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2249,
            "area": "",
            "ech": 0
        },
        {
            "id": 6953,
            "name": "Solignano",
            "provincia": "PR",
            "cap": "43046",
            "cod_catastale": "I803",
            "cod_istat": "034035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2754,
            "area": "",
            "ech": 0
        },
        {
            "id": 6954,
            "name": "Solofra",
            "provincia": "AV",
            "cap": "83029",
            "cod_catastale": "I805",
            "cod_istat": "064101",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1870,
            "area": "",
            "ech": 0
        },
        {
            "id": 6955,
            "name": "Solonghello",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "I808",
            "cod_istat": "006164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2667,
            "area": "",
            "ech": 0
        },
        {
            "id": 6956,
            "name": "Solopaca",
            "provincia": "BN",
            "cap": "82036",
            "cod_catastale": "I809",
            "cod_istat": "062073",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 180,
            "giorni": 1398,
            "area": "",
            "ech": 0
        },
        {
            "id": 6957,
            "name": "Solto Collina",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "I812",
            "cod_istat": "016200",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 449,
            "giorni": 2698,
            "area": "",
            "ech": 0
        },
        {
            "id": 6958,
            "name": "Solza",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "I813",
            "cod_istat": "016251",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 254,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 6959,
            "name": "Somaglia",
            "provincia": "LO",
            "cap": "26867",
            "cod_catastale": "I815",
            "cod_istat": "098054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 6960,
            "name": "Somano",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "I817",
            "cod_istat": "004221",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 2955,
            "area": "",
            "ech": 0
        },
        {
            "id": 6961,
            "name": "Somma Lombardo",
            "provincia": "VA",
            "cap": "21019",
            "cod_catastale": "I819",
            "cod_istat": "012123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2938,
            "area": "",
            "ech": 0
        },
        {
            "id": 6962,
            "name": "Somma Vesuviana",
            "provincia": "NA",
            "cap": "80049",
            "cod_catastale": "I820",
            "cod_istat": "063079",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1241,
            "area": "",
            "ech": 0
        },
        {
            "id": 6963,
            "name": "Sommacampagna",
            "provincia": "VR",
            "cap": "37066",
            "cod_catastale": "I821",
            "cod_istat": "023082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2612,
            "area": "",
            "ech": 0
        },
        {
            "id": 6964,
            "name": "Sommariva del Bosco",
            "provincia": "CN",
            "cap": "12048",
            "cod_catastale": "I822",
            "cod_istat": "004222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 298,
            "giorni": 2624,
            "area": "",
            "ech": 0
        },
        {
            "id": 6965,
            "name": "Sommariva Perno",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "I823",
            "cod_istat": "004223",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 389,
            "giorni": 2797,
            "area": "",
            "ech": 0
        },
        {
            "id": 6966,
            "name": "Sommatino",
            "provincia": "CL",
            "cap": "93019",
            "cod_catastale": "I824",
            "cod_istat": "085019",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 359,
            "giorni": 1205,
            "area": "",
            "ech": 0
        },
        {
            "id": 6967,
            "name": "Sommo",
            "provincia": "PV",
            "cap": "27048",
            "cod_catastale": "I825",
            "cod_istat": "018151",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 6968,
            "name": "Sona",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "I826",
            "cod_istat": "023083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2571,
            "area": "",
            "ech": 0
        },
        {
            "id": 6969,
            "name": "Soncino",
            "provincia": "CR",
            "cap": "26029",
            "cod_catastale": "I827",
            "cod_istat": "019097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 6970,
            "name": "Sondalo",
            "provincia": "SO",
            "cap": "23035",
            "cod_catastale": "I828",
            "cod_istat": "014060",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 939,
            "giorni": 3403,
            "area": "",
            "ech": 0
        },
        {
            "id": 6971,
            "name": "Sondrio",
            "provincia": "SO",
            "cap": "23100",
            "cod_catastale": "I829",
            "cod_istat": "014061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 307,
            "giorni": 2755,
            "area": "",
            "ech": 0
        },
        {
            "id": 6972,
            "name": "Songavazzo",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "I830",
            "cod_istat": "016201",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 640,
            "giorni": 2989,
            "area": "",
            "ech": 0
        },
        {
            "id": 6973,
            "name": "Sonico",
            "provincia": "BS",
            "cap": "25048",
            "cod_catastale": "I831",
            "cod_istat": "017181",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 3120,
            "area": "",
            "ech": 0
        },
        {
            "id": 6974,
            "name": "Sonnino",
            "provincia": "LT",
            "cap": "04010",
            "cod_catastale": "I832",
            "cod_istat": "059029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1865,
            "area": "",
            "ech": 0
        },
        {
            "id": 6975,
            "name": "Soprana",
            "provincia": "BI",
            "cap": "13834",
            "cod_catastale": "I835",
            "cod_istat": "096062",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2895,
            "area": "",
            "ech": 0
        },
        {
            "id": 6976,
            "name": "Sora",
            "provincia": "FR",
            "cap": "03039",
            "cod_catastale": "I838",
            "cod_istat": "060074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2150,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 6977,
            "name": "Soraga di Fassa",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "I839",
            "cod_istat": "022176",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 6978,
            "name": "Soragna",
            "provincia": "PR",
            "cap": "43019",
            "cod_catastale": "I840",
            "cod_istat": "034036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 2517,
            "area": "",
            "ech": 0
        },
        {
            "id": 6979,
            "name": "Sorano",
            "provincia": "GR",
            "cap": "58010",
            "cod_catastale": "I841",
            "cod_istat": "053026",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 379,
            "giorni": 2048,
            "area": "",
            "ech": 0
        },
        {
            "id": 6980,
            "name": "Sorbo San Basile",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I844",
            "cod_istat": "079134",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 2051,
            "area": "",
            "ech": 0
        },
        {
            "id": 6981,
            "name": "Sorbo Serpico",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "I843",
            "cod_istat": "064102",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 480,
            "giorni": 1894,
            "area": "",
            "ech": 0
        },
        {
            "id": 6982,
            "name": "Sorbolo",
            "provincia": "PR",
            "cap": "43058",
            "cod_catastale": "I845",
            "cod_istat": "034051",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 34,
            "giorni": 2359,
            "area": "",
            "ech": 0
        },
        {
            "id": 6983,
            "name": "Sordevolo",
            "provincia": "BI",
            "cap": "13817",
            "cod_catastale": "I847",
            "cod_istat": "096063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 627,
            "giorni": 3123,
            "area": "",
            "ech": 0
        },
        {
            "id": 6984,
            "name": "Sordio",
            "provincia": "LO",
            "cap": "26858",
            "cod_catastale": "I848",
            "cod_istat": "098055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 6985,
            "name": "Soresina",
            "provincia": "CR",
            "cap": "26015",
            "cod_catastale": "I849",
            "cod_istat": "019098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 6986,
            "name": "Sorgà",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "I850",
            "cod_istat": "023084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 6987,
            "name": "Sorgono",
            "provincia": "NU",
            "cap": "08038",
            "cod_catastale": "I851",
            "cod_istat": "091086",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 688,
            "giorni": 1882,
            "area": "",
            "ech": 0
        },
        {
            "id": 6988,
            "name": "Sori",
            "provincia": "GE",
            "cap": "16031",
            "cod_catastale": "I852",
            "cod_istat": "010060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 1423,
            "area": "",
            "ech": 0
        },
        {
            "id": 6989,
            "name": "Sorianello",
            "provincia": "VV",
            "cap": "89831",
            "cod_catastale": "I853",
            "cod_istat": "102039",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1631,
            "area": "",
            "ech": 1
        },
        {
            "id": 6990,
            "name": "Soriano Calabro",
            "provincia": "VV",
            "cap": "89831",
            "cod_catastale": "I854",
            "cod_istat": "102040",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 268,
            "giorni": 1312,
            "area": "",
            "ech": 0
        },
        {
            "id": 6991,
            "name": "Soriano nel Cimino",
            "provincia": "VT",
            "cap": "01038",
            "cod_catastale": "I855",
            "cod_istat": "056048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 6992,
            "name": "Sorico",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "I856",
            "cod_istat": "013216",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 201,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 6993,
            "name": "Soriso",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "I857",
            "cod_istat": "003140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 452,
            "giorni": 2892,
            "area": "",
            "ech": 0
        },
        {
            "id": 6994,
            "name": "Sorisole",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "I858",
            "cod_istat": "016202",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 415,
            "giorni": 2659,
            "area": "",
            "ech": 0
        },
        {
            "id": 6995,
            "name": "Sormano",
            "provincia": "CO",
            "cap": "22030",
            "cod_catastale": "I860",
            "cod_istat": "013217",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 3170,
            "area": "",
            "ech": 0
        },
        {
            "id": 6996,
            "name": "Sorradile",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I861",
            "cod_istat": "095063",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 337,
            "giorni": 1408,
            "area": "",
            "ech": 0
        },
        {
            "id": 6997,
            "name": "Sorrento",
            "provincia": "NA",
            "cap": "80067",
            "cod_catastale": "I862",
            "cod_istat": "063080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1030,
            "area": "",
            "ech": 0
        },
        {
            "id": 6998,
            "name": "Sorso",
            "provincia": "SS",
            "cap": "07037",
            "cod_catastale": "I863",
            "cod_istat": "090069",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 6999,
            "name": "Sortino",
            "provincia": "SR",
            "cap": "96010",
            "cod_catastale": "I864",
            "cod_istat": "089019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 438,
            "giorni": 1280,
            "area": "",
            "ech": 0
        },
        {
            "id": 7000,
            "name": "Sospiro",
            "provincia": "CR",
            "cap": "26048",
            "cod_catastale": "I865",
            "cod_istat": "019099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7001,
            "name": "Sospirolo",
            "provincia": "BL",
            "cap": "32037",
            "cod_catastale": "I866",
            "cod_istat": "025056",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 447,
            "giorni": 3290,
            "area": "",
            "ech": 0
        },
        {
            "id": 7002,
            "name": "Sossano",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "I867",
            "cod_istat": "024102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 19,
            "giorni": 2424,
            "area": "",
            "ech": 0
        },
        {
            "id": 7003,
            "name": "Sostegno",
            "provincia": "BI",
            "cap": "13868",
            "cod_catastale": "I868",
            "cod_istat": "096064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2821,
            "area": "",
            "ech": 0
        },
        {
            "id": 7004,
            "name": "Sotto il Monte Giovanni XXIII",
            "provincia": "BG",
            "cap": "24039",
            "cod_catastale": "I869",
            "cod_istat": "016203",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 7005,
            "name": "Sover",
            "provincia": "TN",
            "cap": "38048",
            "cod_catastale": "I871",
            "cod_istat": "022177",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 831,
            "giorni": 3687,
            "area": "",
            "ech": 0
        },
        {
            "id": 7006,
            "name": "Soverato",
            "provincia": "CZ",
            "cap": "88068",
            "cod_catastale": "I872",
            "cod_istat": "079137",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 854,
            "area": "",
            "ech": 1
        },
        {
            "id": 7007,
            "name": "Sovere",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "I873",
            "cod_istat": "016204",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 379,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 7008,
            "name": "Soveria Mannelli",
            "provincia": "CZ",
            "cap": "88049",
            "cod_catastale": "I874",
            "cod_istat": "079138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 774,
            "giorni": 2374,
            "area": "",
            "ech": 1
        },
        {
            "id": 7009,
            "name": "Soveria Simeri",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I875",
            "cod_istat": "079139",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 367,
            "giorni": 1426,
            "area": "",
            "ech": 0
        },
        {
            "id": 7010,
            "name": "Soverzene",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "I876",
            "cod_istat": "025057",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 424,
            "giorni": 3271,
            "area": "",
            "ech": 0
        },
        {
            "id": 7011,
            "name": "Sovicille",
            "provincia": "SI",
            "cap": "53018",
            "cod_catastale": "I877",
            "cod_istat": "052034",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 1797,
            "area": "",
            "ech": 0
        },
        {
            "id": 7012,
            "name": "Sovico",
            "provincia": "MB",
            "cap": "20845",
            "cod_catastale": "I878",
            "cod_istat": "108041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2450,
            "area": "",
            "ech": 0
        },
        {
            "id": 7013,
            "name": "Sovizzo",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "I879",
            "cod_istat": "024103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 2380,
            "area": "",
            "ech": 0
        },
        {
            "id": 7014,
            "name": "Sovramonte",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "I673",
            "cod_istat": "025058",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 610,
            "giorni": 3548,
            "area": "",
            "ech": 0
        },
        {
            "id": 7015,
            "name": "Sozzago",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "I880",
            "cod_istat": "003141",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 7016,
            "name": "Spadafora",
            "provincia": "ME",
            "cap": "98048",
            "cod_catastale": "I881",
            "cod_istat": "083096",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 696,
            "area": "",
            "ech": 0
        },
        {
            "id": 7017,
            "name": "Spadola",
            "provincia": "VV",
            "cap": "89822",
            "cod_catastale": "I884",
            "cod_istat": "102041",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 754,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 7018,
            "name": "Sparanise",
            "provincia": "CE",
            "cap": "81056",
            "cod_catastale": "I885",
            "cod_istat": "061089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 65,
            "giorni": 1172,
            "area": "",
            "ech": 0
        },
        {
            "id": 7019,
            "name": "Sparone",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "I886",
            "cod_istat": "001267",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 552,
            "giorni": 3182,
            "area": "",
            "ech": 0
        },
        {
            "id": 7020,
            "name": "Specchia",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "I887",
            "cod_istat": "075077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 1367,
            "area": "",
            "ech": 0
        },
        {
            "id": 7021,
            "name": "Spello",
            "provincia": "PG",
            "cap": "06038",
            "cod_catastale": "I888",
            "cod_istat": "054050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2075,
            "area": "",
            "ech": 0
        },
        {
            "id": 7022,
            "name": "Spera",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "I889",
            "cod_istat": "022178",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 553,
            "giorni": 3253,
            "area": "",
            "ech": 0
        },
        {
            "id": 7023,
            "name": "Sperlinga",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "I891",
            "cod_istat": "086017",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 750,
            "giorni": 1800,
            "area": "",
            "ech": 0
        },
        {
            "id": 7024,
            "name": "Sperlonga",
            "provincia": "LT",
            "cap": "04029",
            "cod_catastale": "I892",
            "cod_istat": "059030",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1175,
            "area": "",
            "ech": 0
        },
        {
            "id": 7025,
            "name": "Sperone",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "I893",
            "cod_istat": "064103",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 175,
            "giorni": 1325,
            "area": "",
            "ech": 0
        },
        {
            "id": 7026,
            "name": "Spessa",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "I894",
            "cod_istat": "018152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7027,
            "name": "Spezzano Albanese",
            "provincia": "CS",
            "cap": "87019",
            "cod_catastale": "I895",
            "cod_istat": "078142",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 1462,
            "area": "",
            "ech": 0
        },
        {
            "id": 7028,
            "name": "Spezzano della Sila",
            "provincia": "CS",
            "cap": "87058",
            "cod_catastale": "I896",
            "cod_istat": "078143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 800,
            "giorni": 2392,
            "area": "",
            "ech": 0
        },
        {
            "id": 7029,
            "name": "Spezzano Piccolo",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "I898",
            "cod_istat": "078144",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 743,
            "giorni": 2277,
            "area": "",
            "ech": 0
        },
        {
            "id": 7030,
            "name": "Spiazzo",
            "provincia": "TN",
            "cap": "38088",
            "cod_catastale": "I899",
            "cod_istat": "022179",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 645,
            "giorni": 3405,
            "area": "",
            "ech": 0
        },
        {
            "id": 7031,
            "name": "Spigno Monferrato",
            "provincia": "AL",
            "cap": "15018",
            "cod_catastale": "I901",
            "cod_istat": "006165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 2493,
            "area": "",
            "ech": 0
        },
        {
            "id": 7032,
            "name": "Spigno Saturnia",
            "provincia": "LT",
            "cap": "04020",
            "cod_catastale": "I902",
            "cod_istat": "059031",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 1017,
            "area": "",
            "ech": 0
        },
        {
            "id": 7033,
            "name": "Spilamberto",
            "provincia": "MO",
            "cap": "41057",
            "cod_catastale": "I903",
            "cod_istat": "036045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 7034,
            "name": "Spilimbergo",
            "provincia": "PN",
            "cap": "33097",
            "cod_catastale": "I904",
            "cod_istat": "093044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 2626,
            "area": "",
            "ech": 0
        },
        {
            "id": 7035,
            "name": "Spilinga",
            "provincia": "VV",
            "cap": "89864",
            "cod_catastale": "I905",
            "cod_istat": "102042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 455,
            "giorni": 1705,
            "area": "",
            "ech": 0
        },
        {
            "id": 7036,
            "name": "Spinadesco",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "I906",
            "cod_istat": "019100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7037,
            "name": "Spinazzola",
            "provincia": "BT",
            "cap": "76014",
            "cod_catastale": "I907",
            "cod_istat": "110008",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 435,
            "giorni": 1748,
            "area": "",
            "ech": 0
        },
        {
            "id": 7038,
            "name": "Spinea",
            "provincia": "VE",
            "cap": "30038",
            "cod_catastale": "I908",
            "cod_istat": "027038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 7039,
            "name": "Spineda",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "I909",
            "cod_istat": "019101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7040,
            "name": "Spinete",
            "provincia": "CB",
            "cap": "86020",
            "cod_catastale": "I910",
            "cod_istat": "070076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 600,
            "giorni": 2130,
            "area": "",
            "ech": 0
        },
        {
            "id": 7041,
            "name": "Spineto Scrivia",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "I911",
            "cod_istat": "006166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 7042,
            "name": "Spinetoli",
            "provincia": "AP",
            "cap": "63078",
            "cod_catastale": "I912",
            "cod_istat": "044071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 177,
            "giorni": 1504,
            "area": "",
            "ech": 0
        },
        {
            "id": 7043,
            "name": "Spino d'Adda",
            "provincia": "CR",
            "cap": "26016",
            "cod_catastale": "I914",
            "cod_istat": "019102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7044,
            "name": "Spinone al Lago",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "I916",
            "cod_istat": "016205",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 7045,
            "name": "Spinoso",
            "provincia": "PZ",
            "cap": "85039",
            "cod_catastale": "I917",
            "cod_istat": "076086",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 649,
            "giorni": 2089,
            "area": "",
            "ech": 0
        },
        {
            "id": 7046,
            "name": "Spirano",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "I919",
            "cod_istat": "016206",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2383,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 7047,
            "name": "Spoleto",
            "provincia": "PG",
            "cap": "06049",
            "cod_catastale": "I921",
            "cod_istat": "054051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 396,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 7048,
            "name": "Spoltore",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "I922",
            "cod_istat": "068041",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 7049,
            "name": "Spongano",
            "provincia": "LE",
            "cap": "73038",
            "cod_catastale": "I923",
            "cod_istat": "075078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 1240,
            "area": "",
            "ech": 0
        },
        {
            "id": 7050,
            "name": "Spormaggiore",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I924",
            "cod_istat": "022180",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 565,
            "giorni": 3272,
            "area": "",
            "ech": 0
        },
        {
            "id": 7051,
            "name": "Sporminore",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "I925",
            "cod_istat": "022181",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 3194,
            "area": "",
            "ech": 0
        },
        {
            "id": 7052,
            "name": "Spotorno",
            "provincia": "SV",
            "cap": "17028",
            "cod_catastale": "I926",
            "cod_istat": "009057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1440,
            "area": "",
            "ech": 0
        },
        {
            "id": 7053,
            "name": "Spresiano",
            "provincia": "TV",
            "cap": "31027",
            "cod_catastale": "I927",
            "cod_istat": "026082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 7054,
            "name": "Spriana",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "I928",
            "cod_istat": "014062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 754,
            "giorni": 3140,
            "area": "",
            "ech": 0
        },
        {
            "id": 7055,
            "name": "Squillace",
            "provincia": "CZ",
            "cap": "88069",
            "cod_catastale": "I929",
            "cod_istat": "079142",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 344,
            "giorni": 1258,
            "area": "",
            "ech": 1
        },
        {
            "id": 7056,
            "name": "Squinzano",
            "provincia": "LE",
            "cap": "73018",
            "cod_catastale": "I930",
            "cod_istat": "075079",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 48,
            "giorni": 1105,
            "area": "",
            "ech": 0
        },
        {
            "id": 7057,
            "name": "Staffolo",
            "provincia": "AN",
            "cap": "60039",
            "cod_catastale": "I932",
            "cod_istat": "042049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2234,
            "area": "",
            "ech": 0
        },
        {
            "id": 7058,
            "name": "Stagno Lombardo",
            "provincia": "CR",
            "cap": "26049",
            "cod_catastale": "I935",
            "cod_istat": "019103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7059,
            "name": "Staiti",
            "provincia": "RC",
            "cap": "89030",
            "cod_catastale": "I936",
            "cod_istat": "080090",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 550,
            "giorni": 1728,
            "area": "",
            "ech": 0
        },
        {
            "id": 7060,
            "name": "Stalettì",
            "provincia": "CZ",
            "cap": "88069",
            "cod_catastale": "I937",
            "cod_istat": "079143",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 1551,
            "area": "",
            "ech": 0
        },
        {
            "id": 7061,
            "name": "Stanghella",
            "provincia": "PD",
            "cap": "35048",
            "cod_catastale": "I938",
            "cod_istat": "028088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7062,
            "name": "Staranzano",
            "provincia": "GO",
            "cap": "34079",
            "cod_catastale": "I939",
            "cod_istat": "031023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 7063,
            "name": "Statte",
            "provincia": "TA",
            "cap": "74010",
            "cod_catastale": "M298",
            "cod_istat": "073029",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 1159,
            "area": "",
            "ech": 0
        },
        {
            "id": 7064,
            "name": "Stazzano",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "I941",
            "cod_istat": "006167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2740,
            "area": "",
            "ech": 0
        },
        {
            "id": 7065,
            "name": "Stazzema",
            "provincia": "LU",
            "cap": "55040",
            "cod_catastale": "I942",
            "cod_istat": "046030",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 916,
            "giorni": 3074,
            "area": "",
            "ech": 0
        },
        {
            "id": 7066,
            "name": "Stazzona",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "I943",
            "cod_istat": "013218",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 2801,
            "area": "",
            "ech": 0
        },
        {
            "id": 7067,
            "name": "Stefanaconi",
            "provincia": "VV",
            "cap": "89843",
            "cod_catastale": "I945",
            "cod_istat": "102043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 1516,
            "area": "",
            "ech": 0
        },
        {
            "id": 7068,
            "name": "Stella",
            "provincia": "SV",
            "cap": "17044",
            "cod_catastale": "I946",
            "cod_istat": "009058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 1864,
            "area": "",
            "ech": 0
        },
        {
            "id": 7069,
            "name": "Stella Cilento",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "G887",
            "cod_istat": "065144",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 386,
            "giorni": 1527,
            "area": "",
            "ech": 0
        },
        {
            "id": 7070,
            "name": "Stellanello",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "I947",
            "cod_istat": "009059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 1594,
            "area": "",
            "ech": 0
        },
        {
            "id": 7071,
            "name": "Stelvio",
            "provincia": "BZ",
            "cap": "39029",
            "cod_catastale": "I948",
            "cod_istat": "021095",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1310,
            "giorni": 4564,
            "area": "",
            "ech": 0
        },
        {
            "id": 7072,
            "name": "Stenico",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "I949",
            "cod_istat": "022182",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 666,
            "giorni": 3411,
            "area": "",
            "ech": 0
        },
        {
            "id": 7073,
            "name": "Sternatia",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "I950",
            "cod_istat": "075080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 1197,
            "area": "",
            "ech": 0
        },
        {
            "id": 7074,
            "name": "Stezzano",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "I951",
            "cod_istat": "016207",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 211,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 7075,
            "name": "Stia",
            "provincia": "AR",
            "cap": "52017",
            "cod_catastale": "I952",
            "cod_istat": "051041",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2264,
            "area": "",
            "ech": 0
        },
        {
            "id": 7076,
            "name": "Stienta",
            "provincia": "RO",
            "cap": "45039",
            "cod_catastale": "I953",
            "cod_istat": "029045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 7077,
            "name": "Stigliano",
            "provincia": "MT",
            "cap": "75018",
            "cod_catastale": "I954",
            "cod_istat": "077027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 909,
            "giorni": 2472,
            "area": "",
            "ech": 0
        },
        {
            "id": 7078,
            "name": "Stignano",
            "provincia": "RC",
            "cap": "89040",
            "cod_catastale": "I955",
            "cod_istat": "080091",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 1181,
            "area": "",
            "ech": 1
        },
        {
            "id": 7079,
            "name": "Stilo",
            "provincia": "RC",
            "cap": "89049",
            "cod_catastale": "I956",
            "cod_istat": "080092",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 400,
            "giorni": 1490,
            "area": "",
            "ech": 1
        },
        {
            "id": 7080,
            "name": "Stimigliano",
            "provincia": "RI",
            "cap": "02048",
            "cod_catastale": "I959",
            "cod_istat": "057066",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 207,
            "giorni": 1742,
            "area": "",
            "ech": 0
        },
        {
            "id": 7081,
            "name": "Stintino",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "M290",
            "cod_istat": "090089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 937,
            "area": "",
            "ech": 0
        },
        {
            "id": 7082,
            "name": "Stio",
            "provincia": "SA",
            "cap": "84075",
            "cod_catastale": "I960",
            "cod_istat": "065145",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 675,
            "giorni": 1981,
            "area": "",
            "ech": 0
        },
        {
            "id": 7083,
            "name": "Stornara",
            "provincia": "FG",
            "cap": "71047",
            "cod_catastale": "I962",
            "cod_istat": "071054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 107,
            "giorni": 1445,
            "area": "",
            "ech": 0
        },
        {
            "id": 7084,
            "name": "Stornarella",
            "provincia": "FG",
            "cap": "71048",
            "cod_catastale": "I963",
            "cod_istat": "071055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 1525,
            "area": "",
            "ech": 0
        },
        {
            "id": 7085,
            "name": "Storo",
            "provincia": "TN",
            "cap": "38089",
            "cod_catastale": "I964",
            "cod_istat": "022183",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 409,
            "giorni": 3029,
            "area": "",
            "ech": 0
        },
        {
            "id": 7086,
            "name": "Stra",
            "provincia": "VE",
            "cap": "30039",
            "cod_catastale": "I965",
            "cod_istat": "027039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 7087,
            "name": "Stradella",
            "provincia": "PV",
            "cap": "27049",
            "cod_catastale": "I968",
            "cod_istat": "018153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7088,
            "name": "Strambinello",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "I969",
            "cod_istat": "001268",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 7089,
            "name": "Strambino",
            "provincia": "TO",
            "cap": "10019",
            "cod_catastale": "I970",
            "cod_istat": "001269",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2720,
            "area": "",
            "ech": 0
        },
        {
            "id": 7090,
            "name": "Strangolagalli",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "I973",
            "cod_istat": "060075",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 1830,
            "area": "",
            "ech": 0
        },
        {
            "id": 7091,
            "name": "Stregna",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "I974",
            "cod_istat": "030111",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 404,
            "giorni": 3244,
            "area": "",
            "ech": 0
        },
        {
            "id": 7092,
            "name": "Strembo",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "I975",
            "cod_istat": "022184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 714,
            "giorni": 3505,
            "area": "",
            "ech": 0
        },
        {
            "id": 7093,
            "name": "Stresa",
            "provincia": "VB",
            "cap": "28838",
            "cod_catastale": "I976",
            "cod_istat": "103064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2430,
            "area": "",
            "ech": 0
        },
        {
            "id": 7094,
            "name": "Strevi",
            "provincia": "AL",
            "cap": "15019",
            "cod_catastale": "I977",
            "cod_istat": "006168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 7095,
            "name": "Striano",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "I978",
            "cod_istat": "063081",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 1147,
            "area": "",
            "ech": 0
        },
        {
            "id": 7096,
            "name": "Strigno",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "I979",
            "cod_istat": "022185",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 506,
            "giorni": 3180,
            "area": "",
            "ech": 0
        },
        {
            "id": 7097,
            "name": "Strona",
            "provincia": "BI",
            "cap": "13823",
            "cod_catastale": "I980",
            "cod_istat": "096065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7098,
            "name": "Stroncone",
            "provincia": "TR",
            "cap": "05039",
            "cod_catastale": "I981",
            "cod_istat": "055031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2186,
            "area": "",
            "ech": 0
        },
        {
            "id": 7099,
            "name": "Strongoli",
            "provincia": "KR",
            "cap": "88816",
            "cod_catastale": "I982",
            "cod_istat": "101025",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 1467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7100,
            "name": "Stroppiana",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "I984",
            "cod_istat": "002142",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2820,
            "area": "",
            "ech": 0
        },
        {
            "id": 7101,
            "name": "Stroppo",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "I985",
            "cod_istat": "004224",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1087,
            "giorni": 3663,
            "area": "",
            "ech": 0
        },
        {
            "id": 7102,
            "name": "Strozza",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "I986",
            "cod_istat": "016208",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 7103,
            "name": "Sturno",
            "provincia": "AV",
            "cap": "83055",
            "cod_catastale": "I990",
            "cod_istat": "064104",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 652,
            "giorni": 2233,
            "area": "",
            "ech": 0
        },
        {
            "id": 7104,
            "name": "Suardi",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "B014",
            "cod_istat": "018154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 7105,
            "name": "Subbiano",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "I991",
            "cod_istat": "051037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 266,
            "giorni": 2041,
            "area": "",
            "ech": 0
        },
        {
            "id": 7106,
            "name": "Subiaco",
            "provincia": "RM",
            "cap": "00028",
            "cod_catastale": "I992",
            "cod_istat": "058103",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 2034,
            "area": "",
            "ech": 0
        },
        {
            "id": 7107,
            "name": "Succivo",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "I993",
            "cod_istat": "061090",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 1191,
            "area": "",
            "ech": 0
        },
        {
            "id": 7108,
            "name": "Sueglio",
            "provincia": "LC",
            "cap": "23835",
            "cod_catastale": "I994",
            "cod_istat": "097077",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 3170,
            "area": "",
            "ech": 0
        },
        {
            "id": 7109,
            "name": "Suelli",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "I995",
            "cod_istat": "111088",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 254,
            "giorni": 1350,
            "area": "",
            "ech": 1
        },
        {
            "id": 7110,
            "name": "Suello",
            "provincia": "LC",
            "cap": "23867",
            "cod_catastale": "I996",
            "cod_istat": "097078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 7111,
            "name": "Suisio",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "I997",
            "cod_istat": "016209",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 7112,
            "name": "Sulbiate",
            "provincia": "MB",
            "cap": "20884",
            "cod_catastale": "I998",
            "cod_istat": "108042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 227,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 7113,
            "name": "Sulmona",
            "provincia": "AQ",
            "cap": "67039",
            "cod_catastale": "I804",
            "cod_istat": "066098",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2038,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 7114,
            "name": "Sulzano",
            "provincia": "BS",
            "cap": "25058",
            "cod_catastale": "L002",
            "cod_istat": "017182",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 7115,
            "name": "Sumirago",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "L003",
            "cod_istat": "012124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 392,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 7116,
            "name": "Summonte",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "L004",
            "cod_istat": "064105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 738,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 7117,
            "name": "Suni",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "L006",
            "cod_istat": "095087",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 1317,
            "area": "",
            "ech": 0
        },
        {
            "id": 7118,
            "name": "Suno",
            "provincia": "NO",
            "cap": "28019",
            "cod_catastale": "L007",
            "cod_istat": "003143",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 2631,
            "area": "",
            "ech": 0
        },
        {
            "id": 7119,
            "name": "Supersano",
            "provincia": "LE",
            "cap": "73040",
            "cod_catastale": "L008",
            "cod_istat": "075081",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 106,
            "giorni": 1271,
            "area": "",
            "ech": 0
        },
        {
            "id": 7120,
            "name": "Supino",
            "provincia": "FR",
            "cap": "03019",
            "cod_catastale": "L009",
            "cod_istat": "060076",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 7121,
            "name": "Surano",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "L010",
            "cod_istat": "075082",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1286,
            "area": "",
            "ech": 0
        },
        {
            "id": 7122,
            "name": "Surbo",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "L011",
            "cod_istat": "075083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 40,
            "giorni": 1062,
            "area": "",
            "ech": 0
        },
        {
            "id": 7123,
            "name": "Susa",
            "provincia": "TO",
            "cap": "10059",
            "cod_catastale": "L013",
            "cod_istat": "001270",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 503,
            "giorni": 3108,
            "area": "",
            "ech": 0
        },
        {
            "id": 7124,
            "name": "Susegana",
            "provincia": "TV",
            "cap": "31058",
            "cod_catastale": "L014",
            "cod_istat": "026083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2494,
            "area": "",
            "ech": 0
        },
        {
            "id": 7125,
            "name": "Sustinente",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "L015",
            "cod_istat": "020064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7126,
            "name": "Sutera",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "L016",
            "cod_istat": "085020",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 1557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7127,
            "name": "Sutri",
            "provincia": "VT",
            "cap": "01015",
            "cod_catastale": "L017",
            "cod_istat": "056049",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 291,
            "giorni": 1937,
            "area": "",
            "ech": 0
        },
        {
            "id": 7128,
            "name": "Sutrio",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "L018",
            "cod_istat": "030112",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 3487,
            "area": "",
            "ech": 0
        },
        {
            "id": 7129,
            "name": "Suvereto",
            "provincia": "LI",
            "cap": "57028",
            "cod_catastale": "L019",
            "cod_istat": "049020",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1162,
            "area": "",
            "ech": 0
        },
        {
            "id": 7130,
            "name": "Suzzara",
            "provincia": "MN",
            "cap": "46029",
            "cod_catastale": "L020",
            "cod_istat": "020065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 20,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 7131,
            "name": "Taceno",
            "provincia": "LC",
            "cap": "23837",
            "cod_catastale": "L022",
            "cod_istat": "097079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 507,
            "giorni": 2790,
            "area": "",
            "ech": 0
        },
        {
            "id": 7132,
            "name": "Tadasuni",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "L023",
            "cod_istat": "095064",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 180,
            "giorni": 1207,
            "area": "",
            "ech": 0
        },
        {
            "id": 7133,
            "name": "Taggia",
            "provincia": "IM",
            "cap": "18018",
            "cod_catastale": "L024",
            "cod_istat": "008059",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 1165,
            "area": "",
            "ech": 0
        },
        {
            "id": 7134,
            "name": "Tagliacozzo",
            "provincia": "AQ",
            "cap": "67069",
            "cod_catastale": "L025",
            "cod_istat": "066099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 740,
            "giorni": 2613,
            "area": "",
            "ech": 0
        },
        {
            "id": 7135,
            "name": "Taglio di Po",
            "provincia": "RO",
            "cap": "45019",
            "cod_catastale": "L026",
            "cod_istat": "029046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 0,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 7136,
            "name": "Tagliolo Monferrato",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "L027",
            "cod_istat": "006169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 315,
            "giorni": 2650,
            "area": "",
            "ech": 0
        },
        {
            "id": 7137,
            "name": "Taibon Agordino",
            "provincia": "BL",
            "cap": "32027",
            "cod_catastale": "L030",
            "cod_istat": "025059",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 618,
            "giorni": 3387,
            "area": "",
            "ech": 0
        },
        {
            "id": 7138,
            "name": "Taino",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "L032",
            "cod_istat": "012125",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2487,
            "area": "",
            "ech": 0
        },
        {
            "id": 7139,
            "name": "Taio",
            "provincia": "TN",
            "cap": "38012",
            "cod_catastale": "L033",
            "cod_istat": "022186",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 3194,
            "area": "",
            "ech": 0
        },
        {
            "id": 7140,
            "name": "Taipana",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "G736",
            "cod_istat": "030113",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 478,
            "giorni": 3305,
            "area": "",
            "ech": 0
        },
        {
            "id": 7141,
            "name": "Talamello",
            "provincia": "RN",
            "cap": "47867",
            "cod_catastale": "L034",
            "cod_istat": "099027",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 386,
            "giorni": 2384,
            "area": "",
            "ech": 0
        },
        {
            "id": 7142,
            "name": "Talamona",
            "provincia": "SO",
            "cap": "23018",
            "cod_catastale": "L035",
            "cod_istat": "014063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 3064,
            "area": "",
            "ech": 0
        },
        {
            "id": 7143,
            "name": "Talana",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "L036",
            "cod_istat": "091088",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 682,
            "giorni": 1866,
            "area": "",
            "ech": 1
        },
        {
            "id": 7144,
            "name": "Taleggio",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "L037",
            "cod_istat": "016210",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 758,
            "giorni": 3146,
            "area": "",
            "ech": 0
        },
        {
            "id": 7145,
            "name": "Talla",
            "provincia": "AR",
            "cap": "52010",
            "cod_catastale": "L038",
            "cod_istat": "051038",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 348,
            "giorni": 2168,
            "area": "",
            "ech": 0
        },
        {
            "id": 7146,
            "name": "Talmassons",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "L039",
            "cod_istat": "030114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2304,
            "area": "",
            "ech": 0
        },
        {
            "id": 7147,
            "name": "Tambre",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "L040",
            "cod_istat": "025060",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 922,
            "giorni": 3898,
            "area": "",
            "ech": 0
        },
        {
            "id": 7148,
            "name": "Taormina",
            "provincia": "ME",
            "cap": "98039",
            "cod_catastale": "L042",
            "cod_istat": "083097",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 735,
            "area": "",
            "ech": 1
        },
        {
            "id": 7149,
            "name": "Tarano",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "L046",
            "cod_istat": "057067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 1879,
            "area": "",
            "ech": 0
        },
        {
            "id": 7150,
            "name": "Taranta Peligna",
            "provincia": "CH",
            "cap": "66018",
            "cod_catastale": "L047",
            "cod_istat": "069089",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 460,
            "giorni": 1886,
            "area": "",
            "ech": 0
        },
        {
            "id": 7151,
            "name": "Tarantasca",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "L048",
            "cod_istat": "004225",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 451,
            "giorni": 2874,
            "area": "",
            "ech": 0
        },
        {
            "id": 7152,
            "name": "Taranto",
            "provincia": "TA",
            "cap": "741xx",
            "cod_catastale": "L049",
            "cod_istat": "073027",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 15,
            "giorni": 1071,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7153,
            "name": "Tarcento",
            "provincia": "UD",
            "cap": "33017",
            "cod_catastale": "L050",
            "cod_istat": "030116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2702,
            "area": "",
            "ech": 0
        },
        {
            "id": 7154,
            "name": "Tarquinia",
            "provincia": "VT",
            "cap": "01016",
            "cod_catastale": "D024",
            "cod_istat": "056050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 133,
            "giorni": 1658,
            "area": "",
            "ech": 0
        },
        {
            "id": 7155,
            "name": "Tarsia",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "L055",
            "cod_istat": "078145",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 1201,
            "area": "",
            "ech": 0
        },
        {
            "id": 7156,
            "name": "Tartano",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "L056",
            "cod_istat": "014064",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 3788,
            "area": "",
            "ech": 0
        },
        {
            "id": 7157,
            "name": "Tarvisio",
            "provincia": "UD",
            "cap": "33018",
            "cod_catastale": "L057",
            "cod_istat": "030117",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 732,
            "giorni": 3959,
            "area": "",
            "ech": 0
        },
        {
            "id": 7158,
            "name": "Tarzo",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "L058",
            "cod_istat": "026084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 2828,
            "area": "",
            "ech": 0
        },
        {
            "id": 7159,
            "name": "Tassarolo",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "L059",
            "cod_istat": "006170",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2692,
            "area": "",
            "ech": 0
        },
        {
            "id": 7160,
            "name": "Tassullo",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "L060",
            "cod_istat": "022187",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 546,
            "giorni": 3243,
            "area": "",
            "ech": 0
        },
        {
            "id": 7161,
            "name": "Taurano",
            "provincia": "AV",
            "cap": "83020",
            "cod_catastale": "L061",
            "cod_istat": "064106",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1537,
            "area": "",
            "ech": 0
        },
        {
            "id": 7162,
            "name": "Taurasi",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "L062",
            "cod_istat": "064107",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 398,
            "giorni": 1933,
            "area": "",
            "ech": 0
        },
        {
            "id": 7163,
            "name": "Taurianova",
            "provincia": "RC",
            "cap": "89029",
            "cod_catastale": "L063",
            "cod_istat": "080093",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1093,
            "area": "",
            "ech": 1
        },
        {
            "id": 7164,
            "name": "Taurisano",
            "provincia": "LE",
            "cap": "73056",
            "cod_catastale": "L064",
            "cod_istat": "075084",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 110,
            "giorni": 1340,
            "area": "",
            "ech": 0
        },
        {
            "id": 7165,
            "name": "Tavagnacco",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "L065",
            "cod_istat": "030118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 132,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 7166,
            "name": "Tavagnasco",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "L066",
            "cod_istat": "001271",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2763,
            "area": "",
            "ech": 0
        },
        {
            "id": 7167,
            "name": "Tavarnelle Val di Pesa",
            "provincia": "FI",
            "cap": "50028",
            "cod_catastale": "L067",
            "cod_istat": "048045",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 378,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 7168,
            "name": "Tavazzano con Villavesco",
            "provincia": "LO",
            "cap": "26838",
            "cod_catastale": "F260",
            "cod_istat": "098056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 7169,
            "name": "Tavenna",
            "provincia": "CB",
            "cap": "86030",
            "cod_catastale": "L069",
            "cod_istat": "070077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 1919,
            "area": "",
            "ech": 0
        },
        {
            "id": 7170,
            "name": "Taverna",
            "provincia": "CZ",
            "cap": "88055",
            "cod_catastale": "L070",
            "cod_istat": "079146",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 521,
            "giorni": 1843,
            "area": "",
            "ech": 0
        },
        {
            "id": 7171,
            "name": "Tavernerio",
            "provincia": "CO",
            "cap": "22038",
            "cod_catastale": "L071",
            "cod_istat": "013222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 7172,
            "name": "Tavernola Bergamasca",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L073",
            "cod_istat": "016211",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 7173,
            "name": "Tavernole sul Mella",
            "provincia": "BS",
            "cap": "25060",
            "cod_catastale": "C698",
            "cod_istat": "017183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 475,
            "giorni": 2883,
            "area": "",
            "ech": 0
        },
        {
            "id": 7174,
            "name": "Taviano",
            "provincia": "LE",
            "cap": "73057",
            "cod_catastale": "L074",
            "cod_istat": "075085",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 58,
            "giorni": 1099,
            "area": "",
            "ech": 0
        },
        {
            "id": 7175,
            "name": "Tavigliano",
            "provincia": "BI",
            "cap": "13811",
            "cod_catastale": "L075",
            "cod_istat": "096066",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 659,
            "giorni": 3161,
            "area": "",
            "ech": 0
        },
        {
            "id": 7176,
            "name": "Tavoleto",
            "provincia": "PU",
            "cap": "61020",
            "cod_catastale": "L078",
            "cod_istat": "041064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 426,
            "giorni": 2333,
            "area": "",
            "ech": 0
        },
        {
            "id": 7177,
            "name": "Tavullia",
            "provincia": "PU",
            "cap": "61010",
            "cod_catastale": "L081",
            "cod_istat": "041065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2209,
            "area": "",
            "ech": 0
        },
        {
            "id": 7178,
            "name": "Teana",
            "provincia": "PZ",
            "cap": "85032",
            "cod_catastale": "L082",
            "cod_istat": "076087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 806,
            "giorni": 2248,
            "area": "",
            "ech": 0
        },
        {
            "id": 7179,
            "name": "Teano",
            "provincia": "CE",
            "cap": "81057",
            "cod_catastale": "L083",
            "cod_istat": "061091",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 168,
            "giorni": 1440,
            "area": "",
            "ech": 0
        },
        {
            "id": 7180,
            "name": "Teggiano",
            "provincia": "SA",
            "cap": "84039",
            "cod_catastale": "D292",
            "cod_istat": "065146",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 635,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 7181,
            "name": "Teglio",
            "provincia": "SO",
            "cap": "23036",
            "cod_catastale": "L084",
            "cod_istat": "014065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 851,
            "giorni": 3278,
            "area": "",
            "ech": 0
        },
        {
            "id": 7182,
            "name": "Teglio Veneto",
            "provincia": "VE",
            "cap": "30025",
            "cod_catastale": "L085",
            "cod_istat": "027040",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 7183,
            "name": "Telese Terme",
            "provincia": "BN",
            "cap": "82037",
            "cod_catastale": "L086",
            "cod_istat": "062074",
            "attivo": 1,
            "zona": null,
            "cassa": 1,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7184,
            "name": "Telgate",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L087",
            "cod_istat": "016212",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 191,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7185,
            "name": "Telti",
            "provincia": "SS",
            "cap": "07020",
            "cod_catastale": "L088",
            "cod_istat": "090080",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 1535,
            "area": "",
            "ech": 0
        },
        {
            "id": 7186,
            "name": "Telve",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "L089",
            "cod_istat": "022188",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 3249,
            "area": "",
            "ech": 0
        },
        {
            "id": 7187,
            "name": "Telve di Sopra",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "L090",
            "cod_istat": "022189",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 3405,
            "area": "",
            "ech": 0
        },
        {
            "id": 7188,
            "name": "Tempio Pausania",
            "provincia": "SS",
            "cap": "07029",
            "cod_catastale": "L093",
            "cod_istat": "090070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 566,
            "giorni": 2034,
            "area": "",
            "ech": 0
        },
        {
            "id": 7189,
            "name": "Temù",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "L094",
            "cod_istat": "017184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1144,
            "giorni": 3861,
            "area": "",
            "ech": 0
        },
        {
            "id": 7190,
            "name": "Tenna",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "L096",
            "cod_istat": "022190",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 569,
            "giorni": 3173,
            "area": "",
            "ech": 0
        },
        {
            "id": 7191,
            "name": "Tenno",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "L097",
            "cod_istat": "022191",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 3058,
            "area": "",
            "ech": 0
        },
        {
            "id": 7192,
            "name": "Teolo",
            "provincia": "PD",
            "cap": "35037",
            "cod_catastale": "L100",
            "cod_istat": "028089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7193,
            "name": "Teor",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "L101",
            "cod_istat": "030119",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 7194,
            "name": "Teora",
            "provincia": "AV",
            "cap": "83056",
            "cod_catastale": "L102",
            "cod_istat": "064108",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 660,
            "giorni": 2248,
            "area": "",
            "ech": 0
        },
        {
            "id": 7195,
            "name": "Teramo",
            "provincia": "TE",
            "cap": "64100",
            "cod_catastale": "L103",
            "cod_istat": "067041",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 432,
            "giorni": 1834,
            "area": "",
            "ech": 0
        },
        {
            "id": 7196,
            "name": "Terdobbiate",
            "provincia": "NO",
            "cap": "28070",
            "cod_catastale": "L104",
            "cod_istat": "003144",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 7197,
            "name": "Terelle",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "L105",
            "cod_istat": "060077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 905,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 7198,
            "name": "Terento",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "L106",
            "cod_istat": "021096",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1210,
            "giorni": 4413,
            "area": "",
            "ech": 0
        },
        {
            "id": 7199,
            "name": "Terenzo",
            "provincia": "PR",
            "cap": "43040",
            "cod_catastale": "E548",
            "cod_istat": "034038",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 541,
            "giorni": 3150,
            "area": "",
            "ech": 0
        },
        {
            "id": 7200,
            "name": "Tergu",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M282",
            "cod_istat": "090086",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 1452,
            "area": "",
            "ech": 0
        },
        {
            "id": 7201,
            "name": "Terlago",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "L107",
            "cod_istat": "022192",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 456,
            "giorni": 3102,
            "area": "",
            "ech": 0
        },
        {
            "id": 7202,
            "name": "Terlano",
            "provincia": "BZ",
            "cap": "39018",
            "cod_catastale": "L108",
            "cod_istat": "021097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 248,
            "giorni": 2771,
            "area": "",
            "ech": 0
        },
        {
            "id": 7203,
            "name": "Terlizzi",
            "provincia": "BA",
            "cap": "70038",
            "cod_catastale": "L109",
            "cod_istat": "072043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 1454,
            "area": "",
            "ech": 0
        },
        {
            "id": 7204,
            "name": "Terme Vigliatore",
            "provincia": "ME",
            "cap": "98050",
            "cod_catastale": "M210",
            "cod_istat": "083106",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 667,
            "area": "",
            "ech": 0
        },
        {
            "id": 7205,
            "name": "Termeno sulla strada del vino",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "L111",
            "cod_istat": "021098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2846,
            "area": "",
            "ech": 0
        },
        {
            "id": 7206,
            "name": "Termini Imerese",
            "provincia": "PA",
            "cap": "90018",
            "cod_catastale": "L112",
            "cod_istat": "082070",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 864,
            "area": "",
            "ech": 1
        },
        {
            "id": 7207,
            "name": "Termoli",
            "provincia": "CB",
            "cap": "86039",
            "cod_catastale": "L113",
            "cod_istat": "070078",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 1350,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7208,
            "name": "Ternate",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "L115",
            "cod_istat": "012126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2513,
            "area": "",
            "ech": 0
        },
        {
            "id": 7209,
            "name": "Ternengo",
            "provincia": "BI",
            "cap": "13844",
            "cod_catastale": "L116",
            "cod_istat": "096067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 425,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 7210,
            "name": "Terni",
            "provincia": "TR",
            "cap": "05100",
            "cod_catastale": "L117",
            "cod_istat": "055032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1650,
            "area": "",
            "ech": 0
        },
        {
            "id": 7211,
            "name": "Terno d'Isola",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "L118",
            "cod_istat": "016213",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 229,
            "giorni": 2505,
            "area": "",
            "ech": 0
        },
        {
            "id": 7212,
            "name": "Terracina",
            "provincia": "LT",
            "cap": "04019",
            "cod_catastale": "L120",
            "cod_istat": "059032",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 996,
            "area": "",
            "ech": 0
        },
        {
            "id": 7213,
            "name": "Terragnolo",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "L121",
            "cod_istat": "022193",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 785,
            "giorni": 3615,
            "area": "",
            "ech": 0
        },
        {
            "id": 7214,
            "name": "Terralba",
            "provincia": "OR",
            "cap": "09098",
            "cod_catastale": "L122",
            "cod_istat": "095065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 988,
            "area": "",
            "ech": 0
        },
        {
            "id": 7215,
            "name": "Terranova da Sibari",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "L124",
            "cod_istat": "078146",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 313,
            "giorni": 1449,
            "area": "",
            "ech": 0
        },
        {
            "id": 7216,
            "name": "Terranova dei Passerini",
            "provincia": "LO",
            "cap": "26827",
            "cod_catastale": "L125",
            "cod_istat": "098057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 63,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 7217,
            "name": "Terranova di Pollino",
            "provincia": "PZ",
            "cap": "85030",
            "cod_catastale": "L126",
            "cod_istat": "076088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 926,
            "giorni": 2593,
            "area": "",
            "ech": 0
        },
        {
            "id": 7218,
            "name": "Terranova Sappo Minulio",
            "provincia": "RC",
            "cap": "89010",
            "cod_catastale": "L127",
            "cod_istat": "080094",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1022,
            "area": "",
            "ech": 0
        },
        {
            "id": 7219,
            "name": "Terranuova Bracciolini",
            "provincia": "AR",
            "cap": "52028",
            "cod_catastale": "L123",
            "cod_istat": "051039",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 1971,
            "area": "",
            "ech": 0
        },
        {
            "id": 7220,
            "name": "Terrasini",
            "provincia": "PA",
            "cap": "90049",
            "cod_catastale": "L131",
            "cod_istat": "082071",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 720,
            "area": "",
            "ech": 1
        },
        {
            "id": 7221,
            "name": "Terrassa Padovana",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "L132",
            "cod_istat": "028090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7222,
            "name": "Terravecchia",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "L134",
            "cod_istat": "078147",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 1751,
            "area": "",
            "ech": 1
        },
        {
            "id": 7223,
            "name": "Terrazzo",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "L136",
            "cod_istat": "023085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2317,
            "area": "",
            "ech": 0
        },
        {
            "id": 7224,
            "name": "Terres",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "L137",
            "cod_istat": "022194",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 593,
            "giorni": 3164,
            "area": "",
            "ech": 0
        },
        {
            "id": 7225,
            "name": "Terricciola",
            "provincia": "PI",
            "cap": "56030",
            "cod_catastale": "L138",
            "cod_istat": "050036",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 1819,
            "area": "",
            "ech": 0
        },
        {
            "id": 7226,
            "name": "Terruggia",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "L139",
            "cod_istat": "006171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 7227,
            "name": "Tertenia",
            "provincia": "NU",
            "cap": "08047",
            "cod_catastale": "L140",
            "cod_istat": "091089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 1201,
            "area": "",
            "ech": 1
        },
        {
            "id": 7228,
            "name": "Terzigno",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "L142",
            "cod_istat": "063082",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1307,
            "area": "",
            "ech": 0
        },
        {
            "id": 7229,
            "name": "Terzo",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "L143",
            "cod_istat": "006172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 2669,
            "area": "",
            "ech": 0
        },
        {
            "id": 7230,
            "name": "Terzo d'Aquileia",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "L144",
            "cod_istat": "030120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 2244,
            "area": "",
            "ech": 0
        },
        {
            "id": 7231,
            "name": "Terzolas",
            "provincia": "TN",
            "cap": "38027",
            "cod_catastale": "L145",
            "cod_istat": "022195",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 755,
            "giorni": 3569,
            "area": "",
            "ech": 0
        },
        {
            "id": 7232,
            "name": "Terzorio",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "L146",
            "cod_istat": "008060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 185,
            "giorni": 1564,
            "area": "",
            "ech": 0
        },
        {
            "id": 7233,
            "name": "Tesero",
            "provincia": "TN",
            "cap": "38038",
            "cod_catastale": "L147",
            "cod_istat": "022196",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1000,
            "giorni": 4028,
            "area": "",
            "ech": 0
        },
        {
            "id": 7234,
            "name": "Tesimo",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "L149",
            "cod_istat": "021099",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 635,
            "giorni": 3375,
            "area": "",
            "ech": 0
        },
        {
            "id": 7235,
            "name": "Tessennano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "L150",
            "cod_istat": "056051",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 302,
            "giorni": 1957,
            "area": "",
            "ech": 0
        },
        {
            "id": 7236,
            "name": "Testico",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "L152",
            "cod_istat": "009060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 2414,
            "area": "",
            "ech": 0
        },
        {
            "id": 7237,
            "name": "Teti",
            "provincia": "NU",
            "cap": "08030",
            "cod_catastale": "L153",
            "cod_istat": "091090",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 714,
            "giorni": 1950,
            "area": "",
            "ech": 0
        },
        {
            "id": 7238,
            "name": "Teulada",
            "provincia": "SU",
            "cap": "09019",
            "cod_catastale": "L154",
            "cod_istat": "111089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 913,
            "area": "",
            "ech": 0
        },
        {
            "id": 7239,
            "name": "Teverola",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "L155",
            "cod_istat": "061092",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1091,
            "area": "",
            "ech": 0
        },
        {
            "id": 7240,
            "name": "Tezze sul Brenta",
            "provincia": "VI",
            "cap": "36056",
            "cod_catastale": "L156",
            "cod_istat": "024104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2351,
            "area": "",
            "ech": 0
        },
        {
            "id": 7241,
            "name": "Thiene",
            "provincia": "VI",
            "cap": "36016",
            "cod_catastale": "L157",
            "cod_istat": "024105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2429,
            "area": "",
            "ech": 0
        },
        {
            "id": 7242,
            "name": "Thiesi",
            "provincia": "SS",
            "cap": "07047",
            "cod_catastale": "L158",
            "cod_istat": "090071",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 461,
            "giorni": 1792,
            "area": "",
            "ech": 0
        },
        {
            "id": 7243,
            "name": "Tiana",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "L160",
            "cod_istat": "091091",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 564,
            "giorni": 1672,
            "area": "",
            "ech": 0
        },
        {
            "id": 7244,
            "name": "Ticengo",
            "provincia": "CR",
            "cap": "26020",
            "cod_catastale": "L164",
            "cod_istat": "019104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 76,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7245,
            "name": "Ticineto",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "L165",
            "cod_istat": "006173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 102,
            "giorni": 2803,
            "area": "",
            "ech": 0
        },
        {
            "id": 7246,
            "name": "Tiggiano",
            "provincia": "LE",
            "cap": "73030",
            "cod_catastale": "L166",
            "cod_istat": "075086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 1221,
            "area": "",
            "ech": 0
        },
        {
            "id": 7247,
            "name": "Tiglieto",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "L167",
            "cod_istat": "010061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7248,
            "name": "Tigliole",
            "provincia": "AT",
            "cap": "14016",
            "cod_catastale": "L168",
            "cod_istat": "005108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 2714,
            "area": "",
            "ech": 0
        },
        {
            "id": 7249,
            "name": "Tignale",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "L169",
            "cod_istat": "017185",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 555,
            "giorni": 3003,
            "area": "",
            "ech": 0
        },
        {
            "id": 7250,
            "name": "Tinnura",
            "provincia": "OR",
            "cap": "08010",
            "cod_catastale": "L172",
            "cod_istat": "095088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 328,
            "giorni": 1298,
            "area": "",
            "ech": 0
        },
        {
            "id": 7251,
            "name": "Tione degli Abruzzi",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "L173",
            "cod_istat": "066100",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 581,
            "giorni": 2328,
            "area": "",
            "ech": 0
        },
        {
            "id": 7252,
            "name": "Tione di Trento",
            "provincia": "TN",
            "cap": "38079",
            "cod_catastale": "L174",
            "cod_istat": "022199",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 565,
            "giorni": 3272,
            "area": "",
            "ech": 0
        },
        {
            "id": 7253,
            "name": "Tirano",
            "provincia": "SO",
            "cap": "23037",
            "cod_catastale": "L175",
            "cod_istat": "014066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 441,
            "giorni": 2696,
            "area": "",
            "ech": 0
        },
        {
            "id": 7254,
            "name": "Tires",
            "provincia": "BZ",
            "cap": "39050",
            "cod_catastale": "L176",
            "cod_istat": "021100",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1028,
            "giorni": 4050,
            "area": "",
            "ech": 0
        },
        {
            "id": 7255,
            "name": "Tiriolo",
            "provincia": "CZ",
            "cap": "88056",
            "cod_catastale": "L177",
            "cod_istat": "079147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 690,
            "giorni": 2160,
            "area": "",
            "ech": 0
        },
        {
            "id": 7256,
            "name": "Tirolo",
            "provincia": "BZ",
            "cap": "39019",
            "cod_catastale": "L178",
            "cod_istat": "021101",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 594,
            "giorni": 3307,
            "area": "",
            "ech": 0
        },
        {
            "id": 7257,
            "name": "Tissi",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "L180",
            "cod_istat": "090072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 1232,
            "area": "",
            "ech": 0
        },
        {
            "id": 7258,
            "name": "Tito",
            "provincia": "PZ",
            "cap": "85050",
            "cod_catastale": "L181",
            "cod_istat": "076089",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 7259,
            "name": "Tivoli",
            "provincia": "RM",
            "cap": "00019",
            "cod_catastale": "L182",
            "cod_istat": "058104",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 1580,
            "area": "",
            "ech": 0
        },
        {
            "id": 7260,
            "name": "Tizzano Val Parma",
            "provincia": "PR",
            "cap": "43028",
            "cod_catastale": "L183",
            "cod_istat": "034039",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 814,
            "giorni": 3499,
            "area": "",
            "ech": 0
        },
        {
            "id": 7261,
            "name": "Toano",
            "provincia": "RE",
            "cap": "42010",
            "cod_catastale": "L184",
            "cod_istat": "035041",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 842,
            "giorni": 3388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7262,
            "name": "Tocco Caudio",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "L185",
            "cod_istat": "062075",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 500,
            "giorni": 1980,
            "area": "",
            "ech": 0
        },
        {
            "id": 7263,
            "name": "Tocco da Casauria",
            "provincia": "PE",
            "cap": "65028",
            "cod_catastale": "L186",
            "cod_istat": "068042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 1807,
            "area": "",
            "ech": 0
        },
        {
            "id": 7264,
            "name": "Toceno",
            "provincia": "VB",
            "cap": "28858",
            "cod_catastale": "L187",
            "cod_istat": "103065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 907,
            "giorni": 3484,
            "area": "",
            "ech": 0
        },
        {
            "id": 7265,
            "name": "Todi",
            "provincia": "PG",
            "cap": "06059",
            "cod_catastale": "L188",
            "cod_istat": "054052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2193,
            "area": "",
            "ech": 0
        },
        {
            "id": 7266,
            "name": "Toffia",
            "provincia": "RI",
            "cap": "02039",
            "cod_catastale": "L189",
            "cod_istat": "057068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 1830,
            "area": "",
            "ech": 0
        },
        {
            "id": 7267,
            "name": "Toirano",
            "provincia": "SV",
            "cap": "17055",
            "cod_catastale": "L190",
            "cod_istat": "009061",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1333,
            "area": "",
            "ech": 0
        },
        {
            "id": 7268,
            "name": "Tolentino",
            "provincia": "MC",
            "cap": "62029",
            "cod_catastale": "L191",
            "cod_istat": "043053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 228,
            "giorni": 1906,
            "area": "",
            "ech": 0
        },
        {
            "id": 7269,
            "name": "Tolfa",
            "provincia": "RM",
            "cap": "00059",
            "cod_catastale": "L192",
            "cod_istat": "058105",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 484,
            "giorni": 2070,
            "area": "",
            "ech": 0
        },
        {
            "id": 7270,
            "name": "Tollegno",
            "provincia": "BI",
            "cap": "13818",
            "cod_catastale": "L193",
            "cod_istat": "096068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 495,
            "giorni": 2687,
            "area": "",
            "ech": 0
        },
        {
            "id": 7271,
            "name": "Tollo",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "L194",
            "cod_istat": "069090",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 1424,
            "area": "",
            "ech": 0
        },
        {
            "id": 7272,
            "name": "Tolmezzo",
            "provincia": "UD",
            "cap": "33028",
            "cod_catastale": "L195",
            "cod_istat": "030121",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 323,
            "giorni": 3036,
            "area": "",
            "ech": 0
        },
        {
            "id": 7273,
            "name": "Tolve",
            "provincia": "PZ",
            "cap": "85017",
            "cod_catastale": "L197",
            "cod_istat": "076090",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 568,
            "giorni": 1945,
            "area": "",
            "ech": 0
        },
        {
            "id": 7274,
            "name": "Tombolo",
            "provincia": "PD",
            "cap": "35019",
            "cod_catastale": "L199",
            "cod_istat": "028091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 7275,
            "name": "Ton",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "L200",
            "cod_istat": "022200",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 3143,
            "area": "",
            "ech": 0
        },
        {
            "id": 7276,
            "name": "Tonadico",
            "provincia": "TN",
            "cap": "38054",
            "cod_catastale": "L201",
            "cod_istat": "022201",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 750,
            "giorni": 3561,
            "area": "",
            "ech": 0
        },
        {
            "id": 7277,
            "name": "Tonara",
            "provincia": "NU",
            "cap": "08039",
            "cod_catastale": "L202",
            "cod_istat": "091093",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 900,
            "giorni": 2259,
            "area": "",
            "ech": 0
        },
        {
            "id": 7278,
            "name": "Tonco",
            "provincia": "AT",
            "cap": "14039",
            "cod_catastale": "L203",
            "cod_istat": "005109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2710,
            "area": "",
            "ech": 0
        },
        {
            "id": 7279,
            "name": "Tonengo",
            "provincia": "AT",
            "cap": "14023",
            "cod_catastale": "L204",
            "cod_istat": "005110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2843,
            "area": "",
            "ech": 0
        },
        {
            "id": 7280,
            "name": "Tonezza del Cimone",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "D717",
            "cod_istat": "024106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 991,
            "giorni": 4367,
            "area": "",
            "ech": 0
        },
        {
            "id": 7281,
            "name": "Tora e Piccilli",
            "provincia": "CE",
            "cap": "81044",
            "cod_catastale": "L205",
            "cod_istat": "061093",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 343,
            "giorni": 1736,
            "area": "",
            "ech": 0
        },
        {
            "id": 7282,
            "name": "Torano Castello",
            "provincia": "CS",
            "cap": "87010",
            "cod_catastale": "L206",
            "cod_istat": "078148",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 370,
            "giorni": 1622,
            "area": "",
            "ech": 0
        },
        {
            "id": 7283,
            "name": "Torano Nuovo",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "L207",
            "cod_istat": "067042",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 237,
            "giorni": 1621,
            "area": "",
            "ech": 0
        },
        {
            "id": 7284,
            "name": "Torbole Casaglia",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "L210",
            "cod_istat": "017186",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 120,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7285,
            "name": "Torcegno",
            "provincia": "TN",
            "cap": "38050",
            "cod_catastale": "L211",
            "cod_istat": "022202",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 769,
            "giorni": 3590,
            "area": "",
            "ech": 0
        },
        {
            "id": 7286,
            "name": "Torchiara",
            "provincia": "SA",
            "cap": "84076",
            "cod_catastale": "L212",
            "cod_istat": "065147",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 360,
            "giorni": 1587,
            "area": "",
            "ech": 0
        },
        {
            "id": 7287,
            "name": "Torchiarolo",
            "provincia": "BR",
            "cap": "72020",
            "cod_catastale": "L213",
            "cod_istat": "074018",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1110,
            "area": "",
            "ech": 0
        },
        {
            "id": 7288,
            "name": "Torella dei Lombardi",
            "provincia": "AV",
            "cap": "83057",
            "cod_catastale": "L214",
            "cod_istat": "064109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 666,
            "giorni": 2255,
            "area": "",
            "ech": 0
        },
        {
            "id": 7289,
            "name": "Torella del Sannio",
            "provincia": "CB",
            "cap": "86028",
            "cod_catastale": "L215",
            "cod_istat": "070079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 837,
            "giorni": 2469,
            "area": "",
            "ech": 0
        },
        {
            "id": 7290,
            "name": "Torgiano",
            "provincia": "PG",
            "cap": "06089",
            "cod_catastale": "L216",
            "cod_istat": "054053",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2014,
            "area": "",
            "ech": 0
        },
        {
            "id": 7291,
            "name": "Torgnon",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "L217",
            "cod_istat": "007067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1489,
            "giorni": 4466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7292,
            "name": "Torino",
            "provincia": "TO",
            "cap": "101xx",
            "cod_catastale": "L219",
            "cod_istat": "001272",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 7293,
            "name": "Torino di Sangro",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "L218",
            "cod_istat": "069091",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 164,
            "giorni": 1442,
            "area": "",
            "ech": 0
        },
        {
            "id": 7294,
            "name": "Toritto",
            "provincia": "BA",
            "cap": "70020",
            "cod_catastale": "L220",
            "cod_istat": "072044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 233,
            "giorni": 1516,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7295,
            "name": "Torlino Vimercati",
            "provincia": "CR",
            "cap": "26017",
            "cod_catastale": "L221",
            "cod_istat": "019105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7296,
            "name": "Tornaco",
            "provincia": "NO",
            "cap": "28070",
            "cod_catastale": "L223",
            "cod_istat": "003146",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2463,
            "area": "",
            "ech": 0
        },
        {
            "id": 7297,
            "name": "Tornareccio",
            "provincia": "CH",
            "cap": "66046",
            "cod_catastale": "L224",
            "cod_istat": "069092",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 630,
            "giorni": 2141,
            "area": "",
            "ech": 0
        },
        {
            "id": 7298,
            "name": "Tornata",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "L225",
            "cod_istat": "019106",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7299,
            "name": "Tornimparte",
            "provincia": "AQ",
            "cap": "67049",
            "cod_catastale": "L227",
            "cod_istat": "066101",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 830,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 7300,
            "name": "Torno",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "L228",
            "cod_istat": "013223",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2262,
            "area": "",
            "ech": 0
        },
        {
            "id": 7301,
            "name": "Tornolo",
            "provincia": "PR",
            "cap": "43059",
            "cod_catastale": "L229",
            "cod_istat": "034040",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 3251,
            "area": "",
            "ech": 0
        },
        {
            "id": 7302,
            "name": "Toro",
            "provincia": "CB",
            "cap": "86018",
            "cod_catastale": "L230",
            "cod_istat": "070080",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 588,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 7303,
            "name": "Torpè",
            "provincia": "NU",
            "cap": "08020",
            "cod_catastale": "L231",
            "cod_istat": "091094",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 895,
            "area": "",
            "ech": 1
        },
        {
            "id": 7304,
            "name": "Torraca",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "L233",
            "cod_istat": "065148",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 425,
            "giorni": 1576,
            "area": "",
            "ech": 0
        },
        {
            "id": 7305,
            "name": "Torralba",
            "provincia": "SS",
            "cap": "07048",
            "cod_catastale": "L235",
            "cod_istat": "090073",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1743,
            "area": "",
            "ech": 0
        },
        {
            "id": 7306,
            "name": "Torrazza Coste",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "L237",
            "cod_istat": "018155",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 159,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 7307,
            "name": "Torrazza Piemonte",
            "provincia": "TO",
            "cap": "10037",
            "cod_catastale": "L238",
            "cod_istat": "001273",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 7308,
            "name": "Torrazzo",
            "provincia": "BI",
            "cap": "13884",
            "cod_catastale": "L239",
            "cod_istat": "096069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 622,
            "giorni": 3113,
            "area": "",
            "ech": 0
        },
        {
            "id": 7309,
            "name": "Torre Annunziata",
            "provincia": "NA",
            "cap": "80058",
            "cod_catastale": "L245",
            "cod_istat": "063083",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 1123,
            "area": "",
            "ech": 0
        },
        {
            "id": 7310,
            "name": "Torre Beretti e Castellaro",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "L250",
            "cod_istat": "018156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 89,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7311,
            "name": "Torre Boldone",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "L251",
            "cod_istat": "016214",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 280,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7312,
            "name": "Torre Bormida",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "L252",
            "cod_istat": "004226",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2800,
            "area": "",
            "ech": 0
        },
        {
            "id": 7313,
            "name": "Torre Cajetani",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "L243",
            "cod_istat": "060078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 819,
            "giorni": 2595,
            "area": "",
            "ech": 0
        },
        {
            "id": 7314,
            "name": "Torre Canavese",
            "provincia": "TO",
            "cap": "10010",
            "cod_catastale": "L247",
            "cod_istat": "001274",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 417,
            "giorni": 2979,
            "area": "",
            "ech": 0
        },
        {
            "id": 7315,
            "name": "Torre d'Arese",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "L256",
            "cod_istat": "018157",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7316,
            "name": "Torre de' Busi",
            "provincia": "BG",
            "cap": "23806",
            "cod_catastale": "L257",
            "cod_istat": "016215",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 2698,
            "area": "",
            "ech": 0
        },
        {
            "id": 7317,
            "name": "Torre de' Negri",
            "provincia": "PV",
            "cap": "27011",
            "cod_catastale": "L262",
            "cod_istat": "018158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7318,
            "name": "Torre de' Passeri",
            "provincia": "PE",
            "cap": "65029",
            "cod_catastale": "L263",
            "cod_istat": "068043",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 1530,
            "area": "",
            "ech": 0
        },
        {
            "id": 7319,
            "name": "Torre de' Picenardi",
            "provincia": "CR",
            "cap": "26038",
            "cod_catastale": "L258",
            "cod_istat": "019107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7320,
            "name": "Torre de' Roveri",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L265",
            "cod_istat": "016216",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 2564,
            "area": "",
            "ech": 0
        },
        {
            "id": 7321,
            "name": "Torre del Greco",
            "provincia": "NA",
            "cap": "80059",
            "cod_catastale": "L259",
            "cod_istat": "063084",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 1051,
            "area": "",
            "ech": 0
        },
        {
            "id": 7322,
            "name": "Torre di Mosto",
            "provincia": "VE",
            "cap": "30020",
            "cod_catastale": "L267",
            "cod_istat": "027041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2649,
            "area": "",
            "ech": 0
        },
        {
            "id": 7323,
            "name": "Torre di Ruggiero",
            "provincia": "CZ",
            "cap": "88060",
            "cod_catastale": "L240",
            "cod_istat": "079148",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 566,
            "giorni": 1849,
            "area": "",
            "ech": 0
        },
        {
            "id": 7324,
            "name": "Torre di Santa Maria",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "L244",
            "cod_istat": "014067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 772,
            "giorni": 3166,
            "area": "",
            "ech": 0
        },
        {
            "id": 7325,
            "name": "Torre d'Isola",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L269",
            "cod_istat": "018159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7326,
            "name": "Torre Le Nocelle",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "L272",
            "cod_istat": "064110",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1803,
            "area": "",
            "ech": 0
        },
        {
            "id": 7327,
            "name": "Torre Mondovì",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "L241",
            "cod_istat": "004227",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2885,
            "area": "",
            "ech": 0
        },
        {
            "id": 7328,
            "name": "Torre Orsaia",
            "provincia": "SA",
            "cap": "84077",
            "cod_catastale": "L274",
            "cod_istat": "065149",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 295,
            "giorni": 1300,
            "area": "",
            "ech": 0
        },
        {
            "id": 7329,
            "name": "Torre Pallavicina",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "L276",
            "cod_istat": "016217",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 7330,
            "name": "Torre Pellice",
            "provincia": "TO",
            "cap": "10066",
            "cod_catastale": "L277",
            "cod_istat": "001275",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 516,
            "giorni": 3128,
            "area": "",
            "ech": 0
        },
        {
            "id": 7331,
            "name": "Torre San Giorgio",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "L278",
            "cod_istat": "004228",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 2640,
            "area": "",
            "ech": 0
        },
        {
            "id": 7332,
            "name": "Torre San Patrizio",
            "provincia": "FM",
            "cap": "63814",
            "cod_catastale": "L279",
            "cod_istat": "109040",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 224,
            "giorni": 1988,
            "area": "",
            "ech": 0
        },
        {
            "id": 7333,
            "name": "Torre Santa Susanna",
            "provincia": "BR",
            "cap": "72028",
            "cod_catastale": "L280",
            "cod_istat": "074019",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 1176,
            "area": "",
            "ech": 0
        },
        {
            "id": 7334,
            "name": "Torreano",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "L246",
            "cod_istat": "030122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 7335,
            "name": "Torrebelvicino",
            "provincia": "VI",
            "cap": "36036",
            "cod_catastale": "L248",
            "cod_istat": "024107",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2666,
            "area": "",
            "ech": 0
        },
        {
            "id": 7336,
            "name": "Torrebruna",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "L253",
            "cod_istat": "069093",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 845,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 7337,
            "name": "Torrecuso",
            "provincia": "BN",
            "cap": "82030",
            "cod_catastale": "L254",
            "cod_istat": "062076",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 1835,
            "area": "",
            "ech": 0
        },
        {
            "id": 7338,
            "name": "Torreglia",
            "provincia": "PD",
            "cap": "35038",
            "cod_catastale": "L270",
            "cod_istat": "028092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7339,
            "name": "Torregrotta",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "L271",
            "cod_istat": "083098",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 44,
            "giorni": 702,
            "area": "",
            "ech": 0
        },
        {
            "id": 7340,
            "name": "Torremaggiore",
            "provincia": "FG",
            "cap": "71017",
            "cod_catastale": "L273",
            "cod_istat": "071056",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 1549,
            "area": "",
            "ech": 0
        },
        {
            "id": 7341,
            "name": "Torrenova",
            "provincia": "ME",
            "cap": "98070",
            "cod_catastale": "M286",
            "cod_istat": "083108",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 654,
            "area": "",
            "ech": 0
        },
        {
            "id": 7342,
            "name": "Torresina",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "L281",
            "cod_istat": "004229",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 704,
            "giorni": 3188,
            "area": "",
            "ech": 0
        },
        {
            "id": 7343,
            "name": "Torretta",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "L282",
            "cod_istat": "082072",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1056,
            "area": "",
            "ech": 1
        },
        {
            "id": 7344,
            "name": "Torrevecchia Pia",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "L285",
            "cod_istat": "018160",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7345,
            "name": "Torrevecchia Teatina",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "L284",
            "cod_istat": "069094",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1526,
            "area": "",
            "ech": 0
        },
        {
            "id": 7346,
            "name": "Torri del Benaco",
            "provincia": "VR",
            "cap": "37010",
            "cod_catastale": "L287",
            "cod_istat": "023086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 67,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 7347,
            "name": "Torri di Quartesolo",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "L297",
            "cod_istat": "024108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2357,
            "area": "",
            "ech": 0
        },
        {
            "id": 7348,
            "name": "Torri in Sabina",
            "provincia": "RI",
            "cap": "02049",
            "cod_catastale": "L286",
            "cod_istat": "057070",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 1954,
            "area": "",
            "ech": 0
        },
        {
            "id": 7349,
            "name": "Torriana",
            "provincia": "RN",
            "cap": "47825",
            "cod_catastale": "I550",
            "cod_istat": "099019",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 2588,
            "area": "",
            "ech": 0
        },
        {
            "id": 7350,
            "name": "Torrice",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "L290",
            "cod_istat": "060079",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1981,
            "area": "",
            "ech": 0
        },
        {
            "id": 7351,
            "name": "Torricella",
            "provincia": "TA",
            "cap": "74020",
            "cod_catastale": "L294",
            "cod_istat": "073028",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 1122,
            "area": "",
            "ech": 0
        },
        {
            "id": 7352,
            "name": "Torricella del Pizzo",
            "provincia": "CR",
            "cap": "26040",
            "cod_catastale": "L296",
            "cod_istat": "019108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7353,
            "name": "Torricella in Sabina",
            "provincia": "RI",
            "cap": "02030",
            "cod_catastale": "L293",
            "cod_istat": "057069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 7354,
            "name": "Torricella Peligna",
            "provincia": "CH",
            "cap": "66019",
            "cod_catastale": "L291",
            "cod_istat": "069095",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 910,
            "giorni": 2561,
            "area": "",
            "ech": 0
        },
        {
            "id": 7355,
            "name": "Torricella Sicura",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "L295",
            "cod_istat": "067043",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 437,
            "giorni": 2055,
            "area": "",
            "ech": 0
        },
        {
            "id": 7356,
            "name": "Torricella Verzate",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "L292",
            "cod_istat": "018161",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 160,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7357,
            "name": "Torriglia",
            "provincia": "GE",
            "cap": "16029",
            "cod_catastale": "L298",
            "cod_istat": "010062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 769,
            "giorni": 3387,
            "area": "",
            "ech": 0
        },
        {
            "id": 7358,
            "name": "Torrile",
            "provincia": "PR",
            "cap": "43056",
            "cod_catastale": "L299",
            "cod_istat": "034041",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 32,
            "giorni": 2469,
            "area": "",
            "ech": 0
        },
        {
            "id": 7359,
            "name": "Torrioni",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "L301",
            "cod_istat": "064111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 645,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 7360,
            "name": "Torrita di Siena",
            "provincia": "SI",
            "cap": "53049",
            "cod_catastale": "L303",
            "cod_istat": "052035",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 325,
            "giorni": 1899,
            "area": "CNOR",
            "ech": 0
        },
        {
            "id": 7361,
            "name": "Torrita Tiberina",
            "provincia": "RM",
            "cap": "00060",
            "cod_catastale": "L302",
            "cod_istat": "058106",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 179,
            "giorni": 1773,
            "area": "",
            "ech": 0
        },
        {
            "id": 7362,
            "name": "Tortolì",
            "provincia": "NU",
            "cap": "08048",
            "cod_catastale": "A355",
            "cod_istat": "091095",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 744,
            "area": "",
            "ech": 1
        },
        {
            "id": 7363,
            "name": "Tortona",
            "provincia": "AL",
            "cap": "15057",
            "cod_catastale": "L304",
            "cod_istat": "006174",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 122,
            "giorni": 2516,
            "area": "",
            "ech": 0
        },
        {
            "id": 7364,
            "name": "Tortora",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "L305",
            "cod_istat": "078149",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1325,
            "area": "",
            "ech": 0
        },
        {
            "id": 7365,
            "name": "Tortorella",
            "provincia": "SA",
            "cap": "84030",
            "cod_catastale": "L306",
            "cod_istat": "065150",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 582,
            "giorni": 1838,
            "area": "",
            "ech": 0
        },
        {
            "id": 7366,
            "name": "Tortoreto",
            "provincia": "TE",
            "cap": "64018",
            "cod_catastale": "L307",
            "cod_istat": "067044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 239,
            "giorni": 1625,
            "area": "",
            "ech": 0
        },
        {
            "id": 7367,
            "name": "Tortorici",
            "provincia": "ME",
            "cap": "98078",
            "cod_catastale": "L308",
            "cod_istat": "083099",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 468,
            "giorni": 1396,
            "area": "",
            "ech": 1
        },
        {
            "id": 7368,
            "name": "Torviscosa",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "L309",
            "cod_istat": "030123",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2395,
            "area": "",
            "ech": 0
        },
        {
            "id": 7369,
            "name": "Toscolano-Maderno",
            "provincia": "BS",
            "cap": "25088",
            "cod_catastale": "L312",
            "cod_istat": "017187",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2265,
            "area": "",
            "ech": 0
        },
        {
            "id": 7370,
            "name": "Tossicia",
            "provincia": "TE",
            "cap": "64049",
            "cod_catastale": "L314",
            "cod_istat": "067045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 409,
            "giorni": 2027,
            "area": "",
            "ech": 0
        },
        {
            "id": 7371,
            "name": "Tovo di Sant'Agata",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "L316",
            "cod_istat": "014068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 526,
            "giorni": 3017,
            "area": "",
            "ech": 0
        },
        {
            "id": 7372,
            "name": "Tovo San Giacomo",
            "provincia": "SV",
            "cap": "17020",
            "cod_catastale": "L315",
            "cod_istat": "009062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1435,
            "area": "",
            "ech": 0
        },
        {
            "id": 7373,
            "name": "Trabia",
            "provincia": "PA",
            "cap": "90019",
            "cod_catastale": "L317",
            "cod_istat": "082073",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 735,
            "area": "",
            "ech": 0
        },
        {
            "id": 7374,
            "name": "Tradate",
            "provincia": "VA",
            "cap": "21049",
            "cod_catastale": "L319",
            "cod_istat": "012127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 2562,
            "area": "",
            "ech": 0
        },
        {
            "id": 7375,
            "name": "Tramatza",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "L321",
            "cod_istat": "095066",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 1001,
            "area": "",
            "ech": 0
        },
        {
            "id": 7376,
            "name": "Trambileno",
            "provincia": "TN",
            "cap": "38068",
            "cod_catastale": "L322",
            "cod_istat": "022203",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 3210,
            "area": "",
            "ech": 0
        },
        {
            "id": 7377,
            "name": "Tramonti",
            "provincia": "SA",
            "cap": "84010",
            "cod_catastale": "L323",
            "cod_istat": "065151",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 321,
            "giorni": 1569,
            "area": "",
            "ech": 0
        },
        {
            "id": 7378,
            "name": "Tramonti di Sopra",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "L324",
            "cod_istat": "093045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 3149,
            "area": "",
            "ech": 0
        },
        {
            "id": 7379,
            "name": "Tramonti di Sotto",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "L325",
            "cod_istat": "093046",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 366,
            "giorni": 3053,
            "area": "",
            "ech": 0
        },
        {
            "id": 7380,
            "name": "Tramutola",
            "provincia": "PZ",
            "cap": "85057",
            "cod_catastale": "L326",
            "cod_istat": "076091",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 650,
            "giorni": 2091,
            "area": "",
            "ech": 0
        },
        {
            "id": 7381,
            "name": "Trana",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "L327",
            "cod_istat": "001276",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 372,
            "giorni": 2912,
            "area": "",
            "ech": 0
        },
        {
            "id": 7382,
            "name": "Trani",
            "provincia": "BT",
            "cap": "76125",
            "cod_catastale": "L328",
            "cod_istat": "110009",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 1190,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7383,
            "name": "Transacqua",
            "provincia": "TN",
            "cap": "38054",
            "cod_catastale": "L329",
            "cod_istat": "022204",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 746,
            "giorni": 3555,
            "area": "",
            "ech": 0
        },
        {
            "id": 7384,
            "name": "Traona",
            "provincia": "SO",
            "cap": "23019",
            "cod_catastale": "L330",
            "cod_istat": "014069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 7385,
            "name": "Trapani",
            "provincia": "TP",
            "cap": "91100",
            "cod_catastale": "L331",
            "cod_istat": "081021",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 810,
            "area": "",
            "ech": 0
        },
        {
            "id": 7386,
            "name": "Trappeto",
            "provincia": "PA",
            "cap": "90040",
            "cod_catastale": "L332",
            "cod_istat": "082074",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 681,
            "area": "",
            "ech": 0
        },
        {
            "id": 7387,
            "name": "Trarego Viggiona",
            "provincia": "VB",
            "cap": "28826",
            "cod_catastale": "L333",
            "cod_istat": "103066",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 771,
            "giorni": 3307,
            "area": "",
            "ech": 0
        },
        {
            "id": 7388,
            "name": "Trasacco",
            "provincia": "AQ",
            "cap": "67059",
            "cod_catastale": "L334",
            "cod_istat": "066102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 685,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 7389,
            "name": "Trasaghis",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "L335",
            "cod_istat": "030124",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 217,
            "giorni": 2542,
            "area": "",
            "ech": 0
        },
        {
            "id": 7390,
            "name": "Trasquera",
            "provincia": "VB",
            "cap": "28868",
            "cod_catastale": "L336",
            "cod_istat": "103067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1100,
            "giorni": 3734,
            "area": "",
            "ech": 0
        },
        {
            "id": 7391,
            "name": "Tratalias",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "L337",
            "cod_istat": "111090",
            "attivo": 1,
            "zona": "B",
            "cassa": 1,
            "altitudine": 30,
            "giorni": 839,
            "area": "",
            "ech": 1
        },
        {
            "id": 7392,
            "name": "Trausella",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "L338",
            "cod_istat": "001277",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 654,
            "giorni": 3238,
            "area": "",
            "ech": 0
        },
        {
            "id": 7393,
            "name": "Travacò Siccomario",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "I236",
            "cod_istat": "018162",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7394,
            "name": "Travagliato",
            "provincia": "BS",
            "cap": "25039",
            "cod_catastale": "L339",
            "cod_istat": "017188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 129,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7395,
            "name": "Travedona-Monate",
            "provincia": "VA",
            "cap": "21028",
            "cod_catastale": "L342",
            "cod_istat": "012128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 7396,
            "name": "Traversella",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "L345",
            "cod_istat": "001278",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 827,
            "giorni": 3509,
            "area": "",
            "ech": 0
        },
        {
            "id": 7397,
            "name": "Traversetolo",
            "provincia": "PR",
            "cap": "43029",
            "cod_catastale": "L346",
            "cod_istat": "034042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 7398,
            "name": "Traves",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L340",
            "cod_istat": "001279",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 628,
            "giorni": 3296,
            "area": "",
            "ech": 0
        },
        {
            "id": 7399,
            "name": "Travesio",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "L347",
            "cod_istat": "093047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2746,
            "area": "",
            "ech": 0
        },
        {
            "id": 7400,
            "name": "Travo",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "L348",
            "cod_istat": "033043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 176,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 7401,
            "name": "Trebaseleghe",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L349",
            "cod_istat": "028093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2412,
            "area": "",
            "ech": 0
        },
        {
            "id": 7402,
            "name": "Trebisacce",
            "provincia": "CS",
            "cap": "87075",
            "cod_catastale": "L353",
            "cod_istat": "078150",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 73,
            "giorni": 973,
            "area": "",
            "ech": 0
        },
        {
            "id": 7403,
            "name": "Trecasali",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "L354",
            "cod_istat": "034049",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 33,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 7404,
            "name": "Trecase",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "M280",
            "cod_istat": "063091",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 99,
            "giorni": 1297,
            "area": "",
            "ech": 0
        },
        {
            "id": 7405,
            "name": "Trecastagni",
            "provincia": "CT",
            "cap": "95039",
            "cod_catastale": "L355",
            "cod_istat": "087050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 586,
            "giorni": 1445,
            "area": "",
            "ech": 1
        },
        {
            "id": 7406,
            "name": "Trecate",
            "provincia": "NO",
            "cap": "28069",
            "cod_catastale": "L356",
            "cod_istat": "003149",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 7407,
            "name": "Trecchina",
            "provincia": "PZ",
            "cap": "85049",
            "cod_catastale": "L357",
            "cod_istat": "076092",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 1818,
            "area": "",
            "ech": 0
        },
        {
            "id": 7408,
            "name": "Trecenta",
            "provincia": "RO",
            "cap": "45027",
            "cod_catastale": "L359",
            "cod_istat": "029047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2355,
            "area": "",
            "ech": 0
        },
        {
            "id": 7409,
            "name": "Tredozio",
            "provincia": "FC",
            "cap": "47019",
            "cod_catastale": "L361",
            "cod_istat": "040049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 7410,
            "name": "Treglio",
            "provincia": "CH",
            "cap": "66030",
            "cod_catastale": "L363",
            "cod_istat": "069096",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 1471,
            "area": "",
            "ech": 0
        },
        {
            "id": 7411,
            "name": "Tregnago",
            "provincia": "VR",
            "cap": "37039",
            "cod_catastale": "L364",
            "cod_istat": "023087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 317,
            "giorni": 2811,
            "area": "",
            "ech": 0
        },
        {
            "id": 7412,
            "name": "Treia",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "L366",
            "cod_istat": "043054",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 7413,
            "name": "Treiso",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "L367",
            "cod_istat": "004230",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2823,
            "area": "",
            "ech": 0
        },
        {
            "id": 7414,
            "name": "Tremenico",
            "provincia": "LC",
            "cap": "23836",
            "cod_catastale": "L368",
            "cod_istat": "097081",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 754,
            "giorni": 3140,
            "area": "",
            "ech": 0
        },
        {
            "id": 7415,
            "name": "Tremestieri Etneo",
            "provincia": "CT",
            "cap": "95030",
            "cod_catastale": "L369",
            "cod_istat": "087051",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 1250,
            "area": "",
            "ech": 1
        },
        {
            "id": 7416,
            "name": "Tremezzo",
            "provincia": "CO",
            "cap": "22019",
            "cod_catastale": "L371",
            "cod_istat": "013252",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2253,
            "area": "",
            "ech": 0
        },
        {
            "id": 7417,
            "name": "Tremosine sul Garda",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "L372",
            "cod_istat": "017189",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7418,
            "name": "Trenta",
            "provincia": "CS",
            "cap": "87050",
            "cod_catastale": "L375",
            "cod_istat": "078151",
            "attivo": 0,
            "zona": "D",
            "cassa": 0,
            "altitudine": 618,
            "giorni": 2026,
            "area": "",
            "ech": 0
        },
        {
            "id": 7419,
            "name": "Trentinara",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "L377",
            "cod_istat": "065152",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 606,
            "giorni": 2008,
            "area": "",
            "ech": 0
        },
        {
            "id": 7420,
            "name": "Trento",
            "provincia": "TN",
            "cap": "381xx",
            "cod_catastale": "L378",
            "cod_istat": "022205",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2567,
            "area": "",
            "ech": 0
        },
        {
            "id": 7421,
            "name": "Trentola Ducenta",
            "provincia": "CE",
            "cap": "81038",
            "cod_catastale": "L379",
            "cod_istat": "061094",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7422,
            "name": "Trenzano",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "L380",
            "cod_istat": "017190",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7423,
            "name": "Treppo Carnico",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "L381",
            "cod_istat": "030125",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 671,
            "giorni": 3374,
            "area": "",
            "ech": 0
        },
        {
            "id": 7424,
            "name": "Treppo Grande",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "L382",
            "cod_istat": "030126",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2506,
            "area": "",
            "ech": 0
        },
        {
            "id": 7425,
            "name": "Trepuzzi",
            "provincia": "LE",
            "cap": "73019",
            "cod_catastale": "L383",
            "cod_istat": "075087",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 55,
            "giorni": 1081,
            "area": "",
            "ech": 0
        },
        {
            "id": 7426,
            "name": "Trequanda",
            "provincia": "SI",
            "cap": "53020",
            "cod_catastale": "L384",
            "cod_istat": "052036",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 453,
            "giorni": 2115,
            "area": "",
            "ech": 0
        },
        {
            "id": 7427,
            "name": "Tres",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "L385",
            "cod_istat": "022206",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 810,
            "giorni": 3654,
            "area": "",
            "ech": 0
        },
        {
            "id": 7428,
            "name": "Tresana",
            "provincia": "MS",
            "cap": "54012",
            "cod_catastale": "L386",
            "cod_istat": "045015",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 112,
            "giorni": 1848,
            "area": "",
            "ech": 0
        },
        {
            "id": 7429,
            "name": "Trescore Balneario",
            "provincia": "BG",
            "cap": "24069",
            "cod_catastale": "L388",
            "cod_istat": "016218",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2454,
            "area": "",
            "ech": 0
        },
        {
            "id": 7430,
            "name": "Trescore Cremasco",
            "provincia": "CR",
            "cap": "26017",
            "cod_catastale": "L389",
            "cod_istat": "019109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7431,
            "name": "Tresigallo",
            "provincia": "FE",
            "cap": "44039",
            "cod_catastale": "L390",
            "cod_istat": "038024",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2269,
            "area": "",
            "ech": 0
        },
        {
            "id": 7432,
            "name": "Tresivio",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "L392",
            "cod_istat": "014070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 504,
            "giorni": 3004,
            "area": "",
            "ech": 0
        },
        {
            "id": 7433,
            "name": "Tresnuraghes",
            "provincia": "OR",
            "cap": "09079",
            "cod_catastale": "L393",
            "cod_istat": "095067",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 1340,
            "area": "",
            "ech": 0
        },
        {
            "id": 7434,
            "name": "Trevenzuolo",
            "provincia": "VR",
            "cap": "37060",
            "cod_catastale": "L396",
            "cod_istat": "023088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 7435,
            "name": "Trevi",
            "provincia": "PG",
            "cap": "06039",
            "cod_catastale": "L397",
            "cod_istat": "054054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2208,
            "area": "",
            "ech": 0
        },
        {
            "id": 7436,
            "name": "Trevi nel Lazio",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "L398",
            "cod_istat": "060080",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 821,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 7437,
            "name": "Trevico",
            "provincia": "AV",
            "cap": "83058",
            "cod_catastale": "L399",
            "cod_istat": "064112",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1090,
            "giorni": 3445,
            "area": "",
            "ech": 0
        },
        {
            "id": 7438,
            "name": "Treviglio",
            "provincia": "BG",
            "cap": "24047",
            "cod_catastale": "L400",
            "cod_istat": "016219",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2237,
            "area": "",
            "ech": 0
        },
        {
            "id": 7439,
            "name": "Trevignano",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "L402",
            "cod_istat": "026085",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 2405,
            "area": "",
            "ech": 0
        },
        {
            "id": 7440,
            "name": "Trevignano Romano",
            "provincia": "RM",
            "cap": "00069",
            "cod_catastale": "L401",
            "cod_istat": "058107",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 1605,
            "area": "",
            "ech": 0
        },
        {
            "id": 7441,
            "name": "Treville",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "L403",
            "cod_istat": "006175",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2734,
            "area": "",
            "ech": 0
        },
        {
            "id": 7442,
            "name": "Treviolo",
            "provincia": "BG",
            "cap": "24048",
            "cod_catastale": "L404",
            "cod_istat": "016220",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2499,
            "area": "",
            "ech": 0
        },
        {
            "id": 7443,
            "name": "Treviso",
            "provincia": "TV",
            "cap": "31100",
            "cod_catastale": "L407",
            "cod_istat": "026086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 2378,
            "area": "",
            "ech": 0
        },
        {
            "id": 7444,
            "name": "Treviso Bresciano",
            "provincia": "BS",
            "cap": "25070",
            "cod_catastale": "L406",
            "cod_istat": "017191",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 687,
            "giorni": 3192,
            "area": "",
            "ech": 0
        },
        {
            "id": 7445,
            "name": "Trezzano Rosa",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "L408",
            "cod_istat": "015219",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 7446,
            "name": "Trezzano sul Naviglio",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "L409",
            "cod_istat": "015220",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7447,
            "name": "Trezzo sull'Adda",
            "provincia": "MI",
            "cap": "20056",
            "cod_catastale": "L411",
            "cod_istat": "015221",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 7448,
            "name": "Trezzo Tinella",
            "provincia": "CN",
            "cap": "12050",
            "cod_catastale": "L410",
            "cod_istat": "004231",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2738,
            "area": "",
            "ech": 0
        },
        {
            "id": 7449,
            "name": "Trezzone",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "L413",
            "cod_istat": "013226",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 2680,
            "area": "",
            "ech": 0
        },
        {
            "id": 7450,
            "name": "Tribano",
            "provincia": "PD",
            "cap": "35020",
            "cod_catastale": "L414",
            "cod_istat": "028094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7451,
            "name": "Tribiano",
            "provincia": "MI",
            "cap": "20067",
            "cod_catastale": "L415",
            "cod_istat": "015222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 94,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7452,
            "name": "Tribogna",
            "provincia": "GE",
            "cap": "16030",
            "cod_catastale": "L416",
            "cod_istat": "010063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2247,
            "area": "",
            "ech": 0
        },
        {
            "id": 7453,
            "name": "Tricarico",
            "provincia": "MT",
            "cap": "75019",
            "cod_catastale": "L418",
            "cod_istat": "077028",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 698,
            "giorni": 2056,
            "area": "",
            "ech": 0
        },
        {
            "id": 7454,
            "name": "Tricase",
            "provincia": "LE",
            "cap": "73039",
            "cod_catastale": "L419",
            "cod_istat": "075088",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 1183,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7455,
            "name": "Tricerro",
            "provincia": "VC",
            "cap": "13038",
            "cod_catastale": "L420",
            "cod_istat": "002147",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 141,
            "giorni": 2764,
            "area": "",
            "ech": 0
        },
        {
            "id": 7456,
            "name": "Tricesimo",
            "provincia": "UD",
            "cap": "33019",
            "cod_catastale": "L421",
            "cod_istat": "030127",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 199,
            "giorni": 2451,
            "area": "",
            "ech": 0
        },
        {
            "id": 7457,
            "name": "Trichiana",
            "provincia": "BL",
            "cap": "32028",
            "cod_catastale": "L422",
            "cod_istat": "025061",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 347,
            "giorni": 2879,
            "area": "",
            "ech": 0
        },
        {
            "id": 7458,
            "name": "Triei",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "L423",
            "cod_istat": "091097",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 140,
            "giorni": 971,
            "area": "",
            "ech": 1
        },
        {
            "id": 7459,
            "name": "Trieste",
            "provincia": "TS",
            "cap": "341xx",
            "cod_catastale": "L424",
            "cod_istat": "032006",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 7460,
            "name": "Triggiano",
            "provincia": "BA",
            "cap": "70019",
            "cod_catastale": "L425",
            "cod_istat": "072046",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 1258,
            "area": "",
            "ech": 0
        },
        {
            "id": 7461,
            "name": "Trigolo",
            "provincia": "CR",
            "cap": "26018",
            "cod_catastale": "L426",
            "cod_istat": "019110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 7462,
            "name": "Trinità",
            "provincia": "CN",
            "cap": "12049",
            "cod_catastale": "L427",
            "cod_istat": "004232",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 383,
            "giorni": 2647,
            "area": "",
            "ech": 0
        },
        {
            "id": 7463,
            "name": "Trinità d'Agultu e Vignola",
            "provincia": "SS",
            "cap": "07038",
            "cod_catastale": "L428",
            "cod_istat": "090074",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 365,
            "giorni": 1610,
            "area": "",
            "ech": 0
        },
        {
            "id": 7464,
            "name": "Trinitapoli",
            "provincia": "BT",
            "cap": "76015",
            "cod_catastale": "B915",
            "cod_istat": "110010",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1296,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7465,
            "name": "Trino",
            "provincia": "VC",
            "cap": "13039",
            "cod_catastale": "L429",
            "cod_istat": "002148",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2793,
            "area": "",
            "ech": 0
        },
        {
            "id": 7466,
            "name": "Triora",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "L430",
            "cod_istat": "008061",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 3039,
            "area": "",
            "ech": 0
        },
        {
            "id": 7467,
            "name": "Tripi",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "L431",
            "cod_istat": "083100",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 450,
            "giorni": 1396,
            "area": "",
            "ech": 1
        },
        {
            "id": 7468,
            "name": "Trisobbio",
            "provincia": "AL",
            "cap": "15070",
            "cod_catastale": "L432",
            "cod_istat": "006176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 341,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 7469,
            "name": "Trissino",
            "provincia": "VI",
            "cap": "36070",
            "cod_catastale": "L433",
            "cod_istat": "024110",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2444,
            "area": "",
            "ech": 0
        },
        {
            "id": 7470,
            "name": "Triuggio",
            "provincia": "MB",
            "cap": "20844",
            "cod_catastale": "L434",
            "cod_istat": "108043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 231,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7471,
            "name": "Trivento",
            "provincia": "CB",
            "cap": "86029",
            "cod_catastale": "L435",
            "cod_istat": "070081",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 599,
            "giorni": 2140,
            "area": "",
            "ech": 0
        },
        {
            "id": 7472,
            "name": "Trivero",
            "provincia": "BI",
            "cap": "13835",
            "cod_catastale": "L436",
            "cod_istat": "096070",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 739,
            "giorni": 3182,
            "area": "",
            "ech": 0
        },
        {
            "id": 7473,
            "name": "Trivigliano",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "L437",
            "cod_istat": "060081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 780,
            "giorni": 2527,
            "area": "",
            "ech": 0
        },
        {
            "id": 7474,
            "name": "Trivignano Udinese",
            "provincia": "UD",
            "cap": "33050",
            "cod_catastale": "L438",
            "cod_istat": "030128",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7475,
            "name": "Trivigno",
            "provincia": "PZ",
            "cap": "85018",
            "cod_catastale": "L439",
            "cod_istat": "076093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 735,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 7476,
            "name": "Trivolzio",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L440",
            "cod_istat": "018163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7477,
            "name": "Trodena nel parco naturale",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "L444",
            "cod_istat": "021102",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7478,
            "name": "Trofarello",
            "provincia": "TO",
            "cap": "10028",
            "cod_catastale": "L445",
            "cod_istat": "001280",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2639,
            "area": "",
            "ech": 0
        },
        {
            "id": 7479,
            "name": "Troia",
            "provincia": "FG",
            "cap": "71029",
            "cod_catastale": "L447",
            "cod_istat": "071058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 439,
            "giorni": 1964,
            "area": "",
            "ech": 0
        },
        {
            "id": 7480,
            "name": "Troina",
            "provincia": "EN",
            "cap": "94018",
            "cod_catastale": "L448",
            "cod_istat": "086018",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 1121,
            "giorni": 2364,
            "area": "",
            "ech": 1
        },
        {
            "id": 7481,
            "name": "Tromello",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L449",
            "cod_istat": "018164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7482,
            "name": "Trontano",
            "provincia": "VB",
            "cap": "28859",
            "cod_catastale": "L450",
            "cod_istat": "103068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 520,
            "giorni": 2980,
            "area": "",
            "ech": 0
        },
        {
            "id": 7483,
            "name": "Tronzano Lago Maggiore",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "A705",
            "cod_istat": "012129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 7484,
            "name": "Tronzano Vercellese",
            "provincia": "VC",
            "cap": "13049",
            "cod_catastale": "L451",
            "cod_istat": "002150",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 7485,
            "name": "Tropea",
            "provincia": "VV",
            "cap": "89861",
            "cod_catastale": "L452",
            "cod_istat": "102044",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 61,
            "giorni": 912,
            "area": "",
            "ech": 0
        },
        {
            "id": 7486,
            "name": "Trovo",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L453",
            "cod_istat": "018165",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7487,
            "name": "Truccazzano",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "L454",
            "cod_istat": "015224",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7488,
            "name": "Tubre",
            "provincia": "BZ",
            "cap": "39020",
            "cod_catastale": "L455",
            "cod_istat": "021103",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1240,
            "giorni": 4447,
            "area": "",
            "ech": 0
        },
        {
            "id": 7489,
            "name": "Tuenno",
            "provincia": "TN",
            "cap": "38019",
            "cod_catastale": "L457",
            "cod_istat": "022207",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 629,
            "giorni": 3220,
            "area": "",
            "ech": 0
        },
        {
            "id": 7490,
            "name": "Tufara",
            "provincia": "CB",
            "cap": "86010",
            "cod_catastale": "L458",
            "cod_istat": "070082",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 420,
            "giorni": 1910,
            "area": "",
            "ech": 0
        },
        {
            "id": 7491,
            "name": "Tufillo",
            "provincia": "CH",
            "cap": "66050",
            "cod_catastale": "L459",
            "cod_istat": "069097",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 555,
            "giorni": 2063,
            "area": "",
            "ech": 0
        },
        {
            "id": 7492,
            "name": "Tufino",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "L460",
            "cod_istat": "063085",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 1117,
            "area": "",
            "ech": 0
        },
        {
            "id": 7493,
            "name": "Tufo",
            "provincia": "AV",
            "cap": "83010",
            "cod_catastale": "L461",
            "cod_istat": "064113",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1452,
            "area": "",
            "ech": 0
        },
        {
            "id": 7494,
            "name": "Tuglie",
            "provincia": "LE",
            "cap": "73058",
            "cod_catastale": "L462",
            "cod_istat": "075089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 1078,
            "area": "",
            "ech": 0
        },
        {
            "id": 7495,
            "name": "Tuili",
            "provincia": "SU",
            "cap": "09029",
            "cod_catastale": "L463",
            "cod_istat": "111091",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 1245,
            "area": "",
            "ech": 0
        },
        {
            "id": 7496,
            "name": "Tula",
            "provincia": "SS",
            "cap": "07010",
            "cod_catastale": "L464",
            "cod_istat": "090075",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 275,
            "giorni": 1439,
            "area": "",
            "ech": 0
        },
        {
            "id": 7497,
            "name": "Tuoro sul Trasimeno",
            "provincia": "PG",
            "cap": "06069",
            "cod_catastale": "L466",
            "cod_istat": "054055",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 309,
            "giorni": 2104,
            "area": "",
            "ech": 0
        },
        {
            "id": 7498,
            "name": "Turania",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "G507",
            "cod_istat": "057071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 703,
            "giorni": 2761,
            "area": "",
            "ech": 0
        },
        {
            "id": 7499,
            "name": "Turano Lodigiano",
            "provincia": "LO",
            "cap": "26828",
            "cod_catastale": "L469",
            "cod_istat": "098058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2579,
            "area": "",
            "ech": 0
        },
        {
            "id": 7500,
            "name": "Turate",
            "provincia": "CO",
            "cap": "22078",
            "cod_catastale": "L470",
            "cod_istat": "013227",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7501,
            "name": "Turbigo",
            "provincia": "MI",
            "cap": "20029",
            "cod_catastale": "L471",
            "cod_istat": "015226",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 146,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 7502,
            "name": "Turi",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "L472",
            "cod_istat": "072047",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 7503,
            "name": "Turri",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L473",
            "cod_istat": "111092",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 164,
            "giorni": 1175,
            "area": "",
            "ech": 0
        },
        {
            "id": 7504,
            "name": "Turriaco",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "L474",
            "cod_istat": "031024",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2257,
            "area": "",
            "ech": 0
        },
        {
            "id": 7505,
            "name": "Turrivalignani",
            "provincia": "PE",
            "cap": "65020",
            "cod_catastale": "L475",
            "cod_istat": "068044",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 1727,
            "area": "",
            "ech": 0
        },
        {
            "id": 7506,
            "name": "Tursi",
            "provincia": "MT",
            "cap": "75028",
            "cod_catastale": "L477",
            "cod_istat": "077029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 210,
            "giorni": 1452,
            "area": "",
            "ech": 0
        },
        {
            "id": 7507,
            "name": "Tusa",
            "provincia": "ME",
            "cap": "98079",
            "cod_catastale": "L478",
            "cod_istat": "083101",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 614,
            "giorni": 1676,
            "area": "",
            "ech": 0
        },
        {
            "id": 7508,
            "name": "Tuscania",
            "provincia": "VT",
            "cap": "01017",
            "cod_catastale": "L310",
            "cod_istat": "056052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 1654,
            "area": "",
            "ech": 0
        },
        {
            "id": 7509,
            "name": "Ubiale Clanezzo",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "C789",
            "cod_istat": "016221",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 336,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 7510,
            "name": "Uboldo",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "L480",
            "cod_istat": "012130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 7511,
            "name": "Ucria",
            "provincia": "ME",
            "cap": "98060",
            "cod_catastale": "L482",
            "cod_istat": "083102",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 710,
            "giorni": 1840,
            "area": "",
            "ech": 0
        },
        {
            "id": 7512,
            "name": "Udine",
            "provincia": "UD",
            "cap": "33100",
            "cod_catastale": "L483",
            "cod_istat": "030129",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2323,
            "area": "",
            "ech": 0
        },
        {
            "id": 7513,
            "name": "Ugento",
            "provincia": "LE",
            "cap": "73059",
            "cod_catastale": "L484",
            "cod_istat": "075090",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 108,
            "giorni": 1163,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7514,
            "name": "Uggiano la Chiesa",
            "provincia": "LE",
            "cap": "73020",
            "cod_catastale": "L485",
            "cod_istat": "075091",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 77,
            "giorni": 1120,
            "area": "",
            "ech": 0
        },
        {
            "id": 7515,
            "name": "Uggiate-Trevano",
            "provincia": "CO",
            "cap": "22029",
            "cod_catastale": "L487",
            "cod_istat": "013228",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 414,
            "giorni": 2718,
            "area": "",
            "ech": 0
        },
        {
            "id": 7516,
            "name": "Ulà Tirso",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "L488",
            "cod_istat": "095068",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 348,
            "giorni": 1422,
            "area": "",
            "ech": 0
        },
        {
            "id": 7517,
            "name": "Ulassai",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "L489",
            "cod_istat": "091098",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 775,
            "giorni": 2068,
            "area": "",
            "ech": 1
        },
        {
            "id": 7518,
            "name": "Ultimo",
            "provincia": "BZ",
            "cap": "39016",
            "cod_catastale": "L490",
            "cod_istat": "021104",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1190,
            "giorni": 4228,
            "area": "",
            "ech": 0
        },
        {
            "id": 7519,
            "name": "Umbertide",
            "provincia": "PG",
            "cap": "06019",
            "cod_catastale": "D786",
            "cod_istat": "054056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 247,
            "giorni": 2192,
            "area": "",
            "ech": 0
        },
        {
            "id": 7520,
            "name": "Umbriatico",
            "provincia": "KR",
            "cap": "88823",
            "cod_catastale": "L492",
            "cod_istat": "101026",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 422,
            "giorni": 1633,
            "area": "",
            "ech": 0
        },
        {
            "id": 7521,
            "name": "Urago d'Oglio",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "L494",
            "cod_istat": "017192",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 131,
            "giorni": 2251,
            "area": "",
            "ech": 0
        },
        {
            "id": 7522,
            "name": "Uras",
            "provincia": "OR",
            "cap": "09099",
            "cod_catastale": "L496",
            "cod_istat": "095069",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 23,
            "giorni": 1006,
            "area": "",
            "ech": 0
        },
        {
            "id": 7523,
            "name": "Urbana",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "L497",
            "cod_istat": "028095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 7524,
            "name": "Urbania",
            "provincia": "PU",
            "cap": "61049",
            "cod_catastale": "L498",
            "cod_istat": "041066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 273,
            "giorni": 2293,
            "area": "",
            "ech": 0
        },
        {
            "id": 7525,
            "name": "Urbe",
            "provincia": "SV",
            "cap": "17048",
            "cod_catastale": "L499",
            "cod_istat": "009063",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 526,
            "giorni": 2658,
            "area": "",
            "ech": 0
        },
        {
            "id": 7526,
            "name": "Urbino",
            "provincia": "PU",
            "cap": "61029",
            "cod_catastale": "L500",
            "cod_istat": "041067",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 485,
            "giorni": 2545,
            "area": "",
            "ech": 0
        },
        {
            "id": 7527,
            "name": "Urbisaglia",
            "provincia": "MC",
            "cap": "62010",
            "cod_catastale": "L501",
            "cod_istat": "043055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 2002,
            "area": "",
            "ech": 0
        },
        {
            "id": 7528,
            "name": "Urgnano",
            "provincia": "BG",
            "cap": "24059",
            "cod_catastale": "L502",
            "cod_istat": "016222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 2428,
            "area": "",
            "ech": 0
        },
        {
            "id": 7529,
            "name": "Uri",
            "provincia": "SS",
            "cap": "07040",
            "cod_catastale": "L503",
            "cod_istat": "090076",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1042,
            "area": "",
            "ech": 0
        },
        {
            "id": 7530,
            "name": "Ururi",
            "provincia": "CB",
            "cap": "86049",
            "cod_catastale": "L505",
            "cod_istat": "070083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 262,
            "giorni": 1647,
            "area": "",
            "ech": 0
        },
        {
            "id": 7531,
            "name": "Urzulei",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "L506",
            "cod_istat": "091099",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 511,
            "giorni": 1638,
            "area": "",
            "ech": 1
        },
        {
            "id": 7532,
            "name": "Uscio",
            "provincia": "GE",
            "cap": "16036",
            "cod_catastale": "L507",
            "cod_istat": "010064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 361,
            "giorni": 2329,
            "area": "",
            "ech": 0
        },
        {
            "id": 7533,
            "name": "Usellus",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "L508",
            "cod_istat": "095070",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 289,
            "giorni": 1347,
            "area": "",
            "ech": 0
        },
        {
            "id": 7534,
            "name": "Usini",
            "provincia": "SS",
            "cap": "07049",
            "cod_catastale": "L509",
            "cod_istat": "090077",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 1137,
            "area": "",
            "ech": 0
        },
        {
            "id": 7535,
            "name": "Usmate Velate",
            "provincia": "MB",
            "cap": "20865",
            "cod_catastale": "L511",
            "cod_istat": "108044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 221,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7536,
            "name": "Ussana",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L512",
            "cod_istat": "111093",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1224,
            "area": "",
            "ech": 0
        },
        {
            "id": 7537,
            "name": "Ussaramanna",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L513",
            "cod_istat": "111094",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 158,
            "giorni": 1164,
            "area": "",
            "ech": 0
        },
        {
            "id": 7538,
            "name": "Ussassai",
            "provincia": "NU",
            "cap": "08040",
            "cod_catastale": "L514",
            "cod_istat": "091100",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 670,
            "giorni": 1784,
            "area": "",
            "ech": 1
        },
        {
            "id": 7539,
            "name": "Usseaux",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "L515",
            "cod_istat": "001281",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1416,
            "giorni": 4478,
            "area": "",
            "ech": 0
        },
        {
            "id": 7540,
            "name": "Usseglio",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L516",
            "cod_istat": "001282",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1265,
            "giorni": 4664,
            "area": "",
            "ech": 0
        },
        {
            "id": 7541,
            "name": "Ussita",
            "provincia": "MC",
            "cap": "62039",
            "cod_catastale": "L517",
            "cod_istat": "043056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 744,
            "giorni": 2510,
            "area": "",
            "ech": 0
        },
        {
            "id": 7542,
            "name": "Ustica",
            "provincia": "PA",
            "cap": "90051",
            "cod_catastale": "L519",
            "cod_istat": "082075",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 49,
            "giorni": 717,
            "area": "",
            "ech": 0
        },
        {
            "id": 7543,
            "name": "Uta",
            "provincia": "CA",
            "cap": "09068",
            "cod_catastale": "L521",
            "cod_istat": "092090",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 1070,
            "area": "",
            "ech": 0
        },
        {
            "id": 7544,
            "name": "Uzzano",
            "provincia": "PT",
            "cap": "51010",
            "cod_catastale": "L522",
            "cod_istat": "047021",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 50,
            "giorni": 1837,
            "area": "",
            "ech": 0
        },
        {
            "id": 7545,
            "name": "Vaccarizzo Albanese",
            "provincia": "CS",
            "cap": "87060",
            "cod_catastale": "L524",
            "cod_istat": "078152",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 448,
            "giorni": 1718,
            "area": "",
            "ech": 0
        },
        {
            "id": 7546,
            "name": "Vacone",
            "provincia": "RI",
            "cap": "02040",
            "cod_catastale": "L525",
            "cod_istat": "057072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 517,
            "giorni": 2306,
            "area": "",
            "ech": 0
        },
        {
            "id": 7547,
            "name": "Vacri",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "L526",
            "cod_istat": "069098",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1512,
            "area": "",
            "ech": 0
        },
        {
            "id": 7548,
            "name": "Vadena",
            "provincia": "BZ",
            "cap": "39051",
            "cod_catastale": "L527",
            "cod_istat": "021105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2933,
            "area": "",
            "ech": 0
        },
        {
            "id": 7549,
            "name": "Vado Ligure",
            "provincia": "SV",
            "cap": "17047",
            "cod_catastale": "L528",
            "cod_istat": "009064",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1463,
            "area": "",
            "ech": 0
        },
        {
            "id": 7550,
            "name": "Vagli Sotto",
            "provincia": "LU",
            "cap": "55030",
            "cod_catastale": "L533",
            "cod_istat": "046031",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 575,
            "giorni": 2903,
            "area": "",
            "ech": 0
        },
        {
            "id": 7551,
            "name": "Vaglia",
            "provincia": "FI",
            "cap": "50036",
            "cod_catastale": "L529",
            "cod_istat": "048046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 290,
            "giorni": 2209,
            "area": "",
            "ech": 0
        },
        {
            "id": 7552,
            "name": "Vaglio Basilicata",
            "provincia": "PZ",
            "cap": "85010",
            "cod_catastale": "L532",
            "cod_istat": "076094",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 954,
            "giorni": 2644,
            "area": "",
            "ech": 0
        },
        {
            "id": 7553,
            "name": "Vaglio Serra",
            "provincia": "AT",
            "cap": "14049",
            "cod_catastale": "L531",
            "cod_istat": "005111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 7554,
            "name": "Vaiano",
            "provincia": "PO",
            "cap": "59021",
            "cod_catastale": "L537",
            "cod_istat": "100006",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 150,
            "giorni": 1993,
            "area": "",
            "ech": 0
        },
        {
            "id": 7555,
            "name": "Vaiano Cremasco",
            "provincia": "CR",
            "cap": "26010",
            "cod_catastale": "L535",
            "cod_istat": "019111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 82,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7556,
            "name": "Vaie",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "L538",
            "cod_istat": "001283",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2925,
            "area": "",
            "ech": 0
        },
        {
            "id": 7557,
            "name": "Vailate",
            "provincia": "CR",
            "cap": "26019",
            "cod_catastale": "L539",
            "cod_istat": "019112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7558,
            "name": "Vairano Patenora",
            "provincia": "CE",
            "cap": "81058",
            "cod_catastale": "L540",
            "cod_istat": "061095",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 168,
            "giorni": 1383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7559,
            "name": "Vajont",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "M265",
            "cod_istat": "093052",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2857,
            "area": "",
            "ech": 0
        },
        {
            "id": 7560,
            "name": "Val della Torre",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "L555",
            "cod_istat": "001284",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 510,
            "giorni": 3119,
            "area": "",
            "ech": 0
        },
        {
            "id": 7561,
            "name": "Val di Nizza",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "L562",
            "cod_istat": "018166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2962,
            "area": "",
            "ech": 0
        },
        {
            "id": 7562,
            "name": "Val di Vizze",
            "provincia": "BZ",
            "cap": "39049",
            "cod_catastale": "L564",
            "cod_istat": "021107",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 948,
            "giorni": 3657,
            "area": "",
            "ech": 0
        },
        {
            "id": 7563,
            "name": "Val Masino",
            "provincia": "SO",
            "cap": "23010",
            "cod_catastale": "L638",
            "cod_istat": "014074",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 787,
            "giorni": 3187,
            "area": "",
            "ech": 0
        },
        {
            "id": 7564,
            "name": "Val Rezzo",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "H259",
            "cod_istat": "013233",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1044,
            "giorni": 3552,
            "area": "",
            "ech": 0
        },
        {
            "id": 7565,
            "name": "Valbondione",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "L544",
            "cod_istat": "016223",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 900,
            "giorni": 3348,
            "area": "",
            "ech": 0
        },
        {
            "id": 7566,
            "name": "Valbrembo",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "L545",
            "cod_istat": "016224",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2550,
            "area": "",
            "ech": 0
        },
        {
            "id": 7567,
            "name": "Valbrevenna",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "L546",
            "cod_istat": "010065",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 533,
            "giorni": 2681,
            "area": "",
            "ech": 0
        },
        {
            "id": 7568,
            "name": "Valbrona",
            "provincia": "CO",
            "cap": "22039",
            "cod_catastale": "L547",
            "cod_istat": "013229",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 494,
            "giorni": 2932,
            "area": "",
            "ech": 0
        },
        {
            "id": 7569,
            "name": "Valda",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "L550",
            "cod_istat": "022208",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 795,
            "giorni": 3631,
            "area": "",
            "ech": 0
        },
        {
            "id": 7570,
            "name": "Valdagno",
            "provincia": "VI",
            "cap": "36078",
            "cod_catastale": "L551",
            "cod_istat": "024111",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 7571,
            "name": "Valdaora",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "L552",
            "cod_istat": "021106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1048,
            "giorni": 4413,
            "area": "",
            "ech": 0
        },
        {
            "id": 7572,
            "name": "Valdastico",
            "provincia": "VI",
            "cap": "36040",
            "cod_catastale": "L554",
            "cod_istat": "024112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 2906,
            "area": "",
            "ech": 0
        },
        {
            "id": 7573,
            "name": "Valdengo",
            "provincia": "BI",
            "cap": "13855",
            "cod_catastale": "L556",
            "cod_istat": "096071",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2675,
            "area": "",
            "ech": 0
        },
        {
            "id": 7574,
            "name": "Valderice",
            "provincia": "TP",
            "cap": "91019",
            "cod_catastale": "G319",
            "cod_istat": "081022",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 240,
            "giorni": 1076,
            "area": "",
            "ech": 1
        },
        {
            "id": 7575,
            "name": "Valdidentro",
            "provincia": "SO",
            "cap": "23038",
            "cod_catastale": "L557",
            "cod_istat": "014071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1350,
            "giorni": 3987,
            "area": "",
            "ech": 0
        },
        {
            "id": 7576,
            "name": "Valdieri",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "L558",
            "cod_istat": "004233",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 774,
            "giorni": 3275,
            "area": "",
            "ech": 0
        },
        {
            "id": 7577,
            "name": "Valdina",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "L561",
            "cod_istat": "083103",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 213,
            "giorni": 991,
            "area": "",
            "ech": 1
        },
        {
            "id": 7578,
            "name": "Valdisotto",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "L563",
            "cod_istat": "014072",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1141,
            "giorni": 3690,
            "area": "",
            "ech": 0
        },
        {
            "id": 7579,
            "name": "Valdobbiadene",
            "provincia": "TV",
            "cap": "31049",
            "cod_catastale": "L565",
            "cod_istat": "026087",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2774,
            "area": "",
            "ech": 0
        },
        {
            "id": 7580,
            "name": "Valduggia",
            "provincia": "VC",
            "cap": "13018",
            "cod_catastale": "L566",
            "cod_istat": "002152",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2811,
            "area": "",
            "ech": 0
        },
        {
            "id": 7581,
            "name": "Valeggio",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L568",
            "cod_istat": "018167",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 93,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7582,
            "name": "Valeggio sul Mincio",
            "provincia": "VR",
            "cap": "37067",
            "cod_catastale": "L567",
            "cod_istat": "023089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2440,
            "area": "",
            "ech": 0
        },
        {
            "id": 7583,
            "name": "Valentano",
            "provincia": "VT",
            "cap": "01018",
            "cod_catastale": "L569",
            "cod_istat": "056053",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 538,
            "giorni": 2375,
            "area": "",
            "ech": 0
        },
        {
            "id": 7584,
            "name": "Valenza",
            "provincia": "AL",
            "cap": "15048",
            "cod_catastale": "L570",
            "cod_istat": "006177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2587,
            "area": "",
            "ech": 0
        },
        {
            "id": 7585,
            "name": "Valenzano",
            "provincia": "BA",
            "cap": "70010",
            "cod_catastale": "L571",
            "cod_istat": "072048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 85,
            "giorni": 1303,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7586,
            "name": "Valera Fratta",
            "provincia": "LO",
            "cap": "26859",
            "cod_catastale": "L572",
            "cod_istat": "098059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 7587,
            "name": "Valfabbrica",
            "provincia": "PG",
            "cap": "06029",
            "cod_catastale": "L573",
            "cod_istat": "054057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 289,
            "giorni": 2084,
            "area": "",
            "ech": 0
        },
        {
            "id": 7588,
            "name": "Valfenera",
            "provincia": "AT",
            "cap": "14017",
            "cod_catastale": "L574",
            "cod_istat": "005112",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 282,
            "giorni": 2719,
            "area": "",
            "ech": 0
        },
        {
            "id": 7589,
            "name": "Valfloriana",
            "provincia": "TN",
            "cap": "38040",
            "cod_catastale": "L575",
            "cod_istat": "022209",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 853,
            "giorni": 3721,
            "area": "",
            "ech": 0
        },
        {
            "id": 7590,
            "name": "Valfurva",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "L576",
            "cod_istat": "014073",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1339,
            "giorni": 3971,
            "area": "",
            "ech": 0
        },
        {
            "id": 7591,
            "name": "Valganna",
            "provincia": "VA",
            "cap": "21039",
            "cod_catastale": "L577",
            "cod_istat": "012131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 460,
            "giorni": 2760,
            "area": "",
            "ech": 0
        },
        {
            "id": 7592,
            "name": "Valgioie",
            "provincia": "TO",
            "cap": "10094",
            "cod_catastale": "L578",
            "cod_istat": "001285",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 870,
            "giorni": 3659,
            "area": "",
            "ech": 0
        },
        {
            "id": 7593,
            "name": "Valgoglio",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "L579",
            "cod_istat": "016225",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 929,
            "giorni": 3389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7594,
            "name": "Valgrana",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "L580",
            "cod_istat": "004234",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 642,
            "giorni": 3111,
            "area": "",
            "ech": 0
        },
        {
            "id": 7595,
            "name": "Valgreghentino",
            "provincia": "LC",
            "cap": "23857",
            "cod_catastale": "L581",
            "cod_istat": "097082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2501,
            "area": "",
            "ech": 0
        },
        {
            "id": 7596,
            "name": "Valgrisenche",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "L582",
            "cod_istat": "007068",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1664,
            "giorni": 4728,
            "area": "",
            "ech": 0
        },
        {
            "id": 7597,
            "name": "Valguarnera Caropepe",
            "provincia": "EN",
            "cap": "94019",
            "cod_catastale": "L583",
            "cod_istat": "086019",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 590,
            "giorni": 1557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7598,
            "name": "Vallada Agordina",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "L584",
            "cod_istat": "025062",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1035,
            "giorni": 4056,
            "area": "",
            "ech": 0
        },
        {
            "id": 7599,
            "name": "Vallanzengo",
            "provincia": "BI",
            "cap": "13847",
            "cod_catastale": "L586",
            "cod_istat": "096072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 7600,
            "name": "Vallarsa",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "L588",
            "cod_istat": "022210",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 724,
            "giorni": 3520,
            "area": "",
            "ech": 0
        },
        {
            "id": 7601,
            "name": "Vallata",
            "provincia": "AV",
            "cap": "83059",
            "cod_catastale": "L589",
            "cod_istat": "064114",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 870,
            "giorni": 2651,
            "area": "",
            "ech": 0
        },
        {
            "id": 7602,
            "name": "Valle Agricola",
            "provincia": "CE",
            "cap": "81010",
            "cod_catastale": "L594",
            "cod_istat": "061096",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 691,
            "giorni": 2349,
            "area": "",
            "ech": 0
        },
        {
            "id": 7603,
            "name": "Valle Aurina",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "L595",
            "cod_istat": "021108",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1054,
            "giorni": 4243,
            "area": "",
            "ech": 0
        },
        {
            "id": 7604,
            "name": "Valle Castellana",
            "provincia": "TE",
            "cap": "64010",
            "cod_catastale": "L597",
            "cod_istat": "067046",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 625,
            "giorni": 2392,
            "area": "",
            "ech": 0
        },
        {
            "id": 7605,
            "name": "Valle dell'Angelo",
            "provincia": "SA",
            "cap": "84070",
            "cod_catastale": "G540",
            "cod_istat": "065153",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 621,
            "giorni": 1914,
            "area": "",
            "ech": 0
        },
        {
            "id": 7606,
            "name": "Valle di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "L590",
            "cod_istat": "025063",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 819,
            "giorni": 4003,
            "area": "",
            "ech": 0
        },
        {
            "id": 7607,
            "name": "Valle di Casies",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "L601",
            "cod_istat": "021109",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1206,
            "giorni": 4428,
            "area": "",
            "ech": 0
        },
        {
            "id": 7608,
            "name": "Valle di Maddaloni",
            "provincia": "CE",
            "cap": "81020",
            "cod_catastale": "L591",
            "cod_istat": "061097",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 156,
            "giorni": 1399,
            "area": "",
            "ech": 0
        },
        {
            "id": 7609,
            "name": "Valle Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L593",
            "cod_istat": "018168",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 101,
            "giorni": 2812,
            "area": "",
            "ech": 0
        },
        {
            "id": 7610,
            "name": "Valle Mosso",
            "provincia": "BI",
            "cap": "13825",
            "cod_catastale": "L606",
            "cod_istat": "096073",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 434,
            "giorni": 2608,
            "area": "",
            "ech": 0
        },
        {
            "id": 7611,
            "name": "Valle Salimbene",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "L617",
            "cod_istat": "018169",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 71,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 7612,
            "name": "Valle San Nicolao",
            "provincia": "BI",
            "cap": "13847",
            "cod_catastale": "L620",
            "cod_istat": "096074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 464,
            "giorni": 2647,
            "area": "",
            "ech": 0
        },
        {
            "id": 7613,
            "name": "Vallebona",
            "provincia": "IM",
            "cap": "18012",
            "cod_catastale": "L596",
            "cod_istat": "008062",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 149,
            "giorni": 1572,
            "area": "",
            "ech": 0
        },
        {
            "id": 7614,
            "name": "Vallecorsa",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "L598",
            "cod_istat": "060082",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 1786,
            "area": "",
            "ech": 0
        },
        {
            "id": 7615,
            "name": "Vallecrosia",
            "provincia": "IM",
            "cap": "18019",
            "cod_catastale": "L599",
            "cod_istat": "008063",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1109,
            "area": "",
            "ech": 0
        },
        {
            "id": 7616,
            "name": "Valledolmo",
            "provincia": "PA",
            "cap": "90029",
            "cod_catastale": "L603",
            "cod_istat": "082076",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 746,
            "giorni": 1786,
            "area": "",
            "ech": 0
        },
        {
            "id": 7617,
            "name": "Valledoria",
            "provincia": "SS",
            "cap": "07039",
            "cod_catastale": "L604",
            "cod_istat": "090079",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 16,
            "giorni": 942,
            "area": "",
            "ech": 0
        },
        {
            "id": 7618,
            "name": "Vallefiorita",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "I322",
            "cod_istat": "079151",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 1440,
            "area": "",
            "ech": 0
        },
        {
            "id": 7619,
            "name": "Vallelonga",
            "provincia": "VV",
            "cap": "89821",
            "cod_catastale": "L607",
            "cod_istat": "102045",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 646,
            "giorni": 2017,
            "area": "",
            "ech": 0
        },
        {
            "id": 7620,
            "name": "Vallelunga Pratameno",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "L609",
            "cod_istat": "085021",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 472,
            "giorni": 1377,
            "area": "",
            "ech": 0
        },
        {
            "id": 7621,
            "name": "Vallemaio",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "L605",
            "cod_istat": "060083",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 337,
            "giorni": 1713,
            "area": "",
            "ech": 0
        },
        {
            "id": 7622,
            "name": "Vallepietra",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "L611",
            "cod_istat": "058108",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 825,
            "giorni": 2705,
            "area": "",
            "ech": 0
        },
        {
            "id": 7623,
            "name": "Vallerano",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "L612",
            "cod_istat": "056054",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 7624,
            "name": "Vallermosa",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "L613",
            "cod_istat": "111095",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 70,
            "giorni": 1056,
            "area": "",
            "ech": 0
        },
        {
            "id": 7625,
            "name": "Vallerotonda",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "L614",
            "cod_istat": "060084",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 620,
            "giorni": 2272,
            "area": "",
            "ech": 0
        },
        {
            "id": 7626,
            "name": "Vallesaccarda",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "L616",
            "cod_istat": "064115",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 650,
            "giorni": 2362,
            "area": "",
            "ech": 0
        },
        {
            "id": 7627,
            "name": "Valleve",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "L623",
            "cod_istat": "016226",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1141,
            "giorni": 3690,
            "area": "",
            "ech": 0
        },
        {
            "id": 7628,
            "name": "Valli del Pasubio",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "L624",
            "cod_istat": "024113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2815,
            "area": "",
            "ech": 0
        },
        {
            "id": 7629,
            "name": "Vallinfreda",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "L625",
            "cod_istat": "058109",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 874,
            "giorni": 2920,
            "area": "",
            "ech": 0
        },
        {
            "id": 7630,
            "name": "Vallio Terme",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "L626",
            "cod_istat": "017193",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 304,
            "giorni": 2633,
            "area": "",
            "ech": 0
        },
        {
            "id": 7631,
            "name": "Vallo della Lucania",
            "provincia": "SA",
            "cap": "84078",
            "cod_catastale": "L628",
            "cod_istat": "065154",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 380,
            "giorni": 1519,
            "area": "",
            "ech": 0
        },
        {
            "id": 7632,
            "name": "Vallo di Nera",
            "provincia": "PG",
            "cap": "06040",
            "cod_catastale": "L627",
            "cod_istat": "054058",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 333,
            "giorni": 2128,
            "area": "",
            "ech": 0
        },
        {
            "id": 7633,
            "name": "Vallo Torinese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L629",
            "cod_istat": "001286",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 508,
            "giorni": 3187,
            "area": "",
            "ech": 0
        },
        {
            "id": 7634,
            "name": "Valloriate",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "L631",
            "cod_istat": "004235",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 785,
            "giorni": 3288,
            "area": "",
            "ech": 0
        },
        {
            "id": 7635,
            "name": "Valmacca",
            "provincia": "AL",
            "cap": "15040",
            "cod_catastale": "L633",
            "cod_istat": "006178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 2564,
            "area": "",
            "ech": 0
        },
        {
            "id": 7636,
            "name": "Valmadrera",
            "provincia": "LC",
            "cap": "23868",
            "cod_catastale": "L634",
            "cod_istat": "097083",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2402,
            "area": "",
            "ech": 0
        },
        {
            "id": 7637,
            "name": "Valmala",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "L636",
            "cod_istat": "004236",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 831,
            "giorni": 3346,
            "area": "",
            "ech": 0
        },
        {
            "id": 7638,
            "name": "Valmontone",
            "provincia": "RM",
            "cap": "00038",
            "cod_catastale": "L639",
            "cod_istat": "058110",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 1715,
            "area": "",
            "ech": 0
        },
        {
            "id": 7639,
            "name": "Valmorea",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "L640",
            "cod_istat": "013232",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 408,
            "giorni": 2709,
            "area": "",
            "ech": 0
        },
        {
            "id": 7640,
            "name": "Valmozzola",
            "provincia": "PR",
            "cap": "43050",
            "cod_catastale": "L641",
            "cod_istat": "034044",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 565,
            "giorni": 3180,
            "area": "",
            "ech": 0
        },
        {
            "id": 7641,
            "name": "Valnegra",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "L642",
            "cod_istat": "016227",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 581,
            "giorni": 2895,
            "area": "",
            "ech": 0
        },
        {
            "id": 7642,
            "name": "Valpelline",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "L643",
            "cod_istat": "007069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 960,
            "giorni": 3462,
            "area": "",
            "ech": 0
        },
        {
            "id": 7643,
            "name": "Valperga",
            "provincia": "TO",
            "cap": "10087",
            "cod_catastale": "L644",
            "cod_istat": "001287",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2722,
            "area": "",
            "ech": 0
        },
        {
            "id": 7644,
            "name": "Valprato Soana",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "B510",
            "cod_istat": "001288",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1113,
            "giorni": 3961,
            "area": "",
            "ech": 0
        },
        {
            "id": 7645,
            "name": "Valsavarenche",
            "provincia": "AO",
            "cap": "11010",
            "cod_catastale": "L647",
            "cod_istat": "007070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1541,
            "giorni": 4544,
            "area": "",
            "ech": 0
        },
        {
            "id": 7646,
            "name": "Valsecca",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "L649",
            "cod_istat": "016228",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 627,
            "giorni": 2960,
            "area": "",
            "ech": 0
        },
        {
            "id": 7647,
            "name": "Valsinni",
            "provincia": "MT",
            "cap": "75029",
            "cod_catastale": "D513",
            "cod_istat": "077030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 1462,
            "area": "",
            "ech": 0
        },
        {
            "id": 7648,
            "name": "Valsolda",
            "provincia": "CO",
            "cap": "22010",
            "cod_catastale": "C936",
            "cod_istat": "013234",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 7649,
            "name": "Valstagna",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "L650",
            "cod_istat": "024114",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 147,
            "giorni": 2502,
            "area": "",
            "ech": 0
        },
        {
            "id": 7650,
            "name": "Valstrona",
            "provincia": "VB",
            "cap": "28897",
            "cod_catastale": "L651",
            "cod_istat": "103069",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 525,
            "giorni": 2987,
            "area": "",
            "ech": 0
        },
        {
            "id": 7651,
            "name": "Valtopina",
            "provincia": "PG",
            "cap": "06030",
            "cod_catastale": "L653",
            "cod_istat": "054059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2162,
            "area": "",
            "ech": 0
        },
        {
            "id": 7652,
            "name": "Valtorta",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "L655",
            "cod_istat": "016229",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 935,
            "giorni": 3397,
            "area": "",
            "ech": 0
        },
        {
            "id": 7653,
            "name": "Valtournenche",
            "provincia": "AO",
            "cap": "11028",
            "cod_catastale": "L654",
            "cod_istat": "007071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1528,
            "giorni": 4524,
            "area": "",
            "ech": 0
        },
        {
            "id": 7654,
            "name": "Valva",
            "provincia": "SA",
            "cap": "84020",
            "cod_catastale": "L656",
            "cod_istat": "065155",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 510,
            "giorni": 1952,
            "area": "",
            "ech": 0
        },
        {
            "id": 7655,
            "name": "Valvasone",
            "provincia": "PN",
            "cap": "33098",
            "cod_catastale": "L657",
            "cod_istat": "093053",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 7656,
            "name": "Valverde",
            "provincia": "PV",
            "cap": "27050",
            "cod_catastale": "L659",
            "cod_istat": "087052",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 3165,
            "area": "",
            "ech": 0
        },
        {
            "id": 7657,
            "name": "Valverde",
            "provincia": "CT",
            "cap": "95028",
            "cod_catastale": "L658",
            "cod_istat": "087052",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 1150,
            "area": "",
            "ech": 1
        },
        {
            "id": 7658,
            "name": "Valvestino",
            "provincia": "BS",
            "cap": "25080",
            "cod_catastale": "L468",
            "cod_istat": "017194",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 3182,
            "area": "",
            "ech": 0
        },
        {
            "id": 7659,
            "name": "Vandoies",
            "provincia": "BZ",
            "cap": "39030",
            "cod_catastale": "L660",
            "cod_istat": "021110",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 755,
            "giorni": 3607,
            "area": "",
            "ech": 0
        },
        {
            "id": 7660,
            "name": "Vanzaghello",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "L664",
            "cod_istat": "015249",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2673,
            "area": "",
            "ech": 0
        },
        {
            "id": 7661,
            "name": "Vanzago",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "L665",
            "cod_istat": "015229",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2656,
            "area": "",
            "ech": 0
        },
        {
            "id": 7662,
            "name": "Vanzone con San Carlo",
            "provincia": "VB",
            "cap": "28879",
            "cod_catastale": "L666",
            "cod_istat": "103070",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 677,
            "giorni": 3185,
            "area": "",
            "ech": 0
        },
        {
            "id": 7663,
            "name": "Vaprio d'Adda",
            "provincia": "MI",
            "cap": "20069",
            "cod_catastale": "L667",
            "cod_istat": "015230",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2471,
            "area": "",
            "ech": 0
        },
        {
            "id": 7664,
            "name": "Vaprio d'Agogna",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "L668",
            "cod_istat": "003153",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 7665,
            "name": "Varallo",
            "provincia": "VC",
            "cap": "13019",
            "cod_catastale": "L669",
            "cod_istat": "002156",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 2855,
            "area": "",
            "ech": 0
        },
        {
            "id": 7666,
            "name": "Varallo Pombia",
            "provincia": "NO",
            "cap": "28040",
            "cod_catastale": "L670",
            "cod_istat": "003154",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 7667,
            "name": "Varano Borghi",
            "provincia": "VA",
            "cap": "21020",
            "cod_catastale": "L671",
            "cod_istat": "012132",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 281,
            "giorni": 2532,
            "area": "",
            "ech": 0
        },
        {
            "id": 7668,
            "name": "Varano de' Melegari",
            "provincia": "PR",
            "cap": "43040",
            "cod_catastale": "L672",
            "cod_istat": "034045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2700,
            "area": "",
            "ech": 0
        },
        {
            "id": 7669,
            "name": "Varapodio",
            "provincia": "RC",
            "cap": "89010",
            "cod_catastale": "L673",
            "cod_istat": "080095",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 231,
            "giorni": 1070,
            "area": "",
            "ech": 1
        },
        {
            "id": 7670,
            "name": "Varazze",
            "provincia": "SV",
            "cap": "17019",
            "cod_catastale": "L675",
            "cod_istat": "009065",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1499,
            "area": "",
            "ech": 0
        },
        {
            "id": 7671,
            "name": "Varco Sabino",
            "provincia": "RI",
            "cap": "02020",
            "cod_catastale": "L676",
            "cod_istat": "057073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 742,
            "giorni": 2715,
            "area": "",
            "ech": 0
        },
        {
            "id": 7672,
            "name": "Varedo",
            "provincia": "MB",
            "cap": "20814",
            "cod_catastale": "L677",
            "cod_istat": "108045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 2404,
            "area": "NORD",
            "ech": 0
        },
        {
            "id": 7673,
            "name": "Varena",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "L678",
            "cod_istat": "022211",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1180,
            "giorni": 4232,
            "area": "",
            "ech": 0
        },
        {
            "id": 7674,
            "name": "Varenna",
            "provincia": "LC",
            "cap": "23829",
            "cod_catastale": "L680",
            "cod_istat": "097084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2246,
            "area": "",
            "ech": 0
        },
        {
            "id": 7675,
            "name": "Varese",
            "provincia": "VA",
            "cap": "21100",
            "cod_catastale": "L682",
            "cod_istat": "012133",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 382,
            "giorni": 2652,
            "area": "",
            "ech": 0
        },
        {
            "id": 7676,
            "name": "Varese Ligure",
            "provincia": "SP",
            "cap": "19028",
            "cod_catastale": "L681",
            "cod_istat": "011029",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 1820,
            "area": "",
            "ech": 0
        },
        {
            "id": 7677,
            "name": "Varisella",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L685",
            "cod_istat": "001289",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 521,
            "giorni": 3206,
            "area": "",
            "ech": 0
        },
        {
            "id": 7678,
            "name": "Varmo",
            "provincia": "UD",
            "cap": "33030",
            "cod_catastale": "L686",
            "cod_istat": "030130",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2422,
            "area": "",
            "ech": 0
        },
        {
            "id": 7679,
            "name": "Varna",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "L687",
            "cod_istat": "021111",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 671,
            "giorni": 3482,
            "area": "",
            "ech": 0
        },
        {
            "id": 7680,
            "name": "Varsi",
            "provincia": "PR",
            "cap": "43049",
            "cod_catastale": "L689",
            "cod_istat": "034046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 412,
            "giorni": 2984,
            "area": "",
            "ech": 0
        },
        {
            "id": 7681,
            "name": "Varzi",
            "provincia": "PV",
            "cap": "27057",
            "cod_catastale": "L690",
            "cod_istat": "018171",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 416,
            "giorni": 2903,
            "area": "",
            "ech": 0
        },
        {
            "id": 7682,
            "name": "Varzo",
            "provincia": "VB",
            "cap": "28868",
            "cod_catastale": "L691",
            "cod_istat": "103071",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 568,
            "giorni": 3043,
            "area": "",
            "ech": 0
        },
        {
            "id": 7683,
            "name": "Vas",
            "provincia": "BL",
            "cap": "32030",
            "cod_catastale": "L692",
            "cod_istat": "025064",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 218,
            "giorni": 2928,
            "area": "",
            "ech": 0
        },
        {
            "id": 7684,
            "name": "Vasanello",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "A701",
            "cod_istat": "056055",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 265,
            "giorni": 1891,
            "area": "",
            "ech": 0
        },
        {
            "id": 7685,
            "name": "Vasia",
            "provincia": "IM",
            "cap": "18020",
            "cod_catastale": "L693",
            "cod_istat": "008064",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2114,
            "area": "",
            "ech": 0
        },
        {
            "id": 7686,
            "name": "Vasto",
            "provincia": "CH",
            "cap": "66054",
            "cod_catastale": "E372",
            "cod_istat": "069099",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 144,
            "giorni": 1451,
            "area": "CSUD",
            "ech": 0
        },
        {
            "id": 7687,
            "name": "Vastogirardi",
            "provincia": "IS",
            "cap": "86089",
            "cod_catastale": "L696",
            "cod_istat": "094051",
            "attivo": 1,
            "zona": "F",
            "cassa": 1,
            "altitudine": 1200,
            "giorni": 3131,
            "area": "",
            "ech": 0
        },
        {
            "id": 7688,
            "name": "Vattaro",
            "provincia": "TN",
            "cap": "38049",
            "cod_catastale": "L697",
            "cod_istat": "022212",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 689,
            "giorni": 3466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7689,
            "name": "Vauda Canavese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L698",
            "cod_istat": "001290",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 396,
            "giorni": 2948,
            "area": "",
            "ech": 0
        },
        {
            "id": 7690,
            "name": "Vazzano",
            "provincia": "VV",
            "cap": "89834",
            "cod_catastale": "L699",
            "cod_istat": "102046",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 357,
            "giorni": 1499,
            "area": "",
            "ech": 0
        },
        {
            "id": 7691,
            "name": "Vazzola",
            "provincia": "TV",
            "cap": "31028",
            "cod_catastale": "L700",
            "cod_istat": "026088",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 2398,
            "area": "",
            "ech": 0
        },
        {
            "id": 7692,
            "name": "Vecchiano",
            "provincia": "PI",
            "cap": "56019",
            "cod_catastale": "L702",
            "cod_istat": "050037",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 5,
            "giorni": 1600,
            "area": "",
            "ech": 0
        },
        {
            "id": 7693,
            "name": "Vedano al Lambro",
            "provincia": "MB",
            "cap": "20854",
            "cod_catastale": "L704",
            "cod_istat": "108046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 187,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7694,
            "name": "Vedano Olona",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "L703",
            "cod_istat": "012134",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 360,
            "giorni": 2641,
            "area": "",
            "ech": 0
        },
        {
            "id": 7695,
            "name": "Veddasca",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "L705",
            "cod_istat": "050040",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 896,
            "giorni": 3362,
            "area": "",
            "ech": 0
        },
        {
            "id": 7696,
            "name": "Vedelago",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "L706",
            "cod_istat": "026089",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2418,
            "area": "",
            "ech": 0
        },
        {
            "id": 7697,
            "name": "Vedeseta",
            "provincia": "BG",
            "cap": "24010",
            "cod_catastale": "L707",
            "cod_istat": "016230",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 820,
            "giorni": 3234,
            "area": "",
            "ech": 0
        },
        {
            "id": 7698,
            "name": "Veduggio con Colzano",
            "provincia": "MB",
            "cap": "20837",
            "cod_catastale": "L709",
            "cod_istat": "108047",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 305,
            "giorni": 2532,
            "area": "",
            "ech": 0
        },
        {
            "id": 7699,
            "name": "Veggiano",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "L710",
            "cod_istat": "028096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2344,
            "area": "",
            "ech": 0
        },
        {
            "id": 7700,
            "name": "Veglie",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "L711",
            "cod_istat": "075092",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 1137,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7701,
            "name": "Veglio",
            "provincia": "BI",
            "cap": "13824",
            "cod_catastale": "L712",
            "cod_istat": "096075",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 734,
            "giorni": 3259,
            "area": "",
            "ech": 0
        },
        {
            "id": 7702,
            "name": "Vejano",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "L713",
            "cod_istat": "056056",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2113,
            "area": "",
            "ech": 0
        },
        {
            "id": 7703,
            "name": "Veleso",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "L715",
            "cod_istat": "013236",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 826,
            "giorni": 3243,
            "area": "",
            "ech": 0
        },
        {
            "id": 7704,
            "name": "Velezzo Lomellina",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "L716",
            "cod_istat": "018172",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 98,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7705,
            "name": "Velletri",
            "provincia": "RM",
            "cap": "00049",
            "cod_catastale": "L719",
            "cod_istat": "058111",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 332,
            "giorni": 1544,
            "area": "",
            "ech": 0
        },
        {
            "id": 7706,
            "name": "Vellezzo Bellini",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "L720",
            "cod_istat": "018173",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 94,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7707,
            "name": "Velo d'Astico",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "L723",
            "cod_istat": "024115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 346,
            "giorni": 2862,
            "area": "",
            "ech": 0
        },
        {
            "id": 7708,
            "name": "Velo Veronese",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "L722",
            "cod_istat": "023090",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1087,
            "giorni": 4059,
            "area": "",
            "ech": 0
        },
        {
            "id": 7709,
            "name": "Velturno",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "L724",
            "cod_istat": "021116",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 851,
            "giorni": 3799,
            "area": "",
            "ech": 0
        },
        {
            "id": 7710,
            "name": "Venafro",
            "provincia": "IS",
            "cap": "86079",
            "cod_catastale": "L725",
            "cod_istat": "094052",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 1492,
            "area": "",
            "ech": 0
        },
        {
            "id": 7711,
            "name": "Venaria Reale",
            "provincia": "TO",
            "cap": "10078",
            "cod_catastale": "L727",
            "cod_istat": "001292",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7712,
            "name": "Venarotta",
            "provincia": "AP",
            "cap": "63091",
            "cod_catastale": "L728",
            "cod_istat": "044073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 421,
            "giorni": 2132,
            "area": "",
            "ech": 0
        },
        {
            "id": 7713,
            "name": "Venasca",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "L729",
            "cod_istat": "004237",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 2996,
            "area": "",
            "ech": 0
        },
        {
            "id": 7714,
            "name": "Venaus",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "L726",
            "cod_istat": "001291",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 604,
            "giorni": 3260,
            "area": "",
            "ech": 0
        },
        {
            "id": 7715,
            "name": "Vendone",
            "provincia": "SV",
            "cap": "17032",
            "cod_catastale": "L730",
            "cod_istat": "009066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 398,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 7716,
            "name": "Vendrogno",
            "provincia": "LC",
            "cap": "23838",
            "cod_catastale": "L731",
            "cod_istat": "097085",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 731,
            "giorni": 3108,
            "area": "",
            "ech": 0
        },
        {
            "id": 7717,
            "name": "Venegono Inferiore",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "L733",
            "cod_istat": "012136",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 7718,
            "name": "Venegono Superiore",
            "provincia": "VA",
            "cap": "21040",
            "cod_catastale": "L734",
            "cod_istat": "012137",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 331,
            "giorni": 2601,
            "area": "",
            "ech": 0
        },
        {
            "id": 7719,
            "name": "Venetico",
            "provincia": "ME",
            "cap": "98040",
            "cod_catastale": "L735",
            "cod_istat": "083104",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 6,
            "giorni": 831,
            "area": "",
            "ech": 1
        },
        {
            "id": 7720,
            "name": "Venezia",
            "provincia": "VE",
            "cap": "301xx",
            "cod_catastale": "L736",
            "cod_istat": "027042",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 1,
            "giorni": 2345,
            "area": "",
            "ech": 0
        },
        {
            "id": 7721,
            "name": "Veniano",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "L737",
            "cod_istat": "013238",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 316,
            "giorni": 2578,
            "area": "",
            "ech": 0
        },
        {
            "id": 7722,
            "name": "Venosa",
            "provincia": "PZ",
            "cap": "85029",
            "cod_catastale": "L738",
            "cod_istat": "076095",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 415,
            "giorni": 1663,
            "area": "",
            "ech": 0
        },
        {
            "id": 7723,
            "name": "Venticano",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "L739",
            "cod_istat": "064116",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 370,
            "giorni": 1864,
            "area": "",
            "ech": 0
        },
        {
            "id": 7724,
            "name": "Ventimiglia",
            "provincia": "IM",
            "cap": "18039",
            "cod_catastale": "L741",
            "cod_istat": "008065",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 1119,
            "area": "",
            "ech": 0
        },
        {
            "id": 7725,
            "name": "Ventimiglia di Sicilia",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "L740",
            "cod_istat": "082077",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 540,
            "giorni": 1561,
            "area": "",
            "ech": 0
        },
        {
            "id": 7726,
            "name": "Ventotene",
            "provincia": "LT",
            "cap": "04031",
            "cod_catastale": "L742",
            "cod_istat": "059033",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 1107,
            "area": "",
            "ech": 0
        },
        {
            "id": 7727,
            "name": "Venzone",
            "provincia": "UD",
            "cap": "33010",
            "cod_catastale": "L743",
            "cod_istat": "030131",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2596,
            "area": "",
            "ech": 0
        },
        {
            "id": 7728,
            "name": "Verano",
            "provincia": "BZ",
            "cap": "39010",
            "cod_catastale": "L745",
            "cod_istat": "021112",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1204,
            "giorni": 4314,
            "area": "",
            "ech": 0
        },
        {
            "id": 7729,
            "name": "Verano Brianza",
            "provincia": "MB",
            "cap": "20843",
            "cod_catastale": "L744",
            "cod_istat": "108048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 264,
            "giorni": 2537,
            "area": "",
            "ech": 0
        },
        {
            "id": 7730,
            "name": "Verbania",
            "provincia": "VB",
            "cap": "289xx",
            "cod_catastale": "L746",
            "cod_istat": "103072",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 197,
            "giorni": 2426,
            "area": "",
            "ech": 0
        },
        {
            "id": 7731,
            "name": "Verbicaro",
            "provincia": "CS",
            "cap": "87020",
            "cod_catastale": "L747",
            "cod_istat": "078153",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 428,
            "giorni": 1662,
            "area": "",
            "ech": 1
        },
        {
            "id": 7732,
            "name": "Vercana",
            "provincia": "CO",
            "cap": "22013",
            "cod_catastale": "L748",
            "cod_istat": "013239",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 345,
            "giorni": 2559,
            "area": "",
            "ech": 0
        },
        {
            "id": 7733,
            "name": "Verceia",
            "provincia": "SO",
            "cap": "23020",
            "cod_catastale": "L749",
            "cod_istat": "014075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 200,
            "giorni": 2354,
            "area": "",
            "ech": 0
        },
        {
            "id": 7734,
            "name": "Vercelli",
            "provincia": "VC",
            "cap": "13100",
            "cod_catastale": "L750",
            "cod_istat": "002158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 2751,
            "area": "",
            "ech": 0
        },
        {
            "id": 7735,
            "name": "Vercurago",
            "provincia": "LC",
            "cap": "23808",
            "cod_catastale": "L751",
            "cod_istat": "097086",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7736,
            "name": "Verdellino",
            "provincia": "BG",
            "cap": "24040",
            "cod_catastale": "L752",
            "cod_istat": "016232",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 172,
            "giorni": 2340,
            "area": "",
            "ech": 0
        },
        {
            "id": 7737,
            "name": "Verdello",
            "provincia": "BG",
            "cap": "24049",
            "cod_catastale": "L753",
            "cod_istat": "016233",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 2369,
            "area": "",
            "ech": 0
        },
        {
            "id": 7738,
            "name": "Verderio Inferiore",
            "provincia": "LC",
            "cap": "23879",
            "cod_catastale": "L755",
            "cod_istat": "097087",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 7739,
            "name": "Verderio Superiore",
            "provincia": "LC",
            "cap": "23878",
            "cod_catastale": "L756",
            "cod_istat": "097088",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 250,
            "giorni": 2425,
            "area": "",
            "ech": 0
        },
        {
            "id": 7740,
            "name": "Verduno",
            "provincia": "CN",
            "cap": "12060",
            "cod_catastale": "L758",
            "cod_istat": "004238",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2727,
            "area": "",
            "ech": 0
        },
        {
            "id": 7741,
            "name": "Vergato",
            "provincia": "BO",
            "cap": "40038",
            "cod_catastale": "L762",
            "cod_istat": "037059",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 7742,
            "name": "Vergemoli",
            "provincia": "LU",
            "cap": "55020",
            "cod_catastale": "L763",
            "cod_istat": "046036",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 619,
            "giorni": 2988,
            "area": "",
            "ech": 0
        },
        {
            "id": 7743,
            "name": "Verghereto",
            "provincia": "FC",
            "cap": "47028",
            "cod_catastale": "L764",
            "cod_istat": "040050",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 812,
            "giorni": 3153,
            "area": "",
            "ech": 0
        },
        {
            "id": 7744,
            "name": "Vergiate",
            "provincia": "VA",
            "cap": "21029",
            "cod_catastale": "L765",
            "cod_istat": "012138",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 270,
            "giorni": 2498,
            "area": "",
            "ech": 0
        },
        {
            "id": 7745,
            "name": "Vermezzo",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "L768",
            "cod_istat": "015251",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 119,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 7746,
            "name": "Vermiglio",
            "provincia": "TN",
            "cap": "38029",
            "cod_catastale": "L769",
            "cod_istat": "022213",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1261,
            "giorni": 4358,
            "area": "",
            "ech": 0
        },
        {
            "id": 7747,
            "name": "Vernante",
            "provincia": "CN",
            "cap": "12019",
            "cod_catastale": "L771",
            "cod_istat": "004239",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 799,
            "giorni": 3306,
            "area": "",
            "ech": 0
        },
        {
            "id": 7748,
            "name": "Vernasca",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "L772",
            "cod_istat": "033044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2979,
            "area": "",
            "ech": 0
        },
        {
            "id": 7749,
            "name": "Vernate",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "L773",
            "cod_istat": "015236",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 7750,
            "name": "Vernazza",
            "provincia": "SP",
            "cap": "19018",
            "cod_catastale": "L774",
            "cod_istat": "011030",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 1413,
            "area": "",
            "ech": 0
        },
        {
            "id": 7751,
            "name": "Vernio",
            "provincia": "PO",
            "cap": "59024",
            "cod_catastale": "L775",
            "cod_istat": "100007",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2190,
            "area": "",
            "ech": 0
        },
        {
            "id": 7752,
            "name": "Vernole",
            "provincia": "LE",
            "cap": "73029",
            "cod_catastale": "L776",
            "cod_istat": "075093",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 38,
            "giorni": 1104,
            "area": "",
            "ech": 0
        },
        {
            "id": 7753,
            "name": "Verolanuova",
            "provincia": "BS",
            "cap": "25028",
            "cod_catastale": "L777",
            "cod_istat": "017195",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2403,
            "area": "",
            "ech": 0
        },
        {
            "id": 7754,
            "name": "Verolavecchia",
            "provincia": "BS",
            "cap": "25029",
            "cod_catastale": "L778",
            "cod_istat": "017196",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2479,
            "area": "",
            "ech": 0
        },
        {
            "id": 7755,
            "name": "Verolengo",
            "provincia": "TO",
            "cap": "10038",
            "cod_catastale": "L779",
            "cod_istat": "001293",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 169,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 7756,
            "name": "Veroli",
            "provincia": "FR",
            "cap": "03029",
            "cod_catastale": "L780",
            "cod_istat": "060085",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 594,
            "giorni": 2281,
            "area": "",
            "ech": 0
        },
        {
            "id": 7757,
            "name": "Verona",
            "provincia": "VR",
            "cap": "371xx",
            "cod_catastale": "L781",
            "cod_istat": "023091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 59,
            "giorni": 2468,
            "area": "",
            "ech": 0
        },
        {
            "id": 7758,
            "name": "Veronella",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "D193",
            "cod_istat": "023092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 21,
            "giorni": 2427,
            "area": "",
            "ech": 0
        },
        {
            "id": 7759,
            "name": "Verrayes",
            "provincia": "AO",
            "cap": "11020",
            "cod_catastale": "L783",
            "cod_istat": "007072",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1017,
            "giorni": 3744,
            "area": "",
            "ech": 0
        },
        {
            "id": 7760,
            "name": "Verrès",
            "provincia": "AO",
            "cap": "11029",
            "cod_catastale": "C282",
            "cod_istat": "007073",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 391,
            "giorni": 2793,
            "area": "",
            "ech": 0
        },
        {
            "id": 7761,
            "name": "Verretto",
            "provincia": "PV",
            "cap": "27053",
            "cod_catastale": "L784",
            "cod_istat": "018174",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 78,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7762,
            "name": "Verrone",
            "provincia": "BI",
            "cap": "13871",
            "cod_catastale": "L785",
            "cod_istat": "096076",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 277,
            "giorni": 2665,
            "area": "",
            "ech": 0
        },
        {
            "id": 7763,
            "name": "Verrua Po",
            "provincia": "PV",
            "cap": "27040",
            "cod_catastale": "L788",
            "cod_istat": "018175",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 64,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7764,
            "name": "Verrua Savoia",
            "provincia": "TO",
            "cap": "10020",
            "cod_catastale": "L787",
            "cod_istat": "001294",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2784,
            "area": "",
            "ech": 0
        },
        {
            "id": 7765,
            "name": "Vertemate con Minoprio",
            "provincia": "CO",
            "cap": "22070",
            "cod_catastale": "L792",
            "cod_istat": "013242",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2555,
            "area": "",
            "ech": 0
        },
        {
            "id": 7766,
            "name": "Vertova",
            "provincia": "BG",
            "cap": "24029",
            "cod_catastale": "L795",
            "cod_istat": "016234",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 397,
            "giorni": 2607,
            "area": "",
            "ech": 0
        },
        {
            "id": 7767,
            "name": "Verucchio",
            "provincia": "RN",
            "cap": "47826",
            "cod_catastale": "L797",
            "cod_istat": "099020",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2534,
            "area": "",
            "ech": 0
        },
        {
            "id": 7768,
            "name": "Veruno",
            "provincia": "NO",
            "cap": "28010",
            "cod_catastale": "L798",
            "cod_istat": "003157",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2769,
            "area": "",
            "ech": 0
        },
        {
            "id": 7769,
            "name": "Vervio",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "L799",
            "cod_istat": "014076",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 3030,
            "area": "",
            "ech": 0
        },
        {
            "id": 7770,
            "name": "Vervò",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "L800",
            "cod_istat": "022214",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 886,
            "giorni": 3773,
            "area": "",
            "ech": 0
        },
        {
            "id": 7771,
            "name": "Verzegnis",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "L801",
            "cod_istat": "030132",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 407,
            "giorni": 3192,
            "area": "",
            "ech": 0
        },
        {
            "id": 7772,
            "name": "Verzino",
            "provincia": "KR",
            "cap": "88819",
            "cod_catastale": "L802",
            "cod_istat": "101027",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 549,
            "giorni": 1888,
            "area": "",
            "ech": 1
        },
        {
            "id": 7773,
            "name": "Verzuolo",
            "provincia": "CN",
            "cap": "12039",
            "cod_catastale": "L804",
            "cod_istat": "004240",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 420,
            "giorni": 2834,
            "area": "",
            "ech": 0
        },
        {
            "id": 7774,
            "name": "Vescovana",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "L805",
            "cod_istat": "028097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7775,
            "name": "Vescovato",
            "provincia": "CR",
            "cap": "26039",
            "cod_catastale": "L806",
            "cod_istat": "019113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 46,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7776,
            "name": "Vesime",
            "provincia": "AT",
            "cap": "14059",
            "cod_catastale": "L807",
            "cod_istat": "005113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 225,
            "giorni": 2671,
            "area": "",
            "ech": 0
        },
        {
            "id": 7777,
            "name": "Vespolate",
            "provincia": "NO",
            "cap": "28079",
            "cod_catastale": "L808",
            "cod_istat": "003158",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 123,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 7778,
            "name": "Vessalico",
            "provincia": "IM",
            "cap": "18026",
            "cod_catastale": "L809",
            "cod_istat": "008066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 192,
            "giorni": 2220,
            "area": "",
            "ech": 0
        },
        {
            "id": 7779,
            "name": "Vestenanova",
            "provincia": "VR",
            "cap": "37030",
            "cod_catastale": "L810",
            "cod_istat": "023093",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 515,
            "giorni": 3132,
            "area": "",
            "ech": 0
        },
        {
            "id": 7780,
            "name": "Vestignè",
            "provincia": "TO",
            "cap": "10030",
            "cod_catastale": "L811",
            "cod_istat": "001295",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 235,
            "giorni": 2710,
            "area": "",
            "ech": 0
        },
        {
            "id": 7781,
            "name": "Vestone",
            "provincia": "BS",
            "cap": "25078",
            "cod_catastale": "L812",
            "cod_istat": "017197",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 319,
            "giorni": 2664,
            "area": "",
            "ech": 0
        },
        {
            "id": 7782,
            "name": "Vestreno",
            "provincia": "LC",
            "cap": "23822",
            "cod_catastale": "L813",
            "cod_istat": "097089",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 587,
            "giorni": 2903,
            "area": "",
            "ech": 0
        },
        {
            "id": 7783,
            "name": "Vetralla",
            "provincia": "VT",
            "cap": "01019",
            "cod_catastale": "L814",
            "cod_istat": "056057",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1953,
            "area": "",
            "ech": 0
        },
        {
            "id": 7784,
            "name": "Vetto",
            "provincia": "RE",
            "cap": "42020",
            "cod_catastale": "L815",
            "cod_istat": "035042",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 447,
            "giorni": 3117,
            "area": "",
            "ech": 0
        },
        {
            "id": 7785,
            "name": "Vezza d'Alba",
            "provincia": "CN",
            "cap": "12040",
            "cod_catastale": "L817",
            "cod_istat": "004241",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 353,
            "giorni": 2753,
            "area": "",
            "ech": 0
        },
        {
            "id": 7786,
            "name": "Vezza d'Oglio",
            "provincia": "BS",
            "cap": "25059",
            "cod_catastale": "L816",
            "cod_istat": "017198",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1080,
            "giorni": 3754,
            "area": "",
            "ech": 0
        },
        {
            "id": 7787,
            "name": "Vezzano",
            "provincia": "TN",
            "cap": "38070",
            "cod_catastale": "L821",
            "cod_istat": "022215",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 385,
            "giorni": 2991,
            "area": "",
            "ech": 0
        },
        {
            "id": 7788,
            "name": "Vezzano Ligure",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "L819",
            "cod_istat": "011031",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 271,
            "giorni": 1758,
            "area": "",
            "ech": 0
        },
        {
            "id": 7789,
            "name": "Vezzano sul Crostolo",
            "provincia": "RE",
            "cap": "42030",
            "cod_catastale": "L820",
            "cod_istat": "035043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2503,
            "area": "",
            "ech": 0
        },
        {
            "id": 7790,
            "name": "Vezzi Portio",
            "provincia": "SV",
            "cap": "17028",
            "cod_catastale": "L823",
            "cod_istat": "009067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2009,
            "area": "",
            "ech": 0
        },
        {
            "id": 7791,
            "name": "Viadana",
            "provincia": "MN",
            "cap": "46019",
            "cod_catastale": "L826",
            "cod_istat": "020066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2435,
            "area": "",
            "ech": 0
        },
        {
            "id": 7792,
            "name": "Viadanica",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L827",
            "cod_istat": "016235",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 336,
            "giorni": 2547,
            "area": "",
            "ech": 0
        },
        {
            "id": 7793,
            "name": "Viagrande",
            "provincia": "CT",
            "cap": "95029",
            "cod_catastale": "L828",
            "cod_istat": "087053",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 1260,
            "area": "",
            "ech": 1
        },
        {
            "id": 7794,
            "name": "Viale",
            "provincia": "AT",
            "cap": "14010",
            "cod_catastale": "L829",
            "cod_istat": "005114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 261,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 7795,
            "name": "Vialfrè",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "L830",
            "cod_istat": "001296",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 470,
            "giorni": 2909,
            "area": "",
            "ech": 0
        },
        {
            "id": 7796,
            "name": "Viano",
            "provincia": "RE",
            "cap": "42030",
            "cod_catastale": "L831",
            "cod_istat": "035044",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2642,
            "area": "",
            "ech": 0
        },
        {
            "id": 7797,
            "name": "Viareggio",
            "provincia": "LU",
            "cap": "55049",
            "cod_catastale": "L833",
            "cod_istat": "046033",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1416,
            "area": "CNOR",
            "ech": 0
        },
        {
            "id": 7798,
            "name": "Viarigi",
            "provincia": "AT",
            "cap": "14030",
            "cod_catastale": "L834",
            "cod_istat": "005115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 252,
            "giorni": 2694,
            "area": "",
            "ech": 0
        },
        {
            "id": 7799,
            "name": "Vibo Valentia",
            "provincia": "VV",
            "cap": "89900",
            "cod_catastale": "F537",
            "cod_istat": "102047",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 476,
            "giorni": 1586,
            "area": "",
            "ech": 0
        },
        {
            "id": 7800,
            "name": "Vibonati",
            "provincia": "SA",
            "cap": "84079",
            "cod_catastale": "L835",
            "cod_istat": "065156",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 110,
            "giorni": 1069,
            "area": "",
            "ech": 0
        },
        {
            "id": 7801,
            "name": "Vicalvi",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "L836",
            "cod_istat": "060086",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 590,
            "giorni": 2148,
            "area": "",
            "ech": 0
        },
        {
            "id": 7802,
            "name": "Vicari",
            "provincia": "PA",
            "cap": "90020",
            "cod_catastale": "L837",
            "cod_istat": "082078",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 700,
            "giorni": 1719,
            "area": "",
            "ech": 0
        },
        {
            "id": 7803,
            "name": "Vicchio",
            "provincia": "FI",
            "cap": "50039",
            "cod_catastale": "L838",
            "cod_istat": "048049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 2137,
            "area": "",
            "ech": 0
        },
        {
            "id": 7804,
            "name": "Vicenza",
            "provincia": "VI",
            "cap": "36100",
            "cod_catastale": "L840",
            "cod_istat": "024116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 39,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 7805,
            "name": "Vico Canavese",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "L548",
            "cod_istat": "001297",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 738,
            "giorni": 3348,
            "area": "",
            "ech": 0
        },
        {
            "id": 7806,
            "name": "Vico del Gargano",
            "provincia": "FG",
            "cap": "71018",
            "cod_catastale": "L842",
            "cod_istat": "071059",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 445,
            "giorni": 1974,
            "area": "",
            "ech": 0
        },
        {
            "id": 7807,
            "name": "Vico Equense",
            "provincia": "NA",
            "cap": "80069",
            "cod_catastale": "L845",
            "cod_istat": "063086",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1174,
            "area": "",
            "ech": 0
        },
        {
            "id": 7808,
            "name": "Vico nel Lazio",
            "provincia": "FR",
            "cap": "03010",
            "cod_catastale": "L843",
            "cod_istat": "060087",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 721,
            "giorni": 2418,
            "area": "",
            "ech": 0
        },
        {
            "id": 7809,
            "name": "Vicoforte",
            "provincia": "CN",
            "cap": "12080",
            "cod_catastale": "L841",
            "cod_istat": "004242",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 598,
            "giorni": 2891,
            "area": "",
            "ech": 0
        },
        {
            "id": 7810,
            "name": "Vicoli",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "L846",
            "cod_istat": "068045",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 445,
            "giorni": 1927,
            "area": "",
            "ech": 0
        },
        {
            "id": 7811,
            "name": "Vicolungo",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "L847",
            "cod_istat": "003159",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2478,
            "area": "",
            "ech": 0
        },
        {
            "id": 7812,
            "name": "Vicopisano",
            "provincia": "PI",
            "cap": "56010",
            "cod_catastale": "L850",
            "cod_istat": "050038",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 1858,
            "area": "",
            "ech": 0
        },
        {
            "id": 7813,
            "name": "Vicovaro",
            "provincia": "RM",
            "cap": "00029",
            "cod_catastale": "L851",
            "cod_istat": "058112",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 1891,
            "area": "",
            "ech": 0
        },
        {
            "id": 7814,
            "name": "Viddalba",
            "provincia": "SS",
            "cap": "07030",
            "cod_catastale": "M259",
            "cod_istat": "090082",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 30,
            "giorni": 863,
            "area": "",
            "ech": 0
        },
        {
            "id": 7815,
            "name": "Vidigulfo",
            "provincia": "PV",
            "cap": "27018",
            "cod_catastale": "L854",
            "cod_istat": "018176",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 88,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 7816,
            "name": "Vidor",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "L856",
            "cod_istat": "026090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 152,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 7817,
            "name": "Vidracco",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "L857",
            "cod_istat": "001298",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 481,
            "giorni": 2922,
            "area": "",
            "ech": 0
        },
        {
            "id": 7818,
            "name": "Vieste",
            "provincia": "FG",
            "cap": "71019",
            "cod_catastale": "L858",
            "cod_istat": "071060",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 43,
            "giorni": 1239,
            "area": "SUD",
            "ech": 0
        },
        {
            "id": 7819,
            "name": "Vietri di Potenza",
            "provincia": "PZ",
            "cap": "85058",
            "cod_catastale": "L859",
            "cod_istat": "076096",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 405,
            "giorni": 1645,
            "area": "",
            "ech": 0
        },
        {
            "id": 7820,
            "name": "Vietri sul Mare",
            "provincia": "SA",
            "cap": "84019",
            "cod_catastale": "L860",
            "cod_istat": "065157",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 80,
            "giorni": 1087,
            "area": "",
            "ech": 0
        },
        {
            "id": 7821,
            "name": "Viganella",
            "provincia": "VB",
            "cap": "28841",
            "cod_catastale": "L864",
            "cod_istat": "103073",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 582,
            "giorni": 3061,
            "area": "",
            "ech": 0
        },
        {
            "id": 7822,
            "name": "Viganò",
            "provincia": "LC",
            "cap": "23897",
            "cod_catastale": "L866",
            "cod_istat": "097090",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 390,
            "giorni": 2623,
            "area": "",
            "ech": 0
        },
        {
            "id": 7823,
            "name": "Vigano San Martino",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L865",
            "cod_istat": "016236",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 2585,
            "area": "",
            "ech": 0
        },
        {
            "id": 7824,
            "name": "Vigarano Mainarda",
            "provincia": "FE",
            "cap": "44049",
            "cod_catastale": "L868",
            "cod_istat": "038022",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2327,
            "area": "",
            "ech": 0
        },
        {
            "id": 7825,
            "name": "Vigasio",
            "provincia": "VR",
            "cap": "37068",
            "cod_catastale": "L869",
            "cod_istat": "023094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 7826,
            "name": "Vigevano",
            "provincia": "PV",
            "cap": "27029",
            "cod_catastale": "L872",
            "cod_istat": "018177",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 116,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 7827,
            "name": "Viggianello",
            "provincia": "PZ",
            "cap": "85040",
            "cod_catastale": "L873",
            "cod_istat": "076097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 500,
            "giorni": 2102,
            "area": "",
            "ech": 0
        },
        {
            "id": 7828,
            "name": "Viggiano",
            "provincia": "PZ",
            "cap": "85059",
            "cod_catastale": "L874",
            "cod_istat": "076098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 975,
            "giorni": 2683,
            "area": "",
            "ech": 0
        },
        {
            "id": 7829,
            "name": "Viggiù",
            "provincia": "VA",
            "cap": "21059",
            "cod_catastale": "L876",
            "cod_istat": "012139",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 482,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 7830,
            "name": "Vighizzolo d'Este",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "L878",
            "cod_istat": "028098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2421,
            "area": "",
            "ech": 0
        },
        {
            "id": 7831,
            "name": "Vigliano Biellese",
            "provincia": "BI",
            "cap": "13856",
            "cod_catastale": "L880",
            "cod_istat": "096077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 312,
            "giorni": 2710,
            "area": "",
            "ech": 0
        },
        {
            "id": 7832,
            "name": "Vigliano d'Asti",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "L879",
            "cod_istat": "005116",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 279,
            "giorni": 2529,
            "area": "",
            "ech": 0
        },
        {
            "id": 7833,
            "name": "Vignale Monferrato",
            "provincia": "AL",
            "cap": "15049",
            "cod_catastale": "L881",
            "cod_istat": "006179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 308,
            "giorni": 2741,
            "area": "",
            "ech": 0
        },
        {
            "id": 7834,
            "name": "Vignanello",
            "provincia": "VT",
            "cap": "01039",
            "cod_catastale": "L882",
            "cod_istat": "056058",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 369,
            "giorni": 2076,
            "area": "",
            "ech": 0
        },
        {
            "id": 7835,
            "name": "Vignate",
            "provincia": "MI",
            "cap": "20060",
            "cod_catastale": "L883",
            "cod_istat": "015237",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 121,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 7836,
            "name": "Vignola",
            "provincia": "MO",
            "cap": "41058",
            "cod_catastale": "L885",
            "cod_istat": "036046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 125,
            "giorni": 2322,
            "area": "",
            "ech": 0
        },
        {
            "id": 7837,
            "name": "Vignola-Falesina",
            "provincia": "TN",
            "cap": "38057",
            "cod_catastale": "L886",
            "cod_istat": "022216",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 984,
            "giorni": 3926,
            "area": "",
            "ech": 0
        },
        {
            "id": 7838,
            "name": "Vignole Borbera",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "L887",
            "cod_istat": "006180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2660,
            "area": "",
            "ech": 0
        },
        {
            "id": 7839,
            "name": "Vignolo",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "L888",
            "cod_istat": "004243",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 630,
            "giorni": 3096,
            "area": "",
            "ech": 0
        },
        {
            "id": 7840,
            "name": "Vignone",
            "provincia": "VB",
            "cap": "28819",
            "cod_catastale": "L889",
            "cod_istat": "103074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 449,
            "giorni": 2888,
            "area": "",
            "ech": 0
        },
        {
            "id": 7841,
            "name": "Vigo di Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "L890",
            "cod_istat": "025065",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 951,
            "giorni": 4086,
            "area": "",
            "ech": 0
        },
        {
            "id": 7842,
            "name": "Vigo di Fassa",
            "provincia": "TN",
            "cap": "38039",
            "cod_catastale": "L893",
            "cod_istat": "022217",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1382,
            "giorni": 4789,
            "area": "",
            "ech": 0
        },
        {
            "id": 7843,
            "name": "Vigo Rendena",
            "provincia": "TN",
            "cap": "38080",
            "cod_catastale": "L903",
            "cod_istat": "022220",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 612,
            "giorni": 3345,
            "area": "",
            "ech": 0
        },
        {
            "id": 7844,
            "name": "Vigodarzere",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L892",
            "cod_istat": "028099",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 2383,
            "area": "",
            "ech": 0
        },
        {
            "id": 7845,
            "name": "Vigolo",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "L894",
            "cod_istat": "016237",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 616,
            "giorni": 2944,
            "area": "",
            "ech": 0
        },
        {
            "id": 7846,
            "name": "Vigolo Vattaro",
            "provincia": "TN",
            "cap": "38049",
            "cod_catastale": "L896",
            "cod_istat": "022219",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 725,
            "giorni": 3522,
            "area": "",
            "ech": 0
        },
        {
            "id": 7847,
            "name": "Vigolzone",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "L897",
            "cod_istat": "033045",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 165,
            "giorni": 2668,
            "area": "",
            "ech": 0
        },
        {
            "id": 7848,
            "name": "Vigone",
            "provincia": "TO",
            "cap": "10067",
            "cod_catastale": "L898",
            "cod_istat": "001299",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2643,
            "area": "",
            "ech": 0
        },
        {
            "id": 7849,
            "name": "Vigonovo",
            "provincia": "VE",
            "cap": "30030",
            "cod_catastale": "L899",
            "cod_istat": "027043",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7850,
            "name": "Vigonza",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L900",
            "cod_istat": "028100",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2423,
            "area": "",
            "ech": 0
        },
        {
            "id": 7851,
            "name": "Viguzzolo",
            "provincia": "AL",
            "cap": "15058",
            "cod_catastale": "L904",
            "cod_istat": "006181",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2522,
            "area": "",
            "ech": 0
        },
        {
            "id": 7852,
            "name": "Villa Agnedo",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "L910",
            "cod_istat": "022221",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 356,
            "giorni": 2946,
            "area": "",
            "ech": 0
        },
        {
            "id": 7853,
            "name": "Villa Bartolomea",
            "provincia": "VR",
            "cap": "37049",
            "cod_catastale": "L912",
            "cod_istat": "023095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 14,
            "giorni": 2320,
            "area": "",
            "ech": 0
        },
        {
            "id": 7854,
            "name": "Villa Basilica",
            "provincia": "LU",
            "cap": "55019",
            "cod_catastale": "L913",
            "cod_istat": "046034",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 7855,
            "name": "Villa Biscossi",
            "provincia": "PV",
            "cap": "27035",
            "cod_catastale": "L917",
            "cod_istat": "018178",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7856,
            "name": "Villa Carcina",
            "provincia": "BS",
            "cap": "25069",
            "cod_catastale": "L919",
            "cod_istat": "017199",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 2554,
            "area": "",
            "ech": 0
        },
        {
            "id": 7857,
            "name": "Villa Castelli",
            "provincia": "BR",
            "cap": "72029",
            "cod_catastale": "L920",
            "cod_istat": "074020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 1466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7858,
            "name": "Villa Celiera",
            "provincia": "PE",
            "cap": "65010",
            "cod_catastale": "L922",
            "cod_istat": "068046",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 714,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 7859,
            "name": "Villa Collemandina",
            "provincia": "LU",
            "cap": "55030",
            "cod_catastale": "L926",
            "cod_istat": "046035",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 549,
            "giorni": 2792,
            "area": "",
            "ech": 0
        },
        {
            "id": 7860,
            "name": "Villa Cortese",
            "provincia": "MI",
            "cap": "20020",
            "cod_catastale": "L928",
            "cod_istat": "015248",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 190,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 7861,
            "name": "Villa d'Adda",
            "provincia": "BG",
            "cap": "24030",
            "cod_catastale": "L929",
            "cod_istat": "016238",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 286,
            "giorni": 2476,
            "area": "",
            "ech": 0
        },
        {
            "id": 7862,
            "name": "Villa d'Almè",
            "provincia": "BG",
            "cap": "24018",
            "cod_catastale": "A215",
            "cod_istat": "016239",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 300,
            "giorni": 2496,
            "area": "",
            "ech": 0
        },
        {
            "id": 7863,
            "name": "Villa del Bosco",
            "provincia": "BI",
            "cap": "13868",
            "cod_catastale": "L933",
            "cod_istat": "096078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 293,
            "giorni": 2541,
            "area": "",
            "ech": 0
        },
        {
            "id": 7864,
            "name": "Villa del Conte",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L934",
            "cod_istat": "028101",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 2431,
            "area": "",
            "ech": 0
        },
        {
            "id": 7865,
            "name": "Villa di Briano",
            "provincia": "CE",
            "cap": "81030",
            "cod_catastale": "D801",
            "cod_istat": "061098",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 28,
            "giorni": 1097,
            "area": "",
            "ech": 0
        },
        {
            "id": 7866,
            "name": "Villa di Chiavenna",
            "provincia": "SO",
            "cap": "23029",
            "cod_catastale": "L907",
            "cod_istat": "014077",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 633,
            "giorni": 3065,
            "area": "",
            "ech": 0
        },
        {
            "id": 7867,
            "name": "Villa di Serio",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "L936",
            "cod_istat": "016240",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 275,
            "giorni": 2460,
            "area": "",
            "ech": 0
        },
        {
            "id": 7868,
            "name": "Villa di Tirano",
            "provincia": "SO",
            "cap": "23030",
            "cod_catastale": "L908",
            "cod_istat": "014078",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 400,
            "giorni": 2646,
            "area": "",
            "ech": 0
        },
        {
            "id": 7869,
            "name": "Villa d'Ogna",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "L938",
            "cod_istat": "016241",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 542,
            "giorni": 2839,
            "area": "",
            "ech": 0
        },
        {
            "id": 7870,
            "name": "Villa Estense",
            "provincia": "PD",
            "cap": "35040",
            "cod_catastale": "L937",
            "cod_istat": "028102",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 7871,
            "name": "Villa Faraldi",
            "provincia": "IM",
            "cap": "18010",
            "cod_catastale": "L943",
            "cod_istat": "008067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 336,
            "giorni": 1992,
            "area": "",
            "ech": 0
        },
        {
            "id": 7872,
            "name": "Villa Guardia",
            "provincia": "CO",
            "cap": "22079",
            "cod_catastale": "L956",
            "cod_istat": "013245",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 350,
            "giorni": 2627,
            "area": "",
            "ech": 0
        },
        {
            "id": 7873,
            "name": "Villa Lagarina",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "L957",
            "cod_istat": "022222",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 180,
            "giorni": 2675,
            "area": "",
            "ech": 0
        },
        {
            "id": 7874,
            "name": "Villa Latina",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "A081",
            "cod_istat": "060088",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 415,
            "giorni": 2107,
            "area": "",
            "ech": 0
        },
        {
            "id": 7875,
            "name": "Villa Literno",
            "provincia": "CE",
            "cap": "81039",
            "cod_catastale": "L844",
            "cod_istat": "061099",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 10,
            "giorni": 1082,
            "area": "",
            "ech": 0
        },
        {
            "id": 7876,
            "name": "Villa Minozzo",
            "provincia": "RE",
            "cap": "42030",
            "cod_catastale": "L969",
            "cod_istat": "035045",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 680,
            "giorni": 3153,
            "area": "",
            "ech": 0
        },
        {
            "id": 7877,
            "name": "Villa Poma",
            "provincia": "MN",
            "cap": "46020",
            "cod_catastale": "F804",
            "cod_istat": "020067",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 13,
            "giorni": 2371,
            "area": "",
            "ech": 0
        },
        {
            "id": 7878,
            "name": "Porte di Rendena",
            "provincia": "TN",
            "cap": "38094",
            "cod_catastale": "M358",
            "cod_istat": "022244",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 7879,
            "name": "Villa San Giovanni",
            "provincia": "RC",
            "cap": "89018",
            "cod_catastale": "M018",
            "cod_istat": "080096",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 15,
            "giorni": 775,
            "area": "",
            "ech": 0
        },
        {
            "id": 7880,
            "name": "Villa San Giovanni in Tuscia",
            "provincia": "VT",
            "cap": "01010",
            "cod_catastale": "H913",
            "cod_istat": "056046",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 1905,
            "area": "",
            "ech": 0
        },
        {
            "id": 7881,
            "name": "Villa San Pietro",
            "provincia": "CA",
            "cap": "09050",
            "cod_catastale": "I118",
            "cod_istat": "092099",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 37,
            "giorni": 983,
            "area": "",
            "ech": 0
        },
        {
            "id": 7882,
            "name": "Villa San Secondo",
            "provincia": "AT",
            "cap": "14020",
            "cod_catastale": "M019",
            "cod_istat": "005119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2723,
            "area": "",
            "ech": 0
        },
        {
            "id": 7883,
            "name": "Villa Santa Lucia",
            "provincia": "FR",
            "cap": "03030",
            "cod_catastale": "L905",
            "cod_istat": "060089",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 393,
            "giorni": 1726,
            "area": "",
            "ech": 0
        },
        {
            "id": 7884,
            "name": "Villa Santa Lucia degli Abruzzi",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "M021",
            "cod_istat": "066104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 850,
            "giorni": 2810,
            "area": "",
            "ech": 0
        },
        {
            "id": 7885,
            "name": "Villa Santa Maria",
            "provincia": "CH",
            "cap": "66047",
            "cod_catastale": "M022",
            "cod_istat": "069102",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 320,
            "giorni": 1676,
            "area": "",
            "ech": 0
        },
        {
            "id": 7886,
            "name": "Villa Sant'Angelo",
            "provincia": "AQ",
            "cap": "67020",
            "cod_catastale": "M023",
            "cod_istat": "066105",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 570,
            "giorni": 2309,
            "area": "",
            "ech": 0
        },
        {
            "id": 7887,
            "name": "Villa Sant'Antonio",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "I298",
            "cod_istat": "095048",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 249,
            "giorni": 1296,
            "area": "",
            "ech": 0
        },
        {
            "id": 7888,
            "name": "Villa Santina",
            "provincia": "UD",
            "cap": "33029",
            "cod_catastale": "L909",
            "cod_istat": "030133",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 363,
            "giorni": 3109,
            "area": "",
            "ech": 0
        },
        {
            "id": 7889,
            "name": "Villa Santo Stefano",
            "provincia": "FR",
            "cap": "03020",
            "cod_catastale": "I364",
            "cod_istat": "060090",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 205,
            "giorni": 1517,
            "area": "",
            "ech": 0
        },
        {
            "id": 7890,
            "name": "Villa Verde",
            "provincia": "OR",
            "cap": "09090",
            "cod_catastale": "A609",
            "cod_istat": "095073",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 1238,
            "area": "",
            "ech": 0
        },
        {
            "id": 7891,
            "name": "Villa Vicentina",
            "provincia": "UD",
            "cap": "33059",
            "cod_catastale": "M034",
            "cod_istat": "030134",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 2252,
            "area": "",
            "ech": 0
        },
        {
            "id": 7892,
            "name": "Villabassa",
            "provincia": "BZ",
            "cap": "39039",
            "cod_catastale": "L915",
            "cod_istat": "021113",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1158,
            "giorni": 4161,
            "area": "",
            "ech": 0
        },
        {
            "id": 7893,
            "name": "Villabate",
            "provincia": "PA",
            "cap": "90039",
            "cod_catastale": "L916",
            "cod_istat": "082079",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 47,
            "giorni": 766,
            "area": "",
            "ech": 0
        },
        {
            "id": 7894,
            "name": "Villachiara",
            "provincia": "BS",
            "cap": "25030",
            "cod_catastale": "L923",
            "cod_istat": "017200",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2320,
            "area": "",
            "ech": 0
        },
        {
            "id": 7895,
            "name": "Villacidro",
            "provincia": "SU",
            "cap": "09039",
            "cod_catastale": "L924",
            "cod_istat": "111096",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 267,
            "giorni": 1335,
            "area": "",
            "ech": 0
        },
        {
            "id": 7896,
            "name": "Villadeati",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "L931",
            "cod_istat": "006182",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2827,
            "area": "",
            "ech": 0
        },
        {
            "id": 7897,
            "name": "Villadose",
            "provincia": "RO",
            "cap": "45010",
            "cod_catastale": "L939",
            "cod_istat": "029048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7898,
            "name": "Villadossola",
            "provincia": "VB",
            "cap": "28844",
            "cod_catastale": "L906",
            "cod_istat": "103075",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 257,
            "giorni": 2523,
            "area": "",
            "ech": 0
        },
        {
            "id": 7899,
            "name": "Villafalletto",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "L942",
            "cod_istat": "004244",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 431,
            "giorni": 2955,
            "area": "",
            "ech": 0
        },
        {
            "id": 7900,
            "name": "Villafranca d'Asti",
            "provincia": "AT",
            "cap": "14018",
            "cod_catastale": "L945",
            "cod_istat": "005117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2686,
            "area": "",
            "ech": 0
        },
        {
            "id": 7901,
            "name": "Villafranca di Verona",
            "provincia": "VR",
            "cap": "37069",
            "cod_catastale": "L949",
            "cod_istat": "023096",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 54,
            "giorni": 2282,
            "area": "",
            "ech": 0
        },
        {
            "id": 7902,
            "name": "Villafranca in Lunigiana",
            "provincia": "MS",
            "cap": "54028",
            "cod_catastale": "L946",
            "cod_istat": "045016",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1887,
            "area": "",
            "ech": 0
        },
        {
            "id": 7903,
            "name": "Villafranca Padovana",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L947",
            "cod_istat": "028103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2368,
            "area": "",
            "ech": 0
        },
        {
            "id": 7904,
            "name": "Villafranca Piemonte",
            "provincia": "TO",
            "cap": "10068",
            "cod_catastale": "L948",
            "cod_istat": "001300",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 253,
            "giorni": 2620,
            "area": "",
            "ech": 0
        },
        {
            "id": 7905,
            "name": "Villafranca Sicula",
            "provincia": "AG",
            "cap": "92020",
            "cod_catastale": "L944",
            "cod_istat": "084043",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 330,
            "giorni": 1021,
            "area": "",
            "ech": 1
        },
        {
            "id": 7906,
            "name": "Villafranca Tirrena",
            "provincia": "ME",
            "cap": "98049",
            "cod_catastale": "L950",
            "cod_istat": "083105",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 664,
            "area": "",
            "ech": 0
        },
        {
            "id": 7907,
            "name": "Villafrati",
            "provincia": "PA",
            "cap": "90030",
            "cod_catastale": "L951",
            "cod_istat": "082080",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 1395,
            "area": "",
            "ech": 0
        },
        {
            "id": 7908,
            "name": "Villaga",
            "provincia": "VI",
            "cap": "36021",
            "cod_catastale": "L952",
            "cod_istat": "024117",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 45,
            "giorni": 2312,
            "area": "",
            "ech": 0
        },
        {
            "id": 7909,
            "name": "Villagrande Strisaili",
            "provincia": "NU",
            "cap": "08049",
            "cod_catastale": "L953",
            "cod_istat": "091101",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 700,
            "giorni": 1895,
            "area": "",
            "ech": 1
        },
        {
            "id": 7910,
            "name": "Villalago",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "L958",
            "cod_istat": "066103",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 930,
            "giorni": 2953,
            "area": "",
            "ech": 0
        },
        {
            "id": 7911,
            "name": "Villalba",
            "provincia": "CL",
            "cap": "93010",
            "cod_catastale": "L959",
            "cod_istat": "085022",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 620,
            "giorni": 1602,
            "area": "",
            "ech": 0
        },
        {
            "id": 7912,
            "name": "Villalfonsina",
            "provincia": "CH",
            "cap": "66020",
            "cod_catastale": "L961",
            "cod_istat": "069100",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 203,
            "giorni": 1501,
            "area": "",
            "ech": 0
        },
        {
            "id": 7913,
            "name": "Villalvernia",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "L963",
            "cod_istat": "006183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 193,
            "giorni": 2713,
            "area": "",
            "ech": 0
        },
        {
            "id": 7914,
            "name": "Villamagna",
            "provincia": "CH",
            "cap": "66010",
            "cod_catastale": "L964",
            "cod_istat": "069101",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 255,
            "giorni": 1579,
            "area": "",
            "ech": 0
        },
        {
            "id": 7915,
            "name": "Villamaina",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "L965",
            "cod_istat": "064117",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 560,
            "giorni": 2040,
            "area": "",
            "ech": 0
        },
        {
            "id": 7916,
            "name": "Villamar",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L966",
            "cod_istat": "111097",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 108,
            "giorni": 1137,
            "area": "",
            "ech": 0
        },
        {
            "id": 7917,
            "name": "Villamarzana",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "L967",
            "cod_istat": "029049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2466,
            "area": "",
            "ech": 0
        },
        {
            "id": 7918,
            "name": "Villamassargia",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "L968",
            "cod_istat": "111098",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 121,
            "giorni": 956,
            "area": "",
            "ech": 0
        },
        {
            "id": 7919,
            "name": "Villamiroglio",
            "provincia": "AL",
            "cap": "15020",
            "cod_catastale": "L970",
            "cod_istat": "006184",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 329,
            "giorni": 2758,
            "area": "",
            "ech": 0
        },
        {
            "id": 7920,
            "name": "Villandro",
            "provincia": "BZ",
            "cap": "39040",
            "cod_catastale": "L971",
            "cod_istat": "021114",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 880,
            "giorni": 3826,
            "area": "",
            "ech": 0
        },
        {
            "id": 7921,
            "name": "Villanova Biellese",
            "provincia": "BI",
            "cap": "13877",
            "cod_catastale": "L978",
            "cod_istat": "096079",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2606,
            "area": "",
            "ech": 0
        },
        {
            "id": 7922,
            "name": "Villanova Canavese",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "L982",
            "cod_istat": "001301",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2924,
            "area": "",
            "ech": 0
        },
        {
            "id": 7923,
            "name": "Villanova d'Albenga",
            "provincia": "SV",
            "cap": "17038",
            "cod_catastale": "L975",
            "cod_istat": "009068",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 1258,
            "area": "",
            "ech": 0
        },
        {
            "id": 7924,
            "name": "Villanova d'Ardenghi",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "L983",
            "cod_istat": "018179",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 7925,
            "name": "Villanova d'Asti",
            "provincia": "AT",
            "cap": "14019",
            "cod_catastale": "L984",
            "cod_istat": "005118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 260,
            "giorni": 2701,
            "area": "",
            "ech": 0
        },
        {
            "id": 7926,
            "name": "Villanova del Battista",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "L973",
            "cod_istat": "064118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 742,
            "giorni": 2321,
            "area": "",
            "ech": 0
        },
        {
            "id": 7927,
            "name": "Villanova del Ghebbo",
            "provincia": "RO",
            "cap": "45020",
            "cod_catastale": "L985",
            "cod_istat": "029050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 11,
            "giorni": 2410,
            "area": "",
            "ech": 0
        },
        {
            "id": 7928,
            "name": "Villanova del Sillaro",
            "provincia": "LO",
            "cap": "26818",
            "cod_catastale": "L977",
            "cod_istat": "098060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 69,
            "giorni": 2551,
            "area": "",
            "ech": 0
        },
        {
            "id": 7929,
            "name": "Villanova di Camposampiero",
            "provincia": "PD",
            "cap": "35010",
            "cod_catastale": "L979",
            "cod_istat": "028104",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 2467,
            "area": "",
            "ech": 0
        },
        {
            "id": 7930,
            "name": "Villanova Marchesana",
            "provincia": "RO",
            "cap": "45030",
            "cod_catastale": "L988",
            "cod_istat": "029051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 3,
            "giorni": 2347,
            "area": "",
            "ech": 0
        },
        {
            "id": 7931,
            "name": "Villanova Mondovì",
            "provincia": "CN",
            "cap": "12089",
            "cod_catastale": "L974",
            "cod_istat": "004245",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 526,
            "giorni": 2802,
            "area": "",
            "ech": 0
        },
        {
            "id": 7932,
            "name": "Villanova Monferrato",
            "provincia": "AL",
            "cap": "15030",
            "cod_catastale": "L972",
            "cod_istat": "006185",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 111,
            "giorni": 2810,
            "area": "",
            "ech": 0
        },
        {
            "id": 7933,
            "name": "Villanova Monteleone",
            "provincia": "SS",
            "cap": "07019",
            "cod_catastale": "L989",
            "cod_istat": "090078",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 567,
            "giorni": 1793,
            "area": "",
            "ech": 0
        },
        {
            "id": 7934,
            "name": "Villanova Solaro",
            "provincia": "CN",
            "cap": "12030",
            "cod_catastale": "L990",
            "cod_istat": "004246",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 268,
            "giorni": 2647,
            "area": "",
            "ech": 0
        },
        {
            "id": 7935,
            "name": "Villanova sull'Arda",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "L980",
            "cod_istat": "033046",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 42,
            "giorni": 2385,
            "area": "",
            "ech": 0
        },
        {
            "id": 7936,
            "name": "Villanova Truschedu",
            "provincia": "OR",
            "cap": "09084",
            "cod_catastale": "L991",
            "cod_istat": "095071",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 56,
            "giorni": 974,
            "area": "",
            "ech": 0
        },
        {
            "id": 7937,
            "name": "Villanova Tulo",
            "provincia": "SU",
            "cap": "09066",
            "cod_catastale": "L992",
            "cod_istat": "111099",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 571,
            "giorni": 1769,
            "area": "",
            "ech": 0
        },
        {
            "id": 7938,
            "name": "Villanovaforru",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L986",
            "cod_istat": "111100",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 310,
            "giorni": 1425,
            "area": "",
            "ech": 0
        },
        {
            "id": 7939,
            "name": "Villanovafranca",
            "provincia": "SU",
            "cap": "09020",
            "cod_catastale": "L987",
            "cod_istat": "111101",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 300,
            "giorni": 1384,
            "area": "",
            "ech": 0
        },
        {
            "id": 7940,
            "name": "Villanterio",
            "provincia": "PV",
            "cap": "27019",
            "cod_catastale": "L994",
            "cod_istat": "018180",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7941,
            "name": "Villanuova sul Clisi",
            "provincia": "BS",
            "cap": "25089",
            "cod_catastale": "L995",
            "cod_istat": "017201",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 216,
            "giorni": 2511,
            "area": "",
            "ech": 0
        },
        {
            "id": 7942,
            "name": "Villaperuccio",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "M278",
            "cod_istat": "111102",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 851,
            "area": "",
            "ech": 1
        },
        {
            "id": 7943,
            "name": "Villapiana",
            "provincia": "CS",
            "cap": "87076",
            "cod_catastale": "B903",
            "cod_istat": "078154",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 1371,
            "area": "",
            "ech": 0
        },
        {
            "id": 7944,
            "name": "Villaputzu",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "L998",
            "cod_istat": "111103",
            "attivo": 1,
            "zona": "B",
            "cassa": 0,
            "altitudine": 8,
            "giorni": 887,
            "area": "",
            "ech": 0
        },
        {
            "id": 7945,
            "name": "Villar Dora",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "L999",
            "cod_istat": "001303",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 367,
            "giorni": 2904,
            "area": "",
            "ech": 0
        },
        {
            "id": 7946,
            "name": "Villar Focchiardo",
            "provincia": "TO",
            "cap": "10050",
            "cod_catastale": "M007",
            "cod_istat": "001305",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 450,
            "giorni": 3029,
            "area": "",
            "ech": 0
        },
        {
            "id": 7947,
            "name": "Villar Pellice",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "M013",
            "cod_istat": "001306",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 664,
            "giorni": 3350,
            "area": "",
            "ech": 0
        },
        {
            "id": 7948,
            "name": "Villar Perosa",
            "provincia": "TO",
            "cap": "10069",
            "cod_catastale": "M014",
            "cod_istat": "001307",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 530,
            "giorni": 3149,
            "area": "",
            "ech": 0
        },
        {
            "id": 7949,
            "name": "Villar San Costanzo",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "M015",
            "cod_istat": "004247",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 609,
            "giorni": 3070,
            "area": "",
            "ech": 0
        },
        {
            "id": 7950,
            "name": "Villarbasse",
            "provincia": "TO",
            "cap": "10090",
            "cod_catastale": "M002",
            "cod_istat": "001302",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 381,
            "giorni": 2925,
            "area": "",
            "ech": 0
        },
        {
            "id": 7951,
            "name": "Villarboit",
            "provincia": "VC",
            "cap": "13030",
            "cod_catastale": "M003",
            "cod_istat": "002163",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 162,
            "giorni": 2793,
            "area": "",
            "ech": 0
        },
        {
            "id": 7952,
            "name": "Villareggia",
            "provincia": "TO",
            "cap": "10030",
            "cod_catastale": "M004",
            "cod_istat": "001304",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 274,
            "giorni": 2765,
            "area": "",
            "ech": 0
        },
        {
            "id": 7953,
            "name": "Villaricca",
            "provincia": "NA",
            "cap": "80010",
            "cod_catastale": "G309",
            "cod_istat": "063087",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 105,
            "giorni": 1120,
            "area": "",
            "ech": 0
        },
        {
            "id": 7954,
            "name": "Villaromagnano",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "M009",
            "cod_istat": "006186",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 170,
            "giorni": 2625,
            "area": "",
            "ech": 0
        },
        {
            "id": 7955,
            "name": "Villarosa",
            "provincia": "EN",
            "cap": "94010",
            "cod_catastale": "M011",
            "cod_istat": "086020",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 523,
            "giorni": 1455,
            "area": "",
            "ech": 0
        },
        {
            "id": 7956,
            "name": "Villasalto",
            "provincia": "SU",
            "cap": "09040",
            "cod_catastale": "M016",
            "cod_istat": "111104",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 502,
            "giorni": 1712,
            "area": "",
            "ech": 0
        },
        {
            "id": 7957,
            "name": "Villasanta",
            "provincia": "MB",
            "cap": "20852",
            "cod_catastale": "M017",
            "cod_istat": "108049",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 173,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7958,
            "name": "Villasimius",
            "provincia": "SU",
            "cap": "09049",
            "cod_catastale": "B738",
            "cod_istat": "111105",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 41,
            "giorni": 963,
            "area": "",
            "ech": 0
        },
        {
            "id": 7959,
            "name": "Villasor",
            "provincia": "SU",
            "cap": "09034",
            "cod_catastale": "M025",
            "cod_istat": "111106",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1204,
            "area": "",
            "ech": 0
        },
        {
            "id": 7960,
            "name": "Villaspeciosa",
            "provincia": "SU",
            "cap": "09010",
            "cod_catastale": "M026",
            "cod_istat": "111107",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 12,
            "giorni": 943,
            "area": "",
            "ech": 0
        },
        {
            "id": 7961,
            "name": "Villastellone",
            "provincia": "TO",
            "cap": "10029",
            "cod_catastale": "M027",
            "cod_istat": "001308",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 234,
            "giorni": 2576,
            "area": "",
            "ech": 0
        },
        {
            "id": 7962,
            "name": "Villata",
            "provincia": "VC",
            "cap": "13010",
            "cod_catastale": "M028",
            "cod_istat": "002164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 136,
            "giorni": 2759,
            "area": "",
            "ech": 0
        },
        {
            "id": 7963,
            "name": "Villaurbana",
            "provincia": "OR",
            "cap": "09080",
            "cod_catastale": "M030",
            "cod_istat": "095072",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 84,
            "giorni": 1084,
            "area": "",
            "ech": 0
        },
        {
            "id": 7964,
            "name": "Villavallelonga",
            "provincia": "AQ",
            "cap": "67050",
            "cod_catastale": "M031",
            "cod_istat": "066106",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1005,
            "giorni": 3087,
            "area": "",
            "ech": 0
        },
        {
            "id": 7965,
            "name": "Villaverla",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "M032",
            "cod_istat": "024118",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 75,
            "giorni": 2470,
            "area": "",
            "ech": 0
        },
        {
            "id": 7966,
            "name": "Villeneuve",
            "provincia": "AO",
            "cap": "11018",
            "cod_catastale": "L981",
            "cod_istat": "007074",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 670,
            "giorni": 2982,
            "area": "",
            "ech": 0
        },
        {
            "id": 7967,
            "name": "Villesse",
            "provincia": "GO",
            "cap": "34070",
            "cod_catastale": "M043",
            "cod_istat": "031025",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2232,
            "area": "",
            "ech": 0
        },
        {
            "id": 7968,
            "name": "Villetta Barrea",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "M041",
            "cod_istat": "066107",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 990,
            "giorni": 3061,
            "area": "",
            "ech": 0
        },
        {
            "id": 7969,
            "name": "Villette",
            "provincia": "VB",
            "cap": "28856",
            "cod_catastale": "M042",
            "cod_istat": "103076",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 807,
            "giorni": 3354,
            "area": "",
            "ech": 0
        },
        {
            "id": 7970,
            "name": "Villimpenta",
            "provincia": "MN",
            "cap": "46039",
            "cod_catastale": "M044",
            "cod_istat": "020068",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7971,
            "name": "Villongo",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "M045",
            "cod_istat": "016242",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 230,
            "giorni": 2437,
            "area": "",
            "ech": 0
        },
        {
            "id": 7972,
            "name": "Villorba",
            "provincia": "TV",
            "cap": "31020",
            "cod_catastale": "M048",
            "cod_istat": "026091",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 26,
            "giorni": 2397,
            "area": "",
            "ech": 0
        },
        {
            "id": 7973,
            "name": "Vilminore di Scalve",
            "provincia": "BG",
            "cap": "24020",
            "cod_catastale": "M050",
            "cod_istat": "016243",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1019,
            "giorni": 3517,
            "area": "",
            "ech": 0
        },
        {
            "id": 7974,
            "name": "Vimercate",
            "provincia": "MB",
            "cap": "20871",
            "cod_catastale": "M052",
            "cod_istat": "108050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 194,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7975,
            "name": "Vimodrone",
            "provincia": "MI",
            "cap": "20090",
            "cod_catastale": "M053",
            "cod_istat": "015242",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 128,
            "giorni": 2404,
            "area": "",
            "ech": 0
        },
        {
            "id": 7976,
            "name": "Vinadio",
            "provincia": "CN",
            "cap": "12010",
            "cod_catastale": "M055",
            "cod_istat": "004248",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 904,
            "giorni": 3436,
            "area": "",
            "ech": 0
        },
        {
            "id": 7977,
            "name": "Vinchiaturo",
            "provincia": "CB",
            "cap": "86019",
            "cod_catastale": "M057",
            "cod_istat": "070084",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 620,
            "giorni": 2159,
            "area": "",
            "ech": 0
        },
        {
            "id": 7978,
            "name": "Vinchio",
            "provincia": "AT",
            "cap": "14040",
            "cod_catastale": "M058",
            "cod_istat": "005120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 269,
            "giorni": 2708,
            "area": "",
            "ech": 0
        },
        {
            "id": 7979,
            "name": "Vinci",
            "provincia": "FI",
            "cap": "50059",
            "cod_catastale": "M059",
            "cod_istat": "048050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 97,
            "giorni": 1765,
            "area": "",
            "ech": 0
        },
        {
            "id": 7980,
            "name": "Vinovo",
            "provincia": "TO",
            "cap": "10048",
            "cod_catastale": "M060",
            "cod_istat": "001309",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 232,
            "giorni": 2573,
            "area": "",
            "ech": 0
        },
        {
            "id": 7981,
            "name": "Vinzaglio",
            "provincia": "NO",
            "cap": "28060",
            "cod_catastale": "M062",
            "cod_istat": "003164",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 124,
            "giorni": 2581,
            "area": "",
            "ech": 0
        },
        {
            "id": 7982,
            "name": "Viola",
            "provincia": "CN",
            "cap": "12070",
            "cod_catastale": "M063",
            "cod_istat": "004249",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 827,
            "giorni": 3341,
            "area": "",
            "ech": 0
        },
        {
            "id": 7983,
            "name": "Vione",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "M065",
            "cod_istat": "017202",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1250,
            "giorni": 3997,
            "area": "",
            "ech": 0
        },
        {
            "id": 7984,
            "name": "Vipiteno",
            "provincia": "BZ",
            "cap": "39049",
            "cod_catastale": "M067",
            "cod_istat": "021115",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 948,
            "giorni": 3959,
            "area": "",
            "ech": 0
        },
        {
            "id": 7985,
            "name": "Virgilio",
            "provincia": "MN",
            "cap": "46030",
            "cod_catastale": "H123",
            "cod_istat": "020069",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 22,
            "giorni": 2388,
            "area": "",
            "ech": 0
        },
        {
            "id": 7986,
            "name": "Virle Piemonte",
            "provincia": "TO",
            "cap": "10060",
            "cod_catastale": "M069",
            "cod_istat": "001310",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 246,
            "giorni": 2604,
            "area": "",
            "ech": 0
        },
        {
            "id": 7987,
            "name": "Visano",
            "provincia": "BS",
            "cap": "25010",
            "cod_catastale": "M070",
            "cod_istat": "017203",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 60,
            "giorni": 2396,
            "area": "",
            "ech": 0
        },
        {
            "id": 7988,
            "name": "Vische",
            "provincia": "TO",
            "cap": "10030",
            "cod_catastale": "M071",
            "cod_istat": "001311",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2718,
            "area": "",
            "ech": 0
        },
        {
            "id": 7989,
            "name": "Visciano",
            "provincia": "NA",
            "cap": "80030",
            "cod_catastale": "M072",
            "cod_istat": "063088",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 340,
            "giorni": 1535,
            "area": "",
            "ech": 0
        },
        {
            "id": 7990,
            "name": "Visco",
            "provincia": "UD",
            "cap": "33040",
            "cod_catastale": "M073",
            "cod_istat": "030135",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 24,
            "giorni": 2278,
            "area": "",
            "ech": 0
        },
        {
            "id": 7991,
            "name": "Visone",
            "provincia": "AL",
            "cap": "15010",
            "cod_catastale": "M077",
            "cod_istat": "006187",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 161,
            "giorni": 2617,
            "area": "",
            "ech": 0
        },
        {
            "id": 7992,
            "name": "Visso",
            "provincia": "MC",
            "cap": "62039",
            "cod_catastale": "M078",
            "cod_istat": "043057",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 607,
            "giorni": 2350,
            "area": "",
            "ech": 0
        },
        {
            "id": 7993,
            "name": "Vistarino",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "M079",
            "cod_istat": "018181",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 72,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 7994,
            "name": "Vistrorio",
            "provincia": "TO",
            "cap": "10080",
            "cod_catastale": "M080",
            "cod_istat": "001312",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 2902,
            "area": "",
            "ech": 0
        },
        {
            "id": 7995,
            "name": "Vita",
            "provincia": "TP",
            "cap": "91010",
            "cod_catastale": "M081",
            "cod_istat": "081023",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 480,
            "giorni": 1389,
            "area": "",
            "ech": 0
        },
        {
            "id": 7996,
            "name": "Viterbo",
            "provincia": "VT",
            "cap": "01100",
            "cod_catastale": "M082",
            "cod_istat": "056059",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 326,
            "giorni": 1989,
            "area": "",
            "ech": 0
        },
        {
            "id": 7997,
            "name": "Viticuso",
            "provincia": "FR",
            "cap": "03040",
            "cod_catastale": "M083",
            "cod_istat": "060091",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 825,
            "giorni": 2661,
            "area": "",
            "ech": 0
        },
        {
            "id": 7998,
            "name": "Vito d'Asio",
            "provincia": "PN",
            "cap": "33090",
            "cod_catastale": "M085",
            "cod_istat": "093049",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 320,
            "giorni": 2962,
            "area": "",
            "ech": 0
        },
        {
            "id": 7999,
            "name": "Vitorchiano",
            "provincia": "VT",
            "cap": "01030",
            "cod_catastale": "M086",
            "cod_istat": "056060",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 285,
            "giorni": 1917,
            "area": "",
            "ech": 0
        },
        {
            "id": 8000,
            "name": "Vittoria",
            "provincia": "RG",
            "cap": "97019",
            "cod_catastale": "M088",
            "cod_istat": "088012",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 168,
            "giorni": 965,
            "area": "",
            "ech": 1
        },
        {
            "id": 8001,
            "name": "Vittorio Veneto",
            "provincia": "TV",
            "cap": "31029",
            "cod_catastale": "M089",
            "cod_istat": "026092",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 2657,
            "area": "",
            "ech": 0
        },
        {
            "id": 8002,
            "name": "Vittorito",
            "provincia": "AQ",
            "cap": "67030",
            "cod_catastale": "M090",
            "cod_istat": "066108",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 377,
            "giorni": 1963,
            "area": "",
            "ech": 0
        },
        {
            "id": 8003,
            "name": "Vittuone",
            "provincia": "MI",
            "cap": "20010",
            "cod_catastale": "M091",
            "cod_istat": "015243",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 146,
            "giorni": 2599,
            "area": "",
            "ech": 0
        },
        {
            "id": 8004,
            "name": "Vitulano",
            "provincia": "BN",
            "cap": "82038",
            "cod_catastale": "M093",
            "cod_istat": "062077",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 430,
            "giorni": 1853,
            "area": "",
            "ech": 0
        },
        {
            "id": 8005,
            "name": "Vitulazio",
            "provincia": "CE",
            "cap": "81041",
            "cod_catastale": "M092",
            "cod_istat": "061100",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 57,
            "giorni": 1155,
            "area": "",
            "ech": 0
        },
        {
            "id": 8006,
            "name": "Viù",
            "provincia": "TO",
            "cap": "10070",
            "cod_catastale": "M094",
            "cod_istat": "001313",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 774,
            "giorni": 3515,
            "area": "",
            "ech": 0
        },
        {
            "id": 8007,
            "name": "Vivaro",
            "provincia": "PN",
            "cap": "33099",
            "cod_catastale": "M096",
            "cod_istat": "093050",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 138,
            "giorni": 2597,
            "area": "",
            "ech": 0
        },
        {
            "id": 8008,
            "name": "Vivaro Romano",
            "provincia": "RM",
            "cap": "00020",
            "cod_catastale": "M095",
            "cod_istat": "058113",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 756,
            "giorni": 2855,
            "area": "",
            "ech": 0
        },
        {
            "id": 8009,
            "name": "Viverone",
            "provincia": "BI",
            "cap": "13886",
            "cod_catastale": "M098",
            "cod_istat": "096080",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 287,
            "giorni": 2704,
            "area": "",
            "ech": 0
        },
        {
            "id": 8010,
            "name": "Vizzini",
            "provincia": "CT",
            "cap": "95049",
            "cod_catastale": "M100",
            "cod_istat": "087054",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 586,
            "giorni": 1478,
            "area": "",
            "ech": 1
        },
        {
            "id": 8011,
            "name": "Vizzola Ticino",
            "provincia": "VA",
            "cap": "21010",
            "cod_catastale": "M101",
            "cod_istat": "012140",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2614,
            "area": "",
            "ech": 0
        },
        {
            "id": 8012,
            "name": "Vizzolo Predabissi",
            "provincia": "MI",
            "cap": "20070",
            "cod_catastale": "M102",
            "cod_istat": "015244",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 8013,
            "name": "Vo'",
            "provincia": "PD",
            "cap": "35030",
            "cod_catastale": "M103",
            "cod_istat": "028105",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8014,
            "name": "Vobarno",
            "provincia": "BS",
            "cap": "25079",
            "cod_catastale": "M104",
            "cod_istat": "017204",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 241,
            "giorni": 2560,
            "area": "",
            "ech": 0
        },
        {
            "id": 8015,
            "name": "Vobbia",
            "provincia": "GE",
            "cap": "16010",
            "cod_catastale": "M105",
            "cod_istat": "010066",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 477,
            "giorni": 2566,
            "area": "",
            "ech": 0
        },
        {
            "id": 8016,
            "name": "Vocca",
            "provincia": "VC",
            "cap": "13020",
            "cod_catastale": "M106",
            "cod_istat": "002166",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 506,
            "giorni": 2928,
            "area": "",
            "ech": 0
        },
        {
            "id": 8017,
            "name": "Vodo Cadore",
            "provincia": "BL",
            "cap": "32040",
            "cod_catastale": "M108",
            "cod_istat": "025066",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 901,
            "giorni": 4007,
            "area": "",
            "ech": 0
        },
        {
            "id": 8018,
            "name": "Voghera",
            "provincia": "PV",
            "cap": "27058",
            "cod_catastale": "M109",
            "cod_istat": "018182",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 96,
            "giorni": 2685,
            "area": "",
            "ech": 0
        },
        {
            "id": 8019,
            "name": "Voghiera",
            "provincia": "FE",
            "cap": "44019",
            "cod_catastale": "M110",
            "cod_istat": "038023",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2276,
            "area": "",
            "ech": 0
        },
        {
            "id": 8020,
            "name": "Vogogna",
            "provincia": "VB",
            "cap": "28805",
            "cod_catastale": "M111",
            "cod_istat": "103077",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 226,
            "giorni": 2598,
            "area": "",
            "ech": 0
        },
        {
            "id": 8021,
            "name": "Volano",
            "provincia": "TN",
            "cap": "38060",
            "cod_catastale": "M113",
            "cod_istat": "022224",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 189,
            "giorni": 2689,
            "area": "",
            "ech": 0
        },
        {
            "id": 8022,
            "name": "Volla",
            "provincia": "NA",
            "cap": "80040",
            "cod_catastale": "M115",
            "cod_istat": "063089",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 25,
            "giorni": 1062,
            "area": "",
            "ech": 0
        },
        {
            "id": 8023,
            "name": "Volongo",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "M116",
            "cod_istat": "019114",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 43,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 8024,
            "name": "Volpago del Montello",
            "provincia": "TV",
            "cap": "31040",
            "cod_catastale": "M118",
            "cod_istat": "026093",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 94,
            "giorni": 2436,
            "area": "",
            "ech": 0
        },
        {
            "id": 8025,
            "name": "Volpara",
            "provincia": "PV",
            "cap": "27047",
            "cod_catastale": "M119",
            "cod_istat": "018183",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 357,
            "giorni": 2968,
            "area": "",
            "ech": 0
        },
        {
            "id": 8026,
            "name": "Volpedo",
            "provincia": "AL",
            "cap": "15059",
            "cod_catastale": "M120",
            "cod_istat": "006188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 182,
            "giorni": 2635,
            "area": "",
            "ech": 0
        },
        {
            "id": 8027,
            "name": "Volpeglino",
            "provincia": "AL",
            "cap": "15050",
            "cod_catastale": "M121",
            "cod_istat": "006189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 243,
            "giorni": 2618,
            "area": "",
            "ech": 0
        },
        {
            "id": 8028,
            "name": "Volpiano",
            "provincia": "TO",
            "cap": "10088",
            "cod_catastale": "M122",
            "cod_istat": "001314",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 219,
            "giorni": 2682,
            "area": "",
            "ech": 0
        },
        {
            "id": 8029,
            "name": "Volta Mantovana",
            "provincia": "MN",
            "cap": "46049",
            "cod_catastale": "M125",
            "cod_istat": "020070",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 91,
            "giorni": 2526,
            "area": "",
            "ech": 0
        },
        {
            "id": 8030,
            "name": "Voltaggio",
            "provincia": "AL",
            "cap": "15060",
            "cod_catastale": "M123",
            "cod_istat": "006190",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 342,
            "giorni": 2743,
            "area": "",
            "ech": 0
        },
        {
            "id": 8031,
            "name": "Voltago Agordino",
            "provincia": "BL",
            "cap": "32020",
            "cod_catastale": "M124",
            "cod_istat": "025067",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 858,
            "giorni": 3971,
            "area": "",
            "ech": 0
        },
        {
            "id": 8032,
            "name": "Volterra",
            "provincia": "PI",
            "cap": "56048",
            "cod_catastale": "M126",
            "cod_istat": "050039",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 531,
            "giorni": 2217,
            "area": "",
            "ech": 0
        },
        {
            "id": 8033,
            "name": "Voltido",
            "provincia": "CR",
            "cap": "26030",
            "cod_catastale": "M127",
            "cod_istat": "019115",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2389,
            "area": "",
            "ech": 0
        },
        {
            "id": 8034,
            "name": "Volturara Appula",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "M131",
            "cod_istat": "071061",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 526,
            "giorni": 2020,
            "area": "",
            "ech": 0
        },
        {
            "id": 8035,
            "name": "Volturara Irpina",
            "provincia": "AV",
            "cap": "83050",
            "cod_catastale": "M130",
            "cod_istat": "064119",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 697,
            "giorni": 2319,
            "area": "",
            "ech": 0
        },
        {
            "id": 8036,
            "name": "Volturino",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "M132",
            "cod_istat": "071062",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 735,
            "giorni": 2326,
            "area": "",
            "ech": 0
        },
        {
            "id": 8037,
            "name": "Volvera",
            "provincia": "TO",
            "cap": "10040",
            "cod_catastale": "M133",
            "cod_istat": "001315",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 251,
            "giorni": 2772,
            "area": "",
            "ech": 0
        },
        {
            "id": 8038,
            "name": "Vottignasco",
            "provincia": "CN",
            "cap": "12020",
            "cod_catastale": "M136",
            "cod_istat": "004250",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 380,
            "giorni": 2892,
            "area": "",
            "ech": 0
        },
        {
            "id": 8039,
            "name": "Zaccanopoli",
            "provincia": "VV",
            "cap": "89867",
            "cod_catastale": "M138",
            "cod_istat": "102048",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 430,
            "giorni": 1687,
            "area": "",
            "ech": 0
        },
        {
            "id": 8040,
            "name": "Zafferana Etnea",
            "provincia": "CT",
            "cap": "95019",
            "cod_catastale": "M139",
            "cod_istat": "087055",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 574,
            "giorni": 1184,
            "area": "",
            "ech": 1
        },
        {
            "id": 8041,
            "name": "Zagarise",
            "provincia": "CZ",
            "cap": "88050",
            "cod_catastale": "M140",
            "cod_istat": "079157",
            "attivo": 1,
            "zona": "D",
            "cassa": 1,
            "altitudine": 581,
            "giorni": 1983,
            "area": "",
            "ech": 0
        },
        {
            "id": 8042,
            "name": "Zagarolo",
            "provincia": "RM",
            "cap": "00039",
            "cod_catastale": "M141",
            "cod_istat": "058114",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 303,
            "giorni": 1893,
            "area": "",
            "ech": 0
        },
        {
            "id": 8043,
            "name": "Zambana",
            "provincia": "TN",
            "cap": "38010",
            "cod_catastale": "M142",
            "cod_istat": "022225",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 206,
            "giorni": 2712,
            "area": "",
            "ech": 0
        },
        {
            "id": 8044,
            "name": "Zambrone",
            "provincia": "VV",
            "cap": "89868",
            "cod_catastale": "M143",
            "cod_istat": "102049",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 222,
            "giorni": 1250,
            "area": "",
            "ech": 0
        },
        {
            "id": 8045,
            "name": "Zandobbio",
            "provincia": "BG",
            "cap": "24060",
            "cod_catastale": "M144",
            "cod_istat": "016244",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 278,
            "giorni": 2464,
            "area": "",
            "ech": 0
        },
        {
            "id": 8046,
            "name": "Zanè",
            "provincia": "VI",
            "cap": "36010",
            "cod_catastale": "M145",
            "cod_istat": "024119",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 183,
            "giorni": 2488,
            "area": "",
            "ech": 0
        },
        {
            "id": 8047,
            "name": "Zanica",
            "provincia": "BG",
            "cap": "24050",
            "cod_catastale": "M147",
            "cod_istat": "016245",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 208,
            "giorni": 2475,
            "area": "",
            "ech": 0
        },
        {
            "id": 8048,
            "name": "Zapponeta",
            "provincia": "FG",
            "cap": "71030",
            "cod_catastale": "M267",
            "cod_istat": "071064",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 2,
            "giorni": 1291,
            "area": "",
            "ech": 0
        },
        {
            "id": 8049,
            "name": "Zavattarello",
            "provincia": "PV",
            "cap": "27059",
            "cod_catastale": "M150",
            "cod_istat": "018184",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 550,
            "giorni": 3138,
            "area": "",
            "ech": 0
        },
        {
            "id": 8050,
            "name": "Zeccone",
            "provincia": "PV",
            "cap": "27010",
            "cod_catastale": "M152",
            "cod_istat": "018185",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 86,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 8051,
            "name": "Zeddiani",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "M153",
            "cod_istat": "095074",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 9,
            "giorni": 975,
            "area": "",
            "ech": 0
        },
        {
            "id": 8052,
            "name": "Zelbio",
            "provincia": "CO",
            "cap": "22020",
            "cod_catastale": "M156",
            "cod_istat": "013246",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 802,
            "giorni": 3208,
            "area": "",
            "ech": 0
        },
        {
            "id": 8053,
            "name": "Zelo Buon Persico",
            "provincia": "LO",
            "cap": "26839",
            "cod_catastale": "M158",
            "cod_istat": "098061",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 95,
            "giorni": 2557,
            "area": "",
            "ech": 0
        },
        {
            "id": 8054,
            "name": "Zelo Surrigone",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "M160",
            "cod_istat": "015246",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 113,
            "giorni": 2586,
            "area": "",
            "ech": 0
        },
        {
            "id": 8055,
            "name": "Zeme",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "M161",
            "cod_istat": "018186",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 104,
            "giorni": 2622,
            "area": "",
            "ech": 0
        },
        {
            "id": 8056,
            "name": "Zenevredo",
            "provincia": "PV",
            "cap": "27049",
            "cod_catastale": "M162",
            "cod_istat": "018187",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 204,
            "giorni": 2832,
            "area": "",
            "ech": 0
        },
        {
            "id": 8057,
            "name": "Zenson di Piave",
            "provincia": "TV",
            "cap": "31050",
            "cod_catastale": "M163",
            "cod_istat": "026094",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 7,
            "giorni": 2393,
            "area": "",
            "ech": 0
        },
        {
            "id": 8058,
            "name": "Zerba",
            "provincia": "PC",
            "cap": "29020",
            "cod_catastale": "M165",
            "cod_istat": "033047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 906,
            "giorni": 3449,
            "area": "",
            "ech": 0
        },
        {
            "id": 8059,
            "name": "Zerbo",
            "provincia": "PV",
            "cap": "27017",
            "cod_catastale": "M166",
            "cod_istat": "018188",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2628,
            "area": "",
            "ech": 0
        },
        {
            "id": 8060,
            "name": "Zerbolò",
            "provincia": "PV",
            "cap": "27020",
            "cod_catastale": "M167",
            "cod_istat": "018189",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 68,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 8061,
            "name": "Zerfaliu",
            "provincia": "OR",
            "cap": "09070",
            "cod_catastale": "M168",
            "cod_istat": "095075",
            "attivo": 1,
            "zona": "C",
            "cassa": 1,
            "altitudine": 15,
            "giorni": 1067,
            "area": "",
            "ech": 0
        },
        {
            "id": 8062,
            "name": "Zeri",
            "provincia": "MS",
            "cap": "54029",
            "cod_catastale": "M169",
            "cod_istat": "045017",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 708,
            "giorni": 3136,
            "area": "",
            "ech": 0
        },
        {
            "id": 8063,
            "name": "Zermeghedo",
            "provincia": "VI",
            "cap": "36050",
            "cod_catastale": "M170",
            "cod_istat": "024120",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 8064,
            "name": "Zero Branco",
            "provincia": "TV",
            "cap": "31059",
            "cod_catastale": "M171",
            "cod_istat": "026095",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 18,
            "giorni": 2411,
            "area": "",
            "ech": 0
        },
        {
            "id": 8065,
            "name": "Zevio",
            "provincia": "VR",
            "cap": "37059",
            "cod_catastale": "M172",
            "cod_istat": "023097",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 31,
            "giorni": 2348,
            "area": "",
            "ech": 0
        },
        {
            "id": 8066,
            "name": "Ziano di Fiemme",
            "provincia": "TN",
            "cap": "38030",
            "cod_catastale": "M173",
            "cod_istat": "022226",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 953,
            "giorni": 3877,
            "area": "",
            "ech": 0
        },
        {
            "id": 8067,
            "name": "Ziano Piacentino",
            "provincia": "PC",
            "cap": "29010",
            "cod_catastale": "L848",
            "cod_istat": "033048",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 220,
            "giorni": 2739,
            "area": "",
            "ech": 0
        },
        {
            "id": 8068,
            "name": "Zibello",
            "provincia": "PR",
            "cap": "43010",
            "cod_catastale": "M174",
            "cod_istat": "034050",
            "attivo": 0,
            "zona": "E",
            "cassa": 0,
            "altitudine": 35,
            "giorni": 2376,
            "area": "",
            "ech": 0
        },
        {
            "id": 8069,
            "name": "Zibido San Giacomo",
            "provincia": "MI",
            "cap": "20080",
            "cod_catastale": "M176",
            "cod_istat": "015247",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 103,
            "giorni": 2514,
            "area": "",
            "ech": 0
        },
        {
            "id": 8070,
            "name": "Zignago",
            "provincia": "SP",
            "cap": "19020",
            "cod_catastale": "M177",
            "cod_istat": "011032",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 632,
            "giorni": 2076,
            "area": "",
            "ech": 0
        },
        {
            "id": 8071,
            "name": "Zimella",
            "provincia": "VR",
            "cap": "37040",
            "cod_catastale": "M178",
            "cod_istat": "023098",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 29,
            "giorni": 2440,
            "area": "",
            "ech": 0
        },
        {
            "id": 8072,
            "name": "Zimone",
            "provincia": "BI",
            "cap": "13887",
            "cod_catastale": "M179",
            "cod_istat": "096081",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 410,
            "giorni": 2870,
            "area": "",
            "ech": 0
        },
        {
            "id": 8073,
            "name": "Zinasco",
            "provincia": "PV",
            "cap": "27030",
            "cod_catastale": "M180",
            "cod_istat": "018190",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 84,
            "giorni": 2619,
            "area": "",
            "ech": 0
        },
        {
            "id": 8074,
            "name": "Zoagli",
            "provincia": "GE",
            "cap": "16035",
            "cod_catastale": "M182",
            "cod_istat": "010067",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 17,
            "giorni": 1444,
            "area": "",
            "ech": 0
        },
        {
            "id": 8075,
            "name": "Zocca",
            "provincia": "MO",
            "cap": "41059",
            "cod_catastale": "M183",
            "cod_istat": "036047",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 758,
            "giorni": 3240,
            "area": "",
            "ech": 0
        },
        {
            "id": 8076,
            "name": "Zogno",
            "provincia": "BG",
            "cap": "24019",
            "cod_catastale": "M184",
            "cod_istat": "016246",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 334,
            "giorni": 2544,
            "area": "",
            "ech": 0
        },
        {
            "id": 8077,
            "name": "Zola Predosa",
            "provincia": "BO",
            "cap": "40069",
            "cod_catastale": "M185",
            "cod_istat": "037060",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 74,
            "giorni": 2408,
            "area": "",
            "ech": 0
        },
        {
            "id": 8078,
            "name": "Zoldo Alto",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "I345",
            "cod_istat": "025068",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1177,
            "giorni": 4444,
            "area": "",
            "ech": 0
        },
        {
            "id": 8079,
            "name": "Zollino",
            "provincia": "LE",
            "cap": "73010",
            "cod_catastale": "M187",
            "cod_istat": "075094",
            "attivo": 1,
            "zona": "C",
            "cassa": 0,
            "altitudine": 90,
            "giorni": 1206,
            "area": "",
            "ech": 0
        },
        {
            "id": 8080,
            "name": "Zone",
            "provincia": "BS",
            "cap": "25050",
            "cod_catastale": "M188",
            "cod_istat": "017205",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 684,
            "giorni": 3251,
            "area": "",
            "ech": 0
        },
        {
            "id": 8081,
            "name": "Zoppè di Cadore",
            "provincia": "BL",
            "cap": "32010",
            "cod_catastale": "M189",
            "cod_istat": "025069",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 1460,
            "giorni": 4891,
            "area": "",
            "ech": 0
        },
        {
            "id": 8082,
            "name": "Zoppola",
            "provincia": "PN",
            "cap": "33080",
            "cod_catastale": "M190",
            "cod_istat": "093051",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 36,
            "giorni": 2481,
            "area": "",
            "ech": 0
        },
        {
            "id": 8083,
            "name": "Zovencedo",
            "provincia": "VI",
            "cap": "36020",
            "cod_catastale": "M194",
            "cod_istat": "024121",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 276,
            "giorni": 2693,
            "area": "",
            "ech": 0
        },
        {
            "id": 8084,
            "name": "Zubiena",
            "provincia": "BI",
            "cap": "13888",
            "cod_catastale": "M196",
            "cod_istat": "096082",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 492,
            "giorni": 2944,
            "area": "",
            "ech": 0
        },
        {
            "id": 8085,
            "name": "Zuccarello",
            "provincia": "SV",
            "cap": "17039",
            "cod_catastale": "M197",
            "cod_istat": "009069",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 130,
            "giorni": 1689,
            "area": "",
            "ech": 0
        },
        {
            "id": 8086,
            "name": "Zuclo",
            "provincia": "TN",
            "cap": "38079",
            "cod_catastale": "M198",
            "cod_istat": "022227",
            "attivo": 0,
            "zona": "F",
            "cassa": 0,
            "altitudine": 595,
            "giorni": 3319,
            "area": "",
            "ech": 0
        },
        {
            "id": 8087,
            "name": "Zugliano",
            "provincia": "VI",
            "cap": "36030",
            "cod_catastale": "M199",
            "cod_istat": "024122",
            "attivo": 1,
            "zona": "E",
            "cassa": 0,
            "altitudine": 154,
            "giorni": 2440,
            "area": "",
            "ech": 0
        },
        {
            "id": 8088,
            "name": "Zuglio",
            "provincia": "UD",
            "cap": "33020",
            "cod_catastale": "M200",
            "cod_istat": "030136",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 3226,
            "area": "",
            "ech": 0
        },
        {
            "id": 8089,
            "name": "Zumaglia",
            "provincia": "BI",
            "cap": "13848",
            "cod_catastale": "M201",
            "cod_istat": "096083",
            "attivo": 1,
            "zona": "F",
            "cassa": 0,
            "altitudine": 573,
            "giorni": 3049,
            "area": "",
            "ech": 0
        },
        {
            "id": 8090,
            "name": "Zumpano",
            "provincia": "CS",
            "cap": "87040",
            "cod_catastale": "M202",
            "cod_istat": "078155",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 429,
            "giorni": 1647,
            "area": "",
            "ech": 0
        },
        {
            "id": 8091,
            "name": "Zungoli",
            "provincia": "AV",
            "cap": "83030",
            "cod_catastale": "M203",
            "cod_istat": "064120",
            "attivo": 1,
            "zona": "E",
            "cassa": 1,
            "altitudine": 657,
            "giorni": 2255,
            "area": "",
            "ech": 0
        },
        {
            "id": 8092,
            "name": "Zungri",
            "provincia": "VV",
            "cap": "89867",
            "cod_catastale": "M204",
            "cod_istat": "102050",
            "attivo": 1,
            "zona": "D",
            "cassa": 0,
            "altitudine": 554,
            "giorni": 1912,
            "area": "",
            "ech": 0
        },
        {
            "id": 8095,
            "name": "Val di Chy",
            "provincia": "TO",
            "cap": "10039",
            "cod_catastale": "M405",
            "cod_istat": "001317",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8096,
            "name": "Valchiusa",
            "provincia": "TO",
            "cap": "10089",
            "cod_catastale": "M415",
            "cod_istat": "001318",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8097,
            "name": "Alto Sermenza",
            "provincia": "VC",
            "cap": "13029",
            "cod_catastale": "M389",
            "cod_istat": "002170",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8098,
            "name": "Cellio con Breia",
            "provincia": "VC",
            "cap": "13024",
            "cod_catastale": "M398",
            "cod_istat": "002171",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8099,
            "name": "Gattico-Veruno",
            "provincia": "NO",
            "cap": "28013",
            "cod_catastale": "M416",
            "cod_istat": "003166",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8103,
            "name": "Alluvioni Piovera",
            "provincia": "AL",
            "cap": "15047",
            "cod_catastale": "M397",
            "cod_istat": "006192",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8104,
            "name": "Lu e Cuccaro Monferrato",
            "provincia": "AL",
            "cap": "15037",
            "cod_catastale": "M420",
            "cod_istat": "006193",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8105,
            "name": "Quaregna Cerreto",
            "provincia": "BI",
            "cap": "13854",
            "cod_catastale": "M414",
            "cod_istat": "096087",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8106,
            "name": "Valdilana",
            "provincia": "BI",
            "cap": "13835",
            "cod_catastale": "M417",
            "cod_istat": "096088",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8107,
            "name": "Borgomezzavalle",
            "provincia": "VB",
            "cap": "28846",
            "cod_catastale": "M370",
            "cod_istat": "103078",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8108,
            "name": "Valle Cannobina",
            "provincia": "VB",
            "cap": "28827",
            "cod_catastale": "M404",
            "cod_istat": "103079",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8111,
            "name": "Cadrezzate con Osmate",
            "provincia": "VA",
            "cap": "21062",
            "cod_catastale": "M425",
            "cod_istat": "012143",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8112,
            "name": "Colverde",
            "provincia": "CO",
            "cap": "22041",
            "cod_catastale": "M336",
            "cod_istat": "013251",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8113,
            "name": "Tremezzina",
            "provincia": "CO",
            "cap": "22016",
            "cod_catastale": "M341",
            "cod_istat": "013252",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8114,
            "name": "Alta Valle Intelvi",
            "provincia": "CO",
            "cap": "22024",
            "cod_catastale": "M383",
            "cod_istat": "013253",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8115,
            "name": "Centro Valle Intelvi",
            "provincia": "CO",
            "cap": "22023",
            "cod_catastale": "M394",
            "cod_istat": "013254",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8116,
            "name": "Solbiate con Cagno",
            "provincia": "CO",
            "cap": "22043",
            "cod_catastale": "M412",
            "cod_istat": "013255",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8117,
            "name": "Vermezzo con Zelo",
            "provincia": "MI",
            "cap": "20071",
            "cod_catastale": "M424",
            "cod_istat": "015251",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8118,
            "name": "Val Brembilla",
            "provincia": "BG",
            "cap": "24012",
            "cod_catastale": "M334",
            "cod_istat": "016253",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8123,
            "name": "Cornale e Bastida",
            "provincia": "PV",
            "cap": "27056",
            "cod_catastale": "M338",
            "cod_istat": "018191",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8124,
            "name": "Corteolona e Genzone",
            "provincia": "PV",
            "cap": "27014",
            "cod_catastale": "M372",
            "cod_istat": "018192",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8125,
            "name": "Colli Verdi",
            "provincia": "PV",
            "cap": "27061",
            "cod_catastale": "M419",
            "cod_istat": "018193",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8126,
            "name": "Piadena Drizzona",
            "provincia": "CR",
            "cap": "26034",
            "cod_catastale": "M418",
            "cod_istat": "019116",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8129,
            "name": "Borgo Virgilio",
            "provincia": "MN",
            "cap": "46034",
            "cod_catastale": "M340",
            "cod_istat": "020071",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8130,
            "name": "Borgo Mantovano",
            "provincia": "MN",
            "cap": "46036",
            "cod_catastale": "M396",
            "cod_istat": "020072",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8131,
            "name": "Borgocarbonara",
            "provincia": "MN",
            "cap": "46021",
            "cod_catastale": "M406",
            "cod_istat": "020073",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8132,
            "name": "Verderio",
            "provincia": "LC",
            "cap": "23879",
            "cod_catastale": "M337",
            "cod_istat": "097091",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8133,
            "name": "La Valletta Brianza",
            "provincia": "LC",
            "cap": "23888",
            "cod_catastale": "M348",
            "cod_istat": "097092",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8134,
            "name": "Valvarrone",
            "provincia": "LC",
            "cap": "23836",
            "cod_catastale": "M395",
            "cod_istat": "097093",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8135,
            "name": "Castelgerundo",
            "provincia": "LO",
            "cap": "26844",
            "cod_catastale": "M393",
            "cod_istat": "098062",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8138,
            "name": "Predaia",
            "provincia": "TN",
            "cap": "38012",
            "cod_catastale": "M344",
            "cod_istat": "022230",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8139,
            "name": "San Lorenzo Dorsino",
            "provincia": "TN",
            "cap": "38078",
            "cod_catastale": "M345",
            "cod_istat": "022231",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8140,
            "name": "Valdaone",
            "provincia": "TN",
            "cap": "38091",
            "cod_catastale": "M343",
            "cod_istat": "022232",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8141,
            "name": "Dimaro Folgarida",
            "provincia": "TN",
            "cap": "38025",
            "cod_catastale": "M366",
            "cod_istat": "022233",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8142,
            "name": "Pieve di Bono-Prezzo",
            "provincia": "TN",
            "cap": "38085",
            "cod_catastale": "M365",
            "cod_istat": "022234",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8143,
            "name": "Altavalle",
            "provincia": "TN",
            "cap": "38092",
            "cod_catastale": "M349",
            "cod_istat": "022235",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8144,
            "name": "Altopiano della Vigolana",
            "provincia": "TN",
            "cap": "38049",
            "cod_catastale": "M350",
            "cod_istat": "022236",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8146,
            "name": "Borgo Chiese",
            "provincia": "TN",
            "cap": "38083",
            "cod_catastale": "M352",
            "cod_istat": "022238",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8147,
            "name": "Borgo Lares",
            "provincia": "TN",
            "cap": "38079",
            "cod_catastale": "M353",
            "cod_istat": "022239",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8148,
            "name": "Castel Ivano",
            "provincia": "TN",
            "cap": "38059",
            "cod_catastale": "M354",
            "cod_istat": "022240",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8149,
            "name": "Cembra Lisignago",
            "provincia": "TN",
            "cap": "38034",
            "cod_catastale": "M355",
            "cod_istat": "022241",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8150,
            "name": "Contà",
            "provincia": "TN",
            "cap": "38093",
            "cod_catastale": "M356",
            "cod_istat": "022242",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8151,
            "name": "Madruzzo",
            "provincia": "TN",
            "cap": "38076",
            "cod_catastale": "M357",
            "cod_istat": "022243",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8152,
            "name": "Primiero San Martino di Castrozza",
            "provincia": "TN",
            "cap": "38054",
            "cod_catastale": "M359",
            "cod_istat": "022245",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8153,
            "name": "Sella Giudicarie",
            "provincia": "TN",
            "cap": "38087",
            "cod_catastale": "M360",
            "cod_istat": "022246",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8154,
            "name": "Tre Ville",
            "provincia": "TN",
            "cap": "38095",
            "cod_catastale": "M361",
            "cod_istat": "022247",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8155,
            "name": "Vallelaghi",
            "provincia": "TN",
            "cap": "38096",
            "cod_catastale": "M362",
            "cod_istat": "022248",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8156,
            "name": "Ville d'Anaunia",
            "provincia": "TN",
            "cap": "38019",
            "cod_catastale": "M363",
            "cod_istat": "022249",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8157,
            "name": "San Giovanni di Fassa",
            "provincia": "TN",
            "cap": "38036",
            "cod_catastale": "M390",
            "cod_istat": "022250",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8158,
            "name": "Terre d'Adige",
            "provincia": "TN",
            "cap": "38097",
            "cod_catastale": "M407",
            "cod_istat": "022251",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8162,
            "name": "Val Liona",
            "provincia": "VI",
            "cap": "36044",
            "cod_catastale": "M384",
            "cod_istat": "024123",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8163,
            "name": "Barbarano Mossano",
            "provincia": "VI",
            "cap": "36048",
            "cod_catastale": "M401",
            "cod_istat": "024124",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8164,
            "name": "Valbrenta",
            "provincia": "VI",
            "cap": "36029",
            "cod_catastale": "M423",
            "cod_istat": "024125",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8165,
            "name": "Colceresa",
            "provincia": "VI",
            "cap": "36064",
            "cod_catastale": "M426",
            "cod_istat": "024126",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8166,
            "name": "Lusiana Conco",
            "provincia": "VI",
            "cap": "36046",
            "cod_catastale": "M427",
            "cod_istat": "024127",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8168,
            "name": "Quero Vas",
            "provincia": "BL",
            "cap": "32038",
            "cod_catastale": "M332",
            "cod_istat": "025070",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8169,
            "name": "Alpago",
            "provincia": "BL",
            "cap": "32016",
            "cod_catastale": "M375",
            "cod_istat": "025072",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8170,
            "name": "Val di Zoldo",
            "provincia": "BL",
            "cap": "32012",
            "cod_catastale": "M374",
            "cod_istat": "025073",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8171,
            "name": "Borgo Valbelluna",
            "provincia": "BL",
            "cap": "32026",
            "cod_catastale": "M421",
            "cod_istat": "025074",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8172,
            "name": "Pieve del Grappa",
            "provincia": "TV",
            "cap": "31017",
            "cod_catastale": "M422",
            "cod_istat": "026096",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8177,
            "name": "Borgo Veneto",
            "provincia": "PD",
            "cap": "35046",
            "cod_catastale": "M402",
            "cod_istat": "028107",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8179,
            "name": "Rivignano Teor",
            "provincia": "UD",
            "cap": "33061",
            "cod_catastale": "M317",
            "cod_istat": "030188",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8180,
            "name": "Fiumicello Villa Vicentina",
            "provincia": "UD",
            "cap": "33059",
            "cod_catastale": "M400",
            "cod_istat": "030190",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8181,
            "name": "Treppo Ligosullo",
            "provincia": "UD",
            "cap": "33014",
            "cod_catastale": "M399",
            "cod_istat": "030191",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8184,
            "name": "Valvasone Arzene",
            "provincia": "PN",
            "cap": "33098",
            "cod_catastale": "M346",
            "cod_istat": "093053",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8185,
            "name": "Montalto Carpasio",
            "provincia": "IM",
            "cap": "18028",
            "cod_catastale": "M387",
            "cod_istat": "008068",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8188,
            "name": "Alta Val Tidone",
            "provincia": "PC",
            "cap": "29031",
            "cod_catastale": "M386",
            "cod_istat": "033049",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8189,
            "name": "Sissa Trecasali",
            "provincia": "PR",
            "cap": "43018",
            "cod_catastale": "M325",
            "cod_istat": "034049",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8190,
            "name": "Polesine Zibello",
            "provincia": "PR",
            "cap": "43016",
            "cod_catastale": "M367",
            "cod_istat": "034050",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8191,
            "name": "Sorbolo Mezzani",
            "provincia": "PR",
            "cap": "43058",
            "cod_catastale": "M411",
            "cod_istat": "034051",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8193,
            "name": "Ventasso",
            "provincia": "RE",
            "cap": "42032",
            "cod_catastale": "M364",
            "cod_istat": "035046",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8194,
            "name": "Alto Reno Terme",
            "provincia": "BO",
            "cap": "40046",
            "cod_catastale": "M369",
            "cod_istat": "037062",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8195,
            "name": "Fiscaglia",
            "provincia": "FE",
            "cap": "44027",
            "cod_catastale": "M323",
            "cod_istat": "038027",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8196,
            "name": "Terre del Reno",
            "provincia": "FE",
            "cap": "44047",
            "cod_catastale": "M381",
            "cod_istat": "038028",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8197,
            "name": "Riva del Po",
            "provincia": "FE",
            "cap": "44033",
            "cod_catastale": "M410",
            "cod_istat": "038029",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8198,
            "name": "Tresignana",
            "provincia": "FE",
            "cap": "44039",
            "cod_catastale": "M409",
            "cod_istat": "038030",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8199,
            "name": "Poggio Torriana",
            "provincia": "RN",
            "cap": "47824",
            "cod_catastale": "M324",
            "cod_istat": "099028",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8200,
            "name": "Montescudo-Monte Colombo",
            "provincia": "RN",
            "cap": "47854",
            "cod_catastale": "M368",
            "cod_istat": "099029",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8201,
            "name": "Fabbriche di Vergemoli",
            "provincia": "LU",
            "cap": "55021",
            "cod_catastale": "M319",
            "cod_istat": "046036",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8202,
            "name": "Sillano Giuncugnano",
            "provincia": "LU",
            "cap": "55039",
            "cod_catastale": "M347",
            "cod_istat": "046037",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8204,
            "name": "San Marcello Piteglio",
            "provincia": "PT",
            "cap": "51028",
            "cod_catastale": "M377",
            "cod_istat": "047024",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8205,
            "name": "Figline e Incisa Valdarno",
            "provincia": "FI",
            "cap": "50063",
            "cod_catastale": "M321",
            "cod_istat": "048052",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8206,
            "name": "Scarperia e San Piero",
            "provincia": "FI",
            "cap": "50038",
            "cod_catastale": "M326",
            "cod_istat": "048053",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8207,
            "name": "Barberino Tavarnelle",
            "provincia": "FI",
            "cap": "50028",
            "cod_catastale": "M408",
            "cod_istat": "048054",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8208,
            "name": "Rio",
            "provincia": "LI",
            "cap": "57038",
            "cod_catastale": "M391",
            "cod_istat": "049021",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8209,
            "name": "Casciana Terme Lari",
            "provincia": "PI",
            "cap": "56035",
            "cod_catastale": "M327",
            "cod_istat": "050040",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8210,
            "name": "Crespina Lorenzana",
            "provincia": "PI",
            "cap": "56042",
            "cod_catastale": "M328",
            "cod_istat": "050041",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8211,
            "name": "Castelfranco Piandiscò",
            "provincia": "AR",
            "cap": "52026",
            "cod_catastale": "M322",
            "cod_istat": "051040",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8212,
            "name": "Pratovecchio Stia",
            "provincia": "AR",
            "cap": "52015",
            "cod_catastale": "M329",
            "cod_istat": "051041",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8213,
            "name": "Laterina Pergine Valdarno",
            "provincia": "AR",
            "cap": "52019",
            "cod_catastale": "M392",
            "cod_istat": "051042",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8216,
            "name": "Vallefoglia",
            "provincia": "PU",
            "cap": "61022",
            "cod_catastale": "M331",
            "cod_istat": "041068",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8218,
            "name": "Terre Roveresche",
            "provincia": "PU",
            "cap": "61038",
            "cod_catastale": "M379",
            "cod_istat": "041070",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8219,
            "name": "Sassocorvaro Auditore",
            "provincia": "PU",
            "cap": "61028",
            "cod_catastale": "M413",
            "cod_istat": "041071",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8220,
            "name": "Trecastelli",
            "provincia": "AN",
            "cap": "60012",
            "cod_catastale": "M318",
            "cod_istat": "042050",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8221,
            "name": "Valfornace",
            "provincia": "MC",
            "cap": "62031",
            "cod_catastale": "M382",
            "cod_istat": "043058",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8223,
            "name": "Montoro",
            "provincia": "AV",
            "cap": "83025",
            "cod_catastale": "M330",
            "cod_istat": "064121",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8225,
            "name": "Presicce-Acquarica",
            "provincia": "LE",
            "cap": "730xx",
            "cod_catastale": "M428",
            "cod_istat": "075098",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8226,
            "name": "Casali del Manco",
            "provincia": "CS",
            "cap": "87059",
            "cod_catastale": "M385",
            "cod_istat": "078156",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8227,
            "name": "Corigliano-Rossano",
            "provincia": "CS",
            "cap": "87064",
            "cod_catastale": "M403",
            "cod_istat": "078157",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 1
        },
        {
            "id": 8243,
            "name": "Mappano",
            "provincia": "TO",
            "cap": "10079",
            "cod_catastale": "M316",
            "cod_istat": "001316",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8244,
            "name": "Amblar-Don",
            "provincia": "TN",
            "cap": "38011",
            "cod_catastale": "M351",
            "cod_istat": "022237",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 0,
            "giorni": 0,
            "area": "",
            "ech": 0
        },
        {
            "id": 8245,
            "name": "Monte Terminillo",
            "provincia": "RI",
            "cap": "02100",
            "cod_catastale": null,
            "cod_istat": "057059",
            "attivo": 1,
            "zona": null,
            "cassa": 0,
            "altitudine": 2217,
            "giorni": 0,
            "area": "",
            "ech": 0
        }
    ]

    tipo_fornitura = [
        {id:1, descrizione:"Energia elettrica", code:"E"},
        {id:2, descrizione:"Gas naturale", code:"G"},
        {id:3, descrizione:"Dual fuel", code:"D", disabled: true}
    ]

    tensioni = [
        {id:1, name:"MT", descrizione:"media tensione", consumo:"superiore a 100.000", potenza:"superiore a 100"},
        {id:2, name:"BT", descrizione:"bassa tensione", consumo:"fino a 200.000", potenza:"fino a 200"},
        {id:3, name:"AT", descrizione:"alta tensione", consumo:null, potenza:null},
        {id:4, name:"AAT", descrizione:"altissima tensione", consumo:null, potenza:null}
    ]

    tipo_generalizzazione = [
        {code: 'S', descrizione: 'offerta generalizzata pubblicata su IPO simulabile'},
        {code: 'T', descrizione: 'offerta generalizzata pubblicata su IPO non simulabile'},
        {code: 'P', descrizione: 'offerta trasmessa Gestore IPO cui condizioni economiche oggetto di MUI/evoluzioni automatiche'},
        {code: 'N', descrizione: 'offerta non generalizzata'}
    ]
    tipo_indicizzazione = [
        {id: 1, descrizione: 'Prezzo fisso', code: 'F'},
        {id: 2, descrizione: 'Prezzo variabile', code: 'V'}
    ]

    tipo_tariffazione = [
        {id: 1, descrizione: 'Monorario', code: 'M', for_type: ['ee','gas']},
        {id: 2, descrizione: 'Orario', code: 'O', for_type: ['ee']},
        {id: 3, descrizione: 'Fasce', code: 'F', for_type: ['ee']}
    ]

    tipo_mercato = [
        {id: 1, descrizione: 'Placet', code: 'P'},
        {id: 2, descrizione: 'Mercato libero', code: 'L'},
        {id: 3, descrizione: 'Tutela', code: 'T', disabled: true}
    ]

    getCities(siglaProvincia = null){
        this.comuni = this.comuni.map(comune => {
                return {...comune, name: comune.name.toLocaleUpperCase()}
            }
        )
        if (siglaProvincia === 'null' || siglaProvincia === null) {
            return this.comuni;
        }

        return this.comuni.filter(comune => {
            return comune.provincia.includes(siglaProvincia);
        })
    }

    getNameCityById(id){
        this.comuni = this.comuni.map(comune => {
            return {...comune, name: comune.name.toLocaleUpperCase()}
        })
        let name = null
        let comune = this.comuni.find(comune => comune.id == id)
        if(comune) name = comune.name

        return name;
    }
}